import { defineComponent as ye, inject as Kt, ref as R, computed as m, onMounted as ct, onBeforeUnmount as yt, reactive as Ha, provide as dn, openBlock as c, createElementBlock as g, normalizeClass as C, renderSlot as Ae, useId as qe, toValue as Pt, watch as $e, readonly as Ix, shallowRef as er, onUpdated as uo, nextTick as Ge, Fragment as de, createBlock as W, resolveDynamicComponent as it, mergeProps as Fe, withKeys as ht, withCtx as ve, Teleport as Nn, unref as L, toDisplayString as j, createCommentVNode as w, createVNode as te, Transition as At, createTextVNode as nt, createElementVNode as v, useSlots as Hn, withModifiers as Je, normalizeStyle as je, useAttrs as Gn, normalizeProps as an, guardReactiveProps as sn, renderList as Re, mergeDefaults as Gb, toHandlers as Nl, h as ea, onUnmounted as kt, shallowReactive as Lx, createStaticVNode as co, Comment as Au, Text as Tx, getCurrentInstance as Eu, watchEffect as Kb, markRaw as Ax, customRef as Ex, toRef as An, createSlots as sa, withDirectives as tr, vModelText as Yb, onBeforeUpdate as Rx, useModel as Jb, mergeModels as Ad, vModelDynamic as Bx, vShow as Ru, useTemplateRef as ta, TransitionGroup as Ur, isRef as Jo, toRefs as nf, resolveComponent as Mx } from "vue";
const Xb = Symbol("AccordionContext"), Zb = Symbol("AccordionItemContext"), Dx = ["data-accordion-root"], jW = /* @__PURE__ */ ye({
  __name: "Accordion",
  props: {
    variant: { default: "default" },
    size: { default: void 0 },
    multiple: { type: Boolean, default: void 0 },
    headingLevel: { default: void 0 }
  },
  setup(e) {
    const n = e, t = Kt(Zb, null), a = R(), l = R(!!t), r = m(() => l.value && (t == null ? void 0 : t.variant.value) === "multi-level");
    let o;
    ct(() => {
      var x, y;
      l.value = !!t && !!((y = (x = a.value) == null ? void 0 : x.parentElement) != null && y.closest("[data-accordion-item]")), l.value && (o = t == null ? void 0 : t.registerChildAccordion());
    }), yt(() => o == null ? void 0 : o());
    const i = m(() => r.value ? "multi-level" : n.variant), s = m(() => n.size ?? (r.value && t ? t.size.value : "md")), d = m(() => n.headingLevel ? n.headingLevel : l.value && t ? Math.min(t.headingLevel.value + 1, 6) : 3), u = m(
      () => n.multiple ?? !["separate-cards", "multi-level"].includes(i.value)
    ), f = Ha(/* @__PURE__ */ new Set());
    function b(x) {
      f.has(x) ? f.delete(x) : (u.value || f.clear(), f.add(x));
    }
    function h(x) {
      f.add(x);
    }
    dn(Xb, {
      variant: i,
      size: s,
      headingLevel: d,
      isChildLevel: r,
      openItems: f,
      toggleItem: b,
      openItem: h
    });
    const p = m(() => {
      if (r.value) return "";
      switch (i.value) {
        case "flush":
          return "";
        case "separate-cards":
          return "flex flex-col gap-3";
        default:
          return "border border-(--colors-border-base-soft) rounded-(--border-border-radius-rounded-l) overflow-hidden";
      }
    });
    return (x, y) => (c(), g("div", {
      ref_key: "rootEl",
      ref: a,
      class: C(p.value),
      "data-accordion-root": r.value ? void 0 : "",
      "data-testid": "accordion"
    }, [
      Ae(x.$slots, "default")
    ], 10, Dx));
  }
});
function Qb(e = {}) {
  const n = e.id ?? qe(), t = `${n}-trigger`, a = `${n}-content`, l = R(!1), r = m(() => Pt(e.open) !== void 0), o = m(() => r.value ? Pt(e.open) : e.store ? e.store.isOpen() : l.value);
  ct(() => {
    r.value || !Pt(e.defaultOpen) || o.value || (e.store ? e.store.open() : l.value = !0);
  });
  const i = () => {
    var y;
    const x = !o.value;
    return r.value || (e.store ? e.store.toggle() : l.value = x), (y = e.onOpenChange) == null || y.call(e, x), x;
  }, s = R(!1), d = () => {
    var x;
    return typeof window < "u" && !!((x = window.matchMedia) != null && x.call(window, "(prefers-reduced-motion: reduce)").matches);
  };
  let u = !1;
  ct(() => requestAnimationFrame(() => u = !0)), $e(
    o,
    (x) => {
      s.value = x && (!u || d());
    },
    { immediate: !0 }
  );
  const f = (x) => {
    x.target === x.currentTarget && x.propertyName === "grid-template-rows" && o.value && (s.value = !0);
  }, b = m(() => ({
    id: t,
    "aria-expanded": o.value,
    "aria-controls": a
  })), h = m(() => ({
    id: a,
    role: "region",
    "aria-labelledby": t,
    "aria-hidden": !o.value,
    inert: !o.value || void 0
  })), p = m(() => [
    "accordion-content",
    { "accordion-content--expanded": o.value, "accordion-content--open": s.value }
  ]);
  return {
    id: n,
    triggerId: t,
    panelId: a,
    isOpen: o,
    isControlled: r,
    isFullyOpen: Ix(s),
    toggle: i,
    onTransitionEnd: f,
    triggerProps: b,
    panelProps: h,
    panelClasses: p
  };
}
var mn = "top", On = "bottom", Pn = "right", pn = "left", Bu = "auto", fo = [mn, On, Pn, pn], Hl = "start", Gr = "end", zx = "clippingParents", _b = "viewport", dr = "popper", Ox = "reference", af = /* @__PURE__ */ fo.reduce(function(e, n) {
  return e.concat([n + "-" + Hl, n + "-" + Gr]);
}, []), eg = /* @__PURE__ */ [].concat(fo, [Bu]).reduce(function(e, n) {
  return e.concat([n, n + "-" + Hl, n + "-" + Gr]);
}, []), Px = "beforeRead", Fx = "read", Vx = "afterRead", Nx = "beforeMain", Hx = "main", jx = "afterMain", Wx = "beforeWrite", qx = "write", Ux = "afterWrite", Gx = [Px, Fx, Vx, Nx, Hx, jx, Wx, qx, Ux];
function la(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Cn(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var n = e.ownerDocument;
    return n && n.defaultView || window;
  }
  return e;
}
function ml(e) {
  var n = Cn(e).Element;
  return e instanceof n || e instanceof Element;
}
function Rn(e) {
  var n = Cn(e).HTMLElement;
  return e instanceof n || e instanceof HTMLElement;
}
function Mu(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var n = Cn(e).ShadowRoot;
  return e instanceof n || e instanceof ShadowRoot;
}
function Kx(e) {
  var n = e.state;
  Object.keys(n.elements).forEach(function(t) {
    var a = n.styles[t] || {}, l = n.attributes[t] || {}, r = n.elements[t];
    !Rn(r) || !la(r) || (Object.assign(r.style, a), Object.keys(l).forEach(function(o) {
      var i = l[o];
      i === !1 ? r.removeAttribute(o) : r.setAttribute(o, i === !0 ? "" : i);
    }));
  });
}
function Yx(e) {
  var n = e.state, t = {
    popper: {
      position: n.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(n.elements.popper.style, t.popper), n.styles = t, n.elements.arrow && Object.assign(n.elements.arrow.style, t.arrow), function() {
    Object.keys(n.elements).forEach(function(a) {
      var l = n.elements[a], r = n.attributes[a] || {}, o = Object.keys(n.styles.hasOwnProperty(a) ? n.styles[a] : t[a]), i = o.reduce(function(s, d) {
        return s[d] = "", s;
      }, {});
      !Rn(l) || !la(l) || (Object.assign(l.style, i), Object.keys(r).forEach(function(s) {
        l.removeAttribute(s);
      }));
    });
  };
}
const Jx = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Kx,
  effect: Yx,
  requires: ["computeStyles"]
};
function na(e) {
  return e.split("-")[0];
}
var ul = Math.max, oi = Math.min, jl = Math.round;
function Ed() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(n) {
    return n.brand + "/" + n.version;
  }).join(" ") : navigator.userAgent;
}
function tg() {
  return !/^((?!chrome|android).)*safari/i.test(Ed());
}
function Wl(e, n, t) {
  n === void 0 && (n = !1), t === void 0 && (t = !1);
  var a = e.getBoundingClientRect(), l = 1, r = 1;
  n && Rn(e) && (l = e.offsetWidth > 0 && jl(a.width) / e.offsetWidth || 1, r = e.offsetHeight > 0 && jl(a.height) / e.offsetHeight || 1);
  var o = ml(e) ? Cn(e) : window, i = o.visualViewport, s = !tg() && t, d = (a.left + (s && i ? i.offsetLeft : 0)) / l, u = (a.top + (s && i ? i.offsetTop : 0)) / r, f = a.width / l, b = a.height / r;
  return {
    width: f,
    height: b,
    top: u,
    right: d + f,
    bottom: u + b,
    left: d,
    x: d,
    y: u
  };
}
function Du(e) {
  var n = Wl(e), t = e.offsetWidth, a = e.offsetHeight;
  return Math.abs(n.width - t) <= 1 && (t = n.width), Math.abs(n.height - a) <= 1 && (a = n.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: t,
    height: a
  };
}
function ng(e, n) {
  var t = n.getRootNode && n.getRootNode();
  if (e.contains(n))
    return !0;
  if (t && Mu(t)) {
    var a = n;
    do {
      if (a && e.isSameNode(a))
        return !0;
      a = a.parentNode || a.host;
    } while (a);
  }
  return !1;
}
function xa(e) {
  return Cn(e).getComputedStyle(e);
}
function Xx(e) {
  return ["table", "td", "th"].indexOf(la(e)) >= 0;
}
function Ja(e) {
  return ((ml(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function es(e) {
  return la(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Mu(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Ja(e)
  );
}
function lf(e) {
  return !Rn(e) || // https://github.com/popperjs/popper-core/issues/837
  xa(e).position === "fixed" ? null : e.offsetParent;
}
function Zx(e) {
  var n = /firefox/i.test(Ed()), t = /Trident/i.test(Ed());
  if (t && Rn(e)) {
    var a = xa(e);
    if (a.position === "fixed")
      return null;
  }
  var l = es(e);
  for (Mu(l) && (l = l.host); Rn(l) && ["html", "body"].indexOf(la(l)) < 0; ) {
    var r = xa(l);
    if (r.transform !== "none" || r.perspective !== "none" || r.contain === "paint" || ["transform", "perspective"].indexOf(r.willChange) !== -1 || n && r.willChange === "filter" || n && r.filter && r.filter !== "none")
      return l;
    l = l.parentNode;
  }
  return null;
}
function ho(e) {
  for (var n = Cn(e), t = lf(e); t && Xx(t) && xa(t).position === "static"; )
    t = lf(t);
  return t && (la(t) === "html" || la(t) === "body" && xa(t).position === "static") ? n : t || Zx(e) || n;
}
function zu(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Lr(e, n, t) {
  return ul(e, oi(n, t));
}
function Qx(e, n, t) {
  var a = Lr(e, n, t);
  return a > t ? t : a;
}
function ag() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function lg(e) {
  return Object.assign({}, ag(), e);
}
function rg(e, n) {
  return n.reduce(function(t, a) {
    return t[a] = e, t;
  }, {});
}
var _x = function(n, t) {
  return n = typeof n == "function" ? n(Object.assign({}, t.rects, {
    placement: t.placement
  })) : n, lg(typeof n != "number" ? n : rg(n, fo));
};
function e0(e) {
  var n, t = e.state, a = e.name, l = e.options, r = t.elements.arrow, o = t.modifiersData.popperOffsets, i = na(t.placement), s = zu(i), d = [pn, Pn].indexOf(i) >= 0, u = d ? "height" : "width";
  if (!(!r || !o)) {
    var f = _x(l.padding, t), b = Du(r), h = s === "y" ? mn : pn, p = s === "y" ? On : Pn, x = t.rects.reference[u] + t.rects.reference[s] - o[s] - t.rects.popper[u], y = o[s] - t.rects.reference[s], k = ho(r), $ = k ? s === "y" ? k.clientHeight || 0 : k.clientWidth || 0 : 0, S = x / 2 - y / 2, T = f[h], I = $ - b[u] - f[p], A = $ / 2 - b[u] / 2 + S, E = Lr(T, A, I), D = s;
    t.modifiersData[a] = (n = {}, n[D] = E, n.centerOffset = E - A, n);
  }
}
function t0(e) {
  var n = e.state, t = e.options, a = t.element, l = a === void 0 ? "[data-popper-arrow]" : a;
  l != null && (typeof l == "string" && (l = n.elements.popper.querySelector(l), !l) || ng(n.elements.popper, l) && (n.elements.arrow = l));
}
const n0 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: e0,
  effect: t0,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function ql(e) {
  return e.split("-")[1];
}
var a0 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function l0(e, n) {
  var t = e.x, a = e.y, l = n.devicePixelRatio || 1;
  return {
    x: jl(t * l) / l || 0,
    y: jl(a * l) / l || 0
  };
}
function rf(e) {
  var n, t = e.popper, a = e.popperRect, l = e.placement, r = e.variation, o = e.offsets, i = e.position, s = e.gpuAcceleration, d = e.adaptive, u = e.roundOffsets, f = e.isFixed, b = o.x, h = b === void 0 ? 0 : b, p = o.y, x = p === void 0 ? 0 : p, y = typeof u == "function" ? u({
    x: h,
    y: x
  }) : {
    x: h,
    y: x
  };
  h = y.x, x = y.y;
  var k = o.hasOwnProperty("x"), $ = o.hasOwnProperty("y"), S = pn, T = mn, I = window;
  if (d) {
    var A = ho(t), E = "clientHeight", D = "clientWidth";
    if (A === Cn(t) && (A = Ja(t), xa(A).position !== "static" && i === "absolute" && (E = "scrollHeight", D = "scrollWidth")), A = A, l === mn || (l === pn || l === Pn) && r === Gr) {
      T = On;
      var z = f && A === I && I.visualViewport ? I.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        A[E]
      );
      x -= z - a.height, x *= s ? 1 : -1;
    }
    if (l === pn || (l === mn || l === On) && r === Gr) {
      S = Pn;
      var Y = f && A === I && I.visualViewport ? I.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        A[D]
      );
      h -= Y - a.width, h *= s ? 1 : -1;
    }
  }
  var le = Object.assign({
    position: i
  }, d && a0), ne = u === !0 ? l0({
    x: h,
    y: x
  }, Cn(t)) : {
    x: h,
    y: x
  };
  if (h = ne.x, x = ne.y, s) {
    var re;
    return Object.assign({}, le, (re = {}, re[T] = $ ? "0" : "", re[S] = k ? "0" : "", re.transform = (I.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + x + "px)" : "translate3d(" + h + "px, " + x + "px, 0)", re));
  }
  return Object.assign({}, le, (n = {}, n[T] = $ ? x + "px" : "", n[S] = k ? h + "px" : "", n.transform = "", n));
}
function r0(e) {
  var n = e.state, t = e.options, a = t.gpuAcceleration, l = a === void 0 ? !0 : a, r = t.adaptive, o = r === void 0 ? !0 : r, i = t.roundOffsets, s = i === void 0 ? !0 : i, d = {
    placement: na(n.placement),
    variation: ql(n.placement),
    popper: n.elements.popper,
    popperRect: n.rects.popper,
    gpuAcceleration: l,
    isFixed: n.options.strategy === "fixed"
  };
  n.modifiersData.popperOffsets != null && (n.styles.popper = Object.assign({}, n.styles.popper, rf(Object.assign({}, d, {
    offsets: n.modifiersData.popperOffsets,
    position: n.options.strategy,
    adaptive: o,
    roundOffsets: s
  })))), n.modifiersData.arrow != null && (n.styles.arrow = Object.assign({}, n.styles.arrow, rf(Object.assign({}, d, {
    offsets: n.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: s
  })))), n.attributes.popper = Object.assign({}, n.attributes.popper, {
    "data-popper-placement": n.placement
  });
}
const o0 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: r0,
  data: {}
};
var yo = {
  passive: !0
};
function i0(e) {
  var n = e.state, t = e.instance, a = e.options, l = a.scroll, r = l === void 0 ? !0 : l, o = a.resize, i = o === void 0 ? !0 : o, s = Cn(n.elements.popper), d = [].concat(n.scrollParents.reference, n.scrollParents.popper);
  return r && d.forEach(function(u) {
    u.addEventListener("scroll", t.update, yo);
  }), i && s.addEventListener("resize", t.update, yo), function() {
    r && d.forEach(function(u) {
      u.removeEventListener("scroll", t.update, yo);
    }), i && s.removeEventListener("resize", t.update, yo);
  };
}
const s0 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: i0,
  data: {}
};
var d0 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Xo(e) {
  return e.replace(/left|right|bottom|top/g, function(n) {
    return d0[n];
  });
}
var u0 = {
  start: "end",
  end: "start"
};
function of(e) {
  return e.replace(/start|end/g, function(n) {
    return u0[n];
  });
}
function Ou(e) {
  var n = Cn(e), t = n.pageXOffset, a = n.pageYOffset;
  return {
    scrollLeft: t,
    scrollTop: a
  };
}
function Pu(e) {
  return Wl(Ja(e)).left + Ou(e).scrollLeft;
}
function c0(e, n) {
  var t = Cn(e), a = Ja(e), l = t.visualViewport, r = a.clientWidth, o = a.clientHeight, i = 0, s = 0;
  if (l) {
    r = l.width, o = l.height;
    var d = tg();
    (d || !d && n === "fixed") && (i = l.offsetLeft, s = l.offsetTop);
  }
  return {
    width: r,
    height: o,
    x: i + Pu(e),
    y: s
  };
}
function f0(e) {
  var n, t = Ja(e), a = Ou(e), l = (n = e.ownerDocument) == null ? void 0 : n.body, r = ul(t.scrollWidth, t.clientWidth, l ? l.scrollWidth : 0, l ? l.clientWidth : 0), o = ul(t.scrollHeight, t.clientHeight, l ? l.scrollHeight : 0, l ? l.clientHeight : 0), i = -a.scrollLeft + Pu(e), s = -a.scrollTop;
  return xa(l || t).direction === "rtl" && (i += ul(t.clientWidth, l ? l.clientWidth : 0) - r), {
    width: r,
    height: o,
    x: i,
    y: s
  };
}
function Fu(e) {
  var n = xa(e), t = n.overflow, a = n.overflowX, l = n.overflowY;
  return /auto|scroll|overlay|hidden/.test(t + l + a);
}
function og(e) {
  return ["html", "body", "#document"].indexOf(la(e)) >= 0 ? e.ownerDocument.body : Rn(e) && Fu(e) ? e : og(es(e));
}
function Tr(e, n) {
  var t;
  n === void 0 && (n = []);
  var a = og(e), l = a === ((t = e.ownerDocument) == null ? void 0 : t.body), r = Cn(a), o = l ? [r].concat(r.visualViewport || [], Fu(a) ? a : []) : a, i = n.concat(o);
  return l ? i : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    i.concat(Tr(es(o)))
  );
}
function Rd(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function h0(e, n) {
  var t = Wl(e, !1, n === "fixed");
  return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function sf(e, n, t) {
  return n === _b ? Rd(c0(e, t)) : ml(n) ? h0(n, t) : Rd(f0(Ja(e)));
}
function b0(e) {
  var n = Tr(es(e)), t = ["absolute", "fixed"].indexOf(xa(e).position) >= 0, a = t && Rn(e) ? ho(e) : e;
  return ml(a) ? n.filter(function(l) {
    return ml(l) && ng(l, a) && la(l) !== "body";
  }) : [];
}
function g0(e, n, t, a) {
  var l = n === "clippingParents" ? b0(e) : [].concat(n), r = [].concat(l, [t]), o = r[0], i = r.reduce(function(s, d) {
    var u = sf(e, d, a);
    return s.top = ul(u.top, s.top), s.right = oi(u.right, s.right), s.bottom = oi(u.bottom, s.bottom), s.left = ul(u.left, s.left), s;
  }, sf(e, o, a));
  return i.width = i.right - i.left, i.height = i.bottom - i.top, i.x = i.left, i.y = i.top, i;
}
function ig(e) {
  var n = e.reference, t = e.element, a = e.placement, l = a ? na(a) : null, r = a ? ql(a) : null, o = n.x + n.width / 2 - t.width / 2, i = n.y + n.height / 2 - t.height / 2, s;
  switch (l) {
    case mn:
      s = {
        x: o,
        y: n.y - t.height
      };
      break;
    case On:
      s = {
        x: o,
        y: n.y + n.height
      };
      break;
    case Pn:
      s = {
        x: n.x + n.width,
        y: i
      };
      break;
    case pn:
      s = {
        x: n.x - t.width,
        y: i
      };
      break;
    default:
      s = {
        x: n.x,
        y: n.y
      };
  }
  var d = l ? zu(l) : null;
  if (d != null) {
    var u = d === "y" ? "height" : "width";
    switch (r) {
      case Hl:
        s[d] = s[d] - (n[u] / 2 - t[u] / 2);
        break;
      case Gr:
        s[d] = s[d] + (n[u] / 2 - t[u] / 2);
        break;
    }
  }
  return s;
}
function Kr(e, n) {
  n === void 0 && (n = {});
  var t = n, a = t.placement, l = a === void 0 ? e.placement : a, r = t.strategy, o = r === void 0 ? e.strategy : r, i = t.boundary, s = i === void 0 ? zx : i, d = t.rootBoundary, u = d === void 0 ? _b : d, f = t.elementContext, b = f === void 0 ? dr : f, h = t.altBoundary, p = h === void 0 ? !1 : h, x = t.padding, y = x === void 0 ? 0 : x, k = lg(typeof y != "number" ? y : rg(y, fo)), $ = b === dr ? Ox : dr, S = e.rects.popper, T = e.elements[p ? $ : b], I = g0(ml(T) ? T : T.contextElement || Ja(e.elements.popper), s, u, o), A = Wl(e.elements.reference), E = ig({
    reference: A,
    element: S,
    placement: l
  }), D = Rd(Object.assign({}, S, E)), z = b === dr ? D : A, Y = {
    top: I.top - z.top + k.top,
    bottom: z.bottom - I.bottom + k.bottom,
    left: I.left - z.left + k.left,
    right: z.right - I.right + k.right
  }, le = e.modifiersData.offset;
  if (b === dr && le) {
    var ne = le[l];
    Object.keys(Y).forEach(function(re) {
      var O = [Pn, On].indexOf(re) >= 0 ? 1 : -1, P = [mn, On].indexOf(re) >= 0 ? "y" : "x";
      Y[re] += ne[P] * O;
    });
  }
  return Y;
}
function m0(e, n) {
  n === void 0 && (n = {});
  var t = n, a = t.placement, l = t.boundary, r = t.rootBoundary, o = t.padding, i = t.flipVariations, s = t.allowedAutoPlacements, d = s === void 0 ? eg : s, u = ql(a), f = u ? i ? af : af.filter(function(p) {
    return ql(p) === u;
  }) : fo, b = f.filter(function(p) {
    return d.indexOf(p) >= 0;
  });
  b.length === 0 && (b = f);
  var h = b.reduce(function(p, x) {
    return p[x] = Kr(e, {
      placement: x,
      boundary: l,
      rootBoundary: r,
      padding: o
    })[na(x)], p;
  }, {});
  return Object.keys(h).sort(function(p, x) {
    return h[p] - h[x];
  });
}
function p0(e) {
  if (na(e) === Bu)
    return [];
  var n = Xo(e);
  return [of(e), n, of(n)];
}
function v0(e) {
  var n = e.state, t = e.options, a = e.name;
  if (!n.modifiersData[a]._skip) {
    for (var l = t.mainAxis, r = l === void 0 ? !0 : l, o = t.altAxis, i = o === void 0 ? !0 : o, s = t.fallbackPlacements, d = t.padding, u = t.boundary, f = t.rootBoundary, b = t.altBoundary, h = t.flipVariations, p = h === void 0 ? !0 : h, x = t.allowedAutoPlacements, y = n.options.placement, k = na(y), $ = k === y, S = s || ($ || !p ? [Xo(y)] : p0(y)), T = [y].concat(S).reduce(function(ge, xe) {
      return ge.concat(na(xe) === Bu ? m0(n, {
        placement: xe,
        boundary: u,
        rootBoundary: f,
        padding: d,
        flipVariations: p,
        allowedAutoPlacements: x
      }) : xe);
    }, []), I = n.rects.reference, A = n.rects.popper, E = /* @__PURE__ */ new Map(), D = !0, z = T[0], Y = 0; Y < T.length; Y++) {
      var le = T[Y], ne = na(le), re = ql(le) === Hl, O = [mn, On].indexOf(ne) >= 0, P = O ? "width" : "height", V = Kr(n, {
        placement: le,
        boundary: u,
        rootBoundary: f,
        altBoundary: b,
        padding: d
      }), M = O ? re ? Pn : pn : re ? On : mn;
      I[P] > A[P] && (M = Xo(M));
      var B = Xo(M), q = [];
      if (r && q.push(V[ne] <= 0), i && q.push(V[M] <= 0, V[B] <= 0), q.every(function(ge) {
        return ge;
      })) {
        z = le, D = !1;
        break;
      }
      E.set(le, q);
    }
    if (D)
      for (var N = p ? 3 : 1, G = function(xe) {
        var X = T.find(function(ie) {
          var he = E.get(ie);
          if (he)
            return he.slice(0, xe).every(function(oe) {
              return oe;
            });
        });
        if (X)
          return z = X, "break";
      }, U = N; U > 0; U--) {
        var K = G(U);
        if (K === "break") break;
      }
    n.placement !== z && (n.modifiersData[a]._skip = !0, n.placement = z, n.reset = !0);
  }
}
const x0 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: v0,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function df(e, n, t) {
  return t === void 0 && (t = {
    x: 0,
    y: 0
  }), {
    top: e.top - n.height - t.y,
    right: e.right - n.width + t.x,
    bottom: e.bottom - n.height + t.y,
    left: e.left - n.width - t.x
  };
}
function uf(e) {
  return [mn, Pn, On, pn].some(function(n) {
    return e[n] >= 0;
  });
}
function y0(e) {
  var n = e.state, t = e.name, a = n.rects.reference, l = n.rects.popper, r = n.modifiersData.preventOverflow, o = Kr(n, {
    elementContext: "reference"
  }), i = Kr(n, {
    altBoundary: !0
  }), s = df(o, a), d = df(i, l, r), u = uf(s), f = uf(d);
  n.modifiersData[t] = {
    referenceClippingOffsets: s,
    popperEscapeOffsets: d,
    isReferenceHidden: u,
    hasPopperEscaped: f
  }, n.attributes.popper = Object.assign({}, n.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": f
  });
}
const k0 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: y0
};
function w0(e, n, t) {
  var a = na(e), l = [pn, mn].indexOf(a) >= 0 ? -1 : 1, r = typeof t == "function" ? t(Object.assign({}, n, {
    placement: e
  })) : t, o = r[0], i = r[1];
  return o = o || 0, i = (i || 0) * l, [pn, Pn].indexOf(a) >= 0 ? {
    x: i,
    y: o
  } : {
    x: o,
    y: i
  };
}
function C0(e) {
  var n = e.state, t = e.options, a = e.name, l = t.offset, r = l === void 0 ? [0, 0] : l, o = eg.reduce(function(u, f) {
    return u[f] = w0(f, n.rects, r), u;
  }, {}), i = o[n.placement], s = i.x, d = i.y;
  n.modifiersData.popperOffsets != null && (n.modifiersData.popperOffsets.x += s, n.modifiersData.popperOffsets.y += d), n.modifiersData[a] = o;
}
const S0 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: C0
};
function $0(e) {
  var n = e.state, t = e.name;
  n.modifiersData[t] = ig({
    reference: n.rects.reference,
    element: n.rects.popper,
    placement: n.placement
  });
}
const I0 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: $0,
  data: {}
};
function L0(e) {
  return e === "x" ? "y" : "x";
}
function T0(e) {
  var n = e.state, t = e.options, a = e.name, l = t.mainAxis, r = l === void 0 ? !0 : l, o = t.altAxis, i = o === void 0 ? !1 : o, s = t.boundary, d = t.rootBoundary, u = t.altBoundary, f = t.padding, b = t.tether, h = b === void 0 ? !0 : b, p = t.tetherOffset, x = p === void 0 ? 0 : p, y = Kr(n, {
    boundary: s,
    rootBoundary: d,
    padding: f,
    altBoundary: u
  }), k = na(n.placement), $ = ql(n.placement), S = !$, T = zu(k), I = L0(T), A = n.modifiersData.popperOffsets, E = n.rects.reference, D = n.rects.popper, z = typeof x == "function" ? x(Object.assign({}, n.rects, {
    placement: n.placement
  })) : x, Y = typeof z == "number" ? {
    mainAxis: z,
    altAxis: z
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, z), le = n.modifiersData.offset ? n.modifiersData.offset[n.placement] : null, ne = {
    x: 0,
    y: 0
  };
  if (A) {
    if (r) {
      var re, O = T === "y" ? mn : pn, P = T === "y" ? On : Pn, V = T === "y" ? "height" : "width", M = A[T], B = M + y[O], q = M - y[P], N = h ? -D[V] / 2 : 0, G = $ === Hl ? E[V] : D[V], U = $ === Hl ? -D[V] : -E[V], K = n.elements.arrow, ge = h && K ? Du(K) : {
        width: 0,
        height: 0
      }, xe = n.modifiersData["arrow#persistent"] ? n.modifiersData["arrow#persistent"].padding : ag(), X = xe[O], ie = xe[P], he = Lr(0, E[V], ge[V]), oe = S ? E[V] / 2 - N - he - X - Y.mainAxis : G - he - X - Y.mainAxis, Ce = S ? -E[V] / 2 + N + he + ie + Y.mainAxis : U + he + ie + Y.mainAxis, H = n.elements.arrow && ho(n.elements.arrow), Z = H ? T === "y" ? H.clientTop || 0 : H.clientLeft || 0 : 0, ee = (re = le == null ? void 0 : le[T]) != null ? re : 0, J = M + oe - ee - Z, F = M + Ce - ee, _ = Lr(h ? oi(B, J) : B, M, h ? ul(q, F) : q);
      A[T] = _, ne[T] = _ - M;
    }
    if (i) {
      var ue, se = T === "x" ? mn : pn, Q = T === "x" ? On : Pn, ae = A[I], Te = I === "y" ? "height" : "width", Le = ae + y[se], pe = ae - y[Q], ke = [mn, pn].indexOf(k) !== -1, fe = (ue = le == null ? void 0 : le[I]) != null ? ue : 0, ze = ke ? Le : ae - E[Te] - D[Te] - fe + Y.altAxis, Ee = ke ? ae + E[Te] + D[Te] - fe - Y.altAxis : pe, He = h && ke ? Qx(ze, ae, Ee) : Lr(h ? ze : Le, ae, h ? Ee : pe);
      A[I] = He, ne[I] = He - ae;
    }
    n.modifiersData[a] = ne;
  }
}
const A0 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: T0,
  requiresIfExists: ["offset"]
};
function E0(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function R0(e) {
  return e === Cn(e) || !Rn(e) ? Ou(e) : E0(e);
}
function B0(e) {
  var n = e.getBoundingClientRect(), t = jl(n.width) / e.offsetWidth || 1, a = jl(n.height) / e.offsetHeight || 1;
  return t !== 1 || a !== 1;
}
function M0(e, n, t) {
  t === void 0 && (t = !1);
  var a = Rn(n), l = Rn(n) && B0(n), r = Ja(n), o = Wl(e, l, t), i = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = {
    x: 0,
    y: 0
  };
  return (a || !a && !t) && ((la(n) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Fu(r)) && (i = R0(n)), Rn(n) ? (s = Wl(n, !0), s.x += n.clientLeft, s.y += n.clientTop) : r && (s.x = Pu(r))), {
    x: o.left + i.scrollLeft - s.x,
    y: o.top + i.scrollTop - s.y,
    width: o.width,
    height: o.height
  };
}
function D0(e) {
  var n = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), a = [];
  e.forEach(function(r) {
    n.set(r.name, r);
  });
  function l(r) {
    t.add(r.name);
    var o = [].concat(r.requires || [], r.requiresIfExists || []);
    o.forEach(function(i) {
      if (!t.has(i)) {
        var s = n.get(i);
        s && l(s);
      }
    }), a.push(r);
  }
  return e.forEach(function(r) {
    t.has(r.name) || l(r);
  }), a;
}
function z0(e) {
  var n = D0(e);
  return Gx.reduce(function(t, a) {
    return t.concat(n.filter(function(l) {
      return l.phase === a;
    }));
  }, []);
}
function O0(e) {
  var n;
  return function() {
    return n || (n = new Promise(function(t) {
      Promise.resolve().then(function() {
        n = void 0, t(e());
      });
    })), n;
  };
}
function P0(e) {
  var n = e.reduce(function(t, a) {
    var l = t[a.name];
    return t[a.name] = l ? Object.assign({}, l, a, {
      options: Object.assign({}, l.options, a.options),
      data: Object.assign({}, l.data, a.data)
    }) : a, t;
  }, {});
  return Object.keys(n).map(function(t) {
    return n[t];
  });
}
var cf = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function ff() {
  for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++)
    n[t] = arguments[t];
  return !n.some(function(a) {
    return !(a && typeof a.getBoundingClientRect == "function");
  });
}
function F0(e) {
  e === void 0 && (e = {});
  var n = e, t = n.defaultModifiers, a = t === void 0 ? [] : t, l = n.defaultOptions, r = l === void 0 ? cf : l;
  return function(i, s, d) {
    d === void 0 && (d = r);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, cf, r),
      modifiersData: {},
      elements: {
        reference: i,
        popper: s
      },
      attributes: {},
      styles: {}
    }, f = [], b = !1, h = {
      state: u,
      setOptions: function(k) {
        var $ = typeof k == "function" ? k(u.options) : k;
        x(), u.options = Object.assign({}, r, u.options, $), u.scrollParents = {
          reference: ml(i) ? Tr(i) : i.contextElement ? Tr(i.contextElement) : [],
          popper: Tr(s)
        };
        var S = z0(P0([].concat(a, u.options.modifiers)));
        return u.orderedModifiers = S.filter(function(T) {
          return T.enabled;
        }), p(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!b) {
          var k = u.elements, $ = k.reference, S = k.popper;
          if (ff($, S)) {
            u.rects = {
              reference: M0($, ho(S), u.options.strategy === "fixed"),
              popper: Du(S)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(Y) {
              return u.modifiersData[Y.name] = Object.assign({}, Y.data);
            });
            for (var T = 0; T < u.orderedModifiers.length; T++) {
              if (u.reset === !0) {
                u.reset = !1, T = -1;
                continue;
              }
              var I = u.orderedModifiers[T], A = I.fn, E = I.options, D = E === void 0 ? {} : E, z = I.name;
              typeof A == "function" && (u = A({
                state: u,
                options: D,
                name: z,
                instance: h
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: O0(function() {
        return new Promise(function(y) {
          h.forceUpdate(), y(u);
        });
      }),
      destroy: function() {
        x(), b = !0;
      }
    };
    if (!ff(i, s))
      return h;
    h.setOptions(d).then(function(y) {
      !b && d.onFirstUpdate && d.onFirstUpdate(y);
    });
    function p() {
      u.orderedModifiers.forEach(function(y) {
        var k = y.name, $ = y.options, S = $ === void 0 ? {} : $, T = y.effect;
        if (typeof T == "function") {
          var I = T({
            state: u,
            name: k,
            instance: h,
            options: S
          }), A = function() {
          };
          f.push(I || A);
        }
      });
    }
    function x() {
      f.forEach(function(y) {
        return y();
      }), f = [];
    }
    return h;
  };
}
var V0 = [s0, I0, o0, Jx, S0, x0, A0, n0, k0], Xa = /* @__PURE__ */ F0({
  defaultModifiers: V0
});
const Ul = [];
function ra(e) {
  Ul.includes(e) || Ul.push(e);
}
function Fn(e) {
  const n = Ul.indexOf(e);
  n !== -1 && Ul.splice(n, 1);
}
function ya(e) {
  return Ul[Ul.length - 1] === e;
}
const Wn = er([]);
let sg = "";
function N0(e) {
  Wn.value.includes(e) || (Wn.value.length === 0 && (sg = document.body.style.overflow, document.body.style.overflow = "hidden"), Wn.value = [...Wn.value, e]);
}
function hf(e) {
  Wn.value.includes(e) && (Wn.value = Wn.value.filter((n) => n !== e), Wn.value.length === 0 && (document.body.style.overflow = sg));
}
const dg = {
  top: ["bottom"],
  bottom: ["top"],
  left: ["right", "top", "bottom"],
  right: ["left", "top", "bottom"]
}, ug = 8, ka = [
  "a[href]",
  "area[href]",
  "button:not([disabled])",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "iframe",
  "object",
  "embed",
  "[contenteditable]",
  "[tabindex]:not([tabindex^='-'])"
].join(",");
function Aa(e) {
  const n = Array.from(e.querySelectorAll(ka)).filter(
    (a) => a.offsetParent !== null && cg(a)
  ), t = H0(n);
  return n.filter((a) => !ii(a) || t.has(a));
}
function ii(e) {
  return e instanceof HTMLInputElement && e.type === "radio" && e.name !== "";
}
function Bd(e) {
  return e.form ?? e.getRootNode();
}
function bf(e, n) {
  return e === n ? !0 : !e || !ii(e) || !ii(n) ? !1 : e.name === n.name && Bd(e) === Bd(n);
}
function H0(e) {
  const n = /* @__PURE__ */ new Map();
  for (const a of e) {
    if (!ii(a)) continue;
    const l = Bd(a), r = n.get(l) ?? /* @__PURE__ */ new Map();
    r.set(a.name, [...r.get(a.name) ?? [], a]), n.set(l, r);
  }
  const t = /* @__PURE__ */ new Set();
  for (const a of n.values())
    for (const l of a.values()) t.add(l.find((r) => r.checked) ?? l[0]);
  return t;
}
function cg(e) {
  if (e.hasAttribute("disabled")) return !1;
  const n = e.getAttribute("tabindex");
  return n === null || !n.startsWith("-");
}
function j0(e) {
  return Array.from(e.querySelectorAll(ka)).filter(
    (n) => {
      var t;
      return (((t = n.checkVisibility) == null ? void 0 : t.call(n)) ?? !0) && cg(n);
    }
  );
}
const Md = "[data-focus-trap-allow-outside]", W0 = "data-focus-trap-return";
function gf(e) {
  return e instanceof Element && e.closest(Md) !== null;
}
const ur = [];
function ts(e) {
  const {
    active: n,
    container: t,
    autoFocus: a = !0,
    restoreFocus: l = !0,
    restoreFocusTo: r,
    containFocus: o = !1,
    allowOutsideElements: i
  } = e, s = Symbol("focus-trap");
  let d = null, u = null, f = null;
  const b = () => ur[ur.length - 1] === s;
  function h(A) {
    if (!b() || A.key !== "Tab" || !t.value) return;
    if (!t.value.contains(document.activeElement) && gf(document.activeElement)) {
      if (A.shiftKey) return;
      const le = document.activeElement.closest(
        Md
      ), ne = le ? Aa(le) : [];
      if (!(ne.length === 0 || document.activeElement === ne[ne.length - 1])) return;
      const O = Aa(t.value);
      if (O.length === 0) {
        A.preventDefault();
        return;
      }
      const P = f ? O.indexOf(f) : -1;
      A.preventDefault(), O[P === -1 ? 0 : (P + 1) % O.length].focus();
      return;
    }
    const E = Aa(t.value);
    if (E.length === 0) {
      A.preventDefault();
      return;
    }
    const D = E[0], z = E[E.length - 1], Y = document.activeElement;
    A.shiftKey ? (bf(Y, D) || !t.value.contains(Y)) && (A.preventDefault(), z.focus()) : bf(Y, z) && (A.preventDefault(), D.focus());
  }
  function p() {
    var A;
    t.value && ((A = Aa(t.value)[0]) == null || A.focus({ preventScroll: !0 }));
  }
  function x(A) {
    if (!b() || !t.value) return;
    const E = A.target;
    E && t.value.contains(E) && (f = E);
  }
  function y(A) {
    return gf(A) ? !0 : i ? i().some((E) => E && A && E.contains(A)) : !1;
  }
  function k(A) {
    if (!b() || !t.value) return;
    const E = A.target;
    E && t.value.contains(E) || y(E) || p();
  }
  function $(A) {
    !b() || A.relatedTarget !== null || requestAnimationFrame(() => {
      !n.value || !b() || !t.value || t.value.contains(document.activeElement) || y(document.activeElement) || p();
    });
  }
  function S() {
    o && (document.addEventListener("focusin", k), document.addEventListener("focusout", $));
  }
  function T() {
    document.removeEventListener("focusin", k), document.removeEventListener("focusout", $);
  }
  function I() {
    const A = ur.indexOf(s);
    A !== -1 && ur.splice(A, 1);
  }
  $e(n, (A) => {
    var E;
    if (A)
      ur.push(s), d = document.activeElement, u = ((E = d == null ? void 0 : d.closest(Md)) == null ? void 0 : E.getAttribute(W0)) ?? null, document.addEventListener("keydown", h), document.addEventListener("focusin", x), S(), a && requestAnimationFrame(() => {
        var z;
        if (!t.value || t.value.contains(document.activeElement) || y(document.activeElement)) return;
        (z = Aa(t.value)[0]) == null || z.focus();
      });
    else if (I(), document.removeEventListener("keydown", h), T(), document.removeEventListener("focusin", x), f = null, l) {
      const D = (d == null ? void 0 : d.isConnected) === !1 && u ? document.getElementById(u) : null, z = (r == null ? void 0 : r()) ?? D ?? d;
      z == null || z.focus(), d = null, u = null;
    }
  }, { immediate: !0 }), yt(() => {
    I(), document.removeEventListener("keydown", h), T(), document.removeEventListener("focusin", x);
  });
}
const q0 = ["id"], U0 = 100, G0 = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "Tooltip",
  props: {
    text: {},
    position: { default: "top" },
    delay: { default: 300 },
    disabled: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    as: { default: "div" },
    labelsTrigger: { type: Boolean, default: !1 }
  },
  setup(e, { expose: n }) {
    const t = e, a = qe(), l = R(null), r = R(null), o = R(null), i = R(!1), s = m(() => t.disabled ? !1 : t.open !== void 0 ? t.open : i.value);
    let d = null, u = null, f = null, b = null;
    const h = (re) => {
      if (re.nodeType === Node.TEXT_NODE) return re.textContent ?? "";
      if (!(re instanceof Element) || re.getAttribute("aria-hidden") === "true") return "";
      const O = re.getAttribute("aria-label");
      return O !== null ? O : [...re.childNodes].map(h).join(" ");
    }, p = () => {
      const re = l.value;
      if (!re) return null;
      const P = re.hasAttribute("tabindex") && re.getAttribute("tabindex") !== "-1" ? re : re.querySelector(ka) ?? re, V = (B) => B.trim().replace(/\s+/g, " ").toLowerCase(), M = P.getAttribute("aria-label") ?? [...P.childNodes].map(h).join(" ");
      return V(M) === V(t.text) ? null : P;
    }, x = (re) => {
      const O = (re.getAttribute("aria-describedby") ?? "").split(/\s+/).filter(Boolean);
      O.includes(a) || re.setAttribute("aria-describedby", [...O, a].join(" ")), b = re;
    }, y = () => {
      if (!b) return;
      const re = (b.getAttribute("aria-describedby") ?? "").split(/\s+/).filter((O) => O && O !== a);
      re.length ? b.setAttribute("aria-describedby", re.join(" ")) : b.removeAttribute("aria-describedby"), b = null;
    }, k = m(
      () => !t.labelsTrigger && !t.disabled && (t.open === void 0 || t.open)
    ), $ = () => {
      const re = k.value ? p() : null;
      re !== b && y(), re && x(re);
    };
    ct($), uo($), $e(k, $, { flush: "post" });
    const S = Symbol("tooltip"), T = (re) => {
      re.key !== "Escape" || re.defaultPrevented || ya(S) && ne(re);
    }, I = () => {
      document.removeEventListener("keydown", T), Fn(S);
    }, A = m(() => s.value && t.open === void 0);
    $e(A, (re) => {
      re ? (ra(S), document.addEventListener("keydown", T)) : I();
    });
    const E = () => {
      d == null || d.destroy(), d = null;
    };
    $e(s, async (re) => {
      re && (await Ge(), l.value && r.value && (E(), d = Xa(l.value, r.value, {
        // Fixed keeps the tooltip in the viewport layer so it does not expand
        // document scroll width/height (avoids double scrollbars with nested overflow:auto regions).
        strategy: "fixed",
        placement: t.position,
        modifiers: [
          {
            name: "offset",
            options: { offset: [0, 8] }
          },
          {
            name: "arrow",
            // Own class and an element ref, not the conventional `[data-popper-arrow]` /
            // `.tooltip-arrow` hooks: no global stylesheet aimed at those names can hide or redraw it.
            // Padding keeps the arrow off the corners when the bubble is shifted. At most
            // (36px one-line height - 16px arrow) / 2, or Popper pushes a left/right arrow off-centre.
            options: { element: o.value, padding: 10 }
          },
          {
            // Reflow at 320px (RGAA 10.11): when neither side has room, a left/right bubble moves
            // above or below instead of leaving the viewport.
            name: "flip",
            options: { fallbackPlacements: dg[t.position] }
          },
          {
            name: "preventOverflow",
            options: { padding: ug }
          }
        ]
      })));
    }, { immediate: !0 });
    const D = () => {
      f && (clearTimeout(f), f = null);
    }, z = () => {
      t.disabled || (D(), !(u || i.value) && (u = setTimeout(() => {
        i.value = !0, u = null;
      }, t.delay)));
    }, Y = () => {
      u && (clearTimeout(u), u = null), D(), i.value = !1;
    };
    $e(
      () => t.disabled,
      (re) => {
        var O;
        re ? Y() : (O = l.value) != null && O.contains(document.activeElement) && z();
      }
    );
    const le = () => {
      u && (clearTimeout(u), u = null), i.value && (D(), f = setTimeout(() => {
        i.value = !1, f = null;
      }, U0));
    }, ne = (re) => {
      t.open !== void 0 || !s.value || (re.stopPropagation(), re.preventDefault(), Y());
    };
    return n({ isVisible: s, hide: Y }), yt(() => {
      u && clearTimeout(u), f && clearTimeout(f), I(), y(), E();
    }), (re, O) => (c(), g(de, null, [
      (c(), W(it(e.as), Fe({
        ref_key: "triggerRef",
        ref: l,
        class: "inline-flex"
      }, re.$attrs, {
        onMouseenter: z,
        onMouseleave: le,
        onFocusin: z,
        onFocusout: Y,
        onKeydown: ht(ne, ["escape"])
      }), {
        default: ve(() => [
          Ae(re.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 16)),
      (c(), W(Nn, { to: "body" }, [
        e.labelsTrigger ? w("", !0) : (c(), g("span", {
          key: 0,
          id: L(a),
          hidden: ""
        }, j(e.text), 9, q0)),
        te(At, {
          name: "tooltip",
          onAfterLeave: E
        }, {
          default: ve(() => [
            s.value ? (c(), g("div", {
              key: 0,
              ref_key: "bubbleRef",
              ref: r,
              role: "tooltip",
              class: "tooltip-bubble fixed z-9999 rounded-(--border-border-radius-rounded-l) shadow-(--shadow-m) min-w-33.5 max-w-50 py-2 px-3 text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) wrap-break-word",
              onMouseenter: D,
              onMouseleave: le
            }, [
              nt(j(e.text) + " ", 1),
              v("div", {
                ref_key: "arrowRef",
                ref: o,
                class: "tooltip-pointer",
                "aria-hidden": "true"
              }, [...O[0] || (O[0] = [
                v("svg", {
                  width: "16",
                  height: "8",
                  viewBox: "0 0 16 8"
                }, [
                  v("path", { d: "M0 0L6.59 6.59A2 2 0 0 0 9.41 6.59L16 0Z" })
                ], -1)
              ])], 512)
            ], 544)) : w("", !0)
          ]),
          _: 1
        })
      ]))
    ], 64));
  }
}), dt = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [a, l] of n)
    t[a] = l;
  return t;
}, mt = /* @__PURE__ */ dt(G0, [["__scopeId", "data-v-82534dc2"]]);
function K0(e, n, t = "horizontal") {
  const a = R(!1);
  let l = null;
  function r() {
    const o = e.value;
    a.value = !!o && (t === "vertical" ? o.scrollHeight > o.clientHeight : o.scrollWidth > o.offsetWidth);
  }
  return $e(
    e,
    (o) => {
      if (l == null || l.disconnect(), l = null, !o) {
        a.value = !1;
        return;
      }
      typeof ResizeObserver < "u" && (l = new ResizeObserver(r), l.observe(o)), r();
    },
    { flush: "post" }
  ), $e(n, r, { flush: "post" }), yt(() => {
    l == null || l.disconnect(), l = null;
  }), { isTruncated: a };
}
const Y0 = ["id", "aria-hidden"], J0 = ["id", "aria-hidden"], pt = /* @__PURE__ */ ye({
  __name: "TruncatedText",
  props: {
    text: {},
    lines: { default: 1 },
    textClass: { default: "" },
    position: { default: "top" },
    focusable: { type: Boolean, default: !0 },
    open: { type: Boolean, default: void 0 }
  },
  setup(e, { expose: n }) {
    const t = e, a = R(null), { isTruncated: l } = K0(
      a,
      () => t.text,
      t.lines > 1 ? "vertical" : "horizontal"
    ), r = t.lines > 1 ? "line-clamp-2 break-words" : "truncate", o = R(!1), i = m(() => t.focusable && (l.value || o.value)), s = qe(), d = qe(), u = Hn();
    return n({ isTruncated: l, isTabStop: i }), (f, b) => (c(), W(mt, {
      as: "span",
      class: "w-full min-w-0 rounded-xs focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--border-border-accent)",
      text: e.text,
      position: e.position,
      disabled: !L(l),
      open: e.open,
      "labels-trigger": "",
      tabindex: i.value ? 0 : void 0,
      role: i.value ? "group" : void 0,
      "aria-labelledby": i.value ? L(u).default ? `${L(s)} ${L(d)}` : L(s) : void 0,
      onFocusin: b[0] || (b[0] = (h) => o.value = !0),
      onFocusout: b[1] || (b[1] = (h) => o.value = !1)
    }, {
      default: ve(() => [
        v("span", {
          id: L(s),
          ref_key: "textEl",
          ref: a,
          "data-testid": "truncated-text",
          "aria-hidden": i.value ? "true" : void 0,
          class: C(["w-full min-w-0", L(r), e.textClass])
        }, j(e.text), 11, Y0),
        L(u).default ? (c(), g("span", {
          key: 0,
          id: L(d),
          "aria-hidden": i.value ? "true" : void 0
        }, [
          Ae(f.$slots, "default")
        ], 8, J0)) : w("", !0)
      ]),
      _: 3
    }, 8, ["text", "position", "disabled", "open", "tabindex", "role", "aria-labelledby"]));
  }
}), X0 = ["src"], mf = /* @__PURE__ */ ye({
  __name: "AvatarCircle",
  props: {
    img: {},
    name: {},
    label: {},
    size: {},
    entity: {},
    avatarStyle: {},
    logo: { type: Boolean },
    presentational: { type: Boolean },
    as: {},
    imageError: { type: Boolean }
  },
  emits: ["image-error"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = {
      // 3xs / 2xs: Badge only. Figma shows them with a picture; initials and square radius keep the xs values.
      "3xs": { container: "h-3 w-3", text: "text-(length:--size-2xs) leading-(--line-height-xs)" },
      "2xs": { container: "h-3.5 w-3.5", text: "text-(length:--size-2xs) leading-(--line-height-xs)" },
      xs: { container: "h-[18px] w-[18px]", text: "text-(length:--size-2xs) leading-(--line-height-s)" },
      sm: { container: "h-6 w-6", text: "text-(length:--size-sm) leading-(--line-height-l)" },
      md: { container: "h-9 w-9", text: "text-(length:--size-m) leading-(--line-height-l)" },
      lg: { container: "h-11 w-11", text: "text-(length:--size-xl) leading-(--line-height-xxl)" },
      xl: { container: "h-14 w-14", text: "text-(length:--size-xxl) leading-(--line-height-xxl)" },
      "2xl": { container: "h-16 w-16", text: "text-(length:--size-4xl) leading-(--line-height-xxl)" }
    }, r = m(() => l[t.size]), o = {
      "3xs": "rounded-(--border-border-radius-rounded-xs)",
      "2xs": "rounded-(--border-border-radius-rounded-xs)",
      xs: "rounded-(--border-border-radius-rounded-xs)",
      sm: "rounded-(--border-border-radius-rounded-xs)",
      md: "rounded-(--border-border-radius-rounded-sm)",
      lg: "rounded-(--border-border-radius-rounded-sm)",
      xl: "rounded-(--border-border-radius-rounded-l)",
      "2xl": "rounded-(--border-border-radius-rounded-l)"
    }, i = m(() => t.logo && !!t.img && !t.imageError), s = m(
      () => i.value ? "avatar-container--logo bg-(--background-background-white)" : (
        // Figma "Avatar gradient" (4230:55188) as CSS: its gradientTransform is skewed, so the
        // colour runs at 85deg with stops at 10.83 % / 86.95 % (the 138deg handle line is not it).
        "bg-[linear-gradient(85deg,var(--colors-avatar-gradient-start)_10.83%,var(--colors-avatar-gradient-end)_86.95%)]"
      )
    ), d = m(
      () => t.avatarStyle === "square" ? o[t.size] : "rounded-full"
    ), u = (b) => b.normalize("NFD").replace(/[\u0300-\u036f]/g, "").charAt(0).toUpperCase(), f = m(() => {
      var x;
      const b = (x = t.name) == null ? void 0 : x.trim();
      if (!b)
        return "?";
      const h = b.split(/\s+/), p = t.entity === "organisation" ? 1 : 2;
      return h.slice(0, p).map(u).join("");
    });
    return (b, h) => (c(), W(it(t.as), {
      class: C(["avatar-container flex shrink-0 items-center justify-center overflow-hidden", [r.value.container, d.value, s.value]]),
      role: e.presentational ? void 0 : "img",
      "aria-hidden": e.presentational ? "true" : void 0,
      "aria-label": e.presentational ? void 0 : t.label
    }, {
      default: ve(() => [
        t.img && !t.imageError ? (c(), g("img", {
          key: 0,
          src: t.img,
          alt: "",
          class: C(["h-full w-full", t.logo ? "object-contain" : "object-cover"]),
          loading: "lazy",
          onError: h[0] || (h[0] = (p) => a("image-error"))
        }, null, 42, X0)) : (c(), g("span", {
          key: 1,
          "aria-hidden": "true",
          class: C(["font-(--weight-medium) text-(--text-text-body-subtle)", r.value.text])
        }, j(f.value), 3))
      ]),
      _: 1
    }, 8, ["class", "role", "aria-hidden", "aria-label"]));
  }
}), Z0 = ["aria-label"], Q0 = ["aria-label", "aria-disabled"], pf = "text-(length:--icon-size-xs)", Is = "text-(length:--size-sm)", vf = "text-(length:--icon-size-2xs)", _0 = "text-(length:--size-2xs)", xf = "absolute flex cursor-pointer items-center justify-center rounded-full focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l) before:absolute before:left-1/2 before:top-1/2 before:size-6 before:-translate-x-1/2 before:-translate-y-1/2 before:content-['']", Nt = /* @__PURE__ */ ye({
  __name: "Avatar",
  props: {
    img: { default: void 0 },
    name: {},
    email: { default: void 0 },
    size: { default: "md" },
    entity: { default: "contact" },
    avatarStyle: { default: "circle" },
    logo: { type: Boolean, default: !1 },
    presentational: { type: Boolean, default: !1 },
    as: { default: "div" },
    status: { default: void 0 },
    statusLabel: { default: void 0 },
    removable: { type: Boolean, default: !1 },
    removeLabel: { default: void 0 },
    editable: { type: Boolean, default: !1 },
    editLabel: { default: void 0 },
    editDisabled: { type: Boolean, default: !1 }
  },
  emits: ["remove", "edit"],
  setup(e, { emit: n }) {
    var k;
    const t = ($) => $ !== "3xs" && $ !== "2xs", a = e, l = n, r = R(!1);
    $e(
      () => a.img,
      () => {
        r.value = !1;
      }
    );
    const o = m(() => !t(a.size)), i = m(
      () => !o.value && (!!a.status || a.removable || a.editable)
    ), s = m(() => t(a.size) ? a.size : "xs"), d = m(
      () => {
        var $;
        return a.status && !o.value ? ($ = a.statusLabel) == null ? void 0 : $.trim() : void 0;
      }
    ), u = m(
      () => {
        var $;
        return [($ = a.name) == null ? void 0 : $.trim(), d.value].filter(Boolean).join(", ") || a.name;
      }
    ), f = m(() => ({
      img: a.img,
      name: a.name,
      label: u.value,
      size: a.size,
      entity: a.entity,
      avatarStyle: a.avatarStyle,
      logo: a.logo,
      presentational: a.presentational,
      imageError: r.value
    })), b = {
      online: "bg-(--icons-icon-success-subtle)",
      offline: "bg-(--icons-icon-error)",
      alternative: "bg-(--icons-icon-disabled-strong)"
    }, h = {
      xs: "size-1.5 top-[1px] -right-[2px]",
      sm: "size-2 top-[1px] -right-[2px]",
      md: "size-3 top-[1px] right-[1px]",
      lg: "size-3 top-[4px] -right-[3px]",
      xl: "size-4 top-[2px] -right-[2px]",
      "2xl": "size-4 top-[4px] -right-[1px]"
    }, p = {
      xs: { button: "size-3.5 -top-[2px] -right-[8px]", icon: vf },
      sm: { button: "size-3.5 -top-[2px] -right-[6px]", icon: vf },
      md: { button: "size-4 top-0 -right-[4px]", icon: Is },
      lg: { button: "size-4 top-[3px] -right-[6px]", icon: Is },
      xl: { button: "size-5 top-[1px] -right-[6px]", icon: pf },
      "2xl": { button: "size-5 top-[3px] -right-[5px]", icon: pf }
    }, x = {
      ...p,
      xs: { button: "size-3 -top-[2px] -right-[6px]", icon: _0 },
      md: { button: "size-4 top-0 -right-[2px]", icon: Is }
    };
    return typeof process < "u" && ((k = process.env) == null ? void 0 : k.NODE_ENV) !== "production" && $e(
      () => [
        a.status,
        a.statusLabel,
        a.removable,
        a.removeLabel,
        a.editable,
        a.editLabel,
        a.presentational,
        a.as,
        a.size
      ],
      () => {
        var S, T, I;
        const $ = (A) => console.warn(`[OPAL Avatar] ${A}`);
        a.status && !((S = a.statusLabel) != null && S.trim()) && $("`status` is set without `statusLabel`: assistive tech gets no presence text (WCAG 1.1.1 / 4.1.2)."), a.removable && !((T = a.removeLabel) != null && T.trim()) && $("`removable` is set without `removeLabel`: the remove button has no accessible name."), a.editable && !((I = a.editLabel) != null && I.trim()) && $("`editable` is set without `editLabel`: the edit button has no accessible name."), o.value && (a.status || a.removable || a.editable) && $(`size "${a.size}" shows no status dot, remove or edit button.`), a.removable && a.editable && $("`removable` and `editable` are both set; they share the same corner. Use one."), (a.removable || a.editable) && (a.presentational || a.as === "span") && $(
          '`removable`/`editable` with `presentational` or `as="span"` means the avatar sits inside another control: its buttons would be nested inside that control.'
        );
      },
      { immediate: !0 }
    ), ($, S) => i.value ? (c(), W(it(e.as), {
      key: 1,
      class: "relative flex w-fit shrink-0"
    }, {
      default: ve(() => [
        te(mf, Fe(f.value, {
          as: e.as === "span" ? "span" : "div",
          onImageError: S[1] || (S[1] = (T) => r.value = !0)
        }), null, 16, ["as"]),
        e.status ? (c(), g("span", {
          key: 0,
          class: C(["absolute rounded-full", [b[e.status], h[s.value]]]),
          "aria-hidden": "true",
          "data-testid": "avatar-status"
        }, null, 2)) : w("", !0),
        e.removable ? (c(), g("button", {
          key: 1,
          type: "button",
          class: C([
            xf,
            p[s.value].button,
            "bg-(--background-background-gray) text-(--icons-icon-dark-default)"
          ]),
          "aria-label": e.removeLabel,
          "data-testid": "avatar-remove",
          onClick: S[2] || (S[2] = Je((T) => l("remove"), ["stop"]))
        }, [
          v("i", {
            class: C(["ri-close-fill", p[s.value].icon]),
            "aria-hidden": "true"
          }, null, 2)
        ], 10, Z0)) : w("", !0),
        e.editable ? (c(), g("button", {
          key: 2,
          type: "button",
          class: C([
            xf,
            x[s.value].button,
            "border border-(--border-border-white-full) bg-(--background-background-white)",
            e.editDisabled ? "cursor-not-allowed text-(--icons-icon-disabled-strong)" : "text-(--icons-icon-dark-default) hover:border-transparent hover:text-(--icons-icon-hover)"
          ]),
          "aria-label": e.editLabel,
          "aria-disabled": e.editDisabled || void 0,
          "data-testid": "avatar-edit",
          onClick: S[3] || (S[3] = Je((T) => !e.editDisabled && l("edit"), ["stop"]))
        }, [
          v("i", {
            class: C(["ri-pencil-line", x[s.value].icon]),
            "aria-hidden": "true"
          }, null, 2)
        ], 10, Q0)) : w("", !0)
      ]),
      _: 1
    })) : (c(), W(mf, Fe({ key: 0 }, f.value, {
      as: e.as,
      onImageError: S[0] || (S[0] = (T) => r.value = !0)
    }), null, 16, ["as"]));
  }
}), ey = ["role", "aria-hidden"], ty = {
  class: "opal-spinner-rotate size-full",
  viewBox: "0 0 100 100",
  fill: "none",
  "aria-hidden": "true",
  focusable: "false"
}, ny = { key: 0 }, ay = ["x1", "y1", "x2", "y2"], ly = ["r", "stroke-width"], ry = ["d", "stroke", "stroke-width"], oy = {
  key: 0,
  class: "sr-only"
}, iy = { value: 0 }, sy = /* @__PURE__ */ ye({
  __name: "Spinner",
  props: {
    size: { default: "sm" },
    color: { default: "sky" },
    track: { type: Boolean, default: !0 },
    label: { default: void 0 }
  },
  setup(e) {
    const n = e, t = {
      xs: "size-(--spacing-3)",
      sm: "size-(--spacing-6)",
      md: "size-[50px]",
      base: "size-[75px]",
      lg: "size-[100px]",
      inherit: "size-[1em]"
    }, a = { r: 42.5, width: 15, arc: "M 49.834 7.5 A 42.5 42.5 0 0 1 92.458 48.107" }, l = { r: 45.459, width: 9.081, arc: "M 42.9 5.099 A 45.459 45.459 0 0 1 92.594 34.116" }, r = m(
      () => n.size === "md" || n.size === "base" || n.size === "lg" ? l : a
    ), o = {
      sky: {
        x1: 3.01,
        y1: 0,
        x2: 85.17,
        y2: -7.21,
        start: "--colors-spinner-sky-start",
        end: "--colors-spinner-sky-end"
      },
      primary: {
        x1: 0,
        y1: 50,
        x2: 100,
        y2: 50,
        start: "--colors-spinner-primary-start",
        end: "--colors-spinner-primary-end"
      }
    }, i = {
      sky: { x1: 42.76, y1: 0, x2: 91.22, y2: -4.43 },
      primary: { x1: 40.98, y1: 28.31, x2: 100, y2: 28.31 }
    }, s = `opal-spinner-${++iy.value}`, d = m(() => {
      if (n.color === "current") return;
      const y = o[n.color];
      return n.size === "xs" ? { ...y, ...i[n.color] } : y;
    }), u = m(() => d.value ? `url(#${s})` : "currentColor"), f = m(
      () => n.color === "current" ? "var(--spinner-track, transparent)" : "var(--colors-spinner-track)"
    ), b = 100, h = R("");
    let p;
    const x = m(() => {
      var y;
      return ((y = n.label) == null ? void 0 : y.trim()) || void 0;
    });
    return $e(
      x,
      (y) => {
        clearTimeout(p), h.value = "", y && (p = setTimeout(() => h.value = y, b));
      },
      { immediate: !0 }
    ), yt(() => clearTimeout(p)), (y, k) => (c(), g("span", {
      class: C(["inline-flex shrink-0 align-middle", t[e.size]]),
      role: x.value ? "status" : void 0,
      "aria-hidden": x.value ? void 0 : "true",
      "data-testid": "spinner"
    }, [
      (c(), g("svg", ty, [
        d.value ? (c(), g("defs", ny, [
          v("linearGradient", {
            id: s,
            gradientUnits: "userSpaceOnUse",
            x1: d.value.x1,
            y1: d.value.y1,
            x2: d.value.x2,
            y2: d.value.y2
          }, [
            v("stop", {
              offset: "0",
              style: je({ stopColor: `var(${d.value.start})` })
            }, null, 4),
            v("stop", {
              offset: "1",
              style: je({ stopColor: `var(${d.value.end})` })
            }, null, 4)
          ], 8, ay)
        ])) : w("", !0),
        e.track ? (c(), g("circle", {
          key: 1,
          cx: "50",
          cy: "50",
          r: r.value.r,
          "stroke-width": r.value.width,
          style: je({ stroke: f.value }),
          "data-testid": "spinner-track"
        }, null, 12, ly)) : w("", !0),
        v("path", {
          d: r.value.arc,
          stroke: u.value,
          "stroke-width": r.value.width,
          "stroke-linecap": "round",
          "data-testid": "spinner-arc"
        }, null, 8, ry)
      ])),
      x.value ? (c(), g("span", oy, j(h.value), 1)) : w("", !0)
    ], 10, ey));
  }
}), Vu = /* @__PURE__ */ dt(sy, [["__scopeId", "data-v-1ef84c80"]]);
function Gl(e) {
  return e.startsWith("ri-");
}
const dy = /^ri-[a-z0-9-]+$/, uy = new RegExp("^(?:\\p{Extended_Pictographic}[\\p{Emoji_Modifier}️]*(?:‍\\p{Extended_Pictographic}[\\p{Emoji_Modifier}️]*)*|\\p{Regional_Indicator}{2})$", "u");
function ko(e) {
  return dy.test(e) || uy.test(e);
}
const fg = {
  label: "",
  theme: "neutral",
  size: "sm",
  type: "default",
  badgeStyle: "rounded",
  leftIcon: void 0,
  rightIcon: void 0,
  showLeftIcon: !0,
  showCloseIcon: !1,
  removeLabel: void 0,
  closeIconInactive: !1,
  showText: !0,
  dropdownIcon: !1,
  secondaryText: "",
  avatarSrc: void 0,
  avatarAlt: void 0,
  iconOnly: !1,
  textOnly: !1,
  value: void 0,
  truncate: !1,
  truncationFocusable: !0,
  tooltipText: void 0
}, cy = {
  // Figma component `eudonet` 4728:62829.
  eudonet: [
    "M24.0709 0C23.1879 0 22.3161 0.0495821 21.4578 0.141985C33.4426 1.44915 42.7738 11.6315 42.7738 24C42.7738 36.3685 33.4448 46.5531 21.4578 47.858C22.3161 47.9527 23.1879 48 24.0709 48C37.287 48 48 37.2542 48 23.9977C48 10.7413 37.2847 0 24.0709 0Z",
    "M23.0574 8.97662C22.5046 8.97662 21.9586 9.00818 21.4216 9.06677C28.9239 9.88488 34.7636 16.2584 34.7636 24.0023C34.7636 31.7461 28.9239 38.1196 21.4216 38.9377C21.9586 38.9963 22.5046 39.0279 23.0574 39.0279C31.3303 39.0279 38.035 32.3005 38.035 24.0045C38.035 15.7085 31.3281 8.98113 23.0574 8.98113V8.97662Z",
    "M22.525 16.4297C22.2464 16.4297 21.9723 16.4455 21.7004 16.4748C25.4819 16.8872 28.4253 20.0988 28.4253 24.0022C28.4253 27.9057 25.4819 31.1173 21.7004 31.5297C21.9723 31.559 22.2464 31.5748 22.525 31.5748C26.6952 31.5748 30.0745 28.1852 30.0745 24.0022C30.0745 19.8193 26.6952 16.4297 22.525 16.4297Z",
    "M17.2874 41.3424C17.9255 41.3424 18.5547 41.3064 19.1748 41.2388C10.5154 40.2944 3.77474 32.9383 3.77474 24.0022C3.77474 15.0662 10.5154 7.70772 19.1748 6.76566C18.5547 6.69805 17.9255 6.66199 17.2874 6.66199C7.74047 6.66199 0 14.4261 0 24.0022C0 33.5783 7.74047 41.3424 17.2874 41.3424Z",
    "M19.4895 35.0478C19.8962 35.0478 20.2961 35.0252 20.6916 34.9824C15.1755 34.3806 10.8817 29.6951 10.8817 24.0022C10.8817 18.3093 15.1755 13.6215 20.6916 13.022C20.2961 12.9792 19.8962 12.9567 19.4895 12.9567C13.4072 12.9567 8.47534 17.9036 8.47534 24.0045C8.47534 30.1053 13.4072 35.0523 19.4895 35.0523V35.0478Z"
  ]
}, fy = {
  class: "size-full",
  viewBox: "0 0 48 48",
  fill: "currentColor",
  "aria-hidden": "true",
  focusable: "false",
  "data-testid": "badge-brand-icon"
}, hy = ["d"], by = {
  key: 5,
  class: "sr-only"
}, gy = ["aria-hidden"], my = { "aria-hidden": "true" }, py = ["id", "aria-hidden"], vy = ["id", "aria-hidden"], xy = ["aria-label"], yy = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "BadgeBase",
  props: /* @__PURE__ */ Gb({
    brandIcon: {},
    fitWidth: { type: Boolean },
    label: {},
    theme: {},
    size: {},
    type: {},
    badgeStyle: {},
    leftIcon: {},
    showLeftIcon: { type: Boolean },
    rightIcon: {},
    showCloseIcon: { type: Boolean },
    removeLabel: {},
    closeIconInactive: { type: Boolean },
    showText: { type: Boolean },
    dropdownIcon: { type: Boolean },
    secondaryText: {},
    avatarSrc: {},
    avatarAlt: {},
    iconOnly: { type: Boolean },
    textOnly: { type: Boolean },
    value: {},
    truncate: { type: Boolean },
    truncationFocusable: { type: Boolean },
    tooltipText: {}
  }, { ...fg, brandIcon: void 0, fitWidth: !1 }),
  emits: ["close"],
  setup(e, { emit: n }) {
    var N;
    const t = Gn(), a = m(() => {
      const { class: G, ...U } = t;
      return U;
    }), l = e, r = n, o = {
      disabled: {
        bg: "bg-(--components-badge-background-badge-disabled-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-disabled-strong-text)",
        icon: "text-(--components-badge-icon-badge-disabled-icon)",
        separator: "bg-(--components-badge-border-badge-white-default-border)",
        secondaryText: "text-(--components-badge-text-badge-disabled-strong-text)",
        dot: "bg-(--components-badge-background-badge-gray-bg)",
        dotText: "text-(--components-badge-text-badge-disabled-strong-text)",
        dotIcon: "text-(--components-badge-icon-badge-disabled-icon)",
        spinner: "text-(--components-badge-spinner-disabled-arc) [--spinner-track:var(--components-badge-spinner-disabled-track)]"
      },
      red: {
        bg: "bg-(--components-badge-background-badge-error-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-black-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-error-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-red-arc) [--spinner-track:var(--components-badge-spinner-red-track)]"
      },
      orange: {
        bg: "bg-(--components-badge-background-badge-orange-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--border-border-black-default)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-orange-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-icon)",
        spinner: "text-(--components-badge-spinner-orange-arc) [--spinner-track:var(--components-badge-spinner-orange-track)]"
      },
      yellow: {
        bg: "bg-(--components-badge-background-badge-yellow-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-yellow-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-yellow-arc) [--spinner-track:var(--components-badge-spinner-yellow-track)]"
      },
      green: {
        bg: "bg-(--components-badge-background-badge-green-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-green-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-green-arc) [--spinner-track:var(--components-badge-spinner-green-track)]"
      },
      indigo: {
        bg: "bg-(--components-badge-background-badge-indigo-soft-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-indigo-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-indigo-arc) [--spinner-track:var(--components-badge-spinner-indigo-track)]"
      },
      // OPAL-only (no Figma variant): accent fill with indigo text, Indigo's dot and spinner.
      active: {
        bg: "bg-(--components-badge-background-badge-accent-bg)",
        border: "",
        text: "text-(--components-badge-background-badge-indigo-strong-bg)",
        icon: "text-(--components-badge-background-badge-indigo-strong-bg)",
        separator: "bg-(--components-badge-background-badge-indigo-strong-bg)",
        secondaryText: "text-(--components-badge-background-badge-indigo-strong-bg)",
        dot: "bg-(--components-badge-background-badge-indigo-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-indigo-arc) [--spinner-track:var(--components-badge-spinner-indigo-track)]"
      },
      violet: {
        bg: "bg-(--components-badge-background-badge-violet-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-violet-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-violet-arc) [--spinner-track:var(--components-badge-spinner-violet-track)]"
      },
      purple: {
        bg: "bg-(--components-badge-background-badge-purple-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-purple-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-purple-arc) [--spinner-track:var(--components-badge-spinner-purple-track)]"
      },
      neutral: {
        bg: "bg-(--components-badge-background-badge-neutral-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-black-default-text)",
        dot: "bg-(--components-badge-background-badge-neutral-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-neutral-arc) [--spinner-track:var(--components-badge-spinner-neutral-track)]"
      },
      // Only theme with a dark fill: light text and icon on the fill, dark text once `with-dot` drops it.
      dark: {
        bg: "bg-(--components-badge-background-badge-dark-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-white-default-text)",
        icon: "text-(--components-badge-icon-badge-white-default-icon)",
        separator: "bg-(--components-badge-border-badge-base-soft-border)",
        secondaryText: "text-(--components-badge-text-badge-white-default-text)",
        dot: "bg-(--components-badge-background-badge-dark-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-dark-icon)",
        spinner: "text-(--components-badge-spinner-dark-arc) [--spinner-track:var(--components-badge-spinner-dark-track)]"
      },
      cyan: {
        bg: "bg-(--components-badge-background-badge-cyan-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-black-default-text)",
        dot: "bg-(--components-badge-background-badge-cyan-strong-bg)",
        dotText: "text-(--text-text-black-default)",
        dotIcon: "text-(--icons-icon-dark-default)",
        spinner: "text-(--components-badge-spinner-cyan-arc) [--spinner-track:var(--components-badge-spinner-cyan-track)]"
      },
      white: {
        bg: "bg-(--components-badge-background-badge-white-bg)",
        border: "border-(--components-badge-border-badge-base-soft-border)",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-base-soft-border)",
        secondaryText: "text-(--components-badge-text-badge-black-default-text)",
        dot: "bg-(--components-badge-background-badge-neutral-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-white-arc) [--spinner-track:var(--components-badge-spinner-white-track)]"
      },
      "gradient-light": {
        bg: "badge-gradient-light",
        border: "border-transparent",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-black-default-text)",
        dot: "badge-dot-gradient",
        dotText: "text-(--text-text-black-default)",
        dotIcon: "text-(--icons-icon-dark-default)",
        spinner: "text-(--components-badge-spinner-gradient-light-arc) [--spinner-track:var(--components-badge-spinner-gradient-light-track)]"
      }
    }, i = m(() => o[l.theme]), s = {
      xs: {
        padding: "gap-1 px-1 h-[18px]",
        withDot: "gap-1 px-1 min-h-5",
        compact: "px-1 min-w-5 h-[18px]",
        compactCircle: "px-1 min-w-[18px] h-[18px]",
        text: "text-(length:--size-xs) leading-(--line-height-s)",
        countText: "text-(length:--size-xs) leading-(--line-height-s)",
        icon: "size-2.5",
        glyph: "text-(length:--icon-size-2xs)",
        secondaryGap: "gap-1",
        separator: "h-2.5",
        avatar: "3xs"
      },
      sm: {
        padding: "gap-1 px-1 min-h-6",
        withDot: "gap-1 px-1 min-h-5",
        compact: "px-1 min-w-[22px] h-5",
        compactCircle: "px-1 min-w-[22px] h-[22px]",
        text: "text-(length:--size-sm) leading-(--line-height-l)",
        countText: "text-(length:--size-sm) leading-(--line-height-l)",
        icon: "size-3",
        glyph: "text-(length:--size-sm)",
        secondaryGap: "gap-1.5",
        separator: "h-3",
        avatar: "2xs"
      },
      lg: {
        padding: "gap-1.5 px-1.5 min-h-7",
        withDot: "gap-1.5 px-1.5 min-h-[22px]",
        compact: "px-1 min-w-[22px] h-6",
        compactCircle: "px-1 min-w-6 h-6",
        text: "text-(length:--size-m) leading-(--line-height-l)",
        countText: "text-(length:--size-sm) leading-(--line-height-l)",
        icon: "size-3.5",
        glyph: "text-(length:--icon-size-xs)",
        secondaryGap: "gap-2",
        separator: "h-3",
        avatar: "2xs"
      }
    }, d = m(() => l.iconOnly || l.textOnly), u = m(() => l.type === "with-dot" && !d.value), f = m(() => s[u.value && l.size === "xs" ? "sm" : l.size]), b = m(
      () => l.badgeStyle === "circle" ? "rounded-(--border-border-radius-rounded-full)" : "rounded-(--border-border-radius-rounded-xs)"
    ), h = m(() => {
      const G = i.value, U = f.value;
      let K = u.value ? U.withDot : U.padding;
      return d.value && (K = l.badgeStyle === "circle" ? U.compactCircle : U.compact), [
        "opal-badge inline-flex items-center justify-center font-inter whitespace-nowrap",
        b.value,
        u.value ? "bg-transparent" : [G.bg, G.border && ["border-solid border-[1px]", G.border]],
        u.value ? G.dotText : G.text,
        K
      ];
    }), p = m(() => [f.value.text, "font-(--weight-medium)", l.fitWidth && "min-w-0"]), x = m(() => [f.value.countText, "font-(--weight-medium)"]), y = m(() => [
      ...p.value,
      l.size === "xs" ? i.value.text : i.value.secondaryText
    ]), k = m(() => u.value ? i.value.dotIcon : i.value.icon), $ = m(() => !!l.leftIcon && Gl(l.leftIcon)), S = m(() => l.brandIcon ? cy[l.brandIcon] : void 0), T = m(
      () => (
        // Not a glyph (typo, extra classes): render nothing rather than the raw string as text.
        (!!S.value || !!l.leftIcon && ko(l.leftIcon)) && !l.textOnly && (l.iconOnly || l.showLeftIcon && ["default", "with-secondary-text", "with-dot"].includes(l.type))
      )
    ), I = m(() => !!l.rightIcon && Gl(l.rightIcon)), A = m(
      () => !!l.rightIcon && ko(l.rightIcon) && !d.value && ["default", "with-secondary-text", "with-dot"].includes(l.type)
    ), E = m(
      () => !d.value && l.showText && (!!l.label || l.type === "with-secondary-text" && !!l.secondaryText)
    ), D = m(() => l.showCloseIcon && !d.value && l.type !== "with-dot"), z = m(() => Array.from(l.label ?? "")), Y = m(() => l.truncate && !l.textOnly && z.value.length > 14), le = m(
      () => Y.value ? `${z.value.slice(0, 14).join("")}…` : l.label ?? ""
    ), ne = m(() => !!l.tooltipText || Y.value), re = (G, { slots: U }) => {
      var K;
      return (K = U.default) == null ? void 0 : K.call(U);
    }, O = m(() => l.truncationFocusable && Y.value), P = m(() => O.value && E.value), V = qe(), M = qe(), B = m(
      () => ne.value ? {
        text: l.tooltipText || l.label,
        labelsTrigger: P.value && !l.tooltipText,
        tabindex: O.value ? 0 : void 0,
        role: P.value ? "group" : void 0,
        "aria-labelledby": P.value ? l.type === "with-secondary-text" && l.secondaryText ? `${V} ${M}` : V : void 0,
        position: "top",
        as: "span"
      } : {}
    );
    return typeof process < "u" && ((N = process.env) == null ? void 0 : N.NODE_ENV) !== "production" && $e(
      () => [l.iconOnly, l.leftIcon, l.rightIcon, l.brandIcon, l.label, D.value, l.closeIconInactive, l.removeLabel],
      () => {
        var U, K;
        const G = (ge) => console.warn(`[OPAL Badge] ${ge}`);
        l.iconOnly && !l.leftIcon && !l.brandIcon && G("`iconOnly` is set without `leftIcon`: the badge renders empty."), l.leftIcon && !ko(l.leftIcon) && G(`\`leftIcon\` "${l.leftIcon}" is neither a single \`ri-*\` class nor an emoji: no icon is rendered.`), l.rightIcon && !ko(l.rightIcon) && G(`\`rightIcon\` "${l.rightIcon}" is neither a single \`ri-*\` class nor an emoji: no icon is rendered.`), l.iconOnly && !((U = l.label) != null && U.trim()) && G("`iconOnly` is set without `label`: the badge has no accessible name (WCAG 4.1.2)."), D.value && !l.closeIconInactive && !((K = l.removeLabel) != null && K.trim()) && G("`showCloseIcon` is set without `removeLabel`: the remove button has no accessible name.");
      },
      { immediate: !0 }
    ), (G, U) => (c(), W(it(ne.value ? mt : re), an(sn(B.value)), {
      default: ve(() => [
        v("span", Fe(a.value, {
          class: [h.value, L(t).class]
        }), [
          u.value ? (c(), g("span", {
            key: 0,
            class: C(["size-1.5 shrink-0 rounded-(--border-border-radius-rounded-full)", i.value.dot]),
            "aria-hidden": "true",
            "data-testid": "badge-dot"
          }, null, 2)) : w("", !0),
          e.type === "with-avatar" && !d.value ? (c(), W(Nt, {
            key: 1,
            img: e.avatarSrc,
            name: e.avatarAlt || e.label,
            size: f.value.avatar,
            presentational: !e.avatarAlt,
            as: "span",
            class: C({ "opacity-60": e.theme === "disabled" })
          }, null, 8, ["img", "name", "size", "presentational", "class"])) : w("", !0),
          e.type === "with-loader" && !d.value ? (c(), W(Vu, {
            key: 2,
            size: "xs",
            color: "current",
            class: C(i.value.spinner)
          }, null, 8, ["class"])) : w("", !0),
          T.value && S.value ? (c(), g("span", {
            key: 3,
            class: C([f.value.icon, "text-(--icons-icon-dark-default) shrink-0 inline-flex items-center justify-center"]),
            "aria-hidden": "true",
            "data-testid": "badge-left-icon"
          }, [
            (c(), g("svg", fy, [
              (c(!0), g(de, null, Re(S.value, (K, ge) => (c(), g("path", {
                key: ge,
                d: K
              }, null, 8, hy))), 128))
            ]))
          ], 2)) : T.value ? (c(), g("span", {
            key: 4,
            class: C([f.value.icon, f.value.glyph, k.value, "shrink-0 inline-flex items-center justify-center"]),
            "aria-hidden": "true",
            "data-testid": "badge-left-icon"
          }, [
            $.value ? (c(), g("i", {
              key: 0,
              class: C(e.leftIcon)
            }, null, 2)) : (c(), g(de, { key: 1 }, [
              nt(j(e.leftIcon), 1)
            ], 64))
          ], 2)) : w("", !0),
          e.iconOnly && e.label ? (c(), g("span", by, j(e.label), 1)) : w("", !0),
          e.textOnly ? (c(), g("span", {
            key: 6,
            class: C(x.value)
          }, j(e.value ?? e.label), 3)) : w("", !0),
          E.value ? (c(), g("span", {
            key: 7,
            class: C(e.type === "with-secondary-text" ? ["inline-flex items-center", f.value.secondaryGap] : "contents")
          }, [
            v("span", {
              class: C(p.value),
              "aria-hidden": P.value ? "true" : void 0
            }, [
              Y.value ? (c(), g(de, { key: 0 }, [
                v("span", my, j(le.value), 1),
                v("span", {
                  id: L(V),
                  class: "sr-only",
                  "aria-hidden": P.value ? "true" : void 0
                }, j(e.label), 9, py)
              ], 64)) : e.fitWidth ? (c(), W(pt, {
                key: 1,
                text: e.label ?? "",
                focusable: !1
              }, null, 8, ["text"])) : (c(), g(de, { key: 2 }, [
                nt(j(e.label), 1)
              ], 64))
            ], 10, gy),
            e.type === "with-secondary-text" ? (c(), g(de, { key: 0 }, [
              v("span", {
                class: C(["w-px shrink-0", f.value.separator, i.value.separator]),
                "aria-hidden": "true",
                "data-testid": "badge-separator"
              }, null, 2),
              v("span", {
                id: L(M),
                class: C(y.value),
                "aria-hidden": P.value ? "true" : void 0
              }, j(e.secondaryText), 11, vy)
            ], 64)) : w("", !0)
          ], 2)) : w("", !0),
          A.value ? (c(), g("span", {
            key: 8,
            class: C([f.value.icon, f.value.glyph, k.value, "shrink-0 inline-flex items-center justify-center"]),
            "aria-hidden": "true",
            "data-testid": "badge-right-icon"
          }, [
            I.value ? (c(), g("i", {
              key: 0,
              class: C(e.rightIcon)
            }, null, 2)) : (c(), g(de, { key: 1 }, [
              nt(j(e.rightIcon), 1)
            ], 64))
          ], 2)) : w("", !0),
          D.value && e.closeIconInactive ? (c(), g("span", {
            key: 9,
            class: C([f.value.icon, f.value.glyph, k.value, "shrink-0 inline-flex items-center justify-center"]),
            "aria-hidden": "true",
            "data-testid": "badge-close-icon"
          }, [...U[3] || (U[3] = [
            v("i", { class: "ri-close-fill" }, null, -1)
          ])], 2)) : D.value ? (c(), g("button", {
            key: 10,
            type: "button",
            class: C([
              f.value.icon,
              f.value.glyph,
              k.value,
              "relative shrink-0 inline-flex items-center justify-center cursor-pointer bg-transparent border-none p-0",
              "rounded-(--border-border-radius-rounded-xs) hover:opacity-70 transition-opacity",
              "focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)",
              "before:absolute before:left-1/2 before:top-1/2 before:size-6 before:-translate-x-1/2 before:-translate-y-1/2 before:content-['']"
            ]),
            "aria-label": e.removeLabel,
            onClick: U[0] || (U[0] = Je((K) => r("close"), ["stop"])),
            onKeydown: [
              U[1] || (U[1] = ht(Je(() => {
              }, ["stop"]), ["enter"])),
              U[2] || (U[2] = ht(Je(() => {
              }, ["stop"]), ["space"]))
            ]
          }, [...U[4] || (U[4] = [
            v("i", {
              class: "ri-close-fill",
              "aria-hidden": "true"
            }, null, -1)
          ])], 42, xy)) : w("", !0),
          e.dropdownIcon && !d.value ? (c(), g("span", {
            key: 11,
            class: C([k.value, "size-3 shrink-0 inline-flex items-center justify-center text-(length:--size-sm)"]),
            "aria-hidden": "true",
            "data-testid": "badge-chevron"
          }, [...U[5] || (U[5] = [
            v("i", { class: "ri-arrow-down-s-line" }, null, -1)
          ])], 2)) : w("", !0),
          U[6] || (U[6] = v("span", { class: "sr-only" }, " ", -1))
        ], 16)
      ]),
      _: 1
    }, 16));
  }
}), Nu = /* @__PURE__ */ dt(yy, [["__scopeId", "data-v-05eecf91"]]), gt = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "Badge",
  props: /* @__PURE__ */ Gb({
    label: {},
    theme: {},
    size: {},
    type: {},
    badgeStyle: {},
    leftIcon: {},
    showLeftIcon: { type: Boolean },
    rightIcon: {},
    showCloseIcon: { type: Boolean },
    removeLabel: {},
    closeIconInactive: { type: Boolean },
    showText: { type: Boolean },
    dropdownIcon: { type: Boolean },
    secondaryText: {},
    avatarSrc: {},
    avatarAlt: {},
    iconOnly: { type: Boolean },
    textOnly: { type: Boolean },
    value: {},
    truncate: { type: Boolean },
    truncationFocusable: { type: Boolean },
    tooltipText: {}
  }, fg),
  emits: ["close"],
  setup(e, { emit: n }) {
    const t = Gn(), a = m(() => {
      const { brandIcon: o, "brand-icon": i, ...s } = t;
      return s;
    }), l = e, r = n;
    return (o, i) => (c(), W(Nu, Fe({ ...a.value, ...l }, {
      onClose: i[0] || (i[0] = (s) => r("close"))
    }), null, 16));
  }
}), ky = ["id"], wy = {
  key: 1,
  class: "sr-only",
  "data-testid": "badge-overflow-names"
}, Hu = /* @__PURE__ */ ye({
  __name: "BadgeOverflow",
  props: {
    label: {},
    hiddenLabels: {},
    theme: { default: "neutral" },
    size: { default: "sm" },
    focusable: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = e, t = qe();
    return (a, l) => (c(), W(mt, {
      text: n.hiddenLabels.join(", "),
      as: "span",
      position: "top",
      tabindex: e.focusable ? 0 : void 0,
      role: e.focusable ? "group" : void 0,
      "aria-labelledby": e.focusable ? L(t) : void 0,
      "data-testid": "badge-overflow"
    }, {
      default: ve(() => [
        e.focusable ? (c(), g("span", {
          key: 0,
          id: L(t),
          hidden: ""
        }, j(e.label), 9, ky)) : w("", !0),
        te(gt, {
          label: e.label,
          theme: e.theme,
          size: e.size,
          "show-left-icon": !1,
          "show-close-icon": !1,
          "aria-hidden": e.focusable ? "true" : void 0
        }, null, 8, ["label", "theme", "size", "aria-hidden"]),
        e.focusable ? w("", !0) : (c(), g("span", wy, ": " + j(n.hiddenLabels.join(", ")), 1))
      ]),
      _: 1
    }, 8, ["text", "tabindex", "role", "aria-labelledby"]));
  }
});
function ju(e) {
  return "hiddenLabels" in e;
}
function Wu(e, n) {
  const t = Number.isFinite(n) ? Math.max(0, Math.floor(n)) : e.length, a = e.slice(0, t), l = e.slice(a.length);
  return l.length > 0 ? [...a, { label: `+${l.length}`, hiddenLabels: l.map((r) => r.label) }] : a;
}
const Cy = /* @__PURE__ */ ye({
  __name: "IconShape",
  props: {
    color: {},
    size: { default: "md" },
    type: { default: "square" },
    variant: { default: "filled" },
    icon: { default: void 0 },
    label: { default: void 0 },
    as: { default: "div" }
  },
  setup(e) {
    const n = e, t = {
      xs: "h-4 w-4",
      sm: "h-6 w-6",
      md: "h-9 w-9",
      lg: "h-12 w-12",
      xl: "h-16 w-16",
      "2xl": "h-24 w-24"
    }, a = {
      xs: "rounded-(--border-border-radius-rounded-xs)",
      sm: "rounded-(--border-border-radius-rounded-xs)",
      md: "rounded-(--border-border-radius-rounded-sm)",
      lg: "rounded-(--border-border-radius-rounded-sm)",
      xl: "rounded-(--border-border-radius-rounded-l)",
      "2xl": "rounded-(--border-border-radius-rounded-l)"
    }, l = {
      xs: "border-(length:--border-border-width-border)",
      sm: "border-(length:--border-border-width-border)",
      md: "border-(length:--border-border-width-border-sm)",
      lg: "border-(length:--border-border-width-border-sm)",
      xl: "border-(length:--border-border-width-border-sm)",
      "2xl": "border-(length:--border-border-width-border-sm)"
    }, r = {
      xs: "text-(length:--icon-size-2xs)",
      sm: "text-(length:--icon-size-sm)",
      md: "text-(length:--icon-size-md)",
      lg: "text-(length:--icon-size-xl)",
      xl: "text-(length:--icon-size-2xl)",
      "2xl": "text-(length:--icon-size-3xl)"
    }, o = {
      xs: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)",
      sm: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)",
      md: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)",
      lg: "text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold)",
      xl: "text-(length:--size-xxl) leading-(--line-height-xxl) font-(--weight-bold)",
      "2xl": "text-(length:--size-6xl) leading-(--line-height-6xl) font-(--weight-bold)"
    }, i = {
      red: { bg: "bg-(--components-icon-shape-background-iconshape-red-bg)", icon: "text-(--components-icon-shape-icon-iconshape-red-icon)" },
      orange: { bg: "bg-(--components-icon-shape-background-iconshape-orange-bg)", icon: "text-(--components-icon-shape-icon-iconshape-orange-icon)" },
      yellow: { bg: "bg-(--components-icon-shape-background-iconshape-yellow-bg)", icon: "text-(--components-icon-shape-icon-iconshape-yellow-icon)" },
      green: { bg: "bg-(--components-icon-shape-background-iconshape-green-bg)", icon: "text-(--components-icon-shape-icon-iconshape-success-icon)" },
      purple: { bg: "bg-(--components-icon-shape-background-iconshape-purple-bg)", icon: "text-(--components-icon-shape-icon-iconshape-purple-icon)" },
      violet: { bg: "bg-(--components-icon-shape-background-iconshape-violet-bg)", icon: "text-(--components-icon-shape-icon-iconshape-violet-icon)" },
      indigo: { bg: "bg-(--components-icon-shape-background-iconshape-indigo-bg)", icon: "text-(--components-icon-shape-icon-iconshape-indigo-icon)" },
      dark: { bg: "bg-(--components-icon-shape-background-iconshape-black-bg)", icon: "text-(--components-icon-shape-icon-iconshape-white-icon)" },
      white: { bg: "bg-(--components-icon-shape-background-iconshape-white-bg)", icon: "text-(--components-icon-shape-icon-iconshape-black-icon)" },
      default: { bg: "bg-(--components-icon-shape-background-iconshape-cyan-bg)", icon: "text-(--components-icon-shape-icon-iconshape-default-icon)", text: "text-(--components-icon-shape-text-iconshape-default-text)" },
      success: { bg: "bg-(--components-icon-shape-background-iconshape-success-bg)", icon: "text-(--components-icon-shape-icon-iconshape-white-default-icon)" },
      error: { bg: "bg-(--components-icon-shape-background-iconshape-error-bg)", icon: "text-(--components-icon-shape-icon-iconshape-white-default-icon)" },
      text: {
        bg: "bg-(--components-icon-shape-background-iconshape-black-default-bg)",
        icon: "text-(--components-icon-shape-text-iconshape-white-default-text)",
        text: "text-(--components-icon-shape-text-iconshape-white-default-text)"
      },
      disabled: {
        bg: "bg-(--components-icon-shape-background-iconshape-disabled-bg)",
        border: "border-(--components-icon-shape-border-iconshape-disabled-border)",
        icon: "text-(--components-icon-shape-icon-iconshape-disabled-strong-icon)",
        text: "text-(--components-icon-shape-text-iconshape-disabled-text)"
      },
      gradient: { icon: "text-(--components-icon-shape-icon-iconshape-white-icon)", text: "text-(--components-icon-shape-text-iconshape-white-default-text)" },
      "sunny-gradient": {
        icon: "text-(--components-icon-shape-icon-iconshape-accent-gradient-icon)",
        text: "text-(--components-icon-shape-text-iconshape-accent-gradient-text)"
      }
    }, s = {
      ...i,
      red: { icon: "text-(--components-icon-shape-icon-iconshape-red-icon)" },
      orange: { icon: "text-(--components-icon-shape-icon-iconshape-orange-icon)" },
      yellow: { icon: "text-(--components-icon-shape-icon-iconshape-yellow-icon)" },
      green: { icon: "text-(--components-icon-shape-icon-iconshape-green-icon)" },
      purple: { icon: "text-(--components-icon-shape-icon-iconshape-purple-icon)" },
      violet: { icon: "text-(--components-icon-shape-icon-iconshape-violet-icon)" },
      indigo: { icon: "text-(--components-icon-shape-icon-iconshape-indigo-icon)" },
      white: { icon: "text-(--components-icon-shape-icon-iconshape-black-icon)" },
      default: { icon: "text-(--components-icon-shape-icon-iconshape-default-icon)", text: "text-(--components-icon-shape-text-iconshape-default-text)" },
      success: { border: "border-(--components-icon-shape-border-iconshape-success-border)", icon: "text-(--components-icon-shape-icon-iconshape-success-icon)" },
      error: { border: "border-(--components-icon-shape-border-iconshape-error-border)", icon: "text-(--components-icon-shape-icon-iconshape-error-icon)" },
      text: { icon: "text-(--components-icon-shape-text-iconshape-black-default-text)", text: "text-(--components-icon-shape-text-iconshape-black-default-text)" },
      disabled: {
        border: "border-(--components-icon-shape-border-iconshape-disabled-border)",
        icon: "text-(--components-icon-shape-icon-iconshape-disabled-strong-icon)",
        text: "text-(--components-icon-shape-text-iconshape-disabled-text)"
      },
      gradient: { icon: "text-(--components-icon-shape-icon-iconshape-brand-icon)", text: "text-(--components-icon-shape-text-iconshape-black-default-text)" }
    }, d = m(
      () => n.color === "white" || n.variant === "outlined" && n.color !== "dark"
    ), u = m(() => (d.value ? s : i)[n.color]), f = m(() => !n.icon && n.label !== void 0), b = m(() => !!n.icon && Gl(n.icon)), h = m(() => {
      if (n.color === "gradient") return "var(--gradient-brand-border)";
      if (n.color === "sunny-gradient" && d.value) return "var(--gradient-sunny)";
    }), p = m(() => {
      if (h.value) {
        const y = d.value ? "var(--components-icon-shape-background-iconshape-white-bg)" : "var(--components-icon-shape-background-iconshape-black-default-bg)";
        return { backgroundImage: `linear-gradient(${y}, ${y}), ${h.value}` };
      }
      if (n.color === "sunny-gradient") return { backgroundImage: "var(--gradient-sunny)" };
    }), x = m(() => {
      const y = u.value;
      return [
        t[n.size],
        n.type === "circle" ? "rounded-(--border-border-radius-rounded-full)" : a[n.size],
        "border-solid",
        l[n.size],
        h.value ? "icon-shape-gradient-ring border-transparent" : y.border ?? "border-(--components-icon-shape-border-iconshape-default-border)",
        h.value || n.color === "sunny-gradient" ? void 0 : y.bg ?? "bg-(--components-icon-shape-background-iconshape-white-bg)",
        f.value && y.text ? y.text : y.icon
      ];
    });
    return (y, k) => (c(), W(it(e.as), {
      class: C(["flex shrink-0 items-center justify-center", x.value]),
      style: je(p.value),
      "aria-hidden": "true",
      "data-testid": "icon-shape"
    }, {
      default: ve(() => [
        b.value ? (c(), g("i", {
          key: 0,
          class: C([e.icon, r[e.size], "leading-none"])
        }, null, 2)) : e.icon ? (c(), g("span", {
          key: 1,
          class: C([r[e.size], "leading-none", e.color === "disabled" && "opacity-50"])
        }, j(e.icon), 3)) : e.label !== void 0 ? (c(), g("span", {
          key: 2,
          class: C(["font-inter whitespace-nowrap", o[e.size]])
        }, j(e.label), 3)) : w("", !0)
      ]),
      _: 1
    }, 8, ["class", "style"]));
  }
}), Gt = /* @__PURE__ */ dt(Cy, [["__scopeId", "data-v-3fd4680f"]]), qu = Symbol("CheckboxGroupErrorId");
function hg(e) {
  const n = Kt(qu, void 0);
  return m(() => {
    const t = [...e(), n == null ? void 0 : n.value].filter(Boolean);
    return t.length > 0 ? t.join(" ") : void 0;
  });
}
function Sy() {
  dn(qu, m(() => {
  }));
}
const Ls = "opal:checked-resync";
function $y(e) {
  if (e.type !== "radio" || e.name === "") return [e];
  const n = e.getRootNode();
  return Array.from(n.querySelectorAll('input[type="radio"]')).filter(
    (t) => t.name === e.name && t.form === e.form
  );
}
function ns(e, n, t = () => !1) {
  const a = () => {
    e.value && (e.value.checked = n(), e.value.indeterminate = t());
  };
  $e(
    e,
    (r, o, i) => {
      r && (r.addEventListener(Ls, a), i(() => r.removeEventListener(Ls, a)));
    },
    { immediate: !0, flush: "post" }
  );
  function l() {
    const r = e.value;
    r && Ge(() => {
      for (const o of $y(r)) o.dispatchEvent(new Event(Ls));
    });
  }
  return { resync: l };
}
const bg = "mb-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-heading) dark:text-(--colors-text-white-default)", gg = "flex items-center gap-1 text-(length:--size-sm) leading-(--line-height-m) text-(--text-text-error-strong) dark:text-(--text-text-error)", mg = "ri-error-warning-fill text-(--text-text-error-strong) dark:text-(--text-text-error)", Iy = ["id", "name", "checked", "disabled", "indeterminate", "value", "aria-label", "aria-labelledby", "aria-describedby", "aria-invalid", "aria-disabled"], Ly = ["for"], Ty = ["for"], Ay = {
  key: 0,
  class: "absolute left-1/2 top-1/2 size-6 -translate-x-1/2 -translate-y-1/2",
  "data-testid": "checkbox-hit-area"
}, Ey = ["for"], Ry = ["for"], By = ["id"], Bn = /* @__PURE__ */ ye({
  __name: "Checkbox",
  props: {
    label: { default: void 0 },
    modelValue: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    indeterminate: { type: Boolean, default: !1 },
    labelPosition: { default: "right" },
    variant: { default: "default" },
    labelWrap: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    value: { type: [String, Number, Boolean], default: void 0 },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaDescribedby: { default: void 0 },
    error: { default: void 0 },
    presentational: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: n }) {
    const t = e, a = m(() => t.disabled || t.ariaDisabled), l = qe(), r = m(() => t.id ?? l), o = m(() => `${r.value}-error`), i = m(() => !!t.error && !t.presentational), s = m(() => t.presentational ? "span" : "div"), d = hg(() => [
      t.ariaDescribedby,
      i.value ? o.value : void 0
    ]), u = n, f = R(null), { resync: b } = ns(
      f,
      () => t.modelValue,
      () => t.indeterminate
    ), h = m(() => t.modelValue || t.indeterminate), p = m(
      () => !t.presentational && !!t.label && (t.labelPosition === "left" || t.labelPosition === "right")
    ), x = m(() => {
      const E = "relative size-4 shrink-0 box-border flex items-center justify-center rounded-(--border-border-radius-rounded-xs) border border-solid transition-all duration-200 motion-reduce:transition-none peer-focus-visible:shadow-(--shadow-focus-l) peer-focus-visible:outline-2 peer-focus-visible:outline-transparent" + (p.value ? " mt-0.5" : ""), D = h.value ? "" : " peer-focus-visible:border-(--border-border-hover)";
      if (a.value)
        return `${E} bg-(--background-background-disabled-strong) border-(--border-border-disabled) cursor-not-allowed`;
      if (t.variant === "dark") {
        const z = h.value ? "bg-(--background-background-black-default)" : "bg-transparent";
        return `${E} ${z} border-(--border-border-white-full) cursor-pointer${D}`;
      }
      return h.value ? t.variant === "light" ? `${E} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-white-default) dark:border-(--border-border-base) cursor-pointer` : `${E} bg-(--background-background-black-default) border-(--border-border-base) cursor-pointer` : `${E} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) cursor-pointer${D}`;
    }), y = m(() => {
      const A = `${t.indeterminate ? "ri-subtract-fill" : "ri-check-fill"} text-(length:--size-l) leading-none forced-colors:forced-color-adjust-none`;
      return a.value ? `${A} text-(--icons-icon-disabled-strong) forced-colors:text-[GrayText]` : t.variant === "light" ? `${A} text-(--icons-icon-black) dark:text-(--icons-icon-white-default) forced-colors:text-[CanvasText]` : `${A} text-(--icons-icon-white-default) forced-colors:text-[CanvasText]`;
    }), k = m(() => {
      let A = "relative flex text-left font-inter text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) select-none";
      return t.labelPosition === "top" || t.labelPosition === "bottom" ? A += " flex-col items-center gap-2 w-auto" : A += p.value ? " flex-row items-start gap-2 w-full min-w-0" : " flex-row items-center gap-2 w-full min-w-0", p.value && (A += " min-h-6 px-px py-0.5"), i.value && (A += " flex-wrap"), t.presentational && (A += " pointer-events-none"), a.value ? `${A} text-(--text-text-disabled-strong) dark:text-(--colors-text-disabled)` : t.variant === "dark" ? `${A} text-(--text-text-white-default)` : `${A} text-(--text-text-heading) dark:text-(--text-text-white-default)`;
    }), $ = m(() => {
      const A = "relative cursor-pointer flex-1 min-w-0";
      return t.labelWrap ? `${A} break-words` : A;
    }), S = (A) => {
      A.stopPropagation(), t.ariaDisabled && A.preventDefault();
    }, T = (A) => {
      if (A.preventDefault(), A.stopPropagation(), a.value) return;
      const E = !t.modelValue;
      u("update:modelValue", E), u("change", A);
    }, I = (A) => {
      if (a.value) return;
      const E = A.target;
      u("update:modelValue", E.checked), u("change", A), b();
    };
    return (A, E) => (c(), W(it(s.value), Fe({
      class: k.value,
      "data-testid": "checkbox-container"
    }, Nl(e.presentational ? {} : { click: T })), {
      default: ve(() => [
        e.presentational ? w("", !0) : (c(), g("input", {
          key: 0,
          id: r.value,
          ref_key: "inputRef",
          ref: f,
          name: e.name,
          type: "checkbox",
          checked: e.modelValue,
          disabled: e.disabled,
          indeterminate: e.indeterminate || void 0,
          value: e.value,
          "aria-label": e.ariaLabel,
          "aria-labelledby": e.ariaLabelledby,
          "aria-describedby": L(d),
          "aria-invalid": i.value ? "true" : void 0,
          "aria-disabled": e.ariaDisabled && !e.disabled ? "true" : void 0,
          class: "peer sr-only pointer-events-none",
          onChange: I,
          onClick: S
        }, null, 40, Iy)),
        e.label && e.labelPosition === "top" ? (c(), g("label", {
          key: 1,
          for: r.value,
          class: "relative cursor-pointer text-center"
        }, j(e.label), 9, Ly)) : w("", !0),
        e.label && e.labelPosition === "left" ? (c(), g("label", {
          key: 2,
          for: r.value,
          class: C($.value)
        }, [
          e.labelWrap ? (c(), g(de, { key: 0 }, [
            nt(j(e.label), 1)
          ], 64)) : (c(), W(pt, {
            key: 1,
            text: e.label,
            focusable: !1
          }, null, 8, ["text"]))
        ], 10, Ty)) : w("", !0),
        (c(), W(it(s.value), {
          class: C(x.value),
          "data-testid": "checkbox-box",
          "aria-hidden": "true"
        }, {
          default: ve(() => [
            e.presentational ? w("", !0) : (c(), g("span", Ay)),
            e.indeterminate || e.modelValue ? (c(), g("i", {
              key: 1,
              class: C(y.value),
              "aria-hidden": "true"
            }, null, 2)) : w("", !0)
          ]),
          _: 1
        }, 8, ["class"])),
        e.label && e.labelPosition === "right" ? (c(), g("label", {
          key: 3,
          for: r.value,
          class: C($.value)
        }, [
          e.labelWrap ? (c(), g(de, { key: 0 }, [
            nt(j(e.label), 1)
          ], 64)) : (c(), W(pt, {
            key: 1,
            text: e.label,
            focusable: !1
          }, null, 8, ["text"]))
        ], 10, Ey)) : w("", !0),
        e.label && e.labelPosition === "bottom" ? (c(), g("label", {
          key: 4,
          for: r.value,
          class: "relative cursor-pointer text-center"
        }, j(e.label), 9, Ry)) : w("", !0),
        i.value ? (c(), g("div", {
          key: 5,
          id: o.value,
          "data-testid": "checkbox-error",
          class: C(["basis-full self-stretch", L(gg)]),
          role: "alert",
          onClick: E[0] || (E[0] = Je(() => {
          }, ["stop"]))
        }, [
          v("i", {
            class: C(L(mg)),
            "aria-hidden": "true"
          }, null, 2),
          v("span", null, j(e.error), 1)
        ], 10, By)) : w("", !0)
      ]),
      _: 1
    }, 16, ["class"]));
  }
}), My = {
  key: 0,
  class: "absolute left-5 top-1/2 z-[1] flex -translate-y-1/2"
}, Dy = ["id", "aria-expanded", "aria-controls", "aria-pressed", "aria-disabled", "disabled"], zy = {
  key: 0,
  class: "flex-shrink-0",
  "aria-hidden": "true"
}, Oy = {
  key: 1,
  class: "flex flex-1 min-w-0 items-center gap-2"
}, Py = {
  key: 0,
  class: "flex shrink-0",
  "aria-hidden": "true"
}, Fy = {
  key: 4,
  class: "flex shrink-0",
  "aria-hidden": "true"
}, Vy = ["id"], Ny = {
  key: 0,
  class: "sr-only"
}, Hy = {
  key: 0,
  class: "flex max-w-full shrink-0 flex-wrap items-center gap-1",
  "data-testid": "accordion-item-badges"
}, jy = ["id", "aria-labelledby", "aria-hidden", "inert"], Wy = { class: "accordion-content-inner" }, qy = /* @__PURE__ */ ye({
  __name: "AccordionItem",
  props: {
    title: {},
    subtitle: { default: void 0 },
    icon: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    defaultOpen: { type: Boolean, default: !1 },
    type: { default: "default" },
    badgeLabel: { default: void 0 },
    badgeTheme: { default: "active" },
    expandable: { type: Boolean, default: !0 },
    selected: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    size: { default: void 0 },
    headingLevel: { default: void 0 },
    avatarSrc: { default: void 0 },
    avatarAlt: { default: void 0 },
    completed: { type: Boolean, default: !1 },
    completedLabel: { default: void 0 },
    badges: { default: () => [] },
    maxBadges: { default: 3 },
    selectable: { type: Boolean, default: !1 },
    checked: { type: Boolean, default: !1 }
  },
  emits: ["toggle", "select", "update:open", "update:checked"],
  setup(e, { emit: n }) {
    var Q;
    const t = e, a = n, l = {
      variant: R("default"),
      size: R("md"),
      headingLevel: R(3),
      isChildLevel: R(!1),
      openItems: /* @__PURE__ */ new Set(),
      toggleItem: () => {
      },
      openItem: () => {
      }
    }, r = Kt(Xb, l), o = qe(), i = m(() => t.headingLevel ?? r.headingLevel.value), s = R(0);
    dn(Zb, {
      variant: r.variant,
      headingLevel: i,
      size: m(() => T.value),
      registerChildAccordion: () => (s.value++, () => s.value--)
    });
    const d = r === l, {
      triggerId: u,
      panelId: f,
      isOpen: b,
      isControlled: h,
      onTransitionEnd: p,
      panelClasses: x,
      toggle: y
    } = Qb({
      id: o,
      open: () => t.open,
      defaultOpen: () => t.defaultOpen && t.expandable,
      onOpenChange: (ae) => {
        h.value && a("update:open", ae);
      },
      store: d ? void 0 : {
        isOpen: () => r.openItems.has(o),
        toggle: () => r.toggleItem(o),
        open: () => r.openItem(o)
      }
    }), k = () => {
      if (!t.disabled) {
        if (!A.value) {
          a("select");
          return;
        }
        a("toggle", y());
      }
    }, $ = (ae) => {
      var fe, ze, Ee, He;
      if (!A.value && ["Enter", " "].includes(ae.key)) {
        ae.preventDefault(), k();
        return;
      }
      if (!["ArrowUp", "ArrowDown", "Home", "End"].includes(ae.key)) return;
      const Te = ae.currentTarget, Le = Te.closest("[data-accordion-root]");
      if (!Le) return;
      const pe = Array.from(
        Le.querySelectorAll(
          '[data-testid="accordion-item-trigger"]:not([disabled])'
        )
      ).filter((Ke) => {
        if (Ke.closest("[data-accordion-root]") !== Le) return !1;
        const et = Ke.closest('[inert], [aria-hidden="true"]');
        return !et || !Le.contains(et);
      }), ke = pe.indexOf(Te);
      switch (ae.preventDefault(), ae.key) {
        case "ArrowDown":
          (fe = pe[(ke + 1) % pe.length]) == null || fe.focus();
          break;
        case "ArrowUp":
          (ze = pe[(ke - 1 + pe.length) % pe.length]) == null || ze.focus();
          break;
        case "Home":
          (Ee = pe[0]) == null || Ee.focus();
          break;
        case "End":
          (He = pe[pe.length - 1]) == null || He.focus();
          break;
      }
    }, S = r.variant, T = m(() => t.size ?? r.size.value), I = m(() => t.type === "time-slot"), A = m(() => t.expandable), E = m(() => r.isChildLevel.value), D = m(() => S.value === "flush"), z = m(() => S.value === "with-sub-header"), Y = m(() => !!(t.avatarSrc || t.avatarAlt)), le = m(() => t.completed && z.value), ne = m(() => t.selectable && !I.value && !E.value), re = m(() => `${o}-title`);
    typeof process < "u" && ((Q = process.env) == null ? void 0 : Q.NODE_ENV) !== "production" && $e(
      () => [le.value, t.completedLabel],
      ([ae, Te]) => {
        ae && !(Te != null && Te.trim()) && console.warn("[OPAL AccordionItem] `completed` is set without `completedLabel`: the done state is visual only (WCAG 1.1.1 / 1.3.1).");
      },
      { immediate: !0 }
    );
    const P = m(() => I.value ? "div" : `h${i.value}`), V = m(() => I.value ? [`[&:not(:last-child)]:mb-4 ${J.value ? "overflow-visible" : "overflow-hidden"} rounded-xl`, F.value].join(" ") : S.value === "separate-cards" ? "border border-(--colors-border-base-soft) rounded-(--border-border-radius-rounded-l) overflow-hidden shadow-(--blur-shadow-sm)" : D.value ? A.value && b.value ? "last:[&>.accordion-content>*>*]:border-b-0" : `last:[&>*>*>button]:border-b-0 ${q.value.restoreLast}` : E.value ? "" : [
      `[&:not(:first-child)>*>*>button]:border-t [&:not(:first-child)>*>*>button]:border-solid [&:not(:first-child)>*>*>button]:border-(--colors-border-base-soft) ${q.value.nonFirst}`,
      "first:[&>*>*>button]:rounded-t-(--border-border-radius-rounded-l)",
      A.value && b.value ? "" : "last:[&>*>*>button]:rounded-b-(--border-border-radius-rounded-l)"
    ].join(" ").trim()), M = m(() => I.value ? A.value && b.value ? "rounded-t-xl" : "rounded-xl" : S.value === "separate-cards" ? A.value && b.value ? "rounded-t-(--border-border-radius-rounded-l)" : "rounded-(--border-border-radius-rounded-l)" : ""), B = {
      1: {
        both: "py-1",
        lessBottom: "pt-1 pb-[calc(var(--spacing-1)-1px)]",
        restoreLast: "last:[&>*>*>button]:pb-1",
        nonFirst: "[&:not(:first-child)>*>*>button]:pt-[calc(var(--spacing-1)-1px)]"
      },
      3: {
        both: "py-3",
        lessBottom: "pt-3 pb-[calc(var(--spacing-3)-1px)]",
        restoreLast: "last:[&>*>*>button]:pb-3",
        nonFirst: "[&:not(:first-child)>*>*>button]:pt-[calc(var(--spacing-3)-1px)]"
      },
      5: {
        both: "py-5",
        lessBottom: "pt-5 pb-[calc(var(--spacing-5)-1px)]",
        restoreLast: "last:[&>*>*>button]:pb-5",
        nonFirst: "[&:not(:first-child)>*>*>button]:pt-[calc(var(--spacing-5)-1px)]"
      }
    }, q = m(
      () => B[T.value === "sm" ? 1 : z.value || Y.value || ne.value ? 5 : 3]
    ), N = m(() => {
      if (I.value) return "p-3";
      if (E.value) return "pt-[calc(var(--spacing-5)-1px)] pr-6 pb-5 pl-12";
      const ae = D.value ? q.value.lessBottom : q.value.both, Te = ne.value ? "pr-5 pl-[calc(var(--spacing-5)_+_var(--spacing-4)_+_var(--spacing-6))]" : "px-5";
      return `${ae} ${Te}`;
    }), G = m(() => I.value ? "gap-2.5" : z.value ? "gap-3.5" : "gap-6"), U = m(() => [
      G.value,
      "@max-[40rem]/row:flex-col @max-[40rem]/row:items-stretch @max-[40rem]/row:gap-2"
    ]), K = m(() => I.value || S.value === "separate-cards" ? "" : D.value ? "border-b border-solid border-(--colors-border-base-soft)" : E.value ? "border-t border-solid border-(--colors-border-base-soft)" : ""), ge = m(() => I.value ? "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--border-border-info-strong)" : "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--border-border-accent)"), xe = m(() => I.value ? t.disabled ? "cursor-not-allowed" : "cursor-pointer" : D.value ? t.disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer" : t.disabled ? "cursor-not-allowed opacity-60 bg-(--background-background-white)" : [
      "cursor-pointer",
      b.value ? "bg-(--colors-background-selected)" : `bg-(--background-background-white) ${ne.value ? "group-hover/header:" : "hover:"}bg-(--colors-background-hover)`
    ].join(" ")), X = m(() => D.value && !t.disabled && !b.value), ie = m(() => X.value ? "group-hover/trigger:text-(--text-text-hover)" : ""), he = m(() => [
      "text-(--icons-icon-dark-default)",
      X.value ? "group-hover/trigger:text-(--icons-icon-hover)" : ""
    ]), oe = m(() => [
      "text-(length:--size-l) leading-(--line-height-xxl) text-(--colors-text-heading)",
      E.value ? "font-(--weight-medium)" : "font-(--weight-bold)",
      ie.value
    ]), Ce = m(() => [
      "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-body)",
      ie.value
    ]), H = m(() => T.value === "sm" ? "sm" : "md"), Z = m(() => S.value !== "separate-cards" || E.value ? "text-(length:--icon-size-lg)" : T.value === "sm" ? "text-(length:--icon-size-sm)" : "text-(length:--icon-size-md)"), ee = m(
      () => Wu(t.badges, t.maxBadges).map((ae) => ({
        ...ae,
        theme: ae.theme ?? "gradient-light"
      }))
    ), J = m(() => !t.disabled && A.value && b.value), F = m(() => I.value ? t.disabled || !A.value && t.selected ? "border border-(--border-border-base-medium)" : J.value ? "relative border border-transparent accordion-time-slot-gradient-border" : "border border-(--border-border-info) hover:border-(--border-border-info-strong)" : ""), _ = m(() => I.value ? t.disabled ? "bg-(--background-background-disabled-subtle)" : !A.value && t.selected ? "bg-(--components-badge-background-badge-indigo-strong-bg)" : "bg-(--background-background-info)" : ""), ue = m(() => I.value ? t.disabled ? "font-medium text-(--text-text-disabled-strong) line-through" : !A.value && t.selected ? "font-bold text-(--colors-text-white-default)" : "font-medium text-(--text-text-link)" : ""), se = m(() => I.value ? "flex flex-col gap-1 px-2 py-1.5 rounded-b-xl bg-(--background-background-white) dark:bg-(--colors-background-black-default)" : S.value === "multi-level" && !E.value && s.value > 0 ? "flex flex-col" : [
      "flex flex-col gap-3 bg-(--background-background-white) dark:bg-(--colors-background-black-default) border-(--colors-border-base-soft)",
      D.value ? "border-b" : "border-t",
      T.value === "sm" ? "py-3 px-5" : "p-5"
    ].join(" "));
    return (ae, Te) => (c(), g("div", {
      class: C(V.value),
      "data-accordion-item": "",
      "data-testid": "accordion-item"
    }, [
      v("div", {
        class: C(I.value ? "contents" : ["relative group/header", ee.value.length ? "@container/row" : ""]),
        "data-testid": "accordion-item-header"
      }, [
        ne.value ? (c(), g("div", My, [
          te(Bn, {
            "model-value": e.checked,
            disabled: e.disabled,
            "aria-labelledby": re.value,
            "data-testid": "accordion-item-checkbox",
            "onUpdate:modelValue": Te[0] || (Te[0] = (Le) => a("update:checked", Le))
          }, null, 8, ["model-value", "disabled", "aria-labelledby"])
        ])) : w("", !0),
        (c(), W(it(P.value), {
          class: C(I.value ? "contents" : "m-0")
        }, {
          default: ve(() => [
            v("button", {
              id: I.value ? void 0 : L(u),
              type: "button",
              class: C(["flex w-full items-center text-left transition-colors", [
                M.value,
                G.value,
                K.value,
                N.value,
                xe.value,
                _.value,
                ge.value,
                I.value ? "" : "group/trigger",
                I.value && !A.value ? "justify-center" : ""
              ]]),
              "aria-expanded": A.value ? L(b) : void 0,
              "aria-controls": A.value ? L(f) : void 0,
              "aria-pressed": I.value && !A.value ? e.selected : void 0,
              "aria-disabled": I.value && e.disabled ? "true" : void 0,
              disabled: I.value ? !1 : e.disabled,
              "data-testid": "accordion-item-trigger",
              onClick: k,
              onKeydown: $
            }, [
              I.value ? (c(), g(de, { key: 0 }, [
                e.icon && A.value ? (c(), g("div", zy, [
                  v("i", {
                    class: C([
                      e.icon,
                      "text-[16px]",
                      e.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-link)"
                    ])
                  }, null, 2)
                ])) : w("", !0),
                v("div", {
                  class: C(["flex flex-1 min-w-0 flex-wrap items-center gap-2", A.value ? "" : "justify-center"]),
                  "data-testid": "accordion-item-time-wrapper"
                }, [
                  v("span", {
                    "data-testid": "accordion-item-time",
                    class: C(["text-base leading-6", ue.value])
                  }, j(e.title), 3),
                  e.badgeLabel && A.value ? (c(), W(gt, {
                    key: 0,
                    "data-testid": "accordion-item-badge",
                    label: e.badgeLabel,
                    theme: e.disabled ? "disabled" : e.badgeTheme,
                    size: "sm",
                    "show-left-icon": !1,
                    "show-close-icon": !1
                  }, null, 8, ["label", "theme"])) : w("", !0)
                ], 2)
              ], 64)) : (c(), g("span", Oy, [
                E.value && A.value ? (c(), g("span", Py, [
                  v("i", {
                    class: C(["ri-arrow-down-s-line text-(length:--icon-size-lg) leading-none transition-transform duration-300 ease-in-out motion-reduce:transition-none", [he.value, L(b) ? "rotate-180" : ""]])
                  }, null, 2)
                ])) : Y.value ? (c(), W(Nt, {
                  key: 1,
                  as: "span",
                  img: e.avatarSrc,
                  name: e.avatarAlt || e.title,
                  presentational: !e.avatarAlt,
                  size: T.value === "sm" ? "sm" : "md"
                }, null, 8, ["img", "name", "presentational", "size"])) : le.value ? (c(), W(Gt, {
                  key: 2,
                  as: "span",
                  color: "success",
                  variant: "filled",
                  type: "circle",
                  icon: "ri-check-fill",
                  size: H.value
                }, null, 8, ["size"])) : z.value && e.icon ? (c(), W(Gt, {
                  key: 3,
                  as: "span",
                  color: "white",
                  variant: "outlined",
                  type: "circle",
                  icon: e.icon,
                  size: H.value
                }, null, 8, ["icon", "size"])) : e.icon && !E.value ? (c(), g("span", Fy, [
                  v("i", {
                    class: C([e.icon, "text-(length:--icon-size-md) leading-none", he.value])
                  }, null, 2)
                ])) : w("", !0),
                v("span", {
                  class: C(["flex min-w-0 flex-1 items-center", U.value])
                }, [
                  v("span", {
                    class: C(["flex min-w-0 flex-1 flex-col", z.value || Y.value ? "gap-px" : ""])
                  }, [
                    v("span", {
                      id: re.value,
                      class: C(oe.value),
                      "data-testid": "accordion-item-title"
                    }, [
                      nt(j(e.title), 1),
                      le.value && e.completedLabel ? (c(), g("span", Ny, ", " + j(e.completedLabel), 1)) : w("", !0)
                    ], 10, Vy),
                    e.subtitle ? (c(), g("span", {
                      key: 0,
                      class: C(Ce.value),
                      "data-testid": "accordion-item-subtitle"
                    }, j(e.subtitle), 3)) : w("", !0)
                  ], 2),
                  ee.value.length ? (c(), g("span", Hy, [
                    (c(!0), g(de, null, Re(ee.value, (Le, pe) => (c(), g(de, { key: pe }, [
                      L(ju)(Le) ? (c(), W(Hu, {
                        key: 0,
                        label: Le.label,
                        "hidden-labels": Le.hiddenLabels,
                        theme: Le.theme,
                        size: "xs",
                        focusable: !1
                      }, null, 8, ["label", "hidden-labels", "theme"])) : (c(), W(gt, {
                        key: 1,
                        label: Le.label,
                        theme: Le.theme,
                        size: "xs",
                        truncate: Le.truncate ?? !1,
                        "truncation-focusable": !1,
                        "show-left-icon": !1,
                        "show-close-icon": !1
                      }, null, 8, ["label", "theme", "truncate"]))
                    ], 64))), 128))
                  ])) : w("", !0)
                ], 2)
              ])),
              A.value && !E.value ? (c(), W(it(I.value ? "div" : "span"), {
                key: 2,
                class: C(I.value ? "flex-shrink-0 ml-auto" : "flex shrink-0 ml-auto"),
                "aria-hidden": "true"
              }, {
                default: ve(() => [
                  I.value ? (c(), g("i", {
                    key: 0,
                    class: C(["ri-arrow-down-s-line text-2xl transition-transform duration-300", [
                      e.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-link)",
                      L(b) ? "rotate-180" : ""
                    ]])
                  }, null, 2)) : (c(), g("i", {
                    key: 1,
                    class: C(["ri-arrow-down-s-line block leading-none transition-transform duration-300 ease-in-out motion-reduce:transition-none", [Z.value, he.value, L(b) ? "rotate-180" : ""]])
                  }, null, 2))
                ]),
                _: 1
              }, 8, ["class"])) : w("", !0)
            ], 42, Dy)
          ]),
          _: 1
        }, 8, ["class"]))
      ], 2),
      A.value ? (c(), g("div", {
        key: 0,
        id: L(f),
        class: C(L(x)),
        role: "region",
        "aria-labelledby": I.value ? void 0 : L(u),
        "aria-hidden": !L(b),
        inert: !L(b) || void 0,
        onTransitionend: Te[1] || (Te[1] = //@ts-ignore
        (...Le) => L(p) && L(p)(...Le))
      }, [
        v("div", Wy, [
          v("div", {
            class: C(se.value)
          }, [
            Ae(ae.$slots, "default", {}, void 0, !0)
          ], 2)
        ])
      ], 42, jy)) : w("", !0)
    ], 2));
  }
}), WW = /* @__PURE__ */ dt(qy, [["__scopeId", "data-v-281355d5"]]);
function Uy(e, n) {
  return `${e}-tab-${String(n).replace(/\s+/g, "-")}`;
}
const pg = Symbol("ButtonGroupContext"), Ts = "bg-(--components-button-button-disabled) border-(--border-border-disabled) text-(--text-text-disabled-strong)", Bl = "border-transparent text-(--text-text-disabled-strong) dark:text-(--components-button-button-disabled)", Gy = "border-transparent [background:var(--btn-fill-image,linear-gradient(var(--btn-fill),var(--btn-fill)))_padding-box,linear-gradient(var(--btn-stroke),var(--btn-stroke))_border-box]", yf = "border-(--border-border-disabled) text-(--text-text-disabled-strong) dark:text-(--components-button-button-disabled)", kf = "before:-inset-px before:[background:linear-gradient(var(--btn-ring-angle,85deg),var(--gradient-brand-start)_10.83%,var(--gradient-brand-end)_86.95%)] after:bg-(--background-background-white)", Ky = {
  tertiary: { label: "[--btn-ring-angle:69deg]", iconOnly: "[--btn-ring-angle:85deg]" },
  tab: { label: "[--btn-ring-angle:72deg]", iconOnly: "[--btn-ring-angle:85deg]" }
}, wf = "focus-visible:overflow-visible focus-visible:border-transparent focus-visible:before:opacity-100 focus-visible:after:opacity-100", Yy = {
  primary: {
    shape: `rounded-full ${Gy}`,
    rest: "[--btn-fill:var(--components-button-primary-button-primary)] [--btn-stroke:var(--border-border-primary-button)] text-(--text-text-white-secondary) dark:text-(--text-text-white-default)",
    interactive: "hover:[--btn-fill-image:var(--gradient-button-primary-hover)] hover:[--btn-stroke:var(--border-border-primary-button-hover)] focus-visible:[--btn-stroke:var(--border-border-accent)]",
    labelInteractive: "dark:hover:[--btn-fill-image:linear-gradient(90deg,_var(--text-text-white-default),_var(--colors-indigo-100))] dark:hover:text-(--text-text-black-default)",
    disabled: "[--btn-fill:var(--components-button-button-disabled)] [--btn-stroke:var(--border-border-disabled)] text-(--text-text-disabled-strong)",
    icon: "text-(--icons-icon-white-default)",
    iconInteractive: ""
  },
  // Figma fades the Secondary hover in (Dissolve), hence the `before` layer.
  secondary: {
    shape: "rounded-full before:inset-0 before:[background:var(--gradient-button-secondary-hover)]",
    rest: "bg-(--components-button-secondary-button-secondary) border-(--border-border-secondary-button) text-(--text-text-black-default)",
    interactive: "hover:border-(--border-border-secondary-button-hover) hover:before:opacity-100 dark:hover:bg-(--components-button-secondary-button-secondary-hover) dark:hover:text-(--text-text-white-secondary) focus-visible:text-(--text-text-accent) focus-visible:border-(--border-border-accent)",
    disabled: Ts,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: "group-focus-visible/button:text-(--icons-icon-accent)"
  },
  // background-hover has no dark value; the Tertiary hover token carries the dark one.
  tertiary: {
    shape: `${kf} after:inset-[calc(var(--border-border-width-border-sm)-1px)] dark:after:bg-(--components-button-tertiary-button-tertiary-focused)`,
    rest: "border-transparent text-(--text-text-black-default) dark:text-(--text-text-white-secondary)",
    interactive: `hover:bg-(--background-background-hover) dark:hover:bg-(--components-button-tertiary-button-tertiary-hover) dark:hover:text-(--text-text-black-default) hover:border-(--border-border-tertiary-hover) dark:hover:border-(--components-button-tertiary-button-tertiary-hover) ${wf}`,
    disabled: Bl,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  ghost: {
    shape: "",
    rest: "bg-transparent border-transparent text-(--text-text-black-default) dark:text-(--text-text-white-default)",
    interactive: "hover:bg-(--components-button-ghost-button-ghost-hover) dark:hover:text-(--text-text-black-default)",
    disabled: Bl,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  text: {
    shape: "",
    rest: "bg-transparent border-transparent text-(--components-button-text-button-text) dark:text-(--text-text-white-default)",
    interactive: "hover:text-(--components-button-text-button-text-hover) dark:hover:text-(--text-text-hover)",
    disabled: Bl,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: "group-hover/button:text-(--icons-icon-hover)"
  },
  // Stroke on top and sides only; the bottom edge joins the content below. Figma rounds Initial to
  // rounded-sm and every other state to rounded-l; OPAL keeps rounded-l in all states so hover doesn't reshape the tab.
  tab: {
    shape: `rounded-t-(--border-border-radius-rounded-l) rounded-b-none border-b-0 before:[clip-path:inset(0_0_1px_0)] dark:after:bg-(--components-button-tab-button-tab-active) after:inset-0 ${kf}`,
    rest: "bg-(--components-button-tab-button-tab-default) border-(--border-border-tab) text-(--text-text-black-default)",
    interactive: `hover:bg-(--components-button-tab-button-tab) hover:border-(--border-border-hover) ${wf}`,
    disabled: "bg-(--colors-white-50-opacity-light) dark:bg-(--components-button-button-disabled) border-(--border-border-disabled-subtle) dark:border-(--border-border-disabled) text-(--text-text-disabled-strong)",
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  success: {
    shape: "rounded-full",
    rest: "bg-(--components-button-functional-success-button-success) border-transparent text-(--text-text-white-secondary) dark:text-(--text-text-black-default)",
    interactive: "hover:bg-(--components-button-functional-success-button-success-hover) focus-visible:[--btn-fill:var(--components-button-functional-success-button-success-focused)] focus-visible:[--btn-stroke:var(--border-border-success)] dark:focus-visible:[--btn-stroke:var(--colors-border-success-sublte)] focus-visible:[background:linear-gradient(var(--btn-fill),var(--btn-fill))_padding-box,linear-gradient(var(--btn-stroke),var(--btn-stroke))_border-box]",
    disabled: Ts,
    icon: "text-(--icons-icon-white-default)",
    iconInteractive: ""
  },
  "success-secondary": {
    shape: "rounded-full",
    rest: "bg-transparent border-(--components-button-functional-success-button-success) text-(--text-text-black-default) dark:text-(--text-text-white-default)",
    interactive: "hover:border-(--components-button-functional-success-button-success-hover) focus-visible:border-(--components-button-functional-success-button-success-focused)",
    disabled: yf,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  error: {
    shape: "rounded-full",
    // CONSTRAINT: white-default, not white-secondary like the other filled variants: #f2f0f0 on the
    // error red #d92d20 is 4.26:1 and fails WCAG AA (4.5:1); #fafafa reaches 4.63:1.
    rest: "bg-(--components-button-functional-desctructive-error-background-button-error) border-transparent text-(--text-text-white-default) dark:text-(--text-text-black-default)",
    interactive: "hover:bg-(--components-button-functional-desctructive-error-background-button-error-hover) focus-visible:[--btn-fill:var(--components-button-functional-desctructive-error-background-button-error-focused)] focus-visible:[--btn-stroke:var(--border-border-error)] dark:focus-visible:[--btn-stroke:var(--border-border-error-subtle)] focus-visible:[background:linear-gradient(var(--btn-fill),var(--btn-fill))_padding-box,linear-gradient(var(--btn-stroke),var(--btn-stroke))_border-box]",
    disabled: Ts,
    icon: "text-(--icons-icon-white-default)",
    iconInteractive: ""
  },
  "error-secondary": {
    shape: "rounded-full",
    rest: "bg-transparent border-(--components-button-functional-desctructive-error-background-button-error) text-(--text-text-black-default) dark:text-(--text-text-white-default)",
    interactive: "hover:border-(--components-button-functional-desctructive-error-background-button-error-hover) focus-visible:border-(--components-button-functional-desctructive-error-background-button-error-focused)",
    disabled: yf,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  // Red at rest; icons follow the text colour through every state.
  "error-text": {
    shape: "",
    rest: "bg-transparent border-transparent text-(--components-button-functional-desctructive-error-background-button-error)",
    interactive: "hover:text-(--components-button-functional-desctructive-error-background-button-error-hover) focus-visible:text-(--components-button-functional-desctructive-error-background-button-error-focused) focus-visible:border-(--components-button-functional-desctructive-error-icons-button-error-focused-icon)",
    iconOnlyInteractive: "hover:bg-(--background-background-error) dark:hover:bg-transparent",
    disabled: Bl,
    icon: "",
    iconInteractive: ""
  }
}, Jy = {
  "success-secondary": {
    shape: "rounded-full",
    rest: "bg-transparent border-transparent text-(--text-text-black-default) dark:text-(--text-text-white-default)",
    interactive: "hover:bg-(--background-background-success) dark:hover:bg-transparent",
    disabled: Bl,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  "error-secondary": {
    shape: "rounded-full",
    rest: "bg-transparent border-transparent text-(--text-text-black-default) dark:text-(--text-text-white-default)",
    interactive: "hover:bg-(--background-background-error) dark:hover:bg-transparent",
    disabled: Bl,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: "group-hover/button:text-(--components-button-functional-desctructive-error-icons-button-error-icon)"
  }
}, Xy = /* @__PURE__ */ new Set(["primary", "secondary", "ghost"]), Zy = /* @__PURE__ */ new Set(["tertiary", "ghost", "text", "error-text"]);
function vg(e) {
  return Object.fromEntries(Object.entries(e).filter(([n]) => !/^onClick(?:Once|Capture|Passive)*$/.test(n)));
}
const Qy = ["src"], _y = ["src"], ek = {
  key: 1,
  class: "relative z-10 min-w-0 whitespace-nowrap *:align-top"
}, tk = ["src"], nk = "group/button relative inline-flex max-w-full items-center justify-center gap-1.5 overflow-hidden border border-solid font-inter font-(--weight-medium) transition-colors duration-150 ease-in-out motion-reduce:transition-none focus-visible:outline-hidden before:content-[''] before:absolute before:rounded-[inherit] before:opacity-0 before:transition-opacity before:duration-150 before:z-0 motion-reduce:before:transition-none after:content-[''] after:absolute after:rounded-[inherit] after:opacity-0 after:transition-opacity after:duration-150 after:z-[1] motion-reduce:after:transition-none", ak = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "Button",
  props: {
    as: { default: "button" },
    variant: { default: "primary" },
    outline: { type: Boolean, default: !0 },
    label: { default: "" },
    iconLeft: { default: void 0 },
    iconRight: { default: void 0 },
    dropdownIcon: { type: Boolean, default: !1 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    shrink: { type: Boolean, default: !1 },
    iconOnly: { type: Boolean, default: !1 },
    ariaLabel: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    loadingLabel: { default: void 0 },
    active: { type: Boolean, default: !1 },
    value: { default: void 0 },
    type: { default: "button" }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    var U;
    const t = e, a = n, l = Gn(), r = Hn(), o = Kt(pg, null), i = R(null), s = m(() => t.value === void 0 || o == null ? void 0 : o.mode.value), d = m(
      () => s.value && t.value !== void 0 ? o.isSelected(t.value) : t.active
    ), u = {
      xs: {
        button: "py-[calc(--spacing(1.5)-1px)] px-[calc(--spacing(3)-1px)] text-(length:--size-sm) leading-(--line-height-l)",
        tabBottom: "pb-1.5",
        iconOnly: "size-8 p-0"
      },
      sm: {
        button: "py-[calc(--spacing(2)-1px)] px-[calc(--spacing(3)-1px)] text-(length:--size-m) leading-(--line-height-l)",
        tabBottom: "pb-2",
        iconOnly: "size-9 p-0"
      },
      md: {
        button: "py-[calc(--spacing(2.5)-1px)] px-[calc(--spacing(4)-1px)] text-(length:--size-m) leading-(--line-height-l)",
        tabBottom: "pb-2.5",
        iconOnly: "size-10 p-0"
      },
      lg: {
        button: "py-[calc(--spacing(3)-1px)] px-[calc(--spacing(5)-1px)] text-(length:--size-l) leading-(--line-height-xxl)",
        tabBottom: "pb-3",
        iconOnly: "size-12 p-0"
      },
      xl: {
        button: "py-[calc(--spacing(3.5)-1px)] px-[calc(--spacing(6)-1px)] text-(length:--size-l) leading-(--line-height-xxl)",
        tabBottom: "pb-3.5",
        iconOnly: "size-13 p-0"
      }
    }, f = { font: "text-(length:--icon-size-xs) leading-(--icon-size-xs)", box: "size-(--icon-size-xs)" }, b = { font: "text-(length:--icon-size-sm) leading-(--icon-size-sm)", box: "size-(--icon-size-sm)" }, h = { font: "text-(length:--icon-size-md) leading-(--icon-size-md)", box: "size-(--icon-size-md)" }, p = { xs: f, sm: b, md: b, lg: b, xl: h }, x = { xs: f, sm: b, md: h, lg: h, xl: h }, y = m(() => (t.iconOnly ? x : p)[t.size]), k = m(
      () => !t.outline && (t.variant === "success-secondary" || t.variant === "error-secondary") ? Jy[t.variant] : Yy[t.variant]
    ), $ = m(() => t.disabled && !t.loading && t.as === "button"), S = m(() => t.disabled || t.ariaDisabled || t.loading), T = m(() => (t.disabled || t.ariaDisabled) && !t.loading), I = m(() => !d.value || T.value ? "" : t.variant === "tertiary" ? "active bg-(--background-background-white) dark:bg-[var(--colors-background-black-default)] overflow-visible before:opacity-100 after:opacity-100" : t.variant === "tab" ? "bg-(--background-background-white) dark:bg-[var(--colors-background-black-default)] border-transparent text-(--text-text-black-default) overflow-visible before:opacity-100 after:opacity-100" : ""), A = m(() => {
      var ge;
      const K = u[t.size];
      return [
        nk,
        k.value.shape,
        (ge = Ky[t.variant]) == null ? void 0 : ge[t.iconOnly ? "iconOnly" : "label"],
        T.value ? ["cursor-not-allowed", k.value.disabled] : t.loading ? ["cursor-progress", !(d.value && t.variant === "tab") && k.value.rest] : [
          "cursor-pointer",
          // An active Tab replaces its rest colours instead of competing with them.
          !(d.value && t.variant === "tab") && k.value.rest,
          k.value.interactive,
          t.iconOnly ? k.value.iconOnlyInteractive : k.value.labelInteractive
        ],
        // The OPAL focus ring on every variant, also while `ariaDisabled`/`loading` keep the button
        // focusable: the Figma focus of Ghost and Text is too faint to see (RGAA 10.7).
        Xy.has(t.variant) && !T.value ? "focus-visible:shadow-[var(--shadow-focus-l),var(--shadow-focus-s)]" : "focus-visible:shadow-(--shadow-focus-l)",
        Zy.has(t.variant) && (t.iconOnly ? "rounded-full" : "rounded-(--border-border-radius-rounded-base)"),
        t.iconOnly ? K.iconOnly : K.button,
        t.variant === "tab" && !t.iconOnly && K.tabBottom,
        t.fullWidth && !t.iconOnly && "w-full",
        t.shrink && !t.iconOnly ? "min-w-0" : "shrink-0",
        I.value
      ];
    }), E = m(() => [
      "relative z-10 inline-flex shrink-0 items-center justify-center dark:text-current",
      y.value.font,
      T.value ? "text-(--icons-icon-disabled-strong)" : [k.value.icon, !t.loading && k.value.iconInteractive]
    ]), D = m(() => {
      const K = T.value, ge = t.variant === "error" || t.variant === "success" || t.variant === "error-text";
      return [
        "relative z-10 shrink-0",
        y.value.box,
        !K && !ge && "dark:invert",
        K && "grayscale opacity-60"
      ];
    });
    function z(K) {
      return !!K && !K.includes("/");
    }
    const Y = m(() => t.iconOnly ? `${t.variant}-icon-button` : `${t.variant}-button`);
    function le() {
      const K = S.value ? vg(l) : l;
      return {
        ...t.as === "button" ? { type: t.type, disabled: $.value || void 0 } : {},
        ...K,
        ...t.ariaLabel ? { "aria-label": t.ariaLabel } : {},
        ...S.value && !$.value ? { "aria-disabled": "true" } : {},
        ...ne()
      };
    }
    if (o) {
      const K = o.register({
        value: () => t.value,
        unreachable: () => t.disabled || t.loading,
        blocked: () => S.value,
        el: () => i.value
      });
      ct(o.sort), yt(K);
    }
    function ne() {
      if (!s.value || t.value === void 0) return {};
      const K = o.isTabStop(t.value), ge = o.panelId();
      return {
        "data-button-group-item": "",
        tabindex: K ? 0 : -1,
        ...s.value === "tabs" ? { role: "tab", "aria-selected": String(d.value) } : { role: "radio", "aria-checked": String(d.value) },
        ...ge && {
          id: l.id ?? Uy(ge, t.value),
          "aria-controls": l["aria-controls"] ?? ge
        }
      };
    }
    function re(K) {
      if (S.value) {
        K.preventDefault();
        return;
      }
      s.value && t.value !== void 0 && o.select(t.value), a("click", K);
    }
    const O = R(null), P = R(!1), V = R(!1), M = m(() => V.value ? !1 : P.value ? !0 : void 0);
    function B(K) {
      try {
        P.value = K.target.matches(":focus-visible");
      } catch {
        P.value = !0;
      }
    }
    function q() {
      P.value = !1, V.value = !1;
    }
    $e(
      () => t.disabled,
      (K) => {
        K && q();
      }
    );
    function N(K) {
      var ge;
      s.value && o.onItemKeydown(K), !(K.key !== "Escape" || V.value) && (!P.value || !((ge = O.value) != null && ge.isTruncated) || (K.stopPropagation(), K.preventDefault(), V.value = !0));
    }
    const G = typeof process < "u" && ((U = process.env) == null ? void 0 : U.NODE_ENV) !== "production";
    return $e(
      () => t.iconOnly && !t.ariaLabel,
      (K) => {
        G && K && !l["aria-label"] && !l["aria-labelledby"] && console.warn("[OPAL Button] `iconOnly` without `ariaLabel` or `aria-labelledby`: the button has no accessible name (WCAG 1.1.1 / 4.1.2).");
      },
      { immediate: !0 }
    ), (K, ge) => (c(), W(it(e.as), Fe({
      ref_key: "rootRef",
      ref: i,
      "data-testid": Y.value
    }, le(), {
      class: A.value,
      onClick: re,
      onFocus: B,
      onBlur: q,
      onKeydown: N
    }), {
      default: ve(() => [
        e.loading ? (c(), W(Vu, {
          key: 0,
          size: "inherit",
          color: "current",
          label: e.loadingLabel,
          class: C(E.value)
        }, null, 8, ["label", "class"])) : w("", !0),
        !e.loading && e.iconOnly && (e.iconLeft || e.iconRight) ? (c(), g(de, { key: 1 }, [
          z(e.iconLeft || e.iconRight) ? (c(), g("i", {
            key: 0,
            class: C([e.iconLeft || e.iconRight, E.value]),
            "aria-hidden": "true"
          }, null, 2)) : (c(), g("img", {
            key: 1,
            src: e.iconLeft || e.iconRight,
            class: C(D.value),
            alt: ""
          }, null, 10, Qy))
        ], 64)) : w("", !0),
        e.iconOnly ? w("", !0) : (c(), g(de, { key: 2 }, [
          !e.loading && e.iconLeft ? (c(), g(de, { key: 0 }, [
            z(e.iconLeft) ? (c(), g("i", {
              key: 0,
              class: C([e.iconLeft, E.value]),
              "aria-hidden": "true"
            }, null, 2)) : (c(), g("img", {
              key: 1,
              src: e.iconLeft,
              class: C(D.value),
              alt: ""
            }, null, 10, _y))
          ], 64)) : w("", !0),
          r.default ? (c(), g("span", ek, [
            Ae(K.$slots, "default", {}, void 0, !0)
          ])) : e.label ? (c(), g("span", {
            key: 2,
            class: C(["relative z-10 flex min-w-0", e.variant === "tab" && "max-w-(--tab-label-max-width)"])
          }, [
            te(pt, {
              ref_key: "labelRef",
              ref: O,
              as: "span",
              text: e.label,
              focusable: !1,
              open: M.value
            }, null, 8, ["text", "open"])
          ], 2)) : w("", !0),
          !e.loading && e.iconRight ? (c(), g(de, { key: 3 }, [
            z(e.iconRight) ? (c(), g("i", {
              key: 0,
              class: C([e.iconRight, E.value]),
              "aria-hidden": "true"
            }, null, 2)) : (c(), g("img", {
              key: 1,
              src: e.iconRight,
              class: C(D.value),
              alt: ""
            }, null, 10, tk))
          ], 64)) : w("", !0),
          e.dropdownIcon ? (c(), g("i", {
            key: 4,
            class: C(["ri-arrow-down-s-line transition-transform duration-200 ease-in-out motion-reduce:transition-none group-aria-expanded/button:rotate-180", E.value]),
            "aria-hidden": "true"
          }, null, 2)) : w("", !0)
        ], 64))
      ]),
      _: 3
    }, 16, ["data-testid", "class"]));
  }
}), Me = /* @__PURE__ */ dt(ak, [["__scopeId", "data-v-793b8637"]]), as = (e, n) => typeof e == "function" ? e(n) : e.replace("{count}", String(n)), nl = /* @__PURE__ */ ye({
  __name: "ToggleSwitch",
  props: {
    modelValue: { type: Boolean, default: !1 },
    type: { default: "boolean" },
    size: { default: "base" },
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    presentational: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => t.disabled || t.ariaDisabled), r = m(() => t.size === "lg"), o = m(() => t.type === "default"), i = m(() => o.value ? !t.modelValue : t.modelValue), s = m(() => {
      const p = `relative box-border inline-block ${r.value ? "h-6.5 w-11.5" : "h-5.5 w-9.5"} shrink-0 rounded-(--border-border-radius-rounded-full) border transition-[color,background-color,border-color] duration-100 ease-in-out motion-reduce:transition-none`, x = t.presentational ? "" : " focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent";
      if (l.value)
        return `${p}${x} cursor-not-allowed border-(--components-toggle-border-toggle-disabled-border) bg-(--components-toggle-background-toggle-disabled)`;
      const y = t.presentational ? "" : " cursor-pointer";
      return t.modelValue || o.value ? `${p}${x}${y} border-(--components-toggle-border-toggle-active-border) bg-(--components-toggle-background-toggle-active)` : `${p}${x}${y} border-(--components-toggle-border-toggle-unactive-border) bg-(--components-toggle-background-toggle-unactive)`;
    }), d = m(() => {
      const p = `absolute top-0.5 box-border flex ${r.value ? "size-5" : "size-4"} border items-center justify-center rounded-(--border-border-radius-rounded-full) shadow-(--blur-shadow-xs) transition-[inset-inline-start] duration-150 ease-in-out motion-reduce:transition-none`, x = r.value ? "start-5.25" : "start-4.5", y = t.modelValue ? x : "start-0.5";
      return l.value ? `${p} ${y} border-transparent bg-(--components-toggle-background-toggle-disabled-switch)` : o.value ? `${p} ${y} border-transparent bg-(--components-toggle-background-toggle-active-switch)` : t.modelValue ? `${p} ${y} border-transparent bg-(--colors-background-white-secondary-soft)` : `${p} ${y} border-(--components-toggle-border-toggle-unactive-border) bg-(--components-toggle-background-toggle-active-switch)`;
    }), u = m(() => {
      const h = r.value ? "text-(length:--icon-size-md)" : "text-(length:--icon-size-sm)";
      return l.value ? `ri-check-fill ${h} leading-none text-(--components-toggle-icon-toggle-icon-disabled)` : `ri-check-fill ${h} leading-none text-(--icons-icon-accent)`;
    }), f = m(
      () => t.presentational ? {} : {
        type: "button",
        role: "switch",
        "aria-checked": t.modelValue,
        "aria-disabled": t.ariaDisabled ? "true" : void 0,
        disabled: t.disabled
      }
    ), b = () => {
      t.presentational || l.value || a("update:modelValue", !t.modelValue);
    };
    return (h, p) => (c(), W(it(e.presentational ? "span" : "button"), Fe(f.value, {
      class: s.value,
      onClick: b
    }), {
      default: ve(() => [
        v("span", {
          class: C(d.value)
        }, [
          te(At, {
            "enter-active-class": "transition-opacity duration-150 ease-in-out motion-reduce:transition-none",
            "enter-from-class": "opacity-0"
          }, {
            default: ve(() => [
              i.value ? (c(), g("i", {
                key: 0,
                class: C(u.value),
                "aria-hidden": "true"
              }, null, 2)) : w("", !0)
            ]),
            _: 1
          })
        ], 2)
      ]),
      _: 1
    }, 16, ["class"]));
  }
});
function xg(e, n) {
  const t = n.trim(), a = t ? new RegExp(t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i").exec(e) : null;
  if (!a) return { before: e, match: "", after: "" };
  const l = a.index;
  return {
    before: e.slice(0, l),
    match: a[0],
    after: e.slice(l + a[0].length)
  };
}
const yg = "rounded-(--border-border-radius-rounded-l) border border-solid border-(--border-border-base-soft) bg-(--background-background-white) [backdrop-filter:blur(4px)] dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)", Za = `${yg} shadow-(--blur-shadow-m)`, lk = `${yg} shadow-(--shadow-l)`, Uu = "text-(--text-text-black-default) dark:text-(--colors-text-white-default)", kg = "box-border flex flex-col gap-1.5 p-[calc(--spacing(2)-1px)]", si = `${Za} ${Uu} ${kg}`, Gu = "focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)", rk = `flex min-h-8 w-full cursor-pointer items-center rounded-(--border-border-radius-rounded-sm) px-2 py-1.5 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default) transition-colors hover:bg-(--background-background-hover) ${Gu} dark:text-(--colors-text-white-default) dark:hover:bg-white/8`, ok = "bg-(--background-background-hover) dark:bg-white/8", wg = {
  success: "text-(--icons-icon-success)",
  base: "text-(--icons-icon-base)",
  error: "text-(--icons-icon-error)"
}, ik = {
  key: 0,
  class: "flex shrink-0",
  "data-testid": "dropdown-list-item-checkbox"
}, sk = {
  key: 0,
  class: "h-5.5 w-9.5 shrink-0",
  "aria-hidden": "true",
  "data-testid": "dropdown-list-item-toggle-placeholder"
}, dk = ["src"], uk = ["id"], ck = ["id"], fk = {
  key: 1,
  class: "min-w-0 break-words"
}, hk = {
  class: "text-(--text-text-link)",
  "data-testid": "dropdown-list-item-highlight"
}, bk = {
  key: 1,
  class: "flex min-w-0",
  "data-testid": "dropdown-list-item-secondary-label"
}, gk = {
  class: "flex min-w-0",
  "data-testid": "dropdown-list-item-secondary-label"
}, mk = {
  key: 1,
  class: "flex shrink-0"
}, pk = {
  key: 4,
  class: "flex shrink-0",
  "data-testid": "dropdown-list-item-more-actions"
}, vk = "inline-flex size-(--icon-size-sm) shrink-0 items-center justify-center", wo = "text-(length:--icon-size-sm) leading-(--icon-size-sm) size-(--icon-size-sm) inline-flex items-center justify-center shrink-0", en = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "DropdownListItem",
  props: {
    as: { default: "div" },
    type: { default: "default" },
    label: { default: void 0 },
    icon: { default: void 0 },
    iconColor: { default: void 0 },
    trailingIcon: { default: "ri-arrow-right-s-line" },
    secondaryLabel: { default: void 0 },
    secondaryIcon: { default: void 0 },
    flag: { default: void 0 },
    description: { default: void 0 },
    count: { default: void 0 },
    badge: { default: void 0 },
    checked: { type: Boolean, default: !1 },
    indeterminate: { type: Boolean, default: !1 },
    selected: { type: Boolean, default: !1 },
    highlighted: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    danger: { type: Boolean, default: !1 },
    header: { type: Boolean, default: !1 },
    moreActions: { default: void 0 },
    moreActionsLabel: { default: void 0 },
    moreActionsTabindex: { default: void 0 },
    labelWrap: { type: Boolean, default: !1 },
    avatar: { default: void 0 },
    highlight: { default: void 0 },
    keyboardActive: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = qe(), a = qe(), l = m(() => n.disabled || n.ariaDisabled || n.loading), r = m(() => n.selected && ["default", "two-icons", "two-labels", "flag", "secondary-text"].includes(n.type)), o = m(() => !!n.description), i = m(() => ["checkbox", "badge-checkbox", "checkbox-badge"].includes(n.type)), s = m(() => n.type === "badge" || n.type === "badge-checkbox"), d = m(() => ["default", "two-icons", "two-labels", "switch", "autocomplete", "secondary-text"].includes(n.type)), u = m(() => n.type === "flag"), f = m(() => n.type === "secondary-text"), b = m(() => n.type === "autocomplete"), h = m(() => !!n.badge && (n.type === "checkbox-badge" || b.value)), p = m(() => {
      if (!b.value || !n.highlight) return null;
      const oe = xg(n.label ?? "", n.highlight);
      return oe.match ? oe : null;
    }), x = m(() => {
      var oe;
      return n.type === "toggle" && !!((oe = n.moreActions) != null && oe.length);
    }), y = m(() => n.type === "checkbox" && l.value), k = m(() => {
      var oe;
      return l.value ? "disabled" : ((oe = n.badge) == null ? void 0 : oe.theme) ?? "neutral";
    }), $ = m(() => n.as === "button" ? { type: "button", disabled: n.disabled || void 0, "aria-disabled": n.ariaDisabled ? "true" : void 0 } : { "aria-disabled": n.disabled || n.ariaDisabled ? "true" : void 0 }), S = R(!1), T = R(null), I = m(() => S.value || n.keyboardActive), A = m(() => I.value ? !0 : void 0), E = m(() => {
      var oe;
      return I.value && !((oe = T.value) != null && oe.isTruncated) ? !0 : void 0;
    });
    function D(oe) {
      if (oe.target === oe.currentTarget)
        try {
          S.value = oe.target.matches(":focus-visible");
        } catch {
          S.value = !0;
        }
    }
    function z(oe) {
      oe.target === oe.currentTarget && (S.value = !1);
    }
    const Y = Gn(), le = m(() => {
      const oe = { ...$.value, onFocusin: D, onFocusout: z };
      o.value && Object.assign(oe, { "aria-labelledby": t, "aria-describedby": a });
      for (const Ce of Object.keys(oe)) oe[Ce] === void 0 && delete oe[Ce];
      return Fe(Y, oe);
    }), ne = ({ badge: oe, theme: Ce }) => [
      oe && ea(Nu, {
        label: oe.label,
        theme: Ce,
        leftIcon: oe.icon,
        rightIcon: oe.rightIcon,
        brandIcon: oe.brandIcon,
        size: "sm",
        fitWidth: !0,
        class: "min-w-0 max-w-full",
        "aria-hidden": "true",
        "data-testid": "dropdown-list-item-badge"
      }),
      ea("span", { class: "sr-only", "data-testid": "dropdown-list-item-badge-name" }, oe == null ? void 0 : oe.label)
    ];
    ne.props = ["badge", "theme"];
    const re = m(() => o.value ? "py-2" : b.value ? n.badge ? "py-1.5" : "py-2" : n.type === "switch" || n.type === "toggle" ? "py-[calc(--spacing(1.5)-1px)]" : n.type === "badge" || n.type === "badge-checkbox" || n.type === "checkbox-badge" ? "py-1" : "py-1.5"), O = m(() => l.value ? n.type === "two-labels" ? "text-(--text-text-disabled-strong) dark:text-(--colors-text-disabled)" : "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : r.value ? "text-(--colors-text-accent-strong)" : b.value ? "text-(--text-text-body) dark:text-(--colors-text-white-secondary)" : u.value ? n.highlighted ? "text-(--text-text-black-default) dark:text-(--colors-text-white-default)" : "text-(--text-text-body) group-hover:text-(--text-text-black-default) dark:text-(--colors-text-white-secondary) dark:group-hover:text-(--colors-text-white-default)" : n.type === "toggle" || n.type === "switch" ? "text-(--text-text-heading) dark:text-(--colors-text-white-default)" : "text-(--text-text-black-default) group-hover:text-text-black-default dark:group-hover:text-text-black-default dark:text-(--colors-text-white-default)"), P = Gu, V = m(() => l.value ? "cursor-not-allowed" : "cursor-pointer"), M = m(() => [
      "group flex w-full min-w-0 min-h-8 items-center gap-1.5 text-left rounded-(--border-border-radius-rounded-sm) transition-colors",
      // With more actions the item element inside takes the start padding, the focus ring and the cursor.
      x.value ? "pe-2" : ["px-2", re.value, P, V.value],
      O.value,
      !l.value && "hover:bg-background-hover dark:hover:bg-white/8",
      n.highlighted && !l.value && "bg-background-hover dark:bg-white/8",
      n.type === "toggle" && l.value && "bg-(--background-background-white)"
    ]), B = m(() => [
      "self-stretch ps-2 rounded-(--border-border-radius-rounded-sm)",
      re.value,
      P,
      V.value
    ]), q = m(() => [
      "flex min-w-0 flex-1 items-center text-(length:--size-m) leading-(--line-height-l)",
      n.type === "checkbox-badge" ? "font-(--weight-regular)" : "font-(--weight-medium)",
      n.type === "toggle" ? "gap-2" : "gap-1.5"
    ]), N = m(() => {
      const oe = "text-(--text-text-error-strong) group-hover:text-(--text-text-error-strong)";
      return l.value ? "text-(--icons-icon-disabled-strong) dark:text-(--colors-text-disabled)" : n.danger ? oe : r.value ? "text-(--icons-icon-accent-strong) dark:text-(--colors-text-accent-strong)" : "text-(--icons-icon-dark-default) dark:text-(--colors-text-white-default)";
    }), G = m(
      () => n.iconColor && !l.value && !n.danger && !r.value ? wg[n.iconColor] : N.value
    ), U = m(
      () => n.type === "two-labels" && r.value && !l.value ? "text-(--icons-icon-dark-default) dark:text-(--colors-text-white-default)" : N.value
    ), K = m(() => {
      if (n.type === "two-icons") return r.value ? "ri-check-fill" : n.trailingIcon;
      if (n.type === "two-labels") return n.trailingIcon;
      if ((n.type === "default" || u.value || f.value) && r.value) return "ri-check-fill";
    }), ge = m(() => [
      "min-w-0",
      n.labelWrap ? "break-words" : "flex",
      (n.type === "two-labels" || f.value) && "flex-1",
      !n.icon && n.danger && !l.value && "text-(--text-text-error-strong) group-hover:text-(--text-text-error-strong)"
    ]), xe = m(() => [
      "shrink-0 text-(length:--size-sm) leading-(--line-height-xs) font-(--weight-regular)",
      // Figma Left form Hover/Active turns the count to the label's black.
      l.value ? "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : n.highlighted ? "text-(--text-text-black-default) dark:text-(--colors-text-white-default)" : "text-(--colors-text-body) dark:text-(--colors-text-white-secondary) group-hover:text-(--text-text-black-default) dark:group-hover:text-(--colors-text-white-default)"
    ]), X = m(() => l.value ? "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : n.highlighted ? "text-(--text-text-black-default) dark:text-(--colors-text-white-default)" : "text-(--text-text-body) group-hover:text-(--text-text-black-default) dark:text-(--colors-text-white-secondary) dark:group-hover:text-(--colors-text-white-default)"), ie = m(() => l.value ? "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : r.value ? "text-(--icons-icon-accent-strong) dark:text-(--colors-text-accent-strong)" : "text-(--icons-icon-dark-default) dark:text-(--colors-text-white-default)");
    function he(oe) {
      return oe.startsWith("ri-");
    }
    return (oe, Ce) => (c(), W(it(x.value ? "div" : e.as), Fe(x.value ? void 0 : le.value, { class: M.value }), {
      default: ve(() => [
        (c(), W(it(x.value ? e.as : "div"), Fe({ "data-testid": "dropdown-list-item-content" }, x.value ? le.value : void 0, {
          class: x.value ? [q.value, B.value] : q.value
        }), {
          default: ve(() => [
            i.value ? (c(), g("span", ik, [
              te(Bn, {
                presentational: "",
                "model-value": e.checked,
                indeterminate: e.indeterminate,
                disabled: y.value
              }, null, 8, ["model-value", "indeterminate", "disabled"])
            ])) : w("", !0),
            e.type === "toggle" ? (c(), g(de, { key: 1 }, [
              e.header ? (c(), g("span", sk)) : (c(), W(nl, {
                key: 1,
                presentational: "",
                class: "shrink-0",
                "data-testid": "dropdown-list-item-toggle",
                "model-value": e.checked,
                disabled: l.value
              }, null, 8, ["model-value", "disabled"]))
            ], 64)) : w("", !0),
            u.value ? (c(), g("span", {
              key: 2,
              class: C(vk),
              "aria-hidden": "true",
              "data-testid": "dropdown-list-item-flag-box"
            }, [
              e.flag ? (c(), g("span", {
                key: 0,
                class: C(["fi", `fi-${e.flag.toLowerCase()}`, "fis", "rounded-full", "text-[13.33px]"]),
                "data-testid": "dropdown-list-item-flag"
              }, null, 2)) : w("", !0)
            ])) : w("", !0),
            d.value ? (c(), g(de, { key: 3 }, [
              e.loading ? (c(), g("i", {
                key: 0,
                class: C(["dropdown-icon ri-loader-4-line animate-spin", wo, N.value]),
                "aria-hidden": "true",
                "data-testid": "dropdown-list-item-icon"
              }, null, 2)) : b.value && e.avatar ? (c(), W(Nt, {
                key: 1,
                name: e.avatar.name,
                img: e.avatar.img,
                logo: e.avatar.logo ?? !1,
                size: "xs",
                presentational: "",
                class: "shrink-0",
                "data-testid": "dropdown-list-item-avatar"
              }, null, 8, ["name", "img", "logo"])) : e.icon ? (c(), g(de, { key: 2 }, [
                he(e.icon) ? (c(), g("i", {
                  key: 0,
                  class: C([e.icon, "dropdown-icon", wo, G.value]),
                  "aria-hidden": "true",
                  "data-testid": "dropdown-list-item-icon"
                }, null, 2)) : (c(), g("img", {
                  key: 1,
                  class: C(["dropdown-icon relative h-4 w-4 shrink-0 transition dark:invert dark:filter", [e.highlighted && "dark:invert-0", l.value ? "opacity-50" : "dark:group-hover:invert-0"]]),
                  src: e.icon,
                  alt: "",
                  "data-testid": "dropdown-list-item-icon"
                }, null, 10, dk))
              ], 64)) : w("", !0)
            ], 64)) : w("", !0),
            o.value ? (c(), g("span", {
              key: 4,
              class: C(["flex min-w-0 flex-col gap-px", (e.type === "two-labels" || f.value) && "flex-1"])
            }, [
              v("span", {
                id: L(t),
                class: C(ge.value),
                "data-testid": "dropdown-list-item-label"
              }, [
                s.value ? (c(), W(ne, {
                  key: 0,
                  badge: e.badge,
                  theme: k.value
                }, null, 8, ["badge", "theme"])) : e.labelWrap ? (c(), g(de, { key: 1 }, [
                  nt(j(e.label), 1)
                ], 64)) : (c(), W(pt, {
                  key: 2,
                  ref_key: "labelRef",
                  ref: T,
                  text: e.label ?? "",
                  focusable: !1,
                  open: A.value
                }, null, 8, ["text", "open"]))
              ], 10, uk),
              v("span", {
                id: L(a),
                "data-testid": "dropdown-item-description",
                class: C(["text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)", !l.value && "text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"])
              }, j(e.description), 11, ck)
            ], 2)) : (c(), g("span", {
              key: 5,
              class: C(ge.value),
              "data-testid": "dropdown-list-item-label"
            }, [
              s.value ? (c(), W(ne, {
                key: 0,
                badge: e.badge,
                theme: k.value
              }, null, 8, ["badge", "theme"])) : p.value ? (c(), g("span", fk, [
                nt(j(p.value.before), 1),
                v("span", hk, j(p.value.match), 1),
                nt(j(p.value.after), 1)
              ])) : e.labelWrap ? (c(), g(de, { key: 2 }, [
                nt(j(e.label), 1)
              ], 64)) : (c(), W(pt, {
                key: 3,
                ref_key: "labelRef",
                ref: T,
                text: e.label ?? "",
                focusable: !1,
                open: A.value
              }, null, 8, ["text", "open"]))
            ], 2)),
            b.value && e.secondaryLabel ? (c(), g("span", {
              key: 6,
              class: C(["flex min-w-0 text-(length:--size-sm) leading-(--line-height-xs) font-(--weight-regular)", !l.value && "text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"]),
              "data-testid": "dropdown-list-item-secondary-label"
            }, [
              te(pt, {
                text: e.secondaryLabel,
                focusable: !1,
                open: E.value
              }, null, 8, ["text", "open"])
            ], 2)) : w("", !0),
            f.value && (e.secondaryLabel || e.secondaryIcon) ? (c(), g("span", {
              key: 7,
              class: C(["flex min-w-0 max-w-1/2 shrink items-center justify-end gap-0.5 text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)", X.value]),
              "data-testid": "dropdown-list-item-secondary"
            }, [
              e.secondaryIcon ? (c(), g("i", {
                key: 0,
                class: C([e.secondaryIcon, "size-3 shrink-0 text-(length:--size-sm) leading-(--size-sm) inline-flex items-center justify-center", ie.value]),
                "aria-hidden": "true",
                "data-testid": "dropdown-list-item-secondary-icon"
              }, null, 2)) : w("", !0),
              e.secondaryLabel ? (c(), g("span", bk, [
                te(pt, {
                  text: e.secondaryLabel,
                  focusable: !1,
                  open: E.value
                }, null, 8, ["text", "open"])
              ])) : w("", !0)
            ], 2)) : w("", !0),
            e.type === "two-labels" && e.secondaryLabel ? (c(), g(de, { key: 8 }, [
              e.secondaryIcon ? (c(), g("i", {
                key: 0,
                class: C([e.secondaryIcon, wo, N.value]),
                "aria-hidden": "true",
                "data-testid": "dropdown-list-item-secondary-icon"
              }, null, 2)) : w("", !0),
              v("span", gk, [
                te(pt, {
                  text: e.secondaryLabel,
                  focusable: !1,
                  open: E.value
                }, null, 8, ["text", "open"])
              ])
            ], 64)) : w("", !0)
          ]),
          _: 1
        }, 16, ["class"])),
        e.type === "checkbox" && e.count !== void 0 && e.count !== "" ? (c(), g("span", {
          key: 0,
          class: C(xe.value),
          "data-testid": "dropdown-list-item-count"
        }, j(e.count), 3)) : w("", !0),
        h.value && e.badge ? (c(), g("span", mk, [
          te(ne, {
            badge: e.badge,
            theme: k.value
          }, null, 8, ["badge", "theme"])
        ])) : w("", !0),
        e.type === "switch" ? (c(), W(nl, {
          key: 2,
          presentational: "",
          class: "ms-auto shrink-0",
          "data-testid": "dropdown-list-item-toggle",
          "model-value": e.checked,
          disabled: l.value
        }, null, 8, ["model-value", "disabled"])) : w("", !0),
        K.value ? (c(), g("i", {
          key: 3,
          class: C([K.value, "ms-auto", wo, U.value]),
          "aria-hidden": "true",
          "data-testid": "dropdown-list-item-trailing"
        }, null, 2)) : w("", !0),
        x.value ? (c(), g("span", pk, [
          te(cn, {
            items: e.moreActions,
            "menu-align": "right"
          }, {
            trigger: ve(({ triggerProps: H }) => [
              te(Me, Fe(H, {
                variant: "ghost",
                size: "xs",
                "icon-only": "",
                "icon-left": "ri-more-fill",
                "aria-label": e.moreActionsLabel,
                tabindex: e.moreActionsTabindex,
                "aria-disabled": l.value,
                "data-testid": "dropdown-list-item-more-actions-trigger"
              }), null, 16, ["aria-label", "tabindex", "aria-disabled"])
            ]),
            _: 1
          }, 8, ["items"])
        ])) : w("", !0)
      ]),
      _: 1
    }, 16, ["class"]));
  }
}), xk = ["role", "data-testid", "data-menu-label", "disabled", "aria-disabled", "aria-current", "aria-describedby"], yk = { class: "me-auto flex min-w-0 flex-col" }, kk = ["src"], wk = ["id"], Cf = /* @__PURE__ */ ye({
  __name: "DropdownItemButton",
  props: {
    item: {},
    variant: { default: "default" },
    fallbackTestId: { default: "dropdown-item" },
    selectionStyle: { default: "highlight" }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => !!(t.item.disabled || t.item.loading)), r = m(() => !!t.item.description), o = m(
      () => l.value && (!!t.item.tooltip || r.value)
    ), i = m(() => t.variant === "default" && !t.item.hasSwitch && t.item.active === !0), s = m(() => t.variant === "nav" ? "menuitem" : t.item.hasSwitch ? "menuitemcheckbox" : typeof t.item.active == "boolean" ? "menuitemradio" : "menuitem"), d = m(() => {
      if (s.value === "menuitemcheckbox") return !!t.item.switchChecked;
      if (s.value === "menuitemradio") return t.item.active === !0;
    }), u = m(
      () => t.item.danger && !l.value ? "text-(--text-text-error-strong) group-hover:text-(--text-text-error-strong)" : void 0
    ), f = m(() => [
      Gu,
      // No vertical padding: a Figma Nav link is 20 high, rows 12 apart (pitch 32).
      "min-w-0 p-0",
      l.value ? "cursor-not-allowed text-(--text-text-disabled-strong)" : [
        "cursor-pointer hover:text-(--text-text-hover)",
        t.item.active ? "text-(--text-text-link)" : "text-(--text-text-black-default)"
      ]
    ]), b = m(() => [
      "flex min-w-0 items-center gap-1.5 text-(length:--size-m) leading-(--line-height-l)",
      t.item.active ? "font-(--weight-semi-bold) underline" : "font-(--weight-semi-bold)",
      !l.value && "group-hover:font-(--weight-bold) group-hover:underline"
    ]), h = qe(), p = m(() => t.variant === "nav" ? t.item.description : void 0), x = R(!1);
    function y(S) {
      try {
        x.value = S.target.matches(":focus-visible");
      } catch {
        x.value = !0;
      }
    }
    function k() {
      l.value || a("click", t.item);
    }
    function $(S) {
      return S.startsWith("ri-");
    }
    return (S, T) => e.variant === "default" ? (c(), W(en, {
      key: 0,
      as: "button",
      type: e.item.hasSwitch ? "switch" : "default",
      role: s.value,
      "data-testid": e.item.testId || e.fallbackTestId,
      "data-menu-label": e.item.label,
      label: e.item.label,
      icon: e.item.icon,
      description: e.item.description,
      checked: !!e.item.switchChecked,
      selected: i.value && e.selectionStyle === "check",
      highlighted: i.value && e.selectionStyle === "highlight",
      disabled: l.value && !o.value,
      "aria-disabled": o.value,
      loading: e.item.loading,
      danger: e.item.danger,
      "aria-checked": d.value,
      "label-wrap": "",
      onClick: k
    }, null, 8, ["type", "role", "data-testid", "data-menu-label", "label", "icon", "description", "checked", "selected", "highlighted", "disabled", "aria-disabled", "loading", "danger", "aria-checked"])) : (c(), g("button", {
      key: 1,
      type: "button",
      role: s.value,
      "data-testid": e.item.testId || e.fallbackTestId,
      "data-menu-label": e.item.label,
      disabled: o.value ? void 0 : l.value,
      "aria-disabled": o.value ? "true" : void 0,
      "aria-current": e.item.active ? "true" : void 0,
      "aria-describedby": p.value ? L(h) : void 0,
      class: C(["group inline-flex w-full items-center text-left rounded-(--border-border-radius-rounded-sm) transition-colors", f.value]),
      onFocusin: y,
      onFocusout: T[0] || (T[0] = (I) => x.value = !1),
      onClick: k
    }, [
      v("div", yk, [
        v("div", {
          "data-testid": "dropdown-item-label-row",
          class: C(b.value)
        }, [
          e.item.loading ? (c(), g("i", {
            key: 0,
            class: C(["dropdown-icon ri-loader-4-line animate-spin text-(length:--size-xl) leading-(--line-height-m) size-4.5 inline-flex items-center justify-center shrink-0", u.value]),
            "aria-hidden": "true"
          }, null, 2)) : e.item.icon ? (c(), g(de, { key: 1 }, [
            $(e.item.icon) ? (c(), g("i", {
              key: 0,
              class: C([e.item.icon, "dropdown-icon text-(length:--size-xl) leading-(--line-height-m) size-4.5 inline-flex items-center justify-center shrink-0", u.value]),
              "aria-hidden": "true"
            }, null, 2)) : (c(), g("img", {
              key: 1,
              class: C(["dropdown-icon relative size-4.5 shrink-0 transition dark:invert dark:filter dark:group-hover:invert-0", e.item.active && "dark:invert-0"]),
              src: e.item.icon,
              alt: ""
            }, null, 10, kk))
          ], 64)) : w("", !0),
          te(pt, {
            text: e.item.label,
            focusable: !1,
            open: x.value || void 0,
            "text-class": e.item.icon ? void 0 : u.value
          }, null, 8, ["text", "open", "text-class"])
        ], 2),
        p.value ? (c(), g("span", {
          key: 0,
          id: L(h),
          "data-testid": "dropdown-item-helper",
          "aria-hidden": "true",
          class: "min-w-0 text-(length:--size-sm) leading-(--line-height-m) font-(--weight-regular) text-(--text-text-body-subtle)"
        }, j(p.value), 9, wk)) : w("", !0)
      ])
    ], 42, xk));
  }
}), Co = /* @__PURE__ */ ye({
  __name: "DropdownMenuItem",
  props: {
    item: {},
    variant: {},
    fallbackTestId: {},
    selectionStyle: {},
    tooltipRef: { type: Function }
  },
  emits: ["click"],
  setup(e) {
    return (n, t) => e.item.tooltip ? (c(), W(mt, {
      key: 0,
      ref: e.tooltipRef,
      text: e.item.tooltip,
      class: "w-full"
    }, {
      default: ve(() => [
        te(Cf, {
          item: e.item,
          variant: e.variant,
          "fallback-test-id": e.fallbackTestId,
          "selection-style": e.selectionStyle,
          onClick: t[0] || (t[0] = (a) => n.$emit("click", e.item))
        }, null, 8, ["item", "variant", "fallback-test-id", "selection-style"])
      ]),
      _: 1
    }, 8, ["text"])) : (c(), W(Cf, {
      key: 1,
      item: e.item,
      variant: e.variant,
      "fallback-test-id": e.fallbackTestId,
      "selection-style": e.selectionStyle,
      onClick: t[1] || (t[1] = (a) => n.$emit("click", e.item))
    }, null, 8, ["item", "variant", "fallback-test-id", "selection-style"]));
  }
}), Ck = {}, Sk = {
  class: "w-full py-1",
  "data-testid": "dropdown-separator",
  "aria-hidden": "true"
};
function $k(e, n) {
  return c(), g("div", Sk, [...n[0] || (n[0] = [
    v("div", { class: "border-t border-(--border-border-base-soft) dark:border-(--colors-border-base)" }, null, -1)
  ])]);
}
const Sf = /* @__PURE__ */ dt(Ck, [["render", $k]]);
function ja(e) {
  return e.normalize("NFD").replace(new RegExp("\\p{Diacritic}", "gu"), "").toLowerCase();
}
function Ku(e, n) {
  return ja(e).includes(ja(n.trim()));
}
function Ik(e) {
  return typeof e.getModifierState == "function" && e.getModifierState("AltGraph") ? !0 : e.ctrlKey && e.altKey;
}
function Yu(e = 500) {
  const n = R("");
  let t = null;
  function a() {
    n.value = "", t && (clearTimeout(t), t = null);
  }
  function l() {
    t && clearTimeout(t), t = setTimeout(a, e);
  }
  kt(() => {
    t && clearTimeout(t);
  });
  function r(o) {
    if (o.repeat) return !1;
    if (o.key === "Backspace")
      return n.value ? (n.value = n.value.slice(0, -1), n.value ? l() : a(), !0) : !1;
    if (o.isComposing) return !1;
    const i = Ik(o);
    return o.key.length !== 1 || o.metaKey || o.ctrlKey && !i || o.altKey && !i ? !1 : (n.value += o.key, l(), !0);
  }
  return { query: n, handleKey: r, reset: a };
}
const Lk = {
  key: 0,
  class: "flex items-center"
}, Tk = { class: "flex items-center gap-0.5" }, Ak = { class: "relative leading-(--line-height-l) font-(--weight-medium) dark:text-(--colors-text-white-default)" }, Ek = {
  key: 0,
  class: "relative leading-(--line-height-l) font-(--weight-medium) dark:text-(--colors-text-white-default)"
}, Rk = ["id", "aria-expanded", "aria-label"], Bk = {
  key: 1,
  class: "flex items-center gap-1.5 px-3 py-1 text-(length:--size-sm) leading-(--line-height-l)"
}, Mk = ["src"], Dk = {
  key: 1,
  class: "relative leading-(--line-height-l) font-(--weight-medium) dark:text-(--colors-text-white-default)"
}, zk = ["title"], Ok = ["src"], Pk = ["src"], Fk = ["role", "aria-labelledby", "aria-label", "data-focus-trap-return"], Vk = {
  key: 0,
  class: "flex w-full items-center gap-1.5 rounded-(--border-border-radius-rounded-sm) bg-(--colors-background-white-secondary) p-2 px-3"
}, Nk = { class: "flex min-w-0 flex-1 flex-col gap-0.5 text-(length:--size-m) leading-(--line-height-l)" }, Hk = { class: "truncate font-(--weight-semi-bold) text-(--colors-text-heading)" }, jk = { class: "truncate font-(--weight-regular) text-(--colors-text-body)" }, Wk = {
  key: 1,
  class: "absolute top-3 right-3"
}, qk = {
  key: 2,
  role: "presentation",
  "data-testid": "dropdown-menu-header",
  class: "flex h-4 w-full items-end px-2 text-(length:--size-sm) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
}, Uk = ["id"], Gk = { class: "overflow-y-auto flex-1 min-h-0 pr-[calc(var(--spacing-6)-1px)] -my-0.5 -ml-0.5 py-0.5 pl-0.5" }, Kk = {
  key: 0,
  "data-testid": "dropdown-megamenu-col-header",
  role: "presentation",
  class: "leading-(--line-height-l) font-(--weight-semi-bold) text-(length:--size-sm) text-(--colors-text-body-subtle)"
}, Yk = {
  key: 1,
  class: "flex flex-col gap-3 sm:flex-row sm:items-start sm:gap-5"
}, Jk = ["role", "aria-label"], Xk = { class: "w-full" }, As = 5, cn = /* @__PURE__ */ ye({
  __name: "Dropdown",
  props: {
    label: { default: "Dropdown" },
    triggerIconLeft: { default: void 0 },
    triggerIcon: { default: void 0 },
    triggerIconInfo: { default: void 0 },
    triggerIconInfoTooltip: { default: void 0 },
    items: { default: () => [] },
    groups: { default: void 0 },
    defaultOpen: { type: Boolean, default: !1 },
    menuWidth: { default: "auto" },
    fullWidth: { type: Boolean, default: !1 },
    menuAlign: { default: "left" },
    fieldLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    avatar: { default: void 0 },
    ghost: { type: Boolean, default: !1 },
    tab: { type: Boolean, default: !1 },
    profileType: { default: void 0 },
    ariaLabel: { default: void 0 },
    menuHeader: { default: void 0 },
    bare: { type: Boolean, default: !1 },
    menuItemVariant: { default: "default" },
    selectionStyle: { default: "highlight" },
    columns: { default: void 0 },
    closeable: { type: Boolean, default: !1 },
    closeLabel: { default: void 0 },
    menuOffset: { default: 4 },
    menuReference: { default: null },
    menuSide: { default: "bottom" }
  },
  setup(e, { expose: n }) {
    const t = e, a = m(() => {
      var F;
      if (t.ariaLabel) return t.ariaLabel;
      if (t.avatar) {
        const _ = (F = t.avatar.name) == null ? void 0 : F.trim();
        return _ ? `Open account menu, ${_}` : "Open account menu";
      }
    }), l = (F) => {
      var _;
      ((_ = F.currentTarget) == null ? void 0 : _.getAttribute("aria-disabled")) !== "true" && !r.value && (F.key === "ArrowDown" || F.key === "ArrowUp") && (F.preventDefault(), r.value = !0);
    }, r = R(t.defaultOpen), o = R(null), i = R(null), s = R(null), d = R(null), u = m(() => !t.tab && !t.avatar), f = () => {
      var F;
      return ((F = s.value) == null ? void 0 : F.$el) ?? i.value;
    }, b = qe(), h = qe(), p = R(void 0), x = () => {
      r.value = !r.value;
    }, y = () => {
      r.value = !1;
    }, k = m(() => ({
      id: h,
      "aria-haspopup": "menu",
      "aria-expanded": r.value,
      onClick: x,
      onKeydown: l
    })), $ = (F) => {
      var Q, ae;
      const _ = F.target, ue = ((Q = d.value) == null ? void 0 : Q.contains(_)) ?? !1, se = ((ae = o.value) == null ? void 0 : ae.contains(_)) ?? !1;
      !ue && !se && y();
    };
    ct(() => document.addEventListener("mousedown", $)), kt(() => document.removeEventListener("mousedown", $));
    let S = null;
    const T = () => {
      const F = t.menuReference ?? f() ?? d.value;
      if (!F || !o.value) return;
      S == null || S.destroy();
      const _ = t.menuSide, ue = _ === "top" ? "bottom" : "top", se = t.menuAlign === "right" ? "end" : "start", Q = t.menuAlign === "right" ? "start" : "end";
      S = Xa(F, o.value, {
        strategy: "fixed",
        placement: `${_}-${se}`,
        modifiers: [
          { name: "offset", options: { offset: [0, t.menuOffset] } },
          { name: "flip", options: { fallbackPlacements: [`${_}-${Q}`, `${ue}-${se}`, `${ue}-${Q}`] } },
          { name: "preventOverflow", options: { padding: 8 } },
          // Disable GPU acceleration so Popper uses top/left instead of transform,
          // avoiding conflict with the Vue Transition's transform: scale(...)
          { name: "computeStyles", options: { gpuAcceleration: !1 } }
        ]
      });
    };
    let I = null;
    const A = () => {
      I == null || I.disconnect(), !(!t.menuReference || typeof ResizeObserver > "u") && (I ?? (I = new ResizeObserver(() => S == null ? void 0 : S.update())), I.observe(t.menuReference));
    }, E = () => {
      S == null || S.destroy(), S = null, I == null || I.disconnect();
    };
    $e(
      () => [t.menuReference, t.menuSide, t.menuAlign, t.menuOffset],
      () => {
        r.value && (T(), A());
      }
    ), $e(r, async (F) => {
      var _;
      F ? (ie = !1, p.value = ((_ = Ce()) == null ? void 0 : _.id) || void 0, await Ge(), T(), A(), z()) : (Y.reset(), E());
    }), ct(() => {
      var F;
      r.value && (p.value = ((F = Ce()) == null ? void 0 : F.id) || void 0, Ge(T));
    }), kt(() => E());
    const D = () => o.value ? Array.from(
      o.value.querySelectorAll(
        '[role="menuitem"]:not([disabled]), [role="menuitemradio"]:not([disabled]), [role="menuitemcheckbox"]:not([disabled])'
      )
    ) : [], z = () => {
      Ge(() => {
        var _;
        const F = D();
        (_ = F.find((ue) => ue.getAttribute("role") === "menuitemradio" && ue.getAttribute("aria-checked") === "true") ?? F[0]) == null || _.focus();
      });
    }, Y = Yu(), le = (F, _) => {
      const ue = ja(Y.query.value), se = ue.length === 1 ? _ + 1 : _;
      for (let Q = 0; Q < F.length; Q++) {
        const ae = F[(se + Q) % F.length];
        if (ja(ae.dataset.menuLabel ?? ae.textContent ?? "").trim().startsWith(ue)) {
          ae.focus();
          return;
        }
      }
    }, ne = (F) => {
      var ue;
      const _ = D();
      (ue = _[Math.max(0, Math.min(F, _.length - 1))]) == null || ue.focus();
    }, re = (F) => {
      if (!r.value) {
        F.key === "Tab" && H();
        return;
      }
      const _ = D(), ue = document.activeElement, se = _.indexOf(ue);
      if (se !== -1 && !(F.key === " " && !Y.query.value) && Y.handleKey(F)) {
        F.preventDefault(), le(_, se);
        return;
      }
      switch (F.key) {
        case "ArrowDown":
          F.preventDefault(), ne(se < _.length - 1 ? se + 1 : 0);
          break;
        case "ArrowUp":
          F.preventDefault(), ne(se > 0 ? se - 1 : _.length - 1);
          break;
        case "Home":
          F.preventDefault(), ne(0);
          break;
        case "End":
          F.preventDefault(), ne(_.length - 1);
          break;
        case "Escape":
          M(F);
          break;
        case "Tab":
          H(), y();
          break;
      }
    }, O = /* @__PURE__ */ new Map(), P = (F) => (_) => {
      _ ? O.set(F, _) : O.delete(F);
    }, V = () => {
      for (const F of O.values())
        if (F.isVisible) return F;
    }, M = (F) => {
      F.stopPropagation(), F.preventDefault();
      const _ = V();
      if (_) {
        _.hide();
        return;
      }
      he();
    }, B = (F) => {
      r.value && M(F);
    }, q = m(() => {
      var _;
      if (!t.columns || !((_ = t.groups) != null && _.length)) return null;
      const F = t.groups.filter((ue) => ue.items.length > 0);
      return F.length > 0 ? F : null;
    }), N = m(
      () => q.value ? Math.min(q.value.length, t.columns ?? q.value.length) : 0
    ), G = m(() => {
      var _;
      if (t.columns || !((_ = t.groups) != null && _.length)) return null;
      const F = t.groups.filter((ue) => ue.items.length > 0);
      return F.length > 0 ? F : null;
    }), U = m(() => {
      if (!t.columns || q.value) return null;
      const F = Math.max(1, t.columns), _ = Math.min(F, Math.max(1, Math.ceil(t.items.length / As))), ue = t.items.length > As * F ? Math.ceil(t.items.length / F) : As, se = Array.from({ length: _ }, () => []);
      return t.items.forEach((Q, ae) => {
        var Te;
        (Te = se[Math.min(Math.floor(ae / ue), _ - 1)]) == null || Te.push(Q);
      }), se.filter((Q) => Q.length > 0);
    }), K = m(() => {
      var F;
      return q.value ? N.value : ((F = U.value) == null ? void 0 : F.length) ?? 0;
    }), ge = m(() => K.value > 2), xe = m(() => !!(q.value || U.value)), X = (F) => {
      F.disabled || F.loading || (F.onClick && F.onClick(), (!F.hasSwitch || t.menuItemVariant === "nav") && he());
    };
    let ie = !1;
    const he = () => {
      ie = !0, y();
    }, oe = () => {
      if (!ie) return;
      ie = !1;
      const F = document.activeElement;
      F && F !== document.body || H();
    }, Ce = () => {
      var F;
      return f() ?? ((F = d.value) == null ? void 0 : F.querySelector('button, [tabindex="0"], [tabindex]:not([tabindex="-1"])'));
    }, H = () => {
      var F;
      return (F = Ce()) == null ? void 0 : F.focus();
    }, Z = m(() => t.menuSide === "top" ? t.menuAlign === "right" ? "origin-bottom-right" : "origin-bottom-left" : t.menuAlign === "right" ? "origin-top-right" : "origin-top-left"), ee = m(() => {
      var F;
      return t.fullWidth ? { width: `${((F = d.value) == null ? void 0 : F.offsetWidth) ?? 0}px` } : t.menuWidth !== "auto" ? { width: t.menuWidth } : t.columns || t.bare ? {} : { minWidth: "208px", maxWidth: "320px" };
    }), J = (F) => !!F && F.startsWith("ri-");
    return n({ isOpen: r, close: y }), (F, _) => (c(), g("div", {
      class: C(["text-text-black-default relative text-left dark:text-(--colors-text-white-default)", [e.tab ? "flex h-full items-stretch" : "inline-block", { "w-full": e.fullWidth }]]),
      onKeydown: ht(B, ["escape"])
    }, [
      e.fieldLabel ? (c(), g("div", Lk, [
        v("div", Tk, [
          v("div", Ak, j(e.fieldLabel), 1),
          e.required ? (c(), g("div", Ek, " * ")) : w("", !0)
        ])
      ])) : w("", !0),
      v("div", {
        class: C(["text-text-black-default relative flex flex-col items-start text-left dark:text-(--colors-text-white-default)", { "w-full": e.fullWidth, "h-full": e.tab }])
      }, [
        v("div", {
          ref_key: "triggerWrapperRef",
          ref: d,
          class: C({ "w-full": e.fullWidth, "h-full": e.tab })
        }, [
          Ae(F.$slots, "trigger", {
            toggle: x,
            isOpen: r.value,
            triggerProps: k.value
          }, () => [
            u.value ? (c(), W(Me, Fe({
              key: 0,
              ref_key: "triggerButtonRef",
              ref: s,
              "data-testid": "dropdown-trigger",
              size: "xs",
              variant: e.ghost ? "ghost" : "secondary",
              label: e.label,
              "icon-left": e.triggerIconLeft,
              "icon-right": e.triggerIcon,
              "dropdown-icon": !!e.label && !e.triggerIcon,
              "icon-only": !e.label,
              "aria-label": e.ariaLabel,
              "full-width": e.fullWidth
            }, k.value), null, 16, ["variant", "label", "icon-left", "icon-right", "dropdown-icon", "icon-only", "aria-label", "full-width"])) : (c(), g("button", {
              key: 1,
              id: L(h),
              ref_key: "triggerRef",
              ref: i,
              type: "button",
              "data-testid": "dropdown-trigger",
              class: C(["focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royalblue z-0 cursor-pointer transition-colors", [
                e.tab ? "focus-visible:ring-inset shrink-0 h-full flex items-center rounded-tl-(--border-border-radius-rounded-sm) rounded-tr-(--border-border-radius-rounded-sm) border-t border-r border-l border-(--border-border-tab) bg-(--colors-background-white-tertiary) text-(--colors-text-black-default) hover:bg-whitesmoke dark:bg-white/5 dark:text-(--colors-text-white-secondary) dark:hover:bg-white/10 duration-200" : [
                  "focus-visible:ring-offset-2 rounded-(--border-border-radius-rounded-full) border border-solid duration-300",
                  "border-border-secondary-button hover:border-royalblue bg-white dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default)"
                ],
                {
                  "w-full justify-between": e.fullWidth,
                  "justify-center": !e.fullWidth && !e.tab
                }
              ]]),
              "aria-expanded": r.value,
              "aria-haspopup": "menu",
              "aria-label": a.value,
              onClick: x,
              onKeydown: l
            }, [
              t.avatar ? (c(), W(Nt, {
                key: 0,
                presentational: "",
                as: "span",
                name: t.avatar.name,
                img: t.avatar.img
              }, null, 8, ["name", "img"])) : (c(), g("div", Bk, [
                e.triggerIconLeft ? (c(), g(de, { key: 0 }, [
                  J(e.triggerIconLeft) ? (c(), g("i", {
                    key: 0,
                    class: C([e.triggerIconLeft, "dropdown-icon text-(length:--icon-size-sm) leading-(--icon-size-sm) size-(--icon-size-sm) inline-flex items-center justify-center"])
                  }, null, 2)) : (c(), g("img", {
                    key: 1,
                    class: "dropdown-icon relative h-4 w-4",
                    src: e.triggerIconLeft,
                    alt: ""
                  }, null, 8, Mk))
                ], 64)) : w("", !0),
                e.label ? (c(), g("div", Dk, j(e.label), 1)) : w("", !0),
                e.triggerIconInfo ? (c(), g("span", {
                  key: 2,
                  class: "inline-flex items-center",
                  title: e.triggerIconInfoTooltip,
                  onClick: _[0] || (_[0] = Je(() => {
                  }, ["stop"]))
                }, [
                  J(e.triggerIconInfo) ? (c(), g("i", {
                    key: 0,
                    class: C([e.triggerIconInfo, "dropdown-icon text-(length:--size-xl) leading-(--size-xl) size-(--size-xl) inline-flex items-center justify-center"])
                  }, null, 2)) : (c(), g("img", {
                    key: 1,
                    class: "dropdown-icon relative h-4.5 w-4.5",
                    src: e.triggerIconInfo,
                    alt: ""
                  }, null, 8, Ok))
                ], 8, zk)) : w("", !0),
                e.triggerIcon ? (c(), g(de, { key: 3 }, [
                  J(e.triggerIcon) ? (c(), g("i", {
                    key: 0,
                    class: C([
                      e.triggerIcon,
                      "dropdown-icon text-(length:--icon-size-sm) leading-(--icon-size-sm) size-(--icon-size-sm) inline-flex items-center justify-center transition-transform duration-200 ease-in-out"
                    ]),
                    style: je({ transform: r.value ? "rotate(180deg)" : "rotate(0deg)" })
                  }, null, 6)) : (c(), g("img", {
                    key: 1,
                    class: "dropdown-icon relative h-4 w-4 transition-transform duration-200 ease-in-out",
                    style: je({ transform: r.value ? "rotate(180deg)" : "rotate(0deg)" }),
                    src: e.triggerIcon,
                    alt: ""
                  }, null, 12, Pk))
                ], 64)) : e.label ? (c(), g("svg", {
                  key: 4,
                  class: "relative h-4 w-4 transition-transform duration-200 ease-in-out",
                  style: je({ transform: r.value ? "rotate(180deg)" : "rotate(0deg)" }),
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [..._[1] || (_[1] = [
                  v("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M19 9l-7 7-7-7"
                  }, null, -1)
                ])], 4)) : w("", !0)
              ]))
            ], 42, Rk))
          ])
        ], 2),
        (c(), W(Nn, { to: "body" }, [
          te(At, {
            "enter-active-class": "transition duration-100 ease-out motion-reduce:transition-none",
            "enter-from-class": "transform scale-95 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100",
            "leave-active-class": "transition duration-75 ease-out motion-reduce:transition-none",
            "leave-from-class": "transform scale-100 opacity-100",
            "leave-to-class": "transform scale-95 opacity-0",
            onAfterLeave: oe
          }, {
            default: ve(() => [
              r.value ? (c(), g("div", {
                key: 0,
                ref_key: "menuRef",
                ref: o,
                role: e.bare ? void 0 : "menu",
                "aria-labelledby": xe.value ? L(b) : e.bare ? void 0 : p.value,
                "aria-label": e.bare || xe.value ? void 0 : e.ariaLabel,
                "data-focus-trap-return": p.value,
                "data-testid": "dropdown-menu",
                "data-focus-trap-allow-outside": "",
                class: C(["fixed z-[350]", [
                  xe.value ? L(lk) : L(Za),
                  L(Uu),
                  Z.value,
                  xe.value && "relative flex flex-col pt-[calc(var(--spacing-6)-1px)] pb-[calc(var(--spacing-6)-1px)] pl-[calc(var(--spacing-6)-1px)] max-h-[calc(100vh-90px)] max-w-[calc(100vw-32px)]",
                  !e.bare && !xe.value && [L(kg), "max-h-[min(400px,calc(100vh-24px))] items-start overflow-y-auto"],
                  e.bare && "max-h-[calc(100vh-90px)] overflow-y-auto"
                ]]),
                style: je(ee.value),
                onKeydown: re
              }, [
                t.avatar ? (c(), g("div", Vk, [
                  te(Nt, {
                    name: t.avatar.name,
                    img: t.avatar.img,
                    presentational: ""
                  }, null, 8, ["name", "img"]),
                  v("div", Nk, [
                    v("div", Hk, j(t.avatar.name), 1),
                    v("div", jk, j(t.avatar.email), 1)
                  ]),
                  t.profileType ? (c(), W(gt, {
                    key: 0,
                    class: "ms-auto",
                    theme: "white",
                    size: "sm",
                    label: t.profileType
                  }, null, 8, ["label"])) : w("", !0)
                ])) : w("", !0),
                e.closeable ? (c(), g("div", Wk, [
                  te(Me, {
                    "data-testid": "dropdown-close",
                    variant: "ghost",
                    "icon-only": "",
                    size: "sm",
                    "icon-left": "ri-close-fill",
                    "aria-label": e.closeLabel,
                    onClick: y
                  }, null, 8, ["aria-label"])
                ])) : w("", !0),
                e.menuHeader && !t.avatar && !xe.value ? (c(), g("div", qk, j(e.menuHeader), 1)) : w("", !0),
                Ae(F.$slots, "menu", { close: y }, () => [
                  xe.value ? (c(), g(de, { key: 0 }, [
                    v("div", {
                      class: C(["mb-5", e.closeable ? "pr-[calc(var(--spacing-16)-1px)]" : "pr-[calc(var(--spacing-6)-1px)]"])
                    }, [
                      v("h5", {
                        id: L(b),
                        class: "text-(length:--size-xl) font-(--weight-semi-bold)",
                        style: { color: "var(--text-text-black-default)", "line-height": "var(--line-height-xl)" }
                      }, j(e.menuHeader), 9, Uk)
                    ], 2),
                    v("div", Gk, [
                      q.value ? (c(), g("div", {
                        key: 0,
                        "data-testid": "dropdown-megamenu-groups",
                        class: "grid grid-cols-1 gap-y-3 sm:grid-cols-[repeat(var(--dropdown-megamenu-cols),minmax(0,var(--dropdown-megamenu-col-w)))] sm:gap-x-5",
                        style: je({
                          "--dropdown-megamenu-cols": N.value,
                          "--dropdown-megamenu-col-w": ge.value ? "240px" : "275px"
                        })
                      }, [
                        (c(!0), g(de, null, Re(q.value, (ue) => (c(), g("div", {
                          key: ue.key,
                          "data-testid": "dropdown-megamenu-col",
                          class: "flex flex-col items-start gap-3 min-w-0"
                        }, [
                          ue.label ? (c(), g("div", Kk, j(ue.label), 1)) : w("", !0),
                          (c(!0), g(de, null, Re(ue.items, (se, Q) => (c(), W(Co, {
                            key: Q,
                            item: se,
                            variant: e.menuItemVariant,
                            "selection-style": e.selectionStyle,
                            "tooltip-ref": P(`${ue.key}-${Q}`),
                            "fallback-test-id": "dropdown-megamenu-item",
                            onClick: (ae) => X(se)
                          }, null, 8, ["item", "variant", "selection-style", "tooltip-ref", "onClick"]))), 128))
                        ]))), 128))
                      ], 4)) : (c(), g("div", Yk, [
                        (c(!0), g(de, null, Re(U.value, (ue, se) => (c(), g("div", {
                          key: se,
                          "data-testid": "dropdown-megamenu-col",
                          class: C(["flex flex-col items-start gap-3 w-full shrink-0 sm:shrink sm:min-w-0", ge.value ? "sm:w-60" : "sm:w-68.75"])
                        }, [
                          (c(!0), g(de, null, Re(ue, (Q, ae) => (c(), W(Co, {
                            key: ae,
                            item: Q,
                            variant: e.menuItemVariant,
                            "selection-style": e.selectionStyle,
                            "tooltip-ref": P(`col-${se}-${ae}`),
                            "fallback-test-id": "dropdown-megamenu-item",
                            onClick: (Te) => X(Q)
                          }, null, 8, ["item", "variant", "selection-style", "tooltip-ref", "onClick"]))), 128))
                        ], 2))), 128))
                      ]))
                    ])
                  ], 64)) : G.value ? (c(!0), g(de, { key: 1 }, Re(G.value, (ue, se) => (c(), g(de, {
                    key: ue.key
                  }, [
                    se > 0 ? (c(), W(Sf, { key: 0 })) : w("", !0),
                    v("div", {
                      class: "flex w-full flex-col gap-1.5",
                      role: ue.items.length > 1 && ue.label ? "group" : void 0,
                      "aria-label": ue.items.length > 1 && ue.label ? ue.label : void 0
                    }, [
                      (c(!0), g(de, null, Re(ue.items, (Q, ae) => (c(), W(Co, {
                        key: ae,
                        item: Q,
                        variant: e.menuItemVariant,
                        "selection-style": e.selectionStyle,
                        "tooltip-ref": P(`group-${ue.key}-${ae}`),
                        "fallback-test-id": "dropdown-item",
                        onClick: (Te) => X(Q)
                      }, null, 8, ["item", "variant", "selection-style", "tooltip-ref", "onClick"]))), 128))
                    ], 8, Jk)
                  ], 64))), 128)) : (c(!0), g(de, { key: 2 }, Re(e.items, (ue, se) => (c(), g(de, { key: se }, [
                    v("div", Xk, [
                      te(Co, {
                        item: ue,
                        variant: e.menuItemVariant,
                        "selection-style": e.selectionStyle,
                        "tooltip-ref": P(`flat-${se}`),
                        "fallback-test-id": "dropdown-item",
                        onClick: (Q) => X(ue)
                      }, null, 8, ["item", "variant", "selection-style", "tooltip-ref", "onClick"])
                    ]),
                    ue.hasDividerAfter && se < e.items.length - 1 ? (c(), W(Sf, { key: 0 })) : w("", !0)
                  ], 64))), 128))
                ])
              ], 46, Fk)) : w("", !0)
            ]),
            _: 3
          })
        ]))
      ], 2)
    ], 34));
  }
}), Cg = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "LinkBase",
  props: {
    as: { default: "button" },
    iconLeft: {},
    iconRight: {},
    size: { default: "m" },
    ariaLabel: {},
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: [Boolean, String], default: !1 },
    underline: {}
  },
  setup(e) {
    const n = e, t = m(() => n.disabled && n.as === "button"), a = m(() => !!n.ariaDisabled && n.ariaDisabled !== "false"), l = m(() => n.disabled || a.value), r = Gn();
    function o() {
      const b = l.value ? vg(r) : r;
      return { ...n.as === "button" ? { type: "button" } : {}, ...b };
    }
    const i = {
      s: "text-(length:--size-sm) leading-(--line-height-l)",
      m: "text-(length:--size-m) leading-(--line-height-l)",
      l: "text-(length:--size-l) leading-(--line-height-xxl)"
    }, s = m(() => [
      "group/link inline-flex items-center gap-1.5 py-0.5 font-(--weight-medium) transition-colors duration-150 ease-in-out motion-reduce:transition-none focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)",
      i[n.size],
      l.value ? "cursor-not-allowed text-(--text-text-disabled-strong)" : "cursor-pointer text-(--text-text-link) hover:text-(--text-text-hover)"
    ]), d = m(() => [
      "text-num-16",
      l.value ? "text-(--icons-icon-disabled-strong)" : "text-(--icons-icon-link) group-hover/link:text-(--icons-icon-hover)"
    ]), u = m(() => n.underline === "always" ? "underline" : l.value ? "" : "group-hover/link:underline group-focus-visible/link:underline");
    function f(b) {
      l.value && b.preventDefault();
    }
    return (b, h) => (c(), W(it(e.as), Fe(o(), {
      "aria-label": e.ariaLabel,
      disabled: t.value || void 0,
      "aria-disabled": l.value && !t.value ? "true" : void 0,
      class: s.value,
      onClickCapture: f,
      onAuxclickCapture: f
    }), {
      default: ve(() => [
        e.iconLeft ? (c(), g("i", {
          key: 0,
          class: C([e.iconLeft, d.value]),
          "aria-hidden": "true"
        }, null, 2)) : w("", !0),
        v("span", {
          class: C(u.value)
        }, [
          Ae(b.$slots, "default")
        ], 2),
        e.iconRight ? (c(), g("i", {
          key: 1,
          class: C([e.iconRight, d.value]),
          "aria-hidden": "true"
        }, null, 2)) : w("", !0)
      ]),
      _: 3
    }, 16, ["aria-label", "disabled", "aria-disabled", "class"]));
  }
}), Mn = /* @__PURE__ */ ye({
  __name: "TextLink",
  props: {
    as: {},
    iconLeft: {},
    iconRight: {},
    size: {},
    ariaLabel: {},
    disabled: { type: Boolean },
    ariaDisabled: { type: [Boolean, String] }
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), W(Cg, Fe(n, { underline: "hover" }), {
      default: ve(() => [
        Ae(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Sg = /* @__PURE__ */ ye({
  __name: "FieldLabelTooltip",
  props: {
    text: {}
  },
  setup(e) {
    return (n, t) => (c(), W(mt, {
      as: "span",
      text: e.text,
      class: "shrink-0",
      "data-field-label-tooltip": "",
      tabindex: "0",
      role: "group",
      "aria-label": e.text
    }, {
      default: ve(() => [...t[0] || (t[0] = [
        v("i", {
          class: "ri-information-line inline-flex size-3.5 shrink-0 items-center justify-center cursor-help text-(length:--size-m) text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
          "aria-hidden": "true"
        }, null, -1)
      ])]),
      _: 1
    }, 8, ["text", "aria-label"]));
  }
}), Zk = {
  key: 1,
  class: "sr-only"
}, It = /* @__PURE__ */ ye({
  __name: "FieldLabel",
  props: {
    text: {},
    inputId: { default: void 0 },
    id: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    tooltip: { default: void 0 },
    focused: { type: Boolean, default: !1 },
    inline: { type: Boolean, default: !1 },
    testId: { default: void 0 },
    secondaryText: { default: void 0 },
    secondaryPosition: { default: "right" },
    textClass: { default: void 0 },
    as: { default: "div" }
  },
  setup(e, { expose: n }) {
    const t = e, a = R(null), l = R(!1), r = m(() => l.value ? !1 : t.focused ? !0 : void 0);
    $e(
      () => t.focused,
      (d) => {
        d || (l.value = !1);
      }
    ), n({ handleFieldKeydown: (d) => {
      var u;
      d.key !== "Escape" || l.value || !t.focused || !((u = a.value) != null && u.isTruncated) || (d.stopPropagation(), d.preventDefault(), l.value = !0);
    } });
    const i = m(
      () => t.textClass ?? "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)"
    ), s = m(() => t.secondaryText && t.secondaryPosition === "below" ? [
      "grid min-w-0 max-w-full grid-cols-[minmax(0,auto)_auto] items-center justify-start gap-1",
      t.inline ? "shrink-0" : ""
    ] : [
      "flex min-w-0 max-w-full items-center gap-1",
      t.inline ? "shrink-0" : "",
      t.secondaryText && !t.inline ? "w-full" : ""
    ]);
    return (d, u) => (c(), W(it(e.as), {
      class: C(s.value)
    }, {
      default: ve(() => [
        (c(), W(it(e.inputId ? "label" : "span"), {
          id: e.id,
          for: e.inputId,
          "data-testid": e.testId,
          class: "flex min-w-0 items-center text-(--text-text-black-default) dark:text-(--colors-text-white-default)"
        }, {
          default: ve(() => [
            te(pt, {
              ref_key: "labelRef",
              ref: a,
              text: e.text,
              lines: 1,
              "text-class": i.value,
              focusable: !1,
              open: r.value
            }, null, 8, ["text", "text-class", "open"]),
            e.required ? (c(), g("span", {
              key: 0,
              class: C(["shrink-0 whitespace-pre", i.value])
            }, j(` ${e.requiredIndicator}`), 3)) : w("", !0),
            e.secondaryText ? (c(), g("span", Zk, j(` ${e.secondaryText}`), 1)) : w("", !0)
          ]),
          _: 1
        }, 8, ["id", "for", "data-testid"])),
        e.tooltip ? (c(), W(Sg, {
          key: 0,
          text: e.tooltip
        }, null, 8, ["text"])) : w("", !0),
        e.secondaryText ? (c(), g("span", {
          key: 1,
          "aria-hidden": "true",
          class: C([
            "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body) dark:text-(--colors-text-white-default)",
            e.secondaryPosition === "below" ? "col-span-full min-w-0 break-words" : "ml-auto shrink-0 whitespace-nowrap"
          ])
        }, j(e.secondaryText), 3)) : w("", !0)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), Qk = ["data-type"], _k = ["id"], pl = /* @__PURE__ */ ye({
  __name: "DropdownPanelFooter",
  props: {
    type: {},
    buttons: { default: () => {
    } },
    label: { default: () => {
    } },
    seeAllLabel: { default: () => {
    } },
    createLabel: { default: () => {
    } },
    createIcon: { default: "ri-add-line" },
    seeAllOption: { default: () => {
    } },
    createOption: { default: () => {
    } },
    description: { default: () => {
    } }
  },
  emits: ["button-click", "see-all", "create", "option-hover"],
  setup(e, { emit: n }) {
    const t = qe(), a = (r, o) => r ? {
      id: r.id,
      role: "option",
      "aria-selected": !!r.active,
      "aria-label": o,
      "data-testid": r.testId,
      class: [
        "w-full rounded-(--border-border-radius-rounded-full)",
        r.active && "shadow-(--shadow-focus-l)"
      ]
    } : { class: "contents" }, l = n;
    return (r, o) => (c(), g("div", {
      "data-testid": "dropdown-panel-footer",
      "data-type": e.type,
      class: C([
        "relative flex flex-col gap-1.5 rounded-b-(--border-border-radius-rounded-l) bg-(--background-background-white) px-3 py-4 shadow-(--blur-shadow-m) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)",
        e.label ? "items-start" : ""
      ])
    }, [
      e.label ? (c(), W(It, {
        key: 0,
        text: e.label,
        "test-id": "dropdown-panel-footer-label"
      }, null, 8, ["text"])) : w("", !0),
      e.type === "see-all-create" ? (c(), g(de, { key: 1 }, [
        e.seeAllLabel ? (c(), g("div", Fe({ key: 0 }, a(e.seeAllOption, e.seeAllLabel), {
          onMouseenter: o[1] || (o[1] = (i) => e.seeAllOption && l("option-hover", "see-all"))
        }), [
          te(Me, {
            variant: "secondary",
            size: "md",
            "icon-left": "ri-eye-line",
            label: e.seeAllLabel,
            "full-width": "",
            tabindex: e.seeAllOption ? -1 : void 0,
            "aria-hidden": e.seeAllOption ? "true" : void 0,
            "data-testid": "dropdown-panel-footer-see-all",
            onClick: o[0] || (o[0] = (i) => l("see-all"))
          }, null, 8, ["label", "tabindex", "aria-hidden"])
        ], 16)) : w("", !0),
        e.createLabel ? (c(), g("div", Fe({ key: 1 }, a(e.createOption, e.createLabel), {
          onMouseenter: o[3] || (o[3] = (i) => e.createOption && l("option-hover", "create"))
        }), [
          te(Mn, {
            size: "m",
            "icon-left": e.createIcon,
            class: "w-full justify-center",
            tabindex: e.createOption ? -1 : void 0,
            "aria-hidden": e.createOption ? "true" : void 0,
            "data-testid": "dropdown-panel-footer-create",
            onClick: o[2] || (o[2] = (i) => l("create"))
          }, {
            default: ve(() => [
              nt(j(e.createLabel), 1)
            ]),
            _: 1
          }, 8, ["icon-left", "tabindex", "aria-hidden"])
        ], 16)) : w("", !0)
      ], 64)) : e.buttons ? (c(), g("div", {
        key: 2,
        "data-testid": "dropdown-panel-footer-buttons",
        class: C(e.type === "buttons-inline" ? "flex w-full gap-1.5" : "flex w-full flex-col gap-3")
      }, [
        (c(!0), g(de, null, Re(e.buttons, (i, s) => (c(), W(Me, {
          key: s,
          variant: i.variant ?? "secondary",
          size: "sm",
          label: i.label,
          "icon-left": i.icon,
          disabled: i.disabled,
          "aria-disabled": i.ariaDisabled,
          "aria-describedby": i.ariaDisabled && e.description ? L(t) : void 0,
          "full-width": "",
          shrink: e.type === "buttons-inline",
          class: C(e.type === "buttons-inline" ? "flex-1" : ""),
          "data-testid": i.testId ?? `dropdown-panel-footer-button-${s}`,
          onClick: (d) => l("button-click", s)
        }, null, 8, ["variant", "label", "icon-left", "disabled", "aria-disabled", "aria-describedby", "shrink", "class", "data-testid", "onClick"]))), 128))
      ], 2)) : w("", !0),
      e.description ? (c(), g("p", {
        key: 3,
        id: L(t),
        "data-testid": "dropdown-panel-footer-description",
        class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
      }, j(e.description), 9, _k)) : w("", !0)
    ], 10, Qk));
  }
}), ew = { class: "inline-flex min-w-0 max-w-full text-(--text-text-black-default) dark:text-(--colors-text-white-default)" }, tw = {
  "data-testid": "label-dropdown-label",
  class: "inline-flex min-w-0 items-center gap-1 px-px"
}, nw = {
  "data-testid": "label-dropdown-text-frame",
  class: "inline-flex min-w-0 whitespace-nowrap"
}, aw = ["id"], lw = { class: "sr-only" }, Yr = /* @__PURE__ */ ye({
  __name: "LabelDropdown",
  props: {
    label: {},
    type: { default: "14px" },
    infoLeft: { default: () => {
    } },
    iconLeft: { default: () => {
    } },
    infoRight: { default: () => {
    } },
    required: { type: Boolean, default: !1 },
    requiredLabel: { default: () => {
    } },
    id: { default: () => {
    } }
  },
  setup(e) {
    const n = {
      "14px": {
        text: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)",
        icon: "text-(length:--icon-size-xs) leading-(--icon-size-xs)"
      },
      h6: {
        text: "font-(family-name:--family-heading) text-(length:--size-l) leading-(--line-height-l) font-(--weight-bold)",
        icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)"
      },
      h5: {
        text: "font-(family-name:--family-heading) text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold)",
        icon: "text-(length:--icon-size-md) leading-(--icon-size-md)"
      }
    }, t = m(() => n[e.type]);
    return (a, l) => (c(), g("span", ew, [
      v("span", tw, [
        e.iconLeft ? (c(), g("i", {
          key: 0,
          class: C([e.iconLeft, "shrink-0 text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", t.value.icon]),
          "aria-hidden": "true",
          "data-testid": "label-dropdown-icon-left"
        }, null, 2)) : w("", !0),
        e.infoLeft ? (c(), W(mt, {
          key: 1,
          as: "span",
          text: e.infoLeft,
          tabindex: "0",
          role: "img",
          "aria-label": e.infoLeft,
          "data-testid": "label-dropdown-info-left",
          class: "shrink-0 rounded-(--border-border-radius-rounded-full) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent"
        }, {
          default: ve(() => [
            v("i", {
              class: C(["ri-information-line text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", t.value.icon]),
              "aria-hidden": "true"
            }, null, 2)
          ]),
          _: 1
        }, 8, ["text", "aria-label"])) : w("", !0),
        v("span", nw, [
          v("span", {
            "data-testid": "label-dropdown-text",
            class: C(["flex min-w-0", t.value.text])
          }, [
            Ae(a.$slots, "default", {}, () => [
              te(pt, { text: e.label }, null, 8, ["text"])
            ])
          ], 2),
          e.id ? (c(), g("span", {
            key: 0,
            id: e.id,
            hidden: "",
            "data-testid": "label-dropdown-name"
          }, j(e.label), 9, aw)) : w("", !0),
          e.required ? (c(), g(de, { key: 1 }, [
            l[0] || (l[0] = v("span", {
              "aria-hidden": "true",
              "data-testid": "label-dropdown-required",
              class: "w-(--spacing-2) text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
            }, "*", -1)),
            v("span", lw, j(e.requiredLabel), 1)
          ], 64)) : w("", !0)
        ]),
        e.infoRight ? (c(), W(mt, {
          key: 2,
          as: "span",
          text: e.infoRight,
          tabindex: "0",
          role: "img",
          "aria-label": e.infoRight,
          "data-testid": "label-dropdown-info-right",
          class: "shrink-0 rounded-(--border-border-radius-rounded-full) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent"
        }, {
          default: ve(() => [
            v("i", {
              class: C(["ri-information-line text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", t.value.icon]),
              "aria-hidden": "true"
            }, null, 2)
          ]),
          _: 1
        }, 8, ["text", "aria-label"])) : w("", !0)
      ])
    ]));
  }
}), Es = 1;
function $g({ strip: e, arrow: n, backArrow: t, enabled: a, selection: l }) {
  const r = R(!1), o = R(!1), i = R(!1), s = m(() => r.value && o.value), d = m(() => r.value && i.value);
  function u() {
    const z = e.value;
    if (!z || !a()) {
      r.value = !1, o.value = !1, i.value = !1;
      return;
    }
    const Y = z.scrollWidth - z.clientWidth;
    r.value = Y > Es, o.value = r.value && z.scrollLeft < Y - Es, i.value = r.value && z.scrollLeft > Es;
  }
  const f = () => {
    var z;
    return s.value ? ((z = n.value) == null ? void 0 : z.offsetWidth) ?? 0 : 0;
  }, b = () => {
    var z;
    return d.value ? ((z = t.value) == null ? void 0 : z.offsetWidth) ?? 0 : 0;
  }, h = (z) => f() || parseFloat(getComputedStyle(z).scrollPaddingInlineEnd) || 0, p = (z) => b() || parseFloat(getComputedStyle(z).scrollPaddingInlineStart) || 0;
  let x = !1;
  const y = () => (!s.value || !!n.value) && (!d.value || !!t.value);
  function k(z) {
    const Y = z.querySelector(":scope > [aria-selected='true'], :scope > .active");
    if (Y) return Y;
    let le = z.querySelector("[role='tab'][aria-selected='true']");
    for (; le && le.parentElement !== z; ) le = le.parentElement;
    return le;
  }
  function $() {
    x = !1;
    const z = e.value;
    if (!z || !r.value) return;
    const Y = k(z);
    if (!Y) return;
    const le = z.getBoundingClientRect(), ne = Y.getBoundingClientRect(), re = le.left + z.clientLeft, O = p(z), P = h(z), V = re + O, M = re + z.clientWidth - P;
    if (ne.left < V) {
      const B = z.scrollLeft - (V - ne.left);
      z.scrollLeft = Y === z.firstElementChild || B < O ? 0 : B;
    } else if (ne.right > M) {
      const B = z.scrollWidth - z.clientWidth, q = z.scrollLeft + Math.min(ne.right - M, ne.left - V);
      z.scrollLeft = Y === z.lastElementChild || q > B - P ? B : q;
    }
    u(), x = !y();
  }
  $e(
    () => (s.value || d.value) && y(),
    (z) => {
      z && x && $();
    },
    { flush: "post" }
  );
  function S(z) {
    const Y = e.value;
    if (!Y) return;
    const le = typeof window.matchMedia == "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches, ne = Math.max(Y.clientWidth - f() - b(), 1);
    Y.scrollBy({ left: z * ne, behavior: le ? "auto" : "smooth" });
  }
  function T(z, Y) {
    const le = e.value;
    if (!le || !z || document.activeElement !== z) return;
    const ne = le.querySelectorAll(":scope > [data-button-group-item]"), re = ne.length ? ne : le.querySelectorAll("[role='tab']"), O = Y === "first" ? re[0] ?? le.firstElementChild : re[re.length - 1] ?? le.lastElementChild;
    O == null || O.focus({ preventScroll: !0 });
  }
  $e(s, (z) => z || T(n.value, "last")), $e(d, (z) => z || T(t.value, "first"));
  let I = null, A = 0;
  const E = () => {
    cancelAnimationFrame(A), A = requestAnimationFrame(u);
  };
  function D() {
    if (!I) return;
    I.disconnect();
    const z = e.value;
    !z || !a() || (I.observe(z), Array.from(z.children).forEach((Y) => I.observe(Y)));
  }
  return ct(async () => {
    var z;
    typeof ResizeObserver < "u" && (I = new ResizeObserver(E)), D(), u(), await Ge(), u(), $(), (z = document.fonts) == null || z.ready.then(() => {
      u(), $();
    });
  }), uo(() => {
    D(), u();
  }), $e(l, () => Ge($)), yt(() => {
    I == null || I.disconnect(), I = null, cancelAnimationFrame(A);
  }), {
    overflowing: r,
    showArrow: s,
    showBackArrow: d,
    measure: u,
    scrollForward: () => S(1),
    scrollBack: () => S(-1)
  };
}
const rw = {
  key: 0,
  class: "inline-flex flex-col gap-1"
}, ow = { class: "flex items-center justify-between gap-2.5 px-2" }, iw = ["role", "aria-labelledby"], sw = ["aria-label"], dw = ["role", "tabindex"], uw = ["aria-label"], cw = ["role"], fw = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "ButtonGroup",
  props: {
    variant: { default: "pill" },
    color: { default: () => {
    } },
    size: { default: "sm" },
    labelLeft: { default: () => {
    } },
    labelRight: { default: () => {
    } },
    labelLeftInfo: { default: () => {
    } },
    labelRightInfo: { default: () => {
    } },
    modelValue: { default: () => {
    } },
    panelId: { default: () => {
    } },
    overflowLabel: {},
    overflowPreviousLabel: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, a = Hn();
    ct(() => {
      var q;
      const V = ((q = a.default) == null ? void 0 : q.call(a, {})) ?? [], M = e.variant === "tab" ? "tab" : "tertiary";
      V.some((N) => {
        var U;
        const G = (U = N.props) == null ? void 0 : U.variant;
        return G !== void 0 && G !== M;
      }) && console.warn(
        `[ButtonGroup] variant="${e.variant}" expects <Button variant="${M}"> children. Other button variants will not render the active state correctly.`
      );
    });
    const l = m(
      () => e.variant === "group" || e.variant === "pill" && e.color === "dark"
    ), r = m(() => l.value && (e.color ?? "dark") === "dark"), o = m(() => e.variant !== "tab" && !!(e.labelLeft || e.labelRight)), i = R(!1);
    let s = 0;
    function d() {
      i.value = !0, cancelAnimationFrame(s), s = requestAnimationFrame(() => {
        s = requestAnimationFrame(() => {
          i.value = !1;
        });
      });
    }
    $e(() => e.modelValue, (V, M) => {
      M !== void 0 && V !== M && d();
    }), yt(() => cancelAnimationFrame(s));
    const u = m(() => e.variant === "tab" ? ["inline-flex items-center gap-px shadow-(--blur-shadow-xs)", i.value && "button-group-strip--switching"] : [
      i.value && "button-group-strip--switching",
      "button-group-strip inline-flex items-center",
      "rounded-(--border-border-radius-rounded-base)",
      l.value ? ["border border-(--border-border-base-medium) -space-x-px bg-(--colors-white-50-opacity-light) shadow-(--blur-shadow-xs)", r.value && "button-group--dark"] : [
        "gap-0",
        // A scrolling strip clips its items at its padding box: the overflow wrapper's layer draws the surface instead.
        !E.overflowing.value && [
          "border border-(--border-border-base-medium) bg-(--colors-white-50-opacity-medium)",
          e.size !== "xs" && "shadow-(--blur-shadow-xs)"
        ]
      ]
    ]), f = m(() => e.variant === "pill" && !l.value && !o.value), b = R(null), h = R(null), p = {
      xs: { scroll: "scroll-px-8", arrow: "size-[calc(--spacing(8)-2px)]", icon: "text-(length:--icon-size-xs) leading-(--icon-size-xs)" },
      sm: { scroll: "scroll-px-9", arrow: "size-[calc(--spacing(9)-2px)]", icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)" },
      md: { scroll: "scroll-px-10", arrow: "size-[calc(--spacing(10)-2px)]", icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)" },
      lg: { scroll: "scroll-px-12", arrow: "size-[calc(--spacing(12)-2px)]", icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)" }
    }, x = m(() => {
      if (e.modelValue !== void 0)
        return l.value ? "radio" : "tabs";
    }), y = m(() => x.value === "radio" ? "radiogroup" : e.variant === "tab" || x.value === "tabs" ? "tablist" : "group"), k = Gn(), $ = qe(), S = qe();
    function T() {
      if (!(!x.value || !o.value || k["aria-label"] || k["aria-labelledby"]))
        return [e.labelLeft && $, e.labelRight && S].filter(Boolean).join(" ");
    }
    const I = Lx([]), A = R(null), E = $g({
      strip: A,
      arrow: b,
      backArrow: h,
      enabled: () => f.value,
      selection: () => e.modelValue
    }), D = m(
      () => E.overflowing.value ? [
        "relative isolate inline-flex min-w-0 max-w-full",
        "before:pointer-events-none before:absolute before:inset-0 before:-z-1",
        "before:border before:border-(--border-border-base-medium) before:rounded-(--border-border-radius-rounded-base)",
        "before:bg-(--colors-white-50-opacity-medium)",
        e.size !== "xs" && "before:shadow-(--blur-shadow-xs)"
      ] : "contents"
    ), z = m(() => [
      "max-w-full",
      E.overflowing.value && ["button-group-strip--scroll min-w-0 overflow-x-auto overflow-y-hidden", p[e.size].scroll],
      E.showBackArrow.value && "button-group-strip--clip-start",
      E.showArrow.value && "button-group-strip--clip-end"
    ]), Y = (V) => [
      "absolute top-px z-20 inline-flex items-center justify-center cursor-pointer",
      V,
      "rounded-(--border-border-radius-rounded-base) bg-(--background-background-white) hover:bg-(--background-background-hover)",
      "text-(--icons-icon-dark-default) transition-colors duration-150 motion-reduce:transition-none",
      "focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)",
      p[e.size].arrow
    ];
    function le() {
      I.sort((V, M) => {
        const B = V.el(), q = M.el();
        return !B || !q ? 0 : B.compareDocumentPosition(q) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
      });
    }
    uo(le);
    function ne(V) {
      V !== e.modelValue && (d(), t("update:modelValue", V));
    }
    function re(V) {
      const M = I.filter((q) => !q.unreachable() && q.value() !== void 0), B = M.find((q) => q.value() === e.modelValue) ?? M[0];
      return B !== void 0 && B.value() === V;
    }
    const O = (V) => I.find((M) => M.el() === V);
    function P(V) {
      if (!x.value || V.altKey || V.ctrlKey || V.metaKey || !(x.value === "radio" ? ["ArrowRight", "ArrowLeft", "ArrowDown", "ArrowUp", "Home", "End"] : ["ArrowRight", "ArrowLeft", "Home", "End"]).includes(V.key)) return;
      const B = A.value, q = V.currentTarget;
      if (!B || !q) return;
      const N = Array.from(B.querySelectorAll("[data-button-group-item]")).filter(
        (xe) => xe.closest("[data-button-group-strip]") === B
      ), G = (xe) => {
        var X;
        return ((X = O(xe)) == null ? void 0 : X.unreachable()) === !1;
      }, U = N.filter(G);
      if (!U.length) return;
      let K;
      if (V.key === "Home") K = U[0];
      else if (V.key === "End") K = U[U.length - 1];
      else {
        const xe = V.key === "ArrowRight" || V.key === "ArrowDown" ? 1 : -1, X = N.indexOf(q);
        for (let ie = 1; ie <= N.length && !K; ie++) {
          const he = N[((X + xe * ie) % N.length + N.length) % N.length];
          G(he) && (K = he);
        }
      }
      if (!K) return;
      V.preventDefault(), V.stopPropagation(), K.focus();
      const ge = O(K);
      if (x.value === "radio" && ge && !ge.blocked()) {
        const xe = ge.value();
        xe !== void 0 && ne(xe);
      }
    }
    return dn(pg, {
      mode: x,
      isSelected: (V) => V === e.modelValue,
      select: ne,
      isTabStop: re,
      register(V) {
        return I.push(V), () => {
          const M = I.indexOf(V);
          M !== -1 && I.splice(M, 1);
        };
      },
      sort: le,
      onItemKeydown: P,
      panelId: () => x.value === "tabs" ? e.panelId : void 0
    }), (V, M) => o.value ? (c(), g("div", rw, [
      v("div", ow, [
        e.labelLeft ? (c(), W(Yr, {
          key: 0,
          id: L($),
          label: e.labelLeft,
          type: "14px",
          "info-right": e.labelLeftInfo,
          "data-testid": "button-group-label-left"
        }, null, 8, ["id", "label", "info-right"])) : w("", !0),
        e.labelRight ? (c(), W(Yr, {
          key: 1,
          id: L(S),
          label: e.labelRight,
          type: "14px",
          "info-right": e.labelRightInfo,
          "data-testid": "button-group-label-right"
        }, null, 8, ["id", "label", "info-right"])) : w("", !0)
      ]),
      v("div", Fe({
        ref_key: "stripRef",
        ref: A,
        role: y.value,
        "aria-labelledby": T(),
        "data-button-group-strip": ""
      }, V.$attrs, { class: u.value }), [
        Ae(V.$slots, "default", {}, void 0, !0)
      ], 16, iw)
    ])) : f.value ? (c(), g("div", {
      key: 1,
      class: C(D.value)
    }, [
      L(E).showBackArrow.value ? (c(), g("button", {
        key: 0,
        ref_key: "backArrowRef",
        ref: h,
        type: "button",
        "aria-label": e.overflowPreviousLabel,
        "data-testid": "button-group-overflow-back-arrow",
        class: C(Y("left-px")),
        onClick: M[0] || (M[0] = //@ts-ignore
        (...B) => L(E).scrollBack && L(E).scrollBack(...B))
      }, [
        v("i", {
          class: C(["ri-arrow-left-line", p[e.size].icon]),
          "aria-hidden": "true"
        }, null, 2)
      ], 10, sw)) : w("", !0),
      v("div", Fe({
        ref_key: "stripRef",
        ref: A,
        role: y.value,
        tabindex: L(E).overflowing.value ? -1 : void 0,
        "data-button-group-strip": ""
      }, V.$attrs, {
        class: [u.value, z.value],
        onScrollPassive: M[1] || (M[1] = //@ts-ignore
        (...B) => L(E).measure && L(E).measure(...B))
      }), [
        Ae(V.$slots, "default", {}, void 0, !0)
      ], 16, dw),
      L(E).showArrow.value ? (c(), g("button", {
        key: 1,
        ref_key: "arrowRef",
        ref: b,
        type: "button",
        "aria-label": e.overflowLabel,
        "data-testid": "button-group-overflow-arrow",
        class: C(Y("right-px")),
        onClick: M[2] || (M[2] = //@ts-ignore
        (...B) => L(E).scrollForward && L(E).scrollForward(...B))
      }, [
        v("i", {
          class: C(["ri-arrow-right-line", p[e.size].icon]),
          "aria-hidden": "true"
        }, null, 2)
      ], 10, uw)) : w("", !0)
    ], 2)) : (c(), g("div", Fe({
      key: 2,
      ref_key: "stripRef",
      ref: A,
      role: y.value,
      "data-button-group-strip": ""
    }, V.$attrs, { class: u.value }), [
      Ae(V.$slots, "default", {}, void 0, !0)
    ], 16, cw));
  }
}), Ig = /* @__PURE__ */ dt(fw, [["__scopeId", "data-v-f3b2c0c4"]]), hw = ["id"], bw = ["id"], gw = ["aria-valuemax", "aria-valuenow", "aria-valuetext"], Rs = "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default)", Ju = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "ProgressBar",
  props: {
    value: { default: 0 },
    max: { default: 100 },
    color: { default: "primary" },
    size: { default: "base" },
    labelPosition: { default: "top" },
    label: { default: void 0 },
    valueLabel: { default: void 0 },
    ariaLabel: { default: void 0 }
  },
  setup(e) {
    var A;
    const n = e, t = {
      base: "h-1.5",
      lg: "h-2.5"
    }, a = {
      primary: "bg-[linear-gradient(90deg,var(--gradient-brand-start)_7.4%,var(--gradient-brand-end)_90.2%)]",
      gray: "bg-(--border-border-accessibility)",
      dark: "bg-(--background-background-black-default)",
      success: "bg-(--border-border-success-strong)",
      danger: "bg-(--border-border-error-strong)",
      warning: "bg-(--border-border-warning)"
    }, l = {
      top: "flex-col",
      side: "flex-row items-center",
      bottom: "flex-col"
    }, r = Gn(), o = m(() => ({ class: r.class, style: r.style })), i = m(() => {
      const { class: E, style: D, ...z } = r;
      return z;
    }), s = qe(), d = m(() => {
      var E;
      return ((E = n.label) == null ? void 0 : E.trim()) || void 0;
    }), u = m(() => {
      var E;
      return ((E = n.valueLabel) == null ? void 0 : E.trim()) || void 0;
    }), f = () => u.value ?? r["aria-valuetext"], b = m(() => !!(d.value || u.value)), h = m(() => n.labelPosition === "side"), p = m(
      () => n.labelPosition === "bottom" ? ["track", "row"] : ["row", "track"]
    ), x = m(() => Number.isFinite(n.max) && n.max > 0 ? n.max : 0), y = m(() => {
      const E = Number.isFinite(n.value) ? n.value : 0;
      return Math.min(Math.max(E, 0), x.value);
    }), k = m(() => x.value > 0 ? y.value / x.value * 100 : 0), $ = R(null), S = (E) => {
      $.value = E ?? null;
    }, T = m(() => {
      var z, Y;
      if (r["aria-labelledby"]) return {};
      const E = h.value && !!((z = $.value) != null && z.isTabStop);
      return d.value && !E ? { "aria-labelledby": s } : { "aria-label": (d.value ?? ((Y = n.ariaLabel) == null ? void 0 : Y.trim())) || void 0 };
    });
    return typeof process < "u" && ((A = process.env) == null ? void 0 : A.NODE_ENV) !== "production" && $e(
      () => {
        var E;
        return !d.value && !((E = n.ariaLabel) != null && E.trim()) && !r["aria-labelledby"];
      },
      (E) => {
        E && console.warn("[OPAL ProgressBar] No `label` and no `ariaLabel`: the progress bar has no accessible name.");
      },
      { immediate: !0 }
    ), (E, D) => (c(), g("div", Fe(o.value, {
      class: ["flex w-full min-w-0 gap-1.5", l[e.labelPosition]],
      "data-testid": "progress-bar"
    }), [
      (c(!0), g(de, null, Re(p.value, (z) => (c(), g(de, { key: z }, [
        z === "row" && b.value ? (c(), g("div", {
          key: 0,
          class: C(h.value ? "contents" : "flex w-full min-w-0"),
          "data-testid": "progress-bar-label-row"
        }, [
          d.value && h.value ? (c(), g("span", {
            key: 0,
            id: L(s),
            class: "order-first flex min-w-0 max-w-1/2",
            "data-testid": "progress-bar-label"
          }, [
            te(pt, {
              ref_for: !0,
              ref: S,
              text: d.value,
              "text-class": Rs
            }, null, 8, ["text"])
          ], 8, hw)) : d.value ? (c(), g("span", {
            key: 1,
            id: L(s),
            class: C([Rs, "min-w-0 flex-1 break-words"]),
            "data-testid": "progress-bar-label"
          }, j(d.value), 11, bw)) : w("", !0),
          u.value ? (c(), g("span", {
            key: 2,
            class: C([Rs, "text-right", h.value ? "order-last max-w-1/4 shrink-0 break-words" : "min-w-0 flex-1 break-words"]),
            "aria-hidden": "true",
            "data-testid": "progress-bar-value-label"
          }, j(u.value), 3)) : w("", !0)
        ], 2)) : z === "track" ? (c(), g("div", Fe({
          key: 1,
          ref_for: !0
        }, { ...i.value, ...T.value }, {
          class: ["overflow-hidden rounded-(--border-border-radius-rounded-l) bg-(--background-background-gray)", [t[e.size], h.value ? "min-w-0 flex-1" : "w-full"]],
          role: "progressbar",
          "aria-valuemin": "0",
          "aria-valuemax": x.value > 0 ? x.value : 100,
          "aria-valuenow": y.value,
          "aria-valuetext": f(),
          "data-testid": "progress-bar-track"
        }), [
          v("div", {
            class: C(["h-full rounded-(--border-border-radius-rounded-l) transition-[width] duration-300 motion-reduce:transition-none", a[e.color]]),
            style: je({ width: `${k.value}%` }),
            "data-testid": "progress-bar-fill"
          }, null, 6)
        ], 16, gw)) : w("", !0)
      ], 64))), 128))
    ], 16));
  }
}), mw = ["id"], pw = ["id", "role"], vw = ["data-testid"], xw = {
  key: 3,
  class: "col-start-2 row-start-1 flex shrink-0 items-center"
}, yw = ["data-testid"], kw = ["data-testid"], ww = { class: "min-w-0 break-words" }, Cw = ["data-testid"], Sw = {
  key: 1,
  class: "flex min-w-0 flex-col gap-(--spacing-2-5)"
}, $w = ["id"], Iw = ["aria-labelledby"], Lw = { class: "sr-only" }, Tw = ["data-testid"], Aw = ["data-testid"], Ew = {
  key: 0,
  class: "h-4.5 w-0 shrink-0 border-l-(length:--border-border-width-border) border-(--border-border-base-medium)",
  "aria-hidden": "true"
}, Rw = { class: "flex min-w-0 items-center gap-1.5" }, Bs = "text-(length:--size-m) leading-(--line-height-l)", $t = /* @__PURE__ */ ye({
  __name: "FieldHelper",
  props: {
    hint: { default: void 0 },
    hintIcon: { default: void 0 },
    hintLines: { default: 1 },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    hintId: { default: void 0 },
    errorId: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    focused: { type: Boolean, default: !1 },
    testIdPrefix: { default: void 0 },
    endText: { default: void 0 },
    endIcon: { default: void 0 },
    progress: { default: void 0 },
    progressLabel: { default: void 0 },
    checklistTitle: { default: void 0 },
    checklist: { default: void 0 },
    features: { default: void 0 },
    tags: { default: void 0 },
    labels: { default: () => ({ met: "Met", unmet: "Not met", failed: "Failed", progress: "Progress" }) }
  },
  emits: ["endClick", "removeTag"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = m(() => !!a.endText), o = m(
      () => {
        var $;
        return a.progress !== void 0 || !!a.checklistTitle || !!(($ = a.checklist) != null && $.length);
      }
    ), i = qe(), s = {
      met: { icon: "ri-checkbox-circle-fill text-(--icons-icon-success)", text: "text-(--text-text-success-strong)" },
      unmet: { icon: "ri-checkbox-blank-circle-line text-(--icons-icon-base)", text: "text-(--text-text-body-subtle)" },
      failed: { icon: "ri-close-circle-fill text-(--icons-icon-error)", text: "text-(--text-text-error-strong)" }
    }, d = m(
      () => r.value ? "min-h-5 grid min-w-0 self-stretch grid-cols-[minmax(0,1fr)_auto] items-center gap-x-(--spacing-2-5) gap-y-px" : "min-h-5 flex min-w-0 self-stretch flex-col gap-px"
    ), u = R(null), f = R(!1), b = m(() => f.value ? !1 : a.focused ? !0 : void 0);
    $e(
      () => a.focused,
      ($) => {
        $ || (f.value = !1);
      }
    );
    const h = ($) => {
      var S;
      $.key !== "Escape" || $.defaultPrevented || f.value || !a.focused || !a.hint || !((S = u.value) != null && S.isTruncated) || ($.stopPropagation(), $.preventDefault(), f.value = !0);
    }, p = R(null), x = R(null), y = R(null), k = ($) => {
      var S;
      y.value = { index: $, count: ((S = a.tags) == null ? void 0 : S.length) ?? 0 }, l("removeTag", $);
    };
    return $e(
      () => a.tags,
      ($) => {
        var A, E, D, z;
        const S = y.value;
        if (y.value = null, !S || (($ == null ? void 0 : $.length) ?? 0) >= S.count) return;
        const { index: T } = S, I = (A = x.value) == null ? void 0 : A.querySelectorAll(":scope > li button");
        if (I != null && I.length) {
          I[Math.min(Math.max(T - 1, 0), I.length - 1)].focus();
          return;
        }
        (z = (D = (E = p.value) == null ? void 0 : E.parentElement) == null ? void 0 : D.querySelector("input:not([type='hidden']), textarea, select")) == null || z.focus();
      },
      // deep: consumers also splice the array in place
      { flush: "post", deep: !0 }
    ), n({ handleFieldKeydown: h }), ($, S) => {
      var T, I, A, E;
      return c(), g("div", {
        ref_key: "rootRef",
        ref: p,
        "data-field-helper": "",
        class: C(d.value)
      }, [
        e.hint ? (c(), g("span", {
          key: 0,
          id: e.hintId,
          class: "sr-only"
        }, j(e.hint), 9, mw)) : w("", !0),
        e.error ? (c(), g("span", {
          key: 1,
          id: e.errorId,
          role: e.errorLive ? "alert" : void 0,
          class: "sr-only"
        }, j(e.error), 9, pw)) : w("", !0),
        e.hint ? (c(), g("div", {
          key: 2,
          "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-hint` : void 0,
          "aria-hidden": "true",
          class: C([
            "flex min-w-0 gap-1 text-(length:--size-sm) leading-(--line-height-l)",
            e.disabled ? "text-(--text-text-disabled-light)" : "text-(--text-text-body) dark:text-(--colors-text-white-default)",
            e.hintLines === 2 ? "items-start" : "items-center"
          ])
        }, [
          !r.value || e.hintIcon ? (c(), g("i", {
            key: 0,
            class: C([
              e.hintIcon ?? "ri-error-warning-line",
              "inline-flex w-3 shrink-0 items-center justify-center text-(length:--size-sm)",
              e.disabled ? "text-(--icons-icon-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
              e.hintLines === 2 ? "h-(--line-height-l)" : "h-3"
            ]),
            "aria-hidden": "true"
          }, null, 2)) : w("", !0),
          (c(), W(pt, {
            ref_key: "hintRef",
            ref: u,
            key: e.hintLines,
            text: e.hint,
            lines: e.hintLines,
            "text-class": e.hintLines === 2 ? "whitespace-pre-line" : "",
            focusable: !1,
            open: b.value,
            position: "bottom"
          }, null, 8, ["text", "lines", "text-class", "open"]))
        ], 10, vw)) : w("", !0),
        r.value ? (c(), g("div", xw, [
          v("button", {
            type: "button",
            class: "relative inline-flex cursor-pointer items-center gap-1 rounded-(--border-border-radius-rounded-xs) before:absolute before:left-1/2 before:top-1/2 before:h-6 before:w-full before:min-w-6 before:-translate-x-1/2 before:-translate-y-1/2 before:content-[''] text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-link) focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)",
            "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-end` : void 0,
            onClick: S[0] || (S[0] = (D) => l("endClick"))
          }, [
            e.endIcon ? (c(), g("i", {
              key: 0,
              class: C([e.endIcon, "inline-flex size-3 shrink-0 items-center justify-center text-(length:--size-sm) text-(--icons-icon-link)"]),
              "aria-hidden": "true"
            }, null, 2)) : w("", !0),
            v("span", null, j(e.endText), 1)
          ], 8, yw)
        ])) : w("", !0),
        e.error ? (c(), g("div", {
          key: 4,
          "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-error` : void 0,
          "aria-hidden": "true",
          class: C([
            "flex min-w-0 items-start gap-1 text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-error-strong) dark:text-(--text-text-error)",
            r.value ? "col-span-full" : ""
          ])
        }, [
          S[1] || (S[1] = v("span", { class: "inline-flex h-(--line-height-l) shrink-0 items-center" }, [
            v("i", {
              class: "ri-close-circle-line inline-flex size-3 items-center justify-center text-(length:--size-sm) text-(--icons-icon-error)",
              "aria-hidden": "true"
            })
          ], -1)),
          v("span", ww, j(e.error), 1)
        ], 10, kw)) : w("", !0),
        o.value ? (c(), g("div", {
          key: 5,
          class: "col-span-full flex min-w-0 flex-col gap-(--spacing-2-5)",
          "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-progress` : void 0
        }, [
          e.progress !== void 0 ? (c(), W(Ju, {
            key: 0,
            value: e.progress,
            "aria-label": e.progressLabel ?? e.labels.progress
          }, null, 8, ["value", "aria-label"])) : w("", !0),
          e.checklistTitle || (T = e.checklist) != null && T.length ? (c(), g("div", Sw, [
            e.checklistTitle ? (c(), g("span", {
              key: 0,
              id: L(i),
              class: C([Bs, "font-(--weight-medium) text-(--text-text-heading) dark:text-(--colors-text-white-default)"])
            }, j(e.checklistTitle), 11, $w)) : w("", !0),
            (I = e.checklist) != null && I.length ? (c(), g("ul", {
              key: 1,
              class: "flex min-w-0 flex-col gap-1.5",
              "aria-labelledby": e.checklistTitle ? L(i) : void 0
            }, [
              (c(!0), g(de, null, Re(e.checklist, (D, z) => (c(), g("li", {
                key: z,
                class: "flex min-w-0 items-center gap-1.5"
              }, [
                v("i", {
                  class: C([
                    s[D.status].icon,
                    "inline-flex size-3.5 shrink-0 items-center justify-center text-(length:--icon-size-xs)"
                  ]),
                  "aria-hidden": "true"
                }, null, 2),
                v("span", {
                  class: C([Bs, "min-w-0 flex-1 break-words font-(--weight-regular)", s[D.status].text])
                }, [
                  v("span", Lw, j(`${D.statusLabel ?? e.labels[D.status]}: `), 1),
                  nt(j(D.text), 1)
                ], 2)
              ]))), 128))
            ], 8, Iw)) : w("", !0)
          ])) : w("", !0)
        ], 8, Cw)) : w("", !0),
        (A = e.tags) != null && A.length ? (c(), g("ul", {
          key: 6,
          ref_key: "tagListRef",
          ref: x,
          class: "col-span-full flex min-w-0 flex-wrap items-center gap-(--spacing-2-5)",
          "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-tags` : void 0
        }, [
          (c(!0), g(de, null, Re(e.tags, (D, z) => (c(), g("li", {
            key: `${D.label}-${z}`,
            class: "flex min-w-0"
          }, [
            te(gt, {
              label: D.label,
              theme: "white",
              size: "sm",
              type: "with-avatar",
              "avatar-src": D.avatarSrc,
              "avatar-alt": D.avatarAlt,
              "show-close-icon": "",
              "remove-label": D.removeLabel,
              onClose: (Y) => k(z)
            }, null, 8, ["label", "avatar-src", "avatar-alt", "remove-label", "onClose"])
          ]))), 128))
        ], 8, Tw)) : w("", !0),
        (E = e.features) != null && E.length ? (c(), g("ul", {
          key: 7,
          class: "col-span-full flex min-w-0 flex-wrap items-center gap-3",
          "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-features` : void 0
        }, [
          (c(!0), g(de, null, Re(e.features, (D, z) => (c(), g("li", {
            key: z,
            class: "flex min-w-0 items-center gap-3"
          }, [
            z > 0 ? (c(), g("span", Ew)) : w("", !0),
            v("span", Rw, [
              v("i", {
                class: C([
                  D.icon,
                  "inline-flex size-4 shrink-0 items-center justify-center text-(length:--icon-size-sm) text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
                ]),
                "aria-hidden": "true"
              }, null, 2),
              v("span", {
                class: C([
                  Bs,
                  "min-w-0 break-words font-(--weight-regular) text-(--text-text-heading) dark:text-(--colors-text-white-default)"
                ])
              }, j(D.text), 3)
            ])
          ]))), 128))
        ], 8, Aw)) : w("", !0)
      ], 2);
    };
  }
}), Vn = /* @__PURE__ */ ye({
  __name: "FieldShell",
  props: {
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    success: { type: Boolean, default: !1 },
    focused: { type: Boolean, default: !1 },
    focusScope: { default: "control" },
    hasValue: { type: Boolean, default: !1 },
    rounded: { default: "l" },
    flush: { type: Boolean, default: !1 },
    innerButton: { type: Boolean, default: !1 },
    stacked: { type: Boolean, default: !1 },
    tags: { type: Boolean, default: !1 },
    multiline: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = R(!1), a = R(null), l = R(!1), r = m(() => !n.disabled && (n.focused || l.value));
    function o(z) {
      var Y;
      return !(z instanceof Element) || !((Y = a.value) != null && Y.contains(z)) ? !1 : n.focusScope === "any" || z === a.value || z.matches("input, textarea, select");
    }
    function i(z) {
      l.value = o(z.target);
    }
    function s(z) {
      l.value = o(z.relatedTarget);
    }
    $e(
      () => n.disabled,
      () => {
        l.value = o(document.activeElement);
      }
    );
    const d = {
      sm: {
        height: "h-[32px]",
        container: "h-[32px] px-[calc(--spacing(2)-1px)] py-[calc(--spacing(1.5)-1px)] gap-2",
        text: "text-(length:--size-m) leading-(--line-height-l)"
      },
      md: {
        height: "h-[36px]",
        container: "h-[36px] px-[calc(--spacing(3)-1px)] py-[calc(--spacing(2)-1px)] gap-2",
        text: "text-(length:--size-m) leading-(--line-height-l)"
      },
      lg: {
        height: "h-[48px]",
        container: "h-[48px] px-[calc(--spacing(3.5)-1px)] py-[calc(--spacing(3)-1px)] gap-2",
        text: "text-(length:--size-l) leading-(--line-height-xxl)"
      },
      xl: {
        height: "h-[52px]",
        container: "h-[52px] px-[calc(--spacing(4)-1px)] py-[calc(--spacing(3.5)-1px)] gap-2",
        text: "text-(length:--size-l) leading-(--line-height-xxl)"
      }
    }, u = {
      sm: {
        height: "h-[48px] pr-[calc(--spacing(2)-1px)]",
        container: "h-[48px] pl-[calc(--spacing(2.5)-1px)] pr-[calc(--spacing(2)-1px)] gap-2"
      },
      md: {
        height: "h-[52px] pr-[calc(--spacing(2.5)-1px)]",
        container: "h-[52px] pl-[calc(--spacing(3)-1px)] pr-[calc(--spacing(2.5)-1px)] gap-2"
      },
      lg: {
        height: "h-[56px] pr-[calc(--spacing(3)-1px)]",
        container: "h-[56px] pl-[calc(--spacing(3.5)-1px)] pr-[calc(--spacing(3)-1px)] gap-2"
      },
      xl: {
        height: "h-[60px] pr-[calc(--spacing(3.5)-1px)]",
        container: "h-[60px] pl-[calc(--spacing(4)-1px)] pr-[calc(--spacing(3.5)-1px)] gap-2"
      }
    }, f = {
      sm: {
        container: "h-[56px] p-[calc(--spacing(2)-1px)] flex-col justify-center",
        text: "text-(length:--size-sm) leading-(--line-height-l)",
        topText: "text-(length:--size-m) leading-(--line-height-l)"
      },
      md: {
        container: "h-[62px] p-[calc(--spacing(2.5)-1px)] flex-col justify-center gap-0.5",
        text: "text-(length:--size-sm) leading-(--line-height-l)",
        topText: "text-(length:--size-m) leading-(--line-height-l)"
      },
      lg: {
        container: "h-[70px] p-[calc(--spacing(3)-1px)] flex-col justify-center gap-0.5",
        text: "text-(length:--size-m) leading-(--line-height-l)",
        topText: "text-(length:--size-l) leading-(--line-height-xxl)"
      },
      xl: {
        container: "h-[74px] p-[calc(--spacing(3.5)-1px)] flex-col justify-center gap-0.5",
        text: "text-(length:--size-m) leading-(--line-height-l)",
        topText: "text-(length:--size-l) leading-(--line-height-xxl)"
      }
    }, b = {
      sm: "min-h-[32px] flex-wrap gap-2 py-[calc(--spacing(1)-1px)] px-[calc(--spacing(2)-1px)]",
      md: "min-h-[36px] flex-wrap gap-2 py-[calc(--spacing(1.5)-1px)] px-[calc(--spacing(2.5)-1px)]",
      lg: "min-h-[48px] flex-wrap gap-2 py-[calc(--spacing(2.5)-1px)] px-[calc(--spacing(3)-1px)]",
      xl: "min-h-[52px] flex-wrap gap-2 py-[calc(--spacing(3)-1px)] px-[calc(--spacing(3.5)-1px)]"
    }, h = m(() => d[n.size]), p = m(
      () => n.stacked ? f[n.size].text : h.value.text
    ), x = m(() => n.stacked ? f[n.size].topText : ""), y = m(() => {
      if (n.stacked) return f[n.size].container;
      if (n.tags) return b[n.size];
      if (n.multiline)
        return "h-[144px] overflow-hidden px-[calc(--spacing(3)-1px)] py-[calc(--spacing(2)-1px)]";
      if (n.innerButton) {
        const z = u[n.size];
        return n.flush ? z.height : z.container;
      }
      return n.flush ? `${h.value.height} overflow-hidden` : h.value.container;
    }), k = m(() => {
      const Y = `relative ${n.rounded === "full" ? "rounded-full" : "rounded-(--border-border-radius-rounded-l)"} border-solid box-border flex items-center text-left font-inter border-[1px]`, le = "shadow-[0_0_2px_2px_var(--background-background-hover)]", ne = r.value ? le : "dark:shadow-(--blur-shadow-m-dark)";
      if (n.disabled)
        return `${Y} dark:shadow-(--blur-shadow-m-dark) bg-(--background-background-disabled-opacity) dark:bg-(--colors-background-disabled) border-(--border-border-disabled-subtle) dark:border-(--colors-border-disabled-subtle) text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)`;
      if (n.readonly) {
        const O = r.value ? `${le} border-(--border-border-accent)` : "border-(--border-border-base-soft) dark:border-(--border-border-base)";
        return `${Y} dark:shadow-(--blur-shadow-m-dark) bg-(--background-background-white-secondary-soft) dark:bg-(--colors-background-disabled) ${O} text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-default`;
      }
      if (n.error)
        return `${Y} ${ne} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (n.success)
        return `${Y} ${ne} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-success-strong) dark:border-(--border-border-success-strong) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (r.value)
        return `${Y} ${le} bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (t.value)
        return `${Y} ${le} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      const re = n.hasValue ? "text-(--text-text-black-default)" : "text-(--text-text-body-subtle)";
      return `${Y} dark:shadow-(--blur-shadow-m-dark) bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) ${re} dark:text-(--text-text-white-default)`;
    }), $ = m(() => n.disabled ? "text-(--icons-icon-disabled-strong) dark:text-(--text-text-disabled-light)" : n.readonly ? "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)" : n.error ? "text-(--icons-icon-error)" : n.success ? "text-(--icons-icon-success)" : r.value ? "text-(--icons-icon-accent)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"), S = m(() => n.disabled ? "border-(--border-border-disabled-subtle) dark:border-(--colors-border-disabled-subtle)" : n.readonly ? r.value ? "border-(--border-border-accent)" : "border-(--border-border-base-soft) dark:border-(--border-border-base)" : n.error ? "border-(--border-border-error-strong) dark:border-(--border-border-error)" : n.success ? "border-(--border-border-success-strong)" : r.value || t.value ? "border-(--border-border-accent)" : "border-(--border-border-base-medium) dark:border-(--border-border-base)"), T = m(() => n.disabled ? "text-(--text-text-disabled-light)" : n.readonly ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : n.error ? "text-(--text-text-error-strong) dark:text-(--text-text-error)" : n.success ? "text-(--text-text-success-strong)" : r.value ? "text-(--text-text-accent)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"), I = m(
      () => n.stacked && (n.size === "sm" || n.size === "md") ? "inline-flex size-3.5 shrink-0 items-center justify-center text-(length:--icon-size-xs)" : "inline-flex size-4 shrink-0 items-center justify-center text-(length:--size-l)"
    ), A = m(
      () => !n.stacked && (n.size === "lg" || n.size === "xl") ? "inline-flex size-5 shrink-0 items-center justify-center text-(length:--icon-size-md)" : I.value
    ), E = () => {
      !n.disabled && !n.readonly && !n.tags && (t.value = !0);
    }, D = () => {
      t.value = !1;
    };
    return (z, Y) => (c(), g("div", {
      ref_key: "rootRef",
      ref: a,
      class: C([k.value, y.value]),
      onFocusin: i,
      onFocusout: s,
      onMouseenter: E,
      onMouseleave: D
    }, [
      Ae(z.$slots, "default", {
        hovered: t.value,
        borderColorClass: S.value,
        addonTextClass: T.value,
        iconBoxClass: I.value,
        leftIconBoxClass: A.value,
        iconColorClass: $.value,
        textClass: p.value,
        topTextClass: x.value
      })
    ], 34));
  }
});
function Lg(e, n) {
  return n === 1 ? "only" : e === 0 ? "first" : e === n - 1 ? "last" : "middle";
}
const Bw = { sm: "xs", md: "sm", lg: "lg", xl: "xl" }, Mw = { sm: "xs", md: "xs", lg: "sm", xl: "md" };
function Wa(e, n) {
  return (n === "stacked" ? Mw : Bw)[e];
}
const Dw = {
  l: { left: "rounded-l-(--border-border-radius-rounded-l)", right: "rounded-r-(--border-border-radius-rounded-l)" },
  full: { left: "rounded-l-full", right: "rounded-r-full" }
};
function Tg(e, n) {
  const t = Dw[n], a = e === "first" || e === "only" ? "" : "-ml-px ", l = {
    first: `${t.left} rounded-r-none`,
    middle: "rounded-l-none rounded-r-none",
    last: `rounded-l-none ${t.right}`,
    only: `${t.left} ${t.right}`
  }[e];
  return { part: `${a}relative hover:z-[1] focus-within:z-[1]`, corners: l };
}
function Ag(e) {
  return `flex w-full items-stretch ${e === "full" ? "rounded-full" : "rounded-(--border-border-radius-rounded-l)"} shadow-(--blur-shadow-xs)`;
}
function aa(e, n) {
  return {
    variant: e.color ?? "secondary",
    label: e.iconOnly ? "" : e.label,
    iconLeft: e.icon,
    iconOnly: !!e.iconOnly,
    dropdownIcon: !!e.dropdown,
    ariaLabel: e.iconOnly ? e.label : e.ariaLabel,
    disabled: n || !!e.disabled,
    "data-field-button": e.id
  };
}
function Xu(e) {
  return { icon: "ri-delete-bin-line", ...e, iconOnly: !0 };
}
const bo = /* @__PURE__ */ ye({
  __name: "FieldButtons",
  props: {
    buttons: { default: () => [] },
    layout: { default: "attached" },
    size: { default: "md" },
    rounded: { default: "l" },
    disabled: { type: Boolean, default: !1 },
    buttonSize: { default: void 0 }
  },
  emits: ["button-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = Hn(), r = m(() => t.buttons.filter((S) => S.position === "start")), o = m(() => t.buttons.filter((S) => S.position !== "start")), i = m(
      () => t.layout === "stacked" ? [null, ...r.value, ...o.value] : [...r.value, null, ...o.value]
    ), s = m(
      () => t.buttonSize ?? Wa(t.size, t.layout)
    ), d = m(() => t.layout === "attached"), u = m(() => t.layout === "stacked" ? "flex w-full flex-col gap-4" : t.layout === "spaced" ? "flex w-full items-center gap-4" : Ag(t.rounded)), f = () => l.leading ? 1 : 0, b = () => f() + t.buttons.length > 0, h = () => f() + r.value.length + 1 + o.value.length, p = () => f() + r.value.length;
    function x(S) {
      return Tg(Lg(S, h()), t.rounded);
    }
    function y() {
      return t.layout === "stacked" ? "w-full" : d.value ? `min-w-0 flex-1 ${x(p()).part}` : "min-w-0 flex-1";
    }
    function k() {
      return d.value ? x(p()).corners : "";
    }
    function $(S) {
      if (!d.value) return "";
      const { part: T, corners: I } = x(S);
      return `${T} ${I}`;
    }
    return (S, T) => b() ? (c(), g("div", {
      key: 1,
      class: C(u.value)
    }, [
      Ae(S.$slots, "leading", {
        partClass: $(0),
        buttonSize: s.value
      }),
      (c(!0), g(de, null, Re(i.value, (I, A) => (c(), g(de, {
        key: I ? `button-${I.id}` : "field"
      }, [
        I ? (c(), W(Me, Fe({
          key: 1,
          class: $(f() + A)
        }, { ref_for: !0 }, L(aa)(I, e.disabled), {
          size: s.value,
          "full-width": e.layout === "stacked",
          onClick: (E) => a("button-click", I.id)
        }), null, 16, ["class", "size", "full-width", "onClick"])) : (c(), g("div", {
          key: 0,
          class: C(y())
        }, [
          Ae(S.$slots, "default", {
            fieldClass: k()
          })
        ], 2))
      ], 64))), 128))
    ], 2)) : Ae(S.$slots, "default", {
      key: 0,
      fieldClass: ""
    });
  }
});
function nr(e, n, t) {
  return e && n ? {
    root: "grid grid-cols-[auto_minmax(0,1fr)] items-center gap-x-4 gap-y-0.5",
    label: "",
    field: "col-start-2",
    helper: "col-start-2",
    remove: "",
    removeInFieldRow: !0,
    reservesHelper: !1
  } : t ? {
    root: "grid grid-cols-[minmax(0,1fr)_auto] gap-x-3 gap-y-0.5",
    label: "col-start-1",
    field: "col-start-1",
    helper: "col-start-1",
    remove: `col-start-2 self-end ${n ? "row-start-2" : "row-start-1"}`,
    removeInFieldRow: !1,
    reservesHelper: !0
  } : {
    root: "flex flex-col items-start gap-0.5",
    label: "",
    field: "",
    helper: "",
    remove: "",
    removeInFieldRow: !1,
    reservesHelper: !0
  };
}
const zw = ["src"], Ow = ["src"], Pw = ["id", "name", "value", "placeholder", "disabled", "aria-label", "aria-labelledby", "aria-disabled", "aria-invalid", "aria-describedby", "aria-required", "role", "aria-controls", "aria-expanded", "aria-autocomplete", "aria-activedescendant"], Fw = ["aria-label", "onKeydown"], Vw = ["src"], Nw = /* @__PURE__ */ ye({
  __name: "SearchInput",
  props: {
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    helpIcon: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    modelValue: { default: "" },
    iconLeft: { default: void 0 },
    iconRight: { default: void 0 },
    showSearchIcon: { type: Boolean, default: !0 },
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    rounded: { default: "full" },
    hint: { default: void 0 },
    error: { default: void 0 },
    labels: { default: () => ({ clear: "Clear search" }) },
    buttons: { default: () => [] },
    buttonLayout: { default: "attached" },
    buttonSize: { default: void 0 },
    innerButton: { default: void 0 },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaControls: { default: void 0 },
    ariaExpanded: { type: Boolean, default: !1 },
    ariaActivedescendant: { default: void 0 }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "keydown", "search", "clear", "button-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = qe(), r = m(() => t.id || l), o = m(() => `${r.value}-hint`), i = m(() => `${r.value}-error`), s = R(!1), d = R(null), u = R(null), f = R(null), b = m(() => t.rounded === "full" ? "full" : "l"), h = m(() => !!t.modelValue && t.modelValue.trim() !== ""), p = m(() => !!t.hint || !!t.error), x = m(() => t.buttons.length > 0), y = m(() => {
      const O = [];
      return t.hint && O.push(o.value), t.error && O.push(i.value), O.length > 0 ? O.join(" ") : void 0;
    }), k = m(() => !!t.ariaControls), $ = m(() => s.value && h.value && !t.disabled), S = m(() => nr(t.labelInline, !!t.label, !1)), T = m(() => t.fullWidth || t.width === void 0), I = m(() => t.labelInline && !!t.label && !T.value), A = (O) => !!O && O.startsWith("ri-"), E = m(() => T.value ? {} : { width: t.width }), D = m(() => x.value ? { style: E.value } : {}), z = (O) => {
      const P = O.target;
      a("update:modelValue", P.value), a("input", O);
    }, Y = (O) => {
      var M, B;
      a("keydown", O), O.key === "Enter" && !O.isComposing && a("search", O.target.value);
      const V = k.value && t.ariaExpanded || O.defaultPrevented;
      O.key === "Escape" && !O.isComposing && t.modelValue && !t.disabled && !V && (O.preventDefault(), O.stopPropagation(), re()), (M = u.value) == null || M.handleFieldKeydown(O), (B = f.value) == null || B.handleFieldKeydown(O);
    }, le = (O) => {
      t.disabled || (s.value = !0), a("focus", O);
    }, ne = (O) => {
      s.value = !1, a("blur", O);
    }, re = () => {
      var O;
      a("update:modelValue", ""), a("clear"), (O = d.value) == null || O.focus();
    };
    return (O, P) => (c(), g("div", {
      class: C([
        "relative min-w-0 text-left text-(length:--size-m) text-(--text-text-black-default) dark:text-(--colors-text-white-default) font-inter",
        I.value ? "w-fit" : "w-full",
        S.value.root
      ])
    }, [
      e.label ? (c(), g("div", {
        key: 0,
        class: C(["flex min-w-0 max-w-full items-center gap-1", S.value.label])
      }, [
        te(It, {
          ref_key: "labelRef",
          ref: u,
          text: e.label,
          "input-id": r.value,
          required: e.required,
          "required-indicator": e.requiredIndicator,
          tooltip: e.labelTooltip,
          focused: s.value,
          inline: e.labelInline,
          "test-id": "search-input-label"
        }, null, 8, ["text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline"]),
        e.helpIcon && !e.labelTooltip ? (c(), g("img", {
          key: 0,
          src: e.helpIcon,
          class: "h-3 w-3 relative search-input-icon",
          alt: ""
        }, null, 8, zw)) : w("", !0)
      ], 2)) : w("", !0),
      v("div", {
        class: C(["flex w-full", S.value.field])
      }, [
        te(bo, Fe({
          buttons: e.buttons,
          layout: e.buttonLayout,
          size: e.size,
          rounded: b.value,
          disabled: e.disabled,
          "button-size": e.buttonSize
        }, D.value, {
          onButtonClick: P[2] || (P[2] = (V) => a("button-click", V))
        }), {
          default: ve(({ fieldClass: V }) => [
            te(Vn, {
              size: e.size,
              rounded: b.value,
              "inner-button": !!e.innerButton,
              disabled: e.disabled,
              error: !!e.error,
              "has-value": h.value,
              class: C([
                x.value || T.value ? "w-full" : "",
                x.value && e.buttonLayout === "attached" ? "min-h-full" : "",
                V
              ]),
              style: je(x.value ? {} : E.value)
            }, {
              default: ve(({ iconBoxClass: M, leftIconBoxClass: B, iconColorClass: q, textClass: N }) => [
                e.showSearchIcon ? (c(), g(de, { key: 0 }, [
                  !e.iconLeft || A(e.iconLeft) ? (c(), g("i", {
                    key: 0,
                    class: C([e.iconLeft || "ri-search-line", B, q]),
                    "aria-hidden": "true"
                  }, null, 2)) : (c(), g("img", {
                    key: 1,
                    src: e.iconLeft,
                    class: C([B, "search-input-icon"]),
                    alt: ""
                  }, null, 10, Ow))
                ], 64)) : w("", !0),
                v("input", {
                  id: r.value,
                  ref_key: "inputRef",
                  ref: d,
                  name: e.name,
                  "data-testid": "search-input",
                  type: "search",
                  value: e.modelValue,
                  placeholder: e.placeholder,
                  disabled: e.disabled,
                  "aria-label": e.label || e.ariaLabelledby ? void 0 : e.ariaLabel ?? e.placeholder,
                  "aria-labelledby": e.label ? void 0 : e.ariaLabelledby,
                  "aria-disabled": e.disabled ? "true" : void 0,
                  "aria-invalid": e.error ? "true" : void 0,
                  "aria-describedby": y.value,
                  "aria-required": e.required ? "true" : void 0,
                  role: k.value ? "combobox" : void 0,
                  "aria-controls": e.ariaControls,
                  "aria-expanded": k.value ? e.ariaExpanded ? "true" : "false" : void 0,
                  "aria-autocomplete": k.value ? "list" : void 0,
                  "aria-activedescendant": k.value && e.ariaActivedescendant || void 0,
                  class: C([
                    "flex-1 min-w-0 text-ellipsis relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 p-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary) [&::-webkit-search-cancel-button]:appearance-none [&::-webkit-search-decoration]:appearance-none",
                    N
                  ]),
                  onInput: z,
                  onFocus: le,
                  onBlur: ne,
                  onKeydown: Y
                }, null, 42, Pw),
                $.value ? (c(), g("i", {
                  key: 1,
                  class: C(["ri-close-fill cursor-pointer text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", M]),
                  role: "button",
                  tabindex: "-1",
                  "aria-label": e.labels.clear,
                  "data-testid": "search-input-clear",
                  onMousedown: P[0] || (P[0] = Je(() => {
                  }, ["prevent"])),
                  onClick: Je(re, ["stop"]),
                  onKeydown: [
                    ht(re, ["enter"]),
                    ht(Je(re, ["prevent"]), ["space"])
                  ]
                }, null, 42, Fw)) : w("", !0),
                e.iconRight ? (c(), g("img", {
                  key: 2,
                  src: e.iconRight,
                  class: C([M, "search-input-icon"]),
                  alt: ""
                }, null, 10, Vw)) : w("", !0),
                e.innerButton ? (c(), W(Me, Fe({ key: 3 }, L(aa)(e.innerButton, e.disabled), {
                  size: "xs",
                  onClick: P[1] || (P[1] = (G) => a("button-click", e.innerButton.id))
                }), null, 16)) : w("", !0)
              ]),
              _: 1
            }, 8, ["size", "rounded", "inner-button", "disabled", "error", "has-value", "class", "style"])
          ]),
          _: 1
        }, 16, ["buttons", "layout", "size", "rounded", "disabled", "button-size"])
      ], 2),
      p.value ? (c(), W($t, {
        key: 1,
        ref_key: "helperRef",
        ref: f,
        class: C(S.value.helper),
        focused: s.value,
        hint: e.hint,
        error: e.error,
        "hint-id": o.value,
        "error-id": i.value,
        disabled: e.disabled,
        "test-id-prefix": "search-input"
      }, null, 8, ["class", "focused", "hint", "error", "hint-id", "error-id", "disabled"])) : w("", !0)
    ], 2));
  }
}), ls = /* @__PURE__ */ dt(Nw, [["__scopeId", "data-v-a3d6bac2"]]), Hw = {
  key: 0,
  "data-testid": "dropdown-panel-header-labels",
  class: "flex items-center justify-between gap-2.5 px-2"
}, vl = /* @__PURE__ */ ye({
  __name: "DropdownPanelHeader",
  props: {
    labelLeft: { default: void 0 },
    labelLeftInfo: { default: void 0 },
    labelRight: { default: void 0 },
    labelRightInfo: { default: void 0 },
    showSearch: { type: Boolean, default: !1 },
    searchQuery: { default: "" },
    searchPlaceholder: { default: void 0 },
    searchLabel: { default: void 0 },
    searchClearLabel: { default: "Clear search" },
    groupButtons: { default: () => [] },
    activeGroup: { default: void 0 },
    groupLabelLeft: { default: void 0 },
    groupLabelLeftInfo: { default: void 0 },
    groupLabelRight: { default: void 0 },
    groupLabelRightInfo: { default: void 0 },
    groupAriaLabel: { default: void 0 }
  },
  emits: ["update:searchQuery", "update:activeGroup"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = qe(), o = qe(), i = m(() => !!(a.labelLeft || a.labelRight)), s = m(() => {
      if (!(a.searchLabel || !i.value))
        return [a.labelLeft && r, a.labelRight && o].filter(Boolean).join(" ");
    }), d = m(() => !!(a.groupLabelLeft || a.groupLabelRight)), u = R(null);
    function f() {
      var h;
      const b = (h = u.value) == null ? void 0 : h.querySelector('[data-testid="search-input"]');
      return b == null || b.focus({ preventScroll: !0 }), !!b;
    }
    return n({ focusSearch: f }), (b, h) => (c(), g("div", {
      ref_key: "rootRef",
      ref: u,
      "data-testid": "dropdown-panel-header",
      class: "relative flex flex-col gap-3 border-b border-(--border-border-base-soft) bg-(--background-background-white) px-3 pt-4 pb-[calc(--spacing(4)-1px)] shadow-(--shadow-bottom-dropdown) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--shadow-bottom-dropdown-dark)"
    }, [
      i.value ? (c(), g("div", Hw, [
        e.labelLeft ? (c(), W(Yr, {
          key: 0,
          id: L(r),
          label: e.labelLeft,
          "info-right": e.labelLeftInfo,
          "data-testid": "dropdown-panel-header-label-left"
        }, null, 8, ["id", "label", "info-right"])) : w("", !0),
        e.labelRight ? (c(), W(Yr, {
          key: 1,
          id: L(o),
          label: e.labelRight,
          "info-right": e.labelRightInfo,
          class: "ml-auto",
          "data-testid": "dropdown-panel-header-label-right"
        }, null, 8, ["id", "label", "info-right"])) : w("", !0)
      ])) : w("", !0),
      e.showSearch ? (c(), W(ls, {
        key: 1,
        "model-value": e.searchQuery,
        placeholder: e.searchPlaceholder,
        "aria-label": e.searchLabel,
        "aria-labelledby": s.value,
        labels: { clear: e.searchClearLabel },
        size: "sm",
        "full-width": "",
        "onUpdate:modelValue": h[0] || (h[0] = (p) => l("update:searchQuery", p))
      }, null, 8, ["model-value", "placeholder", "aria-label", "aria-labelledby", "labels"])) : w("", !0),
      e.groupButtons.length ? (c(), W(Ig, {
        key: 2,
        "model-value": e.activeGroup ?? "",
        variant: "group",
        color: "dark",
        size: "sm",
        "label-left": e.groupLabelLeft,
        "label-left-info": e.groupLabelLeftInfo,
        "label-right": e.groupLabelRight,
        "label-right-info": e.groupLabelRightInfo,
        "aria-label": d.value ? void 0 : e.groupAriaLabel,
        class: "w-full",
        "data-testid": "dropdown-panel-header-group",
        "onUpdate:modelValue": h[1] || (h[1] = (p) => l("update:activeGroup", String(p)))
      }, {
        default: ve(() => [
          (c(!0), g(de, null, Re(e.groupButtons, (p) => (c(), W(Me, {
            key: p.value,
            variant: "tertiary",
            size: "sm",
            label: p.label,
            value: p.value,
            shrink: "",
            class: "flex-1"
          }, null, 8, ["label", "value"]))), 128))
        ]),
        _: 1
      }, 8, ["model-value", "label-left", "label-left-info", "label-right", "label-right-info", "aria-label"])) : w("", !0)
    ], 512));
  }
});
function go() {
  const e = R(0);
  function n(o, i) {
    var s;
    o && ((s = o.querySelector(`[data-listbox-index="${i}"]`)) == null || s.focus());
  }
  function t(o, i) {
    for (let s = 0; s < o; s++)
      if (!(i != null && i(s))) return s;
    return 0;
  }
  function a(o, i, s) {
    if (i === 0) return;
    let d;
    switch (o.key) {
      case "ArrowDown":
        d = (e.value + 1) % i;
        break;
      case "ArrowUp":
        d = (e.value - 1 + i) % i;
        break;
      case "Home":
        d = 0;
        break;
      case "End":
        d = i - 1;
        break;
      default:
        return;
    }
    o.preventDefault(), o.stopPropagation(), e.value = d, n(s, d);
  }
  function l(o, i, s, { downIndex: d = 0, upIndex: u = i - 1 } = {}) {
    if (o.key !== "ArrowDown" && o.key !== "ArrowUp" || i === 0) return !1;
    const f = o.key === "ArrowDown" ? d : u, b = s == null ? void 0 : s.querySelector(`[data-listbox-index="${f}"]`);
    return b ? (o.preventDefault(), e.value = f, b.focus({ preventScroll: !0 }), b.scrollIntoView({ block: "nearest" }), !0) : !1;
  }
  function r(o) {
    e.value = Math.min(e.value, Math.max(0, o - 1));
  }
  return {
    focusedIndex: e,
    focusListboxOption: n,
    handleRovingKeydown: a,
    handleSearchFieldKeydown: l,
    clampFocusedIndex: r,
    firstEnabledIndex: t
  };
}
const Zu = Symbol("FieldGroup"), jw = { part: "", corners: "" };
function Qu(e) {
  const n = Kt(Zu, null);
  let t = null;
  return ct(() => {
    t = e.value, n && t && n.register(t);
  }), yt(() => {
    n && t && n.unregister(t);
  }), {
    inGroup: !!n,
    groupPart: m(() => n ? n.partOf(e.value) : jw)
  };
}
const Ww = ["src"], qw = ["src"], Uw = ["name", "value"], Gw = ["id", "aria-expanded", "aria-haspopup", "aria-labelledby", "aria-label", "aria-describedby", "aria-disabled", "aria-readonly", "aria-required", "aria-invalid", "tabindex", "onClick", "onKeydown"], Kw = {
  key: 0,
  class: "inline-flex size-4 shrink-0 items-center justify-center",
  "aria-hidden": "true",
  "data-testid": "select-prefix-flag"
}, Yw = ["src"], Jw = {
  key: 2,
  class: "flex min-w-0 flex-1",
  "data-testid": "select-value"
}, Xw = ["src"], Zw = ["role", "aria-labelledby", "aria-label"], Qw = ["onKeydown"], _w = {
  key: 1,
  "aria-live": "polite",
  role: "status",
  class: "sr-only",
  "data-testid": "select-status"
}, e1 = {
  key: 0,
  "data-testid": "select-results-heading",
  class: "flex shrink-0 px-2.5 pt-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading) dark:text-(--colors-text-white-default)"
}, t1 = ["aria-labelledby", "aria-label"], n1 = ["aria-labelledby"], a1 = ["id"], l1 = {
  "data-testid": "select-no-results",
  class: "flex px-2.5 py-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading) dark:text-(--colors-text-white-default)"
}, So = -1, ll = /* @__PURE__ */ ye({
  __name: "SelectInput",
  props: {
    placeholder: { default: void 0 },
    modelValue: { default: "" },
    options: {},
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: "384px" },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    helpIcon: { default: void 0 },
    prefixIcon: { default: void 0 },
    prefixFlag: { default: void 0 },
    iconLeft: { default: void 0 },
    error: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    hint: { default: void 0 },
    noResultsLabel: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    searchable: { type: Boolean, default: !1 },
    searchPlaceholder: { default: void 0 },
    searchLabel: { default: void 0 },
    searchClearLabel: { default: void 0 },
    resultsCountLabel: { type: [String, Function], default: "{count} results" },
    resultsLabel: { default: void 0 },
    seeAllLabel: { default: void 0 },
    createLabel: { default: void 0 },
    createIcon: { default: "ri-add-line" },
    buttons: { default: () => [] },
    buttonLayout: { default: "attached" },
    buttonSize: { default: void 0 }
  },
  emits: ["update:modelValue", "change", "focus", "blur", "see-all", "create", "button-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = qe(), r = m(() => t.id || l), o = m(() => t.label ? `${r.value}-label` : void 0), i = m(() => `${r.value}-error`), s = m(() => `${r.value}-hint`), d = m(() => !!t.error), u = m(
      () => t.options.find((me) => !me.heading && me.value === t.modelValue) ?? null
    ), f = m(() => {
      var Be;
      const me = (Be = u.value) == null ? void 0 : Be.iconColor;
      return me && !t.disabled ? wg[me] : void 0;
    }), b = m(() => {
      var me;
      return ((me = u.value) == null ? void 0 : me.label) ?? "";
    }), h = m(() => {
      const me = [];
      return t.hint && me.push(s.value), d.value && me.push(i.value), me.length > 0 ? me.join(" ") : void 0;
    }), p = R(!1), x = R(null), y = R(null), k = R(null), $ = (me) => {
      var Be, Ye;
      (Be = y.value) == null || Be.handleFieldKeydown(me), (Ye = k.value) == null || Ye.handleFieldKeydown(me);
    }, S = {
      sm: { container: "h-8 px-[calc(--spacing(2)-1px)] gap-2", text: "text-(length:--size-m) leading-(--line-height-l)", icon: "h-4 w-4" },
      md: { container: "h-9 px-3 py-2 gap-2", text: "text-(length:--size-m) leading-(--line-height-l)", icon: "h-4 w-4" },
      lg: { container: "h-12 px-3.5 gap-2", text: "text-(length:--size-l) leading-(--line-height-xxl)", icon: "h-5 w-5" },
      xl: { container: "h-13 px-4 gap-2", text: "text-(length:--size-l) leading-(--line-height-xxl)", icon: "h-5 w-5" }
    }, T = m(() => S[t.size]), I = (me) => {
      const Be = "relative flex items-center w-full rounded-xl border border-solid box-border text-left font-inter transition-colors select-none focus:outline-none";
      if (t.disabled)
        return `${Be} bg-gainsboro-200 border-border-disabled-subtle text-text-disabled dark:bg-(--colors-background-disabled) dark:border-(--colors-border-disabled-subtle) dark:text-(--colors-text-disabled)`;
      if (t.readonly) {
        const Ye = p.value ? "border-(--border-border-accent) shadow-[0px_0px_2px_var(--border-border-accent)]" : "border-(--border-border-base-soft) dark:border-(--border-border-base)";
        return `${Be} cursor-default bg-(--colors-background-white-secondary-soft) dark:bg-(--colors-background-disabled) ${Ye} text-text-black-default dark:text-(--colors-text-white-default)`;
      }
      if (d.value) {
        const Ye = p.value ? " shadow-[0px_0px_2px_var(--border-border-accent)]" : "";
        return `${Be} cursor-pointer bg-white border-(--border-border-error-strong) text-text-black-default dark:bg-(--colors-background-black-default) dark:border-(--border-border-error) dark:text-(--colors-text-white-default)${Ye}`;
      }
      return p.value || me ? `${Be} cursor-pointer bg-(--background-background-selected) border-(--border-border-accent) shadow-[0px_0px_2px_var(--border-border-accent)] text-text-black-default dark:bg-[rgba(255,255,255,0.05)] dark:text-(--colors-text-white-default)` : `${Be} cursor-pointer bg-(--background-background-white) border-(--border-border-base-medium) hover:border-(--border-border-accent) text-text-black-default dark:bg-(--colors-background-black-default) dark:border-(--colors-border-base) dark:text-(--colors-text-white-default)`;
    }, A = m(() => !!t.label || t.labelInline && !!t.iconLeft), E = m(() => t.labelInline && A.value), D = m(() => nr(t.labelInline, A.value, !1)), z = R(null), { inGroup: Y, groupPart: le } = Qu(z), ne = m(() => t.fullWidth || Y), re = m(() => {
      const me = `relative ${Y ? le.value.part : "pb-0.5"} text-sm text-text-black-default dark:text-(--colors-text-white-default) font-inter`, Be = E.value ? D.value.root : "flex flex-col gap-0.5";
      return `${me} ${Be} ${ne.value ? "w-full" : ""}`;
    }), O = {
      xs: "min-h-8",
      sm: "min-h-9",
      md: "min-h-10",
      lg: "min-h-12",
      xl: "min-h-13"
    }, P = m(
      () => t.buttons.length > 0 && t.buttonLayout === "attached" ? O[t.buttonSize ?? Wa(t.size, "attached")] : ""
    ), V = m(() => ne.value ? {} : { width: t.width }), M = m(() => t.labelInline && !ne.value ? { width: t.width } : ne.value ? {} : { width: t.width }), B = (me) => !!me && me.startsWith("ri-"), q = (me) => {
      a("update:modelValue", me), a("change", me);
    }, N = (me, Be) => {
      me.disabled || (q(me.value), he.reset(), Be(), Ge(() => {
        var Ye;
        return (Ye = x.value) == null ? void 0 : Ye.focus();
      }));
    }, G = (me, Be, Ye) => {
      he.query.value.length > 0 || (Ye.preventDefault(), Ye.stopPropagation(), N(me, Be));
    }, U = R(null), { focusedIndex: K, focusListboxOption: ge, handleRovingKeydown: xe, handleSearchFieldKeydown: X, firstEnabledIndex: ie } = go(), he = Yu(), oe = R(""), Ce = R(null), H = R(null), Z = m(() => {
      const me = ja(he.query.value.trim()), Be = [{ options: [] }];
      let Ye = 0;
      return t.options.forEach((Qe, bt) => {
        if (Qe.disabled, Qe.label, Qe.value, Qe.heading) {
          Be.push({ heading: Qe, headingId: `${r.value}-group-${bt}`, options: [] });
          return;
        }
        (t.searchable ? Ku(Qe.label, oe.value) : !me || ja(Qe.label).startsWith(me)) && Be[Be.length - 1].options.push({ option: Qe, index: Ye++ });
      }), Be.filter((Qe) => Qe.options.length > 0);
    }), ee = m(
      () => Z.value.flatMap((me) => me.options.map(({ option: Be }) => Be))
    ), J = (me) => {
      var Be;
      return ((Be = ee.value[me]) == null ? void 0 : Be.disabled) === !0;
    };
    function F() {
      if (ee.value.length === 0) return So;
      const me = ee.value.findIndex((Be) => Be.value === t.modelValue);
      return me >= 0 ? me : ie(ee.value.length, J);
    }
    function _(me) {
      ge(U.value, me);
    }
    $e(
      U,
      (me) => {
        var Be;
        if (!me) {
          he.reset(), oe.value = "";
          return;
        }
        if (K.value = F(), t.searchable) {
          (Be = H.value) == null || Be.focusSearch();
          return;
        }
        K.value === So ? me.focus() : _(K.value);
      },
      { flush: "post" }
    ), $e(
      ee,
      () => {
        var Be, Ye, Qe;
        if (!U.value) return;
        if ((Be = Ce.value) != null && Be.contains(document.activeElement)) {
          K.value = F();
          return;
        }
        if (document.activeElement !== U.value && U.value.contains(document.activeElement)) {
          const bt = Number(
            (Ye = document.activeElement.closest("[data-listbox-index]")) == null ? void 0 : Ye.dataset.listboxIndex
          );
          if (!Number.isNaN(bt)) {
            K.value = bt;
            return;
          }
        }
        K.value = Math.min(Math.max(K.value, 0), ee.value.length - 1), K.value === So ? t.searchable ? (Qe = H.value) == null || Qe.focusSearch() : U.value.focus() : _(K.value);
      },
      { flush: "post" }
    );
    const ue = (me) => me.key.length === 1 && !me.ctrlKey && !me.metaKey && !me.altKey;
    function se(me) {
      var Be;
      if (t.searchable) {
        if (me.key === "Tab" && (me.shiftKey || pe.value)) {
          me.stopPropagation();
          return;
        }
        const Ye = me.key === "Backspace";
        if (Ye || ue(me) && me.key !== " ") {
          me.preventDefault(), me.stopPropagation(), oe.value = Ye ? oe.value.slice(0, -1) : oe.value + me.key, (Be = H.value) == null || Be.focusSearch();
          return;
        }
      } else if (he.handleKey(me)) {
        me.preventDefault(), me.stopPropagation();
        return;
      }
      xe(me, ee.value.length, U.value);
    }
    const Q = (me, Be) => ({
      ...{
        type: me.badgeTheme ? "badge" : t.searchable ? "autocomplete" : "default",
        label: me.label,
        icon: me.badgeTheme ? void 0 : me.icon,
        iconColor: me.iconColor,
        badge: me.badgeTheme ? { label: me.label, theme: me.badgeTheme, icon: me.icon } : void 0,
        highlighted: me.value === t.modelValue,
        ariaDisabled: !!me.disabled,
        description: me.disabled ? me.disabledReason : void 0
      },
      role: "option",
      "aria-selected": me.value === t.modelValue,
      tabindex: Be === K.value ? 0 : -1,
      "data-listbox-index": Be,
      "data-testid": `select-option-${me.value}`,
      style: me.fontFamily ? { fontFamily: me.fontFamily } : void 0
    }), ae = (me, Be, Ye) => ({
      click: () => N(me, Ye),
      focus: () => {
        K.value = Be;
      },
      keydown: (Qe) => {
        Qe.key === "Enter" ? (Qe.preventDefault(), N(me, Ye)) : Qe.key === " " && G(me, Ye, Qe);
      }
    }), Te = m(
      () => t.searchLabel ?? t.searchPlaceholder ?? t.label ?? t.ariaLabel
    ), Le = m(() => {
      if (!(t.searchable ? oe.value : he.query.value)) return "";
      const Be = ee.value.length;
      return t.searchable ? Be === 0 && t.noResultsLabel ? t.noResultsLabel : as(t.resultsCountLabel, Be) : String(Be);
    }), pe = m(() => t.searchable && !!(t.seeAllLabel || t.createLabel)), ke = (me) => {
      me(), Ge(() => {
        var Be;
        return (Be = x.value) == null ? void 0 : Be.focus();
      });
    };
    function fe(me, Be) {
      ke(Be), a(me === "see-all" ? "see-all" : "create");
    }
    function ze(me, Be) {
      const Ye = ee.value.length;
      switch (me.key) {
        case "ArrowDown":
        case "ArrowUp":
          me.preventDefault(), me.stopPropagation(), X(me, Ye, U.value, { downIndex: Math.max(K.value, 0) });
          break;
        case "Home":
        case "End":
          me.stopPropagation();
          break;
        case "Tab":
          me.shiftKey ? (me.preventDefault(), me.stopPropagation(), ke(Be)) : (K.value !== So || pe.value) && me.stopPropagation();
          break;
      }
    }
    function Ee(me) {
      if (me.key !== "Tab") return;
      const Be = me.currentTarget.querySelectorAll("button, a[href]");
      (me.shiftKey || me.target !== Be[Be.length - 1]) && me.stopPropagation();
    }
    let He = !1;
    const Ke = (me) => {
      var Be;
      return ((Be = me.target) == null ? void 0 : Be.closest("[data-field-label-tooltip]")) != null;
    }, et = (me) => {
      Ke(me) || (He = U.value !== null);
    }, Se = (me) => {
      var Ye, Qe;
      if (Ke(me)) return;
      const Be = He;
      if (He = !1, !t.disabled) {
        if (Be) {
          (Ye = x.value) == null || Ye.focus();
          return;
        }
        (Qe = x.value) == null || Qe.click();
      }
    };
    return (me, Be) => (c(), g("div", {
      ref_key: "rootRef",
      ref: z,
      class: C(re.value),
      style: je(e.labelInline ? {} : V.value)
    }, [
      A.value ? (c(), g("div", {
        key: 0,
        class: C([
          "flex min-w-0 max-w-full items-center gap-1",
          e.labelInline ? "shrink-0" : "",
          !e.disabled && !e.readonly ? "cursor-pointer" : ""
        ]),
        onMousedown: et,
        onClick: Se
      }, [
        e.iconLeft && e.labelInline ? (c(), g("img", {
          key: 0,
          src: e.iconLeft,
          class: "mr-1 h-6 w-6 rounded-full object-cover shrink-0",
          alt: ""
        }, null, 8, Ww)) : w("", !0),
        e.label ? (c(), W(It, {
          key: 1,
          id: o.value,
          ref_key: "labelRef",
          ref: y,
          text: e.label,
          required: e.required,
          "required-indicator": e.requiredIndicator,
          tooltip: e.labelTooltip,
          focused: p.value,
          inline: e.labelInline,
          "test-id": "select-label"
        }, null, 8, ["id", "text", "required", "required-indicator", "tooltip", "focused", "inline"])) : w("", !0),
        e.helpIcon && !e.labelTooltip ? (c(), g(de, { key: 2 }, [
          B(e.helpIcon) ? (c(), g("i", {
            key: 0,
            class: C([e.helpIcon, "text-(length:--size-m) leading-(--line-height-s) text-(--text-text-body-subtle) ml-0.5 cursor-help"])
          }, null, 2)) : (c(), g("img", {
            key: 1,
            src: e.helpIcon,
            class: "h-3.5 w-3.5 ml-0.5 cursor-help",
            alt: "Help"
          }, null, 8, qw))
        ], 64)) : w("", !0)
      ], 34)) : w("", !0),
      v("div", {
        style: je(M.value),
        class: C([{ "w-full": ne.value }, E.value ? D.value.field : ""])
      }, [
        v("input", {
          type: "hidden",
          name: e.name,
          value: e.modelValue
        }, null, 8, Uw),
        te(bo, {
          buttons: e.buttons,
          layout: e.buttonLayout,
          size: e.size,
          disabled: e.disabled,
          "button-size": e.buttonSize,
          onButtonClick: Be[3] || (Be[3] = (Ye) => a("button-click", Ye))
        }, {
          default: ve(({ fieldClass: Ye }) => [
            te(cn, {
              "full-width": !0,
              "menu-width": M.value.width ?? "100%",
              disabled: e.disabled,
              bare: ""
            }, {
              trigger: ve(({ toggle: Qe, isOpen: bt }) => {
                var jt, De, Pe;
                return [
                  v("div", {
                    id: r.value,
                    ref_key: "triggerRef",
                    ref: x,
                    role: "combobox",
                    "aria-expanded": bt,
                    "aria-haspopup": e.searchable ? "dialog" : "listbox",
                    "aria-labelledby": o.value,
                    "aria-label": e.label ? void 0 : e.ariaLabel,
                    "aria-describedby": h.value,
                    "aria-disabled": e.disabled ? "true" : void 0,
                    "aria-readonly": e.readonly ? "true" : void 0,
                    "aria-required": e.required ? "true" : void 0,
                    "aria-invalid": d.value ? "true" : void 0,
                    tabindex: e.disabled ? -1 : 0,
                    "data-testid": "select-input",
                    class: C([I(bt), T.value.container, P.value, Ye || L(le).corners]),
                    onClick: (We) => !e.disabled && !e.readonly && Qe(),
                    onKeydown: [
                      (We) => !bt && $(We),
                      ht(Je((We) => !e.disabled && !e.readonly && Qe(), ["prevent"]), ["enter"]),
                      ht(Je((We) => !e.disabled && !e.readonly && Qe(), ["prevent"]), ["space"])
                    ],
                    onFocus: Be[0] || (Be[0] = (We) => {
                      p.value = !0, me.$emit("focus");
                    }),
                    onBlur: Be[1] || (Be[1] = (We) => {
                      p.value = !1, me.$emit("blur");
                    })
                  }, [
                    e.prefixFlag ? (c(), g("span", Kw, [
                      v("span", {
                        class: C(["fi fis size-[13.33px] rounded-full", `fi-${e.prefixFlag.toLowerCase()}`])
                      }, null, 2)
                    ])) : e.prefixIcon ? (c(), g(de, { key: 1 }, [
                      B(e.prefixIcon) ? (c(), g("i", {
                        key: 0,
                        class: C([e.prefixIcon, "shrink-0 text-base leading-none", T.value.icon])
                      }, null, 2)) : (c(), g("img", {
                        key: 1,
                        src: e.prefixIcon,
                        class: C(["shrink-0 object-cover", T.value.icon]),
                        alt: ""
                      }, null, 10, Yw))
                    ], 64)) : w("", !0),
                    (jt = u.value) != null && jt.badgeTheme ? (c(), g("span", Jw, [
                      te(gt, {
                        label: u.value.label,
                        theme: u.value.badgeTheme,
                        "left-icon": u.value.icon,
                        size: "sm",
                        "data-testid": "select-value-badge"
                      }, null, 8, ["label", "theme", "left-icon"])
                    ])) : (c(), g(de, { key: 3 }, [
                      (De = u.value) != null && De.icon && !e.prefixFlag && !e.prefixIcon ? (c(), g(de, { key: 0 }, [
                        B(u.value.icon) ? (c(), g("i", {
                          key: 0,
                          class: C([u.value.icon, "shrink-0 text-(length:--icon-size-sm) leading-(--icon-size-sm)", T.value.icon, f.value]),
                          "aria-hidden": "true",
                          "data-testid": "select-value-icon"
                        }, null, 2)) : (c(), g("img", {
                          key: 1,
                          src: u.value.icon,
                          class: C(["shrink-0 object-cover", T.value.icon]),
                          alt: "",
                          "data-testid": "select-value-icon"
                        }, null, 10, Xw))
                      ], 64)) : w("", !0),
                      v("span", {
                        class: C(["flex min-w-0 flex-1", [
                          T.value.text,
                          e.disabled ? "" : b.value ? "text-text-black-default dark:text-(--colors-text-white-default)" : "text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
                        ]]),
                        style: je((Pe = u.value) != null && Pe.fontFamily ? { fontFamily: u.value.fontFamily } : void 0),
                        "data-testid": "select-value"
                      }, [
                        te(pt, {
                          text: b.value || e.placeholder || "",
                          focusable: !1
                        }, null, 8, ["text"])
                      ], 6)
                    ], 64)),
                    v("i", {
                      class: C(["ri-arrow-down-s-line shrink-0 text-base leading-none transition-transform duration-200 ease-in-out", [T.value.icon, e.disabled ? "text-text-disabled" : "text-(--text-text-body-subtle)"]]),
                      style: je({ transform: bt ? "rotate(180deg)" : "rotate(0deg)" })
                    }, null, 6)
                  ], 42, Gw)
                ];
              }),
              menu: ve(({ close: Qe }) => [
                v("div", {
                  role: e.searchable ? "dialog" : void 0,
                  "aria-labelledby": e.searchable ? o.value : void 0,
                  "aria-label": e.searchable && !e.label ? e.ariaLabel : void 0,
                  "data-testid": "select-panel",
                  class: C(
                    e.searchable ? "flex max-h-[calc(100vh-90px)] flex-col" : "box-border flex max-h-[min(400px,calc(100vh-24px))] flex-col gap-1.5 overflow-y-auto p-[calc(--spacing(2)-1px)]"
                  )
                }, [
                  e.searchable ? (c(), g("div", {
                    key: 0,
                    ref_key: "searchAreaRef",
                    ref: Ce,
                    class: "shrink-0",
                    onKeydown: (bt) => ze(bt, Qe)
                  }, [
                    te(vl, {
                      ref_key: "headerRef",
                      ref: H,
                      "show-search": "",
                      "search-query": oe.value,
                      "search-placeholder": e.searchPlaceholder,
                      "search-label": Te.value,
                      "search-clear-label": e.searchClearLabel,
                      "onUpdate:searchQuery": Be[2] || (Be[2] = (bt) => oe.value = bt)
                    }, null, 8, ["search-query", "search-placeholder", "search-label", "search-clear-label"])
                  ], 40, Qw)) : w("", !0),
                  e.searchable || L(he).query.value ? (c(), g("span", _w, j(Le.value), 1)) : w("", !0),
                  v("div", {
                    "data-testid": "select-list",
                    class: C(
                      e.searchable ? ["flex max-h-100 min-h-0 flex-col overflow-y-auto p-1", !ee.value.length && "hidden"] : "contents"
                    )
                  }, [
                    e.searchable && e.resultsLabel ? (c(), g("div", e1, j(e.resultsLabel), 1)) : w("", !0),
                    v("ul", {
                      ref_key: "listboxRef",
                      ref: U,
                      role: "listbox",
                      "aria-labelledby": o.value,
                      "aria-label": e.label ? void 0 : e.ariaLabel,
                      tabindex: "-1",
                      class: C(["flex w-full flex-col focus-visible:outline-none", !e.searchable && "gap-1.5"]),
                      onKeydown: se
                    }, [
                      (c(!0), g(de, null, Re(Z.value, (bt) => (c(), g(de, {
                        key: bt.headingId ?? "ungrouped"
                      }, [
                        bt.heading ? (c(), g("li", {
                          key: 0,
                          role: "group",
                          "aria-labelledby": bt.headingId,
                          class: C(["flex flex-col", !e.searchable && "gap-1.5"])
                        }, [
                          v("div", {
                            id: bt.headingId,
                            role: "presentation",
                            "data-testid": "select-group-heading",
                            class: "flex shrink-0 px-2.5 pt-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading) dark:text-(--colors-text-white-default)"
                          }, j(bt.heading.label), 9, a1),
                          (c(!0), g(de, null, Re(bt.options, ({ option: jt, index: De }) => (c(), W(en, Fe({
                            key: jt.value,
                            as: "div"
                          }, { ref_for: !0 }, Q(jt, De), Nl(ae(jt, De, Qe))), null, 16))), 128))
                        ], 10, n1)) : (c(!0), g(de, { key: 1 }, Re(bt.options, ({ option: jt, index: De }) => (c(), W(en, Fe({
                          key: jt.value,
                          as: "li"
                        }, { ref_for: !0 }, Q(jt, De), Nl(ae(jt, De, Qe))), null, 16))), 128))
                      ], 64))), 128))
                    ], 42, t1)
                  ], 2),
                  ee.value.length === 0 && e.noResultsLabel ? (c(), g("div", {
                    key: 2,
                    class: C(e.searchable && "p-1")
                  }, [
                    v("div", l1, j(e.noResultsLabel), 1)
                  ], 2)) : w("", !0),
                  pe.value ? (c(), W(pl, {
                    key: 3,
                    type: "see-all-create",
                    "see-all-label": e.seeAllLabel,
                    "create-label": e.createLabel,
                    "create-icon": e.createIcon,
                    class: "shrink-0",
                    onKeydown: Ee,
                    onSeeAll: (bt) => fe("see-all", Qe),
                    onCreate: (bt) => fe("create", Qe)
                  }, null, 8, ["see-all-label", "create-label", "create-icon", "onSeeAll", "onCreate"])) : w("", !0)
                ], 10, Zw)
              ]),
              _: 2
            }, 1032, ["menu-width", "disabled"])
          ]),
          _: 1
        }, 8, ["buttons", "layout", "size", "disabled", "button-size"])
      ], 6),
      !L(Y) && D.value.reservesHelper || e.hint || e.error ? (c(), W($t, {
        key: 1,
        ref_key: "helperRef",
        ref: k,
        class: C(E.value ? D.value.helper : ""),
        focused: p.value,
        hint: e.hint,
        error: e.error,
        "hint-id": s.value,
        "error-id": i.value,
        "error-live": e.errorLive,
        "test-id-prefix": "select"
      }, null, 8, ["class", "focused", "hint", "error", "hint-id", "error-id", "error-live"])) : w("", !0)
    ], 6));
  }
}), Ms = "None", Dd = /* @__PURE__ */ ye({
  __name: "AccessLevelSelect",
  props: {
    modelValue: {},
    label: {},
    levels: {},
    allowNone: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    disabledLevels: { default: () => [] },
    hint: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => [
      { value: "Edit", label: t.levels.edit, disabled: t.disabledLevels.includes("Edit") },
      { value: "View", label: t.levels.view, disabled: t.disabledLevels.includes("View") },
      ...t.allowNone ? [{ value: Ms, label: t.levels.none }] : []
    ]), r = m(() => t.modelValue ?? Ms), o = m(() => l.value.every((s) => s.disabled)), i = (s) => {
      a("update:modelValue", s === Ms ? null : s);
    };
    return (s, d) => (c(), W(ll, {
      "model-value": r.value,
      options: l.value,
      label: e.label,
      disabled: e.disabled || o.value,
      hint: e.hint,
      "full-width": "",
      "onUpdate:modelValue": i
    }, null, 8, ["model-value", "options", "label", "disabled", "hint"]));
  }
});
function rs(e, n, t = {}) {
  const { ignoreSelectors: a, ignoreElements: l, isActive: r } = t, o = (i) => {
    if (r && !r()) return;
    const s = e.value, d = i.target;
    if (!(!s || !d || s.contains(d)) && d.isConnected && !(l != null && l().some((u) => u && u.contains(d)))) {
      if (a != null && a.length) {
        const u = d instanceof Element ? d : d.parentElement;
        if (u && a.some((f) => u.closest(f))) return;
      }
      n();
    }
  };
  ct(() => {
    document.addEventListener("click", o, !0);
  }), kt(() => {
    document.removeEventListener("click", o, !0);
  });
}
function ar(e = {}) {
  const { defaultOpen: n = !1, onClose: t, ignoreSelectors: a } = e, l = R(n), r = R(null), o = () => {
    l.value = !l.value;
  }, i = () => {
    l.value = !0;
  }, s = () => {
    l.value = !1, t == null || t();
  };
  return rs(r, s, { ignoreSelectors: a }), {
    isOpen: l,
    dropdownRef: r,
    toggleDropdown: o,
    openDropdown: i,
    closeDropdown: s
  };
}
const qW = /* @__PURE__ */ ye({
  __name: "ButtonLink",
  props: {
    as: {},
    iconLeft: {},
    iconRight: {},
    size: {},
    ariaLabel: {},
    disabled: { type: Boolean },
    ariaDisabled: { type: [Boolean, String] }
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), W(Cg, Fe(n, { underline: "always" }), {
      default: ve(() => [
        Ae(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
function r1(e) {
  const n = R(null), t = R(null);
  function a(i) {
    n.value = i;
  }
  function l(i) {
    n.value !== i && (t.value = i);
  }
  function r(i) {
    const s = n.value;
    if (!s || s === i) return;
    const d = e.value.find((b) => b.id === s), u = e.value.find((b) => b.id === i);
    if (!d || !u || u.disabled) return;
    const f = d.order;
    d.order = u.order, u.order = f, n.value = null, t.value = null;
  }
  function o() {
    n.value = null, t.value = null;
  }
  return { draggedId: n, dragOverId: t, onDragStart: a, onDragOver: l, onDrop: r, onDragEnd: o };
}
const _u = {
  m: "320px",
  l: "498px",
  xl: "768px"
}, o1 = ["aria-expanded"], i1 = ["src"], s1 = { class: "relative dark:text-(--colors-text-white-default)" }, d1 = ["src"], u1 = ["aria-label"], c1 = ["role", "aria-label", "aria-multiselectable"], f1 = ["role"], h1 = ["role", "onFocusin"], b1 = { key: 1 }, $o = 4, cr = 8, g1 = 240, $f = '[data-testid="dropdown-list-item-more-actions-trigger"]', Ds = "text-(length:--icon-size-sm) leading-(--icon-size-sm)", ec = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "FilterDropdown",
  props: {
    label: { default: "Filters" },
    triggerIconLeft: { default: void 0 },
    triggerIcon: { default: void 0 },
    defaultOpen: { type: Boolean, default: !1 },
    size: { default: void 0 },
    menuWidth: { default: "auto" },
    menuAlign: { default: "left" },
    tab: { type: Boolean, default: !1 },
    ariaLabel: { default: void 0 },
    headerLabelLeft: { default: void 0 },
    headerLabelRight: { default: void 0 },
    showSearch: { type: Boolean, default: !1 },
    searchQuery: { default: "" },
    searchPlaceholder: { default: "Search…" },
    searchClearLabel: { default: "Clear search" },
    groupButtons: { default: () => [] },
    groupButtonsLabel: { default: void 0 },
    activeGroupButton: { default: void 0 },
    items: { default: () => [] },
    maxListHeight: { default: void 0 },
    reserveListHeight: { type: Boolean, default: !1 },
    emptyLabel: { default: void 0 },
    emptyIcon: { default: void 0 },
    checkboxPosition: { default: void 0 },
    moreActionsLabel: { default: "More actions" },
    footerLabel: { default: void 0 },
    footerButtons: { default: () => [] },
    stickyItem: { default: void 0 },
    disableInternalSearchFilter: { type: Boolean, default: !1 },
    reorderable: { type: Boolean, default: !1 },
    freezeOnOpen: { type: Boolean, default: !1 }
  },
  emits: ["update:searchQuery", "update:activeGroupButton", "open", "close", "reorder"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, { isOpen: r, dropdownRef: o, toggleDropdown: i, openDropdown: s, closeDropdown: d } = ar({
      defaultOpen: a.defaultOpen,
      ignoreSelectors: ['[data-testid="dropdown-menu"]']
    }), u = R(null), f = R(null), b = R(null), h = R(null), p = R(null), x = R(null);
    let y = null, k = -1;
    function $() {
      var Ze, ft;
      const we = ((Ze = f.value) == null ? void 0 : Ze.$el) ?? u.value;
      if (we) return we;
      const Oe = ((ft = o.value) == null ? void 0 : ft.querySelectorAll("[aria-expanded]")) ?? [];
      return Array.from(Oe).find((vt) => !vt.closest('[data-testid="filter-dropdown-menu"]')) ?? null;
    }
    function S() {
      return $() ?? o.value;
    }
    function T(we) {
      const Oe = we.style.maxHeight;
      we.style.maxHeight = "none";
      const Ze = we.offsetHeight, ft = we.querySelector('[data-testid="filter-dropdown-list"]'), vt = ft == null ? void 0 : ft.querySelector(".filter-item-row");
      return we.style.maxHeight = Oe, { height: Ze, least: Ze - ((ft == null ? void 0 : ft.offsetHeight) ?? 0) + ((vt == null ? void 0 : vt.offsetHeight) ?? 0) };
    }
    function I(we, Oe) {
      return Math.min(Math.max(cr, we), Math.max(cr, window.innerWidth - Oe - cr));
    }
    function A() {
      var we;
      a.freezeOnOpen && (y = ((we = S()) == null ? void 0 : we.getBoundingClientRect()) ?? null, E());
    }
    function E() {
      const we = b.value;
      if (!a.freezeOnOpen || !y || !we) return;
      const Oe = y, { height: Ze, least: ft } = T(we);
      k = Ze;
      const vt = Math.max(Ze, g1), Ot = window.innerHeight - Oe.bottom - $o - cr, bn = Oe.top - $o - cr, Mt = x.value, ce = (Mt == null ? void 0 : Mt.bottom) !== void 0, Ie = !!Mt && vt <= (ce ? bn : Ot) ? ce : vt > Ot && bn > Ot, Ue = Math.max(0, Ie ? bn : Ot), Lt = Ie ? { bottom: window.innerHeight - Oe.top + $o } : { top: Oe.bottom + $o }, Kn = we.offsetWidth, sr = a.menuAlign === "right" ? { right: I(window.innerWidth - Oe.right, Kn) } : { left: I(Oe.left, Kn) };
      x.value = { ...Lt, ...sr, maxHeight: Ue, scrollsWhole: Ue < ft };
    }
    uo(() => {
      const we = b.value;
      !x.value || !we || T(we).height === k || E();
    });
    let D = 0;
    const z = /* @__PURE__ */ new Set();
    function Y(we, Oe) {
      return we.bottom >= Oe.top && we.top <= Oe.bottom && we.right >= Oe.left && we.left <= Oe.right;
    }
    function le(we) {
      const Oe = S(), Ze = we.target;
      !Oe || !(Ze === document || Ze instanceof Element && Ze.contains(Oe)) || (Ze instanceof Element && Ze !== document.documentElement && Ze !== document.body && z.add(Ze), D || (D = requestAnimationFrame(ne)));
    }
    function ne() {
      var vt;
      D = 0;
      const we = S(), Oe = [...z];
      if (z.clear(), !r.value || !we) return;
      const Ze = we.getBoundingClientRect(), ft = { top: 0, bottom: window.innerHeight, left: 0, right: window.innerWidth };
      if (!Y(Ze, ft) || Oe.some((Ot) => !Y(Ze, Ot.getBoundingClientRect()))) {
        const Ot = !!((vt = b.value) != null && vt.contains(document.activeElement));
        d(), Ot && Ge(() => {
          var bn;
          return (bn = $()) == null ? void 0 : bn.focus();
        });
        return;
      }
      y = Ze, E();
    }
    function re() {
      window.removeEventListener("scroll", le, !0), D && cancelAnimationFrame(D), D = 0, z.clear();
    }
    yt(re);
    function O() {
      d(), Ge(() => {
        var we;
        return (we = $()) == null ? void 0 : we.focus();
      });
    }
    const P = (we) => {
      r.value && (we.stopPropagation(), we.preventDefault(), O());
    }, V = (we) => {
      var Ze;
      const Oe = a.footerButtons[we];
      !Oe || Oe.disabled || ((Ze = Oe.onClick) == null || Ze.call(Oe), Oe.keepOpen || O());
    };
    function M() {
      var we, Oe;
      (we = p.value) != null && we.focusSearch() || (Oe = b.value) == null || Oe.focus();
    }
    n({ openDropdown: s, closeDropdown: d, isOpen: r }), $e(
      r,
      (we) => {
        we ? (A(), l("open"), M(), a.freezeOnOpen && window.addEventListener("scroll", le, !0)) : (re(), x.value = null, y = null, k = -1, l("close"));
      },
      { flush: "post" }
    );
    const B = m(() => {
      var Ze, ft;
      let we = a.items ?? [];
      a.activeGroupButton && ((Ze = a.groupButtons) != null && Ze.length) && (we = we.filter((vt) => !vt.group || vt.group === a.activeGroupButton));
      const Oe = (ft = a.searchQuery) == null ? void 0 : ft.trim().toLowerCase();
      return Oe && !a.disableInternalSearchFilter && (we = we.filter((vt) => vt.label.toLowerCase().includes(Oe))), we;
    }), q = R([]);
    $e(
      B,
      (we) => {
        q.value = we.map((Oe, Ze) => ({ id: Oe.id, order: Ze, disabled: Oe.disabled }));
      },
      { immediate: !0, deep: !1 }
    );
    const { onDragStart: N, onDragOver: G, onDrop: U, onDragEnd: K } = r1(q), ge = m(() => {
      if (!a.reorderable) return B.value;
      const we = new Map(B.value.map((Oe) => [Oe.id, Oe]));
      return [...q.value].sort((Oe, Ze) => Oe.order - Ze.order).map((Oe) => we.get(Oe.id)).filter((Oe) => !!Oe);
    });
    function xe(we) {
      U(we), l("reorder", [...q.value].sort((Oe, Ze) => Oe.order - Ze.order).map((Oe) => Oe.id));
    }
    const X = m(
      () => {
        var we, Oe, Ze;
        return !!((we = a.headerLabelLeft) != null && we.text || (Oe = a.headerLabelRight) != null && Oe.text || a.showSearch || (Ze = a.groupButtons) != null && Ze.length);
      }
    ), ie = m(() => !!a.stickyItem), he = m(() => ge.value.length > 0), oe = m(() => !he.value && !!a.emptyLabel), Ce = m(
      () => oe.value || !he.value && a.reserveListHeight && !!a.maxListHeight
    ), H = m(() => ie.value || he.value), Z = m(() => {
      var we;
      return a.ariaLabel || ((we = a.headerLabelLeft) == null ? void 0 : we.text) || a.label;
    }), ee = m(
      () => {
        var we, Oe, Ze;
        return !!((we = a.items) != null && we.some((ft) => ft.hasCheckbox || ft.hasSwitch)) || !!((Oe = a.stickyItem) != null && Oe.hasCheckbox) || !!((Ze = a.stickyItem) != null && Ze.hasSwitch);
      }
    ), J = m(() => {
      var we;
      return !!((we = a.items) != null && we.some((Oe) => {
        var Ze;
        return (Ze = Oe.moreActions) == null ? void 0 : Ze.length;
      }));
    }), F = m(() => {
      var we, Oe;
      return !!((we = a.items) != null && we.some((Ze) => Ze.hasCheckbox)) || !!((Oe = a.stickyItem) != null && Oe.hasCheckbox);
    }), _ = m(() => [
      "flex flex-col px-2",
      F.value ? "gap-0.5" : "gap-0",
      ie.value ? "py-0.5" : "py-1.5"
    ]), ue = m(
      () => a.maxListHeight ? { [a.reserveListHeight ? "height" : "maxHeight"]: a.maxListHeight } : {}
    );
    function se(we) {
      return we.hasSwitch ? "toggle" : we.hasCheckbox ? we.badgeTheme ? "badge-checkbox" : "checkbox" : we.badgeTheme ? "badge" : "default";
    }
    function Q(we) {
      return we.map((Oe) => ({ label: Oe.label, icon: Oe.icon, danger: Oe.variant === "danger", onClick: Oe.onClick }));
    }
    const ae = m(() => {
      const we = /* @__PURE__ */ new Map();
      for (const Oe of [a.stickyItem, ...a.items ?? []])
        Oe != null && Oe.moreActions && we.set(Oe.id, Q(Oe.moreActions));
      return we;
    });
    function Te(we) {
      return se(we) === "checkbox" && we.count !== void 0 ? `(${we.count})` : void 0;
    }
    function Le(we, Oe) {
      var ft, vt;
      const Ze = se(we);
      return {
        as: "div",
        type: Ze,
        label: we.label,
        icon: Ze === "default" ? we.icon : void 0,
        count: Te(we),
        badge: we.badgeTheme ? { label: we.label, theme: we.badgeTheme, rightIcon: we.badgeRightIcon } : void 0,
        checked: Ze === "toggle" ? !!we.switchChecked : !!we.checked,
        indeterminate: !!we.indeterminate,
        ariaDisabled: !!we.disabled,
        // The reason wins: it is what the user needs to know about a disabled option.
        description: we.disabled && we.disabledReason || we.secondaryText,
        moreActions: ae.value.get(we.id),
        moreActionsLabel: (ft = we.moreActions) != null && ft.length ? a.moreActionsLabel : void 0,
        moreActionsTabindex: (vt = we.moreActions) != null && vt.length ? Ke(Oe, 1) ? 0 : -1 : void 0
      };
    }
    function pe(we) {
      var Oe;
      we && !we.disabled && ((Oe = we.onClick) == null || Oe.call(we));
    }
    const { focusedIndex: ke, handleRovingKeydown: fe, handleSearchFieldKeydown: ze, clampFocusedIndex: Ee } = go(), He = R(0);
    function Ke(we, Oe) {
      return ke.value === we && (J.value ? He.value === Oe : Oe === 0);
    }
    function et(we) {
      return ie.value ? we + 1 : we;
    }
    const Se = m(() => ge.value.length + (ie.value ? 1 : 0));
    $e(Se, (we) => Ee(we));
    function me(we) {
      return we.hasSwitch ? "switch" : we.hasCheckbox ? "checkbox" : "button";
    }
    function Be(we) {
      if (we.hasSwitch) return we.switchChecked ? "true" : "false";
      if (we.hasCheckbox) return we.indeterminate ? "mixed" : we.checked ? "true" : "false";
    }
    function Ye(we, Oe) {
      return {
        role: J.value ? me(we) : "option",
        "aria-selected": J.value ? void 0 : !!(we.checked || we.switchChecked),
        "aria-checked": J.value ? Be(we) : void 0,
        "aria-label": [we.label, Te(we)].filter(Boolean).join(" "),
        tabindex: Ke(Oe, 0) ? 0 : -1,
        "data-listbox-index": Oe,
        onClick: () => pe(we),
        onKeydown: ht(Je(() => pe(we), ["self", "prevent"]), ["enter", "space"]),
        onFocus: () => {
          ke.value = Oe, He.value = 0;
        }
      };
    }
    function Qe(we, Oe) {
      var Ze;
      (Ze = we.target) != null && Ze.closest($f) && (ke.value = Oe, He.value = 1);
    }
    function bt(we) {
      if (we.key !== "ArrowRight" && we.key !== "ArrowLeft") return !1;
      const Oe = we.target, Ze = Oe.closest('[role="listitem"]');
      if (!Ze) return !1;
      const ft = Ze.querySelector("[data-listbox-index]"), vt = Ze.querySelector($f), Ot = we.key === "ArrowRight" ? vt : ft;
      return !Ot || Ot === Oe || !ft ? !1 : (we.preventDefault(), ke.value = Number(ft.dataset.listboxIndex), He.value = Ot === vt ? 1 : 0, Ot.focus(), !0);
    }
    function jt(we) {
      if (!we.defaultPrevented) {
        if (J.value) {
          if (bt(we)) return;
          ["ArrowDown", "ArrowUp", "Home", "End"].includes(we.key) && (He.value = 0);
        }
        fe(we, Se.value, h.value);
      }
    }
    function De(we) {
      if (we.defaultPrevented) return;
      const Oe = we.target;
      !(Oe instanceof HTMLTextAreaElement || Oe instanceof HTMLInputElement && !["checkbox", "radio", "button", "submit", "reset"].includes(Oe.type)) && Oe !== b.value || ze(we, Se.value, h.value) && (He.value = 0);
    }
    const Pe = m(() => {
      const [we, Oe] = a.footerButtons.slice(0, 2).map((ft) => ({ label: ft.label, variant: ft.variant, icon: ft.icon, disabled: ft.disabled }));
      if (!we) return null;
      const Ze = a.footerLabel;
      return Oe ? Ze ? { type: "buttons-column", buttons: [we, Oe], label: Ze } : { type: "buttons-inline", buttons: [we, Oe] } : Ze ? { type: "label-button", buttons: [we], label: Ze } : { type: "button", buttons: [we] };
    }), We = m(() => a.size ? { width: _u[a.size] } : a.menuWidth && a.menuWidth !== "auto" ? { width: a.menuWidth, maxWidth: "594px" } : { maxWidth: "594px" }), ot = m(() => {
      if (!x.value && a.freezeOnOpen)
        return { position: "fixed", top: "0px", left: "0px", ...We.value };
      if (!x.value) return We.value;
      const we = { position: "fixed", maxHeight: `${x.value.maxHeight}px` };
      return x.value.top !== void 0 ? we.top = `${x.value.top}px` : x.value.bottom !== void 0 && (we.bottom = `${x.value.bottom}px`), x.value.left !== void 0 ? we.left = `${x.value.left}px` : x.value.right !== void 0 && (we.right = `${x.value.right}px`), { ...we, ...We.value };
    }), St = (we) => !!we && we.startsWith("ri-");
    return (we, Oe) => (c(), g("div", Fe({
      ref_key: "dropdownRef",
      ref: o
    }, we.$attrs, {
      class: ["relative dark:text-(--colors-text-white-default)", e.tab ? "flex h-full items-stretch" : "inline-block text-left"],
      onKeydown: ht(P, ["escape"])
    }), [
      Ae(we.$slots, "trigger", {
        toggle: L(i),
        isOpen: L(r)
      }, () => [
        e.tab ? (c(), g("button", {
          key: 0,
          ref_key: "triggerRef",
          ref: u,
          type: "button",
          "data-testid": "filter-dropdown-trigger",
          class: "inline-flex shrink-0 h-full cursor-pointer items-center gap-1.5 px-3 rounded-tl-(--border-border-radius-rounded-sm) rounded-tr-(--border-border-radius-rounded-sm) border-t border-r border-l border-(--border-border-tab) bg-(--colors-background-white-tertiary) text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-black-default) transition-colors duration-200 hover:bg-whitesmoke focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-royalblue dark:bg-white/5 dark:text-(--colors-text-white-secondary) dark:hover:bg-white/10",
          "aria-expanded": L(r),
          "aria-haspopup": "dialog",
          onClick: Oe[0] || (Oe[0] = //@ts-ignore
          (...Ze) => L(i) && L(i)(...Ze))
        }, [
          e.triggerIconLeft ? (c(), g(de, { key: 0 }, [
            St(e.triggerIconLeft) ? (c(), g("i", {
              key: 0,
              class: C([e.triggerIconLeft, Ds]),
              "aria-hidden": "true"
            }, null, 2)) : (c(), g("img", {
              key: 1,
              class: "h-4 w-4",
              src: e.triggerIconLeft,
              alt: ""
            }, null, 8, i1))
          ], 64)) : w("", !0),
          v("span", s1, j(e.label), 1),
          e.triggerIcon ? (c(), g(de, { key: 1 }, [
            St(e.triggerIcon) ? (c(), g("i", {
              key: 0,
              class: C([e.triggerIcon, Ds, "transition-transform duration-200 ease-in-out"]),
              style: je({ transform: L(r) ? "rotate(180deg)" : "rotate(0deg)" }),
              "aria-hidden": "true"
            }, null, 6)) : (c(), g("img", {
              key: 1,
              class: "h-4 w-4 transition-transform duration-200 ease-in-out",
              style: je({ transform: L(r) ? "rotate(180deg)" : "rotate(0deg)" }),
              src: e.triggerIcon,
              alt: ""
            }, null, 12, d1))
          ], 64)) : (c(), g("i", {
            key: 2,
            class: C(["ri-arrow-down-s-line", Ds, "transition-transform duration-200 ease-in-out"]),
            style: je({ transform: L(r) ? "rotate(180deg)" : "rotate(0deg)" }),
            "aria-hidden": "true"
          }, null, 6))
        ], 8, o1)) : (c(), W(L(Me), {
          key: 1,
          ref_key: "triggerButtonRef",
          ref: f,
          "data-testid": "filter-dropdown-trigger",
          size: "xs",
          variant: "secondary",
          label: e.label,
          "icon-left": e.triggerIconLeft,
          "icon-right": e.triggerIcon,
          "dropdown-icon": !e.triggerIcon,
          "aria-expanded": L(r),
          "aria-haspopup": "dialog",
          onClick: L(i)
        }, null, 8, ["label", "icon-left", "icon-right", "dropdown-icon", "aria-expanded", "onClick"]))
      ]),
      te(At, {
        "enter-active-class": "transition duration-100 ease-out motion-reduce:transition-none",
        "enter-from-class": "transform scale-95 opacity-0",
        "enter-to-class": "transform scale-100 opacity-100",
        "leave-active-class": "transition duration-75 ease-out motion-reduce:transition-none",
        "leave-from-class": "transform scale-100 opacity-100",
        "leave-to-class": "transform scale-95 opacity-0"
      }, {
        default: ve(() => {
          var Ze, ft, vt, Ot, bn;
          return [
            L(r) ? (c(), g("div", {
              key: 0,
              ref_key: "menuRef",
              ref: b,
              role: "dialog",
              "aria-label": Z.value,
              "data-testid": "filter-dropdown-menu",
              tabindex: "-1",
              class: C([
                L(Za),
                "z-50 flex min-w-[220px] flex-col focus-visible:outline-none",
                (Ze = x.value) != null && Ze.scrollsWhole ? "overflow-y-auto overscroll-contain" : "overflow-hidden",
                e.freezeOnOpen ? "" : ["absolute top-full mt-1", e.menuAlign === "right" ? "right-0" : "left-0"]
              ]),
              style: je(ot.value),
              onKeydown: De
            }, [
              X.value ? (c(), W(vl, {
                key: 0,
                ref_key: "headerRef",
                ref: p,
                "label-left": (ft = e.headerLabelLeft) == null ? void 0 : ft.text,
                "label-right": (vt = e.headerLabelRight) == null ? void 0 : vt.text,
                "show-search": e.showSearch,
                "search-query": e.searchQuery,
                "search-placeholder": e.searchPlaceholder,
                "search-clear-label": e.searchClearLabel,
                "group-buttons": e.groupButtons,
                "active-group": e.activeGroupButton,
                "group-label-left": e.groupButtonsLabel,
                "group-aria-label": ((Ot = e.headerLabelLeft) == null ? void 0 : Ot.text) || e.label,
                class: "shrink-0",
                "onUpdate:searchQuery": Oe[1] || (Oe[1] = (Mt) => l("update:searchQuery", Mt)),
                "onUpdate:activeGroup": Oe[2] || (Oe[2] = (Mt) => l("update:activeGroupButton", Mt))
              }, null, 8, ["label-left", "label-right", "show-search", "search-query", "search-placeholder", "search-clear-label", "group-buttons", "active-group", "group-label-left", "group-aria-label"])) : w("", !0),
              H.value || Ce.value ? (c(), g("div", {
                key: 1,
                "data-testid": "filter-dropdown-content",
                class: C(["flex min-h-0 flex-col gap-1.5 pb-2", { "shrink-0": (bn = x.value) == null ? void 0 : bn.scrollsWhole }])
              }, [
                H.value ? (c(), g("div", {
                  key: 0,
                  ref_key: "listboxRef",
                  ref: h,
                  role: J.value ? "list" : "listbox",
                  "aria-label": Z.value,
                  "aria-multiselectable": ee.value && !J.value ? "true" : void 0,
                  class: "flex min-h-0 flex-col",
                  onKeydown: jt
                }, [
                  e.stickyItem ? (c(), g("div", {
                    key: 0,
                    "data-testid": "filter-dropdown-select-all",
                    role: J.value ? "listitem" : void 0,
                    class: "shrink-0 border-b border-(--border-border-base-soft) px-2 pt-2 pb-[calc(--spacing(2)-1px)] dark:border-(--colors-border-base)"
                  }, [
                    te(en, Fe({ ...Le(e.stickyItem, 0), ...Ye(e.stickyItem, 0) }, { "data-testid": "filter-dropdown-sticky-item" }), null, 16)
                  ], 8, f1)) : w("", !0),
                  he.value ? (c(), g("div", {
                    key: 1,
                    "data-testid": "filter-dropdown-list",
                    class: C(["min-h-0", {
                      "overflow-y-auto": !!e.maxListHeight || !!x.value && !x.value.scrollsWhole,
                      "overscroll-contain": e.freezeOnOpen
                    }]),
                    style: je(ue.value)
                  }, [
                    v("div", {
                      class: C(_.value)
                    }, [
                      (c(!0), g(de, null, Re(ge.value, (Mt, ce) => (c(), g("div", {
                        key: Mt.id,
                        role: J.value ? "listitem" : void 0,
                        class: "flex",
                        onFocusin: (be) => Qe(be, et(ce))
                      }, [
                        te(en, Fe({ ref_for: !0 }, { ...Le(Mt, et(ce)), ...Ye(Mt, et(ce)) }, {
                          class: "filter-item-row",
                          "data-testid": `filter-dropdown-item-${Mt.id}`,
                          draggable: e.reorderable && !Mt.disabled,
                          onDragstart: (be) => e.reorderable && L(N)(Mt.id),
                          onDragover: Je((be) => e.reorderable && L(G)(Mt.id), ["prevent"]),
                          onDrop: (be) => e.reorderable && xe(Mt.id),
                          onDragend: Oe[3] || (Oe[3] = (be) => e.reorderable && L(K)())
                        }), null, 16, ["data-testid", "draggable", "onDragstart", "onDragover", "onDrop"])
                      ], 40, h1))), 128))
                    ], 2)
                  ], 6)) : w("", !0)
                ], 40, c1)) : w("", !0),
                Ce.value ? (c(), g("div", {
                  key: 1,
                  "data-testid": "filter-dropdown-empty",
                  class: C([{ "overflow-y-auto": e.reserveListHeight && !!e.maxListHeight }, "flex flex-col items-center justify-center gap-1.5 px-4 py-6 text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"]),
                  style: je(e.reserveListHeight ? ue.value : void 0)
                }, [
                  e.emptyIcon && e.emptyLabel ? (c(), g("i", {
                    key: 0,
                    class: C([e.emptyIcon, "text-(length:--icon-size-md) leading-(--icon-size-md)"]),
                    "aria-hidden": "true",
                    "data-testid": "filter-dropdown-empty-icon"
                  }, null, 2)) : w("", !0),
                  e.emptyLabel ? (c(), g("span", b1, j(e.emptyLabel), 1)) : w("", !0)
                ], 6)) : w("", !0)
              ], 2)) : w("", !0),
              Pe.value ? (c(), W(pl, Fe({ key: 2 }, Pe.value, {
                class: "shrink-0",
                onButtonClick: V
              }), null, 16)) : w("", !0)
            ], 46, u1)) : w("", !0)
          ];
        }),
        _: 1
      })
    ], 16));
  }
}), m1 = ["aria-label", "data-step"], p1 = { class: "flex min-h-0 flex-col pb-2" }, v1 = ["aria-label"], x1 = ["aria-label"], y1 = { class: "flex min-h-0 flex-col pb-2" }, k1 = ["aria-label"], w1 = ["aria-labelledby"], C1 = ["id"], S1 = {
  key: 1,
  role: "none",
  class: "flex min-h-0 flex-col overflow-y-auto px-2 py-1.5",
  "data-testid": "sort-dropdown-field-list"
}, $1 = ["aria-label"], I1 = ["src"], L1 = { class: "leading-(--line-height-l) font-(--weight-medium)" }, UW = /* @__PURE__ */ ye({
  __name: "SortDropdown",
  props: {
    modelValue: { default: "" },
    options: { default: () => [] },
    fields: { default: void 0 },
    sort: { default: null },
    ariaLabel: { default: void 0 },
    align: { default: "right" },
    triggerIconLeft: { default: "ri-filter-3-fill" },
    headerLabel: { default: void 0 },
    searchPlaceholder: { default: "Search a field" },
    searchLabel: { default: void 0 },
    noResultsLabel: { default: void 0 },
    appliedSortLabel: { default: void 0 },
    directionsLabel: { default: "Sort direction" },
    backLabel: { default: "Back" },
    defaultOpen: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "update:sort"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(
      () => {
        var H;
        return ((H = t.options.find((Z) => Z.value === t.modelValue)) == null ? void 0 : H.label) ?? "";
      }
    ), r = m(() => t.options.length === 1), o = m(
      () => t.options.map((H) => ({
        label: H.label,
        active: H.value === t.modelValue,
        testId: `sort-option-${H.value}`,
        onClick: () => a("update:modelValue", H.value)
      }))
    ), i = (H) => !!H && H.startsWith("ri-"), s = m(() => t.fields !== void 0), { isOpen: d, dropdownRef: u, toggleDropdown: f, closeDropdown: b } = ar({ defaultOpen: t.defaultOpen }), h = R(null), p = R(null), x = R(null), y = R(null), k = R(null), $ = qe(), S = R(""), T = R(null), I = { asc: "ri-sort-asc", desc: "ri-sort-desc" }, A = ["asc", "desc"], E = m(() => {
      var H;
      return (H = t.fields) == null ? void 0 : H.find((Z) => {
        var ee;
        return Z.key === ((ee = t.sort) == null ? void 0 : ee.field);
      });
    }), D = m(() => {
      var H;
      return (H = t.fields) == null ? void 0 : H.find((Z) => Z.key === T.value);
    }), z = m(() => S.value.trim() ? void 0 : E.value), Y = m(
      () => (t.fields ?? []).filter((H) => H !== z.value && Ku(H.label, S.value))
    ), le = m(() => z.value ? [z.value, ...Y.value] : Y.value), ne = m(() => {
      var H;
      return ((H = E.value) == null ? void 0 : H.label) ?? t.headerLabel ?? "";
    }), { focusedIndex: re, handleRovingKeydown: O, handleSearchFieldKeydown: P, clampFocusedIndex: V } = go();
    $e(
      () => le.value.length,
      (H) => V(H)
    );
    function M() {
      var H;
      return ((H = h.value) == null ? void 0 : H.$el) ?? null;
    }
    function B(H, Z) {
      const ee = H == null ? void 0 : H.querySelector(`[data-listbox-index="${Z}"]`);
      return ee ? (re.value = Z, ee.focus({ preventScroll: !0 }), ee.scrollIntoView({ block: "nearest" }), !0) : !1;
    }
    function q() {
      var H, Z;
      (Z = (H = p.value) == null ? void 0 : H.querySelector('[data-testid="sort-dropdown-back"]')) == null || Z.focus();
    }
    function N() {
      b(), Ge(() => {
        var H;
        return (H = M()) == null ? void 0 : H.focus();
      });
    }
    $e(
      d,
      (H) => {
        var Z;
        H && (T.value = null, S.value = "", re.value = 0, (Z = k.value) == null || Z.focusSearch());
      },
      { flush: "post" }
    );
    function G(H) {
      var ee;
      if (H.disabled) return;
      T.value = H.key;
      const Z = ((ee = t.sort) == null ? void 0 : ee.field) === H.key ? A.indexOf(t.sort.direction) : 0;
      re.value = Math.max(0, Z), Ge(q);
    }
    function U() {
      const H = T.value;
      T.value = null, Ge(() => {
        var ee;
        const Z = le.value.findIndex((J) => J.key === H);
        B(x.value, Math.max(0, Z)) || (ee = k.value) == null || ee.focusSearch();
      });
    }
    function K(H) {
      T.value && (a("update:sort", { field: T.value, direction: H }), N());
    }
    function ge(H) {
      d.value && (H.stopPropagation(), H.preventDefault(), N());
    }
    function xe(H) {
      H.target instanceof HTMLInputElement && P(H, le.value.length, x.value);
    }
    function X(H) {
      O(H, le.value.length, x.value);
    }
    function ie(H) {
      if (H.key === "ArrowLeft") {
        H.preventDefault(), U();
        return;
      }
      O(H, A.length, y.value);
    }
    const he = m(() => [
      { label: t.backLabel, icon: "ri-arrow-left-line", variant: "secondary", testId: "sort-dropdown-back" }
    ]);
    function oe(H) {
      return {
        tabindex: H === re.value ? 0 : -1,
        "data-listbox-index": H,
        onFocus: () => {
          re.value = H;
        }
      };
    }
    function Ce(H) {
      return {
        as: "button",
        role: "menuitem",
        label: H.label,
        icon: H.icon,
        ariaDisabled: !!H.disabled,
        description: H.disabled ? H.disabledReason : void 0,
        onClick: () => G(H)
      };
    }
    return (H, Z) => s.value ? (c(), g("div", {
      key: 0,
      ref_key: "dropdownRef",
      ref: u,
      class: "relative inline-block text-left dark:text-(--colors-text-white-default)",
      "data-testid": "sort-dropdown",
      onKeydown: ht(ge, ["escape"])
    }, [
      te(Me, {
        ref_key: "triggerRef",
        ref: h,
        "data-testid": "sort-dropdown-trigger",
        size: "xs",
        variant: "ghost",
        label: ne.value,
        "icon-left": e.triggerIconLeft,
        "dropdown-icon": !!ne.value,
        "icon-only": !ne.value,
        "aria-label": e.ariaLabel,
        "aria-expanded": L(d),
        "aria-haspopup": "dialog",
        onClick: L(f)
      }, null, 8, ["label", "icon-left", "dropdown-icon", "icon-only", "aria-label", "aria-expanded", "onClick"]),
      te(At, {
        "enter-active-class": "transition duration-100 ease-out motion-reduce:transition-none",
        "enter-from-class": "transform scale-95 opacity-0",
        "enter-to-class": "transform scale-100 opacity-100",
        "leave-active-class": "transition duration-75 ease-out motion-reduce:transition-none",
        "leave-from-class": "transform scale-100 opacity-100",
        "leave-to-class": "transform scale-95 opacity-0"
      }, {
        default: ve(() => [
          L(d) ? (c(), g("div", {
            key: 0,
            ref_key: "panelRef",
            ref: p,
            role: "dialog",
            "aria-label": e.headerLabel ?? e.ariaLabel,
            "data-testid": "sort-dropdown-panel",
            "data-step": D.value ? "directions" : "fields",
            class: C(["absolute top-full z-50 mt-1 flex max-h-105 w-80 max-w-[calc(100vw-32px)] flex-col overflow-hidden", [L(Za), e.align === "right" ? "right-0 origin-top-right" : "left-0 origin-top-left"]])
          }, [
            D.value ? (c(), g(de, { key: 0 }, [
              te(vl, {
                "label-left": D.value.label,
                class: "shrink-0"
              }, null, 8, ["label-left"]),
              v("div", p1, [
                v("div", {
                  ref_key: "directionMenuRef",
                  ref: y,
                  role: "menu",
                  "aria-label": e.directionsLabel,
                  class: "flex flex-col px-2 py-1.5",
                  "data-testid": "sort-dropdown-directions",
                  onKeydown: ie
                }, [
                  v("div", {
                    role: "group",
                    "aria-label": D.value.label,
                    class: "flex flex-col"
                  }, [
                    (c(), g(de, null, Re(A, (ee, J) => {
                      var F, _;
                      return te(en, Fe({ key: ee }, { ref_for: !0 }, oe(J), {
                        as: "button",
                        role: "menuitemradio",
                        "aria-checked": ((F = e.sort) == null ? void 0 : F.field) === D.value.key && e.sort.direction === ee,
                        "aria-label": D.value.directions[ee].ariaLabel,
                        label: D.value.directions[ee].label,
                        icon: I[ee],
                        selected: ((_ = e.sort) == null ? void 0 : _.field) === D.value.key && e.sort.direction === ee,
                        class: "shrink-0",
                        "data-testid": `sort-direction-${ee}`,
                        onClick: (ue) => K(ee)
                      }), null, 16, ["aria-checked", "aria-label", "label", "icon", "selected", "data-testid", "onClick"]);
                    }), 64))
                  ], 8, x1)
                ], 40, v1)
              ]),
              te(pl, {
                type: "button",
                buttons: he.value,
                class: "shrink-0",
                onButtonClick: U
              }, null, 8, ["buttons"])
            ], 64)) : (c(), g(de, { key: 1 }, [
              te(vl, {
                ref_key: "headerRef",
                ref: k,
                class: "shrink-0",
                "label-left": e.headerLabel,
                "show-search": "",
                "search-query": S.value,
                "search-placeholder": e.searchPlaceholder,
                "search-label": e.searchLabel ?? e.searchPlaceholder,
                onKeydown: xe,
                "onUpdate:searchQuery": Z[0] || (Z[0] = (ee) => S.value = ee)
              }, null, 8, ["label-left", "search-query", "search-placeholder", "search-label"]),
              v("div", y1, [
                le.value.length ? (c(), g("div", {
                  key: 0,
                  ref_key: "fieldMenuRef",
                  ref: x,
                  role: "menu",
                  "aria-label": e.headerLabel,
                  class: "flex min-h-0 flex-col",
                  "data-testid": "sort-dropdown-fields",
                  onKeydown: X
                }, [
                  z.value && e.sort ? (c(), g("div", {
                    key: 0,
                    role: "group",
                    "aria-labelledby": e.appliedSortLabel ? L($) : void 0,
                    class: "flex shrink-0 flex-col border-b border-(--border-border-base-soft) pt-2 pe-3 ps-2 pb-[calc(--spacing(2)-1px)] dark:border-(--colors-border-base)",
                    "data-testid": "sort-dropdown-applied"
                  }, [
                    e.appliedSortLabel ? (c(), g("span", {
                      key: 0,
                      id: L($),
                      class: "px-2 text-(length:--size-sm) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)",
                      "data-testid": "sort-dropdown-applied-heading"
                    }, j(e.appliedSortLabel), 9, C1)) : w("", !0),
                    te(en, Fe({ ...Ce(z.value), ...oe(0) }, {
                      type: "two-labels",
                      selected: "",
                      "secondary-icon": I[e.sort.direction],
                      "secondary-label": z.value.directions[e.sort.direction].label,
                      class: "shrink-0",
                      "data-testid": `sort-field-${z.value.key}`
                    }), null, 16, ["secondary-icon", "secondary-label", "data-testid"])
                  ], 8, w1)) : w("", !0),
                  Y.value.length ? (c(), g("div", S1, [
                    (c(!0), g(de, null, Re(Y.value, (ee, J) => (c(), W(en, Fe({
                      key: ee.key
                    }, { ref_for: !0 }, { ...Ce(ee), ...oe(z.value ? J + 1 : J) }, {
                      type: "two-icons",
                      class: "shrink-0",
                      "data-testid": `sort-field-${ee.key}`
                    }), null, 16, ["data-testid"]))), 128))
                  ])) : w("", !0)
                ], 40, k1)) : w("", !0),
                v("div", {
                  role: "status",
                  "aria-live": "polite",
                  class: C(le.value.length || !e.noResultsLabel ? "sr-only" : "px-4 py-6 text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"),
                  "data-testid": "sort-dropdown-status"
                }, j(le.value.length ? "" : e.noResultsLabel), 3)
              ])
            ], 64))
          ], 10, m1)) : w("", !0)
        ]),
        _: 1
      })
    ], 544)) : r.value ? (c(), g("div", {
      key: 1,
      class: "inline-flex items-center gap-1.5 px-3 py-2 text-(length:--size-m) text-(--colors-text-black-default) dark:text-(--colors-text-white-default)",
      "aria-label": e.ariaLabel,
      "data-testid": "sort-dropdown-static"
    }, [
      e.triggerIconLeft ? (c(), g(de, { key: 0 }, [
        i(e.triggerIconLeft) ? (c(), g("i", {
          key: 0,
          class: C([e.triggerIconLeft, "text-(length:--icon-size-sm) leading-(--icon-size-sm) size-(--icon-size-sm) inline-flex items-center justify-center"]),
          "aria-hidden": "true"
        }, null, 2)) : (c(), g("img", {
          key: 1,
          class: "relative h-4 w-4",
          src: e.triggerIconLeft,
          alt: ""
        }, null, 8, I1))
      ], 64)) : w("", !0),
      v("span", L1, j(l.value), 1)
    ], 8, $1)) : (c(), W(cn, {
      key: 2,
      label: l.value,
      "trigger-icon-left": e.triggerIconLeft,
      items: o.value,
      "menu-align": e.align,
      "selection-style": "check",
      "menu-header": e.headerLabel,
      "aria-label": e.ariaLabel,
      ghost: "",
      "data-testid": "sort-dropdown"
    }, null, 8, ["label", "trigger-icon-left", "items", "menu-align", "menu-header", "aria-label"]));
  }
}), T1 = { class: "flex flex-col gap-0.5 pb-0.5" }, A1 = {
  key: 0,
  class: "flex min-w-0 flex-1"
}, E1 = {
  key: 1,
  class: "inline-flex shrink-0"
}, R1 = {
  "data-field-controls": "",
  class: "ms-auto flex shrink-0 items-center gap-2"
}, B1 = ["aria-label"], Eg = /* @__PURE__ */ ye({
  __name: "MultipleSelect",
  props: {
    options: {},
    modelValue: { default: () => [] },
    draft: { default: void 0 },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    helpTooltip: { default: void 0 },
    placeholder: {},
    confirmLabel: {},
    seeAllLabel: { default: void 0 },
    seeAllThreshold: { default: 20 },
    searchPlaceholder: {},
    searchClearLabel: { default: "Clear search" },
    selectAllLabel: {},
    showSelectAll: { type: Boolean, default: !0 },
    clearAllLabel: {},
    removeChipLabel: {},
    emptyLabel: {},
    error: { default: void 0 },
    hint: { default: void 0 },
    success: { type: Boolean, default: !1 },
    size: { default: "md" },
    async: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    loadingLabel: { default: void 0 },
    selectAllResolver: { type: Function, default: void 0 },
    chipTheme: { default: "neutral" },
    totalCount: { default: void 0 },
    maxListHeight: { default: "252px" },
    footerLabel: { default: void 0 },
    freezeOnOpen: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    removeOnly: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "update:draft", "see-all", "search"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => t.async), r = qe(), o = m(() => `${r}-input`), i = m(() => t.label ? `${r}-label` : void 0), s = `${r}-error`, d = `${r}-hint`, u = m(() => !!t.error), f = m(() => {
      const Q = [];
      return t.hint && Q.push(d), u.value && Q.push(s), Q.length > 0 ? Q.join(" ") : void 0;
    }), b = m(
      () => t.options.filter((Q) => (t.modelValue ?? []).includes(Q.id))
    ), h = R([...t.modelValue ?? []]), p = R(!1), x = R(!1), y = (Q, ae) => Q.length === ae.length && Q.every((Te, Le) => Te === ae[Le]);
    $e(
      () => t.draft,
      (Q) => {
        Q && !y(Q, h.value) && (h.value = [...Q]);
      }
    ), $e(h, (Q) => {
      (!t.draft || !y(t.draft, Q)) && a("update:draft", [...Q]);
    });
    const k = () => {
      p.value = !0, h.value = [...t.modelValue ?? []];
    }, $ = () => {
      p.value = !1, h.value = [...t.modelValue ?? []];
    }, S = () => {
      a("update:modelValue", [...h.value]);
    }, T = R(null), I = R(null), A = m(() => t.size === "lg" || t.size === "xl" ? "lg" : "sm"), E = m(() => t.disabled || t.readonly), D = m(
      () => t.disabled ? "text-(--icons-icon-disabled-strong) dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
    );
    function z(Q) {
      Q.currentTarget.contains(Q.relatedTarget) || (x.value = !1);
    }
    const Y = R(null), le = () => {
      var Q;
      return ((Q = Y.value) == null ? void 0 : Q.$el) ?? null;
    }, ne = R(1 / 0), re = R(void 0);
    let O = null;
    const P = m(() => {
      const Q = ne.value === 1 / 0 ? b.value.length : Math.min(ne.value, b.value.length);
      return b.value.slice(0, Q);
    }), V = m(
      () => Math.max(0, b.value.length - P.value.length)
    ), M = async () => {
      ne.value = 1 / 0, await Ge();
      const Q = le();
      if (!Q || b.value.length === 0) {
        ne.value = b.value.length;
        return;
      }
      const ae = Array.from(Q.querySelectorAll("[data-badge-chip]"));
      if (!ae.length) {
        ne.value = b.value.length;
        return;
      }
      const Te = Q.getBoundingClientRect(), Le = getComputedStyle(Q), pe = parseFloat(Le.columnGap) || 0, ke = Q.querySelector("[data-field-controls]"), fe = (parseFloat(Le.paddingRight) || 0) + (ke ? ke.getBoundingClientRect().width + pe : 0), ze = 56, Ee = Te.right - fe;
      let He = ae.length;
      for (let Ke = 0; Ke < ae.length; Ke++) {
        const et = ae[Ke].getBoundingClientRect().right;
        if ((Ke === ae.length - 1 ? et : et + ze) > Ee) {
          He = Ke;
          break;
        }
      }
      ne.value = Math.max(He, 1);
    }, B = () => {
      const Q = le();
      Q && (re.value = `${Q.offsetWidth}px`);
    };
    ct(() => {
      O = new ResizeObserver(() => {
        B(), M();
      });
      const Q = le();
      Q && O.observe(Q), B(), M();
    }), kt(() => {
      O == null || O.disconnect(), clearTimeout(N);
    }), $e(
      () => t.modelValue,
      (Q) => {
        ne.value = 1 / 0, M(), p.value || (h.value = [...Q ?? []]);
      }
    );
    const q = R("");
    let N;
    $e(q, (Q) => {
      t.async && (clearTimeout(N), N = setTimeout(() => a("search", Q), 300));
    });
    const G = R(!1), U = m(() => t.loading || G.value), K = m(
      () => t.loading ? t.loadingLabel ?? t.emptyLabel : t.emptyLabel
    ), ge = m(() => t.options.filter((Q) => !Q.disabled)), xe = m(
      () => ge.value.length > 0 && ge.value.every((Q) => h.value.includes(Q.id))
    ), X = m(
      () => !xe.value && ge.value.some((Q) => h.value.includes(Q.id))
    ), ie = async () => {
      if (t.selectAllResolver) {
        G.value = !0;
        try {
          const Q = await t.selectAllResolver(), ae = new Set(Q);
          if (Q.length > 0 && Q.every((Le) => h.value.includes(Le)))
            h.value = h.value.filter((Le) => !ae.has(Le));
          else {
            const Le = new Set(h.value);
            Q.forEach((pe) => Le.add(pe)), h.value = Array.from(Le);
          }
        } catch {
        } finally {
          G.value = !1;
        }
        return;
      }
      if (xe.value)
        h.value = h.value.filter(
          (Q) => !ge.value.some((ae) => ae.id === Q)
        );
      else {
        const Q = new Set(h.value);
        ge.value.forEach((ae) => Q.add(ae.id)), h.value = Array.from(Q);
      }
    }, he = (Q) => {
      h.value.includes(Q) ? h.value = h.value.filter((ae) => ae !== Q) : h.value = [...h.value, Q];
    }, oe = () => {
      const Q = le();
      Q && Q !== document.activeElement && Q.contains(document.activeElement) && Q.focus();
    }, Ce = (Q) => {
      oe(), h.value = h.value.filter((ae) => ae !== Q), a(
        "update:modelValue",
        (t.modelValue ?? []).filter((ae) => ae !== Q)
      );
    }, H = (Q) => {
      Q.stopPropagation(), oe(), h.value = [], a("update:modelValue", []);
    }, Z = m(() => ({
      id: "__select-all__",
      label: t.selectAllLabel,
      hasCheckbox: !0,
      checked: xe.value,
      indeterminate: X.value,
      onClick: ie
    })), ee = m(() => [
      ...t.options.map((Q) => ({
        id: Q.id,
        label: Q.label,
        hasCheckbox: !0,
        checked: h.value.includes(Q.id),
        badgeTheme: Q.badgeTheme ?? t.chipTheme,
        badgeRightIcon: Q.badgeRightIcon,
        secondaryText: Q.secondaryText,
        disabled: Q.disabled,
        onClick: () => he(Q.id)
      }))
    ]), J = m(() => {
      const Q = [], ae = t.totalCount ?? t.options.length;
      return t.seeAllLabel && ae > (t.seeAllThreshold ?? 20) && Q.push({
        label: t.seeAllLabel,
        variant: "secondary",
        keepOpen: !0,
        onClick: () => a("see-all")
      }), Q.push({ label: t.confirmLabel, variant: "primary", onClick: S }), Q;
    }), F = (Q, ae, Te) => {
      var Le, pe;
      if (Q.key === "Escape" && Te) {
        Q.stopPropagation(), Q.preventDefault(), ae();
        return;
      }
      if (Te || ((Le = T.value) == null || Le.handleFieldKeydown(Q), (pe = I.value) == null || pe.handleFieldKeydown(Q)), Q.key === "Backspace" && Q.target === Q.currentTarget && !t.disabled && !t.readonly && b.value.length > 0) {
        const ke = b.value[b.value.length - 1];
        h.value = h.value.filter((fe) => fe !== ke.id), a(
          "update:modelValue",
          (t.modelValue ?? []).filter((fe) => fe !== ke.id)
        );
      }
    };
    let _ = !1;
    const ue = () => {
      _ = p.value;
    }, se = () => {
      var ae, Te;
      const Q = _;
      if (_ = !1, !t.disabled) {
        if (Q || t.removeOnly) {
          (ae = le()) == null || ae.focus();
          return;
        }
        (Te = le()) == null || Te.click();
      }
    };
    return (Q, ae) => (c(), g("div", T1, [
      e.label ? (c(), W(It, {
        key: 0,
        id: i.value,
        ref_key: "labelRef",
        ref: T,
        text: e.label,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.helpTooltip,
        focused: x.value,
        "test-id": "multiple-select-label",
        class: C(!e.disabled && !e.readonly && !e.removeOnly && "cursor-pointer"),
        onMousedown: ue,
        onClick: Je(se, ["stop"])
      }, null, 8, ["id", "text", "required", "required-indicator", "tooltip", "focused", "class"])) : w("", !0),
      te(L(ec), {
        "search-query": q.value,
        "onUpdate:searchQuery": ae[1] || (ae[1] = (Te) => q.value = Te),
        "aria-label": e.label || e.placeholder,
        items: ee.value,
        "sticky-item": e.showSelectAll ? Z.value : void 0,
        "show-search": !0,
        "search-placeholder": e.searchPlaceholder,
        "search-clear-label": e.searchClearLabel,
        "empty-label": K.value,
        "disable-internal-search-filter": l.value,
        "max-list-height": e.maxListHeight,
        "footer-buttons": J.value,
        "footer-label": e.footerLabel,
        "menu-width": re.value,
        "freeze-on-open": e.freezeOnOpen,
        class: "w-full",
        onOpen: k,
        onClose: $
      }, {
        trigger: ve(({ toggle: Te, isOpen: Le }) => [
          te(Vn, {
            id: o.value,
            ref_key: "shellRef",
            ref: Y,
            role: "combobox",
            "aria-expanded": Le,
            "aria-haspopup": "dialog",
            "aria-labelledby": i.value,
            "aria-label": e.label ? void 0 : e.ariaLabel,
            "aria-describedby": f.value,
            "aria-required": e.required ? "true" : void 0,
            "aria-invalid": u.value ? "true" : void 0,
            "aria-disabled": e.disabled ? "true" : void 0,
            "aria-readonly": e.readonly ? "true" : void 0,
            "aria-busy": U.value ? "true" : void 0,
            tabindex: e.disabled ? -1 : 0,
            tags: "",
            size: e.size,
            disabled: e.disabled,
            readonly: e.readonly || e.removeOnly,
            error: u.value,
            success: e.success,
            focused: Le,
            "focus-scope": "any",
            "has-value": b.value.length > 0,
            class: C(["w-full flex-nowrap! overflow-hidden focus:outline-none", !e.disabled && !e.readonly && !e.removeOnly && "cursor-pointer"]),
            onClick: (pe) => !e.disabled && !e.readonly && !e.removeOnly && Te(),
            onKeydown: [
              (pe) => F(pe, Te, Le),
              ht(Je((pe) => !e.disabled && !e.readonly && !e.removeOnly && Te(), ["self", "prevent"]), ["enter"]),
              ht(Je((pe) => !e.disabled && !e.readonly && !e.removeOnly && Te(), ["self", "prevent"]), ["space"])
            ],
            onFocusin: ae[0] || (ae[0] = (pe) => x.value = !0),
            onFocusout: z
          }, {
            default: ve(({ textClass: pe, iconBoxClass: ke }) => [
              b.value.length === 0 ? (c(), g("span", A1, [
                te(pt, {
                  text: e.placeholder,
                  focusable: !1,
                  "text-class": [pe, e.disabled ? "" : "text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"].join(" ")
                }, null, 8, ["text", "text-class"])
              ])) : w("", !0),
              (c(!0), g(de, null, Re(P.value, (fe) => (c(), g("div", {
                key: fe.id,
                "data-badge-chip": "",
                class: "inline-flex shrink-0"
              }, [
                te(L(gt), {
                  label: fe.label,
                  theme: e.disabled ? "disabled" : fe.badgeTheme ?? e.chipTheme,
                  "tooltip-text": fe.tooltipText,
                  "right-icon": fe.badgeRightIcon,
                  size: A.value,
                  truncate: "",
                  "truncation-focusable": !1,
                  "show-close-icon": "",
                  "close-icon-inactive": E.value,
                  "remove-label": e.removeChipLabel(fe.label),
                  onClose: (ze) => Ce(fe.id)
                }, null, 8, ["label", "theme", "tooltip-text", "right-icon", "size", "close-icon-inactive", "remove-label", "onClose"])
              ]))), 128)),
              V.value > 0 ? (c(), g("div", E1, [
                te(L(gt), {
                  label: `+${V.value}`,
                  theme: e.disabled ? "disabled" : e.chipTheme,
                  size: A.value,
                  "show-close-icon": !1
                }, null, 8, ["label", "theme", "size"])
              ])) : w("", !0),
              v("span", R1, [
                b.value.length > 0 && !e.disabled && !e.readonly ? (c(), g("button", {
                  key: 0,
                  type: "button",
                  class: C([
                    ke,
                    "relative cursor-pointer rounded-(--border-border-radius-rounded-xs) border-none bg-transparent p-0 text-(--text-text-body-subtle) transition-colors hover:text-(--text-text-black-default) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-hidden dark:text-(--colors-text-white-secondary) dark:hover:text-(--colors-text-white-default)",
                    "before:absolute before:top-1/2 before:left-1/2 before:size-6 before:-translate-x-1/2 before:-translate-y-1/2 before:content-['']"
                  ]),
                  "aria-label": e.clearAllLabel,
                  onClick: Je(H, ["stop"])
                }, [...ae[2] || (ae[2] = [
                  v("i", {
                    class: "ri-close-line",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, B1)) : w("", !0),
                e.removeOnly ? w("", !0) : (c(), g("i", {
                  key: 1,
                  class: C([
                    "ri-arrow-down-s-line transition-transform duration-200 ease-in-out motion-reduce:transition-none",
                    ke,
                    D.value
                  ]),
                  style: je({ transform: Le ? "rotate(180deg)" : "rotate(0deg)" }),
                  "aria-hidden": "true"
                }, null, 6))
              ])
            ]),
            _: 2
          }, 1032, ["id", "aria-expanded", "aria-labelledby", "aria-label", "aria-describedby", "aria-required", "aria-invalid", "aria-disabled", "aria-readonly", "aria-busy", "tabindex", "size", "disabled", "readonly", "error", "success", "focused", "has-value", "class", "onClick", "onKeydown"])
        ]),
        _: 1
      }, 8, ["search-query", "aria-label", "items", "sticky-item", "search-placeholder", "search-clear-label", "empty-label", "disable-internal-search-filter", "max-list-height", "footer-buttons", "footer-label", "menu-width", "freeze-on-open"]),
      te($t, {
        ref_key: "helperRef",
        ref: I,
        focused: x.value,
        hint: e.hint,
        error: e.error,
        "hint-id": d,
        "error-id": s,
        "test-id-prefix": "multiple-select"
      }, null, 8, ["focused", "hint", "error"])
    ]));
  }
}), M1 = ["aria-label"], D1 = { class: "w-full sm:w-56 sm:shrink-0" }, z1 = /* @__PURE__ */ ye({
  __name: "AccessRuleRow",
  props: {
    rule: {},
    position: {},
    options: {},
    labels: {},
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    disabledLevels: { default: () => [] },
    levelHint: { default: void 0 },
    removeOnly: { type: Boolean, default: !1 }
  },
  emits: ["update:userIds", "update:level", "remove", "search", "activate"],
  setup(e, { expose: n, emit: t }) {
    const a = t, l = R(null), r = () => {
      var i, s;
      (s = (i = l.value) == null ? void 0 : i.querySelector('[role="combobox"]')) == null || s.focus();
    }, o = (i) => {
      i && a("update:level", i);
    };
    return n({ focusPicker: r }), (i, s) => (c(), g("div", {
      role: "group",
      "aria-label": e.labels.ruleGroupLabel(e.position),
      "data-testid": "access-rule",
      class: "flex flex-col gap-3 sm:flex-row sm:items-start"
    }, [
      v("div", {
        ref_key: "pickerRef",
        ref: l,
        class: "min-w-0 flex-1",
        onFocusin: s[2] || (s[2] = (d) => a("activate"))
      }, [
        te(Eg, {
          "model-value": e.rule.userIds,
          options: e.options,
          label: e.labels.rulePeopleLabel,
          placeholder: e.labels.pickerPlaceholder,
          "confirm-label": e.labels.pickerConfirm,
          "search-placeholder": e.labels.pickerSearchPlaceholder,
          "select-all-label": e.labels.pickerSelectAll,
          "clear-all-label": e.labels.pickerClearAll,
          "remove-chip-label": e.labels.removeUser,
          "empty-label": e.labels.pickerEmpty,
          "loading-label": e.labels.pickerLoading,
          loading: e.loading,
          disabled: e.disabled,
          "remove-only": e.removeOnly,
          async: "",
          "onUpdate:modelValue": s[0] || (s[0] = (d) => a("update:userIds", d)),
          onSearch: s[1] || (s[1] = (d) => a("search", d))
        }, null, 8, ["model-value", "options", "label", "placeholder", "confirm-label", "search-placeholder", "select-all-label", "clear-all-label", "remove-chip-label", "empty-label", "loading-label", "loading", "disabled", "remove-only"])
      ], 544),
      v("div", D1, [
        te(Dd, {
          "model-value": e.rule.level,
          label: e.labels.ruleLevelLabel,
          levels: e.labels.levels,
          "disabled-levels": e.disabledLevels,
          hint: e.levelHint,
          disabled: e.disabled,
          "onUpdate:modelValue": o
        }, null, 8, ["model-value", "label", "levels", "disabled-levels", "hint", "disabled"])
      ]),
      te(Me, {
        variant: "secondary",
        size: "sm",
        "icon-only": "",
        "icon-left": "ri-delete-bin-line",
        "aria-label": e.labels.removeRule,
        disabled: e.disabled,
        class: "self-start sm:mt-5.5",
        "data-testid": "access-rule-remove",
        onClick: s[3] || (s[3] = (d) => a("remove"))
      }, null, 8, ["aria-label", "disabled"])
    ], 8, M1));
  }
}), zs = ["Edit", "View"];
function O1() {
  let e = 0;
  return () => `rule-${++e}`;
}
function If(e, n) {
  const t = /* @__PURE__ */ new Map();
  for (const { id: a, level: l } of e) {
    const r = t.get(a);
    (!r || zs.indexOf(l) < zs.indexOf(r)) && t.set(a, l);
  }
  return zs.map((a) => ({
    key: n(),
    level: a,
    userIds: [...t].filter(([, l]) => l === a).map(([l]) => l)
  })).filter((a) => a.userIds.length > 0);
}
function Lf(e) {
  const n = /* @__PURE__ */ new Set(), t = [];
  for (const a of e)
    for (const l of a.userIds)
      n.has(l) || (n.add(l), t.push({ id: l, level: a.level }));
  return t;
}
function Tf(e, n) {
  if (e.organization !== n.organization || e.users.length !== n.users.length) return !1;
  const t = new Map(e.users.map((a) => [a.id, a.level]));
  return n.users.every((a) => t.get(a.id) === a.level);
}
const P1 = {
  class: "flex flex-col gap-6",
  "data-testid": "access-settings"
}, F1 = ["aria-labelledby"], V1 = { class: "flex flex-col gap-1" }, N1 = ["id"], H1 = { class: "text-sm leading-5 font-normal text-text-black-default dark:text-(--colors-text-white-default)" }, j1 = { class: "grid grid-cols-1 gap-4 sm:grid-cols-2" }, W1 = { "data-testid": "access-organization" }, q1 = ["aria-labelledby", "aria-describedby"], U1 = { class: "flex flex-col gap-1" }, G1 = ["id"], K1 = { class: "text-sm leading-5 font-normal text-text-black-default dark:text-(--colors-text-white-default)" }, Y1 = { class: "text-sm leading-5 font-normal text-text-black-default dark:text-(--colors-text-white-default)" }, J1 = {
  "aria-live": "polite",
  "data-testid": "access-people-status"
}, X1 = ["id"], Z1 = {
  key: 0,
  class: "flex flex-col rounded-xl border border-(--border-border-base-soft) dark:border-(--colors-border-base)"
}, Q1 = { class: "self-start" }, _1 = ["tabindex"], GW = /* @__PURE__ */ ye({
  __name: "AccessSettings",
  props: {
    modelValue: {},
    userOptions: {},
    knownUsers: { default: () => [] },
    usersLoading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    showTeam: { type: Boolean, default: !0 },
    labels: {}
  },
  emits: ["update:modelValue", "search"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = qe(), r = qe(), o = qe(), i = O1(), s = R(If(t.modelValue.users, i));
    let d = null;
    const u = R(t.modelValue.organization), f = m(() => u.value === "Edit" ? ["Edit", "View"] : u.value === "View" ? ["View"] : []), b = m(() => u.value === "Edit"), h = m(() => u.value === "View" ? t.labels.viewWithoutEffect : void 0);
    $e(
      () => t.modelValue,
      (V) => {
        const M = { organization: u.value, users: Lf(s.value) };
        Tf(V, M) || (s.value = If(V.users, i), u.value = V.organization, d = null);
      },
      { deep: !0 }
    );
    const p = (V = u.value) => {
      const M = { organization: V, users: Lf(s.value) };
      Tf(M, d ?? t.modelValue) || (d = { organization: M.organization, users: M.users.map((B) => ({ ...B })) }, u.value = M.organization, a("update:modelValue", M));
    }, x = /* @__PURE__ */ new Map();
    let y = null, k = "";
    const $ = (V) => {
      V !== k && (k = V, a("search", V));
    }, S = (V, M) => {
      x.set(V, M), !(y !== null && y !== V) && (y = V, k = M, a("search", M));
    }, T = (V) => {
      y !== V && (y = V, $(x.get(V) ?? ""));
    }, I = R(/* @__PURE__ */ new Map());
    $e(
      () => [t.userOptions, t.knownUsers],
      ([V, M]) => {
        for (const B of [...V, ...M]) I.value.set(B.id, B);
      },
      { immediate: !0, deep: !0 }
    );
    const A = (V) => {
      const M = new Set(s.value.filter((q) => q.key !== V.key).flatMap((q) => q.userIds));
      return [.../* @__PURE__ */ new Set([...V.userIds, ...t.userOptions.map((q) => q.id)])].map((q) => {
        const N = I.value.get(q) ?? { name: q }, G = M.has(q), U = f.value.includes(V.level) && !V.userIds.includes(q);
        return {
          id: q,
          label: N.inactive ? t.labels.inactiveUser(N.name) : N.name,
          secondaryText: G ? t.labels.alreadyInOtherRule : N.secondaryText,
          disabled: G || U,
          // A warning colour, not the "disabled" theme: the chip stays removable, so its text must keep 4.5:1 contrast.
          badgeTheme: N.inactive ? "orange" : void 0
        };
      });
    }, E = /* @__PURE__ */ new Map(), D = (V) => (M) => {
      M ? E.set(V, M) : E.delete(V);
    }, z = R(null), Y = R(null), le = () => {
      var V, M;
      return (M = b.value ? z.value : (V = Y.value) == null ? void 0 : V.$el) == null ? void 0 : M.focus();
    }, ne = async () => {
      var M;
      const V = { key: i(), level: u.value === "View" ? "Edit" : "View", userIds: [] };
      s.value.push(V), T(V.key), await Ge(), (M = E.get(V.key)) == null || M.focusPicker();
    }, re = async (V) => {
      var q;
      const [M] = s.value.splice(V, 1);
      M && x.delete(M.key), p(), await Ge();
      const B = s.value[V - 1] ?? s.value[V];
      B ? (q = E.get(B.key)) == null || q.focusPicker() : le();
    }, O = (V, M) => {
      s.value[V].userIds = M, p();
    }, P = (V, M) => {
      s.value[V].level = M, p();
    };
    return (V, M) => (c(), g("div", P1, [
      v("section", {
        role: "group",
        "aria-labelledby": L(l),
        class: "flex flex-col gap-3"
      }, [
        v("div", V1, [
          v("p", {
            id: L(l),
            class: "text-base leading-5 font-bold text-text-black-default dark:text-(--colors-text-white-default)"
          }, j(e.labels.generalTitle), 9, N1),
          v("p", H1, j(e.labels.generalDescription), 1)
        ]),
        v("div", j1, [
          v("div", W1, [
            te(Dd, {
              "model-value": u.value,
              label: e.labels.organizationLabel,
              levels: e.labels.levels,
              disabled: e.disabled,
              "allow-none": "",
              "onUpdate:modelValue": M[0] || (M[0] = (B) => p(B))
            }, null, 8, ["model-value", "label", "levels", "disabled"])
          ]),
          e.showTeam ? (c(), W(mt, {
            key: 0,
            text: e.labels.teamUnavailableTooltip,
            role: "group",
            "aria-label": e.labels.teamLabel,
            "aria-disabled": "true",
            tabindex: "0",
            "data-testid": "access-team-row"
          }, {
            default: ve(() => [
              te(Dd, {
                "model-value": null,
                label: e.labels.teamLabel,
                levels: e.labels.levels,
                "allow-none": "",
                disabled: ""
              }, null, 8, ["label", "levels"])
            ]),
            _: 1
          }, 8, ["text", "aria-label"])) : w("", !0)
        ])
      ], 8, F1),
      v("section", {
        role: "group",
        "aria-labelledby": L(r),
        "aria-describedby": b.value ? L(o) : void 0,
        class: "flex flex-col gap-3"
      }, [
        v("div", U1, [
          v("p", {
            id: L(r),
            class: "text-base leading-5 font-bold text-text-black-default dark:text-(--colors-text-white-default)"
          }, j(e.labels.peopleTitle), 9, G1),
          v("p", K1, j(e.labels.peopleDescription), 1),
          v("p", Y1, j(e.labels.groupingHint), 1),
          v("div", J1, [
            b.value ? (c(), g("p", {
              key: 0,
              id: L(o),
              class: "text-sm leading-5 font-medium text-text-black-default dark:text-(--colors-text-white-default)",
              "data-testid": "access-people-without-effect"
            }, j(e.labels.peopleWithoutEffect), 9, X1)) : w("", !0)
          ])
        ]),
        s.value.length > 0 ? (c(), g("div", Z1, [
          (c(!0), g(de, null, Re(s.value, (B, q) => (c(), W(z1, {
            key: B.key,
            ref_for: !0,
            ref: D(B.key),
            class: "border-t border-(--border-border-base-soft) p-4 first:border-t-0 dark:border-(--colors-border-base)",
            rule: B,
            position: q + 1,
            options: A(B),
            "disabled-levels": f.value,
            "level-hint": h.value,
            "remove-only": b.value,
            labels: e.labels,
            loading: e.usersLoading,
            disabled: e.disabled,
            "onUpdate:userIds": (N) => O(q, N),
            "onUpdate:level": (N) => P(q, N),
            onRemove: (N) => re(q),
            onSearch: (N) => S(B.key, N),
            onActivate: (N) => T(B.key)
          }, null, 8, ["rule", "position", "options", "disabled-levels", "level-hint", "remove-only", "labels", "loading", "disabled", "onUpdate:userIds", "onUpdate:level", "onRemove", "onSearch", "onActivate"]))), 128))
        ])) : w("", !0),
        v("div", Q1, [
          te(mt, {
            text: e.labels.peopleWithoutEffect,
            disabled: !b.value
          }, {
            default: ve(() => [
              v("span", {
                ref_key: "addRuleStop",
                ref: z,
                class: "inline-flex rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royalblue focus-visible:ring-offset-2",
                tabindex: b.value ? 0 : void 0,
                "data-testid": "access-add-rule-stop"
              }, [
                te(Me, {
                  ref_key: "addRuleButton",
                  ref: Y,
                  variant: "secondary",
                  size: "sm",
                  "icon-left": "ri-add-line",
                  label: e.labels.addRule,
                  disabled: e.disabled || b.value,
                  "data-testid": "access-add-rule",
                  onClick: ne
                }, null, 8, ["label", "disabled"])
              ], 8, _1)
            ]),
            _: 1
          }, 8, ["text", "disabled"])
        ])
      ], 8, q1)
    ]));
  }
}), KW = /* @__PURE__ */ ye({
  __name: "WeekNavigator",
  props: {
    weekStartDate: {},
    weekEndDate: {},
    locale: { default: "en" },
    previousLabel: { default: "Previous week" },
    nextLabel: { default: "Next week" },
    todayLabel: { default: "Today" },
    previousDisabled: { type: Boolean, default: !1 },
    todayDisabled: { type: Boolean, default: !1 },
    previousDisabledReason: { default: void 0 },
    todayDisabledReason: { default: void 0 },
    showToday: { type: Boolean, default: !0 },
    fullWidth: { type: Boolean, default: !1 }
  },
  emits: ["previous-week", "next-week", "today-week"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => {
      const r = new Intl.DateTimeFormat(t.locale, {
        day: "numeric",
        month: "long",
        timeZone: "UTC"
      }), o = new Intl.DateTimeFormat(t.locale, {
        day: "numeric",
        month: "long",
        ...t.fullWidth ? { year: "numeric" } : {},
        timeZone: "UTC"
      }), i = r.format(/* @__PURE__ */ new Date(`${t.weekStartDate}T00:00:00Z`)), s = o.format(/* @__PURE__ */ new Date(`${t.weekEndDate}T00:00:00Z`));
      return `${i} - ${s}`;
    });
    return (r, o) => (c(), g("div", {
      class: C(["flex flex-wrap items-center gap-(--spacing-2)", e.fullWidth ? "w-full" : void 0])
    }, [
      e.showToday ? (c(), W(mt, {
        key: 0,
        text: e.todayDisabledReason ?? "",
        disabled: !e.todayDisabled || !e.todayDisabledReason,
        tabindex: e.todayDisabled && e.todayDisabledReason ? 0 : void 0
      }, {
        default: ve(() => [
          te(Me, {
            variant: "secondary",
            size: "sm",
            label: e.todayLabel,
            disabled: e.todayDisabled,
            "data-testid": "week-navigator-today",
            onClick: o[0] || (o[0] = (i) => a("today-week"))
          }, null, 8, ["label", "disabled"])
        ]),
        _: 1
      }, 8, ["text", "disabled", "tabindex"])) : w("", !0),
      v("div", {
        class: C(["flex items-center gap-(--spacing-2)", e.fullWidth ? "w-full justify-between" : void 0])
      }, [
        te(mt, {
          text: e.previousDisabledReason ?? "",
          disabled: !e.previousDisabled || !e.previousDisabledReason,
          tabindex: e.previousDisabled && e.previousDisabledReason ? 0 : void 0
        }, {
          default: ve(() => [
            te(Me, {
              variant: "ghost",
              size: e.fullWidth ? "md" : "sm",
              "icon-only": "",
              "icon-left": "ri-arrow-left-line",
              "aria-label": e.previousLabel,
              disabled: e.previousDisabled,
              onClick: o[1] || (o[1] = (i) => a("previous-week"))
            }, null, 8, ["size", "aria-label", "disabled"])
          ]),
          _: 1
        }, 8, ["text", "disabled", "tabindex"]),
        v("p", {
          "aria-live": "polite",
          class: C([
            "font-(--weight-semi-bold)",
            e.fullWidth ? "flex-1 text-center text-(length:--size-xl) leading-(--line-height-xl)" : "text-(length:--size-m)"
          ])
        }, j(l.value), 3),
        te(Me, {
          variant: "ghost",
          size: e.fullWidth ? "md" : "sm",
          "icon-only": "",
          "icon-right": "ri-arrow-right-line",
          "aria-label": e.nextLabel,
          onClick: o[2] || (o[2] = (i) => a("next-week"))
        }, null, 8, ["size", "aria-label"])
      ], 2)
    ], 2));
  }
}), e2 = {
  "data-testid": "metric-card-simple",
  class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex flex-col items-center p-num-24 box-border gap-2"
}, t2 = { class: "relative leading-num-29 text-[24px] text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, n2 = { class: "relative text-num-16 leading-6 text-text-body dark:text-[var(--colors-text-white-secondary)]" }, YW = /* @__PURE__ */ ye({
  __name: "MetricCardSimple",
  props: {
    value: { default: "" },
    label: { default: "" },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", e2, [
      e.loading ? (c(), g(de, { key: 0 }, [
        t[0] || (t[0] = v("div", { class: "skeleton h-[29px] w-24" }, null, -1)),
        t[1] || (t[1] = v("div", { class: "skeleton h-6 w-40" }, null, -1))
      ], 64)) : (c(), g(de, { key: 1 }, [
        v("b", t2, j(e.value), 1),
        v("div", n2, j(e.label), 1)
      ], 64))
    ]));
  }
}), a2 = {
  "data-testid": "metric-card-with-icon",
  class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex items-center p-num-24 box-border gap-3.5"
}, l2 = { class: "h-16 w-[63.9px] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border box-border flex items-center justify-center" }, r2 = ["src", "alt"], o2 = { class: "flex flex-col items-start gap-2" }, i2 = { class: "relative leading-num-29 text-[24px] text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, s2 = { class: "relative text-num-16 leading-6 text-slategray dark:text-[var(--colors-text-white-secondary)]" }, JW = /* @__PURE__ */ ye({
  __name: "MetricCardWithIcon",
  props: {
    value: { default: "" },
    label: { default: "" },
    icon: { default: void 0 },
    iconAlt: { default: "" },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", a2, [
      e.loading ? (c(), g(de, { key: 0 }, [
        t[0] || (t[0] = v("div", { class: "skeleton h-16 w-[63.9px] rounded-num-12" }, null, -1)),
        t[1] || (t[1] = v("div", { class: "flex flex-col items-start gap-2 flex-1" }, [
          v("div", { class: "skeleton h-[29px] w-24" }),
          v("div", { class: "skeleton h-6 w-40" })
        ], -1))
      ], 64)) : (c(), g(de, { key: 1 }, [
        v("div", l2, [
          Ae(n.$slots, "icon", {}, () => [
            e.icon ? (c(), g("img", {
              key: 0,
              src: e.icon,
              alt: e.iconAlt,
              class: "h-9 w-9 relative"
            }, null, 8, r2)) : w("", !0)
          ])
        ]),
        v("div", o2, [
          v("b", i2, j(e.value), 1),
          v("div", s2, j(e.label), 1)
        ])
      ], 64))
    ]));
  }
}), d2 = { class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex flex-col items-center p-num-24 box-border gap-3" }, u2 = { class: "flex flex-col items-center gap-2" }, c2 = { class: "relative leading-num-29 text-[24px] text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, f2 = { class: "relative text-num-16 leading-6 text-text-body dark:text-[var(--colors-text-white-secondary)]" }, h2 = { class: "rounded-sm bg-honeydew dark:bg-[var(--colors-background-success)] flex items-center justify-center py-0.5 px-1 gap-1 text-center text-[12px]" }, b2 = ["src"], g2 = { class: "relative leading-num-20 font-medium dark:text-[var(--colors-text-success-strong)]" }, XW = /* @__PURE__ */ ye({
  __name: "MetricCardWithTrend",
  props: {
    value: { default: "" },
    label: { default: "" },
    trendText: { default: "" },
    trendIcon: { default: void 0 },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", d2, [
      e.loading ? (c(), g(de, { key: 0 }, [
        t[0] || (t[0] = v("div", { class: "flex flex-col items-center gap-2" }, [
          v("div", { class: "skeleton h-[29px] w-24" }),
          v("div", { class: "skeleton h-6 w-40" })
        ], -1)),
        t[1] || (t[1] = v("div", { class: "skeleton h-5 w-32 rounded-sm" }, null, -1))
      ], 64)) : (c(), g(de, { key: 1 }, [
        v("div", u2, [
          v("b", c2, j(e.value), 1),
          v("div", f2, j(e.label), 1)
        ]),
        v("div", h2, [
          Ae(n.$slots, "trend-icon", {}, () => [
            e.trendIcon ? (c(), g("img", {
              key: 0,
              src: e.trendIcon,
              alt: "trend",
              class: "h-3 w-3 relative"
            }, null, 8, b2)) : w("", !0)
          ]),
          v("div", g2, j(e.trendText), 1)
        ])
      ], 64))
    ]));
  }
}), m2 = {
  "data-testid": "metric-card-with-badge",
  class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex flex-col items-start justify-center p-num-24 box-border gap-2 relative"
}, p2 = { class: "relative leading-num-29 text-[24px] text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter z-0" }, v2 = { class: "relative text-num-16 leading-6 text-slategray dark:text-[var(--colors-text-white-secondary)] z-1" }, x2 = {
  key: 0,
  class: "absolute top-[10px] right-[11px] rounded-sm bg-honeydew dark:bg-[var(--colors-background-success)] flex items-center justify-center py-0.5 px-1 z-2 text-center text-[12px]"
}, y2 = { class: "relative leading-num-20 font-medium dark:text-[var(--colors-text-success-strong)]" }, ZW = /* @__PURE__ */ ye({
  __name: "MetricCardWithBadge",
  props: {
    value: { default: "" },
    label: { default: "" },
    badgeText: { default: "" },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", m2, [
      e.loading ? (c(), g(de, { key: 0 }, [
        t[0] || (t[0] = v("div", { class: "skeleton h-[29px] w-24" }, null, -1)),
        t[1] || (t[1] = v("div", { class: "skeleton h-6 w-40" }, null, -1)),
        t[2] || (t[2] = v("div", { class: "skeleton h-5 w-12 rounded-sm absolute top-[10px] right-[11px]" }, null, -1))
      ], 64)) : (c(), g(de, { key: 1 }, [
        v("b", p2, j(e.value), 1),
        v("div", v2, j(e.label), 1),
        e.badgeText ? (c(), g("div", x2, [
          v("div", y2, j(e.badgeText), 1)
        ])) : w("", !0)
      ], 64))
    ]));
  }
}), k2 = { class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex items-center p-num-24 box-border text-num-16 text-slategray dark:text-[var(--colors-text-white-secondary)]" }, w2 = {
  key: 0,
  class: "flex-1 flex flex-col items-start gap-3"
}, C2 = {
  key: 1,
  class: "flex-1 flex flex-col items-start gap-3"
}, S2 = { class: "flex items-center gap-2" }, $2 = ["src"], I2 = { class: "relative leading-6 dark:text-[var(--colors-text-white-secondary)]" }, L2 = { class: "relative text-[24px] leading-num-29 text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, T2 = { class: "flex items-center gap-2 text-[14px] text-text-success dark:text-[var(--colors-text-success-subtle)]" }, A2 = { class: "flex items-center justify-end" }, E2 = ["src"], R2 = { class: "relative leading-num-20 font-medium" }, B2 = { class: "relative leading-num-20 text-dimgray dark:text-[var(--colors-text-white-secondary)]" }, QW = /* @__PURE__ */ ye({
  __name: "MetricCardWithChart",
  props: {
    title: { default: "" },
    value: { default: "" },
    trendValue: { default: "" },
    trendLabel: { default: "" },
    chartIcon: { default: void 0 },
    trendIcon: { default: void 0 },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", k2, [
      e.loading ? (c(), g("div", w2, [...t[0] || (t[0] = [
        co('<div class="flex items-center gap-2"><div class="skeleton h-5 w-5 rounded"></div><div class="skeleton h-6 w-28"></div></div><div class="skeleton h-[29px] w-32"></div><div class="flex items-center gap-2"><div class="skeleton h-5 w-16"></div><div class="skeleton h-5 w-24"></div></div>', 3)
      ])])) : (c(), g("div", C2, [
        v("div", S2, [
          Ae(n.$slots, "chart-icon", {}, () => [
            e.chartIcon ? (c(), g("img", {
              key: 0,
              src: e.chartIcon,
              alt: "chart",
              class: "h-5 w-5 relative"
            }, null, 8, $2)) : w("", !0)
          ]),
          v("div", I2, j(e.title), 1)
        ]),
        v("b", L2, j(e.value), 1),
        v("div", T2, [
          v("div", A2, [
            Ae(n.$slots, "trend-icon", {}, () => [
              e.trendIcon ? (c(), g("img", {
                key: 0,
                src: e.trendIcon,
                alt: "trend",
                class: "h-4 w-4 relative"
              }, null, 8, E2)) : w("", !0)
            ]),
            v("div", R2, j(e.trendValue), 1)
          ]),
          v("div", B2, j(e.trendLabel), 1)
        ])
      ]))
    ]));
  }
}), M2 = {
  class: "flex flex-col justify-center gap-6 rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-soft) bg-(--colors-background-white) p-6 shadow-(--blur-shadow-s) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)]",
  "data-testid": "metric-card-progress"
}, D2 = { class: "flex flex-col gap-2" }, z2 = {
  class: "text-base leading-6 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)",
  "data-testid": "metric-card-progress-title"
}, O2 = { class: "flex items-end gap-2" }, P2 = {
  class: "text-2xl leading-[29px] font-bold text-(--colors-text-heading) dark:text-(--colors-text-white-default)",
  "data-testid": "metric-card-progress-value"
}, F2 = {
  key: 0,
  class: "text-sm leading-5 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)",
  "data-testid": "metric-card-progress-target"
}, V2 = { class: "flex flex-col gap-1.5" }, N2 = ["aria-label", "aria-valuenow", "aria-valuetext"], H2 = {
  key: 0,
  class: "flex items-center justify-between gap-2"
}, j2 = {
  class: "text-sm leading-5 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)",
  "data-testid": "metric-card-progress-label"
}, _W = /* @__PURE__ */ ye({
  __name: "MetricCardProgress",
  props: {
    title: { default: "" },
    value: { default: "" },
    target: { default: void 0 },
    used: { default: 0 },
    total: { default: 0 },
    unit: { default: "" },
    loading: { type: Boolean, default: !1 },
    progressFormat: { type: Function, default: void 0 },
    progressLabel: { default: void 0 }
  },
  setup(e) {
    const n = e, t = m(() => n.total <= 0 ? 0 : Math.min(Math.max(n.used / n.total * 100, 0), 100)), a = m(() => n.progressLabel !== void 0 ? n.progressLabel : n.total <= 0 || !n.progressFormat ? "" : n.progressFormat(n.used, n.total, n.unit));
    return (l, r) => (c(), g("div", M2, [
      e.loading ? (c(), g(de, { key: 0 }, [
        r[0] || (r[0] = co('<div class="flex flex-col gap-2"><div class="skeleton h-6 w-32"></div><div class="skeleton h-[29px] w-24"></div></div><div class="flex flex-col gap-1.5"><div class="skeleton h-2.5 w-full rounded-full"></div><div class="skeleton h-5 w-40"></div></div>', 2))
      ], 64)) : (c(), g(de, { key: 1 }, [
        v("div", D2, [
          v("span", z2, j(e.title), 1),
          v("div", O2, [
            v("b", P2, j(e.value), 1),
            e.target ? (c(), g("span", F2, "/ " + j(e.target), 1)) : w("", !0)
          ])
        ]),
        v("div", V2, [
          v("div", {
            class: "h-2.5 w-full overflow-hidden rounded-full bg-(--colors-background-gray)",
            role: "progressbar",
            "aria-label": e.title || void 0,
            "aria-valuemin": 0,
            "aria-valuemax": 100,
            "aria-valuenow": e.total > 0 ? t.value : void 0,
            "aria-valuetext": a.value || void 0
          }, [
            v("div", {
              class: "h-full rounded-full transition-[width] duration-300",
              style: je({
                width: `${t.value}%`,
                backgroundImage: "var(--gradient-brand-horizontal)"
              })
            }, null, 4)
          ], 8, N2),
          a.value || l.$slots.trend ? (c(), g("div", H2, [
            v("span", j2, j(a.value), 1),
            Ae(l.$slots, "trend")
          ])) : w("", !0)
        ])
      ], 64))
    ]));
  }
}), W2 = { class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex flex-col items-start p-num-24 box-border text-num-16 text-slategray dark:text-[var(--colors-text-white-secondary)]" }, q2 = {
  key: 0,
  class: "self-stretch flex flex-col items-start gap-2"
}, U2 = {
  key: 1,
  class: "self-stretch flex flex-col items-start gap-2"
}, G2 = { class: "self-stretch flex items-center justify-between gap-5" }, K2 = { class: "flex items-center gap-1.5" }, Y2 = { class: "relative leading-6 dark:text-[var(--colors-text-white-secondary)]" }, J2 = ["src"], X2 = { class: "relative text-[24px] leading-num-29 text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, Z2 = { class: "relative leading-6 text-text-body dark:text-[var(--colors-text-white-secondary)]" }, eq = /* @__PURE__ */ ye({
  __name: "MetricCardAction",
  props: {
    title: { default: "" },
    value: { default: "" },
    subtitle: { default: "" },
    actionText: { default: "" },
    dropdownIcon: { default: void 0 },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["action"],
  setup(e) {
    return (n, t) => (c(), g("div", W2, [
      e.loading ? (c(), g("div", q2, [...t[1] || (t[1] = [
        co('<div class="self-stretch flex items-center justify-between gap-5"><div class="skeleton h-6 w-24"></div><div class="skeleton h-8 w-16 rounded"></div></div><div class="skeleton h-[29px] w-32"></div><div class="skeleton h-6 w-40"></div>', 3)
      ])])) : (c(), g("div", U2, [
        v("div", G2, [
          v("div", K2, [
            v("div", Y2, j(e.title), 1),
            Ae(n.$slots, "dropdown-icon", {}, () => [
              e.dropdownIcon ? (c(), g("img", {
                key: 0,
                src: e.dropdownIcon,
                alt: "dropdown",
                class: "h-[18px] w-[18px] relative"
              }, null, 8, J2)) : w("", !0)
            ])
          ]),
          e.actionText ? (c(), W(L(Me), {
            key: 0,
            variant: "secondary",
            label: e.actionText,
            size: "sm",
            onClick: t[0] || (t[0] = (a) => n.$emit("action"))
          }, null, 8, ["label"])) : w("", !0)
        ]),
        v("b", X2, j(e.value), 1),
        v("div", Z2, j(e.subtitle), 1)
      ]))
    ]));
  }
}), Rg = Symbol("FieldBelow"), tc = (e) => e.some((n) => n.type === Au ? !1 : n.type === Tx ? typeof n.children == "string" && n.children.trim() !== "" : n.type === de ? Array.isArray(n.children) && tc(n.children) : !0), Q2 = new Proxy({}, { get: () => {
} });
function tn() {
  const e = Hn();
  return (n) => {
    var t;
    return !!((t = e[n]) != null && t.call(e, Q2).some((a) => a.type !== Au));
  };
}
const za = {
  sm: {
    addon: "pl-[calc(--spacing(2)-1px)] pr-[calc(--spacing(2)-1px)]",
    input: "pl-[calc(--spacing(2))]",
    inputEnd: "pr-[calc(--spacing(2)-1px)]"
  },
  md: {
    addon: "pl-[calc(--spacing(2.5)-1px)] pr-[calc(--spacing(2.5)-1px)]",
    input: "pl-[calc(--spacing(2.5))]",
    inputEnd: "pr-[calc(--spacing(2.5)-1px)]"
  },
  lg: {
    addon: "pl-[calc(--spacing(3)-1px)] pr-[calc(--spacing(3)-1px)]",
    input: "pl-[calc(--spacing(3))]",
    inputEnd: "pr-[calc(--spacing(3)-1px)]"
  },
  xl: {
    addon: "pl-[calc(--spacing(3.5)-1px)] pr-[calc(--spacing(3.5)-1px)]",
    input: "pl-[calc(--spacing(3.5))]",
    inputEnd: "pr-[calc(--spacing(3.5)-1px)]"
  }
}, _2 = ["id", "name", "type", "value", "placeholder", "disabled", "readonly", "inputmode", "autocomplete", "pattern", "maxlength", "minlength", "min", "max", "aria-labelledby", "aria-label", "aria-disabled", "aria-invalid", "aria-describedby", "aria-required"], eC = ["aria-label", "onKeydown"], tC = {
  key: 0,
  class: "shrink-0"
}, nC = /* @__PURE__ */ ye({
  __name: "TextInput",
  props: {
    placeholder: { default: void 0 },
    modelValue: { default: "" },
    iconLeft: { default: void 0 },
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    success: { type: Boolean, default: !1 },
    labels: { default: () => ({ clear: "Clear input" }) },
    type: { default: "text" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    label: { default: void 0 },
    labelTooltip: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelInline: { type: Boolean, default: !1 },
    ariaLabel: { default: void 0 },
    inputmode: { default: void 0 },
    autocomplete: { default: "off" },
    pattern: { default: void 0 },
    maxlength: { default: void 0 },
    minlength: { default: void 0 },
    min: { default: void 0 },
    max: { default: void 0 },
    error: { default: void 0 },
    hint: { default: void 0 },
    ariaDescribedby: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    readonlyChrome: { type: Boolean, default: !0 },
    valueVariant: { default: "default" },
    showEditIcon: { type: Boolean, default: !0 },
    variant: { default: "default" },
    buttons: { default: () => [] },
    buttonLayout: { default: "attached" },
    buttonSize: { default: void 0 },
    innerButton: { default: void 0 },
    prefix: { default: void 0 },
    removeButton: { default: void 0 }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "clear", "keydown", "button-click"],
  setup(e, { emit: n }) {
    const t = e, a = (Z, { slots: ee }) => {
      var J;
      return (J = ee.default) == null ? void 0 : J.call(ee);
    }, l = n, r = R(!1), o = R(null), i = R(null), s = R(null), d = Hn(), u = tn(), f = m(() => u("actions")), b = Kt(Rg, null), h = m(() => (b == null ? void 0 : b()) ?? null), p = m(() => t.modelValue !== void 0 && t.modelValue !== null && t.modelValue.trim() !== ""), x = m(() => !!t.error), y = qe(), k = m(() => t.id || y), $ = m(() => t.label ? `${k.value}-label` : void 0), S = m(() => `${k.value}-error`), T = m(() => `${k.value}-hint`), I = m(() => {
      if (t.ariaDescribedby) return t.ariaDescribedby;
      const Z = [];
      return t.hint && T.value && Z.push(T.value), x.value && S.value && Z.push(S.value), Z.length > 0 ? Z.join(" ") : void 0;
    }), A = m(() => x.value ? "true" : void 0), E = m(() => t.valueVariant === "link" ? "text-(--text-text-link) font-(--weight-semi-bold)" : ""), D = (Z) => t.showEditIcon && Z && !r.value && !t.disabled && !t.readonly, z = m(() => r.value && p.value && !t.disabled && !t.readonly), Y = m(() => t.fullWidth || t.width === void 0), le = m(() => Y.value ? "w-full" : ""), ne = m(() => Y.value ? {} : { width: t.width }), re = m(
      () => t.buttons.length > 0 && t.labelInline ? { style: ne.value } : {}
    ), O = m(() => t.buttons.length > 0), P = m(
      () => nr(t.labelInline, !!t.label && !U.value, !!t.removeButton)
    ), V = m(() => t.removeButton && Xu(t.removeButton)), M = R(null), { inGroup: B, groupPart: q } = Qu(M), N = m(() => `${`relative min-w-0 ${B ? q.value.part : "pb-0.5"} text-left text-(length:--size-m) text-(--text-text-black-default) dark:text-(--colors-text-white-default) font-inter`} ${P.value.root}${Y.value ? " w-full" : ""}`), G = m(() => Y.value || t.labelInline ? {} : { width: t.width }), U = m(() => t.variant === "stacked"), K = m(() => !!t.prefix && !U.value), ge = m(() => {
      if (U.value)
        return { class: "relative flex w-full min-w-0 items-center justify-center gap-0.5 px-6" };
      if (K.value) {
        const Z = za[t.size];
        return {
          class: [
            "flex h-full min-w-0 flex-1 items-center gap-2",
            Z.input,
            t.innerButton ? "" : Z.inputEnd
          ]
        };
      }
      return null;
    }), xe = m(() => t.disabled ? "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : !t.readonly && !x.value && !t.success && !r.value && !p.value ? "text-(--text-text-heading) dark:text-(--colors-text-white-default)" : "text-(--text-text-black-default) dark:text-(--colors-text-white-default)"), X = (Z) => {
      var _;
      if (!U.value || t.disabled) return;
      const ee = Z.target;
      if (ee === o.value) return;
      const J = Z.currentTarget, F = ee == null ? void 0 : ee.closest('button, a, [role="button"], input, select, textarea, [tabindex]');
      F && F !== J && J.contains(F) || (Z.preventDefault(), (_ = o.value) == null || _.focus());
    }, ie = (Z) => {
      const ee = Z.target;
      l("update:modelValue", ee.value), l("input", Z);
    }, he = (Z) => {
      var ee;
      t.disabled || (r.value = !0, (ee = Z.target) == null || ee.select()), l("focus", Z);
    }, oe = (Z) => {
      r.value = !1, l("blur", Z);
    }, Ce = (Z) => {
      var ee, J;
      l("keydown", Z), (ee = i.value) == null || ee.handleFieldKeydown(Z), (J = s.value) == null || J.handleFieldKeydown(Z);
    }, H = () => {
      l("update:modelValue", ""), l("clear");
    };
    return (Z, ee) => (c(), g("div", {
      ref_key: "rootRef",
      ref: M,
      class: C(N.value),
      style: je(G.value)
    }, [
      e.label && !U.value ? (c(), W(It, {
        key: 0,
        id: $.value,
        ref_key: "labelRef",
        ref: i,
        text: e.label,
        "input-id": k.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: r.value,
        inline: e.labelInline,
        class: C(P.value.label),
        "test-id": "text-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline", "class"])) : w("", !0),
      v("div", {
        class: C(["flex items-end gap-3 w-full", P.value.field])
      }, [
        te(bo, Fe({
          buttons: e.buttons,
          layout: e.buttonLayout,
          size: e.size,
          disabled: e.disabled,
          "button-size": e.buttonSize
        }, re.value, {
          onButtonClick: ee[2] || (ee[2] = (J) => l("button-click", J))
        }), {
          default: ve(({ fieldClass: J }) => [
            te(Vn, {
              size: e.size,
              stacked: U.value,
              flush: K.value,
              "inner-button": !!e.innerButton,
              disabled: e.disabled,
              readonly: e.readonly && e.readonlyChrome,
              error: x.value,
              success: e.success,
              "has-value": p.value,
              class: C([
                e.disabled && e.valueVariant === "link" ? "cursor-pointer" : "",
                O.value ? "w-full" : le.value,
                !O.value && f.value ? "flex-1 min-w-0" : "",
                J || L(q).corners
              ]),
              style: je(O.value || f.value ? {} : ne.value),
              onMousedown: X
            }, {
              default: ve(({
                hovered: F,
                iconBoxClass: _,
                leftIconBoxClass: ue,
                iconColorClass: se,
                textClass: Q,
                topTextClass: ae,
                borderColorClass: Te,
                addonTextClass: Le
              }) => [
                U.value && e.label ? (c(), W(It, {
                  key: 0,
                  id: $.value,
                  ref_key: "labelRef",
                  ref: i,
                  text: e.label,
                  "input-id": k.value,
                  required: e.required,
                  "required-indicator": e.requiredIndicator,
                  focused: r.value,
                  "text-class": `${ae} ${xe.value}`,
                  "test-id": "text-input-label"
                }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "focused", "text-class"])) : w("", !0),
                K.value ? (c(), g("span", {
                  key: 1,
                  "data-testid": "text-input-prefix",
                  class: C([
                    "flex shrink-0 select-none items-center gap-2 self-stretch border-r",
                    L(za)[e.size].addon,
                    "text-(length:--size-m) leading-(--line-height-l)",
                    Te,
                    Le
                  ])
                }, [
                  e.iconLeft ? (c(), g("i", {
                    key: 0,
                    class: C([e.iconLeft, ue, se])
                  }, null, 2)) : w("", !0),
                  nt(" " + j(e.prefix), 1)
                ], 2)) : w("", !0),
                (c(), W(it(ge.value ? "div" : a), an(sn(ge.value ?? {})), {
                  default: ve(() => [
                    e.iconLeft && !K.value ? (c(), g("i", {
                      key: 0,
                      class: C([e.iconLeft, ue, se])
                    }, null, 2)) : w("", !0),
                    v("input", {
                      id: k.value,
                      ref_key: "inputRef",
                      ref: o,
                      name: e.name,
                      type: e.type,
                      value: e.modelValue,
                      placeholder: e.placeholder,
                      disabled: e.disabled,
                      readonly: e.readonly,
                      inputmode: e.inputmode,
                      autocomplete: e.autocomplete,
                      pattern: e.pattern,
                      maxlength: e.maxlength,
                      minlength: e.minlength,
                      min: e.min,
                      max: e.max,
                      "aria-labelledby": $.value,
                      "aria-label": e.label ? void 0 : e.ariaLabel,
                      "aria-disabled": e.disabled ? "true" : void 0,
                      "aria-invalid": A.value,
                      "aria-describedby": I.value,
                      "aria-required": e.required ? "true" : void 0,
                      "data-testid": "text-input",
                      class: C([
                        U.value ? "field-sizing-content not-supports-[field-sizing:content]:flex-1 max-w-full min-w-0 text-center text-ellipsis relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary) p-0" : "flex-1 min-w-0 text-ellipsis relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary) pl-0",
                        Q,
                        e.readonly ? "cursor-default" : "",
                        E.value,
                        e.valueVariant === "link" ? "pointer-events-none" : ""
                      ]),
                      onInput: ie,
                      onFocus: he,
                      onBlur: oe,
                      onKeydown: Ce
                    }, null, 42, _2),
                    Ae(Z.$slots, "suffix", {}, void 0, !0),
                    (c(), W(it(U.value ? "span" : a), an(sn(
                      U.value ? { class: "absolute right-0 top-1/2 flex -translate-y-1/2 items-center" } : {}
                    )), {
                      default: ve(() => [
                        Ae(Z.$slots, "iconRight", {
                          iconColorClass: se,
                          iconBoxClass: _
                        }, void 0, !0),
                        !d.iconRight && D(F) ? (c(), g("i", {
                          key: 0,
                          class: C(["ri-pencil-line text-(--icons-icon-accent)", _])
                        }, null, 2)) : !d.iconRight && z.value ? (c(), g("i", {
                          key: 1,
                          class: C(["ri-close-fill cursor-pointer text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", _]),
                          role: "button",
                          tabindex: "-1",
                          "aria-label": e.labels.clear,
                          onMousedown: ee[0] || (ee[0] = Je(() => {
                          }, ["prevent"])),
                          onClick: Je(H, ["stop"]),
                          onKeydown: [
                            ht(H, ["enter"]),
                            ht(Je(H, ["prevent"]), ["space"])
                          ]
                        }, null, 42, eC)) : w("", !0)
                      ]),
                      _: 2
                    }, 1040))
                  ]),
                  _: 2
                }, 1040)),
                e.innerButton ? (c(), W(Me, Fe({ key: 2 }, L(aa)(e.innerButton, e.disabled), {
                  size: "xs",
                  onClick: ee[1] || (ee[1] = (pe) => l("button-click", e.innerButton.id))
                }), null, 16)) : w("", !0)
              ]),
              _: 3
            }, 8, ["size", "stacked", "flush", "inner-button", "disabled", "readonly", "error", "success", "has-value", "class", "style"])
          ]),
          _: 3
        }, 16, ["buttons", "layout", "size", "disabled", "button-size"]),
        f.value ? (c(), g("div", tC, [
          Ae(Z.$slots, "actions", {}, void 0, !0)
        ])) : w("", !0),
        V.value && P.value.removeInFieldRow ? (c(), W(Me, Fe({ key: 1 }, L(aa)(V.value, e.disabled), {
          size: L(Wa)(e.size, "attached"),
          onClick: ee[3] || (ee[3] = (J) => l("button-click", V.value.id))
        }), null, 16, ["size"])) : w("", !0)
      ], 2),
      h.value ? (c(), g("div", {
        key: 1,
        class: C(["w-full", P.value.helper])
      }, [
        (c(), W(it(() => h.value)))
      ], 2)) : w("", !0),
      !L(B) && P.value.reservesHelper || e.hint || e.error ? (c(), W($t, {
        key: 2,
        ref_key: "helperRef",
        ref: s,
        class: C(P.value.helper),
        focused: r.value,
        hint: e.hint,
        error: e.error,
        "hint-id": T.value,
        "error-id": S.value,
        "test-id-prefix": "text-input"
      }, null, 8, ["class", "focused", "hint", "error", "hint-id", "error-id"])) : w("", !0),
      V.value && !P.value.removeInFieldRow ? (c(), W(Me, Fe({ key: 3 }, L(aa)(V.value, e.disabled), {
        class: P.value.remove,
        size: L(Wa)(e.size, "attached"),
        onClick: ee[4] || (ee[4] = (J) => l("button-click", V.value.id))
      }), null, 16, ["class", "size"])) : w("", !0)
    ], 6));
  }
}), Wt = /* @__PURE__ */ dt(nC, [["__scopeId", "data-v-a4da8935"]]), aC = ["aria-labelledby", "aria-describedby"], lC = { class: "mt-px flex min-w-0 flex-col gap-px" }, tq = /* @__PURE__ */ ye({
  __name: "FieldGroup",
  props: {
    label: {},
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    layout: { default: "attached" },
    fullWidth: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = qe(), a = `${t}-hint`, l = `${t}-error`, r = `${t}-label`, o = m(
      () => [n.hint ? a : "", n.error ? l : ""].filter(Boolean).join(" ") || void 0
    ), i = er([]), s = (y, k) => y.compareDocumentPosition(k) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1, d = { part: "", corners: "" };
    dn(Zu, {
      register: (y) => {
        i.value = [...i.value, y].sort(s);
      },
      unregister: (y) => {
        i.value = i.value.filter((k) => k !== y);
      },
      partOf: (y) => {
        const k = y ? i.value.indexOf(y) : -1;
        return n.layout !== "attached" || k < 0 ? d : Tg(Lg(k, i.value.length), "l");
      }
    });
    const u = m(
      () => n.layout === "attached" ? Ag("l") : "flex w-full items-start gap-(--spacing-2-5)"
    ), f = R(!1), b = R(null), h = R(null);
    function p(y) {
      const k = y.relatedTarget;
      (!k || !y.currentTarget.contains(k)) && (f.value = !1);
    }
    function x(y) {
      var k, $;
      (k = b.value) == null || k.handleFieldKeydown(y), ($ = h.value) == null || $.handleFieldKeydown(y);
    }
    return (y, k) => (c(), g("fieldset", {
      "aria-labelledby": e.labelTooltip ? r : void 0,
      "aria-describedby": o.value,
      class: C(["m-0 w-full min-w-0 border-0 p-0 font-inter", { "max-w-sm": !e.fullWidth }]),
      "data-testid": "field-group",
      onFocusin: k[0] || (k[0] = ($) => f.value = !0),
      onFocusout: p,
      onKeydown: x
    }, [
      te(It, {
        id: r,
        ref_key: "labelRef",
        ref: b,
        as: "legend",
        class: "p-0",
        text: e.label,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: f.value,
        "test-id": "field-group-label"
      }, null, 8, ["text", "required", "required-indicator", "tooltip", "focused"]),
      v("div", lC, [
        v("div", {
          class: C([u.value, "*:min-w-0 *:flex-1"]),
          "data-testid": "field-group-row"
        }, [
          Ae(y.$slots, "default")
        ], 2),
        te($t, {
          ref_key: "helperRef",
          ref: h,
          focused: f.value,
          hint: e.hint,
          error: e.error,
          "hint-id": a,
          "error-id": l,
          "test-id-prefix": "field-group"
        }, null, 8, ["focused", "hint", "error"])
      ])
    ], 42, aC));
  }
}), rC = ["id", "value", "placeholder", "disabled", "aria-labelledby", "aria-label", "aria-invalid", "aria-describedby", "aria-required"], oC = {
  role: "status",
  class: "sr-only",
  "data-testid": "copy-input-status"
}, Os = "copy-to-clipboard", iC = 2e3, nq = /* @__PURE__ */ ye({
  __name: "CopyInput",
  props: {
    modelValue: { default: "" },
    variant: { default: "attached" },
    iconOnly: { type: Boolean, default: !1 },
    buttons: { default: () => [] },
    prefix: { default: void 0 },
    iconLeft: { default: void 0 },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    labelTooltip: { default: void 0 },
    required: { type: Boolean, default: !1 },
    ariaLabel: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    size: { default: "md" },
    width: { default: void 0 },
    id: { default: void 0 },
    labels: { default: () => ({}) }
  },
  emits: ["copy", "copy-error", "button-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => t.labels.copy ?? "Copy"), r = m(() => t.labels.copied ?? "Copied!"), o = R(!1), i = R("");
    let s, d = !1;
    async function u() {
      try {
        await navigator.clipboard.writeText(t.modelValue);
      } catch (E) {
        a("copy-error", E);
        return;
      }
      clearTimeout(s), i.value = "", await Ge(), !d && (o.value = !0, i.value = r.value, a("copy", t.modelValue), s = setTimeout(() => {
        o.value = !1, i.value = "";
      }, iC));
    }
    yt(() => {
      d = !0, clearTimeout(s);
    });
    const f = {
      attached: "ri-file-copy-2-line",
      spaced: void 0,
      inner: "ri-file-copy-line",
      large: "ri-file-copy-2-line"
    }, b = m(() => {
      const E = t.iconOnly && (t.variant === "attached" || t.variant === "spaced");
      return {
        id: Os,
        label: o.value && !E ? r.value : l.value,
        // The button keeps its name so only the status announces the copy, not also a name change
        ariaLabel: o.value && !E ? l.value : void 0,
        icon: E ? "ri-file-copy-line" : f[t.variant],
        iconOnly: E,
        color: t.variant === "inner" || t.variant === "large" ? "tertiary" : "secondary",
        position: "end"
      };
    }), h = m(
      () => t.variant === "inner" ? t.buttons : [...t.buttons, b.value]
    );
    function p(E) {
      E === Os ? u() : a("button-click", E);
    }
    const x = qe(), y = m(() => t.id || x), k = m(() => t.label ? `${y.value}-label` : void 0), $ = m(() => `${y.value}-hint`), S = m(() => `${y.value}-error`), T = m(() => {
      const E = [t.hint ? $.value : "", t.error ? S.value : ""].filter(Boolean);
      return E.length ? E.join(" ") : void 0;
    }), I = R(!1), A = m(() => nr(!1, !!t.label, !1));
    return (E, D) => (c(), g("div", {
      class: C(["relative min-w-0", e.width ? "" : "w-full"]),
      style: je(e.width ? { width: e.width } : void 0),
      "data-testid": "copy-input"
    }, [
      e.variant === "large" ? (c(), g("div", {
        key: 0,
        class: C([
          "relative w-full min-w-0 pb-0.5 text-left font-inter text-(length:--size-m) text-(--text-text-black-default) dark:text-(--colors-text-white-default)",
          A.value.root
        ])
      }, [
        e.label ? (c(), W(It, {
          key: 0,
          id: k.value,
          text: e.label,
          "input-id": y.value,
          required: e.required,
          tooltip: e.labelTooltip,
          focused: I.value,
          "test-id": "copy-input-label"
        }, null, 8, ["id", "text", "input-id", "required", "tooltip", "focused"])) : w("", !0),
        te(Vn, {
          multiline: "",
          disabled: e.disabled,
          error: !!e.error,
          "has-value": !!e.modelValue,
          class: "w-full gap-2"
        }, {
          default: ve(() => [
            v("textarea", {
              id: y.value,
              value: e.modelValue,
              placeholder: e.placeholder,
              disabled: e.disabled,
              readonly: "",
              "aria-labelledby": k.value,
              "aria-label": e.label ? void 0 : e.ariaLabel,
              "aria-invalid": e.error ? "true" : void 0,
              "aria-describedby": T.value,
              "aria-required": e.required ? "true" : void 0,
              "data-testid": "copy-input-value",
              class: "h-full min-w-0 flex-1 self-stretch resize-none cursor-default border-0 bg-transparent p-0 text-(length:--size-sm) leading-(--line-height-l-tight) outline-none focus:border-0 focus:outline-none focus:ring-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)",
              onFocus: D[0] || (D[0] = (z) => I.value = !0),
              onBlur: D[1] || (D[1] = (z) => I.value = !1)
            }, null, 40, rC),
            te(Me, {
              class: "-mr-1 mt-[calc(--spacing(2)+1px)] shrink-0 self-start",
              variant: "tertiary",
              size: "xs",
              "icon-left": b.value.icon,
              label: b.value.label,
              "aria-label": b.value.ariaLabel,
              disabled: e.disabled,
              "data-field-button": Os,
              onClick: u
            }, null, 8, ["icon-left", "label", "aria-label", "disabled"])
          ]),
          _: 1
        }, 8, ["disabled", "error", "has-value"]),
        te($t, {
          hint: e.hint,
          error: e.error,
          "hint-id": $.value,
          "error-id": S.value,
          focused: I.value,
          "test-id-prefix": "copy-input"
        }, null, 8, ["hint", "error", "hint-id", "error-id", "focused"])
      ], 2)) : (c(), W(Wt, {
        key: 1,
        id: e.id,
        "model-value": e.modelValue,
        readonly: "",
        "readonly-chrome": !1,
        placeholder: e.placeholder,
        label: e.label,
        "label-tooltip": e.labelTooltip,
        required: e.required,
        "aria-label": e.ariaLabel,
        hint: e.hint,
        error: e.error,
        disabled: e.disabled,
        size: e.size,
        "icon-left": e.iconLeft,
        prefix: e.prefix,
        buttons: h.value,
        "button-layout": e.variant === "spaced" ? "spaced" : "attached",
        "inner-button": e.variant === "inner" ? b.value : void 0,
        onButtonClick: p
      }, null, 8, ["id", "model-value", "placeholder", "label", "label-tooltip", "required", "aria-label", "hint", "error", "disabled", "size", "icon-left", "prefix", "buttons", "button-layout", "inner-button"])),
      v("span", oC, j(i.value), 1)
    ], 6));
  }
}), sC = ["id"], dC = ["id", "name", "value", "placeholder", "disabled", "readonly", "min", "max", "step", "aria-labelledby", "aria-label", "aria-invalid", "aria-describedby", "aria-required"], uC = ["aria-label", "onKeydown"], cC = /* @__PURE__ */ ye({
  __name: "NumberInput",
  props: {
    modelValue: { default: "" },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    iconLeft: { default: void 0 },
    required: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    requiredIndicator: { default: "*" },
    disabled: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    prefix: { default: void 0 },
    min: { default: void 0 },
    max: { default: void 0 },
    step: { default: void 0 },
    error: { default: void 0 },
    success: { type: Boolean, default: !1 },
    hint: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    labels: { default: () => ({ clear: "Clear input" }) },
    labelInline: { type: Boolean, default: !1 },
    buttons: { default: () => [] },
    buttonLayout: { default: "attached" },
    buttonSize: { default: void 0 },
    removeButton: { default: void 0 }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "clear", "button-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R(!1), r = R(null), o = R(null), i = qe(), s = m(() => t.id ?? i), d = m(() => t.label ? `${s.value}-label` : void 0), u = m(() => t.prefix ? `${s.value}-prefix` : void 0), f = m(() => `${s.value}-error`), b = m(() => `${s.value}-hint`), h = m(
      () => d.value ? [d.value, u.value].filter(Boolean).join(" ") : void 0
    ), p = m(() => !!t.error), x = m(
      () => t.modelValue !== void 0 && t.modelValue !== null && String(t.modelValue).trim() !== ""
    ), y = (V) => V && !l.value && !t.disabled && !t.readonly, k = m(
      () => l.value && x.value && !t.disabled && !t.readonly
    ), $ = m(() => {
      const V = [];
      return t.hint && V.push(b.value), p.value && V.push(f.value), V.join(" ") || void 0;
    }), S = m(() => t.fullWidth || t.width === void 0), T = m(
      () => nr(t.labelInline, !!t.label, !!t.removeButton)
    ), I = m(() => t.removeButton && Xu(t.removeButton)), A = R(null), { inGroup: E, groupPart: D } = Qu(A), z = m(
      () => `relative min-w-0 ${E ? D.value.part : "pb-0.5"} text-left text-(length:--size-m) font-inter ${T.value.root}${S.value ? " w-full" : ""}`
    ), Y = m(() => S.value ? {} : { width: t.width });
    function le(V) {
      a("update:modelValue", V.target.value), a("input", V);
    }
    function ne(V) {
      t.disabled || (l.value = !0), a("focus", V);
    }
    function re(V) {
      l.value = !1, a("blur", V);
    }
    function O(V) {
      var M, B;
      (M = r.value) == null || M.handleFieldKeydown(V), (B = o.value) == null || B.handleFieldKeydown(V);
    }
    function P() {
      a("update:modelValue", ""), a("clear");
    }
    return (V, M) => (c(), g("div", {
      ref_key: "rootRef",
      ref: A,
      class: C(z.value),
      style: je(Y.value)
    }, [
      e.label ? (c(), W(It, {
        key: 0,
        id: d.value,
        ref_key: "labelRef",
        ref: r,
        text: e.label,
        "input-id": s.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: l.value,
        inline: e.labelInline,
        class: C(T.value.label),
        "test-id": "number-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline", "class"])) : w("", !0),
      v("div", {
        class: C(["flex w-full items-end gap-3", T.value.field])
      }, [
        te(bo, {
          buttons: e.buttons,
          layout: e.buttonLayout,
          size: e.size,
          disabled: e.disabled,
          "button-size": e.buttonSize,
          onButtonClick: M[1] || (M[1] = (B) => a("button-click", B))
        }, {
          default: ve(({ fieldClass: B }) => [
            te(Vn, {
              class: C(["w-full", B || L(D).corners]),
              flush: !!e.prefix,
              size: e.size,
              disabled: e.disabled,
              readonly: e.readonly,
              error: p.value,
              success: e.success,
              "has-value": x.value
            }, {
              default: ve(({ hovered: q, iconBoxClass: N, leftIconBoxClass: G, iconColorClass: U, borderColorClass: K, addonTextClass: ge, textClass: xe }) => [
                e.prefix ? (c(), g("span", {
                  key: 0,
                  id: u.value,
                  class: C([
                    "flex shrink-0 select-none items-center self-stretch border-r",
                    L(za)[e.size].addon,
                    "text-(length:--size-m) leading-(--line-height-l)",
                    K,
                    ge
                  ])
                }, j(e.prefix), 11, sC)) : w("", !0),
                v("div", {
                  class: C(
                    e.prefix ? ["flex h-full min-w-0 flex-1 items-center gap-2", L(za)[e.size].input, L(za)[e.size].inputEnd] : "contents"
                  )
                }, [
                  e.iconLeft && !e.prefix ? (c(), g("i", {
                    key: 0,
                    class: C([e.iconLeft, G, U]),
                    "aria-hidden": "true"
                  }, null, 2)) : w("", !0),
                  v("input", {
                    id: s.value,
                    name: e.name,
                    type: "number",
                    value: e.modelValue,
                    placeholder: e.placeholder,
                    disabled: e.disabled,
                    readonly: e.readonly,
                    min: e.min,
                    max: e.max,
                    step: e.step,
                    "aria-labelledby": h.value,
                    "aria-label": e.label ? void 0 : e.ariaLabel,
                    "aria-invalid": p.value ? "true" : void 0,
                    "aria-describedby": $.value,
                    "aria-required": e.required ? "true" : void 0,
                    "data-testid": "number-input",
                    class: C([
                      "relative min-w-0 flex-1 text-ellipsis border-0 bg-transparent p-0 outline-none focus:border-0 focus:outline-none focus:ring-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)",
                      xe,
                      e.readonly ? "cursor-default" : ""
                    ]),
                    onInput: le,
                    onFocus: ne,
                    onBlur: re,
                    onKeydown: O
                  }, null, 42, dC),
                  y(q) ? (c(), g("i", {
                    key: 1,
                    class: C(["ri-pencil-line text-(--icons-icon-accent)", N])
                  }, null, 2)) : k.value ? (c(), g("i", {
                    key: 2,
                    class: C([
                      "ri-close-fill cursor-pointer text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
                      N
                    ]),
                    role: "button",
                    tabindex: "-1",
                    "aria-label": e.labels.clear,
                    onMousedown: M[0] || (M[0] = Je(() => {
                    }, ["prevent"])),
                    onClick: Je(P, ["stop"]),
                    onKeydown: [
                      ht(P, ["enter"]),
                      ht(Je(P, ["prevent"]), ["space"])
                    ]
                  }, null, 42, uC)) : w("", !0)
                ], 2)
              ]),
              _: 1
            }, 8, ["class", "flush", "size", "disabled", "readonly", "error", "success", "has-value"])
          ]),
          _: 1
        }, 8, ["buttons", "layout", "size", "disabled", "button-size"]),
        I.value && T.value.removeInFieldRow ? (c(), W(Me, Fe({ key: 0 }, L(aa)(I.value, e.disabled), {
          size: L(Wa)(e.size, "attached"),
          onClick: M[2] || (M[2] = (B) => a("button-click", I.value.id))
        }), null, 16, ["size"])) : w("", !0)
      ], 2),
      !L(E) && T.value.reservesHelper || e.hint || e.error ? (c(), W($t, {
        key: 1,
        ref_key: "helperRef",
        ref: o,
        class: C(T.value.helper),
        focused: l.value,
        hint: e.hint,
        error: e.error,
        "hint-id": b.value,
        "error-id": f.value,
        "test-id-prefix": "number-input"
      }, null, 8, ["class", "focused", "hint", "error", "hint-id", "error-id"])) : w("", !0),
      I.value && !T.value.removeInFieldRow ? (c(), W(Me, Fe({ key: 2 }, L(aa)(I.value, e.disabled), {
        class: T.value.remove,
        size: L(Wa)(e.size, "attached"),
        onClick: M[3] || (M[3] = (B) => a("button-click", I.value.id))
      }), null, 16, ["class", "size"])) : w("", !0)
    ], 6));
  }
}), Af = /* @__PURE__ */ dt(cC, [["__scopeId", "data-v-2b2a52df"]]), fC = ["id", "name", "checked", "disabled", "value", "aria-label", "aria-labelledby", "aria-describedby"], hC = {
  key: 1,
  class: "absolute left-1/2 top-1/2 size-6 -translate-x-1/2 -translate-y-1/2",
  "data-testid": "radio-hit-area"
}, bC = ["for"], gC = /* @__PURE__ */ ye({
  __name: "RadioButton",
  props: {
    label: { default: void 0 },
    modelValue: { type: [String, Number, Boolean], default: void 0 },
    disabled: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    value: { type: [String, Number, Boolean], default: void 0 },
    presentational: { type: Boolean, default: !1 },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaDescribedby: { default: void 0 }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => t.modelValue === t.value), r = R(null), { resync: o } = ns(r, () => l.value), i = qe(), s = m(() => t.id ?? i), d = m(() => t.presentational ? "span" : "div"), u = m(() => !t.presentational && !!t.label), f = m(() => {
      const $ = "relative box-border flex size-4 shrink-0 items-center justify-center rounded-(--border-border-radius-rounded-full) border border-solid transition-all duration-200 motion-reduce:transition-none peer-focus-visible:shadow-(--shadow-focus-l) peer-focus-visible:outline-2 peer-focus-visible:outline-transparent", S = u.value ? " mt-0.5" : "";
      return t.disabled ? `${$}${S} bg-(--background-background-disabled) border-(--border-border-disabled) cursor-not-allowed` : l.value ? `${$}${S} bg-(--background-background-white) border-(--border-border-black-default) dark:bg-(--background-background-black-default) dark:border-(--border-border-base-medium) cursor-pointer` : `${$}${S} bg-(--background-background-white) border-(--border-border-base-medium) dark:bg-(--background-background-black-default) cursor-pointer peer-focus-visible:border-(--border-border-hover)`;
    }), b = m(() => {
      const $ = "size-2 rounded-(--border-border-radius-rounded-full)";
      return t.disabled ? `${$} bg-(--background-background-disabled-strong) forced-colors:bg-[GrayText]` : `${$} bg-(--background-background-black-default) dark:bg-(--background-background-white-secondary) forced-colors:bg-[CanvasText]`;
    }), h = m(() => t.presentational ? "pointer-events-none flex items-center justify-center" : `${u.value ? "min-h-6 px-px " : ""}self-stretch flex items-center`), p = m(() => u.value ? "flex min-w-0 items-start gap-2" : "flex items-center gap-2 shrink-0"), x = m(() => {
      const $ = "relative min-w-0 flex-1 break-words text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)";
      return t.disabled ? `${$} text-(--text-text-disabled-strong) dark:text-(--colors-text-disabled) cursor-not-allowed` : `${$} text-(--text-text-heading) dark:text-(--text-text-white-default) cursor-pointer`;
    }), y = ($) => {
      $.preventDefault(), !(t.disabled || l.value) && (t.value !== void 0 && a("update:modelValue", t.value), a("change", $));
    }, k = ($) => {
      if (t.disabled || l.value) return;
      $.target.checked && t.value !== void 0 && (a("update:modelValue", t.value), a("change", $), o());
    };
    return ($, S) => (c(), W(it(d.value), Fe({
      "data-testid": "radio-container",
      class: h.value
    }, Nl(e.presentational ? {} : { click: y })), {
      default: ve(() => [
        (c(), W(it(d.value), {
          class: C(p.value)
        }, {
          default: ve(() => [
            e.presentational ? w("", !0) : (c(), g("input", {
              key: 0,
              id: s.value,
              ref_key: "inputRef",
              ref: r,
              name: e.name,
              type: "radio",
              checked: l.value,
              disabled: e.disabled,
              value: e.value,
              "aria-label": e.ariaLabel,
              "aria-labelledby": e.ariaLabelledby,
              "aria-describedby": e.ariaDescribedby,
              class: "peer sr-only",
              onChange: k,
              onClick: S[0] || (S[0] = Je(() => {
              }, ["stop"]))
            }, null, 40, fC)),
            (c(), W(it(d.value), {
              "data-testid": "radio-button",
              class: C(f.value)
            }, {
              default: ve(() => [
                l.value ? (c(), W(it(d.value), {
                  key: 0,
                  class: C(b.value)
                }, null, 8, ["class"])) : w("", !0),
                e.presentational ? w("", !0) : (c(), g("span", hC))
              ]),
              _: 1
            }, 8, ["class"])),
            !e.presentational && e.label ? (c(), g("label", {
              key: 1,
              for: s.value,
              class: C(x.value)
            }, j(e.label), 11, bC)) : w("", !0)
          ]),
          _: 1
        }, 8, ["class"]))
      ]),
      _: 1
    }, 16, ["class"]));
  }
}), Bg = "rounded-(--border-border-radius-rounded-l) border border-solid", Mg = `${Bg} p-[calc(--spacing(4)-1px)]`, Dg = "shadow-(--blur-shadow-xs)", zd = "transition-[border-color,box-shadow,background-color] motion-reduce:transition-none", zg = "bg-(--background-background-white) dark:bg-(--colors-background-black-default)", Og = "border-(--border-border-base-medium) dark:border-(--colors-border-base)", Pg = "hover:bg-(--background-background-hover) dark:hover:bg-white/5", Fg = "border-(--border-border-disabled) dark:border-(--colors-border-disabled-subtle)", Vg = "bg-(--background-background-disabled-opacity) dark:bg-(--colors-background-disabled)", is = "text-(--text-text-disabled-strong)", mC = "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)", pC = "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)", Ng = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)", vC = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)", di = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold)", xC = "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)", yC = "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold)";
function Hg(e) {
  return e ? is : "text-(--text-text-heading) dark:text-(--colors-text-white-default)";
}
function jg(e) {
  return e ? is : "text-(--text-text-body) dark:text-(--colors-text-white-secondary)";
}
const Od = "[&_.opal-badge]:whitespace-normal [&_.opal-badge]:break-words [&_.opal-badge]:text-left [&_.opal-badge]:max-w-full";
function Wg(e, n) {
  return n ? "disabled" : e.theme ?? "neutral";
}
const qg = "bg-(--background-background-selected)", Pd = "border-(--border-border-accent)", Fd = "border-(--border-border-hover)", Ar = "has-[[data-selectable-card-input]:focus-visible]:shadow-(--shadow-focus-l) has-[[data-selectable-card-input]:focus-visible]:outline-2 has-[[data-selectable-card-input]:focus-visible]:outline-transparent", Ug = "has-[[data-selectable-card-input]:focus-visible]:border-(--border-border-hover)", kC = ["id", "role", "aria-label", "data-name"], wC = ["id"], CC = ["id", "name", "value", "checked", "disabled", "aria-label", "aria-labelledby", "aria-describedby"], SC = ["id"], $C = ["id"], IC = {
  key: 0,
  class: "flex flex-wrap items-center gap-1"
}, LC = ["id"], TC = ["id"], aq = /* @__PURE__ */ ye({
  __name: "RadioForm",
  props: {
    modelValue: { type: [String, Number, Boolean], default: void 0 },
    value: { type: [String, Number, Boolean] },
    label: {},
    helper: { default: void 0 },
    icon: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    type: { default: "card" },
    ctaLabel: { default: void 0 },
    ctaIcon: { default: "ri-eye-line" },
    ctaSecondaryLabel: { default: void 0 },
    ariaLabel: { default: void 0 },
    labelTooltip: { default: void 0 },
    badges: { default: void 0 },
    indicatorPosition: { default: "right" }
  },
  emits: ["update:modelValue", "cta", "cta-secondary"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = tn(), r = m(() => t.modelValue === t.value), o = m(() => t.type === "simple"), i = m(() => !t.readonly && !t.disabled), s = qe(), d = qe(), u = m(() => !!t.helper && !o.value), f = qe(), b = qe(), h = R(null), p = R(!1);
    $e(
      h,
      (_, ue, se) => {
        const Q = () => {
          p.value = !!_ && !_.querySelector(ka);
        };
        if (Q(), !_) return;
        const ae = new MutationObserver(Q);
        ae.observe(_, {
          childList: !0,
          subtree: !0,
          attributes: !0,
          attributeFilter: ["tabindex", "disabled", "href", "contenteditable", "type"]
        }), se(() => ae.disconnect());
      },
      { immediate: !0, flush: "post" }
    );
    const x = m(() => {
      const _ = [];
      return u.value && _.push(d), p.value && _.push(b), t.labelTooltip && _.push(f), _.length > 0 ? _.join(" ") : void 0;
    }), y = R(null), k = R(null), $ = R(null), { resync: S } = ns($, () => r.value), T = R(null), I = R(null), A = R(!1), E = R(!1), D = m(() => {
      if (t.labelTooltip)
        return E.value ? !1 : A.value ? !0 : void 0;
    });
    function z(_) {
      try {
        return _.matches(":focus-visible");
      } catch {
        return !0;
      }
    }
    function Y(_) {
      var ue;
      return _ instanceof Node && !!((ue = y.value) != null && ue.contains(_));
    }
    function le(_) {
      t.labelTooltip && _.target === $.value && _.target instanceof Element && z(_.target) && (A.value = !0);
    }
    function ne(_) {
      Y(_.relatedTarget) || (A.value = !1, E.value = !1);
    }
    const re = m(
      () => t.labelTooltip ? "flex items-center gap-1" : ""
    ), O = m(
      () => t.disabled ? is : "text-(--colors-icon-dark-default) dark:text-(--colors-text-white-default)"
    );
    function P() {
      A.value || (E.value = !1);
    }
    const V = m(() => {
      const _ = i.value ? " cursor-pointer" : t.disabled ? " cursor-not-allowed" : "";
      return o.value ? `flex w-full flex-wrap items-center gap-3${_}` : `flex w-full flex-wrap items-start ${t.type === "card" && t.icon && u.value ? "gap-3" : "gap-2"}${_}`;
    }), M = m(() => o.value || !t.icon || u.value ? "none" : Gl(t.icon) ? "icon" : "emoji"), B = m(
      () => ({ none: "", icon: "pt-1.5", emoji: "pt-1" })[M.value]
    ), q = m(
      () => t.type === "card-cta" && !!t.ctaLabel && !t.readonly
    ), N = m(() => q.value && !!t.ctaSecondaryLabel), G = m(
      () => `relative flex flex-col gap-4 ${o.value ? "justify-center" : "min-w-60"} ${Mg} ${zd} ${Od}`
    ), U = () => l("default");
    function K() {
      return t.type !== "card" ? Pd : U() ? Fd : t.icon && u.value ? Pd : Fd;
    }
    function ge() {
      const _ = `${Dg} ${zg} ${Og}`;
      return t.readonly ? `${G.value} ${_}` : t.disabled ? `${G.value} ${Vg} ${Fg} cursor-not-allowed` : r.value ? `${G.value} ${qg} ${K()} cursor-pointer ${Ar}` : `${G.value} ${_} ${Pg} cursor-pointer ${Ar} ${Ug}`;
    }
    const xe = m(() => Hg(t.disabled)), X = () => t.type === "card-cta" || t.type === "card" && U() ? yC : di, ie = m(() => [Ng, jg(t.disabled)]);
    function he() {
      i.value && (a("update:modelValue", t.value), S());
    }
    const oe = `${ka},a,button,input,select,textarea,[aria-disabled="true"]`;
    function Ce(_) {
      var se, Q;
      if ((se = T.value) != null && se.contains(_)) return !0;
      const ue = _.closest(oe);
      return !!ue && ue !== $.value && !!((Q = y.value) != null && Q.contains(ue));
    }
    function H(_) {
      !i.value || !(_.target instanceof Element) || Ce(_.target) || _.preventDefault();
    }
    function Z(_) {
      var se, Q, ae;
      if (!i.value || !(_.target instanceof Element)) return;
      const ue = _.target;
      (se = k.value) != null && se.contains(ue) || Ce(ue) || ((Q = $.value) == null || Q.focus({ preventScroll: !0 }), (ae = $.value) == null || ae.click());
    }
    function ee(_) {
      var ue, se;
      _.key !== "Escape" || !t.labelTooltip || ((ue = I.value) != null && ue.isVisible && (_.stopPropagation(), _.preventDefault()), E.value = !0, (se = I.value) == null || se.hide());
    }
    function J() {
      t.disabled || a("cta");
    }
    function F() {
      t.disabled || a("cta-secondary");
    }
    return (_, ue) => (c(), g("div", {
      id: e.readonly ? e.id : void 0,
      ref_key: "cardRef",
      ref: y,
      "data-testid": "radio-form",
      role: e.readonly ? "group" : void 0,
      "aria-label": e.readonly ? e.ariaLabel ?? e.label : void 0,
      "data-name": e.name,
      class: C(ge()),
      onMousedown: H,
      onClick: Z,
      onKeydown: ee,
      onFocusin: le,
      onFocusout: ne,
      onMouseleave: P
    }, [
      e.labelTooltip ? (c(), g("span", {
        key: 0,
        id: L(f),
        class: "sr-only"
      }, j(e.labelTooltip), 9, wC)) : w("", !0),
      (c(), W(it(e.readonly ? "div" : "label"), {
        ref_key: "labelRef",
        ref: k,
        "data-testid": "radio-form-label",
        class: C(V.value)
      }, {
        default: ve(() => [
          e.readonly ? w("", !0) : (c(), g("input", {
            key: 0,
            id: e.id,
            ref_key: "inputRef",
            ref: $,
            type: "radio",
            class: "sr-only",
            name: e.name,
            value: String(e.value),
            checked: r.value,
            disabled: e.disabled,
            "aria-label": e.ariaLabel,
            "aria-labelledby": e.ariaLabel ? void 0 : L(s),
            "aria-describedby": x.value,
            "data-selectable-card-input": "",
            onChange: he
          }, null, 40, CC)),
          e.icon ? (c(), g(de, { key: 1 }, [
            L(Gl)(e.icon) ? (c(), W(Gt, {
              key: 0,
              as: "span",
              size: "md",
              type: "square",
              variant: "outlined",
              color: e.disabled ? "disabled" : "white",
              icon: e.icon
            }, null, 8, ["color", "icon"])) : (c(), g("span", {
              key: 1,
              class: C(["text-num-32 leading-none shrink-0", e.disabled ? "opacity-50" : ""]),
              "aria-hidden": "true"
            }, j(e.icon), 3))
          ], 64)) : w("", !0),
          o.value ? (c(), g("span", {
            key: 2,
            id: L(s),
            class: C(["min-w-0 flex-1", L(di), re.value, xe.value])
          }, [
            nt(j(e.label) + " ", 1),
            e.labelTooltip ? (c(), W(mt, {
              key: 0,
              ref_key: "tooltipRef",
              ref: I,
              as: "span",
              text: e.labelTooltip,
              open: D.value,
              class: "shrink-0"
            }, {
              default: ve(() => [
                v("i", {
                  class: C(["ri-information-line cursor-help text-(length:--size-sm) leading-none", O.value]),
                  "aria-hidden": "true"
                }, null, 2)
              ]),
              _: 1
            }, 8, ["text", "open"])) : w("", !0)
          ], 10, SC)) : (c(), g("span", {
            key: 3,
            class: C(["flex min-w-0 flex-1 flex-col gap-1", B.value])
          }, [
            v("span", {
              "data-testid": "radio-form-title-row",
              class: C(["flex flex-wrap items-start justify-between gap-1", u.value ? "" : "min-h-6"])
            }, [
              v("span", {
                id: L(s),
                "data-testid": "radio-form-title",
                class: C(["min-w-0 grow", X(), re.value, xe.value])
              }, [
                nt(j(e.label) + " ", 1),
                e.labelTooltip ? (c(), W(mt, {
                  key: 0,
                  ref_key: "tooltipRef",
                  ref: I,
                  as: "span",
                  text: e.labelTooltip,
                  open: D.value,
                  class: "shrink-0"
                }, {
                  default: ve(() => [
                    v("i", {
                      class: C(["ri-information-line cursor-help text-(length:--size-sm) leading-none", O.value]),
                      "aria-hidden": "true"
                    }, null, 2)
                  ]),
                  _: 1
                }, 8, ["text", "open"])) : w("", !0)
              ], 10, $C),
              e.badges && e.badges.length > 0 ? (c(), g("span", IC, [
                (c(!0), g(de, null, Re(e.badges, (se, Q) => (c(), W(gt, Fe({ key: Q }, { ref_for: !0 }, se, {
                  theme: L(Wg)(se, e.disabled),
                  "show-close-icon": !1,
                  "truncation-focusable": !1
                }), null, 16, ["theme"]))), 128))
              ])) : w("", !0)
            ], 2),
            u.value ? (c(), g("span", {
              key: 0,
              id: L(d),
              class: C(ie.value)
            }, j(e.helper), 11, LC)) : w("", !0)
          ], 2)),
          e.readonly ? w("", !0) : (c(), g("span", {
            key: 4,
            "data-testid": "radio-form-indicator",
            class: C(["pointer-events-none w-4 shrink-0", [B.value, e.indicatorPosition === "left" ? "order-first" : void 0]]),
            "aria-hidden": "true"
          }, [
            v("span", {
              "data-testid": "radio-form-indicator-line",
              class: C(o.value || u.value ? "block" : "block py-1")
            }, [
              te(gC, {
                "model-value": e.modelValue,
                value: e.value,
                disabled: e.disabled,
                presentational: ""
              }, null, 8, ["model-value", "value", "disabled"])
            ], 2)
          ], 2))
        ]),
        _: 1
      }, 8, ["class"])),
      U() ? (c(), g("div", {
        key: 1,
        id: L(b),
        ref_key: "bodyRef",
        ref: h,
        "data-testid": "radio-form-body",
        class: "flex w-full flex-col gap-3"
      }, [
        Ae(_.$slots, "default")
      ], 8, TC)) : w("", !0),
      q.value ? (c(), g("div", {
        key: 2,
        ref_key: "footerRef",
        ref: T,
        "data-testid": "radio-form-footer",
        class: "flex items-center justify-between gap-4"
      }, [
        te(Me, {
          "data-testid": "radio-form-cta",
          variant: "secondary",
          size: "xs",
          "icon-left": e.ctaIcon,
          label: e.ctaLabel,
          disabled: e.disabled,
          onClick: J
        }, null, 8, ["icon-left", "label", "disabled"]),
        N.value ? (c(), W(Me, {
          key: 0,
          "data-testid": "radio-form-cta-secondary",
          variant: "secondary",
          size: "xs",
          label: e.ctaSecondaryLabel,
          disabled: e.disabled,
          onClick: F
        }, null, 8, ["label", "disabled"])) : w("", !0)
      ], 512)) : w("", !0)
    ], 42, kC));
  }
}), AC = ["aria-labelledby"], EC = ["id"], lq = /* @__PURE__ */ ye({
  __name: "RadioFormGroup",
  props: {
    legend: {}
  },
  setup(e) {
    const n = qe();
    return (t, a) => (c(), g("div", {
      role: "radiogroup",
      "aria-labelledby": e.legend && !t.$attrs["aria-label"] ? L(n) : void 0
    }, [
      e.legend ? (c(), g("div", {
        key: 0,
        id: L(n),
        "data-testid": "radio-form-group-legend",
        class: C(L(bg))
      }, j(e.legend), 11, EC)) : w("", !0),
      Ae(t.$slots, "default")
    ], 8, AC));
  }
}), RC = ["aria-labelledby"], BC = {
  key: 0,
  "data-testid": "checkbox-group-required",
  class: "whitespace-pre"
}, MC = {
  "data-testid": "checkbox-group-items",
  class: "flex flex-wrap items-start gap-2 *:w-auto"
}, rq = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "CheckboxGroup",
  props: {
    legend: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    error: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 }
  },
  setup(e) {
    const n = e, t = Gn(), a = Hn(), l = qe(), r = `${l}-error`, o = `${l}-legend`, i = m(
      () => n.ariaLabelledby ?? (n.labelTooltip && (n.legend || a.legend) ? o : void 0)
    ), s = m(() => {
      const d = [t["aria-describedby"], n.error ? r : void 0].filter(Boolean);
      return d.length > 0 ? d.join(" ") : void 0;
    });
    return dn(
      qu,
      m(() => n.error ? r : void 0)
    ), (d, u) => (c(), g("fieldset", Fe({ ...L(t), "aria-describedby": s.value }, {
      "aria-labelledby": i.value,
      class: "m-0 min-w-0 border-0 p-0"
    }), [
      e.legend || L(a).legend ? (c(), g("legend", {
        key: 0,
        "data-testid": "checkbox-group-legend",
        class: C([L(bg), "p-0", e.labelTooltip ? "flex items-center gap-1" : ""])
      }, [
        v("span", { id: o }, [
          Ae(d.$slots, "legend", {}, () => [
            nt(j(e.legend), 1)
          ]),
          e.required ? (c(), g("span", BC, j(` ${e.requiredIndicator}`), 1)) : w("", !0)
        ]),
        e.labelTooltip ? (c(), W(Sg, {
          key: 0,
          text: e.labelTooltip
        }, null, 8, ["text"])) : w("", !0)
      ], 2)) : w("", !0),
      v("div", MC, [
        Ae(d.$slots, "default")
      ]),
      e.error ? (c(), g("div", {
        key: 1,
        id: r,
        "data-testid": "checkbox-group-error",
        role: "alert",
        class: C(["mt-2", L(gg)])
      }, [
        v("i", {
          class: C(L(mg)),
          "aria-hidden": "true"
        }, null, 2),
        v("span", null, j(e.error), 1)
      ], 2)) : w("", !0)
    ], 16, RC));
  }
}), DC = ["id", "role", "aria-label", "data-name"], zC = ["id", "name", "checked", "disabled", "aria-label", "aria-labelledby", "aria-describedby"], OC = ["id"], PC = {
  key: 2,
  class: "flex min-w-0 flex-1 flex-col gap-2"
}, FC = ["src"], VC = { class: "flex w-full flex-col gap-1" }, NC = ["id"], HC = ["id"], jC = ["id"], WC = {
  key: 0,
  class: "flex min-w-0 flex-wrap items-center gap-3"
}, qC = {
  key: 1,
  class: "flex flex-wrap items-center gap-3"
}, UC = ["id"], GC = ["id"], oq = /* @__PURE__ */ ye({
  __name: "CheckboxForm",
  props: {
    modelValue: { type: Boolean, default: !1 },
    label: {},
    helper: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    type: { default: "card" },
    ariaLabel: { default: void 0 },
    align: { default: void 0 },
    badgesAlign: { default: void 0 },
    badges: { default: void 0 },
    icons: { default: void 0 },
    avatar: { default: void 0 },
    imageSrc: { default: void 0 },
    icon: { default: void 0 },
    subtitle: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = tn(), r = m(() => !t.readonly && !t.disabled), o = m(() => t.type === "inline"), i = qe(), s = qe(), d = qe(), u = m(() => t.type === "simple" && !t.icon), f = m(() => !!t.helper && !u.value), b = m(() => !!t.subtitle && t.type === "card"), h = m(() => t.type === "card" ? t.avatar : void 0), p = m(() => t.type === "card" ? t.icon : void 0), x = () => !u.value && t.type !== "big-card" && l("trailing"), y = m(() => !!t.icon && (t.type === "simple" || t.type === "card")), k = hg(() => [
      b.value ? d : void 0,
      f.value ? s : void 0
    ]);
    Sy();
    const $ = R(null), { resync: S } = ns($, () => t.modelValue), T = R(null), I = m(() => (t.align ?? (t.avatar ? "center" : void 0) ?? (t.type === "simple" && t.icon ? "center" : void 0) ?? "top") === "center" ? "items-center" : "items-start"), A = m(
      () => t.badgesAlign ?? (t.avatar || b.value ? "title" : "end")
    ), E = m(() => o.value ? "flex flex-wrap items-start gap-1" : A.value === "title" ? "flex flex-wrap items-center gap-3" : "flex flex-wrap items-start justify-between gap-1"), D = `group relative flex flex-wrap gap-2 p-px min-w-60 ${Od}`, z = `relative flex flex-wrap ${Mg} ${zd} ${Od}`, Y = `relative flex items-center justify-center ${Bg} px-[calc(--spacing(3)-1px)] py-[calc(--spacing(2)-1px)] ${zd}`, le = m(() => {
      const ie = t.type === "simple" ? "gap-3" : "gap-2";
      return `flex ${I.value} min-w-0 flex-1 ${ie}`;
    });
    function ne() {
      if (o.value)
        return t.readonly ? D : t.disabled ? `${D} cursor-not-allowed` : `${D} cursor-pointer ${Ar}`;
      const ie = t.type === "big-card" ? "min-w-46" : "min-w-60", he = u.value ? Y : `${z} ${ie} ${h.value ? "gap-2" : "gap-1"}`, Ce = `${x() || b.value ? "" : `${Dg} `}${zg} ${Og}`;
      if (t.readonly) return `${he} ${Ce}`;
      if (t.disabled)
        return `${he} ${Vg} ${Fg} cursor-not-allowed`;
      if (t.modelValue) {
        const H = y.value ? Fd : Pd;
        return `${he} ${qg} ${H} cursor-pointer ${Ar}`;
      }
      return `${he} ${Ce} ${Pg} cursor-pointer ${Ar} ${Ug}`;
    }
    const re = m(() => Hg(t.disabled)), O = m(
      () => t.type === "inline" && r.value ? "group-hover:text-(--text-text-hover)" : ""
    ), P = m(() => t.type === "advanced" && t.modelValue), V = m(() => {
      if (u.value) return `${di} text-center ${re.value}`;
      if (t.type === "simple" || p.value) return `min-w-0 flex-1 ${di} ${re.value}`;
      const ie = t.type === "big-card" ? xC : vC, he = o.value ? "min-w-0 flex-1" : "min-w-0", oe = P.value ? " line-through" : "";
      return `${he} ${ie} ${re.value} ${O.value}${oe}`;
    }), M = m(
      () => t.disabled ? is : "text-(--text-text-black-default) dark:text-(--colors-text-white-secondary)"
    ), B = m(() => {
      if (b.value || h.value)
        return `${mC} ${M.value}`;
      const ie = jg(t.disabled), he = P.value ? " line-through" : "";
      return `${Ng} ${ie} ${O.value}${he}`;
    }), q = m(() => `${pC} ${M.value}`), N = m(() => `flex min-w-0 flex-1 flex-col ${h.value ? "gap-1" : "gap-3"}`), G = m(() => `flex flex-wrap items-center ${h.value ? "gap-3" : "gap-4"}`), U = m(() => b.value ? "flex flex-col gap-px" : t.avatar || t.type === "simple" || p.value ? "flex flex-col gap-1" : "flex flex-col gap-0.5"), K = m(() => {
      const ie = r.value ? " cursor-pointer" : t.disabled ? " cursor-not-allowed" : "";
      return `flex min-w-0 flex-1${u.value ? " justify-center" : ""}${ie}`;
    });
    function ge(ie) {
      const he = ie.target;
      a("update:modelValue", he.checked), S();
    }
    function xe(ie) {
      var Ce;
      const he = ie.currentTarget;
      if (!r.value || !(ie.target instanceof Element) || (Ce = T.value) != null && Ce.contains(ie.target)) return;
      const oe = ie.target.closest(ka);
      oe && oe !== $.value && he.contains(oe) || ie.preventDefault();
    }
    function X(ie) {
      var he, oe;
      !r.value || ie.target !== ie.currentTarget || ((he = $.value) == null || he.focus({ preventScroll: !0 }), (oe = $.value) == null || oe.click());
    }
    return (ie, he) => (c(), g("div", {
      id: e.readonly ? e.id : void 0,
      "data-testid": "checkbox-form",
      role: e.readonly ? "group" : void 0,
      "aria-label": e.readonly ? e.ariaLabel ?? e.label : void 0,
      "data-name": e.name,
      class: C(ne()),
      onMousedown: xe,
      onClick: X
    }, [
      (c(), W(it(e.readonly ? "div" : "label"), {
        "data-testid": "checkbox-form-label",
        class: C(K.value)
      }, {
        default: ve(() => [
          e.readonly ? w("", !0) : (c(), g("input", {
            key: 0,
            id: e.id,
            ref_key: "inputRef",
            ref: $,
            type: "checkbox",
            class: "sr-only",
            name: e.name,
            checked: e.modelValue,
            disabled: e.disabled,
            "aria-label": e.ariaLabel,
            "aria-labelledby": e.ariaLabel ? void 0 : L(i),
            "aria-describedby": L(k),
            "data-selectable-card-input": "",
            onChange: ge
          }, null, 40, zC)),
          u.value ? (c(), g("span", {
            key: 1,
            id: L(i),
            class: C(V.value)
          }, j(e.label), 11, OC)) : e.type === "big-card" ? (c(), g("span", PC, [
            e.imageSrc ? (c(), g("img", {
              key: 0,
              src: e.imageSrc,
              alt: "",
              class: "size-8 shrink-0 object-contain"
            }, null, 8, FC)) : w("", !0),
            v("span", VC, [
              v("span", {
                id: L(i),
                class: C(V.value)
              }, j(e.label), 11, NC),
              f.value ? (c(), g("span", {
                key: 0,
                id: L(s),
                class: C(B.value)
              }, j(e.helper), 11, HC)) : w("", !0)
            ])
          ])) : (c(), g("span", {
            key: 3,
            "data-testid": "checkbox-form-content-group",
            class: C(le.value)
          }, [
            !e.readonly && e.type !== "simple" ? (c(), g("span", {
              key: 0,
              "data-testid": "checkbox-form-indicator",
              class: C(["pointer-events-none w-4 shrink-0 py-1", p.value ? "me-1" : ""]),
              "aria-hidden": "true"
            }, [
              te(Bn, {
                "model-value": e.modelValue,
                disabled: e.disabled,
                presentational: ""
              }, null, 8, ["model-value", "disabled"])
            ], 2)) : w("", !0),
            y.value && e.icon ? (c(), g(de, { key: 1 }, [
              L(Gl)(e.icon) ? (c(), W(Gt, {
                key: 0,
                as: "span",
                size: "md",
                type: "square",
                variant: "outlined",
                color: e.disabled ? "disabled" : e.type === "card" ? "default" : "white",
                icon: e.icon
              }, null, 8, ["color", "icon"])) : (c(), g("span", {
                key: 1,
                class: C([
                  "text-num-32 leading-none shrink-0",
                  e.disabled ? "opacity-50" : "",
                  e.type === "card" ? "me-1" : ""
                ]),
                "aria-hidden": "true"
              }, j(e.icon), 3))
            ], 64)) : w("", !0),
            h.value ? (c(), W(Nt, {
              key: 2,
              img: h.value.img,
              name: h.value.name,
              as: "span",
              size: "md",
              presentational: ""
            }, null, 8, ["img", "name"])) : w("", !0),
            v("span", {
              class: C(N.value)
            }, [
              v("span", {
                class: C(U.value)
              }, [
                v("span", {
                  "data-testid": "checkbox-form-title-row",
                  class: C(E.value)
                }, [
                  v("span", {
                    id: L(i),
                    class: C(V.value)
                  }, j(e.label), 11, jC),
                  e.badges && e.badges.length > 0 || e.icons && e.icons.length > 0 ? (c(), g("span", WC, [
                    e.badges && e.badges.length > 0 ? (c(), g("span", {
                      key: 0,
                      class: C(["flex flex-wrap items-center", A.value === "title" ? "gap-3" : "gap-1"])
                    }, [
                      (c(!0), g(de, null, Re(e.badges, (oe, Ce) => (c(), W(gt, Fe({ key: Ce }, { ref_for: !0 }, oe, {
                        theme: L(Wg)(oe, e.disabled),
                        "show-close-icon": !1,
                        "truncation-focusable": !1
                      }), null, 16, ["theme"]))), 128))
                    ], 2)) : w("", !0),
                    e.icons && e.icons.length > 0 ? (c(), g("span", qC, [
                      (c(!0), g(de, null, Re(e.icons, (oe, Ce) => (c(), g("i", {
                        key: Ce,
                        class: C([`ri-${oe}`, "text-(length:--size-4xl) leading-none"]),
                        "aria-hidden": "true"
                      }, null, 2))), 128))
                    ])) : w("", !0)
                  ])) : w("", !0)
                ], 2),
                b.value ? (c(), g("span", {
                  key: 0,
                  id: L(d),
                  "data-testid": "checkbox-form-subtitle",
                  class: C(q.value)
                }, j(e.subtitle), 11, UC)) : w("", !0),
                f.value ? (c(), g("span", {
                  key: 1,
                  id: L(s),
                  class: C(B.value)
                }, j(e.helper), 11, GC)) : w("", !0)
              ], 2),
              (e.type === "advanced" || e.type === "card") && L(l)("details") ? (c(), g("span", {
                key: 0,
                "data-testid": "checkbox-form-details",
                class: C(G.value)
              }, [
                Ae(ie.$slots, "details")
              ], 2)) : w("", !0)
            ], 2)
          ], 2))
        ]),
        _: 3
      }, 8, ["class"])),
      x() ? (c(), g("div", {
        key: 0,
        ref_key: "trailingRef",
        ref: T,
        "data-testid": "checkbox-form-trailing",
        class: "flex shrink-0 items-start justify-end"
      }, [
        Ae(ie.$slots, "trailing")
      ], 512)) : w("", !0)
    ], 42, DC));
  }
}), KC = { class: "w-full flex flex-col gap-2" }, YC = {
  key: 0,
  class: "text-sm font-medium text-text-black-default dark:text-(--colors-text-white-default)"
}, JC = { class: "flex flex-col items-center gap-2" }, XC = ["src"], ZC = { class: "relative text-sm leading-5 dark:text-(--colors-text-white-default)" }, QC = {
  key: 1,
  class: "flex flex-col items-center gap-5"
}, _C = { class: "flex-1 flex flex-col items-center gap-1.5" }, eS = { class: "flex-1 flex flex-col items-center gap-1.5" }, tS = { class: "flex-1 flex flex-col items-center gap-1.5" }, nS = ["id", "name", "accept", "disabled"], aS = {
  key: 1,
  class: "text-sm text-red-600 dark:text-red-400"
}, lS = /* @__PURE__ */ ye({
  __name: "ImageInput",
  props: {
    variant: { default: "default" },
    uploadText: { default: "Click to upload or drag and drop" },
    maxFileSizeText: { default: "Max. File Size: 30MB" },
    browseButtonText: { default: "Browse file" },
    uploadIcon: { default: void 0 },
    browseButtonIcon: { default: void 0 },
    dragDropText: { default: "Drag and drop a file here, or:" },
    browseLabel: { default: "Browse" },
    browseIcon: { default: void 0 },
    libraryLabel: { default: "Library" },
    libraryIcon: { default: void 0 },
    linkLabel: { default: "Link" },
    linkIcon: { default: void 0 },
    accept: { default: "image/*" },
    maxFileSize: { default: 30 * 1024 * 1024 },
    size: { default: "md" },
    success: { type: Boolean, default: !1 },
    error: { type: [String, Boolean], default: !1 },
    disabled: { type: Boolean, default: !1 },
    label: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    modelValue: { default: null }
  },
  emits: ["update:modelValue", "change", "error", "browse", "library", "link"],
  setup(e, { emit: n }) {
    const t = e, a = m(() => !!t.error), l = m(() => typeof t.error == "string" ? t.error : void 0), r = n, o = R(null), i = R(!1), s = R(!1), d = qe(), u = `${d}-browse`, f = `${d}-library`, b = `${d}-link`, p = {
      sm: {
        container: "h-[180px]",
        text: "text-xs",
        icon: "w-5 h-5",
        gap: "gap-3"
      },
      md: {
        container: "h-[228px]",
        text: "text-sm",
        icon: "w-6 h-6",
        gap: "gap-4"
      },
      lg: {
        container: "h-[280px]",
        text: "text-base",
        icon: "w-7 h-7",
        gap: "gap-5"
      },
      xl: {
        container: "h-[320px]",
        text: "text-lg",
        icon: "w-8 h-8",
        gap: "gap-6"
      }
    }[t.size], x = m(() => {
      const O = t.variant === "buttons" ? "border-border-base" : "border-border-primary-button", P = `w-full relative rounded-xl border-dashed border-[1px] box-border flex flex-col items-center justify-center text-center text-sm font-inter transition-[border-color,background-color,box-shadow,color] duration-200 ${p.container}`;
      return t.disabled ? `${P} bg-background-disabled-subtle dark:bg-(--colors-background-disabled) border-[#D1D5DC] dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled) cursor-not-allowed` : a.value ? `${P} bg-background-white dark:bg-(--colors-background-black-default) border-[#B42318] dark:border-[#B42318] text-[#B42318] dark:text-[#B42318] cursor-pointer` : t.success ? `${P} bg-background-white dark:bg-(--colors-background-black-default) border-[#009966] dark:border-[#009966] text-text-body dark:text-(--colors-text-white-default) cursor-pointer` : i.value ? `${P} shadow-[0px_0px_2px_#7c86ff] bg-background-hover dark:bg-[rgba(255,255,255,0.05)] border-[#7c86ff] dark:border-[#7c86ff] text-text-black-default dark:text-(--colors-text-white-default) cursor-pointer` : s.value ? `${P} shadow-[0px_0px_2px_#7c86ff] bg-background-hover dark:bg-[rgba(255,255,255,0.05)] border-[#7c86ff] dark:border-[#7c86ff] text-text-black-default dark:text-(--colors-text-white-default) cursor-pointer` : `${P} bg-background-white dark:bg-(--colors-background-black-default) ${O} dark:border-(--colors-border-base) text-text-black-default dark:text-(--colors-text-white-default) cursor-pointer`;
    }), y = (O) => {
      if (!O || O.length === 0 || t.disabled) return;
      const P = Array.from(O);
      if (P.filter((q) => q.size > t.maxFileSize).length > 0) {
        r("error", `File size exceeds the maximum allowed size of ${t.maxFileSizeText}`);
        return;
      }
      const M = P.length === 1 ? P[0] : P;
      r("update:modelValue", M);
      const B = new Event("change", { bubbles: !0 });
      r("change", B);
    }, k = () => {
      var O;
      t.disabled || (O = o.value) == null || O.click();
    }, $ = (O) => {
      var P;
      t.disabled || (r("browse", O), (P = o.value) == null || P.click());
    }, S = (O) => {
      t.disabled || r("library", O);
    }, T = (O) => {
      t.disabled || r("link", O);
    }, I = (O) => {
      const P = O.target;
      y(P.files);
    }, A = (O) => {
      O.preventDefault(), O.stopPropagation(), t.disabled || (i.value = !0);
    }, E = (O) => {
      O.preventDefault(), O.stopPropagation(), i.value = !1;
    }, D = (O) => {
      var V;
      if (O.preventDefault(), O.stopPropagation(), i.value = !1, t.disabled) return;
      const P = (V = O.dataTransfer) == null ? void 0 : V.files;
      P && y(P);
    }, z = () => {
      var O;
      t.disabled || (O = o.value) == null || O.click();
    }, Y = (O, P) => {
      try {
        if (O.startsWith("data:image/svg+xml")) {
          const V = O.split(",")[1];
          if (!V) return O;
          const B = decodeURIComponent(V).replace(/fill=["']currentColor["']/gi, `fill="${P}"`).replace(/fill=["']#[0-9A-Fa-f]{6}["']/gi, `fill="${P}"`);
          return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(B)}`;
        }
        return O.replace(/color=%[0-9A-Fa-f]{6}/, `color=%23${P.slice(1)}`);
      } catch {
        return O;
      }
    }, le = m(() => {
      if (t.browseIcon)
        return t.success && t.variant === "buttons" ? Y(t.browseIcon, "#007A55") : t.browseIcon;
    }), ne = m(() => {
      if (t.libraryIcon)
        return t.success && t.variant === "buttons" ? Y(t.libraryIcon, "#007A55") : t.libraryIcon;
    }), re = m(() => {
      if (t.linkIcon)
        return t.success && t.variant === "buttons" ? Y(t.linkIcon, "#007A55") : t.linkIcon;
    });
    return (O, P) => (c(), g("div", KC, [
      e.label ? (c(), g("div", YC, j(e.label), 1)) : w("", !0),
      v("div", {
        class: C(x.value),
        onDragover: A,
        onDragleave: E,
        onDrop: D,
        onClick: P[0] || (P[0] = (V) => e.variant === "default" ? z() : void 0),
        onMouseenter: P[1] || (P[1] = (V) => s.value = !0),
        onMouseleave: P[2] || (P[2] = (V) => s.value = !1)
      }, [
        e.variant === "default" ? (c(), g("div", {
          key: 0,
          class: C(["flex flex-col items-center", L(p).gap])
        }, [
          v("div", JC, [
            e.uploadIcon ? (c(), g("img", {
              key: 0,
              src: e.uploadIcon,
              class: C([L(p).icon, "relative", "image-input-icon"]),
              alt: ""
            }, null, 10, XC)) : w("", !0),
            v("div", ZC, j(e.uploadText), 1),
            v("div", {
              class: C([
                "relative text-xs! leading-4 font-medium",
                e.success ? "text-[#007A55] dark:text-[#007A55]" : !e.disabled && !e.error ? "text-text-body dark:text-(--colors-text-white-default)" : "dark:text-(--colors-text-disabled)"
              ])
            }, j(e.maxFileSizeText), 3)
          ]),
          te(L(Me), {
            variant: "primary",
            label: e.browseButtonText,
            "icon-left": e.browseButtonIcon,
            size: "xs",
            disabled: e.disabled,
            type: "button",
            onClick: Je(k, ["stop"])
          }, null, 8, ["label", "icon-left", "disabled"])
        ], 2)) : (c(), g("div", QC, [
          v("div", {
            class: C([
              "relative leading-5 text-sm!",
              e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : a.value ? "text-[#B42318] dark:text-[#B42318]" : e.success ? "text-text-body dark:text-(--colors-text-white-default)" : "text-text-black-default dark:text-(--colors-text-white-default)"
            ])
          }, j(e.dragDropText), 3),
          v("div", {
            class: C([
              "self-stretch flex items-start gap-6 text-xs!",
              e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : "text-text-body dark:text-(--colors-text-white-default)"
            ])
          }, [
            v("div", _C, [
              v("div", {
                class: C([
                  "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                  e.disabled ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#D1D5DC] dark:border-(--colors-border-disabled-subtle) border" : a.value ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#B42318] dark:border-[#B42318] border" : e.success ? "bg-background-success dark:bg-background-success border-transparent border-0" : "bg-background-white dark:bg-(--colors-background-black-default) border-border-base-medium dark:border-(--colors-border-base) border"
                ])
              }, [
                le.value ? (c(), W(L(Me), {
                  key: 0,
                  variant: "secondary",
                  "icon-left": le.value,
                  "icon-only": "",
                  size: "sm",
                  disabled: e.disabled,
                  "aria-labelledby": u,
                  onClick: Je($, ["stop"])
                }, null, 8, ["icon-left", "disabled"])) : w("", !0)
              ], 2),
              v("div", {
                id: u,
                class: C([
                  "relative leading-5 font-medium text-sm!",
                  e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : a.value ? "text-[#B42318] dark:text-[#B42318]" : e.success ? "text-[#007A55] dark:text-[#007A55]" : "text-text-black-default dark:text-(--colors-text-white-default)"
                ])
              }, j(e.browseLabel), 3)
            ]),
            v("div", eS, [
              v("div", {
                class: C([
                  "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                  e.disabled ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#D1D5DC] dark:border-(--colors-border-disabled-subtle) border" : a.value ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#B42318] dark:border-[#B42318] border" : e.success ? "bg-background-success dark:bg-background-success border-transparent border-0" : "bg-background-white dark:bg-(--colors-background-black-default) border-border-base-medium dark:border-(--colors-border-base) border"
                ])
              }, [
                ne.value ? (c(), W(L(Me), {
                  key: 0,
                  variant: "secondary",
                  "icon-left": ne.value,
                  "icon-only": "",
                  size: "sm",
                  disabled: e.disabled,
                  "aria-labelledby": f,
                  onClick: Je(S, ["stop"])
                }, null, 8, ["icon-left", "disabled"])) : w("", !0)
              ], 2),
              v("div", {
                id: f,
                class: C([
                  "relative leading-5 font-medium text-sm!",
                  e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : a.value ? "text-[#B42318] dark:text-[#B42318]" : e.success ? "text-[#007A55] dark:text-[#007A55]" : "text-text-black-default dark:text-(--colors-text-white-default)"
                ])
              }, j(e.libraryLabel), 3)
            ]),
            v("div", tS, [
              v("div", {
                class: C([
                  "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                  e.disabled ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#D1D5DC] dark:border-(--colors-border-disabled-subtle) border" : a.value ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#B42318] dark:border-[#B42318] border" : e.success ? "bg-background-success dark:bg-background-success border-transparent border-0" : "bg-background-white dark:bg-(--colors-background-black-default) border-border-base-medium dark:border-(--colors-border-base) border"
                ])
              }, [
                re.value ? (c(), W(L(Me), {
                  key: 0,
                  variant: "secondary",
                  "icon-left": re.value,
                  "icon-only": "",
                  size: "sm",
                  disabled: e.disabled,
                  "aria-labelledby": b,
                  onClick: Je(T, ["stop"])
                }, null, 8, ["icon-left", "disabled"])) : w("", !0)
              ], 2),
              v("div", {
                id: b,
                class: C([
                  "relative leading-5 font-medium text-sm!",
                  e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : a.value ? "text-[#B42318] dark:text-[#B42318]" : e.success ? "text-[#007A55] dark:text-[#007A55]" : "text-text-black-default dark:text-(--colors-text-white-default)"
                ])
              }, j(e.linkLabel), 3)
            ])
          ], 2)
        ])),
        v("input", {
          id: e.id,
          ref_key: "fileInputRef",
          ref: o,
          "data-testid": "image-input",
          name: e.name,
          type: "file",
          accept: e.accept,
          disabled: e.disabled,
          class: "sr-only",
          onChange: I
        }, null, 40, nS)
      ], 34),
      l.value ? (c(), g("div", aS, j(l.value), 1)) : w("", !0)
    ]));
  }
}), iq = /* @__PURE__ */ dt(lS, [["__scopeId", "data-v-5b729c92"]]), rS = { class: "w-full flex flex-col gap-2" }, oS = {
  key: 1,
  class: "flex flex-col gap-0.5"
}, iS = { class: "relative" }, sS = ["id", "name", "accept", "disabled", "multiple", "aria-describedby", "aria-invalid"], dS = ["disabled"], uS = ["aria-label"], cS = {
  key: 2,
  class: "w-full flex flex-col gap-4"
}, fS = { class: "flex flex-col gap-0.5" }, hS = { class: "flex flex-col items-center gap-2" }, bS = { class: "text-(length:--size-m) leading-(--line-height-l) text-(--text-text-black-default) dark:text-(--text-text-white-default) text-center" }, gS = { class: "text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-body) dark:text-(--text-text-white-default) text-center whitespace-pre-line" }, mS = ["id", "name", "accept", "disabled", "multiple", "aria-describedby", "aria-invalid"], pS = {
  key: 0,
  class: "flex flex-col gap-3"
}, vS = { class: "flex flex-1 items-center gap-2.5 min-w-0" }, xS = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  class: "shrink-0"
}, yS = ["id"], kS = ["stroke", "stroke-dashoffset"], wS = { class: "flex flex-col min-w-0" }, CS = { class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default) dark:text-(--text-text-white-default) truncate" }, SS = { class: "flex gap-2 text-(length:--size-sm)" }, $S = { class: "font-(--weight-medium) text-(--text-text-black-default) dark:text-(--text-text-white-default)" }, IS = { class: "flex items-center gap-1 shrink-0" }, LS = {
  key: 1,
  class: "h-9 w-9 flex items-center justify-center shrink-0"
}, TS = {
  key: 2,
  class: "h-9 w-9 flex items-center justify-center shrink-0"
}, AS = {
  key: 3,
  class: "flex flex-col gap-0.5"
}, ES = { class: "flex flex-col items-center gap-2" }, RS = ["src"], BS = { class: "flex flex-col items-center gap-2" }, MS = ["src"], DS = {
  key: 1,
  class: "flex flex-col items-center gap-5"
}, zS = { class: "flex-1 flex flex-col items-center gap-1.5" }, OS = { class: "flex-1 flex flex-col items-center gap-1.5" }, PS = { class: "flex-1 flex flex-col items-center gap-1.5" }, FS = ["id", "name", "accept", "disabled", "multiple", "aria-describedby", "aria-invalid"], VS = {
  key: 4,
  class: "mt-3 space-y-1"
}, NS = { class: "flex-shrink-0" }, HS = {
  key: 0,
  class: "w-5 h-5 text-(--text-text-success-strong)",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, jS = {
  key: 1,
  class: "w-5 h-5 text-(--text-text-error-strong)",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, WS = { class: "flex-1 min-w-0" }, qS = { key: 0 }, US = ["disabled", "onClick"], Ps = 10.2, Ef = 3.6, GS = /* @__PURE__ */ ye({
  __name: "FileUploadInput",
  props: {
    variant: { default: "default" },
    uploadText: { default: "Click to upload or drag and drop" },
    maxFileSizeText: { default: "Max. File Size: 30MB" },
    hint: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    fileTypeErrorText: { default: void 0 },
    fileSizeErrorText: { default: void 0 },
    browseButtonText: { default: "Select file" },
    placeholder: { default: "Placeholder text" },
    uploadIcon: { default: void 0 },
    browseButtonIcon: { default: void 0 },
    dragDropText: { default: "Drag and drop a file here, or:" },
    browseLabel: { default: "Browse" },
    browseIcon: { default: void 0 },
    libraryLabel: { default: "Library" },
    libraryIcon: { default: void 0 },
    linkLabel: { default: "Link" },
    linkIcon: { default: void 0 },
    accept: { default: "*" },
    maxFileSize: { default: 30 * 1024 * 1024 },
    size: { default: "md" },
    success: { type: Boolean, default: !1 },
    error: { type: [String, Boolean], default: !1 },
    disabled: { type: Boolean, default: !1 },
    label: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    modelValue: { default: null },
    uploadedFile: { default: null },
    uploadedFiles: { default: () => [] },
    multiple: { type: Boolean, default: !1 },
    addFilesText: { default: "Add file(s)" },
    addMoreText: { default: "Add more" },
    addMoreIcon: { default: void 0 },
    progressFiles: { default: () => [] },
    pauseLabel: { default: "Pause" },
    resumeLabel: { default: "Resume" },
    removeLabel: { default: "Remove file" },
    clearFileLabel: { default: "Clear file" },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 }
  },
  emits: ["update:modelValue", "change", "error", "browse", "library", "link", "addMore", "fileClick", "removeFile", "pauseFile", "resumeFile", "removeProgressFile", "clear"],
  setup(e, { emit: n }) {
    const t = e, a = m(() => !!t.error), l = m(() => typeof t.error == "string" ? t.error : void 0), r = qe(), o = `${r}-browse`, i = `${r}-library`, s = `${r}-link`, d = m(() => !!t.uploadedFile), u = (se) => se ? se < 1024 ? `${se}B` : se < 1024 * 1024 ? `${(se / 1024).toFixed(0)}Ko` : `${(se / (1024 * 1024)).toFixed(1)}Mo` : "", f = m(() => {
      if (!t.uploadedFile) return "";
      const se = t.uploadedFile.name, Q = t.uploadedFile.size ? ` (${u(t.uploadedFile.size)})` : "";
      return `${se}${Q}`;
    }), b = n;
    function h() {
      p.value && (p.value.value = ""), b("update:modelValue", null), b("clear");
    }
    const p = R(null), x = qe(), y = m(() => t.id || x), k = R(!1), $ = R(null), S = R(null), T = m(() => `${y.value}-hint`), I = m(() => `${y.value}-error`), A = m(() => t.hint ? t.hint : (t.variant === "basic" || t.variant === "dropzone") && t.maxFileSizeText || void 0), E = m(() => {
      var se;
      return (se = A.value) != null && se.includes(`
`) ? 2 : 1;
    }), D = m(() => {
      const se = [];
      return A.value && se.push(T.value), l.value && se.push(I.value), se.length > 0 ? se.join(" ") : void 0;
    });
    function z(se) {
      var Q, ae;
      (Q = $.value) == null || Q.handleFieldKeydown(se), (ae = S.value) == null || ae.handleFieldKeydown(se);
    }
    const Y = R(!1), le = R(!1), ne = R(/* @__PURE__ */ new Set());
    function re(se) {
      ne.value.has(se) ? (ne.value.delete(se), b("resumeFile", se)) : (ne.value.add(se), b("pauseFile", se)), ne.value = new Set(ne.value);
    }
    const O = 2 * Math.PI * Ps;
    function P(se) {
      return O * (1 - Math.min(Math.max(se, 0), 100) / 100);
    }
    const M = {
      sm: {
        container: "h-[180px]",
        text: "text-xs",
        icon: "w-5 h-5",
        gap: "gap-3"
      },
      md: {
        container: "h-[228px]",
        text: "text-sm",
        icon: "w-6 h-6",
        gap: "gap-4"
      },
      lg: {
        container: "h-[280px]",
        text: "text-base",
        icon: "w-7 h-7",
        gap: "gap-5"
      },
      xl: {
        container: "h-[320px]",
        text: "text-lg",
        icon: "w-8 h-8",
        gap: "gap-6"
      }
    }[t.size], B = m(() => {
      const se = t.variant === "dropzone" ? "border-(--border-border-base)" : "border-(--border-border-primary-button)", Q = `w-full relative rounded-xl border-dashed border-[1px] box-border flex flex-col items-center justify-center text-center text-sm font-inter transition-[border-color,background-color,box-shadow,color] duration-200 ${M.container}`;
      return t.disabled ? `${Q} bg-(--background-background-disabled-subtle) dark:bg-(--background-background-disabled) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light) cursor-not-allowed` : a.value ? `${Q} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer` : t.success || d.value ? `${Q} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-success-strong) dark:border-(--border-border-success-strong) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer` : Y.value ? `${Q} shadow-[0px_0px_2px_var(--border-border-hover)] bg-(--background-background-hover) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-hover) dark:border-(--border-border-hover) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer` : le.value ? `${Q} shadow-[0px_0px_2px_var(--border-border-hover)] bg-(--background-background-hover) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-hover) dark:border-(--border-border-hover) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer` : `${Q} bg-(--background-background-white) dark:bg-(--background-background-black-default) ${se} dark:border-(--border-border-base) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer`;
    }), q = (se, Q) => {
      if (!Q || Q === "*" || Q === "*/*") return !0;
      const ae = Q.split(",").map((pe) => pe.trim().toLowerCase()).filter((pe) => pe.length > 0);
      if (ae.length === 0) return !0;
      const Te = (se.type || "").toLowerCase(), Le = (se.name || "").toLowerCase();
      return ae.some((pe) => pe.startsWith(".") ? Le.endsWith(pe) : pe.endsWith("/*") ? Te.startsWith(pe.slice(0, -1)) : Te === pe);
    }, N = (se) => {
      if (!se || se.length === 0 || t.disabled) return;
      const Q = Array.from(se);
      if (Q.filter((ke) => !q(ke, t.accept)).length > 0) {
        b("error", t.fileTypeErrorText || "File type not supported.");
        return;
      }
      if (Q.filter((ke) => ke.size > t.maxFileSize).length > 0) {
        b(
          "error",
          t.fileSizeErrorText || `File size exceeds the maximum allowed size of ${t.maxFileSizeText}`
        );
        return;
      }
      const Le = t.multiple ? Q : Q[0];
      b("update:modelValue", Le);
      const pe = new Event("change", { bubbles: !0 });
      b("change", pe);
    }, G = () => {
      var se;
      t.disabled || (se = p.value) == null || se.click();
    }, U = (se) => {
      var Q;
      t.disabled || (b("browse", se), (Q = p.value) == null || Q.click());
    }, K = (se) => {
      t.disabled || b("library", se);
    }, ge = (se) => {
      t.disabled || b("link", se);
    }, xe = (se) => {
      var Q;
      t.disabled || (b("addMore", se), (Q = p.value) == null || Q.click());
    }, X = () => {
      t.uploadedFile && b("fileClick", t.uploadedFile);
    }, ie = (se, Q) => {
      t.disabled || b("removeFile", se, Q);
    }, he = (se) => {
      const Q = se.target;
      N(Q.files);
    }, oe = (se) => {
      se.preventDefault(), se.stopPropagation(), t.disabled || (Y.value = !0);
    }, Ce = (se) => {
      se.preventDefault(), se.stopPropagation(), Y.value = !1;
    }, H = (se) => {
      var ae;
      if (se.preventDefault(), se.stopPropagation(), Y.value = !1, t.disabled) return;
      const Q = (ae = se.dataTransfer) == null ? void 0 : ae.files;
      Q && N(Q);
    }, Z = () => {
      var se;
      t.disabled || d.value || (se = p.value) == null || se.click();
    }, ee = (se, Q) => {
      try {
        if (se.startsWith("data:image/svg+xml")) {
          const ae = se.split(",")[1];
          if (!ae) return se;
          const Le = decodeURIComponent(ae).replace(/fill=["']currentColor["']/gi, `fill="${Q}"`).replace(/fill=["']#[0-9A-Fa-f]{6}["']/gi, `fill="${Q}"`);
          return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(Le)}`;
        }
        return se.replace(/color=%[0-9A-Fa-f]{6}/, `color=%23${Q.slice(1)}`);
      } catch {
        return se;
      }
    }, J = {
      // --icons-icon-dark-default
      error: "#b42318",
      // --icons-icon-error
      success: "#007a55",
      // --text-text-success-strong
      disabled: "#99a1af"
      // --icons-icon-disabled-light
    }, F = m(() => {
      if (t.browseIcon)
        return t.disabled && t.variant === "dropzone" ? ee(t.browseIcon, J.disabled) : a.value && t.variant === "dropzone" ? ee(t.browseIcon, J.error) : (t.success || d.value) && t.variant === "dropzone" ? ee(t.browseIcon, J.success) : t.browseIcon;
    }), _ = m(() => {
      if (t.libraryIcon)
        return t.disabled && t.variant === "dropzone" ? ee(t.libraryIcon, J.disabled) : a.value && t.variant === "dropzone" ? ee(t.libraryIcon, J.error) : (t.success || d.value) && t.variant === "dropzone" ? ee(t.libraryIcon, J.success) : t.libraryIcon;
    }), ue = m(() => {
      if (t.linkIcon)
        return t.disabled && t.variant === "dropzone" ? ee(t.linkIcon, J.disabled) : a.value && t.variant === "dropzone" ? ee(t.linkIcon, J.error) : (t.success || d.value) && t.variant === "dropzone" ? ee(t.linkIcon, J.success) : t.linkIcon;
    });
    return (se, Q) => (c(), g("div", rS, [
      e.label ? (c(), W(It, {
        key: 0,
        ref_key: "labelRef",
        ref: $,
        text: e.label,
        "input-id": y.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: k.value,
        "test-id": "file-upload-label"
      }, null, 8, ["text", "input-id", "required", "required-indicator", "tooltip", "focused"])) : w("", !0),
      e.variant === "basic" ? (c(), g("div", oS, [
        v("div", iS, [
          v("input", {
            id: y.value,
            ref_key: "fileInputRef",
            ref: p,
            "data-testid": "file-upload-input-basic",
            name: e.name,
            type: "file",
            accept: e.accept,
            disabled: e.disabled,
            multiple: e.multiple,
            "aria-describedby": D.value,
            "aria-invalid": a.value ? "true" : void 0,
            class: "absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10",
            onChange: he,
            onFocus: Q[0] || (Q[0] = (ae) => k.value = !0),
            onBlur: Q[1] || (Q[1] = (ae) => k.value = !1),
            onKeydown: z
          }, null, 40, sS),
          v("div", {
            class: C([
              "flex items-center w-full bg-(--background-background-white) dark:bg-(--background-background-black-default) border rounded-lg shadow-xs transition-colors",
              e.disabled ? "border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) cursor-not-allowed" : a.value ? "border-(--border-border-error-strong) dark:border-(--border-border-error-strong) focus-within:ring-4 focus-within:ring-(--border-border-error-medium)" : "border-(--border-border-base-medium) dark:border-(--border-border-base) focus-within:ring-4 focus-within:ring-(--border-border-hover-medium) focus-within:border-(--border-border-hover)"
            ])
          }, [
            v("button", {
              type: "button",
              class: C([
                "flex-shrink-0 px-3 py-2 text-sm font-medium rounded-l-lg border-r transition-colors",
                e.disabled ? "bg-(--background-background-disabled-subtle) dark:bg-(--background-background-disabled) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light) cursor-not-allowed" : a.value ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) text-(--text-text-black-default) dark:text-(--text-text-white-default) hover:bg-(--background-background-hover) dark:hover:bg-[rgba(255,255,255,0.05)]"
              ]),
              disabled: e.disabled,
              onClick: Je(G, ["stop"])
            }, j(e.browseButtonText), 11, dS),
            v("div", {
              class: C([
                "flex-1 px-3 py-2 text-sm pointer-events-none truncate",
                e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : e.modelValue ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
              ])
            }, j(e.modelValue ? Array.isArray(e.modelValue) ? `${e.modelValue.length} file(s) selected` : e.modelValue.name : e.placeholder), 3),
            e.modelValue && !e.disabled ? (c(), g("button", {
              key: 0,
              type: "button",
              class: "relative z-20 shrink-0 flex items-center justify-center px-2 self-stretch text-(--text-text-black-default) dark:text-(--text-text-white-default) hover:text-(--text-text-body)",
              "aria-label": e.clearFileLabel,
              onClick: Je(h, ["stop"])
            }, [...Q[9] || (Q[9] = [
              v("i", {
                class: "ri-close-fill text-base",
                "aria-hidden": "true"
              }, null, -1)
            ])], 8, uS)) : w("", !0)
          ], 2)
        ]),
        te($t, {
          ref_key: "helperRef",
          ref: S,
          focused: k.value,
          hint: A.value,
          "hint-lines": E.value,
          disabled: e.disabled,
          error: l.value,
          "hint-id": T.value,
          "error-id": I.value,
          "error-live": e.errorLive,
          "test-id-prefix": "file-upload"
        }, null, 8, ["focused", "hint", "hint-lines", "disabled", "error", "hint-id", "error-id", "error-live"])
      ])) : e.variant === "advanced" ? (c(), g("div", cS, [
        v("div", fS, [
          v("div", {
            class: "w-full rounded-xl border border-dashed border-(--border-border-base-medium) dark:border-(--border-border-base) bg-(--background-background-white-secondary-soft) dark:bg-(--background-background-black-default) flex h-[228px] flex-col items-center justify-center gap-4 px-5",
            onDragover: oe,
            onDragleave: Ce,
            onDrop: H
          }, [
            v("div", hS, [
              Q[10] || (Q[10] = v("i", {
                class: "ri-upload-2-line text-(length:--size-xl) text-(--text-text-black-default) dark:text-(--text-text-white-default)",
                "aria-hidden": "true"
              }, null, -1)),
              v("p", bS, j(e.uploadText), 1),
              v("p", gS, j(e.maxFileSizeText), 1)
            ]),
            te(L(Me), {
              variant: "primary",
              label: e.addFilesText,
              "icon-left": "ri-add-line",
              size: "xs",
              disabled: e.disabled,
              type: "button",
              onClick: Je(G, ["stop"])
            }, null, 8, ["label", "disabled"]),
            v("input", {
              id: y.value,
              ref_key: "fileInputRef",
              ref: p,
              "data-testid": "file-upload-input",
              name: e.name,
              type: "file",
              accept: e.accept,
              disabled: e.disabled,
              multiple: e.multiple,
              "aria-describedby": D.value,
              "aria-invalid": a.value ? "true" : void 0,
              class: "sr-only",
              onChange: he,
              onFocus: Q[2] || (Q[2] = (ae) => k.value = !0),
              onBlur: Q[3] || (Q[3] = (ae) => k.value = !1),
              onKeydown: z
            }, null, 40, mS)
          ], 32),
          te($t, {
            ref_key: "helperRef",
            ref: S,
            focused: k.value,
            hint: A.value,
            "hint-lines": E.value,
            disabled: e.disabled,
            error: l.value,
            "hint-id": T.value,
            "error-id": I.value,
            "error-live": e.errorLive,
            "test-id-prefix": "file-upload"
          }, null, 8, ["focused", "hint", "hint-lines", "disabled", "error", "hint-id", "error-id", "error-live"])
        ]),
        e.progressFiles.length ? (c(), g("div", pS, [
          (c(!0), g(de, null, Re(e.progressFiles, (ae) => (c(), g("div", {
            key: ae.id,
            "data-testid": "upload-progress-row",
            class: "flex w-full items-center justify-between gap-2.5"
          }, [
            v("div", vS, [
              (c(), g("svg", xS, [
                v("defs", null, [
                  v("linearGradient", {
                    id: `upload-ring-gradient-${ae.id}`,
                    x1: "0%",
                    y1: "0%",
                    x2: "100%",
                    y2: "100%"
                  }, [...Q[11] || (Q[11] = [
                    v("stop", {
                      offset: "0%",
                      style: { "stop-color": "var(--gradient-brand-start)" }
                    }, null, -1),
                    v("stop", {
                      offset: "100%",
                      style: { "stop-color": "var(--gradient-brand-end)" }
                    }, null, -1)
                  ])], 8, yS)
                ]),
                v("circle", {
                  cx: "12",
                  cy: "12",
                  r: Ps,
                  fill: "none",
                  "stroke-width": Ef,
                  class: "stroke-(--border-border-base-soft) dark:stroke-(--border-border-base-soft)"
                }),
                v("circle", {
                  "data-testid": "progress-ring-fill",
                  cx: "12",
                  cy: "12",
                  r: Ps,
                  fill: "none",
                  "stroke-width": Ef,
                  "stroke-linecap": "round",
                  transform: "rotate(-90 12 12)",
                  stroke: `url(#upload-ring-gradient-${ae.id})`,
                  "stroke-dasharray": O,
                  "stroke-dashoffset": P(ae.percent)
                }, null, 8, kS)
              ])),
              v("div", wS, [
                v("p", CS, j(ae.name), 1),
                v("div", SS, [
                  v("span", $S, j(ae.percent) + "%", 1),
                  v("span", {
                    class: C(
                      ae.status === "success" ? "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)" : ae.status === "error" ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
                    )
                  }, j(ae.statusText), 3)
                ])
              ])
            ]),
            v("div", IS, [
              ae.status === "uploading" ? (c(), W(L(Me), {
                key: 0,
                variant: "text",
                "icon-only": "",
                size: "sm",
                "icon-left": ne.value.has(ae.id) ? "ri-play-line" : "ri-pause-line",
                "aria-label": ne.value.has(ae.id) ? e.resumeLabel : e.pauseLabel,
                "data-testid": "pause-icon",
                onClick: (Te) => re(ae.id)
              }, null, 8, ["icon-left", "aria-label", "onClick"])) : w("", !0),
              ae.status === "success" ? (c(), g("span", LS, [...Q[12] || (Q[12] = [
                v("i", {
                  "data-testid": "progress-success-icon",
                  class: "ri-checkbox-circle-line text-(length:--size-xxl) text-(--icons-icon-success) dark:text-(--icons-icon-success)",
                  "aria-hidden": "true"
                }, null, -1)
              ])])) : ae.status === "error" ? (c(), g("span", TS, [...Q[13] || (Q[13] = [
                v("i", {
                  "data-testid": "progress-error-icon",
                  class: "ri-error-warning-line text-(length:--size-xxl) text-(--icons-icon-error) dark:text-(--icons-icon-error)",
                  "aria-hidden": "true"
                }, null, -1)
              ])])) : w("", !0),
              te(L(Me), {
                variant: "text",
                "icon-only": "",
                size: "sm",
                "icon-left": "ri-close-line",
                "aria-label": e.removeLabel,
                "data-testid": "delete-icon",
                onClick: (Te) => b("removeProgressFile", ae.id)
              }, null, 8, ["aria-label", "onClick"])
            ])
          ]))), 128))
        ])) : w("", !0)
      ])) : (c(), g("div", AS, [
        v("div", {
          class: C(B.value),
          onDragover: oe,
          onDragleave: Ce,
          onDrop: H,
          onClick: Q[6] || (Q[6] = (ae) => e.variant === "default" ? Z() : void 0),
          onMouseenter: Q[7] || (Q[7] = (ae) => le.value = !0),
          onMouseleave: Q[8] || (Q[8] = (ae) => le.value = !1)
        }, [
          e.variant === "default" ? (c(), g(de, { key: 0 }, [
            d.value ? (c(), g("div", {
              key: 1,
              class: C(["flex flex-col items-center", L(M).gap])
            }, [
              v("div", BS, [
                e.uploadIcon ? (c(), g("img", {
                  key: 0,
                  src: e.uploadIcon,
                  class: C([
                    L(M).icon,
                    "relative",
                    e.disabled ? "file-input-icon-disabled" : "file-input-icon"
                  ]),
                  alt: ""
                }, null, 10, MS)) : w("", !0),
                v("div", {
                  class: C([
                    "relative text-sm leading-5",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                  ])
                }, j(e.uploadText), 3),
                v("button", {
                  type: "button",
                  class: C([
                    "relative text-sm leading-5 font-medium cursor-pointer hover:underline",
                    a.value ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)"
                  ]),
                  onClick: Je(X, ["stop"])
                }, j(f.value), 3)
              ]),
              te(L(Me), {
                variant: "secondary",
                label: `+ ${e.addMoreText}`,
                size: "xs",
                disabled: e.disabled,
                type: "button",
                onClick: Je(xe, ["stop"])
              }, null, 8, ["label", "disabled"])
            ], 2)) : (c(), g("div", {
              key: 0,
              class: C(["flex flex-col items-center", L(M).gap])
            }, [
              v("div", ES, [
                e.uploadIcon ? (c(), g("img", {
                  key: 0,
                  src: e.uploadIcon,
                  class: C([
                    L(M).icon,
                    "relative",
                    e.disabled ? "file-input-icon-disabled" : "file-input-icon"
                  ]),
                  alt: ""
                }, null, 10, RS)) : w("", !0),
                v("div", {
                  class: C([
                    "relative text-sm leading-5",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                  ])
                }, j(e.uploadText), 3),
                v("div", {
                  class: C([
                    "relative text-xs! leading-4 font-medium",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : e.success || d.value || e.error ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
                  ])
                }, j(e.maxFileSizeText), 3)
              ]),
              te(L(Me), {
                variant: "primary",
                label: e.browseButtonText,
                "icon-left": e.browseButtonIcon,
                size: "xs",
                disabled: e.disabled,
                type: "button",
                onClick: Je(G, ["stop"])
              }, null, 8, ["label", "icon-left", "disabled"])
            ], 2))
          ], 64)) : (c(), g("div", DS, [
            v("div", {
              class: C([
                "relative leading-5 text-sm!",
                e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
              ])
            }, j(e.dragDropText), 3),
            v("div", {
              class: C([
                "self-stretch flex items-start gap-6 text-xs!",
                e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
              ])
            }, [
              v("div", zS, [
                v("div", {
                  class: C([
                    "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                    e.disabled ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) border" : a.value ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) border" : e.success || d.value ? "bg-(--background-background-success) dark:bg-(--background-background-success) border-transparent border-0" : "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) border"
                  ])
                }, [
                  F.value ? (c(), W(L(Me), {
                    key: 0,
                    variant: "secondary",
                    "icon-left": F.value,
                    "icon-only": "",
                    size: "sm",
                    disabled: e.disabled,
                    "aria-labelledby": o,
                    onClick: Je(U, ["stop"])
                  }, null, 8, ["icon-left", "disabled"])) : w("", !0)
                ], 2),
                v("div", {
                  id: o,
                  class: C([
                    "relative leading-5 font-medium text-sm!",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : a.value ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : e.success || d.value ? "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                  ])
                }, j(e.browseLabel), 3)
              ]),
              v("div", OS, [
                v("div", {
                  class: C([
                    "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                    e.disabled ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) border" : a.value ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) border" : e.success || d.value ? "bg-(--background-background-success) dark:bg-(--background-background-success) border-transparent border-0" : "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) border"
                  ])
                }, [
                  _.value ? (c(), W(L(Me), {
                    key: 0,
                    variant: "secondary",
                    "icon-left": _.value,
                    "icon-only": "",
                    size: "sm",
                    disabled: e.disabled,
                    "aria-labelledby": i,
                    onClick: Je(K, ["stop"])
                  }, null, 8, ["icon-left", "disabled"])) : w("", !0)
                ], 2),
                v("div", {
                  id: i,
                  class: C([
                    "relative leading-5 font-medium text-sm!",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : a.value ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : e.success || d.value ? "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                  ])
                }, j(e.libraryLabel), 3)
              ]),
              v("div", PS, [
                v("div", {
                  class: C([
                    "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                    e.disabled ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) border" : a.value ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) border" : e.success || d.value ? "bg-(--background-background-success) dark:bg-(--background-background-success) border-transparent border-0" : "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) border"
                  ])
                }, [
                  ue.value ? (c(), W(L(Me), {
                    key: 0,
                    variant: "secondary",
                    "icon-left": ue.value,
                    "icon-only": "",
                    size: "sm",
                    disabled: e.disabled,
                    "aria-labelledby": s,
                    onClick: Je(ge, ["stop"])
                  }, null, 8, ["icon-left", "disabled"])) : w("", !0)
                ], 2),
                v("div", {
                  id: s,
                  class: C([
                    "relative leading-5 font-medium text-sm!",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : a.value ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : e.success || d.value ? "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                  ])
                }, j(e.linkLabel), 3)
              ])
            ], 2)
          ])),
          v("input", {
            id: y.value,
            ref_key: "fileInputRef",
            ref: p,
            "data-testid": "file-upload-input",
            name: e.name,
            type: "file",
            accept: e.accept,
            disabled: e.disabled,
            multiple: e.multiple,
            "aria-describedby": D.value,
            "aria-invalid": a.value ? "true" : void 0,
            class: "sr-only",
            onChange: he,
            onFocus: Q[4] || (Q[4] = (ae) => k.value = !0),
            onBlur: Q[5] || (Q[5] = (ae) => k.value = !1),
            onKeydown: z
          }, null, 40, FS)
        ], 34),
        te($t, {
          ref_key: "helperRef",
          ref: S,
          focused: k.value,
          hint: A.value,
          "hint-lines": E.value,
          disabled: e.disabled,
          error: l.value,
          "hint-id": T.value,
          "error-id": I.value,
          "error-live": e.errorLive,
          "test-id-prefix": "file-upload"
        }, null, 8, ["focused", "hint", "hint-lines", "disabled", "error", "hint-id", "error-id", "error-live"])
      ])),
      e.variant === "dropzone" && e.uploadedFiles && e.uploadedFiles.length > 0 ? (c(), g("div", VS, [
        (c(!0), g(de, null, Re(e.uploadedFiles, (ae, Te) => (c(), g("div", {
          key: `file-${Te}-${ae.name}`,
          class: "flex items-center gap-2"
        }, [
          v("div", NS, [
            ae.status === "success" ? (c(), g("svg", HS, [...Q[14] || (Q[14] = [
              v("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M5 13l4 4L19 7"
              }, null, -1)
            ])])) : ae.status === "error" ? (c(), g("svg", jS, [...Q[15] || (Q[15] = [
              v("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              }, null, -1)
            ])])) : w("", !0)
          ]),
          v("div", WS, [
            v("p", {
              class: C([
                "text-sm truncate",
                ae.status === "error" ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
              ])
            }, [
              nt(j(ae.name) + " ", 1),
              ae.size ? (c(), g("span", qS, " (" + j(u(ae.size)) + ") ", 1)) : w("", !0)
            ], 2)
          ]),
          v("button", {
            type: "button",
            class: "flex-shrink-0 p-0.5 transition-colors",
            disabled: e.disabled,
            onClick: (Le) => ie(ae, Te)
          }, [
            (c(), g("svg", {
              class: C([
                "w-5 h-5",
                e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
              ]),
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor"
            }, [...Q[16] || (Q[16] = [
              v("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              }, null, -1)
            ])], 2))
          ], 8, US)
        ]))), 128))
      ])) : w("", !0)
    ]));
  }
}), KS = /* @__PURE__ */ dt(GS, [["__scopeId", "data-v-8ebe268e"]]), YS = {
  "aria-hidden": "true",
  focusable: "false",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "textarea-icon pointer-events-none text-(--colors-icon-dark-default) dark:text-(--icons-icon-white-default)"
}, Gg = /* @__PURE__ */ ye({
  __name: "ResizeGrip",
  setup(e) {
    return (n, t) => (c(), g("svg", YS, [...t[0] || (t[0] = [
      v("path", {
        d: "M21 11L11 21",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, -1),
      v("path", {
        d: "M21 15L15 21",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, -1),
      v("path", {
        d: "M21 19L19 21",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, -1)
    ])]));
  }
}), JS = { class: "flex min-w-0 items-center gap-4" }, XS = {
  key: 0,
  class: "flex items-center gap-1"
}, ui = /* @__PURE__ */ ye({
  __name: "TextareaFooter",
  props: {
    labels: { default: () => ({}) },
    actions: { default: () => [] },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["send", "action"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => t.labels.send ?? "Send message");
    return (r, o) => (c(), g("div", JS, [
      te(Me, {
        variant: "primary",
        size: "sm",
        label: l.value,
        disabled: e.disabled,
        "data-testid": "field-footer-send",
        onClick: o[0] || (o[0] = (i) => a("send"))
      }, null, 8, ["label", "disabled"]),
      e.actions.length ? (c(), g("div", XS, [
        (c(!0), g(de, null, Re(e.actions, (i) => (c(), W(Me, {
          key: i.id,
          variant: "tertiary",
          size: "xs",
          "icon-only": "",
          "icon-left": i.icon,
          "aria-label": i.label,
          disabled: e.disabled,
          "data-field-footer-action": i.id,
          onClick: (s) => a("action", i.id)
        }, null, 8, ["icon-left", "aria-label", "disabled", "data-field-footer-action", "onClick"]))), 128))
      ])) : w("", !0)
    ]));
  }
}), ZS = ["data-type"], QS = {
  key: 0,
  class: "flex min-w-0 max-w-full items-center gap-1"
}, _S = ["src"], e$ = {
  key: 0,
  class: "flex w-full items-center gap-2 p-2 rounded-(--border-border-radius-rounded-sm) bg-(--background-background-white-secondary) dark:bg-(--background-background-black-default)",
  "data-testid": "textarea-chatroom"
}, t$ = {
  key: 0,
  class: "flex shrink-0 items-center gap-1"
}, n$ = { class: "self-stretch flex flex-1 min-h-0 p-2" }, a$ = ["rows"], l$ = {
  key: 0,
  class: "absolute bottom-2 right-2 flex items-center justify-center"
}, r$ = ["src"], o$ = {
  key: 1,
  class: "text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
}, i$ = {
  key: 1,
  class: "flex items-center gap-4",
  "data-testid": "textarea-footer"
}, s$ = "border border-solid rounded-b-(--border-border-radius-rounded-l) p-[calc(--spacing(2.5)-1px)] border-(--border-border-base-medium) dark:border-(--border-border-base) bg-(--background-background-white) dark:bg-(--background-background-black-default)", Rf = "w-full relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 p-0 text-(length:--size-m) leading-(--line-height-l) placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)", d$ = "w-full relative flex flex-col items-start gap-0.5 pb-0.5 text-left text-(length:--size-m) text-(--text-text-black-default) dark:text-(--colors-text-white-default) font-inter", u$ = /* @__PURE__ */ ye({
  __name: "Textarea",
  props: {
    type: { default: "Default" },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    helpIcon: { default: void 0 },
    placeholder: { default: void 0 },
    showPlaceholder: { type: Boolean, default: void 0 },
    modelValue: { default: "" },
    bottomRightIcon: { default: void 0 },
    helpText: { default: void 0 },
    helpTextIcon: { default: void 0 },
    error: { default: void 0 },
    showError: { type: Boolean, default: void 0 },
    rows: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !0 },
    width: { default: void 0 },
    height: { default: void 0 },
    maxLength: { default: void 0 },
    resizable: { type: Boolean, default: !1 },
    autocomplete: { default: "off" },
    labels: { default: () => ({}) },
    submitLabel: { default: void 0 },
    actions: { default: () => [] }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "send", "action"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = qe(), r = m(() => t.id || l), o = m(() => t.label ? `${r.value}-label` : void 0), i = m(() => `${r.value}-error`), s = m(() => `${r.value}-help`), d = R(!1), u = R(null), f = R(null), b = m(() => t.type === "Chatroom"), h = m(() => t.type === "Buttons inside"), p = m(() => t.type === "Buttons outside"), x = m(() => !!t.error), y = m(() => t.showError !== void 0 ? t.showError : x.value), k = m(() => {
      const X = [];
      return y.value && x.value && X.push(i.value), t.helpText && X.push(s.value), X.length ? X.join(" ") : void 0;
    }), $ = m(() => !!t.modelValue), S = m(() => t.showPlaceholder === !1 ? !1 : t.showPlaceholder === !0 ? !0 : !$.value), T = m(() => S.value ? t.placeholder : void 0), I = R("auto"), A = R(null), E = { send: "Send message", field: "Message" }, D = m(() => ({ ...E, ...t.labels })), z = m(() => {
      const ie = `relative self-stretch box-border flex flex-col items-start justify-between gap-2 border-solid px-[calc(--spacing(1)-1px)] pt-[calc(--spacing(1)-1px)] font-inter ${h.value ? "rounded-t-(--border-border-radius-rounded-l) rounded-b-none border-x border-t border-b-0 pb-1" : "rounded-(--border-border-radius-rounded-l) border pb-[calc(--spacing(1)-1px)]"}`, he = "shadow-[0_0_2px_2px_var(--background-background-hover)]", oe = "shadow-(--blur-shadow-xs)", Ce = "dark:shadow-(--blur-shadow-m-dark)";
      if (t.disabled)
        return `${ie} ${oe} ${Ce} bg-(--background-background-disabled-opacity) dark:bg-(--colors-background-disabled) border-(--border-border-disabled-subtle) dark:border-(--colors-border-disabled-subtle)`;
      if (t.readonly)
        return `${ie} ${oe} ${Ce} bg-(--background-background-white-secondary-soft) dark:bg-(--colors-background-disabled) border-(--border-border-base-soft) dark:border-(--border-border-base)`;
      if (x.value)
        return `${ie} ${d.value ? he : `${oe} ${Ce}`} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error)`;
      if (d.value)
        return `${ie} ${he} bg-(--background-background-selected) dark:bg-(--background-background-black-default) border-(--border-border-accent)`;
      const H = $.value ? "" : oe;
      return `${ie} ${H} ${Ce} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base)`;
    }), Y = m(() => t.disabled ? "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : t.readonly ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : d.value || $.value ? "text-(--text-text-body) dark:text-(--colors-text-white-default)" : "text-(--text-text-body-subtle) dark:text-(--colors-text-white-default)"), le = m(() => !t.fullWidth && t.width ? { width: t.width } : {}), ne = m(() => [
      "flex flex-col",
      p.value ? "gap-4" : "",
      h.value ? "rounded-(--border-border-radius-rounded-l) shadow-(--blur-shadow-xs)" : "",
      "w-full"
    ]), re = m(() => {
      const X = t.height ?? (t.type === "Default" ? "204px" : "184px");
      return t.resizable ? { minHeight: X } : { height: X };
    }), O = m(() => {
      var X;
      if (t.maxLength)
        return ((X = t.modelValue) == null ? void 0 : X.length) || 0;
    }), P = m(() => t.resizable ? "resize-y" : "resize-none"), V = m(() => ({
      id: r.value,
      "data-testid": "textarea",
      name: t.name,
      autocomplete: t.autocomplete,
      value: t.modelValue,
      placeholder: T.value,
      disabled: t.disabled,
      readonly: t.readonly,
      maxlength: t.maxLength,
      "aria-labelledby": o.value,
      // Without `label` or `ariaLabel` the Chatroom field still needs a name: its row has no room for a visible label.
      // `||`, not `??`: an empty `ariaLabel` names nothing (axe aria-input-field-name), so it counts as absent.
      "aria-label": t.label ? void 0 : t.ariaLabel || (b.value ? D.value.field : void 0),
      "aria-required": t.required ? !0 : void 0,
      "aria-invalid": x.value ? !0 : void 0,
      "aria-disabled": t.disabled,
      "aria-describedby": k.value
    })), M = (X) => {
      const ie = X.target;
      a("update:modelValue", ie.value), a("input", X);
    }, B = (X) => {
      t.disabled || (d.value = !0), a("focus", X);
    }, q = (X) => {
      d.value = !1, a("blur", X);
    }, N = (X) => {
      var ie, he;
      (ie = u.value) == null || ie.handleFieldKeydown(X), (he = f.value) == null || he.handleFieldKeydown(X);
    }, G = m(() => t.disabled || t.readonly), U = () => a("send", t.modelValue), K = (X) => a("action", X), ge = () => {
      if (A.value && t.resizable) {
        const X = A.value.offsetHeight;
        X > 0 && (I.value = `${X}px`);
      }
    };
    $e(
      () => t.resizable,
      (X) => {
        X || (I.value = "auto");
      }
    );
    let xe = null;
    return ct(() => {
      t.resizable && A.value && (xe = new ResizeObserver(() => {
        ge();
      }), xe.observe(A.value));
    }), kt(() => {
      xe && xe.disconnect();
    }), $e(
      () => A.value,
      (X) => {
        xe && xe.disconnect(), X && t.resizable && (xe = new ResizeObserver(() => {
          ge();
        }), xe.observe(X));
      }
    ), (X, ie) => (c(), g("div", {
      class: C(d$),
      style: je(le.value),
      "data-type": e.type
    }, [
      e.label ? (c(), g("div", QS, [
        te(It, {
          id: o.value,
          ref_key: "labelRef",
          ref: u,
          text: e.label,
          "input-id": r.value,
          required: e.required,
          "required-indicator": e.requiredIndicator,
          tooltip: e.labelTooltip,
          focused: d.value,
          "test-id": "textarea-label"
        }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused"]),
        e.helpIcon && !e.labelTooltip ? (c(), g("img", {
          key: 0,
          class: "h-3.5 w-3.5 relative textarea-icon",
          src: e.helpIcon,
          alt: ""
        }, null, 8, _S)) : w("", !0)
      ])) : w("", !0),
      v("div", {
        class: C(ne.value),
        "data-testid": "textarea-field"
      }, [
        b.value ? (c(), g("div", e$, [
          e.actions.length ? (c(), g("div", t$, [
            (c(!0), g(de, null, Re(e.actions, (he) => (c(), W(Me, {
              key: he.id,
              variant: "tertiary",
              size: "xs",
              "icon-only": "",
              "icon-left": he.icon,
              "aria-label": he.label,
              disabled: G.value,
              "data-textarea-action": he.id,
              onClick: (oe) => K(he.id)
            }, null, 8, ["icon-left", "aria-label", "disabled", "data-textarea-action", "onClick"]))), 128))
          ])) : w("", !0),
          te(Vn, {
            size: "sm",
            flush: "",
            disabled: e.disabled,
            readonly: e.readonly,
            error: x.value,
            "has-value": $.value,
            class: "min-w-0 flex-1"
          }, {
            default: ve(() => [
              v("textarea", Fe({
                ref_key: "textareaRef",
                ref: A
              }, V.value, {
                rows: "1",
                class: [Rf, Y.value, "h-5 resize-none overflow-hidden px-[calc(--spacing(2.5)-1px)]"],
                onInput: M,
                onFocus: B,
                onBlur: q,
                onKeydown: N
              }), null, 16)
            ]),
            _: 1
          }, 8, ["disabled", "readonly", "error", "has-value"]),
          te(Me, {
            variant: "tertiary",
            size: "xs",
            "icon-only": "",
            "icon-left": "ri-send-plane-2-line",
            "aria-label": D.value.send,
            disabled: G.value,
            "data-testid": "textarea-send",
            onClick: U
          }, null, 8, ["aria-label", "disabled"])
        ])) : (c(), g(de, { key: 1 }, [
          v("div", {
            class: C(z.value),
            style: je(re.value),
            "data-testid": "textarea-box"
          }, [
            v("div", n$, [
              v("textarea", Fe({
                ref_key: "textareaRef",
                ref: A
              }, V.value, {
                rows: e.rows,
                style: { height: I.value },
                class: [Rf, Y.value, P.value],
                onInput: M,
                onFocus: B,
                onBlur: q,
                onKeydown: N
              }), null, 16, a$)
            ]),
            e.bottomRightIcon || e.maxLength || e.resizable ? (c(), g("div", l$, [
              e.bottomRightIcon ? (c(), g("img", {
                key: 0,
                class: "w-[24.2px] h-[24.2px] textarea-icon",
                src: e.bottomRightIcon,
                alt: ""
              }, null, 8, r$)) : e.maxLength ? (c(), g("div", o$, j(O.value) + "/" + j(e.maxLength), 1)) : e.resizable ? (c(), W(Gg, { key: 2 })) : w("", !0)
            ])) : w("", !0)
          ], 6),
          h.value ? (c(), W(ui, {
            key: 0,
            class: C(s$),
            labels: { send: D.value.send },
            actions: e.actions,
            disabled: G.value,
            "data-testid": "textarea-footer",
            onSend: U,
            onAction: K
          }, null, 8, ["labels", "actions", "disabled"])) : w("", !0),
          p.value ? (c(), g("div", i$, [
            te(ui, {
              class: "shrink-0",
              labels: { send: D.value.send },
              actions: e.actions,
              disabled: G.value,
              onSend: U,
              onAction: K
            }, null, 8, ["labels", "actions", "disabled"]),
            te($t, {
              ref_key: "helperRef",
              ref: f,
              class: "min-w-0 flex-1",
              focused: d.value,
              hint: e.helpText,
              error: y.value ? e.error : void 0,
              "hint-id": s.value,
              "error-id": i.value,
              "hint-icon": e.helpTextIcon,
              "test-id-prefix": "textarea"
            }, null, 8, ["focused", "hint", "error", "hint-id", "error-id", "hint-icon"])
          ])) : w("", !0)
        ], 64))
      ], 2),
      p.value ? w("", !0) : (c(), W($t, {
        key: 1,
        ref_key: "helperRef",
        ref: f,
        focused: d.value,
        hint: e.helpText,
        error: y.value ? e.error : void 0,
        "hint-id": s.value,
        "error-id": i.value,
        "hint-icon": e.helpTextIcon,
        "test-id-prefix": "textarea"
      }, null, 8, ["focused", "hint", "error", "hint-id", "error-id", "hint-icon"])),
      e.submitLabel && !h.value && !p.value && !b.value ? (c(), W(Me, {
        key: 2,
        variant: "primary",
        size: "xs",
        label: e.submitLabel,
        disabled: G.value,
        "data-testid": "textarea-submit",
        onClick: U
      }, null, 8, ["label", "disabled"])) : w("", !0)
    ], 12, ZS));
  }
}), sq = /* @__PURE__ */ dt(u$, [["__scopeId", "data-v-d926decc"]]);
function Xt(e) {
  this.content = e;
}
Xt.prototype = {
  constructor: Xt,
  find: function(e) {
    for (var n = 0; n < this.content.length; n += 2)
      if (this.content[n] === e) return n;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(e) {
    var n = this.find(e);
    return n == -1 ? void 0 : this.content[n + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(e, n, t) {
    var a = t && t != e ? this.remove(t) : this, l = a.find(e), r = a.content.slice();
    return l == -1 ? r.push(t || e, n) : (r[l + 1] = n, t && (r[l] = t)), new Xt(r);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(e) {
    var n = this.find(e);
    if (n == -1) return this;
    var t = this.content.slice();
    return t.splice(n, 2), new Xt(t);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(e, n) {
    return new Xt([e, n].concat(this.remove(e).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(e, n) {
    var t = this.remove(e).content.slice();
    return t.push(e, n), new Xt(t);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(e, n, t) {
    var a = this.remove(n), l = a.content.slice(), r = a.find(e);
    return l.splice(r == -1 ? l.length : r, 0, n, t), new Xt(l);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(e) {
    for (var n = 0; n < this.content.length; n += 2)
      e(this.content[n], this.content[n + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(e) {
    return e = Xt.from(e), e.size ? new Xt(e.content.concat(this.subtract(e).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(e) {
    return e = Xt.from(e), e.size ? new Xt(this.subtract(e).content.concat(e.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(e) {
    var n = this;
    e = Xt.from(e);
    for (var t = 0; t < e.content.length; t += 2)
      n = n.remove(e.content[t]);
    return n;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var e = {};
    return this.forEach(function(n, t) {
      e[n] = t;
    }), e;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
Xt.from = function(e) {
  if (e instanceof Xt) return e;
  var n = [];
  if (e) for (var t in e) n.push(t, e[t]);
  return new Xt(n);
};
function Kg(e, n, t) {
  for (let a = 0; ; a++) {
    if (a == e.childCount || a == n.childCount)
      return e.childCount == n.childCount ? null : t;
    let l = e.child(a), r = n.child(a);
    if (l == r) {
      t += l.nodeSize;
      continue;
    }
    if (!l.sameMarkup(r))
      return t;
    if (l.isText && l.text != r.text) {
      for (let o = 0; l.text[o] == r.text[o]; o++)
        t++;
      return t;
    }
    if (l.content.size || r.content.size) {
      let o = Kg(l.content, r.content, t + 1);
      if (o != null)
        return o;
    }
    t += l.nodeSize;
  }
}
function Yg(e, n, t, a) {
  for (let l = e.childCount, r = n.childCount; ; ) {
    if (l == 0 || r == 0)
      return l == r ? null : { a: t, b: a };
    let o = e.child(--l), i = n.child(--r), s = o.nodeSize;
    if (o == i) {
      t -= s, a -= s;
      continue;
    }
    if (!o.sameMarkup(i))
      return { a: t, b: a };
    if (o.isText && o.text != i.text) {
      let d = 0, u = Math.min(o.text.length, i.text.length);
      for (; d < u && o.text[o.text.length - d - 1] == i.text[i.text.length - d - 1]; )
        d++, t--, a--;
      return { a: t, b: a };
    }
    if (o.content.size || i.content.size) {
      let d = Yg(o.content, i.content, t - 1, a - 1);
      if (d)
        return d;
    }
    t -= s, a -= s;
  }
}
class Ve {
  /**
  @internal
  */
  constructor(n, t) {
    if (this.content = n, this.size = t || 0, t == null)
      for (let a = 0; a < n.length; a++)
        this.size += n[a].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(n, t, a, l = 0, r) {
    for (let o = 0, i = 0; i < t; o++) {
      let s = this.content[o], d = i + s.nodeSize;
      if (d > n && a(s, l + i, r || null, o) !== !1 && s.content.size) {
        let u = i + 1;
        s.nodesBetween(Math.max(0, n - u), Math.min(s.content.size, t - u), a, l + u);
      }
      i = d;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(n) {
    this.nodesBetween(0, this.size, n);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(n, t, a, l) {
    let r = "", o = !0;
    return this.nodesBetween(n, t, (i, s) => {
      let d = i.isText ? i.text.slice(Math.max(n, s) - s, t - s) : i.isLeaf ? l ? typeof l == "function" ? l(i) : l : i.type.spec.leafText ? i.type.spec.leafText(i) : "" : "";
      i.isBlock && (i.isLeaf && d || i.isTextblock) && a && (o ? o = !1 : r += a), r += d;
    }, 0), r;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(n) {
    if (!n.size)
      return this;
    if (!this.size)
      return n;
    let t = this.lastChild, a = n.firstChild, l = this.content.slice(), r = 0;
    for (t.isText && t.sameMarkup(a) && (l[l.length - 1] = t.withText(t.text + a.text), r = 1); r < n.content.length; r++)
      l.push(n.content[r]);
    return new Ve(l, this.size + n.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(n, t = this.size) {
    if (n == 0 && t == this.size)
      return this;
    let a = [], l = 0;
    if (t > n)
      for (let r = 0, o = 0; o < t; r++) {
        let i = this.content[r], s = o + i.nodeSize;
        s > n && ((o < n || s > t) && (i.isText ? i = i.cut(Math.max(0, n - o), Math.min(i.text.length, t - o)) : i = i.cut(Math.max(0, n - o - 1), Math.min(i.content.size, t - o - 1))), a.push(i), l += i.nodeSize), o = s;
      }
    return new Ve(a, l);
  }
  /**
  @internal
  */
  cutByIndex(n, t) {
    return n == t ? Ve.empty : n == 0 && t == this.content.length ? this : new Ve(this.content.slice(n, t));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(n, t) {
    let a = this.content[n];
    if (a == t)
      return this;
    let l = this.content.slice(), r = this.size + t.nodeSize - a.nodeSize;
    return l[n] = t, new Ve(l, r);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(n) {
    return new Ve([n].concat(this.content), this.size + n.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(n) {
    return new Ve(this.content.concat(n), this.size + n.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(n) {
    if (this.content.length != n.content.length)
      return !1;
    for (let t = 0; t < this.content.length; t++)
      if (!this.content[t].eq(n.content[t]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(n) {
    let t = this.content[n];
    if (!t)
      throw new RangeError("Index " + n + " out of range for " + this);
    return t;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(n) {
    return this.content[n] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(n) {
    for (let t = 0, a = 0; t < this.content.length; t++) {
      let l = this.content[t];
      n(l, a, t), a += l.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(n, t = 0) {
    return Kg(this, n, t);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(n, t = this.size, a = n.size) {
    return Yg(this, n, t, a);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(n) {
    if (n == 0)
      return Io(0, n);
    if (n == this.size)
      return Io(this.content.length, n);
    if (n > this.size || n < 0)
      throw new RangeError(`Position ${n} outside of fragment (${this})`);
    for (let t = 0, a = 0; ; t++) {
      let l = this.child(t), r = a + l.nodeSize;
      if (r >= n)
        return r == n ? Io(t + 1, r) : Io(t, a);
      a = r;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((n) => n.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(n, t) {
    if (!t)
      return Ve.empty;
    if (!Array.isArray(t))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return Ve.fromArray(t.map(n.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(n) {
    if (!n.length)
      return Ve.empty;
    let t, a = 0;
    for (let l = 0; l < n.length; l++) {
      let r = n[l];
      a += r.nodeSize, l && r.isText && n[l - 1].sameMarkup(r) ? (t || (t = n.slice(0, l)), t[t.length - 1] = r.withText(t[t.length - 1].text + r.text)) : t && t.push(r);
    }
    return new Ve(t || n, a);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(n) {
    if (!n)
      return Ve.empty;
    if (n instanceof Ve)
      return n;
    if (Array.isArray(n))
      return this.fromArray(n);
    if (n.attrs)
      return new Ve([n], n.nodeSize);
    throw new RangeError("Can not convert " + n + " to a Fragment" + (n.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
Ve.empty = new Ve([], 0);
const Fs = { index: 0, offset: 0 };
function Io(e, n) {
  return Fs.index = e, Fs.offset = n, Fs;
}
function ci(e, n) {
  if (e === n)
    return !0;
  if (!(e && typeof e == "object") || !(n && typeof n == "object"))
    return !1;
  let t = Array.isArray(e);
  if (Array.isArray(n) != t)
    return !1;
  if (t) {
    if (e.length != n.length)
      return !1;
    for (let a = 0; a < e.length; a++)
      if (!ci(e[a], n[a]))
        return !1;
  } else {
    for (let a in e)
      if (!(a in n) || !ci(e[a], n[a]))
        return !1;
    for (let a in n)
      if (!(a in e))
        return !1;
  }
  return !0;
}
let Ct = class Vd {
  /**
  @internal
  */
  constructor(n, t) {
    this.type = n, this.attrs = t;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(n) {
    let t, a = !1;
    for (let l = 0; l < n.length; l++) {
      let r = n[l];
      if (this.eq(r))
        return n;
      if (this.type.excludes(r.type))
        t || (t = n.slice(0, l));
      else {
        if (r.type.excludes(this.type))
          return n;
        !a && r.type.rank > this.type.rank && (t || (t = n.slice(0, l)), t.push(this), a = !0), t && t.push(r);
      }
    }
    return t || (t = n.slice()), a || t.push(this), t;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(n) {
    for (let t = 0; t < n.length; t++)
      if (this.eq(n[t]))
        return n.slice(0, t).concat(n.slice(t + 1));
    return n;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(n) {
    for (let t = 0; t < n.length; t++)
      if (this.eq(n[t]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(n) {
    return this == n || this.type == n.type && ci(this.attrs, n.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let n = { type: this.type.name };
    for (let t in this.attrs) {
      n.attrs = this.attrs;
      break;
    }
    return n;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(n, t) {
    if (!t)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let a = n.marks[t.type];
    if (!a)
      throw new RangeError(`There is no mark type ${t.type} in this schema`);
    let l = a.create(t.attrs);
    return a.checkAttrs(l.attrs), l;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(n, t) {
    if (n == t)
      return !0;
    if (n.length != t.length)
      return !1;
    for (let a = 0; a < n.length; a++)
      if (!n[a].eq(t[a]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(n) {
    if (!n || Array.isArray(n) && n.length == 0)
      return Vd.none;
    if (n instanceof Vd)
      return [n];
    let t = n.slice();
    return t.sort((a, l) => a.type.rank - l.type.rank), t;
  }
};
Ct.none = [];
class fi extends Error {
}
class Xe {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(n, t, a) {
    this.content = n, this.openStart = t, this.openEnd = a;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(n, t) {
    let a = Xg(this.content, n + this.openStart, t, this.openStart + 1, this.openEnd + 1);
    return a && new Xe(a, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(n, t) {
    return new Xe(Jg(this.content, n + this.openStart, t + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(n) {
    return this.content.eq(n.content) && this.openStart == n.openStart && this.openEnd == n.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let n = { content: this.content.toJSON() };
    return this.openStart > 0 && (n.openStart = this.openStart), this.openEnd > 0 && (n.openEnd = this.openEnd), n;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(n, t) {
    if (!t)
      return Xe.empty;
    let a = t.openStart || 0, l = t.openEnd || 0;
    if (typeof a != "number" || typeof l != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new Xe(Ve.fromJSON(n, t.content), a, l);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(n, t = !0) {
    let a = 0, l = 0;
    for (let r = n.firstChild; r && !r.isLeaf && (t || !r.type.spec.isolating); r = r.firstChild)
      a++;
    for (let r = n.lastChild; r && !r.isLeaf && (t || !r.type.spec.isolating); r = r.lastChild)
      l++;
    return new Xe(n, a, l);
  }
}
Xe.empty = new Xe(Ve.empty, 0, 0);
function Jg(e, n, t) {
  let { index: a, offset: l } = e.findIndex(n), r = e.maybeChild(a), { index: o, offset: i } = e.findIndex(t);
  if (l == n || r.isText) {
    if (i != t && !e.child(o).isText)
      throw new RangeError("Removing non-flat range");
    return e.cut(0, n).append(e.cut(t));
  }
  if (a != o)
    throw new RangeError("Removing non-flat range");
  return e.replaceChild(a, r.copy(Jg(r.content, n - l - 1, t - l - 1)));
}
function Xg(e, n, t, a, l, r) {
  let { index: o, offset: i } = e.findIndex(n), s = e.maybeChild(o);
  if (i == n || s.isText)
    return r && a <= 0 && l <= 0 && !r.canReplace(o, o, t) ? null : e.cut(0, n).append(t).append(e.cut(n));
  let d = Xg(s.content, n - i - 1, t, o == 0 ? a - 1 : 0, o == e.childCount - 1 ? l - 1 : 0, s);
  return d && e.replaceChild(o, s.copy(d));
}
function c$(e, n, t) {
  if (t.openStart > e.depth)
    throw new fi("Inserted content deeper than insertion position");
  if (e.depth - t.openStart != n.depth - t.openEnd)
    throw new fi("Inconsistent open depths");
  return Zg(e, n, t, 0);
}
function Zg(e, n, t, a) {
  let l = e.index(a), r = e.node(a);
  if (l == n.index(a) && a < e.depth - t.openStart) {
    let o = Zg(e, n, t, a + 1);
    return r.copy(r.content.replaceChild(l, o));
  } else if (t.content.size)
    if (!t.openStart && !t.openEnd && e.depth == a && n.depth == a) {
      let o = e.parent, i = o.content;
      return fl(o, i.cut(0, e.parentOffset).append(t.content).append(i.cut(n.parentOffset)));
    } else {
      let { start: o, end: i } = f$(t, e);
      return fl(r, _g(e, o, i, n, a));
    }
  else return fl(r, hi(e, n, a));
}
function Qg(e, n) {
  if (!n.type.compatibleContent(e.type))
    throw new fi("Cannot join " + n.type.name + " onto " + e.type.name);
}
function Nd(e, n, t) {
  let a = e.node(t);
  return Qg(a, n.node(t)), a;
}
function cl(e, n) {
  let t = n.length - 1;
  t >= 0 && e.isText && e.sameMarkup(n[t]) ? n[t] = e.withText(n[t].text + e.text) : n.push(e);
}
function Er(e, n, t, a) {
  let l = (n || e).node(t), r = 0, o = n ? n.index(t) : l.childCount;
  e && (r = e.index(t), e.depth > t ? r++ : e.textOffset && (cl(e.nodeAfter, a), r++));
  for (let i = r; i < o; i++)
    cl(l.child(i), a);
  n && n.depth == t && n.textOffset && cl(n.nodeBefore, a);
}
function fl(e, n) {
  return e.type.checkContent(n), e.copy(n);
}
function _g(e, n, t, a, l) {
  let r = e.depth > l && Nd(e, n, l + 1), o = a.depth > l && Nd(t, a, l + 1), i = [];
  return Er(null, e, l, i), r && o && n.index(l) == t.index(l) ? (Qg(r, o), cl(fl(r, _g(e, n, t, a, l + 1)), i)) : (r && cl(fl(r, hi(e, n, l + 1)), i), Er(n, t, l, i), o && cl(fl(o, hi(t, a, l + 1)), i)), Er(a, null, l, i), new Ve(i);
}
function hi(e, n, t) {
  let a = [];
  if (Er(null, e, t, a), e.depth > t) {
    let l = Nd(e, n, t + 1);
    cl(fl(l, hi(e, n, t + 1)), a);
  }
  return Er(n, null, t, a), new Ve(a);
}
function f$(e, n) {
  let t = n.depth - e.openStart, l = n.node(t).copy(e.content);
  for (let r = t - 1; r >= 0; r--)
    l = n.node(r).copy(Ve.from(l));
  return {
    start: l.resolveNoCache(e.openStart + t),
    end: l.resolveNoCache(l.content.size - e.openEnd - t)
  };
}
class Jr {
  /**
  @internal
  */
  constructor(n, t, a) {
    this.pos = n, this.path = t, this.parentOffset = a, this.depth = t.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(n) {
    return n == null ? this.depth : n < 0 ? this.depth + n : n;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(n) {
    return this.path[this.resolveDepth(n) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(n) {
    return this.path[this.resolveDepth(n) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(n) {
    return n = this.resolveDepth(n), this.index(n) + (n == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(n) {
    return n = this.resolveDepth(n), n == 0 ? 0 : this.path[n * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(n) {
    return n = this.resolveDepth(n), this.start(n) + this.node(n).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(n) {
    if (n = this.resolveDepth(n), !n)
      throw new RangeError("There is no position before the top-level node");
    return n == this.depth + 1 ? this.pos : this.path[n * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(n) {
    if (n = this.resolveDepth(n), !n)
      throw new RangeError("There is no position after the top-level node");
    return n == this.depth + 1 ? this.pos : this.path[n * 3 - 1] + this.path[n * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let n = this.parent, t = this.index(this.depth);
    if (t == n.childCount)
      return null;
    let a = this.pos - this.path[this.path.length - 1], l = n.child(t);
    return a ? n.child(t).cut(a) : l;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let n = this.index(this.depth), t = this.pos - this.path[this.path.length - 1];
    return t ? this.parent.child(n).cut(0, t) : n == 0 ? null : this.parent.child(n - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(n, t) {
    t = this.resolveDepth(t);
    let a = this.path[t * 3], l = t == 0 ? 0 : this.path[t * 3 - 1] + 1;
    for (let r = 0; r < n; r++)
      l += a.child(r).nodeSize;
    return l;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let n = this.parent, t = this.index();
    if (n.content.size == 0)
      return Ct.none;
    if (this.textOffset)
      return n.child(t).marks;
    let a = n.maybeChild(t - 1), l = n.maybeChild(t);
    if (!a) {
      let i = a;
      a = l, l = i;
    }
    let r = a.marks;
    for (var o = 0; o < r.length; o++)
      r[o].type.spec.inclusive === !1 && (!l || !r[o].isInSet(l.marks)) && (r = r[o--].removeFromSet(r));
    return r;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(n) {
    let t = this.parent.maybeChild(this.index());
    if (!t || !t.isInline)
      return null;
    let a = t.marks, l = n.parent.maybeChild(n.index());
    for (var r = 0; r < a.length; r++)
      a[r].type.spec.inclusive === !1 && (!l || !a[r].isInSet(l.marks)) && (a = a[r--].removeFromSet(a));
    return a;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(n) {
    for (let t = this.depth; t > 0; t--)
      if (this.start(t) <= n && this.end(t) >= n)
        return t;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(n = this, t) {
    if (n.pos < this.pos)
      return n.blockRange(this);
    for (let a = this.depth - (this.parent.inlineContent || this.pos == n.pos ? 1 : 0); a >= 0; a--)
      if (n.pos <= this.end(a) && (!t || t(this.node(a))))
        return new bi(this, n, a);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(n) {
    return this.pos - this.parentOffset == n.pos - n.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(n) {
    return n.pos > this.pos ? n : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(n) {
    return n.pos < this.pos ? n : this;
  }
  /**
  @internal
  */
  toString() {
    let n = "";
    for (let t = 1; t <= this.depth; t++)
      n += (n ? "/" : "") + this.node(t).type.name + "_" + this.index(t - 1);
    return n + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(n, t) {
    if (!(t >= 0 && t <= n.content.size))
      throw new RangeError("Position " + t + " out of range");
    let a = [], l = 0, r = t;
    for (let o = n; ; ) {
      let { index: i, offset: s } = o.content.findIndex(r), d = r - s;
      if (a.push(o, i, l + s), !d || (o = o.child(i), o.isText))
        break;
      r = d - 1, l += s + 1;
    }
    return new Jr(t, a, r);
  }
  /**
  @internal
  */
  static resolveCached(n, t) {
    let a = Bf.get(n);
    if (a)
      for (let r = 0; r < a.elts.length; r++) {
        let o = a.elts[r];
        if (o.pos == t)
          return o;
      }
    else
      Bf.set(n, a = new h$());
    let l = a.elts[a.i] = Jr.resolve(n, t);
    return a.i = (a.i + 1) % b$, l;
  }
}
class h$ {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const b$ = 12, Bf = /* @__PURE__ */ new WeakMap();
class bi {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(n, t, a) {
    this.$from = n, this.$to = t, this.depth = a;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const g$ = /* @__PURE__ */ Object.create(null);
let Oa = class Hd {
  /**
  @internal
  */
  constructor(n, t, a, l = Ct.none) {
    this.type = n, this.attrs = t, this.marks = l, this.content = a || Ve.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(n) {
    return this.content.child(n);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(n) {
    return this.content.maybeChild(n);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(n) {
    this.content.forEach(n);
  }
  /**
  Invoke a callback for all descendant nodes recursively overlapping
  the given two positions that are relative to start of this
  node's content. This includes all ancestors of the nodes
  containing the two positions. The callback is invoked with the
  node, its position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(n, t, a, l = 0) {
    this.content.nodesBetween(n, t, a, l, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(n) {
    this.nodesBetween(0, this.content.size, n);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
  */
  textBetween(n, t, a, l) {
    return this.content.textBetween(n, t, a, l);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(n) {
    return this == n || this.sameMarkup(n) && this.content.eq(n.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(n) {
    return this.hasMarkup(n.type, n.attrs, n.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(n, t, a) {
    return this.type == n && ci(this.attrs, t || n.defaultAttrs || g$) && Ct.sameSet(this.marks, a || Ct.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(n = null) {
    return n == this.content ? this : new Hd(this.type, this.attrs, n, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(n) {
    return n == this.marks ? this : new Hd(this.type, this.attrs, this.content, n);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(n, t = this.content.size) {
    return n == 0 && t == this.content.size ? this : this.copy(this.content.cut(n, t));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(n, t = this.content.size, a = !1) {
    if (n == t)
      return Xe.empty;
    let l = this.resolve(n), r = this.resolve(t), o = a ? 0 : l.sharedDepth(t), i = l.start(o), d = l.node(o).content.cut(l.pos - i, r.pos - i);
    return new Xe(d, l.depth - o, r.depth - o);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(n, t, a) {
    return c$(this.resolve(n), this.resolve(t), a);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(n) {
    for (let t = this; ; ) {
      let { index: a, offset: l } = t.content.findIndex(n);
      if (t = t.maybeChild(a), !t)
        return null;
      if (l == n || t.isText)
        return t;
      n -= l + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(n) {
    let { index: t, offset: a } = this.content.findIndex(n);
    return { node: this.content.maybeChild(t), index: t, offset: a };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(n) {
    if (n == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: t, offset: a } = this.content.findIndex(n);
    if (a < n)
      return { node: this.content.child(t), index: t, offset: a };
    let l = this.content.child(t - 1);
    return { node: l, index: t - 1, offset: a - l.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(n) {
    return Jr.resolveCached(this, n);
  }
  /**
  @internal
  */
  resolveNoCache(n) {
    return Jr.resolve(this, n);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(n, t, a) {
    let l = !1;
    return t > n && this.nodesBetween(n, t, (r) => (a.isInSet(r.marks) && (l = !0), !l)), l;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let n = this.type.name;
    return this.content.size && (n += "(" + this.content.toStringInner() + ")"), em(this.marks, n);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(n) {
    let t = this.type.contentMatch.matchFragment(this.content, 0, n);
    if (!t)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return t;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(n, t, a = Ve.empty, l = 0, r = a.childCount) {
    let o = this.contentMatchAt(n).matchFragment(a, l, r), i = o && o.matchFragment(this.content, t);
    if (!i || !i.validEnd)
      return !1;
    for (let s = l; s < r; s++)
      if (!this.type.allowsMarks(a.child(s).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(n, t, a, l) {
    if (l && !this.type.allowsMarks(l))
      return !1;
    let r = this.contentMatchAt(n).matchType(a), o = r && r.matchFragment(this.content, t);
    return o ? o.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(n) {
    return n.content.size ? this.canReplace(this.childCount, this.childCount, n.content) : this.type.compatibleContent(n.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let n = Ct.none;
    for (let t = 0; t < this.marks.length; t++) {
      let a = this.marks[t];
      a.type.checkAttrs(a.attrs), n = a.addToSet(n);
    }
    if (!Ct.sameSet(n, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((t) => t.type.name)}`);
    this.content.forEach((t) => t.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let n = { type: this.type.name };
    for (let t in this.attrs) {
      n.attrs = this.attrs;
      break;
    }
    return this.content.size && (n.content = this.content.toJSON()), this.marks.length && (n.marks = this.marks.map((t) => t.toJSON())), n;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(n, t) {
    if (!t)
      throw new RangeError("Invalid input for Node.fromJSON");
    let a;
    if (t.marks) {
      if (!Array.isArray(t.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      a = t.marks.map(n.markFromJSON);
    }
    if (t.type == "text") {
      if (typeof t.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return n.text(t.text, a);
    }
    let l = Ve.fromJSON(n, t.content), r = n.nodeType(t.type).create(t.attrs, l, a);
    return r.type.checkAttrs(r.attrs), r;
  }
};
Oa.prototype.text = void 0;
class gi extends Oa {
  /**
  @internal
  */
  constructor(n, t, a, l) {
    if (super(n, t, null, l), !a)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = a;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : em(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(n, t) {
    return this.text.slice(n, t);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(n) {
    return n == this.marks ? this : new gi(this.type, this.attrs, this.text, n);
  }
  withText(n) {
    return n == this.text ? this : new gi(this.type, this.attrs, n, this.marks);
  }
  cut(n = 0, t = this.text.length) {
    return n == 0 && t == this.text.length ? this : this.withText(this.text.slice(n, t));
  }
  eq(n) {
    return this.sameMarkup(n) && this.text == n.text;
  }
  toJSON() {
    let n = super.toJSON();
    return n.text = this.text, n;
  }
}
function em(e, n) {
  for (let t = e.length - 1; t >= 0; t--)
    n = e[t].type.name + "(" + n + ")";
  return n;
}
class xl {
  /**
  @internal
  */
  constructor(n) {
    this.validEnd = n, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(n, t) {
    let a = new m$(n, t);
    if (a.next == null)
      return xl.empty;
    let l = tm(a);
    a.next && a.err("Unexpected trailing text");
    let r = C$(w$(l));
    return S$(r, a), r;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(n) {
    for (let t = 0; t < this.next.length; t++)
      if (this.next[t].type == n)
        return this.next[t].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(n, t = 0, a = n.childCount) {
    let l = this;
    for (let r = t; l && r < a; r++)
      l = l.matchType(n.child(r).type);
    return l;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let n = 0; n < this.next.length; n++) {
      let { type: t } = this.next[n];
      if (!(t.isText || t.hasRequiredAttrs()))
        return t;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(n) {
    for (let t = 0; t < this.next.length; t++)
      for (let a = 0; a < n.next.length; a++)
        if (this.next[t].type == n.next[a].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(n, t = !1, a = 0) {
    let l = [this];
    function r(o, i) {
      let s = o.matchFragment(n, a);
      if (s && (!t || s.validEnd))
        return Ve.from(i.map((d) => d.createAndFill()));
      for (let d = 0; d < o.next.length; d++) {
        let { type: u, next: f } = o.next[d];
        if (!(u.isText || u.hasRequiredAttrs()) && l.indexOf(f) == -1) {
          l.push(f);
          let b = r(f, i.concat(u));
          if (b)
            return b;
        }
      }
      return null;
    }
    return r(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(n) {
    for (let a = 0; a < this.wrapCache.length; a += 2)
      if (this.wrapCache[a] == n)
        return this.wrapCache[a + 1];
    let t = this.computeWrapping(n);
    return this.wrapCache.push(n, t), t;
  }
  /**
  @internal
  */
  computeWrapping(n) {
    let t = /* @__PURE__ */ Object.create(null), a = [{ match: this, type: null, via: null }];
    for (; a.length; ) {
      let l = a.shift(), r = l.match;
      if (r.matchType(n)) {
        let o = [];
        for (let i = l; i.type; i = i.via)
          o.push(i.type);
        return o.reverse();
      }
      for (let o = 0; o < r.next.length; o++) {
        let { type: i, next: s } = r.next[o];
        !i.isLeaf && !i.hasRequiredAttrs() && !(i.name in t) && (!l.type || s.validEnd) && (a.push({ match: i.contentMatch, type: i, via: l }), t[i.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(n) {
    if (n >= this.next.length)
      throw new RangeError(`There's no ${n}th edge in this content match`);
    return this.next[n];
  }
  /**
  @internal
  */
  toString() {
    let n = [];
    function t(a) {
      n.push(a);
      for (let l = 0; l < a.next.length; l++)
        n.indexOf(a.next[l].next) == -1 && t(a.next[l].next);
    }
    return t(this), n.map((a, l) => {
      let r = l + (a.validEnd ? "*" : " ") + " ";
      for (let o = 0; o < a.next.length; o++)
        r += (o ? ", " : "") + a.next[o].type.name + "->" + n.indexOf(a.next[o].next);
      return r;
    }).join(`
`);
  }
}
xl.empty = new xl(!0);
class m$ {
  constructor(n, t) {
    this.string = n, this.nodeTypes = t, this.inline = null, this.pos = 0, this.tokens = n.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(n) {
    return this.next == n && (this.pos++ || !0);
  }
  err(n) {
    throw new SyntaxError(n + " (in content expression '" + this.string + "')");
  }
}
function tm(e) {
  let n = [];
  do
    n.push(p$(e));
  while (e.eat("|"));
  return n.length == 1 ? n[0] : { type: "choice", exprs: n };
}
function p$(e) {
  let n = [];
  do
    n.push(v$(e));
  while (e.next && e.next != ")" && e.next != "|");
  return n.length == 1 ? n[0] : { type: "seq", exprs: n };
}
function v$(e) {
  let n = k$(e);
  for (; ; )
    if (e.eat("+"))
      n = { type: "plus", expr: n };
    else if (e.eat("*"))
      n = { type: "star", expr: n };
    else if (e.eat("?"))
      n = { type: "opt", expr: n };
    else if (e.eat("{"))
      n = x$(e, n);
    else
      break;
  return n;
}
function Mf(e) {
  /\D/.test(e.next) && e.err("Expected number, got '" + e.next + "'");
  let n = Number(e.next);
  return e.pos++, n;
}
function x$(e, n) {
  let t = Mf(e), a = t;
  return e.eat(",") && (e.next != "}" ? a = Mf(e) : a = -1), e.eat("}") || e.err("Unclosed braced range"), { type: "range", min: t, max: a, expr: n };
}
function y$(e, n) {
  let t = e.nodeTypes, a = t[n];
  if (a)
    return [a];
  let l = [];
  for (let r in t) {
    let o = t[r];
    o.isInGroup(n) && l.push(o);
  }
  return l.length == 0 && e.err("No node type or group '" + n + "' found"), l;
}
function k$(e) {
  if (e.eat("(")) {
    let n = tm(e);
    return e.eat(")") || e.err("Missing closing paren"), n;
  } else if (/\W/.test(e.next))
    e.err("Unexpected token '" + e.next + "'");
  else {
    let n = y$(e, e.next).map((t) => (e.inline == null ? e.inline = t.isInline : e.inline != t.isInline && e.err("Mixing inline and block content"), { type: "name", value: t }));
    return e.pos++, n.length == 1 ? n[0] : { type: "choice", exprs: n };
  }
}
function w$(e) {
  let n = [[]];
  return l(r(e, 0), t()), n;
  function t() {
    return n.push([]) - 1;
  }
  function a(o, i, s) {
    let d = { term: s, to: i };
    return n[o].push(d), d;
  }
  function l(o, i) {
    o.forEach((s) => s.to = i);
  }
  function r(o, i) {
    if (o.type == "choice")
      return o.exprs.reduce((s, d) => s.concat(r(d, i)), []);
    if (o.type == "seq")
      for (let s = 0; ; s++) {
        let d = r(o.exprs[s], i);
        if (s == o.exprs.length - 1)
          return d;
        l(d, i = t());
      }
    else if (o.type == "star") {
      let s = t();
      return a(i, s), l(r(o.expr, s), s), [a(s)];
    } else if (o.type == "plus") {
      let s = t();
      return l(r(o.expr, i), s), l(r(o.expr, s), s), [a(s)];
    } else {
      if (o.type == "opt")
        return [a(i)].concat(r(o.expr, i));
      if (o.type == "range") {
        let s = i;
        for (let d = 0; d < o.min; d++) {
          let u = t();
          l(r(o.expr, s), u), s = u;
        }
        if (o.max == -1)
          l(r(o.expr, s), s);
        else
          for (let d = o.min; d < o.max; d++) {
            let u = t();
            a(s, u), l(r(o.expr, s), u), s = u;
          }
        return [a(s)];
      } else {
        if (o.type == "name")
          return [a(i, void 0, o.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function nm(e, n) {
  return n - e;
}
function Df(e, n) {
  let t = [];
  return a(n), t.sort(nm);
  function a(l) {
    let r = e[l];
    if (r.length == 1 && !r[0].term)
      return a(r[0].to);
    t.push(l);
    for (let o = 0; o < r.length; o++) {
      let { term: i, to: s } = r[o];
      !i && t.indexOf(s) == -1 && a(s);
    }
  }
}
function C$(e) {
  let n = /* @__PURE__ */ Object.create(null);
  return t(Df(e, 0));
  function t(a) {
    let l = [];
    a.forEach((o) => {
      e[o].forEach(({ term: i, to: s }) => {
        if (!i)
          return;
        let d;
        for (let u = 0; u < l.length; u++)
          l[u][0] == i && (d = l[u][1]);
        Df(e, s).forEach((u) => {
          d || l.push([i, d = []]), d.indexOf(u) == -1 && d.push(u);
        });
      });
    });
    let r = n[a.join(",")] = new xl(a.indexOf(e.length - 1) > -1);
    for (let o = 0; o < l.length; o++) {
      let i = l[o][1].sort(nm);
      r.next.push({ type: l[o][0], next: n[i.join(",")] || t(i) });
    }
    return r;
  }
}
function S$(e, n) {
  for (let t = 0, a = [e]; t < a.length; t++) {
    let l = a[t], r = !l.validEnd, o = [];
    for (let i = 0; i < l.next.length; i++) {
      let { type: s, next: d } = l.next[i];
      o.push(s.name), r && !(s.isText || s.hasRequiredAttrs()) && (r = !1), a.indexOf(d) == -1 && a.push(d);
    }
    r && n.err("Only non-generatable nodes (" + o.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function am(e) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let t in e) {
    let a = e[t];
    if (!a.hasDefault)
      return null;
    n[t] = a.default;
  }
  return n;
}
function lm(e, n) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let a in e) {
    let l = n && n[a];
    if (l === void 0) {
      let r = e[a];
      if (r.hasDefault)
        l = r.default;
      else
        throw new RangeError("No value supplied for attribute " + a);
    }
    t[a] = l;
  }
  return t;
}
function rm(e, n, t, a) {
  for (let l in n)
    if (!(l in e))
      throw new RangeError(`Unsupported attribute ${l} for ${t} of type ${l}`);
  for (let l in e) {
    let r = e[l];
    r.validate && r.validate(n[l]);
  }
}
function om(e, n) {
  let t = /* @__PURE__ */ Object.create(null);
  if (n)
    for (let a in n)
      t[a] = new I$(e, a, n[a]);
  return t;
}
let zf = class im {
  /**
  @internal
  */
  constructor(n, t, a) {
    this.name = n, this.schema = t, this.spec = a, this.markSet = null, this.groups = a.group ? a.group.split(" ") : [], this.attrs = om(n, a.attrs), this.defaultAttrs = am(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(a.inline || n == "text"), this.isText = n == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == xl.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(n) {
    return this.groups.indexOf(n) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let n in this.attrs)
      if (this.attrs[n].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(n) {
    return this == n || this.contentMatch.compatible(n.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(n) {
    return !n && this.defaultAttrs ? this.defaultAttrs : lm(this.attrs, n);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(n = null, t, a) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new Oa(this, this.computeAttrs(n), Ve.from(t), Ct.setFrom(a));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(n = null, t, a) {
    return t = Ve.from(t), this.checkContent(t), new Oa(this, this.computeAttrs(n), t, Ct.setFrom(a));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(n = null, t, a) {
    if (n = this.computeAttrs(n), t = Ve.from(t), t.size) {
      let o = this.contentMatch.fillBefore(t);
      if (!o)
        return null;
      t = o.append(t);
    }
    let l = this.contentMatch.matchFragment(t), r = l && l.fillBefore(Ve.empty, !0);
    return r ? new Oa(this, n, t.append(r), Ct.setFrom(a)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(n) {
    let t = this.contentMatch.matchFragment(n);
    if (!t || !t.validEnd)
      return !1;
    for (let a = 0; a < n.childCount; a++)
      if (!this.allowsMarks(n.child(a).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(n) {
    if (!this.validContent(n))
      throw new RangeError(`Invalid content for node ${this.name}: ${n.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(n) {
    rm(this.attrs, n, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(n) {
    return this.markSet == null || this.markSet.indexOf(n) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(n) {
    if (this.markSet == null)
      return !0;
    for (let t = 0; t < n.length; t++)
      if (!this.allowsMarkType(n[t].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(n) {
    if (this.markSet == null)
      return n;
    let t;
    for (let a = 0; a < n.length; a++)
      this.allowsMarkType(n[a].type) ? t && t.push(n[a]) : t || (t = n.slice(0, a));
    return t ? t.length ? t : Ct.none : n;
  }
  /**
  @internal
  */
  static compile(n, t) {
    let a = /* @__PURE__ */ Object.create(null);
    n.forEach((r, o) => a[r] = new im(r, t, o));
    let l = t.spec.topNode || "doc";
    if (!a[l])
      throw new RangeError("Schema is missing its top node type ('" + l + "')");
    if (!a.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let r in a.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return a;
  }
};
function $$(e, n, t) {
  let a = t.split("|");
  return (l) => {
    let r = l === null ? "null" : typeof l;
    if (a.indexOf(r) < 0)
      throw new RangeError(`Expected value of type ${a} for attribute ${n} on type ${e}, got ${r}`);
  };
}
class I$ {
  constructor(n, t, a) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(a, "default"), this.default = a.default, this.validate = typeof a.validate == "string" ? $$(n, t, a.validate) : a.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class ss {
  /**
  @internal
  */
  constructor(n, t, a, l) {
    this.name = n, this.rank = t, this.schema = a, this.spec = l, this.attrs = om(n, l.attrs), this.excluded = null;
    let r = am(this.attrs);
    this.instance = r ? new Ct(this, r) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(n = null) {
    return !n && this.instance ? this.instance : new Ct(this, lm(this.attrs, n));
  }
  /**
  @internal
  */
  static compile(n, t) {
    let a = /* @__PURE__ */ Object.create(null), l = 0;
    return n.forEach((r, o) => a[r] = new ss(r, l++, t, o)), a;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(n) {
    for (var t = 0; t < n.length; t++)
      n[t].type == this && (n = n.slice(0, t).concat(n.slice(t + 1)), t--);
    return n;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(n) {
    for (let t = 0; t < n.length; t++)
      if (n[t].type == this)
        return n[t];
  }
  /**
  @internal
  */
  checkAttrs(n) {
    rm(this.attrs, n, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(n) {
    return this.excluded.indexOf(n) > -1;
  }
}
class sm {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(n) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let t = this.spec = {};
    for (let l in n)
      t[l] = n[l];
    t.nodes = Xt.from(n.nodes), t.marks = Xt.from(n.marks || {}), this.nodes = zf.compile(this.spec.nodes, this), this.marks = ss.compile(this.spec.marks, this);
    let a = /* @__PURE__ */ Object.create(null);
    for (let l in this.nodes) {
      if (l in this.marks)
        throw new RangeError(l + " can not be both a node and a mark");
      let r = this.nodes[l], o = r.spec.content || "", i = r.spec.marks;
      if (r.contentMatch = a[o] || (a[o] = xl.parse(o, this.nodes)), r.inlineContent = r.contentMatch.inlineContent, r.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!r.isInline || !r.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = r;
      }
      r.markSet = i == "_" ? null : i ? Of(this, i.split(" ")) : i == "" || !r.inlineContent ? [] : null;
    }
    for (let l in this.marks) {
      let r = this.marks[l], o = r.spec.excludes;
      r.excluded = o == null ? [r] : o == "" ? [] : Of(this, o.split(" "));
    }
    this.nodeFromJSON = (l) => Oa.fromJSON(this, l), this.markFromJSON = (l) => Ct.fromJSON(this, l), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(n, t = null, a, l) {
    if (typeof n == "string")
      n = this.nodeType(n);
    else if (n instanceof zf) {
      if (n.schema != this)
        throw new RangeError("Node type from different schema used (" + n.name + ")");
    } else throw new RangeError("Invalid node type: " + n);
    return n.createChecked(t, a, l);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(n, t) {
    let a = this.nodes.text;
    return new gi(a, a.defaultAttrs, n, Ct.setFrom(t));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(n, t) {
    return typeof n == "string" && (n = this.marks[n]), n.create(t);
  }
  /**
  @internal
  */
  nodeType(n) {
    let t = this.nodes[n];
    if (!t)
      throw new RangeError("Unknown node type: " + n);
    return t;
  }
}
function Of(e, n) {
  let t = [];
  for (let a = 0; a < n.length; a++) {
    let l = n[a], r = e.marks[l], o = r;
    if (r)
      t.push(r);
    else
      for (let i in e.marks) {
        let s = e.marks[i];
        (l == "_" || s.spec.group && s.spec.group.split(" ").indexOf(l) > -1) && t.push(o = s);
      }
    if (!o)
      throw new SyntaxError("Unknown mark type: '" + n[a] + "'");
  }
  return t;
}
function L$(e) {
  return e.tag != null;
}
function T$(e) {
  return e.style != null;
}
class Pa {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(n, t) {
    this.schema = n, this.rules = t, this.tags = [], this.styles = [];
    let a = this.matchedStyles = [];
    t.forEach((l) => {
      if (L$(l))
        this.tags.push(l);
      else if (T$(l)) {
        let r = /[^=]*/.exec(l.style)[0];
        a.indexOf(r) < 0 && a.push(r), this.styles.push(l);
      }
    }), this.normalizeLists = !this.tags.some((l) => {
      if (!/^(ul|ol)\b/.test(l.tag) || !l.node)
        return !1;
      let r = n.nodes[l.node];
      return r.contentMatch.matchType(r);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(n, t = {}) {
    let a = new Ff(this, t, !1);
    return a.addAll(n, Ct.none, t.from, t.to), a.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(n, t = {}) {
    let a = new Ff(this, t, !0);
    return a.addAll(n, Ct.none, t.from, t.to), Xe.maxOpen(a.finish());
  }
  /**
  @internal
  */
  matchTag(n, t, a) {
    for (let l = a ? this.tags.indexOf(a) + 1 : 0; l < this.tags.length; l++) {
      let r = this.tags[l];
      if (R$(n, r.tag) && (r.namespace === void 0 || n.namespaceURI == r.namespace) && (!r.context || t.matchesContext(r.context))) {
        if (r.getAttrs) {
          let o = r.getAttrs(n);
          if (o === !1)
            continue;
          r.attrs = o || void 0;
        }
        return r;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(n, t, a, l) {
    for (let r = l ? this.styles.indexOf(l) + 1 : 0; r < this.styles.length; r++) {
      let o = this.styles[r], i = o.style;
      if (!(i.indexOf(n) != 0 || o.context && !a.matchesContext(o.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      i.length > n.length && (i.charCodeAt(n.length) != 61 || i.slice(n.length + 1) != t))) {
        if (o.getAttrs) {
          let s = o.getAttrs(t);
          if (s === !1)
            continue;
          o.attrs = s || void 0;
        }
        return o;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(n) {
    let t = [];
    function a(l) {
      let r = l.priority == null ? 50 : l.priority, o = 0;
      for (; o < t.length; o++) {
        let i = t[o];
        if ((i.priority == null ? 50 : i.priority) < r)
          break;
      }
      t.splice(o, 0, l);
    }
    for (let l in n.marks) {
      let r = n.marks[l].spec.parseDOM;
      r && r.forEach((o) => {
        a(o = Vf(o)), o.mark || o.ignore || o.clearMark || (o.mark = l);
      });
    }
    for (let l in n.nodes) {
      let r = n.nodes[l].spec.parseDOM;
      r && r.forEach((o) => {
        a(o = Vf(o)), o.node || o.ignore || o.mark || (o.node = l);
      });
    }
    return t;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
  */
  static fromSchema(n) {
    return n.cached.domParser || (n.cached.domParser = new Pa(n, Pa.schemaRules(n)));
  }
}
const dm = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, A$ = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, um = { ol: !0, ul: !0 }, Xr = 1, jd = 2, Rr = 4;
function Pf(e, n, t) {
  return n != null ? (n ? Xr : 0) | (n === "full" ? jd : 0) : e && e.whitespace == "pre" ? Xr | jd : t & ~Rr;
}
class Lo {
  constructor(n, t, a, l, r, o) {
    this.type = n, this.attrs = t, this.marks = a, this.solid = l, this.options = o, this.content = [], this.activeMarks = Ct.none, this.match = r || (o & Rr ? null : n.contentMatch);
  }
  findWrapping(n) {
    if (!this.match) {
      if (!this.type)
        return [];
      let t = this.type.contentMatch.fillBefore(Ve.from(n));
      if (t)
        this.match = this.type.contentMatch.matchFragment(t);
      else {
        let a = this.type.contentMatch, l;
        return (l = a.findWrapping(n.type)) ? (this.match = a, l) : null;
      }
    }
    return this.match.findWrapping(n.type);
  }
  finish(n) {
    if (!(this.options & Xr)) {
      let a = this.content[this.content.length - 1], l;
      if (a && a.isText && (l = /[ \t\r\n\u000c]+$/.exec(a.text))) {
        let r = a;
        a.text.length == l[0].length ? this.content.pop() : this.content[this.content.length - 1] = r.withText(r.text.slice(0, r.text.length - l[0].length));
      }
    }
    let t = Ve.from(this.content);
    return !n && this.match && (t = t.append(this.match.fillBefore(Ve.empty, !0))), this.type ? this.type.create(this.attrs, t, this.marks) : t;
  }
  inlineContext(n) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : n.parentNode && !dm.hasOwnProperty(n.parentNode.nodeName.toLowerCase());
  }
}
class Ff {
  constructor(n, t, a) {
    this.parser = n, this.options = t, this.isOpen = a, this.open = 0, this.localPreserveWS = !1;
    let l = t.topNode, r, o = Pf(null, t.preserveWhitespace, 0) | (a ? Rr : 0);
    l ? r = new Lo(l.type, l.attrs, Ct.none, !0, t.topMatch || l.type.contentMatch, o) : a ? r = new Lo(null, null, Ct.none, !0, null, o) : r = new Lo(n.schema.topNodeType, null, Ct.none, !0, null, o), this.nodes = [r], this.find = t.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(n, t) {
    n.nodeType == 3 ? this.addTextNode(n, t) : n.nodeType == 1 && this.addElement(n, t);
  }
  addTextNode(n, t) {
    let a = n.nodeValue, l = this.top, r = l.options & jd ? "full" : this.localPreserveWS || (l.options & Xr) > 0, { schema: o } = this.parser;
    if (r === "full" || l.inlineContext(n) || /[^ \t\r\n\u000c]/.test(a)) {
      if (r)
        if (r === "full")
          a = a.replace(/\r\n?/g, `
`);
        else if (o.linebreakReplacement && /[\r\n]/.test(a) && this.top.findWrapping(o.linebreakReplacement.create())) {
          let i = a.split(/\r?\n|\r/);
          for (let s = 0; s < i.length; s++)
            s && this.insertNode(o.linebreakReplacement.create(), t, !0), i[s] && this.insertNode(o.text(i[s]), t, !/\S/.test(i[s]));
          a = "";
        } else
          a = a.replace(/\r?\n|\r/g, " ");
      else if (a = a.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(a) && this.open == this.nodes.length - 1) {
        let i = l.content[l.content.length - 1], s = n.previousSibling;
        (!i || s && s.nodeName == "BR" || i.isText && /[ \t\r\n\u000c]$/.test(i.text)) && (a = a.slice(1));
      }
      a && this.insertNode(o.text(a), t, !/\S/.test(a)), this.findInText(n);
    } else
      this.findInside(n);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(n, t, a) {
    let l = this.localPreserveWS, r = this.top;
    (n.tagName == "PRE" || /pre/.test(n.style && n.style.whiteSpace)) && (this.localPreserveWS = !0);
    let o = n.nodeName.toLowerCase(), i;
    um.hasOwnProperty(o) && this.parser.normalizeLists && E$(n);
    let s = this.options.ruleFromNode && this.options.ruleFromNode(n) || (i = this.parser.matchTag(n, this, a));
    e: if (s ? s.ignore : A$.hasOwnProperty(o))
      this.findInside(n), this.ignoreFallback(n, t);
    else if (!s || s.skip || s.closeParent) {
      s && s.closeParent ? this.open = Math.max(0, this.open - 1) : s && s.skip.nodeType && (n = s.skip);
      let d, u = this.needsBlock;
      if (dm.hasOwnProperty(o))
        r.content.length && r.content[0].isInline && this.open && (this.open--, r = this.top), d = !0, r.type || (this.needsBlock = !0);
      else if (!n.firstChild) {
        this.leafFallback(n, t);
        break e;
      }
      let f = s && s.skip ? t : this.readStyles(n, t);
      f && this.addAll(n, f), d && this.sync(r), this.needsBlock = u;
    } else {
      let d = this.readStyles(n, t);
      d && this.addElementByRule(n, s, d, s.consuming === !1 ? i : void 0);
    }
    this.localPreserveWS = l;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(n, t) {
    n.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(n.ownerDocument.createTextNode(`
`), t);
  }
  // Called for ignored nodes
  ignoreFallback(n, t) {
    n.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), t, !0);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(n, t) {
    let a = n.style;
    if (a && a.length)
      for (let l = 0; l < this.parser.matchedStyles.length; l++) {
        let r = this.parser.matchedStyles[l], o = a.getPropertyValue(r);
        if (o)
          for (let i = void 0; ; ) {
            let s = this.parser.matchStyle(r, o, this, i);
            if (!s)
              break;
            if (s.ignore)
              return null;
            if (s.clearMark ? t = t.filter((d) => !s.clearMark(d)) : t = t.concat(this.parser.schema.marks[s.mark].create(s.attrs)), s.consuming === !1)
              i = s;
            else
              break;
          }
      }
    return t;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(n, t, a, l) {
    let r, o;
    if (t.node)
      if (o = this.parser.schema.nodes[t.node], o.isLeaf)
        this.insertNode(o.create(t.attrs), a, n.nodeName == "BR") || this.leafFallback(n, a);
      else {
        let s = this.enter(o, t.attrs || null, a, t.preserveWhitespace);
        s && (r = !0, a = s);
      }
    else {
      let s = this.parser.schema.marks[t.mark];
      a = a.concat(s.create(t.attrs));
    }
    let i = this.top;
    if (o && o.isLeaf)
      this.findInside(n);
    else if (l)
      this.addElement(n, a, l);
    else if (t.getContent)
      this.findInside(n), t.getContent(n, this.parser.schema).forEach((s) => this.insertNode(s, a, !1));
    else {
      let s = n;
      typeof t.contentElement == "string" ? s = n.querySelector(t.contentElement) : typeof t.contentElement == "function" ? s = t.contentElement(n) : t.contentElement && (s = t.contentElement), this.findAround(n, s, !0), this.addAll(s, a), this.findAround(n, s, !1);
    }
    r && this.sync(i) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(n, t, a, l) {
    let r = a || 0;
    for (let o = a ? n.childNodes[a] : n.firstChild, i = l == null ? null : n.childNodes[l]; o != i; o = o.nextSibling, ++r)
      this.findAtPoint(n, r), this.addDOM(o, t);
    this.findAtPoint(n, r);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(n, t, a) {
    let l, r;
    for (let o = this.open, i = 0; o >= 0; o--) {
      let s = this.nodes[o], d = s.findWrapping(n);
      if (d && (!l || l.length > d.length + i) && (l = d, r = s, !d.length))
        break;
      if (s.solid) {
        if (a)
          break;
        i += 2;
      }
    }
    if (!l)
      return null;
    this.sync(r);
    for (let o = 0; o < l.length; o++)
      t = this.enterInner(l[o], null, t, !1);
    return t;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(n, t, a) {
    if (n.isInline && this.needsBlock && !this.top.type) {
      let r = this.textblockFromContext();
      r && (t = this.enterInner(r, null, t));
    }
    let l = this.findPlace(n, t, a);
    if (l) {
      this.closeExtra();
      let r = this.top;
      r.match && (r.match = r.match.matchType(n.type));
      let o = Ct.none;
      for (let i of l.concat(n.marks))
        (r.type ? r.type.allowsMarkType(i.type) : Nf(i.type, n.type)) && (o = i.addToSet(o));
      return r.content.push(n.mark(o)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(n, t, a, l) {
    let r = this.findPlace(n.create(t), a, !1);
    return r && (r = this.enterInner(n, t, a, !0, l)), r;
  }
  // Open a node of the given type
  enterInner(n, t, a, l = !1, r) {
    this.closeExtra();
    let o = this.top;
    o.match = o.match && o.match.matchType(n);
    let i = Pf(n, r, o.options);
    o.options & Rr && o.content.length == 0 && (i |= Rr);
    let s = Ct.none;
    return a = a.filter((d) => (o.type ? o.type.allowsMarkType(d.type) : Nf(d.type, n)) ? (s = d.addToSet(s), !1) : !0), this.nodes.push(new Lo(n, t, s, l, null, i)), this.open++, a;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(n = !1) {
    let t = this.nodes.length - 1;
    if (t > this.open) {
      for (; t > this.open; t--)
        this.nodes[t - 1].content.push(this.nodes[t].finish(n));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(n) {
    for (let t = this.open; t >= 0; t--) {
      if (this.nodes[t] == n)
        return this.open = t, !0;
      this.localPreserveWS && (this.nodes[t].options |= Xr);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let n = 0;
    for (let t = this.open; t >= 0; t--) {
      let a = this.nodes[t].content;
      for (let l = a.length - 1; l >= 0; l--)
        n += a[l].nodeSize;
      t && n++;
    }
    return n;
  }
  findAtPoint(n, t) {
    if (this.find)
      for (let a = 0; a < this.find.length; a++)
        this.find[a].node == n && this.find[a].offset == t && (this.find[a].pos = this.currentPos);
  }
  findInside(n) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].pos == null && n.nodeType == 1 && n.contains(this.find[t].node) && (this.find[t].pos = this.currentPos);
  }
  findAround(n, t, a) {
    if (n != t && this.find)
      for (let l = 0; l < this.find.length; l++)
        this.find[l].pos == null && n.nodeType == 1 && n.contains(this.find[l].node) && t.compareDocumentPosition(this.find[l].node) & (a ? 2 : 4) && (this.find[l].pos = this.currentPos);
  }
  findInText(n) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].node == n && (this.find[t].pos = this.currentPos - (n.nodeValue.length - this.find[t].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(n) {
    if (n.indexOf("|") > -1)
      return n.split(/\s*\|\s*/).some(this.matchesContext, this);
    let t = n.split("/"), a = this.options.context, l = !this.isOpen && (!a || a.parent.type == this.nodes[0].type), r = -(a ? a.depth + 1 : 0) + (l ? 0 : 1), o = (i, s) => {
      for (; i >= 0; i--) {
        let d = t[i];
        if (d == "") {
          if (i == t.length - 1 || i == 0)
            continue;
          for (; s >= r; s--)
            if (o(i - 1, s))
              return !0;
          return !1;
        } else {
          let u = s > 0 || s == 0 && l ? this.nodes[s].type : a && s >= r ? a.node(s - r).type : null;
          if (!u || u.name != d && !u.isInGroup(d))
            return !1;
          s--;
        }
      }
      return !0;
    };
    return o(t.length - 1, this.open);
  }
  textblockFromContext() {
    let n = this.options.context;
    if (n)
      for (let t = n.depth; t >= 0; t--) {
        let a = n.node(t).contentMatchAt(n.indexAfter(t)).defaultType;
        if (a && a.isTextblock && a.defaultAttrs)
          return a;
      }
    for (let t in this.parser.schema.nodes) {
      let a = this.parser.schema.nodes[t];
      if (a.isTextblock && a.defaultAttrs)
        return a;
    }
  }
}
function E$(e) {
  for (let n = e.firstChild, t = null; n; n = n.nextSibling) {
    let a = n.nodeType == 1 ? n.nodeName.toLowerCase() : null;
    a && um.hasOwnProperty(a) && t ? (t.appendChild(n), n = t) : a == "li" ? t = n : a && (t = null);
  }
}
function R$(e, n) {
  return (e.matches || e.msMatchesSelector || e.webkitMatchesSelector || e.mozMatchesSelector).call(e, n);
}
function Vf(e) {
  let n = {};
  for (let t in e)
    n[t] = e[t];
  return n;
}
function Nf(e, n) {
  let t = n.schema.nodes;
  for (let a in t) {
    let l = t[a];
    if (!l.allowsMarkType(e))
      continue;
    let r = [], o = (i) => {
      r.push(i);
      for (let s = 0; s < i.edgeCount; s++) {
        let { type: d, next: u } = i.edge(s);
        if (d == n || r.indexOf(u) < 0 && o(u))
          return !0;
      }
    };
    if (o(l.contentMatch))
      return !0;
  }
}
class Sl {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(n, t) {
    this.nodes = n, this.marks = t;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(n, t = {}, a) {
    a || (a = To(t).createDocumentFragment());
    let l = a, r = [];
    return n.forEach((o) => {
      if (r.length || o.marks.length) {
        let i = 0, s = 0;
        for (; i < r.length && s < o.marks.length; ) {
          let d = o.marks[s];
          if (!this.marks[d.type.name]) {
            s++;
            continue;
          }
          if (!d.eq(r[i][0]) || d.type.spec.spanning === !1)
            break;
          i++, s++;
        }
        for (; i < r.length; )
          l = r.pop()[1];
        for (; s < o.marks.length; ) {
          let d = o.marks[s++], u = this.serializeMark(d, o.isInline, t);
          u && (r.push([d, l]), l.appendChild(u.dom), l = u.contentDOM || u.dom);
        }
      }
      l.appendChild(this.serializeNodeInner(o, t));
    }), a;
  }
  /**
  @internal
  */
  serializeNodeInner(n, t) {
    if (n.isText)
      return To(t).createTextNode(n.text);
    let { dom: a, contentDOM: l } = Zo(To(t), this.nodes[n.type.name](n), null, n.attrs);
    if (l) {
      if (n.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(n.content, t, l);
    }
    return a;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(n, t = {}) {
    let a = this.serializeNodeInner(n, t);
    for (let l = n.marks.length - 1; l >= 0; l--) {
      let r = this.serializeMark(n.marks[l], n.isInline, t);
      r && ((r.contentDOM || r.dom).appendChild(a), a = r.dom);
    }
    return a;
  }
  /**
  @internal
  */
  serializeMark(n, t, a = {}) {
    let l = this.marks[n.type.name];
    return l && Zo(To(a), l(n, t), null, n.attrs);
  }
  static renderSpec(n, t, a = null, l) {
    return typeof t == "string" ? { dom: n.createTextNode(t) } : Zo(n, t, a, l);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(n) {
    return n.cached.domSerializer || (n.cached.domSerializer = new Sl(this.nodesFromSchema(n), this.marksFromSchema(n)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(n) {
    let t = Hf(n.nodes);
    return t.text || (t.text = (a) => a.text), t;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(n) {
    return Hf(n.marks);
  }
}
function Hf(e) {
  let n = {};
  for (let t in e) {
    let a = e[t].spec.toDOM;
    a && (n[t] = a);
  }
  return n;
}
function To(e) {
  return e.document || window.document;
}
const jf = /* @__PURE__ */ new WeakMap();
function B$(e) {
  let n = jf.get(e);
  return n === void 0 && jf.set(e, n = M$(e)), n;
}
function M$(e) {
  let n = null;
  function t(a) {
    if (a && typeof a == "object")
      if (Array.isArray(a))
        if (typeof a[0] == "string")
          n || (n = []), n.push(a);
        else
          for (let l = 0; l < a.length; l++)
            t(a[l]);
      else
        for (let l in a)
          t(a[l]);
  }
  return t(e), n;
}
function Zo(e, n, t, a) {
  if (n.nodeType == 1)
    return { dom: n };
  if (n.dom && n.dom.nodeType == 1)
    return n;
  let l = n[0], r;
  if (typeof l != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (a && (r = B$(a)) && r.indexOf(n) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let o = l.indexOf(" ");
  o > 0 && (t = l.slice(0, o), l = l.slice(o + 1));
  let i, s = t ? e.createElementNS(t, l) : e.createElement(l), d = n[1], u = 1;
  if (d && typeof d == "object" && d.nodeType == null && !Array.isArray(d)) {
    u = 2;
    for (let f in d)
      if (d[f] != null) {
        let b = f.indexOf(" ");
        b > 0 ? s.setAttributeNS(f.slice(0, b), f.slice(b + 1), d[f]) : f == "style" && s.style ? s.style.cssText = d[f] : s.setAttribute(f, d[f]);
      }
  }
  for (let f = u; f < n.length; f++) {
    let b = n[f];
    if (b === 0) {
      if (f < n.length - 1 || f > u)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: s, contentDOM: s };
    } else if (typeof b == "string")
      s.appendChild(e.createTextNode(b));
    else {
      let { dom: h, contentDOM: p } = Zo(e, b, t, a);
      if (s.appendChild(h), p) {
        if (i)
          throw new RangeError("Multiple content holes");
        i = p;
      }
    }
  }
  return { dom: s, contentDOM: i };
}
const cm = 65535, fm = Math.pow(2, 16);
function D$(e, n) {
  return e + n * fm;
}
function Wf(e) {
  return e & cm;
}
function z$(e) {
  return (e - (e & cm)) / fm;
}
const hm = 1, bm = 2, Qo = 4, gm = 8;
class Wd {
  /**
  @internal
  */
  constructor(n, t, a) {
    this.pos = n, this.delInfo = t, this.recover = a;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & gm) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (hm | Qo)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (bm | Qo)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & Qo) > 0;
  }
}
class kn {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(n, t = !1) {
    if (this.ranges = n, this.inverted = t, !n.length && kn.empty)
      return kn.empty;
  }
  /**
  @internal
  */
  recover(n) {
    let t = 0, a = Wf(n);
    if (!this.inverted)
      for (let l = 0; l < a; l++)
        t += this.ranges[l * 3 + 2] - this.ranges[l * 3 + 1];
    return this.ranges[a * 3] + t + z$(n);
  }
  mapResult(n, t = 1) {
    return this._map(n, t, !1);
  }
  map(n, t = 1) {
    return this._map(n, t, !0);
  }
  /**
  @internal
  */
  _map(n, t, a) {
    let l = 0, r = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let i = 0; i < this.ranges.length; i += 3) {
      let s = this.ranges[i] - (this.inverted ? l : 0);
      if (s > n)
        break;
      let d = this.ranges[i + r], u = this.ranges[i + o], f = s + d;
      if (n <= f) {
        let b = d ? n == s ? -1 : n == f ? 1 : t : t, h = s + l + (b < 0 ? 0 : u);
        if (a)
          return h;
        let p = n == (t < 0 ? s : f) ? null : D$(i / 3, n - s), x = n == s ? bm : n == f ? hm : Qo;
        return (t < 0 ? n != s : n != f) && (x |= gm), new Wd(h, x, p);
      }
      l += u - d;
    }
    return a ? n + l : new Wd(n + l, 0, null);
  }
  /**
  @internal
  */
  touches(n, t) {
    let a = 0, l = Wf(t), r = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let i = 0; i < this.ranges.length; i += 3) {
      let s = this.ranges[i] - (this.inverted ? a : 0);
      if (s > n)
        break;
      let d = this.ranges[i + r], u = s + d;
      if (n <= u && i == l * 3)
        return !0;
      a += this.ranges[i + o] - d;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(n) {
    let t = this.inverted ? 2 : 1, a = this.inverted ? 1 : 2;
    for (let l = 0, r = 0; l < this.ranges.length; l += 3) {
      let o = this.ranges[l], i = o - (this.inverted ? r : 0), s = o + (this.inverted ? 0 : r), d = this.ranges[l + t], u = this.ranges[l + a];
      n(i, i + d, s, s + u), r += u - d;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new kn(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(n) {
    return n == 0 ? kn.empty : new kn(n < 0 ? [0, -n, 0] : [0, 0, n]);
  }
}
kn.empty = new kn([]);
class Zr {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(n, t, a = 0, l = n ? n.length : 0) {
    this.mirror = t, this.from = a, this.to = l, this._maps = n || [], this.ownData = !(n || t);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(n = 0, t = this.maps.length) {
    return new Zr(this._maps, this.mirror, n, t);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(n, t) {
    this.ownData || (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), this.ownData = !0), this.to = this._maps.push(n), t != null && this.setMirror(this._maps.length - 1, t);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(n) {
    for (let t = 0, a = this._maps.length; t < n._maps.length; t++) {
      let l = n.getMirror(t);
      this.appendMap(n._maps[t], l != null && l < t ? a + l : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(n) {
    if (this.mirror) {
      for (let t = 0; t < this.mirror.length; t++)
        if (this.mirror[t] == n)
          return this.mirror[t + (t % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(n, t) {
    this.mirror || (this.mirror = []), this.mirror.push(n, t);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(n) {
    for (let t = n.maps.length - 1, a = this._maps.length + n._maps.length; t >= 0; t--) {
      let l = n.getMirror(t);
      this.appendMap(n._maps[t].invert(), l != null && l > t ? a - l - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let n = new Zr();
    return n.appendMappingInverted(this), n;
  }
  /**
  Map a position through this mapping.
  */
  map(n, t = 1) {
    if (this.mirror)
      return this._map(n, t, !0);
    for (let a = this.from; a < this.to; a++)
      n = this._maps[a].map(n, t);
    return n;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(n, t = 1) {
    return this._map(n, t, !1);
  }
  /**
  @internal
  */
  _map(n, t, a) {
    let l = 0;
    for (let r = this.from; r < this.to; r++) {
      let o = this._maps[r], i = o.mapResult(n, t);
      if (i.recover != null) {
        let s = this.getMirror(r);
        if (s != null && s > r && s < this.to) {
          r = s, n = this._maps[s].recover(i.recover);
          continue;
        }
      }
      l |= i.delInfo, n = i.pos;
    }
    return a ? n : new Wd(n, l, null);
  }
}
const Vs = /* @__PURE__ */ Object.create(null);
class on {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return kn.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(n) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(n, t) {
    if (!t || !t.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let a = Vs[t.stepType];
    if (!a)
      throw new RangeError(`No step type ${t.stepType} defined`);
    return a.fromJSON(n, t);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(n, t) {
    if (n in Vs)
      throw new RangeError("Duplicate use of step JSON ID " + n);
    return Vs[n] = t, t.prototype.jsonID = n, t;
  }
}
class Vt {
  /**
  @internal
  */
  constructor(n, t) {
    this.doc = n, this.failed = t;
  }
  /**
  Create a successful step result.
  */
  static ok(n) {
    return new Vt(n, null);
  }
  /**
  Create a failed step result.
  */
  static fail(n) {
    return new Vt(null, n);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(n, t, a, l) {
    try {
      return Vt.ok(n.replace(t, a, l));
    } catch (r) {
      if (r instanceof fi)
        return Vt.fail(r.message);
      throw r;
    }
  }
}
function nc(e, n, t) {
  let a = [];
  for (let l = 0; l < e.childCount; l++) {
    let r = e.child(l);
    r.content.size && (r = r.copy(nc(r.content, n, r))), r.isInline && (r = n(r, t, l)), a.push(r);
  }
  return Ve.fromArray(a);
}
class Ra extends on {
  /**
  Create a mark step.
  */
  constructor(n, t, a) {
    super(), this.from = n, this.to = t, this.mark = a;
  }
  apply(n) {
    let t = n.slice(this.from, this.to), a = n.resolve(this.from), l = a.node(a.sharedDepth(this.to)), r = new Xe(nc(t.content, (o, i) => !o.isAtom || !i.type.allowsMarkType(this.mark.type) ? o : o.mark(this.mark.addToSet(o.marks)), l), t.openStart, t.openEnd);
    return Vt.fromReplace(n, this.from, this.to, r);
  }
  invert() {
    return new qn(this.from, this.to, this.mark);
  }
  map(n) {
    let t = n.mapResult(this.from, 1), a = n.mapResult(this.to, -1);
    return t.deleted && a.deleted || t.pos >= a.pos ? null : new Ra(t.pos, a.pos, this.mark);
  }
  merge(n) {
    return n instanceof Ra && n.mark.eq(this.mark) && this.from <= n.to && this.to >= n.from ? new Ra(Math.min(this.from, n.from), Math.max(this.to, n.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new Ra(t.from, t.to, n.markFromJSON(t.mark));
  }
}
on.jsonID("addMark", Ra);
class qn extends on {
  /**
  Create a mark-removing step.
  */
  constructor(n, t, a) {
    super(), this.from = n, this.to = t, this.mark = a;
  }
  apply(n) {
    let t = n.slice(this.from, this.to), a = new Xe(nc(t.content, (l) => l.mark(this.mark.removeFromSet(l.marks)), n), t.openStart, t.openEnd);
    return Vt.fromReplace(n, this.from, this.to, a);
  }
  invert() {
    return new Ra(this.from, this.to, this.mark);
  }
  map(n) {
    let t = n.mapResult(this.from, 1), a = n.mapResult(this.to, -1);
    return t.deleted && a.deleted || t.pos >= a.pos ? null : new qn(t.pos, a.pos, this.mark);
  }
  merge(n) {
    return n instanceof qn && n.mark.eq(this.mark) && this.from <= n.to && this.to >= n.from ? new qn(Math.min(this.from, n.from), Math.max(this.to, n.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new qn(t.from, t.to, n.markFromJSON(t.mark));
  }
}
on.jsonID("removeMark", qn);
class Ba extends on {
  /**
  Create a node mark step.
  */
  constructor(n, t) {
    super(), this.pos = n, this.mark = t;
  }
  apply(n) {
    let t = n.nodeAt(this.pos);
    if (!t)
      return Vt.fail("No node at mark step's position");
    let a = t.type.create(t.attrs, null, this.mark.addToSet(t.marks));
    return Vt.fromReplace(n, this.pos, this.pos + 1, new Xe(Ve.from(a), 0, t.isLeaf ? 0 : 1));
  }
  invert(n) {
    let t = n.nodeAt(this.pos);
    if (t) {
      let a = this.mark.addToSet(t.marks);
      if (a.length == t.marks.length) {
        for (let l = 0; l < t.marks.length; l++)
          if (!t.marks[l].isInSet(a))
            return new Ba(this.pos, t.marks[l]);
        return new Ba(this.pos, this.mark);
      }
    }
    return new yl(this.pos, this.mark);
  }
  map(n) {
    let t = n.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Ba(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new Ba(t.pos, n.markFromJSON(t.mark));
  }
}
on.jsonID("addNodeMark", Ba);
class yl extends on {
  /**
  Create a mark-removing step.
  */
  constructor(n, t) {
    super(), this.pos = n, this.mark = t;
  }
  apply(n) {
    let t = n.nodeAt(this.pos);
    if (!t)
      return Vt.fail("No node at mark step's position");
    let a = t.type.create(t.attrs, null, this.mark.removeFromSet(t.marks));
    return Vt.fromReplace(n, this.pos, this.pos + 1, new Xe(Ve.from(a), 0, t.isLeaf ? 0 : 1));
  }
  invert(n) {
    let t = n.nodeAt(this.pos);
    return !t || !this.mark.isInSet(t.marks) ? this : new Ba(this.pos, this.mark);
  }
  map(n) {
    let t = n.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new yl(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new yl(t.pos, n.markFromJSON(t.mark));
  }
}
on.jsonID("removeNodeMark", yl);
class Ft extends on {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(n, t, a, l = !1) {
    super(), this.from = n, this.to = t, this.slice = a, this.structure = l;
  }
  apply(n) {
    return this.structure && qd(n, this.from, this.to) ? Vt.fail("Structure replace would overwrite content") : Vt.fromReplace(n, this.from, this.to, this.slice);
  }
  getMap() {
    return new kn([this.from, this.to - this.from, this.slice.size]);
  }
  invert(n) {
    return new Ft(this.from, this.from + this.slice.size, n.slice(this.from, this.to));
  }
  map(n) {
    let t = n.mapResult(this.to, -1), a = this.from == this.to && Ft.MAP_BIAS < 0 ? t : n.mapResult(this.from, 1);
    return a.deletedAcross && t.deletedAcross ? null : new Ft(a.pos, Math.max(a.pos, t.pos), this.slice, this.structure);
  }
  merge(n) {
    if (!(n instanceof Ft) || n.structure || this.structure)
      return null;
    if (this.from + this.slice.size == n.from && !this.slice.openEnd && !n.slice.openStart) {
      let t = this.slice.size + n.slice.size == 0 ? Xe.empty : new Xe(this.slice.content.append(n.slice.content), this.slice.openStart, n.slice.openEnd);
      return new Ft(this.from, this.to + (n.to - n.from), t, this.structure);
    } else if (n.to == this.from && !this.slice.openStart && !n.slice.openEnd) {
      let t = this.slice.size + n.slice.size == 0 ? Xe.empty : new Xe(n.slice.content.append(this.slice.content), n.slice.openStart, this.slice.openEnd);
      return new Ft(n.from, this.to, t, this.structure);
    } else
      return null;
  }
  toJSON() {
    let n = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (n.slice = this.slice.toJSON()), this.structure && (n.structure = !0), n;
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new Ft(t.from, t.to, Xe.fromJSON(n, t.slice), !!t.structure);
  }
}
Ft.MAP_BIAS = 1;
on.jsonID("replace", Ft);
class Yt extends on {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(n, t, a, l, r, o, i = !1) {
    super(), this.from = n, this.to = t, this.gapFrom = a, this.gapTo = l, this.slice = r, this.insert = o, this.structure = i;
  }
  apply(n) {
    if (this.structure && (qd(n, this.from, this.gapFrom) || qd(n, this.gapTo, this.to)))
      return Vt.fail("Structure gap-replace would overwrite content");
    let t = n.slice(this.gapFrom, this.gapTo);
    if (t.openStart || t.openEnd)
      return Vt.fail("Gap is not a flat range");
    let a = this.slice.insertAt(this.insert, t.content);
    return a ? Vt.fromReplace(n, this.from, this.to, a) : Vt.fail("Content does not fit in gap");
  }
  getMap() {
    return new kn([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(n) {
    let t = this.gapTo - this.gapFrom;
    return new Yt(this.from, this.from + this.slice.size + t, this.from + this.insert, this.from + this.insert + t, n.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(n) {
    let t = n.mapResult(this.from, 1), a = n.mapResult(this.to, -1), l = this.from == this.gapFrom ? t.pos : n.map(this.gapFrom, -1), r = this.to == this.gapTo ? a.pos : n.map(this.gapTo, 1);
    return t.deletedAcross && a.deletedAcross || l < t.pos || r > a.pos ? null : new Yt(t.pos, a.pos, l, r, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let n = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (n.slice = this.slice.toJSON()), this.structure && (n.structure = !0), n;
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.from != "number" || typeof t.to != "number" || typeof t.gapFrom != "number" || typeof t.gapTo != "number" || typeof t.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new Yt(t.from, t.to, t.gapFrom, t.gapTo, Xe.fromJSON(n, t.slice), t.insert, !!t.structure);
  }
}
on.jsonID("replaceAround", Yt);
function qd(e, n, t) {
  let a = e.resolve(n), l = t - n, r = a.depth;
  for (; l > 0 && r > 0 && a.indexAfter(r) == a.node(r).childCount; )
    r--, l--;
  if (l > 0) {
    let o = a.node(r).maybeChild(a.indexAfter(r));
    for (; l > 0; ) {
      if (!o || o.isLeaf)
        return !0;
      o = o.firstChild, l--;
    }
  }
  return !1;
}
function O$(e, n, t, a) {
  let l = [], r = [], o, i;
  e.doc.nodesBetween(n, t, (s, d, u) => {
    if (!s.isInline)
      return;
    let f = s.marks;
    if (!a.isInSet(f) && u.type.allowsMarkType(a.type)) {
      let b = Math.max(d, n), h = Math.min(d + s.nodeSize, t), p = a.addToSet(f);
      for (let x = 0; x < f.length; x++)
        f[x].isInSet(p) || (o && o.to == b && o.mark.eq(f[x]) ? o.to = h : l.push(o = new qn(b, h, f[x])));
      i && i.to == b ? i.to = h : r.push(i = new Ra(b, h, a));
    }
  }), l.forEach((s) => e.step(s)), r.forEach((s) => e.step(s));
}
function P$(e, n, t, a) {
  let l = [], r = 0;
  e.doc.nodesBetween(n, t, (o, i) => {
    if (!o.isInline)
      return;
    r++;
    let s = null;
    if (a instanceof ss) {
      let d = o.marks, u;
      for (; u = a.isInSet(d); )
        (s || (s = [])).push(u), d = u.removeFromSet(d);
    } else a ? a.isInSet(o.marks) && (s = [a]) : s = o.marks;
    if (s && s.length) {
      let d = Math.min(i + o.nodeSize, t);
      for (let u = 0; u < s.length; u++) {
        let f = s[u], b;
        for (let h = 0; h < l.length; h++) {
          let p = l[h];
          p.step == r - 1 && f.eq(l[h].style) && (b = p);
        }
        b ? (b.to = d, b.step = r) : l.push({ style: f, from: Math.max(i, n), to: d, step: r });
      }
    }
  }), l.forEach((o) => e.step(new qn(o.from, o.to, o.style)));
}
function ac(e, n, t, a = t.contentMatch, l = !0) {
  let r = e.doc.nodeAt(n), o = [], i = n + 1;
  for (let s = 0; s < r.childCount; s++) {
    let d = r.child(s), u = i + d.nodeSize, f = a.matchType(d.type);
    if (!f)
      o.push(new Ft(i, u, Xe.empty));
    else {
      a = f;
      for (let b = 0; b < d.marks.length; b++)
        t.allowsMarkType(d.marks[b].type) || e.step(new qn(i, u, d.marks[b]));
      if (l && d.isText && t.whitespace != "pre") {
        let b, h = /\r?\n|\r/g, p;
        for (; b = h.exec(d.text); )
          p || (p = new Xe(Ve.from(t.schema.text(" ", t.allowedMarks(d.marks))), 0, 0)), o.push(new Ft(i + b.index, i + b.index + b[0].length, p));
      }
    }
    i = u;
  }
  if (!a.validEnd) {
    let s = a.fillBefore(Ve.empty, !0);
    e.replace(i, i, new Xe(s, 0, 0));
  }
  for (let s = o.length - 1; s >= 0; s--)
    e.step(o[s]);
}
function F$(e, n, t) {
  return (n == 0 || e.canReplace(n, e.childCount)) && (t == e.childCount || e.canReplace(0, t));
}
function lr(e) {
  let t = e.parent.content.cutByIndex(e.startIndex, e.endIndex);
  for (let a = e.depth, l = 0, r = 0; ; --a) {
    let o = e.$from.node(a), i = e.$from.index(a) + l, s = e.$to.indexAfter(a) - r;
    if (a < e.depth && o.canReplace(i, s, t))
      return a;
    if (a == 0 || o.type.spec.isolating || !F$(o, i, s))
      break;
    i && (l = 1), s < o.childCount && (r = 1);
  }
  return null;
}
function V$(e, n, t) {
  let { $from: a, $to: l, depth: r } = n, o = a.before(r + 1), i = l.after(r + 1), s = o, d = i, u = Ve.empty, f = 0;
  for (let p = r, x = !1; p > t; p--)
    x || a.index(p) > 0 ? (x = !0, u = Ve.from(a.node(p).copy(u)), f++) : s--;
  let b = Ve.empty, h = 0;
  for (let p = r, x = !1; p > t; p--)
    x || l.after(p + 1) < l.end(p) ? (x = !0, b = Ve.from(l.node(p).copy(b)), h++) : d++;
  e.step(new Yt(s, d, o, i, new Xe(u.append(b), f, h), u.size - f, !0));
}
function lc(e, n, t = null, a = e) {
  let l = N$(e, n), r = l && H$(a, n);
  return r ? l.map(qf).concat({ type: n, attrs: t }).concat(r.map(qf)) : null;
}
function qf(e) {
  return { type: e, attrs: null };
}
function N$(e, n) {
  let { parent: t, startIndex: a, endIndex: l } = e, r = t.contentMatchAt(a).findWrapping(n);
  if (!r)
    return null;
  let o = r.length ? r[0] : n;
  return t.canReplaceWith(a, l, o) ? r : null;
}
function H$(e, n) {
  let { parent: t, startIndex: a, endIndex: l } = e, r = t.child(a), o = n.contentMatch.findWrapping(r.type);
  if (!o)
    return null;
  let s = (o.length ? o[o.length - 1] : n).contentMatch;
  for (let d = a; s && d < l; d++)
    s = s.matchType(t.child(d).type);
  return !s || !s.validEnd ? null : o;
}
function j$(e, n, t) {
  let a = Ve.empty;
  for (let o = t.length - 1; o >= 0; o--) {
    if (a.size) {
      let i = t[o].type.contentMatch.matchFragment(a);
      if (!i || !i.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    a = Ve.from(t[o].type.create(t[o].attrs, a));
  }
  let l = n.start, r = n.end;
  e.step(new Yt(l, r, l, r, new Xe(a, 0, 0), t.length, !0));
}
function W$(e, n, t, a, l) {
  if (!a.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let r = e.steps.length;
  e.doc.nodesBetween(n, t, (o, i) => {
    let s = typeof l == "function" ? l(o) : l;
    if (o.isTextblock && !o.hasMarkup(a, s) && q$(e.doc, e.mapping.slice(r).map(i), a)) {
      let d = null;
      if (a.schema.linebreakReplacement) {
        let h = a.whitespace == "pre", p = !!a.contentMatch.matchType(a.schema.linebreakReplacement);
        h && !p ? d = !1 : !h && p && (d = !0);
      }
      d === !1 && pm(e, o, i, r), ac(e, e.mapping.slice(r).map(i, 1), a, void 0, d === null);
      let u = e.mapping.slice(r), f = u.map(i, 1), b = u.map(i + o.nodeSize, 1);
      return e.step(new Yt(f, b, f + 1, b - 1, new Xe(Ve.from(a.create(s, null, o.marks)), 0, 0), 1, !0)), d === !0 && mm(e, o, i, r), !1;
    }
  });
}
function mm(e, n, t, a) {
  n.forEach((l, r) => {
    if (l.isText) {
      let o, i = /\r?\n|\r/g;
      for (; o = i.exec(l.text); ) {
        let s = e.mapping.slice(a).map(t + 1 + r + o.index);
        e.replaceWith(s, s + 1, n.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function pm(e, n, t, a) {
  n.forEach((l, r) => {
    if (l.type == l.type.schema.linebreakReplacement) {
      let o = e.mapping.slice(a).map(t + 1 + r);
      e.replaceWith(o, o + 1, n.type.schema.text(`
`));
    }
  });
}
function q$(e, n, t) {
  let a = e.resolve(n), l = a.index();
  return a.parent.canReplaceWith(l, l + 1, t);
}
function U$(e, n, t, a, l) {
  let r = e.doc.nodeAt(n);
  if (!r)
    throw new RangeError("No node at given position");
  t || (t = r.type);
  let o = t.create(a, null, l || r.marks);
  if (r.isLeaf)
    return e.replaceWith(n, n + r.nodeSize, o);
  if (!t.validContent(r.content))
    throw new RangeError("Invalid content for node type " + t.name);
  e.step(new Yt(n, n + r.nodeSize, n + 1, n + r.nodeSize - 1, new Xe(Ve.from(o), 0, 0), 1, !0));
}
function pa(e, n, t = 1, a) {
  let l = e.resolve(n), r = l.depth - t, o = a && a[a.length - 1] || l.parent;
  if (r < 0 || l.parent.type.spec.isolating || !l.parent.canReplace(l.index(), l.parent.childCount) || !o.type.validContent(l.parent.content.cutByIndex(l.index(), l.parent.childCount)))
    return !1;
  for (let d = l.depth - 1, u = t - 2; d > r; d--, u--) {
    let f = l.node(d), b = l.index(d);
    if (f.type.spec.isolating)
      return !1;
    let h = f.content.cutByIndex(b, f.childCount), p = a && a[u + 1];
    p && (h = h.replaceChild(0, p.type.create(p.attrs)));
    let x = a && a[u] || f;
    if (!f.canReplace(b + 1, f.childCount) || !x.type.validContent(h))
      return !1;
  }
  let i = l.indexAfter(r), s = a && a[0];
  return l.node(r).canReplaceWith(i, i, s ? s.type : l.node(r + 1).type);
}
function G$(e, n, t = 1, a) {
  let l = e.doc.resolve(n), r = Ve.empty, o = Ve.empty;
  for (let i = l.depth, s = l.depth - t, d = t - 1; i > s; i--, d--) {
    r = Ve.from(l.node(i).copy(r));
    let u = a && a[d];
    o = Ve.from(u ? u.type.create(u.attrs, o) : l.node(i).copy(o));
  }
  e.step(new Ft(n, n, new Xe(r.append(o), t, t), !0));
}
function Qa(e, n) {
  let t = e.resolve(n), a = t.index();
  return vm(t.nodeBefore, t.nodeAfter) && t.parent.canReplace(a, a + 1);
}
function K$(e, n) {
  n.content.size || e.type.compatibleContent(n.type);
  let t = e.contentMatchAt(e.childCount), { linebreakReplacement: a } = e.type.schema;
  for (let l = 0; l < n.childCount; l++) {
    let r = n.child(l), o = r.type == a ? e.type.schema.nodes.text : r.type;
    if (t = t.matchType(o), !t || !e.type.allowsMarks(r.marks))
      return !1;
  }
  return t.validEnd;
}
function vm(e, n) {
  return !!(e && n && !e.isLeaf && K$(e, n));
}
function ds(e, n, t = -1) {
  let a = e.resolve(n);
  for (let l = a.depth; ; l--) {
    let r, o, i = a.index(l);
    if (l == a.depth ? (r = a.nodeBefore, o = a.nodeAfter) : t > 0 ? (r = a.node(l + 1), i++, o = a.node(l).maybeChild(i)) : (r = a.node(l).maybeChild(i - 1), o = a.node(l + 1)), r && !r.isTextblock && vm(r, o) && a.node(l).canReplace(i, i + 1))
      return n;
    if (l == 0)
      break;
    n = t < 0 ? a.before(l) : a.after(l);
  }
}
function Y$(e, n, t) {
  let a = null, { linebreakReplacement: l } = e.doc.type.schema, r = e.doc.resolve(n - t), o = r.node().type;
  if (l && o.inlineContent) {
    let u = o.whitespace == "pre", f = !!o.contentMatch.matchType(l);
    u && !f ? a = !1 : !u && f && (a = !0);
  }
  let i = e.steps.length;
  if (a === !1) {
    let u = e.doc.resolve(n + t);
    pm(e, u.node(), u.before(), i);
  }
  o.inlineContent && ac(e, n + t - 1, o, r.node().contentMatchAt(r.index()), a == null);
  let s = e.mapping.slice(i), d = s.map(n - t);
  if (e.step(new Ft(d, s.map(n + t, -1), Xe.empty, !0)), a === !0) {
    let u = e.doc.resolve(d);
    mm(e, u.node(), u.before(), e.steps.length);
  }
  return e;
}
function J$(e, n, t) {
  let a = e.resolve(n);
  if (a.parent.canReplaceWith(a.index(), a.index(), t))
    return n;
  if (a.parentOffset == 0)
    for (let l = a.depth - 1; l >= 0; l--) {
      let r = a.index(l);
      if (a.node(l).canReplaceWith(r, r, t))
        return a.before(l + 1);
      if (r > 0)
        return null;
    }
  if (a.parentOffset == a.parent.content.size)
    for (let l = a.depth - 1; l >= 0; l--) {
      let r = a.indexAfter(l);
      if (a.node(l).canReplaceWith(r, r, t))
        return a.after(l + 1);
      if (r < a.node(l).childCount)
        return null;
    }
  return null;
}
function xm(e, n, t) {
  let a = e.resolve(n);
  if (!t.content.size)
    return n;
  let l = t.content;
  for (let r = 0; r < t.openStart; r++)
    l = l.firstChild.content;
  for (let r = 1; r <= (t.openStart == 0 && t.size ? 2 : 1); r++)
    for (let o = a.depth; o >= 0; o--) {
      let i = o == a.depth ? 0 : a.pos <= (a.start(o + 1) + a.end(o + 1)) / 2 ? -1 : 1, s = a.index(o) + (i > 0 ? 1 : 0), d = a.node(o), u = !1;
      if (r == 1)
        u = d.canReplace(s, s, l);
      else {
        let f = d.contentMatchAt(s).findWrapping(l.firstChild.type);
        u = f && d.canReplaceWith(s, s, f[0]);
      }
      if (u)
        return i == 0 ? a.pos : i < 0 ? a.before(o + 1) : a.after(o + 1);
    }
  return null;
}
function us(e, n, t = n, a = Xe.empty) {
  if (n == t && !a.size)
    return null;
  let l = e.resolve(n), r = e.resolve(t);
  return ym(l, r, a) ? new Ft(n, t, a) : new X$(l, r, a).fit();
}
function ym(e, n, t) {
  return !t.openStart && !t.openEnd && e.start() == n.start() && e.parent.canReplace(e.index(), n.index(), t.content);
}
class X$ {
  constructor(n, t, a) {
    this.$from = n, this.$to = t, this.unplaced = a, this.frontier = [], this.placed = Ve.empty;
    for (let l = 0; l <= n.depth; l++) {
      let r = n.node(l);
      this.frontier.push({
        type: r.type,
        match: r.contentMatchAt(n.indexAfter(l))
      });
    }
    for (let l = n.depth; l > 0; l--)
      this.placed = Ve.from(n.node(l).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let d = this.findFittable();
      d ? this.placeNodes(d) : this.openMore() || this.dropNode();
    }
    let n = this.mustMoveInline(), t = this.placed.size - this.depth - this.$from.depth, a = this.$from, l = this.close(n < 0 ? this.$to : a.doc.resolve(n));
    if (!l)
      return null;
    let r = this.placed, o = a.depth, i = l.depth;
    for (; o && i && r.childCount == 1; )
      r = r.firstChild.content, o--, i--;
    let s = new Xe(r, o, i);
    return n > -1 ? new Yt(a.pos, n, this.$to.pos, this.$to.end(), s, t) : s.size || a.pos != this.$to.pos ? new Ft(a.pos, l.pos, s) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let n = this.unplaced.openStart;
    for (let t = this.unplaced.content, a = 0, l = this.unplaced.openEnd; a < n; a++) {
      let r = t.firstChild;
      if (t.childCount > 1 && (l = 0), r.type.spec.isolating && l <= a) {
        n = a;
        break;
      }
      t = r.content;
    }
    for (let t = 1; t <= 2; t++)
      for (let a = t == 1 ? n : this.unplaced.openStart; a >= 0; a--) {
        let l, r = null;
        a ? (r = Ns(this.unplaced.content, a - 1).firstChild, l = r.content) : l = this.unplaced.content;
        let o = l.firstChild;
        for (let i = this.depth; i >= 0; i--) {
          let { type: s, match: d } = this.frontier[i], u, f = null;
          if (t == 1 && (o ? d.matchType(o.type) || (f = d.fillBefore(Ve.from(o), !1)) : r && s.compatibleContent(r.type)))
            return { sliceDepth: a, frontierDepth: i, parent: r, inject: f };
          if (t == 2 && o && (u = d.findWrapping(o.type)))
            return { sliceDepth: a, frontierDepth: i, parent: r, wrap: u };
          if (r && d.matchType(r.type))
            break;
        }
      }
  }
  openMore() {
    let { content: n, openStart: t, openEnd: a } = this.unplaced, l = Ns(n, t);
    return !l.childCount || l.firstChild.isLeaf ? !1 : (this.unplaced = new Xe(n, t + 1, Math.max(a, l.size + t >= n.size - a ? t + 1 : 0)), !0);
  }
  dropNode() {
    let { content: n, openStart: t, openEnd: a } = this.unplaced, l = Ns(n, t);
    if (l.childCount <= 1 && t > 0) {
      let r = n.size - t <= t + l.size;
      this.unplaced = new Xe(kr(n, t - 1, 1), t - 1, r ? t - 1 : a);
    } else
      this.unplaced = new Xe(kr(n, t, 1), t, a);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: n, frontierDepth: t, parent: a, inject: l, wrap: r }) {
    for (; this.depth > t; )
      this.closeFrontierNode();
    if (r)
      for (let x = 0; x < r.length; x++)
        this.openFrontierNode(r[x]);
    let o = this.unplaced, i = a ? a.content : o.content, s = o.openStart - n, d = 0, u = [], { match: f, type: b } = this.frontier[t];
    if (l) {
      for (let x = 0; x < l.childCount; x++)
        u.push(l.child(x));
      f = f.matchFragment(l);
    }
    let h = i.size + n - (o.content.size - o.openEnd);
    for (; d < i.childCount; ) {
      let x = i.child(d), y = f.matchType(x.type);
      if (!y)
        break;
      d++, (d > 1 || s == 0 || x.content.size) && (f = y, u.push(km(x.mark(b.allowedMarks(x.marks)), d == 1 ? s : 0, d == i.childCount ? h : -1)));
    }
    let p = d == i.childCount;
    p || (h = -1), this.placed = wr(this.placed, t, Ve.from(u)), this.frontier[t].match = f, p && h < 0 && a && a.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let x = 0, y = i; x < h; x++) {
      let k = y.lastChild;
      this.frontier.push({ type: k.type, match: k.contentMatchAt(k.childCount) }), y = k.content;
    }
    this.unplaced = p ? n == 0 ? Xe.empty : new Xe(kr(o.content, n - 1, 1), n - 1, h < 0 ? o.openEnd : n - 1) : new Xe(kr(o.content, n, d), o.openStart, o.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let n = this.frontier[this.depth], t;
    if (!n.type.isTextblock || !Hs(this.$to, this.$to.depth, n.type, n.match, !1) || this.$to.depth == this.depth && (t = this.findCloseLevel(this.$to)) && t.depth == this.depth)
      return -1;
    let { depth: a } = this.$to, l = this.$to.after(a);
    for (; a > 1 && l == this.$to.end(--a); )
      ++l;
    return l;
  }
  findCloseLevel(n) {
    e: for (let t = Math.min(this.depth, n.depth); t >= 0; t--) {
      let { match: a, type: l } = this.frontier[t], r = t < n.depth && n.end(t + 1) == n.pos + (n.depth - (t + 1)), o = Hs(n, t, l, a, r);
      if (o) {
        for (let i = t - 1; i >= 0; i--) {
          let { match: s, type: d } = this.frontier[i], u = Hs(n, i, d, s, !0);
          if (!u || u.childCount)
            continue e;
        }
        return { depth: t, fit: o, move: r ? n.doc.resolve(n.after(t + 1)) : n };
      }
    }
  }
  close(n) {
    let t = this.findCloseLevel(n);
    if (!t)
      return null;
    for (; this.depth > t.depth; )
      this.closeFrontierNode();
    t.fit.childCount && (this.placed = wr(this.placed, t.depth, t.fit)), n = t.move;
    for (let a = t.depth + 1; a <= n.depth; a++) {
      let l = n.node(a), r = l.type.contentMatch.fillBefore(l.content, !0, n.index(a));
      this.openFrontierNode(l.type, l.attrs, r);
    }
    return n;
  }
  openFrontierNode(n, t = null, a) {
    let l = this.frontier[this.depth];
    l.match = l.match.matchType(n), this.placed = wr(this.placed, this.depth, Ve.from(n.create(t, a))), this.frontier.push({ type: n, match: n.contentMatch });
  }
  closeFrontierNode() {
    let t = this.frontier.pop().match.fillBefore(Ve.empty, !0);
    t.childCount && (this.placed = wr(this.placed, this.frontier.length, t));
  }
}
function kr(e, n, t) {
  return n == 0 ? e.cutByIndex(t, e.childCount) : e.replaceChild(0, e.firstChild.copy(kr(e.firstChild.content, n - 1, t)));
}
function wr(e, n, t) {
  return n == 0 ? e.append(t) : e.replaceChild(e.childCount - 1, e.lastChild.copy(wr(e.lastChild.content, n - 1, t)));
}
function Ns(e, n) {
  for (let t = 0; t < n; t++)
    e = e.firstChild.content;
  return e;
}
function km(e, n, t) {
  if (n <= 0)
    return e;
  let a = e.content;
  return n > 1 && (a = a.replaceChild(0, km(a.firstChild, n - 1, a.childCount == 1 ? t - 1 : 0))), n > 0 && (a = e.type.contentMatch.fillBefore(a).append(a), t <= 0 && (a = a.append(e.type.contentMatch.matchFragment(a).fillBefore(Ve.empty, !0)))), e.copy(a);
}
function Hs(e, n, t, a, l) {
  let r = e.node(n), o = l ? e.indexAfter(n) : e.index(n);
  if (o == r.childCount && !t.compatibleContent(r.type))
    return null;
  let i = a.fillBefore(r.content, !0, o);
  return i && !Z$(t, r.content, o) ? i : null;
}
function Z$(e, n, t) {
  for (let a = t; a < n.childCount; a++)
    if (!e.allowsMarks(n.child(a).marks))
      return !0;
  return !1;
}
function Q$(e) {
  return e.spec.defining || e.spec.definingForContent;
}
function _$(e, n, t, a) {
  if (!a.size)
    return e.deleteRange(n, t);
  let l = e.doc.resolve(n), r = e.doc.resolve(t);
  if (ym(l, r, a))
    return e.step(new Ft(n, t, a));
  let o = Cm(l, r);
  o[o.length - 1] == 0 && o.pop();
  let i = -(l.depth + 1);
  o.unshift(i);
  for (let b = l.depth, h = l.pos - 1; b > 0; b--, h--) {
    let p = l.node(b).type.spec;
    if (p.defining || p.definingAsContext || p.isolating)
      break;
    o.indexOf(b) > -1 ? i = b : l.before(b) == h && o.splice(1, 0, -b);
  }
  let s = o.indexOf(i), d = [], u = a.openStart;
  for (let b = a.content, h = 0; ; h++) {
    let p = b.firstChild;
    if (d.push(p), h == a.openStart)
      break;
    b = p.content;
  }
  for (let b = u - 1; b >= 0; b--) {
    let h = d[b], p = Q$(h.type);
    if (p && !h.sameMarkup(l.node(Math.abs(i) - 1)))
      u = b;
    else if (p || !h.type.isTextblock)
      break;
  }
  for (let b = a.openStart; b >= 0; b--) {
    let h = (b + u + 1) % (a.openStart + 1), p = d[h];
    if (p)
      for (let x = 0; x < o.length; x++) {
        let y = o[(x + s) % o.length], k = !0;
        y < 0 && (k = !1, y = -y);
        let $ = l.node(y - 1), S = l.index(y - 1);
        if ($.canReplaceWith(S, S, p.type, p.marks))
          return e.replace(l.before(y), k ? r.after(y) : t, new Xe(wm(a.content, 0, a.openStart, h), h, a.openEnd));
      }
  }
  let f = e.steps.length;
  for (let b = o.length - 1; b >= 0 && (e.replace(n, t, a), !(e.steps.length > f)); b--) {
    let h = o[b];
    h < 0 || (n = l.before(h), t = r.after(h));
  }
}
function wm(e, n, t, a, l) {
  if (n < t) {
    let r = e.firstChild;
    e = e.replaceChild(0, r.copy(wm(r.content, n + 1, t, a, r)));
  }
  if (n > a) {
    let r = l.contentMatchAt(0), o = r.fillBefore(e).append(e);
    e = o.append(r.matchFragment(o).fillBefore(Ve.empty, !0));
  }
  return e;
}
function eI(e, n, t, a) {
  if (!a.isInline && n == t && e.doc.resolve(n).parent.content.size) {
    let l = J$(e.doc, n, a.type);
    l != null && (n = t = l);
  }
  e.replaceRange(n, t, new Xe(Ve.from(a), 0, 0));
}
function tI(e, n, t) {
  let a = e.doc.resolve(n), l = e.doc.resolve(t);
  if (a.parent.isTextblock && l.parent.isTextblock && a.start() != l.start() && a.parentOffset == 0 && l.parentOffset == 0) {
    let o = a.sharedDepth(t), i = !1;
    for (let s = a.depth; s > o; s--)
      a.node(s).type.spec.isolating && (i = !0);
    for (let s = l.depth; s > o; s--)
      l.node(s).type.spec.isolating && (i = !0);
    if (!i) {
      for (let s = a.depth; s > 0 && n == a.start(s); s--)
        n = a.before(s);
      for (let s = l.depth; s > 0 && t == l.start(s); s--)
        t = l.before(s);
      a = e.doc.resolve(n), l = e.doc.resolve(t);
    }
  }
  let r = Cm(a, l);
  for (let o = 0; o < r.length; o++) {
    let i = r[o], s = o == r.length - 1;
    if (s && i == 0 || a.node(i).type.contentMatch.validEnd)
      return e.delete(a.start(i), l.end(i));
    if (i > 0 && (s || a.node(i - 1).canReplace(a.index(i - 1), l.indexAfter(i - 1))))
      return e.delete(a.before(i), l.after(i));
  }
  for (let o = 1; o <= a.depth && o <= l.depth; o++)
    if (n - a.start(o) == a.depth - o && t > a.end(o) && l.end(o) - t != l.depth - o && a.start(o - 1) == l.start(o - 1) && a.node(o - 1).canReplace(a.index(o - 1), l.index(o - 1)))
      return e.delete(a.before(o), t);
  e.delete(n, t);
}
function Cm(e, n) {
  let t = [], a = Math.min(e.depth, n.depth);
  for (let l = a; l >= 0; l--) {
    let r = e.start(l);
    if (r < e.pos - (e.depth - l) || n.end(l) > n.pos + (n.depth - l) || e.node(l).type.spec.isolating || n.node(l).type.spec.isolating)
      break;
    (r == n.start(l) || l == e.depth && l == n.depth && e.parent.inlineContent && n.parent.inlineContent && l && n.start(l - 1) == r - 1) && t.push(l);
  }
  return t;
}
class Pl extends on {
  /**
  Construct an attribute step.
  */
  constructor(n, t, a) {
    super(), this.pos = n, this.attr = t, this.value = a;
  }
  apply(n) {
    let t = n.nodeAt(this.pos);
    if (!t)
      return Vt.fail("No node at attribute step's position");
    let a = /* @__PURE__ */ Object.create(null);
    for (let r in t.attrs)
      a[r] = t.attrs[r];
    a[this.attr] = this.value;
    let l = t.type.create(a, null, t.marks);
    return Vt.fromReplace(n, this.pos, this.pos + 1, new Xe(Ve.from(l), 0, t.isLeaf ? 0 : 1));
  }
  getMap() {
    return kn.empty;
  }
  invert(n) {
    return new Pl(this.pos, this.attr, n.nodeAt(this.pos).attrs[this.attr]);
  }
  map(n) {
    let t = n.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Pl(t.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(n, t) {
    if (typeof t.pos != "number" || typeof t.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new Pl(t.pos, t.attr, t.value);
  }
}
on.jsonID("attr", Pl);
class Qr extends on {
  /**
  Construct an attribute step.
  */
  constructor(n, t) {
    super(), this.attr = n, this.value = t;
  }
  apply(n) {
    let t = /* @__PURE__ */ Object.create(null);
    for (let l in n.attrs)
      t[l] = n.attrs[l];
    t[this.attr] = this.value;
    let a = n.type.create(t, n.content, n.marks);
    return Vt.ok(a);
  }
  getMap() {
    return kn.empty;
  }
  invert(n) {
    return new Qr(this.attr, n.attrs[this.attr]);
  }
  map(n) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(n, t) {
    if (typeof t.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new Qr(t.attr, t.value);
  }
}
on.jsonID("docAttr", Qr);
let Kl = class extends Error {
};
Kl = function e(n) {
  let t = Error.call(this, n);
  return t.__proto__ = e.prototype, t;
};
Kl.prototype = Object.create(Error.prototype);
Kl.prototype.constructor = Kl;
Kl.prototype.name = "TransformError";
class Sm {
  /**
  Create a transform that starts with the given document.
  */
  constructor(n) {
    this.doc = n, this.steps = [], this.docs = [], this.mapping = new Zr();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(n) {
    let t = this.maybeStep(n);
    if (t.failed)
      throw new Kl(t.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(n) {
    let t = n.apply(this.doc);
    return t.failed || this.addStep(n, t.doc), t;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  Return a single range, in post-transform document positions,
  that covers all content changed by this transform. Returns null
  if no replacements are made. Note that this will ignore changes
  that add/remove marks without replacing the underlying content.
  */
  changedRange() {
    let n = 1e9, t = -1e9;
    for (let a = 0; a < this.mapping.maps.length; a++) {
      let l = this.mapping.maps[a];
      a && (n = l.map(n, 1), t = l.map(t, -1)), l.forEach((r, o, i, s) => {
        n = Math.min(n, i), t = Math.max(t, s);
      });
    }
    return n == 1e9 ? null : { from: n, to: t };
  }
  /**
  @internal
  */
  addStep(n, t) {
    this.docs.push(this.doc), this.steps.push(n), this.mapping.appendMap(n.getMap()), this.doc = t;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(n, t = n, a = Xe.empty) {
    let l = us(this.doc, n, t, a);
    return l && this.step(l), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(n, t, a) {
    return this.replace(n, t, new Xe(Ve.from(a), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(n, t) {
    return this.replace(n, t, Xe.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(n, t) {
    return this.replaceWith(n, n, t);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(n, t, a) {
    return _$(this, n, t, a), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(n, t, a) {
    return eI(this, n, t, a), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(n, t) {
    return tI(this, n, t), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(n, t) {
    return V$(this, n, t), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(n, t = 1) {
    return Y$(this, n, t), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(n, t) {
    return j$(this, n, t), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(n, t = n, a, l = null) {
    return W$(this, n, t, a, l), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(n, t, a = null, l) {
    return U$(this, n, t, a, l), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(n, t, a) {
    return this.step(new Pl(n, t, a)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(n, t) {
    return this.step(new Qr(n, t)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(n, t) {
    return this.step(new Ba(n, t)), this;
  }
  /**
  Remove a mark (or all marks of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(n, t) {
    let a = this.doc.nodeAt(n);
    if (!a)
      throw new RangeError("No node at position " + n);
    if (t instanceof Ct)
      t.isInSet(a.marks) && this.step(new yl(n, t));
    else {
      let l = a.marks, r, o = [];
      for (; r = t.isInSet(l); )
        o.push(new yl(n, r)), l = r.removeFromSet(l);
      for (let i = o.length - 1; i >= 0; i--)
        this.step(o[i]);
    }
    return this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(n, t = 1, a) {
    return G$(this, n, t, a), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(n, t, a) {
    return O$(this, n, t, a), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(n, t, a) {
    return P$(this, n, t, a), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(n, t, a) {
    return ac(this, n, t, a), this;
  }
}
const js = /* @__PURE__ */ Object.create(null);
class st {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(n, t, a) {
    this.$anchor = n, this.$head = t, this.ranges = a || [new nI(n.min(t), n.max(t))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let n = this.ranges;
    for (let t = 0; t < n.length; t++)
      if (n[t].$from.pos != n[t].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(n, t = Xe.empty) {
    let a = t.content.lastChild, l = null;
    for (let i = 0; i < t.openEnd; i++)
      l = a, a = a.lastChild;
    let r = n.steps.length, o = this.ranges;
    for (let i = 0; i < o.length; i++) {
      let { $from: s, $to: d } = o[i], u = n.mapping.slice(r);
      n.replaceRange(u.map(s.pos), u.map(d.pos), i ? Xe.empty : t), i == 0 && Kf(n, r, (a ? a.isInline : l && l.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(n, t) {
    let a = n.steps.length, l = this.ranges;
    for (let r = 0; r < l.length; r++) {
      let { $from: o, $to: i } = l[r], s = n.mapping.slice(a), d = s.map(o.pos), u = s.map(i.pos);
      r ? n.deleteRange(d, u) : (n.replaceRangeWith(d, u, t), Kf(n, a, t.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(n, t, a = !1) {
    let l = n.parent.inlineContent ? new rt(n) : Al(n.node(0), n.parent, n.pos, n.index(), t, a);
    if (l)
      return l;
    for (let r = n.depth - 1; r >= 0; r--) {
      let o = t < 0 ? Al(n.node(0), n.node(r), n.before(r + 1), n.index(r), t, a) : Al(n.node(0), n.node(r), n.after(r + 1), n.index(r) + 1, t, a);
      if (o)
        return o;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(n, t = 1) {
    return this.findFrom(n, t) || this.findFrom(n, -t) || new wn(n.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(n) {
    return Al(n, n, 0, 0, 1) || new wn(n);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(n) {
    return Al(n, n, n.content.size, n.childCount, -1) || new wn(n);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(n, t) {
    if (!t || !t.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let a = js[t.type];
    if (!a)
      throw new RangeError(`No selection type ${t.type} defined`);
    return a.fromJSON(n, t);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(n, t) {
    if (n in js)
      throw new RangeError("Duplicate use of selection JSON ID " + n);
    return js[n] = t, t.prototype.jsonID = n, t;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return rt.between(this.$anchor, this.$head).getBookmark();
  }
}
st.prototype.visible = !0;
class nI {
  /**
  Create a range.
  */
  constructor(n, t) {
    this.$from = n, this.$to = t;
  }
}
let Uf = !1;
function Gf(e) {
  !Uf && !e.parent.inlineContent && (Uf = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + e.parent.type.name + ")"));
}
class rt extends st {
  /**
  Construct a text selection between the given points.
  */
  constructor(n, t = n) {
    Gf(n), Gf(t), super(n, t);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(n, t) {
    let a = n.resolve(t.map(this.head));
    if (!a.parent.inlineContent)
      return st.near(a);
    let l = n.resolve(t.map(this.anchor));
    return new rt(l.parent.inlineContent ? l : a, a);
  }
  replace(n, t = Xe.empty) {
    if (super.replace(n, t), t == Xe.empty) {
      let a = this.$from.marksAcross(this.$to);
      a && n.ensureMarks(a);
    }
  }
  eq(n) {
    return n instanceof rt && n.anchor == this.anchor && n.head == this.head;
  }
  getBookmark() {
    return new cs(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new rt(n.resolve(t.anchor), n.resolve(t.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(n, t, a = t) {
    let l = n.resolve(t);
    return new this(l, a == t ? l : n.resolve(a));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(n, t, a) {
    let l = n.pos - t.pos;
    if ((!a || l) && (a = l >= 0 ? 1 : -1), !t.parent.inlineContent) {
      let r = st.findFrom(t, a, !0) || st.findFrom(t, -a, !0);
      if (r)
        t = r.$head;
      else
        return st.near(t, a);
    }
    return n.parent.inlineContent || (l == 0 ? n = t : (n = (st.findFrom(n, -a, !0) || st.findFrom(n, a, !0)).$anchor, n.pos < t.pos != l < 0 && (n = t))), new rt(n, t);
  }
}
st.jsonID("text", rt);
class cs {
  constructor(n, t) {
    this.anchor = n, this.head = t;
  }
  map(n) {
    return new cs(n.map(this.anchor), n.map(this.head));
  }
  resolve(n) {
    return rt.between(n.resolve(this.anchor), n.resolve(this.head));
  }
}
class tt extends st {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(n) {
    let t = n.nodeAfter, a = n.node(0).resolve(n.pos + t.nodeSize);
    super(n, a), this.node = t;
  }
  map(n, t) {
    let { deleted: a, pos: l } = t.mapResult(this.anchor), r = n.resolve(l);
    return a ? st.near(r) : new tt(r);
  }
  content() {
    return new Xe(Ve.from(this.node), 0, 0);
  }
  eq(n) {
    return n instanceof tt && n.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new rc(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new tt(n.resolve(t.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(n, t) {
    return new tt(n.resolve(t));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(n) {
    return !n.isText && n.type.spec.selectable !== !1;
  }
}
tt.prototype.visible = !1;
st.jsonID("node", tt);
class rc {
  constructor(n) {
    this.anchor = n;
  }
  map(n) {
    let { deleted: t, pos: a } = n.mapResult(this.anchor);
    return t ? new cs(a, a) : new rc(a);
  }
  resolve(n) {
    let t = n.resolve(this.anchor), a = t.nodeAfter;
    return a && tt.isSelectable(a) ? new tt(t) : st.near(t);
  }
}
class wn extends st {
  /**
  Create an all-selection over the given document.
  */
  constructor(n) {
    super(n.resolve(0), n.resolve(n.content.size));
  }
  replace(n, t = Xe.empty) {
    if (t == Xe.empty) {
      n.delete(0, n.doc.content.size);
      let a = st.atStart(n.doc);
      a.eq(n.selection) || n.setSelection(a);
    } else
      super.replace(n, t);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(n) {
    return new wn(n);
  }
  map(n) {
    return new wn(n);
  }
  eq(n) {
    return n instanceof wn;
  }
  getBookmark() {
    return aI;
  }
}
st.jsonID("all", wn);
const aI = {
  map() {
    return this;
  },
  resolve(e) {
    return new wn(e);
  }
};
function Al(e, n, t, a, l, r = !1) {
  if (n.inlineContent)
    return rt.create(e, t);
  for (let o = a - (l > 0 ? 0 : 1); l > 0 ? o < n.childCount : o >= 0; o += l) {
    let i = n.child(o);
    if (i.isAtom) {
      if (!r && tt.isSelectable(i))
        return tt.create(e, t - (l < 0 ? i.nodeSize : 0));
    } else {
      let s = Al(e, i, t + l, l < 0 ? i.childCount : 0, l, r);
      if (s)
        return s;
    }
    t += i.nodeSize * l;
  }
  return null;
}
function Kf(e, n, t) {
  let a = e.steps.length - 1;
  if (a < n)
    return;
  let l = e.steps[a];
  if (!(l instanceof Ft || l instanceof Yt))
    return;
  let r = e.mapping.maps[a], o;
  r.forEach((i, s, d, u) => {
    o == null && (o = u);
  }), e.setSelection(st.near(e.doc.resolve(o), t));
}
const Yf = 1, Ao = 2, Jf = 4;
class lI extends Sm {
  /**
  @internal
  */
  constructor(n) {
    super(n.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = n.selection, this.storedMarks = n.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(n) {
    if (n.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = n, this.curSelectionFor = this.steps.length, this.updated = (this.updated | Yf) & ~Ao, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & Yf) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(n) {
    return this.storedMarks = n, this.updated |= Ao, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(n) {
    return Ct.sameSet(this.storedMarks || this.selection.$from.marks(), n) || this.setStoredMarks(n), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(n) {
    return this.ensureMarks(n.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(n) {
    return this.ensureMarks(n.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & Ao) > 0;
  }
  /**
  @internal
  */
  addStep(n, t) {
    super.addStep(n, t), this.updated = this.updated & ~Ao, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(n) {
    return this.time = n, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(n) {
    return this.selection.replace(this, n), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(n, t = !0) {
    let a = this.selection;
    return t && (n = n.mark(this.storedMarks || (a.empty ? a.$from.marks() : a.$from.marksAcross(a.$to) || Ct.none))), a.replaceWith(this, n), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(n, t, a) {
    let l = this.doc.type.schema;
    if (t == null)
      return n ? this.replaceSelectionWith(l.text(n), !0) : this.deleteSelection();
    {
      if (a == null && (a = t), !n)
        return this.deleteRange(t, a);
      let r = this.storedMarks;
      if (!r) {
        let o = this.doc.resolve(t);
        r = a == t ? o.marks() : o.marksAcross(this.doc.resolve(a));
      }
      return this.replaceRangeWith(t, a, l.text(n, r)), !this.selection.empty && this.selection.to == t + n.length && this.setSelection(st.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(n, t) {
    return this.meta[typeof n == "string" ? n : n.key] = t, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(n) {
    return this.meta[typeof n == "string" ? n : n.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let n in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= Jf, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & Jf) > 0;
  }
}
function Xf(e, n) {
  return !n || !e ? e : e.bind(n);
}
class Cr {
  constructor(n, t, a) {
    this.name = n, this.init = Xf(t.init, a), this.apply = Xf(t.apply, a);
  }
}
const rI = [
  new Cr("doc", {
    init(e) {
      return e.doc || e.schema.topNodeType.createAndFill();
    },
    apply(e) {
      return e.doc;
    }
  }),
  new Cr("selection", {
    init(e, n) {
      return e.selection || st.atStart(n.doc);
    },
    apply(e) {
      return e.selection;
    }
  }),
  new Cr("storedMarks", {
    init(e) {
      return e.storedMarks || null;
    },
    apply(e, n, t, a) {
      return a.selection.$cursor ? e.storedMarks : null;
    }
  }),
  new Cr("scrollToSelection", {
    init() {
      return 0;
    },
    apply(e, n) {
      return e.scrolledIntoView ? n + 1 : n;
    }
  })
];
class Ws {
  constructor(n, t) {
    this.schema = n, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = rI.slice(), t && t.forEach((a) => {
      if (this.pluginsByKey[a.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + a.key + ")");
      this.plugins.push(a), this.pluginsByKey[a.key] = a, a.spec.state && this.fields.push(new Cr(a.key, a.spec.state, a));
    });
  }
}
class Ml {
  /**
  @internal
  */
  constructor(n) {
    this.config = n;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(n) {
    return this.applyTransaction(n).state;
  }
  /**
  @internal
  */
  filterTransaction(n, t = -1) {
    for (let a = 0; a < this.config.plugins.length; a++)
      if (a != t) {
        let l = this.config.plugins[a];
        if (l.spec.filterTransaction && !l.spec.filterTransaction.call(l, n, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(n) {
    if (!this.filterTransaction(n))
      return { state: this, transactions: [] };
    let t = [n], a = this.applyInner(n), l = null;
    for (; ; ) {
      let r = !1;
      for (let o = 0; o < this.config.plugins.length; o++) {
        let i = this.config.plugins[o];
        if (i.spec.appendTransaction) {
          let s = l ? l[o].n : 0, d = l ? l[o].state : this, u = s < t.length && i.spec.appendTransaction.call(i, s ? t.slice(s) : t, d, a);
          if (u && a.filterTransaction(u, o)) {
            if (u.setMeta("appendedTransaction", n), !l) {
              l = [];
              for (let f = 0; f < this.config.plugins.length; f++)
                l.push(f < o ? { state: a, n: t.length } : { state: this, n: 0 });
            }
            t.push(u), a = a.applyInner(u), r = !0;
          }
          l && (l[o] = { state: a, n: t.length });
        }
      }
      if (!r)
        return { state: a, transactions: t };
    }
  }
  /**
  @internal
  */
  applyInner(n) {
    if (!n.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let t = new Ml(this.config), a = this.config.fields;
    for (let l = 0; l < a.length; l++) {
      let r = a[l];
      t[r.name] = r.apply(n, this[r.name], this, t);
    }
    return t;
  }
  /**
  Accessor that constructs and returns a new [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new lI(this);
  }
  /**
  Create a new state.
  */
  static create(n) {
    let t = new Ws(n.doc ? n.doc.type.schema : n.schema, n.plugins), a = new Ml(t);
    for (let l = 0; l < t.fields.length; l++)
      a[t.fields[l].name] = t.fields[l].init(n, a);
    return a;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(n) {
    let t = new Ws(this.schema, n.plugins), a = t.fields, l = new Ml(t);
    for (let r = 0; r < a.length; r++) {
      let o = a[r].name;
      l[o] = this.hasOwnProperty(o) ? this[o] : a[r].init(n, l);
    }
    return l;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(n) {
    let t = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (t.storedMarks = this.storedMarks.map((a) => a.toJSON())), n && typeof n == "object")
      for (let a in n) {
        if (a == "doc" || a == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let l = n[a], r = l.spec.state;
        r && r.toJSON && (t[a] = r.toJSON.call(l, this[l.key]));
      }
    return t;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(n, t, a) {
    if (!t)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!n.schema)
      throw new RangeError("Required config field 'schema' missing");
    let l = new Ws(n.schema, n.plugins), r = new Ml(l);
    return l.fields.forEach((o) => {
      if (o.name == "doc")
        r.doc = Oa.fromJSON(n.schema, t.doc);
      else if (o.name == "selection")
        r.selection = st.fromJSON(r.doc, t.selection);
      else if (o.name == "storedMarks")
        t.storedMarks && (r.storedMarks = t.storedMarks.map(n.schema.markFromJSON));
      else {
        if (a)
          for (let i in a) {
            let s = a[i], d = s.spec.state;
            if (s.key == o.name && d && d.fromJSON && Object.prototype.hasOwnProperty.call(t, i)) {
              r[o.name] = d.fromJSON.call(s, n, t[i], r);
              return;
            }
          }
        r[o.name] = o.init(n, r);
      }
    }), r;
  }
}
function $m(e, n, t) {
  for (let a in e) {
    let l = e[a];
    l instanceof Function ? l = l.bind(n) : a == "handleDOMEvents" && (l = $m(l, n, {})), t[a] = l;
  }
  return t;
}
class Bt {
  /**
  Create a plugin.
  */
  constructor(n) {
    this.spec = n, this.props = {}, n.props && $m(n.props, this, this.props), this.key = n.key ? n.key.key : Im("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(n) {
    return n[this.key];
  }
}
const qs = /* @__PURE__ */ Object.create(null);
function Im(e) {
  return e in qs ? e + "$" + ++qs[e] : (qs[e] = 0, e + "$");
}
class qt {
  /**
  Create a plugin key.
  */
  constructor(n = "key") {
    this.key = Im(n);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(n) {
    return n.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(n) {
    return n[this.key];
  }
}
const Lm = (e, n) => e.selection.empty ? !1 : (n && n(e.tr.deleteSelection().scrollIntoView()), !0);
function Tm(e, n) {
  let { $cursor: t } = e.selection;
  return !t || (n ? !n.endOfTextblock("backward", e) : t.parentOffset > 0) ? null : t;
}
const Am = (e, n, t) => {
  let a = Tm(e, t);
  if (!a)
    return !1;
  let l = oc(a);
  if (!l) {
    let o = a.blockRange(), i = o && lr(o);
    return i == null ? !1 : (n && n(e.tr.lift(o, i).scrollIntoView()), !0);
  }
  let r = l.nodeBefore;
  if (Fm(e, l, n, -1))
    return !0;
  if (a.parent.content.size == 0 && (Yl(r, "end") || tt.isSelectable(r)))
    for (let o = a.depth; ; o--) {
      let i = us(e.doc, a.before(o), a.after(o), Xe.empty);
      if (i && i.slice.size < i.to - i.from) {
        if (n) {
          let s = e.tr.step(i);
          s.setSelection(Yl(r, "end") ? st.findFrom(s.doc.resolve(s.mapping.map(l.pos, -1)), -1) : tt.create(s.doc, l.pos - r.nodeSize)), n(s.scrollIntoView());
        }
        return !0;
      }
      if (o == 1 || a.node(o - 1).childCount > 1)
        break;
    }
  return r.isAtom && l.depth == a.depth - 1 ? (n && n(e.tr.delete(l.pos - r.nodeSize, l.pos).scrollIntoView()), !0) : !1;
}, oI = (e, n, t) => {
  let a = Tm(e, t);
  if (!a)
    return !1;
  let l = oc(a);
  return l ? Em(e, l, n) : !1;
}, iI = (e, n, t) => {
  let a = Bm(e, t);
  if (!a)
    return !1;
  let l = ic(a);
  return l ? Em(e, l, n) : !1;
};
function Em(e, n, t) {
  let a = n.nodeBefore, l = a, r = n.pos - 1;
  for (; !l.isTextblock; r--) {
    if (l.type.spec.isolating)
      return !1;
    let u = l.lastChild;
    if (!u)
      return !1;
    l = u;
  }
  let o = n.nodeAfter, i = o, s = n.pos + 1;
  for (; !i.isTextblock; s++) {
    if (i.type.spec.isolating)
      return !1;
    let u = i.firstChild;
    if (!u)
      return !1;
    i = u;
  }
  let d = us(e.doc, r, s, Xe.empty);
  if (!d || d.from != r || d instanceof Ft && d.slice.size >= s - r)
    return !1;
  if (t) {
    let u = e.tr.step(d);
    u.setSelection(rt.create(u.doc, r)), t(u.scrollIntoView());
  }
  return !0;
}
function Yl(e, n, t = !1) {
  for (let a = e; a; a = n == "start" ? a.firstChild : a.lastChild) {
    if (a.isTextblock)
      return !0;
    if (t && a.childCount != 1)
      return !1;
  }
  return !1;
}
const Rm = (e, n, t) => {
  let { $head: a, empty: l } = e.selection, r = a;
  if (!l)
    return !1;
  if (a.parent.isTextblock) {
    if (t ? !t.endOfTextblock("backward", e) : a.parentOffset > 0)
      return !1;
    r = oc(a);
  }
  let o = r && r.nodeBefore;
  return !o || !tt.isSelectable(o) ? !1 : (n && n(e.tr.setSelection(tt.create(e.doc, r.pos - o.nodeSize)).scrollIntoView()), !0);
};
function oc(e) {
  if (!e.parent.type.spec.isolating)
    for (let n = e.depth - 1; n >= 0; n--) {
      if (e.index(n) > 0)
        return e.doc.resolve(e.before(n + 1));
      if (e.node(n).type.spec.isolating)
        break;
    }
  return null;
}
function Bm(e, n) {
  let { $cursor: t } = e.selection;
  return !t || (n ? !n.endOfTextblock("forward", e) : t.parentOffset < t.parent.content.size) ? null : t;
}
const Mm = (e, n, t) => {
  let a = Bm(e, t);
  if (!a)
    return !1;
  let l = ic(a);
  if (!l)
    return !1;
  let r = l.nodeAfter;
  if (Fm(e, l, n, 1))
    return !0;
  if (a.parent.content.size == 0 && (Yl(r, "start") || tt.isSelectable(r))) {
    let o = us(e.doc, a.before(), a.after(), Xe.empty);
    if (o && o.slice.size < o.to - o.from) {
      if (n) {
        let i = e.tr.step(o);
        i.setSelection(Yl(r, "start") ? st.findFrom(i.doc.resolve(i.mapping.map(l.pos)), 1) : tt.create(i.doc, i.mapping.map(l.pos))), n(i.scrollIntoView());
      }
      return !0;
    }
  }
  return r.isAtom && l.depth == a.depth - 1 ? (n && n(e.tr.delete(l.pos, l.pos + r.nodeSize).scrollIntoView()), !0) : !1;
}, Dm = (e, n, t) => {
  let { $head: a, empty: l } = e.selection, r = a;
  if (!l)
    return !1;
  if (a.parent.isTextblock) {
    if (t ? !t.endOfTextblock("forward", e) : a.parentOffset < a.parent.content.size)
      return !1;
    r = ic(a);
  }
  let o = r && r.nodeAfter;
  return !o || !tt.isSelectable(o) ? !1 : (n && n(e.tr.setSelection(tt.create(e.doc, r.pos)).scrollIntoView()), !0);
};
function ic(e) {
  if (!e.parent.type.spec.isolating)
    for (let n = e.depth - 1; n >= 0; n--) {
      let t = e.node(n);
      if (e.index(n) + 1 < t.childCount)
        return e.doc.resolve(e.after(n + 1));
      if (t.type.spec.isolating)
        break;
    }
  return null;
}
const sI = (e, n) => {
  let t = e.selection, a = t instanceof tt, l;
  if (a) {
    if (t.node.isTextblock || !Qa(e.doc, t.from))
      return !1;
    l = t.from;
  } else if (l = ds(e.doc, t.from, -1), l == null)
    return !1;
  if (n) {
    let r = e.tr.join(l);
    a && r.setSelection(tt.create(r.doc, l - e.doc.resolve(l).nodeBefore.nodeSize)), n(r.scrollIntoView());
  }
  return !0;
}, dI = (e, n) => {
  let t = e.selection, a;
  if (t instanceof tt) {
    if (t.node.isTextblock || !Qa(e.doc, t.to))
      return !1;
    a = t.to;
  } else if (a = ds(e.doc, t.to, 1), a == null)
    return !1;
  return n && n(e.tr.join(a).scrollIntoView()), !0;
}, uI = (e, n) => {
  let { $from: t, $to: a } = e.selection, l = t.blockRange(a), r = l && lr(l);
  return r == null ? !1 : (n && n(e.tr.lift(l, r).scrollIntoView()), !0);
}, zm = (e, n) => {
  let { $head: t, $anchor: a } = e.selection;
  return !t.parent.type.spec.code || !t.sameParent(a) ? !1 : (n && n(e.tr.insertText(`
`).scrollIntoView()), !0);
};
function sc(e) {
  for (let n = 0; n < e.edgeCount; n++) {
    let { type: t } = e.edge(n);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
const cI = (e, n) => {
  let { $head: t, $anchor: a } = e.selection;
  if (!t.parent.type.spec.code || !t.sameParent(a))
    return !1;
  let l = t.node(-1), r = t.indexAfter(-1), o = sc(l.contentMatchAt(r));
  if (!o || !l.canReplaceWith(r, r, o))
    return !1;
  if (n) {
    let i = t.after(), s = e.tr.replaceWith(i, i, o.createAndFill());
    s.setSelection(st.near(s.doc.resolve(i), 1)), n(s.scrollIntoView());
  }
  return !0;
}, Om = (e, n) => {
  let t = e.selection, { $from: a, $to: l } = t;
  if (t instanceof wn || a.parent.inlineContent || l.parent.inlineContent)
    return !1;
  let r = sc(l.parent.contentMatchAt(l.indexAfter()));
  if (!r || !r.isTextblock)
    return !1;
  if (n) {
    let o = (!a.parentOffset && l.index() < l.parent.childCount ? a : l).pos, i = e.tr.insert(o, r.createAndFill());
    i.setSelection(rt.create(i.doc, o + 1)), n(i.scrollIntoView());
  }
  return !0;
}, Pm = (e, n) => {
  let { $cursor: t } = e.selection;
  if (!t || t.parent.content.size)
    return !1;
  if (t.depth > 1 && t.after() != t.end(-1)) {
    let r = t.before();
    if (pa(e.doc, r))
      return n && n(e.tr.split(r).scrollIntoView()), !0;
  }
  let a = t.blockRange(), l = a && lr(a);
  return l == null ? !1 : (n && n(e.tr.lift(a, l).scrollIntoView()), !0);
};
function fI(e) {
  return (n, t) => {
    let { $from: a, $to: l } = n.selection;
    if (n.selection instanceof tt && n.selection.node.isBlock)
      return !a.parentOffset || !pa(n.doc, a.pos) ? !1 : (t && t(n.tr.split(a.pos).scrollIntoView()), !0);
    if (!a.depth)
      return !1;
    let r = [], o, i, s = !1, d = !1;
    for (let h = a.depth; ; h--)
      if (a.node(h).isBlock) {
        s = a.end(h) == a.pos + (a.depth - h), d = a.start(h) == a.pos - (a.depth - h), i = sc(a.node(h - 1).contentMatchAt(a.indexAfter(h - 1))), r.unshift(s && i ? { type: i } : null), o = h;
        break;
      } else {
        if (h == 1)
          return !1;
        r.unshift(null);
      }
    let u = n.tr;
    (n.selection instanceof rt || n.selection instanceof wn) && u.deleteSelection();
    let f = u.mapping.map(a.pos), b = pa(u.doc, f, r.length, r);
    if (b || (r[0] = i ? { type: i } : null, b = pa(u.doc, f, r.length, r)), !b)
      return !1;
    if (u.split(f, r.length, r), !s && d && a.node(o).type != i) {
      let h = u.mapping.map(a.before(o)), p = u.doc.resolve(h);
      i && a.node(o - 1).canReplaceWith(p.index(), p.index() + 1, i) && u.setNodeMarkup(u.mapping.map(a.before(o)), i);
    }
    return t && t(u.scrollIntoView()), !0;
  };
}
const hI = fI(), bI = (e, n) => {
  let { $from: t, to: a } = e.selection, l, r = t.sharedDepth(a);
  return r == 0 ? !1 : (l = t.before(r), n && n(e.tr.setSelection(tt.create(e.doc, l))), !0);
};
function gI(e, n, t) {
  let a = n.nodeBefore, l = n.nodeAfter, r = n.index();
  return !a || !l || !a.type.compatibleContent(l.type) ? !1 : !a.content.size && n.parent.canReplace(r - 1, r) ? (t && t(e.tr.delete(n.pos - a.nodeSize, n.pos).scrollIntoView()), !0) : !n.parent.canReplace(r, r + 1) || !(l.isTextblock || Qa(e.doc, n.pos)) ? !1 : (t && t(e.tr.join(n.pos).scrollIntoView()), !0);
}
function Fm(e, n, t, a) {
  let l = n.nodeBefore, r = n.nodeAfter, o, i, s = l.type.spec.isolating || r.type.spec.isolating;
  if (!s && gI(e, n, t))
    return !0;
  let d = !s && n.parent.canReplace(n.index(), n.index() + 1);
  if (d && (o = (i = l.contentMatchAt(l.childCount)).findWrapping(r.type)) && i.matchType(o[0] || r.type).validEnd) {
    if (t) {
      let h = n.pos + r.nodeSize, p = Ve.empty;
      for (let k = o.length - 1; k >= 0; k--)
        p = Ve.from(o[k].create(null, p));
      p = Ve.from(l.copy(p));
      let x = e.tr.step(new Yt(n.pos - 1, h, n.pos, h, new Xe(p, 1, 0), o.length, !0)), y = x.doc.resolve(h + 2 * o.length);
      y.nodeAfter && y.nodeAfter.type == l.type && Qa(x.doc, y.pos) && x.join(y.pos), t(x.scrollIntoView());
    }
    return !0;
  }
  let u = r.type.spec.isolating || a > 0 && s ? null : st.findFrom(n, 1), f = u && u.$from.blockRange(u.$to), b = f && lr(f);
  if (b != null && b >= n.depth)
    return t && t(e.tr.lift(f, b).scrollIntoView()), !0;
  if (d && Yl(r, "start", !0) && Yl(l, "end")) {
    let h = l, p = [];
    for (; p.push(h), !h.isTextblock; )
      h = h.lastChild;
    let x = r, y = 1;
    for (; !x.isTextblock; x = x.firstChild)
      y++;
    if (h.canReplace(h.childCount, h.childCount, x.content)) {
      if (t) {
        let k = Ve.empty;
        for (let S = p.length - 1; S >= 0; S--)
          k = Ve.from(p[S].copy(k));
        let $ = e.tr.step(new Yt(n.pos - p.length, n.pos + r.nodeSize, n.pos + y, n.pos + r.nodeSize - y, new Xe(k, p.length, 0), 0, !0));
        t($.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function Vm(e) {
  return function(n, t) {
    let a = n.selection, l = e < 0 ? a.$from : a.$to, r = l.depth;
    for (; l.node(r).isInline; ) {
      if (!r)
        return !1;
      r--;
    }
    return l.node(r).isTextblock ? (t && t(n.tr.setSelection(rt.create(n.doc, e < 0 ? l.start(r) : l.end(r)))), !0) : !1;
  };
}
const mI = Vm(-1), pI = Vm(1);
function vI(e, n = null) {
  return function(t, a) {
    let { $from: l, $to: r } = t.selection, o = l.blockRange(r), i = o && lc(o, e, n);
    return i ? (a && a(t.tr.wrap(o, i).scrollIntoView()), !0) : !1;
  };
}
function Zf(e, n = null) {
  return function(t, a) {
    let l = !1;
    for (let r = 0; r < t.selection.ranges.length && !l; r++) {
      let { $from: { pos: o }, $to: { pos: i } } = t.selection.ranges[r];
      t.doc.nodesBetween(o, i, (s, d) => {
        if (l)
          return !1;
        if (!(!s.isTextblock || s.hasMarkup(e, n)))
          if (s.type == e)
            l = !0;
          else {
            let u = t.doc.resolve(d), f = u.index();
            l = u.parent.canReplaceWith(f, f + 1, e);
          }
      });
    }
    if (!l)
      return !1;
    if (a) {
      let r = t.tr;
      for (let o = 0; o < t.selection.ranges.length; o++) {
        let { $from: { pos: i }, $to: { pos: s } } = t.selection.ranges[o];
        r.setBlockType(i, s, e, n);
      }
      a(r.scrollIntoView());
    }
    return !0;
  };
}
function dc(...e) {
  return function(n, t, a) {
    for (let l = 0; l < e.length; l++)
      if (e[l](n, t, a))
        return !0;
    return !1;
  };
}
dc(Lm, Am, Rm);
dc(Lm, Mm, Dm);
dc(zm, Om, Pm, hI);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function xI(e, n = null) {
  return function(t, a) {
    let { $from: l, $to: r } = t.selection, o = l.blockRange(r);
    if (!o)
      return !1;
    let i = a ? t.tr : null;
    return yI(i, o, e, n) ? (a && a(i.scrollIntoView()), !0) : !1;
  };
}
function yI(e, n, t, a = null) {
  let l = !1, r = n, o = n.$from.doc;
  if (n.depth >= 2 && n.$from.node(n.depth - 1).type.compatibleContent(t) && n.startIndex == 0) {
    if (n.$from.index(n.depth - 1) == 0)
      return !1;
    let s = o.resolve(n.start - 2);
    r = new bi(s, s, n.depth), n.endIndex < n.parent.childCount && (n = new bi(n.$from, o.resolve(n.$to.end(n.depth)), n.depth)), l = !0;
  }
  let i = lc(r, t, a, n);
  return i ? (e && kI(e, n, i, l, t), !0) : !1;
}
function kI(e, n, t, a, l) {
  let r = Ve.empty;
  for (let u = t.length - 1; u >= 0; u--)
    r = Ve.from(t[u].type.create(t[u].attrs, r));
  e.step(new Yt(n.start - (a ? 2 : 0), n.end, n.start, n.end, new Xe(r, 0, 0), t.length, !0));
  let o = 0;
  for (let u = 0; u < t.length; u++)
    t[u].type == l && (o = u + 1);
  let i = t.length - o, s = n.start + t.length - (a ? 2 : 0), d = n.parent;
  for (let u = n.startIndex, f = n.endIndex, b = !0; u < f; u++, b = !1)
    !b && pa(e.doc, s, i) && (e.split(s, i), s += 2 * i), s += d.child(u).nodeSize;
  return e;
}
function wI(e) {
  return function(n, t) {
    let { $from: a, $to: l } = n.selection, r = a.blockRange(l, (o) => o.childCount > 0 && o.firstChild.type == e);
    return r ? t ? a.node(r.depth - 1).type == e ? CI(n, t, e, r) : SI(n, t, r) : !0 : !1;
  };
}
function CI(e, n, t, a) {
  let l = e.tr, r = a.end, o = a.$to.end(a.depth);
  r < o && (l.step(new Yt(r - 1, o, r, o, new Xe(Ve.from(t.create(null, a.parent.copy())), 1, 0), 1, !0)), a = new bi(l.doc.resolve(a.$from.pos), l.doc.resolve(o), a.depth));
  const i = lr(a);
  if (i == null)
    return !1;
  l.lift(a, i);
  let s = l.doc.resolve(l.mapping.map(r, -1) - 1);
  return Qa(l.doc, s.pos) && s.nodeBefore.type == s.nodeAfter.type && l.join(s.pos), n(l.scrollIntoView()), !0;
}
function SI(e, n, t) {
  let a = e.tr, l = t.parent;
  for (let h = t.end, p = t.endIndex - 1, x = t.startIndex; p > x; p--)
    h -= l.child(p).nodeSize, a.delete(h - 1, h + 1);
  let r = a.doc.resolve(t.start), o = r.nodeAfter;
  if (a.mapping.map(t.end) != t.start + r.nodeAfter.nodeSize)
    return !1;
  let i = t.startIndex == 0, s = t.endIndex == l.childCount, d = r.node(-1), u = r.index(-1);
  if (!d.canReplace(u + (i ? 0 : 1), u + 1, o.content.append(s ? Ve.empty : Ve.from(l))))
    return !1;
  let f = r.pos, b = f + o.nodeSize;
  return a.step(new Yt(f - (i ? 1 : 0), b + (s ? 1 : 0), f + 1, b - 1, new Xe((i ? Ve.empty : Ve.from(l.copy(Ve.empty))).append(s ? Ve.empty : Ve.from(l.copy(Ve.empty))), i ? 0 : 1, s ? 0 : 1), i ? 0 : 1)), n(a.scrollIntoView()), !0;
}
function $I(e) {
  return function(n, t) {
    let { $from: a, $to: l } = n.selection, r = a.blockRange(l, (d) => d.childCount > 0 && d.firstChild.type == e);
    if (!r)
      return !1;
    let o = r.startIndex;
    if (o == 0)
      return !1;
    let i = r.parent, s = i.child(o - 1);
    if (s.type != e)
      return !1;
    if (t) {
      let d = s.lastChild && s.lastChild.type == i.type, u = Ve.from(d ? e.create() : null), f = new Xe(Ve.from(e.create(null, Ve.from(i.type.create(null, u)))), d ? 3 : 1, 0), b = r.start, h = r.end;
      t(n.tr.step(new Yt(b - (d ? 3 : 1), h, b, h, f, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
const Zt = function(e) {
  for (var n = 0; ; n++)
    if (e = e.previousSibling, !e)
      return n;
}, Jl = function(e) {
  let n = e.assignedSlot || e.parentNode;
  return n && n.nodeType == 11 ? n.host : n;
};
let Ud = null;
const ha = function(e, n, t) {
  let a = Ud || (Ud = document.createRange());
  return a.setEnd(e, t ?? e.nodeValue.length), a.setStart(e, n || 0), a;
}, II = function() {
  Ud = null;
}, kl = function(e, n, t, a) {
  return t && (Qf(e, n, t, a, -1) || Qf(e, n, t, a, 1));
}, LI = /^(img|br|input|textarea|hr)$/i;
function Qf(e, n, t, a, l) {
  for (var r; ; ) {
    if (e == t && n == a)
      return !0;
    if (n == (l < 0 ? 0 : Tn(e))) {
      let o = e.parentNode;
      if (!o || o.nodeType != 1 || mo(e) || LI.test(e.nodeName) || e.contentEditable == "false")
        return !1;
      n = Zt(e) + (l < 0 ? 0 : 1), e = o;
    } else if (e.nodeType == 1) {
      let o = e.childNodes[n + (l < 0 ? -1 : 0)];
      if (o.nodeType == 1 && o.contentEditable == "false")
        if (!((r = o.pmViewDesc) === null || r === void 0) && r.ignoreForSelection)
          n += l;
        else
          return !1;
      else
        e = o, n = l < 0 ? Tn(e) : 0;
    } else
      return !1;
  }
}
function Tn(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function TI(e, n) {
  for (; ; ) {
    if (e.nodeType == 3 && n)
      return e;
    if (e.nodeType == 1 && n > 0) {
      if (e.contentEditable == "false")
        return null;
      e = e.childNodes[n - 1], n = Tn(e);
    } else if (e.parentNode && !mo(e))
      n = Zt(e), e = e.parentNode;
    else
      return null;
  }
}
function AI(e, n) {
  for (; ; ) {
    if (e.nodeType == 3 && n < e.nodeValue.length)
      return e;
    if (e.nodeType == 1 && n < e.childNodes.length) {
      if (e.contentEditable == "false")
        return null;
      e = e.childNodes[n], n = 0;
    } else if (e.parentNode && !mo(e))
      n = Zt(e) + 1, e = e.parentNode;
    else
      return null;
  }
}
function EI(e, n, t) {
  for (let a = n == 0, l = n == Tn(e); a || l; ) {
    if (e == t)
      return !0;
    let r = Zt(e);
    if (e = e.parentNode, !e)
      return !1;
    a = a && r == 0, l = l && r == Tn(e);
  }
}
function mo(e) {
  let n;
  for (let t = e; t && !(n = t.pmViewDesc); t = t.parentNode)
    ;
  return n && n.node && n.node.isBlock && (n.dom == e || n.contentDOM == e);
}
const fs = function(e) {
  return e.focusNode && kl(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset);
};
function al(e, n) {
  let t = document.createEvent("Event");
  return t.initEvent("keydown", !0, !0), t.keyCode = e, t.key = t.code = n, t;
}
function RI(e) {
  let n = e.activeElement;
  for (; n && n.shadowRoot; )
    n = n.shadowRoot.activeElement;
  return n;
}
function BI(e, n, t) {
  if (e.caretPositionFromPoint)
    try {
      let a = e.caretPositionFromPoint(n, t);
      if (a)
        return { node: a.offsetNode, offset: Math.min(Tn(a.offsetNode), a.offset) };
    } catch {
    }
  if (e.caretRangeFromPoint) {
    let a = e.caretRangeFromPoint(n, t);
    if (a)
      return { node: a.startContainer, offset: Math.min(Tn(a.startContainer), a.startOffset) };
  }
}
const oa = typeof navigator < "u" ? navigator : null, _f = typeof document < "u" ? document : null, _a = oa && oa.userAgent || "", Gd = /Edge\/(\d+)/.exec(_a), Nm = /MSIE \d/.exec(_a), Kd = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(_a), vn = !!(Nm || Kd || Gd), Fa = Nm ? document.documentMode : Kd ? +Kd[1] : Gd ? +Gd[1] : 0, Dn = !vn && /gecko\/(\d+)/i.test(_a);
Dn && +(/Firefox\/(\d+)/.exec(_a) || [0, 0])[1];
const Yd = !vn && /Chrome\/(\d+)/.exec(_a), _t = !!Yd, Hm = Yd ? +Yd[1] : 0, rn = !vn && !!oa && /Apple Computer/.test(oa.vendor), Xl = rn && (/Mobile\/\w+/.test(_a) || !!oa && oa.maxTouchPoints > 2), Ln = Xl || (oa ? /Mac/.test(oa.platform) : !1), jm = oa ? /Win/.test(oa.platform) : !1, ma = /Android \d/.test(_a), po = !!_f && "webkitFontSmoothing" in _f.documentElement.style, MI = po ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function DI(e) {
  let n = e.defaultView && e.defaultView.visualViewport;
  return n ? {
    left: 0,
    right: n.width,
    top: 0,
    bottom: n.height
  } : {
    left: 0,
    right: e.documentElement.clientWidth,
    top: 0,
    bottom: e.documentElement.clientHeight
  };
}
function da(e, n) {
  return typeof e == "number" ? e : e[n];
}
function zI(e) {
  let n = e.getBoundingClientRect(), t = n.width / e.offsetWidth || 1, a = n.height / e.offsetHeight || 1;
  return {
    left: n.left,
    right: n.left + e.clientWidth * t,
    top: n.top,
    bottom: n.top + e.clientHeight * a
  };
}
function eh(e, n, t) {
  let a = e.someProp("scrollThreshold") || 0, l = e.someProp("scrollMargin") || 5, r = e.dom.ownerDocument;
  for (let o = t || e.dom; o; ) {
    if (o.nodeType != 1) {
      o = Jl(o);
      continue;
    }
    let i = o, s = i == r.body, d = s ? DI(r) : zI(i), u = 0, f = 0;
    if (n.top < d.top + da(a, "top") ? f = -(d.top - n.top + da(l, "top")) : n.bottom > d.bottom - da(a, "bottom") && (f = n.bottom - n.top > d.bottom - d.top ? n.top + da(l, "top") - d.top : n.bottom - d.bottom + da(l, "bottom")), n.left < d.left + da(a, "left") ? u = -(d.left - n.left + da(l, "left")) : n.right > d.right - da(a, "right") && (u = n.right - d.right + da(l, "right")), u || f)
      if (s)
        r.defaultView.scrollBy(u, f);
      else {
        let h = i.scrollLeft, p = i.scrollTop;
        f && (i.scrollTop += f), u && (i.scrollLeft += u);
        let x = i.scrollLeft - h, y = i.scrollTop - p;
        n = { left: n.left - x, top: n.top - y, right: n.right - x, bottom: n.bottom - y };
      }
    let b = s ? "fixed" : getComputedStyle(o).position;
    if (/^(fixed|sticky)$/.test(b))
      break;
    o = b == "absolute" ? o.offsetParent : Jl(o);
  }
}
function OI(e) {
  let n = e.dom.getBoundingClientRect(), t = Math.max(0, n.top), a, l;
  for (let r = (n.left + n.right) / 2, o = t + 1; o < Math.min(innerHeight, n.bottom); o += 5) {
    let i = e.root.elementFromPoint(r, o);
    if (!i || i == e.dom || !e.dom.contains(i))
      continue;
    let s = i.getBoundingClientRect();
    if (s.top >= t - 20) {
      a = i, l = s.top;
      break;
    }
  }
  return { refDOM: a, refTop: l, stack: Wm(e.dom) };
}
function Wm(e) {
  let n = [], t = e.ownerDocument;
  for (let a = e; a && (n.push({ dom: a, top: a.scrollTop, left: a.scrollLeft }), e != t); a = Jl(a))
    ;
  return n;
}
function PI({ refDOM: e, refTop: n, stack: t }) {
  let a = e ? e.getBoundingClientRect().top : 0;
  qm(t, a == 0 ? 0 : a - n);
}
function qm(e, n) {
  for (let t = 0; t < e.length; t++) {
    let { dom: a, top: l, left: r } = e[t];
    a.scrollTop != l + n && (a.scrollTop = l + n), a.scrollLeft != r && (a.scrollLeft = r);
  }
}
let $l = null;
function FI(e) {
  if (e.setActive)
    return e.setActive();
  if ($l)
    return e.focus($l);
  let n = Wm(e);
  e.focus($l == null ? {
    get preventScroll() {
      return $l = { preventScroll: !0 }, !0;
    }
  } : void 0), $l || ($l = !1, qm(n, 0));
}
function Um(e, n) {
  let t, a = 2e8, l, r = 0, o = n.top, i = n.top, s, d;
  for (let u = e.firstChild, f = 0; u; u = u.nextSibling, f++) {
    let b;
    if (u.nodeType == 1)
      b = u.getClientRects();
    else if (u.nodeType == 3)
      b = ha(u).getClientRects();
    else
      continue;
    for (let h = 0; h < b.length; h++) {
      let p = b[h];
      if (p.top <= o && p.bottom >= i) {
        o = Math.max(p.bottom, o), i = Math.min(p.top, i);
        let x = p.left > n.left ? p.left - n.left : p.right < n.left ? n.left - p.right : 0;
        if (x < a) {
          t = u, a = x, l = x && t.nodeType == 3 ? {
            left: p.right < n.left ? p.right : p.left,
            top: n.top
          } : n, u.nodeType == 1 && x && (r = f + (n.left >= (p.left + p.right) / 2 ? 1 : 0));
          continue;
        }
      } else p.top > n.top && !s && p.left <= n.left && p.right >= n.left && (s = u, d = { left: Math.max(p.left, Math.min(p.right, n.left)), top: p.top });
      !t && (n.left >= p.right && n.top >= p.top || n.left >= p.left && n.top >= p.bottom) && (r = f + 1);
    }
  }
  return !t && s && (t = s, l = d, a = 0), t && t.nodeType == 3 ? VI(t, l) : !t || a && t.nodeType == 1 ? { node: e, offset: r } : Um(t, l);
}
function VI(e, n) {
  let t = e.nodeValue.length, a = document.createRange(), l;
  for (let r = 0; r < t; r++) {
    a.setEnd(e, r + 1), a.setStart(e, r);
    let o = $a(a, 1);
    if (o.top != o.bottom && uc(n, o)) {
      l = { node: e, offset: r + (n.left >= (o.left + o.right) / 2 ? 1 : 0) };
      break;
    }
  }
  return a.detach(), l || { node: e, offset: 0 };
}
function uc(e, n) {
  return e.left >= n.left - 1 && e.left <= n.right + 1 && e.top >= n.top - 1 && e.top <= n.bottom + 1;
}
function NI(e, n) {
  let t = e.parentNode;
  return t && /^li$/i.test(t.nodeName) && n.left < e.getBoundingClientRect().left ? t : e;
}
function HI(e, n, t) {
  let { node: a, offset: l } = Um(n, t), r = -1;
  if (a.nodeType == 1 && !a.firstChild) {
    let o = a.getBoundingClientRect();
    r = o.left != o.right && t.left > (o.left + o.right) / 2 ? 1 : -1;
  }
  return e.docView.posFromDOM(a, l, r);
}
function jI(e, n, t, a) {
  let l = -1;
  for (let r = n, o = !1; r != e.dom; ) {
    let i = e.docView.nearestDesc(r, !0), s;
    if (!i)
      return null;
    if (i.dom.nodeType == 1 && (i.node.isBlock && i.parent || !i.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((s = i.dom.getBoundingClientRect()).width || s.height) && (i.node.isBlock && i.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(i.dom.nodeName) && (!o && s.left > a.left || s.top > a.top ? l = i.posBefore : (!o && s.right < a.left || s.bottom < a.top) && (l = i.posAfter), o = !0), !i.contentDOM && l < 0 && !i.node.isText))
      return (i.node.isBlock ? a.top < (s.top + s.bottom) / 2 : a.left < (s.left + s.right) / 2) ? i.posBefore : i.posAfter;
    r = i.dom.parentNode;
  }
  return l > -1 ? l : e.docView.posFromDOM(n, t, -1);
}
function Gm(e, n, t) {
  let a = e.childNodes.length;
  if (a && t.top < t.bottom)
    for (let l = Math.max(0, Math.min(a - 1, Math.floor(a * (n.top - t.top) / (t.bottom - t.top)) - 2)), r = l; ; ) {
      let o = e.childNodes[r];
      if (o.nodeType == 1) {
        let i = o.getClientRects();
        for (let s = 0; s < i.length; s++) {
          let d = i[s];
          if (uc(n, d))
            return Gm(o, n, d);
        }
      }
      if ((r = (r + 1) % a) == l)
        break;
    }
  return e;
}
function WI(e, n) {
  let t = e.dom.ownerDocument, a, l = 0, r = BI(t, n.left, n.top);
  r && ({ node: a, offset: l } = r);
  let o = (e.root.elementFromPoint ? e.root : t).elementFromPoint(n.left, n.top), i;
  if (!o || !e.dom.contains(o.nodeType != 1 ? o.parentNode : o)) {
    let d = e.dom.getBoundingClientRect();
    if (!uc(n, d) || (o = Gm(e.dom, n, d), !o))
      return null;
  }
  if (rn)
    for (let d = o; a && d; d = Jl(d))
      d.draggable && (a = void 0);
  if (o = NI(o, n), a) {
    if (Dn && a.nodeType == 1 && (l = Math.min(l, a.childNodes.length), l < a.childNodes.length)) {
      let u = a.childNodes[l], f;
      u.nodeName == "IMG" && (f = u.getBoundingClientRect()).right <= n.left && f.bottom > n.top && l++;
    }
    let d;
    po && l && a.nodeType == 1 && (d = a.childNodes[l - 1]).nodeType == 1 && d.contentEditable == "false" && d.getBoundingClientRect().top >= n.top && l--, a == e.dom && l == a.childNodes.length - 1 && a.lastChild.nodeType == 1 && n.top > a.lastChild.getBoundingClientRect().bottom ? i = e.state.doc.content.size : (l == 0 || a.nodeType != 1 || a.childNodes[l - 1].nodeName != "BR") && (i = jI(e, a, l, n));
  }
  i == null && (i = HI(e, o, n));
  let s = e.docView.nearestDesc(o, !0);
  return { pos: i, inside: s ? s.posAtStart - s.border : -1 };
}
function th(e) {
  return e.top < e.bottom || e.left < e.right;
}
function $a(e, n) {
  let t = e.getClientRects();
  if (t.length) {
    let a = t[n < 0 ? 0 : t.length - 1];
    if (th(a))
      return a;
  }
  return Array.prototype.find.call(t, th) || e.getBoundingClientRect();
}
const qI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function Km(e, n, t) {
  let { node: a, offset: l, atom: r } = e.docView.domFromPos(n, t < 0 ? -1 : 1), o = po || Dn;
  if (a.nodeType == 3)
    if (o && (qI.test(a.nodeValue) || (t < 0 ? !l : l == a.nodeValue.length))) {
      let s = $a(ha(a, l, l), t);
      if (Dn && l && /\s/.test(a.nodeValue[l - 1]) && l < a.nodeValue.length) {
        let d = $a(ha(a, l - 1, l - 1), -1);
        if (d.top == s.top) {
          let u = $a(ha(a, l, l + 1), -1);
          if (u.top != s.top)
            return fr(u, u.left < d.left);
        }
      }
      return s;
    } else {
      let s = l, d = l, u = t < 0 ? 1 : -1;
      return t < 0 && !l ? (d++, u = -1) : t >= 0 && l == a.nodeValue.length ? (s--, u = 1) : t < 0 ? s-- : d++, fr($a(ha(a, s, d), u), u < 0);
    }
  if (!e.state.doc.resolve(n - (r || 0)).parent.inlineContent) {
    if (r == null && l && (t < 0 || l == Tn(a))) {
      let s = a.childNodes[l - 1];
      if (s.nodeType == 1)
        return Us(s.getBoundingClientRect(), !1);
    }
    if (r == null && l < Tn(a)) {
      let s = a.childNodes[l];
      if (s.nodeType == 1)
        return Us(s.getBoundingClientRect(), !0);
    }
    return Us(a.getBoundingClientRect(), t >= 0);
  }
  if (r == null && l && (t < 0 || l == Tn(a))) {
    let s = a.childNodes[l - 1], d = s.nodeType == 3 ? ha(s, Tn(s) - (o ? 0 : 1)) : s.nodeType == 1 && (s.nodeName != "BR" || !s.nextSibling) ? s : null;
    if (d)
      return fr($a(d, 1), !1);
  }
  if (r == null && l < Tn(a)) {
    let s = a.childNodes[l];
    for (; s.pmViewDesc && s.pmViewDesc.ignoreForCoords; )
      s = s.nextSibling;
    let d = s ? s.nodeType == 3 ? ha(s, 0, o ? 0 : 1) : s.nodeType == 1 ? s : null : null;
    if (d)
      return fr($a(d, -1), !0);
  }
  return fr($a(a.nodeType == 3 ? ha(a) : a, -t), t >= 0);
}
function fr(e, n) {
  if (e.width == 0)
    return e;
  let t = n ? e.left : e.right;
  return { top: e.top, bottom: e.bottom, left: t, right: t };
}
function Us(e, n) {
  if (e.height == 0)
    return e;
  let t = n ? e.top : e.bottom;
  return { top: t, bottom: t, left: e.left, right: e.right };
}
function Ym(e, n, t) {
  let a = e.state, l = e.root.activeElement;
  a != n && e.updateState(n), l != e.dom && e.focus();
  try {
    return t();
  } finally {
    a != n && e.updateState(a), l != e.dom && l && l.focus();
  }
}
function UI(e, n, t) {
  let a = n.selection, l = t == "up" ? a.$from : a.$to;
  return Ym(e, n, () => {
    let { node: r } = e.docView.domFromPos(l.pos, t == "up" ? -1 : 1);
    for (; ; ) {
      let i = e.docView.nearestDesc(r, !0);
      if (!i)
        break;
      if (i.node.isBlock) {
        r = i.contentDOM || i.dom;
        break;
      }
      r = i.dom.parentNode;
    }
    let o = Km(e, l.pos, 1);
    for (let i = r.firstChild; i; i = i.nextSibling) {
      let s;
      if (i.nodeType == 1)
        s = i.getClientRects();
      else if (i.nodeType == 3)
        s = ha(i, 0, i.nodeValue.length).getClientRects();
      else
        continue;
      for (let d = 0; d < s.length; d++) {
        let u = s[d];
        if (u.bottom > u.top + 1 && (t == "up" ? o.top - u.top > (u.bottom - o.top) * 2 : u.bottom - o.bottom > (o.bottom - u.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const GI = /[\u0590-\u08ac]/;
function KI(e, n, t) {
  let { $head: a } = n.selection;
  if (!a.parent.isTextblock)
    return !1;
  let l = a.parentOffset, r = !l, o = l == a.parent.content.size, i = e.domSelection();
  return i ? !GI.test(a.parent.textContent) || !i.modify ? t == "left" || t == "backward" ? r : o : Ym(e, n, () => {
    let { focusNode: s, focusOffset: d, anchorNode: u, anchorOffset: f } = e.domSelectionRange(), b = i.caretBidiLevel;
    i.modify("move", t, "character");
    let h = a.depth ? e.docView.domAfterPos(a.before()) : e.dom, { focusNode: p, focusOffset: x } = e.domSelectionRange(), y = p && !h.contains(p.nodeType == 1 ? p : p.parentNode) || s == p && d == x;
    try {
      i.collapse(u, f), s && (s != u || d != f) && i.extend && i.extend(s, d);
    } catch {
    }
    return b != null && (i.caretBidiLevel = b), y;
  }) : a.pos == a.start() || a.pos == a.end();
}
let nh = null, ah = null, lh = !1;
function YI(e, n, t) {
  return nh == n && ah == t ? lh : (nh = n, ah = t, lh = t == "up" || t == "down" ? UI(e, n, t) : KI(e, n, t));
}
const zn = 0, rh = 1, rl = 2, ia = 3;
class vo {
  constructor(n, t, a, l) {
    this.parent = n, this.children = t, this.dom = a, this.contentDOM = l, this.dirty = zn, a.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(n) {
    return !1;
  }
  matchesMark(n) {
    return !1;
  }
  matchesNode(n, t, a) {
    return !1;
  }
  matchesHack(n) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(n) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let n = 0;
    for (let t = 0; t < this.children.length; t++)
      n += this.children[t].size;
    return n;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let n = 0; n < this.children.length; n++)
      this.children[n].destroy();
  }
  posBeforeChild(n) {
    for (let t = 0, a = this.posAtStart; ; t++) {
      let l = this.children[t];
      if (l == n)
        return a;
      a += l.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(n, t, a) {
    if (this.contentDOM && this.contentDOM.contains(n.nodeType == 1 ? n : n.parentNode))
      if (a < 0) {
        let r, o;
        if (n == this.contentDOM)
          r = n.childNodes[t - 1];
        else {
          for (; n.parentNode != this.contentDOM; )
            n = n.parentNode;
          r = n.previousSibling;
        }
        for (; r && !((o = r.pmViewDesc) && o.parent == this); )
          r = r.previousSibling;
        return r ? this.posBeforeChild(o) + o.size : this.posAtStart;
      } else {
        let r, o;
        if (n == this.contentDOM)
          r = n.childNodes[t];
        else {
          for (; n.parentNode != this.contentDOM; )
            n = n.parentNode;
          r = n.nextSibling;
        }
        for (; r && !((o = r.pmViewDesc) && o.parent == this); )
          r = r.nextSibling;
        return r ? this.posBeforeChild(o) : this.posAtEnd;
      }
    let l;
    if (n == this.dom && this.contentDOM)
      l = t > Zt(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      l = n.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (t == 0)
        for (let r = n; ; r = r.parentNode) {
          if (r == this.dom) {
            l = !1;
            break;
          }
          if (r.previousSibling)
            break;
        }
      if (l == null && t == n.childNodes.length)
        for (let r = n; ; r = r.parentNode) {
          if (r == this.dom) {
            l = !0;
            break;
          }
          if (r.nextSibling)
            break;
        }
    }
    return l ?? a > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(n, t = !1) {
    for (let a = !0, l = n; l; l = l.parentNode) {
      let r = this.getDesc(l), o;
      if (r && (!t || r.node))
        if (a && (o = r.nodeDOM) && !(o.nodeType == 1 ? o.contains(n.nodeType == 1 ? n : n.parentNode) : o == n))
          a = !1;
        else
          return r;
    }
  }
  getDesc(n) {
    let t = n.pmViewDesc;
    for (let a = t; a; a = a.parent)
      if (a == this)
        return t;
  }
  posFromDOM(n, t, a) {
    for (let l = n; l; l = l.parentNode) {
      let r = this.getDesc(l);
      if (r)
        return r.localPosFromDOM(n, t, a);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(n) {
    for (let t = 0, a = 0; t < this.children.length; t++) {
      let l = this.children[t], r = a + l.size;
      if (a == n && r != a) {
        for (; !l.border && l.children.length; )
          for (let o = 0; o < l.children.length; o++) {
            let i = l.children[o];
            if (i.size) {
              l = i;
              break;
            }
          }
        return l;
      }
      if (n < r)
        return l.descAt(n - a - l.border);
      a = r;
    }
  }
  domFromPos(n, t) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: n + 1 };
    let a = 0, l = 0;
    for (let r = 0; a < this.children.length; a++) {
      let o = this.children[a], i = r + o.size;
      if (i > n || o instanceof Xm) {
        l = n - r;
        break;
      }
      r = i;
    }
    if (l)
      return this.children[a].domFromPos(l - this.children[a].border, t);
    for (let r; a && !(r = this.children[a - 1]).size && r instanceof Jm && r.side >= 0; a--)
      ;
    if (t <= 0) {
      let r, o = !0;
      for (; r = a ? this.children[a - 1] : null, !(!r || r.dom.parentNode == this.contentDOM); a--, o = !1)
        ;
      return r && t && o && !r.border && !r.domAtom ? r.domFromPos(r.size, t) : { node: this.contentDOM, offset: r ? Zt(r.dom) + 1 : 0 };
    } else {
      let r, o = !0;
      for (; r = a < this.children.length ? this.children[a] : null, !(!r || r.dom.parentNode == this.contentDOM); a++, o = !1)
        ;
      return r && o && !r.border && !r.domAtom ? r.domFromPos(0, t) : { node: this.contentDOM, offset: r ? Zt(r.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(n, t, a = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: n, to: t, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let l = -1, r = -1;
    for (let o = a, i = 0; ; i++) {
      let s = this.children[i], d = o + s.size;
      if (l == -1 && n <= d) {
        let u = o + s.border;
        if (n >= u && t <= d - s.border && s.node && s.contentDOM && this.contentDOM.contains(s.contentDOM))
          return s.parseRange(n, t, u);
        n = o;
        for (let f = i; f > 0; f--) {
          let b = this.children[f - 1];
          if (b.size && b.dom.parentNode == this.contentDOM && !b.emptyChildAt(1)) {
            l = Zt(b.dom) + 1;
            break;
          }
          n -= b.size;
        }
        l == -1 && (l = 0);
      }
      if (l > -1 && (d > t || i == this.children.length - 1)) {
        t = d;
        for (let u = i + 1; u < this.children.length; u++) {
          let f = this.children[u];
          if (f.size && f.dom.parentNode == this.contentDOM && !f.emptyChildAt(-1)) {
            r = Zt(f.dom);
            break;
          }
          t += f.size;
        }
        r == -1 && (r = this.contentDOM.childNodes.length);
        break;
      }
      o = d;
    }
    return { node: this.contentDOM, from: n, to: t, fromOffset: l, toOffset: r };
  }
  emptyChildAt(n) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let t = this.children[n < 0 ? 0 : this.children.length - 1];
    return t.size == 0 || t.emptyChildAt(n);
  }
  domAfterPos(n) {
    let { node: t, offset: a } = this.domFromPos(n, 0);
    if (t.nodeType != 1 || a == t.childNodes.length)
      throw new RangeError("No node after pos " + n);
    return t.childNodes[a];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(n, t, a, l = !1) {
    let r = Math.min(n, t), o = Math.max(n, t);
    for (let h = 0, p = 0; h < this.children.length; h++) {
      let x = this.children[h], y = p + x.size;
      if (r > p && o < y)
        return x.setSelection(n - p - x.border, t - p - x.border, a, l);
      p = y;
    }
    let i = this.domFromPos(n, n ? -1 : 1), s = t == n ? i : this.domFromPos(t, t ? -1 : 1), d = a.root.getSelection(), u = a.domSelectionRange(), f = !1;
    if ((Dn || rn) && n == t) {
      let { node: h, offset: p } = i;
      if (h.nodeType == 3) {
        if (f = !!(p && h.nodeValue[p - 1] == `
`), f && p == h.nodeValue.length)
          for (let x = h, y; x; x = x.parentNode) {
            if (y = x.nextSibling) {
              y.nodeName == "BR" && (i = s = { node: y.parentNode, offset: Zt(y) + 1 });
              break;
            }
            let k = x.pmViewDesc;
            if (k && k.node && k.node.isBlock)
              break;
          }
      } else {
        let x = h.childNodes[p - 1];
        f = x && (x.nodeName == "BR" || x.contentEditable == "false");
      }
    }
    if (Dn && u.focusNode && u.focusNode != s.node && u.focusNode.nodeType == 1) {
      let h = u.focusNode.childNodes[u.focusOffset];
      h && h.contentEditable == "false" && (l = !0);
    }
    if (!(l || f && rn) && kl(i.node, i.offset, u.anchorNode, u.anchorOffset) && kl(s.node, s.offset, u.focusNode, u.focusOffset))
      return;
    let b = !1;
    if ((d.extend || n == t) && !(f && Dn)) {
      d.collapse(i.node, i.offset);
      try {
        n != t && d.extend(s.node, s.offset), b = !0;
      } catch {
      }
    }
    if (!b) {
      if (n > t) {
        let p = i;
        i = s, s = p;
      }
      let h = document.createRange();
      h.setEnd(s.node, s.offset), h.setStart(i.node, i.offset), d.removeAllRanges(), d.addRange(h);
    }
  }
  ignoreMutation(n) {
    return !this.contentDOM && n.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(n, t) {
    for (let a = 0, l = 0; l < this.children.length; l++) {
      let r = this.children[l], o = a + r.size;
      if (a == o ? n <= o && t >= a : n < o && t > a) {
        let i = a + r.border, s = o - r.border;
        if (n >= i && t <= s) {
          this.dirty = n == a || t == o ? rl : rh, n == i && t == s && (r.contentLost || r.dom.parentNode != this.contentDOM) ? r.dirty = ia : r.markDirty(n - i, t - i);
          return;
        } else
          r.dirty = r.dom == r.contentDOM && r.dom.parentNode == this.contentDOM && !r.children.length ? rl : ia;
      }
      a = o;
    }
    this.dirty = rl;
  }
  markParentsDirty() {
    let n = 1;
    for (let t = this.parent; t; t = t.parent, n++) {
      let a = n == 1 ? rl : rh;
      t.dirty < a && (t.dirty = a);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  get ignoreForSelection() {
    return !1;
  }
  isText(n) {
    return !1;
  }
}
class Jm extends vo {
  constructor(n, t, a, l) {
    let r, o = t.type.toDOM;
    if (typeof o == "function" && (o = o(a, () => {
      if (!r)
        return l;
      if (r.parent)
        return r.parent.posBeforeChild(r);
    })), !t.type.spec.raw) {
      if (o.nodeType != 1) {
        let i = document.createElement("span");
        i.appendChild(o), o = i;
      }
      o.contentEditable = "false", o.classList.add("ProseMirror-widget");
    }
    super(n, [], o, null), this.widget = t, this.widget = t, r = this;
  }
  matchesWidget(n) {
    return this.dirty == zn && n.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(n) {
    let t = this.widget.spec.stopEvent;
    return t ? t(n) : !1;
  }
  ignoreMutation(n) {
    return n.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get ignoreForSelection() {
    return !!this.widget.type.spec.relaxedSide;
  }
  get side() {
    return this.widget.type.side;
  }
}
class JI extends vo {
  constructor(n, t, a, l) {
    super(n, [], t, null), this.textDOM = a, this.text = l;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(n, t) {
    return n != this.textDOM ? this.posAtStart + (t ? this.size : 0) : this.posAtStart + t;
  }
  domFromPos(n) {
    return { node: this.textDOM, offset: n };
  }
  ignoreMutation(n) {
    return n.type === "characterData" && n.target.nodeValue == n.oldValue;
  }
}
class wl extends vo {
  constructor(n, t, a, l, r) {
    super(n, [], a, l), this.mark = t, this.spec = r;
  }
  static create(n, t, a, l) {
    let r = l.nodeViews[t.type.name], o = r && r(t, l, a);
    return (!o || !o.dom) && (o = Sl.renderSpec(document, t.type.spec.toDOM(t, a), null, t.attrs)), new wl(n, t, o.dom, o.contentDOM || o.dom, o);
  }
  parseRule() {
    return this.dirty & ia || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(n) {
    return this.dirty != ia && this.mark.eq(n);
  }
  markDirty(n, t) {
    if (super.markDirty(n, t), this.dirty != zn) {
      let a = this.parent;
      for (; !a.node; )
        a = a.parent;
      a.dirty < this.dirty && (a.dirty = this.dirty), this.dirty = zn;
    }
  }
  slice(n, t, a) {
    let l = wl.create(this.parent, this.mark, !0, a), r = this.children, o = this.size;
    t < o && (r = Xd(r, t, o, a)), n > 0 && (r = Xd(r, 0, n, a));
    for (let i = 0; i < r.length; i++)
      r[i].parent = l;
    return l.children = r, l;
  }
  ignoreMutation(n) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(n) : super.ignoreMutation(n);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class Va extends vo {
  constructor(n, t, a, l, r, o, i, s, d) {
    super(n, [], r, o), this.node = t, this.outerDeco = a, this.innerDeco = l, this.nodeDOM = i;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(n, t, a, l, r, o) {
    let i = r.nodeViews[t.type.name], s, d = i && i(t, r, () => {
      if (!s)
        return o;
      if (s.parent)
        return s.parent.posBeforeChild(s);
    }, a, l), u = d && d.dom, f = d && d.contentDOM;
    if (t.isText) {
      if (!u)
        u = document.createTextNode(t.text);
      else if (u.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else u || ({ dom: u, contentDOM: f } = Sl.renderSpec(document, t.type.spec.toDOM(t), null, t.attrs));
    !f && !t.isText && u.nodeName != "BR" && (u.hasAttribute("contenteditable") || (u.contentEditable = "false"), t.type.spec.draggable && (u.draggable = !0));
    let b = u;
    return u = _m(u, a, t), d ? s = new XI(n, t, a, l, u, f || null, b, d, r, o + 1) : t.isText ? new hs(n, t, a, l, u, b, r) : new Va(n, t, a, l, u, f || null, b, r, o + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let n = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (n.preserveWhitespace = "full"), !this.contentDOM)
      n.getContent = () => this.node.content;
    else if (!this.contentLost)
      n.contentElement = this.contentDOM;
    else {
      for (let t = this.children.length - 1; t >= 0; t--) {
        let a = this.children[t];
        if (this.dom.contains(a.dom.parentNode)) {
          n.contentElement = a.dom.parentNode;
          break;
        }
      }
      n.contentElement || (n.getContent = () => Ve.empty);
    }
    return n;
  }
  matchesNode(n, t, a) {
    return this.dirty == zn && n.eq(this.node) && mi(t, this.outerDeco) && a.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(n, t) {
    let a = this.node.inlineContent, l = t, r = n.composing ? this.localCompositionInfo(n, t) : null, o = r && r.pos > -1 ? r : null, i = r && r.pos < 0, s = new QI(this, o && o.node, n);
    tL(this.node, this.innerDeco, (d, u, f) => {
      d.spec.marks ? s.syncToMarks(d.spec.marks, a, n, u) : d.type.side >= 0 && !f && s.syncToMarks(u == this.node.childCount ? Ct.none : this.node.child(u).marks, a, n, u), s.placeWidget(d, n, l);
    }, (d, u, f, b) => {
      s.syncToMarks(d.marks, a, n, b);
      let h;
      s.findNodeMatch(d, u, f, b) || i && n.state.selection.from > l && n.state.selection.to < l + d.nodeSize && (h = s.findIndexWithChild(r.node)) > -1 && s.updateNodeAt(d, u, f, h, n) || s.updateNextNode(d, u, f, n, b, l) || s.addNode(d, u, f, n, l), l += d.nodeSize;
    }), s.syncToMarks([], a, n, 0), this.node.isTextblock && s.addTextblockHacks(), s.destroyRest(), (s.changed || this.dirty == rl) && (o && this.protectLocalComposition(n, o), Zm(this.contentDOM, this.children, n), Xl && nL(this.dom));
  }
  localCompositionInfo(n, t) {
    let { from: a, to: l } = n.state.selection;
    if (!(n.state.selection instanceof rt) || a < t || l > t + this.node.content.size)
      return null;
    let r = n.input.compositionNode;
    if (!r || !this.dom.contains(r.parentNode))
      return null;
    if (this.node.inlineContent) {
      let o = r.nodeValue, i = aL(this.node.content, o, a - t, l - t);
      return i < 0 ? null : { node: r, pos: i, text: o };
    } else
      return { node: r, pos: -1, text: "" };
  }
  protectLocalComposition(n, { node: t, pos: a, text: l }) {
    if (this.getDesc(t))
      return;
    let r = t;
    for (; r.parentNode != this.contentDOM; r = r.parentNode) {
      for (; r.previousSibling; )
        r.parentNode.removeChild(r.previousSibling);
      for (; r.nextSibling; )
        r.parentNode.removeChild(r.nextSibling);
      r.pmViewDesc && (r.pmViewDesc = void 0);
    }
    let o = new JI(this, r, t, l);
    n.input.compositionNodes.push(o), this.children = Xd(this.children, a, a + l.length, n, o);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(n, t, a, l) {
    return this.dirty == ia || !n.sameMarkup(this.node) ? !1 : (this.updateInner(n, t, a, l), !0);
  }
  updateInner(n, t, a, l) {
    this.updateOuterDeco(t), this.node = n, this.innerDeco = a, this.contentDOM && this.updateChildren(l, this.posAtStart), this.dirty = zn;
  }
  updateOuterDeco(n) {
    if (mi(n, this.outerDeco))
      return;
    let t = this.nodeDOM.nodeType != 1, a = this.dom;
    this.dom = Qm(this.dom, this.nodeDOM, Jd(this.outerDeco, this.node, t), Jd(n, this.node, t)), this.dom != a && (a.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = n;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.nodeDOM.draggable = !0));
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.nodeDOM.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function oh(e, n, t, a, l) {
  _m(a, n, e);
  let r = new Va(void 0, e, n, t, a, a, a, l, 0);
  return r.contentDOM && r.updateChildren(l, 0), r;
}
class hs extends Va {
  constructor(n, t, a, l, r, o, i) {
    super(n, t, a, l, r, null, o, i, 0);
  }
  parseRule() {
    let n = this.nodeDOM.parentNode;
    for (; n && n != this.dom && !n.pmIsDeco; )
      n = n.parentNode;
    return { skip: n || !0 };
  }
  update(n, t, a, l) {
    return this.dirty == ia || this.dirty != zn && !this.inParent() || !n.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(t), (this.dirty != zn || n.text != this.node.text) && n.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = n.text, l.trackWrites == this.nodeDOM && (l.trackWrites = null)), this.node = n, this.dirty = zn, !0);
  }
  inParent() {
    let n = this.parent.contentDOM;
    for (let t = this.nodeDOM; t; t = t.parentNode)
      if (t == n)
        return !0;
    return !1;
  }
  domFromPos(n) {
    return { node: this.nodeDOM, offset: n };
  }
  localPosFromDOM(n, t, a) {
    return n == this.nodeDOM ? this.posAtStart + Math.min(t, this.node.text.length) : super.localPosFromDOM(n, t, a);
  }
  ignoreMutation(n) {
    return n.type != "characterData" && n.type != "selection";
  }
  slice(n, t, a) {
    let l = this.node.cut(n, t), r = document.createTextNode(l.text);
    return new hs(this.parent, l, this.outerDeco, this.innerDeco, r, r, a);
  }
  markDirty(n, t) {
    super.markDirty(n, t), this.dom != this.nodeDOM && (n == 0 || t == this.nodeDOM.nodeValue.length) && (this.dirty = ia);
  }
  get domAtom() {
    return !1;
  }
  isText(n) {
    return this.node.text == n;
  }
}
class Xm extends vo {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(n) {
    return this.dirty == zn && this.dom.nodeName == n;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class XI extends Va {
  constructor(n, t, a, l, r, o, i, s, d, u) {
    super(n, t, a, l, r, o, i, d, u), this.spec = s;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(n, t, a, l) {
    if (this.dirty == ia)
      return !1;
    if (this.spec.update && (this.node.type == n.type || this.spec.multiType)) {
      let r = this.spec.update(n, t, a);
      return r && this.updateInner(n, t, a, l), r;
    } else return !this.contentDOM && !n.isLeaf ? !1 : super.update(n, t, a, l);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(n, t, a, l) {
    this.spec.setSelection ? this.spec.setSelection(n, t, a.root) : super.setSelection(n, t, a, l);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(n) {
    return this.spec.stopEvent ? this.spec.stopEvent(n) : !1;
  }
  ignoreMutation(n) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(n) : super.ignoreMutation(n);
  }
}
function Zm(e, n, t) {
  let a = e.firstChild, l = !1;
  for (let r = 0; r < n.length; r++) {
    let o = n[r], i = o.dom;
    if (i.parentNode == e) {
      for (; i != a; )
        a = ih(a), l = !0;
      a = a.nextSibling;
    } else
      l = !0, e.insertBefore(i, a);
    if (o instanceof wl) {
      let s = a ? a.previousSibling : e.lastChild;
      Zm(o.contentDOM, o.children, t), a = s ? s.nextSibling : e.firstChild;
    }
  }
  for (; a; )
    a = ih(a), l = !0;
  l && t.trackWrites == e && (t.trackWrites = null);
}
const Br = function(e) {
  e && (this.nodeName = e);
};
Br.prototype = /* @__PURE__ */ Object.create(null);
const ol = [new Br()];
function Jd(e, n, t) {
  if (e.length == 0)
    return ol;
  let a = t ? ol[0] : new Br(), l = [a];
  for (let r = 0; r < e.length; r++) {
    let o = e[r].type.attrs;
    if (o) {
      o.nodeName && l.push(a = new Br(o.nodeName));
      for (let i in o) {
        let s = o[i];
        s != null && (t && l.length == 1 && l.push(a = new Br(n.isInline ? "span" : "div")), i == "class" ? a.class = (a.class ? a.class + " " : "") + s : i == "style" ? a.style = (a.style ? a.style + ";" : "") + s : i != "nodeName" && (a[i] = s));
      }
    }
  }
  return l;
}
function Qm(e, n, t, a) {
  if (t == ol && a == ol)
    return n;
  let l = n;
  for (let r = 0; r < a.length; r++) {
    let o = a[r], i = t[r];
    if (r) {
      let s;
      i && i.nodeName == o.nodeName && l != e && (s = l.parentNode) && s.nodeName.toLowerCase() == o.nodeName || (s = document.createElement(o.nodeName), s.pmIsDeco = !0, s.appendChild(l), i = ol[0]), l = s;
    }
    ZI(l, i || ol[0], o);
  }
  return l;
}
function ZI(e, n, t) {
  for (let a in n)
    a != "class" && a != "style" && a != "nodeName" && !(a in t) && e.removeAttribute(a);
  for (let a in t)
    a != "class" && a != "style" && a != "nodeName" && t[a] != n[a] && e.setAttribute(a, t[a]);
  if (n.class != t.class) {
    let a = n.class ? n.class.split(" ").filter(Boolean) : [], l = t.class ? t.class.split(" ").filter(Boolean) : [];
    for (let r = 0; r < a.length; r++)
      l.indexOf(a[r]) == -1 && e.classList.remove(a[r]);
    for (let r = 0; r < l.length; r++)
      a.indexOf(l[r]) == -1 && e.classList.add(l[r]);
    e.classList.length == 0 && e.removeAttribute("class");
  }
  if (n.style != t.style) {
    if (n.style) {
      let a = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, l;
      for (; l = a.exec(n.style); )
        e.style.removeProperty(l[1]);
    }
    t.style && (e.style.cssText += t.style);
  }
}
function _m(e, n, t) {
  return Qm(e, e, ol, Jd(n, t, e.nodeType != 1));
}
function mi(e, n) {
  if (e.length != n.length)
    return !1;
  for (let t = 0; t < e.length; t++)
    if (!e[t].type.eq(n[t].type))
      return !1;
  return !0;
}
function ih(e) {
  let n = e.nextSibling;
  return e.parentNode.removeChild(e), n;
}
class QI {
  constructor(n, t, a) {
    this.lock = t, this.view = a, this.index = 0, this.stack = [], this.changed = !1, this.top = n, this.preMatch = _I(n.node.content, n);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(n, t) {
    if (n != t) {
      for (let a = n; a < t; a++)
        this.top.children[a].destroy();
      this.top.children.splice(n, t - n), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(n, t, a, l) {
    let r = 0, o = this.stack.length >> 1, i = Math.min(o, n.length);
    for (; r < i && (r == o - 1 ? this.top : this.stack[r + 1 << 1]).matchesMark(n[r]) && n[r].type.spec.spanning !== !1; )
      r++;
    for (; r < o; )
      this.destroyRest(), this.top.dirty = zn, this.index = this.stack.pop(), this.top = this.stack.pop(), o--;
    for (; o < n.length; ) {
      this.stack.push(this.top, this.index + 1);
      let s = -1, d = this.top.children.length;
      l < this.preMatch.index && (d = Math.min(this.index + 3, d));
      for (let u = this.index; u < d; u++) {
        let f = this.top.children[u];
        if (f.matchesMark(n[o]) && !this.isLocked(f.dom)) {
          s = u;
          break;
        }
      }
      if (s > -1)
        s > this.index && (this.changed = !0, this.destroyBetween(this.index, s)), this.top = this.top.children[this.index];
      else {
        let u = wl.create(this.top, n[o], t, a);
        this.top.children.splice(this.index, 0, u), this.top = u, this.changed = !0;
      }
      this.index = 0, o++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(n, t, a, l) {
    let r = -1, o;
    if (l >= this.preMatch.index && (o = this.preMatch.matches[l - this.preMatch.index]).parent == this.top && o.matchesNode(n, t, a))
      r = this.top.children.indexOf(o, this.index);
    else
      for (let i = this.index, s = Math.min(this.top.children.length, i + 5); i < s; i++) {
        let d = this.top.children[i];
        if (d.matchesNode(n, t, a) && !this.preMatch.matched.has(d)) {
          r = i;
          break;
        }
      }
    return r < 0 ? !1 : (this.destroyBetween(this.index, r), this.index++, !0);
  }
  updateNodeAt(n, t, a, l, r) {
    let o = this.top.children[l];
    return o.dirty == ia && o.dom == o.contentDOM && (o.dirty = rl), o.update(n, t, a, r) ? (this.destroyBetween(this.index, l), this.index++, !0) : !1;
  }
  findIndexWithChild(n) {
    for (; ; ) {
      let t = n.parentNode;
      if (!t)
        return -1;
      if (t == this.top.contentDOM) {
        let a = n.pmViewDesc;
        if (a) {
          for (let l = this.index; l < this.top.children.length; l++)
            if (this.top.children[l] == a)
              return l;
        }
        return -1;
      }
      n = t;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(n, t, a, l, r, o) {
    for (let i = this.index; i < this.top.children.length; i++) {
      let s = this.top.children[i];
      if (s instanceof Va) {
        let d = this.preMatch.matched.get(s);
        if (d != null && d != r)
          return !1;
        let u = s.dom, f, b = this.isLocked(u) && !(n.isText && s.node && s.node.isText && s.nodeDOM.nodeValue == n.text && s.dirty != ia && mi(t, s.outerDeco));
        if (!b && s.update(n, t, a, l))
          return this.destroyBetween(this.index, i), s.dom != u && (this.changed = !0), this.index++, !0;
        if (!b && (f = this.recreateWrapper(s, n, t, a, l, o)))
          return this.destroyBetween(this.index, i), this.top.children[this.index] = f, f.contentDOM && (f.dirty = rl, f.updateChildren(l, o + 1), f.dirty = zn), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(n, t, a, l, r, o) {
    if (n.dirty || t.isAtom || !n.children.length || !n.node.content.eq(t.content) || !mi(a, n.outerDeco) || !l.eq(n.innerDeco))
      return null;
    let i = Va.create(this.top, t, a, l, r, o);
    if (i.contentDOM) {
      i.children = n.children, n.children = [];
      for (let s of i.children)
        s.parent = i;
    }
    return n.destroy(), i;
  }
  // Insert the node as a newly created node desc.
  addNode(n, t, a, l, r) {
    let o = Va.create(this.top, n, t, a, l, r);
    o.contentDOM && o.updateChildren(l, r + 1), this.top.children.splice(this.index++, 0, o), this.changed = !0;
  }
  placeWidget(n, t, a) {
    let l = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (l && l.matchesWidget(n) && (n == l.widget || !l.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let r = new Jm(this.top, n, t, a);
      this.top.children.splice(this.index++, 0, r), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let n = this.top.children[this.index - 1], t = this.top;
    for (; n instanceof wl; )
      t = n, n = t.children[t.children.length - 1];
    (!n || // Empty textblock
    !(n instanceof hs) || /\n$/.test(n.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(n.node.text)) && ((rn || _t) && n && n.dom.contentEditable == "false" && this.addHackNode("IMG", t), this.addHackNode("BR", this.top));
  }
  addHackNode(n, t) {
    if (t == this.top && this.index < t.children.length && t.children[this.index].matchesHack(n))
      this.index++;
    else {
      let a = document.createElement(n);
      n == "IMG" && (a.className = "ProseMirror-separator", a.alt = ""), n == "BR" && (a.className = "ProseMirror-trailingBreak");
      let l = new Xm(this.top, [], a, null);
      t != this.top ? t.children.push(l) : t.children.splice(this.index++, 0, l), this.changed = !0;
    }
  }
  isLocked(n) {
    return this.lock && (n == this.lock || n.nodeType == 1 && n.contains(this.lock.parentNode));
  }
}
function _I(e, n) {
  let t = n, a = t.children.length, l = e.childCount, r = /* @__PURE__ */ new Map(), o = [];
  e: for (; l > 0; ) {
    let i;
    for (; ; )
      if (a) {
        let d = t.children[a - 1];
        if (d instanceof wl)
          t = d, a = d.children.length;
        else {
          i = d, a--;
          break;
        }
      } else {
        if (t == n)
          break e;
        a = t.parent.children.indexOf(t), t = t.parent;
      }
    let s = i.node;
    if (s) {
      if (s != e.child(l - 1))
        break;
      --l, r.set(i, l), o.push(i);
    }
  }
  return { index: l, matched: r, matches: o.reverse() };
}
function eL(e, n) {
  return e.type.side - n.type.side;
}
function tL(e, n, t, a) {
  let l = n.locals(e), r = 0;
  if (l.length == 0) {
    for (let d = 0; d < e.childCount; d++) {
      let u = e.child(d);
      a(u, l, n.forChild(r, u), d), r += u.nodeSize;
    }
    return;
  }
  let o = 0, i = [], s = null;
  for (let d = 0; ; ) {
    let u, f;
    for (; o < l.length && l[o].to == r; ) {
      let y = l[o++];
      y.widget && (u ? (f || (f = [u])).push(y) : u = y);
    }
    if (u)
      if (f) {
        f.sort(eL);
        for (let y = 0; y < f.length; y++)
          t(f[y], d, !!s);
      } else
        t(u, d, !!s);
    let b, h;
    if (s)
      h = -1, b = s, s = null;
    else if (d < e.childCount)
      h = d, b = e.child(d++);
    else
      break;
    for (let y = 0; y < i.length; y++)
      i[y].to <= r && i.splice(y--, 1);
    for (; o < l.length && l[o].from <= r && l[o].to > r; )
      i.push(l[o++]);
    let p = r + b.nodeSize;
    if (b.isText) {
      let y = p;
      o < l.length && l[o].from < y && (y = l[o].from);
      for (let k = 0; k < i.length; k++)
        i[k].to < y && (y = i[k].to);
      y < p && (s = b.cut(y - r), b = b.cut(0, y - r), p = y, h = -1);
    } else
      for (; o < l.length && l[o].to < p; )
        o++;
    let x = b.isInline && !b.isLeaf ? i.filter((y) => !y.inline) : i.slice();
    a(b, x, n.forChild(r, b), h), r = p;
  }
}
function nL(e) {
  if (e.nodeName == "UL" || e.nodeName == "OL") {
    let n = e.style.cssText;
    e.style.cssText = n + "; list-style: square !important", window.getComputedStyle(e).listStyle, e.style.cssText = n;
  }
}
function aL(e, n, t, a) {
  for (let l = 0, r = 0; l < e.childCount && r <= a; ) {
    let o = e.child(l++), i = r;
    if (r += o.nodeSize, !o.isText)
      continue;
    let s = o.text;
    for (; l < e.childCount; ) {
      let d = e.child(l++);
      if (r += d.nodeSize, !d.isText)
        break;
      s += d.text;
    }
    if (r >= t) {
      if (r >= a && s.slice(a - n.length - i, a - i) == n)
        return a - n.length;
      let d = i < a ? s.lastIndexOf(n, a - i - 1) : -1;
      if (d >= 0 && d + n.length + i >= t)
        return i + d;
      if (t == a && s.length >= a + n.length - i && s.slice(a - i, a - i + n.length) == n)
        return a;
    }
  }
  return -1;
}
function Xd(e, n, t, a, l) {
  let r = [];
  for (let o = 0, i = 0; o < e.length; o++) {
    let s = e[o], d = i, u = i += s.size;
    d >= t || u <= n ? r.push(s) : (d < n && r.push(s.slice(0, n - d, a)), l && (r.push(l), l = void 0), u > t && r.push(s.slice(t - d, s.size, a)));
  }
  return r;
}
function cc(e, n = null) {
  let t = e.domSelectionRange(), a = e.state.doc;
  if (!t.focusNode)
    return null;
  let l = e.docView.nearestDesc(t.focusNode), r = l && l.size == 0, o = e.docView.posFromDOM(t.focusNode, t.focusOffset, 1);
  if (o < 0)
    return null;
  let i = a.resolve(o), s, d;
  if (fs(t)) {
    for (s = o; l && !l.node; )
      l = l.parent;
    let f = l.node;
    if (l && f.isAtom && tt.isSelectable(f) && l.parent && !(f.isInline && EI(t.focusNode, t.focusOffset, l.dom))) {
      let b = l.posBefore;
      d = new tt(o == b ? i : a.resolve(b));
    }
  } else {
    if (t instanceof e.dom.ownerDocument.defaultView.Selection && t.rangeCount > 1) {
      let f = o, b = o;
      for (let h = 0; h < t.rangeCount; h++) {
        let p = t.getRangeAt(h);
        f = Math.min(f, e.docView.posFromDOM(p.startContainer, p.startOffset, 1)), b = Math.max(b, e.docView.posFromDOM(p.endContainer, p.endOffset, -1));
      }
      if (f < 0)
        return null;
      [s, o] = b == e.state.selection.anchor ? [b, f] : [f, b], i = a.resolve(o);
    } else
      s = e.docView.posFromDOM(t.anchorNode, t.anchorOffset, 1);
    if (s < 0)
      return null;
  }
  let u = a.resolve(s);
  if (!d) {
    let f = n == "pointer" || e.state.selection.head < i.pos && !r ? 1 : -1;
    d = fc(e, u, i, f);
  }
  return d;
}
function ep(e) {
  return e.editable ? e.hasFocus() : np(e) && document.activeElement && document.activeElement.contains(e.dom);
}
function va(e, n = !1) {
  let t = e.state.selection;
  if (tp(e, t), !!ep(e)) {
    if (!n && e.input.mouseDown && e.input.mouseDown.allowDefault && _t) {
      let a = e.domSelectionRange(), l = e.domObserver.currentSelection;
      if (a.anchorNode && l.anchorNode && kl(a.anchorNode, a.anchorOffset, l.anchorNode, l.anchorOffset)) {
        e.input.mouseDown.delayedSelectionSync = !0, e.domObserver.setCurSelection();
        return;
      }
    }
    if (e.domObserver.disconnectSelection(), e.cursorWrapper)
      rL(e);
    else {
      let { anchor: a, head: l } = t, r, o;
      sh && !(t instanceof rt) && (t.$from.parent.inlineContent || (r = dh(e, t.from)), !t.empty && !t.$from.parent.inlineContent && (o = dh(e, t.to))), e.docView.setSelection(a, l, e, n), sh && (r && uh(r), o && uh(o)), t.visible ? e.dom.classList.remove("ProseMirror-hideselection") : (e.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && lL(e));
    }
    e.domObserver.setCurSelection(), e.domObserver.connectSelection();
  }
}
const sh = rn || _t && Hm < 63;
function dh(e, n) {
  let { node: t, offset: a } = e.docView.domFromPos(n, 0), l = a < t.childNodes.length ? t.childNodes[a] : null, r = a ? t.childNodes[a - 1] : null;
  if (rn && l && l.contentEditable == "false")
    return Gs(l);
  if ((!l || l.contentEditable == "false") && (!r || r.contentEditable == "false")) {
    if (l)
      return Gs(l);
    if (r)
      return Gs(r);
  }
}
function Gs(e) {
  return e.contentEditable = "true", rn && e.draggable && (e.draggable = !1, e.wasDraggable = !0), e;
}
function uh(e) {
  e.contentEditable = "false", e.wasDraggable && (e.draggable = !0, e.wasDraggable = null);
}
function lL(e) {
  let n = e.dom.ownerDocument;
  n.removeEventListener("selectionchange", e.input.hideSelectionGuard);
  let t = e.domSelectionRange(), a = t.anchorNode, l = t.anchorOffset;
  n.addEventListener("selectionchange", e.input.hideSelectionGuard = () => {
    (t.anchorNode != a || t.anchorOffset != l) && (n.removeEventListener("selectionchange", e.input.hideSelectionGuard), setTimeout(() => {
      (!ep(e) || e.state.selection.visible) && e.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function rL(e) {
  let n = e.domSelection();
  if (!n)
    return;
  let t = e.cursorWrapper.dom, a = t.nodeName == "IMG";
  a ? n.collapse(t.parentNode, Zt(t) + 1) : n.collapse(t, 0), !a && !e.state.selection.visible && vn && Fa <= 11 && (t.disabled = !0, t.disabled = !1);
}
function tp(e, n) {
  if (n instanceof tt) {
    let t = e.docView.descAt(n.from);
    t != e.lastSelectedViewDesc && (ch(e), t && t.selectNode(), e.lastSelectedViewDesc = t);
  } else
    ch(e);
}
function ch(e) {
  e.lastSelectedViewDesc && (e.lastSelectedViewDesc.parent && e.lastSelectedViewDesc.deselectNode(), e.lastSelectedViewDesc = void 0);
}
function fc(e, n, t, a) {
  return e.someProp("createSelectionBetween", (l) => l(e, n, t)) || rt.between(n, t, a);
}
function fh(e) {
  return e.editable && !e.hasFocus() ? !1 : np(e);
}
function np(e) {
  let n = e.domSelectionRange();
  if (!n.anchorNode)
    return !1;
  try {
    return e.dom.contains(n.anchorNode.nodeType == 3 ? n.anchorNode.parentNode : n.anchorNode) && (e.editable || e.dom.contains(n.focusNode.nodeType == 3 ? n.focusNode.parentNode : n.focusNode));
  } catch {
    return !1;
  }
}
function oL(e) {
  let n = e.docView.domFromPos(e.state.selection.anchor, 0), t = e.domSelectionRange();
  return kl(n.node, n.offset, t.anchorNode, t.anchorOffset);
}
function Zd(e, n) {
  let { $anchor: t, $head: a } = e.selection, l = n > 0 ? t.max(a) : t.min(a), r = l.parent.inlineContent ? l.depth ? e.doc.resolve(n > 0 ? l.after() : l.before()) : null : l;
  return r && st.findFrom(r, n);
}
function Ia(e, n) {
  return e.dispatch(e.state.tr.setSelection(n).scrollIntoView()), !0;
}
function hh(e, n, t) {
  let a = e.state.selection;
  if (a instanceof rt)
    if (t.indexOf("s") > -1) {
      let { $head: l } = a, r = l.textOffset ? null : n < 0 ? l.nodeBefore : l.nodeAfter;
      if (!r || r.isText || !r.isLeaf)
        return !1;
      let o = e.state.doc.resolve(l.pos + r.nodeSize * (n < 0 ? -1 : 1));
      return Ia(e, new rt(a.$anchor, o));
    } else if (a.empty) {
      if (e.endOfTextblock(n > 0 ? "forward" : "backward")) {
        let l = Zd(e.state, n);
        return l && l instanceof tt ? Ia(e, l) : !1;
      } else if (!(Ln && t.indexOf("m") > -1)) {
        let l = a.$head, r = l.textOffset ? null : n < 0 ? l.nodeBefore : l.nodeAfter, o;
        if (!r || r.isText)
          return !1;
        let i = n < 0 ? l.pos - r.nodeSize : l.pos;
        return r.isAtom || (o = e.docView.descAt(i)) && !o.contentDOM ? tt.isSelectable(r) ? Ia(e, new tt(n < 0 ? e.state.doc.resolve(l.pos - r.nodeSize) : l)) : po ? Ia(e, new rt(e.state.doc.resolve(n < 0 ? i : i + r.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (a instanceof tt && a.node.isInline)
      return Ia(e, new rt(n > 0 ? a.$to : a.$from));
    {
      let l = Zd(e.state, n);
      return l ? Ia(e, l) : !1;
    }
  }
}
function pi(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function Mr(e, n) {
  let t = e.pmViewDesc;
  return t && t.size == 0 && (n < 0 || e.nextSibling || e.nodeName != "BR");
}
function Il(e, n) {
  return n < 0 ? iL(e) : sL(e);
}
function iL(e) {
  let n = e.domSelectionRange(), t = n.focusNode, a = n.focusOffset;
  if (!t)
    return;
  let l, r, o = !1;
  for (Dn && t.nodeType == 1 && a < pi(t) && Mr(t.childNodes[a], -1) && (o = !0); ; )
    if (a > 0) {
      if (t.nodeType != 1)
        break;
      {
        let i = t.childNodes[a - 1];
        if (Mr(i, -1))
          l = t, r = --a;
        else if (i.nodeType == 3)
          t = i, a = t.nodeValue.length;
        else
          break;
      }
    } else {
      if (ap(t))
        break;
      {
        let i = t.previousSibling;
        for (; i && Mr(i, -1); )
          l = t.parentNode, r = Zt(i), i = i.previousSibling;
        if (i)
          t = i, a = pi(t);
        else {
          if (t = t.parentNode, t == e.dom)
            break;
          a = 0;
        }
      }
    }
  o ? Qd(e, t, a) : l && Qd(e, l, r);
}
function sL(e) {
  let n = e.domSelectionRange(), t = n.focusNode, a = n.focusOffset;
  if (!t)
    return;
  let l = pi(t), r, o;
  for (; ; )
    if (a < l) {
      if (t.nodeType != 1)
        break;
      let i = t.childNodes[a];
      if (Mr(i, 1))
        r = t, o = ++a;
      else
        break;
    } else {
      if (ap(t))
        break;
      {
        let i = t.nextSibling;
        for (; i && Mr(i, 1); )
          r = i.parentNode, o = Zt(i) + 1, i = i.nextSibling;
        if (i)
          t = i, a = 0, l = pi(t);
        else {
          if (t = t.parentNode, t == e.dom)
            break;
          a = l = 0;
        }
      }
    }
  r && Qd(e, r, o);
}
function ap(e) {
  let n = e.pmViewDesc;
  return n && n.node && n.node.isBlock;
}
function dL(e, n) {
  for (; e && n == e.childNodes.length && !mo(e); )
    n = Zt(e) + 1, e = e.parentNode;
  for (; e && n < e.childNodes.length; ) {
    let t = e.childNodes[n];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    e = t, n = 0;
  }
}
function uL(e, n) {
  for (; e && !n && !mo(e); )
    n = Zt(e), e = e.parentNode;
  for (; e && n; ) {
    let t = e.childNodes[n - 1];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    e = t, n = e.childNodes.length;
  }
}
function Qd(e, n, t) {
  if (n.nodeType != 3) {
    let r, o;
    (o = dL(n, t)) ? (n = o, t = 0) : (r = uL(n, t)) && (n = r, t = r.nodeValue.length);
  }
  let a = e.domSelection();
  if (!a)
    return;
  if (fs(a)) {
    let r = document.createRange();
    r.setEnd(n, t), r.setStart(n, t), a.removeAllRanges(), a.addRange(r);
  } else a.extend && a.extend(n, t);
  e.domObserver.setCurSelection();
  let { state: l } = e;
  setTimeout(() => {
    e.state == l && va(e);
  }, 50);
}
function bh(e, n) {
  let t = e.state.doc.resolve(n);
  if (!(_t || jm) && t.parent.inlineContent) {
    let l = e.coordsAtPos(n);
    if (n > t.start()) {
      let r = e.coordsAtPos(n - 1), o = (r.top + r.bottom) / 2;
      if (o > l.top && o < l.bottom && Math.abs(r.left - l.left) > 1)
        return r.left < l.left ? "ltr" : "rtl";
    }
    if (n < t.end()) {
      let r = e.coordsAtPos(n + 1), o = (r.top + r.bottom) / 2;
      if (o > l.top && o < l.bottom && Math.abs(r.left - l.left) > 1)
        return r.left > l.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(e.dom).direction == "rtl" ? "rtl" : "ltr";
}
function gh(e, n, t) {
  let a = e.state.selection;
  if (a instanceof rt && !a.empty || t.indexOf("s") > -1 || Ln && t.indexOf("m") > -1)
    return !1;
  let { $from: l, $to: r } = a;
  if (!l.parent.inlineContent || e.endOfTextblock(n < 0 ? "up" : "down")) {
    let o = Zd(e.state, n);
    if (o && o instanceof tt)
      return Ia(e, o);
  }
  if (!l.parent.inlineContent) {
    let o = n < 0 ? l : r, i = a instanceof wn ? st.near(o, n) : st.findFrom(o, n);
    return i ? Ia(e, i) : !1;
  }
  return !1;
}
function mh(e, n) {
  if (!(e.state.selection instanceof rt))
    return !0;
  let { $head: t, $anchor: a, empty: l } = e.state.selection;
  if (!t.sameParent(a))
    return !0;
  if (!l)
    return !1;
  if (e.endOfTextblock(n > 0 ? "forward" : "backward"))
    return !0;
  let r = !t.textOffset && (n < 0 ? t.nodeBefore : t.nodeAfter);
  if (r && !r.isText) {
    let o = e.state.tr;
    return n < 0 ? o.delete(t.pos - r.nodeSize, t.pos) : o.delete(t.pos, t.pos + r.nodeSize), e.dispatch(o), !0;
  }
  return !1;
}
function ph(e, n, t) {
  e.domObserver.stop(), n.contentEditable = t, e.domObserver.start();
}
function cL(e) {
  if (!rn || e.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: n, focusOffset: t } = e.domSelectionRange();
  if (n && n.nodeType == 1 && t == 0 && n.firstChild && n.firstChild.contentEditable == "false") {
    let a = n.firstChild;
    ph(e, a, "true"), setTimeout(() => ph(e, a, "false"), 20);
  }
  return !1;
}
function fL(e) {
  let n = "";
  return e.ctrlKey && (n += "c"), e.metaKey && (n += "m"), e.altKey && (n += "a"), e.shiftKey && (n += "s"), n;
}
function hL(e, n) {
  let t = n.keyCode, a = fL(n);
  if (t == 8 || Ln && t == 72 && a == "c")
    return mh(e, -1) || Il(e, -1);
  if (t == 46 && !n.shiftKey || Ln && t == 68 && a == "c")
    return mh(e, 1) || Il(e, 1);
  if (t == 13 || t == 27)
    return !0;
  if (t == 37 || Ln && t == 66 && a == "c") {
    let l = t == 37 ? bh(e, e.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return hh(e, l, a) || Il(e, l);
  } else if (t == 39 || Ln && t == 70 && a == "c") {
    let l = t == 39 ? bh(e, e.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return hh(e, l, a) || Il(e, l);
  } else {
    if (t == 38 || Ln && t == 80 && a == "c")
      return gh(e, -1, a) || Il(e, -1);
    if (t == 40 || Ln && t == 78 && a == "c")
      return cL(e) || gh(e, 1, a) || Il(e, 1);
    if (a == (Ln ? "m" : "c") && (t == 66 || t == 73 || t == 89 || t == 90))
      return !0;
  }
  return !1;
}
function hc(e, n) {
  e.someProp("transformCopied", (h) => {
    n = h(n, e);
  });
  let t = [], { content: a, openStart: l, openEnd: r } = n;
  for (; l > 1 && r > 1 && a.childCount == 1 && a.firstChild.childCount == 1; ) {
    l--, r--;
    let h = a.firstChild;
    t.push(h.type.name, h.attrs != h.type.defaultAttrs ? h.attrs : null), a = h.content;
  }
  let o = e.someProp("clipboardSerializer") || Sl.fromSchema(e.state.schema), i = dp(), s = i.createElement("div");
  s.appendChild(o.serializeFragment(a, { document: i }));
  let d = s.firstChild, u, f = 0;
  for (; d && d.nodeType == 1 && (u = sp[d.nodeName.toLowerCase()]); ) {
    for (let h = u.length - 1; h >= 0; h--) {
      let p = i.createElement(u[h]);
      for (; s.firstChild; )
        p.appendChild(s.firstChild);
      s.appendChild(p), f++;
    }
    d = s.firstChild;
  }
  d && d.nodeType == 1 && d.setAttribute("data-pm-slice", `${l} ${r}${f ? ` -${f}` : ""} ${JSON.stringify(t)}`);
  let b = e.someProp("clipboardTextSerializer", (h) => h(n, e)) || n.content.textBetween(0, n.content.size, `

`);
  return { dom: s, text: b, slice: n };
}
function lp(e, n, t, a, l) {
  let r = l.parent.type.spec.code, o, i;
  if (!t && !n)
    return null;
  let s = !!n && (a || r || !t);
  if (s) {
    if (e.someProp("transformPastedText", (b) => {
      n = b(n, r || a, e);
    }), r)
      return i = new Xe(Ve.from(e.state.schema.text(n.replace(/\r\n?/g, `
`))), 0, 0), e.someProp("transformPasted", (b) => {
        i = b(i, e, !0);
      }), i;
    let f = e.someProp("clipboardTextParser", (b) => b(n, l, a, e));
    if (f)
      i = f;
    else {
      let b = l.marks(), { schema: h } = e.state, p = Sl.fromSchema(h);
      o = document.createElement("div"), n.split(/(?:\r\n?|\n)+/).forEach((x) => {
        let y = o.appendChild(document.createElement("p"));
        x && y.appendChild(p.serializeNode(h.text(x, b)));
      });
    }
  } else
    e.someProp("transformPastedHTML", (f) => {
      t = f(t, e);
    }), o = pL(t), po && vL(o);
  let d = o && o.querySelector("[data-pm-slice]"), u = d && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(d.getAttribute("data-pm-slice") || "");
  if (u && u[3])
    for (let f = +u[3]; f > 0; f--) {
      let b = o.firstChild;
      for (; b && b.nodeType != 1; )
        b = b.nextSibling;
      if (!b)
        break;
      o = b;
    }
  if (i || (i = (e.someProp("clipboardParser") || e.someProp("domParser") || Pa.fromSchema(e.state.schema)).parseSlice(o, {
    preserveWhitespace: !!(s || u),
    context: l,
    ruleFromNode(b) {
      return b.nodeName == "BR" && !b.nextSibling && b.parentNode && !bL.test(b.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), u)
    i = xL(vh(i, +u[1], +u[2]), u[4]);
  else if (i = Xe.maxOpen(gL(i.content, l), !0), i.openStart || i.openEnd) {
    let f = 0, b = 0;
    for (let h = i.content.firstChild; f < i.openStart && !h.type.spec.isolating; f++, h = h.firstChild)
      ;
    for (let h = i.content.lastChild; b < i.openEnd && !h.type.spec.isolating; b++, h = h.lastChild)
      ;
    i = vh(i, f, b);
  }
  return e.someProp("transformPasted", (f) => {
    i = f(i, e, s);
  }), i;
}
const bL = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function gL(e, n) {
  if (e.childCount < 2)
    return e;
  for (let t = n.depth; t >= 0; t--) {
    let l = n.node(t).contentMatchAt(n.index(t)), r, o = [];
    if (e.forEach((i) => {
      if (!o)
        return;
      let s = l.findWrapping(i.type), d;
      if (!s)
        return o = null;
      if (d = o.length && r.length && op(s, r, i, o[o.length - 1], 0))
        o[o.length - 1] = d;
      else {
        o.length && (o[o.length - 1] = ip(o[o.length - 1], r.length));
        let u = rp(i, s);
        o.push(u), l = l.matchType(u.type), r = s;
      }
    }), o)
      return Ve.from(o);
  }
  return e;
}
function rp(e, n, t = 0) {
  for (let a = n.length - 1; a >= t; a--)
    e = n[a].create(null, Ve.from(e));
  return e;
}
function op(e, n, t, a, l) {
  if (l < e.length && l < n.length && e[l] == n[l]) {
    let r = op(e, n, t, a.lastChild, l + 1);
    if (r)
      return a.copy(a.content.replaceChild(a.childCount - 1, r));
    if (a.contentMatchAt(a.childCount).matchType(l == e.length - 1 ? t.type : e[l + 1]))
      return a.copy(a.content.append(Ve.from(rp(t, e, l + 1))));
  }
}
function ip(e, n) {
  if (n == 0)
    return e;
  let t = e.content.replaceChild(e.childCount - 1, ip(e.lastChild, n - 1)), a = e.contentMatchAt(e.childCount).fillBefore(Ve.empty, !0);
  return e.copy(t.append(a));
}
function _d(e, n, t, a, l, r) {
  let o = n < 0 ? e.firstChild : e.lastChild, i = o.content;
  return e.childCount > 1 && (r = 0), l < a - 1 && (i = _d(i, n, t, a, l + 1, r)), l >= t && (i = n < 0 ? o.contentMatchAt(0).fillBefore(i, r <= l).append(i) : i.append(o.contentMatchAt(o.childCount).fillBefore(Ve.empty, !0))), e.replaceChild(n < 0 ? 0 : e.childCount - 1, o.copy(i));
}
function vh(e, n, t) {
  return n < e.openStart && (e = new Xe(_d(e.content, -1, n, e.openStart, 0, e.openEnd), n, e.openEnd)), t < e.openEnd && (e = new Xe(_d(e.content, 1, t, e.openEnd, 0, 0), e.openStart, t)), e;
}
const sp = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let xh = null;
function dp() {
  return xh || (xh = document.implementation.createHTMLDocument("title"));
}
let Ks = null;
function mL(e) {
  let n = window.trustedTypes;
  return n ? (Ks || (Ks = n.defaultPolicy || n.createPolicy("ProseMirrorClipboard", { createHTML: (t) => t })), Ks.createHTML(e)) : e;
}
function pL(e) {
  let n = /^(\s*<meta [^>]*>)*/.exec(e);
  n && (e = e.slice(n[0].length));
  let t = dp().createElement("div"), a = /<([a-z][^>\s]+)/i.exec(e), l;
  if ((l = a && sp[a[1].toLowerCase()]) && (e = l.map((r) => "<" + r + ">").join("") + e + l.map((r) => "</" + r + ">").reverse().join("")), t.innerHTML = mL(e), l)
    for (let r = 0; r < l.length; r++)
      t = t.querySelector(l[r]) || t;
  return t;
}
function vL(e) {
  let n = e.querySelectorAll(_t ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let t = 0; t < n.length; t++) {
    let a = n[t];
    a.childNodes.length == 1 && a.textContent == " " && a.parentNode && a.parentNode.replaceChild(e.ownerDocument.createTextNode(" "), a);
  }
}
function xL(e, n) {
  if (!e.size)
    return e;
  let t = e.content.firstChild.type.schema, a;
  try {
    a = JSON.parse(n);
  } catch {
    return e;
  }
  let { content: l, openStart: r, openEnd: o } = e;
  for (let i = a.length - 2; i >= 0; i -= 2) {
    let s = t.nodes[a[i]];
    if (!s || s.hasRequiredAttrs())
      break;
    l = Ve.from(s.create(a[i + 1], l)), r++, o++;
  }
  return new Xe(l, r, o);
}
const fn = {}, hn = {}, yL = { touchstart: !0, touchmove: !0 };
class kL {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "", button: 0 }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.badSafariComposition = !1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function wL(e) {
  for (let n in fn) {
    let t = fn[n];
    e.dom.addEventListener(n, e.input.eventHandlers[n] = (a) => {
      SL(e, a) && !bc(e, a) && (e.editable || !(a.type in hn)) && t(e, a);
    }, yL[n] ? { passive: !0 } : void 0);
  }
  rn && e.dom.addEventListener("input", () => null), eu(e);
}
function Ma(e, n) {
  e.input.lastSelectionOrigin = n, e.input.lastSelectionTime = Date.now();
}
function CL(e) {
  e.domObserver.stop();
  for (let n in e.input.eventHandlers)
    e.dom.removeEventListener(n, e.input.eventHandlers[n]);
  clearTimeout(e.input.composingTimeout), clearTimeout(e.input.lastIOSEnterFallbackTimeout);
}
function eu(e) {
  e.someProp("handleDOMEvents", (n) => {
    for (let t in n)
      e.input.eventHandlers[t] || e.dom.addEventListener(t, e.input.eventHandlers[t] = (a) => bc(e, a));
  });
}
function bc(e, n) {
  return e.someProp("handleDOMEvents", (t) => {
    let a = t[n.type];
    return a ? a(e, n) || n.defaultPrevented : !1;
  });
}
function SL(e, n) {
  if (!n.bubbles)
    return !0;
  if (n.defaultPrevented)
    return !1;
  for (let t = n.target; t != e.dom; t = t.parentNode)
    if (!t || t.nodeType == 11 || t.pmViewDesc && t.pmViewDesc.stopEvent(n))
      return !1;
  return !0;
}
function $L(e, n) {
  !bc(e, n) && fn[n.type] && (e.editable || !(n.type in hn)) && fn[n.type](e, n);
}
hn.keydown = (e, n) => {
  let t = n;
  if (e.input.shiftKey = t.keyCode == 16 || t.shiftKey, !cp(e, t) && (e.input.lastKeyCode = t.keyCode, e.input.lastKeyCodeTime = Date.now(), !(ma && _t && t.keyCode == 13)))
    if (t.keyCode != 229 && e.domObserver.forceFlush(), Xl && t.keyCode == 13 && !t.ctrlKey && !t.altKey && !t.metaKey) {
      let a = Date.now();
      e.input.lastIOSEnter = a, e.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        e.input.lastIOSEnter == a && (e.someProp("handleKeyDown", (l) => l(e, al(13, "Enter"))), e.input.lastIOSEnter = 0);
      }, 200);
    } else e.someProp("handleKeyDown", (a) => a(e, t)) || hL(e, t) ? t.preventDefault() : Ma(e, "key");
};
hn.keyup = (e, n) => {
  n.keyCode == 16 && (e.input.shiftKey = !1);
};
hn.keypress = (e, n) => {
  let t = n;
  if (cp(e, t) || !t.charCode || t.ctrlKey && !t.altKey || Ln && t.metaKey)
    return;
  if (e.someProp("handleKeyPress", (l) => l(e, t))) {
    t.preventDefault();
    return;
  }
  let a = e.state.selection;
  if (!(a instanceof rt) || !a.$from.sameParent(a.$to)) {
    let l = String.fromCharCode(t.charCode), r = () => e.state.tr.insertText(l).scrollIntoView();
    !/[\r\n]/.test(l) && !e.someProp("handleTextInput", (o) => o(e, a.$from.pos, a.$to.pos, l, r)) && e.dispatch(r()), t.preventDefault();
  }
};
function bs(e) {
  return { left: e.clientX, top: e.clientY };
}
function IL(e, n) {
  let t = n.x - e.clientX, a = n.y - e.clientY;
  return t * t + a * a < 100;
}
function gc(e, n, t, a, l) {
  if (a == -1)
    return !1;
  let r = e.state.doc.resolve(a);
  for (let o = r.depth + 1; o > 0; o--)
    if (e.someProp(n, (i) => o > r.depth ? i(e, t, r.nodeAfter, r.before(o), l, !0) : i(e, t, r.node(o), r.before(o), l, !1)))
      return !0;
  return !1;
}
function Fl(e, n, t) {
  if (e.focused || e.focus(), e.state.selection.eq(n))
    return;
  let a = e.state.tr.setSelection(n);
  a.setMeta("pointer", !0), e.dispatch(a);
}
function LL(e, n) {
  if (n == -1)
    return !1;
  let t = e.state.doc.resolve(n), a = t.nodeAfter;
  return a && a.isAtom && tt.isSelectable(a) ? (Fl(e, new tt(t)), !0) : !1;
}
function TL(e, n) {
  if (n == -1)
    return !1;
  let t = e.state.selection, a, l;
  t instanceof tt && (a = t.node);
  let r = e.state.doc.resolve(n);
  for (let o = r.depth + 1; o > 0; o--) {
    let i = o > r.depth ? r.nodeAfter : r.node(o);
    if (tt.isSelectable(i)) {
      a && t.$from.depth > 0 && o >= t.$from.depth && r.before(t.$from.depth + 1) == t.$from.pos ? l = r.before(t.$from.depth) : l = r.before(o);
      break;
    }
  }
  return l != null ? (Fl(e, tt.create(e.state.doc, l)), !0) : !1;
}
function AL(e, n, t, a, l) {
  return gc(e, "handleClickOn", n, t, a) || e.someProp("handleClick", (r) => r(e, n, a)) || (l ? TL(e, t) : LL(e, t));
}
function EL(e, n, t, a) {
  return gc(e, "handleDoubleClickOn", n, t, a) || e.someProp("handleDoubleClick", (l) => l(e, n, a));
}
function RL(e, n, t, a) {
  return gc(e, "handleTripleClickOn", n, t, a) || e.someProp("handleTripleClick", (l) => l(e, n, a)) || BL(e, t, a);
}
function BL(e, n, t) {
  if (t.button != 0)
    return !1;
  let a = e.state.doc;
  if (n == -1)
    return a.inlineContent ? (Fl(e, rt.create(a, 0, a.content.size)), !0) : !1;
  let l = a.resolve(n);
  for (let r = l.depth + 1; r > 0; r--) {
    let o = r > l.depth ? l.nodeAfter : l.node(r), i = l.before(r);
    if (o.inlineContent)
      Fl(e, rt.create(a, i + 1, i + 1 + o.content.size));
    else if (tt.isSelectable(o))
      Fl(e, tt.create(a, i));
    else
      continue;
    return !0;
  }
}
function mc(e) {
  return vi(e);
}
const up = Ln ? "metaKey" : "ctrlKey";
fn.mousedown = (e, n) => {
  let t = n;
  e.input.shiftKey = t.shiftKey;
  let a = mc(e), l = Date.now(), r = "singleClick";
  l - e.input.lastClick.time < 500 && IL(t, e.input.lastClick) && !t[up] && e.input.lastClick.button == t.button && (e.input.lastClick.type == "singleClick" ? r = "doubleClick" : e.input.lastClick.type == "doubleClick" && (r = "tripleClick")), e.input.lastClick = { time: l, x: t.clientX, y: t.clientY, type: r, button: t.button };
  let o = e.posAtCoords(bs(t));
  o && (r == "singleClick" ? (e.input.mouseDown && e.input.mouseDown.done(), e.input.mouseDown = new ML(e, o, t, !!a)) : (r == "doubleClick" ? EL : RL)(e, o.pos, o.inside, t) ? t.preventDefault() : Ma(e, "pointer"));
};
class ML {
  constructor(n, t, a, l) {
    this.view = n, this.pos = t, this.event = a, this.flushed = l, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = n.state.doc, this.selectNode = !!a[up], this.allowDefault = a.shiftKey;
    let r, o;
    if (t.inside > -1)
      r = n.state.doc.nodeAt(t.inside), o = t.inside;
    else {
      let u = n.state.doc.resolve(t.pos);
      r = u.parent, o = u.depth ? u.before() : 0;
    }
    const i = l ? null : a.target, s = i ? n.docView.nearestDesc(i, !0) : null;
    this.target = s && s.nodeDOM.nodeType == 1 ? s.nodeDOM : null;
    let { selection: d } = n.state;
    a.button == 0 && (r.type.spec.draggable && r.type.spec.selectable !== !1 || d instanceof tt && d.from <= o && d.to > o) && (this.mightDrag = {
      node: r,
      pos: o,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && Dn && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), n.root.addEventListener("mouseup", this.up = this.up.bind(this)), n.root.addEventListener("mousemove", this.move = this.move.bind(this)), Ma(n, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => va(this.view)), this.view.input.mouseDown = null;
  }
  up(n) {
    if (this.done(), !this.view.dom.contains(n.target))
      return;
    let t = this.pos;
    this.view.state.doc != this.startDoc && (t = this.view.posAtCoords(bs(n))), this.updateAllowDefault(n), this.allowDefault || !t ? Ma(this.view, "pointer") : AL(this.view, t.pos, t.inside, n, this.selectNode) ? n.preventDefault() : n.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    rn && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    _t && !this.view.state.selection.visible && Math.min(Math.abs(t.pos - this.view.state.selection.from), Math.abs(t.pos - this.view.state.selection.to)) <= 2) ? (Fl(this.view, st.near(this.view.state.doc.resolve(t.pos))), n.preventDefault()) : Ma(this.view, "pointer");
  }
  move(n) {
    this.updateAllowDefault(n), Ma(this.view, "pointer"), n.buttons == 0 && this.done();
  }
  updateAllowDefault(n) {
    !this.allowDefault && (Math.abs(this.event.x - n.clientX) > 4 || Math.abs(this.event.y - n.clientY) > 4) && (this.allowDefault = !0);
  }
}
fn.touchstart = (e) => {
  e.input.lastTouch = Date.now(), mc(e), Ma(e, "pointer");
};
fn.touchmove = (e) => {
  e.input.lastTouch = Date.now(), Ma(e, "pointer");
};
fn.contextmenu = (e) => mc(e);
function cp(e, n) {
  return e.composing ? !0 : rn && Math.abs(n.timeStamp - e.input.compositionEndedAt) < 500 ? (e.input.compositionEndedAt = -2e8, !0) : !1;
}
const DL = ma ? 5e3 : -1;
hn.compositionstart = hn.compositionupdate = (e) => {
  if (!e.composing) {
    e.domObserver.flush();
    let { state: n } = e, t = n.selection.$to;
    if (n.selection instanceof rt && (n.storedMarks || !t.textOffset && t.parentOffset && t.nodeBefore.marks.some((a) => a.type.spec.inclusive === !1) || _t && jm && zL(e)))
      e.markCursor = e.state.storedMarks || t.marks(), vi(e, !0), e.markCursor = null;
    else if (vi(e, !n.selection.empty), Dn && n.selection.empty && t.parentOffset && !t.textOffset && t.nodeBefore.marks.length) {
      let a = e.domSelectionRange();
      for (let l = a.focusNode, r = a.focusOffset; l && l.nodeType == 1 && r != 0; ) {
        let o = r < 0 ? l.lastChild : l.childNodes[r - 1];
        if (!o)
          break;
        if (o.nodeType == 3) {
          let i = e.domSelection();
          i && i.collapse(o, o.nodeValue.length);
          break;
        } else
          l = o, r = -1;
      }
    }
    e.input.composing = !0;
  }
  fp(e, DL);
};
function zL(e) {
  let { focusNode: n, focusOffset: t } = e.domSelectionRange();
  if (!n || n.nodeType != 1 || t >= n.childNodes.length)
    return !1;
  let a = n.childNodes[t];
  return a.nodeType == 1 && a.contentEditable == "false";
}
hn.compositionend = (e, n) => {
  e.composing && (e.input.composing = !1, e.input.compositionEndedAt = n.timeStamp, e.input.compositionPendingChanges = e.domObserver.pendingRecords().length ? e.input.compositionID : 0, e.input.compositionNode = null, e.input.badSafariComposition ? e.domObserver.forceFlush() : e.input.compositionPendingChanges && Promise.resolve().then(() => e.domObserver.flush()), e.input.compositionID++, fp(e, 20));
};
function fp(e, n) {
  clearTimeout(e.input.composingTimeout), n > -1 && (e.input.composingTimeout = setTimeout(() => vi(e), n));
}
function hp(e) {
  for (e.composing && (e.input.composing = !1, e.input.compositionEndedAt = PL()); e.input.compositionNodes.length > 0; )
    e.input.compositionNodes.pop().markParentsDirty();
}
function OL(e) {
  let n = e.domSelectionRange();
  if (!n.focusNode)
    return null;
  let t = TI(n.focusNode, n.focusOffset), a = AI(n.focusNode, n.focusOffset);
  if (t && a && t != a) {
    let l = a.pmViewDesc, r = e.domObserver.lastChangedTextNode;
    if (t == r || a == r)
      return r;
    if (!l || !l.isText(a.nodeValue))
      return a;
    if (e.input.compositionNode == a) {
      let o = t.pmViewDesc;
      if (!(!o || !o.isText(t.nodeValue)))
        return a;
    }
  }
  return t || a;
}
function PL() {
  let e = document.createEvent("Event");
  return e.initEvent("event", !0, !0), e.timeStamp;
}
function vi(e, n = !1) {
  if (!(ma && e.domObserver.flushingSoon >= 0)) {
    if (e.domObserver.forceFlush(), hp(e), n || e.docView && e.docView.dirty) {
      let t = cc(e), a = e.state.selection;
      return t && !t.eq(a) ? e.dispatch(e.state.tr.setSelection(t)) : (e.markCursor || n) && !a.$from.node(a.$from.sharedDepth(a.to)).inlineContent ? e.dispatch(e.state.tr.deleteSelection()) : e.updateState(e.state), !0;
    }
    return !1;
  }
}
function FL(e, n) {
  if (!e.dom.parentNode)
    return;
  let t = e.dom.parentNode.appendChild(document.createElement("div"));
  t.appendChild(n), t.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let a = getSelection(), l = document.createRange();
  l.selectNodeContents(n), e.dom.blur(), a.removeAllRanges(), a.addRange(l), setTimeout(() => {
    t.parentNode && t.parentNode.removeChild(t), e.focus();
  }, 50);
}
const _r = vn && Fa < 15 || Xl && MI < 604;
fn.copy = hn.cut = (e, n) => {
  let t = n, a = e.state.selection, l = t.type == "cut";
  if (a.empty)
    return;
  let r = _r ? null : t.clipboardData, o = a.content(), { dom: i, text: s } = hc(e, o);
  r ? (t.preventDefault(), r.clearData(), r.setData("text/html", i.innerHTML), r.setData("text/plain", s)) : FL(e, i), l && e.dispatch(e.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function VL(e) {
  return e.openStart == 0 && e.openEnd == 0 && e.content.childCount == 1 ? e.content.firstChild : null;
}
function NL(e, n) {
  if (!e.dom.parentNode)
    return;
  let t = e.input.shiftKey || e.state.selection.$from.parent.type.spec.code, a = e.dom.parentNode.appendChild(document.createElement(t ? "textarea" : "div"));
  t || (a.contentEditable = "true"), a.style.cssText = "position: fixed; left: -10000px; top: 10px", a.focus();
  let l = e.input.shiftKey && e.input.lastKeyCode != 45;
  setTimeout(() => {
    e.focus(), a.parentNode && a.parentNode.removeChild(a), t ? eo(e, a.value, null, l, n) : eo(e, a.textContent, a.innerHTML, l, n);
  }, 50);
}
function eo(e, n, t, a, l) {
  let r = lp(e, n, t, a, e.state.selection.$from);
  if (e.someProp("handlePaste", (s) => s(e, l, r || Xe.empty)))
    return !0;
  if (!r)
    return !1;
  let o = VL(r), i = o ? e.state.tr.replaceSelectionWith(o, a) : e.state.tr.replaceSelection(r);
  return e.dispatch(i.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function bp(e) {
  let n = e.getData("text/plain") || e.getData("Text");
  if (n)
    return n;
  let t = e.getData("text/uri-list");
  return t ? t.replace(/\r?\n/g, " ") : "";
}
hn.paste = (e, n) => {
  let t = n;
  if (e.composing && !ma)
    return;
  let a = _r ? null : t.clipboardData, l = e.input.shiftKey && e.input.lastKeyCode != 45;
  a && eo(e, bp(a), a.getData("text/html"), l, t) ? t.preventDefault() : NL(e, t);
};
class gp {
  constructor(n, t, a) {
    this.slice = n, this.move = t, this.node = a;
  }
}
const HL = Ln ? "altKey" : "ctrlKey";
function mp(e, n) {
  let t;
  return e.someProp("dragCopies", (a) => {
    t = t || a(n);
  }), t != null ? !t : !n[HL];
}
fn.dragstart = (e, n) => {
  let t = n, a = e.input.mouseDown;
  if (a && a.done(), !t.dataTransfer)
    return;
  let l = e.state.selection, r = l.empty ? null : e.posAtCoords(bs(t)), o;
  if (!(r && r.pos >= l.from && r.pos <= (l instanceof tt ? l.to - 1 : l.to))) {
    if (a && a.mightDrag)
      o = tt.create(e.state.doc, a.mightDrag.pos);
    else if (t.target && t.target.nodeType == 1) {
      let f = e.docView.nearestDesc(t.target, !0);
      f && f.node.type.spec.draggable && f != e.docView && (o = tt.create(e.state.doc, f.posBefore));
    }
  }
  let i = (o || e.state.selection).content(), { dom: s, text: d, slice: u } = hc(e, i);
  (!t.dataTransfer.files.length || !_t || Hm > 120) && t.dataTransfer.clearData(), t.dataTransfer.setData(_r ? "Text" : "text/html", s.innerHTML), t.dataTransfer.effectAllowed = "copyMove", _r || t.dataTransfer.setData("text/plain", d), e.dragging = new gp(u, mp(e, t), o);
};
fn.dragend = (e) => {
  let n = e.dragging;
  window.setTimeout(() => {
    e.dragging == n && (e.dragging = null);
  }, 50);
};
hn.dragover = hn.dragenter = (e, n) => n.preventDefault();
hn.drop = (e, n) => {
  try {
    jL(e, n, e.dragging);
  } finally {
    e.dragging = null;
  }
};
function jL(e, n, t) {
  if (!n.dataTransfer)
    return;
  let a = e.posAtCoords(bs(n));
  if (!a)
    return;
  let l = e.state.doc.resolve(a.pos), r = t && t.slice;
  r ? e.someProp("transformPasted", (h) => {
    r = h(r, e, !1);
  }) : r = lp(e, bp(n.dataTransfer), _r ? null : n.dataTransfer.getData("text/html"), !1, l);
  let o = !!(t && mp(e, n));
  if (e.someProp("handleDrop", (h) => h(e, n, r || Xe.empty, o))) {
    n.preventDefault();
    return;
  }
  if (!r)
    return;
  n.preventDefault();
  let i = r ? xm(e.state.doc, l.pos, r) : l.pos;
  i == null && (i = l.pos);
  let s = e.state.tr;
  if (o) {
    let { node: h } = t;
    h ? h.replace(s) : s.deleteSelection();
  }
  let d = s.mapping.map(i), u = r.openStart == 0 && r.openEnd == 0 && r.content.childCount == 1, f = s.doc;
  if (u ? s.replaceRangeWith(d, d, r.content.firstChild) : s.replaceRange(d, d, r), s.doc.eq(f))
    return;
  let b = s.doc.resolve(d);
  if (u && tt.isSelectable(r.content.firstChild) && b.nodeAfter && b.nodeAfter.sameMarkup(r.content.firstChild))
    s.setSelection(new tt(b));
  else {
    let h = s.mapping.map(i);
    s.mapping.maps[s.mapping.maps.length - 1].forEach((p, x, y, k) => h = k), s.setSelection(fc(e, b, s.doc.resolve(h)));
  }
  e.focus(), e.dispatch(s.setMeta("uiEvent", "drop"));
}
fn.focus = (e) => {
  e.input.lastFocus = Date.now(), e.focused || (e.domObserver.stop(), e.dom.classList.add("ProseMirror-focused"), e.domObserver.start(), e.focused = !0, setTimeout(() => {
    e.docView && e.hasFocus() && !e.domObserver.currentSelection.eq(e.domSelectionRange()) && va(e);
  }, 20));
};
fn.blur = (e, n) => {
  let t = n;
  e.focused && (e.domObserver.stop(), e.dom.classList.remove("ProseMirror-focused"), e.domObserver.start(), t.relatedTarget && e.dom.contains(t.relatedTarget) && e.domObserver.currentSelection.clear(), e.focused = !1);
};
fn.beforeinput = (e, n) => {
  if (_t && ma && n.inputType == "deleteContentBackward") {
    e.domObserver.flushSoon();
    let { domChangeCount: a } = e.input;
    setTimeout(() => {
      if (e.input.domChangeCount != a || (e.dom.blur(), e.focus(), e.someProp("handleKeyDown", (r) => r(e, al(8, "Backspace")))))
        return;
      let { $cursor: l } = e.state.selection;
      l && l.pos > 0 && e.dispatch(e.state.tr.delete(l.pos - 1, l.pos).scrollIntoView());
    }, 50);
  }
};
for (let e in hn)
  fn[e] = hn[e];
function to(e, n) {
  if (e == n)
    return !0;
  for (let t in e)
    if (e[t] !== n[t])
      return !1;
  for (let t in n)
    if (!(t in e))
      return !1;
  return !0;
}
class xi {
  constructor(n, t) {
    this.toDOM = n, this.spec = t || hl, this.side = this.spec.side || 0;
  }
  map(n, t, a, l) {
    let { pos: r, deleted: o } = n.mapResult(t.from + l, this.side < 0 ? -1 : 1);
    return o ? null : new un(r - a, r - a, this);
  }
  valid() {
    return !0;
  }
  eq(n) {
    return this == n || n instanceof xi && (this.spec.key && this.spec.key == n.spec.key || this.toDOM == n.toDOM && to(this.spec, n.spec));
  }
  destroy(n) {
    this.spec.destroy && this.spec.destroy(n);
  }
}
class Na {
  constructor(n, t) {
    this.attrs = n, this.spec = t || hl;
  }
  map(n, t, a, l) {
    let r = n.map(t.from + l, this.spec.inclusiveStart ? -1 : 1) - a, o = n.map(t.to + l, this.spec.inclusiveEnd ? 1 : -1) - a;
    return r >= o ? null : new un(r, o, this);
  }
  valid(n, t) {
    return t.from < t.to;
  }
  eq(n) {
    return this == n || n instanceof Na && to(this.attrs, n.attrs) && to(this.spec, n.spec);
  }
  static is(n) {
    return n.type instanceof Na;
  }
  destroy() {
  }
}
class pc {
  constructor(n, t) {
    this.attrs = n, this.spec = t || hl;
  }
  map(n, t, a, l) {
    let r = n.mapResult(t.from + l, 1);
    if (r.deleted)
      return null;
    let o = n.mapResult(t.to + l, -1);
    return o.deleted || o.pos <= r.pos ? null : new un(r.pos - a, o.pos - a, this);
  }
  valid(n, t) {
    let { index: a, offset: l } = n.content.findIndex(t.from), r;
    return l == t.from && !(r = n.child(a)).isText && l + r.nodeSize == t.to;
  }
  eq(n) {
    return this == n || n instanceof pc && to(this.attrs, n.attrs) && to(this.spec, n.spec);
  }
  destroy() {
  }
}
class un {
  /**
  @internal
  */
  constructor(n, t, a) {
    this.from = n, this.to = t, this.type = a;
  }
  /**
  @internal
  */
  copy(n, t) {
    return new un(n, t, this.type);
  }
  /**
  @internal
  */
  eq(n, t = 0) {
    return this.type.eq(n.type) && this.from + t == n.from && this.to + t == n.to;
  }
  /**
  @internal
  */
  map(n, t, a) {
    return this.type.map(n, this, t, a);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(n, t, a) {
    return new un(n, n, new xi(t, a));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(n, t, a, l) {
    return new un(n, t, new Na(a, l));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(n, t, a, l) {
    return new un(n, t, new pc(a, l));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof Na;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof xi;
  }
}
const El = [], hl = {};
class Et {
  /**
  @internal
  */
  constructor(n, t) {
    this.local = n.length ? n : El, this.children = t.length ? t : El;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(n, t) {
    return t.length ? yi(t, n, 0, hl) : ln;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(n, t, a) {
    let l = [];
    return this.findInner(n ?? 0, t ?? 1e9, l, 0, a), l;
  }
  findInner(n, t, a, l, r) {
    for (let o = 0; o < this.local.length; o++) {
      let i = this.local[o];
      i.from <= t && i.to >= n && (!r || r(i.spec)) && a.push(i.copy(i.from + l, i.to + l));
    }
    for (let o = 0; o < this.children.length; o += 3)
      if (this.children[o] < t && this.children[o + 1] > n) {
        let i = this.children[o] + 1;
        this.children[o + 2].findInner(n - i, t - i, a, l + i, r);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(n, t, a) {
    return this == ln || n.maps.length == 0 ? this : this.mapInner(n, t, 0, 0, a || hl);
  }
  /**
  @internal
  */
  mapInner(n, t, a, l, r) {
    let o;
    for (let i = 0; i < this.local.length; i++) {
      let s = this.local[i].map(n, a, l);
      s && s.type.valid(t, s) ? (o || (o = [])).push(s) : r.onRemove && r.onRemove(this.local[i].spec);
    }
    return this.children.length ? WL(this.children, o || [], n, t, a, l, r) : o ? new Et(o.sort(bl), El) : ln;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(n, t) {
    return t.length ? this == ln ? Et.create(n, t) : this.addInner(n, t, 0) : this;
  }
  addInner(n, t, a) {
    let l, r = 0;
    n.forEach((i, s) => {
      let d = s + a, u;
      if (u = vp(t, i, d)) {
        for (l || (l = this.children.slice()); r < l.length && l[r] < s; )
          r += 3;
        l[r] == s ? l[r + 2] = l[r + 2].addInner(i, u, d + 1) : l.splice(r, 0, s, s + i.nodeSize, yi(u, i, d + 1, hl)), r += 3;
      }
    });
    let o = pp(r ? xp(t) : t, -a);
    for (let i = 0; i < o.length; i++)
      o[i].type.valid(n, o[i]) || o.splice(i--, 1);
    return new Et(o.length ? this.local.concat(o).sort(bl) : this.local, l || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(n) {
    return n.length == 0 || this == ln ? this : this.removeInner(n, 0);
  }
  removeInner(n, t) {
    let a = this.children, l = this.local;
    for (let r = 0; r < a.length; r += 3) {
      let o, i = a[r] + t, s = a[r + 1] + t;
      for (let u = 0, f; u < n.length; u++)
        (f = n[u]) && f.from > i && f.to < s && (n[u] = null, (o || (o = [])).push(f));
      if (!o)
        continue;
      a == this.children && (a = this.children.slice());
      let d = a[r + 2].removeInner(o, i + 1);
      d != ln ? a[r + 2] = d : (a.splice(r, 3), r -= 3);
    }
    if (l.length) {
      for (let r = 0, o; r < n.length; r++)
        if (o = n[r])
          for (let i = 0; i < l.length; i++)
            l[i].eq(o, t) && (l == this.local && (l = this.local.slice()), l.splice(i--, 1));
    }
    return a == this.children && l == this.local ? this : l.length || a.length ? new Et(l, a) : ln;
  }
  forChild(n, t) {
    if (this == ln)
      return this;
    if (t.isLeaf)
      return Et.empty;
    let a, l;
    for (let i = 0; i < this.children.length; i += 3)
      if (this.children[i] >= n) {
        this.children[i] == n && (a = this.children[i + 2]);
        break;
      }
    let r = n + 1, o = r + t.content.size;
    for (let i = 0; i < this.local.length; i++) {
      let s = this.local[i];
      if (s.from < o && s.to > r && s.type instanceof Na) {
        let d = Math.max(r, s.from) - r, u = Math.min(o, s.to) - r;
        d < u && (l || (l = [])).push(s.copy(d, u));
      }
    }
    if (l) {
      let i = new Et(l.sort(bl), El);
      return a ? new Ea([i, a]) : i;
    }
    return a || ln;
  }
  /**
  @internal
  */
  eq(n) {
    if (this == n)
      return !0;
    if (!(n instanceof Et) || this.local.length != n.local.length || this.children.length != n.children.length)
      return !1;
    for (let t = 0; t < this.local.length; t++)
      if (!this.local[t].eq(n.local[t]))
        return !1;
    for (let t = 0; t < this.children.length; t += 3)
      if (this.children[t] != n.children[t] || this.children[t + 1] != n.children[t + 1] || !this.children[t + 2].eq(n.children[t + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(n) {
    return vc(this.localsInner(n));
  }
  /**
  @internal
  */
  localsInner(n) {
    if (this == ln)
      return El;
    if (n.inlineContent || !this.local.some(Na.is))
      return this.local;
    let t = [];
    for (let a = 0; a < this.local.length; a++)
      this.local[a].type instanceof Na || t.push(this.local[a]);
    return t;
  }
  forEachSet(n) {
    n(this);
  }
}
Et.empty = new Et([], []);
Et.removeOverlap = vc;
const ln = Et.empty;
class Ea {
  constructor(n) {
    this.members = n;
  }
  map(n, t) {
    const a = this.members.map((l) => l.map(n, t, hl));
    return Ea.from(a);
  }
  forChild(n, t) {
    if (t.isLeaf)
      return Et.empty;
    let a = [];
    for (let l = 0; l < this.members.length; l++) {
      let r = this.members[l].forChild(n, t);
      r != ln && (r instanceof Ea ? a = a.concat(r.members) : a.push(r));
    }
    return Ea.from(a);
  }
  eq(n) {
    if (!(n instanceof Ea) || n.members.length != this.members.length)
      return !1;
    for (let t = 0; t < this.members.length; t++)
      if (!this.members[t].eq(n.members[t]))
        return !1;
    return !0;
  }
  locals(n) {
    let t, a = !0;
    for (let l = 0; l < this.members.length; l++) {
      let r = this.members[l].localsInner(n);
      if (r.length)
        if (!t)
          t = r;
        else {
          a && (t = t.slice(), a = !1);
          for (let o = 0; o < r.length; o++)
            t.push(r[o]);
        }
    }
    return t ? vc(a ? t : t.sort(bl)) : El;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(n) {
    switch (n.length) {
      case 0:
        return ln;
      case 1:
        return n[0];
      default:
        return new Ea(n.every((t) => t instanceof Et) ? n : n.reduce((t, a) => t.concat(a instanceof Et ? a : a.members), []));
    }
  }
  forEachSet(n) {
    for (let t = 0; t < this.members.length; t++)
      this.members[t].forEachSet(n);
  }
}
function WL(e, n, t, a, l, r, o) {
  let i = e.slice();
  for (let d = 0, u = r; d < t.maps.length; d++) {
    let f = 0;
    t.maps[d].forEach((b, h, p, x) => {
      let y = x - p - (h - b);
      for (let k = 0; k < i.length; k += 3) {
        let $ = i[k + 1];
        if ($ < 0 || b > $ + u - f)
          continue;
        let S = i[k] + u - f;
        h >= S ? i[k + 1] = b <= S ? -2 : -1 : b >= u && y && (i[k] += y, i[k + 1] += y);
      }
      f += y;
    }), u = t.maps[d].map(u, -1);
  }
  let s = !1;
  for (let d = 0; d < i.length; d += 3)
    if (i[d + 1] < 0) {
      if (i[d + 1] == -2) {
        s = !0, i[d + 1] = -1;
        continue;
      }
      let u = t.map(e[d] + r), f = u - l;
      if (f < 0 || f >= a.content.size) {
        s = !0;
        continue;
      }
      let b = t.map(e[d + 1] + r, -1), h = b - l, { index: p, offset: x } = a.content.findIndex(f), y = a.maybeChild(p);
      if (y && x == f && x + y.nodeSize == h) {
        let k = i[d + 2].mapInner(t, y, u + 1, e[d] + r + 1, o);
        k != ln ? (i[d] = f, i[d + 1] = h, i[d + 2] = k) : (i[d + 1] = -2, s = !0);
      } else
        s = !0;
    }
  if (s) {
    let d = qL(i, e, n, t, l, r, o), u = yi(d, a, 0, o);
    n = u.local;
    for (let f = 0; f < i.length; f += 3)
      i[f + 1] < 0 && (i.splice(f, 3), f -= 3);
    for (let f = 0, b = 0; f < u.children.length; f += 3) {
      let h = u.children[f];
      for (; b < i.length && i[b] < h; )
        b += 3;
      i.splice(b, 0, u.children[f], u.children[f + 1], u.children[f + 2]);
    }
  }
  return new Et(n.sort(bl), i);
}
function pp(e, n) {
  if (!n || !e.length)
    return e;
  let t = [];
  for (let a = 0; a < e.length; a++) {
    let l = e[a];
    t.push(new un(l.from + n, l.to + n, l.type));
  }
  return t;
}
function qL(e, n, t, a, l, r, o) {
  function i(s, d) {
    for (let u = 0; u < s.local.length; u++) {
      let f = s.local[u].map(a, l, d);
      f ? t.push(f) : o.onRemove && o.onRemove(s.local[u].spec);
    }
    for (let u = 0; u < s.children.length; u += 3)
      i(s.children[u + 2], s.children[u] + d + 1);
  }
  for (let s = 0; s < e.length; s += 3)
    e[s + 1] == -1 && i(e[s + 2], n[s] + r + 1);
  return t;
}
function vp(e, n, t) {
  if (n.isLeaf)
    return null;
  let a = t + n.nodeSize, l = null;
  for (let r = 0, o; r < e.length; r++)
    (o = e[r]) && o.from > t && o.to < a && ((l || (l = [])).push(o), e[r] = null);
  return l;
}
function xp(e) {
  let n = [];
  for (let t = 0; t < e.length; t++)
    e[t] != null && n.push(e[t]);
  return n;
}
function yi(e, n, t, a) {
  let l = [], r = !1;
  n.forEach((i, s) => {
    let d = vp(e, i, s + t);
    if (d) {
      r = !0;
      let u = yi(d, i, t + s + 1, a);
      u != ln && l.push(s, s + i.nodeSize, u);
    }
  });
  let o = pp(r ? xp(e) : e, -t).sort(bl);
  for (let i = 0; i < o.length; i++)
    o[i].type.valid(n, o[i]) || (a.onRemove && a.onRemove(o[i].spec), o.splice(i--, 1));
  return o.length || l.length ? new Et(o, l) : ln;
}
function bl(e, n) {
  return e.from - n.from || e.to - n.to;
}
function vc(e) {
  let n = e;
  for (let t = 0; t < n.length - 1; t++) {
    let a = n[t];
    if (a.from != a.to)
      for (let l = t + 1; l < n.length; l++) {
        let r = n[l];
        if (r.from == a.from) {
          r.to != a.to && (n == e && (n = e.slice()), n[l] = r.copy(r.from, a.to), yh(n, l + 1, r.copy(a.to, r.to)));
          continue;
        } else {
          r.from < a.to && (n == e && (n = e.slice()), n[t] = a.copy(a.from, r.from), yh(n, l, a.copy(r.from, a.to)));
          break;
        }
      }
  }
  return n;
}
function yh(e, n, t) {
  for (; n < e.length && bl(t, e[n]) > 0; )
    n++;
  e.splice(n, 0, t);
}
function Ys(e) {
  let n = [];
  return e.someProp("decorations", (t) => {
    let a = t(e.state);
    a && a != ln && n.push(a);
  }), e.cursorWrapper && n.push(Et.create(e.state.doc, [e.cursorWrapper.deco])), Ea.from(n);
}
const UL = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, GL = vn && Fa <= 11;
class KL {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(n) {
    this.anchorNode = n.anchorNode, this.anchorOffset = n.anchorOffset, this.focusNode = n.focusNode, this.focusOffset = n.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(n) {
    return n.anchorNode == this.anchorNode && n.anchorOffset == this.anchorOffset && n.focusNode == this.focusNode && n.focusOffset == this.focusOffset;
  }
}
class YL {
  constructor(n, t) {
    this.view = n, this.handleDOMChange = t, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new KL(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((a) => {
      for (let l = 0; l < a.length; l++)
        this.queue.push(a[l]);
      vn && Fa <= 11 && a.some((l) => l.type == "childList" && l.removedNodes.length || l.type == "characterData" && l.oldValue.length > l.target.nodeValue.length) ? this.flushSoon() : rn && n.composing && a.some((l) => l.type == "childList" && l.target.nodeName == "TR") ? (n.input.badSafariComposition = !0, this.flushSoon()) : this.flush();
    }), GL && (this.onCharData = (a) => {
      this.queue.push({ target: a.target, type: "characterData", oldValue: a.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, UL)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let n = this.observer.takeRecords();
      if (n.length) {
        for (let t = 0; t < n.length; t++)
          this.queue.push(n[t]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (fh(this.view)) {
      if (this.suppressingSelectionUpdates)
        return va(this.view);
      if (vn && Fa <= 11 && !this.view.state.selection.empty) {
        let n = this.view.domSelectionRange();
        if (n.focusNode && kl(n.focusNode, n.focusOffset, n.anchorNode, n.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(n) {
    if (!n.focusNode)
      return !0;
    let t = /* @__PURE__ */ new Set(), a;
    for (let r = n.focusNode; r; r = Jl(r))
      t.add(r);
    for (let r = n.anchorNode; r; r = Jl(r))
      if (t.has(r)) {
        a = r;
        break;
      }
    let l = a && this.view.docView.nearestDesc(a);
    if (l && l.ignoreMutation({
      type: "selection",
      target: a.nodeType == 3 ? a.parentNode : a
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let n of this.observer.takeRecords())
        this.queue.push(n);
    return this.queue;
  }
  flush() {
    let { view: n } = this;
    if (!n.docView || this.flushingSoon > -1)
      return;
    let t = this.pendingRecords();
    t.length && (this.queue = []);
    let a = n.domSelectionRange(), l = !this.suppressingSelectionUpdates && !this.currentSelection.eq(a) && fh(n) && !this.ignoreSelectionChange(a), r = -1, o = -1, i = !1, s = [];
    if (n.editable)
      for (let u = 0; u < t.length; u++) {
        let f = this.registerMutation(t[u], s);
        f && (r = r < 0 ? f.from : Math.min(f.from, r), o = o < 0 ? f.to : Math.max(f.to, o), f.typeOver && (i = !0));
      }
    if (s.some((u) => u.nodeName == "BR") && (n.input.lastKeyCode == 8 || n.input.lastKeyCode == 46)) {
      for (let u of s)
        if (u.nodeName == "BR" && u.parentNode) {
          let f = u.nextSibling;
          for (; f && f.nodeType == 1; ) {
            if (f.contentEditable == "false") {
              u.parentNode.removeChild(u);
              break;
            }
            f = f.firstChild;
          }
        }
    } else if (Dn && s.length) {
      let u = s.filter((f) => f.nodeName == "BR");
      if (u.length == 2) {
        let [f, b] = u;
        f.parentNode && f.parentNode.parentNode == b.parentNode ? b.remove() : f.remove();
      } else {
        let { focusNode: f } = this.currentSelection;
        for (let b of u) {
          let h = b.parentNode;
          h && h.nodeName == "LI" && (!f || ZL(n, f) != h) && b.remove();
        }
      }
    }
    let d = null;
    r < 0 && l && n.input.lastFocus > Date.now() - 200 && Math.max(n.input.lastTouch, n.input.lastClick.time) < Date.now() - 300 && fs(a) && (d = cc(n)) && d.eq(st.near(n.state.doc.resolve(0), 1)) ? (n.input.lastFocus = 0, va(n), this.currentSelection.set(a), n.scrollToSelection()) : (r > -1 || l) && (r > -1 && (n.docView.markDirty(r, o), JL(n)), n.input.badSafariComposition && (n.input.badSafariComposition = !1, QL(n, s)), this.handleDOMChange(r, o, i, s), n.docView && n.docView.dirty ? n.updateState(n.state) : this.currentSelection.eq(a) || va(n), this.currentSelection.set(a));
  }
  registerMutation(n, t) {
    if (t.indexOf(n.target) > -1)
      return null;
    let a = this.view.docView.nearestDesc(n.target);
    if (n.type == "attributes" && (a == this.view.docView || n.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    n.attributeName == "style" && !n.oldValue && !n.target.getAttribute("style")) || !a || a.ignoreMutation(n))
      return null;
    if (n.type == "childList") {
      for (let u = 0; u < n.addedNodes.length; u++) {
        let f = n.addedNodes[u];
        t.push(f), f.nodeType == 3 && (this.lastChangedTextNode = f);
      }
      if (a.contentDOM && a.contentDOM != a.dom && !a.contentDOM.contains(n.target))
        return { from: a.posBefore, to: a.posAfter };
      let l = n.previousSibling, r = n.nextSibling;
      if (vn && Fa <= 11 && n.addedNodes.length)
        for (let u = 0; u < n.addedNodes.length; u++) {
          let { previousSibling: f, nextSibling: b } = n.addedNodes[u];
          (!f || Array.prototype.indexOf.call(n.addedNodes, f) < 0) && (l = f), (!b || Array.prototype.indexOf.call(n.addedNodes, b) < 0) && (r = b);
        }
      let o = l && l.parentNode == n.target ? Zt(l) + 1 : 0, i = a.localPosFromDOM(n.target, o, -1), s = r && r.parentNode == n.target ? Zt(r) : n.target.childNodes.length, d = a.localPosFromDOM(n.target, s, 1);
      return { from: i, to: d };
    } else return n.type == "attributes" ? { from: a.posAtStart - a.border, to: a.posAtEnd + a.border } : (this.lastChangedTextNode = n.target, {
      from: a.posAtStart,
      to: a.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: n.target.nodeValue == n.oldValue
    });
  }
}
let kh = /* @__PURE__ */ new WeakMap(), wh = !1;
function JL(e) {
  if (!kh.has(e) && (kh.set(e, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(e.dom).whiteSpace) !== -1)) {
    if (e.requiresGeckoHackNode = Dn, wh)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), wh = !0;
  }
}
function Ch(e, n) {
  let t = n.startContainer, a = n.startOffset, l = n.endContainer, r = n.endOffset, o = e.domAtPos(e.state.selection.anchor);
  return kl(o.node, o.offset, l, r) && ([t, a, l, r] = [l, r, t, a]), { anchorNode: t, anchorOffset: a, focusNode: l, focusOffset: r };
}
function XL(e, n) {
  if (n.getComposedRanges) {
    let l = n.getComposedRanges(e.root)[0];
    if (l)
      return Ch(e, l);
  }
  let t;
  function a(l) {
    l.preventDefault(), l.stopImmediatePropagation(), t = l.getTargetRanges()[0];
  }
  return e.dom.addEventListener("beforeinput", a, !0), document.execCommand("indent"), e.dom.removeEventListener("beforeinput", a, !0), t ? Ch(e, t) : null;
}
function ZL(e, n) {
  for (let t = n.parentNode; t && t != e.dom; t = t.parentNode) {
    let a = e.docView.nearestDesc(t, !0);
    if (a && a.node.isBlock)
      return t;
  }
  return null;
}
function QL(e, n) {
  var t;
  let { focusNode: a, focusOffset: l } = e.domSelectionRange();
  for (let r of n)
    if (((t = r.parentNode) === null || t === void 0 ? void 0 : t.nodeName) == "TR") {
      let o = r.nextSibling;
      for (; o && o.nodeName != "TD" && o.nodeName != "TH"; )
        o = o.nextSibling;
      if (o) {
        let i = o;
        for (; ; ) {
          let s = i.firstChild;
          if (!s || s.nodeType != 1 || s.contentEditable == "false" || /^(BR|IMG)$/.test(s.nodeName))
            break;
          i = s;
        }
        i.insertBefore(r, i.firstChild), a == r && e.domSelection().collapse(r, l);
      } else
        r.parentNode.removeChild(r);
    }
}
function _L(e, n, t) {
  let { node: a, fromOffset: l, toOffset: r, from: o, to: i } = e.docView.parseRange(n, t), s = e.domSelectionRange(), d, u = s.anchorNode;
  if (u && e.dom.contains(u.nodeType == 1 ? u : u.parentNode) && (d = [{ node: u, offset: s.anchorOffset }], fs(s) || d.push({ node: s.focusNode, offset: s.focusOffset })), _t && e.input.lastKeyCode === 8)
    for (let y = r; y > l; y--) {
      let k = a.childNodes[y - 1], $ = k.pmViewDesc;
      if (k.nodeName == "BR" && !$) {
        r = y;
        break;
      }
      if (!$ || $.size)
        break;
    }
  let f = e.state.doc, b = e.someProp("domParser") || Pa.fromSchema(e.state.schema), h = f.resolve(o), p = null, x = b.parse(a, {
    topNode: h.parent,
    topMatch: h.parent.contentMatchAt(h.index()),
    topOpen: !0,
    from: l,
    to: r,
    preserveWhitespace: h.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: d,
    ruleFromNode: eT,
    context: h
  });
  if (d && d[0].pos != null) {
    let y = d[0].pos, k = d[1] && d[1].pos;
    k == null && (k = y), p = { anchor: y + o, head: k + o };
  }
  return { doc: x, sel: p, from: o, to: i };
}
function eT(e) {
  let n = e.pmViewDesc;
  if (n)
    return n.parseRule();
  if (e.nodeName == "BR" && e.parentNode) {
    if (rn && /^(ul|ol)$/i.test(e.parentNode.nodeName)) {
      let t = document.createElement("div");
      return t.appendChild(document.createElement("li")), { skip: t };
    } else if (e.parentNode.lastChild == e || rn && /^(tr|table)$/i.test(e.parentNode.nodeName))
      return { ignore: !0 };
  } else if (e.nodeName == "IMG" && e.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const tT = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function nT(e, n, t, a, l) {
  let r = e.input.compositionPendingChanges || (e.composing ? e.input.compositionID : 0);
  if (e.input.compositionPendingChanges = 0, n < 0) {
    let E = e.input.lastSelectionTime > Date.now() - 50 ? e.input.lastSelectionOrigin : null, D = cc(e, E);
    if (D && !e.state.selection.eq(D)) {
      if (_t && ma && e.input.lastKeyCode === 13 && Date.now() - 100 < e.input.lastKeyCodeTime && e.someProp("handleKeyDown", (Y) => Y(e, al(13, "Enter"))))
        return;
      let z = e.state.tr.setSelection(D);
      E == "pointer" ? z.setMeta("pointer", !0) : E == "key" && z.scrollIntoView(), r && z.setMeta("composition", r), e.dispatch(z);
    }
    return;
  }
  let o = e.state.doc.resolve(n), i = o.sharedDepth(t);
  n = o.before(i + 1), t = e.state.doc.resolve(t).after(i + 1);
  let s = e.state.selection, d = _L(e, n, t), u = e.state.doc, f = u.slice(d.from, d.to), b, h;
  e.input.lastKeyCode === 8 && Date.now() - 100 < e.input.lastKeyCodeTime ? (b = e.state.selection.to, h = "end") : (b = e.state.selection.from, h = "start"), e.input.lastKeyCode = null;
  let p = rT(f.content, d.doc.content, d.from, b, h);
  if (p && e.input.domChangeCount++, (Xl && e.input.lastIOSEnter > Date.now() - 225 || ma) && l.some((E) => E.nodeType == 1 && !tT.test(E.nodeName)) && (!p || p.endA >= p.endB) && e.someProp("handleKeyDown", (E) => E(e, al(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (!p)
    if (a && s instanceof rt && !s.empty && s.$head.sameParent(s.$anchor) && !e.composing && !(d.sel && d.sel.anchor != d.sel.head))
      p = { start: s.from, endA: s.to, endB: s.to };
    else {
      if (d.sel) {
        let E = Sh(e, e.state.doc, d.sel);
        if (E && !E.eq(e.state.selection)) {
          let D = e.state.tr.setSelection(E);
          r && D.setMeta("composition", r), e.dispatch(D);
        }
      }
      return;
    }
  e.state.selection.from < e.state.selection.to && p.start == p.endB && e.state.selection instanceof rt && (p.start > e.state.selection.from && p.start <= e.state.selection.from + 2 && e.state.selection.from >= d.from ? p.start = e.state.selection.from : p.endA < e.state.selection.to && p.endA >= e.state.selection.to - 2 && e.state.selection.to <= d.to && (p.endB += e.state.selection.to - p.endA, p.endA = e.state.selection.to)), vn && Fa <= 11 && p.endB == p.start + 1 && p.endA == p.start && p.start > d.from && d.doc.textBetween(p.start - d.from - 1, p.start - d.from + 1) == "  " && (p.start--, p.endA--, p.endB--);
  let x = d.doc.resolveNoCache(p.start - d.from), y = d.doc.resolveNoCache(p.endB - d.from), k = u.resolve(p.start), $ = x.sameParent(y) && x.parent.inlineContent && k.end() >= p.endA;
  if ((Xl && e.input.lastIOSEnter > Date.now() - 225 && (!$ || l.some((E) => E.nodeName == "DIV" || E.nodeName == "P")) || !$ && x.pos < d.doc.content.size && (!x.sameParent(y) || !x.parent.inlineContent) && x.pos < y.pos && !/\S/.test(d.doc.textBetween(x.pos, y.pos, "", ""))) && e.someProp("handleKeyDown", (E) => E(e, al(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (e.state.selection.anchor > p.start && lT(u, p.start, p.endA, x, y) && e.someProp("handleKeyDown", (E) => E(e, al(8, "Backspace")))) {
    ma && _t && e.domObserver.suppressSelectionUpdates();
    return;
  }
  _t && p.endB == p.start && (e.input.lastChromeDelete = Date.now()), ma && !$ && x.start() != y.start() && y.parentOffset == 0 && x.depth == y.depth && d.sel && d.sel.anchor == d.sel.head && d.sel.head == p.endA && (p.endB -= 2, y = d.doc.resolveNoCache(p.endB - d.from), setTimeout(() => {
    e.someProp("handleKeyDown", function(E) {
      return E(e, al(13, "Enter"));
    });
  }, 20));
  let S = p.start, T = p.endA, I = (E) => {
    let D = E || e.state.tr.replace(S, T, d.doc.slice(p.start - d.from, p.endB - d.from));
    if (d.sel) {
      let z = Sh(e, D.doc, d.sel);
      z && !(_t && e.composing && z.empty && (p.start != p.endB || e.input.lastChromeDelete < Date.now() - 100) && (z.head == S || z.head == D.mapping.map(T) - 1) || vn && z.empty && z.head == S) && D.setSelection(z);
    }
    return r && D.setMeta("composition", r), D.scrollIntoView();
  }, A;
  if ($)
    if (x.pos == y.pos) {
      vn && Fa <= 11 && x.parentOffset == 0 && (e.domObserver.suppressSelectionUpdates(), setTimeout(() => va(e), 20));
      let E = I(e.state.tr.delete(S, T)), D = u.resolve(p.start).marksAcross(u.resolve(p.endA));
      D && E.ensureMarks(D), e.dispatch(E);
    } else if (
      // Adding or removing a mark
      p.endA == p.endB && (A = aT(x.parent.content.cut(x.parentOffset, y.parentOffset), k.parent.content.cut(k.parentOffset, p.endA - k.start())))
    ) {
      let E = I(e.state.tr);
      A.type == "add" ? E.addMark(S, T, A.mark) : E.removeMark(S, T, A.mark), e.dispatch(E);
    } else if (x.parent.child(x.index()).isText && x.index() == y.index() - (y.textOffset ? 0 : 1)) {
      let E = x.parent.textBetween(x.parentOffset, y.parentOffset), D = () => I(e.state.tr.insertText(E, S, T));
      e.someProp("handleTextInput", (z) => z(e, S, T, E, D)) || e.dispatch(D());
    } else
      e.dispatch(I());
  else
    e.dispatch(I());
}
function Sh(e, n, t) {
  return Math.max(t.anchor, t.head) > n.content.size ? null : fc(e, n.resolve(t.anchor), n.resolve(t.head));
}
function aT(e, n) {
  let t = e.firstChild.marks, a = n.firstChild.marks, l = t, r = a, o, i, s;
  for (let u = 0; u < a.length; u++)
    l = a[u].removeFromSet(l);
  for (let u = 0; u < t.length; u++)
    r = t[u].removeFromSet(r);
  if (l.length == 1 && r.length == 0)
    i = l[0], o = "add", s = (u) => u.mark(i.addToSet(u.marks));
  else if (l.length == 0 && r.length == 1)
    i = r[0], o = "remove", s = (u) => u.mark(i.removeFromSet(u.marks));
  else
    return null;
  let d = [];
  for (let u = 0; u < n.childCount; u++)
    d.push(s(n.child(u)));
  if (Ve.from(d).eq(e))
    return { mark: i, type: o };
}
function lT(e, n, t, a, l) {
  if (
    // The content must have shrunk
    t - n <= l.pos - a.pos || // newEnd must point directly at or after the end of the block that newStart points into
    Js(a, !0, !1) < l.pos
  )
    return !1;
  let r = e.resolve(n);
  if (!a.parent.isTextblock) {
    let i = r.nodeAfter;
    return i != null && t == n + i.nodeSize;
  }
  if (r.parentOffset < r.parent.content.size || !r.parent.isTextblock)
    return !1;
  let o = e.resolve(Js(r, !0, !0));
  return !o.parent.isTextblock || o.pos > t || Js(o, !0, !1) < t ? !1 : a.parent.content.cut(a.parentOffset).eq(o.parent.content);
}
function Js(e, n, t) {
  let a = e.depth, l = n ? e.end() : e.pos;
  for (; a > 0 && (n || e.indexAfter(a) == e.node(a).childCount); )
    a--, l++, n = !1;
  if (t) {
    let r = e.node(a).maybeChild(e.indexAfter(a));
    for (; r && !r.isLeaf; )
      r = r.firstChild, l++;
  }
  return l;
}
function rT(e, n, t, a, l) {
  let r = e.findDiffStart(n, t);
  if (r == null)
    return null;
  let { a: o, b: i } = e.findDiffEnd(n, t + e.size, t + n.size);
  if (l == "end") {
    let s = Math.max(0, r - Math.min(o, i));
    a -= o + s - r;
  }
  if (o < r && e.size < n.size) {
    let s = a <= r && a >= o ? r - a : 0;
    r -= s, r && r < n.size && $h(n.textBetween(r - 1, r + 1)) && (r += s ? 1 : -1), i = r + (i - o), o = r;
  } else if (i < r) {
    let s = a <= r && a >= i ? r - a : 0;
    r -= s, r && r < e.size && $h(e.textBetween(r - 1, r + 1)) && (r += s ? 1 : -1), o = r + (o - i), i = r;
  }
  return { start: r, endA: o, endB: i };
}
function $h(e) {
  if (e.length != 2)
    return !1;
  let n = e.charCodeAt(0), t = e.charCodeAt(1);
  return n >= 56320 && n <= 57343 && t >= 55296 && t <= 56319;
}
class yp {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(n, t) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new kL(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = t, this.state = t.state, this.directPlugins = t.plugins || [], this.directPlugins.forEach(Eh), this.dispatch = this.dispatch.bind(this), this.dom = n && n.mount || document.createElement("div"), n && (n.appendChild ? n.appendChild(this.dom) : typeof n == "function" ? n(this.dom) : n.mount && (this.mounted = !0)), this.editable = Th(this), Lh(this), this.nodeViews = Ah(this), this.docView = oh(this.state.doc, Ih(this), Ys(this), this.dom, this), this.domObserver = new YL(this, (a, l, r, o) => nT(this, a, l, r, o)), this.domObserver.start(), wL(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let n = this._props;
      this._props = {};
      for (let t in n)
        this._props[t] = n[t];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(n) {
    n.handleDOMEvents != this._props.handleDOMEvents && eu(this);
    let t = this._props;
    this._props = n, n.plugins && (n.plugins.forEach(Eh), this.directPlugins = n.plugins), this.updateStateInner(n.state, t);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(n) {
    let t = {};
    for (let a in this._props)
      t[a] = this._props[a];
    t.state = this.state;
    for (let a in n)
      t[a] = n[a];
    this.update(t);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(n) {
    this.updateStateInner(n, this._props);
  }
  updateStateInner(n, t) {
    var a;
    let l = this.state, r = !1, o = !1;
    n.storedMarks && this.composing && (hp(this), o = !0), this.state = n;
    let i = l.plugins != n.plugins || this._props.plugins != t.plugins;
    if (i || this._props.plugins != t.plugins || this._props.nodeViews != t.nodeViews) {
      let h = Ah(this);
      iT(h, this.nodeViews) && (this.nodeViews = h, r = !0);
    }
    (i || t.handleDOMEvents != this._props.handleDOMEvents) && eu(this), this.editable = Th(this), Lh(this);
    let s = Ys(this), d = Ih(this), u = l.plugins != n.plugins && !l.doc.eq(n.doc) ? "reset" : n.scrollToSelection > l.scrollToSelection ? "to selection" : "preserve", f = r || !this.docView.matchesNode(n.doc, d, s);
    (f || !n.selection.eq(l.selection)) && (o = !0);
    let b = u == "preserve" && o && this.dom.style.overflowAnchor == null && OI(this);
    if (o) {
      this.domObserver.stop();
      let h = f && (vn || _t) && !this.composing && !l.selection.empty && !n.selection.empty && oT(l.selection, n.selection);
      if (f) {
        let p = _t ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = OL(this)), (r || !this.docView.update(n.doc, d, s, this)) && (this.docView.updateOuterDeco(d), this.docView.destroy(), this.docView = oh(n.doc, d, s, this.dom, this)), p && (!this.trackWrites || !this.dom.contains(this.trackWrites)) && (h = !0);
      }
      h || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && oL(this)) ? va(this, h) : (tp(this, n.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(l), !((a = this.dragging) === null || a === void 0) && a.node && !l.doc.eq(n.doc) && this.updateDraggedNode(this.dragging, l), u == "reset" ? this.dom.scrollTop = 0 : u == "to selection" ? this.scrollToSelection() : b && PI(b);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let n = this.domSelectionRange().focusNode;
    if (!(!n || !this.dom.contains(n.nodeType == 1 ? n : n.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (t) => t(this))) if (this.state.selection instanceof tt) {
        let t = this.docView.domAfterPos(this.state.selection.from);
        t.nodeType == 1 && eh(this, t.getBoundingClientRect(), n);
      } else
        eh(this, this.coordsAtPos(this.state.selection.head, 1), n);
    }
  }
  destroyPluginViews() {
    let n;
    for (; n = this.pluginViews.pop(); )
      n.destroy && n.destroy();
  }
  updatePluginViews(n) {
    if (!n || n.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let t = 0; t < this.directPlugins.length; t++) {
        let a = this.directPlugins[t];
        a.spec.view && this.pluginViews.push(a.spec.view(this));
      }
      for (let t = 0; t < this.state.plugins.length; t++) {
        let a = this.state.plugins[t];
        a.spec.view && this.pluginViews.push(a.spec.view(this));
      }
    } else
      for (let t = 0; t < this.pluginViews.length; t++) {
        let a = this.pluginViews[t];
        a.update && a.update(this, n);
      }
  }
  updateDraggedNode(n, t) {
    let a = n.node, l = -1;
    if (a.from < this.state.doc.content.size && this.state.doc.nodeAt(a.from) == a.node)
      l = a.from;
    else {
      let r = a.from + (this.state.doc.content.size - t.doc.content.size);
      (r > 0 && r < this.state.doc.content.size && this.state.doc.nodeAt(r)) == a.node && (l = r);
    }
    this.dragging = new gp(n.slice, n.move, l < 0 ? void 0 : tt.create(this.state.doc, l));
  }
  someProp(n, t) {
    let a = this._props && this._props[n], l;
    if (a != null && (l = t ? t(a) : a))
      return l;
    for (let o = 0; o < this.directPlugins.length; o++) {
      let i = this.directPlugins[o].props[n];
      if (i != null && (l = t ? t(i) : i))
        return l;
    }
    let r = this.state.plugins;
    if (r)
      for (let o = 0; o < r.length; o++) {
        let i = r[o].props[n];
        if (i != null && (l = t ? t(i) : i))
          return l;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (vn) {
      let n = this.root.activeElement;
      if (n == this.dom)
        return !0;
      if (!n || !this.dom.contains(n))
        return !1;
      for (; n && this.dom != n && this.dom.contains(n); ) {
        if (n.contentEditable == "false")
          return !1;
        n = n.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && FI(this.dom), va(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let n = this._root;
    if (n == null) {
      for (let t = this.dom.parentNode; t; t = t.parentNode)
        if (t.nodeType == 9 || t.nodeType == 11 && t.host)
          return t.getSelection || (Object.getPrototypeOf(t).getSelection = () => t.ownerDocument.getSelection()), this._root = t;
    }
    return n || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(n) {
    return WI(this, n);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(n, t = 1) {
    return Km(this, n, t);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(n, t = 0) {
    return this.docView.domFromPos(n, t);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(n) {
    let t = this.docView.descAt(n);
    return t ? t.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(n, t, a = -1) {
    let l = this.docView.posFromDOM(n, t, a);
    if (l == null)
      throw new RangeError("DOM position not inside the editor");
    return l;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(n, t) {
    return YI(this, t || this.state, n);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(n, t) {
    return eo(this, "", n, !1, t || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(n, t) {
    return eo(this, n, null, !0, t || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(n) {
    return hc(this, n);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (CL(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], Ys(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, II());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(n) {
    return $L(this, n);
  }
  /**
  @internal
  */
  domSelectionRange() {
    let n = this.domSelection();
    return n ? rn && this.root.nodeType === 11 && RI(this.dom.ownerDocument) == this.dom && XL(this, n) || n : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
yp.prototype.dispatch = function(e) {
  let n = this._props.dispatchTransaction;
  n ? n.call(this, e) : this.updateState(this.state.apply(e));
};
function Ih(e) {
  let n = /* @__PURE__ */ Object.create(null);
  return n.class = "ProseMirror", n.contenteditable = String(e.editable), e.someProp("attributes", (t) => {
    if (typeof t == "function" && (t = t(e.state)), t)
      for (let a in t)
        a == "class" ? n.class += " " + t[a] : a == "style" ? n.style = (n.style ? n.style + ";" : "") + t[a] : !n[a] && a != "contenteditable" && a != "nodeName" && (n[a] = String(t[a]));
  }), n.translate || (n.translate = "no"), [un.node(0, e.state.doc.content.size, n)];
}
function Lh(e) {
  if (e.markCursor) {
    let n = document.createElement("img");
    n.className = "ProseMirror-separator", n.setAttribute("mark-placeholder", "true"), n.setAttribute("alt", ""), e.cursorWrapper = { dom: n, deco: un.widget(e.state.selection.from, n, { raw: !0, marks: e.markCursor }) };
  } else
    e.cursorWrapper = null;
}
function Th(e) {
  return !e.someProp("editable", (n) => n(e.state) === !1);
}
function oT(e, n) {
  let t = Math.min(e.$anchor.sharedDepth(e.head), n.$anchor.sharedDepth(n.head));
  return e.$anchor.start(t) != n.$anchor.start(t);
}
function Ah(e) {
  let n = /* @__PURE__ */ Object.create(null);
  function t(a) {
    for (let l in a)
      Object.prototype.hasOwnProperty.call(n, l) || (n[l] = a[l]);
  }
  return e.someProp("nodeViews", t), e.someProp("markViews", t), n;
}
function iT(e, n) {
  let t = 0, a = 0;
  for (let l in e) {
    if (e[l] != n[l])
      return !0;
    t++;
  }
  for (let l in n)
    a++;
  return t != a;
}
function Eh(e) {
  if (e.spec.state || e.spec.filterTransaction || e.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var qa = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, ki = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, sT = typeof navigator < "u" && /Mac/.test(navigator.platform), dT = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var Qt = 0; Qt < 10; Qt++) qa[48 + Qt] = qa[96 + Qt] = String(Qt);
for (var Qt = 1; Qt <= 24; Qt++) qa[Qt + 111] = "F" + Qt;
for (var Qt = 65; Qt <= 90; Qt++)
  qa[Qt] = String.fromCharCode(Qt + 32), ki[Qt] = String.fromCharCode(Qt);
for (var Xs in qa) ki.hasOwnProperty(Xs) || (ki[Xs] = qa[Xs]);
function uT(e) {
  var n = sT && e.metaKey && e.shiftKey && !e.ctrlKey && !e.altKey || dT && e.shiftKey && e.key && e.key.length == 1 || e.key == "Unidentified", t = !n && e.key || (e.shiftKey ? ki : qa)[e.keyCode] || e.key || "Unidentified";
  return t == "Esc" && (t = "Escape"), t == "Del" && (t = "Delete"), t == "Left" && (t = "ArrowLeft"), t == "Up" && (t = "ArrowUp"), t == "Right" && (t = "ArrowRight"), t == "Down" && (t = "ArrowDown"), t;
}
const cT = typeof navigator < "u" && /Mac|iP(hone|[oa]d)/.test(navigator.platform), fT = typeof navigator < "u" && /Win/.test(navigator.platform);
function hT(e) {
  let n = e.split(/-(?!$)/), t = n[n.length - 1];
  t == "Space" && (t = " ");
  let a, l, r, o;
  for (let i = 0; i < n.length - 1; i++) {
    let s = n[i];
    if (/^(cmd|meta|m)$/i.test(s))
      o = !0;
    else if (/^a(lt)?$/i.test(s))
      a = !0;
    else if (/^(c|ctrl|control)$/i.test(s))
      l = !0;
    else if (/^s(hift)?$/i.test(s))
      r = !0;
    else if (/^mod$/i.test(s))
      cT ? o = !0 : l = !0;
    else
      throw new Error("Unrecognized modifier name: " + s);
  }
  return a && (t = "Alt-" + t), l && (t = "Ctrl-" + t), o && (t = "Meta-" + t), r && (t = "Shift-" + t), t;
}
function bT(e) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let t in e)
    n[hT(t)] = e[t];
  return n;
}
function Zs(e, n, t = !0) {
  return n.altKey && (e = "Alt-" + e), n.ctrlKey && (e = "Ctrl-" + e), n.metaKey && (e = "Meta-" + e), t && n.shiftKey && (e = "Shift-" + e), e;
}
function gT(e) {
  return new Bt({ props: { handleKeyDown: kp(e) } });
}
function kp(e) {
  let n = bT(e);
  return function(t, a) {
    let l = uT(a), r, o = n[Zs(l, a)];
    if (o && o(t.state, t.dispatch, t))
      return !0;
    if (l.length == 1 && l != " ") {
      if (a.shiftKey) {
        let i = n[Zs(l, a, !1)];
        if (i && i(t.state, t.dispatch, t))
          return !0;
      }
      if ((a.altKey || a.metaKey || a.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
      !(fT && a.ctrlKey && a.altKey) && (r = qa[a.keyCode]) && r != l) {
        let i = n[Zs(r, a)];
        if (i && i(t.state, t.dispatch, t))
          return !0;
      }
    }
    return !1;
  };
}
var mT = Object.defineProperty, xc = (e, n) => {
  for (var t in n)
    mT(e, t, { get: n[t], enumerable: !0 });
};
function gs(e) {
  const { state: n, transaction: t } = e;
  let { selection: a } = t, { doc: l } = t, { storedMarks: r } = t;
  return {
    ...n,
    apply: n.apply.bind(n),
    applyTransaction: n.applyTransaction.bind(n),
    plugins: n.plugins,
    schema: n.schema,
    reconfigure: n.reconfigure.bind(n),
    toJSON: n.toJSON.bind(n),
    get storedMarks() {
      return r;
    },
    get selection() {
      return a;
    },
    get doc() {
      return l;
    },
    get tr() {
      return a = t.selection, l = t.doc, r = t.storedMarks, t;
    }
  };
}
var ms = class {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: n, state: t } = this, { view: a } = n, { tr: l } = t, r = this.buildProps(l);
    return Object.fromEntries(
      Object.entries(e).map(([o, i]) => [o, (...d) => {
        const u = i(...d)(r);
        return !l.getMeta("preventDispatch") && !this.hasCustomState && a.dispatch(l), u;
      }])
    );
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, n = !0) {
    const { rawCommands: t, editor: a, state: l } = this, { view: r } = a, o = [], i = !!e, s = e || l.tr, d = () => (!i && n && !s.getMeta("preventDispatch") && !this.hasCustomState && r.dispatch(s), o.every((f) => f === !0)), u = {
      ...Object.fromEntries(
        Object.entries(t).map(([f, b]) => [f, (...p) => {
          const x = this.buildProps(s, n), y = b(...p)(x);
          return o.push(y), u;
        }])
      ),
      run: d
    };
    return u;
  }
  createCan(e) {
    const { rawCommands: n, state: t } = this, a = !1, l = e || t.tr, r = this.buildProps(l, a);
    return {
      ...Object.fromEntries(
        Object.entries(n).map(([i, s]) => [i, (...d) => s(...d)({ ...r, dispatch: void 0 })])
      ),
      chain: () => this.createChain(l, a)
    };
  }
  buildProps(e, n = !0) {
    const { rawCommands: t, editor: a, state: l } = this, { view: r } = a, o = {
      tr: e,
      editor: a,
      view: r,
      state: gs({
        state: l,
        transaction: e
      }),
      dispatch: n ? () => {
      } : void 0,
      chain: () => this.createChain(e, n),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(
          Object.entries(t).map(([i, s]) => [i, (...d) => s(...d)(o)])
        );
      }
    };
    return o;
  }
}, wp = {};
xc(wp, {
  blur: () => pT,
  clearContent: () => vT,
  clearNodes: () => xT,
  command: () => yT,
  createParagraphNear: () => kT,
  cut: () => wT,
  deleteCurrentNode: () => CT,
  deleteNode: () => ST,
  deleteRange: () => $T,
  deleteSelection: () => TT,
  enter: () => AT,
  exitCode: () => ET,
  extendMarkRange: () => RT,
  first: () => BT,
  focus: () => DT,
  forEach: () => zT,
  insertContent: () => OT,
  insertContentAt: () => VT,
  joinBackward: () => jT,
  joinDown: () => HT,
  joinForward: () => WT,
  joinItemBackward: () => qT,
  joinItemForward: () => UT,
  joinTextblockBackward: () => GT,
  joinTextblockForward: () => KT,
  joinUp: () => NT,
  keyboardShortcut: () => JT,
  lift: () => XT,
  liftEmptyBlock: () => ZT,
  liftListItem: () => QT,
  newlineInCode: () => _T,
  resetAttributes: () => eA,
  scrollIntoView: () => tA,
  selectAll: () => nA,
  selectNodeBackward: () => aA,
  selectNodeForward: () => lA,
  selectParentNode: () => rA,
  selectTextblockEnd: () => oA,
  selectTextblockStart: () => iA,
  setContent: () => sA,
  setMark: () => AA,
  setMeta: () => EA,
  setNode: () => RA,
  setNodeSelection: () => BA,
  setTextDirection: () => MA,
  setTextSelection: () => DA,
  sinkListItem: () => zA,
  splitBlock: () => OA,
  splitListItem: () => PA,
  toggleList: () => VA,
  toggleMark: () => NA,
  toggleNode: () => HA,
  toggleWrap: () => jA,
  undoInputRule: () => WA,
  unsetAllMarks: () => qA,
  unsetMark: () => UA,
  unsetTextDirection: () => GA,
  updateAttributes: () => KA,
  wrapIn: () => YA,
  wrapInList: () => JA
});
var pT = () => ({ editor: e, view: n }) => (requestAnimationFrame(() => {
  var t;
  e.isDestroyed || (n.dom.blur(), (t = window == null ? void 0 : window.getSelection()) == null || t.removeAllRanges());
}), !0), vT = (e = !0) => ({ commands: n }) => n.setContent("", { emitUpdate: e }), xT = () => ({ state: e, tr: n, dispatch: t }) => {
  const { selection: a } = n, { ranges: l } = a;
  return t && l.forEach(({ $from: r, $to: o }) => {
    e.doc.nodesBetween(r.pos, o.pos, (i, s) => {
      if (i.type.isText)
        return;
      const { doc: d, mapping: u } = n, f = d.resolve(u.map(s)), b = d.resolve(u.map(s + i.nodeSize)), h = f.blockRange(b);
      if (!h)
        return;
      const p = lr(h);
      if (i.type.isTextblock) {
        const { defaultType: x } = f.parent.contentMatchAt(f.index());
        n.setNodeMarkup(h.start, x);
      }
      (p || p === 0) && n.lift(h, p);
    });
  }), !0;
}, yT = (e) => (n) => e(n), kT = () => ({ state: e, dispatch: n }) => Om(e, n), wT = (e, n) => ({ editor: t, tr: a }) => {
  const { state: l } = t, r = l.doc.slice(e.from, e.to);
  a.deleteRange(e.from, e.to);
  const o = a.mapping.map(n);
  return a.insert(o, r.content), a.setSelection(new rt(a.doc.resolve(Math.max(o - 1, 0)))), !0;
}, CT = () => ({ tr: e, dispatch: n }) => {
  const { selection: t } = e, a = t.$anchor.node();
  if (a.content.size > 0)
    return !1;
  const l = e.selection.$anchor;
  for (let r = l.depth; r > 0; r -= 1)
    if (l.node(r).type === a.type) {
      if (n) {
        const i = l.before(r), s = l.after(r);
        e.delete(i, s).scrollIntoView();
      }
      return !0;
    }
  return !1;
};
function Ht(e, n) {
  if (typeof e == "string") {
    if (!n.nodes[e])
      throw Error(`There is no node type named '${e}'. Maybe you forgot to add the extension?`);
    return n.nodes[e];
  }
  return e;
}
var ST = (e) => ({ tr: n, state: t, dispatch: a }) => {
  const l = Ht(e, t.schema), r = n.selection.$anchor;
  for (let o = r.depth; o > 0; o -= 1)
    if (r.node(o).type === l) {
      if (a) {
        const s = r.before(o), d = r.after(o);
        n.delete(s, d).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, $T = (e) => ({ tr: n, dispatch: t }) => {
  const { from: a, to: l } = e;
  return t && n.delete(a, l), !0;
}, IT = (e) => e.content ? /^text(\*|\+)/.test(e.content) : !1, Rh = (e, n, t) => {
  if (!e.parent.isInline || t === "left" && e.pos > e.start() || t === "right" && e.pos < e.end())
    return e.pos;
  const a = n.nodes[e.parent.type.name].spec;
  return IT(a) ? t === "left" ? e.start() - 1 : e.end() + 1 : e.pos;
}, LT = (e, n, t) => {
  const a = Rh(e, t, "left"), l = Rh(n, t, "right");
  return { from: a, to: l };
}, TT = () => ({ state: e, dispatch: n }) => {
  const { $from: t, $to: a } = e.selection;
  if (e.selection.empty)
    return !1;
  const { from: l, to: r } = LT(t, a, e.schema);
  return n && (e.tr.deleteRange(l, r).scrollIntoView(), n(e.tr)), !0;
}, AT = () => ({ commands: e }) => e.keyboardShortcut("Enter"), ET = () => ({ state: e, dispatch: n }) => cI(e, n);
function yc(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}
function wi(e, n, t = { strict: !0 }) {
  const a = Object.keys(n);
  return a.length ? a.every((l) => t.strict ? n[l] === e[l] : yc(n[l]) ? n[l].test(e[l]) : n[l] === e[l]) : !0;
}
function Cp(e, n, t = {}) {
  return e.find((a) => a.type === n && wi(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(t).map((l) => [l, a.attrs[l]])),
    t
  ));
}
function Bh(e, n, t = {}) {
  return !!Cp(e, n, t);
}
function kc(e, n, t) {
  if (!e || !n)
    return;
  let a = e.parent.childAfter(e.parentOffset);
  if ((!a.node || !a.node.marks.some((d) => d.type === n)) && (a = e.parent.childBefore(e.parentOffset)), !a.node || !a.node.marks.some((d) => d.type === n))
    return;
  if (!t) {
    const d = a.node.marks.find((u) => u.type === n);
    d && (t = d.attrs);
  }
  if (!Cp([...a.node.marks], n, t))
    return;
  let r = a.index, o = e.start() + a.offset, i = r + 1, s = o + a.node.nodeSize;
  for (; r > 0 && Bh([...e.parent.child(r - 1).marks], n, t); )
    r -= 1, o -= e.parent.child(r).nodeSize;
  for (; i < e.parent.childCount && Bh([...e.parent.child(i).marks], n, t); )
    s += e.parent.child(i).nodeSize, i += 1;
  return {
    from: o,
    to: s
  };
}
function wa(e, n) {
  if (typeof e == "string") {
    if (!n.marks[e])
      throw Error(`There is no mark type named '${e}'. Maybe you forgot to add the extension?`);
    return n.marks[e];
  }
  return e;
}
var RT = (e, n) => ({ tr: t, state: a, dispatch: l }) => {
  const r = wa(e, a.schema), { doc: o, selection: i } = t, { $from: s, from: d, to: u } = i;
  if (l) {
    const f = kc(s, r, n);
    if (f && f.from <= d && f.to >= u) {
      const b = rt.create(o, f.from, f.to);
      t.setSelection(b);
    }
  }
  return !0;
}, BT = (e) => (n) => {
  const t = typeof e == "function" ? e(n) : e;
  for (let a = 0; a < t.length; a += 1)
    if (t[a](n))
      return !0;
  return !1;
};
function Sp(e) {
  return e instanceof rt;
}
function il(e = 0, n = 0, t = 0) {
  return Math.min(Math.max(e, n), t);
}
function $p(e, n = null) {
  if (!n)
    return null;
  const t = st.atStart(e), a = st.atEnd(e);
  if (n === "start" || n === !0)
    return t;
  if (n === "end")
    return a;
  const l = t.from, r = a.to;
  return n === "all" ? rt.create(e, il(0, l, r), il(e.content.size, l, r)) : rt.create(e, il(n, l, r), il(n, l, r));
}
function Mh() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function Ci() {
  return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || // iPad on iOS 13 detection
  navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
function MT() {
  return typeof navigator < "u" ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : !1;
}
var DT = (e = null, n = {}) => ({ editor: t, view: a, tr: l, dispatch: r }) => {
  n = {
    scrollIntoView: !0,
    ...n
  };
  const o = () => {
    (Ci() || Mh()) && a.dom.focus(), MT() && !Ci() && !Mh() && a.dom.focus({ preventScroll: !0 }), requestAnimationFrame(() => {
      t.isDestroyed || (a.focus(), n != null && n.scrollIntoView && t.commands.scrollIntoView());
    });
  };
  try {
    if (a.hasFocus() && e === null || e === !1)
      return !0;
  } catch {
    return !1;
  }
  if (r && e === null && !Sp(t.state.selection))
    return o(), !0;
  const i = $p(l.doc, e) || t.state.selection, s = t.state.selection.eq(i);
  return r && (s || l.setSelection(i), s && l.storedMarks && l.setStoredMarks(l.storedMarks), o()), !0;
}, zT = (e, n) => (t) => e.every((a, l) => n(a, { ...t, index: l })), OT = (e, n) => ({ tr: t, commands: a }) => a.insertContentAt({ from: t.selection.from, to: t.selection.to }, e, n), Ip = (e) => {
  const n = e.childNodes;
  for (let t = n.length - 1; t >= 0; t -= 1) {
    const a = n[t];
    a.nodeType === 3 && a.nodeValue && /^(\n\s\s|\n)$/.test(a.nodeValue) ? e.removeChild(a) : a.nodeType === 1 && Ip(a);
  }
  return e;
};
function Eo(e) {
  if (typeof window > "u")
    throw new Error("[tiptap error]: there is no window object available, so this function cannot be used");
  const n = `<body>${e}</body>`, t = new window.DOMParser().parseFromString(n, "text/html").body;
  return Ip(t);
}
function no(e, n, t) {
  if (e instanceof Oa || e instanceof Ve)
    return e;
  t = {
    slice: !0,
    parseOptions: {},
    ...t
  };
  const a = typeof e == "object" && e !== null, l = typeof e == "string";
  if (a)
    try {
      if (Array.isArray(e) && e.length > 0)
        return Ve.fromArray(e.map((i) => n.nodeFromJSON(i)));
      const o = n.nodeFromJSON(e);
      return t.errorOnInvalidContent && o.check(), o;
    } catch (r) {
      if (t.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: r });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", e, "Error:", r), no("", n, t);
    }
  if (l) {
    if (t.errorOnInvalidContent) {
      let o = !1, i = "";
      const s = new sm({
        topNode: n.spec.topNode,
        marks: n.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: n.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (d) => (o = !0, i = typeof d == "string" ? d : d.outerHTML, null)
              }
            ]
          }
        })
      });
      if (t.slice ? Pa.fromSchema(s).parseSlice(Eo(e), t.parseOptions) : Pa.fromSchema(s).parse(Eo(e), t.parseOptions), t.errorOnInvalidContent && o)
        throw new Error("[tiptap error]: Invalid HTML content", {
          cause: new Error(`Invalid element found: ${i}`)
        });
    }
    const r = Pa.fromSchema(n);
    return t.slice ? r.parseSlice(Eo(e), t.parseOptions).content : r.parse(Eo(e), t.parseOptions);
  }
  return no("", n, t);
}
function PT(e, n, t) {
  const a = e.steps.length - 1;
  if (a < n)
    return;
  const l = e.steps[a];
  if (!(l instanceof Ft || l instanceof Yt))
    return;
  const r = e.mapping.maps[a];
  let o = 0;
  r.forEach((i, s, d, u) => {
    o === 0 && (o = u);
  }), e.setSelection(st.near(e.doc.resolve(o), t));
}
var FT = (e) => !("type" in e), VT = (e, n, t) => ({ tr: a, dispatch: l, editor: r }) => {
  var o;
  if (l) {
    t = {
      parseOptions: r.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...t
    };
    let i;
    const s = (y) => {
      r.emit("contentError", {
        editor: r,
        error: y,
        disableCollaboration: () => {
          "collaboration" in r.storage && typeof r.storage.collaboration == "object" && r.storage.collaboration && (r.storage.collaboration.isDisabled = !0);
        }
      });
    }, d = {
      preserveWhitespace: "full",
      ...t.parseOptions
    };
    if (!t.errorOnInvalidContent && !r.options.enableContentCheck && r.options.emitContentError)
      try {
        no(n, r.schema, {
          parseOptions: d,
          errorOnInvalidContent: !0
        });
      } catch (y) {
        s(y);
      }
    try {
      i = no(n, r.schema, {
        parseOptions: d,
        errorOnInvalidContent: (o = t.errorOnInvalidContent) != null ? o : r.options.enableContentCheck
      });
    } catch (y) {
      return s(y), !1;
    }
    let { from: u, to: f } = typeof e == "number" ? { from: e, to: e } : { from: e.from, to: e.to }, b = !0, h = !0;
    if ((FT(i) ? i : [i]).forEach((y) => {
      y.check(), b = b ? y.isText && y.marks.length === 0 : !1, h = h ? y.isBlock : !1;
    }), u === f && h) {
      const { parent: y } = a.doc.resolve(u);
      y.isTextblock && !y.type.spec.code && !y.childCount && (u -= 1, f += 1);
    }
    let x;
    if (b) {
      if (Array.isArray(n))
        x = n.map((y) => y.text || "").join("");
      else if (n instanceof Ve) {
        let y = "";
        n.forEach((k) => {
          k.text && (y += k.text);
        }), x = y;
      } else typeof n == "object" && n && n.text ? x = n.text : x = n;
      a.insertText(x, u, f);
    } else {
      x = i;
      const y = a.doc.resolve(u), k = y.node(), $ = y.parentOffset === 0, S = k.isText || k.isTextblock, T = k.content.size > 0;
      $ && S && T && h && (u = Math.max(0, u - 1)), a.replaceWith(u, f, x);
    }
    t.updateSelection && PT(a, a.steps.length - 1, -1), t.applyInputRules && a.setMeta("applyInputRules", { from: u, text: x }), t.applyPasteRules && a.setMeta("applyPasteRules", { from: u, text: x });
  }
  return !0;
}, NT = () => ({ state: e, dispatch: n }) => sI(e, n), HT = () => ({ state: e, dispatch: n }) => dI(e, n), jT = () => ({ state: e, dispatch: n }) => Am(e, n), WT = () => ({ state: e, dispatch: n }) => Mm(e, n), qT = () => ({ state: e, dispatch: n, tr: t }) => {
  try {
    const a = ds(e.doc, e.selection.$from.pos, -1);
    return a == null ? !1 : (t.join(a, 2), n && n(t), !0);
  } catch {
    return !1;
  }
}, UT = () => ({ state: e, dispatch: n, tr: t }) => {
  try {
    const a = ds(e.doc, e.selection.$from.pos, 1);
    return a == null ? !1 : (t.join(a, 2), n && n(t), !0);
  } catch {
    return !1;
  }
}, GT = () => ({ state: e, dispatch: n }) => oI(e, n), KT = () => ({ state: e, dispatch: n }) => iI(e, n);
function Lp() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function YT(e) {
  const n = e.split(/-(?!$)/);
  let t = n[n.length - 1];
  t === "Space" && (t = " ");
  let a, l, r, o;
  for (let i = 0; i < n.length - 1; i += 1) {
    const s = n[i];
    if (/^(cmd|meta|m)$/i.test(s))
      o = !0;
    else if (/^a(lt)?$/i.test(s))
      a = !0;
    else if (/^(c|ctrl|control)$/i.test(s))
      l = !0;
    else if (/^s(hift)?$/i.test(s))
      r = !0;
    else if (/^mod$/i.test(s))
      Ci() || Lp() ? o = !0 : l = !0;
    else
      throw new Error(`Unrecognized modifier name: ${s}`);
  }
  return a && (t = `Alt-${t}`), l && (t = `Ctrl-${t}`), o && (t = `Meta-${t}`), r && (t = `Shift-${t}`), t;
}
var JT = (e) => ({ editor: n, view: t, tr: a, dispatch: l }) => {
  const r = YT(e).split(/-(?!$)/), o = r.find((d) => !["Alt", "Ctrl", "Meta", "Shift"].includes(d)), i = new KeyboardEvent("keydown", {
    key: o === "Space" ? " " : o,
    altKey: r.includes("Alt"),
    ctrlKey: r.includes("Ctrl"),
    metaKey: r.includes("Meta"),
    shiftKey: r.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), s = n.captureTransaction(() => {
    t.someProp("handleKeyDown", (d) => d(t, i));
  });
  return s == null || s.steps.forEach((d) => {
    const u = d.map(a.mapping);
    u && l && a.maybeStep(u);
  }), !0;
};
function Ua(e, n, t = {}) {
  const { from: a, to: l, empty: r } = e.selection, o = n ? Ht(n, e.schema) : null, i = [];
  e.doc.nodesBetween(a, l, (f, b) => {
    if (f.isText)
      return;
    const h = Math.max(a, b), p = Math.min(l, b + f.nodeSize);
    i.push({
      node: f,
      from: h,
      to: p
    });
  });
  const s = l - a, d = i.filter((f) => o ? o.name === f.node.type.name : !0).filter((f) => wi(f.node.attrs, t, { strict: !1 }));
  return r ? !!d.length : d.reduce((f, b) => f + b.to - b.from, 0) >= s;
}
var XT = (e, n = {}) => ({ state: t, dispatch: a }) => {
  const l = Ht(e, t.schema);
  return Ua(t, l, n) ? uI(t, a) : !1;
}, ZT = () => ({ state: e, dispatch: n }) => Pm(e, n), QT = (e) => ({ state: n, dispatch: t }) => {
  const a = Ht(e, n.schema);
  return wI(a)(n, t);
}, _T = () => ({ state: e, dispatch: n }) => zm(e, n);
function ps(e, n) {
  return n.nodes[e] ? "node" : n.marks[e] ? "mark" : null;
}
function Dh(e, n) {
  const t = typeof n == "string" ? [n] : n;
  return Object.keys(e).reduce((a, l) => (t.includes(l) || (a[l] = e[l]), a), {});
}
var eA = (e, n) => ({ tr: t, state: a, dispatch: l }) => {
  let r = null, o = null;
  const i = ps(
    typeof e == "string" ? e : e.name,
    a.schema
  );
  if (!i)
    return !1;
  i === "node" && (r = Ht(e, a.schema)), i === "mark" && (o = wa(e, a.schema));
  let s = !1;
  return t.selection.ranges.forEach((d) => {
    a.doc.nodesBetween(d.$from.pos, d.$to.pos, (u, f) => {
      r && r === u.type && (s = !0, l && t.setNodeMarkup(f, void 0, Dh(u.attrs, n))), o && u.marks.length && u.marks.forEach((b) => {
        o === b.type && (s = !0, l && t.addMark(f, f + u.nodeSize, o.create(Dh(b.attrs, n))));
      });
    });
  }), s;
}, tA = () => ({ tr: e, dispatch: n }) => (n && e.scrollIntoView(), !0), nA = () => ({ tr: e, dispatch: n }) => {
  if (n) {
    const t = new wn(e.doc);
    e.setSelection(t);
  }
  return !0;
}, aA = () => ({ state: e, dispatch: n }) => Rm(e, n), lA = () => ({ state: e, dispatch: n }) => Dm(e, n), rA = () => ({ state: e, dispatch: n }) => bI(e, n), oA = () => ({ state: e, dispatch: n }) => pI(e, n), iA = () => ({ state: e, dispatch: n }) => mI(e, n);
function tu(e, n, t = {}, a = {}) {
  return no(e, n, {
    slice: !1,
    parseOptions: t,
    errorOnInvalidContent: a.errorOnInvalidContent
  });
}
var sA = (e, { errorOnInvalidContent: n, emitUpdate: t = !0, parseOptions: a = {} } = {}) => ({ editor: l, tr: r, dispatch: o, commands: i }) => {
  const { doc: s } = r;
  if (a.preserveWhitespace !== "full") {
    const d = tu(e, l.schema, a, {
      errorOnInvalidContent: n ?? l.options.enableContentCheck
    });
    return o && r.replaceWith(0, s.content.size, d).setMeta("preventUpdate", !t), !0;
  }
  return o && r.setMeta("preventUpdate", !t), i.insertContentAt({ from: 0, to: s.content.size }, e, {
    parseOptions: a,
    errorOnInvalidContent: n ?? l.options.enableContentCheck
  });
};
function Tp(e, n) {
  const t = wa(n, e.schema), { from: a, to: l, empty: r } = e.selection, o = [];
  r ? (e.storedMarks && o.push(...e.storedMarks), o.push(...e.selection.$head.marks())) : e.doc.nodesBetween(a, l, (s) => {
    o.push(...s.marks);
  });
  const i = o.find((s) => s.type.name === t.name);
  return i ? { ...i.attrs } : {};
}
function Ap(e, n) {
  const t = new Sm(e);
  return n.forEach((a) => {
    a.steps.forEach((l) => {
      t.step(l);
    });
  }), t;
}
function dA(e) {
  for (let n = 0; n < e.edgeCount; n += 1) {
    const { type: t } = e.edge(n);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
function uA(e, n, t) {
  const a = [];
  return e.nodesBetween(n.from, n.to, (l, r) => {
    t(l) && a.push({
      node: l,
      pos: r
    });
  }), a;
}
function cA(e, n) {
  for (let t = e.depth; t > 0; t -= 1) {
    const a = e.node(t);
    if (n(a))
      return {
        pos: t > 0 ? e.before(t) : 0,
        start: e.start(t),
        depth: t,
        node: a
      };
  }
}
function vs(e) {
  return (n) => cA(n.$from, e);
}
function _e(e, n, t) {
  return e.config[n] === void 0 && e.parent ? _e(e.parent, n, t) : typeof e.config[n] == "function" ? e.config[n].bind({
    ...t,
    parent: e.parent ? _e(e.parent, n, t) : null
  }) : e.config[n];
}
function wc(e) {
  return e.map((n) => {
    const t = {
      name: n.name,
      options: n.options,
      storage: n.storage
    }, a = _e(n, "addExtensions", t);
    return a ? [n, ...wc(a())] : n;
  }).flat(10);
}
function Cc(e, n) {
  const t = Sl.fromSchema(n).serializeFragment(e), l = document.implementation.createHTMLDocument().createElement("div");
  return l.appendChild(t), l.innerHTML;
}
function Ep(e) {
  return typeof e == "function";
}
function xt(e, n = void 0, ...t) {
  return Ep(e) ? n ? e.bind(n)(...t) : e(...t) : e;
}
function fA(e = {}) {
  return Object.keys(e).length === 0 && e.constructor === Object;
}
function Zl(e) {
  const n = e.filter((l) => l.type === "extension"), t = e.filter((l) => l.type === "node"), a = e.filter((l) => l.type === "mark");
  return {
    baseExtensions: n,
    nodeExtensions: t,
    markExtensions: a
  };
}
function Rp(e) {
  const n = [], { nodeExtensions: t, markExtensions: a } = Zl(e), l = [...t, ...a], r = {
    default: null,
    validate: void 0,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  }, o = t.filter((d) => d.name !== "text").map((d) => d.name), i = a.map((d) => d.name), s = [...o, ...i];
  return e.forEach((d) => {
    const u = {
      name: d.name,
      options: d.options,
      storage: d.storage,
      extensions: l
    }, f = _e(
      d,
      "addGlobalAttributes",
      u
    );
    if (!f)
      return;
    f().forEach((h) => {
      let p;
      Array.isArray(h.types) ? p = h.types : h.types === "*" ? p = s : h.types === "nodes" ? p = o : h.types === "marks" ? p = i : p = [], p.forEach((x) => {
        Object.entries(h.attributes).forEach(([y, k]) => {
          n.push({
            type: x,
            name: y,
            attribute: {
              ...r,
              ...k
            }
          });
        });
      });
    });
  }), l.forEach((d) => {
    const u = {
      name: d.name,
      options: d.options,
      storage: d.storage
    }, f = _e(
      d,
      "addAttributes",
      u
    );
    if (!f)
      return;
    const b = f();
    Object.entries(b).forEach(([h, p]) => {
      const x = {
        ...r,
        ...p
      };
      typeof (x == null ? void 0 : x.default) == "function" && (x.default = x.default()), x != null && x.isRequired && (x == null ? void 0 : x.default) === void 0 && delete x.default, n.push({
        type: d.name,
        name: h,
        attribute: x
      });
    });
  }), n;
}
function hA(e) {
  const n = [];
  let t = "", a = !1, l = !1, r = 0;
  const o = e.length;
  for (let i = 0; i < o; i += 1) {
    const s = e[i];
    if (s === "'" && !l) {
      a = !a, t += s;
      continue;
    }
    if (s === '"' && !a) {
      l = !l, t += s;
      continue;
    }
    if (!a && !l) {
      if (s === "(") {
        r += 1, t += s;
        continue;
      }
      if (s === ")" && r > 0) {
        r -= 1, t += s;
        continue;
      }
      if (s === ";" && r === 0) {
        n.push(t), t = "";
        continue;
      }
    }
    t += s;
  }
  return t && n.push(t), n;
}
function zh(e) {
  const n = [], t = hA(e || ""), a = t.length;
  for (let l = 0; l < a; l += 1) {
    const r = t[l], o = r.indexOf(":");
    if (o === -1)
      continue;
    const i = r.slice(0, o).trim(), s = r.slice(o + 1).trim();
    i && s && n.push([i, s]);
  }
  return n;
}
function Rt(...e) {
  return e.filter((n) => !!n).reduce((n, t) => {
    const a = { ...n };
    return Object.entries(t).forEach(([l, r]) => {
      if (!a[l]) {
        a[l] = r;
        return;
      }
      if (l === "class") {
        const i = r ? String(r).split(" ") : [], s = a[l] ? a[l].split(" ") : [], d = i.filter((u) => !s.includes(u));
        a[l] = [...s, ...d].join(" ");
      } else if (l === "style") {
        const i = new Map([...zh(a[l]), ...zh(r)]);
        a[l] = Array.from(i.entries()).map(([s, d]) => `${s}: ${d}`).join("; ");
      } else
        a[l] = r;
    }), a;
  }, {});
}
function ao(e, n) {
  return n.filter((t) => t.type === e.type.name).filter((t) => t.attribute.rendered).map((t) => t.attribute.renderHTML ? t.attribute.renderHTML(e.attrs) || {} : {
    [t.name]: e.attrs[t.name]
  }).reduce((t, a) => Rt(t, a), {});
}
function bA(e) {
  return typeof e != "string" ? e : e.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(e) : e === "true" ? !0 : e === "false" ? !1 : e;
}
function Oh(e, n) {
  return "style" in e ? e : {
    ...e,
    getAttrs: (t) => {
      const a = e.getAttrs ? e.getAttrs(t) : e.attrs;
      if (a === !1)
        return !1;
      const l = n.reduce((r, o) => {
        const i = o.attribute.parseHTML ? o.attribute.parseHTML(t) : bA(t.getAttribute(o.name));
        return i == null ? r : {
          ...r,
          [o.name]: i
        };
      }, {});
      return { ...a, ...l };
    }
  };
}
function Ph(e) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(e).filter(([n, t]) => n === "attrs" && fA(t) ? !1 : t != null)
  );
}
function Fh(e) {
  var n, t;
  const a = {};
  return !((n = e == null ? void 0 : e.attribute) != null && n.isRequired) && "default" in ((e == null ? void 0 : e.attribute) || {}) && (a.default = e.attribute.default), ((t = e == null ? void 0 : e.attribute) == null ? void 0 : t.validate) !== void 0 && (a.validate = e.attribute.validate), [e.name, a];
}
function gA(e, n) {
  var t;
  const a = Rp(e), { nodeExtensions: l, markExtensions: r } = Zl(e), o = (t = l.find((d) => _e(d, "topNode"))) == null ? void 0 : t.name, i = Object.fromEntries(
    l.map((d) => {
      const u = a.filter((k) => k.type === d.name), f = {
        name: d.name,
        options: d.options,
        storage: d.storage,
        editor: n
      }, b = e.reduce((k, $) => {
        const S = _e($, "extendNodeSchema", f);
        return {
          ...k,
          ...S ? S(d) : {}
        };
      }, {}), h = Ph({
        ...b,
        content: xt(_e(d, "content", f)),
        marks: xt(_e(d, "marks", f)),
        group: xt(_e(d, "group", f)),
        inline: xt(_e(d, "inline", f)),
        atom: xt(_e(d, "atom", f)),
        selectable: xt(_e(d, "selectable", f)),
        draggable: xt(_e(d, "draggable", f)),
        code: xt(_e(d, "code", f)),
        whitespace: xt(_e(d, "whitespace", f)),
        linebreakReplacement: xt(
          _e(d, "linebreakReplacement", f)
        ),
        defining: xt(_e(d, "defining", f)),
        isolating: xt(_e(d, "isolating", f)),
        attrs: Object.fromEntries(u.map(Fh))
      }), p = xt(_e(d, "parseHTML", f));
      p && (h.parseDOM = p.map(
        (k) => Oh(k, u)
      ));
      const x = _e(d, "renderHTML", f);
      x && (h.toDOM = (k) => x({
        node: k,
        HTMLAttributes: ao(k, u)
      }));
      const y = _e(d, "renderText", f);
      return y && (h.toText = y), [d.name, h];
    })
  ), s = Object.fromEntries(
    r.map((d) => {
      const u = a.filter((y) => y.type === d.name), f = {
        name: d.name,
        options: d.options,
        storage: d.storage,
        editor: n
      }, b = e.reduce((y, k) => {
        const $ = _e(k, "extendMarkSchema", f);
        return {
          ...y,
          ...$ ? $(d) : {}
        };
      }, {}), h = Ph({
        ...b,
        inclusive: xt(_e(d, "inclusive", f)),
        excludes: xt(_e(d, "excludes", f)),
        group: xt(_e(d, "group", f)),
        spanning: xt(_e(d, "spanning", f)),
        code: xt(_e(d, "code", f)),
        attrs: Object.fromEntries(u.map(Fh))
      }), p = xt(_e(d, "parseHTML", f));
      p && (h.parseDOM = p.map(
        (y) => Oh(y, u)
      ));
      const x = _e(d, "renderHTML", f);
      return x && (h.toDOM = (y) => x({
        mark: y,
        HTMLAttributes: ao(y, u)
      })), [d.name, h];
    })
  );
  return new sm({
    topNode: o,
    nodes: i,
    marks: s
  });
}
function mA(e) {
  const n = e.filter((t, a) => e.indexOf(t) !== a);
  return Array.from(new Set(n));
}
function Dr(e) {
  return e.sort((t, a) => {
    const l = _e(t, "priority") || 100, r = _e(a, "priority") || 100;
    return l > r ? -1 : l < r ? 1 : 0;
  });
}
function Bp(e) {
  const n = Dr(wc(e)), t = mA(n.map((a) => a.name));
  return t.length && console.warn(
    `[tiptap warn]: Duplicate extension names found: [${t.map((a) => `'${a}'`).join(", ")}]. This can lead to issues.`
  ), n;
}
function Mp(e, n, t) {
  const { from: a, to: l } = n, { blockSeparator: r = `

`, textSerializers: o = {} } = t || {};
  let i = "";
  return e.nodesBetween(a, l, (s, d, u, f) => {
    var b;
    s.isBlock && d > a && (i += r);
    const h = o == null ? void 0 : o[s.type.name];
    if (h)
      return u && (i += h({
        node: s,
        pos: d,
        parent: u,
        index: f,
        range: n
      })), !1;
    s.isText && (i += (b = s == null ? void 0 : s.text) == null ? void 0 : b.slice(Math.max(a, d) - d, l - d));
  }), i;
}
function pA(e, n) {
  const t = {
    from: 0,
    to: e.content.size
  };
  return Mp(e, t, n);
}
function Dp(e) {
  return Object.fromEntries(
    Object.entries(e.nodes).filter(([, n]) => n.spec.toText).map(([n, t]) => [n, t.spec.toText])
  );
}
function vA(e, n) {
  const t = Ht(n, e.schema), { from: a, to: l } = e.selection, r = [];
  e.doc.nodesBetween(a, l, (i) => {
    r.push(i);
  });
  const o = r.reverse().find((i) => i.type.name === t.name);
  return o ? { ...o.attrs } : {};
}
function zp(e, n) {
  const t = ps(
    typeof n == "string" ? n : n.name,
    e.schema
  );
  return t === "node" ? vA(e, n) : t === "mark" ? Tp(e, n) : {};
}
function xA(e, n = JSON.stringify) {
  const t = {};
  return e.filter((a) => {
    const l = n(a);
    return Object.prototype.hasOwnProperty.call(t, l) ? !1 : t[l] = !0;
  });
}
function yA(e) {
  const n = xA(e);
  return n.length === 1 ? n : n.filter((t, a) => !n.filter((r, o) => o !== a).some((r) => t.oldRange.from >= r.oldRange.from && t.oldRange.to <= r.oldRange.to && t.newRange.from >= r.newRange.from && t.newRange.to <= r.newRange.to));
}
function Op(e) {
  const { mapping: n, steps: t } = e, a = [];
  return n.maps.forEach((l, r) => {
    const o = [];
    if (l.ranges.length)
      l.forEach((i, s) => {
        o.push({ from: i, to: s });
      });
    else {
      const { from: i, to: s } = t[r];
      if (i === void 0 || s === void 0)
        return;
      o.push({ from: i, to: s });
    }
    o.forEach(({ from: i, to: s }) => {
      const d = n.slice(r).map(i, -1), u = n.slice(r).map(s), f = n.invert().map(d, -1), b = n.invert().map(u);
      a.push({
        oldRange: {
          from: f,
          to: b
        },
        newRange: {
          from: d,
          to: u
        }
      });
    });
  }), yA(a);
}
function Sc(e, n, t) {
  const a = [];
  return e === n ? t.resolve(e).marks().forEach((l) => {
    const r = t.resolve(e), o = kc(r, l.type);
    o && a.push({
      mark: l,
      ...o
    });
  }) : t.nodesBetween(e, n, (l, r) => {
    !l || (l == null ? void 0 : l.nodeSize) === void 0 || a.push(
      ...l.marks.map((o) => ({
        from: r,
        to: r + l.nodeSize,
        mark: o
      }))
    );
  }), a;
}
var kA = (e, n, t, a = 20) => {
  const l = e.doc.resolve(t);
  let r = a, o = null;
  for (; r > 0 && o === null; ) {
    const i = l.node(r);
    (i == null ? void 0 : i.type.name) === n ? o = i : r -= 1;
  }
  return [o, r];
};
function hr(e, n) {
  return n.nodes[e] || n.marks[e] || null;
}
function _o(e, n, t) {
  return Object.fromEntries(
    Object.entries(t).filter(([a]) => {
      const l = e.find((r) => r.type === n && r.name === a);
      return l ? l.attribute.keepOnSplit : !1;
    })
  );
}
var wA = (e, n = 500) => {
  let t = "";
  const a = e.parentOffset;
  return e.parent.nodesBetween(Math.max(0, a - n), a, (l, r, o, i) => {
    var s, d;
    const u = ((d = (s = l.type.spec).toText) == null ? void 0 : d.call(s, {
      node: l,
      pos: r,
      parent: o,
      index: i
    })) || l.textContent || "%leaf%";
    t += l.isAtom && !l.isText ? u : u.slice(0, Math.max(0, a - r));
  }), t;
};
function nu(e, n, t = {}) {
  const { empty: a, ranges: l } = e.selection, r = n ? wa(n, e.schema) : null;
  if (a)
    return !!(e.storedMarks || e.selection.$from.marks()).filter((f) => r ? r.name === f.type.name : !0).find((f) => wi(f.attrs, t, { strict: !1 }));
  let o = 0;
  const i = [];
  if (l.forEach(({ $from: f, $to: b }) => {
    const h = f.pos, p = b.pos;
    e.doc.nodesBetween(h, p, (x, y) => {
      if (r && x.inlineContent && !x.type.allowsMarkType(r))
        return !1;
      if (!x.isText && !x.marks.length)
        return;
      const k = Math.max(h, y), $ = Math.min(p, y + x.nodeSize), S = $ - k;
      o += S, i.push(
        ...x.marks.map((T) => ({
          mark: T,
          from: k,
          to: $
        }))
      );
    });
  }), o === 0)
    return !1;
  const s = i.filter((f) => r ? r.name === f.mark.type.name : !0).filter((f) => wi(f.mark.attrs, t, { strict: !1 })).reduce((f, b) => f + b.to - b.from, 0), d = i.filter((f) => r ? f.mark.type !== r && f.mark.type.excludes(r) : !0).reduce((f, b) => f + b.to - b.from, 0);
  return (s > 0 ? s + d : s) >= o;
}
function CA(e, n, t = {}) {
  if (!n)
    return Ua(e, null, t) || nu(e, null, t);
  const a = ps(n, e.schema);
  return a === "node" ? Ua(e, n, t) : a === "mark" ? nu(e, n, t) : !1;
}
var SA = (e, n) => {
  const { $from: t, $to: a, $anchor: l } = e.selection;
  if (n) {
    const r = vs((i) => i.type.name === n)(e.selection);
    if (!r)
      return !1;
    const o = e.doc.resolve(r.pos + 1);
    return l.pos + 1 === o.end();
  }
  return !(a.parentOffset < a.parent.nodeSize - 2 || t.pos !== a.pos);
}, $A = (e) => {
  const { $from: n, $to: t } = e.selection;
  return !(n.parentOffset > 0 || n.pos !== t.pos);
};
function Vh(e, n) {
  return Array.isArray(n) ? n.some((t) => (typeof t == "string" ? t : t.name) === e.name) : n;
}
function Qs(e, n) {
  const { nodeExtensions: t } = Zl(n), a = t.find((o) => o.name === e);
  if (!a)
    return !1;
  const l = {
    name: a.name,
    options: a.options,
    storage: a.storage
  }, r = xt(_e(a, "group", l));
  return typeof r != "string" ? !1 : r.split(" ").includes("list");
}
function lo(e, {
  checkChildren: n = !0,
  ignoreWhitespace: t = !1
} = {}) {
  var a;
  if (t) {
    if (e.type.name === "hardBreak")
      return !0;
    if (e.isText)
      return !/\S/.test((a = e.text) != null ? a : "");
  }
  if (e.isText)
    return !e.text;
  if (e.isAtom || e.isLeaf)
    return !1;
  if (e.content.childCount === 0)
    return !0;
  if (n) {
    let l = !0;
    return e.content.forEach((r) => {
      l !== !1 && (lo(r, { ignoreWhitespace: t, checkChildren: n }) || (l = !1));
    }), l;
  }
  return !1;
}
function Pp(e) {
  return e instanceof tt;
}
var Fp = class Vp {
  constructor(n) {
    this.position = n;
  }
  /**
   * Creates a MappablePosition from a JSON object.
   */
  static fromJSON(n) {
    return new Vp(n.position);
  }
  /**
   * Converts the MappablePosition to a JSON object.
   */
  toJSON() {
    return {
      position: this.position
    };
  }
};
function IA(e, n) {
  const t = n.mapping.mapResult(e.position);
  return {
    position: new Fp(t.pos),
    mapResult: t
  };
}
function LA(e) {
  return new Fp(e);
}
function TA(e, n, t) {
  var a;
  const { selection: l } = n;
  let r = null;
  if (Sp(l) && (r = l.$cursor), r) {
    const i = (a = e.storedMarks) != null ? a : r.marks();
    return r.parent.type.allowsMarkType(t) && (!!t.isInSet(i) || !i.some((d) => d.type.excludes(t)));
  }
  const { ranges: o } = l;
  return o.some(({ $from: i, $to: s }) => {
    let d = i.depth === 0 ? e.doc.inlineContent && e.doc.type.allowsMarkType(t) : !1;
    return e.doc.nodesBetween(i.pos, s.pos, (u, f, b) => {
      if (d)
        return !1;
      if (u.isInline) {
        const h = !b || b.type.allowsMarkType(t), p = !!t.isInSet(u.marks) || !u.marks.some((x) => x.type.excludes(t));
        d = h && p;
      }
      return !d;
    }), d;
  });
}
var AA = (e, n = {}) => ({ tr: t, state: a, dispatch: l }) => {
  const { selection: r } = t, { empty: o, ranges: i } = r, s = wa(e, a.schema);
  if (l)
    if (o) {
      const d = Tp(a, s);
      t.addStoredMark(
        s.create({
          ...d,
          ...n
        })
      );
    } else
      i.forEach((d) => {
        const u = d.$from.pos, f = d.$to.pos;
        a.doc.nodesBetween(u, f, (b, h) => {
          const p = Math.max(h, u), x = Math.min(h + b.nodeSize, f);
          b.marks.find((k) => k.type === s) ? b.marks.forEach((k) => {
            s === k.type && t.addMark(
              p,
              x,
              s.create({
                ...k.attrs,
                ...n
              })
            );
          }) : t.addMark(p, x, s.create(n));
        });
      });
  return TA(a, t, s);
}, EA = (e, n) => ({ tr: t }) => (t.setMeta(e, n), !0), RA = (e, n = {}) => ({ state: t, dispatch: a, chain: l }) => {
  const r = Ht(e, t.schema);
  let o;
  return t.selection.$anchor.sameParent(t.selection.$head) && (o = t.selection.$anchor.parent.attrs), r.isTextblock ? l().command(({ commands: i }) => Zf(r, { ...o, ...n })(t) ? !0 : i.clearNodes()).command(({ state: i }) => Zf(r, { ...o, ...n })(i, a)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, BA = (e) => ({ tr: n, dispatch: t }) => {
  if (t) {
    const { doc: a } = n, l = il(e, 0, a.content.size), r = tt.create(a, l);
    n.setSelection(r);
  }
  return !0;
}, MA = (e, n) => ({ tr: t, state: a, dispatch: l }) => {
  const { selection: r } = a;
  let o, i;
  return typeof n == "number" ? (o = n, i = n) : n && "from" in n && "to" in n ? (o = n.from, i = n.to) : (o = r.from, i = r.to), l && t.doc.nodesBetween(o, i, (s, d) => {
    s.isText || t.setNodeMarkup(d, void 0, {
      ...s.attrs,
      dir: e
    });
  }), !0;
}, DA = (e) => ({ tr: n, dispatch: t }) => {
  if (t) {
    const { doc: a } = n, { from: l, to: r } = typeof e == "number" ? { from: e, to: e } : e, o = rt.atStart(a).from, i = rt.atEnd(a).to, s = il(l, o, i), d = il(r, o, i), u = rt.create(a, s, d);
    n.setSelection(u);
  }
  return !0;
}, zA = (e) => ({ state: n, dispatch: t }) => {
  const a = Ht(e, n.schema);
  return $I(a)(n, t);
};
function Nh(e, n) {
  const t = e.storedMarks || e.selection.$to.parentOffset && e.selection.$from.marks();
  if (t) {
    const a = t.filter((l) => n == null ? void 0 : n.includes(l.type.name));
    e.tr.ensureMarks(a);
  }
}
var OA = ({ keepMarks: e = !0 } = {}) => ({ tr: n, state: t, dispatch: a, editor: l }) => {
  const { selection: r, doc: o } = n, { $from: i, $to: s } = r, d = l.extensionManager.attributes, u = _o(d, i.node().type.name, i.node().attrs);
  if (r instanceof tt && r.node.isBlock)
    return !i.parentOffset || !pa(o, i.pos) ? !1 : (a && (e && Nh(t, l.extensionManager.splittableMarks), n.split(i.pos).scrollIntoView()), !0);
  if (!i.parent.isBlock)
    return !1;
  const f = s.parentOffset === s.parent.content.size, b = i.depth === 0 ? void 0 : dA(i.node(-1).contentMatchAt(i.indexAfter(-1)));
  let h = f && b ? [
    {
      type: b,
      attrs: u
    }
  ] : void 0, p = pa(n.doc, n.mapping.map(i.pos), 1, h);
  if (!h && !p && pa(n.doc, n.mapping.map(i.pos), 1, b ? [{ type: b }] : void 0) && (p = !0, h = b ? [
    {
      type: b,
      attrs: u
    }
  ] : void 0), a) {
    if (p && (r instanceof rt && n.deleteSelection(), n.split(n.mapping.map(i.pos), 1, h), b && !f && !i.parentOffset && i.parent.type !== b)) {
      const x = n.mapping.map(i.before()), y = n.doc.resolve(x);
      i.node(-1).canReplaceWith(y.index(), y.index() + 1, b) && n.setNodeMarkup(n.mapping.map(i.before()), b);
    }
    e && Nh(t, l.extensionManager.splittableMarks), n.scrollIntoView();
  }
  return p;
}, PA = (e, n = {}) => ({ tr: t, state: a, dispatch: l, editor: r }) => {
  var o;
  const i = Ht(e, a.schema), { $from: s, $to: d } = a.selection, u = a.selection.node;
  if (u && u.isBlock || s.depth < 2 || !s.sameParent(d))
    return !1;
  const f = s.node(-1);
  if (f.type !== i)
    return !1;
  const b = r.extensionManager.attributes;
  if (s.parent.content.size === 0 && s.node(-1).childCount === s.indexAfter(-1)) {
    if (s.depth === 2 || s.node(-3).type !== i || s.index(-2) !== s.node(-2).childCount - 1)
      return !1;
    if (l) {
      let k = Ve.empty;
      const $ = s.index(-1) ? 1 : s.index(-2) ? 2 : 3;
      for (let D = s.depth - $; D >= s.depth - 3; D -= 1)
        k = Ve.from(s.node(D).copy(k));
      const S = (
        // eslint-disable-next-line no-nested-ternary
        s.indexAfter(-1) < s.node(-2).childCount ? 1 : s.indexAfter(-2) < s.node(-3).childCount ? 2 : 3
      ), T = {
        ..._o(b, s.node().type.name, s.node().attrs),
        ...n
      }, I = ((o = i.contentMatch.defaultType) == null ? void 0 : o.createAndFill(T)) || void 0;
      k = k.append(Ve.from(i.createAndFill(null, I) || void 0));
      const A = s.before(s.depth - ($ - 1));
      t.replace(A, s.after(-S), new Xe(k, 4 - $, 0));
      let E = -1;
      t.doc.nodesBetween(A, t.doc.content.size, (D, z) => {
        if (E > -1)
          return !1;
        D.isTextblock && D.content.size === 0 && (E = z + 1);
      }), E > -1 && t.setSelection(rt.near(t.doc.resolve(E))), t.scrollIntoView();
    }
    return !0;
  }
  const h = d.pos === s.end() ? f.contentMatchAt(0).defaultType : null, p = {
    ..._o(b, f.type.name, f.attrs),
    ...n
  }, x = {
    ..._o(b, s.node().type.name, s.node().attrs),
    ...n
  };
  t.delete(s.pos, d.pos);
  const y = h ? [
    { type: i, attrs: p },
    { type: h, attrs: x }
  ] : [{ type: i, attrs: p }];
  if (!pa(t.doc, s.pos, 2))
    return !1;
  if (l) {
    const { selection: k, storedMarks: $ } = a, { splittableMarks: S } = r.extensionManager, T = $ || k.$to.parentOffset && k.$from.marks();
    if (t.split(s.pos, 2, y).scrollIntoView(), !T || !l)
      return !0;
    const I = T.filter((A) => S.includes(A.type.name));
    t.ensureMarks(I);
  }
  return !0;
}, _s = (e, n) => {
  const t = vs((o) => o.type === n)(e.selection);
  if (!t)
    return !0;
  const a = e.doc.resolve(Math.max(0, t.pos - 1)).before(t.depth);
  if (a === void 0)
    return !0;
  const l = e.doc.nodeAt(a);
  return t.node.type === (l == null ? void 0 : l.type) && Qa(e.doc, t.pos) && e.join(t.pos), !0;
}, ed = (e, n) => {
  const t = vs((o) => o.type === n)(e.selection);
  if (!t)
    return !0;
  const a = e.doc.resolve(t.start).after(t.depth);
  if (a === void 0)
    return !0;
  const l = e.doc.nodeAt(a);
  return t.node.type === (l == null ? void 0 : l.type) && Qa(e.doc, a) && e.join(a), !0;
};
function FA(e) {
  const n = e.doc, t = n.firstChild;
  if (!t)
    return null;
  const a = n.resolve(1), l = n.resolve(t.nodeSize - 1);
  return rt.between(a, l);
}
var VA = (e, n, t, a = {}) => ({ editor: l, tr: r, state: o, dispatch: i, chain: s, commands: d, can: u }) => {
  const { extensions: f, splittableMarks: b } = l.extensionManager, h = Ht(e, o.schema), p = Ht(n, o.schema), { selection: x, storedMarks: y } = o, { $from: k, $to: $ } = x, S = k.blockRange($), T = y || x.$to.parentOffset && x.$from.marks();
  if (!S)
    return !1;
  const I = vs((re) => Qs(re.type.name, f))(x), A = x.from === 0 && x.to === o.doc.content.size, E = o.doc.content.content, D = E.length === 1 ? E[0] : null, z = A && D && Qs(D.type.name, f) ? {
    node: D,
    pos: 0
  } : null, Y = I ?? z, le = !!I && S.depth >= 1 && S.depth - I.depth <= 1, ne = !!z;
  if ((le || ne) && Y) {
    if (Y.node.type === h)
      return A && ne ? s().command(({ tr: re, dispatch: O }) => {
        const P = FA(re);
        return P ? (re.setSelection(P), O && O(re), !0) : !1;
      }).liftListItem(p).run() : d.liftListItem(p);
    if (Qs(Y.node.type.name, f) && h.validContent(Y.node.content))
      return s().command(() => (r.setNodeMarkup(Y.pos, h), !0)).command(() => _s(r, h)).command(() => ed(r, h)).run();
  }
  return !t || !T || !i ? s().command(() => u().wrapInList(h, a) ? !0 : d.clearNodes()).wrapInList(h, a).command(() => _s(r, h)).command(() => ed(r, h)).run() : s().command(() => {
    const re = u().wrapInList(h, a), O = T.filter((P) => b.includes(P.type.name));
    return r.ensureMarks(O), re ? !0 : d.clearNodes();
  }).wrapInList(h, a).command(() => _s(r, h)).command(() => ed(r, h)).run();
}, NA = (e, n = {}, t = {}) => ({ state: a, commands: l }) => {
  const { extendEmptyMarkRange: r = !1 } = t, o = wa(e, a.schema);
  return nu(a, o, n) ? l.unsetMark(o, { extendEmptyMarkRange: r }) : l.setMark(o, n);
}, HA = (e, n, t = {}) => ({ state: a, commands: l }) => {
  const r = Ht(e, a.schema), o = Ht(n, a.schema), i = Ua(a, r, t);
  let s;
  return a.selection.$anchor.sameParent(a.selection.$head) && (s = a.selection.$anchor.parent.attrs), i ? l.setNode(o, s) : l.setNode(r, { ...s, ...t });
}, jA = (e, n = {}) => ({ state: t, commands: a }) => {
  const l = Ht(e, t.schema);
  return Ua(t, l, n) ? a.lift(l) : a.wrapIn(l, n);
}, WA = () => ({ state: e, dispatch: n }) => {
  const t = e.plugins;
  for (let a = 0; a < t.length; a += 1) {
    const l = t[a];
    let r;
    if (l.spec.isInputRules && (r = l.getState(e))) {
      if (n) {
        const o = e.tr, i = r.transform;
        for (let s = i.steps.length - 1; s >= 0; s -= 1)
          o.step(i.steps[s].invert(i.docs[s]));
        if (r.text) {
          const s = o.doc.resolve(r.from).marks();
          o.replaceWith(r.from, r.to, e.schema.text(r.text, s));
        } else
          o.delete(r.from, r.to);
      }
      return !0;
    }
  }
  return !1;
}, qA = () => ({ tr: e, dispatch: n }) => {
  const { selection: t } = e, { empty: a, ranges: l } = t;
  return a || n && l.forEach((r) => {
    e.removeMark(r.$from.pos, r.$to.pos);
  }), !0;
}, UA = (e, n = {}) => ({ tr: t, state: a, dispatch: l }) => {
  var r;
  const { extendEmptyMarkRange: o = !1 } = n, { selection: i } = t, s = wa(e, a.schema), { $from: d, empty: u, ranges: f } = i;
  if (!l)
    return !0;
  if (u && o) {
    let { from: b, to: h } = i;
    const p = (r = d.marks().find((y) => y.type === s)) == null ? void 0 : r.attrs, x = kc(d, s, p);
    x && (b = x.from, h = x.to), t.removeMark(b, h, s);
  } else
    f.forEach((b) => {
      t.removeMark(b.$from.pos, b.$to.pos, s);
    });
  return t.removeStoredMark(s), !0;
}, GA = (e) => ({ tr: n, state: t, dispatch: a }) => {
  const { selection: l } = t;
  let r, o;
  return typeof e == "number" ? (r = e, o = e) : e && "from" in e && "to" in e ? (r = e.from, o = e.to) : (r = l.from, o = l.to), a && n.doc.nodesBetween(r, o, (i, s) => {
    if (i.isText)
      return;
    const d = { ...i.attrs };
    delete d.dir, n.setNodeMarkup(s, void 0, d);
  }), !0;
}, KA = (e, n = {}) => ({ tr: t, state: a, dispatch: l }) => {
  let r = null, o = null;
  const i = ps(
    typeof e == "string" ? e : e.name,
    a.schema
  );
  if (!i)
    return !1;
  i === "node" && (r = Ht(e, a.schema)), i === "mark" && (o = wa(e, a.schema));
  let s = !1;
  return t.selection.ranges.forEach((d) => {
    const u = d.$from.pos, f = d.$to.pos;
    let b, h, p, x;
    t.selection.empty ? a.doc.nodesBetween(u, f, (y, k) => {
      r && r === y.type && (s = !0, p = Math.max(k, u), x = Math.min(k + y.nodeSize, f), b = k, h = y);
    }) : a.doc.nodesBetween(u, f, (y, k) => {
      k < u && r && r === y.type && (s = !0, p = Math.max(k, u), x = Math.min(k + y.nodeSize, f), b = k, h = y), k >= u && k <= f && (r && r === y.type && (s = !0, l && t.setNodeMarkup(k, void 0, {
        ...y.attrs,
        ...n
      })), o && y.marks.length && y.marks.forEach(($) => {
        if (o === $.type && (s = !0, l)) {
          const S = Math.max(k, u), T = Math.min(k + y.nodeSize, f);
          t.addMark(
            S,
            T,
            o.create({
              ...$.attrs,
              ...n
            })
          );
        }
      }));
    }), h && (b !== void 0 && l && t.setNodeMarkup(b, void 0, {
      ...h.attrs,
      ...n
    }), o && h.marks.length && h.marks.forEach((y) => {
      o === y.type && l && t.addMark(
        p,
        x,
        o.create({
          ...y.attrs,
          ...n
        })
      );
    }));
  }), s;
}, YA = (e, n = {}) => ({ state: t, dispatch: a }) => {
  const l = Ht(e, t.schema);
  return vI(l, n)(t, a);
}, JA = (e, n = {}) => ({ state: t, dispatch: a }) => {
  const l = Ht(e, t.schema);
  return xI(l, n)(t, a);
}, XA = class {
  constructor() {
    this.callbacks = {};
  }
  on(e, n) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(n), this;
  }
  emit(e, ...n) {
    const t = this.callbacks[e];
    return t && t.forEach((a) => a.apply(this, n)), this;
  }
  off(e, n) {
    const t = this.callbacks[e];
    return t && (n ? this.callbacks[e] = t.filter((a) => a !== n) : delete this.callbacks[e]), this;
  }
  once(e, n) {
    const t = (...a) => {
      this.off(e, t), n.apply(this, a);
    };
    return this.on(e, t);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}, xs = class {
  constructor(e) {
    var n;
    this.find = e.find, this.handler = e.handler, this.undoable = (n = e.undoable) != null ? n : !0;
  }
}, ZA = (e, n) => {
  if (yc(n))
    return n.exec(e);
  const t = n(e);
  if (!t)
    return null;
  const a = [t.text];
  return a.index = t.index, a.input = e, a.data = t.data, t.replaceWith && (t.text.includes(t.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), a.push(t.replaceWith)), a;
};
function Ro(e) {
  var n;
  const { editor: t, from: a, to: l, text: r, rules: o, plugin: i } = e, { view: s } = t;
  if (s.composing)
    return !1;
  const d = s.state.doc.resolve(a);
  if (
    // check for code node
    d.parent.type.spec.code || (n = d.nodeBefore || d.nodeAfter) != null && n.marks.find((b) => b.type.spec.code)
  )
    return !1;
  let u = !1;
  const f = wA(d) + r;
  return o.forEach((b) => {
    if (u)
      return;
    const h = ZA(f, b.find);
    if (!h)
      return;
    const p = s.state.tr, x = gs({
      state: s.state,
      transaction: p
    }), y = {
      from: a - (h[0].length - r.length),
      to: l
    }, { commands: k, chain: $, can: S } = new ms({
      editor: t,
      state: x
    });
    b.handler({
      state: x,
      range: y,
      match: h,
      commands: k,
      chain: $,
      can: S
    }) === null || !p.steps.length || (b.undoable && p.setMeta(i, {
      transform: p,
      from: a,
      to: l,
      text: r
    }), s.dispatch(p), u = !0);
  }), u;
}
function QA(e) {
  const { editor: n, rules: t } = e, a = new Bt({
    state: {
      init() {
        return null;
      },
      apply(l, r, o) {
        const i = l.getMeta(a);
        if (i)
          return i;
        const s = l.getMeta("applyInputRules");
        return !!s && setTimeout(() => {
          let { text: u } = s;
          typeof u == "string" ? u = u : u = Cc(Ve.from(u), o.schema);
          const { from: f } = s, b = f + u.length;
          Ro({
            editor: n,
            from: f,
            to: b,
            text: u,
            rules: t,
            plugin: a
          });
        }), l.selectionSet || l.docChanged ? null : r;
      }
    },
    props: {
      handleTextInput(l, r, o, i) {
        return Ro({
          editor: n,
          from: r,
          to: o,
          text: i,
          rules: t,
          plugin: a
        });
      },
      handleDOMEvents: {
        compositionend: (l) => (setTimeout(() => {
          const { $cursor: r } = l.state.selection;
          r && Ro({
            editor: n,
            from: r.pos,
            to: r.pos,
            text: "",
            rules: t,
            plugin: a
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(l, r) {
        if (r.key !== "Enter")
          return !1;
        const { $cursor: o } = l.state.selection;
        return o ? Ro({
          editor: n,
          from: o.pos,
          to: o.pos,
          text: `
`,
          rules: t,
          plugin: a
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return a;
}
function _A(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function Bo(e) {
  return _A(e) !== "Object" ? !1 : e.constructor === Object && Object.getPrototypeOf(e) === Object.prototype;
}
function Np(e, n) {
  const t = { ...e };
  return Bo(e) && Bo(n) && Object.keys(n).forEach((a) => {
    Bo(n[a]) && Bo(e[a]) ? t[a] = Np(e[a], n[a]) : t[a] = n[a];
  }), t;
}
var $c = class {
  constructor(e = {}) {
    this.type = "extendable", this.parent = null, this.child = null, this.name = "", this.config = {
      name: this.name
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name;
  }
  get options() {
    return {
      ...xt(
        _e(this, "addOptions", {
          name: this.name
        })
      ) || {}
    };
  }
  get storage() {
    return {
      ...xt(
        _e(this, "addStorage", {
          name: this.name,
          options: this.options
        })
      ) || {}
    };
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => Np(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, this.child = null, n;
  }
  extend(e = {}) {
    const n = new this.constructor({ ...this.config, ...e });
    return n.parent = this, this.child = n, n.name = "name" in e ? e.name : n.parent.name, n;
  }
}, Ca = class Hp extends $c {
  constructor() {
    super(...arguments), this.type = "mark";
  }
  /**
   * Create a new Mark instance
   * @param config - Mark configuration object or a function that returns a configuration object
   */
  static create(n = {}) {
    const t = typeof n == "function" ? n() : n;
    return new Hp(t);
  }
  static handleExit({ editor: n, mark: t }) {
    const { tr: a } = n.state, l = n.state.selection.$from;
    if (l.pos === l.end()) {
      const o = l.marks();
      if (!!!o.find((d) => (d == null ? void 0 : d.type.name) === t.name))
        return !1;
      const s = o.find((d) => (d == null ? void 0 : d.type.name) === t.name);
      return s && a.removeStoredMark(s), a.insertText(" ", l.pos), n.view.dispatch(a), !0;
    }
    return !1;
  }
  configure(n) {
    return super.configure(n);
  }
  extend(n) {
    const t = typeof n == "function" ? n() : n;
    return super.extend(t);
  }
};
function eE(e) {
  return typeof e == "number";
}
var tE = class {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}, nE = (e, n, t) => {
  if (yc(n))
    return [...e.matchAll(n)];
  const a = n(e, t);
  return a ? a.map((l) => {
    const r = [l.text];
    return r.index = l.index, r.input = e, r.data = l.data, l.replaceWith && (l.text.includes(l.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), r.push(l.replaceWith)), r;
  }) : [];
};
function aE(e) {
  const { editor: n, state: t, from: a, to: l, rule: r, pasteEvent: o, dropEvent: i } = e, { commands: s, chain: d, can: u } = new ms({
    editor: n,
    state: t
  }), f = [];
  return t.doc.nodesBetween(a, l, (h, p) => {
    var x, y, k, $, S;
    if ((y = (x = h.type) == null ? void 0 : x.spec) != null && y.code || !(h.isText || h.isTextblock || h.isInline))
      return;
    const T = (S = ($ = (k = h.content) == null ? void 0 : k.size) != null ? $ : h.nodeSize) != null ? S : 0, I = Math.max(a, p), A = Math.min(l, p + T);
    if (I >= A)
      return;
    const E = h.isText ? h.text || "" : h.textBetween(I - p, A - p, void 0, "￼");
    nE(E, r.find, o).forEach((z) => {
      if (z.index === void 0)
        return;
      const Y = I + z.index + 1, le = Y + z[0].length, ne = {
        from: t.tr.mapping.map(Y),
        to: t.tr.mapping.map(le)
      }, re = r.handler({
        state: t,
        range: ne,
        match: z,
        commands: s,
        chain: d,
        can: u,
        pasteEvent: o,
        dropEvent: i
      });
      f.push(re);
    });
  }), f.every((h) => h !== null);
}
var Mo = null, lE = (e) => {
  var n;
  const t = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (n = t.clipboardData) == null || n.setData("text/html", e), t;
};
function rE(e) {
  const { editor: n, rules: t } = e;
  let a = null, l = !1, r = !1, o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, i;
  try {
    i = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    i = null;
  }
  const s = ({
    state: u,
    from: f,
    to: b,
    rule: h,
    pasteEvt: p
  }) => {
    const x = u.tr, y = gs({
      state: u,
      transaction: x
    });
    if (!(!aE({
      editor: n,
      state: y,
      from: Math.max(f - 1, 0),
      to: b.b - 1,
      rule: h,
      pasteEvent: p,
      dropEvent: i
    }) || !x.steps.length)) {
      try {
        i = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        i = null;
      }
      return o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, x;
    }
  };
  return t.map((u) => new Bt({
    // we register a global drag handler to track the current drag source element
    view(f) {
      const b = (p) => {
        var x;
        a = (x = f.dom.parentElement) != null && x.contains(p.target) ? f.dom.parentElement : null, a && (Mo = n);
      }, h = () => {
        Mo && (Mo = null);
      };
      return window.addEventListener("dragstart", b), window.addEventListener("dragend", h), {
        destroy() {
          window.removeEventListener("dragstart", b), window.removeEventListener("dragend", h);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (f, b) => {
          if (r = a === f.dom.parentElement, i = b, !r) {
            const h = Mo;
            h != null && h.isEditable && setTimeout(() => {
              const p = h.state.selection;
              p && h.commands.deleteRange({ from: p.from, to: p.to });
            }, 10);
          }
          return !1;
        },
        paste: (f, b) => {
          var h;
          const p = (h = b.clipboardData) == null ? void 0 : h.getData("text/html");
          return o = b, l = !!(p != null && p.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (f, b, h) => {
      const p = f[0], x = p.getMeta("uiEvent") === "paste" && !l, y = p.getMeta("uiEvent") === "drop" && !r, k = p.getMeta("applyPasteRules"), $ = !!k;
      if (!x && !y && !$)
        return;
      if ($) {
        let { text: I } = k;
        typeof I == "string" ? I = I : I = Cc(Ve.from(I), h.schema);
        const { from: A } = k, E = A + I.length, D = lE(I);
        return s({
          rule: u,
          state: h,
          from: A,
          to: { b: E },
          pasteEvt: D
        });
      }
      const S = b.doc.content.findDiffStart(h.doc.content), T = b.doc.content.findDiffEnd(h.doc.content);
      if (!(!eE(S) || !T || S === T.b))
        return s({
          rule: u,
          state: h,
          from: S,
          to: T,
          pasteEvt: o
        });
    }
  }));
}
var ys = class {
  constructor(e, n) {
    this.splittableMarks = [], this.editor = n, this.baseExtensions = e, this.extensions = Bp(e), this.schema = gA(this.extensions, n), this.setupExtensions();
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((e, n) => {
      const t = {
        name: n.name,
        options: n.options,
        storage: this.editor.extensionStorage[n.name],
        editor: this.editor,
        type: hr(n.name, this.schema)
      }, a = _e(n, "addCommands", t);
      return a ? {
        ...e,
        ...a()
      } : e;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: e } = this;
    return Dr([...this.extensions].reverse()).flatMap((a) => {
      const l = {
        name: a.name,
        options: a.options,
        storage: this.editor.extensionStorage[a.name],
        editor: e,
        type: hr(a.name, this.schema)
      }, r = [], o = _e(
        a,
        "addKeyboardShortcuts",
        l
      );
      let i = {};
      if (a.type === "mark" && _e(a, "exitable", l) && (i.ArrowRight = () => Ca.handleExit({ editor: e, mark: a })), o) {
        const b = Object.fromEntries(
          Object.entries(o()).map(([h, p]) => [h, () => p({ editor: e })])
        );
        i = { ...i, ...b };
      }
      const s = gT(i);
      r.push(s);
      const d = _e(a, "addInputRules", l);
      if (Vh(a, e.options.enableInputRules) && d) {
        const b = d();
        if (b && b.length) {
          const h = QA({
            editor: e,
            rules: b
          }), p = Array.isArray(h) ? h : [h];
          r.push(...p);
        }
      }
      const u = _e(a, "addPasteRules", l);
      if (Vh(a, e.options.enablePasteRules) && u) {
        const b = u();
        if (b && b.length) {
          const h = rE({ editor: e, rules: b });
          r.push(...h);
        }
      }
      const f = _e(
        a,
        "addProseMirrorPlugins",
        l
      );
      if (f) {
        const b = f();
        r.push(...b);
      }
      return r;
    });
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return Rp(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: e } = this, { nodeExtensions: n } = Zl(this.extensions);
    return Object.fromEntries(
      n.filter((t) => !!_e(t, "addNodeView")).map((t) => {
        const a = this.attributes.filter((s) => s.type === t.name), l = {
          name: t.name,
          options: t.options,
          storage: this.editor.extensionStorage[t.name],
          editor: e,
          type: Ht(t.name, this.schema)
        }, r = _e(t, "addNodeView", l);
        if (!r)
          return [];
        const o = r();
        if (!o)
          return [];
        const i = (s, d, u, f, b) => {
          const h = ao(s, a);
          return o({
            // pass-through
            node: s,
            view: d,
            getPos: u,
            decorations: f,
            innerDecorations: b,
            // tiptap-specific
            editor: e,
            extension: t,
            HTMLAttributes: h
          });
        };
        return [t.name, i];
      })
    );
  }
  /**
   * Get the composed dispatchTransaction function from all extensions.
   * @param baseDispatch The base dispatch function (e.g. from the editor or user props)
   * @returns A composed dispatch function
   */
  dispatchTransaction(e) {
    const { editor: n } = this;
    return Dr([...this.extensions].reverse()).reduceRight((a, l) => {
      const r = {
        name: l.name,
        options: l.options,
        storage: this.editor.extensionStorage[l.name],
        editor: n,
        type: hr(l.name, this.schema)
      }, o = _e(
        l,
        "dispatchTransaction",
        r
      );
      return o ? (i) => {
        o.call(r, { transaction: i, next: a });
      } : a;
    }, e);
  }
  /**
   * Get the composed transformPastedHTML function from all extensions.
   * @param baseTransform The base transform function (e.g. from the editor props)
   * @returns A composed transform function that chains all extension transforms
   */
  transformPastedHTML(e) {
    const { editor: n } = this;
    return Dr([...this.extensions]).reduce(
      (a, l) => {
        const r = {
          name: l.name,
          options: l.options,
          storage: this.editor.extensionStorage[l.name],
          editor: n,
          type: hr(l.name, this.schema)
        }, o = _e(
          l,
          "transformPastedHTML",
          r
        );
        return o ? (i, s) => {
          const d = a(i, s);
          return o.call(r, d);
        } : a;
      },
      e || ((a) => a)
    );
  }
  get markViews() {
    const { editor: e } = this, { markExtensions: n } = Zl(this.extensions);
    return Object.fromEntries(
      n.filter((t) => !!_e(t, "addMarkView")).map((t) => {
        const a = this.attributes.filter((i) => i.type === t.name), l = {
          name: t.name,
          options: t.options,
          storage: this.editor.extensionStorage[t.name],
          editor: e,
          type: wa(t.name, this.schema)
        }, r = _e(t, "addMarkView", l);
        if (!r)
          return [];
        const o = (i, s, d) => {
          const u = ao(i, a);
          return r()({
            // pass-through
            mark: i,
            view: s,
            inline: d,
            // tiptap-specific
            editor: e,
            extension: t,
            HTMLAttributes: u,
            updateAttributes: (f) => {
              yE(i, e, f);
            }
          });
        };
        return [t.name, o];
      })
    );
  }
  /**
   * Destroy the extension manager and clean up all extension references
   * to prevent memory leaks through parent/child extension chains.
   *
   * Walks each extension's full parent chain and nulls every forward
   * `parent.child → current` link where the parent still points to the
   * current node. This breaks the retention path from module-scope
   * singleton roots through deep extend() chains.
   *
   * Only ancestor `.child` links matching the current chain are cleared.
   * The `.parent` pointer on ancestors is never touched — extensions
   * may be shared across live editors, so their own backward references
   * and non-matching forward links must remain intact.
   */
  destroy() {
    this.extensions.forEach((e) => {
      let n = e;
      for (; n.parent; ) {
        const t = n.parent;
        t.child === n && (t.child = null), n = t;
      }
    }), this.extensions = [], this.baseExtensions = [], this.schema = null, this.editor = null;
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    const e = this.extensions;
    this.editor.extensionStorage = Object.fromEntries(
      e.map((n) => [n.name, n.storage])
    ), e.forEach((n) => {
      var t;
      const a = {
        name: n.name,
        options: n.options,
        storage: this.editor.extensionStorage[n.name],
        editor: this.editor,
        type: hr(n.name, this.schema)
      };
      n.type === "mark" && ((t = xt(_e(n, "keepOnSplit", a))) == null || t) && this.splittableMarks.push(n.name);
      const l = _e(n, "onBeforeCreate", a), r = _e(n, "onCreate", a), o = _e(n, "onUpdate", a), i = _e(
        n,
        "onSelectionUpdate",
        a
      ), s = _e(n, "onTransaction", a), d = _e(n, "onFocus", a), u = _e(n, "onBlur", a), f = _e(n, "onDestroy", a);
      l && this.editor.on("beforeCreate", l), r && this.editor.on("create", r), o && this.editor.on("update", o), i && this.editor.on("selectionUpdate", i), s && this.editor.on("transaction", s), d && this.editor.on("focus", d), u && this.editor.on("blur", u), f && this.editor.on("destroy", f);
    });
  }
};
ys.resolve = Bp;
ys.sort = Dr;
ys.flatten = wc;
var oE = {};
xc(oE, {
  ClipboardTextSerializer: () => Wp,
  Commands: () => qp,
  Delete: () => Up,
  Drop: () => Gp,
  Editable: () => Kp,
  FocusEvents: () => Jp,
  Keymap: () => Xp,
  Paste: () => Zp,
  Tabindex: () => Qp,
  TextDirection: () => _p,
  focusEventsPluginKey: () => Yp
});
var wt = class jp extends $c {
  constructor() {
    super(...arguments), this.type = "extension";
  }
  /**
   * Create a new Extension instance
   * @param config - Extension configuration object or a function that returns a configuration object
   */
  static create(n = {}) {
    const t = typeof n == "function" ? n() : n;
    return new jp(t);
  }
  configure(n) {
    return super.configure(n);
  }
  extend(n) {
    const t = typeof n == "function" ? n() : n;
    return super.extend(t);
  }
}, Wp = wt.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Bt({
        key: new qt("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: e } = this, { state: n, schema: t } = e, { doc: a, selection: l } = n, { ranges: r } = l, o = Math.min(...r.map((u) => u.$from.pos)), i = Math.max(...r.map((u) => u.$to.pos)), s = Dp(t);
            return Mp(a, { from: o, to: i }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: s
            });
          }
        }
      })
    ];
  }
}), qp = wt.create({
  name: "commands",
  addCommands() {
    return {
      ...wp
    };
  }
}), Up = wt.create({
  name: "delete",
  onUpdate({ transaction: e, appendedTransactions: n }) {
    var t, a, l;
    const r = () => {
      var o, i, s, d;
      if ((d = (s = (i = (o = this.editor.options.coreExtensionOptions) == null ? void 0 : o.delete) == null ? void 0 : i.filterTransaction) == null ? void 0 : s.call(i, e)) != null ? d : e.getMeta("y-sync$"))
        return;
      const u = Ap(e.before, [e, ...n]);
      Op(u).forEach((h) => {
        u.mapping.mapResult(h.oldRange.from).deletedAfter && u.mapping.mapResult(h.oldRange.to).deletedBefore && u.before.nodesBetween(h.oldRange.from, h.oldRange.to, (p, x) => {
          const y = x + p.nodeSize - 2, k = h.oldRange.from <= x && y <= h.oldRange.to;
          this.editor.emit("delete", {
            type: "node",
            node: p,
            from: x,
            to: y,
            newFrom: u.mapping.map(x),
            newTo: u.mapping.map(y),
            deletedRange: h.oldRange,
            newRange: h.newRange,
            partial: !k,
            editor: this.editor,
            transaction: e,
            combinedTransform: u
          });
        });
      });
      const b = u.mapping;
      u.steps.forEach((h, p) => {
        var x, y;
        if (h instanceof qn) {
          const k = b.slice(p).map(h.from, -1), $ = b.slice(p).map(h.to), S = b.invert().map(k, -1), T = b.invert().map($), I = k > 0 ? (x = u.doc.nodeAt(k - 1)) == null ? void 0 : x.marks.some((E) => E.eq(h.mark)) : !1, A = (y = u.doc.nodeAt($)) == null ? void 0 : y.marks.some((E) => E.eq(h.mark));
          this.editor.emit("delete", {
            type: "mark",
            mark: h.mark,
            from: h.from,
            to: h.to,
            deletedRange: {
              from: S,
              to: T
            },
            newRange: {
              from: k,
              to: $
            },
            partial: !!(A || I),
            editor: this.editor,
            transaction: e,
            combinedTransform: u
          });
        }
      });
    };
    (l = (a = (t = this.editor.options.coreExtensionOptions) == null ? void 0 : t.delete) == null ? void 0 : a.async) == null || l ? setTimeout(r, 0) : r();
  }
}), Gp = wt.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new Bt({
        key: new qt("tiptapDrop"),
        props: {
          handleDrop: (e, n, t, a) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: n,
              slice: t,
              moved: a
            });
          }
        }
      })
    ];
  }
}), Kp = wt.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new Bt({
        key: new qt("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), Yp = new qt("focusEvents"), Jp = wt.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: e } = this;
    return [
      new Bt({
        key: Yp,
        props: {
          handleDOMEvents: {
            focus: (n, t) => {
              e.isFocused = !0;
              const a = e.state.tr.setMeta("focus", { event: t }).setMeta("addToHistory", !1);
              return n.dispatch(a), !1;
            },
            blur: (n, t) => {
              e.isFocused = !1;
              const a = e.state.tr.setMeta("blur", { event: t }).setMeta("addToHistory", !1);
              return n.dispatch(a), !1;
            }
          }
        }
      })
    ];
  }
}), Xp = wt.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const e = () => this.editor.commands.first(({ commands: o }) => [
      () => o.undoInputRule(),
      // maybe convert first text block node to default node
      () => o.command(({ tr: i }) => {
        const { selection: s, doc: d } = i, { empty: u, $anchor: f } = s, { pos: b, parent: h } = f, p = f.parent.isTextblock && b > 0 ? i.doc.resolve(b - 1) : f, x = p.parent.type.spec.isolating, y = f.pos - f.parentOffset, k = x && p.parent.childCount === 1 ? y === f.pos : st.atStart(d).from === b;
        return !u || !h.type.isTextblock || h.textContent.length || !k || k && f.parent.type.name === "paragraph" ? !1 : o.clearNodes();
      }),
      () => o.deleteSelection(),
      () => o.joinBackward(),
      () => o.selectNodeBackward()
    ]), n = () => this.editor.commands.first(({ commands: o }) => [
      () => o.deleteSelection(),
      () => o.deleteCurrentNode(),
      () => o.joinForward(),
      () => o.selectNodeForward()
    ]), a = {
      Enter: () => this.editor.commands.first(({ commands: o }) => [
        () => o.newlineInCode(),
        () => o.createParagraphNear(),
        () => o.liftEmptyBlock(),
        () => o.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: e,
      "Mod-Backspace": e,
      "Shift-Backspace": e,
      Delete: n,
      "Mod-Delete": n,
      "Mod-a": () => this.editor.commands.selectAll()
    }, l = {
      ...a
    }, r = {
      ...a,
      "Ctrl-h": e,
      "Alt-Backspace": e,
      "Ctrl-d": n,
      "Ctrl-Alt-Backspace": n,
      "Alt-Delete": n,
      "Alt-d": n,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return Ci() || Lp() ? r : l;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new Bt({
        key: new qt("clearDocument"),
        appendTransaction: (e, n, t) => {
          if (e.some((x) => x.getMeta("composition")))
            return;
          const a = e.some((x) => x.docChanged) && !n.doc.eq(t.doc), l = e.some((x) => x.getMeta("preventClearDocument"));
          if (!a || l)
            return;
          const { empty: r, from: o, to: i } = n.selection, s = st.atStart(n.doc).from, d = st.atEnd(n.doc).to;
          if (r || !(o === s && i === d) || !lo(t.doc))
            return;
          const b = t.tr, h = gs({
            state: t,
            transaction: b
          }), { commands: p } = new ms({
            editor: this.editor,
            state: h
          });
          if (p.clearNodes(), !!b.steps.length)
            return b;
        }
      })
    ];
  }
}), Zp = wt.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new Bt({
        key: new qt("tiptapPaste"),
        props: {
          handlePaste: (e, n, t) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: n,
              slice: t
            });
          }
        }
      })
    ];
  }
}), Qp = wt.create({
  name: "tabindex",
  addOptions() {
    return {
      value: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Bt({
        key: new qt("tabindex"),
        props: {
          attributes: () => {
            var e;
            return !this.editor.isEditable && this.options.value === void 0 ? {} : { tabindex: (e = this.options.value) != null ? e : "0" };
          }
        }
      })
    ];
  }
}), _p = wt.create({
  name: "textDirection",
  addOptions() {
    return {
      direction: void 0
    };
  },
  addGlobalAttributes() {
    if (!this.options.direction)
      return [];
    const { nodeExtensions: e } = Zl(this.extensions);
    return [
      {
        types: e.filter((n) => n.name !== "text").map((n) => n.name),
        attributes: {
          dir: {
            default: this.options.direction,
            parseHTML: (n) => {
              const t = n.getAttribute("dir");
              return t && (t === "ltr" || t === "rtl" || t === "auto") ? t : this.options.direction;
            },
            renderHTML: (n) => n.dir ? {
              dir: n.dir
            } : {}
          }
        }
      }
    ];
  },
  addProseMirrorPlugins() {
    return [
      new Bt({
        key: new qt("textDirection"),
        props: {
          attributes: () => {
            const e = this.options.direction;
            return e ? {
              dir: e
            } : {};
          }
        }
      })
    ];
  }
}), iE = class Sr {
  constructor(n, t, a = !1, l = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = a, this.resolvedPos = n, this.editor = t, this.currentNode = l;
  }
  get name() {
    return this.node.type.name;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var n;
    return (n = this.actualDepth) != null ? n : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(n) {
    let t = this.from, a = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      t = this.from + 1, a = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: t, to: a }, n);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const n = this.resolvedPos.start(this.resolvedPos.depth - 1), t = this.resolvedPos.doc.resolve(n);
    return new Sr(t, this.editor);
  }
  get before() {
    let n = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return n.depth !== this.depth && (n = this.resolvedPos.doc.resolve(this.from - 3)), new Sr(n, this.editor);
  }
  get after() {
    let n = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return n.depth !== this.depth && (n = this.resolvedPos.doc.resolve(this.to + 3)), new Sr(n, this.editor);
  }
  get children() {
    const n = [];
    return this.node.content.forEach((t, a) => {
      const l = t.isBlock && !t.isTextblock, r = t.isAtom && !t.isText, o = t.isInline, i = this.pos + a + (r ? 0 : 1);
      if (i < 0 || i > this.resolvedPos.doc.nodeSize - 2)
        return;
      const s = this.resolvedPos.doc.resolve(i);
      if (!l && !o && s.depth <= this.depth)
        return;
      const d = new Sr(s, this.editor, l, l || o ? t : null);
      l && (d.actualDepth = this.depth + 1), n.push(d);
    }), n;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const n = this.children;
    return n[n.length - 1] || null;
  }
  closest(n, t = {}) {
    let a = null, l = this.parent;
    for (; l && !a; ) {
      if (l.node.type.name === n)
        if (Object.keys(t).length > 0) {
          const r = l.node.attrs, o = Object.keys(t);
          for (let i = 0; i < o.length; i += 1) {
            const s = o[i];
            if (r[s] !== t[s])
              break;
          }
        } else
          a = l;
      l = l.parent;
    }
    return a;
  }
  querySelector(n, t = {}) {
    return this.querySelectorAll(n, t, !0)[0] || null;
  }
  querySelectorAll(n, t = {}, a = !1) {
    let l = [];
    if (!this.children || this.children.length === 0)
      return l;
    const r = Object.keys(t);
    return this.children.forEach((o) => {
      a && l.length > 0 || (o.node.type.name === n && r.every((s) => t[s] === o.node.attrs[s]) && l.push(o), !(a && l.length > 0) && (l = l.concat(o.querySelectorAll(n, t, a))));
    }), l;
  }
  setAttribute(n) {
    const { tr: t } = this.editor.state;
    t.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...n
    }), this.editor.view.dispatch(t);
  }
}, sE = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}`;
function dE(e, n, t) {
  const a = document.querySelector("style[data-tiptap-style]");
  if (a !== null)
    return a;
  const l = document.createElement("style");
  return n && l.setAttribute("nonce", n), l.setAttribute("data-tiptap-style", ""), l.innerHTML = e, document.getElementsByTagName("head")[0].appendChild(l), l;
}
var uE = class extends XA {
  constructor(n = {}) {
    super(), this.css = null, this.className = "tiptap", this.editorView = null, this.isFocused = !1, this.destroyed = !1, this.isInitialized = !1, this.extensionStorage = {}, this.instanceId = Math.random().toString(36).slice(2, 9), this.options = {
      element: typeof document < "u" ? document.createElement("div") : null,
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      textDirection: void 0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      emitContentError: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onMount: () => null,
      onUnmount: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: l }) => {
        throw l;
      },
      onPaste: () => null,
      onDrop: () => null,
      onDelete: () => null,
      enableExtensionDispatchTransaction: !0
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.utils = {
      getUpdatedPosition: IA,
      createMappablePosition: LA
    }, this.setOptions(n), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("mount", this.options.onMount), this.on("unmount", this.options.onUnmount), this.on("contentError", this.options.onContentError), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: l, slice: r, moved: o }) => this.options.onDrop(l, r, o)), this.on("paste", ({ event: l, slice: r }) => this.options.onPaste(l, r)), this.on("delete", this.options.onDelete);
    const t = this.createDoc(), a = $p(t, this.options.autofocus);
    this.editorState = Ml.create({
      doc: t,
      schema: this.schema,
      selection: a || void 0
    }), this.options.element && this.mount(this.options.element);
  }
  /**
   * Attach the editor to the DOM, creating a new editor view.
   */
  mount(n) {
    if (typeof document > "u")
      throw new Error(
        "[tiptap error]: The editor cannot be mounted because there is no 'document' defined in this environment."
      );
    this.createView(n), this.emit("mount", { editor: this }), this.css && !document.head.contains(this.css) && document.head.appendChild(this.css), window.setTimeout(() => {
      this.isDestroyed || (this.options.autofocus !== !1 && this.options.autofocus !== null && this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Remove the editor from the DOM, but still allow remounting at a different point in time
   */
  unmount() {
    if (this.editorView) {
      const n = this.editorView.dom;
      n != null && n.editor && delete n.editor, this.editorView.destroy();
    }
    if (this.editorView = null, this.isInitialized = !1, this.css && !document.querySelectorAll(`.${this.className}`).length)
      try {
        typeof this.css.remove == "function" ? this.css.remove() : this.css.parentNode && this.css.parentNode.removeChild(this.css);
      } catch (n) {
        console.warn("Failed to remove CSS element:", n);
      }
    this.css = null, this.emit("unmount", { editor: this });
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && typeof document < "u" && (this.css = dE(sE, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(n = {}) {
    this.options = {
      ...this.options,
      ...n
    }, !(!this.editorView || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(n, t = !0) {
    this.setOptions({ editable: n }), t && this.emit("update", { editor: this, transaction: this.state.tr, appendedTransactions: [] });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor view.
   */
  get view() {
    return this.editorView ? this.editorView : new Proxy(
      {
        state: this.editorState,
        updateState: (n) => {
          this.editorState = n;
        },
        dispatch: (n) => {
          this.dispatchTransaction(n);
        },
        // Stub some commonly accessed properties to prevent errors
        composing: !1,
        dragging: null,
        editable: !0,
        isDestroyed: !1
      },
      {
        get: (n, t) => {
          if (this.editorView)
            return this.editorView[t];
          if (t === "state")
            return this.editorState;
          if (t in n)
            return Reflect.get(n, t);
          throw new Error(
            `[tiptap error]: The editor view is not available. Cannot access view['${t}']. The editor may not be mounted yet.`
          );
        }
      }
    );
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.editorView && (this.editorState = this.view.state), this.editorState;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(n, t) {
    const a = Ep(t) ? t(n, [...this.state.plugins]) : [...this.state.plugins, n], l = this.state.reconfigure({ plugins: a });
    return this.view.updateState(l), l;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(n) {
    if (this.isDestroyed)
      return;
    const t = this.state.plugins;
    let a = t;
    if ([].concat(n).forEach((r) => {
      const o = typeof r == "string" ? `${r}$` : r.key;
      a = a.filter((i) => !i.key.startsWith(o));
    }), t.length === a.length)
      return;
    const l = this.state.reconfigure({
      plugins: a
    });
    return this.view.updateState(l), l;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var n, t, a, l;
    const o = [...this.options.enableCoreExtensions ? [
      Kp,
      Wp.configure({
        blockSeparator: (t = (n = this.options.coreExtensionOptions) == null ? void 0 : n.clipboardTextSerializer) == null ? void 0 : t.blockSeparator
      }),
      qp,
      Jp,
      Xp,
      Qp.configure({
        value: (l = (a = this.options.coreExtensionOptions) == null ? void 0 : a.tabindex) == null ? void 0 : l.value
      }),
      Gp,
      Zp,
      Up,
      _p.configure({
        direction: this.options.textDirection
      })
    ].filter((i) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[i.name] !== !1 : !0) : [], ...this.options.extensions].filter((i) => ["extension", "node", "mark"].includes(i == null ? void 0 : i.type));
    this.extensionManager = new ys(o, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new ms({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates the initial document.
   */
  createDoc() {
    let n;
    try {
      n = tu(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: this.options.enableContentCheck
      });
    } catch (t) {
      if (!(t instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(t.message))
        throw t;
      this.emit("contentError", {
        editor: this,
        error: t,
        disableCollaboration: () => {
          "collaboration" in this.storage && typeof this.storage.collaboration == "object" && this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((a) => a.name !== "collaboration"), this.createExtensionManager();
        }
      }), n = tu(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: !1
      });
    }
    return n;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView(n) {
    const { editorProps: t, enableExtensionDispatchTransaction: a } = this.options, l = t.dispatchTransaction || this.dispatchTransaction.bind(this), r = a ? this.extensionManager.dispatchTransaction(l) : l, o = t.transformPastedHTML, i = this.extensionManager.transformPastedHTML(o);
    this.editorView = new yp(n, {
      ...t,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...t == null ? void 0 : t.attributes
      },
      dispatchTransaction: r,
      transformPastedHTML: i,
      state: this.editorState,
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
    const s = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(s), this.prependClass(), this.injectCSS();
    const d = this.view.dom;
    d.editor = this;
  }
  /**
   * Creates all node and mark views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `${this.className} ${this.view.dom.className}`;
  }
  captureTransaction(n) {
    this.isCapturingTransaction = !0, n(), this.isCapturingTransaction = !1;
    const t = this.capturedTransaction;
    return this.capturedTransaction = null, t;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(n) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = n;
        return;
      }
      n.steps.forEach((u) => {
        var f;
        return (f = this.capturedTransaction) == null ? void 0 : f.step(u);
      });
      return;
    }
    const { state: t, transactions: a } = this.state.applyTransaction(n), l = !this.state.selection.eq(t.selection), r = a.includes(n), o = this.state;
    if (this.emit("beforeTransaction", {
      editor: this,
      transaction: n,
      nextState: t
    }), !r)
      return;
    this.view.updateState(t), this.emit("transaction", {
      editor: this,
      transaction: n,
      appendedTransactions: a.slice(1)
    }), l && this.emit("selectionUpdate", {
      editor: this,
      transaction: n
    });
    const i = a.findLast((u) => u.getMeta("focus") || u.getMeta("blur")), s = i == null ? void 0 : i.getMeta("focus"), d = i == null ? void 0 : i.getMeta("blur");
    s && this.emit("focus", {
      editor: this,
      event: s.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: i
    }), d && this.emit("blur", {
      editor: this,
      event: d.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: i
    }), !(n.getMeta("preventUpdate") || !a.some((u) => u.docChanged) || o.doc.eq(t.doc)) && this.emit("update", {
      editor: this,
      transaction: n,
      appendedTransactions: a.slice(1)
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(n) {
    return zp(this.state, n);
  }
  isActive(n, t) {
    const a = typeof n == "string" ? n : null, l = typeof n == "string" ? t : n;
    return CA(this.state, a, l);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return Cc(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(n) {
    const { blockSeparator: t = `

`, textSerializers: a = {} } = n || {};
    return pA(this.state.doc, {
      blockSeparator: t,
      textSerializers: {
        ...Dp(this.schema),
        ...a
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return lo(this.state.doc);
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    this.destroyed || (this.destroyed = !0, this.emit("destroy"), this.unmount(), this.removeAllListeners(), this.extensionManager.destroy(), this.extensionManager = null, this.schema = null, this.commandManager = null, this.extensionStorage = {});
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var n, t;
    return (t = (n = this.editorView) == null ? void 0 : n.isDestroyed) != null ? t : !0;
  }
  $node(n, t) {
    var a;
    return ((a = this.$doc) == null ? void 0 : a.querySelector(n, t)) || null;
  }
  $nodes(n, t) {
    var a;
    return ((a = this.$doc) == null ? void 0 : a.querySelectorAll(n, t)) || null;
  }
  $pos(n) {
    const t = this.state.doc.resolve(n), a = n > 0 && t.nodeAfter && !t.nodeAfter.isText ? t.nodeAfter : null;
    return new iE(t, this, !1, a);
  }
  get $doc() {
    return this.$pos(0);
  }
};
function Cl(e) {
  return new xs({
    find: e.find,
    handler: ({ state: n, range: t, match: a }) => {
      const l = xt(e.getAttributes, void 0, a);
      if (l === !1 || l === null)
        return null;
      const { tr: r } = n, o = a[a.length - 1], i = a[0];
      if (o) {
        const s = i.search(/\S/), d = t.from + i.indexOf(o), u = d + o.length;
        if (Sc(t.from, t.to, n.doc).filter((h) => h.mark.type.excluded.find((x) => x === e.type && x !== h.mark.type)).filter((h) => h.to > d).length)
          return null;
        u < t.to && r.delete(u, t.to), d > t.from && r.delete(t.from + s, d);
        const b = t.from + s + o.length;
        r.addMark(t.from + s, b, e.type.create(l || {})), r.removeStoredMark(e.type);
      }
    },
    undoable: e.undoable
  });
}
function ev(e) {
  return new xs({
    find: e.find,
    handler: ({ state: n, range: t, match: a }) => {
      const l = xt(e.getAttributes, void 0, a) || {}, { tr: r } = n, o = t.from;
      let i = t.to;
      const s = e.type.create(l);
      if (a[1]) {
        const d = a[0].lastIndexOf(a[1]);
        let u = o + d;
        u > i ? u = i : i = u + a[1].length;
        const f = a[0][a[0].length - 1];
        r.insertText(f, o + a[0].length - 1), r.replaceWith(u, i, s);
      } else if (a[0]) {
        const d = e.type.isInline ? o : o - 1;
        r.insert(d, e.type.create(l)).delete(r.mapping.map(o), r.mapping.map(i));
      }
      r.scrollIntoView();
    },
    undoable: e.undoable
  });
}
function au(e) {
  return new xs({
    find: e.find,
    handler: ({ state: n, range: t, match: a }) => {
      const l = n.doc.resolve(t.from), r = xt(e.getAttributes, void 0, a) || {};
      if (!l.node(-1).canReplaceWith(l.index(-1), l.indexAfter(-1), e.type))
        return null;
      n.tr.delete(t.from, t.to).setBlockType(t.from, t.from, e.type, r);
    },
    undoable: e.undoable
  });
}
function Ql(e) {
  return new xs({
    find: e.find,
    handler: ({ state: n, range: t, match: a, chain: l }) => {
      const r = xt(e.getAttributes, void 0, a) || {}, o = n.tr.delete(t.from, t.to), s = o.doc.resolve(t.from).blockRange(), d = s && lc(s, e.type, r);
      if (!d)
        return null;
      if (o.wrap(s, d), e.keepMarks && e.editor) {
        const { selection: f, storedMarks: b } = n, { splittableMarks: h } = e.editor.extensionManager, p = b || f.$to.parentOffset && f.$from.marks();
        if (p) {
          const x = p.filter((y) => h.includes(y.type.name));
          o.ensureMarks(x);
        }
      }
      if (e.keepAttributes) {
        const f = e.type.name === "bulletList" || e.type.name === "orderedList" ? "listItem" : "taskList";
        l().updateAttributes(f, r).run();
      }
      const u = o.doc.resolve(t.from - 1).nodeBefore;
      u && u.type === e.type && Qa(o.doc, t.from - 1) && (!e.joinPredicate || e.joinPredicate(a, u)) && o.join(t.from - 1);
    },
    undoable: e.undoable
  });
}
var cE = (e) => "touches" in e, fE = class {
  /**
   * Creates a new ResizableNodeView instance.
   *
   * The constructor sets up the resize handles, applies initial sizing from
   * node attributes, and configures all resize behavior options.
   *
   * @param options - Configuration options for the resizable node view
   */
  constructor(e) {
    this.directions = ["bottom-left", "bottom-right", "top-left", "top-right"], this.minSize = {
      height: 8,
      width: 8
    }, this.preserveAspectRatio = !1, this.classNames = {
      container: "",
      wrapper: "",
      handle: "",
      resizing: ""
    }, this.initialWidth = 0, this.initialHeight = 0, this.aspectRatio = 1, this.isResizing = !1, this.activeHandle = null, this.startX = 0, this.startY = 0, this.startWidth = 0, this.startHeight = 0, this.isShiftKeyPressed = !1, this.lastEditableState = void 0, this.handleMap = /* @__PURE__ */ new Map(), this.handleMouseMove = (i) => {
      if (!this.isResizing || !this.activeHandle)
        return;
      const s = i.clientX - this.startX, d = i.clientY - this.startY;
      this.handleResize(s, d);
    }, this.handleTouchMove = (i) => {
      if (!this.isResizing || !this.activeHandle)
        return;
      const s = i.touches[0];
      if (!s)
        return;
      const d = s.clientX - this.startX, u = s.clientY - this.startY;
      this.handleResize(d, u);
    }, this.handleMouseUp = () => {
      if (!this.isResizing)
        return;
      const i = this.element.offsetWidth, s = this.element.offsetHeight;
      this.onCommit(i, s), this.isResizing = !1, this.activeHandle = null, this.container.dataset.resizeState = "false", this.classNames.resizing && this.container.classList.remove(this.classNames.resizing), document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp);
    }, this.handleKeyDown = (i) => {
      i.key === "Shift" && (this.isShiftKeyPressed = !0);
    }, this.handleKeyUp = (i) => {
      i.key === "Shift" && (this.isShiftKeyPressed = !1);
    };
    var n, t, a, l, r, o;
    this.node = e.node, this.editor = e.editor, this.element = e.element, this.contentElement = e.contentElement, this.getPos = e.getPos, this.onResize = e.onResize, this.onCommit = e.onCommit, this.onUpdate = e.onUpdate, (n = e.options) != null && n.min && (this.minSize = {
      ...this.minSize,
      ...e.options.min
    }), (t = e.options) != null && t.max && (this.maxSize = e.options.max), (a = e == null ? void 0 : e.options) != null && a.directions && (this.directions = e.options.directions), (l = e.options) != null && l.preserveAspectRatio && (this.preserveAspectRatio = e.options.preserveAspectRatio), (r = e.options) != null && r.className && (this.classNames = {
      container: e.options.className.container || "",
      wrapper: e.options.className.wrapper || "",
      handle: e.options.className.handle || "",
      resizing: e.options.className.resizing || ""
    }), (o = e.options) != null && o.createCustomHandle && (this.createCustomHandle = e.options.createCustomHandle), this.wrapper = this.createWrapper(), this.container = this.createContainer(), this.applyInitialSize(), this.attachHandles(), this.editor.on("update", this.handleEditorUpdate.bind(this));
  }
  /**
   * Returns the top-level DOM node that should be placed in the editor.
   *
   * This is required by the ProseMirror NodeView interface. The container
   * includes the wrapper, handles, and the actual content element.
   *
   * @returns The container element to be inserted into the editor
   */
  get dom() {
    return this.container;
  }
  get contentDOM() {
    var e;
    return (e = this.contentElement) != null ? e : null;
  }
  handleEditorUpdate() {
    const e = this.editor.isEditable;
    e !== this.lastEditableState && (this.lastEditableState = e, e ? e && this.handleMap.size === 0 && this.attachHandles() : this.removeHandles());
  }
  /**
   * Called when the node's content or attributes change.
   *
   * Updates the internal node reference. If a custom `onUpdate` callback
   * was provided, it will be called to handle additional update logic.
   *
   * @param node - The new/updated node
   * @param decorations - Node decorations
   * @param innerDecorations - Inner decorations
   * @returns `false` if the node type has changed (requires full rebuild), otherwise the result of `onUpdate` or `true`
   */
  update(e, n, t) {
    return e.type !== this.node.type ? !1 : (this.node = e, this.onUpdate ? this.onUpdate(e, n, t) : !0);
  }
  /**
   * Cleanup method called when the node view is being removed.
   *
   * Removes all event listeners to prevent memory leaks. This is required
   * by the ProseMirror NodeView interface. If a resize is active when
   * destroy is called, it will be properly cancelled.
   */
  destroy() {
    this.isResizing && (this.container.dataset.resizeState = "false", this.classNames.resizing && this.container.classList.remove(this.classNames.resizing), document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp), this.isResizing = !1, this.activeHandle = null), this.editor.off("update", this.handleEditorUpdate.bind(this)), this.container.remove();
  }
  /**
   * Creates the outer container element.
   *
   * The container is the top-level element returned by the NodeView and
   * wraps the entire resizable node. It's set up with flexbox to handle
   * alignment and includes data attributes for styling and identification.
   *
   * @returns The container element
   */
  createContainer() {
    const e = document.createElement("div");
    return e.dataset.resizeContainer = "", e.dataset.node = this.node.type.name, e.style.display = this.node.type.isInline ? "inline-flex" : "flex", this.classNames.container && (e.className = this.classNames.container), e.appendChild(this.wrapper), e;
  }
  /**
   * Creates the wrapper element that contains the content and handles.
   *
   * The wrapper uses relative positioning so that resize handles can be
   * positioned absolutely within it. This is the direct parent of the
   * content element being made resizable.
   *
   * @returns The wrapper element
   */
  createWrapper() {
    const e = document.createElement("div");
    return e.style.position = "relative", e.style.display = "block", e.dataset.resizeWrapper = "", this.classNames.wrapper && (e.className = this.classNames.wrapper), e.appendChild(this.element), e;
  }
  /**
   * Creates a resize handle element for a specific direction.
   *
   * Each handle is absolutely positioned and includes a data attribute
   * identifying its direction for styling purposes.
   *
   * @param direction - The resize direction for this handle
   * @returns The handle element
   */
  createHandle(e) {
    const n = document.createElement("div");
    return n.dataset.resizeHandle = e, n.style.position = "absolute", this.classNames.handle && (n.className = this.classNames.handle), n;
  }
  /**
   * Positions a handle element according to its direction.
   *
   * Corner handles (e.g., 'top-left') are positioned at the intersection
   * of two edges. Edge handles (e.g., 'top') span the full width or height.
   *
   * @param handle - The handle element to position
   * @param direction - The direction determining the position
   */
  positionHandle(e, n) {
    const t = n.includes("top"), a = n.includes("bottom"), l = n.includes("left"), r = n.includes("right");
    t && (e.style.top = "0"), a && (e.style.bottom = "0"), l && (e.style.left = "0"), r && (e.style.right = "0"), (n === "top" || n === "bottom") && (e.style.left = "0", e.style.right = "0"), (n === "left" || n === "right") && (e.style.top = "0", e.style.bottom = "0");
  }
  /**
   * Creates and attaches all resize handles to the wrapper.
   *
   * Iterates through the configured directions, creates a handle for each,
   * positions it, attaches the mousedown listener, and appends it to the DOM.
   */
  attachHandles() {
    this.directions.forEach((e) => {
      let n;
      this.createCustomHandle ? n = this.createCustomHandle(e) : n = this.createHandle(e), n instanceof HTMLElement || (console.warn(
        `[ResizableNodeView] createCustomHandle("${e}") did not return an HTMLElement. Falling back to default handle.`
      ), n = this.createHandle(e)), this.createCustomHandle || this.positionHandle(n, e), n.addEventListener("mousedown", (t) => this.handleResizeStart(t, e)), n.addEventListener("touchstart", (t) => this.handleResizeStart(t, e)), this.handleMap.set(e, n), this.wrapper.appendChild(n);
    });
  }
  /**
   * Removes all resize handles from the wrapper.
   *
   * Cleans up the handle map and removes each handle element from the DOM.
   */
  removeHandles() {
    this.handleMap.forEach((e) => e.remove()), this.handleMap.clear();
  }
  /**
   * Applies initial sizing from node attributes to the element.
   *
   * If width/height attributes exist on the node, they're applied to the element.
   * Otherwise, the element's natural/current dimensions are measured. The aspect
   * ratio is calculated for later use in aspect-ratio-preserving resizes.
   */
  applyInitialSize() {
    const e = this.node.attrs.width, n = this.node.attrs.height;
    e ? (this.element.style.width = `${e}px`, this.initialWidth = e) : this.initialWidth = this.element.offsetWidth, n ? (this.element.style.height = `${n}px`, this.initialHeight = n) : this.initialHeight = this.element.offsetHeight, this.initialWidth > 0 && this.initialHeight > 0 && (this.aspectRatio = this.initialWidth / this.initialHeight);
  }
  /**
   * Initiates a resize operation when a handle is clicked.
   *
   * Captures the starting mouse position and element dimensions, sets up
   * the resize state, adds the resizing class and state attribute, and
   * attaches document-level listeners for mouse movement and keyboard input.
   *
   * @param event - The mouse down event
   * @param direction - The direction of the handle being dragged
   */
  handleResizeStart(e, n) {
    e.preventDefault(), e.stopPropagation(), this.isResizing = !0, this.activeHandle = n, cE(e) ? (this.startX = e.touches[0].clientX, this.startY = e.touches[0].clientY) : (this.startX = e.clientX, this.startY = e.clientY), this.startWidth = this.element.offsetWidth, this.startHeight = this.element.offsetHeight, this.startWidth > 0 && this.startHeight > 0 && (this.aspectRatio = this.startWidth / this.startHeight), this.getPos(), this.container.dataset.resizeState = "true", this.classNames.resizing && this.container.classList.add(this.classNames.resizing), document.addEventListener("mousemove", this.handleMouseMove), document.addEventListener("touchmove", this.handleTouchMove), document.addEventListener("mouseup", this.handleMouseUp), document.addEventListener("keydown", this.handleKeyDown), document.addEventListener("keyup", this.handleKeyUp);
  }
  handleResize(e, n) {
    if (!this.activeHandle)
      return;
    const t = this.preserveAspectRatio || this.isShiftKeyPressed, { width: a, height: l } = this.calculateNewDimensions(this.activeHandle, e, n), r = this.applyConstraints(a, l, t);
    this.element.style.width = `${r.width}px`, this.element.style.height = `${r.height}px`, this.onResize && this.onResize(r.width, r.height);
  }
  /**
   * Calculates new dimensions based on mouse delta and resize direction.
   *
   * Takes the starting dimensions and applies the mouse movement delta
   * according to the handle direction. For corner handles, both dimensions
   * are affected. For edge handles, only one dimension changes. If aspect
   * ratio should be preserved, delegates to applyAspectRatio.
   *
   * @param direction - The active resize handle direction
   * @param deltaX - Horizontal mouse movement since resize start
   * @param deltaY - Vertical mouse movement since resize start
   * @returns The calculated width and height
   */
  calculateNewDimensions(e, n, t) {
    let a = this.startWidth, l = this.startHeight;
    const r = e.includes("right"), o = e.includes("left"), i = e.includes("bottom"), s = e.includes("top");
    return r ? a = this.startWidth + n : o && (a = this.startWidth - n), i ? l = this.startHeight + t : s && (l = this.startHeight - t), (e === "right" || e === "left") && (a = this.startWidth + (r ? n : -n)), (e === "top" || e === "bottom") && (l = this.startHeight + (i ? t : -t)), this.preserveAspectRatio || this.isShiftKeyPressed ? this.applyAspectRatio(a, l, e) : { width: a, height: l };
  }
  /**
   * Applies min/max constraints to dimensions.
   *
   * When aspect ratio is NOT preserved, constraints are applied independently
   * to width and height. When aspect ratio IS preserved, constraints are
   * applied while maintaining the aspect ratio—if one dimension hits a limit,
   * the other is recalculated proportionally.
   *
   * This ensures that aspect ratio is never broken when constrained.
   *
   * @param width - The unconstrained width
   * @param height - The unconstrained height
   * @param preserveAspectRatio - Whether to maintain aspect ratio while constraining
   * @returns The constrained dimensions
   */
  applyConstraints(e, n, t) {
    var a, l, r, o;
    if (!t) {
      let d = Math.max(this.minSize.width, e), u = Math.max(this.minSize.height, n);
      return (a = this.maxSize) != null && a.width && (d = Math.min(this.maxSize.width, d)), (l = this.maxSize) != null && l.height && (u = Math.min(this.maxSize.height, u)), { width: d, height: u };
    }
    let i = e, s = n;
    return i < this.minSize.width && (i = this.minSize.width, s = i / this.aspectRatio), s < this.minSize.height && (s = this.minSize.height, i = s * this.aspectRatio), (r = this.maxSize) != null && r.width && i > this.maxSize.width && (i = this.maxSize.width, s = i / this.aspectRatio), (o = this.maxSize) != null && o.height && s > this.maxSize.height && (s = this.maxSize.height, i = s * this.aspectRatio), { width: i, height: s };
  }
  /**
   * Adjusts dimensions to maintain the original aspect ratio.
   *
   * For horizontal handles (left/right), uses width as the primary dimension
   * and calculates height from it. For vertical handles (top/bottom), uses
   * height as primary and calculates width. For corner handles, uses width
   * as the primary dimension.
   *
   * @param width - The new width
   * @param height - The new height
   * @param direction - The active resize direction
   * @returns Dimensions adjusted to preserve aspect ratio
   */
  applyAspectRatio(e, n, t) {
    const a = t === "left" || t === "right", l = t === "top" || t === "bottom";
    return a ? {
      width: e,
      height: e / this.aspectRatio
    } : l ? {
      width: n * this.aspectRatio,
      height: n
    } : {
      width: e,
      height: e / this.aspectRatio
    };
  }
};
function hE(e, n) {
  const { selection: t } = e, { $from: a } = t;
  if (t instanceof tt) {
    const r = a.index();
    return a.parent.canReplaceWith(r, r + 1, n);
  }
  let l = a.depth;
  for (; l >= 0; ) {
    const r = a.index(l);
    if (a.node(l).contentMatchAt(r).matchType(n))
      return !0;
    l -= 1;
  }
  return !1;
}
function rr(e, n) {
  const t = e.getAttribute("style");
  if (!t)
    return null;
  const a = t.split(";").map((r) => r.trim()).filter(Boolean), l = n.toLowerCase();
  for (let r = a.length - 1; r >= 0; r -= 1) {
    const o = a[r], i = o.indexOf(":");
    if (i === -1)
      continue;
    if (o.slice(0, i).trim().toLowerCase() === l)
      return o.slice(i + 1).trim();
  }
  return null;
}
var bE = {};
xc(bE, {
  createAtomBlockMarkdownSpec: () => gE,
  createBlockMarkdownSpec: () => mE,
  createInlineMarkdownSpec: () => xE,
  parseAttributes: () => Ic,
  parseIndentedBlocks: () => lu,
  renderNestedMarkdownContent: () => Tc,
  serializeAttributes: () => Lc
});
function Ic(e) {
  if (!(e != null && e.trim()))
    return {};
  const n = {}, t = [], a = e.replace(/["']([^"']*)["']/g, (d) => (t.push(d), `__QUOTED_${t.length - 1}__`)), l = a.match(/(?:^|\s)\.([a-zA-Z][\w-]*)/g);
  if (l) {
    const d = l.map((u) => u.trim().slice(1));
    n.class = d.join(" ");
  }
  const r = a.match(/(?:^|\s)#([a-zA-Z][\w-]*)/);
  r && (n.id = r[1]);
  const o = /([a-zA-Z][\w-]*)\s*=\s*(__QUOTED_\d+__)/g;
  Array.from(a.matchAll(o)).forEach(([, d, u]) => {
    var f;
    const b = parseInt(((f = u.match(/__QUOTED_(\d+)__/)) == null ? void 0 : f[1]) || "0", 10), h = t[b];
    h && (n[d] = h.slice(1, -1));
  });
  const s = a.replace(/(?:^|\s)\.([a-zA-Z][\w-]*)/g, "").replace(/(?:^|\s)#([a-zA-Z][\w-]*)/g, "").replace(/([a-zA-Z][\w-]*)\s*=\s*__QUOTED_\d+__/g, "").trim();
  return s && s.split(/\s+/).filter(Boolean).forEach((u) => {
    u.match(/^[a-zA-Z][\w-]*$/) && (n[u] = !0);
  }), n;
}
function Lc(e) {
  if (!e || Object.keys(e).length === 0)
    return "";
  const n = [];
  return e.class && String(e.class).split(/\s+/).filter(Boolean).forEach((a) => n.push(`.${a}`)), e.id && n.push(`#${e.id}`), Object.entries(e).forEach(([t, a]) => {
    t === "class" || t === "id" || (a === !0 ? n.push(t) : a !== !1 && a != null && n.push(`${t}="${String(a)}"`));
  }), n.join(" ");
}
function gE(e) {
  const {
    nodeName: n,
    name: t,
    parseAttributes: a = Ic,
    serializeAttributes: l = Lc,
    defaultAttributes: r = {},
    requiredAttributes: o = [],
    allowedAttributes: i
  } = e, s = t || n, d = (u) => {
    if (!i)
      return u;
    const f = {};
    return i.forEach((b) => {
      b in u && (f[b] = u[b]);
    }), f;
  };
  return {
    parseMarkdown: (u, f) => {
      const b = { ...r, ...u.attributes };
      return f.createNode(n, b, []);
    },
    markdownTokenizer: {
      name: n,
      level: "block",
      start(u) {
        var f;
        const b = new RegExp(`^:::${s}(?:\\s|$)`, "m"), h = (f = u.match(b)) == null ? void 0 : f.index;
        return h !== void 0 ? h : -1;
      },
      tokenize(u, f, b) {
        const h = new RegExp(`^:::${s}(?:\\s+\\{([^}]*)\\})?\\s*:::(?:\\n|$)`), p = u.match(h);
        if (!p)
          return;
        const x = p[1] || "", y = a(x);
        if (!o.find(($) => !($ in y)))
          return {
            type: n,
            raw: p[0],
            attributes: y
          };
      }
    },
    renderMarkdown: (u) => {
      const f = d(u.attrs || {}), b = l(f), h = b ? ` {${b}}` : "";
      return `:::${s}${h} :::`;
    }
  };
}
function mE(e) {
  const {
    nodeName: n,
    name: t,
    getContent: a,
    parseAttributes: l = Ic,
    serializeAttributes: r = Lc,
    defaultAttributes: o = {},
    content: i = "block",
    allowedAttributes: s
  } = e, d = t || n, u = (f) => {
    if (!s)
      return f;
    const b = {};
    return s.forEach((h) => {
      h in f && (b[h] = f[h]);
    }), b;
  };
  return {
    parseMarkdown: (f, b) => {
      let h;
      if (a) {
        const x = a(f);
        h = typeof x == "string" ? [{ type: "text", text: x }] : x;
      } else i === "block" ? h = b.parseChildren(f.tokens || []) : h = b.parseInline(f.tokens || []);
      const p = { ...o, ...f.attributes };
      return b.createNode(n, p, h);
    },
    markdownTokenizer: {
      name: n,
      level: "block",
      start(f) {
        var b;
        const h = new RegExp(`^:::${d}`, "m"), p = (b = f.match(h)) == null ? void 0 : b.index;
        return p !== void 0 ? p : -1;
      },
      tokenize(f, b, h) {
        var p;
        const x = new RegExp(`^:::${d}(?:\\s+\\{([^}]*)\\})?\\s*\\n`), y = f.match(x);
        if (!y)
          return;
        const [k, $ = ""] = y, S = l($);
        let T = 1;
        const I = k.length;
        let A = "";
        const E = /^:::([\w-]*)(\s.*)?/gm, D = f.slice(I);
        for (E.lastIndex = 0; ; ) {
          const z = E.exec(D);
          if (z === null)
            break;
          const Y = z.index, le = z[1];
          if (!((p = z[2]) != null && p.endsWith(":::"))) {
            if (le)
              T += 1;
            else if (T -= 1, T === 0) {
              const ne = D.slice(0, Y);
              A = ne.trim();
              const re = f.slice(0, I + Y + z[0].length);
              let O = [];
              if (A)
                if (i === "block")
                  for (O = h.blockTokens(ne), O.forEach((P) => {
                    P.text && (!P.tokens || P.tokens.length === 0) && (P.tokens = h.inlineTokens(P.text));
                  }); O.length > 0; ) {
                    const P = O[O.length - 1];
                    if (P.type === "paragraph" && (!P.text || P.text.trim() === ""))
                      O.pop();
                    else
                      break;
                  }
                else
                  O = h.inlineTokens(A);
              return {
                type: n,
                raw: re,
                attributes: S,
                content: A,
                tokens: O
              };
            }
          }
        }
      }
    },
    renderMarkdown: (f, b) => {
      const h = u(f.attrs || {}), p = r(h), x = p ? ` {${p}}` : "", y = b.renderChildren(f.content || [], `

`);
      return `:::${d}${x}

${y}

:::`;
    }
  };
}
function pE(e) {
  if (!e.trim())
    return {};
  const n = {}, t = /(\w+)=(?:"([^"]*)"|'([^']*)')/g;
  let a = t.exec(e);
  for (; a !== null; ) {
    const [, l, r, o] = a;
    n[l] = r || o, a = t.exec(e);
  }
  return n;
}
function vE(e) {
  return Object.entries(e).filter(([, n]) => n != null).map(([n, t]) => `${n}="${t}"`).join(" ");
}
function xE(e) {
  const {
    nodeName: n,
    name: t,
    getContent: a,
    parseAttributes: l = pE,
    serializeAttributes: r = vE,
    defaultAttributes: o = {},
    selfClosing: i = !1,
    allowedAttributes: s
  } = e, d = t || n, u = (b) => {
    if (!s)
      return b;
    const h = {};
    return s.forEach((p) => {
      const x = typeof p == "string" ? p : p.name, y = typeof p == "string" ? void 0 : p.skipIfDefault;
      if (x in b) {
        const k = b[x];
        if (y !== void 0 && k === y)
          return;
        h[x] = k;
      }
    }), h;
  }, f = d.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return {
    parseMarkdown: (b, h) => {
      const p = { ...o, ...b.attributes };
      if (i)
        return h.createNode(n, p);
      const x = a ? a(b) : b.content || "";
      return x ? h.createNode(n, p, [h.createTextNode(x)]) : h.createNode(n, p, []);
    },
    markdownTokenizer: {
      name: n,
      level: "inline",
      start(b) {
        const h = i ? new RegExp(`\\[${f}\\s*[^\\]]*\\]`) : new RegExp(`\\[${f}\\s*[^\\]]*\\][\\s\\S]*?\\[\\/${f}\\]`), p = b.match(h), x = p == null ? void 0 : p.index;
        return x !== void 0 ? x : -1;
      },
      tokenize(b, h, p) {
        const x = i ? new RegExp(`^\\[${f}\\s*([^\\]]*)\\]`) : new RegExp(`^\\[${f}\\s*([^\\]]*)\\]([\\s\\S]*?)\\[\\/${f}\\]`), y = b.match(x);
        if (!y)
          return;
        let k = "", $ = "";
        if (i) {
          const [, T] = y;
          $ = T;
        } else {
          const [, T, I] = y;
          $ = T, k = I || "";
        }
        const S = l($.trim());
        return {
          type: n,
          raw: y[0],
          content: k.trim(),
          attributes: S
        };
      }
    },
    renderMarkdown: (b) => {
      let h = "";
      a ? h = a(b) : b.content && b.content.length > 0 && (h = b.content.filter((k) => k.type === "text").map((k) => k.text).join(""));
      const p = u(b.attrs || {}), x = r(p), y = x ? ` ${x}` : "";
      return i ? `[${d}${y}]` : `[${d}${y}]${h}[/${d}]`;
    }
  };
}
function lu(e, n, t) {
  var a, l, r, o;
  const i = e.split(`
`), s = [];
  let d = "", u = 0;
  const f = n.baseIndentSize || 2;
  for (; u < i.length; ) {
    const b = i[u], h = b.match(n.itemPattern);
    if (!h) {
      if (s.length > 0)
        break;
      if (b.trim() === "") {
        u += 1, d = `${d}${b}
`;
        continue;
      } else
        return;
    }
    const p = n.extractItemData(h), { indentLevel: x, mainContent: y } = p;
    d = `${d}${b}
`;
    const k = [y];
    for (u += 1; u < i.length; ) {
      const I = i[u];
      if (I.trim() === "") {
        const E = i.slice(u + 1).findIndex((Y) => Y.trim() !== "");
        if (E === -1)
          break;
        if ((((l = (a = i[u + 1 + E].match(/^(\s*)/)) == null ? void 0 : a[1]) == null ? void 0 : l.length) || 0) > x) {
          k.push(I), d = `${d}${I}
`, u += 1;
          continue;
        } else
          break;
      }
      if ((((o = (r = I.match(/^(\s*)/)) == null ? void 0 : r[1]) == null ? void 0 : o.length) || 0) > x)
        k.push(I), d = `${d}${I}
`, u += 1;
      else
        break;
    }
    let $;
    const S = k.slice(1);
    if (S.length > 0) {
      const I = S.map((A) => A.slice(x + f)).join(`
`);
      I.trim() && (n.customNestedParser ? $ = n.customNestedParser(I) : $ = t.blockTokens(I));
    }
    const T = n.createToken(p, $);
    s.push(T);
  }
  if (s.length !== 0)
    return {
      items: s,
      raw: d
    };
}
function Tc(e, n, t, a) {
  if (!e || !Array.isArray(e.content))
    return "";
  const l = typeof t == "function" ? t(a) : t, [r, ...o] = e.content, i = n.renderChildren([r]);
  let s = `${l}${i}`;
  return o && o.length > 0 && o.forEach((d, u) => {
    var f, b;
    const h = (b = (f = n.renderChild) == null ? void 0 : f.call(n, d, u + 1)) != null ? b : n.renderChildren([d]);
    if (h != null) {
      const p = h.split(`
`).map((x) => x ? n.indent(x) : n.indent("")).join(`
`);
      s += d.type === "paragraph" ? `

${p}` : `
${p}`;
    }
  }), s;
}
function yE(e, n, t = {}) {
  const { state: a } = n, { doc: l, tr: r } = a, o = e;
  l.descendants((i, s) => {
    const d = r.mapping.map(s), u = r.mapping.map(s) + i.nodeSize;
    let f = null;
    if (i.marks.forEach((h) => {
      if (h !== o)
        return !1;
      f = h;
    }), !f)
      return;
    let b = !1;
    if (Object.keys(t).forEach((h) => {
      t[h] !== f.attrs[h] && (b = !0);
    }), b) {
      const h = e.type.create({
        ...e.attrs,
        ...t
      });
      r.removeMark(d, u, e.type), r.addMark(d, u, h);
    }
  }), r.docChanged && n.view.dispatch(r);
}
var xn = class tv extends $c {
  constructor() {
    super(...arguments), this.type = "node";
  }
  /**
   * Create a new Node instance
   * @param config - Node configuration object or a function that returns a configuration object
   */
  static create(n = {}) {
    const t = typeof n == "function" ? n() : n;
    return new tv(t);
  }
  configure(n) {
    return super.configure(n);
  }
  extend(n) {
    const t = typeof n == "function" ? n() : n;
    return super.extend(t);
  }
};
function Ga(e) {
  return new tE({
    find: e.find,
    handler: ({ state: n, range: t, match: a, pasteEvent: l }) => {
      const r = xt(e.getAttributes, void 0, a, l);
      if (r === !1 || r === null)
        return null;
      const { tr: o } = n, i = a[a.length - 1], s = a[0];
      let d = t.to;
      if (i) {
        const u = s.search(/\S/), f = t.from + s.indexOf(i), b = f + i.length;
        if (Sc(t.from, t.to, n.doc).filter((x) => x.mark.type.excluded.find((k) => k === e.type && k !== x.mark.type)).filter((x) => x.to > f).length)
          return null;
        b < t.to && o.delete(b, t.to), f > t.from && o.delete(t.from + u, f), d = t.from + u + i.length, o.addMark(t.from + u, d, e.type.create(r || {})), a.index !== void 0 && a.input !== void 0 && a.index + a[0].length >= a.input.length || o.removeStoredMark(e.type);
      }
    }
  });
}
function Hh(e) {
  return Ex((n, t) => ({
    get() {
      return n(), e;
    },
    set(a) {
      e = a, requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          t();
        });
      });
    }
  }));
}
var kE = class extends uE {
  constructor(e = {}) {
    return super(e), this.contentComponent = null, this.appContext = null, this.reactiveState = Hh(this.view.state), this.reactiveExtensionStorage = Hh(this.extensionStorage), this.on("beforeTransaction", ({ nextState: n }) => {
      this.reactiveState.value = n, this.reactiveExtensionStorage.value = this.extensionStorage;
    }), Ax(this);
  }
  get state() {
    return this.reactiveState ? this.reactiveState.value : this.view.state;
  }
  get storage() {
    return this.reactiveExtensionStorage ? this.reactiveExtensionStorage.value : super.storage;
  }
  /**
   * Register a ProseMirror plugin.
   */
  registerPlugin(e, n) {
    const t = super.registerPlugin(e, n);
    return this.reactiveState && (this.reactiveState.value = t), t;
  }
  /**
   * Unregister a ProseMirror plugin.
   */
  unregisterPlugin(e) {
    const n = super.unregisterPlugin(e);
    return this.reactiveState && n && (this.reactiveState.value = n), n;
  }
}, wE = ye({
  name: "EditorContent",
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  setup(e) {
    const n = R(), t = Eu();
    return Kb(() => {
      const a = e.editor;
      a && a.options.element && n.value && Ge(() => {
        var l;
        if (!n.value || !((l = a.view.dom) != null && l.parentNode))
          return;
        const r = L(n.value);
        n.value.append(...a.view.dom.parentNode.childNodes), a.contentComponent = t.ctx._, t && (a.appContext = {
          ...t.appContext,
          // Vue internally uses prototype chain to forward/shadow injects across the entire component chain
          // so don't use object spread operator or 'Object.assign' and just set `provides` as is on editor's appContext
          // @ts-expect-error forward instance's 'provides' into appContext
          provides: t.provides
        }), a.setOptions({
          element: r
        }), a.createNodeViews();
      });
    }), yt(() => {
      const a = e.editor;
      a && (a.contentComponent = null, a.appContext = null);
    }), { rootEl: n };
  },
  render() {
    return ea("div", {
      ref: (e) => {
        this.rootEl = e;
      }
    });
  }
});
ye({
  name: "NodeViewContent",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  render() {
    return ea(this.as, {
      style: {
        whiteSpace: "pre-wrap"
      },
      "data-node-view-content": ""
    });
  }
});
ye({
  name: "NodeViewWrapper",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  inject: ["onDragStart", "decorationClasses"],
  render() {
    var e, n;
    return ea(
      this.as,
      {
        // @ts-ignore
        class: this.decorationClasses,
        style: {
          whiteSpace: "normal"
        },
        "data-node-view-wrapper": "",
        // @ts-ignore (https://github.com/vuejs/vue-next/issues/3031)
        onDragstart: this.onDragStart
      },
      (n = (e = this.$slots).default) == null ? void 0 : n.call(e)
    );
  }
});
var CE = (e = {}) => {
  const n = er();
  return ct(() => {
    n.value = new kE(e);
  }), yt(() => {
    var t;
    (t = n.value) == null || t.destroy();
  }), n;
};
ye({
  name: "MarkViewContent",
  props: {
    as: {
      type: String,
      default: "span"
    }
  },
  render() {
    return ea(this.as, {
      style: {
        whiteSpace: "inherit"
      },
      "data-mark-view-content": ""
    });
  }
});
var Si = (e, n) => {
  if (e === "slot")
    return 0;
  if (e instanceof Function)
    return e(n);
  const { children: t, ...a } = n ?? {};
  if (e === "svg")
    throw new Error("SVG elements are not supported in the JSX syntax, use the array syntax instead");
  return [e, a, t];
}, SE = /^\s*>\s$/, $E = xn.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [{ tag: "blockquote" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return /* @__PURE__ */ Si("blockquote", { ...Rt(this.options.HTMLAttributes, e), children: /* @__PURE__ */ Si("slot", {}) });
  },
  parseMarkdown: (e, n) => {
    var t;
    const a = (t = n.parseBlockChildren) != null ? t : n.parseChildren;
    return n.createNode("blockquote", void 0, a(e.tokens || []));
  },
  renderMarkdown: (e, n) => {
    if (!e.content)
      return "";
    const t = ">", a = [];
    return e.content.forEach((l, r) => {
      var o, i;
      const u = ((i = (o = n.renderChild) == null ? void 0 : o.call(n, l, r)) != null ? i : n.renderChildren([l])).split(`
`).map((f) => f.trim() === "" ? t : `${t} ${f}`);
      a.push(u.join(`
`));
    }), a.join(`
${t}
`);
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: e }) => e.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: e }) => e.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: e }) => e.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      Ql({
        find: SE,
        type: this.type
      })
    ];
  }
}), IE = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, LE = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, TE = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, AE = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, EE = Ca.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (e) => e.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (e) => e.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (e) => /^(bold(er)?|[5-9]\d{2,})$/.test(e) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return /* @__PURE__ */ Si("strong", { ...Rt(this.options.HTMLAttributes, e), children: /* @__PURE__ */ Si("slot", {}) });
  },
  markdownTokenName: "strong",
  parseMarkdown: (e, n) => n.applyMark("bold", n.parseInline(e.tokens || [])),
  markdownOptions: {
    htmlReopen: {
      open: "<strong>",
      close: "</strong>"
    }
  },
  renderMarkdown: (e, n) => `**${n.renderChildren(e)}**`,
  addCommands() {
    return {
      setBold: () => ({ commands: e }) => e.setMark(this.name),
      toggleBold: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetBold: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      Cl({
        find: IE,
        type: this.type
      }),
      Cl({
        find: TE,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ga({
        find: LE,
        type: this.type
      }),
      Ga({
        find: AE,
        type: this.type
      })
    ];
  }
}), RE = /(^|[^`])`([^`]+)`(?!`)$/, BE = /(^|[^`])`([^`]+)`(?!`)/g, ME = Ca.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [{ tag: "code" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["code", Rt(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "codespan",
  parseMarkdown: (e, n) => n.applyMark("code", [{ type: "text", text: e.text || "" }]),
  renderMarkdown: (e, n) => e.content ? `\`${n.renderChildren(e.content)}\`` : "",
  addCommands() {
    return {
      setCode: () => ({ commands: e }) => e.setMark(this.name),
      toggleCode: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetCode: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      Cl({
        find: RE,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ga({
        find: BE,
        type: this.type
      })
    ];
  }
}), td = 4, DE = /^```([a-z]+)?[\s\n]$/, zE = /^~~~([a-z]+)?[\s\n]$/, OE = xn.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      enableTabIndentation: !1,
      tabSize: td,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (e) => {
          var n;
          const { languageClassPrefix: t } = this.options;
          if (!t)
            return null;
          const r = [...((n = e.firstElementChild) == null ? void 0 : n.classList) || []].filter((o) => o.startsWith(t)).map((o) => o.replace(t, ""))[0];
          return r || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: n }) {
    return [
      "pre",
      Rt(this.options.HTMLAttributes, n),
      [
        "code",
        {
          class: e.attrs.language ? this.options.languageClassPrefix + e.attrs.language : null
        },
        0
      ]
    ];
  },
  markdownTokenName: "code",
  parseMarkdown: (e, n) => {
    var t, a;
    return ((t = e.raw) == null ? void 0 : t.startsWith("```")) === !1 && ((a = e.raw) == null ? void 0 : a.startsWith("~~~")) === !1 && e.codeBlockStyle !== "indented" ? [] : n.createNode(
      "codeBlock",
      { language: e.lang || null },
      e.text ? [n.createTextNode(e.text)] : []
    );
  },
  renderMarkdown: (e, n) => {
    var t;
    let a = "";
    const l = ((t = e.attrs) == null ? void 0 : t.language) || "";
    return e.content ? a = [`\`\`\`${l}`, n.renderChildren(e.content), "```"].join(`
`) : a = `\`\`\`${l}

\`\`\``, a;
  },
  addCommands() {
    return {
      setCodeBlock: (e) => ({ commands: n }) => n.setNode(this.name, e),
      toggleCodeBlock: (e) => ({ commands: n }) => n.toggleNode(this.name, "paragraph", e)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: e, $anchor: n } = this.editor.state.selection, t = n.pos === 1;
        return !e || n.parent.type.name !== this.name ? !1 : t || !n.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // handle tab indentation
      Tab: ({ editor: e }) => {
        var n;
        if (!this.options.enableTabIndentation)
          return !1;
        const t = (n = this.options.tabSize) != null ? n : td, { state: a } = e, { selection: l } = a, { $from: r, empty: o } = l;
        if (r.parent.type !== this.type)
          return !1;
        const i = " ".repeat(t);
        return o ? e.commands.insertContent(i) : e.commands.command(({ tr: s }) => {
          const { from: d, to: u } = l, h = a.doc.textBetween(d, u, `
`, `
`).split(`
`).map((p) => i + p).join(`
`);
          return s.replaceWith(d, u, a.schema.text(h)), !0;
        });
      },
      // handle shift+tab reverse indentation
      "Shift-Tab": ({ editor: e }) => {
        var n;
        if (!this.options.enableTabIndentation)
          return !1;
        const t = (n = this.options.tabSize) != null ? n : td, { state: a } = e, { selection: l } = a, { $from: r, empty: o } = l;
        return r.parent.type !== this.type ? !1 : o ? e.commands.command(({ tr: i }) => {
          var s;
          const { pos: d } = r, u = r.start(), f = r.end(), h = a.doc.textBetween(u, f, `
`, `
`).split(`
`);
          let p = 0, x = 0;
          const y = d - u;
          for (let A = 0; A < h.length; A += 1) {
            if (x + h[A].length >= y) {
              p = A;
              break;
            }
            x += h[A].length + 1;
          }
          const $ = ((s = h[p].match(/^ */)) == null ? void 0 : s[0]) || "", S = Math.min($.length, t);
          if (S === 0)
            return !0;
          let T = u;
          for (let A = 0; A < p; A += 1)
            T += h[A].length + 1;
          return i.delete(T, T + S), d - T <= S && i.setSelection(rt.create(i.doc, T)), !0;
        }) : e.commands.command(({ tr: i }) => {
          const { from: s, to: d } = l, b = a.doc.textBetween(s, d, `
`, `
`).split(`
`).map((h) => {
            var p;
            const x = ((p = h.match(/^ */)) == null ? void 0 : p[0]) || "", y = Math.min(x.length, t);
            return h.slice(y);
          }).join(`
`);
          return i.replaceWith(s, d, a.schema.text(b)), !0;
        });
      },
      // exit node on triple enter
      Enter: ({ editor: e }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: n } = e, { selection: t } = n, { $from: a, empty: l } = t;
        if (!l || a.parent.type !== this.type)
          return !1;
        const r = a.parentOffset === a.parent.nodeSize - 2, o = a.parent.textContent.endsWith(`

`);
        return !r || !o ? !1 : e.chain().command(({ tr: i }) => (i.delete(a.pos - 2, a.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: e }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: n } = e, { selection: t, doc: a } = n, { $from: l, empty: r } = t;
        if (!r || l.parent.type !== this.type || !(l.parentOffset === l.parent.nodeSize - 2))
          return !1;
        const i = l.after();
        return i === void 0 ? !1 : a.nodeAt(i) ? e.commands.command(({ tr: d }) => (d.setSelection(st.near(a.resolve(i))), !0)) : e.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      au({
        find: DE,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      }),
      au({
        find: zE,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new Bt({
        key: new qt("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (e, n) => {
            if (!n.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const t = n.clipboardData.getData("text/plain"), a = n.clipboardData.getData("vscode-editor-data"), l = a ? JSON.parse(a) : void 0, r = l == null ? void 0 : l.mode;
            if (!t || !r)
              return !1;
            const { tr: o, schema: i } = e.state, s = i.text(t.replace(/\r\n?/g, `
`));
            return o.replaceSelectionWith(this.type.create({ language: r }, s)), o.selection.$from.parent.type !== this.type && o.setSelection(rt.near(o.doc.resolve(Math.max(0, o.selection.from - 2)))), o.setMeta("paste", !0), e.dispatch(o), !0;
          }
        }
      })
    ];
  }
}), PE = xn.create({
  name: "doc",
  topNode: !0,
  content: "block+",
  renderMarkdown: (e, n) => e.content ? n.renderChildren(e.content, `

`) : ""
}), FE = xn.create({
  name: "hardBreak",
  markdownTokenName: "br",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [{ tag: "br" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["br", Rt(this.options.HTMLAttributes, e)];
  },
  renderText() {
    return `
`;
  },
  renderMarkdown: () => `  
`,
  parseMarkdown: () => ({
    type: "hardBreak"
  }),
  addCommands() {
    return {
      setHardBreak: () => ({ commands: e, chain: n, state: t, editor: a }) => e.first([
        () => e.exitCode(),
        () => e.command(() => {
          const { selection: l, storedMarks: r } = t;
          if (l.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: o } = this.options, { splittableMarks: i } = a.extensionManager, s = r || l.$to.parentOffset && l.$from.marks();
          return n().insertContent({ type: this.name }).command(({ tr: d, dispatch: u }) => {
            if (u && s && o) {
              const f = s.filter((b) => i.includes(b.type.name));
              d.ensureMarks(f);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), VE = xn.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((e) => ({
      tag: `h${e}`,
      attrs: { level: e }
    }));
  },
  renderHTML({ node: e, HTMLAttributes: n }) {
    return [`h${this.options.levels.includes(e.attrs.level) ? e.attrs.level : this.options.levels[0]}`, Rt(this.options.HTMLAttributes, n), 0];
  },
  parseMarkdown: (e, n) => n.createNode("heading", { level: e.depth || 1 }, n.parseInline(e.tokens || [])),
  renderMarkdown: (e, n) => {
    var t;
    const a = (t = e.attrs) != null && t.level ? parseInt(e.attrs.level, 10) : 1, l = "#".repeat(a);
    return e.content ? `${l} ${n.renderChildren(e.content)}` : "";
  },
  addCommands() {
    return {
      setHeading: (e) => ({ commands: n }) => this.options.levels.includes(e.level) ? n.setNode(this.name, e) : !1,
      toggleHeading: (e) => ({ commands: n }) => this.options.levels.includes(e.level) ? n.toggleNode(this.name, "paragraph", e) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce(
      (e, n) => ({
        ...e,
        [`Mod-Alt-${n}`]: () => this.editor.commands.toggleHeading({ level: n })
      }),
      {}
    );
  },
  addInputRules() {
    return this.options.levels.map((e) => au({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${e}})\\s$`),
      type: this.type,
      getAttributes: {
        level: e
      }
    }));
  }
}), NE = xn.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {},
      nextNodeType: "paragraph"
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["hr", Rt(this.options.HTMLAttributes, e)];
  },
  markdownTokenName: "hr",
  parseMarkdown: (e, n) => n.createNode("horizontalRule"),
  renderMarkdown: () => "---",
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: e, state: n }) => {
        if (!hE(n, n.schema.nodes[this.name]))
          return !1;
        const { selection: t } = n, { $to: a } = t, l = e();
        return Pp(t) ? l.insertContentAt(a.pos, {
          type: this.name
        }) : l.insertContent({ type: this.name }), l.command(({ state: r, tr: o, dispatch: i }) => {
          if (i) {
            const { $to: s } = o.selection, d = s.end();
            if (s.nodeAfter)
              s.nodeAfter.isTextblock ? o.setSelection(rt.create(o.doc, s.pos + 1)) : s.nodeAfter.isBlock ? o.setSelection(tt.create(o.doc, s.pos)) : o.setSelection(rt.create(o.doc, s.pos));
            else {
              const u = r.schema.nodes[this.options.nextNodeType] || s.parent.type.contentMatch.defaultType, f = u == null ? void 0 : u.create();
              f && (o.insert(d, f), o.setSelection(rt.create(o.doc, d + 1)));
            }
            o.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      ev({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), HE = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, jE = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, WE = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, qE = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, UE = Ca.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (e) => e.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (e) => e.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["em", Rt(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: e }) => e.setMark(this.name),
      toggleItalic: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetItalic: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  markdownTokenName: "em",
  parseMarkdown: (e, n) => n.applyMark("italic", n.parseInline(e.tokens || [])),
  markdownOptions: {
    htmlReopen: {
      open: "<em>",
      close: "</em>"
    }
  },
  renderMarkdown: (e, n) => `*${n.renderChildren(e)}*`,
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      Cl({
        find: HE,
        type: this.type
      }),
      Cl({
        find: WE,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ga({
        find: jE,
        type: this.type
      }),
      Ga({
        find: qE,
        type: this.type
      })
    ];
  }
});
const GE = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2odyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rck0msd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2oodside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", KE = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", ru = "numeric", ou = "ascii", iu = "alpha", zr = "asciinumeric", $r = "alphanumeric", su = "domain", nv = "emoji", YE = "scheme", JE = "slashscheme", nd = "whitespace";
function XE(e, n) {
  return e in n || (n[e] = []), n[e];
}
function sl(e, n, t) {
  n[ru] && (n[zr] = !0, n[$r] = !0), n[ou] && (n[zr] = !0, n[iu] = !0), n[zr] && (n[$r] = !0), n[iu] && (n[$r] = !0), n[$r] && (n[su] = !0), n[nv] && (n[su] = !0);
  for (const a in n) {
    const l = XE(a, t);
    l.indexOf(e) < 0 && l.push(e);
  }
}
function ZE(e, n) {
  const t = {};
  for (const a in n)
    n[a].indexOf(e) >= 0 && (t[a] = !0);
  return t;
}
function gn(e = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = e;
}
gn.groups = {};
gn.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(e) {
    const n = this, t = n.j[e];
    if (t)
      return t;
    for (let a = 0; a < n.jr.length; a++) {
      const l = n.jr[a][0], r = n.jr[a][1];
      if (r && l.test(e))
        return r;
    }
    return n.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(e, n = !1) {
    return n ? e in this.j : !!this.go(e);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(e, n, t, a) {
    for (let l = 0; l < e.length; l++)
      this.tt(e[l], n, t, a);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(e, n, t, a) {
    a = a || gn.groups;
    let l;
    return n && n.j ? l = n : (l = new gn(n), t && a && sl(n, t, a)), this.jr.push([e, l]), l;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(e, n, t, a) {
    let l = this;
    const r = e.length;
    if (!r)
      return l;
    for (let o = 0; o < r - 1; o++)
      l = l.tt(e[o]);
    return l.tt(e[r - 1], n, t, a);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(e, n, t, a) {
    a = a || gn.groups;
    const l = this;
    if (n && n.j)
      return l.j[e] = n, n;
    const r = n;
    let o, i = l.go(e);
    if (i ? (o = new gn(), Object.assign(o.j, i.j), o.jr.push.apply(o.jr, i.jr), o.jd = i.jd, o.t = i.t) : o = new gn(), r) {
      if (a)
        if (o.t && typeof o.t == "string") {
          const s = Object.assign(ZE(o.t, a), t);
          sl(r, s, a);
        } else t && sl(r, t, a);
      o.t = r;
    }
    return l.j[e] = o, o;
  }
};
const ut = (e, n, t, a, l) => e.ta(n, t, a, l), Dt = (e, n, t, a, l) => e.tr(n, t, a, l), jh = (e, n, t, a, l) => e.ts(n, t, a, l), Ne = (e, n, t, a, l) => e.tt(n, t, a, l), fa = "WORD", du = "UWORD", av = "ASCIINUMERICAL", lv = "ALPHANUMERICAL", ro = "LOCALHOST", uu = "TLD", cu = "UTLD", ei = "SCHEME", Rl = "SLASH_SCHEME", Ac = "NUM", fu = "WS", Ec = "NL", Or = "OPENBRACE", Pr = "CLOSEBRACE", $i = "OPENBRACKET", Ii = "CLOSEBRACKET", Li = "OPENPAREN", Ti = "CLOSEPAREN", Ai = "OPENANGLEBRACKET", Ei = "CLOSEANGLEBRACKET", Ri = "FULLWIDTHLEFTPAREN", Bi = "FULLWIDTHRIGHTPAREN", Mi = "LEFTCORNERBRACKET", Di = "RIGHTCORNERBRACKET", zi = "LEFTWHITECORNERBRACKET", Oi = "RIGHTWHITECORNERBRACKET", Pi = "FULLWIDTHLESSTHAN", Fi = "FULLWIDTHGREATERTHAN", Vi = "AMPERSAND", Ni = "APOSTROPHE", Hi = "ASTERISK", La = "AT", ji = "BACKSLASH", Wi = "BACKTICK", qi = "CARET", dl = "COLON", Rc = "COMMA", Ui = "DOLLAR", Jn = "DOT", Gi = "EQUALS", Bc = "EXCLAMATION", In = "HYPHEN", Fr = "PERCENT", Ki = "PIPE", Yi = "PLUS", Ji = "POUND", Vr = "QUERY", Mc = "QUOTE", rv = "FULLWIDTHMIDDLEDOT", Dc = "SEMI", Xn = "SLASH", Nr = "TILDE", Xi = "UNDERSCORE", ov = "EMOJI", Zi = "SYM";
var iv = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ALPHANUMERICAL: lv,
  AMPERSAND: Vi,
  APOSTROPHE: Ni,
  ASCIINUMERICAL: av,
  ASTERISK: Hi,
  AT: La,
  BACKSLASH: ji,
  BACKTICK: Wi,
  CARET: qi,
  CLOSEANGLEBRACKET: Ei,
  CLOSEBRACE: Pr,
  CLOSEBRACKET: Ii,
  CLOSEPAREN: Ti,
  COLON: dl,
  COMMA: Rc,
  DOLLAR: Ui,
  DOT: Jn,
  EMOJI: ov,
  EQUALS: Gi,
  EXCLAMATION: Bc,
  FULLWIDTHGREATERTHAN: Fi,
  FULLWIDTHLEFTPAREN: Ri,
  FULLWIDTHLESSTHAN: Pi,
  FULLWIDTHMIDDLEDOT: rv,
  FULLWIDTHRIGHTPAREN: Bi,
  HYPHEN: In,
  LEFTCORNERBRACKET: Mi,
  LEFTWHITECORNERBRACKET: zi,
  LOCALHOST: ro,
  NL: Ec,
  NUM: Ac,
  OPENANGLEBRACKET: Ai,
  OPENBRACE: Or,
  OPENBRACKET: $i,
  OPENPAREN: Li,
  PERCENT: Fr,
  PIPE: Ki,
  PLUS: Yi,
  POUND: Ji,
  QUERY: Vr,
  QUOTE: Mc,
  RIGHTCORNERBRACKET: Di,
  RIGHTWHITECORNERBRACKET: Oi,
  SCHEME: ei,
  SEMI: Dc,
  SLASH: Xn,
  SLASH_SCHEME: Rl,
  SYM: Zi,
  TILDE: Nr,
  TLD: uu,
  UNDERSCORE: Xi,
  UTLD: cu,
  UWORD: du,
  WORD: fa,
  WS: fu
});
const ua = /[a-z]/, br = new RegExp("\\p{L}", "u"), ad = new RegExp("\\p{Emoji}", "u"), ca = /\d/, ld = /\s/, Wh = "\r", rd = `
`, QE = "️", _E = "‍", od = "￼";
let Do = null, zo = null;
function eR(e = []) {
  const n = {};
  gn.groups = n;
  const t = new gn();
  Do == null && (Do = qh(GE)), zo == null && (zo = qh(KE)), Ne(t, "'", Ni), Ne(t, "{", Or), Ne(t, "}", Pr), Ne(t, "[", $i), Ne(t, "]", Ii), Ne(t, "(", Li), Ne(t, ")", Ti), Ne(t, "<", Ai), Ne(t, ">", Ei), Ne(t, "（", Ri), Ne(t, "）", Bi), Ne(t, "「", Mi), Ne(t, "」", Di), Ne(t, "『", zi), Ne(t, "』", Oi), Ne(t, "＜", Pi), Ne(t, "＞", Fi), Ne(t, "&", Vi), Ne(t, "*", Hi), Ne(t, "@", La), Ne(t, "`", Wi), Ne(t, "^", qi), Ne(t, ":", dl), Ne(t, ",", Rc), Ne(t, "$", Ui), Ne(t, ".", Jn), Ne(t, "=", Gi), Ne(t, "!", Bc), Ne(t, "-", In), Ne(t, "%", Fr), Ne(t, "|", Ki), Ne(t, "+", Yi), Ne(t, "#", Ji), Ne(t, "?", Vr), Ne(t, '"', Mc), Ne(t, "/", Xn), Ne(t, ";", Dc), Ne(t, "~", Nr), Ne(t, "_", Xi), Ne(t, "\\", ji), Ne(t, "・", rv);
  const a = Dt(t, ca, Ac, {
    [ru]: !0
  });
  Dt(a, ca, a);
  const l = Dt(a, ua, av, {
    [zr]: !0
  }), r = Dt(a, br, lv, {
    [$r]: !0
  }), o = Dt(t, ua, fa, {
    [ou]: !0
  });
  Dt(o, ca, l), Dt(o, ua, o), Dt(l, ca, l), Dt(l, ua, l);
  const i = Dt(t, br, du, {
    [iu]: !0
  });
  Dt(i, ua), Dt(i, ca, r), Dt(i, br, i), Dt(r, ca, r), Dt(r, ua), Dt(r, br, r);
  const s = Ne(t, rd, Ec, {
    [nd]: !0
  }), d = Ne(t, Wh, fu, {
    [nd]: !0
  }), u = Dt(t, ld, fu, {
    [nd]: !0
  });
  Ne(t, od, u), Ne(d, rd, s), Ne(d, od, u), Dt(d, ld, u), Ne(u, Wh), Ne(u, rd), Dt(u, ld, u), Ne(u, od, u);
  const f = Dt(t, ad, ov, {
    [nv]: !0
  });
  Ne(f, "#"), Dt(f, ad, f), Ne(f, QE, f);
  const b = Ne(f, _E);
  Ne(b, "#"), Dt(b, ad, f);
  const h = [[ua, o], [ca, l]], p = [[ua, null], [br, i], [ca, r]];
  for (let x = 0; x < Do.length; x++)
    Sa(t, Do[x], uu, fa, h);
  for (let x = 0; x < zo.length; x++)
    Sa(t, zo[x], cu, du, p);
  sl(uu, {
    tld: !0,
    ascii: !0
  }, n), sl(cu, {
    utld: !0,
    alpha: !0
  }, n), Sa(t, "file", ei, fa, h), Sa(t, "mailto", ei, fa, h), Sa(t, "http", Rl, fa, h), Sa(t, "https", Rl, fa, h), Sa(t, "ftp", Rl, fa, h), Sa(t, "ftps", Rl, fa, h), sl(ei, {
    scheme: !0,
    ascii: !0
  }, n), sl(Rl, {
    slashscheme: !0,
    ascii: !0
  }, n), e = e.sort((x, y) => x[0] > y[0] ? 1 : -1);
  for (let x = 0; x < e.length; x++) {
    const y = e[x][0], $ = e[x][1] ? {
      [YE]: !0
    } : {
      [JE]: !0
    };
    y.indexOf("-") >= 0 ? $[su] = !0 : ua.test(y) ? ca.test(y) ? $[zr] = !0 : $[ou] = !0 : $[ru] = !0, jh(t, y, y, $);
  }
  return jh(t, "localhost", ro, {
    ascii: !0
  }), t.jd = new gn(Zi), {
    start: t,
    tokens: Object.assign({
      groups: n
    }, iv)
  };
}
function sv(e, n) {
  const t = tR(n.replace(/[A-Z]/g, (i) => i.toLowerCase())), a = t.length, l = [];
  let r = 0, o = 0;
  for (; o < a; ) {
    let i = e, s = null, d = 0, u = null, f = -1, b = -1;
    for (; o < a && (s = i.go(t[o])); )
      i = s, i.accepts() ? (f = 0, b = 0, u = i) : f >= 0 && (f += t[o].length, b++), d += t[o].length, r += t[o].length, o++;
    r -= f, o -= b, d -= f, l.push({
      t: u.t,
      // token type/name
      v: n.slice(r - d, r),
      // string value
      s: r - d,
      // start index
      e: r
      // end index (excluding)
    });
  }
  return l;
}
function tR(e) {
  const n = [], t = e.length;
  let a = 0;
  for (; a < t; ) {
    let l = e.charCodeAt(a), r, o = l < 55296 || l > 56319 || a + 1 === t || (r = e.charCodeAt(a + 1)) < 56320 || r > 57343 ? e[a] : e.slice(a, a + 2);
    n.push(o), a += o.length;
  }
  return n;
}
function Sa(e, n, t, a, l) {
  let r;
  const o = n.length;
  for (let i = 0; i < o - 1; i++) {
    const s = n[i];
    e.j[s] ? r = e.j[s] : (r = new gn(a), r.jr = l.slice(), e.j[s] = r), e = r;
  }
  return r = new gn(t), r.jr = l.slice(), e.j[n[o - 1]] = r, r;
}
function qh(e) {
  const n = [], t = [];
  let a = 0, l = "0123456789";
  for (; a < e.length; ) {
    let r = 0;
    for (; l.indexOf(e[a + r]) >= 0; )
      r++;
    if (r > 0) {
      n.push(t.join(""));
      for (let o = parseInt(e.substring(a, a + r), 10); o > 0; o--)
        t.pop();
      a += r;
    } else
      t.push(e[a]), a++;
  }
  return n;
}
const oo = {
  defaultProtocol: "http",
  events: null,
  format: Uh,
  formatHref: Uh,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function zc(e, n = null) {
  let t = Object.assign({}, oo);
  e && (t = Object.assign(t, e instanceof zc ? e.o : e));
  const a = t.ignoreTags, l = [];
  for (let r = 0; r < a.length; r++)
    l.push(a[r].toUpperCase());
  this.o = t, n && (this.defaultRender = n), this.ignoreTags = l;
}
zc.prototype = {
  o: oo,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(e) {
    return e;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(e) {
    return this.get("validate", e.toString(), e);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(e, n, t) {
    const a = n != null;
    let l = this.o[e];
    return l && (typeof l == "object" ? (l = t.t in l ? l[t.t] : oo[e], typeof l == "function" && a && (l = l(n, t))) : typeof l == "function" && a && (l = l(n, t.t, t)), l);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(e, n, t) {
    let a = this.o[e];
    return typeof a == "function" && n != null && (a = a(n, t.t, t)), a;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(e) {
    const n = e.render(this);
    return (this.get("render", null, e) || this.defaultRender)(n, e.t, e);
  }
};
function Uh(e) {
  return e;
}
function dv(e, n) {
  this.t = "token", this.v = e, this.tk = n;
}
dv.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(e) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(e) {
    const n = this.toString(), t = e.get("truncate", n, this), a = e.get("format", n, this);
    return t && a.length > t ? a.substring(0, t) + "…" : a;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(e) {
    return e.get("formatHref", this.toHref(e.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(e = oo.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(e) {
    return {
      type: this.t,
      value: this.toFormattedString(e),
      isLink: this.isLink,
      href: this.toFormattedHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(e) {
    return e.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(e) {
    const n = this, t = this.toHref(e.get("defaultProtocol")), a = e.get("formatHref", t, this), l = e.get("tagName", t, n), r = this.toFormattedString(e), o = {}, i = e.get("className", t, n), s = e.get("target", t, n), d = e.get("rel", t, n), u = e.getObj("attributes", t, n), f = e.getObj("events", t, n);
    return o.href = a, i && (o.class = i), s && (o.target = s), d && (o.rel = d), u && Object.assign(o, u), {
      tagName: l,
      attributes: o,
      content: r,
      eventListeners: f
    };
  }
};
function ks(e, n) {
  class t extends dv {
    constructor(l, r) {
      super(l, r), this.t = e;
    }
  }
  for (const a in n)
    t.prototype[a] = n[a];
  return t.t = e, t;
}
const nR = ks("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), Gh = ks("text"), aR = ks("nl"), Oo = ks("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(e = oo.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${e}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const e = this.tk;
    return e.length >= 2 && e[0].t !== ro && e[1].t === dl;
  }
}), $n = (e) => new gn(e);
function lR({
  groups: e
}) {
  const n = e.domain.concat([Vi, Hi, La, ji, Wi, qi, Ui, Gi, In, Ac, Fr, Ki, Yi, Ji, Xn, Zi, Nr, Xi]), t = [Ni, dl, Rc, Jn, Bc, Fr, Vr, Mc, Dc, Ai, Ei, Or, Pr, Ii, $i, Li, Ti, Ri, Bi, Mi, Di, zi, Oi, Pi, Fi], a = [Vi, Ni, Hi, ji, Wi, qi, Ui, Gi, In, Or, Pr, Fr, Ki, Yi, Ji, Vr, Xn, Zi, Nr, Xi], l = $n(), r = Ne(l, Nr);
  ut(r, a, r), ut(r, e.domain, r);
  const o = $n(), i = $n(), s = $n();
  ut(l, e.domain, o), ut(l, e.scheme, i), ut(l, e.slashscheme, s), ut(o, a, r), ut(o, e.domain, o);
  const d = Ne(o, La);
  Ne(r, La, d), Ne(i, La, d), Ne(s, La, d);
  const u = Ne(r, Jn);
  ut(u, a, r), ut(u, e.domain, r);
  const f = $n();
  ut(d, e.domain, f), ut(f, e.domain, f);
  const b = Ne(f, Jn);
  ut(b, e.domain, f);
  const h = $n(nR);
  ut(b, e.tld, h), ut(b, e.utld, h), Ne(d, ro, h);
  const p = Ne(f, In);
  Ne(p, In, p), ut(p, e.domain, f), ut(h, e.domain, f), Ne(h, Jn, b), Ne(h, In, p);
  const x = Ne(o, In), y = Ne(o, Jn);
  Ne(x, In, x), ut(x, e.domain, o), ut(y, a, r), ut(y, e.domain, o);
  const k = $n(Oo);
  ut(y, e.tld, k), ut(y, e.utld, k), ut(k, e.domain, o), ut(k, a, r), Ne(k, Jn, y), Ne(k, In, x), Ne(k, La, d);
  const $ = Ne(k, dl), S = $n(Oo);
  ut($, e.numeric, S);
  const T = $n(Oo), I = $n();
  ut(T, n, T), ut(T, t, I), ut(I, n, T), ut(I, t, I), Ne(k, Xn, T), Ne(S, Xn, T);
  const A = Ne(i, dl), E = Ne(s, dl), D = Ne(E, Xn), z = Ne(D, Xn);
  ut(i, e.domain, o), Ne(i, Jn, y), Ne(i, In, x), ut(s, e.domain, o), Ne(s, Jn, y), Ne(s, In, x), ut(A, e.domain, T), Ne(A, Xn, T), Ne(A, Vr, T), ut(z, e.domain, T), ut(z, n, T), Ne(z, Xn, T);
  const Y = [
    [Or, Pr],
    // {}
    [$i, Ii],
    // []
    [Li, Ti],
    // ()
    [Ai, Ei],
    // <>
    [Ri, Bi],
    // （）
    [Mi, Di],
    // 「」
    [zi, Oi],
    // 『』
    [Pi, Fi]
    // ＜＞
  ];
  for (let le = 0; le < Y.length; le++) {
    const [ne, re] = Y[le], O = Ne(T, ne);
    Ne(I, ne, O);
    const P = $n(Oo);
    ut(O, n, P);
    const V = $n();
    ut(O, t, V), Ne(O, re, T), ut(P, n, P), ut(P, t, V), ut(V, n, P), ut(V, t, V), Ne(P, re, T), Ne(V, re, T);
  }
  return Ne(l, ro, k), Ne(l, Ec, aR), {
    start: l,
    tokens: iv
  };
}
function rR(e, n, t) {
  let a = t.length, l = 0, r = [], o = [];
  for (; l < a; ) {
    let i = e, s = null, d = null, u = 0, f = null, b = -1;
    for (; l < a && !(s = i.go(t[l].t)); )
      o.push(t[l++]);
    for (; l < a && (d = s || i.go(t[l].t)); )
      s = null, i = d, i.accepts() ? (b = 0, f = i) : b >= 0 && b++, l++, u++;
    if (b < 0)
      l -= u, l < a && (o.push(t[l]), l++);
    else {
      o.length > 0 && (r.push(id(Gh, n, o)), o = []), l -= b, u -= b;
      const h = f.t, p = t.slice(l - u, l);
      r.push(id(h, n, p));
    }
  }
  return o.length > 0 && r.push(id(Gh, n, o)), r;
}
function id(e, n, t) {
  const a = t[0].s, l = t[t.length - 1].e, r = n.slice(a, l);
  return new e(r, t);
}
const oR = typeof console < "u" && console && console.warn || (() => {
}), iR = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", Tt = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function sR() {
  return gn.groups = {}, Tt.scanner = null, Tt.parser = null, Tt.tokenQueue = [], Tt.pluginQueue = [], Tt.customSchemes = [], Tt.initialized = !1, Tt;
}
function Kh(e, n = !1) {
  if (Tt.initialized && oR(`linkifyjs: already initialized - will not register custom scheme "${e}" ${iR}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(e))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  Tt.customSchemes.push([e, n]);
}
function dR() {
  Tt.scanner = eR(Tt.customSchemes);
  for (let e = 0; e < Tt.tokenQueue.length; e++)
    Tt.tokenQueue[e][1]({
      scanner: Tt.scanner
    });
  Tt.parser = lR(Tt.scanner.tokens);
  for (let e = 0; e < Tt.pluginQueue.length; e++)
    Tt.pluginQueue[e][1]({
      scanner: Tt.scanner,
      parser: Tt.parser
    });
  return Tt.initialized = !0, Tt;
}
function Oc(e) {
  return Tt.initialized || dR(), rR(Tt.parser.start, e, sv(Tt.scanner.start, e));
}
Oc.scan = sv;
function uv(e, n = null, t = null) {
  if (n && typeof n == "object") {
    if (t)
      throw Error(`linkifyjs: Invalid link type ${n}; must be a string`);
    t = n, n = null;
  }
  const a = new zc(t), l = Oc(e), r = [];
  for (let o = 0; o < l.length; o++) {
    const i = l[o];
    i.isLink && (!n || i.t === n) && a.check(i) && r.push(i.toFormattedObject(a));
  }
  return r;
}
var Pc = "[\0-   ᠎ -\u2029 　]", uR = new RegExp(Pc), cR = new RegExp(`${Pc}$`), fR = new RegExp(Pc, "g");
function hR(e) {
  return e.length === 1 ? e[0].isLink : e.length === 3 && e[1].isLink ? ["()", "[]"].includes(e[0].value + e[2].value) : !1;
}
function bR(e) {
  return new Bt({
    key: new qt("autolink"),
    appendTransaction: (n, t, a) => {
      const l = n.some((d) => d.docChanged) && !t.doc.eq(a.doc), r = n.some((d) => d.getMeta("preventAutolink"));
      if (!l || r)
        return;
      const { tr: o } = a, i = Ap(t.doc, [...n]);
      if (Op(i).forEach(({ newRange: d }) => {
        const u = uA(a.doc, d, (h) => h.isTextblock);
        let f, b;
        if (u.length > 1)
          f = u[0], b = a.doc.textBetween(
            f.pos,
            f.pos + f.node.nodeSize,
            void 0,
            " "
          );
        else if (u.length) {
          const h = a.doc.textBetween(d.from, d.to, " ", " ");
          if (!cR.test(h))
            return;
          f = u[0], b = a.doc.textBetween(f.pos, d.to, void 0, " ");
        }
        if (f && b) {
          const h = b.split(uR).filter(Boolean);
          if (h.length <= 0)
            return !1;
          const p = h[h.length - 1], x = f.pos + b.lastIndexOf(p);
          if (!p)
            return !1;
          const y = Oc(p).map((k) => k.toObject(e.defaultProtocol));
          if (!hR(y))
            return !1;
          y.filter((k) => k.isLink).map((k) => ({
            ...k,
            from: x + k.start + 1,
            to: x + k.end + 1
          })).filter((k) => a.schema.marks.code ? !a.doc.rangeHasMark(k.from, k.to, a.schema.marks.code) : !0).filter((k) => e.validate(k.value)).filter((k) => e.shouldAutoLink(k.value)).forEach((k) => {
            Sc(k.from, k.to, a.doc).some(($) => $.mark.type === e.type) || o.addMark(
              k.from,
              k.to,
              e.type.create({
                href: k.href
              })
            );
          });
        }
      }), !!o.steps.length)
        return o;
    }
  });
}
function gR(e) {
  return new Bt({
    key: new qt("handleClickLink"),
    props: {
      handleClick: (n, t, a) => {
        var l, r;
        if (a.button !== 0 || !n.editable)
          return !1;
        let o = null;
        if (a.target instanceof HTMLAnchorElement)
          o = a.target;
        else {
          const s = a.target;
          if (!s)
            return !1;
          const d = e.editor.view.dom;
          o = s.closest("a"), o && !d.contains(o) && (o = null);
        }
        if (!o)
          return !1;
        let i = !1;
        if (e.enableClickSelection && (i = e.editor.commands.extendMarkRange(e.type.name)), e.openOnClick) {
          const s = zp(n.state, e.type.name), d = (l = o.href) != null ? l : s.href, u = (r = o.target) != null ? r : s.target;
          d && (window.open(d, u), i = !0);
        }
        return i;
      }
    }
  });
}
function mR(e) {
  return new Bt({
    key: new qt("handlePasteLink"),
    props: {
      handlePaste: (n, t, a) => {
        const { shouldAutoLink: l } = e, { state: r } = n, { selection: o } = r, { empty: i } = o;
        if (i)
          return !1;
        let s = "";
        a.content.forEach((u) => {
          s += u.textContent;
        });
        const d = uv(s, { defaultProtocol: e.defaultProtocol }).find(
          (u) => u.isLink && u.value === s
        );
        return !s || !d || l !== void 0 && !l(d.value) ? !1 : e.editor.commands.setMark(e.type, {
          href: d.href
        });
      }
    }
  });
}
function el(e, n) {
  const t = ["http", "https", "ftp", "ftps", "mailto", "tel", "callto", "sms", "cid", "xmpp"];
  return n && n.forEach((a) => {
    const l = typeof a == "string" ? a : a.scheme;
    l && t.push(l);
  }), !e || e.replace(fR, "").match(
    new RegExp(
      // eslint-disable-next-line no-useless-escape
      `^(?:(?:${t.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
      "i"
    )
  );
}
var pR = Ca.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((e) => {
      if (typeof e == "string") {
        Kh(e);
        return;
      }
      Kh(e.scheme, e.optionalSlashes);
    });
  },
  onDestroy() {
    sR();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      enableClickSelection: !1,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (e, n) => !!el(e, n.protocols),
      validate: (e) => !!e,
      shouldAutoLink: (e) => {
        const n = /^[a-z][a-z0-9+.-]*:\/\//i.test(e), t = /^[a-z][a-z0-9+.-]*:/i.test(e);
        if (n || t && !e.includes("@"))
          return !0;
        const l = (e.includes("@") ? e.split("@").pop() : e).split(/[/?#:]/)[0];
        return !(/^\d{1,3}(\.\d{1,3}){3}$/.test(l) || !/\./.test(l));
      }
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(e) {
          return e.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      },
      title: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (e) => {
          const n = e.getAttribute("href");
          return !n || !this.options.isAllowedUri(n, {
            defaultValidate: (t) => !!el(t, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          }) ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return this.options.isAllowedUri(e.href, {
      defaultValidate: (n) => !!el(n, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    }) ? ["a", Rt(this.options.HTMLAttributes, e), 0] : ["a", Rt(this.options.HTMLAttributes, { ...e, href: "" }), 0];
  },
  markdownTokenName: "link",
  parseMarkdown: (e, n) => n.applyMark("link", n.parseInline(e.tokens || []), {
    href: e.href,
    title: e.title || null
  }),
  renderMarkdown: (e, n) => {
    var t, a, l, r;
    const o = (a = (t = e.attrs) == null ? void 0 : t.href) != null ? a : "", i = (r = (l = e.attrs) == null ? void 0 : l.title) != null ? r : "", s = n.renderChildren(e);
    return i ? `[${s}](${o} "${i}")` : `[${s}](${o})`;
  },
  addCommands() {
    return {
      setLink: (e) => ({ chain: n }) => {
        const { href: t } = e;
        return this.options.isAllowedUri(t, {
          defaultValidate: (a) => !!el(a, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? n().setMark(this.name, e).setMeta("preventAutolink", !0).run() : !1;
      },
      toggleLink: (e) => ({ chain: n }) => {
        const { href: t } = e || {};
        return t && !this.options.isAllowedUri(t, {
          defaultValidate: (a) => !!el(a, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? !1 : n().toggleMark(this.name, e, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run();
      },
      unsetLink: () => ({ chain: e }) => e().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      Ga({
        find: (e) => {
          const n = [];
          if (e) {
            const { protocols: t, defaultProtocol: a } = this.options, l = uv(e).filter(
              (r) => r.isLink && this.options.isAllowedUri(r.value, {
                defaultValidate: (o) => !!el(o, t),
                protocols: t,
                defaultProtocol: a
              })
            );
            l.length && l.forEach((r) => {
              this.options.shouldAutoLink(r.value) && n.push({
                text: r.value,
                data: {
                  href: r.href
                },
                index: r.start
              });
            });
          }
          return n;
        },
        type: this.type,
        getAttributes: (e) => {
          var n;
          return {
            href: (n = e.data) == null ? void 0 : n.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const e = [], { protocols: n, defaultProtocol: t } = this.options;
    return this.options.autolink && e.push(
      bR({
        type: this.type,
        defaultProtocol: this.options.defaultProtocol,
        validate: (a) => this.options.isAllowedUri(a, {
          defaultValidate: (l) => !!el(l, n),
          protocols: n,
          defaultProtocol: t
        }),
        shouldAutoLink: this.options.shouldAutoLink
      })
    ), e.push(
      gR({
        type: this.type,
        editor: this.editor,
        openOnClick: this.options.openOnClick === "whenNotEditable" ? !0 : this.options.openOnClick,
        enableClickSelection: this.options.enableClickSelection
      })
    ), this.options.linkOnPaste && e.push(
      mR({
        editor: this.editor,
        defaultProtocol: this.options.defaultProtocol,
        type: this.type,
        shouldAutoLink: this.options.shouldAutoLink
      })
    ), e;
  }
}), vR = Object.defineProperty, xR = (e, n) => {
  for (var t in n)
    vR(e, t, { get: n[t], enumerable: !0 });
}, yR = "listItem", Yh = "textStyle", Jh = /^\s*([-+*])\s$/, cv = xn.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [{ tag: "ul" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["ul", Rt(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "list",
  parseMarkdown: (e, n) => e.type !== "list" || e.ordered ? [] : {
    type: "bulletList",
    content: e.items ? n.parseChildren(e.items) : []
  },
  renderMarkdown: (e, n) => e.content ? n.renderChildren(e.content, `
`) : "",
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: e, chain: n }) => this.options.keepAttributes ? n().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(yR, this.editor.getAttributes(Yh)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let e = Ql({
      find: Jh,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = Ql({
      find: Jh,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(Yh),
      editor: this.editor
    })), [e];
  }
});
function kR(e) {
  var n, t;
  const a = (n = e.tokens) == null ? void 0 : n[0];
  return !!(e.text && ((t = e.tokens) == null ? void 0 : t.length) === 1 && (a == null ? void 0 : a.type) === "list" && a.ordered && a.raw === e.text);
}
function wR(e, n) {
  return n.tokenizeInline ? n.parseInline(n.tokenizeInline(e)) : n.parseInline([
    {
      type: "text",
      raw: e,
      text: e
    }
  ]);
}
var fv = xn.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["li", Rt(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "list_item",
  parseMarkdown: (e, n) => {
    var t;
    if (e.type !== "list_item")
      return [];
    const a = (t = n.parseBlockChildren) != null ? t : n.parseChildren;
    let l = [];
    if (e.tokens && e.tokens.length > 0) {
      if (kR(e))
        return {
          type: "listItem",
          content: [
            {
              type: "paragraph",
              content: wR(e.text || "", n)
            }
          ]
        };
      if (e.tokens.some((o) => o.type === "paragraph"))
        l = a(e.tokens);
      else {
        const o = e.tokens[0];
        if (o && o.type === "text" && o.tokens && o.tokens.length > 0) {
          if (l = [
            {
              type: "paragraph",
              content: n.parseInline(o.tokens)
            }
          ], e.tokens.length > 1) {
            const s = e.tokens.slice(1), d = a(s);
            l.push(...d);
          }
        } else
          l = a(e.tokens);
      }
    }
    return l.length === 0 && (l = [
      {
        type: "paragraph",
        content: []
      }
    ]), {
      type: "listItem",
      content: l
    };
  },
  renderMarkdown: (e, n, t) => Tc(
    e,
    n,
    (a) => {
      var l, r;
      return a.parentType === "bulletList" ? "- " : a.parentType === "orderedList" ? `${(((r = (l = a.meta) == null ? void 0 : l.parentAttrs) == null ? void 0 : r.start) || 1) + a.index}. ` : "- ";
    },
    t
  ),
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), CR = {};
xR(CR, {
  findListItemPos: () => xo,
  getNextListDepth: () => Fc,
  handleBackspace: () => hu,
  handleDelete: () => bu,
  hasListBefore: () => hv,
  hasListItemAfter: () => SR,
  hasListItemBefore: () => bv,
  listItemHasSubList: () => gv,
  nextListIsDeeper: () => mv,
  nextListIsHigher: () => pv
});
var xo = (e, n) => {
  const { $from: t } = n.selection, a = Ht(e, n.schema);
  let l = null, r = t.depth, o = t.pos, i = null;
  for (; r > 0 && i === null; )
    l = t.node(r), l.type === a ? i = r : (r -= 1, o -= 1);
  return i === null ? null : { $pos: n.doc.resolve(o), depth: i };
}, Fc = (e, n) => {
  const t = xo(e, n);
  if (!t)
    return !1;
  const [, a] = kA(n, e, t.$pos.pos + 4);
  return a;
}, hv = (e, n, t) => {
  const { $anchor: a } = e.selection, l = Math.max(0, a.pos - 2), r = e.doc.resolve(l).node();
  return !(!r || !t.includes(r.type.name));
}, bv = (e, n) => {
  var t;
  const { $anchor: a } = n.selection, l = n.doc.resolve(a.pos - 2);
  return !(l.index() === 0 || ((t = l.nodeBefore) == null ? void 0 : t.type.name) !== e);
}, gv = (e, n, t) => {
  if (!t)
    return !1;
  const a = Ht(e, n.schema);
  let l = !1;
  return t.descendants((r) => {
    r.type === a && (l = !0);
  }), l;
}, hu = (e, n, t) => {
  if (e.commands.undoInputRule())
    return !0;
  if (e.state.selection.from !== e.state.selection.to)
    return !1;
  if (!Ua(e.state, n) && hv(e.state, n, t)) {
    const { $anchor: i } = e.state.selection, s = e.state.doc.resolve(i.before() - 1), d = [];
    s.node().descendants((b, h) => {
      b.type.name === n && d.push({ node: b, pos: h });
    });
    const u = d.at(-1);
    if (!u)
      return !1;
    const f = e.state.doc.resolve(s.start() + u.pos + 1);
    return e.chain().cut({ from: i.start() - 1, to: i.end() + 1 }, f.end()).joinForward().run();
  }
  if (!Ua(e.state, n) || !$A(e.state))
    return !1;
  const a = xo(n, e.state);
  if (!a)
    return !1;
  const r = e.state.doc.resolve(a.$pos.pos - 2).node(a.depth), o = gv(n, e.state, r);
  return bv(n, e.state) && !o ? e.commands.joinItemBackward() : e.chain().liftListItem(n).run();
}, mv = (e, n) => {
  const t = Fc(e, n), a = xo(e, n);
  return !a || !t ? !1 : t > a.depth;
}, pv = (e, n) => {
  const t = Fc(e, n), a = xo(e, n);
  return !a || !t ? !1 : t < a.depth;
}, bu = (e, n) => {
  if (!Ua(e.state, n) || !SA(e.state, n))
    return !1;
  const { selection: t } = e.state, { $from: a, $to: l } = t;
  return !t.empty && a.sameParent(l) ? !1 : mv(n, e.state) ? e.chain().focus(e.state.selection.from + 4).lift(n).joinBackward().run() : pv(n, e.state) ? e.chain().joinForward().joinBackward().run() : e.commands.joinItemForward();
}, SR = (e, n) => {
  var t;
  const { $anchor: a } = n.selection, l = n.doc.resolve(a.pos - a.parentOffset - 2);
  return !(l.index() === l.parent.childCount - 1 || ((t = l.nodeAfter) == null ? void 0 : t.type.name) !== e);
}, vv = wt.create({
  name: "listKeymap",
  addOptions() {
    return {
      listTypes: [
        {
          itemName: "listItem",
          wrapperNames: ["bulletList", "orderedList"]
        },
        {
          itemName: "taskItem",
          wrapperNames: ["taskList"]
        }
      ]
    };
  },
  addKeyboardShortcuts() {
    return {
      Delete: ({ editor: e }) => {
        let n = !1;
        return this.options.listTypes.forEach(({ itemName: t }) => {
          e.state.schema.nodes[t] !== void 0 && bu(e, t) && (n = !0);
        }), n;
      },
      "Mod-Delete": ({ editor: e }) => {
        let n = !1;
        return this.options.listTypes.forEach(({ itemName: t }) => {
          e.state.schema.nodes[t] !== void 0 && bu(e, t) && (n = !0);
        }), n;
      },
      Backspace: ({ editor: e }) => {
        let n = !1;
        return this.options.listTypes.forEach(({ itemName: t, wrapperNames: a }) => {
          e.state.schema.nodes[t] !== void 0 && hu(e, t, a) && (n = !0);
        }), n;
      },
      "Mod-Backspace": ({ editor: e }) => {
        let n = !1;
        return this.options.listTypes.forEach(({ itemName: t, wrapperNames: a }) => {
          e.state.schema.nodes[t] !== void 0 && hu(e, t, a) && (n = !0);
        }), n;
      }
    };
  }
}), Xh = /^(\s*)(\d+)\.\s+(.*)$/, $R = /^\s/;
function IR(e) {
  const n = e.trimStart();
  return /^[-+*]\s+/.test(n) || /^\d+\.\s+/.test(n) || /^>\s?/.test(n) || /^```/.test(n) || /^~~~/.test(n);
}
function LR(e) {
  const n = [], t = [];
  let a = !1;
  return e.forEach((l) => {
    if (a) {
      t.push(l);
      return;
    }
    if (l.trim() === "") {
      a = !0, t.push(l);
      return;
    }
    if (n.length > 0 && IR(l)) {
      a = !0, t.push(l);
      return;
    }
    n.push(l);
  }), {
    paragraphLines: n,
    blockLines: t
  };
}
function TR(e) {
  const n = [];
  let t = 0, a = 0;
  for (; t < e.length; ) {
    const l = e[t], r = l.match(Xh);
    if (!r)
      break;
    const [, o, i, s] = r, d = o.length, u = [s];
    let f = t + 1;
    const b = [l];
    let h = !1;
    for (; f < e.length; ) {
      const p = e[f];
      if (p.match(Xh))
        break;
      if (p.trim() === "")
        b.push(p), u.push(""), h = !0, f += 1;
      else if (p.match($R))
        b.push(p), u.push(p.slice(d + 2)), f += 1;
      else {
        if (h)
          break;
        b.push(p), u.push(p), f += 1;
      }
    }
    n.push({
      indent: d,
      number: parseInt(i, 10),
      content: u.join(`
`).trim(),
      contentLines: u,
      raw: b.join(`
`)
    }), a = f, t = f;
  }
  return [n, a];
}
function xv(e, n, t) {
  const a = [];
  let l = 0;
  for (; l < e.length; ) {
    const r = e[l];
    if (r.indent === n) {
      const { paragraphLines: o, blockLines: i } = LR(r.contentLines), s = o.join(`
`).trim(), d = [];
      s && d.push({
        type: "paragraph",
        raw: s,
        tokens: t.inlineTokens(s)
      });
      const u = i.join(`
`).trim();
      if (u) {
        const h = t.blockTokens(u);
        d.push(...h);
      }
      let f = l + 1;
      const b = [];
      for (; f < e.length && e[f].indent > n; )
        b.push(e[f]), f += 1;
      if (b.length > 0) {
        const h = Math.min(...b.map((x) => x.indent)), p = xv(b, h, t);
        d.push({
          type: "list",
          ordered: !0,
          start: b[0].number,
          items: p,
          raw: b.map((x) => x.raw).join(`
`)
        });
      }
      a.push({
        type: "list_item",
        raw: r.raw,
        tokens: d
      }), l = f;
    } else
      l += 1;
  }
  return a;
}
function AR(e, n) {
  return e.map((t) => {
    if (t.type !== "list_item")
      return n.parseChildren([t])[0];
    const a = [];
    return t.tokens && t.tokens.length > 0 && t.tokens.forEach((l) => {
      if (l.type === "paragraph" || l.type === "list" || l.type === "blockquote" || l.type === "code")
        a.push(...n.parseChildren([l]));
      else if (l.type === "text" && l.tokens) {
        const r = n.parseChildren([l]);
        a.push({
          type: "paragraph",
          content: r
        });
      } else {
        const r = n.parseChildren([l]);
        r.length > 0 && a.push(...r);
      }
    }), {
      type: "listItem",
      content: a
    };
  });
}
var ER = "listItem", Zh = "textStyle", Qh = /^(\d+)\.\s$/, yv = xn.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (e) => e.hasAttribute("start") ? parseInt(e.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: null,
        parseHTML: (e) => e.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    const { start: n, ...t } = e;
    return n === 1 ? ["ol", Rt(this.options.HTMLAttributes, t), 0] : ["ol", Rt(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "list",
  parseMarkdown: (e, n) => {
    if (e.type !== "list" || !e.ordered)
      return [];
    const t = e.start || 1, a = e.items ? AR(e.items, n) : [];
    return t !== 1 ? {
      type: "orderedList",
      attrs: { start: t },
      content: a
    } : {
      type: "orderedList",
      content: a
    };
  },
  renderMarkdown: (e, n) => e.content ? n.renderChildren(e.content, `
`) : "",
  markdownTokenizer: {
    name: "orderedList",
    level: "block",
    start: (e) => {
      const n = e.match(/^(\s*)(\d+)\.\s+/), t = n == null ? void 0 : n.index;
      return t !== void 0 ? t : -1;
    },
    tokenize: (e, n, t) => {
      var a;
      const l = e.split(`
`), [r, o] = TR(l);
      if (r.length === 0)
        return;
      const i = xv(r, 0, t);
      return i.length === 0 ? void 0 : {
        type: "list",
        ordered: !0,
        start: ((a = r[0]) == null ? void 0 : a.number) || 1,
        items: i,
        raw: l.slice(0, o).join(`
`)
      };
    }
  },
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: e, chain: n }) => this.options.keepAttributes ? n().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(ER, this.editor.getAttributes(Zh)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let e = Ql({
      find: Qh,
      type: this.type,
      getAttributes: (n) => ({ start: +n[1] }),
      joinPredicate: (n, t) => t.childCount + t.attrs.start === +n[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = Ql({
      find: Qh,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (n) => ({ start: +n[1], ...this.editor.getAttributes(Zh) }),
      joinPredicate: (n, t) => t.childCount + t.attrs.start === +n[1],
      editor: this.editor
    })), [e];
  }
}), RR = /^\s*(\[([( |x])?\])\s$/, BR = xn.create({
  name: "taskItem",
  addOptions() {
    return {
      nested: !1,
      HTMLAttributes: {},
      taskListTypeName: "taskList",
      a11y: void 0
    };
  },
  content() {
    return this.options.nested ? "paragraph block*" : "paragraph+";
  },
  defining: !0,
  addAttributes() {
    return {
      checked: {
        default: !1,
        keepOnSplit: !1,
        parseHTML: (e) => {
          const n = e.getAttribute("data-checked");
          return n === "" || n === "true";
        },
        renderHTML: (e) => ({
          "data-checked": e.checked
        })
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: `li[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: n }) {
    return [
      "li",
      Rt(this.options.HTMLAttributes, n, {
        "data-type": this.name
      }),
      [
        "label",
        [
          "input",
          {
            type: "checkbox",
            checked: e.attrs.checked ? "checked" : null
          }
        ],
        ["span"]
      ],
      ["div", 0]
    ];
  },
  parseMarkdown: (e, n) => {
    const t = [];
    if (e.tokens && e.tokens.length > 0 ? t.push(n.createNode("paragraph", {}, n.parseInline(e.tokens))) : e.text ? t.push(n.createNode("paragraph", {}, [n.createNode("text", { text: e.text })])) : t.push(n.createNode("paragraph", {}, [])), e.nestedTokens && e.nestedTokens.length > 0) {
      const a = n.parseChildren(e.nestedTokens);
      t.push(...a);
    }
    return n.createNode("taskItem", { checked: e.checked || !1 }, t);
  },
  renderMarkdown: (e, n) => {
    var t;
    const l = `- [${(t = e.attrs) != null && t.checked ? "x" : " "}] `;
    return Tc(e, n, l);
  },
  addKeyboardShortcuts() {
    const e = {
      Enter: () => this.editor.commands.splitListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
    return this.options.nested ? {
      ...e,
      Tab: () => this.editor.commands.sinkListItem(this.name)
    } : e;
  },
  addNodeView() {
    return ({ node: e, HTMLAttributes: n, getPos: t, editor: a }) => {
      const l = document.createElement("li"), r = document.createElement("label"), o = document.createElement("span"), i = document.createElement("input"), s = document.createElement("div"), d = (f) => {
        var b, h;
        i.ariaLabel = ((h = (b = this.options.a11y) == null ? void 0 : b.checkboxLabel) == null ? void 0 : h.call(b, f, i.checked)) || `Task item checkbox for ${f.textContent || "empty task item"}`;
      };
      d(e), r.contentEditable = "false", i.type = "checkbox", i.addEventListener("mousedown", (f) => f.preventDefault()), i.addEventListener("change", (f) => {
        if (!a.isEditable && !this.options.onReadOnlyChecked) {
          i.checked = !i.checked;
          return;
        }
        const { checked: b } = f.target;
        a.isEditable && typeof t == "function" && a.chain().focus(void 0, { scrollIntoView: !1 }).command(({ tr: h }) => {
          const p = t();
          if (typeof p != "number")
            return !1;
          const x = h.doc.nodeAt(p);
          return h.setNodeMarkup(p, void 0, {
            ...x == null ? void 0 : x.attrs,
            checked: b
          }), !0;
        }).run(), !a.isEditable && this.options.onReadOnlyChecked && (this.options.onReadOnlyChecked(e, b) || (i.checked = !i.checked));
      }), Object.entries(this.options.HTMLAttributes).forEach(([f, b]) => {
        l.setAttribute(f, b);
      }), l.dataset.checked = e.attrs.checked, i.checked = e.attrs.checked, r.append(i, o), l.append(r, s), Object.entries(n).forEach(([f, b]) => {
        l.setAttribute(f, b);
      });
      let u = new Set(Object.keys(n));
      return {
        dom: l,
        contentDOM: s,
        update: (f) => {
          if (f.type !== this.type)
            return !1;
          l.dataset.checked = f.attrs.checked, i.checked = f.attrs.checked, d(f);
          const b = a.extensionManager.attributes, h = ao(f, b), p = new Set(Object.keys(h)), x = this.options.HTMLAttributes;
          return u.forEach((y) => {
            p.has(y) || (y in x ? l.setAttribute(y, x[y]) : l.removeAttribute(y));
          }), Object.entries(h).forEach(([y, k]) => {
            k == null ? y in x ? l.setAttribute(y, x[y]) : l.removeAttribute(y) : l.setAttribute(y, k);
          }), u = p, !0;
        }
      };
    };
  },
  addInputRules() {
    return [
      Ql({
        find: RR,
        type: this.type,
        getAttributes: (e) => ({
          checked: e[e.length - 1] === "x"
        })
      })
    ];
  }
}), MR = xn.create({
  name: "taskList",
  addOptions() {
    return {
      itemTypeName: "taskItem",
      HTMLAttributes: {}
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      {
        tag: `ul[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["ul", Rt(this.options.HTMLAttributes, e, { "data-type": this.name }), 0];
  },
  parseMarkdown: (e, n) => n.createNode("taskList", {}, n.parseChildren(e.items || [])),
  renderMarkdown: (e, n) => e.content ? n.renderChildren(e.content, `
`) : "",
  markdownTokenizer: {
    name: "taskList",
    level: "block",
    start(e) {
      var n;
      const t = (n = e.match(/^\s*[-+*]\s+\[([ xX])\]\s+/)) == null ? void 0 : n.index;
      return t !== void 0 ? t : -1;
    },
    tokenize(e, n, t) {
      const a = (r) => {
        const o = lu(
          r,
          {
            itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
            extractItemData: (i) => ({
              indentLevel: i[1].length,
              mainContent: i[4],
              checked: i[3].toLowerCase() === "x"
            }),
            createToken: (i, s) => ({
              type: "taskItem",
              raw: "",
              mainContent: i.mainContent,
              indentLevel: i.indentLevel,
              checked: i.checked,
              text: i.mainContent,
              tokens: t.inlineTokens(i.mainContent),
              nestedTokens: s
            }),
            // Allow recursive nesting
            customNestedParser: a
          },
          t
        );
        return o ? [
          {
            type: "taskList",
            raw: o.raw,
            items: o.items
          }
        ] : t.blockTokens(r);
      }, l = lu(
        e,
        {
          itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
          extractItemData: (r) => ({
            indentLevel: r[1].length,
            mainContent: r[4],
            checked: r[3].toLowerCase() === "x"
          }),
          createToken: (r, o) => ({
            type: "taskItem",
            raw: "",
            mainContent: r.mainContent,
            indentLevel: r.indentLevel,
            checked: r.checked,
            text: r.mainContent,
            tokens: t.inlineTokens(r.mainContent),
            nestedTokens: o
          }),
          // Use the recursive parser for nested content
          customNestedParser: a
        },
        t
      );
      if (l)
        return {
          type: "taskList",
          raw: l.raw,
          items: l.items
        };
    }
  },
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleTaskList: () => ({ commands: e }) => e.toggleList(this.name, this.options.itemTypeName)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-9": () => this.editor.commands.toggleTaskList()
    };
  }
});
wt.create({
  name: "listKit",
  addExtensions() {
    const e = [];
    return this.options.bulletList !== !1 && e.push(cv.configure(this.options.bulletList)), this.options.listItem !== !1 && e.push(fv.configure(this.options.listItem)), this.options.listKeymap !== !1 && e.push(vv.configure(this.options.listKeymap)), this.options.orderedList !== !1 && e.push(yv.configure(this.options.orderedList)), this.options.taskItem !== !1 && e.push(BR.configure(this.options.taskItem)), this.options.taskList !== !1 && e.push(MR.configure(this.options.taskList)), e;
  }
});
var Po = "&nbsp;", sd = " ", DR = xn.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [{ tag: "p" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["p", Rt(this.options.HTMLAttributes, e), 0];
  },
  parseMarkdown: (e, n) => {
    const t = e.tokens || [];
    if (t.length === 1 && t[0].type === "image")
      return n.parseChildren([t[0]]);
    const a = n.parseInline(t);
    return t.length === 1 && t[0].type === "text" && (t[0].raw === Po || t[0].text === Po || t[0].raw === sd || t[0].text === sd) && a.length === 1 && a[0].type === "text" && (a[0].text === Po || a[0].text === sd) ? n.createNode("paragraph", void 0, []) : n.createNode("paragraph", void 0, a);
  },
  renderMarkdown: (e, n, t) => {
    var a, l;
    if (!e)
      return "";
    const r = Array.isArray(e.content) ? e.content : [];
    if (r.length === 0) {
      const o = Array.isArray((a = t == null ? void 0 : t.previousNode) == null ? void 0 : a.content) ? t.previousNode.content : [];
      return ((l = t == null ? void 0 : t.previousNode) == null ? void 0 : l.type) === "paragraph" && o.length === 0 ? Po : "";
    }
    return n.renderChildren(r);
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: e }) => e.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), zR = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, OR = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, PR = Ca.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["s", Rt(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "del",
  parseMarkdown: (e, n) => n.applyMark("strike", n.parseInline(e.tokens || [])),
  renderMarkdown: (e, n) => `~~${n.renderChildren(e)}~~`,
  addCommands() {
    return {
      setStrike: () => ({ commands: e }) => e.setMark(this.name),
      toggleStrike: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetStrike: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      Cl({
        find: zR,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ga({
        find: OR,
        type: this.type
      })
    ];
  }
}), FR = xn.create({
  name: "text",
  group: "inline",
  parseMarkdown: (e) => ({
    type: "text",
    text: e.text || ""
  }),
  renderMarkdown: (e) => e.text || ""
}), VR = Ca.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["u", Rt(this.options.HTMLAttributes, e), 0];
  },
  parseMarkdown(e, n) {
    return n.applyMark(this.name || "underline", n.parseInline(e.tokens || []));
  },
  renderMarkdown(e, n) {
    return `++${n.renderChildren(e)}++`;
  },
  markdownTokenizer: {
    name: "underline",
    level: "inline",
    start(e) {
      return e.indexOf("++");
    },
    tokenize(e, n, t) {
      const l = /^(\+\+)([\s\S]+?)(\+\+)/.exec(e);
      if (!l)
        return;
      const r = l[2].trim();
      return {
        type: "underline",
        raw: l[0],
        text: r,
        tokens: t.inlineTokens(r)
      };
    }
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: e }) => e.setMark(this.name),
      toggleUnderline: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetUnderline: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
});
function NR(e = {}) {
  return new Bt({
    view(n) {
      return new HR(n, e);
    }
  });
}
class HR {
  constructor(n, t) {
    var a;
    this.editorView = n, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (a = t.width) !== null && a !== void 0 ? a : 1, this.color = t.color === !1 ? void 0 : t.color || "black", this.class = t.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((l) => {
      let r = (o) => {
        this[l](o);
      };
      return n.dom.addEventListener(l, r), { name: l, handler: r };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: n, handler: t }) => this.editorView.dom.removeEventListener(n, t));
  }
  update(n, t) {
    this.cursorPos != null && t.doc != n.state.doc && (this.cursorPos > n.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(n) {
    n != this.cursorPos && (this.cursorPos = n, n == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let n = this.editorView.state.doc.resolve(this.cursorPos), t = !n.parent.inlineContent, a, l = this.editorView.dom, r = l.getBoundingClientRect(), o = r.width / l.offsetWidth, i = r.height / l.offsetHeight;
    if (t) {
      let f = n.nodeBefore, b = n.nodeAfter;
      if (f || b) {
        let h = this.editorView.nodeDOM(this.cursorPos - (f ? f.nodeSize : 0));
        if (h) {
          let p = h.getBoundingClientRect(), x = f ? p.bottom : p.top;
          f && b && (x = (x + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2);
          let y = this.width / 2 * i;
          a = { left: p.left, right: p.right, top: x - y, bottom: x + y };
        }
      }
    }
    if (!a) {
      let f = this.editorView.coordsAtPos(this.cursorPos), b = this.width / 2 * o;
      a = { left: f.left - b, right: f.left + b, top: f.top, bottom: f.bottom };
    }
    let s = this.editorView.dom.offsetParent;
    this.element || (this.element = s.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", t), this.element.classList.toggle("prosemirror-dropcursor-inline", !t);
    let d, u;
    if (!s || s == document.body && getComputedStyle(s).position == "static")
      d = -pageXOffset, u = -pageYOffset;
    else {
      let f = s.getBoundingClientRect(), b = f.width / s.offsetWidth, h = f.height / s.offsetHeight;
      d = f.left - s.scrollLeft * b, u = f.top - s.scrollTop * h;
    }
    this.element.style.left = (a.left - d) / o + "px", this.element.style.top = (a.top - u) / i + "px", this.element.style.width = (a.right - a.left) / o + "px", this.element.style.height = (a.bottom - a.top) / i + "px";
  }
  scheduleRemoval(n) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), n);
  }
  dragover(n) {
    if (!this.editorView.editable)
      return;
    let t = this.editorView.posAtCoords({ left: n.clientX, top: n.clientY }), a = t && t.inside >= 0 && this.editorView.state.doc.nodeAt(t.inside), l = a && a.type.spec.disableDropCursor, r = typeof l == "function" ? l(this.editorView, t, n) : l;
    if (t && !r) {
      let o = t.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let i = xm(this.editorView.state.doc, o, this.editorView.dragging.slice);
        i != null && (o = i);
      }
      this.setCursor(o), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(n) {
    this.editorView.dom.contains(n.relatedTarget) || this.setCursor(null);
  }
}
class zt extends st {
  /**
  Create a gap cursor.
  */
  constructor(n) {
    super(n, n);
  }
  map(n, t) {
    let a = n.resolve(t.map(this.head));
    return zt.valid(a) ? new zt(a) : st.near(a);
  }
  content() {
    return Xe.empty;
  }
  eq(n) {
    return n instanceof zt && n.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new zt(n.resolve(t.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new Vc(this.anchor);
  }
  /**
  @internal
  */
  static valid(n) {
    let t = n.parent;
    if (t.inlineContent || !jR(n) || !WR(n))
      return !1;
    let a = t.type.spec.allowGapCursor;
    if (a != null)
      return a;
    let l = t.contentMatchAt(n.index()).defaultType;
    return l && l.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(n, t, a = !1) {
    e: for (; ; ) {
      if (!a && zt.valid(n))
        return n;
      let l = n.pos, r = null;
      for (let o = n.depth; ; o--) {
        let i = n.node(o);
        if (t > 0 ? n.indexAfter(o) < i.childCount : n.index(o) > 0) {
          r = i.child(t > 0 ? n.indexAfter(o) : n.index(o) - 1);
          break;
        } else if (o == 0)
          return null;
        l += t;
        let s = n.doc.resolve(l);
        if (zt.valid(s))
          return s;
      }
      for (; ; ) {
        let o = t > 0 ? r.firstChild : r.lastChild;
        if (!o) {
          if (r.isAtom && !r.isText && !tt.isSelectable(r)) {
            n = n.doc.resolve(l + r.nodeSize * t), a = !1;
            continue e;
          }
          break;
        }
        r = o, l += t;
        let i = n.doc.resolve(l);
        if (zt.valid(i))
          return i;
      }
      return null;
    }
  }
}
zt.prototype.visible = !1;
zt.findFrom = zt.findGapCursorFrom;
st.jsonID("gapcursor", zt);
class Vc {
  constructor(n) {
    this.pos = n;
  }
  map(n) {
    return new Vc(n.map(this.pos));
  }
  resolve(n) {
    let t = n.resolve(this.pos);
    return zt.valid(t) ? new zt(t) : st.near(t);
  }
}
function kv(e) {
  return e.isAtom || e.spec.isolating || e.spec.createGapCursor;
}
function jR(e) {
  for (let n = e.depth; n >= 0; n--) {
    let t = e.index(n), a = e.node(n);
    if (t == 0) {
      if (a.type.spec.isolating)
        return !0;
      continue;
    }
    for (let l = a.child(t - 1); ; l = l.lastChild) {
      if (l.childCount == 0 && !l.inlineContent || kv(l.type))
        return !0;
      if (l.inlineContent)
        return !1;
    }
  }
  return !0;
}
function WR(e) {
  for (let n = e.depth; n >= 0; n--) {
    let t = e.indexAfter(n), a = e.node(n);
    if (t == a.childCount) {
      if (a.type.spec.isolating)
        return !0;
      continue;
    }
    for (let l = a.child(t); ; l = l.firstChild) {
      if (l.childCount == 0 && !l.inlineContent || kv(l.type))
        return !0;
      if (l.inlineContent)
        return !1;
    }
  }
  return !0;
}
function qR() {
  return new Bt({
    props: {
      decorations: YR,
      createSelectionBetween(e, n, t) {
        return n.pos == t.pos && zt.valid(t) ? new zt(t) : null;
      },
      handleClick: GR,
      handleKeyDown: UR,
      handleDOMEvents: { beforeinput: KR }
    }
  });
}
const UR = kp({
  ArrowLeft: Fo("horiz", -1),
  ArrowRight: Fo("horiz", 1),
  ArrowUp: Fo("vert", -1),
  ArrowDown: Fo("vert", 1)
});
function Fo(e, n) {
  const t = e == "vert" ? n > 0 ? "down" : "up" : n > 0 ? "right" : "left";
  return function(a, l, r) {
    let o = a.selection, i = n > 0 ? o.$to : o.$from, s = o.empty;
    if (o instanceof rt) {
      if (!r.endOfTextblock(t) || i.depth == 0)
        return !1;
      s = !1, i = a.doc.resolve(n > 0 ? i.after() : i.before());
    }
    let d = zt.findGapCursorFrom(i, n, s);
    return d ? (l && l(a.tr.setSelection(new zt(d))), !0) : !1;
  };
}
function GR(e, n, t) {
  if (!e || !e.editable)
    return !1;
  let a = e.state.doc.resolve(n);
  if (!zt.valid(a))
    return !1;
  let l = e.posAtCoords({ left: t.clientX, top: t.clientY });
  return l && l.inside > -1 && tt.isSelectable(e.state.doc.nodeAt(l.inside)) ? !1 : (e.dispatch(e.state.tr.setSelection(new zt(a))), !0);
}
function KR(e, n) {
  if (n.inputType != "insertCompositionText" || !(e.state.selection instanceof zt))
    return !1;
  let { $from: t } = e.state.selection, a = t.parent.contentMatchAt(t.index()).findWrapping(e.state.schema.nodes.text);
  if (!a)
    return !1;
  let l = Ve.empty;
  for (let o = a.length - 1; o >= 0; o--)
    l = Ve.from(a[o].createAndFill(null, l));
  let r = e.state.tr.replace(t.pos, t.pos, new Xe(l, 0, 0));
  return r.setSelection(rt.near(r.doc.resolve(t.pos + 1))), e.dispatch(r), !1;
}
function YR(e) {
  if (!(e.selection instanceof zt))
    return null;
  let n = document.createElement("div");
  return n.className = "ProseMirror-gapcursor", Et.create(e.doc, [un.widget(e.selection.head, n, { key: "gapcursor" })]);
}
var Qi = 200, Jt = function() {
};
Jt.prototype.append = function(n) {
  return n.length ? (n = Jt.from(n), !this.length && n || n.length < Qi && this.leafAppend(n) || this.length < Qi && n.leafPrepend(this) || this.appendInner(n)) : this;
};
Jt.prototype.prepend = function(n) {
  return n.length ? Jt.from(n).append(this) : this;
};
Jt.prototype.appendInner = function(n) {
  return new JR(this, n);
};
Jt.prototype.slice = function(n, t) {
  return n === void 0 && (n = 0), t === void 0 && (t = this.length), n >= t ? Jt.empty : this.sliceInner(Math.max(0, n), Math.min(this.length, t));
};
Jt.prototype.get = function(n) {
  if (!(n < 0 || n >= this.length))
    return this.getInner(n);
};
Jt.prototype.forEach = function(n, t, a) {
  t === void 0 && (t = 0), a === void 0 && (a = this.length), t <= a ? this.forEachInner(n, t, a, 0) : this.forEachInvertedInner(n, t, a, 0);
};
Jt.prototype.map = function(n, t, a) {
  t === void 0 && (t = 0), a === void 0 && (a = this.length);
  var l = [];
  return this.forEach(function(r, o) {
    return l.push(n(r, o));
  }, t, a), l;
};
Jt.from = function(n) {
  return n instanceof Jt ? n : n && n.length ? new wv(n) : Jt.empty;
};
var wv = /* @__PURE__ */ function(e) {
  function n(a) {
    e.call(this), this.values = a;
  }
  e && (n.__proto__ = e), n.prototype = Object.create(e && e.prototype), n.prototype.constructor = n;
  var t = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return n.prototype.flatten = function() {
    return this.values;
  }, n.prototype.sliceInner = function(l, r) {
    return l == 0 && r == this.length ? this : new n(this.values.slice(l, r));
  }, n.prototype.getInner = function(l) {
    return this.values[l];
  }, n.prototype.forEachInner = function(l, r, o, i) {
    for (var s = r; s < o; s++)
      if (l(this.values[s], i + s) === !1)
        return !1;
  }, n.prototype.forEachInvertedInner = function(l, r, o, i) {
    for (var s = r - 1; s >= o; s--)
      if (l(this.values[s], i + s) === !1)
        return !1;
  }, n.prototype.leafAppend = function(l) {
    if (this.length + l.length <= Qi)
      return new n(this.values.concat(l.flatten()));
  }, n.prototype.leafPrepend = function(l) {
    if (this.length + l.length <= Qi)
      return new n(l.flatten().concat(this.values));
  }, t.length.get = function() {
    return this.values.length;
  }, t.depth.get = function() {
    return 0;
  }, Object.defineProperties(n.prototype, t), n;
}(Jt);
Jt.empty = new wv([]);
var JR = /* @__PURE__ */ function(e) {
  function n(t, a) {
    e.call(this), this.left = t, this.right = a, this.length = t.length + a.length, this.depth = Math.max(t.depth, a.depth) + 1;
  }
  return e && (n.__proto__ = e), n.prototype = Object.create(e && e.prototype), n.prototype.constructor = n, n.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, n.prototype.getInner = function(a) {
    return a < this.left.length ? this.left.get(a) : this.right.get(a - this.left.length);
  }, n.prototype.forEachInner = function(a, l, r, o) {
    var i = this.left.length;
    if (l < i && this.left.forEachInner(a, l, Math.min(r, i), o) === !1 || r > i && this.right.forEachInner(a, Math.max(l - i, 0), Math.min(this.length, r) - i, o + i) === !1)
      return !1;
  }, n.prototype.forEachInvertedInner = function(a, l, r, o) {
    var i = this.left.length;
    if (l > i && this.right.forEachInvertedInner(a, l - i, Math.max(r, i) - i, o + i) === !1 || r < i && this.left.forEachInvertedInner(a, Math.min(l, i), r, o) === !1)
      return !1;
  }, n.prototype.sliceInner = function(a, l) {
    if (a == 0 && l == this.length)
      return this;
    var r = this.left.length;
    return l <= r ? this.left.slice(a, l) : a >= r ? this.right.slice(a - r, l - r) : this.left.slice(a, r).append(this.right.slice(0, l - r));
  }, n.prototype.leafAppend = function(a) {
    var l = this.right.leafAppend(a);
    if (l)
      return new n(this.left, l);
  }, n.prototype.leafPrepend = function(a) {
    var l = this.left.leafPrepend(a);
    if (l)
      return new n(l, this.right);
  }, n.prototype.appendInner = function(a) {
    return this.left.depth >= Math.max(this.right.depth, a.depth) + 1 ? new n(this.left, new n(this.right, a)) : new n(this, a);
  }, n;
}(Jt);
const XR = 500;
class jn {
  constructor(n, t) {
    this.items = n, this.eventCount = t;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(n, t) {
    if (this.eventCount == 0)
      return null;
    let a = this.items.length;
    for (; ; a--)
      if (this.items.get(a - 1).selection) {
        --a;
        break;
      }
    let l, r;
    t && (l = this.remapping(a, this.items.length), r = l.maps.length);
    let o = n.tr, i, s, d = [], u = [];
    return this.items.forEach((f, b) => {
      if (!f.step) {
        l || (l = this.remapping(a, b + 1), r = l.maps.length), r--, u.push(f);
        return;
      }
      if (l) {
        u.push(new Zn(f.map));
        let h = f.step.map(l.slice(r)), p;
        h && o.maybeStep(h).doc && (p = o.mapping.maps[o.mapping.maps.length - 1], d.push(new Zn(p, void 0, void 0, d.length + u.length))), r--, p && l.appendMap(p, r);
      } else
        o.maybeStep(f.step);
      if (f.selection)
        return i = l ? f.selection.map(l.slice(r)) : f.selection, s = new jn(this.items.slice(0, a).append(u.reverse().concat(d)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: s, transform: o, selection: i };
  }
  // Create a new branch with the given transform added.
  addTransform(n, t, a, l) {
    let r = [], o = this.eventCount, i = this.items, s = !l && i.length ? i.get(i.length - 1) : null;
    for (let u = 0; u < n.steps.length; u++) {
      let f = n.steps[u].invert(n.docs[u]), b = new Zn(n.mapping.maps[u], f, t), h;
      (h = s && s.merge(b)) && (b = h, u ? r.pop() : i = i.slice(0, i.length - 1)), r.push(b), t && (o++, t = void 0), l || (s = b);
    }
    let d = o - a.depth;
    return d > QR && (i = ZR(i, d), o -= d), new jn(i.append(r), o);
  }
  remapping(n, t) {
    let a = new Zr();
    return this.items.forEach((l, r) => {
      let o = l.mirrorOffset != null && r - l.mirrorOffset >= n ? a.maps.length - l.mirrorOffset : void 0;
      a.appendMap(l.map, o);
    }, n, t), a;
  }
  addMaps(n) {
    return this.eventCount == 0 ? this : new jn(this.items.append(n.map((t) => new Zn(t))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(n, t) {
    if (!this.eventCount)
      return this;
    let a = [], l = Math.max(0, this.items.length - t), r = n.mapping, o = n.steps.length, i = this.eventCount;
    this.items.forEach((b) => {
      b.selection && i--;
    }, l);
    let s = t;
    this.items.forEach((b) => {
      let h = r.getMirror(--s);
      if (h == null)
        return;
      o = Math.min(o, h);
      let p = r.maps[h];
      if (b.step) {
        let x = n.steps[h].invert(n.docs[h]), y = b.selection && b.selection.map(r.slice(s + 1, h));
        y && i++, a.push(new Zn(p, x, y));
      } else
        a.push(new Zn(p));
    }, l);
    let d = [];
    for (let b = t; b < o; b++)
      d.push(new Zn(r.maps[b]));
    let u = this.items.slice(0, l).append(d).append(a), f = new jn(u, i);
    return f.emptyItemCount() > XR && (f = f.compress(this.items.length - a.length)), f;
  }
  emptyItemCount() {
    let n = 0;
    return this.items.forEach((t) => {
      t.step || n++;
    }), n;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(n = this.items.length) {
    let t = this.remapping(0, n), a = t.maps.length, l = [], r = 0;
    return this.items.forEach((o, i) => {
      if (i >= n)
        l.push(o), o.selection && r++;
      else if (o.step) {
        let s = o.step.map(t.slice(a)), d = s && s.getMap();
        if (a--, d && t.appendMap(d, a), s) {
          let u = o.selection && o.selection.map(t.slice(a));
          u && r++;
          let f = new Zn(d.invert(), s, u), b, h = l.length - 1;
          (b = l.length && l[h].merge(f)) ? l[h] = b : l.push(f);
        }
      } else o.map && a--;
    }, this.items.length, 0), new jn(Jt.from(l.reverse()), r);
  }
}
jn.empty = new jn(Jt.empty, 0);
function ZR(e, n) {
  let t;
  return e.forEach((a, l) => {
    if (a.selection && n-- == 0)
      return t = l, !1;
  }), e.slice(t);
}
class Zn {
  constructor(n, t, a, l) {
    this.map = n, this.step = t, this.selection = a, this.mirrorOffset = l;
  }
  merge(n) {
    if (this.step && n.step && !n.selection) {
      let t = n.step.merge(this.step);
      if (t)
        return new Zn(t.getMap().invert(), t, this.selection);
    }
  }
}
class Ta {
  constructor(n, t, a, l, r) {
    this.done = n, this.undone = t, this.prevRanges = a, this.prevTime = l, this.prevComposition = r;
  }
}
const QR = 20;
function _R(e, n, t, a) {
  let l = t.getMeta(gl), r;
  if (l)
    return l.historyState;
  t.getMeta(n5) && (e = new Ta(e.done, e.undone, null, 0, -1));
  let o = t.getMeta("appendedTransaction");
  if (t.steps.length == 0)
    return e;
  if (o && o.getMeta(gl))
    return o.getMeta(gl).redo ? new Ta(e.done.addTransform(t, void 0, a, ti(n)), e.undone, _h(t.mapping.maps), e.prevTime, e.prevComposition) : new Ta(e.done, e.undone.addTransform(t, void 0, a, ti(n)), null, e.prevTime, e.prevComposition);
  if (t.getMeta("addToHistory") !== !1 && !(o && o.getMeta("addToHistory") === !1)) {
    let i = t.getMeta("composition"), s = e.prevTime == 0 || !o && e.prevComposition != i && (e.prevTime < (t.time || 0) - a.newGroupDelay || !e5(t, e.prevRanges)), d = o ? dd(e.prevRanges, t.mapping) : _h(t.mapping.maps);
    return new Ta(e.done.addTransform(t, s ? n.selection.getBookmark() : void 0, a, ti(n)), jn.empty, d, t.time, i ?? e.prevComposition);
  } else return (r = t.getMeta("rebased")) ? new Ta(e.done.rebased(t, r), e.undone.rebased(t, r), dd(e.prevRanges, t.mapping), e.prevTime, e.prevComposition) : new Ta(e.done.addMaps(t.mapping.maps), e.undone.addMaps(t.mapping.maps), dd(e.prevRanges, t.mapping), e.prevTime, e.prevComposition);
}
function e5(e, n) {
  if (!n)
    return !1;
  if (!e.docChanged)
    return !0;
  let t = !1;
  return e.mapping.maps[0].forEach((a, l) => {
    for (let r = 0; r < n.length; r += 2)
      a <= n[r + 1] && l >= n[r] && (t = !0);
  }), t;
}
function _h(e) {
  let n = [];
  for (let t = e.length - 1; t >= 0 && n.length == 0; t--)
    e[t].forEach((a, l, r, o) => n.push(r, o));
  return n;
}
function dd(e, n) {
  if (!e)
    return null;
  let t = [];
  for (let a = 0; a < e.length; a += 2) {
    let l = n.map(e[a], 1), r = n.map(e[a + 1], -1);
    l <= r && t.push(l, r);
  }
  return t;
}
function t5(e, n, t) {
  let a = ti(n), l = gl.get(n).spec.config, r = (t ? e.undone : e.done).popEvent(n, a);
  if (!r)
    return null;
  let o = r.selection.resolve(r.transform.doc), i = (t ? e.done : e.undone).addTransform(r.transform, n.selection.getBookmark(), l, a), s = new Ta(t ? i : r.remaining, t ? r.remaining : i, null, 0, -1);
  return r.transform.setSelection(o).setMeta(gl, { redo: t, historyState: s });
}
let ud = !1, eb = null;
function ti(e) {
  let n = e.plugins;
  if (eb != n) {
    ud = !1, eb = n;
    for (let t = 0; t < n.length; t++)
      if (n[t].spec.historyPreserveItems) {
        ud = !0;
        break;
      }
  }
  return ud;
}
const gl = new qt("history"), n5 = new qt("closeHistory");
function a5(e = {}) {
  return e = {
    depth: e.depth || 100,
    newGroupDelay: e.newGroupDelay || 500
  }, new Bt({
    key: gl,
    state: {
      init() {
        return new Ta(jn.empty, jn.empty, null, 0, -1);
      },
      apply(n, t, a) {
        return _R(t, a, n, e);
      }
    },
    config: e,
    props: {
      handleDOMEvents: {
        beforeinput(n, t) {
          let a = t.inputType, l = a == "historyUndo" ? Sv : a == "historyRedo" ? $v : null;
          return !l || !n.editable ? !1 : (t.preventDefault(), l(n.state, n.dispatch));
        }
      }
    }
  });
}
function Cv(e, n) {
  return (t, a) => {
    let l = gl.getState(t);
    if (!l || (e ? l.undone : l.done).eventCount == 0)
      return !1;
    if (a) {
      let r = t5(l, t, e);
      r && a(n ? r.scrollIntoView() : r);
    }
    return !0;
  };
}
const Sv = Cv(!1, !0), $v = Cv(!0, !0);
wt.create({
  name: "characterCount",
  addOptions() {
    return {
      limit: null,
      autoTrim: !0,
      mode: "textSize",
      textCounter: (e) => e.length,
      wordCounter: (e) => e.split(" ").filter((n) => n !== "").length
    };
  },
  addStorage() {
    return {
      characters: () => 0,
      words: () => 0
    };
  },
  onBeforeCreate() {
    this.storage.characters = (e) => {
      const n = (e == null ? void 0 : e.node) || this.editor.state.doc;
      if (((e == null ? void 0 : e.mode) || this.options.mode) === "textSize") {
        const a = n.textBetween(0, n.content.size, void 0, " ");
        return this.options.textCounter(a);
      }
      return n.nodeSize;
    }, this.storage.words = (e) => {
      const n = (e == null ? void 0 : e.node) || this.editor.state.doc, t = n.textBetween(0, n.content.size, " ", " ");
      return this.options.wordCounter(t);
    };
  },
  addProseMirrorPlugins() {
    let e = !1;
    return [
      new Bt({
        key: new qt("characterCount"),
        appendTransaction: (n, t, a) => {
          if (e)
            return;
          const l = this.options.limit, r = this.options.autoTrim;
          if (l == null || l === 0 || r === !1) {
            e = !0;
            return;
          }
          const o = this.storage.characters({ node: a.doc });
          if (o > l) {
            const i = o - l, s = 0, d = i;
            console.warn(
              `[CharacterCount] Initial content exceeded limit of ${l} characters. Content was automatically trimmed.`
            );
            const u = a.tr.deleteRange(s, d);
            return e = !0, u;
          }
          e = !0;
        },
        filterTransaction: (n, t) => {
          const a = this.options.limit;
          if (!n.docChanged || a === 0 || a === null || a === void 0)
            return !0;
          const l = this.storage.characters({ node: t.doc }), r = this.storage.characters({ node: n.doc });
          if (r <= a || l > a && r > a && r <= l)
            return !0;
          if (l > a && r > a && r > l || !n.getMeta("paste"))
            return !1;
          const i = n.selection.$head.pos, s = r - a, d = i - s, u = i;
          return n.deleteRange(d, u), !(this.storage.characters({ node: n.doc }) > a);
        }
      })
    ];
  }
});
var l5 = wt.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [NR(this.options)];
  }
});
wt.create({
  name: "focus",
  addOptions() {
    return {
      className: "has-focus",
      mode: "all"
    };
  },
  addProseMirrorPlugins() {
    return [
      new Bt({
        key: new qt("focus"),
        props: {
          decorations: ({ doc: e, selection: n }) => {
            const { isEditable: t, isFocused: a } = this.editor, { anchor: l } = n, r = [];
            if (!t || !a)
              return Et.create(e, []);
            let o = 0;
            this.options.mode === "deepest" && e.descendants((s, d) => {
              if (s.isText)
                return;
              if (!(l >= d && l <= d + s.nodeSize - 1))
                return !1;
              o += 1;
            });
            let i = 0;
            return e.descendants((s, d) => {
              if (s.isText || !(l >= d && l <= d + s.nodeSize - 1))
                return !1;
              if (i += 1, this.options.mode === "deepest" && o - i > 0 || this.options.mode === "shallowest" && i > 1)
                return this.options.mode === "deepest";
              r.push(
                un.node(d, d + s.nodeSize, {
                  class: this.options.className
                })
              );
            }), Et.create(e, r);
          }
        }
      })
    ];
  }
});
var r5 = wt.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [qR()];
  },
  extendNodeSchema(e) {
    var n;
    const t = {
      name: e.name,
      options: e.options,
      storage: e.storage
    };
    return {
      allowGapCursor: (n = xt(_e(e, "allowGapCursor", t))) != null ? n : null
    };
  }
});
function tb(e) {
  const {
    editor: n,
    placeholder: t,
    dataAttribute: a,
    pos: l,
    node: r,
    isEmptyDoc: o,
    hasAnchor: i,
    classes: { emptyNode: s, emptyEditor: d }
  } = e, u = [s];
  return o && u.push(d), un.node(l, l + r.nodeSize, {
    class: u.join(" "),
    [a]: typeof t == "function" ? t({
      editor: n,
      node: r,
      pos: l,
      hasAnchor: i
    }) : t
  });
}
function o5(e) {
  const n = getComputedStyle(e), t = `${n.overflow} ${n.overflowY} ${n.overflowX}`;
  return /auto|scroll|overlay/.test(t);
}
function i5(e) {
  let n = e;
  for (; n; ) {
    if (o5(n))
      return n;
    const t = n.parentElement;
    if (!t) {
      const a = n.getRootNode();
      if (a instanceof ShadowRoot) {
        n = a.host;
        continue;
      }
      return window;
    }
    n = t;
  }
  return window;
}
function s5(e) {
  return e === window ? { top: 0, bottom: window.innerHeight } : e.getBoundingClientRect();
}
function d5({
  doc: e,
  view: n,
  scrollContainer: t
}) {
  const a = n.dom.getBoundingClientRect(), l = t ? s5(t) : { top: 0, bottom: window.innerHeight }, r = Math.max(a.top, l.top), o = Math.min(a.bottom, l.bottom);
  if (r >= o)
    return { top: 0, bottom: e.content.size };
  const s = getComputedStyle(n.dom).direction === "rtl" ? Math.max(a.right - 2, a.left + 2) : a.left + 2, d = n.posAtCoords({ left: s, top: r + 2 }), u = n.posAtCoords({ left: s, top: o - 2 });
  return {
    top: d ? d.pos : 0,
    bottom: u ? u.pos : e.content.size
  };
}
function u5(e, n) {
  let t = null;
  return { call: (...r) => {
    t || (e(...r), t = setTimeout(() => {
      t = null;
    }, n));
  }, cancel: () => {
    t && (clearTimeout(t), t = null);
  } };
}
var nb = "placeholder";
function c5(e) {
  return e.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9-]/g, "").replace(/^[0-9-]+/, "").replace(/^-+/, "").toLowerCase();
}
var gr = new qt("tiptap__placeholder");
wt.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      dataAttribute: nb,
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    const e = this.options.dataAttribute ? `data-${c5(this.options.dataAttribute)}` : `data-${nb}`;
    return [
      new Bt({
        state: {
          init() {
            return {
              // null means "no viewport info yet" — decoration callback falls
              // back to full document scan until the scroll handler fires.
              topPos: null,
              bottomPos: null
            };
          },
          apply(n, t) {
            const a = n.getMeta(gr);
            return a != null && a.positions ? {
              topPos: a.positions.top,
              bottomPos: a.positions.bottom
            } : n.docChanged ? {
              topPos: t.topPos !== null ? n.mapping.map(t.topPos) : null,
              bottomPos: t.bottomPos !== null ? n.mapping.map(t.bottomPos) : null
            } : t;
          }
        },
        key: gr,
        view(n) {
          const t = i5(n.dom), a = () => {
            const i = d5({
              view: n,
              doc: n.state.doc,
              scrollContainer: t
            }), s = gr.getState(n.state);
            if (s.topPos === i.top && s.bottomPos === i.bottom)
              return;
            const d = n.state.tr.setMeta(gr, { positions: i }).setMeta("tiptap__viewportUpdate", !0);
            n.dispatch(d);
          }, { call: l, cancel: r } = u5(a, 250), o = t;
          return o.addEventListener("scroll", l, { passive: !0 }), a(), {
            update(i, s) {
              n.state.doc.content.size !== s.doc.content.size && a();
            },
            destroy: () => {
              r(), o.removeEventListener("scroll", l);
            }
          };
        },
        props: {
          decorations: ({ doc: n, selection: t }) => {
            var a, l;
            if (!(this.editor.isEditable || !this.options.showOnlyWhenEditable))
              return null;
            const { anchor: o } = t, i = [], s = this.editor.isEmpty;
            if (this.options.showOnlyCurrent && !this.options.includeChildren) {
              const u = n.resolve(o);
              if (u.depth > 0) {
                const f = u.node(1), b = u.before(1);
                if (f.type.isTextblock && lo(f)) {
                  const h = o >= b && o <= b + f.nodeSize, p = tb({
                    node: f,
                    dataAttribute: e,
                    hasAnchor: h,
                    placeholder: this.options.placeholder,
                    classes: {
                      emptyEditor: this.options.emptyEditorClass,
                      emptyNode: this.options.emptyNodeClass
                    },
                    editor: this.editor,
                    isEmptyDoc: s,
                    pos: u.before(1)
                  });
                  i.push(p);
                }
              }
            } else {
              const u = gr.getState(this.editor.state), f = (a = u.topPos) != null ? a : 0, b = (l = u.bottomPos) != null ? l : n.content.size;
              n.nodesBetween(f, b, (h, p) => {
                const x = o >= p && o <= p + h.nodeSize, y = !h.isLeaf && lo(h);
                if (!h.type.isTextblock)
                  return this.options.includeChildren;
                if ((x || !this.options.showOnlyCurrent) && y) {
                  const k = tb({
                    classes: { emptyEditor: this.options.emptyEditorClass, emptyNode: this.options.emptyNodeClass },
                    editor: this.editor,
                    isEmptyDoc: s,
                    dataAttribute: e,
                    hasAnchor: x,
                    placeholder: this.options.placeholder,
                    node: h,
                    pos: p
                  });
                  i.push(k);
                }
                return this.options.includeChildren;
              });
            }
            return Et.create(n, i);
          }
        }
      })
    ];
  }
});
wt.create({
  name: "selection",
  addOptions() {
    return {
      className: "selection"
    };
  },
  addProseMirrorPlugins() {
    const { editor: e, options: n } = this;
    return [
      new Bt({
        key: new qt("selection"),
        props: {
          decorations(t) {
            return t.selection.empty || e.isFocused || !e.isEditable || Pp(t.selection) || e.view.dragging ? null : Et.create(t.doc, [
              un.inline(t.selection.from, t.selection.to, {
                class: n.className
              })
            ]);
          }
        }
      })
    ];
  }
});
var f5 = "skipTrailingNode";
function ab({ types: e, node: n }) {
  return n && Array.isArray(e) && e.includes(n.type) || (n == null ? void 0 : n.type) === e;
}
var h5 = wt.create({
  name: "trailingNode",
  addOptions() {
    return {
      node: void 0,
      notAfter: []
    };
  },
  addProseMirrorPlugins() {
    var e;
    const n = new qt(this.name), t = this.options.node || ((e = this.editor.schema.topNodeType.contentMatch.defaultType) == null ? void 0 : e.name) || "paragraph", a = Object.entries(this.editor.schema.nodes).map(([, l]) => l).filter((l) => (this.options.notAfter || []).concat(t).includes(l.name));
    return [
      new Bt({
        key: n,
        appendTransaction: (l, r, o) => {
          const { doc: i, tr: s, schema: d } = o, u = n.getState(o), f = i.content.size, b = d.nodes[t];
          if (!l.some((h) => h.getMeta(f5)) && u)
            return s.insert(f, b.create());
        },
        state: {
          init: (l, r) => {
            const o = r.tr.doc.lastChild;
            return !ab({ node: o, types: a });
          },
          apply: (l, r) => {
            if (!l.docChanged || l.getMeta("__uniqueIDTransaction"))
              return r;
            const o = l.doc.lastChild;
            return !ab({ node: o, types: a });
          }
        }
      })
    ];
  }
}), b5 = wt.create({
  name: "undoRedo",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: e, dispatch: n }) => Sv(e, n),
      redo: () => ({ state: e, dispatch: n }) => $v(e, n)
    };
  },
  addProseMirrorPlugins() {
    return [a5(this.options)];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), g5 = wt.create({
  name: "starterKit",
  addExtensions() {
    var e, n, t, a;
    const l = [];
    return this.options.bold !== !1 && l.push(EE.configure(this.options.bold)), this.options.blockquote !== !1 && l.push($E.configure(this.options.blockquote)), this.options.bulletList !== !1 && l.push(cv.configure(this.options.bulletList)), this.options.code !== !1 && l.push(ME.configure(this.options.code)), this.options.codeBlock !== !1 && l.push(OE.configure(this.options.codeBlock)), this.options.document !== !1 && l.push(PE.configure(this.options.document)), this.options.dropcursor !== !1 && l.push(l5.configure(this.options.dropcursor)), this.options.gapcursor !== !1 && l.push(r5.configure(this.options.gapcursor)), this.options.hardBreak !== !1 && l.push(FE.configure(this.options.hardBreak)), this.options.heading !== !1 && l.push(VE.configure(this.options.heading)), this.options.undoRedo !== !1 && l.push(b5.configure(this.options.undoRedo)), this.options.horizontalRule !== !1 && l.push(NE.configure(this.options.horizontalRule)), this.options.italic !== !1 && l.push(UE.configure(this.options.italic)), this.options.listItem !== !1 && l.push(fv.configure(this.options.listItem)), this.options.listKeymap !== !1 && l.push(vv.configure((e = this.options) == null ? void 0 : e.listKeymap)), this.options.link !== !1 && l.push(pR.configure((n = this.options) == null ? void 0 : n.link)), this.options.orderedList !== !1 && l.push(yv.configure(this.options.orderedList)), this.options.paragraph !== !1 && l.push(DR.configure(this.options.paragraph)), this.options.strike !== !1 && l.push(PR.configure(this.options.strike)), this.options.text !== !1 && l.push(FR.configure(this.options.text)), this.options.underline !== !1 && l.push(VR.configure((t = this.options) == null ? void 0 : t.underline)), this.options.trailingNode !== !1 && l.push(h5.configure((a = this.options) == null ? void 0 : a.trailingNode)), l;
  }
}), m5 = g5, p5 = wt.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: null
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: (e) => {
              const n = e.style.textAlign;
              return this.options.alignments.includes(n) ? n : this.options.defaultAlignment;
            },
            renderHTML: (e) => e.textAlign ? { style: `text-align: ${e.textAlign}` } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlign: (e) => ({ commands: n }) => this.options.alignments.includes(e) ? this.options.types.map((t) => n.updateAttributes(t, { textAlign: e })).some((t) => t) : !1,
      unsetTextAlign: () => ({ commands: e }) => this.options.types.map((n) => e.resetAttributes(n, "textAlign")).some((n) => n),
      toggleTextAlign: (e) => ({ editor: n, commands: t }) => this.options.alignments.includes(e) ? n.isActive({ textAlign: e }) ? t.unsetTextAlign() : t.setTextAlign(e) : !1
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
}), v5 = p5, x5 = 20, Iv = (e, n = 0) => {
  const t = [];
  return !e.children.length || n > x5 || Array.from(e.children).forEach((a) => {
    a.tagName === "SPAN" ? t.push(a) : a.children.length && t.push(...Iv(a, n + 1));
  }), t;
}, y5 = (e) => {
  if (!e.children.length)
    return;
  const n = Iv(e);
  n && n.forEach((t) => {
    var a, l;
    const r = t.getAttribute("style"), o = (l = (a = t.parentElement) == null ? void 0 : a.closest("span")) == null ? void 0 : l.getAttribute("style");
    t.setAttribute("style", `${o};${r}`);
  });
}, Lv = Ca.create({
  name: "textStyle",
  priority: 101,
  addOptions() {
    return {
      HTMLAttributes: {},
      mergeNestedSpanStyles: !0
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        consuming: !1,
        getAttrs: (e) => e.hasAttribute("style") ? (this.options.mergeNestedSpanStyles && y5(e), {}) : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["span", Rt(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      toggleTextStyle: (e) => ({ commands: n }) => n.toggleMark(this.name, e),
      removeEmptyTextStyle: () => ({ tr: e }) => {
        const { selection: n } = e;
        return e.doc.nodesBetween(n.from, n.to, (t, a) => {
          if (t.isTextblock)
            return !0;
          t.marks.filter((l) => l.type === this.type).some((l) => Object.values(l.attrs).some((r) => !!r)) || e.removeMark(a, a + t.nodeSize, this.type);
        }), !0;
      }
    };
  }
}), k5 = wt.create({
  name: "backgroundColor",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          backgroundColor: {
            default: null,
            parseHTML: (e) => {
              var n;
              const t = (n = rr(e, "background-color")) != null ? n : e.style.backgroundColor;
              return t == null ? void 0 : t.replace(/['"]+/g, "");
            },
            renderHTML: (e) => e.backgroundColor ? {
              style: `background-color: ${e.backgroundColor}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setBackgroundColor: (e) => ({ chain: n }) => n().setMark("textStyle", { backgroundColor: e }).run(),
      unsetBackgroundColor: () => ({ chain: e }) => e().setMark("textStyle", { backgroundColor: null }).removeEmptyTextStyle().run()
    };
  }
}), Tv = wt.create({
  name: "color",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (e) => {
              var n;
              const t = (n = rr(e, "color")) != null ? n : e.style.color;
              return t == null ? void 0 : t.replace(/['"]+/g, "");
            },
            renderHTML: (e) => e.color ? {
              style: `color: ${e.color}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setColor: (e) => ({ chain: n }) => n().setMark("textStyle", { color: e }).run(),
      unsetColor: () => ({ chain: e }) => e().setMark("textStyle", { color: null }).removeEmptyTextStyle().run()
    };
  }
}), w5 = wt.create({
  name: "fontFamily",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontFamily: {
            default: null,
            // Prefer the raw inline `style` attribute so unquoted or
            // single-quoted multi-word names are preserved instead of being
            // canonicalized by `element.style.fontFamily`, which forces double
            // quotes that then get HTML-encoded to `&quot;` on serialization.
            parseHTML: (e) => {
              var n;
              return (n = rr(e, "font-family")) != null ? n : e.style.fontFamily;
            },
            renderHTML: (e) => e.fontFamily ? {
              style: `font-family: ${e.fontFamily}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontFamily: (e) => ({ chain: n }) => n().setMark("textStyle", { fontFamily: e }).run(),
      unsetFontFamily: () => ({ chain: e }) => e().setMark("textStyle", { fontFamily: null }).removeEmptyTextStyle().run()
    };
  }
}), Av = wt.create({
  name: "fontSize",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            // Prefer the raw inline `style` attribute so the original format
            // is preserved instead of the canonicalized value returned by
            // `element.style.fontSize`.
            parseHTML: (e) => {
              var n;
              return (n = rr(e, "font-size")) != null ? n : e.style.fontSize;
            },
            renderHTML: (e) => e.fontSize ? {
              style: `font-size: ${e.fontSize}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontSize: (e) => ({ chain: n }) => n().setMark("textStyle", { fontSize: e }).run(),
      unsetFontSize: () => ({ chain: e }) => e().setMark("textStyle", { fontSize: null }).removeEmptyTextStyle().run()
    };
  }
}), Ev = wt.create({
  name: "lineHeight",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          lineHeight: {
            default: null,
            // Prefer the raw inline `style` attribute so the original format
            // is preserved instead of the canonicalized value returned by
            // `element.style.lineHeight`.
            parseHTML: (e) => {
              var n;
              return (n = rr(e, "line-height")) != null ? n : e.style.lineHeight;
            },
            renderHTML: (e) => e.lineHeight ? {
              style: `line-height: ${e.lineHeight}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setLineHeight: (e) => ({ chain: n }) => n().setMark("textStyle", { lineHeight: e }).run(),
      unsetLineHeight: () => ({ chain: e }) => e().setMark("textStyle", { lineHeight: null }).removeEmptyTextStyle().run()
    };
  }
});
wt.create({
  name: "textStyleKit",
  addExtensions() {
    const e = [];
    return this.options.backgroundColor !== !1 && e.push(k5.configure(this.options.backgroundColor)), this.options.color !== !1 && e.push(Tv.configure(this.options.color)), this.options.fontFamily !== !1 && e.push(w5.configure(this.options.fontFamily)), this.options.fontSize !== !1 && e.push(Av.configure(this.options.fontSize)), this.options.lineHeight !== !1 && e.push(Ev.configure(this.options.lineHeight)), this.options.textStyle !== !1 && e.push(Lv.configure(this.options.textStyle)), e;
  }
});
var C5 = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))$/, S5 = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))/g, $5 = Ca.create({
  name: "highlight",
  addOptions() {
    return {
      multicolor: !1,
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    return this.options.multicolor ? {
      color: {
        default: null,
        // Prefer `data-color` (set by our own `renderHTML`) for lossless
        // round-trips. Otherwise parse the raw inline `style` attribute so
        // the original color format (e.g. `#rrggbb`) is preserved instead of
        // the canonicalized `rgb(...)` value from `element.style.backgroundColor`.
        parseHTML: (e) => e.getAttribute("data-color") || rr(e, "background-color") || e.style.backgroundColor,
        renderHTML: (e) => e.color ? {
          "data-color": e.color,
          style: `background-color: ${e.color}; color: inherit`
        } : {}
      }
    } : {};
  },
  parseHTML() {
    return [
      {
        tag: "mark"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["mark", Rt(this.options.HTMLAttributes, e), 0];
  },
  renderMarkdown: (e, n) => `==${n.renderChildren(e)}==`,
  parseMarkdown: (e, n) => n.applyMark("highlight", n.parseInline(e.tokens || [])),
  markdownTokenizer: {
    name: "highlight",
    level: "inline",
    start: (e) => e.indexOf("=="),
    tokenize(e, n, t) {
      const l = /^(==)([^=]+)(==)/.exec(e);
      if (l) {
        const r = l[2].trim(), o = t.inlineTokens(r);
        return {
          type: "highlight",
          raw: l[0],
          text: r,
          tokens: o
        };
      }
    }
  },
  addCommands() {
    return {
      setHighlight: (e) => ({ commands: n }) => n.setMark(this.name, e),
      toggleHighlight: (e) => ({ commands: n }) => n.toggleMark(this.name, e),
      unsetHighlight: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-h": () => this.editor.commands.toggleHighlight()
    };
  },
  addInputRules() {
    return [
      Cl({
        find: C5,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ga({
        find: S5,
        type: this.type
      })
    ];
  }
}), I5 = $5, L5 = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, T5 = xn.create({
  name: "image",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {},
      resize: !1
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      },
      width: {
        default: null
      },
      height: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["img", Rt(this.options.HTMLAttributes, e)];
  },
  parseMarkdown: (e, n) => n.createNode("image", {
    src: e.href,
    title: e.title,
    alt: e.text
  }),
  renderMarkdown: (e) => {
    var n, t, a, l, r, o;
    const i = (t = (n = e.attrs) == null ? void 0 : n.src) != null ? t : "", s = (l = (a = e.attrs) == null ? void 0 : a.alt) != null ? l : "", d = (o = (r = e.attrs) == null ? void 0 : r.title) != null ? o : "";
    return d ? `![${s}](${i} "${d}")` : `![${s}](${i})`;
  },
  addNodeView() {
    if (!this.options.resize || !this.options.resize.enabled || typeof document > "u")
      return null;
    const { directions: e, minWidth: n, minHeight: t, alwaysPreserveAspectRatio: a } = this.options.resize;
    return ({ node: l, getPos: r, HTMLAttributes: o, editor: i }) => {
      const s = document.createElement("img");
      Object.entries(o).forEach(([f, b]) => {
        if (b != null)
          switch (f) {
            case "width":
            case "height":
              break;
            default:
              s.setAttribute(f, b);
              break;
          }
      }), s.src = o.src;
      const d = new fE({
        element: s,
        editor: i,
        node: l,
        getPos: r,
        onResize: (f, b) => {
          s.style.width = `${f}px`, s.style.height = `${b}px`;
        },
        onCommit: (f, b) => {
          const h = r();
          h !== void 0 && this.editor.chain().setNodeSelection(h).updateAttributes(this.name, {
            width: f,
            height: b
          }).run();
        },
        onUpdate: (f, b, h) => f.type === l.type,
        options: {
          directions: e,
          min: {
            width: n,
            height: t
          },
          preserveAspectRatio: a === !0
        }
      }), u = d.dom;
      return u.style.visibility = "hidden", u.style.pointerEvents = "none", s.onload = () => {
        u.style.visibility = "", u.style.pointerEvents = "";
      }, d;
    };
  },
  addCommands() {
    return {
      setImage: (e) => ({ commands: n }) => n.insertContent({
        type: this.name,
        attrs: e
      })
    };
  },
  addInputRules() {
    return [
      ev({
        find: L5,
        type: this.type,
        getAttributes: (e) => {
          const [, , n, t, a] = e;
          return { src: t, alt: n, title: a };
        }
      })
    ];
  }
}), A5 = T5;
const lb = 60, E5 = 10, R5 = 290;
function Rv(e) {
  const n = Symbol("opal-overlay-layer");
  $e(
    e,
    (r) => r ? N0(n) : hf(n),
    { immediate: !0 }
  ), kt(() => hf(n));
  let t = lb;
  const a = m(() => {
    const r = Wn.value.indexOf(n);
    return r >= 0 && (t = Math.min(lb + r * E5, R5)), t;
  }), l = m(() => Wn.value[Wn.value.length - 1] === n);
  return { zIndex: a, isTop: l };
}
const B5 = ["aria-label", "aria-labelledby", "aria-describedby", "aria-modal"], M5 = {
  "data-testid": "modal-pre-header",
  class: "flex items-center justify-end h-9"
}, D5 = {
  key: 0,
  class: "flex-1 min-w-0"
}, z5 = ["data-testid"], O5 = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "Modal",
  props: {
    modelValue: { type: Boolean, default: !1 },
    size: { default: "md" },
    showCloseButton: { type: Boolean, default: !0 },
    title: { default: void 0 },
    subtitle: { default: void 0 },
    headingLevel: { default: 2 },
    icon: { default: void 0 },
    avatar: { default: void 0 },
    headerAlign: { default: "stacked" },
    headerPosition: { default: "left" },
    actions: { default: () => [] },
    footerAlign: { default: "right" },
    footerPosition: { default: "right" },
    initialFocus: { default: void 0 },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    dismissable: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    showFooter: { type: Boolean, default: !0 },
    showHeader: { type: Boolean, default: !0 },
    showHeaderBorder: { type: Boolean, default: !1 },
    showFooterBorder: { type: Boolean, default: !1 },
    contentClass: { default: void 0 },
    headerClass: { default: void 0 },
    overlayClass: { default: void 0 },
    borderGradient: { default: void 0 },
    ariaCloseLabel: { default: "Close modal" }
  },
  emits: ["update:modelValue", "close", "action"],
  setup(e, { emit: n }) {
    var _;
    const t = Gn(), a = () => Object.fromEntries(Object.entries(t).filter(([, ue]) => ue !== void 0)), l = Hn();
    dn(Zu, null);
    const r = e, o = n, i = (ue) => {
      var se;
      (se = ue.onClick) == null || se.call(ue), o("action", ue.id);
    }, s = () => {
      o("update:modelValue", !1), o("close");
    }, d = () => {
      r.dismissable && s();
    }, u = Symbol("opal-modal"), f = () => ra(u), b = () => Fn(u), h = (ue) => {
      ue.key !== "Escape" || !r.closeOnEscape || !r.modelValue || ya(u) && (ue.defaultPrevented || (ue.preventDefault(), s()));
    }, { zIndex: p, isTop: x } = Rv(An(r, "modelValue"));
    $e(
      () => r.modelValue,
      (ue) => {
        ue ? f() : b();
      }
    ), ct(() => {
      document.addEventListener("keydown", h), r.modelValue && f();
    }), kt(() => {
      document.removeEventListener("keydown", h), b();
    });
    const y = {
      xs: "max-w-[384px]",
      sm: "max-w-[500px]",
      md: "max-w-[704px]",
      lg: "max-w-[996px]",
      xl: "max-w-[1340px]",
      "2xl": "max-w-full"
    }, k = {
      left: "justify-start text-left",
      center: "justify-center text-center"
    }, $ = {
      right: "justify-end",
      center: "justify-center",
      split: "justify-between"
    }, S = qe(), T = `${S}-title`, I = `${S}-subtitle`, A = (ue) => {
      const se = l[ue];
      return !!se && tc(se({ titleId: T, subtitleId: I }));
    }, E = () => A("header"), D = () => A("footer"), z = () => r.showHeader && (!!r.title || !!r.icon || !!r.avatar || E()), Y = () => r.showFooter && (D() || r.actions.length > 0), le = () => z() && !E() && !!r.title, ne = () => z() && !E() && !!r.subtitle, re = () => r.ariaLabelledby || (le() ? T : void 0), O = () => ne() ? I : void 0, P = m(() => `h${r.headingLevel}`), V = m(() => r.headerAlign === "middle-stacked"), M = m(() => !r.icon && !r.avatar || r.headerAlign === "aligned"), B = m(() => M.value ? "flex-row items-start" : V.value ? "flex-col items-center" : "flex-col items-start"), q = m(
      () => r.footerAlign === "split" && r.actions.length < 2 ? "right" : r.footerAlign
    ), N = m(() => (q.value === "split" ? [
      { side: "start", actions: r.actions.slice(0, 1) },
      { side: "end", actions: r.actions.slice(1) }
    ] : [{ side: "all", actions: r.actions }]).filter((se) => se.actions.length > 0)), G = m(() => y[r.size]), U = () => E() ? k[r.headerPosition] : k[V.value ? "center" : "left"], K = () => $[D() ? r.footerPosition : q.value], ge = m(() => r.size === "2xl"), xe = m(
      () => r.borderGradient ? { "--Border-gradient": r.borderGradient } : void 0
    ), X = R(null);
    ts({
      active: An(r, "modelValue"),
      container: X,
      containFocus: !0
    });
    const ie = typeof process < "u" && ((_ = process.env) == null ? void 0 : _.NODE_ENV) !== "production", he = (ue) => {
      var se;
      if (typeof ue != "string") return ue;
      try {
        return (se = X.value) == null ? void 0 : se.querySelector(ue);
      } catch {
        ie && console.warn(`[OPAL Modal] \`initialFocus\` "${ue}" is not a valid CSS selector.`);
        return;
      }
    }, oe = 96, Ce = R(!1), H = () => {
      const ue = X.value, se = ue == null ? void 0 : ue.querySelector('[data-testid="modal-content"]');
      if (!ue || !se) return;
      const Q = getComputedStyle(ue), ae = parseFloat(Q.maxHeight);
      if (!Number.isFinite(ae)) {
        Ce.value = !1;
        return;
      }
      let Le = ["paddingTop", "paddingBottom", "borderTopWidth", "borderBottomWidth"].reduce((pe, ke) => pe + (parseFloat(Q[ke]) || 0), 0);
      for (const pe of Array.from(ue.children)) pe !== se && (Le += pe.offsetHeight);
      Ce.value = ae - Le < Math.min(se.scrollHeight, oe);
    };
    let Z, ee;
    const J = () => {
      Z == null || Z.disconnect(), Z = void 0, ee == null || ee.disconnect(), ee = void 0, window.removeEventListener("resize", H);
    }, F = (ue) => {
      if (!Z) return;
      Z.observe(ue);
      for (const Q of Array.from(ue.children)) Z.observe(Q);
      const se = ue.querySelector('[data-testid="modal-content"]');
      for (const Q of Array.from((se == null ? void 0 : se.children) ?? [])) Z.observe(Q);
    };
    return $e(X, (ue) => {
      if (J(), Ce.value = !1, !(!ue || typeof ResizeObserver > "u")) {
        if (Z = new ResizeObserver(H), F(ue), typeof MutationObserver < "u") {
          ee = new MutationObserver(() => {
            F(ue), H();
          }), ee.observe(ue, { childList: !0 });
          const se = ue.querySelector('[data-testid="modal-content"]');
          se && ee.observe(se, { childList: !0 });
        }
        window.addEventListener("resize", H), H();
      }
    }), kt(J), $e(
      () => r.modelValue,
      async (ue) => {
        var se;
        ue && (await Ge(), !(!r.modelValue || !r.initialFocus) && ((se = he(r.initialFocus)) == null || se.focus()));
      },
      { immediate: !0 }
    ), (ue, se) => (c(), W(Nn, { to: "body" }, [
      te(At, { name: "modal-fade" }, {
        default: ve(() => [
          e.modelValue ? (c(), g("div", {
            key: 0,
            "data-testid": "modal-backdrop",
            class: C([
              "fixed inset-0 flex overflow-y-auto overflow-x-hidden",
              ge.value ? "p-0" : "p-4",
              e.overlayClass
            ]),
            style: je({ zIndex: L(p) }),
            onClick: Je(d, ["self"])
          }, [
            v("div", {
              class: "fixed inset-0 bg-black/50 dark:bg-black/70",
              onClick: d
            }),
            v("div", Fe({
              "data-testid": "modal-container",
              "aria-label": e.ariaLabel,
              "aria-labelledby": re(),
              "aria-describedby": O()
            }, a(), {
              role: "dialog",
              "aria-modal": L(x) ? "true" : void 0,
              class: ["relative z-10 w-full m-auto", G.value, ge.value ? "h-full" : ""],
              onClick: se[0] || (se[0] = Je(() => {
              }, ["stop"]))
            }), [
              v("div", {
                ref_key: "panelRef",
                ref: X,
                class: C([
                  // overflow-y-auto: the whole panel scrolls only in the `cramped` state (see measureCramped).
                  "relative flex flex-col overflow-y-auto bg-(--colors-background-white) dark:bg-(--colors-background-black-default) modal-container",
                  ge.value ? "rounded-none h-full border border-(--colors-border-base-soft) dark:border-(--colors-border-base) shadow-xl" : (
                    // DS rule: constant 30px vertical margin — beyond that the content scrolls
                    // internally and the footer stays pinned (except in the `cramped` state, see
                    // measureCramped). Figma's 8px padding
                    // includes its INSIDE stroke, so the CSS border is subtracted.
                    "rounded-[var(--border-border-radius-rounded-base,24px)] p-[calc(var(--spacing-2)_-_var(--border-border-width-border-sm))] shadow-(--shadow-xl) max-h-[calc(100dvh-60px)]"
                  ),
                  e.contentClass
                ]),
                style: je(xe.value)
              }, [
                v("div", M5, [
                  e.showCloseButton ? (c(), W(Me, {
                    key: 0,
                    "data-testid": "modal-close-button",
                    variant: "ghost",
                    size: "sm",
                    "icon-only": "",
                    "icon-left": "ri-close-fill",
                    "aria-label": e.ariaCloseLabel,
                    onClick: s
                  }, null, 8, ["aria-label"])) : w("", !0)
                ]),
                z() ? (c(), g("div", {
                  key: 0,
                  "data-testid": "modal-header",
                  class: C([
                    [
                      "flex items-center gap-5 pt-0 pb-6 px-6",
                      e.showHeaderBorder && "border-b border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
                    ],
                    U(),
                    e.headerClass
                  ])
                }, [
                  E() ? (c(), g("div", D5, [
                    Ae(ue.$slots, "header", {
                      titleId: T,
                      subtitleId: I
                    }, void 0, !0)
                  ])) : (c(), g("div", {
                    key: 1,
                    "data-testid": "modal-heading-lead",
                    class: C(["flex flex-1 min-w-0 gap-2", B.value])
                  }, [
                    e.icon ? (c(), W(Gt, {
                      key: 0,
                      icon: e.icon,
                      size: "lg",
                      type: "square",
                      variant: "outlined",
                      color: "white",
                      "data-testid": "modal-header-icon",
                      class: "shrink-0"
                    }, null, 8, ["icon"])) : e.avatar ? (c(), W(Nt, {
                      key: 1,
                      name: e.avatar.name,
                      img: e.avatar.img,
                      entity: e.avatar.entity,
                      size: "xl",
                      "avatar-style": "circle",
                      presentational: "",
                      class: "shrink-0"
                    }, null, 8, ["name", "img", "entity"])) : w("", !0),
                    v("div", {
                      "data-testid": "modal-heading-text",
                      class: C([
                        "flex min-w-0 flex-col justify-center gap-0.5 self-stretch",
                        M.value && "flex-1",
                        V.value && "items-center text-center"
                      ])
                    }, [
                      e.title ? (c(), W(it(P.value), {
                        key: 0,
                        id: T,
                        "data-testid": "modal-title",
                        class: "text-(length:--size-xxl) leading-(--line-height-xxl) font-(--weight-bold) text-(--colors-text-black-default) dark:text-(--colors-text-white-default) break-words [overflow-wrap:anywhere]"
                      }, {
                        default: ve(() => [
                          nt(j(e.title), 1)
                        ]),
                        _: 1
                      })) : w("", !0),
                      e.subtitle ? (c(), g("p", {
                        key: 1,
                        id: I,
                        "data-testid": "modal-subtitle",
                        class: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--colors-text-black-default) dark:text-(--colors-text-white-default) break-words [overflow-wrap:anywhere]"
                      }, j(e.subtitle), 1)) : w("", !0)
                    ], 2)
                  ], 2))
                ], 2)) : w("", !0),
                v("div", {
                  "data-testid": "modal-content",
                  class: C([
                    "flex flex-col gap-5 pt-0 px-6",
                    Ce.value ? "flex-none" : "flex-1 overflow-y-auto",
                    Y() ? "pb-0" : "pb-6"
                  ])
                }, [
                  Ae(ue.$slots, "default", {}, void 0, !0)
                ], 2),
                Y() ? (c(), g("div", {
                  key: 1,
                  "data-testid": "modal-footer",
                  class: C([
                    [
                      "flex flex-wrap items-center gap-4 pt-6 pb-6 px-6",
                      e.showFooterBorder && "border-t border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
                    ],
                    K()
                  ])
                }, [
                  D() ? Ae(ue.$slots, "footer", { key: 0 }, void 0, !0) : (c(!0), g(de, { key: 1 }, Re(N.value, (Q) => (c(), g("div", {
                    key: Q.side,
                    "data-testid": `modal-actions-${Q.side}`,
                    class: "flex flex-wrap items-center gap-4"
                  }, [
                    (c(!0), g(de, null, Re(Q.actions, (ae) => (c(), W(Me, {
                      key: ae.id,
                      "data-testid": ae.testId ?? `modal-action-${ae.id}`,
                      size: "md",
                      label: ae.label,
                      variant: ae.variant,
                      "icon-left": ae.icon,
                      disabled: ae.disabled,
                      "aria-disabled": ae.ariaDisabled,
                      loading: ae.loading,
                      "loading-label": ae.loadingLabel,
                      type: ae.type,
                      form: ae.form,
                      onClick: (Te) => i(ae)
                    }, null, 8, ["data-testid", "label", "variant", "icon-left", "disabled", "aria-disabled", "loading", "loading-label", "type", "form", "onClick"]))), 128))
                  ], 8, z5))), 128))
                ], 2)) : w("", !0)
              ], 6)
            ], 16, B5)
          ], 6)) : w("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), Ka = /* @__PURE__ */ dt(O5, [["__scopeId", "data-v-6fa2d15b"]]), P5 = ["data-type"], F5 = ["aria-label"], V5 = { class: "flex items-center gap-1 flex-wrap" }, N5 = ["disabled", "aria-label", "title"], H5 = ["disabled", "aria-label", "title"], j5 = ["disabled", "aria-label", "title"], W5 = ["disabled", "aria-label", "title"], q5 = ["disabled", "aria-label", "title"], U5 = ["title"], G5 = ["aria-label", "disabled"], K5 = ["title"], Y5 = ["aria-label", "disabled"], J5 = ["disabled", "aria-expanded", "aria-label", "title"], X5 = ["aria-label"], Z5 = ["disabled", "aria-label", "title"], Q5 = ["disabled", "aria-label", "title"], _5 = ["disabled", "aria-label", "title"], eB = { class: "flex items-center gap-2 flex-wrap" }, tB = ["disabled", "aria-expanded", "aria-label"], nB = { class: "leading-(--line-height-l)" }, aB = ["aria-label"], lB = ["disabled", "aria-label", "title"], rB = ["disabled", "aria-label", "title"], oB = ["disabled", "aria-label", "title"], iB = ["disabled", "aria-label", "title"], sB = ["disabled", "aria-label", "title"], dB = ["disabled", "aria-expanded", "aria-label", "title"], uB = ["aria-label"], cB = { class: "min-h-0 flex-1 overflow-y-auto" }, fB = {
  key: 0,
  "aria-hidden": "true",
  "data-testid": "rich-text-editor-placeholder",
  class: "pointer-events-none absolute top-[calc(--spacing(3)-1px)] left-[calc(--spacing(3)-1px)] text-(length:--size-m) leading-(--line-height-l) text-(--text-text-body-subtle)"
}, hB = {
  key: 0,
  class: "flex items-start gap-4",
  "data-testid": "rich-text-editor-footer"
}, bB = "w-full flex flex-col items-start gap-0.5 text-left text-(length:--size-m) font-inter", gB = /* @__PURE__ */ ye({
  __name: "RichTextEditor",
  props: {
    type: { default: "Default" },
    modelValue: { default: "" },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    placeholder: { default: void 0 },
    helpText: { default: void 0 },
    error: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !0 },
    width: { default: void 0 },
    minHeight: { default: "184px" },
    resizable: { type: Boolean, default: !1 },
    id: { default: void 0 },
    labels: { default: void 0 },
    actions: { default: () => [] }
  },
  emits: ["update:modelValue", "focus", "blur", "send", "action"],
  setup(e, { emit: n }) {
    const t = `absolute top-[calc(100%+4px)] z-20 min-w-50 w-max ${si}`, a = {
      toolbar: "Rich text formatting",
      bold: "Bold",
      clearFormatting: "Clear formatting",
      italic: "Italic",
      underline: "Underline",
      strikethrough: "Strikethrough",
      textColor: "Text color",
      highlight: "Highlight",
      alignLeft: "Align left",
      alignCenter: "Align center",
      alignRight: "Align right",
      textFormat: "Text format",
      paragraph: "Paragraph",
      heading1: "Heading 1",
      heading2: "Heading 2",
      heading3: "Heading 3",
      insertLink: "Insert link",
      insertImage: "Insert image",
      bulletList: "Bullet list",
      orderedList: "Ordered list",
      blockquote: "Blockquote",
      closeDialog: "Close modal",
      linkDialogTitle: "Insert link",
      linkUrlLabel: "URL",
      linkUrlPlaceholder: "https://example.com",
      linkInsert: "Insert",
      linkRemove: "Remove link",
      imageDialogTitle: "Insert image",
      imageUrlLabel: "Image URL",
      imageUrlPlaceholder: "https://example.com/image.png",
      imageInsert: "Insert",
      cancel: "Cancel",
      invalidUrl: "Enter a valid http(s) URL.",
      send: "Send message",
      fontSize: "Font size",
      lineHeight: "Line height",
      defaultStyle: "Default"
    }, l = e, r = m(() => ({ ...a, ...l.labels })), o = n, i = qe(), s = m(() => l.id || i), d = m(() => l.label ? `${s.value}-label` : void 0), u = m(() => `${s.value}-error`), f = m(() => `${s.value}-help`), b = m(() => !!l.error), h = m(() => {
      const ce = [];
      return b.value && ce.push(u.value), l.helpText && ce.push(f.value), ce.length ? ce.join(" ") : void 0;
    }), p = m(() => d.value ? { "aria-labelledby": d.value } : l.ariaLabel ? { "aria-label": l.ariaLabel } : {}), x = m(
      () => h.value ? { "aria-describedby": h.value } : {}
    ), y = m(() => ({
      id: s.value,
      role: "textbox",
      "aria-multiline": "true",
      "aria-disabled": l.disabled ? "true" : "false",
      "aria-required": l.required ? "true" : "false",
      ...p.value,
      "aria-invalid": b.value ? "true" : "false",
      ...x.value,
      class: "prose prose-sm max-w-none focus:outline-none text-(--text-text-black-default) dark:text-(--colors-text-white-default) min-h-full"
    })), k = ["paragraph", "heading"], $ = CE({
      content: l.modelValue,
      editable: !l.disabled,
      extensions: [
        m5.configure({
          // StarterKit v3 already bundles Underline, Link, lists.
          link: {
            openOnClick: !1,
            autolink: !0,
            defaultProtocol: "https"
          }
        }),
        v5.configure({ types: ["heading", "paragraph"] }),
        Lv,
        Av,
        Ev.configure({ types: k }),
        Tv,
        I5.configure({ multicolor: !0 }),
        A5.configure({ inline: !1 })
      ],
      editorProps: { attributes: y.value },
      onUpdate({ editor: ce }) {
        o("update:modelValue", ce.getHTML());
      },
      onFocus() {
        S.value = !0, o("focus");
      },
      onBlur() {
        S.value = !1, o("blur");
      }
    }), S = R(!1), T = R(null), I = R(null);
    $e(
      () => l.modelValue,
      (ce) => {
        var Ie, Ue;
        const be = (Ie = $.value) == null ? void 0 : Ie.getHTML();
        ce !== void 0 && ce !== be && ((Ue = $.value) == null || Ue.commands.setContent(ce || "", { emitUpdate: !1 }));
      }
    ), $e(
      () => l.disabled,
      (ce) => {
        var be;
        (be = $.value) == null || be.setEditable(!ce);
      }
    ), $e(y, (ce) => {
      var be;
      (be = $.value) == null || be.setOptions({ editorProps: { attributes: ce } });
    }), yt(() => {
      var ce;
      (ce = $.value) == null || ce.destroy();
    });
    const A = m(() => [
      { value: "paragraph", label: r.value.paragraph, shortcut: "⌘⌥0" },
      { value: "h1", label: r.value.heading1, shortcut: "⌘⌥1" },
      { value: "h2", label: r.value.heading2, shortcut: "⌘⌥2" },
      { value: "h3", label: r.value.heading3, shortcut: "⌘⌥3" }
    ]), E = ["12px", "14px", "16px", "18px", "20px", "24px"], D = ["1", "1.25", "1.5", "2"], z = m(() => [
      { value: "", label: r.value.defaultStyle },
      ...E.map((ce) => ({ value: ce, label: ce.replace("px", " px") }))
    ]), Y = m(() => [
      { value: "", label: r.value.defaultStyle },
      ...D.map((ce) => ({ value: ce, label: ce }))
    ]), le = (ce) => {
      var Ie;
      const be = (Ie = $.value) == null ? void 0 : Ie.chain().focus();
      if (be) {
        if (ce === "paragraph")
          be.setParagraph().run();
        else {
          const Ue = Number(ce.replace("h", ""));
          be.toggleHeading({ level: Ue }).run();
        }
        O.value = null;
      }
    }, ne = (ce) => {
      var Ie;
      const be = (Ie = $.value) == null ? void 0 : Ie.chain().focus();
      ce ? be == null || be.setFontSize(ce).run() : be == null || be.unsetFontSize().run(), O.value = null;
    }, re = (ce) => {
      var be;
      (be = $.value) == null || be.chain().focus().command(
        ({ commands: Ie }) => k.map((Ue) => Ie.updateAttributes(Ue, { lineHeight: ce || null })).some(Boolean)
      ).run(), O.value = null;
    }, O = R(null), P = R(null), V = R(null), M = R(null), B = { format: P, fontSize: V, lineHeight: M }, q = (ce) => {
      l.disabled || (O.value = O.value === ce ? null : ce);
    }, N = R(null), G = R(!1), U = async () => {
      var Ue;
      G.value = !1;
      const ce = O.value;
      if (!ce) return;
      await Ge();
      const be = (Ue = B[ce].value) == null ? void 0 : Ue.querySelector('[role="menu"]'), Ie = N.value;
      !be || !Ie || O.value !== ce || (G.value = be.getBoundingClientRect().right > Ie.getBoundingClientRect().right);
    };
    $e(O, U);
    const K = (ce) => Array.from(ce.querySelectorAll('[role="menuitemradio"]'));
    $e(O, async (ce) => {
      var Ue, Lt;
      if (!ce) return;
      await Ge();
      const be = (Ue = B[ce].value) == null ? void 0 : Ue.querySelector('[role="menu"]');
      if (!be) return;
      const Ie = K(be);
      (Lt = Ie.find((Kn) => Kn.getAttribute("aria-checked") === "true") ?? Ie[0]) == null || Lt.focus();
    });
    const ge = (ce) => {
      if (ce.key === "Tab") {
        O.value = null;
        return;
      }
      const be = K(ce.currentTarget), Ie = be.indexOf(document.activeElement), Ue = {
        ArrowDown: (Ie + 1) % be.length,
        ArrowUp: (Ie - 1 + be.length) % be.length,
        Home: 0,
        End: be.length - 1
      }[ce.key];
      Ue === void 0 || !be.length || (ce.preventDefault(), be[Ue].focus());
    }, xe = (ce) => {
      var be, Ie;
      return (Ie = (be = B[ce].value) == null ? void 0 : be.querySelector('[aria-haspopup="menu"]')) == null ? void 0 : Ie.focus();
    }, X = () => {
      O.value && U();
    }, ie = (ce) => {
      if (!O.value) return;
      const be = B[O.value].value;
      be && !be.contains(ce.target) && (O.value = null);
    }, he = (ce) => {
      if (O.value && ce.key === "Escape") {
        ce.stopPropagation(), ce.preventDefault();
        const be = O.value;
        O.value = null, xe(be);
      }
    };
    ct(() => {
      document.addEventListener("mousedown", ie), document.addEventListener("keydown", he), window.addEventListener("resize", X);
    }), yt(() => {
      document.removeEventListener("mousedown", ie), document.removeEventListener("keydown", he), window.removeEventListener("resize", X);
    });
    const oe = (ce) => {
      var Ie;
      const be = ce.target.value;
      (Ie = $.value) == null || Ie.chain().focus().setColor(be).run();
    }, Ce = (ce) => {
      var Ie;
      const be = ce.target.value;
      (Ie = $.value) == null || Ie.chain().focus().toggleHighlight({ color: be }).run();
    }, H = R(!1), Z = R(""), ee = R(!1), J = R(!1), F = R(""), _ = R(!1);
    function ue(ce) {
      try {
        const be = new URL(ce);
        return be.protocol === "http:" || be.protocol === "https:";
      } catch {
        return !1;
      }
    }
    const se = (ce) => {
      var be;
      return (be = ce == null ? void 0 : ce.currentTarget) == null ? void 0 : be.focus();
    }, Q = (ce) => {
      var Ie;
      if (l.disabled) return;
      se(ce);
      const be = (Ie = $.value) == null ? void 0 : Ie.getAttributes("link").href;
      Z.value = be ?? "", ee.value = !1, H.value = !0;
    }, ae = () => {
      var ce;
      (ce = $.value) == null || ce.chain().extendMarkRange("link").unsetLink().run(), H.value = !1;
    }, Te = () => {
      var be;
      const ce = Z.value.trim();
      if (ce === "") {
        ae();
        return;
      }
      if (!ue(ce)) {
        ee.value = !0;
        return;
      }
      (be = $.value) == null || be.chain().extendMarkRange("link").setLink({ href: ce, target: "_blank", rel: "noopener noreferrer" }).run(), H.value = !1;
    }, Le = () => {
      H.value = !1;
    }, pe = (ce) => {
      l.disabled || (se(ce), F.value = "", _.value = !1, J.value = !0);
    }, ke = () => {
      var be;
      const ce = F.value.trim();
      if (!ue(ce)) {
        _.value = !0;
        return;
      }
      (be = $.value) == null || be.chain().setImage({ src: ce }).run(), J.value = !1;
    }, fe = () => {
      J.value = !1;
    }, ze = m(() => [
      { id: "remove", label: r.value.linkRemove, variant: "tertiary", onClick: ae },
      { id: "cancel", label: r.value.cancel, variant: "secondary", onClick: Le },
      { id: "insert", label: r.value.linkInsert, variant: "primary", onClick: Te }
    ]), Ee = m(() => [
      { id: "cancel", label: r.value.cancel, variant: "secondary", onClick: fe },
      { id: "insert", label: r.value.imageInsert, variant: "primary", onClick: ke }
    ]), He = (ce, be) => {
      ce.key === "Enter" && (ce.preventDefault(), be());
    }, Ke = () => {
      var ce;
      (ce = $.value) == null || ce.chain().focus().clearNodes().unsetAllMarks().run();
    }, et = (ce, be) => $.value ? typeof ce == "string" ? $.value.isActive(ce, {}) : $.value.isActive(ce) : !1, Se = m(() => $.value ? $.value.isActive("heading", { level: 1 }) ? "h1" : $.value.isActive("heading", { level: 2 }) ? "h2" : $.value.isActive("heading", { level: 3 }) ? "h3" : "paragraph" : "paragraph"), me = m(
      () => {
        var ce;
        return ((ce = $.value) == null ? void 0 : ce.getAttributes("textStyle").fontSize) ?? "";
      }
    ), Be = m(() => k.map((be) => {
      var Ie;
      return (Ie = $.value) == null ? void 0 : Ie.getAttributes(be).lineHeight;
    }).find(Boolean) ?? ""), Ye = m(
      () => {
        var ce;
        return ((ce = A.value.find((be) => be.value === Se.value)) == null ? void 0 : ce.label) ?? r.value.paragraph;
      }
    ), Qe = m(() => l.type === "Buttons inside"), bt = m(() => l.type === "Buttons outside"), jt = m(() => !!$.value && !$.value.isEmpty), De = m(() => {
      var Ie;
      const ce = (Ie = $.value) == null ? void 0 : Ie.state.doc, be = (ce == null ? void 0 : ce.childCount) === 1 ? ce.firstChild : null;
      return !!l.placeholder && (be == null ? void 0 : be.type.name) === "paragraph" && be.content.size === 0;
    }), Pe = m(
      () => l.disabled ? "border-(--border-border-disabled-subtle) dark:border-(--colors-border-disabled-subtle)" : "border-(--border-border-base-medium) dark:border-(--border-border-base)"
    ), We = m(
      () => l.disabled ? `bg-(--background-background-disabled-opacity) dark:bg-(--colors-background-disabled) ${Pe.value}` : `bg-(--background-background-white) dark:bg-(--background-background-black-default) ${Pe.value}`
    ), ot = m(() => l.type === "Default"), St = m(() => {
      const ce = "flex flex-col rounded-(--border-border-radius-rounded-l) shadow-(--blur-shadow-xs)";
      if (ot.value) return `${ce} gap-0.5`;
      const be = `${ce} dark:shadow-(--blur-shadow-m-dark)`;
      return Qe.value ? `${be} border border-solid ${Pe.value}` : be;
    }), we = m(
      () => ot.value ? "flex flex-col rounded-(--border-border-radius-rounded-l) dark:shadow-(--blur-shadow-m-dark)" : "flex flex-col"
    ), Oe = m(() => `flex flex-col gap-2 border-solid rounded-t-(--border-border-radius-rounded-l) px-[calc(--spacing(3)-1px)] pt-[calc(--spacing(3)-1px)] ${Qe.value ? "-mx-px -mt-px border-x border-t pb-3" : "border pb-[calc(--spacing(3)-1px)]"} ${We.value}`), Ze = m(() => {
      const ce = Qe.value ? "-mx-px" : "rounded-b-(--border-border-radius-rounded-l)", be = l.resizable && !l.disabled ? "resize-y" : "", Ie = `relative flex flex-col overflow-hidden border border-solid p-[calc(--spacing(3)-1px)] ${ce} ${be}`, Ue = Qe.value ? "" : "border-t-transparent dark:border-t-transparent", Lt = "shadow-[0_0_2px_2px_var(--background-background-hover)]", Kn = "shadow-(--blur-shadow-xs) dark:shadow-(--blur-shadow-m-dark)";
      return l.disabled ? `${Ie} ${Ue} ${We.value} cursor-not-allowed` : b.value ? `${Ie} ${S.value ? Lt : Kn} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error)` : S.value ? `${Ie} ${Lt} bg-(--background-background-selected) dark:bg-(--background-background-black-default) border-(--border-border-accent)` : `${Ie} ${Ue} ${jt.value ? "" : Kn} ${We.value}`;
    }), ft = m(
      () => `-mx-px -mb-px flex items-center gap-4 border-x border-b border-solid rounded-b-(--border-border-radius-rounded-l) px-[calc(--spacing(3)-1px)] pt-3 pb-[calc(--spacing(3)-1px)] ${We.value}`
    ), vt = () => {
      var ce;
      return o("send", ((ce = $.value) == null ? void 0 : ce.getHTML()) ?? l.modelValue);
    }, Ot = (ce) => o("action", ce), bn = m(() => l.fullWidth ? {} : l.width ? { width: l.width } : {}), Mt = (ce) => {
      var be, Ie;
      l.disabled || (be = ce.target) != null && be.closest("[data-field-label-tooltip]") || (Ie = $.value) == null || Ie.commands.focus();
    };
    return (ce, be) => (c(), g("div", {
      class: C(bB),
      style: je(bn.value),
      "data-type": e.type
    }, [
      e.label ? (c(), W(It, {
        key: 0,
        id: d.value,
        ref_key: "labelRef",
        ref: T,
        text: e.label,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: S.value,
        "test-id": "rich-text-editor-label",
        class: C(!e.disabled && "cursor-pointer"),
        onClick: Mt
      }, null, 8, ["id", "text", "required", "required-indicator", "tooltip", "focused", "class"])) : w("", !0),
      v("div", {
        class: C(["self-stretch flex flex-col", bt.value && "gap-4"])
      }, [
        v("div", {
          ref_key: "fieldRef",
          ref: N,
          class: C(St.value),
          "data-testid": "rich-text-editor-field"
        }, [
          v("div", {
            class: C(we.value),
            "data-testid": "rich-text-editor-box"
          }, [
            v("div", {
              class: C(Oe.value),
              role: "toolbar",
              "aria-label": r.value.toolbar,
              "data-testid": "rich-text-editor-toolbar"
            }, [
              v("div", V5, [
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": et("bold") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.bold,
                  title: r.value.bold,
                  onClick: be[0] || (be[0] = (Ie) => {
                    var Ue;
                    return (Ue = L($)) == null ? void 0 : Ue.chain().focus().toggleBold().run();
                  })
                }, [...be[20] || (be[20] = [
                  v("i", {
                    class: "ri-bold",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, N5),
                v("button", {
                  type: "button",
                  class: "toolbar-btn",
                  disabled: e.disabled,
                  "aria-label": r.value.clearFormatting,
                  title: r.value.clearFormatting,
                  onClick: Ke
                }, [...be[21] || (be[21] = [
                  v("i", {
                    class: "ri-format-clear",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 8, H5),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": et("italic") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.italic,
                  title: r.value.italic,
                  onClick: be[1] || (be[1] = (Ie) => {
                    var Ue;
                    return (Ue = L($)) == null ? void 0 : Ue.chain().focus().toggleItalic().run();
                  })
                }, [...be[22] || (be[22] = [
                  v("i", {
                    class: "ri-italic",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, j5),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": et("underline") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.underline,
                  title: r.value.underline,
                  onClick: be[2] || (be[2] = (Ie) => {
                    var Ue;
                    return (Ue = L($)) == null ? void 0 : Ue.chain().focus().toggleUnderline().run();
                  })
                }, [...be[23] || (be[23] = [
                  v("i", {
                    class: "ri-underline",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, W5),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": et("strike") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.strikethrough,
                  title: r.value.strikethrough,
                  onClick: be[3] || (be[3] = (Ie) => {
                    var Ue;
                    return (Ue = L($)) == null ? void 0 : Ue.chain().focus().toggleStrike().run();
                  })
                }, [...be[24] || (be[24] = [
                  v("i", {
                    class: "ri-strikethrough",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, q5),
                v("label", {
                  class: C(["toolbar-btn relative cursor-pointer", { "opacity-50 cursor-not-allowed": e.disabled }]),
                  title: r.value.textColor
                }, [
                  be[25] || (be[25] = v("i", {
                    class: "ri-font-color",
                    "aria-hidden": "true"
                  }, null, -1)),
                  v("input", {
                    type: "color",
                    "aria-label": r.value.textColor,
                    class: "absolute inset-0 opacity-0 cursor-pointer",
                    disabled: e.disabled,
                    onInput: oe
                  }, null, 40, G5)
                ], 10, U5),
                v("label", {
                  class: C(["toolbar-btn relative cursor-pointer", {
                    "is-active": et("highlight"),
                    "opacity-50 cursor-not-allowed": e.disabled
                  }]),
                  title: r.value.highlight
                }, [
                  be[26] || (be[26] = v("i", {
                    class: "ri-mark-pen-line",
                    "aria-hidden": "true"
                  }, null, -1)),
                  v("input", {
                    type: "color",
                    "aria-label": r.value.highlight,
                    class: "absolute inset-0 opacity-0 cursor-pointer",
                    disabled: e.disabled,
                    onInput: Ce
                  }, null, 40, Y5)
                ], 10, K5),
                v("div", {
                  ref_key: "fontSizeWrapperRef",
                  ref: V,
                  class: "relative"
                }, [
                  v("button", {
                    type: "button",
                    class: C(["toolbar-btn", { "is-active": O.value === "fontSize" }]),
                    disabled: e.disabled,
                    "aria-expanded": O.value === "fontSize",
                    "aria-haspopup": "menu",
                    "aria-label": r.value.fontSize,
                    title: r.value.fontSize,
                    onClick: be[4] || (be[4] = (Ie) => q("fontSize"))
                  }, [...be[27] || (be[27] = [
                    v("i", {
                      class: "ri-font-size",
                      "aria-hidden": "true"
                    }, null, -1)
                  ])], 10, J5),
                  O.value === "fontSize" ? (c(), g("div", {
                    key: 0,
                    role: "menu",
                    "aria-label": r.value.fontSize,
                    class: C([t, G.value ? "right-0 left-auto" : "left-0"]),
                    onKeydown: ge
                  }, [
                    (c(!0), g(de, null, Re(z.value, (Ie) => (c(), W(en, {
                      key: Ie.value,
                      as: "button",
                      type: "default",
                      role: "menuitemradio",
                      tabindex: "-1",
                      label: Ie.label,
                      selected: me.value === Ie.value,
                      "aria-checked": me.value === Ie.value,
                      onClick: (Ue) => ne(Ie.value)
                    }, null, 8, ["label", "selected", "aria-checked", "onClick"]))), 128))
                  ], 42, X5)) : w("", !0)
                ], 512),
                be[31] || (be[31] = v("span", {
                  class: "mx-1 inline-block w-px h-4 bg-(--colors-background-gray)",
                  "aria-hidden": "true"
                }, null, -1)),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": et({ textAlign: "left" }) }]),
                  disabled: e.disabled,
                  "aria-label": r.value.alignLeft,
                  title: r.value.alignLeft,
                  onClick: be[5] || (be[5] = (Ie) => {
                    var Ue;
                    return (Ue = L($)) == null ? void 0 : Ue.chain().focus().setTextAlign("left").run();
                  })
                }, [...be[28] || (be[28] = [
                  v("i", {
                    class: "ri-align-left",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, Z5),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": et({ textAlign: "center" }) }]),
                  disabled: e.disabled,
                  "aria-label": r.value.alignCenter,
                  title: r.value.alignCenter,
                  onClick: be[6] || (be[6] = (Ie) => {
                    var Ue;
                    return (Ue = L($)) == null ? void 0 : Ue.chain().focus().setTextAlign("center").run();
                  })
                }, [...be[29] || (be[29] = [
                  v("i", {
                    class: "ri-align-center",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, Q5),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": et({ textAlign: "right" }) }]),
                  disabled: e.disabled,
                  "aria-label": r.value.alignRight,
                  title: r.value.alignRight,
                  onClick: be[7] || (be[7] = (Ie) => {
                    var Ue;
                    return (Ue = L($)) == null ? void 0 : Ue.chain().focus().setTextAlign("right").run();
                  })
                }, [...be[30] || (be[30] = [
                  v("i", {
                    class: "ri-align-right",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, _5)
              ]),
              v("div", eB, [
                v("div", {
                  ref_key: "formatWrapperRef",
                  ref: P,
                  class: "relative"
                }, [
                  v("button", {
                    type: "button",
                    class: C(["format-btn", { "is-open": O.value === "format" }]),
                    disabled: e.disabled,
                    "aria-expanded": O.value === "format",
                    "aria-haspopup": "menu",
                    "aria-label": r.value.textFormat,
                    onClick: be[8] || (be[8] = (Ie) => q("format"))
                  }, [
                    v("span", nB, j(Ye.value), 1),
                    be[32] || (be[32] = v("i", {
                      class: "ri-arrow-down-s-line text-(length:--size-m)",
                      "aria-hidden": "true"
                    }, null, -1))
                  ], 10, tB),
                  O.value === "format" ? (c(), g("div", {
                    key: 0,
                    role: "menu",
                    "aria-label": r.value.textFormat,
                    class: C([t, G.value ? "right-0 left-auto" : "left-0"]),
                    onKeydown: ge
                  }, [
                    (c(!0), g(de, null, Re(A.value, (Ie) => (c(), W(en, {
                      key: Ie.value,
                      as: "button",
                      type: "secondary-text",
                      role: "menuitemradio",
                      tabindex: "-1",
                      label: Ie.label,
                      "secondary-label": Ie.shortcut,
                      "aria-label": Ie.label,
                      selected: Se.value === Ie.value,
                      "aria-checked": Se.value === Ie.value,
                      onClick: (Ue) => le(Ie.value)
                    }, null, 8, ["label", "secondary-label", "aria-label", "selected", "aria-checked", "onClick"]))), 128))
                  ], 42, aB)) : w("", !0)
                ], 512),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": et("link") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.insertLink,
                  title: r.value.insertLink,
                  onClick: Q
                }, [...be[33] || (be[33] = [
                  v("i", {
                    class: "ri-link",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, lB),
                v("button", {
                  type: "button",
                  class: "toolbar-btn",
                  disabled: e.disabled,
                  "aria-label": r.value.insertImage,
                  title: r.value.insertImage,
                  onClick: pe
                }, [...be[34] || (be[34] = [
                  v("i", {
                    class: "ri-image-line",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 8, rB),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": et("bulletList") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.bulletList,
                  title: r.value.bulletList,
                  onClick: be[9] || (be[9] = (Ie) => {
                    var Ue;
                    return (Ue = L($)) == null ? void 0 : Ue.chain().focus().toggleBulletList().run();
                  })
                }, [...be[35] || (be[35] = [
                  v("i", {
                    class: "ri-list-unordered",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, oB),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": et("orderedList") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.orderedList,
                  title: r.value.orderedList,
                  onClick: be[10] || (be[10] = (Ie) => {
                    var Ue;
                    return (Ue = L($)) == null ? void 0 : Ue.chain().focus().toggleOrderedList().run();
                  })
                }, [...be[36] || (be[36] = [
                  v("i", {
                    class: "ri-list-ordered",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, iB),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": et("blockquote") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.blockquote,
                  title: r.value.blockquote,
                  onClick: be[11] || (be[11] = (Ie) => {
                    var Ue;
                    return (Ue = L($)) == null ? void 0 : Ue.chain().focus().toggleBlockquote().run();
                  })
                }, [...be[37] || (be[37] = [
                  v("i", {
                    class: "ri-double-quotes-l",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, sB),
                v("div", {
                  ref_key: "lineHeightWrapperRef",
                  ref: M,
                  class: "relative"
                }, [
                  v("button", {
                    type: "button",
                    class: C(["toolbar-btn", { "is-active": O.value === "lineHeight" }]),
                    disabled: e.disabled,
                    "aria-expanded": O.value === "lineHeight",
                    "aria-haspopup": "menu",
                    "aria-label": r.value.lineHeight,
                    title: r.value.lineHeight,
                    onClick: be[12] || (be[12] = (Ie) => q("lineHeight"))
                  }, [...be[38] || (be[38] = [
                    v("i", {
                      class: "ri-line-height",
                      "aria-hidden": "true"
                    }, null, -1)
                  ])], 10, dB),
                  O.value === "lineHeight" ? (c(), g("div", {
                    key: 0,
                    role: "menu",
                    "aria-label": r.value.lineHeight,
                    class: C([t, G.value ? "right-0 left-auto" : "left-0"]),
                    onKeydown: ge
                  }, [
                    (c(!0), g(de, null, Re(Y.value, (Ie) => (c(), W(en, {
                      key: Ie.value,
                      as: "button",
                      type: "default",
                      role: "menuitemradio",
                      tabindex: "-1",
                      label: Ie.label,
                      selected: Be.value === Ie.value,
                      "aria-checked": Be.value === Ie.value,
                      onClick: (Ue) => re(Ie.value)
                    }, null, 8, ["label", "selected", "aria-checked", "onClick"]))), 128))
                  ], 42, uB)) : w("", !0)
                ], 512)
              ])
            ], 10, F5),
            v("div", {
              class: C(Ze.value),
              style: je({ minHeight: e.minHeight }),
              "data-testid": "rich-text-editor-content"
            }, [
              v("div", cB, [
                L($) ? (c(), W(L(wE), {
                  key: 0,
                  editor: L($),
                  "data-testid": "rich-text-editor",
                  class: "text-(length:--size-m) leading-(--line-height-l)",
                  onKeydown: be[13] || (be[13] = (Ie) => {
                    var Ue, Lt;
                    (Ue = T.value) == null || Ue.handleFieldKeydown(Ie), (Lt = I.value) == null || Lt.handleFieldKeydown(Ie);
                  })
                }, null, 8, ["editor"])) : w("", !0)
              ]),
              De.value ? (c(), g("span", fB, j(e.placeholder), 1)) : w("", !0),
              e.resizable && !e.disabled ? (c(), W(Gg, {
                key: 1,
                class: "absolute right-[calc(--spacing(2)-1px)] bottom-[calc(--spacing(2)-1px)]"
              })) : w("", !0)
            ], 6)
          ], 2),
          ot.value ? (c(), W($t, {
            key: 0,
            ref_key: "helperRef",
            ref: I,
            focused: S.value,
            hint: e.helpText,
            error: e.error,
            "hint-id": f.value,
            "error-id": u.value,
            "test-id-prefix": "rich-text-editor"
          }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"])) : w("", !0),
          Qe.value ? (c(), g("div", {
            key: 1,
            class: C(ft.value),
            "data-testid": "rich-text-editor-footer"
          }, [
            te(ui, {
              class: "shrink-0",
              labels: { send: r.value.send },
              actions: e.actions,
              disabled: e.disabled,
              onSend: vt,
              onAction: Ot
            }, null, 8, ["labels", "actions", "disabled"]),
            te($t, {
              ref_key: "helperRef",
              ref: I,
              class: "min-w-0 flex-1",
              focused: S.value,
              hint: e.helpText,
              error: e.error,
              "hint-id": f.value,
              "error-id": u.value,
              "test-id-prefix": "rich-text-editor"
            }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"])
          ], 2)) : w("", !0)
        ], 2),
        bt.value ? (c(), g("div", hB, [
          te(ui, {
            class: "shrink-0",
            labels: { send: r.value.send },
            actions: e.actions,
            disabled: e.disabled,
            onSend: vt,
            onAction: Ot
          }, null, 8, ["labels", "actions", "disabled"]),
          te($t, {
            ref_key: "helperRef",
            ref: I,
            class: "min-w-0 flex-1",
            focused: S.value,
            hint: e.helpText,
            error: e.error,
            "hint-id": f.value,
            "error-id": u.value,
            "test-id-prefix": "rich-text-editor"
          }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"])
        ])) : w("", !0)
      ], 2),
      te(Ka, {
        modelValue: H.value,
        "onUpdate:modelValue": be[16] || (be[16] = (Ie) => H.value = Ie),
        size: "sm",
        title: r.value.linkDialogTitle,
        "aria-close-label": r.value.closeDialog,
        "footer-align": "split",
        actions: ze.value
      }, {
        default: ve(() => [
          te(Wt, {
            "model-value": Z.value,
            type: "url",
            label: r.value.linkUrlLabel,
            placeholder: r.value.linkUrlPlaceholder,
            error: ee.value ? r.value.invalidUrl : void 0,
            "full-width": "",
            "onUpdate:modelValue": be[14] || (be[14] = (Ie) => {
              Z.value = Ie, ee.value = !1;
            }),
            onKeydown: be[15] || (be[15] = (Ie) => He(Ie, Te))
          }, null, 8, ["model-value", "label", "placeholder", "error"])
        ]),
        _: 1
      }, 8, ["modelValue", "title", "aria-close-label", "actions"]),
      te(Ka, {
        modelValue: J.value,
        "onUpdate:modelValue": be[19] || (be[19] = (Ie) => J.value = Ie),
        size: "xs",
        title: r.value.imageDialogTitle,
        "aria-close-label": r.value.closeDialog,
        actions: Ee.value
      }, {
        default: ve(() => [
          te(Wt, {
            "model-value": F.value,
            type: "url",
            label: r.value.imageUrlLabel,
            placeholder: r.value.imageUrlPlaceholder,
            error: _.value ? r.value.invalidUrl : void 0,
            "full-width": "",
            "onUpdate:modelValue": be[17] || (be[17] = (Ie) => {
              F.value = Ie, _.value = !1;
            }),
            onKeydown: be[18] || (be[18] = (Ie) => He(Ie, ke))
          }, null, 8, ["model-value", "label", "placeholder", "error"])
        ]),
        _: 1
      }, 8, ["modelValue", "title", "aria-close-label", "actions"])
    ], 12, P5));
  }
}), uq = /* @__PURE__ */ dt(gB, [["__scopeId", "data-v-8601a4c1"]]), mB = /* @__PURE__ */ ye({
  __name: "EmailInput",
  props: {
    modelValue: { default: "" },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    success: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    labels: { default: () => ({ clear: "Clear input" }) },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    iconLeft: { default: void 0 },
    hint: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    autocomplete: { default: "off" },
    error: { default: void 0 },
    validator: { type: Function, default: void 0 },
    validateOnBlur: { type: Boolean, default: !0 },
    validateOnInput: { type: Boolean, default: !1 },
    invalidEmailMessage: { default: "Please enter a valid email address" },
    requiredMessage: { default: "Email is required" }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "validation-change"],
  setup(e, { expose: n, emit: t }) {
    const a = tn(), l = e, r = t, o = R(void 0), i = R(!1), s = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/, d = (k) => {
      if (l.validator)
        return l.validator(k) ?? void 0;
      if (l.required && !k.trim())
        return l.requiredMessage;
      if (k.trim() && !s.test(k))
        return l.invalidEmailMessage;
    }, u = () => {
      const k = d(l.modelValue ?? "");
      o.value = k, r("validation-change", !k, k);
    }, f = m(() => {
      if (l.error) return l.error;
      if (i.value) return o.value;
    }), b = (k) => {
      const $ = k.target;
      r("update:modelValue", $.value), r("input", k), l.validateOnInput && u();
    }, h = (k) => {
      r("focus", k);
    }, p = (k) => {
      i.value = !0, r("blur", k), l.validateOnBlur && u();
    };
    return $e(
      () => l.modelValue,
      () => {
        i.value && (l.validateOnBlur || l.validateOnInput) && u();
      }
    ), $e(
      () => l.error,
      (k) => {
        k && (o.value = void 0);
      }
    ), n({
      validate: () => (i.value = !0, u(), !o.value),
      resetValidation: () => {
        i.value = !1, o.value = void 0;
      }
    }), (k, $) => (c(), W(Wt, {
      id: e.id,
      "model-value": e.modelValue,
      placeholder: e.placeholder,
      label: e.label,
      required: e.required,
      "required-indicator": e.requiredIndicator,
      success: e.success,
      "label-tooltip": e.labelTooltip,
      labels: e.labels,
      disabled: e.disabled,
      readonly: e.readonly,
      size: e.size,
      name: e.name,
      "full-width": e.fullWidth,
      width: e.width,
      "icon-left": e.iconLeft,
      hint: e.hint,
      "label-inline": e.labelInline,
      error: f.value,
      type: "email",
      inputmode: "email",
      autocomplete: e.autocomplete,
      "data-testid": "email-input",
      "onUpdate:modelValue": $[0] || ($[0] = (S) => r("update:modelValue", S)),
      onInput: b,
      onFocus: h,
      onBlur: p
    }, sa({ _: 2 }, [
      L(a)("actions") ? {
        name: "actions",
        fn: ve(() => [
          Ae(k.$slots, "actions")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["id", "model-value", "placeholder", "label", "required", "required-indicator", "success", "label-tooltip", "labels", "disabled", "readonly", "size", "name", "full-width", "width", "icon-left", "hint", "label-inline", "error", "autocomplete"]));
  }
}), pB = ["disabled", "aria-pressed", "aria-controls", "aria-label"], cq = /* @__PURE__ */ ye({
  __name: "PasswordInput",
  props: {
    modelValue: { default: "" },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    labelTooltip: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    ariaLabel: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    success: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    autocomplete: { default: "current-password" },
    maxlength: { default: void 0 },
    minlength: { default: void 0 },
    labels: { default: () => ({}) },
    remember: { type: Boolean, default: !1 },
    rememberLabel: { default: void 0 },
    forgotLabel: { default: void 0 },
    forgotHref: { default: void 0 }
  },
  emits: ["update:modelValue", "update:remember", "forgot", "focus", "blur"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = qe(), r = m(() => t.id ?? l), o = R(!1), i = m(() => t.labels.show ?? "Show password"), s = m(() => !!t.rememberLabel || !!t.forgotLabel), d = m(() => t.disabled ? "cursor-not-allowed" : "cursor-pointer");
    function u() {
      t.forgotHref || a("forgot");
    }
    return dn(
      Rg,
      () => s.value ? ea("div", { class: "flex w-full items-center justify-between gap-1", "data-testid": "password-input-row" }, [
        t.rememberLabel ? ea(Bn, {
          modelValue: t.remember,
          label: t.rememberLabel,
          disabled: t.disabled,
          "onUpdate:modelValue": (f) => a("update:remember", f)
        }) : null,
        t.forgotLabel ? ea(
          Mn,
          {
            class: "ml-auto shrink-0",
            "data-testid": "password-input-forgot",
            as: t.forgotHref ? "a" : "button",
            href: t.forgotHref,
            disabled: t.disabled,
            onClick: u
          },
          () => t.forgotLabel
        ) : null
      ]) : null
    ), (f, b) => (c(), W(Wt, {
      id: r.value,
      "model-value": e.modelValue,
      type: o.value ? "text" : "password",
      "icon-left": "ri-lock-2-line",
      placeholder: e.placeholder,
      label: e.label,
      "label-tooltip": e.labelTooltip,
      required: e.required,
      "required-indicator": e.requiredIndicator,
      "aria-label": e.ariaLabel,
      hint: e.hint,
      error: e.error,
      success: e.success,
      disabled: e.disabled,
      readonly: e.readonly,
      size: e.size,
      name: e.name,
      "full-width": e.fullWidth,
      width: e.width,
      "label-inline": e.labelInline,
      autocomplete: e.autocomplete,
      maxlength: e.maxlength,
      minlength: e.minlength,
      "onUpdate:modelValue": b[1] || (b[1] = (h) => a("update:modelValue", h)),
      onFocus: b[2] || (b[2] = (h) => a("focus", h)),
      onBlur: b[3] || (b[3] = (h) => a("blur", h))
    }, {
      iconRight: ve(({ iconColorClass: h, iconBoxClass: p }) => [
        v("button", {
          type: "button",
          "data-testid": "password-input-toggle",
          class: C([
            p,
            h,
            d.value,
            "rounded-(--border-border-radius-rounded-xs) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent"
          ]),
          disabled: e.disabled,
          "aria-pressed": o.value,
          "aria-controls": r.value,
          "aria-label": i.value,
          onClick: b[0] || (b[0] = (x) => o.value = !o.value)
        }, [
          v("i", {
            class: C(o.value ? "ri-eye-off-line" : "ri-eye-line"),
            "aria-hidden": "true"
          }, null, 2)
        ], 10, pB)
      ]),
      _: 1
    }, 8, ["id", "model-value", "type", "placeholder", "label", "label-tooltip", "required", "required-indicator", "aria-label", "hint", "error", "success", "disabled", "readonly", "size", "name", "full-width", "width", "label-inline", "autocomplete", "maxlength", "minlength"]));
  }
});
function Bv(e) {
  if (!e || !/^[dmy/\-. ]+$/.test(e) || !/[dmy]/.test(e)) return null;
  for (const n of e.match(/([dmy])\1*/g) ?? [])
    if (n.length < 2) return null;
  return e.replace(/[dmy]/g, "0");
}
function gu(e) {
  const n = new Set([...e].filter((l) => /\D/.test(l)));
  if (n.size !== 1) return null;
  const [t] = [...n], a = e.split(t).map((l) => l.length).filter((l) => l > 0);
  return a.length === 0 ? null : { groupSizes: a, separator: t };
}
function vB(e) {
  if (!e) return null;
  const n = e.match(/[Xx]+/g);
  if (!n) return null;
  const t = e.split(/[Xx]+/);
  if (t[0] !== "" || t[t.length - 1] !== "") return null;
  const a = t.slice(1, -1);
  if (a.length === 0) return null;
  const [l] = a;
  return l === "" || a.some((r) => r !== l) ? null : { groupSizes: n.map((r) => r.length), separator: l };
}
function io(e, n) {
  if (!e) return "";
  const t = [];
  let a = 0;
  for (const l of n.groupSizes) {
    if (a >= e.length) break;
    t.push(e.slice(a, a + l)), a += l;
  }
  return a < e.length && t.push(e.slice(a)), t.join(n.separator);
}
function xB(e, n) {
  if (n <= 0) return 0;
  let t = 0;
  for (let a = 0; a < e.length; a++)
    if (/\d/.test(e[a]) && (t += 1, t === n))
      return a + 1;
  return e.length;
}
function Mv(e, n, t) {
  const a = e.value, l = e.selectionStart ?? a.length, r = n(a.slice(0, l)).length, o = n(a), i = t(o);
  e.value = i;
  const s = xB(i, r);
  try {
    e.setSelectionRange(s, s);
  } catch {
  }
  return i;
}
function rb(e, n, t) {
  return Mv(
    e,
    n,
    (a) => t ? io(a, t) : a
  );
}
function Dv(e, n, t) {
  if (e.key !== "Backspace" && e.key !== "Delete" || e.ctrlKey || e.altKey || e.metaKey) return !1;
  const a = n.selectionStart, l = n.selectionEnd;
  if (a === null || l === null || a !== l) return !1;
  const r = n.value, o = (d) => d !== void 0 && /\d/.test(d);
  let i, s;
  if (e.key === "Backspace") {
    if (a === 0 || o(r[a - 1])) return !1;
    let d = a - 1;
    for (; d >= 0 && !o(r[d]); ) d -= 1;
    if (d < 0) return !1;
    i = d, s = d;
  } else {
    if (a >= r.length || o(r[a])) return !1;
    let d = a;
    for (; d < r.length && !o(r[d]); ) d += 1;
    if (d >= r.length) return !1;
    i = d, s = a;
  }
  n.value = r.slice(0, i) + r.slice(i + 1);
  try {
    n.setSelectionRange(s, s);
  } catch {
  }
  return e.preventDefault(), t(n), !0;
}
const _n = {
  FR: { placeholder: "6 12 34 56 78", min: 9, max: 9, name: "France", hasTrunkZero: !0 },
  GB: {
    placeholder: "7911 123456",
    min: 9,
    max: 10,
    name: "United Kingdom",
    hasTrunkZero: !0
  },
  CA: {
    placeholder: "123-456-7890",
    min: 10,
    max: 10,
    name: "Canada",
    hasTrunkZero: !1,
    displaySeparator: " "
  },
  US: {
    placeholder: "123-456-7890",
    min: 10,
    max: 10,
    name: "United States",
    hasTrunkZero: !1,
    displaySeparator: " "
  },
  NL: { placeholder: "6 12345678", min: 9, max: 9, name: "Netherlands", hasTrunkZero: !0 },
  DE: { placeholder: "176 12345678", min: 10, max: 11, name: "Germany", hasTrunkZero: !0 },
  // min: 8 covers landline numbers behind a 2-digit area code (Brussels "02 XXX XX XX" = 8
  // significant digits); mobiles and other landlines are 9 (the placeholder's own length).
  BE: { placeholder: "470 12 34 56", min: 8, max: 9, name: "Belgium", hasTrunkZero: !0 },
  CH: { placeholder: "78 123 45 67", min: 9, max: 9, name: "Switzerland", hasTrunkZero: !0 },
  // The leading "0" is a significant digit of the Italian landline numbering plan (mandatory,
  // not a trunk prefix) — hasTrunkZero: false so it is never split out, stripped, or parenthesised
  // anywhere (input, display, validation count). min/max count the "0" itself, so hasTrunkZero:
  // false means nothing strips it before counting. min: 9 covers a shorter landline behind a
  // 2-digit area code ("02 1234 567" = 9 digits); max: 10 matches the placeholder (mobiles and
  // longer landlines).
  IT: { placeholder: "06 1234 5678", min: 9, max: 10, name: "Italy", hasTrunkZero: !1 },
  ES: { placeholder: "612 34 56 78", min: 9, max: 9, name: "Spain", hasTrunkZero: !1 },
  PT: { placeholder: "912 345 678", min: 9, max: 9, name: "Portugal", hasTrunkZero: !1 },
  GR: { placeholder: "691 234 5678", min: 10, max: 10, name: "Greece", hasTrunkZero: !1 },
  DK: { placeholder: "20 12 34 56", min: 8, max: 8, name: "Denmark", hasTrunkZero: !1 },
  NO: { placeholder: "406 12 345", min: 8, max: 8, name: "Norway", hasTrunkZero: !1 }
}, Dl = {
  placeholder: "123 456 789",
  min: 6,
  max: Number.POSITIVE_INFINITY,
  name: "",
  hasTrunkZero: !1
}, ob = "FR", zv = {
  FR: "+33",
  GB: "+44",
  CA: "+1",
  US: "+1",
  NL: "+31",
  DE: "+49",
  BE: "+32",
  CH: "+41",
  IT: "+39",
  ES: "+34",
  PT: "+351",
  GR: "+30",
  DK: "+45",
  NO: "+47"
}, Nc = Object.entries(zv).sort((e, n) => n[1].length - e[1].length), yB = Object.entries(
  _n
).reduce((e, [n, t]) => {
  const a = zv[n];
  return a in e || (e[a] = t), e;
}, {});
function ib(e) {
  const n = e.replace(/^0+/, "");
  return n.length > 0 ? n : e;
}
function sb(e, n) {
  const t = _n[n] ?? Dl, a = gu(t.placeholder);
  if (!a) return e;
  const l = t.displaySeparator ?? a.separator;
  return io(e, { groupSizes: a.groupSizes, separator: l });
}
function mr(e, n, t) {
  if (!e) return "";
  if (!t) {
    const i = gu(n);
    return i ? io(e, i) : e;
  }
  if (/^0*$/.test(e)) return e;
  const a = e.startsWith("0"), l = a ? "0" : "", r = a ? e.slice(1) : e, o = gu(n);
  return l + (o ? io(r, o) : r);
}
function Hc(e, n) {
  return /^0*$/.test(e) ? "" : n && e.startsWith("0") ? e.slice(1) : e;
}
function fq(e) {
  const n = (e ?? "").trim();
  if (!n.startsWith("+")) return e;
  const t = Nc.find(([, i]) => n.startsWith(i));
  if (!t) return e;
  const [a, l] = t;
  if (!_n[a].hasTrunkZero) return e;
  const o = n.slice(l.length).replace(/\D/g, "");
  return !o || o.startsWith("0") ? e : `${l}0${o}`;
}
function hq(e) {
  const n = (e ?? "").trim();
  if (!n.startsWith("+")) return e;
  const t = Nc.find(([, s]) => n.startsWith(s));
  if (!t) return e;
  const [a, l] = t, r = _n[a], o = n.slice(l.length).replace(/\D/g, ""), i = r.hasTrunkZero ? Hc(o, !0) : o;
  return i ? `${l}${i}` : e;
}
function kB(e) {
  const n = (e ?? "").trim();
  if (!n) return e;
  if (n.startsWith("+")) {
    const i = Nc.find(([, x]) => n.startsWith(x));
    if (!i) return e;
    const [s, d] = i, u = _n[s], f = n.slice(d.length).replace(/\D/g, ""), b = u.hasTrunkZero ? ib(f) : f;
    if (!b) return e;
    const h = sb(b, s), p = u.hasTrunkZero ? "(0)" : "";
    return `${d} ${p}${h}`;
  }
  const t = ib(n.replace(/\D/g, ""));
  if (!t) return e;
  const { min: a, max: l } = _n[ob];
  if (t.length < a || t.length > l) return e;
  const r = sb(t, ob);
  return `${n.replace(/\D/g, "").startsWith("0") ? "0" : ""}${r}`;
}
const wB = ["id"], CB = { class: "relative min-w-0 flex-1" }, SB = { class: "inline-flex items-center gap-1.5" }, $B = { class: "inline-flex size-4 shrink-0 items-center justify-center" }, IB = ["title"], LB = ["id", "autocomplete", "disabled", "readonly", "aria-labelledby", "aria-invalid", "aria-describedby", "placeholder"], TB = ["aria-label"], AB = {
  key: 0,
  class: "shrink-0"
}, EB = /* @__PURE__ */ ye({
  __name: "PhoneInput",
  props: {
    modelValue: { default: "" },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    hint: { default: void 0 },
    disableInternalValidation: { type: Boolean, default: !1 },
    showCountrySelector: { type: Boolean, default: !0 },
    showVerificationButton: { type: Boolean, default: !1 },
    verificationOptions: { default: () => [
      { id: "sms", label: "Send SMS" },
      { id: "call", label: "Call" }
    ] },
    countries: { default: () => [
      { code: "FR", name: "France", dialCode: "+33" },
      { code: "GB", name: "United Kingdom", dialCode: "+44" },
      { code: "CA", name: "Canada", dialCode: "+1" },
      { code: "NL", name: "Netherlands", dialCode: "+31" },
      { code: "DE", name: "Germany", dialCode: "+49" },
      { code: "BE", name: "Belgium", dialCode: "+32" },
      { code: "CH", name: "Switzerland", dialCode: "+41" },
      { code: "IT", name: "Italy", dialCode: "+39" },
      { code: "ES", name: "Spain", dialCode: "+34" },
      { code: "PT", name: "Portugal", dialCode: "+351" },
      { code: "GR", name: "Greece", dialCode: "+30" },
      { code: "DK", name: "Denmark", dialCode: "+45" },
      { code: "NO", name: "Norway", dialCode: "+47" }
    ] },
    countryListLabel: { default: "Country" },
    locale: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    size: { default: "md" },
    autocomplete: { default: "tel" },
    maskInput: { type: Boolean, default: !0 },
    formatHintLabel: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    labelInline: { type: Boolean, default: !1 },
    buttons: { default: () => [] },
    buttonLayout: { default: "attached" },
    buttonSize: { default: void 0 },
    innerButton: { default: void 0 },
    removeButton: { default: void 0 }
  },
  emits: ["update:modelValue", "focus", "blur", "validation-change", "verification-click", "country-change", "button-click"],
  setup(e, { emit: n }) {
    const t = e, a = tn(), l = m(() => a("actions")), r = n, o = R(!1), i = R(!1), s = R(""), d = R(t.countries[0]), u = R(t.verificationOptions[0]), f = R(!1), b = R(void 0), h = R(null), p = R(null), x = m(() => {
      var De;
      return ((De = h.value) == null ? void 0 : De.$el) ?? null;
    }), y = R(null), k = m(
      () => {
        var De;
        return ((De = p.value) == null ? void 0 : De.$el) ?? null;
      }
    ), $ = R(null), S = Yu(), T = m(() => {
      if (!t.locale) return null;
      try {
        return new Intl.DisplayNames([t.locale], { type: "region", fallback: "none" });
      } catch {
        return null;
      }
    }), I = (De) => {
      var Pe;
      return ((Pe = T.value) == null ? void 0 : Pe.of(De.code)) ?? De.name;
    }, A = (De) => {
      var Pe;
      return De.placeholder || ((Pe = _n[De.code]) == null ? void 0 : Pe.placeholder) || Dl.placeholder;
    }, E = (De) => {
      const Pe = De.replace(/\s/g, "");
      return [...t.countries].sort((ot, St) => St.dialCode.length - ot.dialCode.length).find((ot) => Pe.startsWith(ot.dialCode));
    }, D = () => {
      if (!t.modelValue) {
        s.value = "";
        return;
      }
      const De = E(t.modelValue);
      if (De) {
        d.value = De;
        const Pe = t.modelValue.slice(De.dialCode.length);
        s.value = t.maskInput && t.showCountrySelector ? mr(
          Pe.replace(/\D/g, ""),
          A(De),
          (_n[De.code] ?? Dl).hasTrunkZero
        ) : Pe;
        return;
      }
      s.value = t.modelValue.replace(/^\+/, "");
    };
    D();
    const z = m(() => {
      const De = s.value.replace(/\D/g, "");
      return !De || !/[1-9]/.test(De) ? "" : t.showCountrySelector ? `${d.value.dialCode}${De}` : `+${De}`;
    }), Y = m(() => _n[d.value.code] || Dl), le = m(() => t.showCountrySelector ? A(d.value) : "+33612345678"), ne = m(() => {
      if (t.error) return t.error;
      if (!t.disableInternalValidation && f.value)
        return b.value;
    }), re = () => {
      const De = s.value.replace(/\D/g, "");
      if (t.required && !De)
        return "Phone number is required";
      if (!De)
        return;
      const Pe = Hc(De, Y.value.hasTrunkZero), { min: We, max: ot } = Y.value;
      if (Pe.length < We || Pe.length > ot)
        return `Phone number must be ${We === ot ? `${We}` : `${We}–${ot}`} digits for ${d.value.name}`;
    }, O = () => {
      const De = re();
      b.value = De, r("validation-change", !De, De);
    }, P = () => {
      b.value = void 0;
    }, V = (De) => Mv(
      De,
      (Pe) => Pe.replace(/\D/g, ""),
      (Pe) => mr(Pe, le.value, Y.value.hasTrunkZero)
    ), M = (De) => {
      const Pe = De.target;
      if (P(), t.maskInput && t.showCountrySelector) {
        s.value = V(Pe);
        return;
      }
      const We = Pe.value.replace(/[^\d\s\-()]/g, "");
      s.value = We, Pe.value = We;
    }, B = (De) => {
      var ot, St;
      if ((ot = ze.value) == null || ot.handleFieldKeydown(De), (St = Ee.value) == null || St.handleFieldKeydown(De), t.readonly || t.disabled || !(t.maskInput && t.showCountrySelector)) return;
      const Pe = De.target;
      Dv(De, Pe, (we) => V(we)) && (P(), s.value = Pe.value);
    }, q = (De) => {
      if (fe.value = !1, f.value = !0, t.showCountrySelector) {
        const Pe = s.value.replace(/\D/g, "");
        s.value = t.maskInput ? mr(
          Pe,
          le.value,
          Y.value.hasTrunkZero
        ) : Pe;
      }
      O(), r("blur", De);
    }, N = (De) => {
      fe.value = !0, r("focus", De);
    }, G = (De) => {
      var we;
      if (!t.showCountrySelector) return;
      const Pe = (((we = De.clipboardData) == null ? void 0 : we.getData("text")) ?? "").trim();
      if (!Pe.startsWith("+")) return;
      const We = E(Pe);
      if (!We) return;
      De.preventDefault(), P(), d.value = We;
      const ot = _n[We.code] ?? Dl, St = Pe.replace(/\D/g, "").slice(We.dialCode.replace(/\D/g, "").length);
      s.value = t.maskInput ? mr(St, A(We), ot.hasTrunkZero) : St;
    }, U = (De) => {
      d.value = De, Z("country"), t.maskInput && t.showCountrySelector && s.value && (s.value = mr(
        s.value.replace(/\D/g, ""),
        le.value,
        Y.value.hasTrunkZero
      )), f.value && O();
    }, K = (De, Pe) => {
      Pe.stopPropagation(), U(De);
    }, ge = (De) => De === "country" ? o : i, xe = (De) => De === "country" ? x.value : k.value, X = (De) => De === "country" ? y.value : $.value, ie = (De) => {
      var Pe;
      return Array.from(((Pe = X(De)) == null ? void 0 : Pe.querySelectorAll("[data-popup-row]")) ?? []);
    }, he = (De) => De.findIndex((Pe) => Pe.getAttribute("aria-selected") === "true" || Pe.getAttribute("aria-checked") === "true"), oe = (De, Pe) => {
      const We = De[(Pe + De.length) % De.length];
      We == null || We.focus({ preventScroll: !0 }), We == null || We.scrollIntoView({ block: "nearest" });
    }, Ce = (De, Pe) => {
      const We = he(De);
      oe(De, We !== -1 ? We : Pe === "first" ? 0 : De.length - 1);
    }, H = async (De, Pe = "first") => {
      ge(De).value = !0, await Ge(), Ce(ie(De), Pe);
    }, Z = (De) => {
      var Pe, We;
      (Pe = X(De)) != null && Pe.contains(document.activeElement) && ((We = xe(De)) == null || We.focus()), ge(De).value = !1;
    }, ee = (De, Pe) => {
      t.disabled || (Pe.stopPropagation(), ge(De).value ? Z(De) : Pe.detail === 0 ? H(De) : ge(De).value = !0);
    }, J = (De, Pe) => {
      const We = ja(S.query.value), ot = /^(.)\1+$/u.test(We) ? We[0] : We, St = ot.length === 1 ? Pe + 1 : Math.max(Pe, 0);
      for (let we = 0; we < t.countries.length; we++) {
        const Oe = (St + we) % t.countries.length;
        if (ja(I(t.countries[Oe])).startsWith(ot)) {
          oe(De, Oe);
          return;
        }
      }
    }, F = (De, Pe) => {
      var St;
      if (!ge(De).value) {
        (Pe.key === "ArrowDown" || Pe.key === "ArrowUp") && (Pe.preventDefault(), H(De, Pe.key === "ArrowDown" ? "first" : "last"));
        return;
      }
      const We = ie(De), ot = We.indexOf(document.activeElement);
      if (De === "country" && !(Pe.key === " " && !S.query.value) && S.handleKey(Pe)) {
        Pe.preventDefault(), Pe.stopPropagation(), J(We, ot);
        return;
      }
      switch (Pe.key) {
        case "ArrowDown":
        case "ArrowUp":
          Pe.preventDefault(), ot === -1 ? Ce(We, Pe.key === "ArrowDown" ? "first" : "last") : oe(We, ot + (Pe.key === "ArrowDown" ? 1 : -1));
          break;
        case "Home":
        case "End":
          Pe.preventDefault(), oe(We, Pe.key === "Home" ? 0 : We.length - 1);
          break;
        case "Enter":
        case " ":
          if (ot === -1) return;
          Pe.preventDefault(), Pe.stopPropagation(), We[ot].click();
          break;
        case "Escape":
          Pe.preventDefault(), Pe.stopPropagation(), Z(De), (St = xe(De)) == null || St.focus();
          break;
        case "Tab":
          Z(De);
          break;
      }
    }, _ = (De) => ee("country", De), ue = (De) => ee("verification", De), se = (De, Pe) => {
      Pe.stopPropagation(), u.value = De, Z("verification"), r("verification-click", De.id);
    }, Q = (De) => {
      const Pe = De.target, We = !x.value || !x.value.contains(Pe), ot = !y.value || !y.value.contains(Pe);
      We && ot && (o.value = !1);
      const St = !k.value || !k.value.contains(Pe), we = !$.value || !$.value.contains(Pe);
      St && we && (i.value = !1);
    };
    $e([s, d], () => {
      if (r("update:modelValue", z.value), t.showCountrySelector) {
        const De = s.value.replace(/\D/g, "");
        r("country-change", d.value, De);
      }
    }), $e(
      () => t.modelValue,
      (De) => {
        De !== z.value && (P(), D());
      }
    ), $e([o, i], ([De, Pe]) => {
      De || Pe ? document.addEventListener("click", Q) : document.removeEventListener("click", Q), De || S.reset();
    }), ct(() => {
      t.maskInput && t.showCountrySelector && t.modelValue && t.countries.some((De) => t.modelValue.startsWith(De.dialCode)) && z.value !== t.modelValue && r("update:modelValue", z.value);
    }), kt(() => {
      document.removeEventListener("click", Q);
    });
    const ae = m(
      () => nr(t.labelInline, !!t.label, !!t.removeButton)
    ), Te = m(() => t.removeButton && Xu(t.removeButton)), Le = m(() => !!t.innerButton || t.showVerificationButton), pe = m(
      () => t.size === "md" ? "pl-[calc(--spacing(2)-1px)] pr-[calc(--spacing(2)-1px)]" : ""
    ), ke = qe(), fe = R(!1), ze = R(null), Ee = R(null), He = m(() => `${ke}-phone`), Ke = m(() => t.label ? `${ke}-label` : void 0), et = m(() => `${ke}-error`), Se = m(() => `${ke}-hint`), me = m(() => `${ke}-format-hint`), Be = `${ke}-countries`, Ye = `${ke}-verification`, Qe = `${ke}-verification-menu`, bt = m(() => t.formatHintLabel ? `${t.formatHintLabel} ${le.value}` : t.showCountrySelector ? le.value : ""), jt = m(() => {
      const De = [];
      return bt.value && De.push(me.value), t.hint && De.push(Se.value), ne.value && De.push(et.value), De.length > 0 ? De.join(" ") : void 0;
    });
    return (De, Pe) => (c(), g("div", {
      class: C(["relative w-full pb-0.5", ae.value.root])
    }, [
      e.label ? (c(), W(It, {
        key: 0,
        id: Ke.value,
        ref_key: "labelRef",
        ref: ze,
        text: e.label,
        "input-id": He.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: fe.value,
        inline: e.labelInline,
        class: C(ae.value.label),
        "test-id": "phone-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline", "class"])) : w("", !0),
      bt.value ? (c(), g("span", {
        key: 1,
        id: me.value,
        class: "sr-only"
      }, j(bt.value), 9, wB)) : w("", !0),
      v("div", {
        class: C(["flex w-full items-end gap-3", ae.value.field])
      }, [
        v("div", CB, [
          te(bo, {
            buttons: e.buttons,
            layout: e.buttonLayout,
            size: e.size,
            disabled: e.disabled,
            "button-size": e.buttonSize,
            onButtonClick: Pe[4] || (Pe[4] = (We) => r("button-click", We))
          }, sa({
            default: ve(({ fieldClass: We }) => [
              te(Vn, {
                class: C(["w-full", We]),
                size: e.size,
                "inner-button": Le.value,
                disabled: e.disabled,
                readonly: e.readonly,
                error: !!ne.value,
                "has-value": !!s.value
              }, {
                default: ve(({ leftIconBoxClass: ot, iconColorClass: St, textClass: we }) => [
                  v("i", {
                    class: C(["ri-phone-fill", ot, St]),
                    "aria-hidden": "true"
                  }, null, 2),
                  tr(v("input", {
                    id: He.value,
                    "onUpdate:modelValue": Pe[1] || (Pe[1] = (Oe) => s.value = Oe),
                    type: "tel",
                    inputmode: "tel",
                    autocomplete: e.autocomplete,
                    disabled: e.disabled,
                    readonly: e.readonly,
                    "aria-labelledby": Ke.value,
                    "aria-invalid": !!ne.value,
                    "aria-describedby": jt.value,
                    class: C([
                      "relative min-w-0 flex-1 text-ellipsis border-0 bg-transparent p-0 outline-none focus:border-0 focus:outline-none focus:ring-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)",
                      we,
                      e.readonly ? "cursor-default" : ""
                    ]),
                    placeholder: le.value,
                    onInput: M,
                    onKeydown: B,
                    onPaste: G,
                    onBlur: q,
                    onFocus: N
                  }, null, 42, LB), [
                    [Yb, s.value]
                  ]),
                  e.innerButton ? (c(), W(Me, Fe({ key: 0 }, L(aa)(e.innerButton, e.disabled), {
                    size: "xs",
                    onClick: Pe[2] || (Pe[2] = (Oe) => r("button-click", e.innerButton.id))
                  }), null, 16)) : w("", !0),
                  e.showVerificationButton ? (c(), W(Me, {
                    key: 1,
                    id: Ye,
                    ref_key: "verificationButtonRef",
                    ref: p,
                    variant: "tertiary",
                    size: "xs",
                    class: C(e.size === "md" ? "-mr-0.5" : ""),
                    label: u.value.label,
                    disabled: e.disabled || e.readonly,
                    "aria-haspopup": "menu",
                    "aria-expanded": i.value,
                    "aria-controls": i.value ? Qe : void 0,
                    "dropdown-icon": "",
                    onClick: ue,
                    onKeydown: Pe[3] || (Pe[3] = (Oe) => F("verification", Oe))
                  }, null, 8, ["class", "label", "disabled", "aria-expanded", "aria-controls"])) : w("", !0)
                ]),
                _: 1
              }, 8, ["class", "size", "inner-button", "disabled", "readonly", "error", "has-value"])
            ]),
            _: 2
          }, [
            e.showCountrySelector ? {
              name: "leading",
              fn: ve(({ partClass: We, buttonSize: ot }) => [
                te(Me, {
                  ref_key: "countryButtonRef",
                  ref: h,
                  variant: "secondary",
                  size: ot,
                  class: C([We, pe.value]),
                  disabled: e.disabled || e.readonly,
                  "aria-haspopup": "listbox",
                  "aria-expanded": o.value,
                  "aria-controls": o.value ? Be : void 0,
                  "dropdown-icon": "",
                  onClick: _,
                  onKeydown: Pe[0] || (Pe[0] = (St) => F("country", St))
                }, {
                  default: ve(() => [
                    v("span", SB, [
                      v("span", $B, [
                        v("span", {
                          class: C(["fi fis size-[13.33px] rounded-full", `fi-${d.value.code.toLowerCase()}`]),
                          title: I(d.value)
                        }, null, 10, IB)
                      ]),
                      v("span", null, j(d.value.dialCode), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["size", "class", "disabled", "aria-expanded", "aria-controls"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["buttons", "layout", "size", "disabled", "button-size"]),
          e.showCountrySelector && o.value ? (c(), g("div", {
            key: 0,
            ref_key: "countryDropdownMenuRef",
            ref: y,
            class: C(["absolute left-0 top-full z-50 mt-1 w-56 max-h-[min(400px,calc(100vh-24px))] overflow-y-auto", L(si)]),
            onKeydown: Pe[5] || (Pe[5] = (We) => F("country", We))
          }, [
            v("ul", {
              id: Be,
              class: "flex min-w-0 flex-col gap-1.5",
              role: "listbox",
              "aria-label": e.countryListLabel
            }, [
              (c(!0), g(de, null, Re(e.countries, (We) => (c(), W(en, {
                key: We.code,
                as: "li",
                type: "flag",
                role: "option",
                tabindex: "-1",
                "data-popup-row": "",
                "aria-selected": We.code === d.value.code,
                label: I(We),
                flag: We.code,
                selected: We.code === d.value.code,
                "data-testid": `phone-country-${We.code}`,
                onClick: (ot) => K(We, ot)
              }, null, 8, ["aria-selected", "label", "flag", "selected", "data-testid", "onClick"]))), 128))
            ], 8, TB)
          ], 34)) : w("", !0),
          e.showVerificationButton && i.value ? (c(), g("div", {
            key: 1,
            ref_key: "verificationDropdownMenuRef",
            ref: $,
            class: C(["absolute right-0 top-full z-50 mt-1 min-w-36 w-max", L(si)]),
            onKeydown: Pe[6] || (Pe[6] = (We) => F("verification", We))
          }, [
            v("ul", {
              id: Qe,
              class: "flex min-w-0 flex-col gap-1.5",
              role: "menu",
              "aria-labelledby": Ye
            }, [
              (c(!0), g(de, null, Re(e.verificationOptions, (We) => (c(), W(en, {
                key: We.id,
                as: "li",
                type: "default",
                role: "menuitemradio",
                tabindex: "-1",
                "data-popup-row": "",
                "aria-checked": We.id === u.value.id,
                label: We.label,
                selected: We.id === u.value.id,
                onClick: (ot) => se(We, ot)
              }, null, 8, ["aria-checked", "label", "selected", "onClick"]))), 128))
            ])
          ], 34)) : w("", !0)
        ]),
        l.value ? (c(), g("div", AB, [
          Ae(De.$slots, "actions", {}, void 0, !0)
        ])) : w("", !0),
        Te.value && ae.value.removeInFieldRow ? (c(), W(Me, Fe({ key: 1 }, L(aa)(Te.value, e.disabled), {
          size: L(Wa)(e.size, "attached"),
          onClick: Pe[7] || (Pe[7] = (We) => r("button-click", Te.value.id))
        }), null, 16, ["size"])) : w("", !0)
      ], 2),
      ae.value.reservesHelper || e.hint || ne.value ? (c(), W($t, {
        key: 2,
        ref_key: "helperRef",
        ref: Ee,
        class: C(ae.value.helper),
        focused: fe.value,
        hint: e.hint,
        error: ne.value,
        "hint-id": Se.value,
        "error-id": et.value,
        "test-id-prefix": "phone-input"
      }, null, 8, ["class", "focused", "hint", "error", "hint-id", "error-id"])) : w("", !0),
      Te.value && !ae.value.removeInFieldRow ? (c(), W(Me, Fe({ key: 3 }, L(aa)(Te.value, e.disabled), {
        class: ae.value.remove,
        size: L(Wa)(e.size, "attached"),
        onClick: Pe[8] || (Pe[8] = (We) => r("button-click", Te.value.id))
      }), null, 16, ["class", "size"])) : w("", !0)
    ], 2));
  }
}), RB = /* @__PURE__ */ dt(EB, [["__scopeId", "data-v-da8fce2b"]]), BB = ["href", "aria-label"], MB = { key: 1 }, bq = /* @__PURE__ */ ye({
  __name: "PhoneDisplay",
  props: {
    value: {},
    link: { type: Boolean, default: !0 },
    ariaLabel: { default: void 0 }
  },
  setup(e) {
    const n = e, t = m(() => kB(n.value)), a = m(() => `tel:${n.value.replace(/[^\d+]/g, "")}`);
    return (l, r) => e.link ? (c(), g("a", {
      key: 0,
      href: a.value,
      "aria-label": e.ariaLabel
    }, j(t.value), 9, BB)) : (c(), g("span", MB, j(t.value), 1));
  }
}), DB = ["id"], gq = /* @__PURE__ */ ye({
  __name: "MaskedInput",
  props: {
    modelValue: { default: "" },
    mask: {},
    label: { default: void 0 },
    placeholder: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    disabled: { type: Boolean, default: !1 },
    success: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    labels: { default: () => ({ clear: "Clear input" }) },
    readonly: { type: Boolean, default: !1 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    iconLeft: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    autocomplete: { default: "off" },
    formatHintLabel: { default: void 0 },
    showEditIcon: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "clear"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = tn(), r = m(() => vB(t.mask)), o = ($) => $.replace(/\D/g, ""), i = m(() => {
      const $ = o(t.modelValue ?? "");
      return r.value ? io($, r.value) : $;
    }), s = qe(), d = m(() => t.id || `${s}-masked`), u = m(() => `${d.value}-format-hint`), f = m(
      () => t.formatHintLabel ? `${t.formatHintLabel} ${t.mask}` : t.mask
    ), b = m(() => {
      const $ = [u.value];
      return t.hint && $.push(`${d.value}-hint`), t.error && $.push(`${d.value}-error`), $.join(" ");
    }), h = ($) => {
      const S = $.target, T = rb(S, o, r.value);
      a("update:modelValue", T), a("input", $);
    }, p = ($) => {
      if (t.readonly || t.disabled) return;
      const S = $.target;
      Dv(
        $,
        S,
        (I) => rb(I, o, r.value)
      ) && a("update:modelValue", S.value);
    }, x = ($) => a("focus", $), y = ($) => a("blur", $), k = () => {
      a("update:modelValue", ""), a("clear");
    };
    return ($, S) => (c(), g("div", null, [
      v("span", {
        id: u.value,
        class: "sr-only"
      }, j(f.value), 9, DB),
      te(Wt, {
        id: d.value,
        "model-value": i.value,
        placeholder: e.placeholder,
        label: e.label,
        hint: e.hint,
        error: e.error,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        disabled: e.disabled,
        success: e.success,
        "label-tooltip": e.labelTooltip,
        labels: e.labels,
        readonly: e.readonly,
        size: e.size,
        name: e.name,
        "full-width": e.fullWidth,
        width: e.width,
        "icon-left": e.iconLeft,
        "show-edit-icon": e.showEditIcon,
        "label-inline": e.labelInline,
        autocomplete: e.autocomplete,
        "aria-describedby": b.value,
        type: "text",
        inputmode: "numeric",
        "data-testid": "masked-input",
        onInput: h,
        onKeydown: p,
        onFocus: x,
        onBlur: y,
        onClear: k
      }, sa({ _: 2 }, [
        L(l)("actions") ? {
          name: "actions",
          fn: ve(() => [
            Ae($.$slots, "actions")
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["id", "model-value", "placeholder", "label", "hint", "error", "required", "required-indicator", "disabled", "success", "label-tooltip", "labels", "readonly", "size", "name", "full-width", "width", "icon-left", "show-edit-icon", "label-inline", "autocomplete", "aria-describedby"])
    ]));
  }
}), zB = ["disabled", "aria-disabled", "aria-label", "data-testid"], OB = {
  key: 2,
  role: "status",
  class: "sr-only"
}, PB = 2e3, cd = /* @__PURE__ */ ye({
  __name: "ListItemActionButton",
  props: {
    action: {},
    appearance: {},
    variant: {},
    muted: { type: Boolean },
    rowHover: { type: Boolean },
    keepFocusable: { type: Boolean }
  },
  setup(e, { expose: n }) {
    const t = e, a = m(() => t.action.disabled ? t.action.disabledReason : void 0), l = m(() => !!t.action.disabled), r = m(() => l.value && !a.value && !t.keepFocusable), o = m(() => l.value && !r.value), i = m(() => t.muted || l.value ? "text-(--icons-icon-base)" : t.rowHover ? "text-(--icons-icon-base-strong) group-hover/row:text-(--icons-icon-hover)" : "text-(--icons-icon-base-strong)"), s = R(null), d = R(null), u = R(!1);
    let f, b = !1;
    const h = m(() => "copiedLabel" in t.action ? t.action.copiedLabel : void 0);
    async function p(k) {
      l.value || (clearTimeout(f), u.value = !1, await t.action.onClick(k), await Ge(), !(!h.value || b) && (u.value = !0, f = setTimeout(() => u.value = !1, PB)));
    }
    yt(() => {
      b = !0, clearTimeout(f);
    });
    const x = m(() => (u.value ? h.value : a.value) ?? "");
    function y() {
      var $;
      const k = d.value ?? (($ = s.value) == null ? void 0 : $.$el) ?? null;
      return !k || r.value ? !1 : (k.focus(), !0);
    }
    return n({ focus: y }), (k, $) => (c(), W(mt, {
      text: x.value,
      disabled: !x.value,
      open: u.value ? !0 : void 0,
      as: "span",
      class: "shrink-0"
    }, {
      default: ve(() => [
        e.appearance === "inline-icon" ? (c(), g("button", {
          key: 0,
          ref_key: "inlineRef",
          ref: d,
          type: "button",
          class: C(["inline-flex size-6 -mx-1 shrink-0 items-center justify-center rounded-(--border-border-radius-rounded-xs) focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-(--border-border-accent)", l.value ? "cursor-default" : "cursor-pointer"]),
          disabled: r.value,
          "aria-disabled": o.value ? "true" : void 0,
          "aria-label": e.action.label,
          "data-testid": e.action.testId ?? "list-item-copy-action",
          onClick: p
        }, [
          v("i", {
            class: C(["ri-file-copy-line inline-flex size-(--icon-size-sm) items-center justify-center text-(length:--icon-size-sm) leading-(--icon-size-sm)", i.value]),
            "aria-hidden": "true"
          }, null, 2)
        ], 10, zB)) : (c(), W(Me, Fe({
          key: 1,
          ref_key: "buttonRef",
          ref: s,
          variant: e.variant,
          size: "xs",
          "icon-only": e.appearance === "icon",
          "icon-left": "icon" in e.action ? e.action.icon : void 0,
          label: e.appearance === "label" ? e.action.label : void 0,
          "aria-label": e.appearance === "icon" ? e.action.label : void 0,
          disabled: r.value,
          "aria-disabled": o.value
        }, e.action.testId ? { "data-testid": e.action.testId } : {}, {
          onClick: e.action.onClick
        }), null, 16, ["variant", "icon-only", "icon-left", "label", "aria-label", "disabled", "aria-disabled", "onClick"])),
        e.appearance === "inline-icon" ? (c(), g("span", OB, j(u.value ? h.value : ""), 1)) : w("", !0)
      ]),
      _: 1
    }, 8, ["text", "disabled", "open"]));
  }
}), FB = ["id"], VB = {
  key: 0,
  class: "flex shrink-0",
  "data-testid": "list-item-leading"
}, NB = {
  key: 1,
  class: "flex shrink-0",
  "data-testid": "list-item-leading"
}, HB = {
  key: 0,
  class: "flex",
  "data-testid": "list-item-top-badge"
}, jB = ["id"], WB = ["id"], qB = ["id"], UB = {
  key: 3,
  class: "flex min-w-0 items-end justify-between gap-1.5",
  "data-testid": "list-item-amount-row"
}, GB = { class: "flex min-w-0 items-end gap-1.5" }, KB = ["id"], YB = ["id"], JB = ["id"], XB = ["id"], ZB = ["id"], QB = {
  key: 6,
  class: "flex flex-wrap gap-1",
  "data-testid": "list-item-label-badge"
}, _B = ["id"], eM = ["id"], tM = {
  key: 5,
  class: "flex shrink-0",
  "data-testid": "list-item-right-icon"
}, nM = {
  key: 6,
  class: "ml-0.5 flex shrink-0 items-center gap-1.5",
  "data-testid": "list-item-icons"
}, aM = ["id", "src", "alt"], lM = ["id", "role", "aria-label", "aria-hidden"], rM = {
  key: 0,
  class: "flex items-center gap-1.5",
  "data-testid": "list-item-trend"
}, oM = { class: "flex items-center" }, iM = ["id"], sM = ["id"], db = "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)", ub = "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)", cb = "@max-[24rem]/item:flex-col-reverse", fb = "pt-3.5 pr-3.5", dM = 2, uM = "ri-arrow-right-line", cM = "cursor-pointer text-left disabled:cursor-default aria-disabled:cursor-default focus-visible:outline-hidden after:absolute after:inset-0 after:content-[''] after:rounded-(--border-border-radius-rounded-xs) focus-visible:after:ring-2 focus-visible:after:ring-(--border-border-accent) focus-visible:after:outline-2 focus-visible:after:outline-transparent", fM = /* @__PURE__ */ ye({
  __name: "ListItem",
  props: {
    type: {},
    label: {},
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    interactive: { type: Boolean, default: !1 },
    icon: { default: void 0 },
    value: { default: void 0 },
    rightIcon: { default: void 0 },
    icons: { default: void 0 },
    avatar: { default: void 0 },
    iconShape: { default: void 0 },
    helperText: { default: void 0 },
    extraText: { default: void 0 },
    labelBadge: { default: void 0 },
    badge: { default: void 0 },
    status: { default: void 0 },
    copyAction: { default: void 0 },
    primaryAction: { default: void 0 },
    secondaryAction: { default: void 0 },
    trend: { default: void 0 },
    progress: { default: void 0 },
    max: { default: void 0 },
    amount: { default: void 0 },
    total: { default: void 0 },
    sideText: { default: void 0 },
    percentText: { default: void 0 },
    valueTone: { default: void 0 },
    meta: { default: void 0 },
    author: { default: void 0 },
    badges: { default: void 0 },
    selected: { type: Boolean, default: void 0 }
  },
  emits: ["click"],
  setup(e, { expose: n, emit: t }) {
    var J;
    const a = e, l = t, r = {
      root: "items-center justify-between gap-1.5",
      main: "flex-1",
      height: "min-h-6",
      labelText: db,
      extra: ub,
      column: "gap-px",
      labelGap: "gap-1.5",
      surface: "",
      surfaceHover: "",
      surfaceActive: "",
      surfaceMuted: "",
      recolour: !0,
      hoverRecolour: !0,
      caption: "text-(--text-text-body)",
      gap: "gap-1.5",
      align: "items-center",
      value: "text-(--text-text-black-default)",
      valueText: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)",
      valueBox: "shrink-0",
      end: "inline",
      shape: "circle",
      trailingGap: "gap-4",
      trailingStack: cb,
      label: "text-(--text-text-body)",
      helper: "text-(--text-text-body)",
      labelRow: "items-center",
      leading: "",
      badgePlacement: "trailing",
      secondaryVariant: "secondary",
      mutedBadges: !0,
      mutedIconShape: !0
    }, o = {
      root: "items-center justify-between gap-0.5",
      main: "flex-1",
      height: "",
      gap: "gap-2",
      labelText: db,
      extra: ub,
      column: "gap-px",
      labelGap: "gap-1.5",
      surface: "",
      surfaceHover: "",
      surfaceActive: "",
      surfaceMuted: "",
      recolour: !0,
      hoverRecolour: !0,
      caption: "text-(--text-text-body)",
      value: "",
      valueText: "",
      valueBox: "",
      end: "inline",
      shape: "circle",
      trailingGap: "gap-4",
      trailingStack: cb,
      mutedBadges: !0,
      mutedIconShape: !0
    }, i = {
      ...o,
      root: "items-center justify-between gap-1.5",
      height: "",
      label: "text-(--text-text-body)",
      helper: "text-(--text-text-body)",
      value: "text-(--text-text-body)",
      valueText: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)",
      // Figma puts the value in the root, 6 px after `Left content`; here it sits in the main zone,
      // whose gap is the 8 px of `Left content`.
      valueBox: "shrink-0 -ml-0.5",
      align: "items-center",
      labelRow: "items-center",
      leading: "",
      badgePlacement: "trailing",
      secondaryVariant: "secondary",
      // Figma Disabled object rows keep the Icon Shape colours.
      mutedIconShape: !1
    }, s = `${fb} pl-3.5 pb-[calc(--spacing(3.5)-1px)]`, d = `${s} border-b border-(--border-border-disabled-subtle) bg-(--background-background-disabled-opacity)`, u = `${s} border-b border-(--border-border-disabled) bg-(--background-background-disabled-opacity)`, f = {
      ...i,
      root: "items-center justify-between gap-2",
      gap: "gap-2",
      labelText: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold)",
      label: "text-(--text-text-black-default)",
      column: "gap-1",
      labelGap: "gap-0",
      hoverRecolour: !1,
      surface: `${s} border-b border-(--border-border-base-soft) bg-(--background-background-white)`,
      surfaceHover: "hover:pl-[calc(--spacing(3.5)-2px)] hover:pb-3.5 hover:border-b-0 hover:border-l-2 hover:border-l-(--border-border-hover) hover:bg-(--background-background-hover)",
      surfaceActive: `${fb} pl-[calc(--spacing(3.5)-2px)] pb-3.5 border-l-2 border-(--border-border-hover) bg-(--background-background-hover)`,
      surfaceMuted: d,
      mutedIconShape: !0
    }, b = {
      avatar: !0,
      helperText: !0,
      extraText: !0,
      labelBadge: !0,
      badge: !0,
      secondaryAction: !0
    }, h = {
      default: { ...r, props: { icon: !0 } },
      "with-number": { ...r, props: { icon: !0, value: !0 } },
      "with-badge": { ...r, props: { icon: !0, badge: !0 } },
      "with-right-icon": { ...r, props: { icon: !0, rightIcon: !0 } },
      "with-icons": { ...r, root: "items-center justify-start gap-2", main: "flex-initial", props: { icon: !0, icons: !0 } },
      "image-number": { ...i, props: { avatar: !0, helperText: !0, value: !0 } },
      "icon-number": {
        ...i,
        root: "items-start justify-start gap-2",
        main: "flex-initial",
        valueBox: "shrink-0 self-start",
        props: { iconShape: !0, helperText: !0, value: !0 }
      },
      // Figma Disabled 12773:10692, 15346:13357, 12773:13407 keep the Badge theme.
      "icon-number-badge": {
        ...i,
        badgePlacement: "above",
        mutedBadges: !1,
        props: { iconShape: !0, helperText: !0, badge: !0 }
      },
      "icon-badge": { ...i, mutedBadges: !1, props: { iconShape: !0, helperText: !0, badge: !0 } },
      "badge-name": { ...i, badgePlacement: "above", mutedBadges: !1, props: { badge: !0, helperText: !0 } },
      "image-buttons": {
        ...i,
        trailingGap: "gap-1.5",
        // Two buttons: on screen in their Tab order.
        trailingStack: "@max-[24rem]/item:flex-col",
        secondaryVariant: "ghost",
        props: { avatar: !0, helperText: !0, primaryAction: !0, secondaryAction: !0 }
      },
      transaction: {
        ...i,
        label: "text-(--text-text-black-default)",
        helper: "text-(--text-text-black-default)",
        valueText: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)",
        value: "text-(--text-text-black-default)",
        end: "column",
        shape: "square",
        props: { iconShape: !0, helperText: !0, value: !0, status: !0 }
      },
      // Figma 19619:3015: only the label and extra text recolour (hover and disabled).
      "data-list": {
        ...i,
        root: "items-center justify-between gap-1.5 pb-1.5",
        height: "",
        gap: "gap-1.5",
        labelText: "text-(length:--size-xxl) leading-(--line-height-xxl) font-(--weight-bold)",
        label: "text-(--text-text-heading)",
        extra: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular)",
        helper: "text-(--text-text-black-default)",
        column: "gap-0.5",
        trailingGap: "gap-1.5",
        props: { extraText: !0, trend: !0 }
      },
      // Figma 19563:13185: hover and disabled change the fill only.
      progress: {
        ...i,
        root: "flex-col items-stretch gap-1.5 p-1 pt-0 rounded-(--border-border-radius-rounded-xs)",
        main: "w-full",
        gap: "gap-0",
        labelText: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular)",
        labelGap: "gap-4",
        labelRow: "items-end",
        column: "gap-0",
        surfaceHover: "hover:bg-(--background-background-hover)",
        surfaceMuted: "bg-(--background-background-disabled-opacity)",
        recolour: !1,
        hoverRecolour: !1,
        props: {
          progress: !0,
          max: !0,
          amount: !0,
          total: !0,
          sideText: !0,
          percentText: !0,
          valueTone: !0
        }
      },
      "tab-document": {
        ...f,
        shape: "square",
        props: { iconShape: !0, meta: !0, author: !0, selected: !0 }
      },
      // The Figma raw binds a stronger disabled border on these two than on tab-document.
      "tab-badge": { ...f, badgePlacement: "below", surfaceMuted: u, props: { badge: !0, selected: !0 } },
      "tab-history": {
        ...f,
        surfaceMuted: u,
        props: { meta: !0, author: !0, badges: !0, selected: !0 }
      },
      "avatar-text-badge": {
        ...o,
        props: { ...b, copyAction: !0 },
        label: "text-(--text-text-body)",
        helper: "text-(--text-text-body)",
        align: "items-center",
        labelRow: "items-center",
        leading: "",
        badgePlacement: "trailing",
        secondaryVariant: "secondary"
      },
      "avatar-text-two-badges": {
        ...o,
        props: b,
        label: "text-(--text-text-heading)",
        helper: "text-(--text-text-black-default)",
        align: "items-start",
        labelRow: "items-start",
        leading: "py-1",
        badgePlacement: "label-row",
        secondaryVariant: "secondary"
      },
      "contact-item-badge": {
        ...o,
        props: b,
        label: "text-(--text-text-heading)",
        helper: "text-(--text-text-black-default)",
        align: "items-center",
        labelRow: "items-start",
        leading: "",
        badgePlacement: "trailing",
        secondaryVariant: "secondary"
      }
    }, p = m(() => h[a.type] ?? h.default), x = m(() => a.disabled || a.ariaDisabled), y = [
      "icon",
      "value",
      "rightIcon",
      "icons",
      "avatar",
      "iconShape",
      "helperText",
      "extraText",
      "labelBadge",
      "badge",
      "status",
      "copyAction",
      "primaryAction",
      "secondaryAction",
      "trend",
      "progress",
      "max",
      "amount",
      "total",
      "sideText",
      "percentText",
      "valueTone",
      "meta",
      "author",
      "badges",
      "selected"
    ];
    function k(F) {
      return !!p.value.props[F];
    }
    const $ = m(() => {
      const F = k("copyAction") ? a.copyAction : void 0;
      return F && x.value ? { ...F, disabled: !0, disabledReason: void 0 } : F;
    }), S = m(() => {
      var ue;
      const F = (se) => k(se) ? a[se] : void 0, _ = p.value.badgePlacement;
      return {
        icon: F("icon"),
        value: F("value"),
        rightIcon: k("rightIcon") ? a.rightIcon ?? uM : void 0,
        icons: F("icons"),
        avatar: F("avatar"),
        iconShape: F("iconShape"),
        status: F("status"),
        helperText: F("helperText"),
        extraText: F("extraText"),
        labelBadge: F("labelBadge"),
        belowBadges: [
          k("labelBadge") ? a.labelBadge : void 0,
          _ === "below" ? a.badge : void 0,
          ...k("badges") ? (a.badges ?? []).slice(0, dM) : []
        ].filter((se) => !!se),
        meta: k("meta") && ((ue = a.meta) != null && ue.length) ? a.meta.join(" · ") : void 0,
        author: F("author"),
        selected: k("selected") && a.interactive && !!a.selected,
        rowBadge: _ === "label-row" ? F("badge") : void 0,
        topBadge: _ === "above" ? F("badge") : void 0,
        trailingBadge: _ === "trailing" ? F("badge") : void 0,
        copyAction: $.value,
        primaryAction: F("primaryAction"),
        secondaryAction: F("secondaryAction"),
        trend: F("trend"),
        progress: F("progress"),
        max: F("max"),
        amount: F("amount"),
        total: F("total"),
        sideText: F("sideText"),
        percentText: F("percentText")
      };
    }), T = {
      neutral: "text-(--text-text-body)",
      success: "text-(--text-text-success)",
      warning: "text-(--text-text-warning)",
      destructive: "text-(--text-text-error-strong)",
      info: "text-(--text-text-info)"
    }, I = m(() => T[a.valueTone ?? "neutral"]), A = qe(), E = qe(), D = (F) => `${E}-${F}`, z = m(() => {
      var ue;
      const F = S.value;
      return [
        F.topBadge && D("top-badge"),
        F.sideText && D("side"),
        F.rowBadge && D("row-badge"),
        F.helperText && D("helper"),
        F.extraText && D("extra"),
        F.amount && D("amount"),
        F.amount && F.total && D("total"),
        F.amount && F.percentText && D("percent"),
        F.meta && D("meta"),
        F.author && D("author"),
        ...F.belowBadges.map((se, Q) => D(`below-badge-${Q}`)),
        F.value && D("value"),
        F.value && F.status && p.value.end === "column" && D("status"),
        ...(F.icons ?? []).flatMap((se, Q) => se.label ? [D(`icon-${Q}`)] : []),
        F.trend && D("trend-value"),
        ((ue = F.trend) == null ? void 0 : ue.caption) && D("trend-caption"),
        F.trailingBadge && D("trailing-badge")
      ].filter((se) => !!se).join(" ") || void 0;
    }), Y = m(() => x.value ? p.value.surfaceMuted : S.value.selected ? p.value.surfaceActive : a.interactive ? [p.value.surface, p.value.surfaceHover] : p.value.surface), le = m(() => x.value ? "text-(--text-text-disabled-strong)" : p.value.caption), ne = m(
      () => !!(S.value.trailingBadge || S.value.primaryAction || S.value.secondaryAction || S.value.trend)
    ), re = m(() => {
      if (x.value && p.value.recolour) return "text-(--text-text-disabled-strong)";
      const F = p.value.label;
      return a.interactive && p.value.hoverRecolour ? `${F} group-hover/row:text-(--text-text-hover)` : F;
    }), O = m(() => {
      if (x.value && p.value.recolour) return "text-(--text-text-disabled-strong)";
      const F = p.value.helper;
      return a.interactive && p.value.hoverRecolour ? `${F} group-hover/row:text-(--text-text-hover)` : F;
    }), P = m(() => {
      if (x.value) return "text-(--icons-icon-disabled-strong)";
      const F = "text-(--icons-icon-dark-default)";
      return a.interactive ? `${F} group-hover/row:text-(--icons-icon-hover)` : F;
    }), V = m(() => {
      if (x.value) return `${p.value.valueText} text-(--text-text-disabled-strong)`;
      const F = `${p.value.valueText} ${p.value.value}`;
      return a.interactive ? `${F} group-hover/row:text-(--text-text-hover)` : F;
    }), M = m(() => x.value ? "grayscale opacity-60" : "");
    function B(F) {
      return x.value && p.value.mutedBadges ? "disabled" : F.theme;
    }
    const q = m(() => a.interactive && !x.value ? "group-hover/row:text-(--text-text-hover)" : "");
    function N(F) {
      x.value || l("click", F);
    }
    const G = m(
      () => a.interactive ? {
        type: "button",
        disabled: a.disabled,
        "aria-disabled": a.ariaDisabled && !a.disabled ? "true" : void 0,
        "aria-current": S.value.selected ? "true" : void 0,
        "aria-labelledby": A,
        "aria-describedby": z.value,
        "data-row-button": "",
        "data-testid": "list-item-row-button"
      } : {}
    ), U = R(null), K = R(null), ge = R(null);
    function xe(F) {
      const _ = { primary: U, secondary: K, copy: ge }[F].value;
      return (_ == null ? void 0 : _.focus()) ?? !1;
    }
    n({ focusAction: xe });
    const X = R(null), ie = R(!1), he = R(!1), oe = m(() => he.value ? !1 : ie.value ? !0 : void 0);
    function Ce(F) {
      try {
        ie.value = F.target.matches(":focus-visible");
      } catch {
        ie.value = !0;
      }
    }
    function H() {
      ie.value = !1, he.value = !1;
    }
    $e(
      () => [a.disabled, a.interactive],
      ([F, _]) => {
        (F || !_) && H();
      }
    );
    function Z(F) {
      var _;
      F.key !== "Escape" || he.value || !ie.value || !((_ = X.value) != null && _.isTruncated) || (F.stopPropagation(), F.preventDefault(), he.value = !0);
    }
    const ee = typeof process < "u" && ((J = process.env) == null ? void 0 : J.NODE_ENV) !== "production";
    return $e(
      () => [a.type, a.interactive, a.selected, ...y.map((F) => a[F] !== void 0)].join(),
      () => {
        if (!ee) return;
        if (!(a.type in h)) {
          console.warn(`[OPAL ListItem] unknown type "${a.type}": rendered as "default".`);
          return;
        }
        const F = y.filter((_) => a[_] !== void 0 && !k(_));
        F.length && console.warn(`[OPAL ListItem] type "${a.type}" takes no ${F.map((_) => `\`${_}\``).join(", ")}: ignored.`), a.selected && !a.interactive && console.warn("[OPAL ListItem] `selected` needs `interactive`: ignored.");
      },
      { immediate: !0 }
    ), (F, _) => {
      var ue;
      return c(), g("li", {
        class: C(["@container/item flex w-full min-w-0", [p.value.root, p.value.height, Y.value, e.interactive ? "group/row relative" : ""]]),
        "data-testid": "list-item"
      }, [
        e.interactive || S.value.progress !== void 0 ? (c(), g("span", {
          key: 0,
          id: L(A),
          hidden: ""
        }, j(e.label), 9, FB)) : w("", !0),
        v("div", {
          class: C(["flex min-w-0", [p.value.main, p.value.gap, p.value.align]]),
          "data-testid": "list-item-main"
        }, [
          S.value.icon ? (c(), g("div", VB, [
            v("i", {
              class: C(["inline-flex size-(--icon-size-sm) items-center justify-center text-(length:--icon-size-sm) leading-(--icon-size-sm)", [S.value.icon, P.value]]),
              "aria-hidden": "true"
            }, null, 2)
          ])) : w("", !0),
          S.value.iconShape ? (c(), g("div", NB, [
            te(Gt, {
              icon: S.value.iconShape.icon,
              color: x.value && p.value.mutedIconShape ? "disabled" : S.value.iconShape.color ?? "default",
              type: p.value.shape,
              variant: "outlined",
              size: "md",
              as: "span"
            }, null, 8, ["icon", "color", "type"])
          ])) : w("", !0),
          S.value.avatar ? (c(), g("div", {
            key: 2,
            class: C(["flex shrink-0", p.value.leading]),
            "data-testid": "list-item-leading"
          }, [
            te(Nt, {
              name: S.value.avatar.name,
              img: S.value.avatar.img,
              entity: S.value.avatar.entity,
              size: "md",
              as: "span",
              presentational: ""
            }, null, 8, ["name", "img", "entity"])
          ], 2)) : w("", !0),
          v("div", {
            class: C(["flex flex-1 min-w-0 flex-col", p.value.column])
          }, [
            S.value.topBadge ? (c(), g("div", HB, [
              te(gt, {
                id: D("top-badge"),
                label: S.value.topBadge.label,
                theme: B(S.value.topBadge),
                "left-icon": S.value.topBadge.leftIcon,
                "show-left-icon": !!S.value.topBadge.leftIcon,
                size: "sm"
              }, null, 8, ["id", "label", "theme", "left-icon", "show-left-icon"])
            ])) : w("", !0),
            v("div", {
              class: C(["flex min-w-0", [p.value.labelGap, p.value.labelRow]]),
              "data-testid": "list-item-label-row"
            }, [
              (c(), W(it(e.interactive ? "button" : "span"), Fe({
                class: ["flex min-w-0", [S.value.copyAction ? "" : "flex-1", e.interactive ? cM : ""]]
              }, G.value, Nl(e.interactive ? { click: N, focus: Ce, blur: H, keydown: Z } : {})), {
                default: ve(() => [
                  te(pt, {
                    ref_key: "labelRef",
                    ref: X,
                    as: "span",
                    class: C(e.interactive ? "relative z-1" : ""),
                    text: e.label,
                    focusable: !e.interactive,
                    open: e.interactive ? oe.value : void 0,
                    "text-class": `${p.value.labelText} @max-[24rem]/item:whitespace-normal @max-[24rem]/item:wrap-break-word ${re.value}`,
                    "data-testid": "list-item-label"
                  }, null, 8, ["class", "text", "focusable", "open", "text-class"])
                ]),
                _: 1
              }, 16, ["class"])),
              S.value.sideText ? (c(), g("div", {
                key: 0,
                id: D("side"),
                class: "block min-w-0 max-w-1/2 shrink-0 wrap-break-word text-right text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body)",
                "data-testid": "list-item-side-text"
              }, j(S.value.sideText), 9, jB)) : w("", !0),
              S.value.copyAction ? (c(), W(cd, {
                key: 1,
                ref_key: "copyRef",
                ref: ge,
                class: C(e.interactive ? "relative z-1" : ""),
                action: S.value.copyAction,
                appearance: "inline-icon",
                muted: x.value,
                "row-hover": e.interactive,
                "keep-focusable": e.ariaDisabled && !e.disabled
              }, null, 8, ["class", "action", "muted", "row-hover", "keep-focusable"])) : w("", !0),
              S.value.rowBadge ? (c(), W(gt, {
                key: 2,
                id: D("row-badge"),
                class: "shrink-0",
                label: S.value.rowBadge.label,
                theme: B(S.value.rowBadge),
                "left-icon": S.value.rowBadge.leftIcon,
                "show-left-icon": !!S.value.rowBadge.leftIcon,
                size: "sm",
                "data-testid": "list-item-badge"
              }, null, 8, ["id", "label", "theme", "left-icon", "show-left-icon"])) : w("", !0)
            ], 2),
            S.value.helperText ? (c(), g("span", {
              key: 1,
              id: D("helper"),
              class: C(["block min-w-0 wrap-break-word text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)", O.value]),
              "data-testid": "list-item-helper"
            }, j(S.value.helperText), 11, WB)) : w("", !0),
            S.value.extraText ? (c(), g("span", {
              key: 2,
              id: D("extra"),
              class: C(["block min-w-0 wrap-break-word", [p.value.extra, O.value]]),
              "data-testid": "list-item-extra"
            }, j(S.value.extraText), 11, qB)) : w("", !0),
            S.value.amount ? (c(), g("div", UB, [
              v("div", GB, [
                v("span", {
                  id: D("amount"),
                  class: "text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold) text-(--text-text-heading)",
                  "data-testid": "list-item-amount"
                }, j(S.value.amount), 9, KB),
                S.value.total ? (c(), g("span", {
                  key: 0,
                  id: D("total"),
                  class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body)",
                  "data-testid": "list-item-total"
                }, j(S.value.total), 9, YB)) : w("", !0)
              ]),
              S.value.percentText ? (c(), g("span", {
                key: 0,
                id: D("percent"),
                class: C(["shrink-0 text-right text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)", I.value]),
                "data-testid": "list-item-percent"
              }, j(S.value.percentText), 11, JB)) : w("", !0)
            ])) : w("", !0),
            S.value.meta ? (c(), g("span", {
              key: 4,
              id: D("meta"),
              class: C(["block min-w-0 wrap-break-word text-(length:--size-sm) leading-(--line-height-s) font-(--weight-regular)", le.value]),
              "data-testid": "list-item-meta"
            }, j(S.value.meta), 11, XB)) : w("", !0),
            S.value.author ? (c(), g("span", {
              key: 5,
              id: D("author"),
              class: C(["block min-w-0 wrap-break-word text-(length:--size-xs) leading-(--line-height-xs) font-(--weight-regular)", le.value]),
              "data-testid": "list-item-author"
            }, j(S.value.author), 11, ZB)) : w("", !0),
            S.value.belowBadges.length ? (c(), g("div", QB, [
              (c(!0), g(de, null, Re(S.value.belowBadges, (se, Q) => (c(), W(gt, {
                id: D(`below-badge-${Q}`),
                key: Q,
                label: se.label,
                theme: B(se),
                "left-icon": se.leftIcon,
                "show-left-icon": !!se.leftIcon,
                size: "sm"
              }, null, 8, ["id", "label", "theme", "left-icon", "show-left-icon"]))), 128))
            ])) : w("", !0)
          ], 2),
          S.value.value && p.value.end === "column" ? (c(), g("div", {
            key: 3,
            class: C(["flex shrink-0 flex-col items-end", p.value.valueBox]),
            "data-testid": "list-item-end"
          }, [
            v("span", {
              id: D("value"),
              class: C(V.value),
              "data-testid": "list-item-value"
            }, j(S.value.value), 11, _B),
            S.value.status ? (c(), W(gt, {
              key: 0,
              id: D("status"),
              label: S.value.status.label,
              theme: B(S.value.status),
              type: "with-dot",
              size: "sm",
              class: C(q.value),
              "data-testid": "list-item-status"
            }, null, 8, ["id", "label", "theme", "class"])) : w("", !0)
          ], 2)) : S.value.value ? (c(), g("span", {
            key: 4,
            id: D("value"),
            class: C([p.value.valueBox, V.value]),
            "data-testid": "list-item-value"
          }, j(S.value.value), 11, eM)) : w("", !0),
          S.value.rightIcon ? (c(), g("div", tM, [
            v("i", {
              class: C(["inline-flex size-(--icon-size-sm) items-center justify-center text-(length:--icon-size-sm) leading-(--icon-size-sm)", [S.value.rightIcon, P.value]]),
              "aria-hidden": "true"
            }, null, 2)
          ])) : w("", !0),
          (ue = S.value.icons) != null && ue.length ? (c(), g("div", nM, [
            (c(!0), g(de, null, Re(S.value.icons, (se, Q) => (c(), g(de, { key: Q }, [
              se.src ? (c(), g("img", {
                key: 0,
                id: se.label ? D(`icon-${Q}`) : void 0,
                class: C(["size-4.5 shrink-0 object-contain", M.value]),
                src: se.src,
                alt: se.label,
                "data-testid": "list-item-icons-entry"
              }, null, 10, aM)) : (c(), g("i", {
                key: 1,
                id: se.label ? D(`icon-${Q}`) : void 0,
                class: C(["inline-flex size-4.5 items-center justify-center text-[18px] leading-[18px]", [se.icon, P.value]]),
                role: se.label ? "img" : void 0,
                "aria-label": se.label,
                "aria-hidden": se.label ? void 0 : "true",
                "data-testid": "list-item-icons-entry"
              }, null, 10, lM))
            ], 64))), 128))
          ])) : w("", !0)
        ], 2),
        S.value.progress !== void 0 ? (c(), W(Ju, {
          key: 1,
          value: S.value.progress,
          max: S.value.max,
          size: "lg",
          "aria-labelledby": L(A),
          "aria-valuetext": S.value.percentText,
          "data-testid": "list-item-progress"
        }, null, 8, ["value", "max", "aria-labelledby", "aria-valuetext"])) : w("", !0),
        ne.value ? (c(), g("div", {
          key: 2,
          class: C(["flex shrink-0 items-center @max-[24rem]/item:items-end @max-[24rem]/item:gap-2", [p.value.trailingGap, p.value.trailingStack]]),
          "data-testid": "list-item-trailing"
        }, [
          S.value.trend ? (c(), g("div", rM, [
            v("span", oM, [
              _[0] || (_[0] = v("i", {
                class: "ri-arrow-right-up-line inline-flex size-(--icon-size-sm) items-center justify-center text-(length:--icon-size-sm) leading-(--icon-size-sm) text-(--icons-icon-success)",
                "aria-hidden": "true"
              }, null, -1)),
              v("span", {
                id: D("trend-value"),
                class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-success)",
                "data-testid": "list-item-trend-value"
              }, j(S.value.trend.value), 9, iM)
            ]),
            S.value.trend.caption ? (c(), g("span", {
              key: 0,
              id: D("trend-caption"),
              class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body)",
              "data-testid": "list-item-trend-caption"
            }, j(S.value.trend.caption), 9, sM)) : w("", !0)
          ])) : w("", !0),
          S.value.trailingBadge ? (c(), W(gt, {
            key: 1,
            id: D("trailing-badge"),
            label: S.value.trailingBadge.label,
            theme: B(S.value.trailingBadge),
            "left-icon": S.value.trailingBadge.leftIcon,
            "show-left-icon": !!S.value.trailingBadge.leftIcon,
            size: "sm",
            "data-testid": "list-item-badge"
          }, null, 8, ["id", "label", "theme", "left-icon", "show-left-icon"])) : w("", !0),
          S.value.primaryAction ? (c(), W(cd, {
            key: 2,
            ref_key: "primaryRef",
            ref: U,
            class: C(e.interactive ? "relative z-1" : ""),
            action: S.value.primaryAction,
            appearance: "label",
            variant: "secondary"
          }, null, 8, ["class", "action"])) : w("", !0),
          S.value.secondaryAction ? (c(), W(cd, {
            key: 3,
            ref_key: "secondaryRef",
            ref: K,
            class: C(e.interactive ? "relative z-1" : ""),
            action: S.value.secondaryAction,
            appearance: "icon",
            variant: p.value.secondaryVariant
          }, null, 8, ["class", "action", "variant"])) : w("", !0)
        ], 2)) : w("", !0)
      ], 2);
    };
  }
}), hM = /* @__PURE__ */ ye({
  __name: "ListItemGroup",
  props: {
    divider: { type: Boolean, default: !1 },
    dividerColor: { default: "var(--border-border-base-soft)" }
  },
  setup(e) {
    const n = e, t = m(() => n.divider ? { "--list-item-group-divider": n.dividerColor } : void 0);
    return (a, l) => (c(), g("ul", {
      role: "list",
      class: C(["m-0 flex w-full min-w-0 list-none flex-col p-0", e.divider ? "gap-3 [&>li+li]:border-t [&>li+li]:border-solid [&>li+li]:border-(--list-item-group-divider) [&>li+li]:pt-3" : "gap-4"]),
      style: je(t.value),
      "data-testid": "list-item-group"
    }, [
      Ae(a.$slots, "default")
    ], 6));
  }
});
function Ov(e) {
  return m(() => {
    const n = e(), t = n.border !== !1, a = [
      `flex items-center rounded-(--border-border-radius-rounded-l) border border-solid w-full transition-[color,background-color,border-color,box-shadow] duration-200 ${n.padding}`,
      n.gap
    ];
    return n.minHeight && a.push(n.minHeight), n.alwaysClasses && a.push(n.alwaysClasses), n.disabled ? (a.push("bg-(--background-background-disabled-opacity) cursor-default"), a.push(t ? "border-(--border-border-disabled)" : "border-transparent"), a) : (n.selected ? a.push("bg-(--background-background-accent) border-(--border-border-accent)") : (a.push("bg-(--background-background-white) hover:bg-(--background-background-hover)"), a.push(
      t ? "border-(--border-border-base-medium) hover:border-(--border-border-hover)" : "border-transparent"
    )), n.restingClasses && a.push(n.restingClasses), n.grabbed && a.push("ring-2 ring-(--border-border-accent)"), a);
  });
}
const bM = {
  key: 0,
  class: "min-w-0 flex-1"
}, gM = ["aria-label"], mM = /* @__PURE__ */ ye({
  __name: "EditableTitle",
  props: {
    modelValue: {},
    editable: { type: Boolean, default: !0 },
    showPen: { type: Boolean, default: !0 },
    size: { default: "md" },
    placeholder: { default: void 0 },
    emptyText: { default: void 0 },
    maxlength: { default: void 0 },
    error: { default: void 0 },
    editLabel: {},
    saveLabel: {},
    penVariant: { default: "secondary" },
    inputWidth: { default: void 0 },
    maxWidth: { default: void 0 },
    warnPattern: { default: void 0 },
    warnLabel: { default: void 0 },
    autoEdit: { type: Boolean, default: !1 }
  },
  emits: ["save", "cancel", "edit-start", "edit-end"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = {
      sm: {
        text: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading) dark:text-(--colors-text-white-default)",
        gap: "gap-1.5",
        pen: "xs"
      },
      md: {
        text: "text-(length:--size-4xl) leading-(--line-height-4xl) font-(--weight-bold) text-(--text-text-black-default) dark:text-(--colors-text-white-default)",
        gap: "gap-3",
        pen: "xs"
      },
      lg: {
        text: "text-(length:--size-5xl) leading-(--line-height-5xl) font-(--weight-bold) text-(--text-text-black-default) dark:text-(--colors-text-white-default)",
        gap: "gap-2",
        pen: "xs"
      }
    }, r = m(() => l[t.size]), o = m(() => t.modelValue || t.emptyText || ""), i = R(!1), s = R(""), d = R(null), u = R(null), f = m(
      () => t.maxWidth && !i.value ? { maxWidth: t.maxWidth } : void 0
    ), b = m(() => !!t.warnPattern && t.warnPattern.test(s.value));
    function h() {
      var I;
      const S = (I = d.value) == null ? void 0 : I.$el, T = S == null ? void 0 : S.querySelector("input");
      T == null || T.focus(), T == null || T.select();
    }
    async function p() {
      t.editable && (s.value = t.modelValue, i.value = !0, await Ge(), h());
    }
    async function x() {
      var S, T;
      i.value = !1, await Ge(), (T = (S = u.value) == null ? void 0 : S.$el) == null || T.focus();
    }
    function y() {
      x(), a("cancel");
    }
    function k() {
      const S = s.value.trim();
      if (S.length === 0 || S === t.modelValue) {
        y();
        return;
      }
      a("save", S), x();
    }
    function $(S) {
      S.key === "Enter" ? (S.preventDefault(), k()) : S.key === "Escape" && (S.preventDefault(), y());
    }
    return $e(
      () => t.error,
      async (S) => {
        S && !i.value && (i.value = !0, await Ge(), h());
      }
    ), $e(i, (S) => {
      a(S ? "edit-start" : "edit-end");
    }), $e(
      () => t.autoEdit,
      (S) => {
        S && t.editable && !i.value && p();
      },
      { immediate: !0 }
    ), (S, T) => (c(), g("div", {
      class: C(["inline-flex min-w-0 items-center", i.value ? "gap-3" : r.value.gap]),
      style: je(f.value),
      "data-testid": "editable-title"
    }, [
      i.value ? (c(), g(de, { key: 1 }, [
        te(Wt, {
          ref_key: "inputRef",
          ref: d,
          modelValue: s.value,
          "onUpdate:modelValue": T[0] || (T[0] = (I) => s.value = I),
          size: "md",
          placeholder: e.placeholder,
          maxlength: e.maxlength,
          "aria-label": e.editLabel,
          "full-width": !e.inputWidth,
          width: e.inputWidth,
          "data-testid": "editable-title-input",
          onKeydown: $
        }, sa({ _: 2 }, [
          b.value ? {
            name: "iconRight",
            fn: ve(() => [
              te(mt, {
                text: e.warnLabel ?? "",
                disabled: !e.warnLabel,
                position: "bottom"
              }, {
                default: ve(() => [
                  v("i", {
                    class: "ri-alert-fill inline-flex size-4 shrink-0 items-center justify-center text-(length:--size-l) text-(--icons-icon-warning)",
                    role: "img",
                    "aria-label": e.warnLabel,
                    "data-testid": "editable-title-warning"
                  }, null, 8, gM)
                ]),
                _: 1
              }, 8, ["text", "disabled"])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["modelValue", "placeholder", "maxlength", "aria-label", "full-width", "width"]),
        te(Me, {
          variant: "secondary",
          size: "sm",
          "icon-only": "",
          "icon-left": "ri-save-3-fill",
          "aria-label": e.saveLabel,
          "data-testid": "editable-title-save",
          onMousedown: T[1] || (T[1] = Je(() => {
          }, ["prevent"])),
          onClick: k
        }, null, 8, ["aria-label"])
      ], 64)) : (c(), g(de, { key: 0 }, [
        e.maxWidth ? (c(), g("div", bM, [
          te(pt, {
            text: o.value,
            position: "bottom",
            "text-class": r.value.text,
            "data-testid": "editable-title-text"
          }, null, 8, ["text", "text-class"])
        ])) : (c(), g("span", {
          key: 1,
          class: C([r.value.text, "truncate"]),
          "data-testid": "editable-title-text"
        }, j(o.value), 3)),
        e.editable && e.showPen ? (c(), W(Me, {
          key: 2,
          ref_key: "penRef",
          ref: u,
          variant: e.penVariant,
          size: r.value.pen,
          "icon-only": "",
          "icon-left": "ri-pencil-line",
          "aria-label": e.editLabel,
          "data-testid": "editable-title-edit",
          onClick: p
        }, null, 8, ["variant", "size", "aria-label"])) : w("", !0)
      ], 64))
    ], 6));
  }
}), jc = /* @__PURE__ */ dt(mM, [["__scopeId", "data-v-b33d760d"]]), pM = { class: "flex flex-1 min-w-0 items-center gap-2" }, vM = { class: "flex-1 min-w-0 flex flex-col gap-0" }, xM = { class: "flex grow shrink basis-48 min-w-0 items-center gap-2" }, yM = { class: "flex flex-1 min-w-0 flex-col gap-0" }, kM = {
  key: 0,
  class: "w-full min-w-0 truncate text-(length:--size-sm) leading-(--line-height-s) text-(--text-text-body)",
  "data-testid": "list-item-subtitle"
}, wM = {
  key: 0,
  class: "ml-auto flex min-w-0 flex-wrap items-center justify-end gap-x-6 gap-y-3",
  "data-testid": "list-item-trailing"
}, CM = {
  key: 0,
  class: "flex flex-wrap items-center justify-end gap-x-6 gap-y-3",
  "data-testid": "list-item-trailing-actions"
}, SM = {
  key: 0,
  class: "flex items-center gap-6",
  "data-testid": "list-item-stats"
}, $M = { class: "flex min-w-0 grow shrink basis-32 flex-col" }, IM = {
  key: 0,
  class: "flex min-w-0 flex-wrap items-center gap-x-4 gap-y-3",
  "data-testid": "list-item-stats"
}, LM = {
  key: 1,
  class: "flex min-h-12.5 w-[153px] max-w-full shrink-0 flex-col justify-center gap-1.5",
  "data-testid": "list-item-progress"
}, TM = ["id"], AM = ["id"], EM = {
  key: 2,
  class: "flex shrink-0 items-center gap-4",
  "data-testid": "list-item-trailing-actions"
}, RM = { class: "flex grow shrink basis-48 min-w-0 items-center gap-2" }, BM = ["aria-label", "aria-pressed", "disabled"], MM = { class: "flex flex-1 min-w-0 flex-col gap-0" }, DM = {
  key: 1,
  class: "w-full min-w-0 truncate text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading)",
  "data-testid": "list-item-title"
}, zM = {
  key: 0,
  class: "w-full min-w-0 truncate text-(length:--size-sm) leading-(--line-height-s) text-(--text-text-body)",
  "data-testid": "list-item-subtitle"
}, OM = {
  key: 0,
  class: "ml-auto flex max-w-full shrink-0 flex-wrap items-center justify-end gap-3.5",
  "data-testid": "list-item-trailing"
}, PM = ["aria-label", "aria-pressed", "disabled"], FM = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "ListItemCard",
  props: {
    type: { default: "default" },
    label: {},
    subtitle: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    reorderable: { type: Boolean, default: void 0 },
    dragHandleLabel: { default: void 0 },
    grabbed: { type: Boolean, default: !1 },
    editable: { type: Boolean, default: !1 },
    showEdit: { type: Boolean, default: !1 },
    editLabel: { default: void 0 },
    saveLabel: { default: void 0 },
    maxlength: { default: void 0 },
    editError: { default: void 0 },
    autoEdit: { type: Boolean, default: !1 },
    editInputWidth: { default: void 0 },
    selected: { type: Boolean, default: !1 },
    progress: { default: void 0 },
    max: { default: 100 },
    progressLabel: { default: void 0 }
  },
  emits: ["rename", "grab", "grab-cancel", "select"],
  setup(e, { emit: n }) {
    const t = ["draggable-edit", "draggable-collapsed"], a = ["card-item", "draggable-edit"], l = e, r = n, o = tn();
    let i = {};
    Rx(() => {
      i = {};
    });
    const s = (D) => i[D] ?? (i[D] = o(D)), d = R(!1), u = m(() => t.includes(l.type)), f = m(
      () => l.type === "draggable-collapsed" ? {
        role: "button",
        tabindex: l.disabled ? void 0 : 0,
        "aria-pressed": l.selected || void 0,
        // The row IS the button here, so it carries the disabled state (other types' roots have a
        // role that supports none). Only set when disabled, so a forwarded attr is not clobbered.
        ...l.disabled ? { "aria-disabled": "true" } : {}
      } : {}
    ), b = m(() => !u.value || l.reorderable === !1 ? !1 : l.reorderable === !0 ? !0 : !l.disabled), h = {
      default: { padding: "p-[calc(--spacing(3.5)-1px)]", gap: "gap-3.5", shadow: !0 },
      "card-item": { padding: "p-[calc(--spacing(3.5)-1px)]", gap: "gap-6", minHeight: "min-h-[74px]", shadow: !1 },
      "draggable-edit": { padding: "p-[calc(--spacing(3.5)-1px)]", gap: "gap-3.5", minHeight: "min-h-[74px]", shadow: !0 },
      "draggable-collapsed": { padding: "p-[calc(--spacing(3.5)-1px)]", gap: "gap-2", minHeight: "min-h-14", shadow: !0 },
      progression: {
        padding: "pt-[calc(--spacing(4.5)-1px)] pr-[calc(--spacing(5)-1px)] pb-[calc(--spacing(4.5)-1px)] pl-[calc(--spacing(6)-1px)]",
        gap: "gap-4",
        shadow: !0
      }
    }, p = Ov(() => {
      const D = h[l.type];
      return {
        padding: D.padding,
        gap: D.gap,
        minHeight: D.minHeight,
        // The draggable Figma variants drop the DS card shadow on hover and when disabled.
        restingClasses: D.shadow ? l.type === "progression" ? "shadow-(--blur-shadow-s)" : "shadow-(--blur-shadow-s) hover:shadow-none" : void 0,
        // The trailing zone wraps under the text only when it no longer fits beside a 12rem text
        // block (`basis-48` below; Figma has no narrow card), 12px below it. The drag rows of a
        // drawer (`default`) and the palette (`draggable-collapsed`) stay on one line.
        alwaysClasses: a.includes(l.type) ? "flex-wrap gap-y-3" : l.type === "progression" ? "flex-wrap justify-between gap-y-3" : void 0,
        disabled: l.disabled,
        // selected wins over the resting border (collapsed palette pick); grabbed is the
        // keyboard-grabbed accent ring (Rule n°4 feedback) — both are no-ops outside their own type.
        selected: l.selected,
        grabbed: l.grabbed
      };
    }), x = qe(), y = qe(), k = m(() => {
      var D;
      return ((D = l.progressLabel) == null ? void 0 : D.trim()) || void 0;
    }), $ = m(
      () => l.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-body)"
    );
    function S() {
      b.value && r("grab");
    }
    function T() {
      r("grab-cancel");
    }
    function I(D) {
      r("rename", D);
    }
    function A() {
      l.disabled || l.type !== "draggable-collapsed" || r("select");
    }
    function E(D) {
      l.type !== "draggable-collapsed" || l.disabled || (D.key === "Enter" || D.key === " ") && (D.preventDefault(), r("select"));
    }
    return (D, z) => (c(), g("div", Fe({ ...D.$attrs, ...f.value }, {
      class: L(p),
      onClick: A,
      onKeydown: E
    }), [
      e.type === "default" ? (c(), g(de, { key: 0 }, [
        v("div", pM, [
          s("icon") || s("leading") ? (c(), g("div", {
            key: 0,
            class: C(["shrink-0 flex items-center", { "opacity-40": e.disabled }])
          }, [
            Ae(D.$slots, "leading", {}, () => [
              Ae(D.$slots, "icon")
            ])
          ], 2)) : w("", !0),
          v("div", vM, [
            v("p", {
              class: C(["text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) w-full truncate", $.value])
            }, j(e.label), 3),
            e.subtitle ? (c(), g("p", {
              key: 0,
              class: C(["text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) w-full", $.value])
            }, j(e.subtitle), 3)) : w("", !0)
          ])
        ]),
        Ae(D.$slots, "badge"),
        Ae(D.$slots, "actions")
      ], 64)) : e.type === "card-item" ? (c(), g(de, { key: 1 }, [
        v("div", xM, [
          Ae(D.$slots, "leading"),
          v("div", yM, [
            te(pt, {
              text: e.label,
              "text-class": "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading)",
              "data-testid": "list-item-title"
            }, null, 8, ["text"]),
            Ae(D.$slots, "subtitle", {}, () => [
              e.subtitle ? (c(), g("p", kM, j(e.subtitle), 1)) : w("", !0)
            ])
          ])
        ]),
        s("badge") || s("stats") || s("actions") ? (c(), g("div", wM, [
          Ae(D.$slots, "badge"),
          s("stats") || s("actions") ? (c(), g("div", CM, [
            s("stats") ? (c(), g("div", SM, [
              Ae(D.$slots, "stats")
            ])) : w("", !0),
            Ae(D.$slots, "actions")
          ])) : w("", !0)
        ])) : w("", !0)
      ], 64)) : e.type === "progression" ? (c(), g(de, { key: 2 }, [
        v("div", $M, [
          te(pt, {
            text: e.label,
            "text-class": "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold) text-(--text-text-heading)",
            "data-testid": "list-item-title"
          }, null, 8, ["text"])
        ]),
        s("stats") ? (c(), g("div", IM, [
          Ae(D.$slots, "stats")
        ])) : w("", !0),
        e.progress !== void 0 ? (c(), g("div", LM, [
          k.value ? (c(), g("span", {
            key: 0,
            id: L(x),
            class: "min-w-0 wrap-break-word text-(length:--size-xs) leading-(--line-height-s) font-(--weight-regular) text-(--text-text-black-default)",
            "data-testid": "list-item-progress-label"
          }, j(k.value), 9, TM)) : w("", !0),
          te(Ju, Fe({
            value: e.progress,
            max: e.max
          }, k.value ? { "aria-labelledby": `${L(y)} ${L(x)}` } : { ariaLabel: e.label }), null, 16, ["value", "max"]),
          k.value ? (c(), g("span", {
            key: 1,
            id: L(y),
            hidden: ""
          }, j(e.label), 9, AM)) : w("", !0)
        ])) : w("", !0),
        s("actions") ? (c(), g("div", EM, [
          Ae(D.$slots, "actions")
        ])) : w("", !0)
      ], 64)) : e.type === "draggable-edit" ? (c(), g(de, { key: 3 }, [
        v("div", RM, [
          v("button", {
            type: "button",
            class: C(["ri-draggable shrink-0 rounded-(--border-border-radius-rounded-xs) p-0 text-(length:--icon-size-lg) leading-none focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-(--border-border-accent)", [
              b.value ? "cursor-grab text-(--icons-icon-dark-default)" : "opacity-40 cursor-default",
              e.grabbed ? "text-(--text-text-accent)" : ""
            ]]),
            "aria-label": e.dragHandleLabel,
            "aria-roledescription": "draggable",
            "aria-pressed": e.grabbed || void 0,
            disabled: e.disabled || !b.value,
            "data-testid": "list-item-drag-handle",
            onClick: S,
            onKeydown: ht(T, ["esc"])
          }, null, 42, BM),
          Ae(D.$slots, "leading"),
          v("div", MM, [
            e.editable ? (c(), W(jc, {
              key: 0,
              "model-value": e.label,
              editable: !e.disabled,
              "show-pen": e.showEdit && !e.disabled,
              size: "sm",
              "pen-variant": "tertiary",
              maxlength: e.maxlength,
              error: e.editError,
              "auto-edit": e.autoEdit,
              "input-width": e.editInputWidth,
              "edit-label": e.editLabel ?? "",
              "save-label": e.saveLabel ?? "",
              class: "w-full min-w-0 min-h-8",
              onSave: I,
              onEditStart: z[0] || (z[0] = (Y) => d.value = !0),
              onEditEnd: z[1] || (z[1] = (Y) => d.value = !1)
            }, null, 8, ["model-value", "editable", "show-pen", "maxlength", "error", "auto-edit", "input-width", "edit-label", "save-label"])) : (c(), g("p", DM, j(e.label), 1)),
            Ae(D.$slots, "subtitle", {}, () => [
              e.subtitle ? (c(), g("p", zM, j(e.subtitle), 1)) : w("", !0)
            ])
          ])
        ]),
        !d.value && (s("badge") || s("actions")) ? (c(), g("div", OM, [
          Ae(D.$slots, "badge"),
          Ae(D.$slots, "actions")
        ])) : w("", !0)
      ], 64)) : (c(), g(de, { key: 4 }, [
        v("button", {
          type: "button",
          class: C(["ri-draggable shrink-0 rounded-(--border-border-radius-rounded-xs) p-0 text-(length:--icon-size-lg) leading-none focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-(--border-border-accent)", [
            b.value ? "cursor-grab text-(--icons-icon-dark-default)" : "opacity-40 cursor-default",
            e.grabbed ? "text-(--text-text-accent)" : ""
          ]]),
          "aria-label": e.dragHandleLabel,
          "aria-roledescription": "draggable",
          "aria-pressed": e.grabbed || void 0,
          disabled: e.disabled || !b.value,
          "data-testid": "list-item-drag-handle",
          onClick: Je(S, ["stop"]),
          onKeydown: ht(T, ["esc"])
        }, null, 42, PM),
        Ae(D.$slots, "leading"),
        v("span", {
          class: C(["flex-1 min-w-0 truncate text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)", e.disabled ? "text-(--text-text-disabled-strong)" : e.selected ? "text-(--text-text-accent)" : "text-(--text-text-body)"]),
          "data-testid": "list-item-label"
        }, j(e.label), 3),
        Ae(D.$slots, "badge"),
        Ae(D.$slots, "actions")
      ], 64))
    ], 16));
  }
}), VM = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "DraggableListItem",
  props: {
    reorderable: { type: Boolean, default: void 0 },
    type: {},
    label: {},
    subtitle: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    dragHandleLabel: {},
    grabbed: { type: Boolean },
    editable: { type: Boolean },
    showEdit: { type: Boolean },
    editLabel: {},
    saveLabel: {},
    maxlength: {},
    editError: {},
    autoEdit: { type: Boolean },
    editInputWidth: {},
    selected: { type: Boolean },
    progress: {},
    max: {},
    progressLabel: {}
  },
  setup(e) {
    const n = e, t = tn(), a = m(() => n.reorderable === !1 ? !1 : n.reorderable === !0 ? !0 : !n.disabled);
    return (l, r) => (c(), W(FM, Fe(l.$attrs, {
      label: n.label,
      subtitle: n.subtitle,
      disabled: n.disabled,
      draggable: a.value ? "true" : "false"
    }), sa({
      icon: ve(() => [
        v("i", {
          class: C(["ri-draggable text-(length:--icon-size-lg) leading-none select-none text-(--icons-icon-dark-default)", a.value ? "cursor-grab" : "opacity-40"]),
          "aria-hidden": "true"
        }, null, 2)
      ]),
      _: 2
    }, [
      L(t)("badge") ? {
        name: "badge",
        fn: ve(() => [
          v("div", null, [
            Ae(l.$slots, "badge")
          ])
        ]),
        key: "0"
      } : void 0,
      L(t)("actions") ? {
        name: "actions",
        fn: ve(() => [
          Ae(l.$slots, "actions")
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["label", "subtitle", "disabled", "draggable"]));
  }
}), NM = ["aria-level"], HM = {
  class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body-subtle)",
  "data-testid": "date-group-header-label"
}, mq = /* @__PURE__ */ ye({
  __name: "DateGroupHeader",
  props: {
    label: {},
    count: {},
    ariaLevel: { default: 3 },
    fullWidth: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", {
      class: C([
        "flex items-center gap-2.5 rounded-md bg-(--background-background-white-tertiary) px-4 py-1",
        e.fullWidth ? "w-full" : "w-fit"
      ]),
      role: "heading",
      "aria-level": e.ariaLevel
    }, [
      v("span", HM, j(e.label), 1),
      te(gt, {
        theme: "gradient-light",
        size: "sm",
        "badge-style": "circle",
        "text-only": "",
        value: e.count,
        "data-testid": "date-group-header-count"
      }, null, 8, ["value"])
    ], 10, NM));
  }
}), jM = ["role", "aria-label", "aria-hidden"], Pv = /* @__PURE__ */ ye({
  __name: "AvatarGroup",
  props: {
    avatars: {},
    size: { default: "md" },
    max: { default: 4 },
    ariaLabel: { default: void 0 },
    ringClass: { default: "ring-(--border-border-white-full)" }
  },
  setup(e) {
    const n = e, t = m(() => n.avatars.slice(0, n.max)), a = m(() => Math.max(n.avatars.length - n.max, 0)), l = m(() => (n.ariaLabel ?? "").trim().length > 0), r = {
      sm: { item: "-ml-2 first:ml-0 ring-1", bubble: "h-6 w-6 text-(length:--size-2xs)" },
      md: { item: "-ml-3.5 first:ml-0 ring-2", bubble: "h-9 w-9 text-(length:--size-sm)" },
      lg: { item: "-ml-4 first:ml-0 ring-2", bubble: "h-11 w-11 text-(length:--size-m)" }
    };
    return (o, i) => (c(), g("div", {
      class: "flex items-center",
      role: l.value ? "img" : void 0,
      "aria-label": l.value ? e.ariaLabel : void 0,
      "aria-hidden": l.value ? void 0 : "true",
      "data-testid": "avatar-group"
    }, [
      (c(!0), g(de, null, Re(t.value, (s, d) => (c(), W(Nt, {
        key: d,
        name: s.name,
        img: s.img,
        size: e.size,
        "avatar-style": "circle",
        presentational: !0,
        class: C([e.ringClass, r[e.size].item]),
        "data-testid": "avatar-group-avatar",
        "aria-hidden": "true"
      }, null, 8, ["name", "img", "size", "class"]))), 128)),
      a.value > 0 ? (c(), g("span", {
        key: 0,
        class: C(["flex shrink-0 items-center justify-center rounded-full bg-(--colors-indigo-100) font-(--weight-medium) text-(--icons-icon-dark-default)", [e.ringClass, r[e.size].item, r[e.size].bubble]]),
        "data-testid": "avatar-group-overflow",
        "aria-hidden": "true"
      }, "+" + j(a.value), 3)) : w("", !0)
    ], 8, jM));
  }
}), WM = { class: "flex grow shrink basis-64 min-w-0 flex-wrap items-center gap-5" }, qM = {
  class: "flex grow shrink basis-64 min-w-0 flex-col gap-1",
  "data-testid": "list-item-interaction-content"
}, UM = {
  class: "flex items-center gap-2",
  "data-testid": "list-item-interaction-header"
}, GM = {
  key: 0,
  class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body)",
  "data-testid": "list-item-interaction-date-time"
}, KM = {
  class: "flex min-w-0 flex-col gap-1.5",
  "data-testid": "list-item-interaction-body"
}, YM = {
  key: 0,
  class: "w-full min-w-0 wrap-break-word text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body)",
  "data-testid": "list-item-subtitle"
}, JM = {
  key: 1,
  class: "flex flex-col gap-1 rounded-(--border-border-radius-rounded-sm) border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft) px-4 py-3 text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-body)",
  "data-testid": "list-item-call-summary"
}, XM = {
  key: 0,
  class: "flex items-center gap-1.5"
}, ZM = {
  class: "font-(--weight-medium)",
  "data-testid": "list-item-call-duration"
}, QM = {
  key: 1,
  class: "wrap-break-word font-(--weight-regular)",
  "data-testid": "list-item-call-summary-text"
}, _M = {
  key: 2,
  class: "text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-body)",
  "data-testid": "list-item-interaction-meta"
}, eD = {
  key: 3,
  class: "flex items-center gap-1",
  "data-testid": "list-item-person"
}, tD = {
  class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body)",
  "data-testid": "list-item-person-name"
}, nD = {
  class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body)",
  "data-testid": "list-item-attachment-label"
}, aD = {
  key: 0,
  class: "ml-auto flex max-w-full shrink-0 flex-wrap items-center justify-end gap-3",
  "data-testid": "list-item-trailing-actions"
}, pq = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "InteractionListItem",
  props: {
    label: {},
    subtitle: { default: void 0 },
    cancelled: { type: Boolean, default: !1 },
    kind: { default: void 0 },
    typeLabel: { default: "" },
    date: { default: void 0 },
    time: { default: void 0 },
    dotTheme: { default: "green" },
    people: { default: void 0 },
    peopleLabel: { default: void 0 },
    attachmentLabel: { default: void 0 },
    durationLabel: { default: void 0 },
    summary: { default: void 0 },
    summaryBadgeLabel: { default: void 0 }
  },
  setup(e) {
    const n = {
      call: "ri-phone-fill",
      email: "ri-mail-line",
      "face-to-face": "ri-user-line",
      event: "ri-group-2-line",
      meeting: "ri-calendar-2-line"
    }, t = e, a = tn(), l = {
      green: "green",
      active: "active",
      red: "red",
      disabled: "neutral",
      orange: "orange",
      dark: "dark"
    }, r = m(() => l[t.dotTheme]), o = m(
      () => t.cancelled ? "text-(--text-text-disabled-strong) line-through" : "text-(--text-text-heading)"
    ), i = m(() => [t.date, t.time].filter(Boolean).join(" · ")), s = m(() => t.kind ? n[t.kind] : void 0);
    return $e(
      () => {
        var d;
        return [((d = t.people) == null ? void 0 : d.length) ?? 0, t.peopleLabel];
      },
      ([d, u]) => {
        d > 0 && !(u != null && u.trim()) && console.warn(
          "[InteractionListItem] `people` is set without `peopleLabel` — the avatar group has no accessible name for assistive tech (WCAG 1.1.1). Pass a pre-formatted `peopleLabel`."
        );
      },
      { immediate: !0 }
    ), (d, u) => {
      var f;
      return c(), g("div", Fe({
        class: "flex w-full min-w-64 flex-wrap items-start gap-4",
        "data-testid": "list-item-interaction-row"
      }, d.$attrs), [
        s.value ? (c(), W(Gt, {
          key: 0,
          size: "md",
          type: "square",
          variant: "outlined",
          color: e.cancelled ? "disabled" : "default",
          icon: s.value,
          class: "shrink-0"
        }, null, 8, ["color", "icon"])) : w("", !0),
        v("div", WM, [
          v("div", qM, [
            v("div", UM, [
              te(gt, {
                type: "with-dot",
                theme: r.value,
                label: e.typeLabel,
                size: "lg",
                "data-testid": "list-item-interaction-type-label"
              }, null, 8, ["theme", "label"]),
              Ae(d.$slots, "header-badges"),
              i.value ? (c(), g("span", GM, j(i.value), 1)) : w("", !0)
            ]),
            v("div", KM, [
              v("p", {
                class: C(["w-full min-w-0 wrap-break-word text-(length:--size-l) leading-(--line-height-l) font-(--weight-bold)", o.value]),
                "data-testid": "list-item-title"
              }, j(e.label), 3),
              e.subtitle ? (c(), g("p", YM, j(e.subtitle), 1)) : w("", !0),
              e.durationLabel || e.summary || e.summaryBadgeLabel ? (c(), g("div", JM, [
                e.durationLabel || e.summaryBadgeLabel ? (c(), g("div", XM, [
                  e.durationLabel ? (c(), g(de, { key: 0 }, [
                    u[0] || (u[0] = v("i", {
                      class: "ri-timer-line shrink-0 leading-none",
                      "aria-hidden": "true"
                    }, null, -1)),
                    v("span", ZM, j(e.durationLabel), 1)
                  ], 64)) : w("", !0),
                  e.summaryBadgeLabel ? (c(), W(gt, {
                    key: 1,
                    label: e.summaryBadgeLabel,
                    theme: "purple",
                    size: "sm",
                    "show-left-icon": !1,
                    "show-close-icon": !1,
                    "data-testid": "list-item-call-summary-badge"
                  }, null, 8, ["label"])) : w("", !0)
                ])) : w("", !0),
                e.summary ? (c(), g("p", QM, j(e.summary), 1)) : w("", !0)
              ])) : w("", !0),
              L(a)("interaction-meta") ? (c(), g("div", _M, [
                Ae(d.$slots, "interaction-meta")
              ])) : w("", !0),
              (f = e.people) != null && f.length ? (c(), g("div", eD, [
                te(Pv, {
                  avatars: e.people,
                  "ring-class": "ring-(--background-background-white)",
                  size: "sm"
                }, null, 8, ["avatars"]),
                v("span", tD, j(e.peopleLabel), 1),
                e.attachmentLabel ? (c(), g(de, { key: 0 }, [
                  u[1] || (u[1] = v("span", {
                    class: "text-(length:--size-m) font-(--weight-medium) text-(--text-text-body)",
                    "aria-hidden": "true"
                  }, "·", -1)),
                  u[2] || (u[2] = v("i", {
                    class: "ri-attachment-2 shrink-0 text-(length:--size-sm) leading-none text-(--text-text-body)",
                    "aria-hidden": "true"
                  }, null, -1)),
                  v("span", nD, j(e.attachmentLabel), 1)
                ], 64)) : w("", !0)
              ])) : w("", !0)
            ])
          ]),
          L(a)("cta") || L(a)("actions") ? (c(), g("div", aD, [
            Ae(d.$slots, "cta"),
            Ae(d.$slots, "actions")
          ])) : w("", !0)
        ])
      ], 16);
    };
  }
}), lD = {
  class: "flex flex-1 min-w-0 flex-col gap-2 py-3.5 pl-6 @[calc(44rem-25px)]/meeting:flex-row @[calc(44rem-25px)]/meeting:items-center @[calc(44rem-25px)]/meeting:gap-0 @[calc(44rem-25px)]/meeting:py-0 @[calc(44rem-25px)]/meeting:pl-0",
  "data-testid": "list-item-content-row"
}, rD = {
  class: "flex min-w-0 flex-wrap items-center gap-x-3 gap-y-2 @[calc(44rem-25px)]/meeting:contents",
  "data-testid": "list-item-time-meta"
}, oD = { class: "flex items-center self-stretch shrink-0" }, iD = {
  key: 0,
  class: "flex items-center self-stretch shrink-0 overflow-hidden @[calc(44rem-25px)]/meeting:px-5 @[calc(44rem-25px)]/meeting:w-[185px]",
  "data-testid": "list-item-meta-badge"
}, sD = { class: "flex flex-1 min-w-0 flex-col gap-0.5 @[calc(44rem-25px)]/meeting:basis-64 @[calc(44rem-25px)]/meeting:px-6 @[calc(44rem-25px)]/meeting:py-3.5" }, dD = { class: "flex w-full min-w-0 items-start gap-1.5" }, uD = ["aria-label"], cD = { class: "flex flex-wrap items-center gap-x-2 gap-y-1 @[calc(44rem-25px)]/meeting:flex-col @[calc(44rem-25px)]/meeting:items-start @[calc(44rem-25px)]/meeting:gap-1 @[calc(50rem-25px)]/meeting:flex-row @[calc(50rem-25px)]/meeting:items-center @[calc(50rem-25px)]/meeting:gap-x-2" }, fD = {
  key: 1,
  class: "flex items-center gap-1.5",
  "data-testid": "list-item-person"
}, hD = {
  key: 0,
  class: "flex min-w-min flex-wrap items-center justify-end gap-x-4 gap-y-3 @[calc(44rem-25px)]/meeting:flex-col @[calc(44rem-25px)]/meeting:items-end @[calc(44rem-25px)]/meeting:gap-3 @[calc(50rem-25px)]/meeting:flex-row @[calc(50rem-25px)]/meeting:items-center @[calc(50rem-25px)]/meeting:gap-x-4",
  "data-testid": "list-item-trailing-actions"
}, bD = { class: "flex flex-1 min-w-0 flex-col gap-3 py-4" }, gD = { class: "flex flex-col gap-0.5 min-w-0" }, mD = { class: "flex items-center justify-between gap-2" }, pD = { class: "flex w-full min-w-0 items-start gap-1.5" }, vD = ["aria-label"], xD = {
  key: 1,
  class: "flex items-center gap-1.5",
  "data-testid": "list-item-person"
}, yD = {
  key: 1,
  class: "flex items-start gap-3",
  "data-testid": "list-item-cta"
}, vq = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "MeetingListItem",
  props: {
    layout: {},
    label: {},
    subtitle: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    border: { type: Boolean, default: !0 },
    time: { default: void 0 },
    statusTheme: { default: "green" },
    statusLabel: { default: "" },
    struckThrough: { type: Boolean, default: !1 },
    metaBadge: { default: void 0 },
    personName: { default: void 0 },
    personAvatarUrl: { default: void 0 },
    date: { default: void 0 },
    urgencyLabel: { default: void 0 },
    titleIcon: { default: void 0 }
  },
  setup(e) {
    const n = e, t = tn(), a = {
      long: { padding: "pl-0 pr-[calc(--spacing(6)-1px)] py-0", gap: "gap-6", minHeight: "min-h-[100px]" },
      short: { padding: "pl-0 pr-[calc(--spacing(4)-1px)] py-0", gap: "gap-4" }
    }, l = Ov(() => {
      const f = a[n.layout];
      return {
        padding: f.padding,
        gap: f.gap,
        minHeight: f.minHeight,
        disabled: n.disabled,
        border: n.border,
        // Only Long queries its own width; Short keeps its content-based width.
        alwaysClasses: `overflow-hidden min-w-64 ${n.layout === "long" ? "@container/meeting" : ""}`,
        restingClasses: "shadow-(--blur-shadow-s)"
      };
    }), r = m(
      () => n.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-heading)"
    ), o = {
      green: "green",
      active: "active",
      red: "red",
      disabled: "neutral",
      orange: "orange"
    }, i = {
      green: "bg-(--components-badge-background-badge-green-strong-bg)",
      active: "bg-(--components-badge-background-badge-indigo-strong-bg)",
      red: "bg-(--components-badge-background-badge-error-strong-bg)",
      disabled: "bg-(--components-badge-background-badge-neutral-strong-bg)",
      orange: "bg-(--components-badge-background-badge-orange-strong-bg)"
    }, s = m(() => o[n.statusTheme]), d = m(() => i[n.statusTheme]), u = m(() => [n.date, n.time].filter(Boolean).join(" · "));
    return (f, b) => (c(), g("div", Fe(f.$attrs, { class: L(l) }), [
      e.layout === "long" ? (c(), g(de, { key: 0 }, [
        v("div", {
          class: C(["w-[5px] self-stretch shrink-0", d.value]),
          "aria-hidden": "true",
          "data-testid": "list-item-accent-bar"
        }, null, 2),
        v("div", lD, [
          v("div", rD, [
            v("div", oD, [
              v("p", {
                class: C(["whitespace-nowrap text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold)", r.value]),
                "data-testid": "list-item-time"
              }, j(e.time), 3)
            ]),
            e.metaBadge ? (c(), g("div", iD, [
              te(gt, {
                label: e.metaBadge.label,
                theme: e.metaBadge.theme ?? "cyan",
                size: "sm",
                truncate: "",
                "show-left-icon": !1,
                "show-close-icon": !1
              }, null, 8, ["label", "theme"])
            ])) : w("", !0)
          ]),
          v("div", sD, [
            te(gt, {
              type: "with-dot",
              theme: s.value,
              label: e.statusLabel,
              size: "sm",
              class: "self-start",
              "data-testid": "list-item-status-badge"
            }, null, 8, ["theme", "label"]),
            v("div", dD, [
              e.titleIcon ? (c(), g("i", {
                key: 0,
                class: C([[e.titleIcon.icon, r.value], "shrink-0 text-(length:--size-l) leading-(--line-height-xxl)"]),
                role: "img",
                "aria-label": e.titleIcon.label,
                "data-testid": "list-item-title-icon"
              }, null, 10, uD)) : w("", !0),
              te(pt, {
                text: e.label,
                lines: 2,
                "text-class": ["text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold)", r.value, e.struckThrough ? "line-through" : ""].join(" "),
                "data-testid": "list-item-title"
              }, null, 8, ["text", "text-class"])
            ]),
            v("div", cD, [
              e.subtitle ? (c(), g("p", {
                key: 0,
                class: C(["min-w-0 text-(length:--size-m) leading-(--line-height-l)", r.value]),
                "data-testid": "list-item-subtitle"
              }, j(e.subtitle), 3)) : w("", !0),
              e.personName ? (c(), g("div", fD, [
                te(Nt, {
                  name: e.personName,
                  img: e.personAvatarUrl,
                  size: "sm",
                  presentational: !0,
                  class: C({ "opacity-70": e.disabled })
                }, null, 8, ["name", "img", "class"]),
                v("span", {
                  class: C(["text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)", r.value])
                }, j(e.personName), 3)
              ])) : w("", !0)
            ])
          ]),
          L(t)("cta") || L(t)("actions") ? (c(), g("div", hD, [
            Ae(f.$slots, "cta"),
            Ae(f.$slots, "actions")
          ])) : w("", !0)
        ])
      ], 64)) : (c(), g(de, { key: 1 }, [
        v("div", {
          class: C(["w-[5px] self-stretch shrink-0", d.value]),
          "aria-hidden": "true",
          "data-testid": "list-item-accent-bar"
        }, null, 2),
        v("div", bD, [
          v("div", gD, [
            v("div", mD, [
              v("p", {
                class: C(["whitespace-nowrap text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold)", r.value]),
                "data-testid": "list-item-date-time"
              }, j(u.value), 3),
              te(gt, {
                type: "with-dot",
                theme: s.value,
                label: e.statusLabel,
                size: "sm",
                "data-testid": "list-item-status-badge"
              }, null, 8, ["theme", "label"])
            ]),
            v("div", pD, [
              e.titleIcon ? (c(), g("i", {
                key: 0,
                class: C([[e.titleIcon.icon, r.value], "shrink-0 text-(length:--size-l) leading-(--line-height-xxl)"]),
                role: "img",
                "aria-label": e.titleIcon.label,
                "data-testid": "list-item-title-icon"
              }, null, 10, vD)) : w("", !0),
              v("p", {
                class: C(["w-full min-w-0 break-words text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold)", [r.value, e.struckThrough ? "line-through" : ""]]),
                "data-testid": "list-item-title"
              }, j(e.label), 3)
            ]),
            e.subtitle ? (c(), g("p", {
              key: 0,
              class: C(["w-full min-w-0 break-words text-(length:--size-m) leading-(--line-height-l)", r.value]),
              "data-testid": "list-item-subtitle"
            }, j(e.subtitle), 3)) : w("", !0),
            e.personName ? (c(), g("div", xD, [
              te(Nt, {
                name: e.personName,
                img: e.personAvatarUrl,
                size: "sm",
                presentational: !0,
                class: C({ "opacity-70": e.disabled })
              }, null, 8, ["name", "img", "class"]),
              v("span", {
                class: C(["text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)", r.value])
              }, j(e.personName), 3)
            ])) : w("", !0)
          ]),
          e.urgencyLabel ? (c(), W(gt, {
            key: 0,
            theme: "red",
            size: "xs",
            label: e.urgencyLabel,
            "show-close-icon": !1,
            "data-testid": "list-item-urgency-badge",
            "left-icon": "ri-alert-line"
          }, null, 8, ["label"])) : w("", !0),
          L(t)("cta") ? (c(), g("div", yD, [
            Ae(f.$slots, "cta")
          ])) : w("", !0)
        ])
      ], 64))
    ], 16));
  }
}), kD = {
  class: "flex min-w-0 flex-col gap-3",
  "data-testid": "list-item-accordion"
}, wD = { class: "border-b border-solid border-(--border-border-base-soft) pb-3" }, CD = ["aria-expanded", "aria-controls"], SD = { class: "flex min-w-0 flex-1 items-center gap-1.5" }, $D = { class: "flex shrink-0 items-center gap-1.5" }, ID = {
  class: "flex size-8 items-center justify-center",
  "aria-hidden": "true"
}, LD = ["id", "hidden"], xq = /* @__PURE__ */ ye({
  __name: "ListItemAccordion",
  props: /* @__PURE__ */ Ad({
    title: {},
    icon: { default: void 0 },
    count: { default: void 0 }
  }, {
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: ["update:open"],
  setup(e) {
    const n = Jb(e, "open"), t = qe(), a = R(null), l = R(!1), r = R(!1), o = m(() => r.value ? !1 : l.value ? !0 : void 0);
    function i(u) {
      try {
        l.value = u.target.matches(":focus-visible");
      } catch {
        l.value = !0;
      }
    }
    function s() {
      l.value = !1, r.value = !1;
    }
    function d(u) {
      var f;
      u.key !== "Escape" || r.value || !l.value || !((f = a.value) != null && f.isTruncated) || (u.stopPropagation(), u.preventDefault(), r.value = !0);
    }
    return (u, f) => (c(), g("div", kD, [
      v("div", wD, [
        v("button", {
          type: "button",
          class: "flex h-8 w-full min-w-0 cursor-pointer items-center justify-between gap-1.5 rounded-(--border-border-radius-rounded-xs) border-0 bg-transparent p-0 text-left focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-(--border-border-accent)",
          "aria-expanded": n.value,
          "aria-controls": L(t),
          "data-testid": "list-item-accordion-header",
          onClick: f[0] || (f[0] = (b) => n.value = !n.value),
          onFocus: i,
          onBlur: s,
          onKeydown: d
        }, [
          v("span", SD, [
            e.icon ? (c(), g("i", {
              key: 0,
              class: C([e.icon, "shrink-0 text-(length:--icon-size-sm) text-(--icons-icon-dark-default)"]),
              "aria-hidden": "true",
              "data-testid": "list-item-accordion-icon"
            }, null, 2)) : w("", !0),
            te(pt, {
              ref_key: "titleRef",
              ref: a,
              as: "span",
              class: "min-w-0",
              text: e.title,
              focusable: !1,
              open: o.value,
              "text-class": "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading)",
              "data-testid": "list-item-accordion-title"
            }, null, 8, ["text", "open"])
          ]),
          v("span", $D, [
            e.count !== void 0 ? (c(), W(gt, {
              key: 0,
              label: String(e.count),
              theme: "gradient-light",
              size: "lg",
              "badge-style": "circle",
              "text-only": "",
              "data-testid": "list-item-accordion-count"
            }, null, 8, ["label"])) : w("", !0),
            v("span", ID, [
              v("i", {
                class: C([n.value ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line", "text-(length:--icon-size-sm) text-(--icons-icon-dark-default)"]),
                "data-testid": "list-item-accordion-chevron"
              }, null, 2)
            ])
          ])
        ], 40, CD)
      ]),
      v("ul", {
        id: L(t),
        role: "list",
        class: "m-0 list-none flex-col gap-3 p-0 [&:not([hidden])]:flex",
        hidden: !n.value,
        "data-testid": "list-item-accordion-body"
      }, [
        Ae(u.$slots, "default")
      ], 8, LD)
    ]));
  }
}), TD = {
  class: "m-0 min-w-0 list-none border-b border-solid border-(--border-border-base-soft) pb-3",
  "data-testid": "list-item-accordion-row"
}, AD = { class: "flex min-w-0 flex-1 items-center gap-1.5" }, yq = /* @__PURE__ */ ye({
  __name: "ListItemAccordionRow",
  props: {
    label: {},
    value: { default: void 0 },
    variant: { default: "default" },
    icon: { default: void 0 }
  },
  setup(e) {
    const n = e, t = {
      default: {
        row: "min-h-5 pl-6",
        label: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body)",
        value: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default)",
        icon: ""
      },
      header: {
        row: "min-h-5",
        label: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-body)",
        value: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default)",
        icon: "size-(--icon-size-sm) text-(length:--icon-size-sm) leading-(--icon-size-sm)"
      },
      title: {
        row: "min-h-6",
        label: "text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold) text-(--text-text-body)",
        value: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold) text-(--text-text-black-default)",
        icon: "size-(--icon-size-md) text-(length:--icon-size-md) leading-(--icon-size-md)"
      }
    };
    return (a, l) => (c(), g("li", TD, [
      v("div", {
        class: C(["flex min-w-0 items-center justify-between gap-1.5", t[n.variant].row])
      }, [
        v("div", AD, [
          e.icon && e.variant !== "default" ? (c(), g("i", {
            key: 0,
            class: C([e.icon, t[n.variant].icon, "inline-flex shrink-0 items-center justify-center text-(--icons-icon-dark-default)"]),
            "aria-hidden": "true",
            "data-testid": "list-item-accordion-row-icon"
          }, null, 2)) : w("", !0),
          te(pt, {
            class: "min-w-0",
            text: e.label,
            "text-class": t[n.variant].label,
            "data-testid": "list-item-accordion-row-label"
          }, null, 8, ["text", "text-class"])
        ]),
        e.value !== void 0 ? (c(), g("span", {
          key: 0,
          class: C(["shrink-0", t[n.variant].value]),
          "data-testid": "list-item-accordion-row-value"
        }, j(e.value), 3)) : w("", !0)
      ], 2)
    ]));
  }
}), ED = fM, RD = { class: "flex w-full min-w-0 items-start gap-2" }, BD = {
  "data-testid": "alert-icon-column",
  class: "flex items-start py-1 shrink-0"
}, MD = {
  "data-testid": "alert-text-column",
  class: "flex min-w-0 flex-1 flex-col"
}, DD = { class: "flex min-w-0 items-center gap-2" }, zD = { class: "flex min-w-0 flex-1 flex-col gap-2" }, OD = {
  key: 0,
  "data-testid": "alert-heading",
  class: "wrap-break-word text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)"
}, PD = {
  key: 1,
  "data-testid": "alert-message",
  class: "wrap-break-word text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)"
}, FD = { class: "accordion-content-inner" }, VD = { class: "min-w-0 pt-2" }, ND = /* @__PURE__ */ ye({
  __name: "AlertDuplicatesList",
  props: {
    duplicates: {},
    heading: {},
    message: {},
    icon: {},
    iconTint: {},
    listBorderClass: {},
    listDividerVar: {},
    open: { type: Boolean },
    defaultOpen: { type: Boolean },
    labels: {}
  },
  emits: ["update:open", "remove"],
  setup(e, { emit: n }) {
    const t = e, a = n, { isOpen: l, toggle: r, triggerProps: o, panelProps: i, panelClasses: s, onTransitionEnd: d } = Qb({
      open: () => t.open,
      defaultOpen: () => t.defaultOpen,
      onOpenChange: ($) => a("update:open", $)
    }), u = R(null), f = R(null), b = /* @__PURE__ */ new Map();
    function h($, S) {
      S ? b.set($, S) : b.delete($);
    }
    const p = m(() => t.labels.toggleButton ?? (t.heading || t.message || "Show duplicates"));
    function x($) {
      var T, I;
      const S = $.helperText ? `${$.label}, ${$.helperText}` : $.label;
      return ((I = (T = t.labels).removeDuplicate) == null ? void 0 : I.call(T, $)) ?? `Remove ${S}`;
    }
    $e(l, ($) => {
      var S, T;
      !$ && ((S = f.value) != null && S.contains(document.activeElement)) && ((T = u.value) == null || T.$el.focus());
    });
    let y = null;
    function k($, S) {
      y = { id: $.id, index: S }, a("remove", $);
    }
    return $e(
      () => t.duplicates.map(($) => $.id),
      async ($, S) => {
        var z;
        const T = y;
        if (!T) return;
        const I = !$.includes(T.id);
        if (!I && $.length >= S.length || (y = null, !I)) return;
        await Ge();
        const A = document.activeElement;
        if (A && A !== document.body && A.isConnected) return;
        const E = $[Math.min(T.index, $.length - 1)], D = E !== void 0 ? b.get(E) : void 0;
        D != null && D.focusAction("secondary") || (z = u.value) == null || z.$el.focus();
      }
    ), ($, S) => (c(), g("div", RD, [
      v("div", BD, [
        v("i", {
          class: C([[e.icon, e.iconTint], "inline-flex items-center justify-center size-(--icon-size-sm) text-(length:--size-l)"]),
          "aria-hidden": "true"
        }, null, 2)
      ]),
      v("div", MD, [
        v("div", DD, [
          v("div", zD, [
            e.heading ? (c(), g("p", OD, j(e.heading), 1)) : w("", !0),
            e.message ? (c(), g("p", PD, j(e.message), 1)) : w("", !0)
          ]),
          te(L(Me), Fe({
            ref_key: "toggleRef",
            ref: u
          }, L(o), {
            "data-testid": "alert-duplicates-toggle",
            variant: "tertiary",
            size: "md",
            "icon-only": "",
            "icon-left": L(l) ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line",
            "aria-label": p.value,
            class: "shrink-0",
            onClick: L(r)
          }), null, 16, ["icon-left", "aria-label", "onClick"])
        ]),
        v("div", Fe({
          ref_key: "panelRef",
          ref: f
        }, L(i), {
          class: L(s),
          "data-testid": "alert-duplicates-panel",
          onTransitionend: S[0] || (S[0] = //@ts-ignore
          (...T) => L(d) && L(d)(...T))
        }), [
          v("div", FD, [
            v("div", VD, [
              v("div", {
                "data-testid": "alert-duplicates-list",
                class: C(["min-w-0 border-y-(length:--border-border-width-border) border-solid py-3", e.listBorderClass])
              }, [
                te(L(hM), {
                  divider: "",
                  "divider-color": `var(${e.listDividerVar})`
                }, {
                  default: ve(() => [
                    (c(!0), g(de, null, Re(e.duplicates, (T, I) => (c(), W(L(ED), {
                      key: T.id,
                      ref_for: !0,
                      ref: (A) => h(T.id, A),
                      type: "avatar-text-badge",
                      label: T.label,
                      "helper-text": T.helperText,
                      "label-badge": T.badge ? { label: T.badge, theme: "orange" } : void 0,
                      "secondary-action": {
                        label: x(T),
                        icon: "ri-delete-bin-line",
                        testId: "alert-duplicate-remove",
                        onClick: () => k(T, I)
                      }
                    }, null, 8, ["label", "helper-text", "label-badge", "secondary-action"]))), 128))
                  ]),
                  _: 1
                }, 8, ["divider-color"])
              ], 2)
            ])
          ])
        ], 16)
      ])
    ]));
  }
}), HD = { class: "flex w-full min-w-0 items-start gap-2" }, jD = {
  "data-testid": "alert-icon-column",
  class: "flex items-start py-1 shrink-0"
}, WD = {
  "data-testid": "alert-text-column",
  class: "flex min-w-0 flex-1 flex-col gap-2"
}, qD = {
  "data-testid": "alert-heading",
  class: "wrap-break-word text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)"
}, UD = {
  key: 0,
  "data-testid": "alert-message",
  class: "wrap-break-word text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)"
}, GD = {
  key: 1,
  "data-testid": "alert-error-links",
  class: "flex flex-col gap-1"
}, KD = /* @__PURE__ */ ye({
  __name: "AlertErrorSummary",
  props: {
    errors: {},
    message: {},
    showLinks: { type: Boolean },
    icon: {},
    iconTint: {},
    labels: {}
  },
  setup(e) {
    const n = e, t = m(() => {
      var r, o;
      const l = n.errors.length;
      return ((o = (r = n.labels).errorSummaryHeading) == null ? void 0 : o.call(r, l)) ?? (l === 1 ? "1 error" : `${l} errors`);
    });
    function a(l, r) {
      const o = document.getElementById(r);
      o && (l.preventDefault(), o.scrollIntoView({ block: "center" }), o.focus({ preventScroll: !0 }));
    }
    return (l, r) => (c(), g("div", HD, [
      v("div", jD, [
        v("i", {
          class: C([[e.icon, e.iconTint], "inline-flex items-center justify-center size-(--icon-size-sm) text-(length:--size-l)"]),
          "aria-hidden": "true"
        }, null, 2)
      ]),
      v("div", WD, [
        v("h2", qD, j(t.value), 1),
        e.message ? (c(), g("p", UD, j(e.message), 1)) : w("", !0),
        e.showLinks ? (c(), g("ul", GD, [
          (c(!0), g(de, null, Re(e.errors, (o) => (c(), g("li", {
            key: o.fieldId
          }, [
            te(L(Mn), {
              as: "a",
              href: `#${o.fieldId}`,
              onClick: (i) => a(i, o.fieldId)
            }, {
              default: ve(() => [
                nt(j(o.message), 1)
              ]),
              _: 2
            }, 1032, ["href", "onClick"])
          ]))), 128))
        ])) : w("", !0)
      ])
    ]));
  }
}), YD = {
  "data-testid": "alert-pill-link",
  class: "flex min-w-0 flex-1 items-center gap-0.5"
}, JD = {
  key: 4,
  "data-testid": "alert-inline-row",
  class: "flex w-full items-start gap-2"
}, XD = { class: "flex-1 flex flex-col gap-3" }, ZD = {
  "data-testid": "alert-text-group",
  class: "flex flex-col gap-1"
}, QD = {
  key: 5,
  "data-testid": "alert-compact-row",
  class: "flex w-full items-start gap-2"
}, _D = { class: "flex-1 flex flex-col gap-2" }, ez = { class: "flex flex-col gap-1" }, tz = {
  key: 1,
  class: "flex items-center gap-1"
}, nz = {
  key: 0,
  "data-testid": "alert-actions",
  class: "flex items-center gap-4"
}, az = {
  key: 1,
  "data-testid": "alert-actions",
  class: "flex items-center gap-4"
}, lz = {
  key: 2,
  "data-testid": "alert-right-column",
  class: "flex flex-col items-end justify-center gap-2 shrink-0"
}, hb = "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)", rz = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)", bb = "text-(length:--size-xs) leading-(--line-height-xs) font-(--weight-regular)", _l = /* @__PURE__ */ ye({
  __name: "Alert",
  props: /* @__PURE__ */ Ad({
    color: { default: "success" },
    surface: { default: "card" },
    layout: { default: "inline" },
    heading: { default: void 0 },
    message: { default: "" },
    closable: { type: Boolean, default: !1 },
    percentage: { default: void 0 },
    buttons: { default: () => [] },
    buttonsPosition: { default: "bottom" },
    compact: { type: Boolean, default: !1 },
    href: { default: void 0 },
    optionalIcon: { default: void 0 },
    checkbox: { default: void 0 },
    duplicates: { default: void 0 },
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean, default: !1 },
    errors: { default: void 0 },
    labels: { default: () => ({}) }
  }, {
    checked: { type: Boolean, default: !1 },
    checkedModifiers: {}
  }),
  emits: /* @__PURE__ */ Ad(["close", "navigate", "update:open", "remove"], ["update:checked"]),
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = Jb(e, "checked"), o = R(!1), i = {
      success: {
        bg: "bg-(--background-background-success)",
        borderClass: "border-(--border-border-success)",
        borderTopClass: "border-(--border-border-success)",
        pillHoverBorderClass: "hover:border-(--background-background-success)",
        icon: "ri-checkbox-circle-line",
        iconTint: "text-(--icons-icon-success)",
        badgeTheme: "green",
        listBorderClass: "border-(--border-border-success-sublte)",
        listDividerVar: "--border-border-success-sublte"
      },
      danger: {
        bg: "bg-(--background-background-error)",
        borderClass: "border-(--border-border-error-subtle)",
        borderTopClass: "border-(--border-border-error-strong)",
        pillHoverBorderClass: "hover:border-(--background-background-error)",
        icon: "ri-alert-line",
        iconTint: "text-(--icons-icon-error)",
        badgeTheme: "red",
        listBorderClass: "border-(--border-border-error-strong)",
        listDividerVar: "--border-border-error-strong"
      },
      warning: {
        bg: "bg-(--background-background-warning)",
        borderClass: "border-(--border-border-warning-subtle)",
        borderTopClass: "border-(--border-border-warning)",
        pillHoverBorderClass: "hover:border-(--background-background-warning)",
        icon: "ri-alert-line",
        iconTint: "text-(--icons-icon-warning)",
        badgeTheme: "orange",
        listBorderClass: "border-(--border-border-warning)",
        listDividerVar: "--border-border-warning"
      },
      info: {
        bg: "bg-(--background-background-info)",
        borderClass: "border-(--border-border-info-subtle)",
        borderTopClass: "border-(--border-border-info-subtle)",
        pillHoverBorderClass: "hover:border-(--background-background-info)",
        icon: "ri-information-line",
        iconTint: "text-(--icons-icon-info)",
        badgeTheme: "indigo",
        listBorderClass: "border-(--border-border-info-strong)",
        listDividerVar: "--border-border-info-strong"
      },
      default: {
        bg: "bg-(--background-background-white)",
        borderClass: "border-(--border-border-base-medium)",
        borderTopClass: "border-(--border-border-base-medium)",
        pillHoverBorderClass: "hover:border-(--background-background-white)",
        icon: "ri-information-line",
        iconTint: "text-(--icons-icon-dark-default)",
        badgeTheme: "neutral",
        listBorderClass: "border-(--border-border-base)",
        listDividerVar: "--border-border-base"
      },
      ia: {
        bg: "bg-(--background-background-ia)",
        borderClass: "border-(--border-border-ia)",
        borderTopClass: "border-(--colors-border-ia-strong)",
        pillHoverBorderClass: "hover:border-(--background-background-ia)",
        icon: "ri-magic-line",
        iconTint: "text-(--icons-icon-ia)",
        badgeTheme: "purple",
        listBorderClass: "border-(--border-border-ia)",
        listDividerVar: "--border-border-ia"
      }
    }, s = m(() => {
      var M;
      return i[(M = a.errors) != null && M.length ? "danger" : a.color];
    }), d = m(() => s.value.badgeTheme), u = m(
      () => a.color === "danger" ? { role: "alert", ariaLive: "assertive", ariaAtomic: "true" } : { role: "status", ariaLive: "polite", ariaAtomic: void 0 }
    ), f = m(() => a.surface === "pill"), b = m(() => {
      var M;
      return (((M = a.errors) == null ? void 0 : M.length) ?? 0) > 10;
    }), h = m(() => f.value ? a.href ? "a" : "button" : "div"), p = m(() => {
      var M;
      return f.value ? a.href ? { href: a.href } : { type: "button" } : a.duplicates ? {} : (M = a.errors) != null && M.length ? { tabindex: -1, role: "group" } : {
        role: u.value.role,
        "aria-live": u.value.ariaLive,
        "aria-atomic": u.value.ariaAtomic
      };
    }), x = m(() => a.surface === "pill" ? "rounded-(--border-border-radius-rounded-full) border-(length:--border-border-width-border) border-solid flex-row items-center gap-2 py-[calc(--spacing(1)-1px)] pr-[calc(--spacing(2)-1px)] pl-[calc(--spacing(1)-1px)] w-full" : a.surface === "borderTop" ? "rounded-none border-t-(length:--border-border-width-border-lg) border-solid flex-col items-start gap-4 px-4 pb-4 pt-[calc(--spacing(4)-4px)] w-full" : "rounded-(--border-border-radius-rounded-l) border-(length:--border-border-width-border) border-solid flex-col items-start gap-4 p-[calc(--spacing(4)-1px)] w-full"), y = m(() => [
      b.value ? "sticky top-0 z-10 max-h-[40vh] overflow-y-auto" : "relative",
      "box-border flex min-w-64 text-left font-inter transition-all duration-300",
      s.value.bg,
      a.surface === "borderTop" ? s.value.borderTopClass : s.value.borderClass,
      "text-(--text-text-heading)",
      x.value,
      f.value ? ["cursor-pointer", "transition-colors", s.value.pillHoverBorderClass] : ""
    ]), k = m(() => a.percentage !== void 0 || a.layout === "stacked" && a.buttonsPosition === "bottom" ? "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)" : "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)"), $ = m(() => !!a.heading && a.surface !== "borderTop"), S = m(
      () => a.surface === "borderTop" ? "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)" : hb
    ), T = m(
      () => a.closable && a.percentage === void 0 && !f.value && !a.compact
    ), I = m(
      () => a.buttonsPosition === "right" && (T.value || a.buttons.length > 0)
    ), A = m(
      () => a.buttonsPosition === "right" && (!a.message || a.buttons.length > 0 && a.buttons.every((M) => M.variant === "tertiary"))
    ), E = m(
      () => !!a.checkbox && !f.value && !a.compact && !a.heading && !a.message
    ), D = m(() => a.percentage !== void 0), z = m(() => {
      var M;
      return ((M = a.labels) == null ? void 0 : M.closeButton) ?? "Dismiss alert";
    });
    function Y() {
      o.value = !0, l("close");
    }
    function le() {
      l("navigate");
    }
    function ne(M) {
      var B;
      (B = M.onClick) == null || B.call(M);
    }
    function re(M) {
      return {
        as: M.href ? "a" : "button",
        href: M.href,
        ariaLabel: M.ariaLabel,
        iconLeft: M.iconPosition !== "right" ? M.icon : void 0,
        iconRight: M.iconPosition === "right" ? M.icon : void 0,
        size: "s",
        onClick: () => ne(M)
      };
    }
    function O(M) {
      return {
        label: M.label,
        variant: M.variant ?? (a.buttonsPosition === "right" ? "primary" : "secondary"),
        as: M.href ? "a" : "button",
        href: M.href,
        // Passed as a literal HTML attribute key, not a declared Button prop —
        // Button.vue never declares `ariaLabel`, so this lands in Button's
        // $attrs and Vue's default attrs inheritance forwards it straight to
        // the root <button>/<a> element, overriding nothing else. Declaring a
        // real `ariaLabel` prop on Button.vue would close the automatic $attrs
        // fallthrough for that attribute name for every consumer in the
        // monorepo (many icon-only Button call sites rely on a raw, undeclared
        // :aria-label falling through) — see Refs: #OP-5881 fix commit.
        "aria-label": M.ariaLabel,
        iconLeft: M.iconPosition !== "right" ? M.icon : void 0,
        iconRight: M.iconPosition === "right" ? M.icon : void 0,
        size: "xs",
        loading: M.loading,
        onClick: () => ne(M)
      };
    }
    const P = R(null);
    n({
      /** Moves focus to the Alert; only the error summary (`errors`) can take it. */
      focus: () => {
        var M;
        return (M = P.value) == null ? void 0 : M.focus();
      }
    });
    function V() {
      f.value && !a.href && le();
    }
    return (M, B) => o.value ? w("", !0) : (c(), W(it(h.value), Fe({
      key: 0,
      ref_key: "rootRef",
      ref: P
    }, p.value, { class: y.value }, Nl(f.value ? { click: V } : {})), {
      default: ve(() => {
        var q;
        return [
          E.value && !M.$slots.body ? (c(), W(Bn, {
            key: 0,
            modelValue: r.value,
            "onUpdate:modelValue": B[0] || (B[0] = (N) => r.value = N),
            label: e.checkbox.label,
            "label-wrap": ""
          }, null, 8, ["modelValue", "label"])) : f.value ? (c(), g(de, { key: 1 }, [
            te(L(gt), {
              "data-testid": "alert-badge",
              label: e.heading,
              theme: d.value,
              size: "sm",
              "show-left-icon": !1,
              "show-close-icon": !1,
              class: "h-5! min-h-5! min-w-0! max-w-1/2 rounded-(--border-border-radius-rounded-full)! px-2! py-0! [&>span>span]:min-w-0 [&>span>span]:truncate"
            }, null, 8, ["label", "theme"]),
            v("span", YD, [
              e.message ? (c(), g("span", {
                key: 0,
                "data-testid": "alert-message",
                class: C([k.value, "min-w-0 truncate"])
              }, j(e.message), 3)) : w("", !0),
              B[5] || (B[5] = v("i", {
                class: "ri-arrow-right-line inline-flex items-center justify-center size-(--icon-size-sm) text-(length:--size-l) shrink-0",
                "aria-hidden": "true"
              }, null, -1))
            ])
          ], 64)) : e.duplicates ? (c(), W(ND, {
            key: 2,
            duplicates: e.duplicates,
            heading: e.heading,
            message: e.message,
            icon: s.value.icon,
            "icon-tint": s.value.iconTint,
            "list-border-class": s.value.listBorderClass,
            "list-divider-var": s.value.listDividerVar,
            open: e.open,
            "default-open": e.defaultOpen,
            labels: e.labels,
            "onUpdate:open": B[1] || (B[1] = (N) => l("update:open", N)),
            onRemove: B[2] || (B[2] = (N) => l("remove", N))
          }, null, 8, ["duplicates", "heading", "message", "icon", "icon-tint", "list-border-class", "list-divider-var", "open", "default-open", "labels"])) : (q = e.errors) != null && q.length ? (c(), W(KD, {
            key: 3,
            errors: e.errors,
            message: e.message,
            "show-links": b.value,
            icon: s.value.icon,
            "icon-tint": s.value.iconTint,
            labels: e.labels
          }, null, 8, ["errors", "message", "show-links", "icon", "icon-tint", "labels"])) : e.layout === "inline" ? (c(), g("div", JD, [
            v("div", {
              "data-testid": "alert-icon-column",
              class: C(["flex items-center shrink-0", $.value ? "py-1" : "py-0.5"])
            }, [
              v("i", {
                class: C([[s.value.icon, s.value.iconTint], "inline-flex items-center justify-center size-(--icon-size-sm) text-(length:--size-l)"]),
                "aria-hidden": "true"
              }, null, 2)
            ], 2),
            v("div", XD, [
              v("div", ZD, [
                e.heading ? (c(), g("p", {
                  key: 0,
                  "data-testid": "alert-heading",
                  class: C(S.value)
                }, j(e.heading), 3)) : w("", !0),
                e.message ? (c(), g("p", {
                  key: 1,
                  "data-testid": "alert-message",
                  class: C(k.value)
                }, j(e.message), 3)) : w("", !0)
              ]),
              e.checkbox ? (c(), W(Bn, {
                key: 0,
                modelValue: r.value,
                "onUpdate:modelValue": B[3] || (B[3] = (N) => r.value = N),
                label: e.checkbox.label,
                "label-wrap": ""
              }, null, 8, ["modelValue", "label"])) : w("", !0)
            ]),
            T.value ? (c(), W(L(Me), {
              key: 0,
              variant: "text",
              "icon-only": "",
              "icon-left": "ri-close-line",
              size: "xs",
              "aria-label": z.value,
              class: C(["-mx-2 shrink-0", $.value ? "-my-1" : "-my-1.5"]),
              onClick: Y
            }, null, 8, ["aria-label", "class"])) : w("", !0)
          ])) : e.compact ? (c(), g("div", QD, [
            D.value ? (c(), W(L(gt), {
              key: 0,
              "data-testid": "alert-percentage",
              label: `${e.percentage}%`,
              theme: d.value,
              size: "sm",
              "show-left-icon": !1,
              "show-close-icon": !1,
              class: "min-w-10 rounded-(--border-border-radius-rounded-xs)!"
            }, null, 8, ["label", "theme"])) : w("", !0),
            v("div", _D, [
              v("div", ez, [
                e.heading ? (c(), g("p", {
                  key: 0,
                  "data-testid": "alert-heading",
                  class: C(rz)
                }, j(e.heading), 1)) : w("", !0),
                e.optionalIcon ? (c(), g("div", tz, [
                  Ae(M.$slots, "body", {}, () => [
                    e.message ? (c(), g("p", {
                      key: 0,
                      "data-testid": "alert-message",
                      class: C(bb)
                    }, j(e.message), 1)) : w("", !0)
                  ]),
                  te(L(Gt), {
                    icon: e.optionalIcon,
                    color: "yellow",
                    size: "xs",
                    type: "square",
                    variant: "outlined"
                  }, null, 8, ["icon"])
                ])) : Ae(M.$slots, "body", { key: 2 }, () => [
                  e.message ? (c(), g("p", {
                    key: 0,
                    "data-testid": "alert-message",
                    class: C(bb)
                  }, j(e.message), 1)) : w("", !0)
                ])
              ]),
              e.buttons.length ? (c(), g("div", nz, [
                (c(!0), g(de, null, Re(e.buttons, (N, G) => (c(), g(de, { key: G }, [
                  N.component === "link" ? (c(), W(L(Mn), Fe({
                    key: 0,
                    ref_for: !0
                  }, re(N)), {
                    default: ve(() => [
                      nt(j(N.label), 1)
                    ]),
                    _: 2
                  }, 1040)) : (c(), W(L(Me), Fe({
                    key: 1,
                    ref_for: !0
                  }, O(N)), null, 16))
                ], 64))), 128))
              ])) : w("", !0)
            ])
          ])) : (c(), g("div", {
            key: 6,
            "data-testid": "alert-main-row",
            class: C(["flex w-full", [
              A.value ? "items-center" : "items-start",
              D.value ? "gap-1 ps-5" : "gap-2 ps-6",
              { "flex-wrap": I.value }
            ]])
          }, [
            v("div", {
              class: C(["relative flex min-h-6 min-w-0", I.value ? "grow basis-40" : "flex-1"])
            }, [
              v("div", {
                "data-testid": "alert-icon-column",
                class: C(["absolute top-0 flex items-start py-1", D.value ? "-start-5" : "-start-6"])
              }, [
                v("i", {
                  class: C([[s.value.icon, s.value.iconTint], "inline-flex items-center justify-center size-(--icon-size-sm) text-(length:--size-l)"]),
                  "aria-hidden": "true"
                }, null, 2)
              ], 2),
              v("div", {
                "data-testid": "alert-text-column",
                class: C(["flex min-w-0 flex-1 flex-col", e.checkbox ? "gap-3" : "gap-2"])
              }, [
                v("div", {
                  "data-testid": "alert-text-group",
                  class: C(e.checkbox ? "flex flex-col gap-1" : "contents")
                }, [
                  e.heading ? (c(), g("p", {
                    key: 0,
                    "data-testid": "alert-heading",
                    class: C(hb)
                  }, j(e.heading), 1)) : w("", !0),
                  Ae(M.$slots, "body", {}, () => [
                    e.message ? (c(), g("p", {
                      key: 0,
                      "data-testid": "alert-message",
                      class: C(k.value)
                    }, j(e.message), 3)) : w("", !0)
                  ])
                ], 2),
                e.checkbox ? (c(), W(Bn, {
                  key: 0,
                  modelValue: r.value,
                  "onUpdate:modelValue": B[4] || (B[4] = (N) => r.value = N),
                  label: e.checkbox.label,
                  "label-wrap": ""
                }, null, 8, ["modelValue", "label"])) : w("", !0),
                e.buttons.length && e.buttonsPosition === "bottom" ? (c(), g("div", az, [
                  (c(!0), g(de, null, Re(e.buttons, (N, G) => (c(), g(de, { key: G }, [
                    N.component === "link" ? (c(), W(L(Mn), Fe({
                      key: 0,
                      ref_for: !0
                    }, re(N)), {
                      default: ve(() => [
                        nt(j(N.label), 1)
                      ]),
                      _: 2
                    }, 1040)) : (c(), W(L(Me), Fe({
                      key: 1,
                      ref_for: !0
                    }, O(N)), null, 16))
                  ], 64))), 128))
                ])) : w("", !0)
              ], 2)
            ], 2),
            D.value ? (c(), W(L(gt), {
              key: 0,
              "data-testid": "alert-percentage",
              label: `${e.percentage}%`,
              theme: d.value,
              size: "sm",
              "show-left-icon": !1,
              "show-close-icon": !1,
              class: "shrink-0 min-w-10 rounded-(--border-border-radius-rounded-xs)!"
            }, null, 8, ["label", "theme"])) : w("", !0),
            T.value && e.buttonsPosition !== "right" ? (c(), W(L(Me), {
              key: 1,
              variant: "text",
              "icon-only": "",
              "icon-left": "ri-close-line",
              size: "xs",
              "aria-label": z.value,
              class: "-mx-2 -my-1 shrink-0",
              onClick: Y
            }, null, 8, ["aria-label"])) : w("", !0),
            I.value ? (c(), g("div", lz, [
              T.value ? (c(), W(L(Me), {
                key: 0,
                variant: "text",
                "icon-only": "",
                "icon-left": "ri-close-line",
                size: "xs",
                "aria-label": z.value,
                class: "-m-2",
                onClick: Y
              }, null, 8, ["aria-label"])) : w("", !0),
              (c(!0), g(de, null, Re(e.buttons, (N, G) => (c(), g(de, { key: G }, [
                N.component === "link" ? (c(), W(L(Mn), Fe({
                  key: 0,
                  ref_for: !0
                }, re(N)), {
                  default: ve(() => [
                    nt(j(N.label), 1)
                  ]),
                  _: 2
                }, 1040)) : (c(), W(L(Me), Fe({
                  key: 1,
                  ref_for: !0
                }, O(N)), null, 16))
              ], 64))), 128))
            ])) : w("", !0)
          ], 2))
        ];
      }),
      _: 3
    }, 16, ["class"]));
  }
}), oz = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M7.82843 10.9999H20V12.9999H7.82843L13.1924 18.3638L11.7782 19.778L4 11.9999L11.7782 4.22168L13.1924 5.63589L7.82843 10.9999Z"/></svg>', gb = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"/></svg>', iz = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z"/></svg>', sz = ["src", "alt"], dz = ["aria-label", "disabled", "aria-describedby"], uz = { class: "flex flex-col gap-4" }, cz = { class: "flex items-start gap-4" }, fz = {
  "data-testid": "image-upload-preview",
  class: "shrink-0"
}, hz = ["src", "alt"], bz = { class: "flex-1 min-w-0" }, gz = { key: 0 }, mb = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200' viewBox='0 0 200 200'%3E%3Crect width='200' height='200' fill='%23c0c0c0'/%3E%3Crect x='30' y='30' width='140' height='140' rx='4' fill='%23e0e0e0'/%3E%3Ccircle cx='80' cy='82' r='14' fill='%23b0b0b0'/%3E%3Cpath d='M50 140 l30-40 l20 25 l15-18 l35 45 H50z' fill='%23b0b0b0'/%3E%3C/svg%3E", kq = /* @__PURE__ */ ye({
  __name: "ImageUploadInput",
  props: {
    imageUrl: { default: void 0 },
    imageAlt: { default: "Profile picture" },
    avatarSize: { default: 64 },
    label: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    accept: { default: "image/*" },
    maxFileSize: { default: 30 * 1024 * 1024 },
    maxFileSizeText: { default: "SVG, PNG, JPG or GIF (MAX. 800x400px)." },
    fileTypeErrorText: { default: void 0 },
    fileSizeErrorText: { default: void 0 },
    fileInputLabel: { default: void 0 },
    browseButtonText: { default: "Choose files" },
    placeholder: { default: "No file chosen" },
    removeButtonLabel: { default: "Remove current picture" },
    alertHeading: { default: "Important" },
    alertMessage: { default: "In order for new users to access their accounts, they must receive approval from an administrator to verify their eligibility." },
    alertVariant: { default: "info" },
    showAlert: { type: Boolean, default: !0 },
    cancelButtonLabel: { default: "Cancel" },
    uploadButtonLabel: { default: "Upload new picture" },
    modalTitle: { default: "Upload profile picture" },
    modalSize: { default: "sm" },
    disabled: { type: Boolean, default: !1 },
    editButtonLabel: { default: "Edit profile picture" },
    closeModalLabel: { default: "Close modal" }
  },
  emits: ["upload", "remove", "cancel"],
  setup(e, { expose: n, emit: t }) {
    const a = (ne, re) => {
      const O = ne.replace('fill="currentColor"', `fill="${re}"`).replace("<svg", '<svg width="16" height="16"');
      return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(O)}`;
    }, l = {
      arrowLeftDark: a(oz, "#242424"),
      arrowRightDark: a(gb, "#242424"),
      arrowRightLight: a(gb, "#f2f0f0"),
      deleteDark: a(iz, "#242424")
    }, r = e, o = t, i = R(!1), s = R(!1), d = R(null), u = qe(), f = `${u}-hint`, b = `${u}-error`, h = m(() => {
      const ne = [];
      return r.hint && ne.push(f), r.error && ne.push(b), ne.length > 0 ? ne.join(" ") : void 0;
    }), p = R(null), x = R(void 0), y = R(null), k = m(() => ({
      width: `${r.avatarSize}px`,
      height: `${r.avatarSize}px`
    })), $ = m(() => {
      const ne = "flex text-left text-sm font-inter";
      return r.labelInline ? `${ne} flex-row items-center gap-4` : `${ne} flex-col items-start gap-2`;
    }), S = () => {
      r.disabled || (p.value = null, x.value = r.imageUrl, y.value = null, i.value = !0);
    };
    n({
      /** Opens the upload modal, as the edit button does (no-op while `disabled`). */
      open: S
    });
    const T = () => {
      i.value = !1, p.value = null, x.value = void 0;
    }, I = () => {
      o("cancel"), T();
    }, A = (ne) => {
      !ne || Array.isArray(ne) || (y.value = null, p.value = ne, x.value = URL.createObjectURL(ne));
    }, E = (ne) => {
      y.value = ne, p.value = null;
    }, D = () => {
      p.value = null, x.value = void 0, o("remove");
    }, z = () => {
      p.value && (o("upload", p.value), T());
    }, Y = m(() => !!p.value), le = m(() => !!x.value);
    return $e(i, (ne) => {
      !ne && x.value && x.value !== r.imageUrl && URL.revokeObjectURL(x.value);
    }), (ne, re) => (c(), g("div", {
      "data-testid": "image-upload-input",
      class: C($.value)
    }, [
      e.label ? (c(), W(It, {
        key: 0,
        text: e.label,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        inline: e.labelInline,
        "test-id": "image-upload-label"
      }, null, 8, ["text", "required", "required-indicator", "tooltip", "inline"])) : w("", !0),
      v("div", {
        class: C(["flex min-w-0 flex-col items-start gap-0.5", e.labelInline ? "flex-1" : "self-stretch"])
      }, [
        v("div", {
          class: "relative inline-block",
          style: je(k.value)
        }, [
          v("div", {
            "data-testid": "image-upload-trigger",
            class: C(["w-full h-full rounded-(--border-border-radius-rounded-l) overflow-hidden border border-(--colors-border-base-soft) dark:border-(--colors-border-base)", e.disabled ? "opacity-50" : ""])
          }, [
            v("img", {
              src: e.imageUrl || mb,
              alt: e.imageAlt,
              class: "w-full h-full object-cover"
            }, null, 8, sz)
          ], 2),
          v("button", {
            "data-testid": "image-upload-edit-button",
            type: "button",
            "aria-label": e.editButtonLabel,
            class: C(["absolute -top-2 -right-2 flex items-center justify-center w-8 h-8 rounded-full bg-(--background-background-white) dark:bg-(--colors-background-black-default) border border-(--colors-border-base-soft) dark:border-(--colors-border-base) shadow-sm transition-colors duration-200 hover:bg-(--colors-background-hover) dark:hover:bg-[rgba(255,255,255,0.1)]", e.disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"]),
            disabled: e.disabled,
            "aria-describedby": h.value,
            onClick: S,
            onFocus: re[0] || (re[0] = (O) => s.value = !0),
            onBlur: re[1] || (re[1] = (O) => s.value = !1),
            onKeydown: re[2] || (re[2] = (O) => {
              var P;
              return (P = d.value) == null ? void 0 : P.handleFieldKeydown(O);
            })
          }, [...re[4] || (re[4] = [
            v("i", {
              class: "ri-pencil-line text-(length:--size-m) text-(--colors-text-heading) dark:text-(--colors-text-white-default)",
              "aria-hidden": "true"
            }, null, -1)
          ])], 42, dz)
        ], 4),
        e.hint || e.error ? (c(), W($t, {
          key: 0,
          ref_key: "helperRef",
          ref: d,
          focused: s.value,
          hint: e.hint,
          error: e.error,
          "hint-id": f,
          "error-id": b,
          "error-live": e.errorLive,
          "test-id-prefix": "image-upload"
        }, null, 8, ["focused", "hint", "error", "error-live"])) : w("", !0)
      ], 2),
      te(L(Ka), {
        modelValue: i.value,
        "onUpdate:modelValue": re[3] || (re[3] = (O) => i.value = O),
        size: e.modalSize,
        title: e.modalTitle,
        "aria-close-label": e.closeModalLabel
      }, {
        footer: ve(() => [
          te(L(Me), {
            "data-testid": "image-upload-cancel-button",
            variant: "secondary",
            label: e.cancelButtonLabel,
            "icon-left": l.arrowLeftDark,
            onClick: I
          }, null, 8, ["label", "icon-left"]),
          te(L(Me), {
            "data-testid": "image-upload-submit-button",
            variant: "primary",
            label: e.uploadButtonLabel,
            "icon-right": l.arrowRightLight,
            disabled: !Y.value,
            onClick: z
          }, null, 8, ["label", "icon-right", "disabled"])
        ]),
        default: ve(() => [
          v("div", uz, [
            v("div", cz, [
              v("div", fz, [
                v("img", {
                  src: x.value || mb,
                  alt: e.imageAlt,
                  class: "w-16 h-16 rounded-xl object-cover border border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
                }, null, 8, hz)
              ]),
              v("div", bz, [
                te(L(KS), {
                  variant: "basic",
                  accept: e.accept,
                  "max-file-size": e.maxFileSize,
                  "max-file-size-text": e.maxFileSizeText,
                  "file-type-error-text": e.fileTypeErrorText,
                  "file-size-error-text": e.fileSizeErrorText,
                  label: e.fileInputLabel,
                  "browse-button-text": e.browseButtonText,
                  placeholder: e.placeholder,
                  "model-value": p.value,
                  error: y.value ?? void 0,
                  "onUpdate:modelValue": A,
                  onError: E
                }, null, 8, ["accept", "max-file-size", "max-file-size-text", "file-type-error-text", "file-size-error-text", "label", "browse-button-text", "placeholder", "model-value", "error"])
              ])
            ]),
            le.value ? (c(), g("div", gz, [
              te(L(Me), {
                "data-testid": "image-upload-remove-button",
                variant: "secondary",
                label: e.removeButtonLabel,
                "icon-left": l.deleteDark,
                size: "sm",
                onClick: D
              }, null, 8, ["label", "icon-left"])
            ])) : w("", !0),
            e.showAlert ? (c(), W(L(_l), {
              key: 1,
              heading: e.alertHeading,
              message: e.alertMessage,
              color: e.alertVariant === "error" ? "danger" : e.alertVariant,
              closable: !1
            }, null, 8, ["heading", "message", "color"])) : w("", !0)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "size", "title", "aria-close-label"])
    ], 2));
  }
}), mz = ["id", "aria-label", "data-testid"], pz = {
  key: 0,
  class: "flex w-full items-center gap-3"
}, Fv = /* @__PURE__ */ ye({
  __name: "DatepickerPanel",
  props: {
    open: { type: Boolean, default: !1 },
    anchorEl: {},
    dialogLabel: {},
    testId: {},
    widthClass: {},
    id: { default: void 0 },
    keepAnchorFocusable: { type: Boolean, default: !1 },
    additionalAnchorEls: { default: () => [] },
    placement: { default: "bottom-start" }
  },
  emits: ["update:open", "close"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = R(null);
    let o = null;
    function i(p) {
      return p.startsWith("bottom") ? p.replace("bottom", "top") : p.replace("top", "bottom");
    }
    function s() {
      r.value && (o == null || o.destroy(), o = Xa(a.anchorEl, r.value, {
        strategy: "fixed",
        placement: a.placement,
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: [i(a.placement)] } },
          { name: "preventOverflow", options: { padding: 8 } }
        ]
      }));
    }
    function d() {
      o == null || o.destroy(), o = null;
    }
    function u() {
      o == null || o.update();
    }
    function f() {
      l("update:open", !1), l("close");
    }
    ts({
      active: An(a, "open"),
      container: r,
      containFocus: !0,
      restoreFocusTo: () => a.anchorEl,
      // See keepAnchorFocusable's doc above: without this, a consumer whose anchor IS its own
      // typing surface can never place a caret in it while the panel is open — containFocus treats
      // the click as focus escaping the trap and yanks it straight back to the panel's first
      // focusable cell.
      allowOutsideElements: a.keepAnchorFocusable ? () => [a.anchorEl, ...a.additionalAnchorEls] : void 0
    }), rs(r, f, {
      isActive: () => a.open,
      ignoreElements: () => [a.anchorEl, ...a.additionalAnchorEls]
    });
    const b = Symbol("datepicker-panel");
    function h(p) {
      p.key !== "Escape" || !a.open || ya(b) && (p.defaultPrevented || (p.stopPropagation(), p.preventDefault(), f()));
    }
    return $e(
      () => a.open,
      async (p) => {
        p ? (ra(b), await Ge(), s()) : (Fn(b), d());
      },
      { immediate: !0 }
    ), $e(
      () => a.anchorEl,
      () => {
        a.open && s();
      }
    ), ct(() => {
      document.addEventListener("keydown", h);
    }), yt(() => {
      document.removeEventListener("keydown", h), Fn(b), d();
    }), n({ updatePosition: u }), (p, x) => (c(), W(Nn, { to: "body" }, [
      e.open ? (c(), g("div", {
        key: 0,
        id: e.id,
        ref_key: "panelRef",
        ref: r,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": e.dialogLabel,
        "data-focus-trap-allow-outside": "",
        "data-testid": e.testId,
        class: C([
          "z-[350] flex flex-col items-center gap-4 rounded-(--border-border-radius-rounded-l) border border-solid border-(--border-border-base-soft) bg-(--background-background-white) p-5 shadow-(--blur-shadow-m) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)",
          e.widthClass
        ])
      }, [
        Ae(p.$slots, "default"),
        p.$slots.actions ? (c(), g("div", pz, [
          Ae(p.$slots, "actions")
        ])) : w("", !0)
      ], 10, mz)) : w("", !0)
    ]));
  }
}), vz = ["aria-disabled", "data-state", "aria-current"], tl = "relative inline-flex items-center justify-center font-inter focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) focus-visible:ring-offset-1", xz = "flex size-9 items-center justify-center rounded-(--border-border-radius-rounded-full) border border-solid datepicker-cell--gradient-white", Ll = "text-(length:--size-sm) leading-(--line-height-l)", yz = /* @__PURE__ */ ye({
  __name: "DatepickerCell",
  props: {
    type: { default: "Day" },
    state: { default: "Initial" },
    text: { default: "" },
    muted: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => t.state === "Disabled");
    function r(u) {
      l.value || a("click", u);
    }
    const o = m(
      () => t.type === "Day" && (t.state === "Active start" || t.state === "Active end")
    ), i = m(() => {
      switch (t.type) {
        case "Month":
          return "h-9 min-w-[78px] flex-1";
        case "Year":
        case "Wheel":
          return "h-9 min-w-[57px] flex-1";
        default:
          return "size-9 shrink-0";
      }
    }), s = m(() => {
      switch (t.state) {
        case "Hover":
          return `${tl} bg-(--background-background-accent) rounded-(--border-border-radius-rounded-base)`;
        case "Active":
          return `${tl} datepicker-cell--gradient-white border border-solid rounded-(--border-border-radius-rounded-full)`;
        case "Active start":
          return `${tl} bg-(--background-background-accent) rounded-l-(--border-border-radius-rounded-base)`;
        case "Active between":
          return `${tl} bg-(--background-background-accent)`;
        case "Active end":
          return `${tl} bg-(--background-background-accent) rounded-r-(--border-border-radius-rounded-base)`;
        case "Today":
          return `${tl} datepicker-cell--gradient-black border border-solid rounded-(--border-border-radius-rounded-full)`;
        default:
          return `${tl} rounded-(--border-border-radius-rounded-base)`;
      }
    }), d = m(() => {
      switch (t.state) {
        case "Active":
        case "Active start":
        case "Active end":
          return `${Ll} font-(--weight-semi-bold) text-(--text-text-accent)`;
        case "Today":
          return `${Ll} font-(--weight-semi-bold) text-(--text-text-white-default)`;
        case "Disabled":
          return `${Ll} font-(--weight-medium) text-(--text-text-disabled-light)`;
        case "Hover":
        case "Active between":
          return `${Ll} font-(--weight-medium) text-(--text-text-black-default)`;
        default:
          return t.muted ? `${Ll} font-(--weight-medium) text-(--text-text-disabled-strong) dark:text-(--text-text-disabled-light)` : `${Ll} font-(--weight-medium) text-(--text-text-black-default) dark:text-(--colors-text-white-default)`;
      }
    });
    return (u, f) => (c(), g("button", {
      type: "button",
      "aria-disabled": l.value ? "true" : void 0,
      class: C([s.value, i.value, l.value ? "cursor-not-allowed" : "cursor-pointer"]),
      "data-state": e.state,
      "aria-current": e.state === "Today" ? "date" : void 0,
      "data-testid": "datepicker-cell",
      onClick: r
    }, [
      o.value ? (c(), g("span", {
        key: 0,
        class: C(xz),
        "data-testid": "datepicker-cell-inner"
      }, [
        v("span", {
          class: C(d.value)
        }, j(e.text), 3)
      ])) : (c(), g("span", {
        key: 1,
        class: C(d.value)
      }, j(e.text), 3))
    ], 10, vz));
  }
}), Hr = /* @__PURE__ */ dt(yz, [["__scopeId", "data-v-c4eaa4a3"]]);
function fd(e, n) {
  const t = R(0);
  function a() {
    const s = e.value.findIndex((d) => d.value === n.value);
    t.value = s >= 0 ? s : Math.max(e.value.findIndex((d) => !d.disabled), 0);
  }
  a();
  function l(s) {
    const d = e.value[s];
    !d || d.disabled || (t.value = s, n.value = d.value);
  }
  function r(s) {
    if (s < 0 || s >= e.value.length) return;
    t.value = s;
    const d = e.value[s];
    d.disabled || (n.value = d.value);
  }
  function o(s) {
    r(t.value + s);
  }
  function i(s) {
    const d = e.value;
    r(s === "start" ? 0 : d.length - 1);
  }
  return { focusedIndex: t, selectIndex: l, moveFocus: o, moveToEdge: i, syncFocusToSelected: a };
}
const kz = { class: "w-full text-center text-(length:--size-m) font-(--weight-semi-bold) leading-(--line-height-l) text-(--text-text-black-default) dark:text-(--colors-text-white-default)" }, wz = { class: "flex w-full flex-wrap content-start items-start justify-between" }, Cz = ["aria-label"], Sz = ["aria-label"], $z = ["aria-label"], Iz = 120, Lz = 10, Tz = 200, Az = 200, Ez = /* @__PURE__ */ ye({
  __name: "DatepickerDobPicker",
  props: {
    open: { type: Boolean, default: !1 },
    modelValue: { default: void 0 },
    anchorEl: {},
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    defaultDate: { default: void 0 },
    id: { default: void 0 },
    autoFocusOnOpen: { type: Boolean, default: !0 },
    title: {},
    yearColumnLabel: {},
    monthColumnLabel: {},
    dayColumnLabel: {},
    monthLabels: {},
    monthShortLabels: {},
    clearLabel: {}
  },
  emits: ["update:open", "update:modelValue", "clear", "close"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t;
    function r(H) {
      return String(H).padStart(2, "0");
    }
    function o(H, Z, ee) {
      return `${H}-${r(Z + 1)}-${r(ee)}`;
    }
    function i(H, Z) {
      return new Date(H, Z + 1, 0).getDate();
    }
    function s() {
      const H = a.modelValue || a.defaultDate, Z = H ? /* @__PURE__ */ new Date(`${H}T00:00:00`) : /* @__PURE__ */ new Date();
      return { year: Z.getFullYear(), month: Z.getMonth(), day: Z.getDate() };
    }
    const d = s(), u = R(d.year), f = R(d.month), b = R(d.day);
    function h(H) {
      const Z = (/* @__PURE__ */ new Date()).getFullYear();
      return Math.min(Math.max(H, Z - Tz), Z + Az);
    }
    const p = m(() => a.minDate ? h(Number(a.minDate.slice(0, 4))) : void 0), x = m(() => a.maxDate ? h(Number(a.maxDate.slice(0, 4))) : void 0), y = m(() => {
      const H = (/* @__PURE__ */ new Date()).getFullYear(), Z = [H - Iz, H + Lz];
      return p.value !== void 0 && Z.push(p.value), x.value !== void 0 && Z.push(x.value), Z.push(h(u.value)), {
        min: Math.min(...Z),
        max: Math.max(...Z)
      };
    });
    function k(H) {
      const { minDate: Z, maxDate: ee } = a;
      return !!(Z && H < Z.slice(0, H.length) || ee && H > ee.slice(0, H.length));
    }
    const $ = m(() => {
      const { min: H, max: Z } = y.value, ee = [];
      for (let J = H; J <= Z; J++) {
        const F = String(J);
        k(F) || ee.push({ value: J, label: F, disabled: !1 });
      }
      return ee;
    }), S = m(() => {
      const H = [];
      return a.monthShortLabels.forEach((Z, ee) => {
        const J = `${u.value}-${r(ee + 1)}`;
        k(J) || H.push({ value: ee, label: Z, disabled: !1 });
      }), H;
    }), T = m(() => {
      const H = i(u.value, f.value), Z = [];
      for (let ee = 0; ee < H; ee++) {
        const J = ee + 1, F = o(u.value, f.value, J);
        k(F) || Z.push({ value: J, label: String(J), disabled: !1 });
      }
      return Z;
    }), I = fd($, u), A = fd(S, f), E = fd(T, b);
    function D() {
      l("update:modelValue", o(u.value, f.value, b.value));
    }
    function z(H) {
      u.value = h(u.value), x.value !== void 0 && u.value > x.value && (u.value = x.value), p.value !== void 0 && u.value < p.value && (u.value = p.value);
      const Z = i(u.value, f.value);
      if (b.value > Z && (b.value = Z), a.maxDate) {
        const [F, _, ue] = a.maxDate.split("-").map(Number);
        u.value === F && f.value > _ - 1 && (f.value = _ - 1, b.value = Math.min(b.value, i(u.value, f.value))), u.value === F && f.value === _ - 1 && b.value > ue && (b.value = ue);
      }
      if (a.minDate) {
        const [F, _, ue] = a.minDate.split("-").map(Number);
        u.value === F && f.value < _ - 1 && (f.value = _ - 1, b.value = Math.min(b.value, i(u.value, f.value))), u.value === F && f.value === _ - 1 && b.value < ue && (b.value = ue);
      }
      const ee = H ?? ge, J = ["year", "month", "day"].filter((F) => F !== ee);
      J.forEach((F) => K.value.add(F)), H !== void 0 && (ge = H), I.syncFocusToSelected(), A.syncFocusToSelected(), E.syncFocusToSelected(), Ge(() => {
        J.forEach((F) => K.value.delete(F)), H !== void 0 && (ge = void 0);
      });
    }
    $e([u, f], () => z());
    function Y(H) {
      I.selectIndex(H), z("year"), D();
    }
    function le(H) {
      A.selectIndex(H), z("month"), D();
    }
    function ne(H) {
      E.selectIndex(H), D();
    }
    const re = { year: I, month: A, day: E }, O = {
      year: u,
      month: f,
      day: b
    }, P = ["year", "month", "day"];
    function V(H, Z) {
      const ee = P.indexOf(H) + Z;
      if (ee < 0 || ee >= P.length) return;
      const J = P[ee], F = U[J].value, _ = F == null ? void 0 : F.querySelectorAll('[role="option"]')[re[J].focusedIndex.value];
      _ == null || _.focus({ preventScroll: !0 }), _ == null || _.scrollIntoView({ block: "center", behavior: "smooth" });
    }
    function M() {
      l("update:open", !1), l("close");
    }
    function B(H, Z) {
      if (H.key === "ArrowLeft" || H.key === "ArrowRight") {
        H.preventDefault(), V(Z, H.key === "ArrowLeft" ? -1 : 1);
        return;
      }
      if (H.key === "Enter" || H.key === " ") {
        H.preventDefault(), M();
        return;
      }
      const ee = re[Z], J = O[Z], F = J.value;
      switch (H.key) {
        case "ArrowDown":
          H.preventDefault(), ee.moveFocus(1);
          break;
        case "ArrowUp":
          H.preventDefault(), ee.moveFocus(-1);
          break;
        case "Home":
          H.preventDefault(), ee.moveToEdge("start");
          break;
        case "End":
          H.preventDefault(), ee.moveToEdge("end");
          break;
        default:
          return;
      }
      J.value !== F && (Z !== "day" && z(Z), D());
    }
    const q = R(null), N = R(null), G = R(null), U = { year: q, month: N, day: G }, K = R(/* @__PURE__ */ new Set());
    let ge;
    function xe(H) {
      const Z = U[H].value, ee = Z == null ? void 0 : Z.querySelectorAll('[role="option"]')[re[H].focusedIndex.value];
      K.value.has(H) || ee == null || ee.focus({ preventScroll: !0 }), ee == null || ee.scrollIntoView({ block: "center", behavior: "smooth" });
    }
    $e(I.focusedIndex, () => xe("year"), { flush: "post" }), $e(A.focusedIndex, () => xe("month"), { flush: "post" }), $e(E.focusedIndex, () => xe("day"), { flush: "post" });
    function X(H, Z) {
      return H.value === Z ? "Active" : "Initial";
    }
    function ie() {
      l("clear");
    }
    async function he() {
      const H = s();
      u.value = H.year, f.value = H.month, b.value = H.day, z(), K.value.add("year"), K.value.add("month"), K.value.add("day"), I.syncFocusToSelected(), A.syncFocusToSelected(), E.syncFocusToSelected(), await Ge(), K.value.delete("year"), K.value.delete("month"), K.value.delete("day");
      const Z = ["year", "month", "day"].map(
        (ee) => {
          var J;
          return (J = U[ee].value) == null ? void 0 : J.querySelectorAll('[role="option"]')[re[ee].focusedIndex.value];
        }
      );
      return Z.forEach((ee) => ee == null ? void 0 : ee.scrollIntoView({ block: "center" })), Z[0];
    }
    async function oe() {
      const H = await he();
      H == null || H.focus({ preventScroll: !0 });
    }
    $e(
      () => a.open,
      (H) => {
        H && (a.autoFocusOnOpen ? oe() : he());
      },
      // DatePickerInput's openDobPicker() sets
      // dobMounted/isDobOpen true in the SAME synchronous call, so this component can mount with
      // `open` ALREADY true on first open — without `immediate`, this watcher would never fire for
      // that case (a plain watch only fires on a subsequent CHANGE), and the explicit year-column
      // focus above would never run on the very first open at all.
      { immediate: !0 }
    );
    function Ce() {
      oe();
    }
    return n({ focusYearColumn: Ce }), $e(
      () => a.modelValue,
      (H) => {
        if (!a.open || H === o(u.value, f.value, b.value)) return;
        const Z = s();
        u.value = Z.year, f.value = Z.month, b.value = Z.day, z();
      }
    ), (H, Z) => (c(), W(Fv, {
      id: e.id,
      open: e.open,
      "anchor-el": e.anchorEl,
      "keep-anchor-focusable": "",
      "dialog-label": e.title,
      "test-id": "datepicker-dob-picker",
      "width-class": "w-[224px]",
      "onUpdate:open": Z[3] || (Z[3] = (ee) => l("update:open", ee)),
      onClose: Z[4] || (Z[4] = (ee) => l("close"))
    }, {
      actions: ve(() => [
        te(Me, {
          variant: "secondary",
          size: "sm",
          class: "flex-1",
          "full-width": "",
          label: e.clearLabel,
          "data-testid": "datepicker-dob-picker-clear",
          onClick: ie
        }, null, 8, ["label"])
      ]),
      default: ve(() => [
        v("p", kz, j(e.title), 1),
        v("div", wz, [
          v("div", {
            ref_key: "yearListRef",
            ref: q,
            role: "listbox",
            "aria-label": e.yearColumnLabel,
            class: "dob-wheel-column h-[108px] w-[57px] shrink-0 snap-y snap-mandatory overflow-y-auto scroll-smooth py-9",
            onKeydown: Z[0] || (Z[0] = (ee) => B(ee, "year"))
          }, [
            (c(!0), g(de, null, Re($.value, (ee, J) => (c(), W(Hr, {
              key: ee.value,
              type: "Wheel",
              state: X(ee, u.value),
              text: ee.label,
              role: "option",
              class: "snap-center",
              "aria-selected": ee.value === u.value ? "true" : void 0,
              tabindex: J === L(I).focusedIndex.value ? 0 : -1,
              "aria-label": ee.label,
              onClick: (F) => Y(J)
            }, null, 8, ["state", "text", "aria-selected", "tabindex", "aria-label", "onClick"]))), 128))
          ], 40, Cz),
          v("div", {
            ref_key: "monthListRef",
            ref: N,
            role: "listbox",
            "aria-label": e.monthColumnLabel,
            class: "dob-wheel-column h-[108px] w-[57px] shrink-0 snap-y snap-mandatory overflow-y-auto scroll-smooth py-9",
            onKeydown: Z[1] || (Z[1] = (ee) => B(ee, "month"))
          }, [
            (c(!0), g(de, null, Re(S.value, (ee, J) => (c(), W(Hr, {
              key: ee.value,
              type: "Wheel",
              state: X(ee, f.value),
              text: ee.label,
              role: "option",
              class: "snap-center",
              "aria-selected": ee.value === f.value ? "true" : void 0,
              tabindex: J === L(A).focusedIndex.value ? 0 : -1,
              "aria-label": e.monthLabels[ee.value],
              onClick: (F) => le(J)
            }, null, 8, ["state", "text", "aria-selected", "tabindex", "aria-label", "onClick"]))), 128))
          ], 40, Sz),
          v("div", {
            ref_key: "dayListRef",
            ref: G,
            role: "listbox",
            "aria-label": e.dayColumnLabel,
            class: "dob-wheel-column h-[108px] w-[57px] shrink-0 snap-y snap-mandatory overflow-y-auto scroll-smooth py-9",
            onKeydown: Z[2] || (Z[2] = (ee) => B(ee, "day"))
          }, [
            (c(!0), g(de, null, Re(T.value, (ee, J) => (c(), W(Hr, {
              key: ee.value,
              type: "Wheel",
              state: X(ee, b.value),
              text: ee.label,
              role: "option",
              class: "snap-center",
              "aria-selected": ee.value === b.value ? "true" : void 0,
              tabindex: J === L(E).focusedIndex.value ? 0 : -1,
              "aria-label": ee.label,
              onClick: (F) => ne(J)
            }, null, 8, ["state", "text", "aria-selected", "tabindex", "aria-label", "onClick"]))), 128))
          ], 40, $z)
        ])
      ]),
      _: 1
    }, 8, ["id", "open", "anchor-el", "dialog-label"]));
  }
}), Rz = /* @__PURE__ */ dt(Ez, [["__scopeId", "data-v-f30f2f82"]]), Bz = { class: "flex w-full items-center justify-between" }, Mz = ["disabled"], Dz = /* @__PURE__ */ ye({
  __name: "DatepickerControls",
  props: {
    label: {},
    previousLabel: {},
    nextLabel: {},
    labelDisabled: { type: Boolean, default: !1 },
    previousDisabled: { type: Boolean, default: !1 },
    nextDisabled: { type: Boolean, default: !1 }
  },
  emits: ["prev", "next", "drill-up"],
  setup(e, { emit: n }) {
    const t = n;
    return (a, l) => (c(), g("div", Bz, [
      te(Me, {
        variant: "ghost",
        size: "xs",
        "icon-only": "",
        "icon-left": "ri-arrow-left-line",
        "aria-label": e.previousLabel,
        disabled: e.previousDisabled,
        "data-testid": "datepicker-controls-prev",
        onClick: l[0] || (l[0] = (r) => t("prev"))
      }, null, 8, ["aria-label", "disabled"]),
      v("button", {
        type: "button",
        "aria-live": "polite",
        disabled: e.labelDisabled,
        class: "font-(--weight-semi-bold) text-(length:--size-m) leading-(--line-height-l) text-(--text-text-heading) dark:text-(--colors-text-white-default) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) focus-visible:ring-offset-1 rounded-(--border-border-radius-rounded-sm) cursor-pointer disabled:cursor-not-allowed disabled:opacity-60",
        "data-testid": "datepicker-controls-label",
        onClick: l[1] || (l[1] = (r) => t("drill-up"))
      }, j(e.label), 9, Mz),
      te(Me, {
        variant: "ghost",
        size: "xs",
        "icon-only": "",
        "icon-right": "ri-arrow-right-line",
        "aria-label": e.nextLabel,
        disabled: e.nextDisabled,
        "data-testid": "datepicker-controls-next",
        onClick: l[2] || (l[2] = (r) => t("next"))
      }, null, 8, ["aria-label", "disabled"])
    ]));
  }
});
function mu(e) {
  return String(e).padStart(2, "0");
}
function pb(e, n, t) {
  const a = e * 12 + n + t;
  return { year: Math.floor(a / 12), month: (a % 12 + 12) % 12 };
}
function Wc(e, n, t) {
  return `${e}-${mu(n + 1)}-${mu(t)}`;
}
function pu(e, n) {
  return `${e}-${mu(n + 1)}`;
}
function En(e, n) {
  return e < n ? -1 : e > n ? 1 : 0;
}
function ni() {
  const e = /* @__PURE__ */ new Date();
  return Wc(e.getFullYear(), e.getMonth(), e.getDate());
}
function qc(e, n, t) {
  const { selectedIso: a, selectedEndIso: l, todayIso: r, minIso: o, maxIso: i } = n, s = r.substring(0, e.length), d = a !== void 0 ? a.substring(0, e.length) : void 0, u = l !== void 0 ? l.substring(0, e.length) : void 0;
  if (o !== void 0 && En(e, o) < 0 || i !== void 0 && En(e, i) > 0) return "Disabled";
  if (d !== void 0 && u !== void 0) {
    if (e === d) return "Active start";
    if (e === u) return "Active end";
    if (En(e, d) > 0 && En(e, u) < 0) return "Active between";
  } else {
    if (d !== void 0 && e === d)
      return "Active";
    if (u !== void 0 && e === u)
      return "Active";
  }
  return e === s ? "Today" : t;
}
function zz(e, n, t) {
  const l = (new Date(e, n, 1).getDay() + 6) % 7, r = new Date(e, n, 1 - l), o = [];
  for (let i = 0; i < 42; i++) {
    const s = new Date(r);
    s.setDate(r.getDate() + i);
    const d = Wc(s.getFullYear(), s.getMonth(), s.getDate()), u = s.getMonth() === n && s.getFullYear() === e, f = qc(d, t, "Initial");
    o.push({ iso: d, label: String(s.getDate()), state: f, inMonth: u });
  }
  return o;
}
function Oz(e, n, t) {
  return n.map((a, l) => {
    const r = pu(e, l);
    return { iso: r, label: a, state: qc(r, t, "Initial"), inMonth: !0 };
  });
}
function Pz(e, n) {
  return Array.from({ length: 12 }, (t, a) => {
    const l = e + a, r = String(l);
    return { iso: r, label: r, state: qc(r, n, "Initial"), inMonth: !0 };
  });
}
const Fz = {
  key: 0,
  class: "flex w-[252px] flex-col"
}, Vz = {
  role: "row",
  "data-testid": "datepicker-weekday-header-row",
  class: "mb-1.5 flex items-center"
}, Uc = /* @__PURE__ */ ye({
  __name: "DatepickerDropdownMenu",
  props: {
    open: { type: Boolean, default: !1 },
    modelValue: { default: void 0 },
    startDate: { default: void 0 },
    endDate: { default: void 0 },
    seedField: { default: "start" },
    anchorEl: {},
    additionalAnchorEls: { default: () => [] },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    todayButtonMode: { default: "highlight" },
    mode: { default: "day" },
    showTodayButton: { type: Boolean, default: !0 },
    showClearButton: { type: Boolean, default: !0 },
    weekdayLabels: {},
    monthLabels: {},
    monthShortLabels: {},
    clearLabel: {},
    todayLabel: {},
    previousLabel: {},
    nextLabel: {},
    unavailableLabel: {},
    rangeStartLabel: { default: "start of selected range" },
    rangeEndLabel: { default: "end of selected range" },
    rangeBetweenLabel: { default: "in selected range" },
    dialogLabel: {},
    id: { default: void 0 },
    placement: { default: "bottom-start" },
    keepAnchorFocusable: { type: Boolean, default: !1 },
    autoFocusOnOpen: { type: Boolean, default: !0 }
  },
  emits: ["update:open", "update:modelValue", "select", "range-select", "clear", "close"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = m(() => a.startDate !== void 0 || a.endDate !== void 0), o = R(/* @__PURE__ */ new Date()), i = m(() => {
      const J = o.value;
      return `${J.getFullYear()}-${String(J.getMonth() + 1).padStart(2, "0")}-${String(J.getDate()).padStart(2, "0")}`;
    });
    function s(J) {
      const F = J ?? a.seedField, _ = F === "end" ? a.endDate : a.startDate, ue = F === "end" ? a.startDate : a.endDate, se = r.value ? _ || ue : a.modelValue;
      if (se) {
        const [Q, ae, Te] = se.split("-").map(Number);
        return { year: Q, month: ae - 1, day: Te };
      }
      return { year: o.value.getFullYear(), month: o.value.getMonth(), day: o.value.getDate() };
    }
    const d = s(), u = R(d.year), f = R(d.month), b = R(d.day), h = R(a.mode), p = R(o.value.getFullYear() - o.value.getFullYear() % 12), x = m(
      () => zz(u.value, f.value, {
        todayIso: i.value,
        // "" (not yet picked) is normalized to undefined here — cellState's own selectedEndIso
        // contract treats any DEFINED value, empty string included, as a real endpoint, which would
        // otherwise render the lone startDate cell "Active start" instead of plain "Active" before an
        // end date is chosen.
        selectedIso: r.value ? a.startDate || void 0 : a.modelValue,
        selectedEndIso: r.value && a.endDate || void 0,
        minIso: a.minDate,
        maxIso: a.maxDate
      })
    ), y = m(
      () => {
        var J, F;
        return Oz(u.value, a.monthShortLabels, {
          todayIso: i.value,
          selectedIso: r.value ? a.startDate || void 0 : a.modelValue,
          selectedEndIso: r.value && a.endDate || void 0,
          minIso: (J = a.minDate) == null ? void 0 : J.slice(0, 7),
          maxIso: (F = a.maxDate) == null ? void 0 : F.slice(0, 7)
        });
      }
    ), k = m(
      () => {
        var J, F;
        return Pz(p.value, {
          todayIso: i.value,
          selectedIso: r.value ? a.startDate || void 0 : a.modelValue,
          selectedEndIso: r.value && a.endDate || void 0,
          minIso: (J = a.minDate) == null ? void 0 : J.slice(0, 4),
          maxIso: (F = a.maxDate) == null ? void 0 : F.slice(0, 4)
        });
      }
    ), $ = m(() => h.value === "month" ? y.value : h.value === "year" ? k.value : x.value), S = m(() => {
      const J = [];
      for (let F = 0; F < 6; F++)
        J.push(
          x.value.slice(F * 7, F * 7 + 7).map((_, ue) => ({ cell: _, index: F * 7 + ue }))
        );
      return J;
    }), T = m(() => h.value === "day" ? 7 : h.value === "month" ? 3 : 4), I = m(() => {
      const J = T.value, F = $.value, _ = [];
      for (let ue = 0; ue < F.length; ue += J)
        _.push(F.slice(ue, ue + J).map((se, Q) => ({ cell: se, index: ue + Q })));
      return _;
    }), A = R(null);
    function E(J) {
      return J.state === "Initial" && A.value === J.iso ? "Hover" : J.state;
    }
    const D = /* @__PURE__ */ new Set([
      "Active",
      "Active start",
      "Active between",
      "Active end"
    ]);
    function z(J) {
      const [F, _] = J.iso.split("-").map(Number), ue = `${a.monthLabels[_ - 1]} ${J.label}, ${F}`;
      return J.state === "Disabled" ? `${ue}, ${a.unavailableLabel}` : J.state === "Active start" ? `${ue}, ${a.rangeStartLabel}` : J.state === "Active end" ? `${ue}, ${a.rangeEndLabel}` : J.state === "Active between" ? `${ue}, ${a.rangeBetweenLabel}` : ue;
    }
    function Y(J) {
      const F = Number(J.iso.split("-")[1]), _ = a.monthLabels[F - 1];
      return J.state === "Disabled" ? `${_}, ${a.unavailableLabel}` : _;
    }
    const le = m(() => h.value === "month" ? String(u.value) : h.value === "year" ? `${p.value}-${p.value + 11}` : `${a.monthLabels[f.value]} ${u.value}`), ne = m(() => a.mode !== "day" || h.value === "year"), re = m(() => {
      var F;
      if (h.value === "day") {
        if (a.minDate === void 0) return !1;
        const _ = (F = x.value[0]) == null ? void 0 : F.iso;
        return _ !== void 0 && En(_, a.minDate) <= 0;
      }
      if (a.minDate === void 0) return !1;
      const J = Number(a.minDate.slice(0, 4));
      return h.value === "month" ? u.value <= J : p.value <= J;
    }), O = m(() => {
      var F;
      if (h.value === "day") {
        if (a.maxDate === void 0) return !1;
        const _ = (F = x.value[41]) == null ? void 0 : F.iso;
        return _ !== void 0 && En(_, a.maxDate) >= 0;
      }
      if (a.maxDate === void 0) return !1;
      const J = Number(a.maxDate.slice(0, 4));
      return h.value === "month" ? u.value >= J : p.value + 11 >= J;
    }), P = m(() => {
      var se, Q;
      const J = a.mode === "month" ? 7 : a.mode === "year" ? 4 : 10, F = i.value.slice(0, J), _ = (se = a.minDate) == null ? void 0 : se.slice(0, J), ue = (Q = a.maxDate) == null ? void 0 : Q.slice(0, J);
      return _ !== void 0 && En(F, _) < 0 || ue !== void 0 && En(F, ue) > 0;
    });
    async function V() {
      await Ge(), oe(xe.value);
    }
    function M() {
      var J;
      return ((J = document.activeElement) == null ? void 0 : J.getAttribute("data-testid")) === "datepicker-cell";
    }
    async function B() {
      if (re.value) return;
      const J = M();
      if (h.value === "day") {
        const { year: F, month: _ } = pb(u.value, f.value, -1);
        u.value = F, f.value = _;
      } else h.value === "month" ? u.value -= 1 : p.value -= 12;
      J && await V();
    }
    async function q() {
      if (O.value) return;
      const J = M();
      if (h.value === "day") {
        const { year: F, month: _ } = pb(u.value, f.value, 1);
        u.value = F, f.value = _;
      } else h.value === "month" ? u.value += 1 : p.value += 12;
      J && await V();
    }
    async function N() {
      const J = M();
      if (h.value === "day")
        h.value = "month";
      else if (h.value === "month")
        p.value = u.value - u.value % 12, h.value = "year";
      else
        return;
      J && await V();
    }
    function G() {
      l("clear");
    }
    async function U() {
      if (!P.value) {
        if (a.mode === "month") {
          if (u.value = o.value.getFullYear(), a.todayButtonMode === "select") {
            K(pu(o.value.getFullYear(), o.value.getMonth()));
            return;
          }
          await Ge(), oe(y.value.findIndex((J) => J.iso === i.value.slice(0, 7)));
          return;
        }
        if (a.mode === "year") {
          if (p.value = o.value.getFullYear() - o.value.getFullYear() % 12, a.todayButtonMode === "select") {
            K(String(o.value.getFullYear()));
            return;
          }
          await Ge(), oe(k.value.findIndex((J) => J.iso === i.value.slice(0, 4)));
          return;
        }
        if (h.value = "day", u.value = o.value.getFullYear(), f.value = o.value.getMonth(), a.todayButtonMode === "select") {
          if (r.value) {
            l("range-select", i.value);
            return;
          }
          l("update:modelValue", i.value), l("select", i.value), H();
          return;
        }
        await Ge(), oe(x.value.findIndex((J) => J.iso === i.value));
      }
    }
    function K(J) {
      l("update:modelValue", J), l("select", J), H();
    }
    async function ge(J) {
      if (J.state !== "Disabled") {
        if (h.value === "year") {
          if (a.mode === "year") {
            K(J.iso);
            return;
          }
          u.value = Number(J.iso), h.value = "month", await V();
          return;
        }
        if (h.value === "month") {
          if (a.mode === "month") {
            K(J.iso);
            return;
          }
          f.value = Number(J.iso.slice(5)) - 1, h.value = "day", await V();
          return;
        }
        if (r.value) {
          l("range-select", J.iso);
          return;
        }
        K(J.iso);
      }
    }
    const xe = R(0);
    function X() {
      const J = $.value;
      let F;
      if (h.value === "day") {
        const ue = new Date(u.value, f.value + 1, 0).getDate();
        F = Wc(u.value, f.value, Math.min(b.value, ue));
      } else h.value === "month" ? F = pu(u.value, f.value) : F = String(u.value);
      const _ = J.findIndex((ue) => ue.iso === F);
      xe.value = _ >= 0 ? _ : Math.max(J.findIndex((ue) => ue.state !== "Disabled"), 0);
    }
    X(), $e([u, f, h, p], X);
    const ie = R(null), he = R(null);
    function oe(J) {
      var F, _;
      if (xe.value = J, h.value === "day") {
        const ue = x.value[J];
        ue && (b.value = Number(ue.iso.slice(8, 10)));
      }
      (_ = (F = ie.value) == null ? void 0 : F.querySelectorAll('[data-testid="datepicker-cell"]')[J]) == null || _.focus({ preventScroll: !0 });
    }
    function Ce(J) {
      const F = $.value, _ = F.length, ue = xe.value, se = T.value, Q = ue - ue % se;
      switch (J.key) {
        case "ArrowRight":
          J.preventDefault(), ue < _ - 1 && oe(ue + 1);
          break;
        case "ArrowLeft":
          J.preventDefault(), ue > 0 && oe(ue - 1);
          break;
        case "ArrowDown":
          J.preventDefault(), ue + se < _ && oe(ue + se);
          break;
        case "ArrowUp":
          J.preventDefault(), ue - se >= 0 && oe(ue - se);
          break;
        case "Home":
          J.preventDefault(), oe(Q);
          break;
        case "End":
          J.preventDefault(), oe(Math.min(Q + se - 1, _ - 1));
          break;
        case "PageUp":
          h.value === "day" && (J.preventDefault(), B());
          break;
        case "PageDown":
          h.value === "day" && (J.preventDefault(), q());
          break;
        case "Enter":
        case " ":
          J.preventDefault(), ge(F[ue]);
          break;
      }
    }
    function H() {
      l("update:open", !1), l("close");
    }
    function Z(J) {
      o.value = /* @__PURE__ */ new Date(), h.value = a.mode;
      const F = s(J);
      u.value = F.year, f.value = F.month, b.value = F.day, p.value = F.year - F.year % 12, X();
    }
    $e(
      () => a.open,
      (J) => {
        J ? (Z(), a.autoFocusOnOpen && Ge(() => oe(xe.value))) : A.value = null;
      },
      { immediate: !0 }
    ), $e(h, async () => {
      var J;
      await Ge(), (J = he.value) == null || J.updatePosition();
    });
    async function ee(J) {
      Z(J), await Ge(), oe(xe.value);
    }
    return n({ focusGrid: ee, reseedVisibleGrid: Z }), (J, F) => (c(), W(Fv, {
      id: e.id,
      ref_key: "panelComponent",
      ref: he,
      open: e.open,
      "anchor-el": e.anchorEl,
      "additional-anchor-els": e.additionalAnchorEls,
      "dialog-label": e.dialogLabel,
      "test-id": "datepicker-dropdown-menu",
      "width-class": "w-[292px]",
      placement: e.placement,
      "keep-anchor-focusable": e.keepAnchorFocusable,
      "onUpdate:open": F[2] || (F[2] = (_) => l("update:open", _)),
      onClose: F[3] || (F[3] = (_) => l("close"))
    }, sa({
      default: ve(() => [
        v("div", {
          ref_key: "contentRef",
          ref: ie,
          class: "contents"
        }, [
          te(Dz, {
            label: le.value,
            "previous-label": e.previousLabel,
            "next-label": e.nextLabel,
            "label-disabled": ne.value,
            "previous-disabled": re.value,
            "next-disabled": O.value,
            onPrev: B,
            onNext: q,
            onDrillUp: N
          }, null, 8, ["label", "previous-label", "next-label", "label-disabled", "previous-disabled", "next-disabled"]),
          h.value === "day" ? (c(), g("div", Fz, [
            v("div", {
              role: "grid",
              class: "flex flex-col gap-0.5",
              onKeydown: Ce
            }, [
              v("div", Vz, [
                (c(!0), g(de, null, Re(e.weekdayLabels, (_, ue) => (c(), g("span", {
                  key: ue,
                  role: "columnheader",
                  "data-testid": "datepicker-weekday-header",
                  class: "w-9 flex-1 text-center text-(length:--size-sm) font-(--weight-medium) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
                }, j(_), 1))), 128))
              ]),
              (c(!0), g(de, null, Re(S.value, (_, ue) => (c(), g("div", {
                key: ue,
                role: "row",
                "data-testid": "datepicker-day-row",
                class: "flex items-center"
              }, [
                (c(!0), g(de, null, Re(_, ({ cell: se, index: Q }) => (c(), W(Hr, {
                  key: se.iso,
                  type: "Day",
                  state: E(se),
                  text: se.label,
                  muted: !se.inMonth,
                  role: "gridcell",
                  tabindex: Q === xe.value ? 0 : -1,
                  "aria-selected": L(D).has(se.state) ? "true" : void 0,
                  "aria-label": z(se),
                  onClick: (ae) => ge(se),
                  onMouseover: (ae) => A.value = se.iso,
                  onMouseout: F[0] || (F[0] = (ae) => A.value = null)
                }, null, 8, ["state", "text", "muted", "tabindex", "aria-selected", "aria-label", "onClick", "onMouseover"]))), 128))
              ]))), 128))
            ], 32)
          ])) : (c(), g("div", {
            key: 1,
            role: "grid",
            class: "flex w-[252px] flex-col gap-1.5",
            onKeydown: Ce
          }, [
            (c(!0), g(de, null, Re(I.value, (_, ue) => (c(), g("div", {
              key: ue,
              role: "row",
              "data-testid": "datepicker-grid-row",
              class: "flex gap-1.5"
            }, [
              (c(!0), g(de, null, Re(_, ({ cell: se, index: Q }) => (c(), W(Hr, {
                key: se.iso,
                type: h.value === "month" ? "Month" : "Year",
                state: E(se),
                text: se.label,
                role: "gridcell",
                tabindex: Q === xe.value ? 0 : -1,
                "aria-selected": L(D).has(se.state) ? "true" : void 0,
                "aria-label": h.value === "month" ? Y(se) : se.state === "Disabled" ? `${se.label}, ${e.unavailableLabel}` : se.label,
                onClick: (ae) => ge(se),
                onMouseover: (ae) => A.value = se.iso,
                onMouseout: F[1] || (F[1] = (ae) => A.value = null)
              }, null, 8, ["type", "state", "text", "tabindex", "aria-selected", "aria-label", "onClick", "onMouseover"]))), 128))
            ]))), 128))
          ], 32))
        ], 512)
      ]),
      _: 2
    }, [
      e.showClearButton || e.showTodayButton ? {
        name: "actions",
        fn: ve(() => [
          e.showClearButton ? (c(), W(Me, {
            key: 0,
            variant: "secondary",
            size: "sm",
            class: "flex-1",
            "full-width": "",
            label: e.clearLabel,
            "data-testid": "datepicker-dropdown-menu-clear",
            onClick: G
          }, null, 8, ["label"])) : w("", !0),
          e.showTodayButton ? (c(), W(Me, {
            key: 1,
            variant: "primary",
            size: "sm",
            class: "flex-1",
            "full-width": "",
            label: e.todayLabel,
            disabled: P.value,
            "data-testid": "datepicker-dropdown-menu-today",
            onClick: U
          }, null, 8, ["label", "disabled"])) : w("", !0)
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["id", "open", "anchor-el", "additional-anchor-els", "dialog-label", "placement", "keep-anchor-focusable"]));
  }
}), Nz = {
  en: "mm/yyyy",
  fr: "mm/yyyy",
  nl: "mm-yyyy"
};
function Hz(e) {
  return e ?? "";
}
function jz(e) {
  return /^\d{4}$/.test(e) ? e : void 0;
}
function Vv(e) {
  return e.replace(/[my]/g, "");
}
function Wz(e, n) {
  if (!e) return "";
  const [t, a] = e.split("-");
  return `${a}${Vv(n)}${t}`;
}
function qz(e, n) {
  const t = Vv(n), [a, l] = e.split(t);
  if (!a || !l || !/^\d{2}$/.test(a) || !/^\d{4}$/.test(l)) return;
  const r = Number(a);
  if (!(r < 1 || r > 12))
    return `${l}-${a}`;
}
function yn(e, n) {
  if (!e) return "";
  const [t, a, l] = e.split("-");
  return !t || !a || !l ? "" : n.replace(/y+/, t).replace(/m+/, a).replace(/d+/, l);
}
function Uz(e) {
  const n = e.match(/([dmy])\1*|[^dmy]+/g) ?? [], t = [];
  let a = "^";
  for (const r of n)
    /^[dmy]+$/.test(r) ? (t.push({ field: r[0], length: r.length }), a += r.length > 1 ? `(\\d{${r.length}})` : "(\\d{1,2})") : a += r.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  a += "$";
  const l = t.map((r) => r.field);
  if (l.filter((r) => r === "d").length === 1 && l.filter((r) => r === "m").length === 1 && l.filter((r) => r === "y").length === 1)
    return { tokens: t, regex: new RegExp(a) };
}
function Ut(e, n) {
  const t = Uz(n);
  if (!t) return;
  const a = t.regex.exec(e);
  if (!a) return;
  let l, r, o;
  if (t.tokens.forEach((s, d) => {
    const u = Number(a[d + 1]);
    s.field === "d" ? l = u : s.field === "m" ? r = u : o = u;
  }), l === void 0 || r === void 0 || o === void 0 || r < 1 || r > 12) return;
  const i = new Date(o, r, 0).getDate();
  if (!(l < 1 || l > i))
    return `${String(o).padStart(4, "0")}-${String(r).padStart(2, "0")}-${String(l).padStart(2, "0")}`;
}
function vu(e) {
  const { inputRef: n, format: t, maskEnabled: a, disabled: l, readonly: r, onAccept: o, resolveRevertValue: i, resolveResyncValue: s } = e;
  let d = null, u = null, f = 0, b = !1;
  const h = R(!1), p = R(!1), x = R(!1), y = R(e.initialDisplayValue), k = m(() => a.value ? Bv(t.value) : null), $ = () => {
    if (!u || !n.value || k.value === null) return;
    S();
    const O = y.value || n.value.value;
    d = u(n.value, { mask: k.value, lazy: !0 }), d.value = O ?? "", x.value = !0, d.on("accept", () => {
      if (!d) return;
      const P = b;
      if (b = !1, r.value || l.value) {
        const M = i();
        d.value = M, y.value = M;
        return;
      }
      const V = d.value;
      y.value = V, !P && o(V);
    });
  }, S = () => {
    d == null || d.destroy(), d = null, x.value = !1;
  };
  ct(async () => {
    if (n.value && k.value !== null) {
      const O = ++f;
      if (u = (await import("./index-CZ98n4Cf.js")).default, !n.value || O !== f) return;
      $();
    }
  }), kt(() => {
    S();
  }), $e(k, async (O) => {
    const P = ++f;
    S(), O !== null && (u || (u = (await import("./index-CZ98n4Cf.js")).default), P === f && $());
  });
  const T = () => {
    l.value || (p.value = !0);
  }, I = () => {
    p.value = !1;
  }, A = () => {
    l.value || (h.value = !0);
  }, E = (O) => {
    y.value = O, d && (b = !0, d.value = O, b = !1);
  }, D = () => {
    h.value = !1, E(s());
  }, z = (O) => {
    if (d) return;
    const P = O.target.value;
    y.value = P, o(P);
  }, Y = (O) => {
    d ? d.value = O : (y.value = O, o(O));
  };
  let le = !1;
  return {
    displayValue: y,
    isFocused: h,
    isHovered: p,
    datePattern: k,
    isMaskAttached: x,
    handleMouseEnter: T,
    handleMouseLeave: I,
    handleFocus: A,
    handleBlur: D,
    handleInput: z,
    setValue: Y,
    syncDisplayValue: E,
    armMouseDown: (O) => {
      le = O;
    },
    consumeClick: () => {
      const O = le;
      return le = !1, O;
    }
  };
}
const Nv = {
  weekdayLabels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  monthLabels: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  monthShortLabels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  clearLabel: "Clear",
  todayLabel: "Today",
  previousLabel: "Previous month",
  nextLabel: "Next month",
  unavailableLabel: "Unavailable",
  dialogLabel: "Choose date",
  rangeStartLabel: "start of selected range",
  rangeEndLabel: "end of selected range",
  rangeBetweenLabel: "in selected range",
  rangeDialogLabel: "Choose date range",
  clearStartLabel: "Clear start date",
  clearEndLabel: "Clear end date"
}, Hv = {
  fr: {
    weekdayLabels: ["lun.", "mar.", "mer.", "jeu.", "ven.", "sam.", "dim."],
    monthLabels: [
      "janvier",
      "février",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "août",
      "septembre",
      "octobre",
      "novembre",
      "décembre"
    ],
    monthShortLabels: [
      "janv.",
      "févr.",
      "mars",
      "avril",
      "mai",
      "juin",
      "juil.",
      "août",
      "sept.",
      "oct.",
      "nov.",
      "déc."
    ],
    clearLabel: "Effacer",
    todayLabel: "Aujourd'hui",
    previousLabel: "Mois précédent",
    nextLabel: "Mois suivant",
    unavailableLabel: "Indisponible",
    dialogLabel: "Choisir une date",
    rangeStartLabel: "début de la période sélectionnée",
    rangeEndLabel: "fin de la période sélectionnée",
    rangeBetweenLabel: "dans la période sélectionnée",
    rangeDialogLabel: "Choisir une période",
    clearStartLabel: "Effacer la date de début",
    clearEndLabel: "Effacer la date de fin"
  },
  nl: {
    weekdayLabels: ["ma", "di", "wo", "do", "vr", "za", "zo"],
    monthLabels: [
      "januari",
      "februari",
      "maart",
      "april",
      "mei",
      "juni",
      "juli",
      "augustus",
      "september",
      "oktober",
      "november",
      "december"
    ],
    monthShortLabels: ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"],
    clearLabel: "Wissen",
    todayLabel: "Vandaag",
    previousLabel: "Vorige maand",
    nextLabel: "Volgende maand",
    unavailableLabel: "Niet beschikbaar",
    dialogLabel: "Kies een datum",
    rangeStartLabel: "begin van de geselecteerde periode",
    rangeEndLabel: "einde van de geselecteerde periode",
    rangeBetweenLabel: "in de geselecteerde periode",
    rangeDialogLabel: "Kies een periode",
    clearStartLabel: "Startdatum wissen",
    clearEndLabel: "Einddatum wissen"
  }
}, Gz = ["id", "name", "inputmode", "value", "placeholder", "disabled", "readonly", "autocomplete", "aria-labelledby", "aria-label", "aria-disabled", "aria-invalid", "aria-describedby", "aria-required", "aria-expanded", "aria-controls", "data-testid"], xu = /* @__PURE__ */ ye({
  __name: "DatePickerInput",
  props: {
    modelValue: { default: "" },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    placeholder: { default: void 0 },
    format: { default: void 0 },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    autohide: { type: Boolean, default: !0 },
    buttons: { type: Boolean, default: !0 },
    orientation: { default: "auto" },
    weekStart: { default: 1 },
    language: { default: "en" },
    title: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: "384px" },
    error: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    hint: { default: void 0 },
    showHint: { type: Boolean, default: !0 },
    labelInline: { type: Boolean, default: !1 },
    id: { default: void 0 },
    name: { default: void 0 },
    autocomplete: { default: void 0 },
    testId: { default: void 0 },
    maskInput: { type: Boolean, default: !0 },
    readonly: { type: Boolean, default: !1 },
    type: { default: "default" },
    dobLabels: { default: void 0 },
    dobDefaultDate: { default: void 0 },
    labels: { default: void 0 }
  },
  emits: ["update:modelValue", "changeDate", "show", "hide"],
  setup(e, { emit: n }) {
    var pe;
    const t = e, a = n, l = R(null), r = R(null), o = R(null), i = m(() => t.modelValue !== void 0 && t.modelValue !== null && t.modelValue.trim() !== ""), s = m(() => !!t.error), d = qe(), u = m(() => t.id || d), f = m(() => t.label ? `${u.value}-label` : void 0), b = m(() => `${u.value}-error`), h = m(() => `${u.value}-hint`), p = m(() => t.language.slice(0, 2).toLowerCase()), x = {
      en: "mm/dd/yyyy",
      fr: "dd/mm/yyyy",
      nl: "dd-mm-yyyy"
    }, y = m(() => t.format !== void 0 ? t.format : x[p.value] ?? "dd/mm/yyyy"), k = m(
      () => t.labels ?? Hv[p.value] ?? Nv
    ), $ = m(
      () => t.minDate ? Ut(t.minDate, y.value) ?? t.minDate : void 0
    ), S = m(
      () => t.maxDate ? Ut(t.maxDate, y.value) ?? t.maxDate : void 0
    ), T = {
      fr: { d: "j", y: "a" },
      // jour / année
      nl: { y: "j" }
      // jaar
    }, I = m(() => {
      const ke = T[p.value];
      return ke ? y.value.replace(/d+|m+|y+/g, (fe) => {
        const ze = ke[fe[0]];
        return ze ? ze.repeat(fe.length) : fe;
      }) : y.value;
    }), A = m(() => {
      var fe;
      const ke = (fe = t.hint) == null ? void 0 : fe.trim();
      return ke && ke.length > 0 ? ke : s.value ? void 0 : I.value;
    }), E = m(() => {
      var fe;
      const ke = (fe = t.placeholder) == null ? void 0 : fe.trim();
      return ke && ke.length > 0 ? ke : I.value;
    }), D = m(() => {
      const ke = [];
      return t.showHint && A.value && ke.push(h.value), s.value && ke.push(b.value), ke.length > 0 ? ke.join(" ") : void 0;
    }), z = m(() => s.value ? "true" : void 0), Y = m(() => {
      const ke = "relative rounded-xl border-solid box-border flex items-center text-left font-inter";
      if (t.disabled)
        return `${ke} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled)`;
      if (t.readonly) {
        const Ee = B.isFocused.value ? "shadow-[0px_0px_2px_var(--border-border-accent)] border-(--border-border-accent)" : "shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] border-(--border-border-base-soft) dark:border-(--border-border-base)";
        return `${ke} border-[1px] ${Ee} bg-(--colors-background-white-secondary-soft) dark:bg-(--colors-background-disabled) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-default`;
      }
      if (s.value)
        return `${ke} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (B.isFocused.value)
        return `${ke} border-[1px] shadow-[0px_0px_2px_var(--border-border-accent)] bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (B.isHovered.value)
        return `${ke} border-[1px] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      const fe = i.value ? "text-(--text-text-black-default)" : "text-(--text-text-body-subtle)";
      return `${ke} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) ${fe} dark:text-(--text-text-white-default)`;
    }), ne = {
      sm: {
        container: "h-[32px] px-2 py-1.5 gap-2",
        text: "text-sm leading-5"
      },
      md: {
        container: "h-[36px] px-3 py-2 gap-2",
        text: "text-sm leading-5"
      },
      lg: {
        container: "h-[48px] px-3.5 py-3 gap-2",
        text: "text-base leading-6"
      },
      xl: {
        container: "h-[52px] px-4 py-3.5 gap-2",
        text: "text-base leading-6"
      }
    }[t.size], re = m(() => t.fullWidth ? "w-full" : ""), O = m(() => t.fullWidth ? {} : { width: t.width }), P = m(() => {
      const ke = "relative flex pb-0.5 text-left text-sm text-text-black-default dark:text-(--colors-text-white-default) font-inter";
      return t.labelInline ? `${ke} flex-row items-center gap-2${t.fullWidth ? " w-full" : ""}` : `${ke} flex-col items-start gap-0.5${t.fullWidth ? " w-full" : ""}`;
    }), V = m(() => t.fullWidth || t.labelInline ? {} : { width: t.width });
    function M(ke) {
      if (ke === "") {
        t.modelValue && a("update:modelValue", "");
        return;
      }
      const fe = Ut(ke, y.value);
      fe !== void 0 && fe !== t.modelValue && a("update:modelValue", fe);
    }
    const B = vu({
      inputRef: l,
      format: y,
      maskEnabled: m(() => t.maskInput),
      disabled: An(t, "disabled"),
      readonly: An(t, "readonly"),
      initialDisplayValue: t.type === "dob" ? yn(t.modelValue, y.value) : t.modelValue,
      onAccept: (ke) => {
        if (t.type === "dob") {
          M(ke);
          return;
        }
        (!B.isMaskAttached.value || ke === "" || Ut(ke, y.value) !== void 0) && ke !== t.modelValue && a("update:modelValue", ke);
      },
      resolveRevertValue: () => t.type === "dob" ? yn(t.modelValue, y.value) : t.modelValue ?? "",
      resolveResyncValue: () => t.type === "dob" ? yn(t.modelValue, y.value) : t.modelValue
    });
    $e(
      () => t.modelValue,
      (ke) => {
        if (B.isFocused.value) return;
        const fe = t.type === "dob" ? yn(ke, y.value) : ke;
        B.syncDisplayValue(fe);
      }
    ), $e([y, p], ([ke], [fe]) => {
      if (t.type === "dob" && !B.isFocused.value && B.syncDisplayValue(yn(t.modelValue, ke)), t.type === "default" && !B.isFocused.value && ke !== fe) {
        const ze = Ut(B.displayValue.value, fe);
        ze !== void 0 && B.syncDisplayValue(yn(ze, ke));
      }
    });
    const q = R(!1), N = R(!1), G = m(() => `${u.value}-dob-dialog`), U = R(null), K = typeof process < "u" && ((pe = process.env) == null ? void 0 : pe.NODE_ENV) !== "production";
    function ge() {
      if (!(t.type !== "dob" || t.disabled || t.readonly) && !q.value) {
        if (!t.dobLabels) {
          K && console.error(
            '[OPAL DatePickerInput] type="dob" requires the `dobLabels` prop (see DatepickerDobLabels) — the wheel picker was not opened.'
          );
          return;
        }
        q.value = !0, N.value = !0, a("show");
      }
    }
    function xe(ke) {
      B.setValue(yn(ke, y.value)), a("changeDate", ke);
    }
    function X() {
      B.setValue(""), a("changeDate", "");
    }
    function ie() {
      var ke;
      q.value = !1, a("hide"), (ke = l.value) == null || ke.focus();
    }
    const he = R(!1), oe = R(!1), Ce = m(() => `${u.value}-default-dialog`), H = R(null), Z = R(!0), ee = m(
      () => Ut(B.displayValue.value, y.value) ?? ""
    ), J = m(() => {
      const ke = t.orientation.includes("right") ? "end" : "start";
      return `${t.orientation.includes("top") ? "top" : "bottom"}-${ke}`;
    });
    function F() {
      t.type !== "default" || t.disabled || t.readonly || he.value || (he.value = !0, oe.value = !0, a("show"));
    }
    function _(ke) {
      const fe = yn(ke, y.value);
      B.setValue(fe), a("changeDate", fe);
    }
    function ue() {
      B.setValue(""), a("changeDate", "");
    }
    function se() {
      var ke;
      he.value = !1, a("hide"), (ke = l.value) == null || ke.focus();
    }
    function Q() {
      t.type === "dob" ? ge() : F();
    }
    function ae() {
      B.armMouseDown(t.type === "dob" ? q.value : he.value);
    }
    function Te() {
      var ke;
      t.disabled || t.readonly || B.consumeClick() || (Z.value = !1, Q(), (ke = l.value) == null || ke.focus());
    }
    function Le(ke) {
      var fe, ze, Ee, He;
      if (!q.value && !he.value && ((fe = r.value) == null || fe.handleFieldKeydown(ke), (ze = o.value) == null || ze.handleFieldKeydown(ke)), !(t.disabled || t.readonly)) {
        if (ke.key === "Enter") {
          q.value ? ie() : he.value && se();
          const Ke = ni(), et = ($.value === void 0 || En(Ke, $.value) >= 0) && (S.value === void 0 || En(Ke, S.value) <= 0);
          (B.displayValue.value ?? "").trim() === "" && et && (t.type === "dob" ? xe(Ke) : _(Ke));
          return;
        }
        if (ke.key === "ArrowDown") {
          if (ke.preventDefault(), q.value) {
            (Ee = U.value) == null || Ee.focusYearColumn();
            return;
          }
          if (he.value) {
            (He = H.value) == null || He.focusGrid();
            return;
          }
          Z.value = !0, Q();
        }
      }
    }
    return (ke, fe) => (c(), g("div", {
      class: C(P.value),
      style: je(V.value),
      "data-testid": "date-picker-wrapper"
    }, [
      e.label ? (c(), W(It, {
        key: 0,
        id: f.value,
        ref_key: "labelRef",
        ref: r,
        text: e.label,
        "input-id": u.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: L(B).isFocused.value,
        inline: e.labelInline,
        class: C(e.labelInline ? "" : "order-1"),
        "test-id": "date-picker-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline", "class"])) : w("", !0),
      v("div", {
        class: C(e.labelInline ? "flex flex-col gap-0.5" : "contents")
      }, [
        te($t, {
          ref_key: "helperRef",
          ref: o,
          focused: L(B).isFocused.value,
          class: "order-3",
          hint: e.showHint ? A.value : void 0,
          error: e.error,
          "hint-id": h.value,
          "error-id": b.value,
          "error-live": e.errorLive,
          "test-id-prefix": "date-picker"
        }, null, 8, ["focused", "hint", "error", "hint-id", "error-id", "error-live"]),
        v("div", {
          class: C([Y.value, L(ne).container, re.value, "order-2"]),
          style: je(O.value),
          "data-testid": "date-picker-container",
          onMouseenter: fe[3] || (fe[3] = //@ts-ignore
          (...ze) => L(B).handleMouseEnter && L(B).handleMouseEnter(...ze)),
          onMouseleave: fe[4] || (fe[4] = //@ts-ignore
          (...ze) => L(B).handleMouseLeave && L(B).handleMouseLeave(...ze)),
          onMousedown: ae,
          onClick: Te
        }, [
          v("i", {
            "aria-hidden": "true",
            "data-testid": "date-picker-calendar-icon",
            class: C([
              "ri-calendar-line",
              L(ne).text,
              e.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
            ])
          }, null, 2),
          v("input", {
            id: u.value,
            ref_key: "inputRef",
            ref: l,
            name: e.name,
            type: "text",
            inputmode: L(B).datePattern.value ? "numeric" : void 0,
            value: L(B).displayValue.value,
            placeholder: E.value,
            disabled: e.disabled,
            readonly: e.readonly,
            autocomplete: e.autocomplete ?? "off",
            "aria-labelledby": f.value,
            "aria-label": e.label ? void 0 : e.ariaLabel,
            "aria-disabled": e.disabled ? "true" : void 0,
            "aria-invalid": z.value,
            "aria-describedby": D.value,
            "aria-required": e.required ? "true" : void 0,
            role: "combobox",
            "aria-haspopup": "dialog",
            "aria-expanded": e.type === "dob" ? q.value : he.value,
            "aria-controls": e.type === "dob" ? N.value ? G.value : void 0 : oe.value ? Ce.value : void 0,
            "data-testid": e.testId ?? "date-picker-input",
            class: C([
              "flex-1 min-w-0 relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 forced-colors:focus-visible:outline forced-colors:focus-visible:outline-2 forced-colors:focus-visible:outline-offset-2 placeholder:text-text-body-subtle dark:placeholder:text-(--colors-text-white-secondary) pl-0",
              !e.disabled && !e.readonly && "cursor-text",
              L(ne).text
            ]),
            onFocus: fe[0] || (fe[0] = //@ts-ignore
            (...ze) => L(B).handleFocus && L(B).handleFocus(...ze)),
            onBlur: fe[1] || (fe[1] = //@ts-ignore
            (...ze) => L(B).handleBlur && L(B).handleBlur(...ze)),
            onInput: fe[2] || (fe[2] = //@ts-ignore
            (...ze) => L(B).handleInput && L(B).handleInput(...ze)),
            onKeydown: Le
          }, null, 42, Gz)
        ], 38)
      ], 2),
      e.type === "dob" && l.value && N.value ? (c(), W(Rz, Fe({ key: 1 }, e.dobLabels, {
        id: G.value,
        ref_key: "dobPickerRef",
        ref: U,
        open: q.value,
        "model-value": e.modelValue,
        "anchor-el": l.value,
        "auto-focus-on-open": Z.value,
        "min-date": $.value,
        "max-date": S.value,
        "default-date": e.dobDefaultDate,
        "onUpdate:open": fe[5] || (fe[5] = (ze) => q.value = ze),
        "onUpdate:modelValue": xe,
        onClear: X,
        onClose: ie
      }), null, 16, ["id", "open", "model-value", "anchor-el", "auto-focus-on-open", "min-date", "max-date", "default-date"])) : w("", !0),
      e.type === "default" && l.value && oe.value ? (c(), W(Uc, {
        key: 2,
        id: Ce.value,
        ref_key: "defaultDropdownMenuRef",
        ref: H,
        open: he.value,
        "model-value": ee.value,
        "anchor-el": l.value,
        "keep-anchor-focusable": "",
        "auto-focus-on-open": Z.value,
        "min-date": $.value,
        "max-date": S.value,
        "today-button-mode": "select",
        "show-today-button": e.buttons,
        "show-clear-button": e.buttons,
        placement: J.value,
        "weekday-labels": k.value.weekdayLabels,
        "month-labels": k.value.monthLabels,
        "month-short-labels": k.value.monthShortLabels,
        "clear-label": k.value.clearLabel,
        "today-label": k.value.todayLabel,
        "previous-label": k.value.previousLabel,
        "next-label": k.value.nextLabel,
        "unavailable-label": k.value.unavailableLabel,
        "dialog-label": k.value.dialogLabel,
        "onUpdate:open": fe[6] || (fe[6] = (ze) => he.value = ze),
        "onUpdate:modelValue": _,
        onClear: ue,
        onClose: se
      }, null, 8, ["id", "open", "model-value", "anchor-el", "auto-focus-on-open", "min-date", "max-date", "show-today-button", "show-clear-button", "placement", "weekday-labels", "month-labels", "month-short-labels", "clear-label", "today-label", "previous-label", "next-label", "unavailable-label", "dialog-label"])) : w("", !0)
    ], 6));
  }
}), Kz = { class: "relative flex flex-col items-start gap-0.5 text-left text-(length:--size-m) font-inter" }, Yz = ["id", "inputmode", "value", "disabled", "aria-labelledby", "aria-required", "aria-invalid", "aria-describedby", "aria-expanded", "data-testid"], wq = /* @__PURE__ */ ye({
  __name: "YearMonthPickerInput",
  props: {
    type: {},
    modelValue: { default: "" },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    language: { default: "en" },
    disabled: { type: Boolean, default: !1 },
    showTodayButton: { type: Boolean, default: !1 },
    todayButtonMode: { default: "highlight" },
    weekdayLabels: {},
    monthLabels: {},
    monthShortLabels: {},
    clearLabel: {},
    todayLabel: {},
    previousLabel: {},
    nextLabel: {},
    unavailableLabel: {},
    dialogLabel: {},
    testId: { default: void 0 }
  },
  emits: ["update:modelValue", "select"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => t.language.slice(0, 2).toLowerCase()), r = m(() => Nz[l.value] ?? "mm/yyyy"), o = m(() => t.type === "year" ? "yyyy" : r.value), i = m(() => Bv(o.value));
    function s(U) {
      return t.type === "year" ? Hz(U) : Wz(U, r.value);
    }
    function d(U) {
      return t.type === "year" ? jz(U) : qz(U, r.value);
    }
    const u = R(null), f = R(null), b = R(!1), h = R(!1), p = R(null), x = R(null), y = R(s(t.modelValue));
    let k = null, $ = null, S = 0;
    function T() {
      k == null || k.destroy(), k = null;
    }
    function I() {
      !$ || !u.value || i.value === null || (T(), k = $(u.value, { mask: i.value, lazy: !0 }), k.value = y.value, k.on("accept", () => {
        if (!k) return;
        const U = k.value;
        if (y.value = U, U === "") {
          t.modelValue !== "" && a("update:modelValue", "");
          return;
        }
        const K = d(U);
        K !== void 0 && K !== t.modelValue && a("update:modelValue", K);
      }));
    }
    ct(async () => {
      if (!u.value || i.value === null) return;
      const U = ++S;
      $ = (await import("./index-CZ98n4Cf.js")).default, !(!u.value || U !== S) && I();
    }), kt(() => {
      T();
    }), $e(
      () => t.modelValue,
      (U) => {
        if (h.value) return;
        const K = s(U);
        y.value = K, k && (k.value = K);
      }
    ), $e([i], async () => {
      const U = ++S;
      T(), i.value !== null && ($ || ($ = (await import("./index-CZ98n4Cf.js")).default), U === S && I());
    });
    function A() {
      t.disabled || (h.value = !0);
    }
    function E() {
      h.value = !1;
      const U = s(t.modelValue);
      y.value = U, k && (k.value = U);
    }
    function D(U) {
      if (k) return;
      const K = U.target.value;
      y.value = K;
      const ge = d(K);
      ge !== void 0 && a("update:modelValue", ge);
    }
    function z() {
      t.disabled || (b.value = !0);
    }
    function Y(U) {
      var K, ge;
      b.value || ((K = p.value) == null || K.handleFieldKeydown(U), (ge = x.value) == null || ge.handleFieldKeydown(U)), !(U.key !== "Enter" && U.key !== " " && U.key !== "ArrowDown") && (U.preventDefault(), z());
    }
    function le(U) {
      a("select", U);
    }
    function ne() {
      var U;
      (U = u.value) == null || U.focus();
    }
    const O = qe(), P = m(() => t.label ? `${O}-label` : void 0), V = `${O}-dialog`, M = `${O}-hint`, B = `${O}-error`, q = m(() => {
      const U = [];
      return t.hint && U.push(M), t.error && U.push(B), U.length > 0 ? U.join(" ") : void 0;
    }), N = m(() => t.disabled ? "border-border-disabled-subtle bg-gainsboro-200 dark:border-(--colors-border-disabled-subtle) dark:bg-(--colors-background-disabled)" : t.error ? "border-(--border-border-error-strong) bg-(--background-background-white) dark:border-(--border-border-error) dark:bg-(--background-background-black-default)" : "border-(--border-border-base-medium) bg-(--background-background-white) dark:border-(--border-border-base) dark:bg-(--background-background-black-default)"), G = m(
      () => t.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
    );
    return (U, K) => (c(), g("div", Kz, [
      e.label ? (c(), W(It, {
        key: 0,
        id: P.value,
        ref_key: "labelRef",
        ref: p,
        text: e.label,
        "input-id": L(O),
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: h.value,
        "test-id": "year-month-picker-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused"])) : w("", !0),
      v("div", {
        ref_key: "triggerRef",
        ref: f,
        class: C([
          "relative flex h-[36px] items-center gap-2 rounded-xl border-[1px] border-solid px-3 py-2",
          N.value
        ])
      }, [
        v("i", {
          "aria-hidden": "true",
          class: C(["ri-calendar-line text-sm", G.value])
        }, null, 2),
        v("input", {
          id: L(O),
          ref_key: "inputRef",
          ref: u,
          type: "text",
          inputmode: i.value ? "numeric" : void 0,
          value: y.value,
          disabled: e.disabled,
          "aria-labelledby": P.value,
          "aria-required": e.required ? "true" : void 0,
          "aria-invalid": e.error ? "true" : void 0,
          "aria-describedby": q.value,
          "aria-haspopup": "dialog",
          "aria-expanded": b.value,
          "aria-controls": V,
          "data-testid": e.testId ?? "year-month-picker-input",
          class: "min-w-0 flex-1 border-0 bg-transparent text-(length:--size-m) leading-(--line-height-l) outline-none placeholder:text-text-body-subtle focus:outline-none focus:ring-0",
          onFocus: A,
          onBlur: E,
          onInput: D,
          onClick: z,
          onKeydown: Y
        }, null, 40, Yz)
      ], 2),
      te($t, {
        ref_key: "helperRef",
        ref: x,
        class: "self-stretch",
        focused: h.value,
        hint: e.hint,
        error: e.error,
        "hint-id": M,
        "error-id": B,
        "error-live": e.errorLive,
        "test-id-prefix": "year-month-picker"
      }, null, 8, ["focused", "hint", "error", "error-live"]),
      f.value ? (c(), W(Uc, {
        key: 1,
        id: V,
        open: b.value,
        "onUpdate:open": K[0] || (K[0] = (ge) => b.value = ge),
        "model-value": e.modelValue,
        "anchor-el": f.value,
        mode: e.type,
        "min-date": e.minDate,
        "max-date": e.maxDate,
        "show-today-button": e.showTodayButton,
        "today-button-mode": e.todayButtonMode,
        "weekday-labels": e.weekdayLabels,
        "month-labels": e.monthLabels,
        "month-short-labels": e.monthShortLabels,
        "clear-label": e.clearLabel,
        "today-label": e.todayLabel,
        "previous-label": e.previousLabel,
        "next-label": e.nextLabel,
        "unavailable-label": e.unavailableLabel,
        "dialog-label": e.dialogLabel,
        "onUpdate:modelValue": K[1] || (K[1] = (ge) => a("update:modelValue", ge)),
        onSelect: le,
        onClear: K[2] || (K[2] = (ge) => a("update:modelValue", "")),
        onClose: ne
      }, null, 8, ["open", "model-value", "anchor-el", "mode", "min-date", "max-date", "show-today-button", "today-button-mode", "weekday-labels", "month-labels", "month-short-labels", "clear-label", "today-label", "previous-label", "next-label", "unavailable-label", "dialog-label"])) : w("", !0)
    ]));
  }
}), Jz = {
  class: "flex flex-col gap-0.5 pb-0.5",
  "data-testid": "date-range-wrapper"
}, Xz = ["id", "value", "placeholder", "disabled", "readonly", "inputmode", "aria-expanded", "aria-controls", "aria-labelledby", "aria-label", "aria-required", "aria-invalid", "aria-describedby"], Zz = ["aria-label"], Qz = ["id", "value", "placeholder", "disabled", "readonly", "inputmode", "aria-expanded", "aria-controls", "aria-labelledby", "aria-label", "aria-required", "aria-invalid", "aria-describedby"], _z = ["aria-label"], e3 = /* @__PURE__ */ ye({
  __name: "DateRangePickerInput",
  props: {
    startDate: { default: "" },
    endDate: { default: "" },
    startLabel: { default: "From" },
    endLabel: { default: "To" },
    startPlaceholder: { default: "Select date start" },
    endPlaceholder: { default: "Select date end" },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    format: { default: void 0 },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    buttons: { type: Boolean, default: !0 },
    weekStart: { default: 1 },
    language: { default: "en" },
    disabled: { type: Boolean, default: !1 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    error: { default: void 0 },
    hint: { default: void 0 },
    readonly: { type: Boolean, default: !0 },
    labels: { default: void 0 }
  },
  emits: ["update:startDate", "update:endDate", "changeDate"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R(null), r = R(null), o = qe(), i = m(() => t.language.slice(0, 2).toLowerCase()), s = {
      en: "mm/dd/yyyy",
      fr: "dd/mm/yyyy",
      nl: "dd-mm-yyyy"
    }, d = m(() => t.format !== void 0 ? t.format : s[i.value] ?? "mm/dd/yyyy"), u = m(
      () => t.labels ?? Hv[i.value] ?? Nv
    ), f = m(() => !!t.error), b = qe(), h = m(() => `${b}-start-input`), p = m(() => `${b}-end-input`), x = m(() => t.startLabel ? `${b}-start-label` : void 0), y = m(() => t.endLabel ? `${b}-end-label` : void 0), k = m(() => `${b}-hint`), $ = R(null), S = R(null), T = R(null), I = m(() => `${b}-error`), A = m(() => {
      const pe = [];
      return t.hint && pe.push(k.value), f.value && pe.push(I.value), pe.length > 0 ? pe.join(" ") : void 0;
    }), E = R(!1), D = R(null), z = R(null), Y = R("start"), le = R("start"), ne = R(!1), re = R(!0), O = vu({
      inputRef: l,
      format: d,
      maskEnabled: m(() => !t.readonly),
      disabled: An(t, "disabled"),
      readonly: An(t, "readonly"),
      initialDisplayValue: t.startDate,
      onAccept: (pe) => {
        if (pe === "") {
          t.startDate !== "" && (a("update:startDate", ""), a("changeDate", { startDate: "", endDate: P.displayValue.value }));
          return;
        }
        Ut(pe, d.value) !== void 0 && pe !== t.startDate && (a("update:startDate", pe), a("changeDate", { startDate: pe, endDate: P.displayValue.value }));
      },
      resolveRevertValue: () => t.startDate,
      resolveResyncValue: () => t.startDate
    }), P = vu({
      inputRef: r,
      format: d,
      maskEnabled: m(() => !t.readonly),
      disabled: An(t, "disabled"),
      readonly: An(t, "readonly"),
      initialDisplayValue: t.endDate,
      onAccept: (pe) => {
        if (pe === "") {
          t.endDate !== "" && (a("update:endDate", ""), a("changeDate", { startDate: O.displayValue.value, endDate: "" }));
          return;
        }
        Ut(pe, d.value) !== void 0 && pe !== t.endDate && (a("update:endDate", pe), a("changeDate", { startDate: O.displayValue.value, endDate: pe }));
      },
      resolveRevertValue: () => t.endDate,
      resolveResyncValue: () => t.endDate
    });
    $e(
      () => t.startDate,
      (pe) => {
        O.isFocused.value || O.syncDisplayValue(pe);
      }
    ), $e(
      () => t.endDate,
      (pe) => {
        P.isFocused.value || P.syncDisplayValue(pe);
      }
    ), $e([d], ([pe], [ke]) => {
      if (pe !== ke) {
        if (!O.isFocused.value) {
          const fe = Ut(O.displayValue.value, ke);
          fe !== void 0 && O.syncDisplayValue(yn(fe, pe));
        }
        if (!P.isFocused.value) {
          const fe = Ut(P.displayValue.value, ke);
          fe !== void 0 && P.syncDisplayValue(yn(fe, pe));
        }
      }
    });
    const V = (pe, ke, fe) => {
      const ze = "relative rounded-xl border-solid box-border flex items-center text-left font-inter";
      return t.disabled ? `${ze} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled)` : f.value ? `${ze} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error) text-(--text-text-black-default) dark:text-(--text-text-white-default)` : pe || ke ? `${ze} border-[1px] shadow-[0px_0px_2px_var(--border-border-accent)] bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)` : `${ze} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) ${fe ? "text-(--text-text-black-default)" : "text-(--text-text-body-subtle)"} dark:text-(--text-text-white-default)`;
    }, M = m(
      () => V(O.isFocused.value, O.isHovered.value, !!t.startDate)
    ), B = m(
      () => V(P.isFocused.value, P.isHovered.value, !!t.endDate)
    ), N = {
      sm: { container: "h-[32px] px-2 py-1.5 gap-2", text: "text-sm leading-5", icon: "h-4 w-4" },
      md: { container: "h-[36px] px-3 py-2 gap-2", text: "text-sm leading-5", icon: "h-4 w-4" },
      lg: { container: "h-[48px] px-3.5 py-3 gap-2", text: "text-base leading-6", icon: "h-5 w-5" },
      xl: { container: "h-[52px] px-4 py-3.5 gap-2", text: "text-base leading-6", icon: "h-5 w-5" }
    }[t.size], G = m(
      () => t.fullWidth ? "flex flex-col items-start gap-0.5 flex-1 min-w-0" : "flex flex-col items-start gap-0.5"
    ), U = m(() => t.fullWidth ? "w-full" : "w-[180px]"), K = m(
      () => t.fullWidth ? "flex flex-row gap-4 w-full" : "flex flex-row gap-4"
    ), ge = m(() => Ut(t.startDate, d.value) ?? ""), xe = m(() => Ut(t.endDate, d.value) ?? ""), X = m(
      () => t.minDate ? Ut(t.minDate, d.value) ?? t.minDate : void 0
    ), ie = m(
      () => t.maxDate ? Ut(t.maxDate, d.value) ?? t.maxDate : void 0
    );
    function he() {
      const pe = ni();
      return (X.value === void 0 || En(pe, X.value) >= 0) && (ie.value === void 0 || En(pe, ie.value) <= 0);
    }
    function oe(pe) {
      var ze;
      D.value = pe;
      const ke = pe === r.value ? "end" : "start";
      le.value = ke;
      const fe = ke === "end" ? t.endDate !== "" : t.startDate !== "";
      ne.value = fe, Y.value = ne.value ? ke : t.startDate === "" ? "start" : "end", E.value = !0, (ze = z.value) == null || ze.reseedVisibleGrid(ke);
    }
    function Ce() {
      O.armMouseDown(E.value && D.value === l.value);
    }
    function H() {
      var pe;
      t.disabled || O.consumeClick() || (re.value = !1, oe(l.value), (pe = l.value) == null || pe.focus());
    }
    function Z(pe) {
      var fe;
      if (t.disabled) return;
      pe.preventDefault();
      const ke = E.value;
      re.value = !0, oe(l.value), ke && ((fe = z.value) == null || fe.focusGrid("start"));
    }
    function ee(pe) {
      var fe, ze;
      if (E.value || ((fe = $.value) == null || fe.handleFieldKeydown(pe), (ze = T.value) == null || ze.handleFieldKeydown(pe)), pe.key === "ArrowDown") {
        Z(pe);
        return;
      }
      if (pe.key !== "Enter" || t.disabled || t.readonly) return;
      E.value && (E.value = !1), O.displayValue.value.trim() === "" && he() && O.setValue(yn(ni(), d.value));
    }
    function J() {
      P.armMouseDown(E.value && D.value === r.value);
    }
    function F() {
      var pe;
      t.disabled || P.consumeClick() || (re.value = !1, oe(r.value), (pe = r.value) == null || pe.focus());
    }
    function _(pe) {
      var fe;
      if (t.disabled) return;
      pe.preventDefault();
      const ke = E.value;
      re.value = !0, oe(r.value), ke && ((fe = z.value) == null || fe.focusGrid("end"));
    }
    function ue(pe) {
      var fe, ze;
      if (E.value || ((fe = S.value) == null || fe.handleFieldKeydown(pe), (ze = T.value) == null || ze.handleFieldKeydown(pe)), pe.key === "ArrowDown") {
        _(pe);
        return;
      }
      if (pe.key !== "Enter" || t.disabled || t.readonly) return;
      E.value && (E.value = !1), P.displayValue.value.trim() === "" && he() && P.setValue(yn(ni(), d.value));
    }
    function se(pe) {
      const ke = yn(pe, d.value);
      if (ne.value) {
        if (Y.value === "start") {
          O.setValue(ke);
          const ze = Ut(t.endDate, d.value);
          ze !== void 0 && pe > ze && P.setValue("");
        } else {
          P.setValue(ke);
          const ze = Ut(t.startDate, d.value);
          ze !== void 0 && pe < ze && O.setValue("");
        }
        E.value = !1;
        return;
      }
      if (Y.value === "start") {
        O.setValue(ke);
        const ze = Ut(t.endDate, d.value);
        ze !== void 0 && pe > ze && P.setValue(""), Y.value = "end";
        return;
      }
      const fe = Ut(t.startDate, d.value);
      if (fe !== void 0 && pe < fe) {
        O.setValue(ke), P.setValue(""), Y.value = "end";
        return;
      }
      P.setValue(ke), E.value = !1;
    }
    function Q() {
      E.value = !1;
    }
    function ae() {
      O.setValue(""), P.setValue(""), Y.value = "start", ne.value = !1;
    }
    function Te() {
      O.consumeClick(), O.setValue("");
    }
    function Le() {
      P.consumeClick(), P.setValue("");
    }
    return (pe, ke) => (c(), g("div", Jz, [
      v("div", {
        class: C(K.value),
        "data-testid": "date-range-row"
      }, [
        v("div", {
          class: C(G.value)
        }, [
          e.startLabel ? (c(), W(It, {
            key: 0,
            id: x.value,
            ref_key: "startLabelRef",
            ref: $,
            text: e.startLabel,
            "input-id": h.value,
            required: e.required,
            "required-indicator": e.requiredIndicator,
            tooltip: e.labelTooltip,
            focused: L(O).isFocused.value,
            "test-id": "date-range-start-label"
          }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused"])) : w("", !0),
          v("div", {
            class: C([M.value, L(N).container, U.value]),
            "data-testid": "date-range-start-container",
            onMouseenter: ke[3] || (ke[3] = //@ts-ignore
            (...fe) => L(O).handleMouseEnter && L(O).handleMouseEnter(...fe)),
            onMouseleave: ke[4] || (ke[4] = //@ts-ignore
            (...fe) => L(O).handleMouseLeave && L(O).handleMouseLeave(...fe)),
            onMousedown: Ce,
            onClick: H
          }, [
            v("i", {
              class: C([
                "ri-calendar-line",
                L(N).icon,
                e.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
              ])
            }, null, 2),
            v("input", {
              id: h.value,
              ref_key: "startInputRef",
              ref: l,
              name: "start",
              type: "text",
              value: L(O).displayValue.value,
              placeholder: e.startPlaceholder,
              disabled: e.disabled,
              readonly: e.readonly,
              autocomplete: "off",
              inputmode: L(O).datePattern.value ? "numeric" : void 0,
              role: "combobox",
              "aria-haspopup": "dialog",
              "aria-expanded": E.value && D.value === l.value,
              "aria-controls": E.value && D.value === l.value ? L(o) : void 0,
              "aria-labelledby": x.value,
              "aria-label": x.value ? void 0 : e.startPlaceholder,
              "aria-required": e.required ? "true" : void 0,
              "aria-invalid": f.value ? "true" : void 0,
              "aria-describedby": A.value,
              "data-testid": "date-range-start-input",
              class: C([
                // forced-colors:focus-visible: mirrors DatePickerInput.vue's own gap fix — the
                // designed focus indicator lives on the CONTAINER (startInputClasses, CSS-var
                // border + box-shadow), and Windows High Contrast Mode suppresses both, so a real
                // outline is re-added here, painted by the UA in the system Highlight color.
                "flex-1 relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 forced-colors:focus-visible:outline forced-colors:focus-visible:outline-2 forced-colors:focus-visible:outline-offset-2 placeholder:text-text-body-subtle dark:placeholder:text-(--colors-text-white-secondary) min-w-0",
                !e.disabled && !e.readonly ? "cursor-text" : "cursor-pointer",
                L(N).text
              ]),
              onFocus: ke[0] || (ke[0] = //@ts-ignore
              (...fe) => L(O).handleFocus && L(O).handleFocus(...fe)),
              onBlur: ke[1] || (ke[1] = //@ts-ignore
              (...fe) => L(O).handleBlur && L(O).handleBlur(...fe)),
              onInput: ke[2] || (ke[2] = //@ts-ignore
              (...fe) => L(O).handleInput && L(O).handleInput(...fe)),
              onKeydown: ee
            }, null, 42, Xz),
            e.disabled ? w("", !0) : (c(), g("button", {
              key: 0,
              type: "button",
              "data-testid": "date-range-start-clear",
              class: C([
                "shrink-0 flex items-center justify-center text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default) bg-transparent border-0 p-0 transition-opacity",
                e.startDate ? "opacity-100 hover:opacity-70 cursor-pointer" : "hidden"
              ]),
              "aria-label": u.value.clearStartLabel,
              onClick: Je(Te, ["stop"])
            }, [
              v("i", {
                class: C(["ri-close-line", L(N).icon])
              }, null, 2)
            ], 10, Zz))
          ], 34)
        ], 2),
        v("div", {
          class: C(G.value)
        }, [
          e.endLabel ? (c(), W(It, {
            key: 0,
            id: y.value,
            ref_key: "endLabelRef",
            ref: S,
            text: e.endLabel,
            "input-id": p.value,
            required: e.required,
            "required-indicator": e.requiredIndicator,
            focused: L(P).isFocused.value,
            "test-id": "date-range-end-label"
          }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "focused"])) : w("", !0),
          v("div", {
            class: C([B.value, L(N).container, U.value]),
            "data-testid": "date-range-end-container",
            onMouseenter: ke[8] || (ke[8] = //@ts-ignore
            (...fe) => L(P).handleMouseEnter && L(P).handleMouseEnter(...fe)),
            onMouseleave: ke[9] || (ke[9] = //@ts-ignore
            (...fe) => L(P).handleMouseLeave && L(P).handleMouseLeave(...fe)),
            onMousedown: J,
            onClick: F
          }, [
            v("i", {
              class: C([
                "ri-calendar-line",
                L(N).icon,
                e.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
              ])
            }, null, 2),
            v("input", {
              id: p.value,
              ref_key: "endInputRef",
              ref: r,
              name: "end",
              type: "text",
              value: L(P).displayValue.value,
              placeholder: e.endPlaceholder,
              disabled: e.disabled,
              readonly: e.readonly,
              autocomplete: "off",
              inputmode: L(P).datePattern.value ? "numeric" : void 0,
              role: "combobox",
              "aria-haspopup": "dialog",
              "aria-expanded": E.value && D.value === r.value,
              "aria-controls": E.value && D.value === r.value ? L(o) : void 0,
              "aria-labelledby": y.value,
              "aria-label": y.value ? void 0 : e.endPlaceholder,
              "aria-required": e.required ? "true" : void 0,
              "aria-invalid": f.value ? "true" : void 0,
              "aria-describedby": A.value,
              "data-testid": "date-range-end-input",
              class: C([
                // See the Start input's own class comment above — same forced-colors rationale.
                "flex-1 relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 forced-colors:focus-visible:outline forced-colors:focus-visible:outline-2 forced-colors:focus-visible:outline-offset-2 placeholder:text-text-body-subtle dark:placeholder:text-(--colors-text-white-secondary) min-w-0",
                !e.disabled && !e.readonly ? "cursor-text" : "cursor-pointer",
                L(N).text
              ]),
              onFocus: ke[5] || (ke[5] = //@ts-ignore
              (...fe) => L(P).handleFocus && L(P).handleFocus(...fe)),
              onBlur: ke[6] || (ke[6] = //@ts-ignore
              (...fe) => L(P).handleBlur && L(P).handleBlur(...fe)),
              onInput: ke[7] || (ke[7] = //@ts-ignore
              (...fe) => L(P).handleInput && L(P).handleInput(...fe)),
              onKeydown: ue
            }, null, 42, Qz),
            e.disabled ? w("", !0) : (c(), g("button", {
              key: 0,
              type: "button",
              "data-testid": "date-range-end-clear",
              class: C([
                "shrink-0 flex items-center justify-center text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default) bg-transparent border-0 p-0 transition-opacity",
                e.endDate ? "opacity-100 hover:opacity-70 cursor-pointer" : "hidden"
              ]),
              "aria-label": u.value.clearEndLabel,
              onClick: Je(Le, ["stop"])
            }, [
              v("i", {
                class: C(["ri-close-line", L(N).icon])
              }, null, 2)
            ], 10, _z))
          ], 34)
        ], 2)
      ], 2),
      te($t, {
        ref_key: "helperRef",
        ref: T,
        focused: L(O).isFocused.value || L(P).isFocused.value,
        hint: e.hint,
        error: e.error,
        "hint-id": k.value,
        "error-id": I.value,
        "test-id-prefix": "date-range"
      }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"]),
      D.value ? (c(), W(Uc, {
        key: 0,
        id: L(o),
        ref_key: "dropdownMenuRef",
        ref: z,
        open: E.value,
        "anchor-el": D.value,
        "additional-anchor-els": [l.value, r.value],
        "keep-anchor-focusable": "",
        "auto-focus-on-open": re.value,
        "start-date": ge.value,
        "end-date": xe.value,
        "seed-field": le.value,
        "min-date": X.value,
        "max-date": ie.value,
        "today-button-mode": "select",
        "show-today-button": e.buttons,
        "show-clear-button": e.buttons,
        "weekday-labels": u.value.weekdayLabels,
        "month-labels": u.value.monthLabels,
        "month-short-labels": u.value.monthShortLabels,
        "clear-label": u.value.clearLabel,
        "today-label": u.value.todayLabel,
        "previous-label": u.value.previousLabel,
        "next-label": u.value.nextLabel,
        "unavailable-label": u.value.unavailableLabel,
        "range-start-label": u.value.rangeStartLabel,
        "range-end-label": u.value.rangeEndLabel,
        "range-between-label": u.value.rangeBetweenLabel,
        "dialog-label": u.value.rangeDialogLabel,
        "onUpdate:open": ke[10] || (ke[10] = (fe) => E.value = fe),
        onRangeSelect: se,
        onClear: ae,
        onClose: Q
      }, null, 8, ["id", "open", "anchor-el", "additional-anchor-els", "auto-focus-on-open", "start-date", "end-date", "seed-field", "min-date", "max-date", "show-today-button", "show-clear-button", "weekday-labels", "month-labels", "month-short-labels", "clear-label", "today-label", "previous-label", "next-label", "unavailable-label", "range-start-label", "range-end-label", "range-between-label", "dialog-label"])) : w("", !0)
    ]));
  }
}), t3 = { class: "flex w-full items-end gap-3" }, n3 = ["id", "value", "name", "title", "placeholder", "disabled", "readonly", "required", "autocomplete", "aria-labelledby", "aria-invalid", "aria-describedby", "aria-required", "aria-disabled"], a3 = ["aria-label", "onKeydown"], l3 = /* @__PURE__ */ ye({
  __name: "UrlInput",
  props: {
    modelValue: { default: "" },
    prefix: { default: void 0 },
    iconLeft: { default: void 0 },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    requiredIndicator: { default: "*" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    hint: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    autocomplete: { default: "off" },
    error: { default: void 0 },
    validator: { type: Function, default: void 0 },
    validateOnBlur: { type: Boolean, default: !0 },
    validateOnInput: { type: Boolean, default: !1 },
    invalidUrlMessage: { default: "Please enter a valid URL" },
    requiredMessage: { default: "URL is required" },
    buttonLabels: { default: () => ({
      label: "",
      labelWhenCopied: ""
    }) },
    resolvedUrl: { default: void 0 },
    labels: { default: () => ({ clear: "Clear input" }) }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "clear", "validation-change"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = R(!1), o = R(null), i = R(null), s = R(!1), d = R(!1), u = R(void 0), f = (U) => {
      if (a.validator)
        return a.validator(U) ?? void 0;
      if (a.required && !U.trim())
        return a.requiredMessage;
      if (U.trim())
        try {
          const K = !a.prefix && /^https?:\/\/|^ftps?:\/\//i.test(U), xe = new URL(K ? U : (a.prefix || "https://") + U).hostname.split("."), X = xe[xe.length - 1];
          if (xe.length < 2 || X.length < 2)
            return a.invalidUrlMessage;
        } catch {
          return a.invalidUrlMessage;
        }
    }, b = () => {
      const U = f(a.modelValue ?? "");
      u.value = U, l("validation-change", !U, U);
    }, h = m(() => {
      if (a.error) return a.error;
      if (d.value && s.value) return u.value;
    }), p = m(() => !!(a.modelValue ?? "").trim()), x = m(
      () => d.value && s.value && !h.value && p.value
    ), y = (U) => U && !r.value && !a.disabled && !a.readonly, k = m(
      () => r.value && p.value && !a.disabled && !a.readonly
    ), $ = m(() => {
      var U;
      return !!((U = a.buttonLabels) != null && U.label);
    }), S = m(() => a.fullWidth || a.width === void 0), T = (U) => {
      const K = U.target;
      d.value = !0, l("update:modelValue", K.value), l("input", U), a.validateOnInput && b();
    }, I = (U) => {
      r.value = !0, l("focus", U);
    }, A = (U) => {
      r.value = !1, s.value = !0, l("blur", U), a.validateOnBlur && b();
    }, E = (U) => {
      var K, ge;
      (K = o.value) == null || K.handleFieldKeydown(U), (ge = i.value) == null || ge.handleFieldKeydown(U);
    }, D = () => {
      l("update:modelValue", ""), l("clear");
    }, z = R("idle"), Y = m(() => {
      if (a.resolvedUrl !== void 0) return a.resolvedUrl;
      const U = a.modelValue ?? "";
      return U.trim() ? !a.prefix && /^https?:\/\/|^ftps?:\/\//i.test(U) ? U : (a.prefix ?? "") + U : "";
    });
    async function le() {
      if (Y.value)
        try {
          await navigator.clipboard.writeText(Y.value), z.value = "copied", setTimeout(() => {
            z.value = "idle";
          }, 2e3);
        } catch (U) {
          console.error("Copy failed", U);
        }
    }
    const ne = m(() => a.buttonLabels ? z.value === "copied" ? a.buttonLabels.labelWhenCopied : a.buttonLabels.label : ""), re = m(
      () => z.value === "copied" ? "ri-check-line" : "ri-file-copy-2-line"
    );
    $e(
      () => a.modelValue,
      () => {
        s.value && (a.validateOnBlur || a.validateOnInput) && b();
      }
    ), $e(
      () => a.error,
      (U) => {
        U && (u.value = void 0);
      }
    ), n({ validate: () => (s.value = !0, b(), !u.value), resetValidation: () => {
      s.value = !1, u.value = void 0;
    } });
    const V = qe(), M = m(() => a.id ?? `${V}-url`), B = m(() => a.label ? `${V}-label` : void 0), q = m(() => `${V}-error`), N = m(() => `${V}-hint`), G = m(() => {
      const U = [];
      return a.hint && U.push(N.value), h.value && U.push(q.value), U.join(" ") || void 0;
    });
    return (U, K) => (c(), g("div", {
      class: C([
        "relative flex min-w-0 pb-0.5 text-left font-inter",
        e.labelInline ? "flex-row items-center gap-2" : "flex-col items-start gap-0.5",
        S.value ? "w-full" : ""
      ]),
      style: je(S.value ? void 0 : { width: e.width })
    }, [
      e.label ? (c(), W(It, {
        key: 0,
        id: B.value,
        ref_key: "labelRef",
        ref: o,
        text: e.label,
        "input-id": M.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: r.value,
        inline: e.labelInline,
        "test-id": "url-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline"])) : w("", !0),
      v("div", {
        class: C(["flex min-w-0 flex-col gap-0.5", S.value || e.labelInline ? "w-full flex-1" : "w-full"])
      }, [
        v("div", t3, [
          te(Vn, {
            class: "min-w-0 flex-1",
            flush: !!e.prefix,
            "inner-button": $.value,
            size: e.size,
            disabled: e.disabled,
            readonly: e.readonly,
            error: !!h.value,
            success: x.value,
            "has-value": p.value,
            "data-testid": "url-input-shell"
          }, {
            default: ve(({ hovered: ge, iconBoxClass: xe, leftIconBoxClass: X, iconColorClass: ie, borderColorClass: he, addonTextClass: oe, textClass: Ce }) => [
              e.iconLeft && !e.prefix ? (c(), g("i", {
                key: 0,
                class: C([e.iconLeft, X, ie])
              }, null, 2)) : w("", !0),
              e.prefix ? (c(), g("span", {
                key: 1,
                "data-testid": "url-input-prefix",
                class: C([
                  "flex shrink-0 select-none items-center gap-2 self-stretch border-r",
                  L(za)[e.size].addon,
                  "text-(length:--size-m) leading-(--line-height-l)",
                  he,
                  oe
                ])
              }, [
                e.iconLeft ? (c(), g("i", {
                  key: 0,
                  class: C([e.iconLeft, X, ie])
                }, null, 2)) : w("", !0),
                nt(" " + j(e.prefix), 1)
              ], 2)) : w("", !0),
              v("div", {
                class: C([
                  e.prefix ? ["flex h-full min-w-0 flex-1 items-center gap-2", L(za)[e.size].input] : "contents",
                  e.prefix && !$.value ? L(za)[e.size].inputEnd : ""
                ])
              }, [
                v("input", {
                  id: M.value,
                  value: e.modelValue,
                  name: e.name,
                  title: Y.value || void 0,
                  placeholder: e.placeholder,
                  disabled: e.disabled,
                  readonly: e.readonly,
                  required: e.required,
                  type: "url",
                  inputmode: "url",
                  autocomplete: e.autocomplete,
                  "aria-labelledby": B.value,
                  "aria-invalid": !!h.value,
                  "aria-describedby": G.value,
                  "aria-required": e.required || void 0,
                  "aria-disabled": e.disabled || void 0,
                  "data-testid": "url-input",
                  class: C([
                    "relative min-w-0 flex-1 text-ellipsis border-0 bg-transparent p-0 outline-none focus:border-0 focus:outline-none focus:ring-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)",
                    Ce,
                    e.readonly ? "cursor-default" : ""
                  ]),
                  onInput: T,
                  onFocus: I,
                  onBlur: A,
                  onKeydown: E
                }, null, 42, n3),
                y(ge) ? (c(), g("i", {
                  key: 0,
                  class: C(["ri-pencil-line text-(--icons-icon-accent)", xe])
                }, null, 2)) : k.value ? (c(), g("i", {
                  key: 1,
                  class: C([
                    "ri-close-fill cursor-pointer text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
                    xe
                  ]),
                  role: "button",
                  tabindex: "-1",
                  "aria-label": e.labels.clear,
                  onMousedown: K[0] || (K[0] = Je(() => {
                  }, ["prevent"])),
                  onClick: Je(D, ["stop"]),
                  onKeydown: [
                    ht(D, ["enter"]),
                    ht(Je(D, ["prevent"]), ["space"])
                  ]
                }, null, 42, a3)) : w("", !0),
                $.value ? (c(), W(Me, {
                  key: 2,
                  variant: "secondary",
                  size: "xs",
                  "icon-left": re.value,
                  label: ne.value,
                  "aria-label": ne.value,
                  disabled: e.disabled || !e.modelValue,
                  onClick: le
                }, null, 8, ["icon-left", "label", "aria-label", "disabled"])) : w("", !0)
              ], 2)
            ]),
            _: 1
          }, 8, ["flush", "inner-button", "size", "disabled", "readonly", "error", "success", "has-value"]),
          Ae(U.$slots, "actions", {}, void 0, !0)
        ]),
        te($t, {
          ref_key: "helperRef",
          ref: i,
          focused: r.value,
          hint: e.hint,
          error: h.value,
          "hint-id": N.value,
          "error-id": q.value,
          "test-id-prefix": "url-input"
        }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"])
      ], 2)
    ], 6));
  }
}), Cq = /* @__PURE__ */ dt(l3, [["__scopeId", "data-v-3d78c675"]]), Gc = {
  name: "sameWidth",
  enabled: !0,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({ state: e }) => {
    e.styles.popper.width = `${e.rects.reference.width}px`;
  }
}, r3 = {
  indigo: "indigo",
  amber: "orange",
  green: "green",
  red: "red"
}, jv = (e) => e.badge ? {
  label: e.badge,
  theme: e.badgeTheme ?? r3[e.badgeVariant ?? "indigo"],
  icon: e.badgeIcon,
  brandIcon: e.badgeBrandIcon
} : void 0, o3 = ["aria-expanded", "aria-activedescendant", "aria-required", "aria-invalid", "aria-disabled", "aria-describedby", "disabled", "placeholder"], i3 = ["aria-label"], s3 = { class: "flex items-start justify-between gap-2" }, d3 = {
  role: "status",
  "aria-live": "polite",
  class: "sr-only",
  "data-testid": "autocomplete-status"
}, u3 = {
  key: 0,
  class: "flex justify-center py-4"
}, c3 = {
  key: 1,
  "data-testid": "autocomplete-empty",
  class: "flex px-2.5 py-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-black-default) dark:text-(--colors-text-white-default)"
}, f3 = {
  key: 2,
  "data-testid": "autocomplete-results-heading",
  class: "flex shrink-0 px-2.5 pt-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-black-default) dark:text-(--colors-text-white-default)"
}, h3 = ["aria-labelledby", "aria-label"], Wv = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "AutoComplete",
  props: {
    modelValue: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean },
    requiredIndicator: { default: "*" },
    placeholder: { default: void 0 },
    iconLeft: { default: "ri-map-pin-2-line" },
    iconRight: { default: "ri-search-line" },
    options: { default: void 0 },
    loading: { type: Boolean },
    emptyLabel: { default: void 0 },
    resultsLabel: { default: void 0 },
    error: { default: void 0 },
    hint: { default: void 0 },
    disabled: { type: Boolean },
    fullWidth: { type: Boolean, default: !0 },
    showAddMoreDetails: { type: Boolean },
    addMoreDetailsLabel: { default: void 0 },
    labelTooltip: { default: void 0 },
    debounce: { default: 300 },
    minSearchLength: { default: 1 },
    maxVisibleOptions: { default: 5 },
    keepInputOnEdit: { type: Boolean },
    clearable: { type: Boolean, default: !0 },
    clearLabel: { default: "Clear" },
    resultsCountLabel: { type: [String, Function], default: "{count} results" },
    seeAllLabel: { type: [String, Function], default: void 0 },
    createLabel: { type: [String, Function], default: void 0 },
    createIcon: { default: "ri-add-line" }
  },
  emits: ["update:modelValue", "search", "select", "clear", "addMoreDetails", "blur", "see-all", "create"],
  setup(e, { expose: n, emit: t }) {
    var pe, ke;
    const a = e, l = t, r = qe(), o = `autocomplete-input-${r}`, i = `autocomplete-listbox-${r}`, s = `autocomplete-error-${r}`, d = `autocomplete-hint-${r}`, u = `autocomplete-label-${r}`, f = m(() => {
      const fe = [];
      return a.hint && fe.push(d), a.error && fe.push(s), fe.length > 0 ? fe.join(" ") : void 0;
    }), b = R(
      a.modelValue ? ((ke = (pe = a.options) == null ? void 0 : pe.find((fe) => fe.value === a.modelValue)) == null ? void 0 : ke.label) ?? a.modelValue : ""
    ), h = R(!1), p = R(!1), x = R(!1), y = R(null), k = R(null), $ = R(!1), S = R(-1), T = R(), I = R(), A = R(), E = R(null), D = R(!1), z = R(!1);
    let Y = null, le = null, ne = !1, re = !1, O = !1;
    const P = m(
      () => h.value && !p.value && b.value.length >= (a.minSearchLength ?? 1) && !a.disabled
    ), V = m(() => (a.options ?? []).slice(0, a.maxVisibleOptions)), M = (fe) => fe.image !== void 0 ? { name: fe.label, img: fe.image ?? void 0, logo: fe.logo } : void 0, B = m(() => {
      if (!P.value || a.loading || z.value) return "";
      const fe = V.value.length;
      return fe === 0 ? a.emptyLabel ?? "No results" : as(a.resultsCountLabel, fe);
    }), q = (fe) => typeof fe == "function" ? fe(b.value) : fe, N = m(() => q(a.seeAllLabel)), G = m(() => q(a.createLabel)), U = m(() => !!(N.value || G.value)), K = m(() => !!a.modelValue), ge = m(
      () => a.clearable && !!b.value && !a.disabled && ($.value || h.value)
    ), xe = m(() => a.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : h.value ? "text-(--border-border-accent)" : K.value ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-body-subtle)"), X = m(() => a.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : $.value && !h.value ? "text-(--border-border-accent)" : K.value ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-body-subtle)"), ie = m(() => {
      const fe = "relative rounded-(--border-border-radius-rounded-l) border-solid box-border flex items-center gap-2 px-3 h-9 font-inter";
      return a.disabled ? `${fe} border-[1px] bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled)` : a.error ? `${fe} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error)` : h.value ? `${fe} border-[1px] shadow-[0px_0px_2px_var(--border-border-accent)] bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent)` : $.value ? `${fe} border-[1px] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-accent)` : `${fe} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base)`;
    });
    $e(P, async (fe) => {
      fe ? (await Ge(), Y = Xa(T.value, A.value, {
        placement: "bottom-start",
        onFirstUpdate: () => {
          D.value = !0;
        },
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: ["top-start"] } },
          { name: "preventOverflow", options: { padding: 8 } },
          Gc
        ]
      })) : (Y == null || Y.destroy(), Y = null, D.value = !1);
    }), $e(D, async (fe) => {
      fe && (await Ge(), await (Y == null ? void 0 : Y.update()));
    }), $e(
      [() => a.options, () => a.loading],
      async () => {
        var fe;
        if (!h.value && a.modelValue) {
          const ze = (fe = a.options) == null ? void 0 : fe.find((Ee) => Ee.value === a.modelValue);
          ze && (b.value = ze.label);
        }
        S.value = -1, await Ge(), await (Y == null ? void 0 : Y.update());
      }
    ), $e(P, (fe) => {
      fe || (S.value = -1);
    }), $e(
      () => a.modelValue,
      (fe) => {
        var Ee;
        if (!fe) {
          ne || (b.value = ""), ne = !1;
          return;
        }
        const ze = (Ee = a.options) == null ? void 0 : Ee.find((He) => He.value === fe);
        b.value = ze ? ze.label : fe;
      },
      { immediate: !0 }
    ), yt(() => {
      Y == null || Y.destroy(), Y = null, le && clearTimeout(le);
    });
    const he = (fe) => {
      if (re) {
        re = !1;
        return;
      }
      h.value = !0, p.value = !1, fe.target.select();
    }, oe = () => {
      a.disabled || (h.value = !0, p.value = !1);
    }, Ce = (fe) => {
      var ze;
      if (O || (ze = A.value) != null && ze.contains(fe.relatedTarget)) {
        O = !1;
        return;
      }
      h.value = !1, l("blur");
    }, H = () => {
      p.value = !1, a.modelValue && (a.keepInputOnEdit && (ne = !0), l("update:modelValue", "")), z.value = !0, le && clearTimeout(le), le = setTimeout(() => {
        z.value = !1, l("search", b.value);
      }, a.debounce ?? 300);
    }, Z = (fe) => {
      fe.disabled || (b.value = fe.label, l("update:modelValue", fe.value), l("select", fe), J());
    }, ee = () => {
      b.value = "", l("update:modelValue", ""), l("clear");
    }, J = () => {
      p.value = !0;
    }, F = () => {
      J(), I.value && document.activeElement !== I.value && (re = !0, I.value.focus());
    }, _ = () => {
      var fe, ze;
      return Array.from(
        ((ze = (fe = E.value) == null ? void 0 : fe.$el) == null ? void 0 : ze.querySelectorAll("button, a[href]")) ?? []
      );
    };
    function ue(fe) {
      const ze = b.value;
      F(), l(fe === "see-all" ? "see-all" : "create", ze);
    }
    function se(fe) {
      var Ee, He;
      const ze = _();
      fe.key === "Escape" ? (fe.preventDefault(), fe.stopPropagation(), F()) : fe.key === "Tab" && fe.shiftKey && fe.target === ze[0] ? (fe.preventDefault(), (Ee = I.value) == null || Ee.focus()) : fe.key === "Tab" && !fe.shiftKey && fe.target === ze[ze.length - 1] && (re = !0, (He = I.value) == null || He.focus(), J());
    }
    function Q(fe) {
      var Ee;
      const ze = fe.relatedTarget;
      ze === I.value || (Ee = A.value) != null && Ee.contains(ze) || (h.value = !1, l("blur"));
    }
    function ae(fe, ze) {
      fe.disabled || (S.value = ze, x.value = !1);
    }
    const Te = async () => {
      var fe;
      await Ge(), (fe = document.getElementById(`${i}-option-${S.value}`)) == null || fe.scrollIntoView({ block: "nearest" });
    }, Le = (fe) => {
      var He, Ke;
      if (!P.value) {
        if (p.value && (fe.key === "ArrowDown" || fe.key === "ArrowUp")) {
          fe.preventDefault(), p.value = !1;
          return;
        }
        (He = y.value) == null || He.handleFieldKeydown(fe), (Ke = k.value) == null || Ke.handleFieldKeydown(fe);
        return;
      }
      if (fe.key === "Escape") {
        fe.stopPropagation(), fe.preventDefault(), J();
        return;
      }
      const ze = V.value.length;
      if (!ze && fe.key !== "Tab") return;
      const Ee = S.value < ze ? S.value : -1;
      switch (fe.key) {
        case "ArrowDown": {
          fe.preventDefault(), S.value = (Ee + 1) % ze, x.value = !0, Te();
          break;
        }
        case "ArrowUp": {
          fe.preventDefault(), S.value = Ee === -1 ? ze - 1 : Ee - 1, x.value = !0, Te();
          break;
        }
        case "Enter": {
          fe.preventDefault(), S.value >= 0 && V.value[S.value] && Z(V.value[S.value]);
          break;
        }
        case "Tab": {
          if (!fe.shiftKey && S.value >= 0 && V.value[S.value])
            Z(V.value[S.value]);
          else if (!fe.shiftKey && _()[0]) {
            fe.preventDefault(), O = !0, _()[0].focus();
            break;
          }
          J();
          break;
        }
      }
    };
    return n({ focus: () => {
      var fe;
      return (fe = I.value) == null ? void 0 : fe.focus();
    } }), (fe, ze) => (c(), g(de, null, [
      v("div", {
        class: C(["font-inter text-(length:--size-m) leading-(--line-height-l) flex flex-col gap-0.5 pb-0.5", e.fullWidth ? "w-full" : ""])
      }, [
        e.label ? (c(), W(It, {
          key: 0,
          id: u,
          ref_key: "labelRef",
          ref: y,
          text: e.label,
          "input-id": o,
          required: e.required,
          "required-indicator": e.requiredIndicator,
          tooltip: e.labelTooltip,
          focused: h.value,
          "test-id": "autocomplete-label"
        }, null, 8, ["text", "required", "required-indicator", "tooltip", "focused"])) : w("", !0),
        v("div", {
          ref_key: "inputRef",
          ref: T,
          class: C(ie.value),
          onMouseenter: ze[2] || (ze[2] = (Ee) => $.value = !0),
          onMouseleave: ze[3] || (ze[3] = (Ee) => $.value = !1)
        }, [
          e.iconLeft ? (c(), g("i", {
            key: 0,
            class: C([e.iconLeft, "shrink-0 text-(length:--icon-size-sm) leading-(--line-height-xxl) transition-colors", xe.value])
          }, null, 2)) : w("", !0),
          tr(v("input", Fe(fe.$attrs, {
            id: o,
            ref_key: "nativeInputRef",
            ref: I,
            "onUpdate:modelValue": ze[0] || (ze[0] = (Ee) => b.value = Ee),
            role: "combobox",
            "aria-expanded": P.value,
            "aria-autocomplete": "list",
            "aria-controls": i,
            "aria-activedescendant": S.value >= 0 ? `${i}-option-${S.value}` : void 0,
            "aria-haspopup": "listbox",
            "aria-required": e.required || void 0,
            "aria-invalid": !!e.error || void 0,
            "aria-disabled": e.disabled ? "true" : void 0,
            "aria-describedby": f.value,
            autocomplete: "off",
            disabled: e.disabled,
            placeholder: e.placeholder,
            class: ["flex-1 min-w-0 truncate bg-transparent outline-none text-(length:--size-m) leading-(--line-height-l) placeholder:text-(--text-text-body-subtle)", e.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"],
            onInput: H,
            onFocus: he,
            onClick: oe,
            onBlur: Ce,
            onKeydown: Le
          }), null, 16, o3), [
            [Bx, b.value]
          ]),
          ge.value ? (c(), g("button", {
            key: 1,
            type: "button",
            "aria-label": e.clearLabel,
            "data-testid": "autocomplete-clear",
            class: C(["-m-1 inline-flex size-6 shrink-0 cursor-pointer items-center justify-center rounded-full transition-colors focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)", X.value]),
            onMousedown: ze[1] || (ze[1] = Je(() => {
            }, ["prevent"])),
            onClick: ee
          }, [...ze[8] || (ze[8] = [
            v("i", {
              class: "ri-close-line text-(length:--icon-size-sm) leading-(--line-height-xxl)",
              "aria-hidden": "true"
            }, null, -1)
          ])], 42, i3)) : e.iconRight ? (c(), g("i", {
            key: 2,
            class: C([e.iconRight, "shrink-0 text-(length:--icon-size-sm) leading-(--line-height-xxl) transition-colors", X.value])
          }, null, 2)) : w("", !0)
        ], 34),
        v("div", s3, [
          te($t, {
            ref_key: "helperRef",
            ref: k,
            focused: h.value,
            class: "flex-1",
            hint: e.hint,
            error: e.error,
            "hint-id": d,
            "error-id": s,
            "test-id-prefix": "autocomplete"
          }, null, 8, ["focused", "hint", "error"]),
          te(At, {
            "enter-active-class": "transition duration-150 ease-in-out motion-reduce:transition-none",
            "enter-from-class": "opacity-0 -translate-y-1 motion-reduce:translate-y-0",
            "enter-to-class": "opacity-100 translate-y-0"
          }, {
            default: ve(() => [
              e.showAddMoreDetails ? (c(), W(L(Mn), {
                key: 0,
                "data-testid": "autocomplete-add-more-details",
                "icon-right": "ri-pencil-line",
                class: "shrink-0 ml-2",
                disabled: e.disabled,
                onClick: ze[4] || (ze[4] = (Ee) => l("addMoreDetails"))
              }, {
                default: ve(() => [
                  nt(j(e.addMoreDetailsLabel ?? "Add more details"), 1)
                ]),
                _: 1
              }, 8, ["disabled"])) : w("", !0)
            ]),
            _: 1
          })
        ]),
        v("span", d3, j(B.value), 1)
      ], 2),
      (c(), W(Nn, { to: "body" }, [
        P.value ? (c(), g("div", {
          key: 0,
          ref_key: "panelRef",
          ref: A,
          class: "fixed z-[200]",
          "data-focus-trap-allow-outside": "",
          onMousedown: ze[7] || (ze[7] = Je(() => {
          }, ["prevent"])),
          onFocusout: Q
        }, [
          te(At, {
            "enter-active-class": "transition duration-100 ease-out",
            "enter-from-class": "transform scale-95 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100",
            "leave-active-class": "transition duration-75 ease-out",
            "leave-from-class": "transform scale-100 opacity-100",
            "leave-to-class": "transform scale-95 opacity-0"
          }, {
            default: ve(() => [
              D.value ? (c(), g("div", {
                key: 0,
                "data-testid": "autocomplete-panel",
                class: C([
                  "flex w-full flex-col overflow-hidden",
                  // Without a footer the border is medium and there is no blur, so only the footer panel is the shared surface.
                  U.value ? L(Za) : "rounded-(--border-border-radius-rounded-l) border border-solid border-(--border-border-base-medium) bg-(--background-background-white) shadow-(--blur-shadow-m) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)"
                ])
              }, [
                v("div", {
                  "data-testid": "autocomplete-list",
                  class: C([
                    "flex min-h-0 flex-col",
                    U.value ? "p-1" : "gap-1.5 p-[calc(--spacing(2)-1px)]"
                  ])
                }, [
                  e.loading ? (c(), g("div", u3, [...ze[9] || (ze[9] = [
                    v("i", {
                      class: "ri-loader-4-line animate-spin text-(--text-text-body-subtle)",
                      "aria-hidden": "true"
                    }, null, -1)
                  ])])) : !V.value.length && !z.value ? (c(), g("div", c3, j(e.emptyLabel ?? "No results"), 1)) : e.resultsLabel ? (c(), g("div", f3, j(e.resultsLabel), 1)) : w("", !0),
                  v("ul", {
                    id: i,
                    role: "listbox",
                    "aria-labelledby": e.label ? u : void 0,
                    "aria-label": e.label ? void 0 : e.resultsLabel,
                    class: C([
                      "flex flex-col",
                      !U.value && "gap-1.5",
                      (e.loading || !V.value.length) && "hidden"
                    ])
                  }, [
                    (c(!0), g(de, null, Re(V.value, (Ee, He) => (c(), W(en, {
                      id: `${i}-option-${He}`,
                      key: Ee.value,
                      as: "li",
                      type: "autocomplete",
                      role: "option",
                      "aria-selected": He === S.value,
                      label: Ee.label,
                      highlight: b.value,
                      icon: Ee.icon,
                      avatar: M(Ee),
                      "secondary-label": Ee.description,
                      badge: L(jv)(Ee),
                      description: Ee.disabled ? Ee.disabledReason : void 0,
                      "aria-disabled": !!Ee.disabled,
                      highlighted: He === S.value,
                      "keyboard-active": x.value && He === S.value,
                      "data-testid": `autocomplete-option-${Ee.value}`,
                      onClick: (Ke) => Z(Ee),
                      onMouseenter: (Ke) => ae(Ee, He)
                    }, null, 8, ["id", "aria-selected", "label", "highlight", "icon", "avatar", "secondary-label", "badge", "description", "aria-disabled", "highlighted", "keyboard-active", "data-testid", "onClick", "onMouseenter"]))), 128))
                  ], 10, h3)
                ], 2),
                U.value ? (c(), W(pl, {
                  key: 0,
                  ref_key: "footerRef",
                  ref: E,
                  type: "see-all-create",
                  "see-all-label": N.value,
                  "create-label": G.value,
                  "create-icon": e.createIcon,
                  class: "shrink-0",
                  onKeydown: se,
                  onSeeAll: ze[5] || (ze[5] = (Ee) => ue("see-all")),
                  onCreate: ze[6] || (ze[6] = (Ee) => ue("create"))
                }, null, 8, ["see-all-label", "create-label", "create-icon"])) : w("", !0)
              ], 2)) : w("", !0)
            ]),
            _: 1
          })
        ], 544)) : w("", !0)
      ]))
    ], 64));
  }
}), b3 = { class: "flex w-full flex-col" }, g3 = { class: "@container flex flex-col" }, m3 = {
  "data-testid": "address-input-zip-city",
  class: "grid grid-cols-1 gap-x-4 @sm:grid-cols-2"
}, p3 = { class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-black-default) dark:text-(--text-text-white-default)" }, v3 = "ri-map-pin-2-line", vb = "ri-search-line", Sq = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "AddressInput",
  props: {
    modelValue: { default: "" },
    details: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    ariaLabel: { default: void 0 },
    labelTooltip: { default: void 0 },
    options: { default: () => [] },
    loading: { type: Boolean, default: !1 },
    hint: { default: void 0 },
    error: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    countries: { default: () => [] },
    formatAddress: { type: Function, default: void 0 },
    labels: { default: () => ({}) }
  },
  emits: ["update:modelValue", "update:details", "search", "select", "clear", "blur", "addMoreDetails"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = { line1: "", line2: "", line3: "", zip: "", city: "", country: "" }, r = m(() => ({
      addMoreDetails: t.labels.addMoreDetails ?? "Add more details",
      modalTitle: t.labels.modalTitle ?? "Edit address",
      line1: t.labels.line1 ?? "Address line 1",
      line2: t.labels.line2 ?? "Address line 2 (optional)",
      line3: t.labels.line3 ?? "Address line 3 (optional)",
      linePlaceholder: t.labels.linePlaceholder ?? "Enter a new address line",
      zip: t.labels.zip ?? "Zip code",
      city: t.labels.city ?? "City",
      country: t.labels.country ?? "Country",
      save: t.labels.save ?? "Save",
      cancel: t.labels.cancel ?? "Cancel",
      closeModal: t.labels.closeModal ?? "Close modal"
    })), o = R(t.modelValue);
    $e(
      () => t.modelValue,
      (le) => {
        o.value = le;
      }
    );
    const i = R({ ...l, ...t.details });
    $e(
      () => t.details,
      (le) => {
        i.value = { ...l, ...le };
      },
      { deep: !0 }
    );
    const s = m(() => !!o.value), d = R(null);
    function u() {
      t.details || (i.value = { ...l });
    }
    function f(le) {
      u(), a("select", le);
    }
    function b() {
      i.value = { ...l }, a("clear");
    }
    function h(le) {
      o.value = le, a("update:modelValue", le);
    }
    function p(le) {
      u(), h(le);
    }
    function x(le) {
      var ne, re;
      t.disabled || (ne = le.target) != null && ne.closest(`.${vb}`) && ((re = d.value) == null || re.focus());
    }
    const y = m(() => [
      "[&_.ri-search-line]:cursor-pointer",
      // AutoComplete sizes its icons `text-base`, a 24 px line box; Figma's icons are 16 px squares.
      "[&_.ri-map-pin-2-line]:text-(length:--icon-size-sm) [&_.ri-map-pin-2-line]:leading-(--icon-size-sm)",
      "[&_.ri-search-line]:text-(length:--icon-size-sm) [&_.ri-search-line]:leading-(--icon-size-sm)",
      s.value && !t.disabled ? "[&_input]:text-(--text-text-link) [&_input]:font-(--weight-medium)" : ""
    ]), k = R(!1), $ = Ha({ ...l }), S = `address-input-description-${qe()}`;
    function T(le) {
      var O;
      const ne = ((O = t.countries.find((P) => P.value === le.country)) == null ? void 0 : O.label) ?? le.country, re = [le.zip, le.city].filter((P) => P.trim()).join(" ");
      return [le.line1, le.line2, le.line3, re, ne].filter((P) => P.trim());
    }
    const I = (le) => t.formatAddress ? t.formatAddress(le) : T(le).join(", "), A = m(() => T($));
    function E() {
      Object.assign($, i.value), k.value = !0, a("addMoreDetails");
    }
    function D() {
      const le = { ...$ }, ne = I(le);
      k.value = !1, ne && (i.value = le, a("update:details", le), h(ne));
    }
    function z() {
      k.value = !1;
    }
    const Y = m(() => [
      { id: "cancel", label: r.value.cancel, variant: "secondary", onClick: z, testId: "address-input-cancel" },
      { id: "save", label: r.value.save, variant: "primary", onClick: D, testId: "address-input-save" }
    ]);
    return (le, ne) => (c(), g("div", b3, [
      v("div", {
        "data-testid": "address-input-field",
        class: C(y.value),
        onClick: x
      }, [
        te(Wv, Fe({
          ref_key: "autoCompleteRef",
          ref: d
        }, le.$attrs, {
          "model-value": o.value,
          label: e.label,
          required: e.required,
          placeholder: e.placeholder,
          "aria-label": e.label ? void 0 : e.ariaLabel,
          "label-tooltip": e.labelTooltip,
          options: e.options,
          loading: e.loading,
          hint: e.hint,
          error: e.error,
          disabled: e.disabled,
          "icon-left": v3,
          "icon-right": vb,
          "keep-input-on-edit": "",
          "show-add-more-details": s.value,
          "add-more-details-label": r.value.addMoreDetails,
          onAddMoreDetails: E,
          "onUpdate:modelValue": p,
          onSearch: ne[0] || (ne[0] = (re) => a("search", re)),
          onSelect: f,
          onClear: b,
          onBlur: ne[1] || (ne[1] = (re) => a("blur"))
        }), null, 16, ["model-value", "label", "required", "placeholder", "aria-label", "label-tooltip", "options", "loading", "hint", "error", "disabled", "show-add-more-details", "add-more-details-label"])
      ], 2),
      te(Ka, {
        modelValue: k.value,
        "onUpdate:modelValue": ne[8] || (ne[8] = (re) => k.value = re),
        size: "sm",
        title: r.value.modalTitle,
        "aria-close-label": r.value.closeModal,
        actions: Y.value,
        "aria-describedby": A.value.length ? S : void 0
      }, {
        default: ve(() => [
          v("div", g3, [
            te(Wt, {
              modelValue: $.line1,
              "onUpdate:modelValue": ne[2] || (ne[2] = (re) => $.line1 = re),
              "data-testid": "address-input-line1",
              label: r.value.line1,
              "full-width": ""
            }, null, 8, ["modelValue", "label"]),
            te(Wt, {
              modelValue: $.line2,
              "onUpdate:modelValue": ne[3] || (ne[3] = (re) => $.line2 = re),
              "data-testid": "address-input-line2",
              label: r.value.line2,
              placeholder: r.value.linePlaceholder,
              "full-width": ""
            }, null, 8, ["modelValue", "label", "placeholder"]),
            te(Wt, {
              modelValue: $.line3,
              "onUpdate:modelValue": ne[4] || (ne[4] = (re) => $.line3 = re),
              "data-testid": "address-input-line3",
              label: r.value.line3,
              placeholder: r.value.linePlaceholder,
              "full-width": ""
            }, null, 8, ["modelValue", "label", "placeholder"]),
            v("div", m3, [
              te(Wt, {
                modelValue: $.zip,
                "onUpdate:modelValue": ne[5] || (ne[5] = (re) => $.zip = re),
                "data-testid": "address-input-zip",
                label: r.value.zip,
                "full-width": ""
              }, null, 8, ["modelValue", "label"]),
              te(Wt, {
                modelValue: $.city,
                "onUpdate:modelValue": ne[6] || (ne[6] = (re) => $.city = re),
                "data-testid": "address-input-city",
                label: r.value.city,
                "full-width": ""
              }, null, 8, ["modelValue", "label"])
            ]),
            te(ll, {
              modelValue: $.country,
              "onUpdate:modelValue": ne[7] || (ne[7] = (re) => $.country = re),
              "data-testid": "address-input-country",
              label: r.value.country,
              options: e.countries,
              "full-width": ""
            }, null, 8, ["modelValue", "label", "options"]),
            A.value.length ? (c(), W(_l, {
              key: 0,
              id: S,
              "data-testid": "address-input-description",
              color: "default",
              layout: "stacked",
              "aria-live": "off"
            }, {
              body: ve(() => [
                v("p", p3, [
                  (c(!0), g(de, null, Re(A.value, (re, O) => (c(), g("span", {
                    key: O,
                    class: "block"
                  }, j(re), 1))), 128))
                ])
              ]),
              _: 1
            })) : w("", !0)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "title", "aria-close-label", "actions", "aria-describedby"])
    ]));
  }
}), x3 = { class: "flex w-full flex-col" }, y3 = { class: "box-border flex w-full flex-col gap-1.5 p-[calc(--spacing(2)-1px)]" }, k3 = ["id"], w3 = {
  key: 1,
  class: "flex justify-center py-2"
}, C3 = {
  key: 2,
  class: "px-2 py-2 text-(length:--size-m) leading-(--line-height-l) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)",
  "data-testid": "relation-input-empty"
}, S3 = ["id", "aria-labelledby", "aria-label", "aria-owns", "aria-busy"], $3 = ["id", "aria-selected", "onClick", "onMouseenter"], I3 = { class: "flex min-w-0 flex-1 flex-col gap-px" }, L3 = {
  class: "truncate text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-heading) dark:text-(--colors-text-white-default)",
  "data-testid": "relation-input-option-name"
}, T3 = {
  key: 0,
  class: "bg-transparent text-(--text-text-accent)"
}, A3 = {
  key: 0,
  class: "truncate text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body) dark:text-(--colors-text-white-secondary)"
}, E3 = /* @__PURE__ */ ye({
  __name: "RelationListbox",
  props: {
    listboxId: {},
    items: {},
    activeIndex: {},
    query: {},
    heading: {},
    name: {},
    loading: { type: Boolean },
    loadingLabel: {},
    emptyText: {}
  },
  emits: ["choose", "hover"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => `${t.listboxId}-heading`), r = m(
      () => t.items.map((f, b) => ({ item: f, index: b })).filter(
        (f) => f.item.kind === "record"
      )
    ), o = m(
      () => t.items.map((f, b) => ({ item: f, index: b })).filter(
        (f) => f.item.kind !== "record"
      )
    ), i = m(() => o.value.find((f) => f.item.kind === "viewAll")), s = m(() => o.value.find((f) => f.item.kind === "create")), d = m(() => o.value.map((f) => f.item.id).join(" ") || void 0), u = (f) => f.role ?? f.email;
    return (f, b) => {
      var h, p;
      return c(), g("div", x3, [
        v("div", y3, [
          e.heading ? (c(), g("div", {
            key: 0,
            id: l.value,
            class: "flex h-4 w-full items-end px-2 text-(length:--size-sm) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
          }, j(e.heading), 9, k3)) : w("", !0),
          e.loading ? (c(), g("div", w3, [
            te(Vu, {
              size: "sm",
              label: e.loadingLabel
            }, null, 8, ["label"])
          ])) : e.emptyText ? (c(), g("div", C3, j(e.emptyText), 1)) : w("", !0),
          v("div", {
            id: e.listboxId,
            role: "listbox",
            "aria-labelledby": e.heading ? l.value : void 0,
            "aria-label": e.heading ? void 0 : e.name,
            "aria-owns": d.value,
            "aria-busy": e.loading || void 0,
            class: C(["flex flex-col gap-1.5", d.value ? "empty:sr-only" : "empty:hidden"]),
            "data-testid": "relation-input-listbox"
          }, [
            (c(!0), g(de, null, Re(r.value, ({ item: x, index: y }) => (c(), g("div", {
              id: x.id,
              key: x.id,
              role: "option",
              "aria-selected": y === e.activeIndex,
              "data-testid": "relation-input-option",
              class: C([
                "flex h-[46px] cursor-pointer items-center gap-1.5 rounded-(--border-border-radius-rounded-sm) p-2",
                y === e.activeIndex ? "bg-(--background-background-hover) dark:bg-white/8" : "hover:bg-(--background-background-hover) dark:hover:bg-white/8"
              ]),
              onClick: (k) => a("choose", x),
              onMouseenter: (k) => a("hover", y)
            }, [
              te(Nt, {
                name: x.record.label,
                img: x.record.avatarSrc,
                size: "sm",
                presentational: ""
              }, null, 8, ["name", "img"]),
              v("span", I3, [
                v("span", L3, [
                  (c(!0), g(de, null, Re([L(xg)(x.record.label, e.query)], (k, $) => (c(), g(de, { key: $ }, [
                    nt(j(k.before), 1),
                    k.match ? (c(), g("mark", T3, j(k.match), 1)) : w("", !0),
                    nt(j(k.after), 1)
                  ], 64))), 128))
                ]),
                u(x.record) ? (c(), g("span", A3, j(u(x.record)), 1)) : w("", !0)
              ]),
              x.record.badge ? (c(), W(gt, {
                key: 0,
                label: x.record.badge.label,
                theme: x.record.badge.color,
                size: "sm",
                "show-left-icon": !1,
                class: "shrink-0",
                "data-testid": "relation-input-option-badge"
              }, null, 8, ["label", "theme"])) : w("", !0)
            ], 42, $3))), 128))
          ], 10, S3)
        ]),
        o.value.length ? (c(), W(pl, {
          key: 0,
          type: "see-all-create",
          "see-all-label": (h = i.value) == null ? void 0 : h.item.label,
          "see-all-option": i.value && {
            id: i.value.item.id,
            active: i.value.index === e.activeIndex,
            testId: "relation-input-view-all"
          },
          "create-label": (p = s.value) == null ? void 0 : p.item.label,
          "create-option": s.value && {
            id: s.value.item.id,
            active: s.value.index === e.activeIndex,
            testId: "relation-input-create"
          },
          onSeeAll: b[0] || (b[0] = (x) => i.value && a("choose", i.value.item)),
          onCreate: b[1] || (b[1] = (x) => s.value && a("choose", s.value.item)),
          onOptionHover: b[2] || (b[2] = (x) => a("hover", (x === "see-all" ? i.value : s.value).index))
        }, null, 8, ["see-all-label", "see-all-option", "create-label", "create-option"])) : w("", !0)
      ]);
    };
  }
}), Tl = er(null), R3 = ["id", "role", "aria-labelledby"], B3 = { class: "opal-popover-inner" }, M3 = { class: "opal-popover-header flex h-8 items-center justify-between ps-3 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)" }, D3 = {
  key: 0,
  class: "opal-popover-record mb-1 flex min-w-0 flex-col"
}, z3 = {
  key: 0,
  class: "flex items-start justify-between gap-2"
}, O3 = {
  key: 0,
  class: "opal-popover-avatar"
}, P3 = {
  key: 1,
  class: "opal-popover-action ml-auto shrink-0"
}, F3 = {
  key: 2,
  class: "opal-popover-badges mt-px flex flex-wrap gap-1.5"
}, V3 = { class: "opal-popover-content" }, N3 = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "Popover",
  props: {
    header: {},
    position: { default: "bottom" },
    delay: { default: 400 },
    closeDelay: { default: 100 },
    disabled: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    interactive: { type: Boolean, default: !1 },
    closable: { type: Boolean, default: !1 },
    closeLabel: { default: "Close" },
    minWidth: { default: void 0 },
    maxWidth: { default: "255px" }
  },
  emits: ["update:open"],
  setup(e, { emit: n }) {
    var ze;
    const t = Eu(), a = e, l = n, r = tn(), o = () => ["avatar", "title", "badges", "action"].some(r), i = qe(), s = `${i}-header`, d = `${i}-body`, u = R(a.position), f = () => u.value === "bottom" ? "var(--background-background-white-secondary)" : "var(--colors-white-50-opacity-bold)", b = R(null), h = R(null), p = R(!1), x = R(!1), y = Symbol("popover"), k = m(() => a.open !== void 0), $ = m(() => k.value ? a.open === !0 : p.value), S = m(() => a.interactive || a.closable), T = typeof process < "u" && ((ze = process.env) == null ? void 0 : ze.NODE_ENV) !== "production", I = m(
      () => S.value ? {
        "aria-haspopup": "dialog",
        "aria-expanded": $.value,
        "aria-controls": $.value ? i : void 0
      } : { "aria-describedby": $.value ? d : void 0 }
    );
    let A = null, E = null, D = null, z = null, Y = !1, le = null, ne = !1;
    const re = (Ee) => Ee === "top" || Ee === "bottom", O = {
      name: "syncSide",
      enabled: !0,
      phase: "afterWrite",
      fn: ({ state: Ee, instance: He }) => {
        const Ke = u.value;
        u.value = Ee.placement.split("-")[0], re(Ke) !== re(u.value) && Ge(() => He.update());
      }
    }, P = () => {
      le == null || le.disconnect(), le = null, A == null || A.destroy(), A = null;
    };
    $e(
      $,
      async (Ee) => {
        if (!Ee) {
          ne = !1, B();
          return;
        }
        if (u.value = a.position, await Ge(), !$.value || !b.value || !h.value) return;
        P();
        const He = Xa(b.value, h.value, {
          placement: a.position,
          modifiers: [
            // Arrow height: the caret tip touches the trigger.
            { name: "offset", options: { offset: [0, 10] } },
            { name: "arrow", options: { element: ".opal-popover-arrow", padding: 12 } },
            {
              name: "flip",
              // altAxis off: near the top or bottom edge a side bubble is shifted, not flipped.
              options: { fallbackPlacements: dg[a.position], altAxis: !1 }
            },
            { name: "preventOverflow", options: { padding: ug } },
            O
          ],
          // The first pass measures the caret before the side's CSS (10×40 on left/right) applies.
          onFirstUpdate: () => void He.update()
        });
        A = He, typeof ResizeObserver < "u" && (le = new ResizeObserver(() => void He.update()), le.observe(h.value));
      },
      { immediate: !0 }
    );
    const V = () => {
      E && (clearTimeout(E), E = null);
    }, M = () => {
      D && (clearTimeout(D), D = null);
    };
    function B() {
      Tl.value === y && (Tl.value = null), x.value = !1, document.removeEventListener("pointerdown", N, !0);
    }
    const q = () => {
      if (k.value) {
        l("update:open", !1);
        return;
      }
      B(), p.value = !1;
    };
    function N(Ee) {
      xe(b.value, Ee.target) || xe(h.value, Ee.target) || q();
    }
    const G = () => {
      !a.closable || a.disabled || k.value || x.value || (V(), M(), Tl.value = y, x.value = !0, p.value = !0, document.addEventListener("pointerdown", N, !0));
    };
    $e(Tl, (Ee) => {
      x.value && Ee !== y && q();
    });
    const U = () => !a.disabled && !k.value && !(Tl.value && Tl.value !== y), K = () => {
      U() && (M(), !E && (E = setTimeout(() => {
        p.value = !0, E = null;
      }, a.delay)));
    }, ge = () => {
      k.value || (V(), M(), D = setTimeout(q, a.closeDelay));
    }, xe = (Ee, He) => !!Ee && He instanceof Node && Ee.contains(He), X = () => {
      x.value || xe(h.value, document.activeElement) || xe(b.value, document.activeElement) || ge();
    }, ie = () => (z != null && z.isConnected ? z : null) ?? (b.value ? Aa(b.value)[0] ?? null : null), he = (Ee) => {
      Ee.target instanceof HTMLElement && (z = Ee.target), Y || K();
    }, oe = () => {
      ne = !0, M();
    }, Ce = () => {
      ne = !1, X();
    }, H = (Ee) => Ee.relatedTarget === null && (document.activeElement === Ee.target || ne), Z = () => x.value ? q() : ge(), ee = (Ee) => {
      H(Ee) || xe(h.value, Ee.relatedTarget) || Z();
    }, J = (Ee) => {
      H(Ee) || xe(h.value, Ee.relatedTarget) || xe(b.value, Ee.relatedTarget) || Z();
    }, F = (Ee) => void Ge(
      () => (
        // Two frames: the first can already be pending and fire in the same task as the re-render.
        requestAnimationFrame(
          () => requestAnimationFrame(() => {
            Y = !0;
            try {
              Ee == null || Ee.focus();
            } finally {
              Y = !1;
            }
          })
        )
      )
    ), _ = () => {
      const Ee = ie();
      q(), k.value || F(Ee);
    }, ue = (Ee) => {
      var Se;
      if (!$.value) return;
      Ee.stopPropagation(), Ee.preventDefault();
      const He = document.activeElement, Ke = xe(h.value, He) || x.value && (!He || He === document.body), et = ie();
      q(), T && k.value && !((Se = t == null ? void 0 : t.vnode.props) != null && Se["onUpdate:open"]) && console.warn(
        "[OPAL Popover] Escape was consumed and emitted as `update:open(false)`, but no `update:open` listener is bound: nothing can close this controlled popover. Listen for the emit (`v-model:open`), or Escape does nothing."
      ), !(!Ke || k.value) && F(et);
    }, se = Symbol("popover"), Q = (Ee) => {
      Ee.key !== "Escape" || Ee.defaultPrevented || ya(se) && ue(Ee);
    }, ae = () => {
      document.removeEventListener("keydown", Q), Fn(se);
    }, Te = m(() => $.value && !k.value);
    $e(Te, (Ee) => {
      Ee ? (ra(se), document.addEventListener("keydown", Q)) : ae();
    });
    const Le = (Ee) => {
      if (Ee.key === "Escape") {
        ue(Ee);
        return;
      }
      if ((Ee.key === "Enter" || Ee.key === " ") && !Ee.repeat && Ee.target instanceof Element && Ee.target.matches("[aria-haspopup='dialog']") && a.interactive && !a.closable && !$.value && U()) {
        Ee.key === " " && Ee.preventDefault(), V(), M(), p.value = !0;
        return;
      }
      if (Ee.key !== "Tab" || Ee.shiftKey || !S.value || !$.value || !h.value)
        return;
      const He = Aa(h.value)[0];
      He && (pe(Ee), He.focus());
    }, pe = (Ee) => {
      Ee.preventDefault(), Ee.stopPropagation();
    }, ke = () => {
      const Ee = ie();
      if (!Ee) return;
      const He = j0(document.body).filter((et) => {
        if (xe(h.value, et)) return !1;
        const Se = et.closest("[role='dialog'], [role='alertdialog']");
        return !Se || Se.contains(Ee);
      }), Ke = He.indexOf(Ee);
      return Ke < 0 ? void 0 : He[Ke + 1];
    }, fe = (Ee) => {
      var et;
      if (Ee.key === "Escape") {
        ue(Ee);
        return;
      }
      if (Ee.key !== "Tab" || !S.value || !h.value) return;
      const He = Aa(h.value), Ke = document.activeElement;
      if (Ee.shiftKey && Ke === He[0])
        pe(Ee), (et = ie()) == null || et.focus();
      else if (!Ee.shiftKey && Ke === He[He.length - 1]) {
        const Se = ke();
        if (!Se) return;
        pe(Ee), Se.focus(), k.value || q();
      }
    };
    return yt(() => {
      V(), M(), B(), ae(), P();
    }), (Ee, He) => (c(), g(de, null, [
      v("div", Fe({
        ref_key: "triggerRef",
        ref: b,
        class: "inline-flex"
      }, Ee.$attrs, {
        onMouseenter: K,
        onMouseleave: X,
        onFocusin: he,
        onFocusout: ee,
        onKeydown: Le,
        onClick: G
      }), [
        Ae(Ee.$slots, "trigger", { triggerProps: I.value }, void 0, !0)
      ], 16),
      (c(), W(Nn, { to: "body" }, [
        te(At, {
          name: "opal-popover",
          onAfterLeave: P
        }, {
          default: ve(() => [
            $.value ? (c(), g("div", {
              key: 0,
              id: L(i),
              ref_key: "bubbleRef",
              ref: h,
              role: S.value ? "dialog" : "tooltip",
              "aria-labelledby": S.value ? s : void 0,
              class: C(["opal-popover absolute z-9999", `opal-popover--${u.value}`]),
              style: je({ minWidth: a.minWidth, maxWidth: a.maxWidth }),
              "data-focus-trap-allow-outside": "",
              onMouseenter: oe,
              onMouseleave: Ce,
              onFocusin: G,
              onFocusout: J,
              onKeydown: fe
            }, [
              v("div", B3, [
                v("div", M3, [
                  v("span", {
                    id: s,
                    class: "min-w-0"
                  }, j(a.header), 1),
                  a.closable ? (c(), W(Me, {
                    key: 0,
                    variant: "ghost",
                    size: "xs",
                    "icon-only": "",
                    "icon-left": "ri-close-line",
                    "aria-label": a.closeLabel,
                    class: "opal-popover-close shrink-0",
                    onClick: _
                  }, null, 8, ["aria-label"])) : w("", !0)
                ]),
                v("div", {
                  id: d,
                  class: "opal-popover-body p-3 text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)"
                }, [
                  o() ? (c(), g("div", D3, [
                    L(r)("avatar") || L(r)("action") ? (c(), g("div", z3, [
                      L(r)("avatar") ? (c(), g("div", O3, [
                        Ae(Ee.$slots, "avatar", {}, void 0, !0)
                      ])) : w("", !0),
                      L(r)("action") ? (c(), g("div", P3, [
                        Ae(Ee.$slots, "action", {}, void 0, !0)
                      ])) : w("", !0)
                    ])) : w("", !0),
                    L(r)("title") ? (c(), g("div", {
                      key: 1,
                      class: C(["opal-popover-title min-w-0 font-(--weight-semi-bold)", { "mt-0.5": L(r)("avatar") || L(r)("action") }])
                    }, [
                      Ae(Ee.$slots, "title", {}, void 0, !0)
                    ], 2)) : w("", !0),
                    L(r)("badges") ? (c(), g("div", F3, [
                      Ae(Ee.$slots, "badges", {}, void 0, !0)
                    ])) : w("", !0)
                  ])) : w("", !0),
                  v("div", V3, [
                    Ae(Ee.$slots, "default", {}, void 0, !0)
                  ])
                ])
              ]),
              v("div", {
                class: "opal-popover-arrow",
                "aria-hidden": "true",
                style: je({ "--arrow-bg": f() })
              }, [...He[0] || (He[0] = [
                v("svg", {
                  viewBox: "0 0 40 10",
                  width: "40",
                  height: "10",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  v("path", {
                    class: "opal-popover-arrow-fill",
                    d: "M 0 0 L 6.59 0 Q 10.59 0 13.33 2.91 L 17.26 7.09 Q 20 10 22.74 7.09 L 26.67 2.91 Q 29.41 0 33.41 0 L 40 0 Z"
                  }),
                  v("path", {
                    class: "opal-popover-arrow-outline",
                    d: "M 6.59 0 Q 10.59 0 13.33 2.91 L 17.26 7.09 Q 20 10 22.74 7.09 L 26.67 2.91 Q 29.41 0 33.41 0"
                  })
                ], -1)
              ])], 4)
            ], 46, R3)) : w("", !0)
          ]),
          _: 3
        })
      ]))
    ], 64));
  }
}), qv = /* @__PURE__ */ dt(N3, [["__scopeId", "data-v-0eb73eba"]]), H3 = {
  key: 0,
  class: "block truncate"
}, j3 = {
  key: 1,
  class: "block truncate text-(--text-text-body)"
}, W3 = /* @__PURE__ */ ye({
  __name: "RelationPopover",
  props: {
    record: {},
    linkId: {},
    header: {},
    viewRecordLabel: {},
    disabled: { type: Boolean },
    linkClass: {}
  },
  setup(e) {
    return (n, t) => (c(), W(qv, {
      header: e.header,
      position: "top",
      interactive: "",
      delay: 0,
      "min-width": "260px",
      "max-width": "none",
      disabled: e.disabled,
      class: "min-w-0 max-w-full"
    }, sa({
      trigger: ve(({ triggerProps: a }) => [
        (c(), W(it(e.record.href ? "a" : "span"), Fe({ id: e.linkId }, a, {
          href: e.record.href,
          tabindex: e.record.href ? void 0 : 0,
          role: e.record.href ? void 0 : "button",
          "data-testid": "relation-input-link",
          class: ["min-w-0 truncate rounded-(--border-border-radius-rounded-xs) font-(--weight-medium) hover:underline focus-visible:underline focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-hidden", e.linkClass]
        }), {
          default: ve(() => [
            nt(j(e.record.label), 1)
          ]),
          _: 1
        }, 16, ["id", "href", "tabindex", "role", "class"]))
      ]),
      avatar: ve(() => [
        te(Nt, {
          name: e.record.label,
          img: e.record.avatarSrc,
          size: "md"
        }, null, 8, ["name", "img"])
      ]),
      title: ve(() => [
        te(pt, {
          text: e.record.label
        }, null, 8, ["text"])
      ]),
      default: ve(() => [
        e.record.email ? (c(), g("span", H3, j(e.record.email), 1)) : w("", !0),
        e.record.role ? (c(), g("span", j3, j(e.record.role), 1)) : w("", !0)
      ]),
      _: 2
    }, [
      e.record.href ? {
        name: "action",
        fn: ve(() => [
          te(Me, {
            as: "a",
            href: e.record.href,
            variant: "primary",
            size: "xs",
            label: e.viewRecordLabel
          }, null, 8, ["href", "label"])
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["header", "disabled"]));
  }
}), q3 = ["id", "value", "aria-expanded", "aria-controls", "aria-activedescendant", "aria-required", "aria-invalid", "aria-label", "aria-describedby", "placeholder"], U3 = ["aria-label"], G3 = ["id", "value", "readonly", "disabled", "placeholder", "aria-label", "aria-describedby"], K3 = {
  class: "sr-only",
  role: "status",
  "data-testid": "relation-input-status"
}, $q = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "RelationInput",
  props: {
    modelValue: { default: null },
    recentRecords: { default: () => [] },
    results: { default: () => [] },
    loading: { type: Boolean, default: !1 },
    resultsCount: { default: void 0 },
    label: { default: void 0 },
    labelTooltip: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    size: { default: "md" },
    id: { default: void 0 },
    labels: { default: () => ({}) }
  },
  emits: ["update:modelValue", "select", "search", "clear", "restore", "view-all", "create"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = m(() => ({
      recent: a.labels.recent ?? "Recently viewed",
      viewAll: a.labels.viewAll ?? "View all results",
      linkRemoved: a.labels.linkRemoved ?? "Link removed",
      restore: a.labels.restore ?? "Restore",
      clear: a.labels.clear ?? "Remove link",
      viewRecord: a.labels.viewRecord ?? "View record",
      noResults: a.labels.noResults ?? "No results",
      recordDetails: a.labels.recordDetails ?? "Record details",
      resultCount: a.labels.resultCount ?? ((F) => `${F} results`),
      loading: a.labels.loading ?? "Loading"
    })), o = qe(), i = m(() => a.id ?? `relation-input-${o}`), s = `relation-input-listbox-${o}`, d = `relation-input-hint-${o}`, u = `relation-input-error-${o}`, f = R(null), b = R(null), h = R(null), p = R(null), x = R(null), y = R(""), k = R(!1), $ = R(!1), S = R(!1), T = R(-1), I = R(null), A = m(() => !a.readonly && !a.disabled), E = m(() => y.value.trim() !== ""), D = m(() => !!a.modelValue), z = m(() => D.value && !E.value), Y = `relation-input-link-${o}`, le = m(() => {
      const F = [z.value && A.value && Y, a.hint && d, a.error && u].filter(Boolean);
      return F.length ? F.join(" ") : void 0;
    }), ne = m(() => a.resultsCount ?? a.results.length), re = m(() => {
      const F = a.labels.create;
      if (F)
        return typeof F == "function" ? F(y.value.trim()) : F;
    }), O = m(() => {
      const F = E.value ? a.results : a.recentRecords, _ = a.loading ? [] : F.map((ue, se) => ({ kind: "record", id: `${s}-option-${se}`, record: ue }));
      return E.value && (!a.loading && ne.value > 0 && _.push({ kind: "viewAll", id: `${s}-view-all`, label: `${r.value.viewAll} (${ne.value})` }), re.value && _.push({ kind: "create", id: `${s}-create`, label: re.value })), _;
    }), P = m(
      () => E.value && !a.loading && a.results.length === 0 ? r.value.noResults : void 0
    ), V = m(
      () => k.value && A.value && (E.value || a.loading || a.recentRecords.length > 0)
    ), M = m(() => !V.value || !E.value || a.loading ? "" : a.results.length ? r.value.resultCount(ne.value) : r.value.noResults), B = m(() => {
      var F;
      return (F = O.value[T.value]) == null ? void 0 : F.id;
    });
    $e(O, () => {
      T.value = -1;
    }), $e(
      () => a.modelValue,
      (F) => {
        F && (I.value = null);
      }
    );
    let q = null;
    $e(V, async (F) => {
      var ue;
      if (q == null || q.destroy(), q = null, !F) return;
      await Ge();
      const _ = (ue = b.value) == null ? void 0 : ue.$el;
      !_ || !h.value || (q = Xa(_, h.value, {
        placement: "bottom-start",
        strategy: "fixed",
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: ["top-start"] } },
          { name: "preventOverflow", options: { padding: 8 } },
          Gc
        ]
      }));
    }), $e(O, async () => {
      await Ge(), await (q == null ? void 0 : q.update());
    }), yt(() => q == null ? void 0 : q.destroy());
    function N() {
      A.value && (I.value = null, k.value = !0);
    }
    function G() {
      k.value = !1, T.value = -1;
    }
    function U(F) {
      I.value = null, y.value = "", G(), l("update:modelValue", F), l("select", F);
    }
    function K(F) {
      if (F.kind === "record") {
        U(F.record);
        return;
      }
      const _ = y.value.trim();
      G(), F.kind === "viewAll" ? l("view-all", _) : l("create", _);
    }
    function ge() {
      var _;
      const F = a.modelValue;
      F && (I.value = F, y.value = "", G(), l("update:modelValue", null), l("clear", F), (_ = f.value) == null || _.focus());
    }
    function xe() {
      var _;
      const F = I.value;
      F && (I.value = null, l("update:modelValue", F), l("restore", F), (_ = f.value) == null || _.focus());
    }
    function X(F) {
      y.value = F.target.value, I.value = null, N(), l("search", y.value);
    }
    function ie(F) {
      var ue;
      if (!A.value) return;
      const _ = F.target;
      _ != null && _.closest("a, button") || (_ !== f.value && (F.preventDefault(), (ue = f.value) == null || ue.focus()), N());
    }
    function he() {
      $.value = !1, G(), y.value = "";
    }
    function oe(F) {
      const _ = O.value.length;
      _ && (T.value = T.value === -1 ? F === 1 ? 0 : _ - 1 : (T.value + F + _) % _, Ge(() => {
        var ue, se;
        return (se = (ue = document.getElementById(B.value ?? "")) == null ? void 0 : ue.scrollIntoView) == null ? void 0 : se.call(ue, { block: "nearest" });
      }));
    }
    function Ce(F) {
      var ue, se;
      const _ = V.value;
      switch (F.key) {
        case "ArrowDown":
        case "ArrowUp": {
          F.preventDefault();
          const Q = F.key === "ArrowDown" ? 1 : -1;
          if (!_) {
            if (N(), F.altKey) return;
            Ge(() => oe(Q));
            return;
          }
          F.altKey || oe(Q);
          return;
        }
        case "Enter": {
          if (!_) {
            E.value || (F.preventDefault(), N());
            return;
          }
          F.preventDefault();
          const Q = O.value[T.value];
          Q && K(Q);
          return;
        }
        case " ": {
          !_ && !E.value && (F.preventDefault(), N());
          return;
        }
        case "Escape": {
          if (_) {
            F.preventDefault(), F.stopPropagation(), G();
            return;
          }
          if (E.value || I.value) {
            F.preventDefault(), F.stopPropagation(), y.value = "", I.value = null;
            return;
          }
          (ue = p.value) == null || ue.handleFieldKeydown(F), (se = x.value) == null || se.handleFieldKeydown(F);
          return;
        }
        case "Tab": {
          const Q = O.value[T.value];
          _ && (Q == null ? void 0 : Q.kind) === "record" && U(Q.record);
          return;
        }
      }
    }
    function H(F) {
      const _ = F.currentTarget;
      S.value = _.contains(F.relatedTarget);
    }
    const Z = (F) => F || $.value || V.value ? "text-(--icons-icon-accent)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", ee = (F) => A.value && D.value && (F || S.value || V.value), J = m(
      () => a.disabled ? "text-(--text-text-link)/44" : "text-(--text-text-link) dark:text-(--colors-text-link)"
    );
    return n({ focus: () => {
      var F;
      return (F = f.value) == null ? void 0 : F.focus();
    } }), (F, _) => (c(), g(de, null, [
      v("div", Fe(F.$attrs, {
        class: "flex w-full flex-col gap-px font-inter",
        "data-testid": "relation-input",
        onFocusin: _[2] || (_[2] = (ue) => S.value = !0),
        onFocusout: H
      }), [
        e.label ? (c(), W(It, {
          key: 0,
          ref_key: "labelRef",
          ref: p,
          text: e.label,
          "input-id": i.value,
          required: e.required,
          tooltip: e.labelTooltip,
          focused: $.value,
          "test-id": "relation-input-label"
        }, null, 8, ["text", "input-id", "required", "tooltip", "focused"])) : w("", !0),
        te(Vn, {
          ref_key: "shellRef",
          ref: b,
          size: e.size,
          disabled: e.disabled,
          readonly: e.readonly,
          error: !!e.error,
          focused: V.value,
          "has-value": D.value,
          class: C(A.value ? "cursor-text" : ""),
          "data-testid": "relation-input-field",
          onMousedown: ie
        }, {
          default: ve(({ hovered: ue, iconBoxClass: se, textClass: Q }) => {
            var ae;
            return [
              A.value ? (c(), g(de, { key: 0 }, [
                z.value && e.modelValue ? (c(), W(W3, {
                  key: 0,
                  record: e.modelValue,
                  header: r.value.recordDetails,
                  "view-record-label": r.value.viewRecord,
                  "link-id": Y,
                  disabled: V.value,
                  "link-class": [Q, J.value]
                }, null, 8, ["record", "header", "view-record-label", "disabled", "link-class"])) : w("", !0),
                v("input", {
                  id: i.value,
                  ref_key: "inputRef",
                  ref: f,
                  value: y.value,
                  type: "text",
                  role: "combobox",
                  "aria-autocomplete": "list",
                  "aria-haspopup": "listbox",
                  "aria-expanded": V.value,
                  "aria-controls": V.value ? s : void 0,
                  "aria-activedescendant": V.value ? B.value : void 0,
                  "aria-required": e.required || void 0,
                  "aria-invalid": !!e.error || void 0,
                  "aria-label": e.label ? void 0 : e.ariaLabel,
                  "aria-describedby": le.value,
                  autocomplete: "off",
                  placeholder: D.value ? void 0 : e.placeholder,
                  "data-testid": "relation-input-input",
                  class: C(["min-w-0 flex-1 truncate border-0 bg-transparent p-0 font-(--weight-medium) text-(--text-text-black-default) outline-none placeholder:text-(--text-text-disabled-strong) dark:text-(--text-text-white-default) dark:placeholder:text-(--colors-text-white-secondary)", Q]),
                  onInput: X,
                  onFocus: _[0] || (_[0] = (Te) => $.value = !0),
                  onBlur: he,
                  onKeydown: Ce
                }, null, 42, q3),
                ee(ue) ? (c(), g("button", {
                  key: 1,
                  type: "button",
                  "aria-label": r.value.clear,
                  "data-testid": "relation-input-clear",
                  class: C(["cursor-pointer rounded-(--border-border-radius-rounded-xs) text-(--icons-icon-dark-default) focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l) dark:text-(--icons-icon-white-default)", se]),
                  onMousedown: _[1] || (_[1] = Je(() => {
                  }, ["prevent"])),
                  onClick: ge
                }, [..._[5] || (_[5] = [
                  v("i", {
                    class: "ri-close-line",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 42, U3)) : (c(), g("i", {
                  key: 2,
                  class: C(["ri-search-line", [se, Z(ue)]]),
                  "aria-hidden": "true",
                  "data-testid": "relation-input-search-icon"
                }, null, 2))
              ], 64)) : (c(), g("input", {
                key: 1,
                id: i.value,
                value: ((ae = e.modelValue) == null ? void 0 : ae.label) ?? "",
                type: "text",
                readonly: e.readonly,
                disabled: e.disabled,
                placeholder: e.placeholder,
                "aria-label": e.label ? void 0 : e.ariaLabel,
                "aria-describedby": le.value,
                "data-testid": "relation-input-input",
                class: C(["min-w-0 flex-1 truncate border-0 bg-transparent p-0 font-(--weight-medium) outline-none placeholder:text-(--text-text-disabled-strong)", [Q, J.value, e.readonly ? "cursor-default" : "cursor-not-allowed"]])
              }, null, 10, G3))
            ];
          }),
          _: 1
        }, 8, ["size", "disabled", "readonly", "error", "focused", "has-value", "class"]),
        I.value && A.value ? (c(), W(_l, {
          key: 1,
          class: "mt-1",
          color: "info",
          layout: "stacked",
          "buttons-position": "right",
          message: r.value.linkRemoved,
          buttons: [{ label: r.value.restore, variant: "tertiary", icon: "ri-arrow-left-line", onClick: xe }],
          "data-testid": "relation-input-removed"
        }, null, 8, ["message", "buttons"])) : w("", !0),
        te($t, {
          ref_key: "helperRef",
          ref: x,
          focused: $.value,
          hint: e.hint,
          error: e.error,
          "hint-id": d,
          "error-id": u,
          "test-id-prefix": "relation-input"
        }, null, 8, ["focused", "hint", "error"]),
        v("span", K3, j(M.value), 1)
      ], 16),
      (c(), W(Nn, { to: "body" }, [
        V.value ? (c(), g("div", {
          key: 0,
          ref_key: "panelRef",
          ref: h,
          class: C(["fixed z-[200] overflow-y-auto", [L(Za), L(Uu)]]),
          "data-focus-trap-allow-outside": "",
          onMousedown: _[4] || (_[4] = Je(() => {
          }, ["prevent"]))
        }, [
          te(E3, {
            "listbox-id": s,
            items: O.value,
            "active-index": T.value,
            query: y.value,
            heading: E.value ? void 0 : r.value.recent,
            name: e.label ?? r.value.recent,
            loading: e.loading,
            "loading-label": r.value.loading,
            "empty-text": P.value,
            onChoose: K,
            onHover: _[3] || (_[3] = (ue) => T.value = ue)
          }, null, 8, ["items", "active-index", "query", "heading", "name", "loading", "loading-label", "empty-text"])
        ], 34)) : w("", !0)
      ]))
    ], 64));
  }
}), Y3 = {
  key: 0,
  class: "sr-only"
}, J3 = {
  key: 1,
  class: "flex flex-wrap gap-1.5",
  "data-testid": "avatar-label-badges"
}, Iq = /* @__PURE__ */ ye({
  __name: "AvatarLabel",
  props: {
    name: {},
    helperText: { default: void 0 },
    type: { default: "heading-helper" },
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    img: { default: void 0 },
    entity: { default: "contact" },
    avatarStyle: { default: "circle" },
    status: { default: void 0 },
    statusLabel: { default: void 0 },
    badges: { default: () => [] },
    maxBadges: { default: 3 },
    truncationFocusable: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = e, t = {
      "heading-helper": {
        sm: {
          avatar: "sm",
          gap: "gap-1.5",
          name: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)",
          helper: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)"
        },
        md: {
          avatar: "md",
          gap: "gap-2",
          name: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)",
          helper: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)"
        },
        lg: {
          avatar: "lg",
          gap: "gap-2.5",
          name: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)",
          helper: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular)"
        },
        xl: {
          avatar: "xl",
          gap: "gap-2.5",
          name: "text-(length:--size-5xl) leading-(--line-height-5xl) font-(--weight-bold)",
          helper: "text-(length:--size-xl) leading-(--line-height-xxl) font-(--weight-regular)"
        }
      },
      text: {
        sm: { avatar: "xs", gap: "gap-1.5", name: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)" },
        md: { avatar: "sm", gap: "gap-1.5", name: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)" },
        lg: { avatar: "lg", gap: "gap-2", name: "text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold)" },
        xl: { avatar: "xl", gap: "gap-2", name: "text-(length:--size-5xl) leading-(--line-height-5xl) font-(--weight-bold)" }
      }
    }, a = m(() => t[n.type][n.size]), l = m(() => {
      var b;
      return n.type === "heading-helper" && !!((b = n.helperText) != null && b.trim());
    }), r = m(() => n.type === "heading-helper" ? "xs" : "sm"), o = m(
      () => Wu(n.badges, n.maxBadges).map((b) => ({
        ...b,
        theme: n.disabled ? "disabled" : b.theme ?? "neutral"
      }))
    ), i = m(() => n.type === "heading-helper" && o.value.length > 0), s = m(() => i.value ? "items-start" : "items-center"), d = m(
      () => i.value ? n.size === "xl" ? "mt-0.5" : "mt-1" : void 0
    ), u = m(
      () => n.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-heading)"
    ), f = m(
      () => n.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-body)"
    );
    return (b, h) => (c(), g("div", {
      class: C(["flex min-w-0", [a.value.gap, s.value]]),
      "data-testid": "avatar-label"
    }, [
      te(Nt, {
        name: e.name,
        img: e.img,
        size: a.value.avatar,
        entity: e.entity,
        "avatar-style": e.avatarStyle,
        status: e.status,
        "status-label": e.statusLabel,
        presentational: "",
        class: C([{ "opacity-70": e.disabled }, d.value])
      }, null, 8, ["name", "img", "size", "entity", "avatar-style", "status", "status-label", "class"]),
      v("div", {
        class: C(["flex min-w-0 flex-1 flex-col", e.type === "text" ? "gap-1" : "gap-px"])
      }, [
        v("div", {
          class: C(["flex min-w-0", [a.value.name, u.value]]),
          "data-testid": "avatar-label-name"
        }, [
          te(pt, {
            text: e.name,
            focusable: e.truncationFocusable
          }, {
            default: ve(() => {
              var p;
              return [
                e.status && ((p = e.statusLabel) != null && p.trim()) ? (c(), g("span", Y3, ", " + j(e.statusLabel.trim()), 1)) : w("", !0)
              ];
            }),
            _: 1
          }, 8, ["text", "focusable"])
        ], 2),
        l.value ? (c(), g("div", {
          key: 0,
          class: C(["flex min-w-0", [a.value.helper, f.value]]),
          "data-testid": "avatar-label-helper"
        }, [
          te(pt, {
            text: e.helperText,
            focusable: e.truncationFocusable
          }, null, 8, ["text", "focusable"])
        ], 2)) : w("", !0),
        o.value.length ? (c(), g("div", J3, [
          (c(!0), g(de, null, Re(o.value, (p, x) => (c(), g(de, { key: x }, [
            L(ju)(p) ? (c(), W(Hu, {
              key: 0,
              label: p.label,
              "hidden-labels": p.hiddenLabels,
              theme: p.theme,
              size: r.value,
              focusable: e.truncationFocusable
            }, null, 8, ["label", "hidden-labels", "theme", "size", "focusable"])) : (c(), W(gt, {
              key: 1,
              label: p.label,
              theme: p.theme,
              size: r.value,
              truncate: p.truncate ?? !1,
              "truncation-focusable": e.truncationFocusable,
              "show-close-icon": !1
            }, null, 8, ["label", "theme", "size", "truncate", "truncation-focusable"]))
          ], 64))), 128))
        ])) : w("", !0)
      ], 2)
    ], 2));
  }
}), X3 = { class: "modal-scrollbar border border-(--border-border-base-medium) dark:border-(--colors-border-base) rounded-xl p-1 overflow-y-auto max-h-135" }, Z3 = {
  key: 0,
  class: "flex justify-center py-8"
}, Q3 = {
  key: 1,
  class: "flex flex-col items-center gap-2 py-8 text-center"
}, _3 = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default)" }, e4 = {
  key: 2,
  class: "flex flex-col items-center gap-2 py-8 text-center"
}, t4 = { class: "text-sm text-(--text-text-body-subtle)" }, n4 = ["aria-label"], a4 = ["aria-selected", "onClick"], l4 = { class: "flex items-center gap-1.5 min-w-0 flex-1" }, r4 = { class: "flex flex-col min-w-0" }, o4 = { class: "text-xs leading-5 font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" }, i4 = {
  key: 0,
  class: "text-xs leading-5 text-(--text-text-body) dark:text-(--text-text-white-default)"
}, Lq = /* @__PURE__ */ ye({
  __name: "AutoCompleteAllResultsModal",
  props: {
    modelValue: { type: Boolean },
    options: {},
    title: {},
    subtitle: { default: void 0 },
    loading: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    loadErrorLabel: { default: void 0 },
    emptyLabel: { default: void 0 },
    closeLabel: { default: void 0 },
    selectLabel: { default: void 0 }
  },
  emits: ["update:modelValue", "confirm"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R(null);
    $e(
      () => t.modelValue,
      (d) => {
        d && (l.value = null);
      }
    );
    function r(d) {
      var u;
      return ((u = d.meta) == null ? void 0 : u.uniqueKey) ?? d.value;
    }
    function o(d) {
      const u = jv(d);
      return { label: u == null ? void 0 : u.label, theme: u == null ? void 0 : u.theme, leftIcon: u == null ? void 0 : u.icon, brandIcon: u == null ? void 0 : u.brandIcon };
    }
    const i = m(() => [
      {
        id: "close",
        label: t.closeLabel ?? "Close",
        variant: "secondary",
        testId: "autocomplete-all-results-close",
        onClick: () => a("update:modelValue", !1)
      },
      {
        id: "select",
        label: t.selectLabel ?? "Select",
        variant: "primary",
        testId: "autocomplete-all-results-select",
        icon: "ri-check-line",
        disabled: !l.value,
        onClick: s
      }
    ]);
    function s() {
      l.value && (a("confirm", l.value), a("update:modelValue", !1));
    }
    return (d, u) => (c(), W(L(Ka), {
      "model-value": e.modelValue,
      size: "lg",
      "show-close-button": !0,
      "footer-align": "split",
      "overlay-class": "!z-[300]",
      "content-class": "!max-h-[748px]",
      "header-class": "pt-0!",
      title: e.title,
      subtitle: e.subtitle,
      actions: i.value,
      "onUpdate:modelValue": u[0] || (u[0] = (f) => d.$emit("update:modelValue", f))
    }, {
      default: ve(() => [
        v("div", X3, [
          e.loading ? (c(), g("div", Z3, [...u[1] || (u[1] = [
            v("i", { class: "ri-loader-4-line animate-spin text-2xl text-(--text-text-body-subtle)" }, null, -1)
          ])])) : e.error ? (c(), g("div", Q3, [
            u[2] || (u[2] = v("i", { class: "ri-error-warning-line text-2xl text-red-500" }, null, -1)),
            v("span", _3, j(e.loadErrorLabel ?? "Unable to load results."), 1)
          ])) : e.options.length ? (c(), g("div", {
            key: 3,
            role: "listbox",
            "aria-label": e.title,
            class: "flex flex-col gap-0.5"
          }, [
            (c(!0), g(de, null, Re(e.options, (f) => (c(), g("button", {
              key: r(f),
              type: "button",
              role: "option",
              "aria-selected": !!l.value && r(l.value) === r(f),
              class: C([
                "flex items-center justify-between h-11.5 w-full p-2 rounded-lg cursor-pointer transition-colors text-left",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)",
                l.value && r(l.value) === r(f) ? "bg-(--colors-background-accent) dark:bg-indigo-950/20" : "bg-transparent hover:bg-(--colors-background-hover) dark:hover:bg-(--colors-background-hover)"
              ]),
              onClick: (b) => l.value = f
            }, [
              v("span", l4, [
                f.image !== void 0 ? (c(), W(L(Nt), {
                  key: 0,
                  as: "span",
                  img: f.image ?? void 0,
                  name: f.label,
                  size: "sm",
                  presentational: !0,
                  class: "border border-(--border-border-base-soft)"
                }, null, 8, ["img", "name"])) : w("", !0),
                v("span", r4, [
                  v("span", o4, j(f.label), 1),
                  f.description ? (c(), g("span", i4, j(f.description), 1)) : w("", !0)
                ])
              ]),
              f.badge ? (c(), W(Nu, Fe({
                key: 0,
                ref_for: !0
              }, o(f), {
                size: "sm",
                class: "shrink-0 ml-2",
                "data-testid": "autocomplete-all-results-badge"
              }), null, 16)) : w("", !0)
            ], 10, a4))), 128))
          ], 8, n4)) : (c(), g("div", e4, [
            v("span", t4, j(e.emptyLabel ?? "No results to display."), 1)
          ]))
        ])
      ]),
      _: 1
    }, 8, ["model-value", "title", "subtitle", "actions"]));
  }
}), s4 = ["id", "name", "value", "placeholder", "disabled", "required", "aria-expanded", "aria-controls", "aria-labelledby", "aria-label", "aria-disabled", "aria-invalid", "aria-describedby", "aria-activedescendant"], d4 = ["id", "aria-label"], u4 = {
  key: 0,
  class: "px-3 py-2 text-sm text-gray-400 dark:text-(--colors-text-white-secondary)"
}, c4 = ["id", "data-index", "aria-selected", "aria-disabled", "onMousedown", "onMouseenter"], f4 = /* @__PURE__ */ ye({
  __name: "TimePickerInput",
  props: {
    modelValue: { default: void 0 },
    label: { default: void 0 },
    placeholder: { default: "HH:mm" },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    showError: { type: Boolean, default: void 0 },
    hint: { default: void 0 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: "384px" },
    minuteStep: { default: 15 },
    minTime: { default: void 0 },
    maxTime: { default: void 0 },
    gridStartTime: { default: void 0 },
    gridEndTime: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    groupPosition: { default: void 0 },
    ariaDescribedby: { default: void 0 },
    ariaLabel: { default: void 0 }
  },
  emits: ["update:modelValue", "change", "focus", "blur"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R(!1), r = R(!1), o = R(null), i = R(null), s = R(""), d = R(-1), u = R(null), f = R(null), b = R(null);
    let h = null;
    const p = () => {
      !f.value || !u.value || (h == null || h.destroy(), h = Xa(f.value, u.value, {
        strategy: "fixed",
        placement: "bottom-start",
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: ["top-start"] } },
          { name: "preventOverflow", options: { padding: 8 } },
          Gc
        ]
      }));
    }, x = () => {
      h == null || h.destroy(), h = null;
    }, y = qe(), k = m(() => t.id || y), $ = m(() => t.label ? `${k.value}-label` : void 0), S = m(() => `${k.value}-error`), T = m(() => `${k.value}-hint`), I = m(() => `${k.value}-listbox`), A = m(() => !!t.error), E = m(
      () => t.showError !== void 0 ? t.showError : A.value
    ), D = m(() => {
      if (t.ariaDescribedby) return t.ariaDescribedby;
      const Z = [];
      return t.hint && Z.push(T.value), A.value && E.value && Z.push(S.value), Z.length > 0 ? Z.join(" ") : void 0;
    }), z = m(() => {
      const Z = [], ee = t.minuteStep, J = t.gridStartTime ? le(t.gridStartTime) : 0, F = t.gridEndTime ? le(t.gridEndTime) : 24 * 60 - 1;
      for (let _ = J; _ <= F; _ += ee) {
        const ue = Math.floor(_ / 60).toString().padStart(2, "0"), se = (_ % 60).toString().padStart(2, "0");
        Z.push(`${ue}:${se}`);
      }
      return Z;
    }), Y = m(() => {
      if (!s.value) return z.value;
      const Z = s.value.replace(/[^0-9:]/g, "");
      return z.value.filter((ee) => ee.includes(Z));
    });
    function le(Z) {
      const [ee, J] = Z.split(":").map(Number);
      return ee * 60 + J;
    }
    function ne(Z) {
      if (!t.minTime && !t.maxTime) return !1;
      const ee = le(Z), J = t.minTime ? le(t.minTime) : 0, F = t.maxTime ? le(t.maxTime) : 24 * 60 - 1;
      return ee < J || ee > F;
    }
    function re(Z) {
      const ee = Z.findIndex((J) => !ne(J));
      return ee >= 0 ? ee : 0;
    }
    function O(Z, ee, J) {
      let F = Z;
      for (let _ = 0; _ < J.length; _++) {
        if (F += ee, F < 0 || F >= J.length) return Z;
        if (!ne(J[F])) return F;
      }
      return Z;
    }
    const V = {
      sm: {
        container: "h-[36px] px-2.5 gap-2",
        text: "text-sm leading-5",
        icon: "h-4 w-4"
      },
      md: {
        container: "h-[36px] px-3 py-2 gap-2",
        text: "text-sm leading-5",
        icon: "h-4 w-4"
      },
      lg: {
        container: "h-[48px] px-3.5 gap-2",
        text: "text-base leading-6",
        icon: "h-5 w-5"
      }
    }[t.size], M = m(() => t.groupPosition === "start" ? "rounded-r-none! border-r-0!" : t.groupPosition === "end" ? "rounded-l-none!" : ""), B = m(() => {
      const Z = "relative rounded-xl border-solid box-border flex items-center text-left font-inter";
      if (t.disabled)
        return `${Z} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled)`;
      if (A.value)
        return `${Z} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-white dark:bg-(--colors-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error) text-text-black-default dark:text-(--colors-text-white-default)`;
      if (r.value)
        return `${Z} border-[1px] shadow-[0px_0px_2px_var(--border-border-accent)] bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent) text-text-black-default dark:text-(--colors-text-white-default)`;
      const J = t.modelValue !== void 0 && t.modelValue !== "" ? "text-text-black-default" : "text-text-body-subtle";
      return `${Z} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--colors-background-black-default) border-(--border-border-base-medium) hover:border-(--border-border-accent) dark:border-(--colors-border-base) transition-colors ${J} dark:text-(--colors-text-white-default)`;
    }), q = m(() => t.fullWidth ? "w-full" : ""), N = m(() => t.fullWidth ? {} : { width: t.width }), G = m(() => `relative flex items-start pb-0.5 text-left text-sm text-text-black-default dark:text-(--colors-text-white-default) font-inter flex-col gap-0.5 ${t.fullWidth ? "w-full" : ""}`), U = m(() => t.fullWidth ? {} : { width: t.width }), K = () => {
      if (t.disabled) return;
      l.value = !0, s.value = "";
      const Z = z.value.indexOf(t.modelValue || "");
      Z >= 0 ? d.value = Z : t.modelValue ? d.value = -1 : d.value = re(z.value), Ce();
    }, ge = () => {
      l.value = !1, s.value = "", d.value = -1;
    }, xe = (Z) => {
      var ee;
      ne(Z) || (a("update:modelValue", Z), a("change", Z), ge(), (ee = f.value) == null || ee.focus());
    }, X = (Z) => {
      t.disabled || (r.value = !0, a("focus", Z));
    }, ie = (Z) => {
      setTimeout(() => {
        var ee;
        (ee = b.value) != null && ee.contains(document.activeElement) || (r.value = !1, ge(), a("blur", Z));
      }, 150);
    }, he = (Z) => {
      const ee = Z.target;
      s.value = ee.value, l.value || K(), d.value = 0;
    }, oe = (Z) => {
      var J, F;
      l.value || ((J = o.value) == null || J.handleFieldKeydown(Z), (F = i.value) == null || F.handleFieldKeydown(Z));
      const ee = Y.value;
      switch (Z.key) {
        case "ArrowDown":
          Z.preventDefault(), l.value ? (d.value = O(d.value, 1, ee), Ce()) : K();
          break;
        case "ArrowUp":
          Z.preventDefault(), l.value && (d.value = O(d.value, -1, ee), Ce());
          break;
        case "Enter":
          Z.preventDefault(), l.value && d.value >= 0 && d.value < ee.length ? xe(ee[d.value]) : l.value || K();
          break;
        case "Escape":
          l.value && (Z.stopPropagation(), Z.preventDefault(), ge());
          break;
        case "Tab":
          ge();
          break;
      }
    }, Ce = () => {
      requestAnimationFrame(() => {
        var ee;
        const Z = (ee = u.value) == null ? void 0 : ee.querySelector(`[data-index="${d.value}"]`);
        Z == null || Z.scrollIntoView({ block: "nearest" });
      });
    }, H = (Z) => {
      b.value && !b.value.contains(Z.target) && (ge(), r.value = !1);
    };
    return ct(() => {
      document.addEventListener("mousedown", H);
    }), kt(() => {
      document.removeEventListener("mousedown", H), x();
    }), $e(l, async (Z) => {
      Z ? (await Ge(), p()) : x();
    }), $e(s, () => {
      d.value = 0;
    }), (Z, ee) => (c(), g("div", {
      ref_key: "containerRef",
      ref: b,
      class: C(G.value),
      style: je(U.value)
    }, [
      e.label ? (c(), W(It, {
        key: 0,
        id: $.value,
        ref_key: "labelRef",
        ref: o,
        text: e.label,
        "input-id": k.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: r.value,
        "test-id": "time-picker-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused"])) : w("", !0),
      v("div", {
        class: C(["relative", q.value]),
        style: je(N.value)
      }, [
        v("div", {
          class: C([B.value, L(V).container, q.value, M.value]),
          style: je(N.value),
          onClick: K
        }, [
          v("i", {
            class: C(["ri-time-line flex-shrink-0", [
              L(V).icon,
              e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : r.value ? "text-[#7c86ff]" : "text-gray-400 dark:text-(--colors-text-white-secondary)"
            ]])
          }, null, 2),
          v("input", {
            id: k.value,
            ref_key: "inputRef",
            ref: f,
            type: "text",
            name: e.name,
            value: l.value ? s.value : e.modelValue || "",
            placeholder: e.placeholder,
            disabled: e.disabled,
            required: e.required,
            autocomplete: "off",
            "data-testid": "time-picker-input",
            role: "combobox",
            "aria-expanded": l.value,
            "aria-controls": I.value,
            "aria-labelledby": $.value,
            "aria-label": e.ariaLabel,
            "aria-disabled": e.disabled ? "true" : "false",
            "aria-invalid": A.value ? "true" : void 0,
            "aria-describedby": D.value,
            "aria-activedescendant": l.value && d.value >= 0 ? `${k.value}-option-${d.value}` : void 0,
            class: C([
              "flex-1 min-w-0 bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 w-full",
              L(V).text,
              !e.disabled && "cursor-text"
            ]),
            onFocus: X,
            onBlur: ie,
            onInput: he,
            onKeydown: oe
          }, null, 42, s4)
        ], 6),
        tr(v("div", {
          id: I.value,
          ref_key: "dropdownRef",
          ref: u,
          role: "listbox",
          "aria-label": e.label || e.ariaLabel || "Time selection",
          class: "fixed z-50 max-h-[200px] overflow-auto rounded-xl border border-solid border-lightgray dark:border-(--colors-border-base) bg-white-50-opacity-bold dark:bg-(--colors-background-black-default) shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] dark:shadow-(--blur-shadow-m-dark)",
          "data-testid": "time-picker-dropdown"
        }, [
          Y.value.length === 0 ? (c(), g("div", u4, " Aucun horaire disponible ")) : w("", !0),
          (c(!0), g(de, null, Re(Y.value, (J, F) => (c(), g("div", {
            id: `${k.value}-option-${F}`,
            key: J,
            "data-index": F,
            role: "option",
            "aria-selected": J === e.modelValue,
            "aria-disabled": ne(J) ? "true" : void 0,
            class: C(["px-3 py-2 text-sm transition-colors", [
              ne(J) ? "cursor-not-allowed text-text-disabled dark:text-(--colors-text-disabled)" : "cursor-pointer",
              !ne(J) && J === e.modelValue ? "bg-[#7c86ff]/10 text-[#7c86ff] font-medium" : "",
              !ne(J) && J !== e.modelValue && F === d.value ? "bg-gray-100 dark:bg-[rgba(255,255,255,0.08)] text-text-black-default dark:text-(--colors-text-white-default)" : "",
              !ne(J) && J !== e.modelValue && F !== d.value ? "text-text-black-default dark:text-(--colors-text-white-default) hover:bg-gray-50 dark:hover:bg-[rgba(255,255,255,0.05)]" : ""
            ]]),
            onMousedown: Je((_) => xe(J), ["prevent"]),
            onMouseenter: (_) => !ne(J) && (d.value = F)
          }, j(J), 43, c4))), 128))
        ], 8, d4), [
          [Ru, l.value]
        ])
      ], 6),
      te($t, {
        ref_key: "helperRef",
        ref: i,
        focused: r.value,
        hint: e.hint,
        error: E.value ? e.error : void 0,
        "hint-id": T.value,
        "error-id": S.value,
        "test-id-prefix": "time-picker"
      }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"])
    ], 6));
  }
}), Tq = /* @__PURE__ */ dt(f4, [["__scopeId", "data-v-60bc77d5"]]), h4 = {
  "data-testid": "number-range-input",
  class: "flex flex-col gap-4 w-full"
}, b4 = {
  key: 0,
  "data-testid": "number-range-slider",
  class: "relative w-full h-5"
}, g4 = ["min", "max", "step", "value", "disabled", "aria-label"], m4 = ["min", "max", "step", "value", "disabled", "aria-label"], p4 = { class: "flex flex-1 min-w-0 flex-col gap-px" }, v4 = ["id", "value", "min", "max", "step", "placeholder", "disabled", "aria-label"], x4 = { class: "shrink-0 py-2 font-(--weight-medium) text-(length:--size-m) leading-(--line-height-l) text-(--text-text-black-default) dark:text-(--colors-text-white-default)" }, y4 = { class: "flex flex-1 min-w-0 flex-col gap-px" }, k4 = ["id", "value", "min", "max", "step", "placeholder", "disabled", "aria-label"], w4 = {
  key: 1,
  "data-testid": "number-range-hint",
  class: "text-(length:--size-xs) leading-(--line-height-s) text-(--text-text-body-subtle) dark:text-(--colors-text-body-subtle) m-0"
}, C4 = /* @__PURE__ */ ye({
  __name: "NumberRangeInput",
  props: {
    minValue: { default: null },
    maxValue: { default: null },
    min: { default: 0 },
    max: { default: 100 },
    step: { default: 1 },
    minPlaceholder: { default: "0" },
    maxPlaceholder: { default: "" },
    separatorLabel: { default: "to" },
    showSlider: { type: Boolean, default: !0 },
    disabled: { type: Boolean, default: !1 },
    minAriaLabel: { default: "Minimum value" },
    maxAriaLabel: { default: "Maximum value" },
    minLabel: { default: void 0 },
    maxLabel: { default: void 0 },
    clampInputToBounds: { type: Boolean, default: !0 },
    dataMin: { default: null },
    dataMax: { default: null },
    hintLabel: { default: "" }
  },
  emits: ["update:minValue", "update:maxValue"],
  setup(e, { emit: n }) {
    const t = e, a = qe(), l = qe(), r = n, o = (I) => Math.max(t.min, Math.min(I, t.max)), i = R(o(t.minValue ?? t.min)), s = R(o(t.maxValue ?? t.max));
    $e(
      () => t.minValue,
      (I) => {
        i.value = o(I ?? t.min);
      }
    ), $e(
      () => t.maxValue,
      (I) => {
        s.value = o(I ?? t.max);
      }
    );
    const d = m(() => t.max - t.min || 1), u = m(() => (i.value - t.min) / d.value * 100), f = m(() => (s.value - t.min) / d.value * 100), b = m(() => ({
      left: `${u.value}%`,
      width: `${f.value - u.value}%`
    })), h = m(() => u.value > 50), p = m(
      () => t.dataMin != null && t.dataMax != null && t.dataMax > t.dataMin
    ), x = m(
      () => t.dataMin != null ? Math.max(0, Math.min(100, (t.dataMin - t.min) / d.value * 100)) : 0
    ), y = m(
      () => t.dataMax != null ? Math.max(0, Math.min(100, (t.dataMax - t.min) / d.value * 100)) : 100
    );
    function k(I) {
      const A = I.target, E = Number(A.value), D = Math.min(E, s.value - t.step);
      i.value = D, E !== D && (A.value = String(D)), r("update:minValue", D);
    }
    function $(I) {
      const A = I.target, E = Number(A.value), D = Math.max(E, i.value + t.step);
      s.value = D, E !== D && (A.value = String(D)), r("update:maxValue", D);
    }
    function S(I) {
      const A = I.target, E = A.value;
      if (E === "") {
        r("update:minValue", null);
        return;
      }
      const D = Number(E);
      if (Number.isFinite(D))
        if (i.value = o(D), t.clampInputToBounds) {
          const z = o(D);
          D !== z && (A.value = String(z)), r("update:minValue", z);
        } else
          r("update:minValue", D);
    }
    function T(I) {
      const A = I.target, E = A.value;
      if (E === "") {
        r("update:maxValue", null);
        return;
      }
      const D = Number(E);
      if (Number.isFinite(D))
        if (s.value = o(D), t.clampInputToBounds) {
          const z = o(D);
          D !== z && (A.value = String(z)), r("update:maxValue", z);
        } else
          r("update:maxValue", D);
    }
    return (I, A) => (c(), g("div", h4, [
      e.showSlider ? (c(), g("div", b4, [
        A[0] || (A[0] = v("div", { class: "absolute top-1/2 -translate-y-1/2 w-full h-2 rounded-(--border-border-radius-rounded-base) bg-(--background-background-gray)" }, null, -1)),
        p.value ? (c(), g(de, { key: 0 }, [
          v("div", {
            "data-testid": "number-range-data-marker-min",
            class: "absolute top-1/2 -translate-y-1/2 h-3 w-px bg-(--border-border-base-soft) dark:bg-(--colors-border-base-soft) opacity-80 pointer-events-none",
            style: je({ left: `${x.value}%` }),
            "aria-hidden": "true"
          }, null, 4),
          v("div", {
            "data-testid": "number-range-data-marker-max",
            class: "absolute top-1/2 -translate-y-1/2 h-3 w-px bg-(--border-border-base-soft) dark:bg-(--colors-border-base-soft) opacity-80 pointer-events-none",
            style: je({ left: `${y.value}%` }),
            "aria-hidden": "true"
          }, null, 4)
        ], 64)) : w("", !0),
        v("div", {
          class: "absolute top-1/2 -translate-y-1/2 h-2 rounded-(--border-border-radius-rounded-base)",
          style: je({ ...b.value, background: "linear-gradient(36deg, #716FF2 11%, #52DBF5 87%)" })
        }, null, 4),
        v("input", {
          type: "range",
          min: e.min,
          max: e.max,
          step: e.step,
          value: i.value,
          disabled: e.disabled,
          "aria-label": e.minAriaLabel,
          class: C(["range-thumb absolute top-0 left-0 w-full h-5 appearance-none bg-transparent pointer-events-none", h.value ? "z-30" : "z-20"]),
          onInput: k
        }, null, 42, g4),
        v("input", {
          type: "range",
          min: e.min,
          max: e.max,
          step: e.step,
          value: s.value,
          disabled: e.disabled,
          "aria-label": e.maxAriaLabel,
          class: C(["range-thumb absolute top-0 left-0 w-full h-5 appearance-none bg-transparent pointer-events-none", h.value ? "z-20" : "z-30"]),
          onInput: $
        }, null, 42, m4)
      ])) : w("", !0),
      v("div", {
        class: C(["flex gap-6 w-full", e.minLabel || e.maxLabel ? "items-end" : "items-center"])
      }, [
        v("div", p4, [
          e.minLabel ? (c(), W(It, {
            key: 0,
            text: e.minLabel,
            "input-id": L(a),
            "test-id": "number-range-min-label"
          }, null, 8, ["text", "input-id"])) : w("", !0),
          v("input", {
            id: L(a),
            type: "number",
            "data-testid": "number-range-min",
            value: e.minValue ?? "",
            min: e.clampInputToBounds ? e.min : void 0,
            max: e.clampInputToBounds ? e.max : void 0,
            step: e.step,
            placeholder: e.minPlaceholder,
            disabled: e.disabled,
            "aria-label": e.minLabel ? void 0 : e.minAriaLabel,
            class: "w-full bg-(--background-background-white) border border-solid border-(--border-border-base-soft) rounded-(--border-border-radius-rounded-l) px-3 py-2 text-(length:--size-m) font-inter leading-(--line-height-l) text-(--text-text-black-default) placeholder:text-(--text-text-body-subtle) outline-none focus:border-royalblue transition-colors disabled:opacity-50",
            onChange: S
          }, null, 40, v4)
        ]),
        v("span", x4, j(e.separatorLabel), 1),
        v("div", y4, [
          e.maxLabel ? (c(), W(It, {
            key: 0,
            text: e.maxLabel,
            "input-id": L(l),
            "test-id": "number-range-max-label"
          }, null, 8, ["text", "input-id"])) : w("", !0),
          v("input", {
            id: L(l),
            type: "number",
            "data-testid": "number-range-max",
            value: e.maxValue ?? "",
            min: e.clampInputToBounds ? e.min : void 0,
            max: e.clampInputToBounds ? e.max : void 0,
            step: e.step,
            placeholder: e.maxPlaceholder,
            disabled: e.disabled,
            "aria-label": e.maxLabel ? void 0 : e.maxAriaLabel,
            class: "w-full bg-(--background-background-white) border border-solid border-(--border-border-base-soft) rounded-(--border-border-radius-rounded-l) px-3 py-2 text-(length:--size-m) font-inter leading-(--line-height-l) text-(--text-text-black-default) placeholder:text-(--text-text-body-subtle) outline-none focus:border-royalblue transition-colors disabled:opacity-50",
            onChange: T
          }, null, 40, k4)
        ])
      ], 2),
      e.hintLabel ? (c(), g("p", w4, j(e.hintLabel), 1)) : w("", !0)
    ]));
  }
}), Uv = /* @__PURE__ */ dt(C4, [["__scopeId", "data-v-61d0ad59"]]), S4 = { class: "inline-flex min-w-0 items-center gap-1" }, $4 = { class: "inline-flex min-w-0 items-center gap-0.5" }, I4 = ["for"], L4 = {
  key: 0,
  "aria-hidden": "true",
  class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
}, hd = /* @__PURE__ */ ye({
  __name: "ToggleLabel",
  props: {
    forId: {},
    text: {},
    required: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    unavailable: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), g("span", S4, [
      v("span", $4, [
        v("label", {
          for: e.forId,
          class: C(["min-w-0 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-heading) dark:text-(--colors-text-white-default)", e.unavailable ? "cursor-not-allowed" : "cursor-pointer"])
        }, j(e.text), 11, I4),
        e.required ? (c(), g("span", L4, "*")) : w("", !0)
      ]),
      e.labelTooltip ? (c(), W(mt, {
        key: 0,
        text: e.labelTooltip,
        as: "span",
        "labels-trigger": "",
        role: "img",
        tabindex: "0",
        "aria-label": e.labelTooltip,
        class: "shrink-0 rounded-(--border-border-radius-rounded-full) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent"
      }, {
        default: ve(() => [...t[0] || (t[0] = [
          v("i", {
            class: "ri-question-line text-(length:--icon-size-xs) leading-none text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
            "aria-hidden": "true"
          }, null, -1)
        ])]),
        _: 1
      }, 8, ["text", "aria-label"])) : w("", !0)
    ]));
  }
}), Gv = Symbol("ToggleGroup"), T4 = { class: "flex min-w-0 flex-[1_1_11rem] flex-col gap-2" }, A4 = { class: "flex h-8 w-22.5 shrink-0 items-center" }, E4 = ["for"], R4 = ["id"], B4 = ["data-testid"], M4 = ["id", "name", "checked", "disabled", "aria-disabled", "onChange"], D4 = {
  key: 0,
  class: "whitespace-nowrap text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
}, z4 = { class: "sr-only" }, O4 = { class: "flex min-w-0 items-start justify-between gap-2" }, P4 = ["id"], F4 = ["id"], V4 = { class: "flex min-w-0 flex-[1_1_11rem] items-center gap-2.5" }, N4 = { class: "flex min-w-0 flex-1 flex-col gap-0.5" }, H4 = ["id"], j4 = "label, a, button, input, select, textarea, summary, [role=button], [role=link], [tabindex]", bd = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)", pr = "min-w-0 rounded-(--border-border-radius-rounded-l) border border-(--colors-border-base-soft) bg-(--colors-background-white) shadow-(--blur-shadow-xs) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default)", Aq = /* @__PURE__ */ ye({
  __name: "ToggleInput",
  props: {
    modelValue: { type: Boolean, default: !1 },
    label: {},
    description: { default: void 0 },
    type: { default: void 0 },
    icon: { default: void 0 },
    required: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    leftLabel: { default: void 0 },
    rightLabel: { default: void 0 },
    leftIcon: { default: void 0 },
    rightIcon: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    id: { default: void 0 },
    ariaDescribedby: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = Kt(Gv, void 0), r = m(() => t.type ?? (l == null ? void 0 : l.value) ?? "advanced"), o = m(() => r.value === "left-right-label" || r.value === "left-right-icons"), i = m(() => r.value !== "default" && !o.value), s = m(() => t.disabled || t.ariaDisabled), d = qe(), u = m(() => t.id ?? d), f = m(() => `${u.value}-description`), b = m(() => {
      const z = !!t.description && !o.value, Y = [t.ariaDescribedby, z ? f.value : void 0].filter(Boolean);
      return Y.length > 0 ? Y.join(" ") : void 0;
    }), h = m(() => ({
      id: u.value,
      modelValue: t.modelValue,
      disabled: t.disabled,
      ariaDisabled: t.ariaDisabled,
      "aria-describedby": b.value,
      "onUpdate:modelValue": (z) => a("update:modelValue", z)
    })), p = ta("toggleSwitch");
    function x(z) {
      var P;
      const Y = z.currentTarget, le = z.target;
      if (z.detail > 1) {
        const V = le == null ? void 0 : le.closest("label");
        V && Y.contains(V) && z.preventDefault();
        return;
      }
      if (!i.value) return;
      const ne = (P = p.value) == null ? void 0 : P.$el;
      if (!ne || !le || ne.contains(le) || ne.disabled) return;
      const re = le.closest(j4);
      if (re && Y.contains(re)) return;
      const O = window.getSelection();
      O && !O.isCollapsed && Y.contains(O.anchorNode) || (z.stopPropagation(), ne.click());
    }
    const y = ta("leftRadio"), k = ta("rightRadio"), $ = m(() => [
      { key: "left", right: !1, text: t.leftLabel, icon: t.leftIcon },
      { key: "right", right: !0, text: t.rightLabel, icon: t.rightIcon }
    ]);
    function S(z) {
      t.ariaDisabled && z.preventDefault();
    }
    function T(z, Y = !1) {
      var le, ne;
      s.value || t.modelValue === z || (a("update:modelValue", z), Y && ((ne = (le = (z ? k : y).value) == null ? void 0 : le[0]) == null || ne.focus()));
    }
    async function I(z) {
      var le;
      T(z), await Ge();
      const Y = (le = (t.modelValue ? k : y).value) == null ? void 0 : le[0];
      Y && !Y.checked && (Y.checked = !0);
    }
    const A = m(() => {
      const z = s.value ? "" : " cursor-pointer";
      switch (r.value) {
        case "default":
          return "flex min-w-0 items-start gap-2";
        case "simple":
          return `${pr} flex items-start gap-2.5 p-4${z}`;
        case "logo":
          return `${pr} flex flex-wrap items-start justify-between gap-x-16 gap-y-3 p-4${z}`;
        case "title-toggle":
          return `${pr} flex flex-col gap-2 p-4${z}`;
        case "toggle-text":
          return `${pr} flex items-center gap-2.5 px-4 py-3${z}`;
        case "left-right-label":
        case "left-right-icons":
          return "group inline-flex items-center gap-3";
        default:
          return `${pr} flex flex-wrap items-center justify-between gap-x-16 gap-y-3 px-4 py-3${z}`;
      }
    }), E = m(() => s.value ? "relative flex cursor-not-allowed" : "relative flex cursor-pointer"), D = m(
      () => o.value ? { role: "radiogroup", "aria-label": t.label, "aria-describedby": t.ariaDescribedby } : {}
    );
    return (z, Y) => (c(), g("div", Fe({ class: A.value }, D.value, { onClick: x }), [
      r.value === "logo" ? (c(), g(de, { key: 0 }, [
        v("div", T4, [
          v("div", A4, [
            Ae(z.$slots, "logo")
          ]),
          v("label", {
            for: u.value,
            class: "sr-only"
          }, j(e.label), 9, E4),
          e.description ? (c(), g("p", {
            key: 0,
            id: f.value,
            class: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
          }, j(e.description), 9, R4)) : w("", !0)
        ]),
        te(nl, Fe({
          ref_key: "toggleSwitch",
          ref: p
        }, h.value), null, 16)
      ], 64)) : o.value ? (c(!0), g(de, { key: 1 }, Re($.value, (le) => (c(), g(de, {
        key: le.key
      }, [
        le.right ? (c(), W(nl, {
          key: 0,
          type: "default",
          presentational: "",
          "aria-hidden": "true",
          "data-testid": "toggle-input-switch",
          class: C(["group-has-focus-visible:shadow-(--shadow-focus-l) group-has-focus-visible:outline-2 group-has-focus-visible:outline-transparent", s.value ? "cursor-not-allowed" : "cursor-pointer"]),
          "model-value": e.modelValue,
          disabled: e.disabled,
          "aria-disabled": e.ariaDisabled,
          onClick: Y[0] || (Y[0] = (ne) => T(!e.modelValue, !0))
        }, null, 8, ["class", "model-value", "disabled", "aria-disabled"])) : w("", !0),
        v("label", {
          class: C(E.value),
          "data-testid": `toggle-input-${le.key}`
        }, [
          v("input", {
            id: `${u.value}-${le.key}`,
            ref_for: !0,
            ref: le.right ? "rightRadio" : "leftRadio",
            type: "radio",
            class: "absolute inset-0 m-0 size-full cursor-[inherit] appearance-none opacity-0",
            name: u.value,
            checked: e.modelValue === le.right,
            disabled: e.disabled,
            "aria-disabled": e.ariaDisabled ? "true" : void 0,
            onClick: S,
            onChange: (ne) => I(le.right)
          }, null, 40, M4),
          r.value === "left-right-label" ? (c(), g("span", D4, j(le.text), 1)) : (c(), g(de, { key: 1 }, [
            v("i", {
              "aria-hidden": "true",
              class: C([le.icon, "block text-(length:--icon-size-md) leading-none text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"])
            }, null, 2),
            v("span", z4, j(le.text), 1)
          ], 64))
        ], 10, B4)
      ], 64))), 128)) : r.value === "title-toggle" ? (c(), g(de, { key: 2 }, [
        v("div", O4, [
          te(hd, {
            "for-id": u.value,
            text: e.label,
            required: e.required,
            "label-tooltip": e.labelTooltip,
            unavailable: s.value
          }, null, 8, ["for-id", "text", "required", "label-tooltip", "unavailable"]),
          te(nl, Fe({
            ref_key: "toggleSwitch",
            ref: p
          }, h.value), null, 16)
        ]),
        e.description ? (c(), g("p", {
          key: 0,
          id: f.value,
          class: C(bd)
        }, j(e.description), 9, P4)) : w("", !0)
      ], 64)) : r.value === "default" || r.value === "simple" || r.value === "toggle-text" ? (c(), g(de, { key: 3 }, [
        te(nl, Fe({
          ref_key: "toggleSwitch",
          ref: p
        }, h.value), null, 16),
        v("div", {
          class: C(["flex min-w-0 flex-col", r.value === "default" ? "gap-0.5" : r.value === "simple" ? "flex-1 gap-1" : "flex-1 gap-0.5"])
        }, [
          te(hd, {
            "for-id": u.value,
            text: e.label,
            required: e.required,
            "label-tooltip": e.labelTooltip,
            unavailable: s.value
          }, null, 8, ["for-id", "text", "required", "label-tooltip", "unavailable"]),
          e.description ? (c(), g("p", {
            key: 0,
            id: f.value,
            class: C(bd)
          }, j(e.description), 9, F4)) : w("", !0)
        ], 2)
      ], 64)) : (c(), g(de, { key: 4 }, [
        v("div", V4, [
          e.icon ? (c(), W(Gt, {
            key: 0,
            icon: e.icon,
            color: "white",
            size: "md",
            type: "square"
          }, null, 8, ["icon"])) : w("", !0),
          v("div", N4, [
            te(hd, {
              "for-id": u.value,
              text: e.label,
              required: e.required,
              "label-tooltip": e.labelTooltip,
              unavailable: s.value
            }, null, 8, ["for-id", "text", "required", "label-tooltip", "unavailable"]),
            e.description ? (c(), g("p", {
              key: 0,
              id: f.value,
              class: C(bd)
            }, j(e.description), 9, H4)) : w("", !0)
          ])
        ]),
        te(nl, Fe({
          ref_key: "toggleSwitch",
          ref: p
        }, h.value), null, 16)
      ], 64))
    ], 16));
  }
}), W4 = ["aria-label"], Eq = /* @__PURE__ */ ye({
  __name: "ToggleGroup",
  props: {
    type: { default: "default" },
    ariaLabel: { default: void 0 }
  },
  setup(e) {
    const n = e, t = {
      default: "simple",
      integration: "logo",
      settings: "advanced"
    };
    return dn(
      Gv,
      m(() => t[n.type])
    ), (a, l) => (c(), g("div", {
      role: "group",
      "aria-label": e.ariaLabel,
      class: "flex min-w-0 flex-col gap-4"
    }, [
      Ae(a.$slots, "default")
    ], 8, W4));
  }
}), q4 = ["value", "placeholder", "aria-label", "title", "disabled"], U4 = ["aria-label"], G4 = /* @__PURE__ */ ye({
  __name: "CollapsibleSearch",
  props: {
    modelValue: {},
    placeholder: { default: "Search..." },
    labels: { default: void 0 },
    maxWidth: { default: "175px" },
    disabled: { type: Boolean, default: !1 },
    autoFocus: { type: Boolean, default: !0 },
    debounce: { default: 0 }
  },
  emits: ["update:modelValue", "expand", "collapse", "clear", "pending"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = { closeSearch: "Clear search" }, o = m(() => ({ ...r, ...a.labels })), i = R(a.modelValue.length > 0), s = R(null), d = R(null), u = R(a.modelValue);
    let f;
    function b() {
      f !== void 0 && (clearTimeout(f), f = void 0, l("pending", !1));
    }
    function h(I) {
      b(), I !== a.modelValue && l("update:modelValue", I);
    }
    $e(
      () => a.modelValue,
      (I) => {
        I.length > 0 && (i.value = !0), I !== u.value && (b(), u.value = I);
      }
    ), yt(b);
    function p() {
      a.disabled || (i.value = !0, l("expand"), a.autoFocus && Ge(() => {
        var I;
        return (I = s.value) == null ? void 0 : I.focus();
      }));
    }
    function x() {
      u.value.length > 0 || (i.value = !1, l("collapse"));
    }
    function y() {
      b(), u.value = "", l("update:modelValue", ""), l("clear"), i.value = !1, Ge(() => {
        var I, A;
        return (A = (I = d.value) == null ? void 0 : I.$el) == null ? void 0 : A.focus();
      });
    }
    function k(I) {
      I.preventDefault(), I.stopPropagation(), y();
    }
    function $(I) {
      if (u.value = I.target.value, a.debounce <= 0 || u.value === "") {
        h(u.value);
        return;
      }
      if (u.value === a.modelValue) {
        b();
        return;
      }
      f === void 0 ? l("pending", !0) : clearTimeout(f), f = setTimeout(() => h(u.value), a.debounce);
    }
    function S() {
      f !== void 0 && h(u.value);
    }
    function T(I) {
      b(), u.value = I;
    }
    return n({ discardPending: T }), (I, A) => i.value ? (c(), W(At, {
      key: 1,
      "enter-active-class": "transition-all duration-200 ease-out",
      "enter-from-class": "opacity-0 w-0!",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition-all duration-150 ease-in",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0 w-0!"
    }, {
      default: ve(() => [
        v("div", {
          class: "flex h-8 items-center gap-2 p-2 rounded-(--border-border-radius-rounded-l) overflow-hidden group w-(--cs-w)",
          style: je({ "--cs-w": e.maxWidth })
        }, [
          v("i", {
            class: C(["ri-search-line text-(length:--icon-size-sm) leading-(--icon-size-sm) shrink-0 transition-colors text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", u.value ? "group-focus-within:text-(--icons-icon-accent)" : ""]),
            "aria-hidden": "true"
          }, null, 2),
          v("input", {
            ref_key: "inputRef",
            ref: s,
            type: "text",
            "data-testid": "collapsible-search-input",
            value: u.value,
            placeholder: e.placeholder,
            "aria-label": o.value.input ?? e.placeholder,
            title: u.value || void 0,
            disabled: e.disabled,
            class: "flex-1 min-w-0 bg-transparent border-0 outline-none focus:outline-none focus:ring-0 p-0 text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-black-default) dark:text-(--colors-text-white-default) placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary) text-ellipsis overflow-hidden",
            onInput: $,
            onBlur: x,
            onKeydown: [
              ht(k, ["escape"]),
              ht(S, ["enter"])
            ]
          }, null, 40, q4),
          v("button", {
            type: "button",
            class: "shrink-0 inline-flex items-center justify-center text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default) cursor-pointer rounded-(--border-border-radius-rounded-xs) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent",
            "aria-label": o.value.closeSearch,
            "data-testid": "collapsible-search-clear",
            onClick: y
          }, [...A[0] || (A[0] = [
            v("i", {
              class: "ri-close-circle-line text-(length:--icon-size-sm) leading-(--icon-size-sm)",
              "aria-hidden": "true"
            }, null, -1)
          ])], 8, U4)
        ], 4)
      ]),
      _: 1
    })) : (c(), W(Me, {
      key: 0,
      ref_key: "toggleRef",
      ref: d,
      variant: "tertiary",
      "icon-left": "ri-search-line",
      "icon-only": "",
      size: "xs",
      class: "[&_i]:text-(length:--icon-size-sm) [&_i]:leading-(--icon-size-sm)",
      "aria-label": e.placeholder,
      disabled: e.disabled,
      "data-testid": "collapsible-search-toggle",
      onClick: p
    }, null, 8, ["aria-label", "disabled"]));
  }
}), K4 = ["id", "value", "placeholder", "aria-labelledby", "aria-label", "aria-invalid", "aria-required", "aria-describedby", "disabled", "readonly"], Y4 = /* @__PURE__ */ ye({
  __name: "TagInput",
  props: {
    modelValue: {},
    placeholder: { default: void 0 },
    ariaLabel: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    hint: { default: void 0 },
    removeLabel: { default: void 0 },
    truncate: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    error: { default: void 0 },
    success: { type: Boolean, default: !1 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R(""), r = qe(), o = m(() => `${r}-error`), i = `${r}-hint`, s = m(() => t.label ? `${r}-label` : void 0), d = m(() => {
      const U = [];
      return t.hint && U.push(i), t.error && U.push(o.value), U.length > 0 ? U.join(" ") : void 0;
    }), u = R(!1), f = R(null), b = R(null), h = R(null), p = R(null), x = m(() => t.disabled || t.readonly), y = m(() => t.modelValue.length > 0 || l.value !== ""), k = m(() => t.fullWidth || t.width === void 0), $ = m(() => t.size === "lg" || t.size === "xl" ? "lg" : "sm"), S = m(() => t.disabled ? "disabled" : "white"), T = m(() => t.disabled ? void 0 : "border-(--border-border-base-medium)!");
    function I(U) {
      U.currentTarget.contains(U.relatedTarget) || (u.value = !1);
    }
    const A = m(() => !u.value && t.modelValue.length > 0), E = R(Number.POSITIVE_INFINITY), D = m(
      () => A.value ? Math.max(0, t.modelValue.length - E.value) : 0
    ), z = m(() => t.modelValue.slice(t.modelValue.length - D.value)), Y = (U) => {
      var xe, X;
      if (t.disabled) return;
      const K = U.currentTarget, ge = (xe = U.target) == null ? void 0 : xe.closest('button, a, [role="button"], input, [tabindex]');
      ge && ge !== K && K.contains(ge) || (U.preventDefault(), (X = h.value) == null || X.focus());
    }, le = (U) => A.value && U >= E.value;
    function ne() {
      var Ce, H;
      const U = (Ce = p.value) == null ? void 0 : Ce.$el;
      if (!U || !A.value) return;
      const K = getComputedStyle(U), ge = parseFloat(K.columnGap) || 0, xe = U.clientWidth - (parseFloat(K.paddingLeft) || 0) - (parseFloat(K.paddingRight) || 0), X = Array.from(U.querySelectorAll(":scope > [data-tag-chip]")).map(
        (Z) => Z.getBoundingClientRect().width
      );
      if (X.reduce((Z, ee, J) => Z + ee + (J > 0 ? ge : 0), 0) <= xe) {
        E.value = X.length;
        return;
      }
      let he = ((H = U.querySelector(":scope > [data-tag-overflow]")) == null ? void 0 : H.getBoundingClientRect().width) ?? 0, oe = 0;
      for (const Z of X) {
        if (he + ge + Z > xe) break;
        he += ge + Z, oe++;
      }
      E.value = oe;
    }
    let re = null, O = 0;
    const P = () => {
      cancelAnimationFrame(O), O = requestAnimationFrame(ne);
    };
    function V() {
      var K;
      const U = (K = p.value) == null ? void 0 : K.$el;
      !re || !U || (re.disconnect(), re.observe(U), U.querySelectorAll(":scope > [data-tag-chip], :scope > [data-tag-overflow]").forEach((ge) => re.observe(ge)));
    }
    ct(() => {
      typeof ResizeObserver < "u" && (re = new ResizeObserver(P)), V(), ne();
    }), uo(() => {
      V(), ne();
    }), yt(() => {
      re == null || re.disconnect(), re = null, cancelAnimationFrame(O);
    });
    function M(U) {
      l.value = "";
      const K = U.split(",").map((xe) => xe.trim()).filter((xe) => xe.length > 0), ge = [...t.modelValue];
      for (const xe of K)
        ge.includes(xe) || ge.push(xe);
      ge.length !== t.modelValue.length && a("update:modelValue", ge);
    }
    function B(U) {
      const K = U.target.value;
      if (K.endsWith(",")) {
        M(K.slice(0, -1));
        return;
      }
      l.value = K;
    }
    function q(U) {
      U.preventDefault(), !t.readonly && M(l.value);
    }
    function N() {
      t.readonly || l.value === "" && t.modelValue.length > 0 && a("update:modelValue", t.modelValue.slice(0, -1));
    }
    function G(U) {
      var K;
      a("update:modelValue", t.modelValue.filter((ge, xe) => xe !== U)), (K = h.value) == null || K.focus();
    }
    return (U, K) => (c(), g("div", {
      class: C(["flex min-w-0 flex-col gap-0.5", k.value ? "w-full" : ""]),
      style: je(k.value ? void 0 : { width: e.width })
    }, [
      e.label ? (c(), W(It, {
        key: 0,
        id: s.value,
        ref_key: "labelRef",
        ref: f,
        text: e.label,
        "input-id": L(r),
        required: e.required,
        tooltip: e.labelTooltip,
        focused: u.value,
        "test-id": "tag-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "tooltip", "focused"])) : w("", !0),
      te(Vn, {
        ref_key: "shellRef",
        ref: p,
        role: "group",
        "aria-labelledby": s.value,
        "aria-label": e.label ? void 0 : e.ariaLabel,
        "aria-describedby": d.value,
        class: C(["w-full", A.value ? "flex-nowrap! overflow-hidden" : ""]),
        tags: "",
        size: e.size,
        disabled: e.disabled,
        readonly: e.readonly,
        error: !!e.error,
        success: e.success,
        "has-value": y.value,
        "focus-scope": "any",
        onFocusin: K[2] || (K[2] = (ge) => u.value = !0),
        onFocusout: I,
        onMousedown: Y
      }, {
        default: ve(({ textClass: ge }) => [
          (c(!0), g(de, null, Re(e.modelValue, (xe, X) => (c(), g("span", {
            key: `${xe}-${X}`,
            "data-tag-chip": "",
            class: C(["inline-flex", { "shrink-0": A.value, "order-2 invisible": le(X) }])
          }, [
            te(gt, {
              label: xe,
              size: $.value,
              theme: S.value,
              truncate: e.truncate,
              class: C(T.value),
              "show-close-icon": "",
              "close-icon-inactive": x.value,
              "remove-label": `${e.removeLabel ?? ""} ${xe}`.trim(),
              onClose: (ie) => G(X)
            }, null, 8, ["label", "size", "theme", "truncate", "class", "close-icon-inactive", "remove-label", "onClose"])
          ], 2))), 128)),
          D.value > 0 ? (c(), g("span", {
            key: 0,
            "data-tag-overflow": "",
            class: "order-1 inline-flex shrink-0 cursor-pointer",
            onClick: K[0] || (K[0] = (xe) => {
              var X;
              return (X = h.value) == null ? void 0 : X.focus();
            })
          }, [
            te(gt, {
              label: `+${D.value}`,
              size: $.value,
              theme: S.value,
              class: C(T.value),
              "tooltip-text": z.value.join(", ")
            }, null, 8, ["label", "size", "theme", "class", "tooltip-text"])
          ])) : w("", !0),
          v("input", {
            id: L(r),
            ref_key: "inputRef",
            ref: h,
            value: l.value,
            type: "text",
            class: C([
              "flex-1 border-0 bg-transparent p-0 outline-none focus:border-0 focus:outline-none focus:ring-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)",
              ge,
              A.value ? "order-1 min-w-0" : "min-w-20",
              e.readonly ? "cursor-default" : ""
            ]),
            placeholder: e.modelValue.length > 0 ? void 0 : e.placeholder,
            "aria-labelledby": s.value,
            "aria-label": e.label ? void 0 : e.ariaLabel,
            "aria-invalid": e.error ? "true" : void 0,
            "aria-required": e.required ? "true" : void 0,
            "aria-describedby": d.value,
            disabled: e.disabled,
            readonly: e.readonly,
            onKeydown: [
              K[1] || (K[1] = (xe) => {
                var X, ie;
                (X = f.value) == null || X.handleFieldKeydown(xe), (ie = b.value) == null || ie.handleFieldKeydown(xe);
              }),
              ht(q, ["enter"]),
              ht(N, ["delete"])
            ],
            onInput: B
          }, null, 42, K4)
        ]),
        _: 1
      }, 8, ["aria-labelledby", "aria-label", "aria-describedby", "class", "size", "disabled", "readonly", "error", "success", "has-value"]),
      te($t, {
        ref_key: "helperRef",
        ref: b,
        focused: u.value,
        hint: e.hint,
        error: e.error,
        "hint-id": i,
        "error-id": o.value,
        "test-id-prefix": "tag-input"
      }, null, 8, ["focused", "hint", "error", "error-id"])
    ], 6));
  }
}), J4 = { class: "inline-flex max-w-full min-w-0 flex-col gap-1" }, X4 = ["aria-labelledby", "aria-label"], Z4 = {
  key: 0,
  "data-otp-separator": "",
  "aria-hidden": "true",
  class: "h-0 w-3 shrink-0 border-t-(length:--border-border-width-border-base) border-(--border-border-black-default) dark:border-(--border-border-white-default)"
}, Q4 = ["id", "value", "inputmode", "autocomplete", "aria-label", "aria-invalid", "aria-required", "aria-describedby", "disabled", "readonly", "onInput", "onPaste", "onKeydown"], Rq = /* @__PURE__ */ ye({
  __name: "OtpInput",
  props: {
    modelValue: {},
    length: { default: 6 },
    size: { default: "md" },
    type: { default: "default" },
    numeric: { type: Boolean, default: !0 },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    success: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    labels: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = { cell: "Digit {index} of {length}" }, r = m(() => ({ ...l, ...t.labels })), o = (N) => r.value.cell.replace("{index}", String(N + 1)).replace("{length}", String(t.length)), i = qe(), s = (N) => `${i}-cell-${N}`, d = m(() => t.label ? `${i}-label` : void 0), u = `${i}-hint`, f = `${i}-error`, b = m(() => {
      const N = [];
      return t.hint && N.push(u), t.error && N.push(f), N.length > 0 ? N.join(" ") : void 0;
    }), h = (N) => Array.from({ length: t.length }, (G, U) => N[U] ?? ""), p = R(h(t.modelValue));
    $e(
      () => [t.modelValue, t.length],
      ([N]) => {
        (N !== p.value.join("") || p.value.length !== t.length) && (p.value = h(N));
      }
    );
    const x = R([]), y = R(!1), k = R(null), $ = R(null), S = (N) => {
      const G = Array.from(N.replace(/\s/g, ""));
      return t.numeric ? G.filter((U) => /\d/.test(U)) : G;
    };
    function T() {
      a("update:modelValue", p.value.join(""));
    }
    function I(N) {
      const G = x.value[Math.max(0, Math.min(N, t.length - 1))];
      G == null || G.focus(), G == null || G.select();
    }
    function A(N, G) {
      const U = G.length >= t.length ? 0 : N, K = G.slice(0, t.length - U);
      K.forEach((ge, xe) => {
        p.value[U + xe] = ge;
      }), T(), I(U + K.length);
    }
    function E(N, G) {
      const U = G.target, K = G, ge = K.inputType === "insertText" && K.data ? K.data : U.value, xe = S(ge);
      if (xe.length > 1) {
        U.value = p.value[N], A(N, xe);
        return;
      }
      if (xe.length === 0) {
        U.value === "" ? (p.value[N] = "", T()) : U.value = p.value[N];
        return;
      }
      p.value[N] = xe[0], U.value = xe[0], T(), N < t.length - 1 && I(N + 1);
    }
    function D(N, G) {
      var K;
      if (G.preventDefault(), t.readonly || t.disabled) return;
      const U = S(((K = G.clipboardData) == null ? void 0 : K.getData("text")) ?? "");
      U.length > 0 && A(N, U);
    }
    function z(N, G) {
      var U, K;
      switch ((U = k.value) == null || U.handleFieldKeydown(G), (K = $.value) == null || K.handleFieldKeydown(G), G.key) {
        case "ArrowLeft":
          G.preventDefault(), I(N - 1);
          return;
        case "ArrowRight":
          G.preventDefault(), I(N + 1);
          return;
        case "Home":
          G.preventDefault(), I(0);
          return;
        case "End":
          G.preventDefault(), I(t.length - 1);
          return;
        case "Backspace":
          if (G.preventDefault(), t.readonly) return;
          p.value[N] ? (p.value[N] = "", T()) : N > 0 && (p.value[N - 1] = "", T(), I(N - 1));
          return;
        case "Delete":
          if (G.preventDefault(), t.readonly || !p.value[N]) return;
          p.value[N] = "", T();
          return;
      }
    }
    function Y(N) {
      var G, U;
      y.value = !0, (U = (G = N.target).select) == null || U.call(G);
    }
    function le(N) {
      N.currentTarget.contains(N.relatedTarget) || (y.value = !1);
    }
    const ne = 3, re = m(() => t.type === "separator" || t.type === "separator-spaced"), O = m(() => t.type === "spaced" || t.type === "separator-spaced"), P = m(() => {
      const N = re.value ? ne : t.length, G = [];
      for (let U = 0; U < t.length; U += N)
        G.push(Array.from({ length: Math.min(N, t.length - U) }, (K, ge) => U + ge));
      return G;
    }), V = {
      sm: "size-9 text-(length:--size-l) leading-(--line-height-xxl)",
      md: "size-10 text-(length:--size-l) leading-(--line-height-xxl)",
      lg: "size-12 text-(length:--size-4xl) leading-(--line-height-4xl)",
      xl: "size-13 text-(length:--size-4xl) leading-(--line-height-4xl)"
    }, M = "focus:shadow-[0_0_2px_2px_var(--background-background-hover)]", B = m(() => {
      if (t.disabled)
        return "bg-(--background-background-disabled-subtle) dark:bg-(--colors-background-disabled) border-(--border-border-disabled) dark:border-(--colors-border-disabled-subtle) text-(--text-text-disabled-light) dark:text-(--colors-text-disabled) cursor-not-allowed";
      if (t.readonly)
        return `bg-(--background-background-white-secondary-soft) dark:bg-(--colors-background-disabled) border-(--border-border-base-medium) dark:border-(--border-border-base) focus:border-(--border-border-accent) ${M} text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-default`;
      const N = "bg-(--background-background-white) dark:bg-(--background-background-black-default) text-(--text-text-black-default) dark:text-(--text-text-white-default)";
      return t.error ? `${N} border-(--border-border-error-strong) dark:border-(--border-border-error) ${M}` : t.success ? `${N} border-(--border-border-success-strong) ${M}` : `${N} border-(--border-border-base-medium) dark:border-(--border-border-base) focus:border-(--border-border-accent) ${M}`;
    });
    function q(N, G) {
      const U = O.value ? "rounded-(--border-border-radius-rounded-l)" : [
        G === 0 ? "rounded-l-(--border-border-radius-rounded-l)" : "-ml-px",
        G === N.length - 1 ? "rounded-r-(--border-border-radius-rounded-l)" : ""
      ].join(" ");
      return [
        "relative box-border border border-solid p-0 text-center font-inter font-(--weight-bold) outline-none focus:z-10 focus:outline-none focus:ring-0",
        V[t.size],
        U,
        B.value
      ];
    }
    return (N, G) => (c(), g("div", J4, [
      e.label ? (c(), W(It, {
        key: 0,
        id: d.value,
        ref_key: "labelRef",
        ref: k,
        text: e.label,
        "input-id": s(0),
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: y.value,
        "test-id": "otp-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused"])) : w("", !0),
      v("div", {
        role: "group",
        "data-otp-cells": "",
        "aria-labelledby": d.value,
        "aria-label": e.label ? void 0 : e.ariaLabel,
        class: C(["flex items-center", re.value || O.value ? "gap-2" : ""]),
        onFocusin: Y,
        onFocusout: le
      }, [
        (c(!0), g(de, null, Re(P.value, (U, K) => (c(), g(de, { key: K }, [
          K > 0 && re.value ? (c(), g("span", Z4)) : w("", !0),
          v("div", {
            class: C(["flex items-center", O.value ? "gap-2" : ""])
          }, [
            (c(!0), g(de, null, Re(U, (ge, xe) => (c(), g("input", {
              id: s(ge),
              key: ge,
              ref_for: !0,
              ref: (X) => {
                X && (x.value[ge] = X);
              },
              value: p.value[ge],
              type: "text",
              inputmode: e.numeric ? "numeric" : "text",
              autocomplete: ge === 0 ? "one-time-code" : "off",
              "aria-label": o(ge),
              "aria-invalid": e.error ? "true" : void 0,
              "aria-required": e.required ? "true" : void 0,
              "aria-describedby": b.value,
              disabled: e.disabled,
              readonly: e.readonly,
              class: C(q(U, xe)),
              onInput: (X) => E(ge, X),
              onPaste: (X) => D(ge, X),
              onKeydown: (X) => z(ge, X)
            }, null, 42, Q4))), 128))
          ], 2)
        ], 64))), 128))
      ], 42, X4),
      te($t, {
        ref_key: "helperRef",
        ref: $,
        focused: y.value,
        hint: e.hint,
        error: e.error,
        "hint-id": u,
        "error-id": f,
        "test-id-prefix": "otp-input"
      }, null, 8, ["focused", "hint", "error"])
    ]));
  }
}), _4 = ["data-status", "aria-label", "disabled"], Bq = /* @__PURE__ */ ye({
  __name: "LookupInput",
  props: {
    placeholder: {},
    modelValue: {},
    iconLeft: {},
    size: {},
    disabled: { type: Boolean },
    success: { type: Boolean },
    type: {},
    name: {},
    id: {},
    fullWidth: { type: Boolean },
    width: {},
    label: {},
    labelTooltip: {},
    required: { type: Boolean },
    requiredIndicator: {},
    labelInline: { type: Boolean },
    ariaLabel: {},
    inputmode: {},
    autocomplete: {},
    pattern: {},
    maxlength: {},
    minlength: {},
    min: {},
    max: {},
    error: {},
    hint: {},
    ariaDescribedby: {},
    readonly: { type: Boolean },
    readonlyChrome: { type: Boolean, default: !0 },
    valueVariant: {},
    showEditIcon: { type: Boolean, default: !0 },
    variant: {},
    buttons: {},
    buttonLayout: {},
    buttonSize: {},
    innerButton: {},
    prefix: {},
    removeButton: {},
    status: { default: null },
    statusTitle: { default: void 0 },
    statusText: { default: void 0 },
    open: { type: Boolean, default: void 0 },
    labels: { default: () => ({}) }
  },
  emits: ["update:open", "update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = {
      recognized: { icon: "ri-check-fill", color: "text-(--icons-icon-success)" },
      unrecognized: { icon: "ri-alert-line", color: "text-(--icons-icon-warning)" }
    }, r = m(() => t.statusTitle ? t.statusTitle : t.status === "unrecognized" ? t.labels.unrecognized ?? "Not recognized" : t.labels.recognized ?? "Recognized"), o = /* @__PURE__ */ new Set(["status", "statusTitle", "statusText", "open", "labels"]), i = m(
      () => Object.fromEntries(Object.entries(t).filter(([d]) => !o.has(d)))
    ), s = m(() => t.labels.clear ? { clear: t.labels.clear } : void 0);
    return (d, u) => (c(), W(Wt, Fe(i.value, {
      labels: s.value,
      "onUpdate:modelValue": u[1] || (u[1] = (f) => a("update:modelValue", f))
    }), sa({ _: 2 }, [
      e.status ? {
        name: "iconRight",
        fn: ve(({ iconBoxClass: f }) => [
          te(qv, {
            header: r.value,
            position: "top",
            delay: 0,
            open: e.open,
            disabled: !e.statusText || e.disabled,
            "onUpdate:open": u[0] || (u[0] = (b) => a("update:open", b))
          }, {
            trigger: ve(({ triggerProps: b }) => [
              v("button", Fe({ type: "button" }, b, {
                "data-testid": "lookup-input-status",
                "data-status": e.status,
                "aria-label": r.value,
                disabled: e.disabled,
                class: [
                  f,
                  l[e.status].color,
                  "rounded-(--border-border-radius-rounded-xs) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent"
                ]
              }), [
                v("i", {
                  class: C(l[e.status].icon),
                  "aria-hidden": "true"
                }, null, 2)
              ], 16, _4)
            ]),
            default: ve(() => [
              nt(" " + j(e.statusText), 1)
            ]),
            _: 2
          }, 1032, ["header", "open", "disabled"])
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["labels"]));
  }
}), eO = ["disabled", "aria-current"], tO = "inline-flex h-9 min-w-9 shrink-0 items-center justify-center whitespace-nowrap rounded-full border border-solid px-[calc(--spacing(2.5)-1px)] text-(length:--size-m) leading-(--line-height-m) font-(--weight-semi-bold) focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)", nO = "cursor-pointer border-(--border-border-white-default) bg-(--background-background-white) text-(--text-text-black-default) hover:border-(--border-border-hover) hover:bg-(--background-background-hover) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:text-(--colors-text-white-default) dark:hover:border-(--border-border-hover) dark:hover:bg-(--background-background-hover) dark:hover:text-(--text-text-black-default)", aO = "cursor-default border-(--border-border-black-default) bg-(--background-background-black-default) text-(--icons-icon-white-default) dark:border-(--background-background-white) dark:bg-(--background-background-white) dark:text-(--text-text-black-default)", lO = "cursor-not-allowed border-(--border-border-disabled) bg-(--components-button-button-disabled) text-(--icons-icon-disabled-strong)", rO = /* @__PURE__ */ ye({
  __name: "PageNumber",
  props: {
    page: {},
    active: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["select"],
  setup(e, { emit: n }) {
    const t = n;
    return (a, l) => (c(), g("button", {
      type: "button",
      disabled: e.disabled,
      "aria-current": e.active ? "page" : void 0,
      class: C([tO, e.disabled ? lO : e.active ? aO : nO]),
      onClick: l[0] || (l[0] = (r) => t("select", e.page))
    }, j(e.page), 11, eO));
  }
});
function Kv(e, n, t, a) {
  $e(
    n,
    () => {
      const l = document.activeElement;
      if (!e.value || !(l instanceof HTMLButtonElement) || !l.disabled) return;
      const r = e.value.querySelector(`[data-testid="${t}"]`), o = e.value.querySelector(`[data-testid="${a}"]`), i = l === o ? r : l === r ? o : null;
      i && !i.disabled && i.focus();
    },
    { flush: "post" }
  );
}
const oO = ["aria-label"], iO = {
  key: 0,
  class: "@4xl/pager:col-start-1 flex min-w-0 flex-wrap items-center gap-3"
}, sO = {
  key: 0,
  class: "flex items-center gap-3"
}, dO = ["id", "for"], uO = ["id", "aria-labelledby", "disabled", "aria-expanded", "aria-controls"], cO = { class: "min-w-0 flex-1 truncate" }, fO = ["id", "aria-labelledby"], hO = ["aria-selected", "tabindex", "onClick", "onKeydown", "onKeyup"], bO = {
  key: 1,
  "data-testid": "pager-items-count",
  class: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium) text-(--text-text-black-default) dark:text-(--text-text-white-default)"
}, gO = { class: "flex min-w-0 flex-wrap items-center justify-center gap-1.5" }, mO = {
  key: 0,
  "data-testid": "pager-ellipsis",
  class: "flex size-9 shrink-0 select-none items-center justify-center text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold) text-(--text-text-black-default) dark:text-(--text-text-white-default)",
  "aria-hidden": "true"
}, pO = {
  key: 2,
  class: "@4xl/pager:col-start-3 ml-auto flex min-w-0 flex-wrap items-center justify-end gap-3"
}, vO = { class: "flex min-w-0 items-center gap-2" }, xO = ["for"], yO = ["id", "max", "disabled", "aria-invalid", "aria-describedby"], kO = ["id"], wO = 1500, CO = /* @__PURE__ */ ye({
  __name: "Pager",
  props: {
    currentPage: { default: 1 },
    totalPages: { default: 1 },
    totalItems: { default: 0 },
    itemsPerPage: { default: 10 },
    previousLabel: { default: "Previous" },
    nextLabel: { default: "Next" },
    disabled: { type: Boolean, default: !1 },
    rowsPerPageOptions: { default: () => [10, 30, 50] },
    rowsPerPageLabel: { default: "Rows per page" },
    showRowsPerPage: { type: Boolean, default: !0 },
    showItemsCount: { type: Boolean, default: !1 },
    itemsCountSeparator: { default: "of" },
    itemsCountFormat: { type: Function, default: void 0 },
    maxVisiblePages: { default: 5 },
    alwaysShowPages: { type: Boolean, default: !1 },
    pageAlign: { default: "center" },
    showGoToPage: { type: Boolean, default: !1 },
    goToPageLabel: { default: "Go to page" },
    goLabel: { default: "Go" },
    goToPageErrorLabel: { default: void 0 },
    navLabel: { default: void 0 }
  },
  emits: ["page-change", "items-per-page-change"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => {
      const H = t.totalPages, Z = t.currentPage, ee = Math.max(5, t.maxVisiblePages);
      if (H <= ee)
        return Array.from({ length: H }, (_, ue) => ue + 1);
      const J = Math.floor((ee - 5) / 2);
      if (Z <= J + 2)
        return [...Array.from({ length: ee - 2 }, (ue, se) => se + 1), "ellipsis-end", H];
      if (Z >= H - J - 1) {
        const _ = H - ee + 3;
        return [1, "ellipsis-start", ...Array.from({ length: ee - 2 }, (se, Q) => _ + Q)];
      }
      return [1, "ellipsis-start", ...Array.from({ length: J * 2 + 1 }, (_, ue) => Z - J + ue), "ellipsis-end", H];
    }), r = m(() => t.currentPage > 1 && !t.disabled), o = m(() => t.currentPage < t.totalPages && !t.disabled), i = m(() => {
      if (t.totalItems === 0) return `0 ${t.itemsCountSeparator} 0`;
      const H = (t.currentPage - 1) * t.itemsPerPage + 1, Z = Math.min(t.currentPage * t.itemsPerPage, t.totalItems);
      return t.itemsCountFormat ? t.itemsCountFormat(H, Z, t.totalItems) : `${H}-${Z} ${t.itemsCountSeparator} ${t.totalItems}`;
    }), s = m(
      () => t.rowsPerPageOptions.map((H) => ({
        value: String(H),
        label: String(H)
      }))
    ), d = (H) => {
      t.disabled || H < 1 || H > t.totalPages || H !== t.currentPage && a("page-change", H);
    }, u = () => {
      r.value && d(t.currentPage - 1);
    }, f = () => {
      o.value && d(t.currentPage + 1);
    }, b = (H) => {
      a("items-per-page-change", Number(H));
    }, h = qe(), p = qe(), x = Hn(), y = (H) => {
      const Z = x[H];
      return Z && Z({}).length;
    }, k = qe(), $ = R(""), S = R(!1), T = R(0);
    let I = null;
    function A() {
      I && clearTimeout(I), I = null;
    }
    const E = m(() => t.disabled || t.totalPages === 0), D = () => {
      A(), S.value = !1;
    };
    $e(
      [
        () => t.currentPage,
        () => t.totalPages,
        () => t.itemsPerPage,
        E,
        () => t.goToPageErrorLabel
      ],
      () => {
        I && ($.value = ""), A(), S.value = !1;
      }
    );
    const z = () => {
      A();
      const H = parseInt($.value, 10);
      if (isNaN(H) || H < 1 || H > t.totalPages) {
        S.value = !0, T.value += 1, t.goToPageErrorLabel || (I = setTimeout(() => {
          $.value = "", S.value = !1, I = null;
        }, wO));
        return;
      }
      S.value = !1, d(H), $.value = "";
    };
    yt(() => {
      document.removeEventListener("click", X), N(), A();
    });
    const Y = R(!1), le = R(null), ne = R(null), re = R(null);
    let O = !1;
    const P = R([]), V = R(0);
    function M(H) {
      var ee;
      const Z = s.value.length;
      V.value = (H + Z) % Z, (ee = P.value[V.value]) == null || ee.focus();
    }
    async function B() {
      const H = s.value.findIndex((Z) => Z.value === String(t.itemsPerPage));
      V.value = Math.max(H, 0), Y.value = !0, await Ge(), M(V.value);
    }
    function q() {
      var H;
      Y.value = !1, (H = ne.value) == null || H.focus();
    }
    function N() {
      O = !1, document.removeEventListener("mouseup", N, !0);
    }
    function G() {
      O = !0, document.addEventListener("mouseup", N, !0);
    }
    function U() {
      N(), !t.disabled && (Y.value ? q() : B());
    }
    function K(H) {
      q(), b(H);
    }
    function ge(H, Z) {
      const ee = {
        ArrowDown: Z + 1,
        ArrowUp: Z - 1,
        Home: 0,
        End: s.value.length - 1
      };
      H.key in ee && (H.preventDefault(), M(ee[H.key]));
    }
    function xe(H) {
      var ee;
      if (!Y.value || O) return;
      const Z = H.relatedTarget;
      Z && ((ee = re.value) != null && ee.contains(Z)) || (Y.value = !1);
    }
    function X(H) {
      Y.value && le.value && !le.value.contains(H.target) && (Y.value = !1);
    }
    function ie(H) {
      H.key !== "Escape" || !Y.value || (H.stopPropagation(), H.preventDefault(), q());
    }
    $e(Y, (H) => {
      H ? document.addEventListener("click", X) : document.removeEventListener("click", X);
    });
    const he = m(() => t.alwaysShowPages || t.totalPages > 1), oe = () => !!y("info") || t.showRowsPerPage || t.showItemsCount, Ce = R(null);
    return Kv(Ce, () => t.currentPage, "pager-previous", "pager-next"), (H, Z) => (c(), g("div", {
      ref_key: "rootRef",
      ref: Ce,
      class: "@container/pager"
    }, [
      oe() || he.value || e.showGoToPage ? (c(), g("nav", {
        key: 0,
        class: "flex flex-wrap items-center justify-between gap-x-6 gap-y-3 text-(length:--size-m) leading-(--line-height-l) @4xl/pager:grid @4xl/pager:grid-cols-[1fr_auto_1fr] @4xl/pager:gap-x-0 @4xl/pager:gap-y-0",
        "aria-label": e.navLabel,
        "data-testid": "pager-nav"
      }, [
        oe() ? (c(), g("div", iO, [
          y("info") ? Ae(H.$slots, "info", { key: 0 }) : w("", !0),
          e.showRowsPerPage || e.showItemsCount ? (c(), g(de, { key: 1 }, [
            e.showRowsPerPage ? (c(), g("div", sO, [
              v("label", {
                id: `${L(h)}-label`,
                for: L(h),
                class: "whitespace-nowrap text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body) dark:text-(--text-text-white-secondary)"
              }, j(e.rowsPerPageLabel), 9, dO),
              v("div", {
                ref_key: "rowsMenuRef",
                ref: le,
                class: "relative",
                onKeydown: ie,
                onFocusout: xe
              }, [
                te(Vn, {
                  size: "sm",
                  flush: "",
                  "has-value": "",
                  disabled: e.disabled,
                  "focus-scope": "any",
                  class: "min-w-16 shrink-0"
                }, {
                  default: ve(({ iconBoxClass: ee, iconColorClass: J, textClass: F }) => [
                    v("button", {
                      id: L(h),
                      ref_key: "rowsTriggerRef",
                      ref: ne,
                      type: "button",
                      "aria-labelledby": `${L(h)}-label ${L(h)}`,
                      disabled: e.disabled,
                      "aria-haspopup": "listbox",
                      "aria-expanded": Y.value,
                      "aria-controls": `${L(h)}-listbox`,
                      class: C([
                        "flex h-full w-full min-w-0 items-center gap-2 px-[calc(--spacing(2)-1px)] text-left focus-visible:outline-hidden focus-visible:-outline-offset-2 disabled:cursor-not-allowed",
                        F
                      ]),
                      "data-testid": "pager-rows-trigger",
                      onMousedown: G,
                      onClick: U
                    }, [
                      v("span", cO, j(e.itemsPerPage), 1),
                      v("i", {
                        class: C(["ri-arrow-down-s-line", ee, J]),
                        "aria-hidden": "true"
                      }, null, 2)
                    ], 42, uO)
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                Y.value ? (c(), g("ul", {
                  key: 0,
                  id: `${L(h)}-listbox`,
                  ref_key: "rowsListboxRef",
                  ref: re,
                  role: "listbox",
                  "aria-labelledby": `${L(h)}-label`,
                  class: C([L(si), "absolute bottom-full left-0 z-30 mb-px min-w-full"]),
                  "data-testid": "pager-rows-menu"
                }, [
                  (c(!0), g(de, null, Re(s.value, (ee, J) => (c(), g("li", {
                    key: ee.value,
                    ref_for: !0,
                    ref_key: "rowsOptionRefs",
                    ref: P,
                    role: "option",
                    "aria-selected": String(e.itemsPerPage) === ee.value,
                    tabindex: J === V.value ? 0 : -1,
                    class: C([L(rk), String(e.itemsPerPage) === ee.value ? L(ok) : ""]),
                    onClick: (F) => K(ee.value),
                    onKeydown: [
                      ht(Je((F) => K(ee.value), ["prevent"]), ["enter"]),
                      Z[0] || (Z[0] = ht(Je(() => {
                      }, ["prevent"]), ["space"])),
                      (F) => ge(F, J)
                    ],
                    onKeyup: ht(Je((F) => K(ee.value), ["prevent"]), ["space"])
                  }, j(ee.label), 43, hO))), 128))
                ], 10, fO)) : w("", !0)
              ], 544)
            ])) : w("", !0),
            e.showItemsCount ? (c(), g("div", bO, j(i.value), 1)) : w("", !0)
          ], 64)) : w("", !0)
        ])) : w("", !0),
        he.value ? (c(), g("div", {
          key: 1,
          class: C([
            "flex min-w-0 max-w-full items-center gap-x-4",
            e.pageAlign === "end" ? [
              "justify-end",
              // CONSTRAINT: never alone in a `1fr` side track: long page numbers would wrap there.
              e.showGoToPage ? "@4xl/pager:col-start-2" : oe() ? "@4xl/pager:col-start-2 @4xl/pager:col-span-2" : "@4xl/pager:col-span-full @4xl/pager:justify-end"
            ] : "@4xl/pager:col-start-2 justify-center",
            // Alone at the start of the wrapping row, justify-between would push the centred pages to the left.
            e.pageAlign === "center" && !oe() ? "mx-auto @4xl/pager:mx-0" : "",
            e.pageAlign === "end" && !oe() ? "ml-auto @4xl/pager:ml-0" : ""
          ])
        }, [
          te(L(Me), {
            variant: "secondary",
            size: "sm",
            "icon-only": "",
            "icon-left": "ri-arrow-left-s-line",
            disabled: !r.value,
            "aria-label": e.previousLabel,
            "data-testid": "pager-previous",
            class: "shrink-0",
            onClick: u
          }, null, 8, ["disabled", "aria-label"]),
          v("div", gO, [
            (c(!0), g(de, null, Re(l.value, (ee) => (c(), g(de, { key: ee }, [
              String(ee).startsWith("ellipsis") ? (c(), g("span", mO, " ... ")) : (c(), W(rO, {
                key: 1,
                page: ee,
                active: ee === e.currentPage,
                disabled: e.disabled,
                "data-testid": "pager-page",
                onSelect: d
              }, null, 8, ["page", "active", "disabled"]))
            ], 64))), 128))
          ]),
          te(L(Me), {
            variant: "secondary",
            size: "sm",
            "icon-only": "",
            "icon-right": "ri-arrow-right-s-line",
            disabled: !o.value,
            "aria-label": e.nextLabel,
            "data-testid": "pager-next",
            class: "shrink-0",
            onClick: f
          }, null, 8, ["disabled", "aria-label"])
        ], 2)) : w("", !0),
        e.showGoToPage ? (c(), g("div", pO, [
          v("div", vO, [
            v("label", {
              for: L(p),
              class: "whitespace-nowrap text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body) dark:text-(--text-text-white-secondary)"
            }, j(e.goToPageLabel), 9, xO),
            te(Vn, {
              size: "sm",
              disabled: E.value,
              error: S.value,
              "has-value": $.value !== "",
              class: "w-16 shrink-0"
            }, {
              default: ve(({ textClass: ee }) => [
                tr(v("input", {
                  id: L(p),
                  "onUpdate:modelValue": Z[1] || (Z[1] = (J) => $.value = J),
                  type: "number",
                  min: "1",
                  max: e.totalPages,
                  disabled: E.value,
                  "aria-invalid": S.value || void 0,
                  "aria-describedby": S.value && e.goToPageErrorLabel ? L(k) : void 0,
                  "data-testid": "pager-go-to-page",
                  class: C([
                    "min-w-0 flex-1 border-0 bg-transparent p-0 outline-none focus:ring-0 disabled:cursor-not-allowed [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none",
                    ee
                  ]),
                  onInput: D,
                  onKeydown: ht(z, ["enter"])
                }, null, 42, yO), [
                  [Yb, $.value]
                ])
              ]),
              _: 1
            }, 8, ["disabled", "error", "has-value"])
          ]),
          te(L(Me), {
            variant: "primary",
            size: "xs",
            label: e.goLabel,
            disabled: E.value,
            "data-testid": "pager-go-button",
            onClick: z
          }, null, 8, ["label", "disabled"])
        ])) : w("", !0),
        e.showGoToPage && e.goToPageErrorLabel && S.value ? (c(), g("p", {
          id: L(k),
          key: T.value,
          role: "alert",
          "data-testid": "pager-go-to-page-error",
          class: "basis-full text-right text-balance text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-error-strong) dark:text-(--border-border-error-subtle) @4xl/pager:col-start-3 @4xl/pager:row-start-2 @4xl/pager:pt-1"
        }, j(e.goToPageErrorLabel), 9, kO)) : w("", !0)
      ], 8, oO)) : w("", !0)
    ], 512));
  }
}), Yv = "enabled:z-10 hover:enabled:z-20 focus-visible:z-20", Jv = `${Yv} rounded-r-none -mr-px`, Xv = `${Yv} rounded-l-none`, SO = ["aria-label"], $O = {
  key: 0,
  "data-testid": "compact-pager-helper",
  class: "text-center text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium) text-(--text-text-black-default) dark:text-(--text-text-white-default)"
}, IO = { class: "inline-flex shadow-(--blur-shadow-xs)" }, LO = ["id"], TO = { class: "inline-flex" }, AO = { "aria-hidden": "true" }, EO = { class: "sr-only" }, Vo = "whitespace-nowrap text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default)", gd = "border border-solid border-(--border-border-secondary-button) bg-(--components-button-secondary-button-secondary)", Mq = /* @__PURE__ */ ye({
  __name: "CompactPager",
  props: {
    type: { default: "arrows" },
    currentPage: { default: 1 },
    totalPages: { default: 1 },
    disabled: { type: Boolean, default: !1 },
    previousLabel: { default: "Previous" },
    nextLabel: { default: "Next" },
    pageStatusFormat: { type: Function, default: void 0 },
    navLabel: { default: void 0 },
    helperText: { default: void 0 },
    totalPagesFormat: { type: Function, default: void 0 },
    pageSelectLabel: { default: "Page" }
  },
  emits: ["page-change"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => !t.disabled && t.currentPage > 1), r = m(() => !t.disabled && t.currentPage < t.totalPages), o = m(
      () => t.pageStatusFormat ? t.pageStatusFormat(t.currentPage, t.totalPages) : `${t.currentPage} of ${t.totalPages}`
    ), i = m(
      () => t.totalPagesFormat ? t.totalPagesFormat(t.totalPages) : `of ${t.totalPages} pages`
    ), s = qe(), d = (S) => String(S).padStart(2, "0"), u = m(
      () => Array.from({ length: Math.max(t.totalPages, 0) }, (S, T) => {
        const I = T + 1;
        return {
          label: d(I),
          active: I === t.currentPage,
          testId: `compact-pager-page-${I}`,
          onClick: () => {
            t.disabled || I > t.totalPages || I === t.currentPage || a("page-change", I);
          }
        };
      })
    );
    function f() {
      l.value && a("page-change", t.currentPage - 1);
    }
    function b() {
      r.value && a("page-change", t.currentPage + 1);
    }
    const h = {
      "arrow-buttons": { variant: "secondary", size: "xs", content: "icon", fused: !0 },
      arrows: { variant: "secondary", size: "xs", content: "icon", fused: !0 },
      "arrows-text": { variant: "text", size: "xs", content: "icon", fused: !1 },
      "arrows-number": { variant: "secondary", size: "sm", content: "icon", fused: !1 },
      "two-buttons": { variant: "secondary", size: "xs", content: "icon-label", fused: !1 },
      "buttons-helper": { variant: "secondary", size: "xs", content: "label", fused: !0 },
      "dropdown-buttons": { variant: "secondary", size: "xs", content: "icon", fused: !0 }
    };
    function p(S) {
      const T = h[t.type], I = S === "previous", A = I ? t.previousLabel : t.nextLabel, E = T.content === "label" ? void 0 : `ri-arrow-${I ? "left" : "right"}-s-line`;
      return {
        variant: T.variant,
        size: T.size,
        iconOnly: T.content === "icon",
        iconLeft: I ? E : void 0,
        iconRight: I ? void 0 : E,
        label: T.content === "icon" ? void 0 : A,
        ariaLabel: T.content === "icon" ? A : void 0,
        disabled: I ? !l.value : !r.value,
        "data-testid": `compact-pager-${S}`,
        class: T.fused ? I ? Jv : Xv : void 0,
        onClick: I ? f : b
      };
    }
    const x = m(() => p("previous")), y = m(() => p("next")), k = R(null);
    Kv(k, () => t.currentPage, "compact-pager-previous", "compact-pager-next");
    const $ = {
      "arrow-buttons": "shadow-(--blur-shadow-xs)",
      arrows: "shadow-(--blur-shadow-xs)",
      "arrows-text": "",
      "arrows-number": "gap-1 shadow-(--blur-shadow-xs)",
      "two-buttons": "gap-3 shadow-(--blur-shadow-xs)",
      "buttons-helper": "flex-col gap-4",
      "dropdown-buttons": "gap-3 shadow-(--blur-shadow-xs)"
    };
    return (S, T) => (c(), g("nav", {
      ref_key: "rootRef",
      ref: k,
      "aria-label": e.navLabel,
      "data-testid": "compact-pager",
      class: C(["inline-flex items-center", $[e.type]])
    }, [
      e.type === "two-buttons" || e.type === "arrow-buttons" ? (c(), g(de, { key: 0 }, [
        te(L(Me), an(sn(x.value)), null, 16),
        te(L(Me), an(sn(y.value)), null, 16)
      ], 64)) : e.type === "arrows" ? (c(), g(de, { key: 1 }, [
        te(L(Me), an(sn(x.value)), null, 16),
        v("span", {
          "data-testid": "compact-pager-status",
          class: C([
            "relative z-5 -mr-px self-stretch inline-flex items-center px-[calc(--spacing(3)-1px)] py-[calc(--spacing(1.5)-1px)]",
            gd,
            Vo
          ])
        }, j(o.value), 3),
        te(L(Me), an(sn(y.value)), null, 16)
      ], 64)) : e.type === "arrows-text" ? (c(), g(de, { key: 2 }, [
        te(L(Me), an(sn(x.value)), null, 16),
        v("span", {
          "data-testid": "compact-pager-status",
          class: C(["px-3 py-1.5", Vo, "dark:text-(--text-text-white-default)"])
        }, j(o.value), 3),
        te(L(Me), an(sn(y.value)), null, 16)
      ], 64)) : e.type === "buttons-helper" ? (c(), g(de, { key: 3 }, [
        e.helperText ? (c(), g("span", $O, j(e.helperText), 1)) : w("", !0),
        v("div", IO, [
          te(L(Me), an(sn(x.value)), null, 16),
          te(L(Me), an(sn(y.value)), null, 16)
        ])
      ], 64)) : e.type === "dropdown-buttons" ? (c(), g(de, { key: 4 }, [
        te(cn, { items: u.value }, {
          trigger: ve(({ triggerProps: I }) => [
            te(L(Me), Fe({
              variant: "secondary",
              size: "xs",
              label: d(e.currentPage),
              "dropdown-icon": "",
              "aria-label": `${e.pageSelectLabel} ${d(e.currentPage)}`,
              "aria-describedby": L(s),
              disabled: e.disabled,
              "data-testid": "compact-pager-page-select"
            }, I), null, 16, ["label", "aria-label", "aria-describedby", "disabled"])
          ]),
          _: 1
        }, 8, ["items"]),
        v("span", {
          id: L(s),
          "data-testid": "compact-pager-status",
          class: C([
            "inline-flex items-center rounded-(--border-border-radius-rounded-base) px-[calc(--spacing(3)-1px)] py-[calc(--spacing(1.5)-1px)]",
            gd,
            Vo
          ])
        }, j(i.value), 11, LO),
        v("div", TO, [
          te(L(Me), an(sn(x.value)), null, 16),
          te(L(Me), an(sn(y.value)), null, 16)
        ])
      ], 64)) : e.type === "arrows-number" ? (c(), g(de, { key: 5 }, [
        te(L(Me), an(sn(x.value)), null, 16),
        v("span", {
          "data-testid": "compact-pager-status",
          class: C(["inline-flex size-9 shrink-0 items-center justify-center rounded-full", gd, Vo])
        }, [
          v("span", AO, j(e.currentPage), 1),
          v("span", EO, j(o.value), 1)
        ], 2),
        te(L(Me), an(sn(y.value)), null, 16)
      ], 64)) : w("", !0)
    ], 10, SO));
  }
});
function Dq(e, n) {
  return {
    result: e.data.map(n),
    currentPage: e.pagination.page,
    pageSize: e.pagination.perPage,
    totalItems: e.pagination.totalItems,
    totalPages: e.pagination.totalPages
  };
}
const or = Symbol("tableQuery"), ws = Symbol("tableViews"), RO = Symbol(
  "tableColumnSettings"
), Zv = Symbol("tablePermissions"), Qv = Symbol("tableLabels"), _v = Symbol("tableViewPanel");
function ex(e, n) {
  return `${e}-tab-${n}`;
}
const tx = {
  tableLabel: "Table",
  filterButton: "Filter",
  eraseAll: "Erase all",
  hideFilters: (e) => `Hide filters (${e})`,
  showFilters: (e) => `Show filters (${e})`,
  saveView: "Save",
  shareView: "Share",
  closeSearch: "Close search",
  removeFilter: (e) => `Remove ${e} filter`,
  renameView: "Rename view",
  setAsDefault: "Set as default",
  deleteView: "Delete view",
  manageViews: "Manage views",
  viewSettingsLabel: "View settings",
  viewModeTable: "Table",
  viewModeBoard: "Board",
  viewModeCalendar: "Calendar",
  viewModeGantt: "Gantt",
  viewTabsLabel: "Pre-filtered lists",
  viewTabsOverflowLabel: "lists"
};
function ir() {
  return Kt(
    Qv,
    m(() => tx)
  );
}
const BO = ["aria-label"], MO = ["id", "aria-controls", "aria-selected", "tabindex", "data-testid", "data-active", "onClick"], DO = {
  "data-tab-label": "",
  class: "truncate min-w-0"
}, zO = {
  key: 0,
  "data-tab-count": "",
  "data-testid": "table-view-tab-count",
  class: "shrink-0 whitespace-pre"
}, xb = "ri-arrow-down-s-line", OO = "ri-information-line", PO = 6, FO = 233, md = 1, VO = /* @__PURE__ */ ye({
  __name: "TableViewTabs",
  props: {
    tabDropdowns: { default: () => [] },
    overflowLabel: { default: void 0 }
  },
  emits: ["tab-requested", "tab-reordered"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = Kt(or), r = Kt(ws), o = R(null), i = R(null), s = R(null), d = R(/* @__PURE__ */ new Map()), u = R([]), f = /* @__PURE__ */ new Map(), b = (oe) => {
      var Ce;
      return ((Ce = f.get(oe)) == null ? void 0 : Ce.width) ?? 0;
    };
    let h = 0;
    const p = m(() => (r == null ? void 0 : r.presetViews.value) ?? []), x = ir(), y = Kt(_v, null);
    function k(oe) {
      return oe.count === void 0 ? oe.label : `${oe.label} (${oe.count})`;
    }
    const $ = R([]);
    function S() {
      const oe = p.value.filter((Ce) => {
        var Z;
        const H = (Z = d.value.get(Ce.id)) == null ? void 0 : Z.querySelector("[data-tab-label]");
        return !!H && H.scrollWidth > H.offsetWidth;
      }).map((Ce) => Ce.id);
      oe.join("\0") !== $.value.join("\0") && ($.value = oe);
    }
    const T = m(
      () => p.value.map((oe) => oe.id).filter((oe) => !u.value.includes(oe))
    ), I = m(() => D.value ? E.value : T.value[0] ?? null);
    function A(oe) {
      var ee;
      const Ce = T.value, H = Ce.findIndex((J) => d.value.get(J) === document.activeElement);
      if (H < 0 || Ce.length === 0) return;
      let Z;
      switch (oe.key) {
        case "ArrowRight":
          Z = (H + 1) % Ce.length;
          break;
        case "ArrowLeft":
          Z = (H - 1 + Ce.length) % Ce.length;
          break;
        case "Home":
          Z = 0;
          break;
        case "End":
          Z = Ce.length - 1;
          break;
        default:
          return;
      }
      oe.preventDefault(), (ee = d.value.get(Ce[Z])) == null || ee.focus();
    }
    const E = m(() => (l == null ? void 0 : l.state.activeViewId) ?? null), D = m(() => !!E.value && p.value.some((oe) => oe.id === E.value)), z = m(() => t.tabDropdowns), Y = m(
      () => {
        var oe;
        return ((oe = z.value.find((Ce) => Ce.overflowLabel)) == null ? void 0 : oe.overflowLabel) ?? t.overflowLabel ?? x.value.viewTabsOverflowLabel;
      }
    ), le = m(
      () => {
        var oe;
        return (oe = z.value.find((Ce) => Ce.overflowInfoTooltip)) == null ? void 0 : oe.overflowInfoTooltip;
      }
    ), ne = R(
      t.tabDropdowns.reduce((oe, Ce, H) => {
        var Z, ee;
        return (ee = (Z = Ce.groupButtons) == null ? void 0 : Z[0]) != null && ee.value && (oe[H] = Ce.groupButtons[0].value), oe;
      }, {})
    ), re = (oe, Ce) => {
      ne.value[oe] = Ce;
    }, O = R({}), P = (oe, Ce) => {
      O.value[oe] = Ce;
    }, V = R({}), M = (oe, Ce) => {
      const H = V.value[oe] ?? [];
      H.indexOf(Ce) >= 0 ? V.value[oe] = H.filter((ee) => ee !== Ce) : V.value[oe] = [...H, Ce];
    }, B = m(
      () => z.value.map(
        (oe, Ce) => {
          if (!oe.showHeader) return { left: void 0, right: void 0 };
          const H = oe.controlledSelection ? oe.items.filter((ee) => ee.switchChecked).length : (V.value[Ce] ?? []).length, Z = oe.selectedCountSuffix ?? "selected";
          return {
            left: { text: oe.label },
            right: { text: `${H}/${oe.items.length} ${Z}` }
          };
        }
      )
    ), q = m(
      () => z.value.map(
        (oe, Ce) => oe.items.map((H) => oe.controlledSelection ? {
          id: H.id,
          label: H.label,
          group: H.group,
          hasSwitch: !0,
          switchChecked: H.switchChecked === !0,
          disabled: H.disabled === !0,
          onClick: H.onClick,
          moreActions: H.moreActions
        } : {
          id: H.id,
          label: H.label,
          group: H.group,
          hasSwitch: !0,
          switchChecked: (V.value[Ce] ?? []).includes(H.id),
          onClick: () => M(Ce, H.id),
          moreActions: H.moreActions
        })
      )
    ), N = m(
      () => z.value.map(
        (oe, Ce) => (oe.footerButtons ?? []).map((H) => oe.controlledSelection ? {
          label: H.label,
          variant: H.variant,
          keepOpen: H.keepOpen,
          disabled: H.disabled,
          onClick: () => {
            var Z;
            return (Z = H.onClick) == null ? void 0 : Z.call(H, []);
          }
        } : {
          label: H.label,
          variant: H.variant,
          keepOpen: H.keepOpen,
          onClick: () => {
            var J;
            const Z = V.value[Ce] ?? [], ee = oe.items.filter((F) => Z.includes(F.id));
            a("tab-requested", Ce, ee), (J = H.onClick) == null || J.call(H, ee), V.value = { ...V.value, [Ce]: [] };
          }
        })
      )
    ), G = m(
      () => p.value.filter((oe) => u.value.includes(oe.id)).map((oe) => ({
        label: k(oe),
        onClick: () => l == null ? void 0 : l.setView(oe.id)
      }))
    );
    let U = 0;
    function K() {
      return typeof window > "u" ? 0.72 : window.innerWidth >= 1920 ? 0.8 : 0.72;
    }
    function ge(oe) {
      return oe.reduce((Ce, H) => Ce + b(H), 0) + md * Math.max(0, oe.length - 1);
    }
    function xe(oe) {
      var ue, se;
      const Ce = oe.getBoundingClientRect().width, H = ((ue = oe.querySelector("[data-tab-label]")) == null ? void 0 : ue.scrollWidth) ?? 0;
      if (Ce === 0 && H === 0) return 0;
      const Z = getComputedStyle(oe), J = ["paddingLeft", "paddingRight", "borderLeftWidth", "borderRightWidth"].reduce((Q, ae) => Q + (parseFloat(Z[ae]) || 0), 0), F = ((se = oe.querySelector("[data-tab-count]")) == null ? void 0 : se.getBoundingClientRect().width) ?? 0, _ = Math.ceil(J + H + F);
      return Math.min(FO, Math.max(Ce, _));
    }
    function X() {
      var Ee, He;
      if (U >= PO) return;
      const oe = o.value, Ce = i.value;
      if (!oe || !Ce) {
        u.value = [];
        return;
      }
      const H = oe.getBoundingClientRect().width;
      if (H <= 0) return;
      let Z = !1;
      for (const Ke of p.value) {
        if (((Ee = f.get(Ke.id)) == null ? void 0 : Ee.label) === k(Ke)) continue;
        const et = d.value.get(Ke.id);
        if (et) {
          const Se = xe(et);
          Se > 0 ? f.set(Ke.id, { label: k(Ke), width: Se }) : Z = !0;
        } else
          Z = !0;
      }
      if (Z) {
        u.value = [], U++, Ge(X);
        return;
      }
      S();
      const ee = ((He = s.value) == null ? void 0 : He.$el) ?? null;
      let J = 0, F = 0;
      for (let Ke = 0; Ke < oe.children.length; Ke++) {
        const et = oe.children[Ke];
        et !== Ce && (ee && (et === ee || et.contains(ee)) || (J += et.getBoundingClientRect().width, F++));
      }
      const _ = (typeof window < "u" ? window.innerWidth : H) * K(), ue = Math.min(H, _), se = Math.floor(ue - J - md * F), Q = p.value.map((Ke) => Ke.id);
      if (ge(Q) <= se - 1) {
        const Ke = JSON.stringify(u.value);
        u.value = [], JSON.stringify([]) !== Ke ? (U++, Ge(X)) : U = 0;
        return;
      }
      if (ee) {
        const Ke = ee.getBoundingClientRect().width;
        Ke > 0 && (h = Ke);
      }
      const ae = Math.floor(
        ue - J - h - md * (F + 1)
      ), Te = (Ke) => ge(Ke) <= ae - 1, Le = [], pe = [];
      for (const Ke of Q) (Te([...pe, Ke]) ? pe : Le).push(Ke);
      const ke = E.value;
      if (ke && Le.includes(ke)) {
        for (; pe.length > 0 && !Te([...pe, ke]); ) Le.push(pe.pop());
        Le.splice(Le.indexOf(ke), 1), pe.push(ke);
      }
      pe.length === 0 && Le.length > 0 && pe.push(Le.shift());
      const fe = JSON.stringify(u.value), ze = JSON.stringify(Le);
      u.value = Le, fe !== ze ? (U++, Ge(X)) : U = 0;
    }
    function ie() {
      U = 0, Ge(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(X);
        });
      });
    }
    let he = null;
    return ct(() => {
      var oe;
      ie(), he = new ResizeObserver(() => {
        h = 0, ie();
      }), o.value && he.observe(o.value), (oe = document.fonts) == null || oe.ready.then(() => {
        f.clear(), h = 0, ie();
      });
    }), kt(() => he == null ? void 0 : he.disconnect()), $e(
      p,
      (oe) => {
        const Ce = new Set(oe.map((H) => H.id));
        for (const [H] of f)
          Ce.has(H) || f.delete(H);
        h = 0, ie();
      },
      // CONSTRAINT: deep, so a counter mutated in place on the same view object still re-measures.
      { deep: !0 }
    ), $e(E, () => {
      ie();
    }), $e([Y, le], () => {
      ie();
    }), (oe, Ce) => (c(), g("div", {
      ref_key: "outerRef",
      ref: o,
      class: "flex items-stretch gap-px min-w-0 flex-1"
    }, [
      v("div", {
        ref_key: "containerRef",
        ref: i,
        "data-testid": "tab-container",
        role: "tablist",
        "aria-label": L(x).viewTabsLabel,
        class: "flex items-stretch gap-px min-w-0 overflow-hidden",
        onKeydown: A
      }, [
        (c(!0), g(de, null, Re(p.value, (H) => (c(), W(L(mt), {
          key: H.id,
          role: "presentation",
          class: C(["min-w-0", { "hidden!": u.value.includes(H.id) }]),
          text: k(H),
          disabled: !$.value.includes(H.id),
          "labels-trigger": ""
        }, {
          default: ve(() => {
            var Z;
            return [
              tr(v("button", {
                id: L(y) ? L(ex)(L(y).id, H.id) : void 0,
                ref_for: !0,
                ref: (ee) => {
                  ee && d.value.set(H.id, ee);
                },
                type: "button",
                role: "tab",
                "aria-controls": (Z = L(y)) != null && Z.isTabpanel.value ? L(y).id : void 0,
                "aria-selected": E.value === H.id ? "true" : "false",
                tabindex: I.value === H.id ? 0 : -1,
                "data-testid": `table-view-tab-${H.id}`,
                "data-active": E.value === H.id ? "true" : "false",
                class: C([
                  "min-w-0 px-3 flex items-center text-xs leading-5 font-medium transition-colors duration-200 rounded-tl-(--border-border-radius-rounded-sm) rounded-tr-(--border-border-radius-rounded-sm) max-w-[233px] overflow-hidden focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-royalblue",
                  E.value === H.id ? "tab-active tab-active--has-left -mb-px text-gray-900 dark:text-white" : "border-t border-r border-l border-(--border-border-tab) bg-(--colors-background-white-tertiary) text-(--colors-text-black-default) hover:bg-whitesmoke dark:bg-white/5 dark:text-(--colors-text-white-secondary) dark:hover:bg-white/10"
                ]),
                onClick: (ee) => {
                  var J;
                  return (J = L(l)) == null ? void 0 : J.setView(H.id);
                }
              }, [
                v("span", DO, j(H.label), 1),
                H.count !== void 0 ? (c(), g("span", zO, " (" + j(H.count) + ")", 1)) : w("", !0)
              ], 10, MO), [
                [Ru, !u.value.includes(H.id)]
              ])
            ];
          }),
          _: 2
        }, 1032, ["class", "text", "disabled"]))), 128))
      ], 40, BO),
      G.value.length > 0 ? (c(), W(L(cn), {
        key: 0,
        ref_key: "overflowDropdownRef",
        ref: s,
        class: "shrink-0",
        label: `+${G.value.length} ${Y.value}`,
        items: G.value,
        "trigger-icon-info": le.value ? OO : void 0,
        "trigger-icon-info-tooltip": le.value,
        "trigger-icon": xb,
        "menu-align": "left",
        "menu-width": "220px",
        tab: !0
      }, null, 8, ["label", "items", "trigger-icon-info", "trigger-icon-info-tooltip"])) : w("", !0),
      (c(!0), g(de, null, Re(z.value, (H, Z) => (c(), g("div", {
        key: Z,
        class: "flex items-center gap-1 shrink-0"
      }, [
        te(L(ec), {
          class: "shrink-0",
          label: H.label,
          "trigger-icon-left": H.iconLeft,
          "trigger-icon": xb,
          tab: !0,
          "header-label-left": B.value[Z].left,
          "header-label-right": B.value[Z].right,
          "show-search": H.showSearch,
          "search-query": O.value[Z] ?? "",
          "search-placeholder": H.searchPlaceholder,
          "search-clear-label": H.searchClearLabel,
          "group-buttons": H.groupButtons,
          "active-group-button": ne.value[Z],
          items: q.value[Z],
          "footer-buttons": N.value[Z],
          reorderable: H.reorderable === !0,
          "freeze-on-open": !0,
          "menu-align": "left",
          size: H.size ?? "m",
          "max-list-height": "280px",
          "reserve-list-height": H.reserveListHeight !== !1,
          "empty-label": H.emptyLabel,
          "onUpdate:searchQuery": (ee) => P(Z, ee),
          "onUpdate:activeGroupButton": (ee) => re(Z, ee),
          onReorder: (ee) => a("tab-reordered", Z, ee)
        }, null, 8, ["label", "trigger-icon-left", "header-label-left", "header-label-right", "show-search", "search-query", "search-placeholder", "search-clear-label", "group-buttons", "active-group-button", "items", "footer-buttons", "reorderable", "size", "reserve-list-height", "empty-label", "onUpdate:searchQuery", "onUpdate:activeGroupButton", "onReorder"])
      ]))), 128))
    ], 512));
  }
}), NO = /* @__PURE__ */ dt(VO, [["__scopeId", "data-v-b1c338bb"]]), Cs = 300;
function zq(e = {}) {
  const { initialViewMode: n, filterLabels: t, filterItems: a, filterFieldConfigs: l, ...r } = e, o = R(n ?? "table"), i = R(!1), s = R(0), d = Ha({
    search: "",
    filters: {},
    sort: null,
    activeViewId: null,
    page: 1,
    pageSize: 10,
    ...r
  }), u = m(() => Object.keys(d.filters).length > 0), f = m(() => Object.keys(d.filters).length), b = m(() => {
    const z = Pt(t), Y = Pt(a), le = Pt(l);
    return Object.entries(d.filters).map(([ne, re]) => {
      const O = {
        key: ne,
        label: (z == null ? void 0 : z[ne]) ?? ne,
        valueLabel: HO(re, Y == null ? void 0 : Y[ne]),
        value: re
      };
      Y != null && Y[ne] && (O.items = Y[ne]);
      const P = le == null ? void 0 : le[ne];
      return P && (P.placeholder && (O.placeholder = P.placeholder), P.rangeConfig && (O.rangeConfig = P.rangeConfig), P.dateRangeConfig && (O.dateRangeConfig = P.dateRangeConfig)), O;
    });
  });
  function h(z, Y) {
    d.filters[z] = Y, d.page = 1;
  }
  function p(z) {
    delete d.filters[z], d.page = 1;
  }
  function x() {
    d.filters = {}, d.page = 1;
  }
  function y(z) {
    d.search = z, d.page = 1, s.value++;
  }
  function k(z) {
    i.value = z;
  }
  function $(z, Y) {
    d.sort = { column: z, direction: Y };
  }
  function S() {
    d.sort = null;
  }
  function T(z) {
    d.page = z;
  }
  function I(z) {
    d.pageSize = z, d.page = 1;
  }
  function A(z) {
    d.activeViewId = z, d.page = 1;
  }
  function E(z) {
    o.value = z;
  }
  function D(z) {
    Object.assign(d, z);
  }
  return {
    state: d,
    viewMode: o,
    searchPending: i,
    searchRevision: s,
    hasActiveFilters: u,
    activeFilterCount: f,
    activeFilterPills: b,
    setFilter: h,
    removeFilter: p,
    clearAllFilters: x,
    setSearch: y,
    setSearchPending: k,
    setSort: $,
    clearSort: S,
    setPage: T,
    setPageSize: I,
    setView: A,
    setViewMode: E,
    patch: D
  };
}
function HO(e, n) {
  switch (e.type) {
    case "equals":
      return String(e.value);
    case "in": {
      const t = (a) => {
        var l;
        return ((l = n == null ? void 0 : n.find((r) => r.id === a)) == null ? void 0 : l.label) ?? a;
      };
      return e.values.length === 1 ? t(e.values[0]) : `${t(e.values[0])} (${e.values.length})`;
    }
    case "range":
      return e.min != null && e.max != null ? `${e.min} – ${e.max}` : e.min != null ? `≥ ${e.min}` : e.max != null ? `≤ ${e.max}` : "";
    case "dateRange":
      return e.from && e.to ? `${e.from} – ${e.to}` : e.from ? `≥ ${e.from}` : e.to ? `≤ ${e.to}` : "";
    case "boolean":
      return e.value ? "Yes" : "No";
  }
}
const jO = /* @__PURE__ */ ye({
  __name: "TableSearch",
  props: {
    placeholder: { default: "Search..." },
    debounce: { default: Cs }
  },
  setup(e) {
    const n = Kt(or), t = ir(), a = R(null);
    $e(
      () => n == null ? void 0 : n.searchRevision.value,
      () => {
        var r;
        return (r = a.value) == null ? void 0 : r.discardPending((n == null ? void 0 : n.state.search) ?? "");
      }
    );
    function l(r) {
      n == null || n.setSearch(r);
    }
    return (r, o) => {
      var i;
      return c(), W(G4, {
        ref_key: "searchRef",
        ref: a,
        "data-table-search": "",
        "model-value": ((i = L(n)) == null ? void 0 : i.state.search) ?? "",
        placeholder: e.placeholder,
        labels: { closeSearch: L(t).closeSearch },
        debounce: e.debounce,
        "onUpdate:modelValue": l,
        onPending: o[0] || (o[0] = (s) => {
          var d;
          return (d = L(n)) == null ? void 0 : d.setSearchPending(s);
        })
      }, null, 8, ["model-value", "placeholder", "labels", "debounce"]);
    };
  }
}), WO = {
  key: 0,
  class: "inline-flex items-center px-3 py-2 text-(length:--size-m) leading-[20px] font-medium text-(--colors-text-black-default) dark:text-(--colors-text-white-default)",
  "data-testid": "table-view-selector-static"
}, qO = /* @__PURE__ */ ye({
  __name: "TableViewSelector",
  emits: ["rename-view", "delete-view", "set-default"],
  setup(e, { emit: n }) {
    const t = n, a = Kt(or), l = Kt(ws), r = ir(), o = m(
      () => l == null ? void 0 : l.views.value.find((d) => d.id === (a == null ? void 0 : a.state.activeViewId))
    ), i = m(() => !!(o.value && !o.value.isPreset)), s = m(() => i.value ? [
      { label: r.value.renameView, onClick: () => t("rename-view", o.value.id) },
      {
        label: r.value.setAsDefault,
        hasDividerAfter: !0,
        onClick: () => {
          l == null || l.setDefault(o.value.id), t("set-default", o.value.id);
        }
      },
      { label: r.value.deleteView, onClick: () => t("delete-view", o.value.id) }
    ] : []);
    return (d, u) => i.value ? (c(), W(L(cn), {
      key: 1,
      label: L(r).viewModeTable,
      items: s.value,
      "menu-align": "right",
      "menu-width": "180px",
      ghost: !0
    }, null, 8, ["label", "items"])) : (c(), g("div", WO, j(L(r).viewModeTable), 1));
  }
}), UO = { class: "@container/topbar relative flex flex-wrap items-stretch border-gainsboro dark:border-(--colors-border-base)" }, GO = {
  key: 1,
  class: "flex-1"
}, nx = /* @__PURE__ */ ye({
  __name: "TableTopbar",
  props: {
    searchPlaceholder: { default: "Search..." },
    showSearch: { type: Boolean, default: !0 },
    searchDebounce: { default: Cs },
    showViewSelector: { type: Boolean, default: !1 },
    tabDropdowns: { default: () => [] }
  },
  emits: ["rename-view", "delete-view", "set-default", "tab-requested", "tab-reordered"],
  setup(e, { emit: n }) {
    const t = n, a = Kt(ws), l = m(() => ((a == null ? void 0 : a.presetViews.value.length) ?? 0) > 0);
    return (r, o) => (c(), g("div", UO, [
      v("div", {
        class: C(["h-9 items-stretch w-full @2xl/topbar:w-[73%] min-w-0", l.value ? "flex" : "hidden @2xl/topbar:flex"]),
        "data-testid": "table-topbar-tabs"
      }, [
        l.value ? (c(), W(NO, {
          key: 0,
          "tab-dropdowns": e.tabDropdowns,
          onTabRequested: o[0] || (o[0] = (i, s) => t("tab-requested", i, s)),
          onTabReordered: o[1] || (o[1] = (i, s) => t("tab-reordered", i, s))
        }, null, 8, ["tab-dropdowns"])) : (c(), g("div", GO))
      ], 2),
      v("div", {
        class: C(["order-first flex h-9 items-center justify-end gap-1 w-full @2xl/topbar:order-none @2xl/topbar:w-[27%] px-4 py-1", l.value ? "border-gainsboro dark:border-(--colors-border-base)" : ""]),
        "data-testid": "table-topbar-search"
      }, [
        e.showSearch ? (c(), W(jO, {
          key: 0,
          placeholder: e.searchPlaceholder,
          debounce: e.searchDebounce
        }, null, 8, ["placeholder", "debounce"])) : w("", !0),
        e.showViewSelector ? (c(), W(qO, {
          key: 1,
          onRenameView: o[2] || (o[2] = (i) => t("rename-view", i)),
          onDeleteView: o[3] || (o[3] = (i) => t("delete-view", i)),
          onSetDefault: o[4] || (o[4] = (i) => t("set-default", i))
        })) : w("", !0)
      ], 2)
    ]));
  }
}), KO = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M14%2014V20L10%2022V14L4%205V3H20V5L14%2014ZM6.4037%205L12%2013.3944L17.5963%205H6.4037Z'/%3e%3c/svg%3e", YO = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M17.8827%2019.2968C16.1814%2020.3755%2014.1638%2021.0002%2012.0003%2021.0002C6.60812%2021.0002%202.12215%2017.1204%201.18164%2012.0002C1.61832%209.62282%202.81932%207.5129%204.52047%205.93457L1.39366%202.80777L2.80788%201.39355L22.6069%2021.1925L21.1927%2022.6068L17.8827%2019.2968ZM5.9356%207.3497C4.60673%208.56015%203.6378%2010.1672%203.22278%2012.0002C4.14022%2016.0521%207.7646%2019.0002%2012.0003%2019.0002C13.5997%2019.0002%2015.112%2018.5798%2016.4243%2017.8384L14.396%2015.8101C13.7023%2016.2472%2012.8808%2016.5002%2012.0003%2016.5002C9.51498%2016.5002%207.50026%2014.4854%207.50026%2012.0002C7.50026%2011.1196%207.75317%2010.2981%208.19031%209.60442L5.9356%207.3497ZM12.9139%2014.328L9.67246%2011.0866C9.5613%2011.3696%209.50026%2011.6777%209.50026%2012.0002C9.50026%2013.3809%2010.6196%2014.5002%2012.0003%2014.5002C12.3227%2014.5002%2012.6309%2014.4391%2012.9139%2014.328ZM20.8068%2016.5925L19.376%2015.1617C20.0319%2014.2268%2020.5154%2013.1586%2020.7777%2012.0002C19.8603%207.94818%2016.2359%205.00016%2012.0003%205.00016C11.1544%205.00016%2010.3329%205.11773%209.55249%205.33818L7.97446%203.76015C9.22127%203.26959%2010.5793%203.00016%2012.0003%203.00016C17.3924%203.00016%2021.8784%206.87992%2022.8189%2012.0002C22.5067%2013.6998%2021.8038%2015.2628%2020.8068%2016.5925ZM11.7229%207.50857C11.8146%207.50299%2011.9071%207.50016%2012.0003%207.50016C14.4855%207.50016%2016.5003%209.51488%2016.5003%2012.0002C16.5003%2012.0933%2016.4974%2012.1858%2016.4919%2012.2775L11.7229%207.50857Z'/%3e%3c/svg%3e", JO = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12.0003%203C17.3924%203%2021.8784%206.87976%2022.8189%2012C21.8784%2017.1202%2017.3924%2021%2012.0003%2021C6.60812%2021%202.12215%2017.1202%201.18164%2012C2.12215%206.87976%206.60812%203%2012.0003%203ZM12.0003%2019C16.2359%2019%2019.8603%2016.052%2020.7777%2012C19.8603%207.94803%2016.2359%205%2012.0003%205C7.7646%205%204.14022%207.94803%203.22278%2012C4.14022%2016.052%207.7646%2019%2012.0003%2019ZM12.0003%2016.5C9.51498%2016.5%207.50026%2014.4853%207.50026%2012C7.50026%209.51472%209.51498%207.5%2012.0003%207.5C14.4855%207.5%2016.5003%209.51472%2016.5003%2012C16.5003%2014.4853%2014.4855%2016.5%2012.0003%2016.5ZM12.0003%2014.5C13.381%2014.5%2014.5003%2013.3807%2014.5003%2012C14.5003%2010.6193%2013.381%209.5%2012.0003%209.5C10.6196%209.5%209.50026%2010.6193%209.50026%2012C9.50026%2013.3807%2010.6196%2014.5%2012.0003%2014.5Z'/%3e%3c/svg%3e", XO = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4%203H18L20.7071%205.70711C20.8946%205.89464%2021%206.149%2021%206.41421V20C21%2020.5523%2020.5523%2021%2020%2021H4C3.44772%2021%203%2020.5523%203%2020V4C3%203.44772%203.44772%203%204%203ZM7%204V9H16V4H7ZM6%2012V19H18V12H6ZM13%205H15V8H13V5Z'/%3e%3c/svg%3e", Vl = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11.9999%2013.1714L16.9497%208.22168L18.3639%209.63589L11.9999%2015.9999L5.63599%209.63589L7.0502%208.22168L11.9999%2013.1714Z'/%3e%3c/svg%3e", ai = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11.9999%2010.8284L7.0502%2015.7782L5.63599%2014.364L11.9999%208L18.3639%2014.364L16.9497%2015.7782L11.9999%2010.8284Z'/%3e%3c/svg%3e", ax = /* @__PURE__ */ ye({
  __name: "TableControls",
  props: {
    isFilterPanelOpen: { type: Boolean, default: !1 },
    isFilterBarVisible: { type: Boolean, default: !0 },
    showFilter: { type: Boolean, default: !0 },
    bordered: { type: Boolean, default: !0 }
  },
  emits: ["toggle-filter-panel", "toggle-filter-bar", "save-view", "share-view", "focus-fallback"],
  setup(e, { expose: n, emit: t }) {
    const a = t, l = Kt(or), r = Kt(Zv), o = ir(), i = m(() => (l == null ? void 0 : l.hasActiveFilters.value) ?? !1), s = m(() => (l == null ? void 0 : l.activeFilterCount.value) ?? 0), d = ta("filterTrigger");
    function u() {
      var h;
      const b = (h = d.value) == null ? void 0 : h.querySelector(ka);
      return b == null || b.focus(), !!b && document.activeElement === b;
    }
    async function f() {
      l == null || l.clearAllFilters(), await Ge(), u() || a("focus-fallback");
    }
    return n({ focusFilterTrigger: u }), (b, h) => {
      var p, x;
      return c(), g("div", {
        class: C([
          "flex flex-wrap items-center gap-3 p-3 bg-white dark:bg-(--colors-background-black-default) rounded-tr-[12px]",
          e.bordered && "border-b border-x border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
        ])
      }, [
        e.showFilter ? (c(), g("div", {
          key: 0,
          ref_key: "filterTrigger",
          ref: d,
          class: "contents"
        }, [
          b.$slots.filter ? Ae(b.$slots, "filter", { key: 0 }) : (c(), W(L(Me), {
            key: 1,
            variant: "tertiary",
            "icon-left": L(KO),
            "icon-right": L(Vl),
            size: "sm",
            active: e.isFilterPanelOpen,
            onClick: h[0] || (h[0] = (y) => a("toggle-filter-panel"))
          }, {
            default: ve(() => [
              nt(j(L(o).filterButton), 1)
            ]),
            _: 1
          }, 8, ["icon-left", "icon-right", "active"]))
        ], 512)) : w("", !0),
        i.value ? (c(), g("button", {
          key: 1,
          type: "button",
          class: "shrink-0 text-sm font-medium text-blue-600 underline cursor-pointer hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 transition-colors",
          onClick: f
        }, j(L(o).eraseAll), 1)) : w("", !0),
        i.value ? (c(), W(L(Me), {
          key: 2,
          variant: "tertiary",
          "icon-left": e.isFilterBarVisible ? L(YO) : L(JO),
          "icon-right": e.isFilterBarVisible ? L(ai) : L(Vl),
          size: "sm",
          "aria-expanded": e.isFilterBarVisible,
          "data-testid": "table-controls-filter-bar-toggle",
          onClick: h[1] || (h[1] = (y) => a("toggle-filter-bar"))
        }, {
          default: ve(() => [
            nt(j(e.isFilterBarVisible ? L(o).hideFilters(s.value) : L(o).showFilters(s.value)), 1)
          ]),
          _: 1
        }, 8, ["icon-left", "icon-right", "aria-expanded"])) : w("", !0),
        Ae(b.$slots, "controls-info"),
        h[4] || (h[4] = v("div", { class: "flex-1" }, null, -1)),
        Ae(b.$slots, "controls-actions"),
        ((p = L(r)) == null ? void 0 : p.canSaveView) !== !1 ? (c(), W(L(Me), {
          key: 3,
          variant: "secondary",
          label: L(o).saveView,
          "icon-left": L(XO),
          "icon-right": L(Vl),
          size: "sm",
          disabled: !i.value,
          onClick: h[2] || (h[2] = (y) => a("save-view"))
        }, null, 8, ["label", "icon-left", "icon-right", "disabled"])) : w("", !0),
        ((x = L(r)) == null ? void 0 : x.canShareView) !== !1 ? (c(), W(L(Me), {
          key: 4,
          variant: "secondary",
          label: L(o).shareView,
          size: "sm",
          onClick: h[3] || (h[3] = (y) => a("share-view"))
        }, null, 8, ["label"])) : w("", !0)
      ], 2);
    };
  }
}), ZO = { class: "pill-gradient relative inline-flex shrink-0 items-stretch rounded-full" }, QO = { class: "flex items-stretch rounded-full bg-white dark:bg-(--colors-background-black-default)" }, _O = { class: "whitespace-nowrap text-sm font-medium text-slategray dark:text-(--colors-text-white-secondary)" }, eP = ["title"], tP = {
  key: 1,
  class: "ml-0.5 whitespace-nowrap text-sm font-medium text-(--colors-text-black-default) dark:text-(--colors-text-white-default)"
}, nP = ["aria-label"], aP = /* @__PURE__ */ ye({
  __name: "FilterPill",
  props: {
    pill: {}
  },
  emits: ["remove", "edit"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = ir(), r = m(
      () => t.pill.value.type === "in" ? t.pill.value.values.length : null
    ), o = m(() => r.value !== null && r.value > 1);
    function i() {
      a("edit", t.pill.key);
    }
    return (s, d) => (c(), g("div", ZO, [
      v("div", QO, [
        v("button", {
          type: "button",
          class: "inline-flex cursor-pointer items-center gap-1 py-1 pl-3 pr-1.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royalblue focus-visible:ring-offset-1 rounded-l-full",
          onClick: Je(i, ["stop"])
        }, [
          v("span", _O, j(e.pill.label), 1),
          o.value ? (c(), g("span", tP, " (" + j(r.value) + ") ", 1)) : (c(), g(de, { key: 0 }, [
            d[1] || (d[1] = v("span", { class: "text-sm text-slategray dark:text-(--colors-text-white-secondary)" }, " : ", -1)),
            v("span", {
              class: "max-w-50 truncate text-sm font-medium text-(--colors-text-black-default) dark:text-(--colors-text-white-default)",
              title: e.pill.valueLabel
            }, j(e.pill.valueLabel), 9, eP)
          ], 64)),
          d[2] || (d[2] = v("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            class: "ml-0.5 h-3 w-3 shrink-0 text-slategray dark:text-(--colors-text-white-secondary)"
          }, [
            v("path", { d: "M6 9l6 6 6-6" })
          ], -1))
        ]),
        d[4] || (d[4] = v("div", { class: "my-1.5 w-px bg-gainsboro dark:bg-(--colors-border-base)" }, null, -1)),
        v("button", {
          type: "button",
          class: "inline-flex w-7 cursor-pointer items-center justify-center rounded-r-full transition-colors duration-150 hover:bg-gray-100 dark:hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royalblue focus-visible:ring-offset-1",
          "aria-label": L(l).removeFilter(e.pill.label),
          "data-filter-pill-remove": "",
          onClick: d[0] || (d[0] = Je((u) => a("remove", e.pill.key), ["stop"]))
        }, [...d[3] || (d[3] = [
          v("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            class: "h-2.5 w-2.5 text-slategray dark:text-(--colors-text-white-secondary)"
          }, [
            v("path", { d: "M18 6 6 18M6 6l12 12" })
          ], -1)
        ])], 8, nP)
      ])
    ]));
  }
}), lP = /* @__PURE__ */ dt(aP, [["__scopeId", "data-v-41b3792d"]]), lx = /* @__PURE__ */ ye({
  __name: "TableFilterBar",
  props: {
    bordered: { type: Boolean, default: !0 }
  },
  emits: ["edit-filter", "last-filter-removed"],
  setup(e, { emit: n }) {
    const t = n, a = Kt(or), l = m(() => (a == null ? void 0 : a.activeFilterPills.value) ?? []), r = ta("pillList");
    async function o(i) {
      var u, f;
      const s = l.value.findIndex((b) => b.key === i);
      if (a == null || a.removeFilter(i), await Ge(), l.value.length === 0) {
        t("last-filter-removed");
        return;
      }
      const d = ((u = r.value) == null ? void 0 : u.querySelectorAll("[data-filter-pill-remove]")) ?? [];
      (f = d[Math.min(s, d.length - 1)]) == null || f.focus();
    }
    return (i, s) => (c(), W(At, {
      "enter-active-class": "transition-[max-height] duration-200 ease-out overflow-hidden",
      "enter-from-class": "max-h-0",
      "enter-to-class": "max-h-60",
      "leave-active-class": "transition-[max-height] duration-150 ease-in overflow-hidden",
      "leave-from-class": "max-h-60",
      "leave-to-class": "max-h-0"
    }, {
      default: ve(() => [
        l.value.length > 0 ? (c(), g("div", {
          key: 0,
          class: C([
            "flex items-start gap-2 px-4 py-2 bg-white dark:bg-(--colors-background-black-default)",
            e.bordered && "border-b border-gainsboro dark:border-(--colors-border-base)"
          ])
        }, [
          v("div", {
            ref_key: "pillList",
            ref: r,
            class: "flex items-center gap-2 flex-1 flex-wrap"
          }, [
            (c(!0), g(de, null, Re(l.value, (d) => (c(), W(lP, {
              key: d.key,
              pill: d,
              onRemove: o,
              onEdit: s[0] || (s[0] = (u) => t("edit-filter", u))
            }, null, 8, ["pill"]))), 128))
          ], 512)
        ], 2)) : w("", !0)
      ]),
      _: 1
    }));
  }
}), rP = {
  "data-testid": "table-skeleton",
  "aria-hidden": "true",
  class: "w-full"
}, oP = {
  key: 0,
  class: "flex border-b border-(--colors-border-base-medium) dark:border-(--colors-border-base)"
}, iP = /* @__PURE__ */ ye({
  __name: "TableSkeleton",
  props: {
    columns: { default: 5 },
    rows: { default: 10 },
    showHeader: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = [85, 45, 30, 65, 40, 55, 35, 75];
    function t(a, l) {
      return `${n[(a + l) % n.length]}%`;
    }
    return (a, l) => (c(), g("div", rP, [
      e.showHeader ? (c(), g("div", oP, [
        (c(!0), g(de, null, Re(e.columns, (r) => (c(), g("div", {
          key: `skeleton-header-${r}`,
          class: "flex-1 h-11 px-5 flex items-center"
        }, [...l[0] || (l[0] = [
          v("div", { class: "skeleton h-2.5 w-full max-w-[140px] rounded-full" }, null, -1)
        ])]))), 128))
      ])) : w("", !0),
      (c(!0), g(de, null, Re(e.rows, (r) => (c(), g("div", {
        key: `skeleton-row-${r}`,
        class: "flex border-b border-(--colors-border-base-soft) dark:border-(--colors-border-base) last:border-b-0"
      }, [
        (c(!0), g(de, null, Re(e.columns, (o) => (c(), g("div", {
          key: `skeleton-cell-${r}-${o}`,
          class: "flex-1 h-14 px-5 flex items-center"
        }, [
          v("div", {
            class: "skeleton h-2.5 rounded-full",
            style: je({ width: t(r, o) })
          }, null, 4)
        ]))), 128))
      ]))), 128))
    ]));
  }
}), sP = { class: "flex items-center gap-1.5 justify-center" }, dP = ["src"], uP = ["src"], cP = { class: "self-stretch flex flex-col items-start gap-2" }, fP = {
  key: 0,
  class: "self-stretch flex flex-col items-start"
}, hP = ["onClick"], bP = ["src"], gP = {
  key: 1,
  class: "h-5 w-5 relative flex-shrink-0"
}, mP = {
  key: 2,
  class: "relative leading-num-24 font-medium"
}, pP = ["src"], vP = ["onClick"], xP = { class: "flex-1 flex items-center py-num-0 pl-0.5 pr-num-0 shrink-0 relative z-10" }, yP = { class: "relative leading-num-24 font-medium" }, kP = ["onClick"], wP = ["src"], CP = {
  key: 1,
  class: "h-5 w-5 relative flex-shrink-0"
}, SP = {
  key: 2,
  class: "relative leading-num-24 font-medium z-10"
}, $P = {
  key: 0,
  class: "flex items-center gap-1.5 text-center text-[12px] text-colors-text-black-default relative z-10"
}, IP = { class: "relative leading-5 font-medium z-10" }, LP = "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23242424%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cline x1=%2218%22 y1=%226%22 x2=%226%22 y2=%2218%22/%3E%3Cline x1=%226%22 y1=%226%22 x2=%2218%22 y2=%2218%22/%3E%3C/svg%3E", TP = "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23242424%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cpolyline points=%229 18 15 12 9 6%22/%3E%3C/svg%3E", AP = "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23242424%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cpolyline points=%226 9 12 15 18 9%22/%3E%3C/svg%3E", EP = "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23242424%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cpolyline points=%2218 15 12 9 6 15%22/%3E%3C/svg%3E", RP = /* @__PURE__ */ ye({
  __name: "MainDrawer",
  props: {
    logoIcon: { default: "/logo-eudonet.svg" },
    logoText: { default: void 0 },
    closeIcon: { default: void 0 },
    items: { default: () => [
      {
        label: "Overview",
        children: []
      },
      {
        label: "Pages",
        children: []
      },
      {
        label: "Ecommerce",
        icon: void 0,
        children: [
          { label: "All products" },
          { label: "Billing", active: !0 },
          { label: "Invoice" },
          { label: "Transactions" }
        ]
      },
      {
        label: "Messages",
        badge: 4,
        children: []
      },
      {
        label: "Users",
        children: []
      },
      {
        label: "Support",
        children: []
      }
    ] },
    modelValue: { type: Boolean, default: !0 },
    width: { default: "100%" }
  },
  emits: ["update:modelValue", "close", "item-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R({
      Ecommerce: !0
    }), r = R(!1), o = m(() => t.items), i = (x) => {
      l.value[x] = !l.value[x];
    }, s = (x) => l.value[x] === !0, d = (x) => {
      x.children && x.children.length > 0 && !r.value && i(x.label), x.onClick && x.onClick(), a("item-click", x);
    }, u = () => {
      const x = !r.value;
      r.value = x, x && Object.keys(l.value).forEach((y) => {
        l.value[y] = !1;
      });
    }, f = m(() => r.value ? "/logo-eudonet-small.svg" : t.logoIcon || "/logo-eudonet.svg"), b = (x) => {
      const y = 'self-stretch flex items-center py-num-6 pl-8 pr-num-8 cursor-pointer border-solid border-[1px] border-transparent transition-[background,border-color] duration-300 relative before:content-[""] before:absolute before:inset-[-1px] before:rounded-[48px] before:[background:linear-gradient(90deg,_#716ff2,_#52DBF5)] before:transition-opacity before:duration-300 before:z-0 after:content-[""] after:absolute after:inset-0 after:rounded-[48px] after:bg-white after:transition-opacity after:duration-300 after:z-[1]';
      return x.active ? `${y} h-9 rounded-[48px] bg-white overflow-visible before:opacity-100 after:opacity-100` : `${y} rounded-num-12 hover:bg-aliceblue hover:border-[rgba(255,255,255,0.2)] hover:overflow-hidden before:opacity-0 after:opacity-0`;
    }, h = (x) => {
      const y = "self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border-[1px] border-transparent transition-[background,border-color] duration-300";
      return x.active ? `${y} relative before:content-[""] before:absolute before:inset-[-1px] before:rounded-[48px] before:[background:linear-gradient(90deg,_#716ff2,_#52DBF5)] before:transition-opacity before:duration-300 before:z-0 before:opacity-100 after:content-[""] after:absolute after:inset-0 after:rounded-[48px] after:bg-white after:transition-opacity after:duration-300 after:z-[1] after:opacity-100 bg-white overflow-visible` : `${y} hover:bg-aliceblue hover:border-[rgba(255,255,255,0.2)] hover:overflow-hidden`;
    }, p = () => 'h-[22px] w-[22px] rounded-[9999px] relative flex items-center justify-center overflow-visible before:opacity-100 after:opacity-100 before:content-[""] before:absolute before:inset-[-1px] before:rounded-[9999px] before:[background:linear-gradient(90deg,_#716ff2,_#52DBF5)] before:transition-opacity before:duration-300 before:z-0 after:content-[""] after:absolute after:inset-0 after:rounded-[9999px] after:bg-white after:transition-opacity after:duration-300 after:z-[1]';
    return (x, y) => e.modelValue ? (c(), g("div", {
      key: 0,
      role: "dialog",
      class: C(["drawer h-[1184px] relative bg-white flex flex-col items-start box-border gap-5 text-left text-num-16 text-colors-text-body font-inter transition-all duration-300", { "w-20 p-2 overflow-visible": r.value, "p-5 overflow-hidden": !r.value }]),
      style: je(r.value ? { width: "80px" } : { width: e.width })
    }, [
      v("div", {
        class: C([
          "self-stretch border-colors-border-black-default border-solid border-b-[1px] pt-num-0 px-num-0 relative",
          r.value ? "flex flex-col items-center gap-2 overflow-visible pb-2" : "flex items-center justify-between gap-5 pb-4"
        ])
      }, [
        v("div", sP, [
          f.value ? (c(), g("img", {
            key: 0,
            class: "h-[30px] w-auto relative",
            src: f.value,
            alt: "Eudonet"
          }, null, 8, dP)) : w("", !0),
          e.logoText && !r.value ? (c(), g("img", {
            key: 1,
            class: "h-[30px] w-[73.8px] relative",
            src: e.logoText,
            alt: "Eudonet"
          }, null, 8, uP)) : w("", !0)
        ]),
        r.value ? (c(), W(L(Me), {
          key: 1,
          variant: "tertiary",
          "icon-left": TP,
          "icon-only": "",
          size: "md",
          "aria-label": "Expand",
          class: "drawer-expand-button flex-shrink-0",
          onClick: u
        })) : (c(), W(L(Me), {
          key: 0,
          variant: "tertiary",
          "icon-left": e.closeIcon || LP,
          "icon-only": "",
          size: "md",
          "aria-label": "Close",
          class: "drawer-close-button flex-shrink-0",
          onClick: u
        }, null, 8, ["icon-left"]))
      ], 2),
      v("div", cP, [
        (c(!0), g(de, null, Re(o.value, (k, $) => (c(), g(de, { key: $ }, [
          k.children && k.children.length > 0 ? (c(), g("div", fP, [
            v("button", {
              type: "button",
              class: C(["self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border-[1px] border-transparent hover:bg-aliceblue hover:border-[rgba(255,255,255,0.2)] hover:overflow-hidden transition-[background,border-color] duration-300", { "justify-center": r.value }]),
              onClick: (S) => d(k)
            }, [
              v("div", {
                class: C(["flex-1 flex items-center gap-1.5", { "justify-center": r.value }])
              }, [
                k.icon ? (c(), g("img", {
                  key: 0,
                  class: "h-5 w-5 relative flex-shrink-0",
                  src: k.icon,
                  alt: ""
                }, null, 8, bP)) : (c(), g("div", gP)),
                r.value ? w("", !0) : (c(), g("div", mP, j(k.label), 1))
              ], 2),
              r.value ? w("", !0) : (c(), g("img", {
                key: 0,
                class: "h-4 w-4 relative transition-transform duration-200",
                src: s(k.label) ? EP : AP,
                alt: ""
              }, null, 8, pP))
            ], 10, hP),
            te(Ur, {
              name: "submenu",
              tag: "div",
              class: C([
                "self-stretch flex flex-col items-start gap-2 submenu-wrapper",
                { "submenu-open": s(k.label) }
              ])
            }, {
              default: ve(() => [
                (c(!0), g(de, null, Re(s(k.label) ? k.children : [], (S, T) => (c(), g("button", {
                  key: `${k.label}-${T}`,
                  type: "button",
                  class: C(b(S)),
                  onClick: (I) => d(S)
                }, [
                  v("div", xP, [
                    v("div", yP, j(S.label), 1)
                  ])
                ], 10, vP))), 128))
              ]),
              _: 2
            }, 1032, ["class"])
          ])) : (c(), g("button", {
            key: 1,
            type: "button",
            class: C([h(k), { "justify-center": r.value }]),
            onClick: (S) => d(k)
          }, [
            v("div", {
              class: C(["flex-1 flex items-center gap-1.5 relative z-10", { "justify-center": r.value }])
            }, [
              k.icon ? (c(), g("img", {
                key: 0,
                class: "h-5 w-5 relative flex-shrink-0 z-10",
                src: k.icon,
                alt: ""
              }, null, 8, wP)) : (c(), g("div", CP)),
              r.value ? w("", !0) : (c(), g("div", SP, j(k.label), 1))
            ], 2),
            k.badge && !r.value ? (c(), g("div", $P, [
              v("div", {
                class: C(p())
              }, [
                v("div", IP, j(k.badge), 1)
              ], 2)
            ])) : w("", !0)
          ], 10, kP))
        ], 64))), 128))
      ])
    ], 6)) : w("", !0);
  }
}), Oq = /* @__PURE__ */ dt(RP, [["__scopeId", "data-v-ce4179bf"]]), BP = ["aria-label"], MP = { class: "flex min-w-0 flex-wrap items-center gap-2.5 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)" }, DP = {
  key: 1,
  class: "sr-only"
}, zP = ["aria-current"], OP = {
  key: 1,
  class: "sr-only"
}, PP = {
  key: 2,
  "data-testid": "breadcrumb-separator",
  class: "ri-arrow-right-s-line inline-flex size-3.5 shrink-0 items-center justify-center text-num-14 text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
  "aria-hidden": "true"
}, yb = "inline-flex min-w-0 max-w-full items-center gap-1.5 rounded-(--border-border-radius-rounded-xs)", FP = "text-(--text-text-heading) hover:text-(--text-text-body) dark:text-(--text-text-white-default) dark:hover:text-(--text-text-white-secondary) transition-colors duration-150 ease-in-out motion-reduce:transition-none focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)", kb = "inline-flex size-4 shrink-0 items-center justify-center text-num-16 text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", VP = /* @__PURE__ */ ye({
  __name: "Breadcrumb",
  props: {
    items: {},
    type: { default: "default" },
    ariaLabel: {},
    linkAs: { default: "a" }
  },
  setup(e) {
    var y;
    const n = e, t = m(() => [
      "flex w-fit max-w-full min-w-0 items-center text-(--text-text-heading) dark:text-(--text-text-white-default)",
      n.type === "background" ? "border border-(--border-border-white-default) bg-(--background-background-white) p-[calc(--spacing(2.5)-1px)] rounded-(--border-border-radius-rounded-base) shadow-(--blur-shadow-xs) dark:bg-(--background-background-black-default) dark:border-(--border-border-base)" : "rounded-(--border-border-radius-rounded-xs)"
    ]);
    function a(k) {
      return k === n.items.length - 1;
    }
    function l(k) {
      return k.to != null && n.linkAs !== "a";
    }
    function r(k, $) {
      return !a($) && (l(k) || k.href !== void 0);
    }
    const o = typeof process < "u" && ((y = process.env) == null ? void 0 : y.NODE_ENV) !== "production";
    $e(
      () => n.items,
      (k) => {
        o && n.linkAs === "a" && k.some(($) => $.to != null) && console.warn(
          "[OPAL Breadcrumb] items with `to` need `linkAs` (e.g. RouterLink); they render as text."
        );
      },
      { immediate: !0 }
    );
    function i(k) {
      return !!(k.hideLabel && k.icon);
    }
    const s = R([]), d = R(null), u = R(!1);
    function f(k) {
      if (d.value === k)
        return !u.value;
    }
    function b(k, $) {
      let S;
      try {
        S = $.target.matches(":focus-visible");
      } catch {
        S = !0;
      }
      d.value = S ? k : null;
    }
    function h() {
      d.value = null, u.value = !1;
    }
    function p(k, $) {
      var S;
      $.key !== "Escape" || u.value || d.value !== k || !((S = s.value[k]) != null && S.isTruncated) || ($.stopPropagation(), $.preventDefault(), u.value = !0);
    }
    const x = R(null);
    return $e(
      () => n.items,
      () => {
        var k;
        (k = x.value) != null && k.contains(document.activeElement) || h();
      },
      { deep: 1, flush: "post" }
    ), (k, $) => (c(), g("nav", {
      ref_key: "navEl",
      ref: x,
      "aria-label": e.ariaLabel,
      "data-testid": "breadcrumb",
      class: C(t.value)
    }, [
      v("ol", MP, [
        (c(!0), g(de, null, Re(e.items, (S, T) => (c(), g("li", {
          key: T,
          "data-testid": "breadcrumb-item",
          class: "flex min-w-0 max-w-full items-center gap-1.5"
        }, [
          r(S, T) ? (c(), W(it(l(S) ? e.linkAs : "a"), Fe({
            key: 0,
            ref_for: !0
          }, l(S) ? { to: S.to } : { href: S.href }, {
            "data-testid": "breadcrumb-link",
            class: [yb, FP],
            onFocus: (I) => b(T, I),
            onBlur: h,
            onKeydown: (I) => p(T, I)
          }), {
            default: ve(() => [
              S.icon ? (c(), g("i", {
                key: 0,
                class: C([S.icon, kb]),
                "aria-hidden": "true"
              }, null, 2)) : w("", !0),
              i(S) ? (c(), g("span", DP, j(S.label), 1)) : (c(), W(pt, {
                key: 2,
                ref_for: !0,
                ref: (I) => s.value[T] = I,
                text: S.label,
                focusable: !1,
                open: f(T)
              }, null, 8, ["text", "open"]))
            ]),
            _: 2
          }, 1040, ["class", "onFocus", "onKeydown"])) : (c(), g("span", {
            key: 1,
            "data-testid": "breadcrumb-text",
            "aria-current": a(T) && i(S) ? "page" : void 0,
            class: C([
              yb,
              a(T) ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-heading) dark:text-(--text-text-white-default)"
            ])
          }, [
            S.icon ? (c(), g("i", {
              key: 0,
              class: C([S.icon, kb]),
              "aria-hidden": "true"
            }, null, 2)) : w("", !0),
            i(S) ? (c(), g("span", OP, j(S.label), 1)) : (c(), W(pt, {
              key: 2,
              text: S.label,
              "aria-current": a(T) ? "page" : void 0
            }, null, 8, ["text", "aria-current"]))
          ], 10, zP)),
          T < e.items.length - 1 ? (c(), g("i", PP)) : w("", !0)
        ]))), 128))
      ])
    ], 10, BP));
  }
}), NP = ["id", "aria-modal", "aria-label", "aria-labelledby", "aria-describedby"], HP = {
  key: 0,
  class: "flex-1 min-w-0"
}, jP = ["src", "alt"], WP = { class: "min-w-0 break-words [overflow-wrap:anywhere]" }, qP = {
  key: 2,
  "data-testid": "drawer-heading-badges",
  class: "flex flex-wrap items-start gap-1.5"
}, UP = {
  key: 3,
  "data-testid": "drawer-heading-actions",
  class: "flex shrink-0 items-center gap-2"
}, GP = {
  key: 1,
  "data-testid": "drawer-subheader",
  class: "shrink-0 px-5 pt-5 pb-3"
}, KP = {
  "data-testid": "drawer-content",
  class: "flex-1 overflow-y-auto px-5 py-5"
}, YP = ["data-layout"];
let JP = 0;
const XP = () => `drawer-${++JP}`, ZP = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "Drawer",
  props: {
    modelValue: { type: Boolean, default: !1 },
    title: { default: void 0 },
    position: { default: "right" },
    subtitle: { default: void 0 },
    headingLevel: { default: 2 },
    back: { default: void 0 },
    icon: { default: void 0 },
    logo: { default: void 0 },
    avatar: { default: void 0 },
    avatars: { default: void 0 },
    badges: { default: void 0 },
    headerActions: { default: void 0 },
    breadcrumb: { default: void 0 },
    size: { default: "md" },
    actions: { default: void 0 },
    actionsLayout: { default: void 0 },
    showCloseButton: { type: Boolean, default: !0 },
    dismissable: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    showBackdrop: { type: Boolean, default: !0 },
    backdropClass: { default: void 0 },
    panelClass: { default: void 0 },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaCloseLabel: { default: "Close drawer" },
    variant: { default: "default" },
    beforeClose: { type: Function, default: void 0 }
  },
  emits: ["update:modelValue", "close", "back", "header-action", "action"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = Hn(), r = (J) => {
      const F = l[J];
      return !!F && tc(F({ titleId: k, subtitleId: $ }));
    }, o = () => r("header"), i = () => {
      var J;
      return a.showCloseButton || !!a.title || !!a.subtitle || !!a.back || !!a.breadcrumb || !!((J = a.headerActions) != null && J.length) || !!V.value || M.value || o();
    }, s = m(() => {
      var F;
      if (a.actionsLayout) return a.actionsLayout;
      const J = ((F = a.actions) == null ? void 0 : F.length) ?? 0;
      return J === 1 ? "one" : J === 2 ? "two" : J === 3 ? "three" : "stacked";
    }), d = {
      one: "items-center justify-end gap-4",
      two: "items-center justify-end gap-4",
      three: "items-center justify-between gap-3",
      stacked: "flex-col gap-4"
    }, u = m(() => {
      const J = a.actions ?? [];
      return s.value === "three" ? [J.slice(0, 1), J.slice(1)] : [J];
    }), f = (J) => s.value === "three" && J === 1 ? "flex items-center gap-4" : "contents", b = m(() => s.value === "one" || s.value === "stacked"), h = (J) => {
      var F;
      (F = J.onClick) == null || F.call(J), x("action", J.id);
    }, p = (J) => [
      "flex shrink-0 pt-[calc(--spacing(5)-1px)] pb-5 border-t border-(--colors-border-base-medium) dark:border-(--colors-border-base)",
      J,
      a.variant === "column" ? "px-5" : "mx-5"
    ], x = t, y = XP(), k = `${y}-title`, $ = `${y}-subtitle`, S = Symbol("opal-drawer"), T = () => {
      x("update:modelValue", !1), x("close");
    };
    let I = !1, A = 0;
    $e(
      () => a.modelValue,
      (J) => {
        J && A++;
      }
    );
    const E = async () => {
      if (I) return;
      if (!a.beforeClose) {
        T();
        return;
      }
      I = !0;
      const J = A;
      try {
        await a.beforeClose() !== !1 && a.modelValue && J === A && T();
      } catch {
      } finally {
        I = !1;
      }
    }, D = () => {
      a.dismissable && E();
    }, z = (J) => {
      J.key !== "Escape" || !a.closeOnEscape || !a.modelValue || ya(S) && (J.defaultPrevented || (J.preventDefault(), E()));
    }, { zIndex: Y, isTop: le } = Rv(An(a, "modelValue"));
    $e(
      () => a.modelValue,
      (J) => {
        J ? ra(S) : Fn(S);
      }
    ), ct(() => {
      document.addEventListener("keydown", z), a.modelValue && ra(S);
    }), kt(() => {
      document.removeEventListener("keydown", z), Fn(S);
    });
    const ne = {
      md: "w-80",
      lg: "w-96",
      xl: "w-[min(80%,1280px)]"
    }, re = m(() => a.variant === "column" ? "w-[512px]" : ne[a.size]), O = m(() => `h${a.headingLevel}`), P = "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--text-text-black-default) dark:text-(--colors-text-white-default) break-words [overflow-wrap:anywhere]", V = m(() => {
      if (a.icon) return "icon";
      if (a.logo) return "logo";
      if (a.avatar) return "avatar";
      if (a.avatars) return "avatars";
    }), M = m(() => {
      var J;
      return !!((J = a.badges) != null && J.length);
    }), B = m(() => {
      var J;
      return !!((J = a.headerActions) != null && J.length);
    }), q = () => !!a.breadcrumb && !o(), N = () => o() || !V.value && !M.value && !B.value && !a.breadcrumb, G = () => !o() && !q() && V.value === "avatars", U = () => N() ? "pb-[calc(--spacing(4)-1px)]" : "pb-[calc(--spacing(5)-1px)]", K = () => {
      if (!N())
        return G() ? "flex-wrap gap-x-6 gap-y-2" : "gap-6";
    }, ge = () => q() ? "items-center" : "items-start", xe = m(() => {
      if (V.value)
        return V.value === "icon" ? "items-start gap-2.5" : "items-center gap-2.5";
    }), X = () => !!a.title && !q(), ie = m(() => a.position === "left" ? "left-0" : "right-0"), he = m(
      () => a.variant === "column" ? a.position === "left" ? "border-r" : "border-l" : void 0
    ), oe = m(() => `drawer-slide-${a.position}`), Ce = () => a.subtitle && i() && !q() ? $ : void 0, H = () => a.ariaLabelledby ?? (a.ariaLabel || !X() ? void 0 : k);
    n({ focusTitle: () => {
      var J;
      (J = document.getElementById(k)) == null || J.focus();
    } });
    const ee = R(null);
    return ts({
      active: An(a, "modelValue"),
      container: ee
    }), (J, F) => (c(), W(Nn, { to: "body" }, [
      te(At, { name: "drawer-fade" }, {
        default: ve(() => [
          e.modelValue && e.showBackdrop ? (c(), g("div", {
            key: 0,
            "data-testid": "drawer-backdrop",
            "aria-hidden": "true",
            class: C(["fixed inset-0 bg-(--colors-background-overlay) dark:bg-(--colors-background-overlay-dark)", e.backdropClass]),
            style: je({ zIndex: L(Y) }),
            onClick: D
          }, null, 6)) : w("", !0)
        ]),
        _: 1
      }),
      te(At, { name: oe.value }, {
        default: ve(() => {
          var _;
          return [
            e.modelValue ? (c(), g("div", Fe({
              key: 0,
              id: L(y),
              ref_key: "panelRef",
              ref: ee
            }, J.$attrs, {
              "data-testid": "drawer-panel",
              role: "dialog",
              "aria-modal": L(le) ? "true" : void 0,
              "aria-label": e.ariaLabel,
              "aria-labelledby": H(),
              "aria-describedby": Ce(),
              class: [
                "fixed inset-y-0 flex flex-col",
                "bg-(--background-background-white) dark:bg-(--colors-background-black-default)",
                "border-(--colors-border-base-soft) dark:border-(--colors-border-base)",
                e.variant === "column" ? "shadow-(--shadow-drawer-column)" : "shadow-(--shadow-drawer)",
                re.value,
                ie.value,
                he.value,
                e.panelClass
              ],
              style: { zIndex: L(Y) + 1 }
            }), [
              i() ? (c(), g("div", {
                key: 0,
                "data-testid": "drawer-header",
                class: C([
                  "flex shrink-0 justify-between mx-5 mt-5 border-b border-(--colors-border-base-medium) dark:border-(--colors-border-base)",
                  ge(),
                  K(),
                  U()
                ])
              }, [
                o() ? (c(), g("div", HP, [
                  Ae(J.$slots, "header", {
                    titleId: k,
                    subtitleId: $
                  }, void 0, !0)
                ])) : e.breadcrumb ? (c(), W(VP, an(Fe({ key: 1 }, e.breadcrumb)), null, 16)) : (c(), g("div", {
                  key: 2,
                  "data-testid": "drawer-heading-lead",
                  class: C(["flex flex-1 min-w-0", xe.value])
                }, [
                  V.value === "icon" ? (c(), W(Gt, {
                    key: 0,
                    "data-testid": "drawer-heading-icon",
                    icon: e.icon,
                    size: "lg",
                    type: "square",
                    variant: "outlined",
                    color: "white",
                    class: "shrink-0"
                  }, null, 8, ["icon"])) : V.value === "logo" && e.logo ? (c(), g("img", {
                    key: 1,
                    "data-testid": "drawer-heading-logo",
                    src: e.logo.src,
                    alt: e.logo.alt,
                    class: "size-12 shrink-0 object-contain"
                  }, null, 8, jP)) : V.value === "avatar" && e.avatar ? (c(), W(Nt, {
                    key: 2,
                    "data-testid": "drawer-heading-avatar",
                    name: e.avatar.name,
                    img: e.avatar.img,
                    entity: e.avatar.entity,
                    size: "lg",
                    "avatar-style": "circle",
                    presentational: "",
                    class: "shrink-0"
                  }, null, 8, ["name", "img", "entity"])) : V.value === "avatars" && e.avatars ? (c(), W(Pv, {
                    key: 3,
                    "data-testid": "drawer-heading-avatars",
                    avatars: e.avatars.avatars,
                    max: e.avatars.max,
                    "aria-label": e.avatars.ariaLabel,
                    size: "lg",
                    class: "shrink-0"
                  }, null, 8, ["avatars", "max", "aria-label"])) : w("", !0),
                  v("div", {
                    class: C(["flex flex-1 min-w-0 flex-col", M.value ? "gap-0.5" : void 0])
                  }, [
                    e.back ? (c(), g("button", {
                      key: 0,
                      type: "button",
                      "data-testid": "drawer-heading-back",
                      class: "inline-flex w-fit max-w-full items-center gap-1.5 rounded-(--border-border-radius-rounded-xs) text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default) hover:text-(--text-text-body) dark:text-(--text-text-white-default) dark:hover:text-(--text-text-white-secondary) transition-colors duration-150 ease-in-out motion-reduce:transition-none focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)",
                      onClick: F[0] || (F[0] = (ue) => x("back"))
                    }, [
                      F[1] || (F[1] = v("i", {
                        class: "ri-arrow-left-line inline-flex size-4 shrink-0 items-center justify-center text-num-16 text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
                        "aria-hidden": "true"
                      }, null, -1)),
                      v("span", WP, j(e.back.label), 1)
                    ])) : w("", !0),
                    e.title ? (c(), W(it(O.value), {
                      key: 1,
                      id: k,
                      "data-testid": "drawer-title",
                      tabindex: "-1",
                      class: "text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold) text-(--text-text-black-default) dark:text-(--colors-text-white-default) break-words [overflow-wrap:anywhere] focus:outline-hidden"
                    }, {
                      default: ve(() => [
                        nt(j(e.title), 1)
                      ]),
                      _: 1
                    })) : w("", !0),
                    M.value ? (c(), g("div", qP, [
                      (c(!0), g(de, null, Re(e.badges, (ue, se) => (c(), W(gt, Fe({ key: se }, { ref_for: !0 }, ue, { size: "sm" }), null, 16))), 128))
                    ])) : w("", !0),
                    e.subtitle && !G() ? (c(), g("p", {
                      key: 3,
                      id: $,
                      "data-testid": "drawer-subtitle",
                      class: C(P)
                    }, j(e.subtitle), 1)) : w("", !0)
                  ], 2)
                ], 2)),
                B.value || e.showCloseButton ? (c(), g("div", UP, [
                  (c(!0), g(de, null, Re(e.headerActions, (ue) => (c(), W(Me, {
                    key: ue.id,
                    "data-testid": "drawer-header-action",
                    variant: "ghost",
                    size: "sm",
                    "icon-only": "",
                    "icon-left": ue.icon,
                    "aria-label": ue.label,
                    onClick: (se) => x("header-action", ue.id)
                  }, null, 8, ["icon-left", "aria-label", "onClick"]))), 128)),
                  e.showCloseButton ? (c(), W(Me, {
                    key: 0,
                    "data-testid": "drawer-close-button",
                    variant: "ghost",
                    size: "sm",
                    "icon-only": "",
                    "icon-left": "ri-close-fill",
                    "aria-label": e.ariaCloseLabel,
                    onClick: E
                  }, null, 8, ["aria-label"])) : w("", !0)
                ])) : w("", !0),
                e.subtitle && G() ? (c(), g("p", {
                  key: 4,
                  id: $,
                  "data-testid": "drawer-subtitle",
                  class: C(["basis-full", P])
                }, j(e.subtitle), 3)) : w("", !0)
              ], 2)) : w("", !0),
              r("subheader") ? (c(), g("div", GP, [
                Ae(J.$slots, "subheader", {}, void 0, !0)
              ])) : w("", !0),
              v("div", KP, [
                Ae(J.$slots, "default", {}, void 0, !0)
              ]),
              (_ = e.actions) != null && _.length ? (c(), g("div", {
                key: 2,
                "data-testid": "drawer-footer",
                "data-layout": s.value,
                class: C(p(d[s.value]))
              }, [
                (c(!0), g(de, null, Re(u.value, (ue, se) => (c(), g("div", {
                  key: se,
                  class: C(f(se))
                }, [
                  (c(!0), g(de, null, Re(ue, (Q) => (c(), W(Me, {
                    key: Q.id,
                    "data-testid": Q.testId ?? `drawer-action-${Q.id}`,
                    variant: Q.variant,
                    size: s.value === "one" ? "md" : "sm",
                    "full-width": b.value,
                    label: Q.label,
                    "icon-left": Q.icon,
                    disabled: Q.disabled,
                    "aria-disabled": Q.ariaDisabled,
                    loading: Q.loading,
                    "loading-label": Q.loadingLabel,
                    type: Q.type,
                    form: Q.form,
                    onClick: (ae) => h(Q)
                  }, null, 8, ["data-testid", "variant", "size", "full-width", "label", "icon-left", "disabled", "aria-disabled", "loading", "loading-label", "type", "form", "onClick"]))), 128))
                ], 2))), 128))
              ], 10, YP)) : r("footer") ? (c(), g("div", {
                key: 3,
                "data-testid": "drawer-footer",
                class: C(p("items-center justify-end gap-4"))
              }, [
                Ae(J.$slots, "footer", {}, void 0, !0)
              ], 2)) : w("", !0)
            ], 16, NP)) : w("", !0)
          ];
        }),
        _: 3
      }, 8, ["name"])
    ]));
  }
}), QP = /* @__PURE__ */ dt(ZP, [["__scopeId", "data-v-b34a8a79"]]), _P = {
  class: "inline-flex min-w-0 max-w-full items-stretch rounded-(--border-border-radius-rounded-base) shadow-(--blur-shadow-xs)",
  "data-testid": "split-button"
}, e8 = "rounded-r-none! hover:z-10 focus-visible:z-10", t8 = "flex! rounded-l-none! hover:z-10 focus-visible:z-10", n8 = /* @__PURE__ */ ye({
  __name: "SplitButton",
  props: {
    label: {},
    menu: {},
    menuLabel: {},
    variant: { default: "secondary" },
    size: { default: "sm" },
    icon: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    loadingLabel: { default: void 0 },
    menuAlign: { default: "right" }
  },
  emits: ["click", "select"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(
      () => t.menu.map((r) => ({
        ...r,
        onClick: () => {
          var o;
          (o = r.onClick) == null || o.call(r), a("select", r);
        }
      }))
    );
    return (r, o) => (c(), g("div", _P, [
      te(Me, {
        variant: e.variant,
        size: e.size,
        label: e.label,
        "icon-left": e.icon,
        disabled: e.disabled,
        "aria-disabled": e.ariaDisabled,
        shrink: "",
        loading: e.loading,
        "loading-label": e.loadingLabel,
        class: C(e8),
        "data-testid": "split-button-label",
        onClick: o[0] || (o[0] = (i) => a("click", i))
      }, null, 8, ["variant", "size", "label", "icon-left", "disabled", "aria-disabled", "loading", "loading-label"]),
      te(cn, {
        items: l.value,
        "menu-align": e.menuAlign,
        class: "-ml-px shrink-0"
      }, {
        trigger: ve(({ triggerProps: i }) => [
          te(Me, Fe({
            "icon-only": "",
            "icon-left": "ri-arrow-down-s-line",
            variant: e.variant,
            size: e.size,
            "aria-label": e.menuLabel,
            disabled: e.disabled,
            "aria-disabled": e.ariaDisabled,
            class: t8,
            "data-testid": "split-button-chevron"
          }, i), null, 16, ["variant", "size", "aria-label", "disabled", "aria-disabled"])
        ]),
        _: 1
      }, 8, ["items", "menu-align"])
    ]));
  }
}), jr = 3, a8 = {
  class: "sr-only",
  role: "status",
  "aria-live": "polite",
  "aria-atomic": "true",
  "data-testid": "faceted-reorder-live"
}, l8 = { class: "flex flex-col gap-3 px-5 py-4" }, r8 = { class: "shadow-(--blur-shadow-xs)" }, o8 = { class: "flex-1 overflow-y-auto px-5 pb-1" }, i8 = { key: "visible" }, s8 = ["aria-labelledby"], d8 = ["id"], u8 = { class: "flex flex-col gap-4" }, c8 = { class: "shrink-0 w-4.5" }, f8 = ["for"], h8 = { class: "flex items-center gap-3 shrink-0" }, b8 = ["aria-labelledby", "aria-label"], g8 = ["id"], m8 = { class: "flex flex-col gap-4" }, p8 = { class: "shrink-0 w-4.5" }, v8 = ["for"], x8 = { class: "flex items-center gap-3 shrink-0" }, y8 = ["disabled", "aria-label", "aria-pressed", "onClick"], k8 = {
  key: 1,
  class: "flex items-center justify-center py-8 text-(length:--size-m) leading-(--line-height-l) text-(--colors-text-body-subtle) font-inter"
}, w8 = { key: "order" }, C8 = {
  key: 0,
  class: "flex items-center gap-1.5 text-(length:--size-sm) leading-(--line-height-l) text-(--colors-text-body-subtle) mb-2 font-inter"
}, S8 = ["aria-label"], $8 = ["aria-label"], I8 = ["disabled", "aria-label", "aria-pressed", "onClick"], L8 = {
  key: 1,
  class: "flex items-center justify-center py-8 text-(length:--size-m) leading-(--line-height-l) text-(--colors-text-body-subtle) font-inter"
}, T8 = /* @__PURE__ */ ye({
  __name: "FacetedSearchDrawer",
  props: {
    modelValue: { type: Boolean },
    columns: {},
    defaultColumns: { default: () => [] },
    columnOrder: { default: () => [] },
    labels: { default: () => ({}) }
  },
  emits: ["update:modelValue", "save", "reset"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R(!1), r = {
      fige: "Pinned",
      "actif-indigo": "Active",
      "actif-orange": "Active",
      fixe: "Fixed"
    }, o = m(() => ({
      title: t.labels.title ?? "Customize columns",
      subtitle: t.labels.subtitle ?? ((ae, Te) => `${ae} of ${Te} selected`),
      searchPlaceholder: t.labels.searchPlaceholder ?? "Search a column",
      searchClearLabel: t.labels.searchClearLabel ?? "Clear search",
      visibleTab: t.labels.visibleTab ?? "Visible",
      orderTab: t.labels.orderTab ?? "Order",
      defaultColumnHeader: t.labels.defaultColumnHeader ?? "Default fixed column",
      pinnedBadge: t.labels.pinnedBadge ?? "Pinned",
      resetLabel: t.labels.resetLabel ?? "Reset columns",
      cancelLabel: t.labels.cancelLabel ?? "Cancel",
      saveLabel: t.labels.saveLabel ?? "Save",
      closeAriaLabel: t.labels.closeAriaLabel ?? "Close",
      emptySearchText: t.labels.emptySearchText ?? "No columns found",
      emptyOrderText: t.labels.emptyOrderText ?? "No visible columns",
      orderSearchHint: t.labels.orderSearchHint ?? "Showing filtered results. Drag to reorder within visible columns.",
      pinTooltip: t.labels.pinTooltip ?? "Locked column",
      pinAriaLabelPinned: t.labels.pinAriaLabelPinned ?? "Unfreeze column",
      pinAriaLabelUnpinned: t.labels.pinAriaLabelUnpinned ?? "Freeze column",
      pinLimitTooltip: t.labels.pinLimitTooltip ?? `You can freeze up to ${jr} columns. Unfreeze a column to freeze another.`,
      badgeLabels: {
        ...r,
        ...t.labels.badgeLabels ?? {}
      },
      reorderMoved: t.labels.reorderMoved ?? ((ae, Te, Le) => `${ae} moved to position ${Te} of ${Le}`),
      reorderPickedUp: t.labels.reorderPickedUp ?? ((ae) => `${ae} picked up. Use arrow keys to move, space to drop, escape to cancel.`),
      reorderCancelled: t.labels.reorderCancelled ?? ((ae) => `${ae} reorder cancelled`),
      orderListLabel: t.labels.orderListLabel ?? "Column order"
    })), i = R(null), s = R([]), d = R(""), u = R("visible"), f = R(null), b = R(null), h = R(null), p = R(null);
    let x = null;
    const y = qe();
    function k(ae) {
      return `${y}-section-${ae.replace(/\s+/g, "-").toLowerCase() || "ungrouped"}`;
    }
    function $(ae) {
      return `${y}-column-${ae.replace(/\s+/g, "-")}`;
    }
    const S = R("");
    function T(ae, Te, Le) {
      S.value = o.value.reorderMoved(ae, Te, Le);
    }
    function I(ae) {
      return ae.map((Te) => ({
        ...Te,
        visible: Te.disabled || Te.alwaysVisible ? !0 : Te.visible
      }));
    }
    function A() {
      const ae = I(t.columns);
      if (t.columnOrder.length > 0) {
        const Te = new Map(t.columnOrder.map((Le, pe) => [Le, pe]));
        ae.sort((Le, pe) => (Te.get(Le.key) ?? 1 / 0) - (Te.get(pe.key) ?? 1 / 0));
      }
      s.value = he(ae);
    }
    $e(
      () => t.modelValue,
      (ae) => {
        ae && (A(), d.value = "", u.value = "visible", p.value = null, x = null, l.value = !1);
      },
      { immediate: !0 }
    ), $e(
      () => t.modelValue ? `${t.columnOrder.join("|")}::${t.columns.map((ae) => ae.key).join("|")}` : null,
      (ae) => {
        ae !== null && p.value === null && A();
      }
    );
    const E = {
      fige: "bg-white ring-1 ring-(--colors-border-base-soft) text-(--colors-text-black-default)",
      "actif-indigo": "bg-(--colors-indigo-100) text-(--colors-text-black-default)",
      "actif-orange": "bg-(--colors-warning-100) text-(--colors-text-black-default)",
      fixe: "bg-(--colors-indigo-100) text-(--colors-text-black-default)"
    };
    function D(ae) {
      return E[ae];
    }
    function z(ae) {
      return ae.badge ? o.value.badgeLabels[ae.badge] : ae.pinned || B(ae) ? o.value.pinnedBadge : "";
    }
    const Y = m(() => s.value.filter((ae) => ae.visible).length), le = m(() => s.value.length), ne = m(
      () => o.value.subtitle(Y.value, le.value)
    ), re = m(() => {
      const ae = d.value.toLowerCase().trim();
      return ae ? s.value.filter((Te) => Te.label.toLowerCase().includes(ae)) : s.value;
    }), O = m(
      () => re.value.filter((ae) => ae.alwaysVisible || ae.disabled)
    ), P = m(
      () => re.value.filter((ae) => !ae.alwaysVisible && !ae.disabled)
    ), V = m(() => {
      const ae = [], Te = /* @__PURE__ */ new Map(), Le = [];
      for (const pe of P.value)
        pe.group ? (Te.has(pe.group) || Te.set(pe.group, []), Te.get(pe.group).push(pe)) : Le.push(pe);
      for (const [pe, ke] of Te)
        ae.push({ name: pe, items: ke });
      return Le.length > 0 && ae.push({ name: "", items: Le }), ae;
    }), M = m(() => {
      const ae = d.value.toLowerCase().trim(), Te = s.value.filter((Le) => Le.visible);
      return ae ? Te.filter((Le) => Le.label.toLowerCase().includes(ae)) : Te;
    });
    function B(ae) {
      return !!(ae.disabled || ae.alwaysVisible);
    }
    const q = m(
      () => s.value.filter((ae) => ae.visible && (B(ae) || ae.pinned)).length
    ), N = m(() => q.value >= jr);
    function G(ae) {
      return !ae.visible || B(ae) ? !1 : ae.pinned || !N.value;
    }
    function U(ae) {
      return ae.pinned ? o.value.pinAriaLabelPinned : o.value.pinAriaLabelUnpinned;
    }
    function K(ae) {
      return ae.visible && !ae.pinned && N.value ? o.value.pinLimitTooltip : U(ae);
    }
    function ge(ae) {
      return !B(ae);
    }
    function xe(ae) {
      return B(ae) ? "locked" : ae.pinned ? "pinned" : "regular";
    }
    function X(ae, Te) {
      return xe(ae) === xe(Te);
    }
    function ie(ae) {
      const Te = [], Le = [], pe = [];
      for (const ke of ae)
        B(ke) ? Te.push(ke) : ke.pinned ? Le.push(ke) : pe.push(ke);
      return [...Te, ...Le, ...pe];
    }
    function he(ae = s.value) {
      const Te = [], Le = [];
      for (const pe of ae)
        (pe.visible ? Te : Le).push(pe);
      return [...ie(Te), ...Le];
    }
    function oe(ae) {
      B(ae) || (ae.visible = !ae.visible, ae.visible || (ae.pinned = !1));
    }
    function Ce(ae) {
      G(ae) && (ae.pinned = !ae.pinned, s.value = he());
    }
    function H() {
      a("update:modelValue", !1);
    }
    function Z() {
      l.value && a("reset"), a(
        "save",
        s.value.map((ae) => ({ ...ae }))
      ), a("update:modelValue", !1);
    }
    const ee = m(() => [
      {
        id: "reset",
        label: o.value.resetLabel,
        variant: "ghost",
        icon: "ri-restart-line",
        onClick: J
      },
      { id: "cancel", label: o.value.cancelLabel, variant: "secondary", onClick: H },
      { id: "save", label: o.value.saveLabel, variant: "primary", onClick: Z }
    ]);
    function J() {
      s.value = he(I(t.defaultColumns)), l.value = !0;
    }
    function F(ae, Te) {
      f.value = ae, Te.dataTransfer && (Te.dataTransfer.effectAllowed = "move");
    }
    function _(ae) {
      const Te = M.value[ae], Le = f.value !== null ? M.value[f.value] : null;
      if (!Te || !ge(Te)) {
        b.value = null;
        return;
      }
      if (Le && !X(Le, Te)) {
        b.value = null;
        return;
      }
      b.value = ae;
    }
    function ue(ae) {
      if (f.value === null || f.value === ae) {
        f.value = null, b.value = null;
        return;
      }
      const Te = M.value[f.value], Le = M.value[ae];
      if (!Te || !Le || !ge(Te) || !ge(Le) || !X(Te, Le)) {
        f.value = null, b.value = null;
        return;
      }
      const pe = Te.key, ke = Le.key, fe = [...s.value], ze = fe.findIndex((Ke) => Ke.key === pe), Ee = fe.findIndex((Ke) => Ke.key === ke), [He] = fe.splice(ze, 1);
      fe.splice(Ee, 0, He), f.value = null, b.value = null, requestAnimationFrame(() => {
        s.value = he(fe);
        const Ke = s.value.findIndex((Se) => Se.key === pe) + 1, et = s.value.filter((Se) => Se.visible).length;
        T(Te.label, Ke, et);
      });
    }
    function se() {
      f.value = null, b.value = null;
    }
    function Q(ae, Te) {
      const Le = M.value[ae];
      if (!Le) return;
      if (Te.key === "Escape" && p.value !== null) {
        Te.preventDefault(), x && (s.value = x), p.value = null, x = null, S.value = o.value.reorderCancelled(Le.label);
        return;
      }
      if (Te.key === " " || Te.key === "Enter") {
        if (p.value === null) {
          if (!ge(Le)) return;
          Te.preventDefault(), p.value = ae, x = s.value.map((Qe) => ({ ...Qe })), S.value = o.value.reorderPickedUp(Le.label);
          return;
        }
        Te.preventDefault();
        const Be = M.value[p.value], Ye = M.value.length;
        T((Be == null ? void 0 : Be.label) ?? Le.label, p.value + 1, Ye), p.value = null, x = null;
        return;
      }
      if (p.value === null || Te.key !== "ArrowUp" && Te.key !== "ArrowDown") return;
      const pe = p.value, ke = M.value[pe];
      if (!ke) return;
      let fe = Te.key === "ArrowUp" ? pe - 1 : pe + 1;
      for (; fe >= 0 && fe < M.value.length && (!ge(M.value[fe]) || !X(ke, M.value[fe])); )
        fe += Te.key === "ArrowUp" ? -1 : 1;
      if (fe < 0 || fe >= M.value.length) return;
      Te.preventDefault();
      const ze = M.value[pe].key, Ee = M.value[fe].key, He = [...s.value], Ke = He.findIndex((Be) => Be.key === ze), et = He.findIndex((Be) => Be.key === Ee), [Se] = He.splice(Ke, 1);
      He.splice(et, 0, Se), s.value = he(He), p.value = fe, h.value = fe;
      const me = s.value.filter((Be) => Be.visible).length;
      T(Le.label, fe + 1, me), requestAnimationFrame(() => {
        var Ye, Qe;
        const Be = (Ye = i.value) == null ? void 0 : Ye.querySelectorAll("[role='listitem']");
        (Qe = Be == null ? void 0 : Be[fe]) == null || Qe.focus();
      });
    }
    return (ae, Te) => (c(), W(L(QP), {
      "model-value": e.modelValue,
      position: "right",
      variant: "column",
      title: o.value.title,
      subtitle: ne.value,
      "aria-close-label": o.value.closeAriaLabel,
      actions: ee.value,
      dismissable: !0,
      "onUpdate:modelValue": Te[2] || (Te[2] = (Le) => a("update:modelValue", Le))
    }, {
      default: ve(() => [
        v("div", {
          ref_key: "drawerContainerRef",
          ref: i,
          class: "flex flex-col h-full -mx-5 -mt-4 -mb-5 gap-1"
        }, [
          v("div", a8, j(S.value), 1),
          v("div", l8, [
            v("div", r8, [
              te(L(ls), {
                modelValue: d.value,
                "onUpdate:modelValue": Te[0] || (Te[0] = (Le) => d.value = Le),
                placeholder: o.value.searchPlaceholder,
                labels: { clear: o.value.searchClearLabel },
                size: "sm",
                "full-width": ""
              }, null, 8, ["modelValue", "placeholder", "labels"])
            ]),
            te(L(Ig), {
              modelValue: u.value,
              "onUpdate:modelValue": Te[1] || (Te[1] = (Le) => u.value = Le),
              variant: "group",
              color: "dark",
              size: "sm",
              class: "w-full",
              "aria-label": o.value.title,
              "data-testid": "faceted-view-switch"
            }, {
              default: ve(() => [
                te(L(Me), {
                  value: "visible",
                  variant: "tertiary",
                  size: "sm",
                  label: o.value.visibleTab,
                  class: "flex-1"
                }, null, 8, ["label"]),
                te(L(Me), {
                  value: "order",
                  variant: "tertiary",
                  size: "sm",
                  label: o.value.orderTab,
                  class: "flex-1"
                }, null, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue", "aria-label"])
          ]),
          v("div", o8, [
            te(At, {
              name: "faceted-tab-fade",
              mode: "out-in"
            }, {
              default: ve(() => [
                u.value === "visible" ? (c(), g("div", i8, [
                  O.value.length > 0 ? (c(), g("div", {
                    key: 0,
                    class: "mb-8",
                    role: "group",
                    "aria-labelledby": k("default-fixed")
                  }, [
                    v("div", {
                      id: k("default-fixed"),
                      class: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold) text-(--colors-text-heading) mb-4 font-inter"
                    }, j(o.value.defaultColumnHeader), 9, d8),
                    v("div", u8, [
                      (c(!0), g(de, null, Re(O.value, (Le) => (c(), g("div", {
                        key: Le.key,
                        class: "flex items-center gap-(--spacing-2-5) p-px"
                      }, [
                        v("div", c8, [
                          te(L(Bn), {
                            id: $(Le.key),
                            "model-value": !0,
                            disabled: !0,
                            variant: "light"
                          }, null, 8, ["id"])
                        ]),
                        v("label", {
                          for: $(Le.key),
                          class: "flex-1 min-w-0 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) font-inter truncate cursor-not-allowed text-(--colors-text-body-subtle)"
                        }, j(Le.label), 9, f8),
                        v("div", h8, [
                          v("span", {
                            class: C(["inline-flex items-center px-1 py-0.5 rounded-(--border-border-radius-rounded-xs) text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) font-inter", D(Le.badge ?? "fige")])
                          }, j(z(Le)), 3),
                          Te[3] || (Te[3] = v("i", {
                            class: "ri-pushpin-2-fill text-(length:--icon-size-lg) leading-(--line-height-xxl) text-(--colors-text-body-subtle)",
                            "aria-hidden": "true"
                          }, null, -1))
                        ])
                      ]))), 128))
                    ])
                  ], 8, s8)) : w("", !0),
                  (c(!0), g(de, null, Re(V.value, (Le) => (c(), g("div", {
                    key: Le.name,
                    class: "mb-8 last:mb-0",
                    role: "group",
                    "aria-labelledby": Le.name ? k(Le.name) : void 0,
                    "aria-label": Le.name ? void 0 : o.value.visibleTab
                  }, [
                    Le.name ? (c(), g("div", {
                      key: 0,
                      id: k(Le.name),
                      class: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold) text-(--colors-text-heading) mb-4 font-inter"
                    }, j(Le.name), 9, g8)) : w("", !0),
                    v("div", m8, [
                      (c(!0), g(de, null, Re(Le.items, (pe) => (c(), g("div", {
                        key: pe.key,
                        class: "flex items-center gap-(--spacing-2-5) p-px"
                      }, [
                        v("div", p8, [
                          te(L(Bn), {
                            id: $(pe.key),
                            "model-value": pe.visible,
                            variant: "default",
                            "onUpdate:modelValue": (ke) => oe(pe)
                          }, null, 8, ["id", "model-value", "onUpdate:modelValue"])
                        ]),
                        v("label", {
                          for: $(pe.key),
                          class: "flex-1 min-w-0 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) font-inter truncate text-(--colors-text-heading) cursor-pointer"
                        }, j(pe.label), 9, v8),
                        v("div", x8, [
                          pe.pinned || pe.badge ? (c(), g("span", {
                            key: 0,
                            class: C(["inline-flex items-center px-1 py-0.5 rounded-(--border-border-radius-rounded-xs) text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) font-inter", D(pe.badge ?? "fige")])
                          }, j(z(pe)), 3)) : w("", !0),
                          te(L(mt), {
                            text: K(pe),
                            position: "top",
                            tabindex: G(pe) ? void 0 : 0
                          }, {
                            default: ve(() => [
                              v("button", {
                                type: "button",
                                class: C([
                                  "inline-flex items-center justify-center size-6 rounded-(--border-border-radius-rounded-xs) transition-colors duration-150 hover:bg-(--colors-background-hover) disabled:cursor-not-allowed disabled:hover:bg-transparent",
                                  pe.pinned ? "text-(--colors-text-black-default)" : "text-(--colors-text-body-subtle) hover:text-(--colors-text-black-default)"
                                ]),
                                disabled: !G(pe),
                                "aria-label": U(pe),
                                "aria-pressed": pe.pinned,
                                onClick: Je((ke) => Ce(pe), ["stop"])
                              }, [
                                v("i", {
                                  class: C([pe.pinned ? "ri-pushpin-2-fill" : "ri-pushpin-2-line", "text-(length:--icon-size-lg) leading-(--line-height-xxl)"])
                                }, null, 2)
                              ], 10, y8)
                            ]),
                            _: 2
                          }, 1032, ["text", "tabindex"])
                        ])
                      ]))), 128))
                    ])
                  ], 8, b8))), 128)),
                  re.value.length === 0 ? (c(), g("div", k8, j(o.value.emptySearchText), 1)) : w("", !0)
                ])) : u.value === "order" ? (c(), g("div", w8, [
                  d.value.trim() && M.value.length > 0 ? (c(), g("div", C8, [
                    Te[4] || (Te[4] = v("i", { class: "ri-information-line text-(length:--icon-size-xs) shrink-0" }, null, -1)),
                    v("span", null, j(o.value.orderSearchHint), 1)
                  ])) : w("", !0),
                  v("div", {
                    class: "flex flex-col gap-3",
                    role: "list",
                    "aria-label": o.value.orderListLabel
                  }, [
                    (c(!0), g(de, null, Re(M.value, (Le, pe) => (c(), W(VM, {
                      key: Le.key,
                      label: Le.label,
                      disabled: Le.disabled || Le.alwaysVisible,
                      reorderable: ge(Le),
                      class: C([
                        "transition-all duration-150 ease-out rounded-(--border-border-radius-rounded-l) focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-(--border-border-accent) focus-visible:ring-offset-1",
                        b.value === pe && f.value !== pe ? "ring-2 ring-(--border-border-hover) rounded-(--border-border-radius-rounded-l)" : "",
                        f.value === pe ? "opacity-40" : "",
                        p.value === pe ? "ring-2 ring-(--border-border-accent) rounded-(--border-border-radius-rounded-l)" : ""
                      ]),
                      role: "listitem",
                      "aria-roledescription": ge(Le) ? "sortable" : void 0,
                      "data-picked-up": p.value === pe ? "true" : void 0,
                      tabindex: "0",
                      onDragstart: (ke) => F(pe, ke),
                      onDragover: Je((ke) => _(pe), ["prevent"]),
                      onDragend: se,
                      onDrop: Je((ke) => ue(pe), ["prevent"]),
                      onKeydown: (ke) => Q(pe, ke)
                    }, {
                      badge: ve(() => [
                        Le.pinned || Le.badge ? (c(), g("span", {
                          key: 0,
                          class: C(["shrink-0 inline-flex items-center px-1 py-0.5 rounded-(--border-border-radius-rounded-xs) text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) font-inter", D(Le.badge ?? "fige")])
                        }, j(z(Le)), 3)) : w("", !0)
                      ]),
                      actions: ve(() => [
                        Le.disabled || Le.alwaysVisible ? (c(), W(L(mt), {
                          key: 0,
                          text: o.value.pinTooltip,
                          position: "top"
                        }, {
                          default: ve(() => [
                            v("button", {
                              type: "button",
                              class: "shrink-0 size-6 flex items-center justify-center",
                              disabled: "",
                              "aria-label": o.value.pinTooltip
                            }, [...Te[5] || (Te[5] = [
                              v("i", { class: "ri-pushpin-2-fill text-(length:--icon-size-lg) leading-(--line-height-xxl) text-(--colors-text-body-subtle)" }, null, -1)
                            ])], 8, $8)
                          ]),
                          _: 1
                        }, 8, ["text"])) : (c(), W(L(mt), {
                          key: 1,
                          text: K(Le),
                          position: "top",
                          tabindex: G(Le) ? void 0 : 0
                        }, {
                          default: ve(() => [
                            v("button", {
                              type: "button",
                              class: "shrink-0 size-6 flex items-center justify-center rounded-(--border-border-radius-rounded-xs) transition-colors duration-150 hover:bg-(--colors-background-hover) disabled:cursor-not-allowed disabled:hover:bg-transparent",
                              disabled: !G(Le),
                              "aria-label": U(Le),
                              "aria-pressed": Le.pinned,
                              onClick: Je((ke) => Ce(Le), ["stop"])
                            }, [
                              v("i", {
                                class: C([
                                  Le.pinned ? "ri-pushpin-2-fill text-(--colors-text-black-default)" : "ri-pushpin-2-line text-(--colors-text-body-subtle)",
                                  "text-(length:--icon-size-lg) leading-(--line-height-xxl)"
                                ])
                              }, null, 2)
                            ], 8, I8)
                          ]),
                          _: 2
                        }, 1032, ["text", "tabindex"]))
                      ]),
                      _: 2
                    }, 1032, ["label", "disabled", "reorderable", "class", "aria-roledescription", "data-picked-up", "onDragstart", "onDragover", "onDrop", "onKeydown"]))), 128))
                  ], 8, S8),
                  M.value.length === 0 ? (c(), g("div", L8, j(o.value.emptyOrderText), 1)) : w("", !0)
                ])) : w("", !0)
              ]),
              _: 1
            })
          ])
        ], 512)
      ]),
      _: 1
    }, 8, ["model-value", "title", "subtitle", "aria-close-label", "actions"]));
  }
}), A8 = /* @__PURE__ */ dt(T8, [["__scopeId", "data-v-bacb0a0c"]]);
function Pq(e = {}) {
  const { defaultOpen: n = !1, onClose: t } = e, a = R(n);
  return { isOpen: a, open: () => {
    a.value = !0;
  }, close: () => {
    a.value = !1, t == null || t();
  }, toggle: () => {
    a.value = !a.value;
  } };
}
function rx(e, n, t) {
  function a() {
    var s;
    const o = (s = e.value) == null ? void 0 : s.querySelector("[data-table-search]"), i = o != null && o.matches(ka) ? o : o == null ? void 0 : o.querySelector(ka);
    return i == null || i.focus(), !!i && document.activeElement === i;
  }
  function l() {
    if (a()) return;
    const o = e.value;
    o && (o.tabIndex = -1, o.setAttribute("role", "group"), o.setAttribute("aria-label", t()), o.addEventListener(
      "blur",
      () => {
        o.removeAttribute("tabindex"), o.removeAttribute("role"), o.removeAttribute("aria-label");
      },
      { once: !0 }
    ), o.focus());
  }
  function r() {
    var o;
    (o = n.value) != null && o.focusFilterTrigger() || l();
  }
  return { focusSearchOrRoot: l, focusAfterFiltersCleared: r };
}
const E8 = ["aria-busy"], R8 = {
  key: 0,
  class: "border-b border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
}, B8 = ["id", "role", "aria-labelledby", "aria-busy"], M8 = {
  key: 1,
  class: "border border-(--colors-border-base-soft) dark:border-(--colors-border-base) px-5 py-3 bg-white dark:bg-(--colors-background-black-default) rounded-b-xl"
}, D8 = {
  key: 0,
  "data-testid": "table-skeleton-footer",
  "aria-hidden": "true",
  class: "flex items-center justify-between h-7"
}, z8 = { class: "flex items-center gap-2.5" }, Fq = /* @__PURE__ */ ye({
  __name: "TableShell",
  props: {
    query: {},
    views: { default: void 0 },
    permissions: { default: () => ({}) },
    labels: { default: void 0 },
    showTopbar: { type: Boolean, default: !0 },
    showControls: { type: Boolean, default: !0 },
    showFilter: { type: Boolean, default: !0 },
    searchPlaceholder: { default: "Search..." },
    showSearch: { type: Boolean, default: !0 },
    searchDebounce: { default: Cs },
    markSearchStale: { type: Boolean, default: !0 },
    showViewSelector: { type: Boolean, default: !1 },
    tabDropdowns: { default: () => [] },
    columnSettings: { default: void 0 },
    loading: { type: Boolean, default: !1 },
    skeletonColumns: { default: void 0 },
    skeletonRows: { default: void 0 },
    bordered: { type: Boolean, default: !1 }
  },
  emits: ["rename-view", "delete-view", "set-default", "save-view", "share-view", "toggle-filter-panel", "toggle-filter-bar", "edit-filter", "tab-requested", "tab-reordered"],
  setup(e, { expose: n, emit: t }) {
    const a = tn(), l = e, r = t;
    dn(or, l.query), l.views && dn(ws, l.views), l.columnSettings && dn(RO, l.columnSettings);
    const o = m(() => l.permissions ?? {});
    dn(Zv, o.value);
    const i = m(() => ({ ...tx, ...l.labels }));
    dn(Qv, i);
    const s = qe(), d = m(() => {
      var D;
      const A = l.query.state.activeViewId;
      return l.showTopbar && !!A && !!((D = l.views) != null && D.presetViews.value.some((z) => z.id === A)) ? ex(s, A) : null;
    });
    dn(_v, { id: s, isTabpanel: m(() => d.value !== null) });
    const u = R(!1), f = R(!0), b = ta("controls"), h = ta("shellRoot"), { focusSearchOrRoot: p, focusAfterFiltersCleared: x } = rx(
      h,
      b,
      () => i.value.tableLabel
    );
    function y() {
      u.value = !u.value, r("toggle-filter-panel");
    }
    function k() {
      f.value = !f.value, r("toggle-filter-bar", f.value);
    }
    n({ toggleFilterPanel: y });
    const $ = m(
      () => l.skeletonColumns ?? (l.columnSettings && l.columnSettings.settingsItems.value.filter((A) => A.visible).length || void 0) ?? 5
    ), S = m(() => l.skeletonRows ?? l.query.state.pageSize), T = m(
      () => l.markSearchStale && l.query.searchPending.value && !l.loading
    ), I = m(
      () => {
        var A, E;
        return l.showControls && (l.showFilter || ((A = l.permissions) == null ? void 0 : A.canSaveView) !== !1 || ((E = l.permissions) == null ? void 0 : E.canShareView) !== !1 || a("controls-info") || a("controls-actions") || a("filter"));
      }
    );
    return (A, E) => (c(), g(de, null, [
      v("div", {
        ref_key: "shellRoot",
        ref: h,
        "data-table-shell-root": "",
        class: "w-full flex flex-col flex-1 min-h-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-royalblue",
        "aria-busy": e.loading || void 0
      }, [
        e.showTopbar ? (c(), W(nx, {
          key: 0,
          "search-placeholder": e.searchPlaceholder,
          "show-search": e.showSearch,
          "search-debounce": e.searchDebounce,
          "show-view-selector": e.showViewSelector,
          "tab-dropdowns": e.tabDropdowns,
          onRenameView: E[0] || (E[0] = (D) => r("rename-view", D)),
          onDeleteView: E[1] || (E[1] = (D) => r("delete-view", D)),
          onSetDefault: E[2] || (E[2] = (D) => r("set-default", D)),
          onTabRequested: E[3] || (E[3] = (D, z) => r("tab-requested", D, z)),
          onTabReordered: E[4] || (E[4] = (D, z) => r("tab-reordered", D, z))
        }, null, 8, ["search-placeholder", "show-search", "search-debounce", "show-view-selector", "tab-dropdowns"])) : w("", !0),
        v("div", {
          class: C([
            "flex flex-col flex-1 min-h-0 bg-white dark:bg-(--colors-background-black-default) shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] overflow-hidden",
            e.showTopbar ? I.value ? "rounded-b-xl rounded-tr-xl" : "rounded-b-xl" : "rounded-xl",
            // -mt-px pulls this card up 1px over the tabs row above so its own top border sits
            // underneath the tabs' bottom edge instead of showing as a seam; pt-px compensates
            // so the card's own content doesn't shift up with it.
            e.bordered && "border border-(--colors-border-base-soft) dark:border-(--colors-border-base) -mt-px pt-px"
          ])
        }, [
          I.value ? (c(), W(ax, {
            key: 0,
            ref_key: "controls",
            ref: b,
            "is-filter-panel-open": u.value,
            "is-filter-bar-visible": f.value,
            "show-filter": e.showFilter,
            bordered: !e.bordered,
            onFocusFallback: L(p),
            onToggleFilterPanel: y,
            onToggleFilterBar: k,
            onSaveView: E[5] || (E[5] = (D) => r("save-view")),
            onShareView: E[6] || (E[6] = (D) => r("share-view"))
          }, sa({ _: 2 }, [
            A.$slots.filter ? {
              name: "filter",
              fn: ve(() => [
                Ae(A.$slots, "filter")
              ]),
              key: "0"
            } : void 0,
            A.$slots["controls-info"] ? {
              name: "controls-info",
              fn: ve(() => [
                Ae(A.$slots, "controls-info")
              ]),
              key: "1"
            } : void 0,
            A.$slots["controls-actions"] ? {
              name: "controls-actions",
              fn: ve(() => [
                Ae(A.$slots, "controls-actions")
              ]),
              key: "2"
            } : void 0
          ]), 1032, ["is-filter-panel-open", "is-filter-bar-visible", "show-filter", "bordered", "onFocusFallback"])) : w("", !0),
          te(At, {
            "enter-active-class": "transition-all duration-200 ease-out overflow-hidden",
            "enter-from-class": "max-h-0 opacity-0",
            "enter-to-class": "max-h-[600px] opacity-100",
            "leave-active-class": "transition-all duration-150 ease-in overflow-hidden",
            "leave-from-class": "max-h-[600px] opacity-100",
            "leave-to-class": "max-h-0 opacity-0"
          }, {
            default: ve(() => [
              u.value ? (c(), g("div", R8, [
                Ae(A.$slots, "filter-panel", {
                  close: () => u.value = !1
                })
              ])) : w("", !0)
            ]),
            _: 3
          }),
          te(At, {
            "enter-active-class": "transition-[max-height] duration-200 ease-out overflow-hidden",
            "enter-from-class": "max-h-0",
            "enter-to-class": "max-h-[100px]",
            "leave-active-class": "transition-[max-height] duration-150 ease-in overflow-hidden",
            "leave-from-class": "max-h-[100px]",
            "leave-to-class": "max-h-0"
          }, {
            default: ve(() => [
              f.value ? (c(), W(lx, {
                key: 0,
                bordered: !e.bordered,
                onEditFilter: E[7] || (E[7] = (D) => r("edit-filter", D)),
                onLastFilterRemoved: L(x)
              }, null, 8, ["bordered", "onLastFilterRemoved"])) : w("", !0)
            ]),
            _: 1
          }),
          v("div", {
            id: L(s),
            role: d.value ? "tabpanel" : void 0,
            "aria-labelledby": d.value ?? void 0,
            class: C(["flex-1 overflow-x-hidden min-h-0 transition-opacity", T.value && "opacity-50"]),
            "aria-busy": T.value || void 0,
            "data-testid": "table-shell-body"
          }, [
            e.loading ? (c(), W(iP, {
              key: 0,
              columns: $.value,
              rows: S.value
            }, null, 8, ["columns", "rows"])) : Ae(A.$slots, "table", { key: 1 })
          ], 10, B8),
          e.loading || L(a)("pagination") ? (c(), g("div", M8, [
            e.loading ? (c(), g("div", D8, [
              E[9] || (E[9] = v("div", { class: "flex items-center gap-3" }, [
                v("div", { class: "skeleton h-1.5 w-36 rounded-full" }),
                v("div", { class: "skeleton h-1.5 w-11 rounded-full" })
              ], -1)),
              v("div", z8, [
                (c(), g(de, null, Re(5, (D) => v("div", {
                  key: `skeleton-page-${D}`,
                  class: "skeleton size-7 rounded-md"
                })), 64))
              ])
            ])) : Ae(A.$slots, "pagination", { key: 1 })
          ])) : w("", !0)
        ], 2)
      ], 8, E8),
      e.columnSettings ? (c(), W(L(A8), {
        key: 0,
        modelValue: e.columnSettings.drawerOpen.value,
        "onUpdate:modelValue": E[8] || (E[8] = (D) => e.columnSettings.drawerOpen.value = D),
        columns: e.columnSettings.settingsItems.value,
        "default-columns": e.columnSettings.defaultSettingsItems.value,
        "column-order": e.columnSettings.order.value,
        labels: e.columnSettings.labels.value,
        onSave: e.columnSettings.handleSave,
        onReset: e.columnSettings.handleReset
      }, null, 8, ["modelValue", "columns", "default-columns", "column-order", "labels", "onSave", "onReset"])) : w("", !0)
    ], 64));
  }
}), O8 = {
  key: 0,
  class: "border-b border-gainsboro dark:border-(--colors-border-base)"
}, Vq = /* @__PURE__ */ ye({
  __name: "TableHeader",
  props: {
    showTopbar: { type: Boolean, default: !0 },
    showControls: { type: Boolean, default: !0 },
    showFilter: { type: Boolean, default: !0 },
    searchPlaceholder: { default: "Search..." },
    showSearch: { type: Boolean, default: !0 },
    searchDebounce: { default: Cs },
    showViewSelector: { type: Boolean, default: !1 },
    tabDropdowns: { default: () => [] }
  },
  emits: ["rename-view", "delete-view", "set-default", "save-view", "share-view", "toggle-filter-panel", "edit-filter", "tab-requested"],
  setup(e, { expose: n, emit: t }) {
    const a = t, l = R(!1), r = R(!0), o = ta("controls"), i = ta("headerRoot"), s = ir(), { focusSearchOrRoot: d, focusAfterFiltersCleared: u } = rx(
      i,
      o,
      () => s.value.tableLabel
    );
    function f() {
      l.value = !l.value, a("toggle-filter-panel");
    }
    function b() {
      r.value = !r.value;
    }
    return n({ toggleFilterPanel: f }), (h, p) => (c(), g("div", {
      ref_key: "headerRoot",
      ref: i,
      class: "flex flex-col focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-royalblue"
    }, [
      e.showTopbar ? (c(), W(nx, {
        key: 0,
        "search-placeholder": e.searchPlaceholder,
        "show-search": e.showSearch,
        "search-debounce": e.searchDebounce,
        "show-view-selector": e.showViewSelector,
        "tab-dropdowns": e.tabDropdowns,
        onRenameView: p[0] || (p[0] = (x) => a("rename-view", x)),
        onDeleteView: p[1] || (p[1] = (x) => a("delete-view", x)),
        onSetDefault: p[2] || (p[2] = (x) => a("set-default", x)),
        onTabRequested: p[3] || (p[3] = (x, y) => a("tab-requested", x, y))
      }, null, 8, ["search-placeholder", "show-search", "search-debounce", "show-view-selector", "tab-dropdowns"])) : w("", !0),
      e.showControls ? (c(), W(ax, {
        key: 1,
        ref_key: "controls",
        ref: o,
        "is-filter-panel-open": l.value,
        "is-filter-bar-visible": r.value,
        "show-filter": e.showFilter,
        onFocusFallback: L(d),
        onToggleFilterPanel: f,
        onToggleFilterBar: b,
        onSaveView: p[4] || (p[4] = (x) => a("save-view")),
        onShareView: p[5] || (p[5] = (x) => a("share-view"))
      }, sa({ _: 2 }, [
        h.$slots.filter ? {
          name: "filter",
          fn: ve(() => [
            Ae(h.$slots, "filter")
          ]),
          key: "0"
        } : void 0,
        h.$slots["controls-info"] ? {
          name: "controls-info",
          fn: ve(() => [
            Ae(h.$slots, "controls-info")
          ]),
          key: "1"
        } : void 0,
        h.$slots["controls-actions"] ? {
          name: "controls-actions",
          fn: ve(() => [
            Ae(h.$slots, "controls-actions")
          ]),
          key: "2"
        } : void 0
      ]), 1032, ["is-filter-panel-open", "is-filter-bar-visible", "show-filter", "onFocusFallback"])) : w("", !0),
      te(At, {
        "enter-active-class": "transition-all duration-200 ease-out overflow-hidden",
        "enter-from-class": "max-h-0 opacity-0",
        "enter-to-class": "max-h-[600px] opacity-100",
        "leave-active-class": "transition-all duration-150 ease-in overflow-hidden",
        "leave-from-class": "max-h-[600px] opacity-100",
        "leave-to-class": "max-h-0 opacity-0"
      }, {
        default: ve(() => [
          l.value ? (c(), g("div", O8, [
            Ae(h.$slots, "filter-panel", {
              close: () => l.value = !1
            })
          ])) : w("", !0)
        ]),
        _: 3
      }),
      te(At, {
        "enter-active-class": "transition-[max-height] duration-200 ease-out overflow-hidden",
        "enter-from-class": "max-h-0",
        "enter-to-class": "max-h-[100px]",
        "leave-active-class": "transition-[max-height] duration-150 ease-in overflow-hidden",
        "leave-from-class": "max-h-[100px]",
        "leave-to-class": "max-h-0"
      }, {
        default: ve(() => [
          r.value ? (c(), W(lx, {
            key: 0,
            onEditFilter: p[6] || (p[6] = (x) => a("edit-filter", x)),
            onLastFilterRemoved: L(u)
          }, null, 8, ["onLastFilterRemoved"])) : w("", !0)
        ]),
        _: 1
      })
    ], 512));
  }
});
function Nq(e = {}) {
  const n = R(e.initialViews ?? []), t = m(() => n.value.filter((d) => d.isPreset)), a = m(() => n.value.filter((d) => !d.isPreset));
  function l(d) {
    n.value.push(d);
  }
  function r(d, u) {
    const f = n.value.findIndex((b) => b.id === d);
    f !== -1 && (n.value[f] = { ...n.value[f], ...u });
  }
  function o(d) {
    n.value = n.value.filter((u) => u.id !== d);
  }
  function i(d) {
    n.value.forEach((u) => {
      u.isDefault = u.id === d;
    });
  }
  function s(d) {
    const u = new Map(d.map((h, p) => [h, p])), f = n.value.filter((h) => h.isPreset).sort(
      (h, p) => (u.get(h.id) ?? Number.MAX_SAFE_INTEGER) - (u.get(p.id) ?? Number.MAX_SAFE_INTEGER)
    ), b = n.value.filter((h) => !h.isPreset);
    n.value = [...f, ...b];
  }
  return {
    views: n,
    presetViews: t,
    savedViews: a,
    addView: l,
    updateView: r,
    removeView: o,
    setDefault: i,
    reorderViews: s
  };
}
const wb = 10, P8 = 30, F8 = 900;
function Hq() {
  function e() {
    return typeof window > "u" ? wb : window.innerHeight >= F8 ? P8 : wb;
  }
  const n = R(e());
  function t() {
    n.value = e();
  }
  return ct(() => {
    n.value = e(), window.addEventListener("resize", t, { passive: !0 });
  }), kt(() => {
    window.removeEventListener("resize", t);
  }), { pageSize: n };
}
function jq(e) {
  const { defaultVisibility: n, defaultOrder: t = [] } = e, a = e.defaultPinning ?? {
    left: Pt(e.columns).filter((O) => O.pinned).map((O) => O.key),
    right: []
  }, l = m(
    () => new Set(
      Pt(e.columns).filter((O) => O.disabled || O.alwaysVisible).map((O) => O.key)
    )
  ), r = m(() => [...l.value]), o = (O) => l.value.has(O), i = Ha(
    n ?? Object.fromEntries(Pt(e.columns).map((O) => [O.key, O.visible ?? !0]))
  ), s = Array.from(/* @__PURE__ */ new Set([...r.value, ...a.left])), d = R({
    left: s,
    right: [...a.right]
  }), u = R([...t]), f = R(!1), b = (O) => {
    var P;
    return ((P = d.value.left) == null ? void 0 : P.includes(O)) ?? !1;
  }, h = m(
    () => Pt(e.columns).filter((O) => (o(O.key) || (i[O.key] ?? !0)) && (o(O.key) || b(O.key))).length
  ), p = m(() => h.value >= jr);
  function x(O) {
    return b(O) || !p.value;
  }
  const y = m(() => Pt(e.columns).map((O) => ({
    ...O,
    visible: i[O.key] ?? !0,
    pinned: b(O.key)
  }))), k = m(() => {
    const O = n ?? Object.fromEntries(Pt(e.columns).map((V) => [V.key, V.visible ?? !0])), P = new Set(a.left);
    return Pt(e.columns).map((V) => ({
      ...V,
      visible: O[V.key] ?? !0,
      pinned: P.has(V.key)
    }));
  }), $ = m(() => Pt(e.labels) ?? {});
  function S() {
    f.value = !0;
  }
  function T() {
    f.value = !1;
  }
  function I(O) {
    for (const G of O)
      i[G.key] = o(G.key) ? !0 : G.visible;
    const P = [], V = [], M = [], B = [];
    for (const G of O)
      o(G.key) ? P.push(G.key) : G.visible ? G.pinned ? V.push(G.key) : M.push(G.key) : B.push(G.key);
    u.value = [...P, ...V, ...M, ...B, ...e.trailingColumns ?? []];
    const q = new Set(Pt(e.columns).map((G) => G.key)), N = (d.value.left ?? []).filter((G) => !q.has(G));
    d.value = {
      left: [...N, ...P, ...V],
      right: [...d.value.right ?? []]
    };
  }
  function A() {
    const O = n ?? Object.fromEntries(Pt(e.columns).map((V) => [V.key, V.visible ?? !0]));
    Object.keys(i).forEach((V) => {
      i[V] = o(V) ? !0 : O[V] ?? !0;
    }), u.value = [...t];
    const P = Array.from(/* @__PURE__ */ new Set([...r.value, ...a.left]));
    d.value = { left: P, right: [...a.right] };
  }
  function E() {
    return u.value.length > 0 ? [...u.value] : [...Pt(e.columns).map((O) => O.key), ...e.trailingColumns ?? []];
  }
  function D(O) {
    if (b(O) || !x(O)) return;
    const P = [...d.value.left ?? [], O];
    d.value = { ...d.value, left: P };
    const V = new Set(P), M = E().filter((q) => q !== O);
    let B = -1;
    for (let q = 0; q < M.length; q++)
      V.has(M[q]) && (B = q);
    M.splice(B + 1, 0, O), u.value = M;
  }
  function z(O) {
    o(O) || (d.value = {
      ...d.value,
      left: (d.value.left ?? []).filter((P) => P !== O)
    });
  }
  function Y(O, P) {
    if (O.length !== P.length) return !1;
    for (let V = 0; V < O.length; V++) if (O[V] !== P[V]) return !1;
    return !0;
  }
  function le(O) {
    const P = e.trailingColumns ?? [], V = new Set(P), M = O.filter((G) => !V.has(G)), B = [...M, ...P];
    Y(B, u.value) || (u.value = B);
    const q = new Set(d.value.left ?? []), N = M.filter((G) => q.has(G));
    Y(N, d.value.left ?? []) || (d.value = { ...d.value, left: N });
  }
  function ne(O) {
    const P = new Set(Pt(e.columns).map((G) => G.key)), V = O.filter((G) => P.has(G));
    if (V.length <= jr) return O;
    const M = V.filter((G) => o(G)), B = V.filter((G) => !o(G)), q = Math.max(0, jr - M.length), N = /* @__PURE__ */ new Set([...M, ...B.slice(0, q)]);
    return O.filter((G) => !P.has(G) || N.has(G));
  }
  function re(O) {
    const P = ne(O.left ?? []), V = O.right ?? [], M = d.value.left ?? [], B = d.value.right ?? [];
    Y(P, M) && Y(V, B) || (d.value = { left: [...P], right: [...V] });
  }
  return {
    // State
    visibility: i,
    pinning: d,
    order: u,
    drawerOpen: f,
    // Computed
    settingsItems: y,
    defaultSettingsItems: k,
    labels: $,
    isPinned: b,
    isFrozenLimitReached: p,
    canPinColumn: x,
    // Actions
    openDrawer: S,
    closeDrawer: T,
    handleSave: I,
    handleReset: A,
    pinColumn: D,
    unpinColumn: z,
    setOrder: le,
    setPinning: re
  };
}
const V8 = {
  "data-testid": "filter-field-picker",
  class: "flex min-h-0 flex-col"
}, N8 = {
  role: "status",
  "aria-live": "polite",
  class: "sr-only",
  "data-testid": "filter-field-picker-status"
}, H8 = {
  class: "flex min-h-0 flex-col pb-2",
  "data-testid": "filter-field-picker-content"
}, j8 = ["aria-label"], W8 = ["data-empty-reason"], ox = /* @__PURE__ */ ye({
  __name: "FilterFieldPicker",
  props: {
    fields: {},
    groups: { default: () => [] },
    activeGroup: { default: void 0 },
    strictGroups: { type: Boolean, default: !1 },
    searchQuery: { default: "" },
    searchPlaceholder: {},
    searchLabel: { default: void 0 },
    searchClearLabel: { default: "Clear search" },
    groupsLabel: { default: void 0 },
    groupAriaLabel: { default: void 0 },
    listLabel: {},
    selectedKey: { default: void 0 },
    selectable: { type: Boolean, default: !0 },
    noResultsLabel: { default: void 0 },
    resultsCountLabel: { type: [String, Function], default: "{count} results" },
    noFieldsLabel: { default: void 0 },
    emptyGroupLabel: { default: void 0 }
  },
  emits: ["select", "update:activeGroup", "update:searchQuery"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = R(null), o = R(null), i = m(() => {
      let E = a.fields;
      return a.groups.length && a.activeGroup && (E = E.filter((D) => D.group === a.activeGroup || !D.group && !a.strictGroups)), a.searchQuery.trim() && (E = E.filter((D) => Ku(D.label, a.searchQuery))), E;
    }), s = m(() => a.searchQuery.trim() ? a.noResultsLabel : a.fields.length ? a.emptyGroupLabel ?? a.noFieldsLabel : a.noFieldsLabel), d = m(() => a.searchQuery.trim() ? "no-results" : a.fields.length ? "empty-group" : "no-fields"), { focusedIndex: u, handleRovingKeydown: f, handleSearchFieldKeydown: b, clampFocusedIndex: h } = go(), p = m(() => i.value.findIndex((E) => E.key === a.selectedKey));
    $e(
      [p, () => i.value.length],
      ([E, D]) => {
        E >= 0 ? u.value = E : h(D);
      },
      { immediate: !0 }
    );
    function x(E) {
      return !a.selectable || !!E.disabled;
    }
    function y(E) {
      x(E) || l("select", E.key);
    }
    function k(E, D) {
      return {
        role: "option",
        "aria-selected": E.key === a.selectedKey,
        tabindex: D === u.value ? 0 : -1,
        "data-listbox-index": D,
        onClick: () => y(E),
        onKeydown: ht(Je(() => y(E), ["self", "prevent"]), ["enter", "space"]),
        onFocus: () => {
          u.value = D;
        }
      };
    }
    function $(E) {
      f(E, i.value.length, o.value);
    }
    function S(E) {
      if (!(E.target instanceof HTMLInputElement)) return;
      const D = p.value;
      b(E, i.value.length, o.value, D >= 0 ? { downIndex: D, upIndex: D } : {});
    }
    function T() {
      var E;
      return ((E = r.value) == null ? void 0 : E.focusSearch()) ?? !1;
    }
    function I(E = u.value) {
      var z;
      const D = (z = o.value) == null ? void 0 : z.querySelector(`[data-listbox-index="${E}"]`);
      return D ? (u.value = E, D.focus({ preventScroll: !0 }), D.scrollIntoView({ block: "nearest" }), !0) : !1;
    }
    function A(E) {
      const D = i.value.findIndex((z) => z.key === E);
      return D >= 0 && I(D);
    }
    return n({ focusSearch: T, focusOption: I, focusField: A }), (E, D) => (c(), g("div", V8, [
      te(vl, {
        ref_key: "headerRef",
        ref: r,
        class: "shrink-0",
        "show-search": "",
        "search-query": e.searchQuery,
        "search-placeholder": e.searchPlaceholder,
        "search-label": e.searchLabel ?? e.searchPlaceholder,
        "search-clear-label": e.searchClearLabel,
        "group-buttons": e.groups,
        "active-group": e.activeGroup,
        "group-label-left": e.groupsLabel,
        "group-aria-label": e.groupAriaLabel,
        onKeydown: S,
        "onUpdate:searchQuery": D[0] || (D[0] = (z) => l("update:searchQuery", z)),
        "onUpdate:activeGroup": D[1] || (D[1] = (z) => l("update:activeGroup", z))
      }, null, 8, ["search-query", "search-placeholder", "search-label", "search-clear-label", "group-buttons", "active-group", "group-label-left", "group-aria-label"]),
      v("span", N8, j(i.value.length ? L(as)(e.resultsCountLabel, i.value.length) : s.value), 1),
      v("div", H8, [
        i.value.length ? (c(), g("div", {
          key: 0,
          ref_key: "listboxRef",
          ref: o,
          role: "listbox",
          "aria-label": e.listLabel,
          class: "flex min-h-0 flex-col overflow-y-auto px-2 py-1.5",
          "data-testid": "filter-field-picker-list",
          onKeydown: $
        }, [
          (c(!0), g(de, null, Re(i.value, (z, Y) => (c(), W(en, Fe({
            key: z.key
          }, { ref_for: !0 }, k(z, Y), {
            type: "two-icons",
            label: z.label,
            icon: z.icon,
            selected: z.key === e.selectedKey,
            "aria-disabled": x(z),
            description: z.disabled ? z.disabledReason : void 0,
            class: "shrink-0",
            "data-testid": `filter-field-picker-option-${z.key}`
          }), null, 16, ["label", "icon", "selected", "aria-disabled", "description", "data-testid"]))), 128))
        ], 40, j8)) : s.value ? (c(), g("div", {
          key: 1,
          "data-testid": "filter-field-picker-empty",
          "data-empty-reason": d.value,
          class: "flex flex-col items-center justify-center px-4 py-6 text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"
        }, j(s.value), 9, W8)) : w("", !0)
      ])
    ]));
  }
}), q8 = ["id", "aria-label", "data-size"], U8 = {
  key: 0,
  "data-testid": "filter-step-list",
  class: "flex min-h-0 flex-col"
}, G8 = { class: "flex min-h-0 flex-col pb-2" }, K8 = ["aria-multiselectable", "aria-label"], Y8 = {
  key: 0,
  "data-testid": "filter-select-all",
  class: "shrink-0 border-b border-(--border-border-base-soft) px-2 pt-2 pb-[calc(--spacing(2)-1px)] dark:border-(--colors-border-base)"
}, J8 = {
  key: 1,
  class: "min-h-0 overflow-y-auto"
}, X8 = {
  key: 1,
  "data-testid": "filter-step-list-empty",
  class: "px-4 py-6 text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"
}, Z8 = {
  key: 1,
  class: "flex min-h-0 flex-col"
}, Q8 = { class: "flex min-h-0 flex-col overflow-y-auto pb-2" }, _8 = {
  key: 0,
  "data-testid": "filter-step-text",
  class: "flex flex-col gap-4 px-3 py-4"
}, eF = { "data-testid": "filter-text-validate-error" }, tF = ["aria-label"], nF = {
  key: 0,
  class: "text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-error-strong) dark:text-(--text-text-error)",
  role: "alert"
}, aF = ["aria-label"], lF = { class: "flex items-start gap-6" }, rF = {
  key: 0,
  class: "text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-error-strong) dark:text-(--text-text-error)",
  role: "alert"
}, No = 4, vr = 16, oF = 540, iF = 240, Wq = /* @__PURE__ */ ye({
  __name: "TableFilterSelector",
  props: {
    fields: {},
    fieldGroups: { default: () => [] },
    fieldGroupsLabel: { default: "" },
    triggerLabel: { default: "Filter" },
    triggerIconLeft: { default: void 0 },
    activeCount: { default: 0 },
    step1SearchPlaceholder: { default: "Search a filter…" },
    searchClearLabel: { default: "Clear search" },
    step1FooterLabel: { default: "Rechercher par :" },
    advancedFiltersLabel: { default: "Filters avancées" },
    advancedFiltersIcon: { default: "ri-equalizer-line" },
    viewAdvancedLabel: { default: "" },
    createAdvancedLabel: { default: "" },
    advancedDisabled: { type: Boolean, default: !1 },
    advancedDisabledTooltip: { default: "" },
    backLabel: { default: "Back" },
    confirmLabel: { default: "Confirm" },
    closeOnConfirm: { type: Boolean, default: !0 },
    dateRangeErrorLabel: { default: 'The "From" date must be before or equal to the "To" date.' },
    noResultsLabel: { default: "No results for" },
    noFieldResultsLabel: { default: "No field matches your search" },
    resultsCountLabel: { type: [String, Function], default: "{count} results" },
    selectedCountLabel: { type: Function, default: (e, n) => `${e} of ${n} selected` },
    noFieldsLabel: { default: "" },
    activeFilters: { default: () => ({}) },
    fieldsSelectable: { type: Boolean, default: !0 }
  },
  emits: ["apply", "apply-filter", "remove-filter", "advanced-filters", "view-advanced-filters", "create-advanced-filter"],
  setup(e, { expose: n, emit: t }) {
    var bn, Mt;
    const a = e, l = t, r = R(null), o = m(() => {
      var ce;
      return ((ce = r.value) == null ? void 0 : ce.$el) ?? null;
    }), { isOpen: i, dropdownRef: s, toggleDropdown: d, openDropdown: u, closeDropdown: f } = ar({
      onClose: Ot,
      ignoreSelectors: [
        '[data-testid="datepicker-dropdown-menu"]',
        '[data-testid="datepicker-dob-picker"]',
        '[data-testid="filter-selector-menu"]'
      ]
    }), b = R({}), h = R(null), p = R(null), x = R(null);
    function y() {
      var ef, tf;
      const ce = (ef = o.value) == null ? void 0 : ef.getBoundingClientRect();
      if (!ce) return;
      const be = typeof window < "u" ? window.innerWidth : ce.right, Ie = typeof window < "u" ? window.innerHeight : ce.bottom, Ue = ((tf = p.value) == null ? void 0 : tf.offsetWidth) ?? 0, sr = ce.left + ce.width / 2 > be / 2 ? ce.right - Ue : ce.left, $x = Math.max(vr, be - vr - Ue), $s = Ie - ce.bottom - No - vr, Qc = ce.top - No - vr, _c = $s < iF && Qc > $s;
      b.value = {
        position: "fixed",
        ..._c ? { bottom: `${Ie - ce.top + No}px` } : { top: `${ce.bottom + No}px` },
        left: `${Math.max(vr, Math.min(sr, $x))}px`,
        maxHeight: `${Math.min(oF, Math.max(_c ? Qc : $s, 0))}px`,
        zIndex: "350"
      };
    }
    function k() {
      typeof window > "u" || (window.addEventListener("scroll", y, !0), window.addEventListener("resize", y));
    }
    function $() {
      typeof window > "u" || (window.removeEventListener("scroll", y, !0), window.removeEventListener("resize", y));
    }
    $e(i, (ce) => {
      ce ? Ge(() => {
        var be;
        if (y(), k(), h.value) {
          Pe(h.value), h.value = null;
          return;
        }
        (be = x.value) != null && be.focusSearch() || Se();
      }) : $();
    }), yt($);
    function S(ce) {
      !i.value && (ce.key === "ArrowDown" || ce.key === "ArrowUp") && (ce.preventDefault(), u());
    }
    function T(ce) {
      if (i.value) {
        Pe(ce);
        return;
      }
      h.value = ce, setTimeout(d, 0);
    }
    n({ openDropdown: u, closeDropdown: f, openForField: T, triggerEl: o });
    function I(ce) {
      i.value && (ce.stopPropagation(), ce.preventDefault(), A.value === "value" ? ot() : (f(), Ge(() => {
        var be;
        return (be = o.value) == null ? void 0 : be.focus();
      })));
    }
    const A = R("field"), E = R(""), D = R(((Mt = (bn = a.fieldGroups) == null ? void 0 : bn[0]) == null ? void 0 : Mt.value) ?? "");
    $e(
      () => a.fieldGroups,
      (ce) => {
        ce != null && ce.length && (ce.some((be) => be.value === D.value) || (D.value = ce[0].value));
      },
      { immediate: !0 }
    );
    const z = R(null), Y = R(null), le = R(""), ne = R(/* @__PURE__ */ new Set()), re = R(""), O = R(null), P = R(null), V = R(""), M = R(""), B = m(
      () => z.value != null ? a.fields.find((ce) => ce.key === z.value) ?? null : null
    );
    function q(ce, be) {
      if (!ce) return null;
      const Ie = ce.split(/[/\\\-.]/), Ue = be.toLowerCase().split(/[/\\\-.]/), Lt = {};
      return Ue.forEach((Kn, sr) => {
        Lt[Kn] = parseInt(Ie[sr], 10);
      }), isNaN(Lt.yyyy) || isNaN(Lt.mm) || isNaN(Lt.dd) ? null : new Date(Lt.yyyy, (Lt.mm || 1) - 1, Lt.dd || 1);
    }
    const N = m(() => {
      var ce;
      return (ce = B.value) != null && ce.maxLength ? re.value.length <= B.value.maxLength : !0;
    }), G = m(() => {
      var Ie, Ue;
      if (((Ie = B.value) == null ? void 0 : Ie.type) !== "text") return null;
      const ce = (Ue = B.value) == null ? void 0 : Ue.validate;
      if (!ce) return null;
      const be = re.value.trim();
      return be.length === 0 ? null : ce(be);
    }), U = m(() => {
      const ce = B.value;
      if (!(!ce || ce.type !== "text")) {
        if (ce.maxLength && re.value.length > ce.maxLength)
          return ce.maxLengthErrorLabel ?? `Maximum ${ce.maxLength} characters`;
        if (G.value) return G.value;
      }
    }), K = qe(), ge = m(() => `${K}-text`), xe = m(() => `${K}-date-from`), X = m(() => `${K}-date-to`), ie = m(() => O.value == null || P.value == null ? !0 : O.value <= P.value), he = m(() => {
      var Ue;
      if (!V.value || !M.value) return !0;
      const ce = ((Ue = B.value) == null ? void 0 : Ue.dateFormat) ?? "dd/mm/yyyy", be = q(V.value, ce), Ie = q(M.value, ce);
      return !be || !Ie ? !0 : be <= Ie;
    }), oe = m(() => {
      var ce;
      return ((ce = B.value) == null ? void 0 : ce.type) ?? "list";
    }), Ce = m(
      () => A.value === "value" && B.value && oe.value !== "list" ? "m" : "l"
    ), H = m(() => ({ width: _u[Ce.value] }));
    $e(Ce, () => {
      i.value && Ge(y);
    });
    const Z = m(
      () => a.fields.map((ce) => ({
        key: ce.key,
        label: ce.label,
        icon: ce.icon,
        group: ce.group,
        disabled: ce.disabled,
        disabledReason: ce.disabledReason
      }))
    ), ee = m(() => !!a.viewAdvancedLabel && !!a.createAdvancedLabel), J = m(() => {
      const ce = a.step1FooterLabel;
      if (ee.value)
        return {
          type: "buttons-column",
          label: ce,
          buttons: [
            {
              label: a.createAdvancedLabel,
              variant: "primary",
              icon: "ri-add-line",
              ariaDisabled: a.advancedDisabled,
              testId: "create-advanced-filter-btn"
            },
            {
              label: a.viewAdvancedLabel,
              variant: "secondary",
              icon: a.advancedFiltersIcon,
              ariaDisabled: a.advancedDisabled,
              testId: "view-advanced-filters-btn"
            }
          ],
          description: a.advancedDisabled && a.advancedDisabledTooltip || void 0
        };
      if (!a.advancedFiltersLabel) return null;
      const be = {
        label: a.advancedFiltersLabel,
        variant: "secondary",
        icon: a.advancedFiltersIcon,
        testId: "advanced-filters-btn"
      };
      return ce ? { type: "label-button", label: ce, buttons: [be] } : { type: "button", buttons: [be] };
    });
    function F(ce) {
      ee.value ? ce === 0 ? vt() : ft() : Ze();
    }
    const _ = m(() => {
      if (!B.value || oe.value !== "list") return [];
      const ce = B.value.items ?? [], be = le.value.trim().toLowerCase();
      return be ? ce.filter((Ie) => Ie.label.toLowerCase().includes(be)) : ce;
    }), ue = m(() => {
      var ce;
      return (((ce = B.value) == null ? void 0 : ce.items) ?? []).length;
    }), se = m(() => {
      var Ie;
      const ce = ((Ie = B.value) == null ? void 0 : Ie.items) ?? [];
      return ce.some((Ue) => typeof Ue.count == "number") ? ce.reduce((Ue, Lt) => Ue + (typeof Lt.count == "number" ? Lt.count : 0), 0) : ue.value;
    }), Q = m(
      () => {
        var ce;
        return (((ce = B.value) == null ? void 0 : ce.items) ?? []).filter((be) => ne.value.has(be.id)).length;
      }
    ), ae = m(
      () => Q.value === ue.value && ue.value > 0
    ), Te = m(
      () => Q.value > 0 && Q.value < ue.value
    ), Le = R(null), {
      focusedIndex: pe,
      handleRovingKeydown: ke,
      clampFocusedIndex: fe,
      focusListboxOption: ze,
      handleSearchFieldKeydown: Ee
    } = go(), He = m(
      () => {
        var ce, be;
        return !((ce = B.value) != null && ce.single) && !le.value && (((be = B.value) == null ? void 0 : be.items) ?? []).length > 0;
      }
    ), Ke = m(
      () => (He.value ? 1 : 0) + _.value.length
    );
    $e(
      () => Ke.value,
      (ce) => fe(ce)
    ), $e(A, (ce) => {
      if (ce === "field") {
        const be = Y.value;
        Ge(() => {
          var Ie, Ue;
          be && ((Ie = x.value) != null && Ie.focusField(be)) || (Ue = x.value) != null && Ue.focusOption(0) || Se();
        });
      }
    });
    function et() {
      pe.value = 0, Ge(() => {
        ze(Le.value, 0), Se();
      });
    }
    function Se() {
      var be, Ie, Ue;
      if ((be = p.value) != null && be.contains(document.activeElement)) return;
      (Ue = ((Ie = p.value) == null ? void 0 : Ie.querySelector(
        'input:not([type="hidden"]):not([type="range"]), textarea, button'
      )) ?? p.value) == null || Ue.focus({ preventScroll: !0 });
    }
    function me(ce) {
      ke(ce, Ke.value, Le.value);
    }
    function Be(ce) {
      ce.target instanceof HTMLInputElement && Ee(ce, Ke.value, Le.value);
    }
    function Ye(ce, be, Ie) {
      return {
        role: "option",
        "aria-selected": be,
        tabindex: pe.value === ce ? 0 : -1,
        "data-listbox-index": ce,
        onClick: Ie,
        onKeydown: ht(Je(Ie, ["self", "prevent"]), ["enter", "space"]),
        onFocus: () => {
          pe.value = ce;
        }
      };
    }
    const Qe = m(
      () => Q.value > 0 ? a.selectedCountLabel(Q.value, ue.value) : ""
    ), bt = m(
      () => oe.value === "text" && (!N.value || !!G.value) || oe.value === "dateRange" && !he.value || oe.value === "range" && !ie.value
    ), jt = m(() => ({
      type: "buttons-inline",
      buttons: [
        { label: a.backLabel, variant: "secondary", icon: "ri-arrow-left-line", testId: "filter-back-btn" },
        { label: a.confirmLabel, variant: "primary", disabled: bt.value, testId: "filter-apply-btn" }
      ]
    }));
    function De(ce) {
      ce === 0 ? ot() : Oe();
    }
    function Pe(ce) {
      var Ue, Lt;
      const be = z.value === ce;
      z.value = ce, le.value = "";
      const Ie = (Ue = a.activeFilters) == null ? void 0 : Ue[ce];
      Ie ? (Ie.type === "in" ? ne.value = new Set(Ie.values) : ne.value = /* @__PURE__ */ new Set(), re.value = Ie.type === "equals" ? String(Ie.value) : "", O.value = Ie.type === "range" ? Ie.min : null, P.value = Ie.type === "range" ? Ie.max : null, V.value = Ie.type === "dateRange" ? Ie.from ?? "" : "", M.value = Ie.type === "dateRange" ? Ie.to ?? "" : "") : (ne.value = /* @__PURE__ */ new Set(), re.value = "", O.value = null, P.value = null, V.value = "", M.value = ""), A.value = "value", (!be || !((Lt = p.value) != null && Lt.contains(document.activeElement))) && et();
    }
    function We(ce) {
      a.fieldsSelectable && Pe(ce);
    }
    function ot() {
      Y.value = z.value, A.value = "field", z.value = null;
    }
    function St(ce) {
      var Ie;
      if ((Ie = B.value) != null && Ie.single) {
        ne.value = ne.value.has(ce) ? /* @__PURE__ */ new Set() : /* @__PURE__ */ new Set([ce]);
        return;
      }
      const be = new Set(ne.value);
      be.has(ce) ? be.delete(ce) : be.add(ce), ne.value = be;
    }
    function we() {
      var ce;
      ae.value ? ne.value = /* @__PURE__ */ new Set() : ne.value = new Set((((ce = B.value) == null ? void 0 : ce.items) ?? []).map((be) => be.id));
    }
    function Oe() {
      const ce = z.value, be = oe.value;
      if (be === "list")
        l("apply", ce, [...ne.value]);
      else if (be === "text") {
        if (G.value)
          return;
        re.value.trim() ? l("apply-filter", ce, { type: "equals", value: re.value.trim() }) : l("remove-filter", ce);
      } else be === "range" ? O.value != null || P.value != null ? l("apply-filter", ce, { type: "range", min: O.value, max: P.value }) : l("remove-filter", ce) : be === "dateRange" && (V.value || M.value ? l("apply-filter", ce, {
        type: "dateRange",
        from: V.value || null,
        to: M.value || null
      }) : l("remove-filter", ce));
      a.closeOnConfirm ? (f(), Ge(() => {
        var Ie;
        return (Ie = o.value) == null ? void 0 : Ie.focus();
      })) : ot();
    }
    function Ze() {
      l("advanced-filters"), f();
    }
    function ft() {
      a.advancedDisabled || (l("view-advanced-filters"), f());
    }
    function vt() {
      a.advancedDisabled || (l("create-advanced-filter"), f());
    }
    function Ot() {
      var ce, be;
      Y.value = null, A.value = "field", z.value = null, E.value = "", D.value = ((be = (ce = a.fieldGroups) == null ? void 0 : ce[0]) == null ? void 0 : be.value) ?? "", le.value = "", ne.value = /* @__PURE__ */ new Set(), re.value = "", O.value = null, P.value = null, V.value = "", M.value = "";
    }
    return (ce, be) => (c(), g("div", {
      ref_key: "dropdownRef",
      ref: s,
      class: "relative inline-block text-left dark:text-(--colors-text-white-default)",
      onKeydown: ht(I, ["escape"])
    }, [
      te(L(Me), {
        ref_key: "triggerButtonRef",
        ref: r,
        "data-testid": "filter-selector-trigger",
        size: "xs",
        variant: "secondary",
        "icon-left": e.triggerIconLeft,
        "dropdown-icon": "",
        "aria-expanded": L(i),
        "aria-controls": L(i) ? L(K) : void 0,
        "aria-haspopup": "dialog",
        onClick: L(d),
        onKeydown: S
      }, {
        default: ve(() => [
          nt(j(e.triggerLabel) + " ", 1),
          e.activeCount > 0 ? (c(), W(gt, {
            key: 0,
            "data-testid": "filter-active-badge",
            class: "ms-1.5",
            theme: "active",
            size: "sm",
            "badge-style": "circle",
            "text-only": "",
            value: e.activeCount
          }, null, 8, ["value"])) : w("", !0)
        ]),
        _: 1
      }, 8, ["icon-left", "aria-expanded", "aria-controls", "onClick"]),
      (c(), W(Nn, { to: "body" }, [
        te(At, {
          "enter-active-class": "transition duration-100 ease-out motion-reduce:transition-none",
          "enter-from-class": "transform scale-95 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100",
          "leave-active-class": "transition duration-75 ease-out motion-reduce:transition-none",
          "leave-from-class": "transform scale-100 opacity-100",
          "leave-to-class": "transform scale-95 opacity-0"
        }, {
          default: ve(() => [
            L(i) ? (c(), g("div", {
              key: 0,
              id: L(K),
              ref_key: "panelRef",
              ref: p,
              role: "dialog",
              "aria-label": e.triggerLabel,
              "data-testid": "filter-selector-menu",
              "data-size": Ce.value,
              "data-focus-trap-allow-outside": "",
              tabindex: "-1",
              style: je([H.value, b.value]),
              class: C([
                "flex max-h-[540px] max-w-[calc(100vw-2rem)] flex-col overflow-hidden focus-visible:outline-none",
                L(Za)
              ]),
              onKeydown: ht(I, ["escape"])
            }, [
              A.value === "field" ? (c(), g(de, { key: 0 }, [
                te(ox, {
                  ref_key: "pickerRef",
                  ref: x,
                  "active-group": D.value,
                  "onUpdate:activeGroup": be[0] || (be[0] = (Ie) => D.value = Ie),
                  "search-query": E.value,
                  "onUpdate:searchQuery": be[1] || (be[1] = (Ie) => E.value = Ie),
                  fields: Z.value,
                  groups: e.fieldGroups,
                  "groups-label": e.fieldGroupsLabel || void 0,
                  "group-aria-label": e.triggerLabel,
                  "search-placeholder": e.step1SearchPlaceholder,
                  "search-clear-label": e.searchClearLabel,
                  "list-label": e.step1SearchPlaceholder,
                  selectable: e.fieldsSelectable,
                  "no-results-label": e.noFieldResultsLabel,
                  "results-count-label": e.resultsCountLabel,
                  "no-fields-label": e.noFieldsLabel || void 0,
                  onSelect: We
                }, null, 8, ["active-group", "search-query", "fields", "groups", "groups-label", "group-aria-label", "search-placeholder", "search-clear-label", "list-label", "selectable", "no-results-label", "results-count-label", "no-fields-label"]),
                J.value ? (c(), W(pl, Fe({ key: 0 }, J.value, {
                  class: "shrink-0",
                  onButtonClick: F
                }), null, 16)) : w("", !0)
              ], 64)) : w("", !0),
              A.value === "value" && B.value ? (c(), g(de, { key: 1 }, [
                oe.value === "list" ? (c(), g("div", U8, [
                  te(vl, {
                    class: "shrink-0",
                    "label-left": B.value.label,
                    "label-right": Qe.value || void 0,
                    "show-search": "",
                    "search-query": le.value,
                    "search-placeholder": B.value.step2SearchPlaceholder ?? "Search…",
                    "search-label": B.value.step2SearchPlaceholder ?? "Search…",
                    "search-clear-label": e.searchClearLabel,
                    onKeydown: Be,
                    "onUpdate:searchQuery": be[2] || (be[2] = (Ie) => le.value = Ie)
                  }, null, 8, ["label-left", "label-right", "search-query", "search-placeholder", "search-label", "search-clear-label"]),
                  v("div", G8, [
                    Ke.value ? (c(), g("div", {
                      key: 0,
                      ref_key: "step2ListboxRef",
                      ref: Le,
                      role: "listbox",
                      "aria-multiselectable": !B.value.single,
                      "aria-label": B.value.label,
                      class: "flex min-h-0 flex-col",
                      onKeydown: me
                    }, [
                      He.value ? (c(), g("div", Y8, [
                        te(en, Fe(Ye(0, ae.value, we), {
                          type: "checkbox",
                          label: B.value.selectAllLabel ?? "Select all",
                          checked: ae.value,
                          indeterminate: Te.value,
                          count: se.value > 0 ? `(${se.value})` : void 0
                        }), null, 16, ["label", "checked", "indeterminate", "count"])
                      ])) : w("", !0),
                      _.value.length ? (c(), g("div", J8, [
                        v("div", {
                          class: C(["flex flex-col gap-0.5 px-2", He.value ? "pt-0.5 pb-0.5" : "py-1.5"])
                        }, [
                          (c(!0), g(de, null, Re(_.value, (Ie, Ue) => (c(), W(en, Fe({
                            key: Ie.id
                          }, { ref_for: !0 }, Ye(He.value ? Ue + 1 : Ue, ne.value.has(Ie.id), () => St(Ie.id)), {
                            class: "shrink-0",
                            type: "checkbox",
                            label: Ie.label,
                            checked: ne.value.has(Ie.id),
                            count: Ie.count !== void 0 ? `(${Ie.count})` : void 0,
                            "data-testid": `filter-item-${Ie.id}`
                          }), null, 16, ["label", "checked", "count", "data-testid"]))), 128))
                        ], 2)
                      ])) : w("", !0)
                    ], 40, K8)) : w("", !0),
                    !_.value.length && le.value ? (c(), g("div", X8, j(e.noResultsLabel) + ' "' + j(le.value) + '". ', 1)) : w("", !0)
                  ])
                ])) : (c(), g("div", Z8, [
                  te(vl, {
                    class: "shrink-0",
                    "label-left": B.value.label
                  }, null, 8, ["label-left"]),
                  v("div", Q8, [
                    oe.value === "text" ? (c(), g("div", _8, [
                      v("div", eF, [
                        te(L(Wt), {
                          id: ge.value,
                          modelValue: re.value,
                          "onUpdate:modelValue": be[3] || (be[3] = (Ie) => re.value = Ie),
                          "aria-label": B.value.label,
                          placeholder: B.value.placeholder ?? "",
                          error: U.value,
                          size: "md",
                          "full-width": ""
                        }, null, 8, ["id", "modelValue", "aria-label", "placeholder", "error"])
                      ])
                    ])) : oe.value === "range" ? (c(), g("div", {
                      key: 1,
                      "data-testid": "filter-step-range",
                      role: "group",
                      "aria-label": B.value.label,
                      class: "flex flex-col gap-4 px-3 py-4"
                    }, [
                      te(L(Uv), {
                        "min-value": O.value,
                        "onUpdate:minValue": be[4] || (be[4] = (Ie) => O.value = Ie),
                        "max-value": P.value,
                        "onUpdate:maxValue": be[5] || (be[5] = (Ie) => P.value = Ie),
                        min: B.value.rangeMin ?? 0,
                        max: B.value.rangeMax ?? 1e4,
                        step: B.value.rangeStep ?? 1,
                        "separator-label": B.value.rangeSeparatorLabel ?? "to",
                        "min-label": B.value.rangeMinLabel ?? "Minimum",
                        "max-label": B.value.rangeMaxLabel ?? "Maximum",
                        "clamp-input-to-bounds": B.value.rangeClampInputToBounds ?? !0,
                        "data-min": B.value.rangeDataMin ?? null,
                        "data-max": B.value.rangeDataMax ?? null,
                        "hint-label": B.value.rangeHintLabel ?? ""
                      }, null, 8, ["min-value", "max-value", "min", "max", "step", "separator-label", "min-label", "max-label", "clamp-input-to-bounds", "data-min", "data-max", "hint-label"]),
                      ie.value ? w("", !0) : (c(), g("p", nF, j(B.value.rangeErrorLabel ?? "Min value must be less than or equal to max value"), 1))
                    ], 8, tF)) : oe.value === "dateRange" ? (c(), g("div", {
                      key: 2,
                      "data-testid": "filter-step-date-range",
                      role: "group",
                      "aria-label": B.value.label,
                      class: "flex flex-col gap-4 px-3 py-4"
                    }, [
                      v("div", lF, [
                        te(L(xu), {
                          id: xe.value,
                          modelValue: V.value,
                          "onUpdate:modelValue": be[6] || (be[6] = (Ie) => V.value = Ie),
                          class: "min-w-0 flex-1",
                          label: B.value.dateFromLabel ?? "From",
                          placeholder: B.value.datePlaceholder,
                          format: B.value.dateFormat ?? "dd/mm/yyyy",
                          language: B.value.dateLanguage,
                          size: "md",
                          "full-width": ""
                        }, null, 8, ["id", "modelValue", "label", "placeholder", "format", "language"]),
                        te(L(xu), {
                          id: X.value,
                          modelValue: M.value,
                          "onUpdate:modelValue": be[7] || (be[7] = (Ie) => M.value = Ie),
                          class: "min-w-0 flex-1",
                          label: B.value.dateToLabel ?? "To",
                          placeholder: B.value.datePlaceholder,
                          format: B.value.dateFormat ?? "dd/mm/yyyy",
                          language: B.value.dateLanguage,
                          size: "md",
                          "full-width": ""
                        }, null, 8, ["id", "modelValue", "label", "placeholder", "format", "language"])
                      ]),
                      he.value ? w("", !0) : (c(), g("p", rF, j(e.dateRangeErrorLabel), 1))
                    ], 8, aF)) : w("", !0)
                  ])
                ])),
                te(pl, Fe(jt.value, {
                  class: "shrink-0",
                  onButtonClick: De
                }), null, 16)
              ], 64)) : w("", !0)
            ], 46, q8)) : w("", !0)
          ]),
          _: 1
        })
      ]))
    ], 544));
  }
}), sF = /* @__PURE__ */ ye({
  __name: "TablePanel",
  props: {
    roundTop: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", {
      class: C([
        "min-w-0 border border-(--border-border-base-soft) overflow-x-auto shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)]",
        e.roundTop ? "rounded-xl" : "rounded-b-xl"
      ])
    }, [
      Ae(n.$slots, "default")
    ], 2));
  }
}), dF = {
  key: 0,
  class: "border-b border-(--border-border-base-soft)"
}, uF = {
  key: 1,
  "data-testid": "records-table-header",
  class: "flex items-center justify-between gap-4 px-3 py-3 border-b border-(--border-border-base-soft)"
}, cF = { class: "flex items-center gap-2.5 min-w-0" }, fF = {
  key: 0,
  class: "shrink-0 size-12 flex items-center justify-center bg-white border border-(--border-border-base-medium) rounded-lg"
}, hF = { class: "flex flex-col gap-px min-w-0" }, bF = {
  key: 0,
  class: "text-base font-medium leading-6 text-(--text-text-heading) truncate"
}, gF = {
  key: 1,
  class: "text-base font-normal leading-6 text-(--text-text-body) truncate"
}, mF = {
  key: 0,
  "data-testid": "records-table-actions",
  class: "flex items-center gap-2 shrink-0"
}, pF = ["onClick"], vF = { class: "flex items-center gap-1" }, xF = {
  key: 0,
  class: "ri-expand-up-down-line text-xs"
}, yF = { key: 0 }, kF = ["colspan"], Cb = "sticky right-0 z-10 shadow-[inset_1px_0_0_var(--border-border-base-soft),-2px_0_4px_-2px_rgba(0,0,0,0.06)]", wF = "[transform:translateZ(0)]", qq = /* @__PURE__ */ ye({
  __name: "RecordsTable",
  props: {
    columns: {},
    data: {},
    emptyText: { default: "" },
    tableClass: {},
    title: {},
    subtitle: {},
    icon: {},
    minWidth: {},
    layout: { default: "fixed" }
  },
  setup(e) {
    const n = e, t = tn(), a = R(null), l = R("asc"), r = (i) => {
      a.value === i ? l.value = l.value === "asc" ? "desc" : "asc" : (a.value = i, l.value = "asc");
    }, o = m(() => {
      if (!a.value) return n.data;
      const i = n.columns.find((s) => s.id === a.value);
      return i != null && i.sortable ? [...n.data].sort((s, d) => {
        const u = i.sortBy(s), f = i.sortBy(d), b = String(u).localeCompare(String(f), void 0, { numeric: !0 });
        return l.value === "asc" ? b : -b;
      }) : n.data;
    });
    return (i, s) => (c(), W(sF, null, {
      default: ve(() => [
        v("div", {
          style: je(e.minWidth ? { minWidth: `max(100%, ${e.minWidth}px)` } : void 0)
        }, [
          L(t)("header") ? (c(), g("div", dF, [
            Ae(i.$slots, "header")
          ])) : e.title || e.subtitle || e.icon || L(t)("actions") ? (c(), g("div", uF, [
            v("div", cF, [
              e.icon ? (c(), g("div", fF, [
                v("i", {
                  class: C([e.icon, "text-[length:var(--size-5xl)] leading-none text-(--text-text-body)"]),
                  "aria-hidden": "true"
                }, null, 2)
              ])) : w("", !0),
              v("div", hF, [
                e.title ? (c(), g("span", bF, j(e.title), 1)) : w("", !0),
                e.subtitle ? (c(), g("span", gF, j(e.subtitle), 1)) : w("", !0)
              ])
            ]),
            L(t)("actions") ? (c(), g("div", mF, [
              Ae(i.$slots, "actions")
            ])) : w("", !0)
          ])) : w("", !0),
          v("table", {
            class: C(["w-full", e.layout === "auto" ? "table-auto" : "table-fixed", e.tableClass])
          }, [
            v("thead", null, [
              v("tr", null, [
                (c(!0), g(de, null, Re(e.columns, (d) => (c(), g("th", {
                  key: d.id,
                  class: C([
                    "h-11 px-5 overflow-hidden text-left text-sm font-medium text-(--text-text-body) border-b border-(--border-border-base-medium) bg-white",
                    d.width,
                    d.sortable && "cursor-pointer select-none",
                    d.sticky && [Cb, wF]
                  ]),
                  onClick: (u) => d.sortable ? r(d.id) : void 0
                }, [
                  v("div", vF, [
                    nt(j(d.header) + " ", 1),
                    d.sortable ? (c(), g("i", xF)) : w("", !0)
                  ])
                ], 10, pF))), 128))
              ])
            ]),
            v("tbody", null, [
              o.value.length ? w("", !0) : (c(), g("tr", yF, [
                v("td", {
                  colspan: e.columns.length,
                  class: "h-14 px-5 text-sm text-center text-(--text-text-body)"
                }, j(e.emptyText), 9, kF)
              ])),
              (c(!0), g(de, null, Re(o.value, (d, u) => (c(), g("tr", {
                key: u,
                class: "border-b border-(--border-border-base-soft) last:border-b-0"
              }, [
                (c(!0), g(de, null, Re(e.columns, (f, b) => (c(), g("td", {
                  key: f.id,
                  class: C([
                    "h-14 px-5 overflow-hidden",
                    b === 0 && e.layout === "fixed" && "max-w-0",
                    f.sticky && ["bg-white", Cb]
                  ])
                }, [
                  (c(), W(it(() => f.cell(d))))
                ], 2))), 128))
              ]))), 128))
            ])
          ], 2)
        ], 4)
      ]),
      _: 3
    }));
  }
}), CF = { class: "w-full relative shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-t-[0px] rounded-b-3xl bg-white dark:bg-[var(--colors-background-black-default)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-[1px] box-border flex flex-col items-start text-left text-[14px] text-gray-200 dark:text-[var(--colors-text-white-default)] font-inter" }, SF = {
  key: 0,
  style: { width: "256px" }
}, $F = { class: "flex items-center justify-end gap-3 flex-shrink-0" }, IF = {
  key: 0,
  class: "skeleton h-9 w-32"
}, LF = {
  key: 1,
  class: "skeleton h-9 w-20"
}, TF = { class: "self-stretch overflow-x-auto" }, AF = {
  class: "flex items-start",
  style: { width: "100%", "min-width": "max-content", "min-height": "324px" }
}, EF = {
  key: 0,
  class: "flex flex-col items-start"
}, RF = {
  key: 2,
  class: "flex-1 bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start min-w-0",
  style: { "min-width": "0" }
}, BF = {
  key: 0,
  class: "self-stretch rounded-t-[0px] rounded-b-[12px] bg-white dark:bg-[var(--colors-background-black-default)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] flex items-center justify-between p-[20px] gap-5"
}, MF = ["data-testid"], DF = { class: "flex items-center justify-end gap-3 text-gray-200 dark:text-[var(--colors-text-white-default)] flex-shrink-0" }, zF = { class: "self-stretch overflow-x-auto" }, OF = {
  class: "flex items-start",
  style: { width: "100%", "min-width": "max-content", "min-height": "324px" }
}, PF = {
  key: 0,
  class: "flex flex-col items-start"
}, FF = { class: "w-14 h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-center justify-center py-0 px-[20px]" }, VF = { class: "flex items-center" }, NF = ["onClick"], HF = { class: "flex items-center gap-1 min-w-0" }, jF = ["title"], WF = ["src"], qF = ["onMousedown"], UF = { class: "flex-1 relative leading-[20px] overflow-hidden text-ellipsis whitespace-nowrap" }, GF = { class: "self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-start justify-center py-0 px-[20px] text-[14px] text-(--colors-text-body) dark:text-(--colors-text-white-default)" }, KF = { class: "flex items-center gap-1" }, YF = { class: "relative leading-[20px] font-medium" }, JF = {
  key: 2,
  class: "flex-1 bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start min-w-0",
  style: { "min-width": "0" }
}, XF = {
  key: 0,
  class: "self-stretch rounded-t-[0px] rounded-b-[12px] bg-white dark:bg-[var(--colors-background-black-default)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] flex items-center justify-between p-[20px] gap-5"
}, ZF = { class: "relative leading-[20px] dark:text-[var(--colors-text-white-default)]" }, QF = { class: "min-w-0 flex-1" }, _F = /* @__PURE__ */ ye({
  __name: "Table",
  props: {
    columns: {},
    rows: {},
    showCheckbox: { type: Boolean, default: !0 },
    title: { default: "Transactions" },
    searchPlaceholder: { default: "Search for transaction" },
    searchClearLabel: { default: "Clear search" },
    showSearch: { type: Boolean, default: !0 },
    showFilters: { type: Boolean, default: !0 },
    showAddButton: { type: Boolean, default: !0 },
    addButtonLabel: { default: "Add transaction" },
    showActions: { type: Boolean, default: !0 },
    rowActions: { type: [Array, Function], default: () => [
      { label: "Actions", icon: void 0, onClick: () => {
      } },
      { label: "Delete", icon: void 0, onClick: () => {
      }, isDelete: !0 }
    ] },
    enablePagination: { type: Boolean, default: !0 },
    itemsPerPage: { default: 10 },
    totalItems: { default: 1e3 },
    currentPage: { default: 1 },
    searchIcon: { default: void 0 },
    filtersIcon: { default: void 0 },
    actionsIcon: { default: void 0 },
    addButtonIconLeft: { default: void 0 },
    filterItems: { default: () => [
      { label: "All", onClick: () => {
      } },
      { label: "Completed", onClick: () => {
      } },
      { label: "Pending", onClick: () => {
      } },
      { label: "Failed", onClick: () => {
      } }
    ] },
    filterSections: { default: () => [] },
    headerActionsItems: { default: () => [
      { label: "Export CSV", onClick: () => {
      } },
      { label: "Export Excel", onClick: () => {
      } },
      { label: "Print", onClick: () => {
      } }
    ] },
    filtersLabel: { default: "Filters" },
    actionsLabel: { default: "Actions" },
    actionsColumnLabel: { default: "Actions" },
    filterResetLabel: { default: "Reset" },
    filterApplyLabel: { default: "Apply" },
    filterMenuWidth: { default: "280px" },
    paginationText: { type: Function, default: (e, n, t) => `Showing ${e}-${n} of ${t}` },
    wrap: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    serverSideSearch: { type: Boolean, default: !1 },
    serverSidePagination: { type: Boolean, default: !1 },
    searchDataTestId: { default: void 0 }
  },
  emits: ["search", "filter", "filter-apply", "filter-reset", "filter-change", "add", "action", "page-change", "selection-change"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => [
      {
        label: t.filterResetLabel,
        variant: "secondary",
        onClick: () => a("filter-reset"),
        keepOpen: !0
      },
      {
        label: t.filterApplyLabel,
        variant: "primary",
        onClick: () => {
          var B;
          const M = {};
          (B = t.filterSections) == null || B.forEach((q) => {
            M[q.id] = q.checked ?? q.switchChecked ?? !1;
          }), a("filter-apply", M);
        }
      }
    ]), r = R(""), o = R(/* @__PURE__ */ new Set()), i = R(null), s = R("asc"), d = R(t.currentPage);
    $e(
      () => t.currentPage,
      (M) => {
        t.serverSidePagination && M !== void 0 && (d.value = M);
      }
    );
    const u = R({}), f = R(!1), b = R(null), h = R(0), p = R(0), x = () => {
      const M = {};
      return t.columns.forEach((B) => {
        if (B.width) {
          const q = parseFloat(B.width);
          B.width.includes("px") ? M[B.key] = q : t.wrap || (M[B.key] = 200);
        } else t.wrap || (M[B.key] = 200);
      }), t.showActions && !t.wrap && (M.__actions__ = 150), M;
    };
    Object.keys(u.value).length === 0 && (u.value = x());
    const y = (M) => u.value[M] ? `${u.value[M]}px` : "200px", k = (M, B) => {
      if (f.value = !0, b.value = M, h.value = B.clientX, u.value[M])
        p.value = u.value[M];
      else {
        const N = B.target.closest(".bg-white.flex.flex-col");
        N ? p.value = N.offsetWidth : p.value = 200;
      }
      document.body.classList.add("resizing"), document.addEventListener("mousemove", $), document.addEventListener("mouseup", S), B.preventDefault(), B.stopPropagation();
    }, $ = (M) => {
      if (!f.value || !b.value) return;
      const B = M.clientX - h.value, q = p.value + B;
      q >= 50 && q <= 1e3 && (u.value[b.value] = q);
    }, S = () => {
      f.value = !1, b.value = null, document.body.classList.remove("resizing"), document.removeEventListener("mousemove", $), document.removeEventListener("mouseup", S);
    };
    $e(
      () => t.columns,
      () => {
        if (t.wrap) {
          const M = x();
          Object.keys(M).forEach((B) => {
            u.value[B] === void 0 && M[B] !== void 0 && (u.value[B] = M[B]);
          });
        } else {
          const M = t.columns.every((q) => u.value[q.key] !== void 0), B = !t.showActions || u.value.__actions__ !== void 0;
          if (!M || !B) {
            const q = x();
            Object.keys(q).forEach((N) => {
              u.value[N] === void 0 && q[N] !== void 0 && (u.value[N] = q[N]);
            });
          }
        }
      },
      { deep: !0 }
    ), $e(
      () => t.wrap,
      () => {
        u.value = x();
      }
    );
    const T = m(() => {
      let M = t.rows;
      if (r.value && t.showSearch && !t.serverSideSearch && (M = M.filter(
        (B) => JSON.stringify(B).toLowerCase().includes(r.value.toLowerCase())
      )), i.value && (M = [...M].sort((B, q) => {
        const N = B[i.value], G = q[i.value];
        return N == null && G == null ? 0 : N == null ? 1 : G == null ? -1 : N < G ? s.value === "asc" ? -1 : 1 : N > G ? s.value === "asc" ? 1 : -1 : 0;
      })), t.enablePagination && !t.serverSidePagination) {
        const B = (d.value - 1) * t.itemsPerPage, q = B + t.itemsPerPage;
        return M.slice(B, q);
      }
      return M;
    }), I = m(() => {
      if (!t.enablePagination) return 1;
      if (t.serverSidePagination) return Math.ceil((t.totalItems ?? 0) / t.itemsPerPage);
      if (t.serverSideSearch) return Math.ceil(t.rows.length / t.itemsPerPage);
      const M = t.rows.filter(
        (B) => !r.value || JSON.stringify(B).toLowerCase().includes(r.value.toLowerCase())
      );
      return Math.ceil(M.length / t.itemsPerPage);
    }), A = (M) => {
      d.value = 1, a("search", M);
    }, E = (M) => {
      M.sortable && (i.value === M.key ? s.value = s.value === "asc" ? "desc" : "asc" : (i.value = M.key, s.value = "asc"));
    }, D = (M) => {
      M ? T.value.forEach((B) => {
        o.value.add(B.id);
      }) : T.value.forEach((B) => {
        o.value.delete(B.id);
      }), a(
        "selection-change",
        Array.from(o.value).map((B) => t.rows.find((q) => q.id === B))
      );
    }, z = (M) => {
      o.value.has(M.id) ? o.value.delete(M.id) : o.value.add(M.id), a(
        "selection-change",
        Array.from(o.value).map((B) => t.rows.find((q) => q.id === B))
      );
    }, Y = (M) => {
      d.value = M, a("page-change", M);
    }, le = (M, B) => {
      M.onClick(B), a("action", M, B);
    }, ne = (M) => o.value.has(M.id), re = (M) => typeof t.rowActions == "function" ? t.rowActions(M) : t.rowActions || [], O = m(() => T.value.length === 0 ? !1 : T.value.every((M) => o.value.has(M.id))), P = (M, B) => B.render ? B.render(M[B.key], M) : M[B.key], V = (M) => {
      const B = [70, 85, 60, 90, 75, 80, 65, 95];
      return `${B[M % B.length]}%`;
    };
    return (M, B) => (c(), g("div", CF, [
      e.loading ? (c(), g(de, { key: 0 }, [
        v("div", {
          class: C(["self-stretch rounded-t-[12px] rounded-b-[0px] bg-white dark:bg-[var(--colors-background-black-default)] flex items-center p-[20px] gap-5", e.showSearch ? "justify-between" : "justify-end"])
        }, [
          e.showSearch ? (c(), g("div", SF, [...B[4] || (B[4] = [
            v("div", { class: "skeleton h-10 w-full" }, null, -1)
          ])])) : w("", !0),
          v("div", $F, [
            e.showAddButton ? (c(), g("div", IF)) : w("", !0),
            e.showFilters ? (c(), g("div", LF)) : w("", !0),
            B[5] || (B[5] = v("div", { class: "skeleton h-9 w-20" }, null, -1))
          ])
        ], 2),
        v("div", TF, [
          v("div", AF, [
            e.showCheckbox ? (c(), g("div", EF, [
              B[7] || (B[7] = v("div", { class: "w-14 h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-center justify-center py-0 px-[20px]" }, [
                v("div", { class: "skeleton h-4 w-4" })
              ], -1)),
              (c(!0), g(de, null, Re(e.itemsPerPage, (q) => (c(), g("div", {
                key: `skeleton-checkbox-${q}`,
                class: "w-14 h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border flex items-center justify-center py-0 px-[20px]"
              }, [...B[6] || (B[6] = [
                v("div", { class: "skeleton h-4 w-4" }, null, -1)
              ])]))), 128))
            ])) : w("", !0),
            (c(!0), g(de, null, Re(e.columns, (q, N) => (c(), g("div", {
              key: `skeleton-col-${N}`,
              style: je(
                e.wrap ? u.value[q.key] ? { width: `${u.value[q.key]}px`, minWidth: "50px", flexShrink: 0 } : {
                  minWidth: "50px",
                  flex: q.width ? "0 0 auto" : "1 1 0%",
                  width: q.width || "auto"
                } : { width: y(q.key), minWidth: "50px", flexShrink: 0 }
              ),
              class: "bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start relative"
            }, [
              B[8] || (B[8] = v("div", { class: "self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-start justify-center py-0 px-[20px]" }, [
                v("div", { class: "skeleton h-5 w-24" })
              ], -1)),
              (c(!0), g(de, null, Re(e.itemsPerPage, (G) => (c(), g("div", {
                key: `skeleton-row-${N}-${G}`,
                class: "self-stretch h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border overflow-hidden shrink-0 flex items-center py-0 px-[20px]"
              }, [
                v("div", {
                  class: "skeleton h-5",
                  style: je({ width: V(G - 1) })
                }, null, 4)
              ]))), 128))
            ], 4))), 128)),
            e.showActions && e.rowActions && e.rowActions.length > 0 ? (c(), g("div", {
              key: 1,
              class: "bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start relative",
              style: je(
                e.wrap ? u.value.__actions__ ? { width: `${u.value.__actions__}px`, minWidth: "50px", flexShrink: 0 } : { minWidth: "50px", flex: "0 0 auto", width: "auto" } : { width: y("__actions__"), minWidth: "50px", flexShrink: 0 }
              )
            }, [
              B[10] || (B[10] = v("div", { class: "self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-start justify-center py-0 px-[20px]" }, [
                v("div", { class: "skeleton h-5 w-16" })
              ], -1)),
              (c(!0), g(de, null, Re(e.itemsPerPage, (q) => (c(), g("div", {
                key: `skeleton-actions-${q}`,
                class: "h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border flex items-center py-0 px-[20px] gap-2",
                style: { width: "100%" }
              }, [...B[9] || (B[9] = [
                v("div", { class: "skeleton h-8 w-20" }, null, -1)
              ])]))), 128))
            ], 4)) : w("", !0),
            e.wrap ? w("", !0) : (c(), g("div", RF, [
              B[11] || (B[11] = v("div", { class: "self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border" }, null, -1)),
              (c(!0), g(de, null, Re(e.itemsPerPage, (q) => (c(), g("div", {
                key: `skeleton-spacer-${q}`,
                class: "self-stretch h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border"
              }))), 128))
            ]))
          ])
        ]),
        e.enablePagination ? (c(), g("div", BF, [...B[12] || (B[12] = [
          v("div", { class: "skeleton h-5 w-32" }, null, -1),
          v("div", { class: "skeleton h-9 w-48" }, null, -1)
        ])])) : w("", !0)
      ], 64)) : (c(), g(de, { key: 1 }, [
        v("div", {
          class: C(["self-stretch rounded-t-[12px] rounded-b-[0px] bg-white dark:bg-[var(--colors-background-black-default)] flex items-center p-[20px] gap-5 text-slategray dark:text-[var(--colors-text-white-default)]", e.showSearch ? "justify-between" : "justify-end"])
        }, [
          e.showSearch ? (c(), g("div", {
            key: 0,
            style: { width: "256px" },
            "data-testid": e.searchDataTestId
          }, [
            te(L(ls), {
              modelValue: r.value,
              "onUpdate:modelValue": [
                B[0] || (B[0] = (q) => r.value = q),
                B[1] || (B[1] = (q) => A(q))
              ],
              placeholder: e.searchPlaceholder,
              labels: { clear: e.searchClearLabel },
              "icon-left": e.searchIcon,
              size: "md",
              width: "256px"
            }, null, 8, ["modelValue", "placeholder", "labels", "icon-left"])
          ], 8, MF)) : w("", !0),
          v("div", DF, [
            e.showAddButton ? (c(), W(L(Me), {
              key: 0,
              variant: "primary",
              label: e.addButtonLabel,
              "icon-left": e.addButtonIconLeft,
              size: "sm",
              class: "flex-shrink-0 whitespace-nowrap",
              onClick: B[2] || (B[2] = () => M.$emit("add"))
            }, null, 8, ["label", "icon-left"])) : w("", !0),
            e.showFilters && e.filterSections && e.filterSections.length > 0 ? (c(), W(L(ec), {
              key: 1,
              label: e.filtersLabel,
              "trigger-icon-left": e.filtersIcon,
              items: e.filterSections,
              "menu-width": e.filterMenuWidth,
              "menu-align": "right",
              "footer-buttons": l.value
            }, null, 8, ["label", "trigger-icon-left", "items", "menu-width", "footer-buttons"])) : e.showFilters && (!e.filterSections || e.filterSections.length === 0) ? (c(), W(L(cn), {
              key: 2,
              label: e.filtersLabel,
              "trigger-icon-left": e.filtersIcon,
              items: e.filterItems,
              "menu-width": "180px",
              "menu-align": "right"
            }, null, 8, ["label", "trigger-icon-left", "items"])) : w("", !0),
            e.headerActionsItems && e.headerActionsItems.length > 0 ? (c(), W(L(cn), {
              key: 3,
              label: e.actionsLabel,
              "trigger-icon": e.actionsIcon,
              items: e.headerActionsItems,
              "menu-width": "180px",
              "menu-align": "right"
            }, null, 8, ["label", "trigger-icon", "items"])) : w("", !0)
          ])
        ], 2),
        v("div", zF, [
          v("div", OF, [
            e.showCheckbox ? (c(), g("div", PF, [
              v("div", FF, [
                v("div", VF, [
                  te(L(Bn), {
                    "model-value": O.value,
                    "onUpdate:modelValue": D
                  }, null, 8, ["model-value"])
                ])
              ]),
              (c(!0), g(de, null, Re(T.value, (q) => (c(), g("div", {
                key: q.id,
                class: "w-14 h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border flex items-center justify-center py-0 px-[20px]"
              }, [
                te(L(Bn), {
                  "model-value": ne(q),
                  "onUpdate:modelValue": () => z(q)
                }, null, 8, ["model-value", "onUpdate:modelValue"])
              ]))), 128))
            ])) : w("", !0),
            (c(!0), g(de, null, Re(e.columns, (q, N) => (c(), g("div", {
              key: N,
              style: je(
                e.wrap ? u.value[q.key] ? { width: `${u.value[q.key]}px`, minWidth: "50px", flexShrink: 0 } : {
                  minWidth: "50px",
                  flex: q.width ? "0 0 auto" : "1 1 0%",
                  width: q.width || "auto"
                } : { width: y(q.key), minWidth: "50px", flexShrink: 0 }
              ),
              class: C([
                "bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start relative",
                e.wrap && !q.width && !u.value[q.key] ? "min-w-0" : ""
              ])
            }, [
              v("div", {
                class: C(["self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-start justify-center py-0 px-[20px] text-(--colors-text-body) dark:text-(--colors-text-white-default) cursor-pointer hover:bg-gray-50 dark:hover:bg-[rgba(255,255,255,0.05)] transition-colors duration-200", { "opacity-50": !q.sortable }]),
                onClick: (G) => E(q)
              }, [
                v("div", HF, [
                  v("div", {
                    class: "relative leading-[20px] font-medium overflow-hidden text-ellipsis whitespace-nowrap",
                    title: q.label
                  }, j(q.label), 9, jF),
                  q.sortable && i.value === q.key ? (c(), g("img", {
                    key: 0,
                    class: "h-3.5 w-3.5 relative table-sort-icon",
                    style: je({
                      transform: s.value === "asc" ? "rotate(0deg)" : "rotate(180deg)"
                    }),
                    src: i.value === q.key ? "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22currentColor%22 stroke-width=%222%22%3E%3Cpath d=%22M19 9l-7 7-7-7%22/%3E%3C/svg%3E" : "",
                    alt: ""
                  }, null, 12, WF)) : w("", !0)
                ])
              ], 10, NF),
              v("div", {
                class: C(["absolute top-0 right-0 w-1 h-full cursor-col-resize z-0 hover:bg-blue-500 transition-colors", { "bg-blue-500": f.value && b.value === q.key }]),
                onMousedown: (G) => k(q.key, G)
              }, null, 42, qF),
              (c(!0), g(de, null, Re(T.value, (G) => (c(), g("div", {
                key: G.id,
                class: "self-stretch h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border overflow-hidden shrink-0 flex items-center py-0 px-[20px] text-text-body dark:text-[var(--colors-text-white-default)]"
              }, [
                v("div", UF, [
                  Ae(M.$slots, `cell-${q.key}`, {
                    value: G[q.key],
                    row: G,
                    column: q
                  }, () => [
                    nt(j(P(G, q)), 1)
                  ], !0)
                ])
              ]))), 128))
            ], 6))), 128)),
            e.showActions && e.rowActions && e.rowActions.length > 0 ? (c(), g("div", {
              key: 1,
              class: "bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start text-[12px] text-text-body dark:text-[var(--colors-text-white-default)] relative",
              style: je(
                e.wrap ? u.value.__actions__ ? { width: `${u.value.__actions__}px`, minWidth: "50px", flexShrink: 0 } : { minWidth: "50px", flex: "0 0 auto", width: "auto" } : { width: y("__actions__"), minWidth: "50px", flexShrink: 0 }
              )
            }, [
              v("div", GF, [
                v("div", KF, [
                  v("div", YF, j(e.actionsColumnLabel), 1)
                ])
              ]),
              v("div", {
                class: C(["absolute top-0 right-0 w-1 h-full cursor-col-resize z-0 hover:bg-blue-500 transition-colors", { "bg-blue-500": f.value && b.value === "__actions__" }]),
                onMousedown: B[3] || (B[3] = (q) => k("__actions__", q))
              }, null, 34),
              (c(!0), g(de, null, Re(T.value, (q) => (c(), g("div", {
                key: `actions-${q.id}`,
                class: "h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border flex items-center py-0 px-[20px] gap-2",
                style: { width: "100%" }
              }, [
                re(q).filter((N) => !N.isDelete).length > 0 ? (c(), W(L(cn), {
                  key: 0,
                  label: e.actionsColumnLabel,
                  items: re(q).filter((N) => !N.isDelete).map((N) => ({
                    label: N.label,
                    icon: N.icon,
                    testId: N.testId,
                    onClick: () => le(N, q)
                  })),
                  "menu-width": "150px"
                }, null, 8, ["label", "items"])) : w("", !0),
                (c(!0), g(de, null, Re(re(q).filter((N) => N.isDelete), (N) => (c(), W(L(Me), {
                  key: N.label,
                  variant: "error",
                  label: N.label,
                  "icon-left": N.icon,
                  size: "xs",
                  onClick: () => le(N, q)
                }, null, 8, ["label", "icon-left", "onClick"]))), 128))
              ]))), 128))
            ], 4)) : w("", !0),
            e.wrap ? w("", !0) : (c(), g("div", JF, [
              B[13] || (B[13] = v("div", { class: "self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border" }, null, -1)),
              (c(!0), g(de, null, Re(T.value, (q) => (c(), g("div", {
                key: `spacer-${q.id}`,
                class: "self-stretch h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border"
              }))), 128))
            ]))
          ])
        ]),
        e.enablePagination ? (c(), g("div", XF, [
          v("div", ZF, j(e.paginationText(
            (d.value - 1) * e.itemsPerPage + 1,
            Math.min(d.value * e.itemsPerPage, e.totalItems),
            e.totalItems
          )), 1),
          v("div", QF, [
            te(L(CO), {
              "current-page": d.value,
              "total-pages": I.value,
              "total-items": e.totalItems,
              "items-per-page": e.itemsPerPage,
              "page-align": "end",
              "show-rows-per-page": !1,
              onPageChange: Y
            }, null, 8, ["current-page", "total-pages", "total-items", "items-per-page"])
          ])
        ])) : w("", !0)
      ], 64))
    ]));
  }
}), Uq = /* @__PURE__ */ dt(_F, [["__scopeId", "data-v-2c369241"]]), e6 = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M10.8284%2012.0007L15.7782%2016.9504L14.364%2018.3646L8%2012.0007L14.364%205.63672L15.7782%207.05093L10.8284%2012.0007Z'/%3e%3c/svg%3e", t6 = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M13.1717%2012.0007L8.22192%207.05093L9.63614%205.63672L16.0001%2012.0007L9.63614%2018.3646L8.22192%2016.9504L13.1717%2012.0007Z'/%3e%3c/svg%3e", n6 = ["data-theme", "data-collapsed", "aria-label"], a6 = { class: "flex items-center sidebar-logo" }, l6 = ["src"], r6 = {
  key: 0,
  class: "h-7.5 border-border-base-medium border-solid border-l box-border flex items-center justify-center py-num-0 pl-3 pr-num-0"
}, o6 = { class: "relative leading-5.5 font-semibold dark:text-(--colors-text-white-secondary)" }, i6 = ["aria-label", "aria-expanded"], s6 = ["src"], d6 = {
  key: 0,
  class: "self-stretch shrink-0 flex flex-col items-center relative z-10 sidebar-scroll-indicator"
}, u6 = ["src"], c6 = {
  key: 0,
  class: "self-stretch border-border-base-soft border-solid border-b flex flex-col items-start pt-num-0 px-num-0 pb-4 shrink-0"
}, f6 = ["data-active", "aria-label", "aria-expanded", "aria-controls", "aria-current", "disabled"], h6 = ["src"], b6 = {
  key: 1,
  class: "h-5 w-5 relative shrink-0",
  "aria-hidden": "true"
}, g6 = {
  key: 2,
  class: "relative leading-num-24 font-medium dark:text-(--colors-text-white-secondary)"
}, m6 = {
  key: 0,
  class: "flex items-center gap-1.5 text-center text-[12px] text-text-black-default dark:text-(--colors-text-white-secondary) relative z-10"
}, p6 = { class: "relative leading-5 font-medium z-10 dark:text-(--colors-text-white-secondary)" }, v6 = ["src"], x6 = ["data-active", "aria-current", "aria-disabled", "disabled", "onClick"], y6 = { class: "flex-1 flex items-center justify-start py-num-0 pl-num-2 pr-num-0 shrink-0 relative z-10 text-left min-w-0" }, k6 = { class: "relative leading-num-24 font-medium text-left dark:text-(--colors-text-white-secondary)" }, w6 = { class: "self-stretch flex flex-col items-start gap-2 shrink-0 text-text-black-default dark:text-(--colors-text-white-secondary)" }, C6 = {
  key: 0,
  class: "self-stretch border-t border-border-base-soft my-1 sidebar-divider",
  "aria-hidden": "true"
}, S6 = {
  key: 1,
  class: "self-stretch flex flex-col items-start"
}, $6 = ["data-active", "data-opened", "data-testid", "aria-label", "aria-expanded", "aria-controls", "aria-current", "aria-disabled", "disabled", "onClick"], I6 = ["src"], L6 = {
  key: 1,
  class: "h-5 w-5 relative shrink-0",
  "aria-hidden": "true"
}, T6 = {
  key: 2,
  class: "relative leading-num-24 font-medium dark:text-(--colors-text-white-secondary) truncate"
}, A6 = ["src"], E6 = ["data-active", "data-testid", "aria-current", "aria-disabled", "disabled", "onClick"], R6 = { class: "flex-1 flex items-center justify-start py-num-0 pl-num-2 pr-num-0 shrink-0 relative z-10 text-left min-w-0" }, B6 = { class: "relative leading-num-24 font-medium text-left dark:text-(--colors-text-white-secondary) truncate" }, M6 = ["data-active", "data-testid", "aria-label", "aria-current", "aria-disabled", "disabled", "onClick"], D6 = ["src"], z6 = {
  key: 1,
  class: "h-5 w-5 relative shrink-0",
  "aria-hidden": "true"
}, O6 = {
  key: 2,
  class: "relative leading-num-24 font-medium z-10 dark:text-(--colors-text-white-secondary) truncate"
}, P6 = {
  key: 0,
  class: "self-stretch shrink-0 flex flex-col items-center relative z-10 sidebar-scroll-indicator"
}, F6 = ["src"], V6 = { class: "self-stretch border-border-base-soft border-solid border-t shrink-0 pt-4 text-[12px] relative z-10" }, N6 = { key: 0 }, H6 = ["href"], j6 = {
  key: 1,
  class: "relative leading-5 font-medium mb-1 sidebar-footer-a11y"
}, W6 = { class: "relative leading-5 font-medium dark:text-(--colors-text-white-secondary)" }, q6 = /* @__PURE__ */ ye({
  __name: "Sidebar",
  props: {
    companyIcon: { default: "/logo-eudonet-small.svg" },
    companyName: { default: "Eudonet" },
    items: { default: () => [] },
    modelValue: { type: Boolean, default: !0 },
    collapsed: { type: Boolean, default: void 0 },
    width: { default: "239px" },
    collapsedWidth: { default: "80px" },
    theme: { default: "light" },
    footerText: { default: "Powered by Eudonet" },
    ariaLabel: {},
    accessibilityText: { default: "" },
    accessibilityLink: { default: void 0 },
    backgroundColor: { default: void 0 },
    textColor: { default: void 0 },
    borderColor: { default: void 0 },
    accentColor: { default: void 0 },
    hoverBackgroundColor: { default: void 0 }
  },
  emits: ["update:modelValue", "update:collapsed", "item-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R(!1), r = R({}), o = () => {
      Object.keys(r.value).forEach((q) => {
        r.value[q] = !1;
      });
    };
    $e(
      () => t.collapsed,
      (q, N) => {
        q !== void 0 && (l.value = q, q ? o() : N === !0 && !Object.values(r.value).some(Boolean) && y());
      },
      { immediate: !0 }
    );
    const i = () => {
      const q = !l.value;
      l.value = q, a("update:collapsed", q), q ? o() : y();
    }, s = R(
      typeof window < "u" ? window.matchMedia("(prefers-color-scheme: dark)").matches : !1
    );
    ct(() => {
      if (typeof window > "u") return;
      const q = window.matchMedia("(prefers-color-scheme: dark)"), N = (G) => {
        s.value = G.matches;
      };
      q.addEventListener("change", N), kt(() => q.removeEventListener("change", N));
    });
    const d = m(
      () => t.theme === "auto" ? s.value : t.theme === "dark"
    ), u = m(() => d.value ? "sidebar-dark" : "sidebar-light"), f = m(() => {
      const q = {};
      return t.backgroundColor && (q["--sidebar-bg"] = t.backgroundColor), t.textColor && (q["--sidebar-text"] = t.textColor), t.borderColor && (q["--sidebar-border"] = t.borderColor), t.accentColor && (q["--sidebar-accent"] = t.accentColor), t.hoverBackgroundColor && (q["--sidebar-hover-bg"] = t.hoverBackgroundColor), q.width = l.value ? t.collapsedWidth : t.width, q;
    }), b = (q) => q.key ?? q.label, h = m(() => t.items.find((q) => q.key === "bookmarks")), p = m(
      () => h.value ? b(h.value) : "bookmarks"
    ), x = m(() => t.items.filter((q) => q.key !== "bookmarks")), y = () => {
      t.items.forEach((q) => {
        var N;
        (N = q.children) != null && N.some((G) => G.active) && (r.value[b(q)] = !0);
      });
    };
    ct(() => {
      l.value || y();
    });
    const k = (q) => r.value[q] === !0, $ = (q) => {
      const N = !r.value[q];
      N && Object.keys(r.value).forEach((G) => {
        G !== q && (r.value[G] = !1);
      }), r.value[q] = N;
    }, S = R(null), T = R(!1), I = R(!1), A = () => {
      const q = S.value;
      q && (T.value = q.scrollTop > 4, I.value = q.scrollTop + q.clientHeight < q.scrollHeight - 4);
    }, E = () => {
      const q = S.value;
      q && q.scrollBy({ top: -100, behavior: "smooth" });
    }, D = () => {
      const q = S.value;
      q && q.scrollBy({ top: 100, behavior: "smooth" });
    };
    let z = null, Y = null;
    ct(() => {
      setTimeout(() => {
        A();
        const q = S.value;
        q && (Y = new ResizeObserver(() => A()), Y.observe(q), z = new MutationObserver(() => A()), z.observe(q, { childList: !0, subtree: !0 }));
      }, 0);
    }), kt(() => {
      Y == null || Y.disconnect(), Y = null, z == null || z.disconnect(), z = null;
    }), $e(
      r,
      () => {
        Ge(A), setTimeout(A, 100), setTimeout(A, 200), setTimeout(A, 350);
      },
      { deep: !0 }
    );
    const le = (q) => {
      if (q.disabled) return;
      const N = q.children !== void 0 && q.children.length > 0;
      l.value ? (l.value = !1, a("update:collapsed", !1), N ? $(b(q)) : y()) : N && $(b(q)), q.onClick && q.onClick(), a("item-click", q);
    }, ne = (q) => {
      var N;
      return q.active === !0 || l.value && (((N = q.children) == null ? void 0 : N.some((G) => G.active)) ?? !1);
    }, re = Hn(), O = m(() => !!re.logo), P = m(
      () => l.value ? "/logo-eudonet-small.svg" : t.companyIcon
    ), V = (q) => {
      const N = "group self-stretch flex items-center justify-start py-num-6 pl-num-32 pr-num-8 cursor-pointer border-solid border border-transparent transition-[background,border-color] duration-300 relative text-left sidebar-child-item";
      return q.disabled ? `${N} opacity-50 cursor-not-allowed` : q.active ? `${N} rounded-[48px] overflow-visible sidebar-item-active` : `${N} rounded-num-12 sidebar-item-hover`;
    }, M = (q) => {
      const N = "group self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border border-transparent transition-[background,border-color] duration-300 sidebar-simple-item";
      return q.disabled ? `${N} opacity-50 cursor-not-allowed` : q.active ? `${N} relative overflow-visible sidebar-item-active` : `${N} sidebar-item-hover`;
    }, B = () => 'h-5.5 w-5.5 rounded-full relative flex items-center justify-center overflow-visible before:opacity-100 after:opacity-100 before:content-[""] before:absolute before:inset-[-1px] before:rounded-full before:[background:var(--sidebar-accent)] before:transition-opacity before:duration-300 before:z-0 after:content-[""] after:absolute after:inset-0 after:rounded-full after:transition-opacity after:duration-300 after:z-[1] sidebar-badge';
    return (q, N) => e.modelValue ? (c(), g("nav", {
      key: 0,
      class: C(["h-full relative shadow-[0px_4px_4px_rgba(0,0,0,0.25)] rounded-tl-none rounded-tr-3xl rounded-b-none box-border flex flex-col items-start text-left text-[18px] font-inter transition-all duration-300 sidebar-container", [u.value, { "sidebar-collapsed": l.value }, l.value ? "p-2" : "p-5"]]),
      "data-theme": d.value ? "dark" : "light",
      "data-collapsed": l.value ? "true" : "false",
      style: je(f.value),
      "aria-label": e.ariaLabel ?? "Main navigation"
    }, [
      v("div", {
        class: C([
          "self-stretch border-border-base-soft border-solid border-b pt-num-0 px-num-0 relative z-[2] shrink-0",
          l.value ? "flex flex-col items-center gap-2 overflow-visible pb-2" : "flex items-center justify-between gap-5 pb-5"
        ])
      }, [
        v("div", {
          class: C(["flex items-center gap-3", [{ "justify-center": l.value }, { "flex-1": !l.value }]])
        }, [
          v("div", a6, [
            O.value ? Ae(q.$slots, "logo", {
              key: 0,
              collapsed: l.value
            }, void 0, !0) : P.value ? (c(), g("img", {
              key: 1,
              class: "h-7 w-7 relative",
              src: P.value,
              alt: "Company logo"
            }, null, 8, l6)) : w("", !0)
          ]),
          l.value ? w("", !0) : (c(), g("div", r6, [
            v("div", o6, j(e.companyName), 1)
          ]))
        ], 2),
        v("button", {
          type: "button",
          class: "sidebar-toggle-button shrink-0 h-6 w-6 rounded-full bg-white border border-gray-200 shadow-sm flex items-center justify-center cursor-pointer hover:border-gray-300 transition-colors duration-200",
          "aria-label": l.value ? "Expand sidebar" : "Collapse sidebar",
          "aria-expanded": !l.value,
          onClick: i
        }, [
          v("img", {
            src: l.value ? L(t6) : L(e6),
            class: "h-4 w-4 relative sidebar-toggle-icon",
            alt: "",
            "aria-hidden": "true"
          }, null, 8, s6)
        ], 8, i6)
      ], 2),
      te(At, { name: "fade" }, {
        default: ve(() => [
          T.value ? (c(), g("div", d6, [
            v("button", {
              type: "button",
              class: "flex w-9 h-9 p-0 justify-center items-center shrink-0 rounded-full cursor-pointer bg-transparent border-none sidebar-scroll-btn",
              "aria-label": "Scroll up",
              onClick: E
            }, [
              v("img", {
                src: L(ai),
                class: "h-4 w-4 sidebar-scroll-icon",
                alt: "",
                "aria-hidden": "true"
              }, null, 8, u6)
            ]),
            N[1] || (N[1] = v("div", { class: "flex h-px justify-center items-center shrink-0 self-stretch sidebar-scroll-divider" }, null, -1))
          ])) : w("", !0)
        ]),
        _: 1
      }),
      v("div", {
        ref_key: "scrollAreaRef",
        ref: S,
        class: "flex-1 min-h-0 overflow-y-auto self-stretch flex flex-col gap-4 py-4 text-num-16 dark:text-(--colors-text-white-secondary) sidebar-scroll-area relative z-[2]",
        onScroll: A
      }, [
        h.value ? (c(), g("div", c6, [
          te(mt, {
            text: h.value.label,
            position: "right",
            disabled: !l.value,
            class: "self-stretch flex-col"
          }, {
            default: ve(() => {
              var G;
              return [
                v("button", {
                  type: "button",
                  class: C(["group self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border border-transparent transition-[background,border-color] duration-300 sidebar-section-header", [
                    { "justify-center": l.value },
                    { "sidebar-item-active": ne(h.value) },
                    { "opacity-50 cursor-not-allowed": h.value.disabled }
                  ]]),
                  "data-active": ne(h.value) ? "true" : "false",
                  "aria-label": l.value ? h.value.label : void 0,
                  "aria-expanded": k(p.value),
                  "aria-controls": (G = h.value.children) != null && G.length ? "sidebar-submenu-bookmarks" : void 0,
                  "aria-current": h.value.active ? "page" : void 0,
                  disabled: h.value.disabled,
                  onClick: N[0] || (N[0] = (U) => le(h.value))
                }, [
                  v("div", {
                    class: C(["flex-1 flex items-center gap-1.5", { "justify-center": l.value }])
                  }, [
                    h.value.icon ? (c(), g("img", {
                      key: 0,
                      class: "h-5 w-5 relative shrink-0",
                      src: h.value.icon,
                      alt: "",
                      "aria-hidden": "true"
                    }, null, 8, h6)) : (c(), g("div", b6)),
                    l.value ? w("", !0) : (c(), g("div", g6, j(h.value.label), 1))
                  ], 2),
                  l.value ? w("", !0) : (c(), g("div", m6, [
                    v("div", {
                      class: C(B())
                    }, [
                      v("div", p6, j(h.value.badge ?? 0), 1)
                    ], 2),
                    v("img", {
                      class: "h-4 w-4 relative z-10 transition-transform duration-200",
                      src: k(p.value) ? L(ai) : L(Vl),
                      alt: "",
                      "aria-hidden": "true"
                    }, null, 8, v6)
                  ]))
                ], 10, f6)
              ];
            }),
            _: 1
          }, 8, ["text", "disabled"]),
          h.value.children && h.value.children.length > 0 ? (c(), W(Ur, {
            key: 0,
            id: "sidebar-submenu-bookmarks",
            name: "submenu",
            tag: "div",
            role: "region",
            "aria-label": `${h.value.label} submenu`,
            class: C([
              "self-stretch flex flex-col items-start gap-2 submenu-wrapper",
              { "submenu-open": k(p.value) }
            ])
          }, {
            default: ve(() => [
              (c(!0), g(de, null, Re(k(p.value) ? h.value.children : [], (G) => (c(), g("button", {
                key: b(G),
                type: "button",
                class: C(V(G)),
                "data-active": G.active ? "true" : "false",
                "aria-current": G.active ? "page" : void 0,
                "aria-disabled": G.disabled ? "true" : void 0,
                disabled: G.disabled,
                onClick: (U) => le(G)
              }, [
                v("div", y6, [
                  v("div", k6, j(G.label), 1)
                ])
              ], 10, x6))), 128))
            ]),
            _: 1
          }, 8, ["aria-label", "class"])) : w("", !0)
        ])) : w("", !0),
        v("div", w6, [
          (c(!0), g(de, null, Re(x.value, (G) => (c(), g(de, {
            key: b(G)
          }, [
            G.divider ? (c(), g("hr", C6)) : w("", !0),
            G.children !== void 0 ? (c(), g("div", S6, [
              te(mt, {
                text: G.label,
                position: "right",
                disabled: !l.value,
                class: "self-stretch flex-col"
              }, {
                default: ve(() => {
                  var U;
                  return [
                    v("button", {
                      type: "button",
                      class: C(["group self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border border-transparent transition-[background,border-color] duration-300 sidebar-section-header", [
                        { "justify-center": l.value },
                        { "sidebar-item-active": ne(G) },
                        {
                          "sidebar-item-opened": (k(b(G)) || ((U = G.children) == null ? void 0 : U.some((K) => K.active))) && !G.active
                        },
                        { "opacity-50 cursor-not-allowed": G.disabled }
                      ]]),
                      "data-active": ne(G) ? "true" : "false",
                      "data-opened": k(b(G)) ? "true" : "false",
                      "data-testid": G.testId,
                      "aria-label": l.value ? G.label : void 0,
                      "aria-expanded": k(b(G)),
                      "aria-controls": `sidebar-submenu-${b(G)}`,
                      "aria-current": G.active ? "page" : void 0,
                      "aria-disabled": G.disabled ? "true" : void 0,
                      disabled: G.disabled,
                      onClick: (K) => le(G)
                    }, [
                      v("div", {
                        class: C(["flex-1 flex items-center gap-1.5 min-w-0", { "justify-center": l.value }])
                      }, [
                        G.icon ? (c(), g("img", {
                          key: 0,
                          class: "h-5 w-5 relative shrink-0",
                          src: G.icon,
                          alt: "",
                          "aria-hidden": "true"
                        }, null, 8, I6)) : (c(), g("div", L6)),
                        l.value ? w("", !0) : (c(), g("div", T6, j(G.label), 1))
                      ], 2),
                      !l.value && G.children.length > 0 ? (c(), g("img", {
                        key: 0,
                        class: "h-4 w-4 relative transition-transform duration-200 shrink-0",
                        src: k(b(G)) ? L(ai) : L(Vl),
                        alt: "",
                        "aria-hidden": "true"
                      }, null, 8, A6)) : w("", !0)
                    ], 10, $6)
                  ];
                }),
                _: 2
              }, 1032, ["text", "disabled"]),
              te(Ur, {
                id: `sidebar-submenu-${b(G)}`,
                name: "submenu",
                tag: "div",
                role: "region",
                "aria-label": `${G.label} submenu`,
                class: C([
                  "self-stretch flex flex-col items-start gap-2 submenu-wrapper",
                  { "submenu-open": k(b(G)) }
                ])
              }, {
                default: ve(() => [
                  (c(!0), g(de, null, Re(k(b(G)) ? G.children : [], (U) => (c(), g("button", {
                    key: b(U),
                    type: "button",
                    class: C(V(U)),
                    "data-active": U.active ? "true" : "false",
                    "data-testid": U.testId,
                    "aria-current": U.active ? "page" : void 0,
                    "aria-disabled": U.disabled ? "true" : void 0,
                    disabled: U.disabled,
                    onClick: (K) => le(U)
                  }, [
                    v("div", R6, [
                      v("div", B6, j(U.label), 1)
                    ])
                  ], 10, E6))), 128))
                ]),
                _: 2
              }, 1032, ["id", "aria-label", "class"])
            ])) : (c(), W(mt, {
              key: 2,
              text: G.label,
              position: "right",
              disabled: !l.value,
              class: "self-stretch flex-col"
            }, {
              default: ve(() => [
                v("button", {
                  type: "button",
                  class: C([M(G), { "justify-center": l.value }]),
                  "data-active": G.active ? "true" : "false",
                  "data-testid": G.testId,
                  "aria-label": l.value ? G.label : void 0,
                  "aria-current": G.active ? "page" : void 0,
                  "aria-disabled": G.disabled ? "true" : void 0,
                  disabled: G.disabled,
                  onClick: (U) => le(G)
                }, [
                  v("div", {
                    class: C(["flex-1 flex items-center gap-1.5 relative z-10 min-w-0", { "justify-center": l.value }])
                  }, [
                    G.icon ? (c(), g("img", {
                      key: 0,
                      class: "h-5 w-5 relative z-10 shrink-0",
                      src: G.icon,
                      alt: "",
                      "aria-hidden": "true"
                    }, null, 8, D6)) : (c(), g("div", z6)),
                    l.value ? w("", !0) : (c(), g("div", O6, j(G.label), 1))
                  ], 2)
                ], 10, M6)
              ]),
              _: 2
            }, 1032, ["text", "disabled"]))
          ], 64))), 128))
        ])
      ], 544),
      te(At, { name: "fade" }, {
        default: ve(() => [
          I.value ? (c(), g("div", P6, [
            N[2] || (N[2] = v("div", { class: "flex h-px justify-center items-center shrink-0 self-stretch sidebar-scroll-divider" }, null, -1)),
            v("button", {
              type: "button",
              class: "flex w-9 h-9 p-0 justify-center items-center shrink-0 rounded-full cursor-pointer bg-transparent border-none sidebar-scroll-btn",
              "aria-label": "Scroll down",
              onClick: D
            }, [
              v("img", {
                src: L(Vl),
                class: "h-4 w-4 sidebar-scroll-icon",
                alt: "",
                "aria-hidden": "true"
              }, null, 8, F6)
            ])
          ])) : w("", !0)
        ]),
        _: 1
      }),
      v("div", V6, [
        l.value ? w("", !0) : (c(), g("div", N6, [
          Ae(q.$slots, "footer", {}, () => [
            e.accessibilityText && e.accessibilityLink ? (c(), g("a", {
              key: 0,
              href: e.accessibilityLink,
              class: "block relative leading-5 font-medium mb-1 underline sidebar-footer-a11y-link"
            }, j(e.accessibilityText), 9, H6)) : e.accessibilityText ? (c(), g("div", j6, j(e.accessibilityText), 1)) : w("", !0),
            v("div", W6, j(e.footerText), 1)
          ], !0)
        ]))
      ])
    ], 14, n6)) : w("", !0);
  }
}), Gq = /* @__PURE__ */ dt(q6, [["__scopeId", "data-v-0fb03d0f"]]), U6 = { class: "px-4 pt-5 pb-4" }, G6 = { class: "text-lg font-semibold secondary-sidebar-title" }, K6 = { class: "flex flex-col gap-8 px-4 pb-5" }, Y6 = { class: "text-xs font-medium uppercase tracking-wider secondary-sidebar-group-header" }, J6 = {
  key: 0,
  class: "flex flex-col gap-1"
}, X6 = ["aria-expanded", "aria-controls", "data-testid", "onClick"], Z6 = { class: "text-sm font-medium secondary-sidebar-item-text" }, Q6 = ["id"], _6 = ["data-active", "aria-current", "data-testid", "onClick"], eV = { class: "text-sm font-medium secondary-sidebar-item-text" }, tV = ["data-active", "aria-current", "data-testid", "onClick"], nV = { class: "text-sm font-medium secondary-sidebar-item-text" }, aV = /* @__PURE__ */ ye({
  __name: "SecondarySidebar",
  props: {
    title: { default: "Settings" },
    groups: { default: () => [
      {
        label: "Profile management",
        items: [
          { label: "Profile" },
          { label: "Security information", active: !0 },
          { label: "Permissions" },
          { label: "Notification settings" }
        ]
      },
      {
        label: "Organisation management",
        items: [
          { label: "Global settings" },
          { label: "Users" },
          { label: "Security" },
          { label: "Configuration" },
          { label: "IA" },
          { label: "Billing & Plan" }
        ]
      },
      {
        label: "Module management",
        items: [{ label: "Global settings" }, { label: "Contact" }, { label: "Security" }]
      }
    ] },
    theme: { default: "light" },
    width: { default: "248px" },
    backgroundColor: { default: void 0 },
    textColor: { default: void 0 },
    borderColor: { default: void 0 },
    accentColor: { default: void 0 },
    hoverBackgroundColor: { default: void 0 },
    groupHeaderColor: { default: void 0 }
  },
  emits: ["item-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => t.theme === "auto" ? typeof window < "u" ? window.matchMedia("(prefers-color-scheme: dark)").matches : !1 : t.theme === "dark"), r = m(() => l.value ? "secondary-sidebar-dark" : "secondary-sidebar-light"), o = m(() => {
      const S = {};
      return t.backgroundColor && (S["--secondary-sidebar-bg"] = t.backgroundColor), t.textColor && (S["--secondary-sidebar-text"] = t.textColor), t.borderColor && (S["--secondary-sidebar-border"] = t.borderColor), t.accentColor && (S["--secondary-sidebar-accent"] = t.accentColor), t.hoverBackgroundColor && (S["--secondary-sidebar-hover-bg"] = t.hoverBackgroundColor), t.groupHeaderColor && (S["--secondary-sidebar-group-header"] = t.groupHeaderColor), S.width = t.width || "248px", S;
    }), i = qe(), s = (S, T) => `${i}-category-${S}-${T}`, d = (S) => S.testId ?? S.label, u = (S, T) => T.key ?? `${S.label}/${d(T)}`, f = (S) => S.children !== void 0, b = (S) => {
      var T;
      return (T = S.children) == null ? void 0 : T.find((I) => I.active);
    }, h = R({}), p = (S, T) => h.value[u(S, T)] ?? (b(T) !== void 0 || T.defaultExpanded === !0), x = (S, T) => {
      h.value = {
        ...h.value,
        [u(S, T)]: !p(S, T)
      };
    }, y = m(() => {
      const S = {};
      for (const T of t.groups)
        for (const I of T.items) {
          const A = f(I) ? b(I) : void 0;
          A && (S[u(T, I)] = d(A));
        }
      return S;
    });
    $e(y, (S, T) => {
      const I = Object.keys(S).filter((E) => S[E] !== T[E]);
      if (I.length === 0) return;
      const A = { ...h.value };
      for (const E of I) delete A[E];
      h.value = A;
    });
    const k = (S, T) => {
      S.onClick && S.onClick(), a("item-click", S, T);
    }, $ = (S) => {
      const T = "w-full text-left py-2 cursor-pointer transition-all duration-200 secondary-sidebar-item";
      return S.active ? `${T} secondary-sidebar-item-active` : `${T} secondary-sidebar-item-hover`;
    };
    return (S, T) => (c(), g("aside", {
      class: C(["h-full flex flex-col box-border overflow-y-auto overflow-x-hidden secondary-sidebar-container", r.value]),
      style: je(o.value)
    }, [
      v("div", U6, [
        v("h2", G6, j(e.title), 1)
      ]),
      v("div", K6, [
        (c(!0), g(de, null, Re(e.groups, (I, A) => (c(), g("div", {
          key: A,
          class: "flex flex-col gap-1"
        }, [
          v("div", Y6, j(I.label), 1),
          (c(!0), g(de, null, Re(I.items, (E, D) => (c(), g(de, {
            key: `${A}-${D}`
          }, [
            f(E) ? (c(), g("div", J6, [
              v("button", {
                type: "button",
                class: "w-[calc(100%+24px)] -mx-3 px-3 flex items-center justify-between gap-2 text-left py-2 rounded-lg cursor-pointer transition-colors duration-200 secondary-sidebar-item hover:bg-(--secondary-sidebar-hover-bg)",
                "aria-expanded": p(I, E) ? "true" : "false",
                "aria-controls": s(A, D),
                "data-testid": E.testId,
                onClick: (z) => x(I, E)
              }, [
                v("span", Z6, j(E.label), 1),
                v("i", {
                  class: C([
                    p(I, E) ? "ri-arrow-down-s-line" : "ri-arrow-right-s-line",
                    "text-base leading-none secondary-sidebar-item-text"
                  ]),
                  "aria-hidden": "true"
                }, null, 2)
              ], 8, X6),
              tr(v("div", {
                id: s(A, D),
                class: "flex flex-col gap-1 pl-3"
              }, [
                (c(!0), g(de, null, Re(E.children, (z, Y) => (c(), g("button", {
                  key: `${A}-${D}-${Y}`,
                  type: "button",
                  class: C($(z)),
                  "data-active": z.active ? "true" : "false",
                  "aria-current": z.active ? "page" : void 0,
                  "data-testid": z.testId,
                  onClick: (le) => k(z, I)
                }, [
                  v("span", eV, j(z.label), 1)
                ], 10, _6))), 128))
              ], 8, Q6), [
                [Ru, p(I, E)]
              ])
            ])) : (c(), g("button", {
              key: 1,
              type: "button",
              class: C($(E)),
              "data-active": E.active ? "true" : "false",
              "aria-current": E.active ? "page" : void 0,
              "data-testid": E.testId,
              onClick: (z) => k(E, I)
            }, [
              v("span", nV, j(E.label), 1)
            ], 10, tV))
          ], 64))), 128))
        ]))), 128))
      ])
    ], 6));
  }
}), Kq = /* @__PURE__ */ dt(aV, [["__scopeId", "data-v-4e518031"]]), lV = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "FormSaveButton",
  props: {
    enabled: { type: Boolean },
    saving: { type: Boolean },
    saveLabel: {},
    savingLabel: {},
    disabledHint: {}
  },
  emits: ["save"],
  setup(e, { expose: n }) {
    const t = R(null);
    return n({ buttonElement: m(() => {
      var a;
      return ((a = t.value) == null ? void 0 : a.$el) ?? null;
    }) }), (a, l) => (c(), W(mt, {
      text: e.disabledHint ?? "",
      disabled: e.enabled || e.saving || !e.disabledHint
    }, {
      default: ve(() => [
        te(Me, Fe({
          ref_key: "buttonRef",
          ref: t
        }, a.$attrs, {
          variant: "primary",
          "icon-left": "ri-save-line",
          label: e.saveLabel,
          "aria-disabled": !e.enabled,
          loading: e.saving,
          "loading-label": e.savingLabel,
          onClick: l[0] || (l[0] = (r) => a.$emit("save"))
        }), null, 16, ["label", "aria-disabled", "loading", "loading-label"])
      ]),
      _: 1
    }, 8, ["text", "disabled"]));
  }
}), rV = {
  class: "flex",
  "data-testid": "nav-header-badges"
}, li = /* @__PURE__ */ ye({
  __name: "NavHeaderBadges",
  props: {
    badges: {}
  },
  setup(e) {
    return (n, t) => (c(), g("div", rV, [
      (c(!0), g(de, null, Re(e.badges, (a, l) => (c(), g(de, { key: l }, [
        L(ju)(a) ? (c(), W(Hu, {
          key: 0,
          label: a.label,
          "hidden-labels": a.hiddenLabels
        }, null, 8, ["label", "hidden-labels"])) : (c(), W(gt, {
          key: 1,
          label: a.label,
          theme: a.theme ?? "neutral",
          size: "sm",
          "left-icon": a.icon,
          "show-left-icon": !!a.icon,
          truncate: a.truncate ?? !0,
          "show-close-icon": !1
        }, null, 8, ["label", "theme", "left-icon", "show-left-icon", "truncate"]))
      ], 64))), 128))
    ]));
  }
}), oV = { class: "box-border flex w-full flex-col justify-center border-b border-solid border-(--colors-border-base-medium) px-5 pt-3 pb-[calc(--spacing(3)-1px)]" }, iV = {
  key: 0,
  class: "flex min-w-0 flex-wrap items-center gap-x-5 gap-y-2 self-stretch",
  "data-testid": "navbar-editor"
}, sV = {
  class: "flex min-w-0 grow basis-48 items-center gap-5",
  "data-testid": "navbar-left"
}, dV = {
  class: "flex min-w-0 items-center",
  "data-testid": "navbar-title"
}, uV = {
  key: 0,
  class: "ml-auto flex max-w-full min-w-0 flex-wrap items-center justify-end gap-2",
  "data-testid": "navbar-actions"
}, cV = {
  key: 0,
  class: "flex min-w-0 items-center gap-1 px-px text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default) dark:text-(--colors-text-white-default)",
  "data-testid": "navbar-status"
}, fV = {
  key: 1,
  class: "flex min-w-0 flex-wrap items-center justify-between gap-x-8 gap-y-2 self-stretch"
}, hV = {
  class: "flex min-w-0 grow basis-48 items-center gap-4",
  "data-testid": "navbar-left"
}, bV = {
  class: "ml-auto flex max-w-full shrink-0 flex-wrap items-center justify-end gap-2",
  "data-testid": "navbar-right"
}, Yq = /* @__PURE__ */ ye({
  __name: "Navbar",
  props: {
    type: { default: "default" },
    backLabel: { default: void 0 },
    title: { default: "" },
    editableTitle: { type: Boolean, default: !0 },
    titleError: { default: void 0 },
    editTitleLabel: { default: "" },
    saveTitleLabel: { default: "" },
    editorBadges: { default: () => [] },
    editorStatus: { default: void 0 },
    editorActions: { default: () => [] },
    searchPlaceholder: { default: "" },
    searchLabel: { default: void 0 },
    searchControls: { default: void 0 },
    searchExpanded: { type: Boolean, default: !1 },
    searchActivedescendant: { default: void 0 },
    searchClearLabel: { default: void 0 },
    searchIcon: { default: void 0 },
    filterIcon: { default: void 0 },
    filterLabel: { default: void 0 },
    actions: { default: () => [] },
    avatar: { default: void 0 },
    searchWidth: { default: "453px" },
    searchSize: { default: "sm" },
    searchValue: { default: "" },
    searchDisabled: { type: Boolean, default: !1 },
    avatarDropdownItems: { default: void 0 },
    avatarDropdownWidth: { default: "288px" },
    avatarDropdownAriaLabel: { default: void 0 }
  },
  emits: ["action-click", "editor-action-click", "back", "update:title", "update:searchValue", "search-click", "search-keydown", "search-blur", "filter-click"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = R(null);
    n({
      /** The `<button>` of the `form-save` editor action, or null when there is none */
      buttonElement: m(() => {
        var p, x;
        return ((x = (p = r.value) == null ? void 0 : p[0]) == null ? void 0 : x.buttonElement) ?? null;
      })
    });
    const o = R(a.searchValue || "");
    $e(
      () => a.searchValue,
      (p) => {
        o.value = p || "";
      }
    ), $e(o, (p) => {
      l("update:searchValue", p);
    });
    let i = !1;
    const s = (p) => p.target instanceof HTMLInputElement, d = (p) => {
      s(p) && (i = document.activeElement === p.target);
    }, u = (p) => {
      const x = p.relatedTarget;
      p.currentTarget.contains(x) || s(p) && l("search-click");
    }, f = (p) => {
      i = !1, p.currentTarget.contains(p.relatedTarget) || l("search-blur");
    }, b = (p) => {
      s(p) && i && l("search-click");
    }, h = (p, x) => {
      p.onClick && p.onClick(), l("action-click", p, x);
    };
    return (p, x) => (c(), g("header", oV, [
      e.type === "editor" ? (c(), g("div", iV, [
        te(L(Me), {
          variant: "ghost",
          size: "md",
          "icon-left": "ri-arrow-left-line",
          label: e.backLabel,
          "data-testid": "navbar-back",
          onClick: x[0] || (x[0] = (y) => l("back"))
        }, null, 8, ["label"]),
        x[5] || (x[5] = v("span", {
          class: "h-8 w-px shrink-0 bg-(--colors-border-base-medium)",
          "aria-hidden": "true",
          "data-testid": "navbar-divider"
        }, null, -1)),
        v("div", sV, [
          v("div", dV, [
            te(jc, {
              "model-value": e.title,
              editable: e.editableTitle,
              error: e.titleError,
              "edit-label": e.editTitleLabel,
              "save-label": e.saveTitleLabel,
              "max-width": "100%",
              onSave: x[1] || (x[1] = (y) => l("update:title", y))
            }, null, 8, ["model-value", "editable", "error", "edit-label", "save-label"])
          ]),
          e.editorBadges.length ? (c(), W(li, {
            key: 0,
            badges: e.editorBadges,
            class: "shrink-0 items-start gap-1.5",
            "data-testid": "navbar-badges"
          }, null, 8, ["badges"])) : w("", !0)
        ]),
        e.editorStatus || e.editorActions.length ? (c(), g("div", uV, [
          e.editorStatus ? (c(), g("div", cV, [
            e.editorStatus.icon ? (c(), g("i", {
              key: 0,
              class: C([e.editorStatus.icon, "shrink-0 text-(length:--icon-size-xs) leading-(--icon-size-xs) text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"]),
              "aria-hidden": "true"
            }, null, 2)) : w("", !0),
            te(pt, {
              text: e.editorStatus.label,
              class: "min-w-0",
              "data-testid": "navbar-status-text"
            }, null, 8, ["text"])
          ])) : w("", !0),
          (c(!0), g(de, null, Re(e.editorActions, (y, k) => (c(), g(de, { key: k }, [
            y.kind === "form-save" ? (c(), W(lV, {
              key: 0,
              ref_for: !0,
              ref_key: "saveButtonRef",
              ref: r,
              enabled: y.enabled,
              saving: y.saving,
              "save-label": y.label,
              "saving-label": y.savingLabel,
              "disabled-hint": y.disabledHint,
              class: "shrink-0",
              "data-testid": "navbar-save",
              onSave: ($) => l("editor-action-click", y, k)
            }, null, 8, ["enabled", "saving", "save-label", "saving-label", "disabled-hint", "onSave"])) : (c(), W(L(Me), {
              key: 1,
              variant: y.variant,
              size: "md",
              "icon-left": y.icon,
              label: y.label,
              disabled: y.disabled,
              class: "shrink-0",
              onClick: ($) => l("editor-action-click", y, k)
            }, null, 8, ["variant", "icon-left", "label", "disabled", "onClick"]))
          ], 64))), 128))
        ])) : w("", !0)
      ])) : (c(), g("div", fV, [
        v("div", hV, [
          v("div", {
            role: "search",
            class: "min-w-0 flex-1",
            style: je({ maxWidth: e.searchWidth }),
            "data-testid": "navbar-search",
            onMousedown: d,
            onFocusin: u,
            onFocusout: f,
            onClick: b
          }, [
            te(ls, {
              modelValue: o.value,
              "onUpdate:modelValue": x[2] || (x[2] = (y) => o.value = y),
              placeholder: e.searchPlaceholder,
              "aria-label": e.searchLabel,
              "aria-controls": e.searchControls,
              "aria-expanded": e.searchExpanded,
              "aria-activedescendant": e.searchActivedescendant,
              labels: { clear: e.searchClearLabel },
              "icon-left": e.searchIcon,
              size: e.searchSize,
              disabled: e.searchDisabled,
              rounded: "full",
              onKeydown: x[3] || (x[3] = (y) => l("search-keydown", y))
            }, null, 8, ["modelValue", "placeholder", "aria-label", "aria-controls", "aria-expanded", "aria-activedescendant", "labels", "icon-left", "size", "disabled"])
          ], 36),
          e.filterIcon ? (c(), W(L(Me), {
            key: 0,
            variant: "primary",
            "icon-left": e.filterIcon,
            "icon-only": "",
            size: "xs",
            "aria-label": e.filterLabel,
            "data-testid": "navbar-filter",
            onClick: x[4] || (x[4] = () => p.$emit("filter-click"))
          }, null, 8, ["icon-left", "aria-label"])) : w("", !0)
        ]),
        v("div", bV, [
          (c(!0), g(de, null, Re(e.actions, (y, k) => (c(), g(de, { key: k }, [
            y.icon ? (c(), W(L(Me), {
              key: 0,
              variant: "secondary",
              "icon-left": y.icon,
              "icon-only": "",
              size: "xs",
              "aria-label": y.label || y.alt,
              onClick: ($) => h(y, k)
            }, null, 8, ["icon-left", "aria-label", "onClick"])) : w("", !0)
          ], 64))), 128)),
          e.avatar && !e.avatarDropdownItems ? (c(), W(Nt, {
            key: 0,
            name: e.avatar.name,
            img: e.avatar.img
          }, null, 8, ["name", "img"])) : w("", !0),
          e.avatar && e.avatarDropdownItems ? (c(), W(cn, {
            key: 1,
            avatar: e.avatar,
            items: e.avatarDropdownItems,
            "menu-align": "right",
            "menu-width": e.avatarDropdownWidth,
            "aria-label": e.avatarDropdownAriaLabel
          }, null, 8, ["avatar", "items", "menu-width", "aria-label"])) : w("", !0)
        ])
      ]))
    ]));
  }
}), gV = {
  "data-testid": "segmented-pager",
  role: "group",
  class: "inline-flex items-center shadow-(--blur-shadow-xs)"
}, mV = /* @__PURE__ */ ye({
  __name: "SegmentedPager",
  props: {
    prevLabel: {},
    nextLabel: {},
    prevDisabled: { type: Boolean, default: !1 },
    nextDisabled: { type: Boolean, default: !1 }
  },
  emits: ["prev", "next"],
  setup(e, { emit: n }) {
    const t = n;
    return (a, l) => (c(), g("div", gV, [
      te(Me, {
        variant: "secondary",
        size: "md",
        "icon-left": "ri-arrow-left-s-line",
        label: e.prevLabel,
        disabled: e.prevDisabled,
        "data-testid": "segmented-pager-prev",
        class: C(L(Jv)),
        onClick: l[0] || (l[0] = (r) => t("prev"))
      }, null, 8, ["label", "disabled", "class"]),
      te(Me, {
        variant: "secondary",
        size: "md",
        "icon-right": "ri-arrow-right-s-line",
        label: e.nextLabel,
        disabled: e.nextDisabled,
        "data-testid": "segmented-pager-next",
        class: C(L(Xv)),
        onClick: l[1] || (l[1] = (r) => t("next"))
      }, null, 8, ["label", "disabled", "class"])
    ]));
  }
}), pV = {
  class: "nav-header-title flex min-w-0 text-(length:--size-5xl) leading-(--line-height-5xl) font-(--weight-bold) text-(--text-text-heading) dark:text-(--colors-text-white-default)",
  "data-testid": "nav-header-title"
}, vV = /* @__PURE__ */ ye({
  __name: "NavHeaderTitle",
  props: {
    title: {},
    placeholder: {},
    editable: {}
  },
  emits: ["save"],
  setup(e, { emit: n }) {
    const t = e, a = m(() => t.title.trim() ? t.title : t.placeholder ?? ""), l = n;
    return (r, o) => (c(), g("h1", pV, [
      e.editable ? (c(), W(jc, {
        key: 0,
        "model-value": e.title,
        "empty-text": e.placeholder,
        placeholder: e.placeholder,
        "edit-label": e.editable.editLabel,
        "save-label": e.editable.saveLabel,
        size: "lg",
        "max-width": "100%",
        onSave: o[0] || (o[0] = (i) => l("save", i))
      }, null, 8, ["model-value", "empty-text", "placeholder", "edit-label", "save-label"])) : (c(), W(pt, {
        key: 1,
        text: a.value,
        position: "bottom"
      }, null, 8, ["text"]))
    ]));
  }
}), xV = /* @__PURE__ */ dt(vV, [["__scopeId", "data-v-615995d8"]]), yV = {
  ref: "root",
  class: "flex min-w-0 flex-col",
  "data-testid": "nav-header"
}, kV = {
  key: 0,
  class: "flex",
  "data-testid": "nav-header-back-row"
}, wV = {
  key: 0,
  class: "flex min-w-0 items-start gap-2"
}, CV = {
  key: 0,
  class: "min-w-0 text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--text-text-heading) dark:text-(--colors-text-white-default)",
  "data-testid": "nav-header-description"
}, SV = {
  key: 2,
  class: "min-w-0 text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--text-text-heading) dark:text-(--colors-text-white-default)",
  "data-testid": "nav-header-description"
}, $V = {
  key: 2,
  class: "flex shrink-0 items-center gap-1.5",
  "data-testid": "nav-header-icon-actions"
}, Jq = /* @__PURE__ */ ye({
  __name: "NavHeader",
  props: {
    type: {},
    title: {},
    titlePlaceholder: { default: "" },
    back: { default: void 0 },
    description: { default: void 0 },
    badges: { default: () => [] },
    maxBadges: { default: 3 },
    avatar: { default: void 0 },
    primaryAction: { default: void 0 },
    secondaryAction: { default: void 0 },
    iconActions: { default: () => [] },
    pagination: { default: void 0 },
    editableTitle: { default: void 0 }
  },
  emits: ["back", "primary-action", "primary-action-select", "secondary-action", "icon-action", "prev", "next", "title-save", "avatar-edit"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = ta("root");
    n({
      /**
       * Focuses the button of `iconActions[index]` (the trigger, for an action with a menu). For a host
       * returning focus after the menu item it opened closed: the item is unmounted with the menu, so
       * the overlay's own focus restore has nothing to land on.
       */
      focusIconAction(S) {
        var I, A;
        const T = (I = r.value) == null ? void 0 : I.querySelectorAll(
          '[data-testid="nav-header-icon-action"]'
        );
        (A = T == null ? void 0 : T[S]) == null || A.focus();
      }
    });
    const o = m(() => a.type === "wizard"), i = m(() => a.type === "table"), s = m(() => a.type === "record"), d = m(() => a.type === "settings");
    function u(S) {
      var T;
      if ((T = a.back) != null && T.href) {
        if (S.ctrlKey || S.metaKey || S.shiftKey || S.altKey || S.button !== 0) return;
        S.preventDefault();
      }
      l("back");
    }
    const f = m(() => !!a.back && !i.value), b = m(() => {
      var S;
      return !!((S = a.description) != null && S.trim()) && !s.value;
    }), h = m(
      () => s.value ? Wu(a.badges, a.maxBadges) : a.badges
    ), p = m(() => !!a.secondaryAction && !o.value), x = m(() => a.iconActions.length > 0 && (i.value || s.value)), y = m(() => o.value ? "md" : "lg"), k = {
      wizard: "min-h-18 gap-x-4 gap-y-3",
      table: "items-start gap-x-4 gap-y-3 px-0.5 py-3",
      record: "items-start justify-between gap-x-4 gap-y-3 py-1",
      settings: "items-center gap-y-3"
    }, $ = {
      wizard: "items-end",
      table: "items-center self-stretch",
      record: "items-center self-stretch",
      settings: "items-center"
    };
    return (S, T) => (c(), g("div", yV, [
      s.value && e.back ? (c(), g("div", kV, [
        te(Me, {
          variant: "text",
          size: "sm",
          "icon-left": "ri-arrow-left-line",
          label: e.back.label,
          as: e.back.href ? "a" : "button",
          href: e.back.href,
          "data-testid": "nav-header-back",
          onClick: u
        }, null, 8, ["label", "as", "href"])
      ])) : w("", !0),
      v("div", {
        class: C(["flex min-w-0 flex-wrap", k[e.type]]),
        "data-testid": "nav-header-row"
      }, [
        v("div", {
          class: C(["flex min-w-0 grow basis-64", {
            "flex-col items-start": o.value || d.value,
            "min-h-10 flex-col justify-center gap-1": i.value,
            "items-center gap-2": s.value
          }]),
          "data-testid": "nav-header-left"
        }, [
          f.value && !s.value ? (c(), W(Me, {
            key: 0,
            variant: "text",
            size: "sm",
            "icon-left": "ri-arrow-left-line",
            label: e.back.label,
            as: e.back.href ? "a" : "button",
            href: e.back.href,
            "data-testid": "nav-header-back",
            onClick: u
          }, null, 8, ["label", "as", "href"])) : w("", !0),
          s.value && e.avatar ? (c(), W(mt, {
            key: 1,
            text: e.avatar.editDisabledReason ?? "",
            disabled: !e.avatar.editLabel || !e.avatar.editDisabledReason
          }, {
            default: ve(() => [
              te(Nt, {
                name: e.avatar.name,
                img: e.avatar.img,
                entity: e.avatar.entity,
                "avatar-style": e.avatar.avatarStyle ?? "square",
                size: "xl",
                presentational: !e.avatar.editLabel,
                editable: !!e.avatar.editLabel,
                "edit-label": e.avatar.editLabel,
                "edit-disabled": !!e.avatar.editDisabledReason,
                "data-testid": "nav-header-avatar",
                onEdit: T[0] || (T[0] = (I) => l("avatar-edit"))
              }, null, 8, ["name", "img", "entity", "avatar-style", "presentational", "editable", "edit-label", "edit-disabled"])
            ]),
            _: 1
          }, 8, ["text", "disabled"])) : w("", !0),
          v("div", {
            class: C(["flex max-w-full min-w-0", {
              "flex-col": o.value,
              "flex-col gap-1": i.value || s.value,
              "flex-col gap-2 py-1": d.value
            }]),
            "data-testid": "nav-header-heading"
          }, [
            v("div", {
              class: C(["flex min-w-0 items-center", { "gap-4": o.value, "gap-2": d.value }])
            }, [
              te(xV, {
                title: e.title,
                placeholder: e.titlePlaceholder || void 0,
                editable: e.editableTitle,
                onSave: T[1] || (T[1] = (I) => l("title-save", I))
              }, null, 8, ["title", "placeholder", "editable"]),
              (o.value || d.value) && h.value.length ? (c(), W(li, {
                key: 0,
                badges: h.value,
                class: "shrink-0 items-center gap-2"
              }, null, 8, ["badges"])) : w("", !0)
            ], 2),
            i.value && (b.value || h.value.length) ? (c(), g("div", wV, [
              b.value ? (c(), g("p", CV, j(e.description), 1)) : w("", !0),
              h.value.length ? (c(), W(li, {
                key: 1,
                badges: h.value,
                class: "shrink-0 items-center gap-2"
              }, null, 8, ["badges"])) : w("", !0)
            ])) : w("", !0),
            s.value ? (c(), W(li, {
              key: 1,
              badges: h.value,
              class: "min-h-6 flex-wrap gap-1.5"
            }, null, 8, ["badges"])) : w("", !0),
            (o.value || d.value) && b.value ? (c(), g("p", SV, j(e.description), 1)) : w("", !0)
          ], 2)
        ], 2),
        e.primaryAction || p.value || x.value || o.value && e.pagination ? (c(), g("div", {
          key: 0,
          class: C(["ml-auto flex max-w-full min-w-0 flex-none flex-wrap justify-end gap-x-4 gap-y-3", $[e.type]]),
          "data-testid": "nav-header-right"
        }, [
          e.primaryAction ? (c(), g(de, { key: 0 }, [
            e.primaryAction.menu ? (c(), W(n8, {
              key: 0,
              variant: "primary",
              size: y.value,
              label: e.primaryAction.label,
              icon: e.primaryAction.icon,
              menu: e.primaryAction.menu,
              "menu-label": e.primaryAction.menuLabel,
              disabled: e.primaryAction.disabled,
              "aria-disabled": e.primaryAction.ariaDisabled,
              loading: e.primaryAction.loading,
              "loading-label": e.primaryAction.loadingLabel,
              "data-testid": "nav-header-primary",
              onClick: T[2] || (T[2] = (I) => l("primary-action", I)),
              onSelect: T[3] || (T[3] = (I) => l("primary-action-select", I))
            }, null, 8, ["size", "label", "icon", "menu", "menu-label", "disabled", "aria-disabled", "loading", "loading-label"])) : (c(), W(Me, {
              key: 1,
              variant: "primary",
              size: y.value,
              label: e.primaryAction.label,
              "icon-left": e.primaryAction.icon,
              disabled: e.primaryAction.disabled,
              "aria-disabled": e.primaryAction.ariaDisabled,
              loading: e.primaryAction.loading,
              "loading-label": e.primaryAction.loadingLabel,
              "data-testid": "nav-header-primary",
              onClick: T[4] || (T[4] = (I) => l("primary-action", I))
            }, null, 8, ["size", "label", "icon-left", "disabled", "aria-disabled", "loading", "loading-label"]))
          ], 64)) : w("", !0),
          p.value ? (c(), g(de, { key: 1 }, [
            e.secondaryAction.menu ? (c(), W(cn, {
              key: 0,
              items: e.secondaryAction.menu,
              "menu-align": "right"
            }, {
              trigger: ve(({ triggerProps: I }) => [
                te(Me, Fe(I, {
                  variant: "secondary",
                  size: "lg",
                  label: e.secondaryAction.label,
                  "icon-left": e.secondaryAction.icon,
                  "dropdown-icon": "",
                  disabled: e.secondaryAction.disabled,
                  "aria-disabled": e.secondaryAction.ariaDisabled,
                  "data-testid": "nav-header-secondary"
                }), null, 16, ["label", "icon-left", "disabled", "aria-disabled"])
              ]),
              _: 1
            }, 8, ["items"])) : (c(), W(Me, {
              key: 1,
              variant: "secondary",
              size: "lg",
              label: e.secondaryAction.label,
              "icon-left": e.secondaryAction.icon,
              disabled: e.secondaryAction.disabled,
              "aria-disabled": e.secondaryAction.ariaDisabled,
              "data-testid": "nav-header-secondary",
              onClick: T[5] || (T[5] = (I) => l("secondary-action", I))
            }, null, 8, ["label", "icon-left", "disabled", "aria-disabled"]))
          ], 64)) : w("", !0),
          x.value ? (c(), g("div", $V, [
            (c(!0), g(de, null, Re(e.iconActions, (I, A) => (c(), g(de, { key: A }, [
              I.menu ? (c(), W(cn, {
                key: 0,
                items: I.menu,
                "menu-align": "right"
              }, {
                trigger: ve(({ triggerProps: E }) => [
                  te(Me, Fe({ ref_for: !0 }, E, {
                    variant: "secondary",
                    size: "lg",
                    "icon-only": "",
                    "icon-left": I.icon,
                    "aria-label": I.label,
                    disabled: I.disabled,
                    "aria-disabled": I.ariaDisabled,
                    "data-testid": "nav-header-icon-action"
                  }), null, 16, ["icon-left", "aria-label", "disabled", "aria-disabled"])
                ]),
                _: 2
              }, 1032, ["items"])) : (c(), W(Me, {
                key: 1,
                variant: "secondary",
                size: "lg",
                "icon-only": "",
                "icon-left": I.icon,
                "aria-label": I.label,
                disabled: I.disabled,
                "aria-disabled": I.ariaDisabled,
                "data-testid": "nav-header-icon-action",
                onClick: (E) => l("icon-action", I, A)
              }, null, 8, ["icon-left", "aria-label", "disabled", "aria-disabled", "onClick"]))
            ], 64))), 128))
          ])) : w("", !0),
          o.value && e.pagination ? (c(), W(mV, {
            key: 3,
            "prev-label": e.pagination.prevLabel,
            "next-label": e.pagination.nextLabel,
            "prev-disabled": e.pagination.prevDisabled,
            "next-disabled": e.pagination.nextDisabled,
            "data-testid": "nav-header-pagination",
            onPrev: T[6] || (T[6] = (I) => l("prev")),
            onNext: T[7] || (T[7] = (I) => l("next"))
          }, null, 8, ["prev-label", "next-label", "prev-disabled", "next-disabled"])) : w("", !0)
        ], 2)) : w("", !0)
      ], 2)
    ], 512));
  }
}), IV = /* @__PURE__ */ ye({
  __name: "SpeedDial",
  props: {
    primaryIcon: {},
    primaryIconAlt: { default: "" },
    items: {},
    size: { default: "md" },
    orientation: { default: "vertical" },
    direction: { default: "top" },
    open: { type: Boolean, default: !1 }
  },
  emits: ["update:open", "item-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R(t.open);
    $e(
      () => t.open,
      (h) => {
        l.value = h;
      }
    );
    const r = (h) => {
      l.value = h, a("update:open", h);
    }, o = () => {
      r(!l.value);
    }, i = (h, p) => {
      h.onClick && h.onClick(p), a("item-click", h, p);
    }, s = m(() => {
      const h = "relative w-full flex p-2.5 box-border gap-2";
      return t.orientation === "horizontal" ? t.direction === "left" ? `${h} flex-row items-center` : `${h} flex-row-reverse items-center` : t.direction === "top" ? `${h} flex-col-reverse items-end` : `${h} flex-col items-end`;
    }), d = m(() => ({
      position: "relative"
    })), u = m(() => {
      const h = "flex items-center";
      return t.orientation === "horizontal" ? `${h} flex-row` : `${h} flex-col`;
    }), f = m(() => (t.orientation === "horizontal", "gap-2")), b = m(() => t.direction);
    return (h, p) => (c(), g("div", {
      class: C([s.value, "speed-dial-container"])
    }, [
      te(Ur, {
        name: `speed-dial-${b.value}`,
        tag: "div",
        class: C([[u.value, f.value], "relative"]),
        style: je(d.value)
      }, {
        default: ve(() => [
          (c(!0), g(de, null, Re(l.value ? e.items : [], (x, y) => (c(), W(L(Me), {
            key: `speed-dial-item-${y}`,
            variant: "secondary",
            "icon-left": x.icon,
            "icon-only": "",
            "aria-label": x.iconAlt,
            size: e.size,
            style: je({
              "--index": y
            }),
            class: "relative",
            onClick: (k) => i(x, k)
          }, null, 8, ["icon-left", "aria-label", "size", "style", "onClick"]))), 128))
        ]),
        _: 1
      }, 8, ["name", "class", "style"]),
      te(L(Me), {
        variant: "primary",
        "icon-left": e.primaryIcon,
        "icon-only": "",
        "aria-label": e.primaryIconAlt,
        size: e.size,
        class: "relative z-20 speed-dial-primary-button",
        onClick: o
      }, null, 8, ["icon-left", "aria-label", "size"])
    ], 2));
  }
}), Xq = /* @__PURE__ */ dt(IV, [["__scopeId", "data-v-0eb94464"]]);
function LV(e) {
  return !!e.duration && e.status !== "error" && !e.link && !e.primaryAction && !e.secondaryAction;
}
function ix(e) {
  return (e.layout ?? "default") === "default" && (e.status === "error" || e.status === "warning");
}
function TV(e) {
  const n = e.layout === "withHeader" && e.avatar ? `${e.avatar.name} ${e.message}` : e.message;
  return [e.title, n].filter(Boolean).join(". ");
}
const AV = 3, Yn = R([]), Wr = /* @__PURE__ */ new Map(), xr = /* @__PURE__ */ new Set();
let Sb = !1;
function $b(e) {
  const n = Wr.get(e);
  n != null && n.handle && clearTimeout(n.handle), Wr.delete(e);
}
function EV() {
  function e(i, s) {
    s.startedAt = Date.now(), s.handle = setTimeout(() => o(i), s.remaining);
  }
  function n(i) {
    if (!LV(i)) return;
    const s = /* @__PURE__ */ new Set();
    Sb && s.add("window"), xr.has(i.id) && s.add("pointer");
    const d = { remaining: i.duration, startedAt: 0, pausedBy: s };
    Wr.set(i.id, d), s.size || e(i.id, d);
  }
  function t(i) {
    const s = (f) => (f.layout ?? "default") === "default", d = s(i) ? Yn.value.findIndex(
      (f) => s(f) && f.status === i.status && f.title === i.title && f.message === i.message
    ) : -1;
    if (d >= 0) {
      const f = { ariaClose: "Close", ...i, id: Yn.value[d].id };
      return $b(f.id), Yn.value[d] = f, n(f), f.id;
    }
    const u = {
      id: crypto.randomUUID(),
      ariaClose: "Close",
      ...i
    };
    if (Yn.value.length >= AV) {
      const f = Yn.value.find(
        (b) => b.status !== "error" && !b.link && !b.primaryAction && !b.secondaryAction && !xr.has(b.id)
      );
      f && o(f.id);
    }
    return Yn.value.push(u), n(u), u.id;
  }
  function a(i, s = "pointer") {
    s === "pointer" && xr.add(i);
    const d = Wr.get(i);
    d && (d.pausedBy.add(s), d.handle && (clearTimeout(d.handle), d.handle = void 0, d.remaining = Math.max(0, d.remaining - (Date.now() - d.startedAt))));
  }
  function l(i, s = "pointer") {
    s === "pointer" && xr.delete(i);
    const d = Wr.get(i);
    d && (d.pausedBy.delete(s), !(d.handle || d.pausedBy.size) && e(i, d));
  }
  function r(i) {
    Sb = i, Yn.value.forEach(
      (s) => i ? a(s.id, "window") : l(s.id, "window")
    );
  }
  function o(i) {
    $b(i), xr.delete(i), Yn.value = Yn.value.filter((s) => s.id !== i);
  }
  return {
    toasts: Yn,
    showToast: t,
    removeToast: o,
    pauseToast: a,
    resumeToast: l,
    setWindowBlurred: r
  };
}
const pd = /* @__PURE__ */ ye({
  __name: "ToastActions",
  props: {
    primary: {},
    secondary: {}
  },
  emits: ["run"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => {
      const r = [];
      return t.primary && r.push({ action: t.primary, variant: "primary" }), t.secondary && r.push({ action: t.secondary, variant: "secondary" }), r;
    });
    return (r, o) => l.value.length ? (c(), g("div", {
      key: 0,
      "data-testid": "toast-actions",
      class: C(["grid items-center gap-3", l.value.length > 1 ? "grid-cols-2" : "grid-cols-1"])
    }, [
      (c(!0), g(de, null, Re(l.value, ({ action: i, variant: s }) => (c(), W(L(Me), {
        key: s,
        variant: s,
        size: "xs",
        "full-width": "",
        label: i.label,
        "icon-left": i.icon,
        onClick: (d) => a("run", i.onClick)
      }, null, 8, ["variant", "label", "icon-left", "onClick"]))), 128))
    ], 2)) : w("", !0);
  }
}), RV = ["role", "aria-atomic"], BV = { class: "flex min-w-0 flex-1 flex-col gap-1" }, MV = { class: "flex flex-col gap-px" }, DV = {
  key: 0,
  "data-testid": "toast-name",
  class: "text-(length:--size-l) leading-(--line-height-l-tight) font-(--weight-semi-bold)"
}, zV = {
  "data-testid": "toast-message",
  class: "text-(length:--size-m) leading-(--line-height-l)"
}, OV = {
  key: 0,
  "data-testid": "toast-time",
  class: "text-(length:--size-sm) leading-(--line-height-xs)"
}, PV = {
  key: 1,
  "data-testid": "toast-content",
  class: "flex items-start gap-3"
}, FV = { class: "flex min-w-0 flex-1 flex-col gap-3.5" }, VV = {
  key: 0,
  "data-testid": "toast-title",
  class: "text-(length:--size-l) font-(--weight-bold)"
}, NV = { "data-testid": "toast-message" }, HV = {
  key: 2,
  "data-testid": "toast-message-group",
  class: "flex min-w-0 flex-1 items-start gap-3"
}, jV = {
  "data-testid": "toast-icon",
  class: "inline-flex shrink-0 items-center justify-center",
  "aria-hidden": "true"
}, WV = { class: "flex min-w-0 flex-1 flex-col gap-1 text-(length:--size-m) leading-(--line-height-m)" }, qV = {
  key: 0,
  "data-testid": "toast-title",
  class: "text-(length:--size-l) leading-(--line-height-l) font-(--weight-bold)"
}, UV = /* @__PURE__ */ ye({
  __name: "ToastItem",
  props: {
    toast: {}
  },
  emits: ["close", "pause", "resume"],
  setup(e, { emit: n }) {
    const t = e, a = n;
    let l = !1, r = !1;
    function o($, S) {
      const T = l || r;
      l = $, r = S;
      const I = l || r;
      I && !T && a("pause"), !I && T && a("resume");
    }
    function i($) {
      $.currentTarget.contains($.relatedTarget) || o(l, !1);
    }
    function s($) {
      $.key === "Escape" && ($.stopPropagation(), $.preventDefault(), a("close"));
    }
    const d = m(() => t.toast.layout ?? "default"), u = m(() => ix(t.toast) ? "alert" : void 0), f = {
      default: "items-center justify-between gap-3 p-4",
      withHeader: "flex-col gap-4 p-[calc(--spacing(4)-1px)]",
      iconShape: "flex-col p-[calc(--spacing(4)-1px)]"
    }, b = {
      success: {
        color: "text-(--icons-icon-success)",
        leading: "leading-(--line-height-l)",
        icon: "ri-checkbox-circle-fill"
      },
      info: {
        color: "text-(--icons-icon-info)",
        leading: "leading-(--line-height-l)",
        icon: "ri-information-fill"
      },
      warning: {
        color: "text-(--icons-icon-warning)",
        leading: "leading-(--line-height-m)",
        icon: "ri-alert-fill"
      },
      error: {
        color: "text-(--icons-icon-error)",
        leading: "leading-(--line-height-l)",
        icon: "ri-error-warning-fill"
      }
    }, h = m(() => b[t.toast.status]), p = m(
      () => d.value !== "withHeader" || !t.toast.primaryAction && !t.toast.secondaryAction
    ), x = m(() => p.value && d.value !== "default" ? "pe-6" : "");
    function y($) {
      try {
        $ == null || $();
      } finally {
        a("close");
      }
    }
    function k() {
      var $;
      ($ = t.toast.link) != null && $.onClick && y(t.toast.link.onClick);
    }
    return ($, S) => (c(), g("div", {
      class: C(["relative flex w-full overflow-hidden rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-medium) bg-(--background-background-black-default) text-(--text-text-white-default) shadow-(--blur-shadow-toast)", f[d.value]]),
      "data-testid": "toast",
      role: u.value,
      "aria-atomic": u.value ? "true" : void 0,
      onMouseenter: S[1] || (S[1] = (T) => o(!0, L(r))),
      onMouseleave: S[2] || (S[2] = (T) => o(!1, L(r))),
      onFocusin: S[3] || (S[3] = (T) => o(L(l), !0)),
      onFocusout: i,
      onKeydown: s
    }, [
      d.value === "withHeader" ? (c(), g(de, { key: 0 }, [
        e.toast.title ? (c(), g("div", {
          key: 0,
          "data-testid": "toast-header",
          class: C(["py-1 text-(length:--size-l) leading-(--line-height-l) font-(--weight-bold)", x.value])
        }, j(e.toast.title), 3)) : w("", !0),
        v("div", {
          "data-testid": "toast-avatar-row",
          class: C(["flex items-start gap-3", !e.toast.title && x.value])
        }, [
          e.toast.avatar ? (c(), W(L(Nt), {
            key: 0,
            img: e.toast.avatar.src,
            name: e.toast.avatar.name,
            presentational: ""
          }, null, 8, ["img", "name"])) : w("", !0),
          v("div", BV, [
            v("div", MV, [
              e.toast.avatar ? (c(), g("div", DV, j(e.toast.avatar.name), 1)) : w("", !0),
              v("div", zV, j(e.toast.message), 1)
            ]),
            e.toast.time ? (c(), g("div", OV, j(e.toast.time), 1)) : w("", !0)
          ])
        ], 2),
        te(pd, {
          primary: e.toast.primaryAction,
          secondary: e.toast.secondaryAction,
          onRun: y
        }, null, 8, ["primary", "secondary"])
      ], 64)) : d.value === "iconShape" ? (c(), g("div", PV, [
        e.toast.icon ? (c(), W(Gt, {
          key: 0,
          "data-testid": "toast-icon-shape",
          color: "white",
          variant: "outlined",
          size: "md",
          icon: e.toast.icon
        }, null, 8, ["icon"])) : w("", !0),
        v("div", FV, [
          v("div", {
            class: C(["flex flex-col gap-2 text-(length:--size-m) leading-(--line-height-l)", x.value])
          }, [
            e.toast.title ? (c(), g("div", VV, j(e.toast.title), 1)) : w("", !0),
            v("div", NV, j(e.toast.message), 1)
          ], 2),
          te(pd, {
            primary: e.toast.primaryAction,
            secondary: e.toast.secondaryAction,
            onRun: y
          }, null, 8, ["primary", "secondary"])
        ])
      ])) : (c(), g("div", HV, [
        v("div", jV, [
          v("i", {
            class: C(["size-(--icon-size-md) text-(length:--icon-size-md) leading-(--icon-size-md)", [h.value.icon, h.value.color]])
          }, null, 2)
        ]),
        v("div", WV, [
          e.toast.title ? (c(), g("div", qV, j(e.toast.title), 1)) : w("", !0),
          v("div", {
            "data-testid": "toast-message",
            class: C(h.value.leading)
          }, j(e.toast.message), 3),
          e.toast.link ? (c(), W(L(Mn), {
            key: 1,
            "data-testid": "toast-link",
            class: "self-start text-(--text-text-link-on-dark)!",
            as: e.toast.link.href ? "a" : "button",
            href: e.toast.link.href,
            onClick: k
          }, {
            default: ve(() => [
              nt(j(e.toast.link.label), 1)
            ]),
            _: 1
          }, 8, ["as", "href"])) : w("", !0),
          te(pd, {
            class: "mt-3.5",
            primary: e.toast.primaryAction,
            secondary: e.toast.secondaryAction,
            onRun: y
          }, null, 8, ["primary", "secondary"])
        ])
      ])),
      p.value ? (c(), g("div", {
        key: 3,
        "data-testid": "toast-close",
        class: C(d.value === "default" ? "flex shrink-0" : "absolute top-1 right-1")
      }, [
        te(L(Me), {
          class: "[&_i]:text-(--icons-icon-white-default)! hover:[&_i]:text-(--icons-icon-dark-default)! [&_i]:text-(length:--icon-size-sm) [&_i]:leading-(--icon-size-sm)",
          variant: "ghost",
          size: "xs",
          "icon-only": "",
          "icon-left": "ri-close-fill",
          "aria-label": t.toast.ariaClose,
          onClick: S[0] || (S[0] = (T) => a("close"))
        }, null, 8, ["aria-label"])
      ], 2)) : w("", !0)
    ], 42, RV));
  }
}), GV = {
  role: "status",
  "aria-live": "polite",
  "aria-atomic": "true",
  class: "sr-only",
  "data-testid": "toast-live-polite"
}, KV = 250, Zq = /* @__PURE__ */ ye({
  __name: "ToastContainer",
  setup(e) {
    const { toasts: n, removeToast: t, pauseToast: a, resumeToast: l, setWindowBlurred: r } = EV(), o = R();
    let i, s = !1, d = null;
    const u = R("");
    let f = new Map(n.value.map(($) => [$.id, $])), b = /* @__PURE__ */ new Set();
    function h($) {
      var z, Y, le;
      const S = $.map((ne) => {
        var re;
        return (re = o.value) == null ? void 0 : re.querySelector(`[data-toast-id="${ne}"]`);
      }), T = S.find((ne) => ne == null ? void 0 : ne.contains(document.activeElement));
      if (!T) return;
      const I = d;
      if (d = null, I != null && I.isConnected) return I.focus();
      if (!((z = document.activeElement) != null && z.matches(":focus-visible"))) return;
      const A = [...((Y = o.value) == null ? void 0 : Y.querySelectorAll("[data-toast-id]")) ?? []], E = A.indexOf(T), D = [...A.slice(E + 1), ...A.slice(0, E).reverse()].find(
        (ne) => !S.includes(ne)
      );
      (le = D == null ? void 0 : D.querySelector("button")) == null || le.focus();
    }
    $e(
      () => [...n.value],
      async ($) => {
        const S = new Map($.map((I) => [I.id, I]));
        h([...f.keys()].filter((I) => !S.has(I)));
        const T = $.filter((I) => f.has(I.id) ? f.get(I.id) !== I : !ix(I));
        if (f = S, !T.length) {
          b.size && ![...b].some((I) => S.has(I)) && (u.value = "", b = /* @__PURE__ */ new Set());
          return;
        }
        b = new Set(T.map((I) => I.id)), u.value = "", await Ge(), u.value = T.map(TV).join(" ");
      }
    );
    function p() {
      const $ = !document.hasFocus();
      $ !== s && (s = $, r($));
    }
    function x($) {
      clearInterval(i), i = void 0, $ && (p(), i = setInterval(p, KV));
    }
    $e(() => n.value.length > 0, x, { flush: "sync" });
    function y($) {
      var T;
      const S = $.relatedTarget;
      S instanceof HTMLElement && !((T = o.value) != null && T.contains(S)) && (d = S);
    }
    function k($) {
      var T;
      const S = $.relatedTarget;
      (S instanceof Node ? !((T = o.value) != null && T.contains(S)) : document.hasFocus()) && (d = null);
    }
    return ct(() => {
      s = !document.hasFocus(), r(s), x(n.value.length > 0);
    }), yt(() => {
      x(!1), r(!1);
    }), ($, S) => (c(), g("div", {
      ref_key: "root",
      ref: o,
      class: "fixed right-4 z-[500] w-80 max-w-[calc(100vw-2rem)]",
      style: { top: "var(--toast-container-top, 1rem)" },
      onFocusin: y,
      onFocusout: k
    }, [
      v("div", GV, j(u.value), 1),
      te(Ur, {
        name: "toast",
        tag: "div",
        class: "flex max-h-[calc(100vh-var(--toast-container-top,1rem)-1rem+--spacing(5))] flex-col gap-3 overflow-x-hidden overflow-y-auto not-empty:-m-2.5 not-empty:p-2.5 *:shrink-0"
      }, {
        default: ve(() => [
          (c(!0), g(de, null, Re(L(n), (T) => (c(), W(UV, {
            key: T.id,
            toast: T,
            "data-toast-id": T.id,
            onClose: (I) => L(t)(T.id),
            onPause: (I) => L(a)(T.id, "pointer"),
            onResume: (I) => L(l)(T.id, "pointer")
          }, null, 8, ["toast", "data-toast-id", "onClose", "onPause", "onResume"]))), 128))
        ]),
        _: 1
      })
    ], 544));
  }
}), YV = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z"/></svg>', JV = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"/></svg>', XV = { key: 0 }, ZV = {
  key: 0,
  "data-testid": "form-error-summary-inline",
  class: "inline-flex items-center gap-2 px-3 py-1.5 rounded-(--border-border-radius-rounded-sm) bg-(--background-background-error) border border-solid border-(--border-border-error-subtle) text-(length:--size-m) leading-(--line-height-l) text-(--text-text-heading) font-(--weight-medium)"
}, QV = ["innerHTML"], _V = ["innerHTML"], eN = {
  key: 0,
  "data-testid": "form-error-summary-menu",
  class: "absolute left-0 top-[calc(100%+4px)] z-50 min-w-56 rounded-(--border-border-radius-rounded-l) border border-solid border-(--border-border-error-subtle) bg-white-50-opacity-bold p-3 shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] dark:border-(--border-border-base) dark:bg-(--background-background-black-default) dark:shadow-(--blur-shadow-m-dark)"
}, tN = {
  key: 0,
  "data-testid": "form-error-summary-list-heading",
  class: "mb-2 text-(length:--size-sm) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-body) dark:text-(--text-text-white-secondary)"
}, nN = { class: "flex flex-col gap-1" }, aN = ["onClick"], lN = ["innerHTML"], Qq = /* @__PURE__ */ ye({
  __name: "FormErrorSummary",
  props: {
    errors: {},
    mode: { default: "inline" },
    heading: { default: void 0 },
    triggerLabel: { default: void 0 },
    listHeading: { default: void 0 }
  },
  emits: ["navigateToField"],
  setup(e, { emit: n }) {
    const t = n, { isOpen: a, dropdownRef: l, toggleDropdown: r, closeDropdown: o } = ar(), i = m(
      () => YV.replace("<svg", '<svg width="16" height="16" style="display: block;"')
    ), s = m(
      () => JV.replace("<svg", '<svg width="12" height="12" style="display: block;"')
    ), d = (u) => {
      o(), t("navigateToField", u);
    };
    return (u, f) => e.errors.length > 0 ? (c(), g("div", XV, [
      e.mode === "inline" ? (c(), g("div", ZV, [
        v("span", {
          class: "h-4 w-4 flex-shrink-0 inline-flex items-center justify-center text-(--icons-icon-error)",
          innerHTML: i.value
        }, null, 8, QV),
        v("span", null, j(e.heading), 1)
      ])) : (c(), g("div", {
        key: 1,
        ref_key: "dropdownRef",
        ref: l,
        class: "relative inline-block"
      }, [
        v("button", {
          type: "button",
          "data-testid": "form-error-summary-trigger",
          class: "inline-flex items-center gap-1.5 rounded-(--border-border-radius-rounded-full) border border-solid border-(--border-border-error-subtle) bg-(--background-background-error) px-3 py-1.5 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-heading) cursor-pointer transition-opacity hover:opacity-80",
          onClick: f[0] || (f[0] = //@ts-ignore
          (...b) => L(r) && L(r)(...b))
        }, [
          v("span", {
            class: "h-4 w-4 flex-shrink-0 inline-flex items-center justify-center text-(--icons-icon-error)",
            innerHTML: i.value
          }, null, 8, _V),
          v("span", null, j(e.triggerLabel), 1),
          (c(), g("svg", {
            class: "h-4 w-4 transition-transform duration-200",
            style: je({ transform: L(a) ? "rotate(180deg)" : "rotate(0deg)" }),
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [...f[1] || (f[1] = [
            v("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M19 9l-7 7-7-7"
            }, null, -1)
          ])], 4))
        ]),
        te(At, {
          "enter-active-class": "transition duration-100 ease-out",
          "enter-from-class": "transform scale-95 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100",
          "leave-active-class": "transition duration-75 ease-out",
          "leave-from-class": "transform scale-100 opacity-100",
          "leave-to-class": "transform scale-95 opacity-0"
        }, {
          default: ve(() => [
            L(a) ? (c(), g("div", eN, [
              e.listHeading ? (c(), g("p", tN, j(e.listHeading), 1)) : w("", !0),
              v("ul", nN, [
                (c(!0), g(de, null, Re(e.errors, (b) => (c(), g("li", {
                  key: b.key
                }, [
                  v("button", {
                    type: "button",
                    "data-testid": "form-error-summary-item",
                    class: "inline-flex w-full items-center gap-1.5 rounded-(--border-border-radius-rounded-sm) px-2 py-1 text-(length:--size-m) leading-(--line-height-l) text-(--text-text-body) cursor-pointer transition-colors hover:bg-(--background-background-error) dark:text-(--text-text-white-secondary) dark:hover:bg-white/8",
                    onClick: (h) => d(b.key)
                  }, [
                    v("span", {
                      class: "h-3 w-3 flex-shrink-0 inline-flex items-center justify-center text-(--icons-icon-error)",
                      innerHTML: s.value
                    }, null, 8, lN),
                    v("span", null, j(b.label), 1)
                  ], 8, aN)
                ]))), 128))
              ])
            ])) : w("", !0)
          ]),
          _: 1
        })
      ], 512))
    ])) : w("", !0);
  }
}), rN = ["id"], _q = /* @__PURE__ */ ye({
  __name: "DynamicFormField",
  props: {
    field: {},
    modelValue: {},
    error: {}
  },
  emits: ["update:modelValue", "country-change", "blur"],
  setup(e) {
    return (n, t) => (c(), g("div", {
      id: `field-${e.field.key}`
    }, [
      e.field.type === "email" ? (c(), W(mB, {
        key: 0,
        "model-value": e.modelValue,
        label: e.field.label,
        required: e.field.required,
        readonly: e.field.readonly,
        size: e.field.size,
        "full-width": !0,
        hint: e.field.hint,
        placeholder: e.field.placeholder ?? "",
        error: e.error,
        "onUpdate:modelValue": t[0] || (t[0] = (a) => n.$emit("update:modelValue", a)),
        onBlur: t[1] || (t[1] = (a) => n.$emit("blur"))
      }, null, 8, ["model-value", "label", "required", "readonly", "size", "hint", "placeholder", "error"])) : e.field.type === "text" ? (c(), W(Wt, {
        key: 1,
        "model-value": e.modelValue,
        label: e.field.label,
        required: e.field.required,
        readonly: e.field.readonly,
        size: e.field.size,
        "full-width": !0,
        placeholder: e.field.placeholder ?? "",
        error: e.error,
        "onUpdate:modelValue": t[2] || (t[2] = (a) => n.$emit("update:modelValue", a)),
        onBlur: t[3] || (t[3] = (a) => n.$emit("blur"))
      }, null, 8, ["model-value", "label", "required", "readonly", "size", "placeholder", "error"])) : e.field.type === "phone" ? (c(), W(RB, {
        key: 2,
        "model-value": e.modelValue,
        label: e.field.label,
        readonly: e.field.readonly,
        "show-country-selector": e.field.showCountrySelector,
        countries: e.field.countries,
        "full-width": !0,
        size: e.field.size,
        error: e.error,
        "onUpdate:modelValue": t[4] || (t[4] = (a) => n.$emit("update:modelValue", a)),
        onBlur: t[5] || (t[5] = (a) => n.$emit("blur")),
        onCountryChange: t[6] || (t[6] = (a, l) => n.$emit("country-change", { dialCode: a.dialCode, nationalNumber: l }))
      }, null, 8, ["model-value", "label", "readonly", "show-country-selector", "countries", "size", "error"])) : e.field.type === "select" ? (c(), W(ll, {
        key: 3,
        "model-value": e.modelValue,
        options: e.field.options || [],
        label: e.field.label,
        required: e.field.required,
        readonly: e.field.readonly,
        "full-width": !0,
        hint: e.field.hint,
        error: e.error,
        "onUpdate:modelValue": t[7] || (t[7] = (a) => n.$emit("update:modelValue", a)),
        onBlur: t[8] || (t[8] = (a) => n.$emit("blur"))
      }, null, 8, ["model-value", "options", "label", "required", "readonly", "hint", "error"])) : w("", !0)
    ], 8, rN));
  }
}), oN = /* @__PURE__ */ ye({
  __name: "UnsavedChangesModal",
  props: {
    modelValue: { type: Boolean },
    title: {},
    message: {},
    stayLabel: {},
    leaveLabel: {},
    saveLabel: {},
    saveDisabled: { type: Boolean }
  },
  emits: ["update:modelValue", "stay", "leave", "discard", "save"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m({
      get: () => t.modelValue,
      set: (u) => a("update:modelValue", u)
    }), r = m(
      () => t.saveLabel ? [
        {
          id: "discard",
          label: t.leaveLabel,
          variant: "secondary",
          testId: "unsaved-discard",
          onClick: s
        },
        {
          id: "save",
          label: t.saveLabel,
          variant: "primary",
          disabled: t.saveDisabled,
          testId: "unsaved-save",
          onClick: d
        }
      ] : [
        { id: "leave", label: t.leaveLabel, variant: "secondary", testId: "unsaved-leave", onClick: i },
        { id: "stay", label: t.stayLabel, variant: "primary", testId: "unsaved-stay", onClick: o }
      ]
    );
    function o() {
      a("update:modelValue", !1), a("stay");
    }
    function i() {
      a("update:modelValue", !1), a("leave");
    }
    function s() {
      a("update:modelValue", !1), a("discard");
    }
    function d() {
      t.saveDisabled || a("save");
    }
    return (u, f) => (c(), W(Ka, {
      modelValue: l.value,
      "onUpdate:modelValue": f[0] || (f[0] = (b) => l.value = b),
      size: "xs",
      dismissable: !1,
      "close-on-escape": !0,
      title: e.title,
      subtitle: e.message,
      icon: "ℹ️",
      "header-align": "middle-stacked",
      "footer-align": "center",
      actions: r.value,
      "overlay-class": "!z-[400]",
      onClose: o
    }, null, 8, ["modelValue", "title", "subtitle", "actions"]));
  }
}), eU = /* @__PURE__ */ ye({
  __name: "ConfirmDeleteModal",
  props: {
    modelValue: { type: Boolean },
    title: {},
    subtitle: {},
    confirmLabel: {},
    cancelLabel: {},
    icon: { default: "ri-delete-bin-6-line" },
    confirmDisabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "confirm", "cancel"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m({
      get: () => t.modelValue,
      set: (s) => a("update:modelValue", s)
    }), r = m(() => [
      {
        id: "cancel",
        label: t.cancelLabel,
        variant: "secondary",
        testId: "confirm-delete-modal-cancel",
        onClick: i
      },
      {
        id: "confirm",
        label: t.confirmLabel,
        variant: "error",
        icon: "ri-delete-bin-6-line",
        disabled: t.confirmDisabled,
        testId: "confirm-delete-modal-confirm",
        onClick: o
      }
    ]);
    function o() {
      t.confirmDisabled || (a("update:modelValue", !1), a("confirm"));
    }
    function i() {
      a("update:modelValue", !1), a("cancel");
    }
    return (s, d) => (c(), W(Ka, {
      modelValue: l.value,
      "onUpdate:modelValue": d[0] || (d[0] = (u) => l.value = u),
      size: "xs",
      dismissable: !1,
      "close-on-escape": !0,
      title: e.title,
      subtitle: e.subtitle,
      icon: e.icon,
      "header-align": "middle-stacked",
      "footer-align": "center",
      actions: r.value,
      "data-testid": "confirm-delete-modal-body",
      onClose: i
    }, null, 8, ["modelValue", "title", "subtitle", "icon", "actions"]));
  }
}), iN = /* @__PURE__ */ ye({
  __name: "DataTableContainer",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    tableWidth: {}
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), g("table", {
      "data-slot": "table",
      class: C([
        "min-w-full table-fixed border-spacing-0 text-sm text-left text-text-black-default",
        n.class
      ]),
      style: je(e.tableWidth ? { width: e.tableWidth } : void 0)
    }, [
      Ae(t.$slots, "default")
    ], 6));
  }
}), sN = /* @__PURE__ */ ye({
  __name: "DataTableBody",
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), g("tbody", {
      "data-slot": "table-body",
      class: C(["", n.class])
    }, [
      Ae(t.$slots, "default")
    ], 2));
  }
}), tU = /* @__PURE__ */ ye({
  __name: "DataTableCaption",
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), g("caption", {
      "data-slot": "table-caption",
      class: C(["text-muted-foreground mt-4 text-sm", n.class])
    }, [
      Ae(t.$slots, "default")
    ], 2));
  }
}), yu = /* @__PURE__ */ ye({
  __name: "DataTableCell",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    noTruncate: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = R(null);
    function a() {
      var r;
      const l = t.value;
      l && (l.scrollWidth > l.clientWidth ? l.title = ((r = l.textContent) == null ? void 0 : r.trim()) ?? "" : l.title = "");
    }
    return (l, r) => (c(), g("td", {
      "data-slot": "table-cell",
      class: C([
        "leading-5 font-medium text-sm p-3 h-12 align-middle [&:has([type=checkbox])]:pr-0 [&:has([type=checkbox])]:max-w-none",
        e.noTruncate ? "overflow-visible" : "overflow-hidden max-w-0",
        n.class
      ])
    }, [
      e.noTruncate ? Ae(l.$slots, "default", { key: 1 }) : (c(), g("div", {
        key: 0,
        ref_key: "truncateRef",
        ref: t,
        class: "truncate",
        onMouseenter: a
      }, [
        Ae(l.$slots, "default")
      ], 544))
    ], 2));
  }
});
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
function dN(e) {
  return Jo(e) ? Ha(new Proxy({}, {
    get(n, t, a) {
      return L(Reflect.get(e.value, t, a));
    },
    set(n, t, a) {
      return Jo(e.value[t]) && !Jo(a) ? e.value[t].value = a : e.value[t] = a, !0;
    },
    deleteProperty(n, t) {
      return Reflect.deleteProperty(e.value, t);
    },
    has(n, t) {
      return Reflect.has(e.value, t);
    },
    ownKeys() {
      return Object.keys(e.value);
    },
    getOwnPropertyDescriptor() {
      return {
        enumerable: !0,
        configurable: !0
      };
    }
  })) : Ha(e);
}
function uN(e) {
  return dN(m(e));
}
function cN(e, ...n) {
  const t = n.flat(), a = t[0];
  return uN(() => Object.fromEntries(typeof a == "function" ? Object.entries(nf(e)).filter(([l, r]) => !a(Pt(r), l)) : Object.entries(nf(e)).filter((l) => !t.includes(l[0]))));
}
const ri = /* @__PURE__ */ ye({
  __name: "DataTableRow",
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), g("tr", {
      "data-slot": "table-row",
      class: C([
        "bg-white dark:bg-(--colors-background-black-default) border-b border-border-base-soft dark:border-(--colors-border-base) hover:bg-(--background-background-hover) dark:hover:bg-(--color-dark-bg-tertiary)",
        n.class
      ])
    }, [
      Ae(t.$slots, "default")
    ], 2));
  }
}), fN = { class: "flex items-center justify-center py-10" }, nU = /* @__PURE__ */ ye({
  __name: "DataTableEmpty",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    colspan: { default: 1 }
  },
  setup(e) {
    const n = e, t = cN(n, "class");
    return (a, l) => (c(), W(ri, null, {
      default: ve(() => [
        te(yu, Fe({
          class: ["p-4 whitespace-nowrap align-middle text-sm text-foreground", n.class]
        }, L(t)), {
          default: ve(() => [
            v("div", fN, [
              Ae(a.$slots, "default")
            ])
          ]),
          _: 3
        }, 16, ["class"])
      ]),
      _: 3
    }));
  }
}), aU = /* @__PURE__ */ ye({
  __name: "DataTableFooter",
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), g("tfoot", {
      "data-slot": "table-footer",
      class: C(["", n.class])
    }, [
      Ae(t.$slots, "default")
    ], 2));
  }
}), hN = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M8.5%207C9.32843%207%2010%206.32843%2010%205.5C10%204.67157%209.32843%204%208.5%204C7.67157%204%207%204.67157%207%205.5C7%206.32843%207.67157%207%208.5%207ZM8.5%2013.5C9.32843%2013.5%2010%2012.8284%2010%2012C10%2011.1716%209.32843%2010.5%208.5%2010.5C7.67157%2010.5%207%2011.1716%207%2012C7%2012.8284%207.67157%2013.5%208.5%2013.5ZM10%2018.5C10%2019.3284%209.32843%2020%208.5%2020C7.67157%2020%207%2019.3284%207%2018.5C7%2017.6716%207.67157%2017%208.5%2017C9.32843%2017%2010%2017.6716%2010%2018.5ZM15.5%207C16.3284%207%2017%206.32843%2017%205.5C17%204.67157%2016.3284%204%2015.5%204C14.6716%204%2014%204.67157%2014%205.5C14%206.32843%2014.6716%207%2015.5%207ZM17%2012C17%2012.8284%2016.3284%2013.5%2015.5%2013.5C14.6716%2013.5%2014%2012.8284%2014%2012C14%2011.1716%2014.6716%2010.5%2015.5%2010.5C16.3284%2010.5%2017%2011.1716%2017%2012ZM15.5%2020C16.3284%2020%2017%2019.3284%2017%2018.5C17%2017.6716%2016.3284%2017%2015.5%2017C14.6716%2017%2014%2017.6716%2014%2018.5C14%2019.3284%2014.6716%2020%2015.5%2020Z'/%3e%3c/svg%3e", bN = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18%203V5H17V11L19%2014V16H13V23H11V16H5V14L7%2011V5H6V3H18Z'/%3e%3c/svg%3e", gN = ["aria-sort"], mN = { class: "flex items-center gap-1 min-w-0" }, pN = ["src", "data-drag-handle", "draggable"], vN = {
  key: 1,
  class: "me-auto min-w-0"
}, xN = ["src"], yN = {
  key: 4,
  ref: "menuRef",
  class: "relative shrink-0"
}, kN = ["aria-label"], wN = /* @__PURE__ */ ye({
  __name: "DataTableHead",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    isDraggable: { type: Boolean, default: !1 },
    isPinned: { type: Boolean, default: !1 },
    isLastPinned: { type: Boolean, default: !1 },
    isLocked: { type: Boolean, default: !1 },
    isPinIconVisible: { type: Boolean, default: !0 },
    headerMenuItems: { default: void 0 },
    isCustomHeader: { type: Boolean, default: !1 },
    isResizingActive: { type: Boolean, default: !1 },
    isResizable: { type: Boolean, default: !0 },
    menuAriaLabel: { default: "Column menu" },
    sortDirection: { default: void 0 }
  },
  emits: ["resize-start", "resize-auto", "drag-handle-start"],
  setup(e, { emit: n }) {
    const t = e, a = m(() => {
      if (t.sortDirection !== void 0)
        return t.sortDirection === "asc" ? "ascending" : t.sortDirection === "desc" ? "descending" : "none";
    }), l = m(() => t.sortDirection === "asc" ? "ri-arrow-up-s-line" : t.sortDirection === "desc" ? "ri-arrow-down-s-line" : "ri-expand-up-down-fill"), r = n;
    let o = 0;
    function i(f) {
      const b = Date.now();
      if (b - o < 300) {
        o = 0, r("resize-auto");
        return;
      }
      o = b, r("resize-start", f);
    }
    const s = m(() => {
      if (t.headerMenuItems)
        return t.headerMenuItems.map((f, b, h) => {
          const p = h[b + 1];
          return {
            label: f.label,
            icon: f.icon,
            onClick: f.onClick,
            disabled: f.disabled,
            hasDividerAfter: (p == null ? void 0 : p.dividerBefore) === !0
          };
        });
    }), d = R(null);
    function u() {
      var b;
      const f = d.value;
      f && (f.scrollWidth > f.clientWidth ? f.title = ((b = f.textContent) == null ? void 0 : b.trim()) ?? "" : f.title = "");
    }
    return (f, b) => (c(), g("th", {
      "data-slot": "table-head",
      scope: "col",
      "aria-sort": a.value,
      class: C([
        "relative h-10 px-3 min-w-32.5 text-left align-middle font-semibold whitespace-nowrap text-(--text-text-heading) dark:text-(--colors-text-white-default) [&:has([type=checkbox])]:min-w-auto [&:has([type=checkbox])]:w-10 [&:has([type=checkbox])]:pr-0 [&_button]:border-0 [&>div>div>button]:p-0",
        e.isPinned ? "bg-white dark:bg-(--colors-background-black-default) z-20" : "z-0",
        t.class
      ])
    }, [
      v("div", mN, [
        e.isDraggable || e.isLocked ? (c(), g("img", {
          key: 0,
          class: C([
            "size-3.5 shrink-0 dark:invert",
            e.isLocked ? "opacity-40 cursor-not-allowed" : "cursor-grab"
          ]),
          src: L(hN),
          alt: "",
          "data-drag-handle": e.isLocked ? "false" : "true",
          draggable: e.isLocked ? "false" : "true",
          onDragstart: b[0] || (b[0] = Je((h) => !e.isLocked && r("drag-handle-start", h), ["stop"]))
        }, null, 42, pN)) : w("", !0),
        e.isCustomHeader ? (c(), g("div", vN, [
          Ae(f.$slots, "default")
        ])) : (c(), g("div", {
          key: 2,
          ref_key: "headerTextRef",
          ref: d,
          class: "truncate me-auto min-w-0",
          onMouseenter: u
        }, [
          Ae(f.$slots, "default")
        ], 544)),
        e.isPinned && e.isPinIconVisible ? (c(), g("img", {
          key: 3,
          class: C(["size-3.5 shrink-0 ms-auto dark:invert", e.isLocked ? "opacity-40" : ""]),
          src: L(bN),
          alt: ""
        }, null, 10, xN)) : w("", !0),
        e.headerMenuItems ? (c(), g("div", yN, [
          te(cn, {
            "menu-align": "right",
            items: s.value
          }, {
            trigger: ve(({ triggerProps: h, isOpen: p }) => [
              v("button", Fe({
                type: "button",
                "data-testid": "dropdown-trigger",
                class: "inline-flex min-h-6 min-w-6 cursor-pointer items-center justify-center rounded-(--border-border-radius-rounded-full) bg-white transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royalblue focus-visible:ring-offset-2 dark:bg-(--colors-background-black-default)",
                "aria-label": e.menuAriaLabel
              }, h), [
                v("i", {
                  class: C([[l.value, { "rotate-180": p }], "inline-flex size-(--icon-size-sm) items-center justify-center text-(length:--icon-size-sm) leading-(--icon-size-sm) transition-transform duration-200 ease-in-out motion-reduce:transition-none"]),
                  "aria-hidden": "true"
                }, null, 2)
              ], 16, kN)
            ]),
            _: 1
          }, 8, ["items"])
        ], 512)) : w("", !0)
      ]),
      e.isResizable ? (c(), g("div", {
        key: 0,
        class: C(["absolute top-0 right-0 w-0.5 h-full cursor-col-resize z-10 bg-(--background-background-gray)/40 hover:bg-blue-400 hover:opacity-50 transition-colors", { "bg-blue-500 opacity-50": e.isResizingActive }]),
        onMousedown: b[1] || (b[1] = Je((h) => i(h), ["stop", "prevent"])),
        onClick: b[2] || (b[2] = Je(() => {
        }, ["stop", "prevent"]))
      }, null, 34)) : w("", !0)
    ], 10, gN));
  }
}), CN = /* @__PURE__ */ ye({
  __name: "DataTableHeader",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    isSticky: { type: Boolean }
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), g("thead", {
      "data-slot": "table-header",
      class: C([
        "shadow-[0_1px_4px_0_rgba(0,0,0,0.1)] [&_tr:hover]:bg-transparent",
        n.isSticky && "sticky top-0 z-30 bg-white dark:bg-(--colors-background-black-default)",
        n.class
      ])
    }, [
      Ae(t.$slots, "default")
    ], 2));
  }
});
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Da(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function Sn(e, n) {
  return (t) => {
    n.setState((a) => ({
      ...a,
      [e]: Da(t, a[e])
    }));
  };
}
function Ss(e) {
  return e instanceof Function;
}
function SN(e) {
  return Array.isArray(e) && e.every((n) => typeof n == "number");
}
function $N(e, n) {
  const t = [], a = (l) => {
    l.forEach((r) => {
      t.push(r);
      const o = n(r);
      o != null && o.length && a(o);
    });
  };
  return a(e), t;
}
function at(e, n, t) {
  let a = [], l;
  return (r) => {
    let o;
    t.key && t.debug && (o = Date.now());
    const i = e(r);
    if (!(i.length !== a.length || i.some((u, f) => a[f] !== u)))
      return l;
    a = i;
    let d;
    if (t.key && t.debug && (d = Date.now()), l = n(...i), t == null || t.onChange == null || t.onChange(l), t.key && t.debug && t != null && t.debug()) {
      const u = Math.round((Date.now() - o) * 100) / 100, f = Math.round((Date.now() - d) * 100) / 100, b = f / 16, h = (p, x) => {
        for (p = String(p); p.length < x; )
          p = " " + p;
        return p;
      };
      console.info(`%c⏱ ${h(f, 5)} /${h(u, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * b, 120))}deg 100% 31%);`, t == null ? void 0 : t.key);
    }
    return l;
  };
}
function lt(e, n, t, a) {
  return {
    debug: () => {
      var l;
      return (l = e == null ? void 0 : e.debugAll) != null ? l : e[n];
    },
    key: process.env.NODE_ENV === "development" && t,
    onChange: a
  };
}
function IN(e, n, t, a) {
  const l = () => {
    var o;
    return (o = r.getValue()) != null ? o : e.options.renderFallbackValue;
  }, r = {
    id: `${n.id}_${t.id}`,
    row: n,
    column: t,
    getValue: () => n.getValue(a),
    renderValue: l,
    getContext: at(() => [e, t, n, r], (o, i, s, d) => ({
      table: o,
      column: i,
      row: s,
      cell: d,
      getValue: d.getValue,
      renderValue: d.renderValue
    }), lt(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((o) => {
    o.createCell == null || o.createCell(r, t, n, e);
  }, {}), r;
}
function LN(e, n, t, a) {
  var l, r;
  const i = {
    ...e._getDefaultColumnDef(),
    ...n
  }, s = i.accessorKey;
  let d = (l = (r = i.id) != null ? r : s ? typeof String.prototype.replaceAll == "function" ? s.replaceAll(".", "_") : s.replace(/\./g, "_") : void 0) != null ? l : typeof i.header == "string" ? i.header : void 0, u;
  if (i.accessorFn ? u = i.accessorFn : s && (s.includes(".") ? u = (b) => {
    let h = b;
    for (const x of s.split(".")) {
      var p;
      h = (p = h) == null ? void 0 : p[x], process.env.NODE_ENV !== "production" && h === void 0 && console.warn(`"${x}" in deeply nested key "${s}" returned undefined.`);
    }
    return h;
  } : u = (b) => b[i.accessorKey]), !d)
    throw process.env.NODE_ENV !== "production" ? new Error(i.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let f = {
    id: `${String(d)}`,
    accessorFn: u,
    parent: a,
    depth: t,
    columnDef: i,
    columns: [],
    getFlatColumns: at(() => [!0], () => {
      var b;
      return [f, ...(b = f.columns) == null ? void 0 : b.flatMap((h) => h.getFlatColumns())];
    }, lt(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: at(() => [e._getOrderColumnsFn()], (b) => {
      var h;
      if ((h = f.columns) != null && h.length) {
        let p = f.columns.flatMap((x) => x.getLeafColumns());
        return b(p);
      }
      return [f];
    }, lt(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const b of e._features)
    b.createColumn == null || b.createColumn(f, e);
  return f;
}
const nn = "debugHeaders";
function Ib(e, n, t) {
  var a;
  let r = {
    id: (a = t.id) != null ? a : n.id,
    column: n,
    index: t.index,
    isPlaceholder: !!t.isPlaceholder,
    placeholderId: t.placeholderId,
    depth: t.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const o = [], i = (s) => {
        s.subHeaders && s.subHeaders.length && s.subHeaders.map(i), o.push(s);
      };
      return i(r), o;
    },
    getContext: () => ({
      table: e,
      header: r,
      column: n
    })
  };
  return e._features.forEach((o) => {
    o.createHeader == null || o.createHeader(r, e);
  }), r;
}
const TN = {
  createTable: (e) => {
    e.getHeaderGroups = at(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, t, a, l) => {
      var r, o;
      const i = (r = a == null ? void 0 : a.map((f) => t.find((b) => b.id === f)).filter(Boolean)) != null ? r : [], s = (o = l == null ? void 0 : l.map((f) => t.find((b) => b.id === f)).filter(Boolean)) != null ? o : [], d = t.filter((f) => !(a != null && a.includes(f.id)) && !(l != null && l.includes(f.id)));
      return Ho(n, [...i, ...d, ...s], e);
    }, lt(e.options, nn, "getHeaderGroups")), e.getCenterHeaderGroups = at(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, t, a, l) => (t = t.filter((r) => !(a != null && a.includes(r.id)) && !(l != null && l.includes(r.id))), Ho(n, t, e, "center")), lt(e.options, nn, "getCenterHeaderGroups")), e.getLeftHeaderGroups = at(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (n, t, a) => {
      var l;
      const r = (l = a == null ? void 0 : a.map((o) => t.find((i) => i.id === o)).filter(Boolean)) != null ? l : [];
      return Ho(n, r, e, "left");
    }, lt(e.options, nn, "getLeftHeaderGroups")), e.getRightHeaderGroups = at(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (n, t, a) => {
      var l;
      const r = (l = a == null ? void 0 : a.map((o) => t.find((i) => i.id === o)).filter(Boolean)) != null ? l : [];
      return Ho(n, r, e, "right");
    }, lt(e.options, nn, "getRightHeaderGroups")), e.getFooterGroups = at(() => [e.getHeaderGroups()], (n) => [...n].reverse(), lt(e.options, nn, "getFooterGroups")), e.getLeftFooterGroups = at(() => [e.getLeftHeaderGroups()], (n) => [...n].reverse(), lt(e.options, nn, "getLeftFooterGroups")), e.getCenterFooterGroups = at(() => [e.getCenterHeaderGroups()], (n) => [...n].reverse(), lt(e.options, nn, "getCenterFooterGroups")), e.getRightFooterGroups = at(() => [e.getRightHeaderGroups()], (n) => [...n].reverse(), lt(e.options, nn, "getRightFooterGroups")), e.getFlatHeaders = at(() => [e.getHeaderGroups()], (n) => n.map((t) => t.headers).flat(), lt(e.options, nn, "getFlatHeaders")), e.getLeftFlatHeaders = at(() => [e.getLeftHeaderGroups()], (n) => n.map((t) => t.headers).flat(), lt(e.options, nn, "getLeftFlatHeaders")), e.getCenterFlatHeaders = at(() => [e.getCenterHeaderGroups()], (n) => n.map((t) => t.headers).flat(), lt(e.options, nn, "getCenterFlatHeaders")), e.getRightFlatHeaders = at(() => [e.getRightHeaderGroups()], (n) => n.map((t) => t.headers).flat(), lt(e.options, nn, "getRightFlatHeaders")), e.getCenterLeafHeaders = at(() => [e.getCenterFlatHeaders()], (n) => n.filter((t) => {
      var a;
      return !((a = t.subHeaders) != null && a.length);
    }), lt(e.options, nn, "getCenterLeafHeaders")), e.getLeftLeafHeaders = at(() => [e.getLeftFlatHeaders()], (n) => n.filter((t) => {
      var a;
      return !((a = t.subHeaders) != null && a.length);
    }), lt(e.options, nn, "getLeftLeafHeaders")), e.getRightLeafHeaders = at(() => [e.getRightFlatHeaders()], (n) => n.filter((t) => {
      var a;
      return !((a = t.subHeaders) != null && a.length);
    }), lt(e.options, nn, "getRightLeafHeaders")), e.getLeafHeaders = at(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (n, t, a) => {
      var l, r, o, i, s, d;
      return [...(l = (r = n[0]) == null ? void 0 : r.headers) != null ? l : [], ...(o = (i = t[0]) == null ? void 0 : i.headers) != null ? o : [], ...(s = (d = a[0]) == null ? void 0 : d.headers) != null ? s : []].map((u) => u.getLeafHeaders()).flat();
    }, lt(e.options, nn, "getLeafHeaders"));
  }
};
function Ho(e, n, t, a) {
  var l, r;
  let o = 0;
  const i = function(b, h) {
    h === void 0 && (h = 1), o = Math.max(o, h), b.filter((p) => p.getIsVisible()).forEach((p) => {
      var x;
      (x = p.columns) != null && x.length && i(p.columns, h + 1);
    }, 0);
  };
  i(e);
  let s = [];
  const d = (b, h) => {
    const p = {
      depth: h,
      id: [a, `${h}`].filter(Boolean).join("_"),
      headers: []
    }, x = [];
    b.forEach((y) => {
      const k = [...x].reverse()[0], $ = y.column.depth === p.depth;
      let S, T = !1;
      if ($ && y.column.parent ? S = y.column.parent : (S = y.column, T = !0), k && (k == null ? void 0 : k.column) === S)
        k.subHeaders.push(y);
      else {
        const I = Ib(t, S, {
          id: [a, h, S.id, y == null ? void 0 : y.id].filter(Boolean).join("_"),
          isPlaceholder: T,
          placeholderId: T ? `${x.filter((A) => A.column === S).length}` : void 0,
          depth: h,
          index: x.length
        });
        I.subHeaders.push(y), x.push(I);
      }
      p.headers.push(y), y.headerGroup = p;
    }), s.push(p), h > 0 && d(x, h - 1);
  }, u = n.map((b, h) => Ib(t, b, {
    depth: o,
    index: h
  }));
  d(u, o - 1), s.reverse();
  const f = (b) => b.filter((p) => p.column.getIsVisible()).map((p) => {
    let x = 0, y = 0, k = [0];
    p.subHeaders && p.subHeaders.length ? (k = [], f(p.subHeaders).forEach((S) => {
      let {
        colSpan: T,
        rowSpan: I
      } = S;
      x += T, k.push(I);
    })) : x = 1;
    const $ = Math.min(...k);
    return y = y + $, p.colSpan = x, p.rowSpan = y, {
      colSpan: x,
      rowSpan: y
    };
  });
  return f((l = (r = s[0]) == null ? void 0 : r.headers) != null ? l : []), s;
}
const AN = (e, n, t, a, l, r, o) => {
  let i = {
    id: n,
    index: a,
    original: t,
    depth: l,
    parentId: o,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (s) => {
      if (i._valuesCache.hasOwnProperty(s))
        return i._valuesCache[s];
      const d = e.getColumn(s);
      if (d != null && d.accessorFn)
        return i._valuesCache[s] = d.accessorFn(i.original, a), i._valuesCache[s];
    },
    getUniqueValues: (s) => {
      if (i._uniqueValuesCache.hasOwnProperty(s))
        return i._uniqueValuesCache[s];
      const d = e.getColumn(s);
      if (d != null && d.accessorFn)
        return d.columnDef.getUniqueValues ? (i._uniqueValuesCache[s] = d.columnDef.getUniqueValues(i.original, a), i._uniqueValuesCache[s]) : (i._uniqueValuesCache[s] = [i.getValue(s)], i._uniqueValuesCache[s]);
    },
    renderValue: (s) => {
      var d;
      return (d = i.getValue(s)) != null ? d : e.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => $N(i.subRows, (s) => s.subRows),
    getParentRow: () => i.parentId ? e.getRow(i.parentId, !0) : void 0,
    getParentRows: () => {
      let s = [], d = i;
      for (; ; ) {
        const u = d.getParentRow();
        if (!u) break;
        s.push(u), d = u;
      }
      return s.reverse();
    },
    getAllCells: at(() => [e.getAllLeafColumns()], (s) => s.map((d) => IN(e, i, d, d.id)), lt(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: at(() => [i.getAllCells()], (s) => s.reduce((d, u) => (d[u.column.id] = u, d), {}), lt(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let s = 0; s < e._features.length; s++) {
    const d = e._features[s];
    d == null || d.createRow == null || d.createRow(i, e);
  }
  return i;
}, EN = {
  createColumn: (e, n) => {
    e._getFacetedRowModel = n.options.getFacetedRowModel && n.options.getFacetedRowModel(n, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : n.getPreFilteredRowModel(), e._getFacetedUniqueValues = n.options.getFacetedUniqueValues && n.options.getFacetedUniqueValues(n, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = n.options.getFacetedMinMaxValues && n.options.getFacetedMinMaxValues(n, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, sx = (e, n, t) => {
  var a, l;
  const r = t == null || (a = t.toString()) == null ? void 0 : a.toLowerCase();
  return !!(!((l = e.getValue(n)) == null || (l = l.toString()) == null || (l = l.toLowerCase()) == null) && l.includes(r));
};
sx.autoRemove = (e) => Un(e);
const dx = (e, n, t) => {
  var a;
  return !!(!((a = e.getValue(n)) == null || (a = a.toString()) == null) && a.includes(t));
};
dx.autoRemove = (e) => Un(e);
const ux = (e, n, t) => {
  var a;
  return ((a = e.getValue(n)) == null || (a = a.toString()) == null ? void 0 : a.toLowerCase()) === (t == null ? void 0 : t.toLowerCase());
};
ux.autoRemove = (e) => Un(e);
const cx = (e, n, t) => {
  var a;
  return (a = e.getValue(n)) == null ? void 0 : a.includes(t);
};
cx.autoRemove = (e) => Un(e);
const fx = (e, n, t) => !t.some((a) => {
  var l;
  return !((l = e.getValue(n)) != null && l.includes(a));
});
fx.autoRemove = (e) => Un(e) || !(e != null && e.length);
const hx = (e, n, t) => t.some((a) => {
  var l;
  return (l = e.getValue(n)) == null ? void 0 : l.includes(a);
});
hx.autoRemove = (e) => Un(e) || !(e != null && e.length);
const bx = (e, n, t) => e.getValue(n) === t;
bx.autoRemove = (e) => Un(e);
const gx = (e, n, t) => e.getValue(n) == t;
gx.autoRemove = (e) => Un(e);
const Kc = (e, n, t) => {
  let [a, l] = t;
  const r = e.getValue(n);
  return r >= a && r <= l;
};
Kc.resolveFilterValue = (e) => {
  let [n, t] = e, a = typeof n != "number" ? parseFloat(n) : n, l = typeof t != "number" ? parseFloat(t) : t, r = n === null || Number.isNaN(a) ? -1 / 0 : a, o = t === null || Number.isNaN(l) ? 1 / 0 : l;
  if (r > o) {
    const i = r;
    r = o, o = i;
  }
  return [r, o];
};
Kc.autoRemove = (e) => Un(e) || Un(e[0]) && Un(e[1]);
const ba = {
  includesString: sx,
  includesStringSensitive: dx,
  equalsString: ux,
  arrIncludes: cx,
  arrIncludesAll: fx,
  arrIncludesSome: hx,
  equals: bx,
  weakEquals: gx,
  inNumberRange: Kc
};
function Un(e) {
  return e == null || e === "";
}
const RN = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: Sn("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, n) => {
    e.getAutoFilterFn = () => {
      const t = n.getCoreRowModel().flatRows[0], a = t == null ? void 0 : t.getValue(e.id);
      return typeof a == "string" ? ba.includesString : typeof a == "number" ? ba.inNumberRange : typeof a == "boolean" || a !== null && typeof a == "object" ? ba.equals : Array.isArray(a) ? ba.arrIncludes : ba.weakEquals;
    }, e.getFilterFn = () => {
      var t, a;
      return Ss(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (t = (a = n.options.filterFns) == null ? void 0 : a[e.columnDef.filterFn]) != null ? t : ba[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var t, a, l;
      return ((t = e.columnDef.enableColumnFilter) != null ? t : !0) && ((a = n.options.enableColumnFilters) != null ? a : !0) && ((l = n.options.enableFilters) != null ? l : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var t;
      return (t = n.getState().columnFilters) == null || (t = t.find((a) => a.id === e.id)) == null ? void 0 : t.value;
    }, e.getFilterIndex = () => {
      var t, a;
      return (t = (a = n.getState().columnFilters) == null ? void 0 : a.findIndex((l) => l.id === e.id)) != null ? t : -1;
    }, e.setFilterValue = (t) => {
      n.setColumnFilters((a) => {
        const l = e.getFilterFn(), r = a == null ? void 0 : a.find((u) => u.id === e.id), o = Da(t, r ? r.value : void 0);
        if (Lb(l, o, e)) {
          var i;
          return (i = a == null ? void 0 : a.filter((u) => u.id !== e.id)) != null ? i : [];
        }
        const s = {
          id: e.id,
          value: o
        };
        if (r) {
          var d;
          return (d = a == null ? void 0 : a.map((u) => u.id === e.id ? s : u)) != null ? d : [];
        }
        return a != null && a.length ? [...a, s] : [s];
      });
    };
  },
  createRow: (e, n) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (n) => {
      const t = e.getAllLeafColumns(), a = (l) => {
        var r;
        return (r = Da(n, l)) == null ? void 0 : r.filter((o) => {
          const i = t.find((s) => s.id === o.id);
          if (i) {
            const s = i.getFilterFn();
            if (Lb(s, o.value, i))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(a);
    }, e.resetColumnFilters = (n) => {
      var t, a;
      e.setColumnFilters(n ? [] : (t = (a = e.initialState) == null ? void 0 : a.columnFilters) != null ? t : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function Lb(e, n, t) {
  return (e && e.autoRemove ? e.autoRemove(n, t) : !1) || typeof n > "u" || typeof n == "string" && !n;
}
const BN = (e, n, t) => t.reduce((a, l) => {
  const r = l.getValue(e);
  return a + (typeof r == "number" ? r : 0);
}, 0), MN = (e, n, t) => {
  let a;
  return t.forEach((l) => {
    const r = l.getValue(e);
    r != null && (a > r || a === void 0 && r >= r) && (a = r);
  }), a;
}, DN = (e, n, t) => {
  let a;
  return t.forEach((l) => {
    const r = l.getValue(e);
    r != null && (a < r || a === void 0 && r >= r) && (a = r);
  }), a;
}, zN = (e, n, t) => {
  let a, l;
  return t.forEach((r) => {
    const o = r.getValue(e);
    o != null && (a === void 0 ? o >= o && (a = l = o) : (a > o && (a = o), l < o && (l = o)));
  }), [a, l];
}, ON = (e, n) => {
  let t = 0, a = 0;
  if (n.forEach((l) => {
    let r = l.getValue(e);
    r != null && (r = +r) >= r && (++t, a += r);
  }), t) return a / t;
}, PN = (e, n) => {
  if (!n.length)
    return;
  const t = n.map((r) => r.getValue(e));
  if (!SN(t))
    return;
  if (t.length === 1)
    return t[0];
  const a = Math.floor(t.length / 2), l = t.sort((r, o) => r - o);
  return t.length % 2 !== 0 ? l[a] : (l[a - 1] + l[a]) / 2;
}, FN = (e, n) => Array.from(new Set(n.map((t) => t.getValue(e))).values()), VN = (e, n) => new Set(n.map((t) => t.getValue(e))).size, NN = (e, n) => n.length, vd = {
  sum: BN,
  min: MN,
  max: DN,
  extent: zN,
  mean: ON,
  median: PN,
  unique: FN,
  uniqueCount: VN,
  count: NN
}, HN = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var n, t;
      return (n = (t = e.getValue()) == null || t.toString == null ? void 0 : t.toString()) != null ? n : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: Sn("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, n) => {
    e.toggleGrouping = () => {
      n.setGrouping((t) => t != null && t.includes(e.id) ? t.filter((a) => a !== e.id) : [...t ?? [], e.id]);
    }, e.getCanGroup = () => {
      var t, a;
      return ((t = e.columnDef.enableGrouping) != null ? t : !0) && ((a = n.options.enableGrouping) != null ? a : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var t;
      return (t = n.getState().grouping) == null ? void 0 : t.includes(e.id);
    }, e.getGroupedIndex = () => {
      var t;
      return (t = n.getState().grouping) == null ? void 0 : t.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const t = e.getCanGroup();
      return () => {
        t && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const t = n.getCoreRowModel().flatRows[0], a = t == null ? void 0 : t.getValue(e.id);
      if (typeof a == "number")
        return vd.sum;
      if (Object.prototype.toString.call(a) === "[object Date]")
        return vd.extent;
    }, e.getAggregationFn = () => {
      var t, a;
      if (!e)
        throw new Error();
      return Ss(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (t = (a = n.options.aggregationFns) == null ? void 0 : a[e.columnDef.aggregationFn]) != null ? t : vd[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (n) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(n), e.resetGrouping = (n) => {
      var t, a;
      e.setGrouping(n ? [] : (t = (a = e.initialState) == null ? void 0 : a.grouping) != null ? t : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, n) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (t) => {
      if (e._groupingValuesCache.hasOwnProperty(t))
        return e._groupingValuesCache[t];
      const a = n.getColumn(t);
      return a != null && a.columnDef.getGroupingValue ? (e._groupingValuesCache[t] = a.columnDef.getGroupingValue(e.original), e._groupingValuesCache[t]) : e.getValue(t);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, n, t, a) => {
    e.getIsGrouped = () => n.getIsGrouped() && n.id === t.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && n.getIsGrouped(), e.getIsAggregated = () => {
      var l;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((l = t.subRows) != null && l.length);
    };
  }
};
function jN(e, n, t) {
  if (!(n != null && n.length) || !t)
    return e;
  const a = e.filter((r) => !n.includes(r.id));
  return t === "remove" ? a : [...n.map((r) => e.find((o) => o.id === r)).filter(Boolean), ...a];
}
const WN = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: Sn("columnOrder", e)
  }),
  createColumn: (e, n) => {
    e.getIndex = at((t) => [qr(n, t)], (t) => t.findIndex((a) => a.id === e.id), lt(n.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (t) => {
      var a;
      return ((a = qr(n, t)[0]) == null ? void 0 : a.id) === e.id;
    }, e.getIsLastColumn = (t) => {
      var a;
      const l = qr(n, t);
      return ((a = l[l.length - 1]) == null ? void 0 : a.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (n) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(n), e.resetColumnOrder = (n) => {
      var t;
      e.setColumnOrder(n ? [] : (t = e.initialState.columnOrder) != null ? t : []);
    }, e._getOrderColumnsFn = at(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (n, t, a) => (l) => {
      let r = [];
      if (!(n != null && n.length))
        r = l;
      else {
        const o = [...n], i = [...l];
        for (; i.length && o.length; ) {
          const s = o.shift(), d = i.findIndex((u) => u.id === s);
          d > -1 && r.push(i.splice(d, 1)[0]);
        }
        r = [...r, ...i];
      }
      return jN(r, t, a);
    }, lt(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, xd = () => ({
  left: [],
  right: []
}), qN = {
  getInitialState: (e) => ({
    columnPinning: xd(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: Sn("columnPinning", e)
  }),
  createColumn: (e, n) => {
    e.pin = (t) => {
      const a = e.getLeafColumns().map((l) => l.id).filter(Boolean);
      n.setColumnPinning((l) => {
        var r, o;
        if (t === "right") {
          var i, s;
          return {
            left: ((i = l == null ? void 0 : l.left) != null ? i : []).filter((f) => !(a != null && a.includes(f))),
            right: [...((s = l == null ? void 0 : l.right) != null ? s : []).filter((f) => !(a != null && a.includes(f))), ...a]
          };
        }
        if (t === "left") {
          var d, u;
          return {
            left: [...((d = l == null ? void 0 : l.left) != null ? d : []).filter((f) => !(a != null && a.includes(f))), ...a],
            right: ((u = l == null ? void 0 : l.right) != null ? u : []).filter((f) => !(a != null && a.includes(f)))
          };
        }
        return {
          left: ((r = l == null ? void 0 : l.left) != null ? r : []).filter((f) => !(a != null && a.includes(f))),
          right: ((o = l == null ? void 0 : l.right) != null ? o : []).filter((f) => !(a != null && a.includes(f)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((a) => {
      var l, r, o;
      return ((l = a.columnDef.enablePinning) != null ? l : !0) && ((r = (o = n.options.enableColumnPinning) != null ? o : n.options.enablePinning) != null ? r : !0);
    }), e.getIsPinned = () => {
      const t = e.getLeafColumns().map((i) => i.id), {
        left: a,
        right: l
      } = n.getState().columnPinning, r = t.some((i) => a == null ? void 0 : a.includes(i)), o = t.some((i) => l == null ? void 0 : l.includes(i));
      return r ? "left" : o ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var t, a;
      const l = e.getIsPinned();
      return l ? (t = (a = n.getState().columnPinning) == null || (a = a[l]) == null ? void 0 : a.indexOf(e.id)) != null ? t : -1 : 0;
    };
  },
  createRow: (e, n) => {
    e.getCenterVisibleCells = at(() => [e._getAllVisibleCells(), n.getState().columnPinning.left, n.getState().columnPinning.right], (t, a, l) => {
      const r = [...a ?? [], ...l ?? []];
      return t.filter((o) => !r.includes(o.column.id));
    }, lt(n.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = at(() => [e._getAllVisibleCells(), n.getState().columnPinning.left], (t, a) => (a ?? []).map((r) => t.find((o) => o.column.id === r)).filter(Boolean).map((r) => ({
      ...r,
      position: "left"
    })), lt(n.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = at(() => [e._getAllVisibleCells(), n.getState().columnPinning.right], (t, a) => (a ?? []).map((r) => t.find((o) => o.column.id === r)).filter(Boolean).map((r) => ({
      ...r,
      position: "right"
    })), lt(n.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (n) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(n), e.resetColumnPinning = (n) => {
      var t, a;
      return e.setColumnPinning(n ? xd() : (t = (a = e.initialState) == null ? void 0 : a.columnPinning) != null ? t : xd());
    }, e.getIsSomeColumnsPinned = (n) => {
      var t;
      const a = e.getState().columnPinning;
      if (!n) {
        var l, r;
        return !!((l = a.left) != null && l.length || (r = a.right) != null && r.length);
      }
      return !!((t = a[n]) != null && t.length);
    }, e.getLeftLeafColumns = at(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (n, t) => (t ?? []).map((a) => n.find((l) => l.id === a)).filter(Boolean), lt(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = at(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (n, t) => (t ?? []).map((a) => n.find((l) => l.id === a)).filter(Boolean), lt(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = at(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, t, a) => {
      const l = [...t ?? [], ...a ?? []];
      return n.filter((r) => !l.includes(r.id));
    }, lt(e.options, "debugColumns", "getCenterLeafColumns"));
  }
};
function UN(e) {
  return e || (typeof document < "u" ? document : null);
}
const jo = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, yd = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), GN = {
  getDefaultColumnDef: () => jo,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: yd(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: Sn("columnSizing", e),
    onColumnSizingInfoChange: Sn("columnSizingInfo", e)
  }),
  createColumn: (e, n) => {
    e.getSize = () => {
      var t, a, l;
      const r = n.getState().columnSizing[e.id];
      return Math.min(Math.max((t = e.columnDef.minSize) != null ? t : jo.minSize, (a = r ?? e.columnDef.size) != null ? a : jo.size), (l = e.columnDef.maxSize) != null ? l : jo.maxSize);
    }, e.getStart = at((t) => [t, qr(n, t), n.getState().columnSizing], (t, a) => a.slice(0, e.getIndex(t)).reduce((l, r) => l + r.getSize(), 0), lt(n.options, "debugColumns", "getStart")), e.getAfter = at((t) => [t, qr(n, t), n.getState().columnSizing], (t, a) => a.slice(e.getIndex(t) + 1).reduce((l, r) => l + r.getSize(), 0), lt(n.options, "debugColumns", "getAfter")), e.resetSize = () => {
      n.setColumnSizing((t) => {
        let {
          [e.id]: a,
          ...l
        } = t;
        return l;
      });
    }, e.getCanResize = () => {
      var t, a;
      return ((t = e.columnDef.enableResizing) != null ? t : !0) && ((a = n.options.enableColumnResizing) != null ? a : !0);
    }, e.getIsResizing = () => n.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, n) => {
    e.getSize = () => {
      let t = 0;
      const a = (l) => {
        if (l.subHeaders.length)
          l.subHeaders.forEach(a);
        else {
          var r;
          t += (r = l.column.getSize()) != null ? r : 0;
        }
      };
      return a(e), t;
    }, e.getStart = () => {
      if (e.index > 0) {
        const t = e.headerGroup.headers[e.index - 1];
        return t.getStart() + t.getSize();
      }
      return 0;
    }, e.getResizeHandler = (t) => {
      const a = n.getColumn(e.column.id), l = a == null ? void 0 : a.getCanResize();
      return (r) => {
        if (!a || !l || (r.persist == null || r.persist(), kd(r) && r.touches && r.touches.length > 1))
          return;
        const o = e.getSize(), i = e ? e.getLeafHeaders().map((k) => [k.column.id, k.column.getSize()]) : [[a.id, a.getSize()]], s = kd(r) ? Math.round(r.touches[0].clientX) : r.clientX, d = {}, u = (k, $) => {
          typeof $ == "number" && (n.setColumnSizingInfo((S) => {
            var T, I;
            const A = n.options.columnResizeDirection === "rtl" ? -1 : 1, E = ($ - ((T = S == null ? void 0 : S.startOffset) != null ? T : 0)) * A, D = Math.max(E / ((I = S == null ? void 0 : S.startSize) != null ? I : 0), -0.999999);
            return S.columnSizingStart.forEach((z) => {
              let [Y, le] = z;
              d[Y] = Math.round(Math.max(le + le * D, 0) * 100) / 100;
            }), {
              ...S,
              deltaOffset: E,
              deltaPercentage: D
            };
          }), (n.options.columnResizeMode === "onChange" || k === "end") && n.setColumnSizing((S) => ({
            ...S,
            ...d
          })));
        }, f = (k) => u("move", k), b = (k) => {
          u("end", k), n.setColumnSizingInfo(($) => ({
            ...$,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, h = UN(t), p = {
          moveHandler: (k) => f(k.clientX),
          upHandler: (k) => {
            h == null || h.removeEventListener("mousemove", p.moveHandler), h == null || h.removeEventListener("mouseup", p.upHandler), b(k.clientX);
          }
        }, x = {
          moveHandler: (k) => (k.cancelable && (k.preventDefault(), k.stopPropagation()), f(k.touches[0].clientX), !1),
          upHandler: (k) => {
            var $;
            h == null || h.removeEventListener("touchmove", x.moveHandler), h == null || h.removeEventListener("touchend", x.upHandler), k.cancelable && (k.preventDefault(), k.stopPropagation()), b(($ = k.touches[0]) == null ? void 0 : $.clientX);
          }
        }, y = KN() ? {
          passive: !1
        } : !1;
        kd(r) ? (h == null || h.addEventListener("touchmove", x.moveHandler, y), h == null || h.addEventListener("touchend", x.upHandler, y)) : (h == null || h.addEventListener("mousemove", p.moveHandler, y), h == null || h.addEventListener("mouseup", p.upHandler, y)), n.setColumnSizingInfo((k) => ({
          ...k,
          startOffset: s,
          startSize: o,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: i,
          isResizingColumn: a.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (n) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(n), e.setColumnSizingInfo = (n) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(n), e.resetColumnSizing = (n) => {
      var t;
      e.setColumnSizing(n ? {} : (t = e.initialState.columnSizing) != null ? t : {});
    }, e.resetHeaderSizeInfo = (n) => {
      var t;
      e.setColumnSizingInfo(n ? yd() : (t = e.initialState.columnSizingInfo) != null ? t : yd());
    }, e.getTotalSize = () => {
      var n, t;
      return (n = (t = e.getHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((a, l) => a + l.getSize(), 0)) != null ? n : 0;
    }, e.getLeftTotalSize = () => {
      var n, t;
      return (n = (t = e.getLeftHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((a, l) => a + l.getSize(), 0)) != null ? n : 0;
    }, e.getCenterTotalSize = () => {
      var n, t;
      return (n = (t = e.getCenterHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((a, l) => a + l.getSize(), 0)) != null ? n : 0;
    }, e.getRightTotalSize = () => {
      var n, t;
      return (n = (t = e.getRightHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((a, l) => a + l.getSize(), 0)) != null ? n : 0;
    };
  }
};
let Wo = null;
function KN() {
  if (typeof Wo == "boolean") return Wo;
  let e = !1;
  try {
    const n = {
      get passive() {
        return e = !0, !1;
      }
    }, t = () => {
    };
    window.addEventListener("test", t, n), window.removeEventListener("test", t);
  } catch {
    e = !1;
  }
  return Wo = e, Wo;
}
function kd(e) {
  return e.type === "touchstart";
}
const YN = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: Sn("columnVisibility", e)
  }),
  createColumn: (e, n) => {
    e.toggleVisibility = (t) => {
      e.getCanHide() && n.setColumnVisibility((a) => ({
        ...a,
        [e.id]: t ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var t, a;
      const l = e.columns;
      return (t = l.length ? l.some((r) => r.getIsVisible()) : (a = n.getState().columnVisibility) == null ? void 0 : a[e.id]) != null ? t : !0;
    }, e.getCanHide = () => {
      var t, a;
      return ((t = e.columnDef.enableHiding) != null ? t : !0) && ((a = n.options.enableHiding) != null ? a : !0);
    }, e.getToggleVisibilityHandler = () => (t) => {
      e.toggleVisibility == null || e.toggleVisibility(t.target.checked);
    };
  },
  createRow: (e, n) => {
    e._getAllVisibleCells = at(() => [e.getAllCells(), n.getState().columnVisibility], (t) => t.filter((a) => a.column.getIsVisible()), lt(n.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = at(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (t, a, l) => [...t, ...a, ...l], lt(n.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const n = (t, a) => at(() => [a(), a().filter((l) => l.getIsVisible()).map((l) => l.id).join("_")], (l) => l.filter((r) => r.getIsVisible == null ? void 0 : r.getIsVisible()), lt(e.options, "debugColumns", t));
    e.getVisibleFlatColumns = n("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = n("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = n("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = n("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = n("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (t) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(t), e.resetColumnVisibility = (t) => {
      var a;
      e.setColumnVisibility(t ? {} : (a = e.initialState.columnVisibility) != null ? a : {});
    }, e.toggleAllColumnsVisible = (t) => {
      var a;
      t = (a = t) != null ? a : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((l, r) => ({
        ...l,
        [r.id]: t || !(r.getCanHide != null && r.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((t) => !(t.getIsVisible != null && t.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((t) => t.getIsVisible == null ? void 0 : t.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (t) => {
      var a;
      e.toggleAllColumnsVisible((a = t.target) == null ? void 0 : a.checked);
    };
  }
};
function qr(e, n) {
  return n ? n === "center" ? e.getCenterVisibleLeafColumns() : n === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const JN = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, XN = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: Sn("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (n) => {
      var t;
      const a = (t = e.getCoreRowModel().flatRows[0]) == null || (t = t._getAllCellsByColumnId()[n.id]) == null ? void 0 : t.getValue();
      return typeof a == "string" || typeof a == "number";
    }
  }),
  createColumn: (e, n) => {
    e.getCanGlobalFilter = () => {
      var t, a, l, r;
      return ((t = e.columnDef.enableGlobalFilter) != null ? t : !0) && ((a = n.options.enableGlobalFilter) != null ? a : !0) && ((l = n.options.enableFilters) != null ? l : !0) && ((r = n.options.getColumnCanGlobalFilter == null ? void 0 : n.options.getColumnCanGlobalFilter(e)) != null ? r : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => ba.includesString, e.getGlobalFilterFn = () => {
      var n, t;
      const {
        globalFilterFn: a
      } = e.options;
      return Ss(a) ? a : a === "auto" ? e.getGlobalAutoFilterFn() : (n = (t = e.options.filterFns) == null ? void 0 : t[a]) != null ? n : ba[a];
    }, e.setGlobalFilter = (n) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(n);
    }, e.resetGlobalFilter = (n) => {
      e.setGlobalFilter(n ? void 0 : e.initialState.globalFilter);
    };
  }
}, ZN = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: Sn("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let n = !1, t = !1;
    e._autoResetExpanded = () => {
      var a, l;
      if (!n) {
        e._queue(() => {
          n = !0;
        });
        return;
      }
      if ((a = (l = e.options.autoResetAll) != null ? l : e.options.autoResetExpanded) != null ? a : !e.options.manualExpanding) {
        if (t) return;
        t = !0, e._queue(() => {
          e.resetExpanded(), t = !1;
        });
      }
    }, e.setExpanded = (a) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(a), e.toggleAllRowsExpanded = (a) => {
      a ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (a) => {
      var l, r;
      e.setExpanded(a ? {} : (l = (r = e.initialState) == null ? void 0 : r.expanded) != null ? l : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((a) => a.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (a) => {
      a.persist == null || a.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const a = e.getState().expanded;
      return a === !0 || Object.values(a).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const a = e.getState().expanded;
      return typeof a == "boolean" ? a === !0 : !(!Object.keys(a).length || e.getRowModel().flatRows.some((l) => !l.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let a = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((r) => {
        const o = r.split(".");
        a = Math.max(a, o.length);
      }), a;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, n) => {
    e.toggleExpanded = (t) => {
      n.setExpanded((a) => {
        var l;
        const r = a === !0 ? !0 : !!(a != null && a[e.id]);
        let o = {};
        if (a === !0 ? Object.keys(n.getRowModel().rowsById).forEach((i) => {
          o[i] = !0;
        }) : o = a, t = (l = t) != null ? l : !r, !r && t)
          return {
            ...o,
            [e.id]: !0
          };
        if (r && !t) {
          const {
            [e.id]: i,
            ...s
          } = o;
          return s;
        }
        return a;
      });
    }, e.getIsExpanded = () => {
      var t;
      const a = n.getState().expanded;
      return !!((t = n.options.getIsRowExpanded == null ? void 0 : n.options.getIsRowExpanded(e)) != null ? t : a === !0 || a != null && a[e.id]);
    }, e.getCanExpand = () => {
      var t, a, l;
      return (t = n.options.getRowCanExpand == null ? void 0 : n.options.getRowCanExpand(e)) != null ? t : ((a = n.options.enableExpanding) != null ? a : !0) && !!((l = e.subRows) != null && l.length);
    }, e.getIsAllParentsExpanded = () => {
      let t = !0, a = e;
      for (; t && a.parentId; )
        a = n.getRow(a.parentId, !0), t = a.getIsExpanded();
      return t;
    }, e.getToggleExpandedHandler = () => {
      const t = e.getCanExpand();
      return () => {
        t && e.toggleExpanded();
      };
    };
  }
}, ku = 0, wu = 10, wd = () => ({
  pageIndex: ku,
  pageSize: wu
}), QN = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...wd(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: Sn("pagination", e)
  }),
  createTable: (e) => {
    let n = !1, t = !1;
    e._autoResetPageIndex = () => {
      var a, l;
      if (!n) {
        e._queue(() => {
          n = !0;
        });
        return;
      }
      if ((a = (l = e.options.autoResetAll) != null ? l : e.options.autoResetPageIndex) != null ? a : !e.options.manualPagination) {
        if (t) return;
        t = !0, e._queue(() => {
          e.resetPageIndex(), t = !1;
        });
      }
    }, e.setPagination = (a) => {
      const l = (r) => Da(a, r);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(l);
    }, e.resetPagination = (a) => {
      var l;
      e.setPagination(a ? wd() : (l = e.initialState.pagination) != null ? l : wd());
    }, e.setPageIndex = (a) => {
      e.setPagination((l) => {
        let r = Da(a, l.pageIndex);
        const o = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return r = Math.max(0, Math.min(r, o)), {
          ...l,
          pageIndex: r
        };
      });
    }, e.resetPageIndex = (a) => {
      var l, r;
      e.setPageIndex(a ? ku : (l = (r = e.initialState) == null || (r = r.pagination) == null ? void 0 : r.pageIndex) != null ? l : ku);
    }, e.resetPageSize = (a) => {
      var l, r;
      e.setPageSize(a ? wu : (l = (r = e.initialState) == null || (r = r.pagination) == null ? void 0 : r.pageSize) != null ? l : wu);
    }, e.setPageSize = (a) => {
      e.setPagination((l) => {
        const r = Math.max(1, Da(a, l.pageSize)), o = l.pageSize * l.pageIndex, i = Math.floor(o / r);
        return {
          ...l,
          pageIndex: i,
          pageSize: r
        };
      });
    }, e.setPageCount = (a) => e.setPagination((l) => {
      var r;
      let o = Da(a, (r = e.options.pageCount) != null ? r : -1);
      return typeof o == "number" && (o = Math.max(-1, o)), {
        ...l,
        pageCount: o
      };
    }), e.getPageOptions = at(() => [e.getPageCount()], (a) => {
      let l = [];
      return a && a > 0 && (l = [...new Array(a)].fill(null).map((r, o) => o)), l;
    }, lt(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: a
      } = e.getState().pagination, l = e.getPageCount();
      return l === -1 ? !0 : l === 0 ? !1 : a < l - 1;
    }, e.previousPage = () => e.setPageIndex((a) => a - 1), e.nextPage = () => e.setPageIndex((a) => a + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var a;
      return (a = e.options.pageCount) != null ? a : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var a;
      return (a = e.options.rowCount) != null ? a : e.getPrePaginationRowModel().rows.length;
    };
  }
}, Cd = () => ({
  top: [],
  bottom: []
}), _N = {
  getInitialState: (e) => ({
    rowPinning: Cd(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: Sn("rowPinning", e)
  }),
  createRow: (e, n) => {
    e.pin = (t, a, l) => {
      const r = a ? e.getLeafRows().map((s) => {
        let {
          id: d
        } = s;
        return d;
      }) : [], o = l ? e.getParentRows().map((s) => {
        let {
          id: d
        } = s;
        return d;
      }) : [], i = /* @__PURE__ */ new Set([...o, e.id, ...r]);
      n.setRowPinning((s) => {
        var d, u;
        if (t === "bottom") {
          var f, b;
          return {
            top: ((f = s == null ? void 0 : s.top) != null ? f : []).filter((x) => !(i != null && i.has(x))),
            bottom: [...((b = s == null ? void 0 : s.bottom) != null ? b : []).filter((x) => !(i != null && i.has(x))), ...Array.from(i)]
          };
        }
        if (t === "top") {
          var h, p;
          return {
            top: [...((h = s == null ? void 0 : s.top) != null ? h : []).filter((x) => !(i != null && i.has(x))), ...Array.from(i)],
            bottom: ((p = s == null ? void 0 : s.bottom) != null ? p : []).filter((x) => !(i != null && i.has(x)))
          };
        }
        return {
          top: ((d = s == null ? void 0 : s.top) != null ? d : []).filter((x) => !(i != null && i.has(x))),
          bottom: ((u = s == null ? void 0 : s.bottom) != null ? u : []).filter((x) => !(i != null && i.has(x)))
        };
      });
    }, e.getCanPin = () => {
      var t;
      const {
        enableRowPinning: a,
        enablePinning: l
      } = n.options;
      return typeof a == "function" ? a(e) : (t = a ?? l) != null ? t : !0;
    }, e.getIsPinned = () => {
      const t = [e.id], {
        top: a,
        bottom: l
      } = n.getState().rowPinning, r = t.some((i) => a == null ? void 0 : a.includes(i)), o = t.some((i) => l == null ? void 0 : l.includes(i));
      return r ? "top" : o ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var t, a;
      const l = e.getIsPinned();
      if (!l) return -1;
      const r = (t = l === "top" ? n.getTopRows() : n.getBottomRows()) == null ? void 0 : t.map((o) => {
        let {
          id: i
        } = o;
        return i;
      });
      return (a = r == null ? void 0 : r.indexOf(e.id)) != null ? a : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (n) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(n), e.resetRowPinning = (n) => {
      var t, a;
      return e.setRowPinning(n ? Cd() : (t = (a = e.initialState) == null ? void 0 : a.rowPinning) != null ? t : Cd());
    }, e.getIsSomeRowsPinned = (n) => {
      var t;
      const a = e.getState().rowPinning;
      if (!n) {
        var l, r;
        return !!((l = a.top) != null && l.length || (r = a.bottom) != null && r.length);
      }
      return !!((t = a[n]) != null && t.length);
    }, e._getPinnedRows = (n, t, a) => {
      var l;
      return ((l = e.options.keepPinnedRows) == null || l ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (t ?? []).map((o) => {
          const i = e.getRow(o, !0);
          return i.getIsAllParentsExpanded() ? i : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (t ?? []).map((o) => n.find((i) => i.id === o))
      )).filter(Boolean).map((o) => ({
        ...o,
        position: a
      }));
    }, e.getTopRows = at(() => [e.getRowModel().rows, e.getState().rowPinning.top], (n, t) => e._getPinnedRows(n, t, "top"), lt(e.options, "debugRows", "getTopRows")), e.getBottomRows = at(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (n, t) => e._getPinnedRows(n, t, "bottom"), lt(e.options, "debugRows", "getBottomRows")), e.getCenterRows = at(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (n, t, a) => {
      const l = /* @__PURE__ */ new Set([...t ?? [], ...a ?? []]);
      return n.filter((r) => !l.has(r.id));
    }, lt(e.options, "debugRows", "getCenterRows"));
  }
}, e9 = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: Sn("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (n) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(n), e.resetRowSelection = (n) => {
      var t;
      return e.setRowSelection(n ? {} : (t = e.initialState.rowSelection) != null ? t : {});
    }, e.toggleAllRowsSelected = (n) => {
      e.setRowSelection((t) => {
        n = typeof n < "u" ? n : !e.getIsAllRowsSelected();
        const a = {
          ...t
        }, l = e.getPreGroupedRowModel().flatRows;
        return n ? l.forEach((r) => {
          r.getCanSelect() && (a[r.id] = !0);
        }) : l.forEach((r) => {
          delete a[r.id];
        }), a;
      });
    }, e.toggleAllPageRowsSelected = (n) => e.setRowSelection((t) => {
      const a = typeof n < "u" ? n : !e.getIsAllPageRowsSelected(), l = {
        ...t
      };
      return e.getRowModel().rows.forEach((r) => {
        Cu(l, r.id, a, !0, e);
      }), l;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = at(() => [e.getState().rowSelection, e.getCoreRowModel()], (n, t) => Object.keys(n).length ? Sd(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, lt(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = at(() => [e.getState().rowSelection, e.getFilteredRowModel()], (n, t) => Object.keys(n).length ? Sd(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, lt(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = at(() => [e.getState().rowSelection, e.getSortedRowModel()], (n, t) => Object.keys(n).length ? Sd(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, lt(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const n = e.getFilteredRowModel().flatRows, {
        rowSelection: t
      } = e.getState();
      let a = !!(n.length && Object.keys(t).length);
      return a && n.some((l) => l.getCanSelect() && !t[l.id]) && (a = !1), a;
    }, e.getIsAllPageRowsSelected = () => {
      const n = e.getPaginationRowModel().flatRows.filter((l) => l.getCanSelect()), {
        rowSelection: t
      } = e.getState();
      let a = !!n.length;
      return a && n.some((l) => !t[l.id]) && (a = !1), a;
    }, e.getIsSomeRowsSelected = () => {
      var n;
      const t = Object.keys((n = e.getState().rowSelection) != null ? n : {}).length;
      return t > 0 && t < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const n = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : n.filter((t) => t.getCanSelect()).some((t) => t.getIsSelected() || t.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (n) => {
      e.toggleAllRowsSelected(n.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (n) => {
      e.toggleAllPageRowsSelected(n.target.checked);
    };
  },
  createRow: (e, n) => {
    e.toggleSelected = (t, a) => {
      const l = e.getIsSelected();
      n.setRowSelection((r) => {
        var o;
        if (t = typeof t < "u" ? t : !l, e.getCanSelect() && l === t)
          return r;
        const i = {
          ...r
        };
        return Cu(i, e.id, t, (o = a == null ? void 0 : a.selectChildren) != null ? o : !0, n), i;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: t
      } = n.getState();
      return Yc(e, t);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: t
      } = n.getState();
      return Su(e, t) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: t
      } = n.getState();
      return Su(e, t) === "all";
    }, e.getCanSelect = () => {
      var t;
      return typeof n.options.enableRowSelection == "function" ? n.options.enableRowSelection(e) : (t = n.options.enableRowSelection) != null ? t : !0;
    }, e.getCanSelectSubRows = () => {
      var t;
      return typeof n.options.enableSubRowSelection == "function" ? n.options.enableSubRowSelection(e) : (t = n.options.enableSubRowSelection) != null ? t : !0;
    }, e.getCanMultiSelect = () => {
      var t;
      return typeof n.options.enableMultiRowSelection == "function" ? n.options.enableMultiRowSelection(e) : (t = n.options.enableMultiRowSelection) != null ? t : !0;
    }, e.getToggleSelectedHandler = () => {
      const t = e.getCanSelect();
      return (a) => {
        var l;
        t && e.toggleSelected((l = a.target) == null ? void 0 : l.checked);
      };
    };
  }
}, Cu = (e, n, t, a, l) => {
  var r;
  const o = l.getRow(n, !0);
  t ? (o.getCanMultiSelect() || Object.keys(e).forEach((i) => delete e[i]), o.getCanSelect() && (e[n] = !0)) : delete e[n], a && (r = o.subRows) != null && r.length && o.getCanSelectSubRows() && o.subRows.forEach((i) => Cu(e, i.id, t, a, l));
};
function Sd(e, n) {
  const t = e.getState().rowSelection, a = [], l = {}, r = function(o, i) {
    return o.map((s) => {
      var d;
      const u = Yc(s, t);
      if (u && (a.push(s), l[s.id] = s), (d = s.subRows) != null && d.length && (s = {
        ...s,
        subRows: r(s.subRows)
      }), u)
        return s;
    }).filter(Boolean);
  };
  return {
    rows: r(n.rows),
    flatRows: a,
    rowsById: l
  };
}
function Yc(e, n) {
  var t;
  return (t = n[e.id]) != null ? t : !1;
}
function Su(e, n, t) {
  var a;
  if (!((a = e.subRows) != null && a.length)) return !1;
  let l = !0, r = !1;
  return e.subRows.forEach((o) => {
    if (!(r && !l) && (o.getCanSelect() && (Yc(o, n) ? r = !0 : l = !1), o.subRows && o.subRows.length)) {
      const i = Su(o, n);
      i === "all" ? r = !0 : (i === "some" && (r = !0), l = !1);
    }
  }), l ? "all" : r ? "some" : !1;
}
const $u = /([0-9]+)/gm, t9 = (e, n, t) => mx(Ya(e.getValue(t)).toLowerCase(), Ya(n.getValue(t)).toLowerCase()), n9 = (e, n, t) => mx(Ya(e.getValue(t)), Ya(n.getValue(t))), a9 = (e, n, t) => Jc(Ya(e.getValue(t)).toLowerCase(), Ya(n.getValue(t)).toLowerCase()), l9 = (e, n, t) => Jc(Ya(e.getValue(t)), Ya(n.getValue(t))), r9 = (e, n, t) => {
  const a = e.getValue(t), l = n.getValue(t);
  return a > l ? 1 : a < l ? -1 : 0;
}, o9 = (e, n, t) => Jc(e.getValue(t), n.getValue(t));
function Jc(e, n) {
  return e === n ? 0 : e > n ? 1 : -1;
}
function Ya(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function mx(e, n) {
  const t = e.split($u).filter(Boolean), a = n.split($u).filter(Boolean);
  for (; t.length && a.length; ) {
    const l = t.shift(), r = a.shift(), o = parseInt(l, 10), i = parseInt(r, 10), s = [o, i].sort();
    if (isNaN(s[0])) {
      if (l > r)
        return 1;
      if (r > l)
        return -1;
      continue;
    }
    if (isNaN(s[1]))
      return isNaN(o) ? -1 : 1;
    if (o > i)
      return 1;
    if (i > o)
      return -1;
  }
  return t.length - a.length;
}
const yr = {
  alphanumeric: t9,
  alphanumericCaseSensitive: n9,
  text: a9,
  textCaseSensitive: l9,
  datetime: r9,
  basic: o9
}, i9 = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: Sn("sorting", e),
    isMultiSortEvent: (n) => n.shiftKey
  }),
  createColumn: (e, n) => {
    e.getAutoSortingFn = () => {
      const t = n.getFilteredRowModel().flatRows.slice(10);
      let a = !1;
      for (const l of t) {
        const r = l == null ? void 0 : l.getValue(e.id);
        if (Object.prototype.toString.call(r) === "[object Date]")
          return yr.datetime;
        if (typeof r == "string" && (a = !0, r.split($u).length > 1))
          return yr.alphanumeric;
      }
      return a ? yr.text : yr.basic;
    }, e.getAutoSortDir = () => {
      const t = n.getFilteredRowModel().flatRows[0];
      return typeof (t == null ? void 0 : t.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var t, a;
      if (!e)
        throw new Error();
      return Ss(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (t = (a = n.options.sortingFns) == null ? void 0 : a[e.columnDef.sortingFn]) != null ? t : yr[e.columnDef.sortingFn];
    }, e.toggleSorting = (t, a) => {
      const l = e.getNextSortingOrder(), r = typeof t < "u" && t !== null;
      n.setSorting((o) => {
        const i = o == null ? void 0 : o.find((h) => h.id === e.id), s = o == null ? void 0 : o.findIndex((h) => h.id === e.id);
        let d = [], u, f = r ? t : l === "desc";
        if (o != null && o.length && e.getCanMultiSort() && a ? i ? u = "toggle" : u = "add" : o != null && o.length && s !== o.length - 1 ? u = "replace" : i ? u = "toggle" : u = "replace", u === "toggle" && (r || l || (u = "remove")), u === "add") {
          var b;
          d = [...o, {
            id: e.id,
            desc: f
          }], d.splice(0, d.length - ((b = n.options.maxMultiSortColCount) != null ? b : Number.MAX_SAFE_INTEGER));
        } else u === "toggle" ? d = o.map((h) => h.id === e.id ? {
          ...h,
          desc: f
        } : h) : u === "remove" ? d = o.filter((h) => h.id !== e.id) : d = [{
          id: e.id,
          desc: f
        }];
        return d;
      });
    }, e.getFirstSortDir = () => {
      var t, a;
      return ((t = (a = e.columnDef.sortDescFirst) != null ? a : n.options.sortDescFirst) != null ? t : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (t) => {
      var a, l;
      const r = e.getFirstSortDir(), o = e.getIsSorted();
      return o ? o !== r && ((a = n.options.enableSortingRemoval) == null || a) && // If enableSortRemove, enable in general
      (!(t && (l = n.options.enableMultiRemove) != null) || l) ? !1 : o === "desc" ? "asc" : "desc" : r;
    }, e.getCanSort = () => {
      var t, a;
      return ((t = e.columnDef.enableSorting) != null ? t : !0) && ((a = n.options.enableSorting) != null ? a : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var t, a;
      return (t = (a = e.columnDef.enableMultiSort) != null ? a : n.options.enableMultiSort) != null ? t : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var t;
      const a = (t = n.getState().sorting) == null ? void 0 : t.find((l) => l.id === e.id);
      return a ? a.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var t, a;
      return (t = (a = n.getState().sorting) == null ? void 0 : a.findIndex((l) => l.id === e.id)) != null ? t : -1;
    }, e.clearSorting = () => {
      n.setSorting((t) => t != null && t.length ? t.filter((a) => a.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const t = e.getCanSort();
      return (a) => {
        t && (a.persist == null || a.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? n.options.isMultiSortEvent == null ? void 0 : n.options.isMultiSortEvent(a) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (n) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(n), e.resetSorting = (n) => {
      var t, a;
      e.setSorting(n ? [] : (t = (a = e.initialState) == null ? void 0 : a.sorting) != null ? t : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, s9 = [
  TN,
  YN,
  WN,
  qN,
  EN,
  RN,
  JN,
  //depends on ColumnFaceting
  XN,
  //depends on ColumnFiltering
  i9,
  HN,
  //depends on RowSorting
  ZN,
  QN,
  _N,
  e9,
  GN
];
function d9(e) {
  var n, t;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const a = [...s9, ...(n = e._features) != null ? n : []];
  let l = {
    _features: a
  };
  const r = l._features.reduce((b, h) => Object.assign(b, h.getDefaultOptions == null ? void 0 : h.getDefaultOptions(l)), {}), o = (b) => l.options.mergeOptions ? l.options.mergeOptions(r, b) : {
    ...r,
    ...b
  };
  let s = {
    ...{},
    ...(t = e.initialState) != null ? t : {}
  };
  l._features.forEach((b) => {
    var h;
    s = (h = b.getInitialState == null ? void 0 : b.getInitialState(s)) != null ? h : s;
  });
  const d = [];
  let u = !1;
  const f = {
    _features: a,
    options: {
      ...r,
      ...e
    },
    initialState: s,
    _queue: (b) => {
      d.push(b), u || (u = !0, Promise.resolve().then(() => {
        for (; d.length; )
          d.shift()();
        u = !1;
      }).catch((h) => setTimeout(() => {
        throw h;
      })));
    },
    reset: () => {
      l.setState(l.initialState);
    },
    setOptions: (b) => {
      const h = Da(b, l.options);
      l.options = o(h);
    },
    getState: () => l.options.state,
    setState: (b) => {
      l.options.onStateChange == null || l.options.onStateChange(b);
    },
    _getRowId: (b, h, p) => {
      var x;
      return (x = l.options.getRowId == null ? void 0 : l.options.getRowId(b, h, p)) != null ? x : `${p ? [p.id, h].join(".") : h}`;
    },
    getCoreRowModel: () => (l._getCoreRowModel || (l._getCoreRowModel = l.options.getCoreRowModel(l)), l._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => l.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (b, h) => {
      let p = (h ? l.getPrePaginationRowModel() : l.getRowModel()).rowsById[b];
      if (!p && (p = l.getCoreRowModel().rowsById[b], !p))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${b}`) : new Error();
      return p;
    },
    _getDefaultColumnDef: at(() => [l.options.defaultColumn], (b) => {
      var h;
      return b = (h = b) != null ? h : {}, {
        header: (p) => {
          const x = p.header.column.columnDef;
          return x.accessorKey ? x.accessorKey : x.accessorFn ? x.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (p) => {
          var x, y;
          return (x = (y = p.renderValue()) == null || y.toString == null ? void 0 : y.toString()) != null ? x : null;
        },
        ...l._features.reduce((p, x) => Object.assign(p, x.getDefaultColumnDef == null ? void 0 : x.getDefaultColumnDef()), {}),
        ...b
      };
    }, lt(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => l.options.columns,
    getAllColumns: at(() => [l._getColumnDefs()], (b) => {
      const h = function(p, x, y) {
        return y === void 0 && (y = 0), p.map((k) => {
          const $ = LN(l, k, y, x), S = k;
          return $.columns = S.columns ? h(S.columns, $, y + 1) : [], $;
        });
      };
      return h(b);
    }, lt(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: at(() => [l.getAllColumns()], (b) => b.flatMap((h) => h.getFlatColumns()), lt(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: at(() => [l.getAllFlatColumns()], (b) => b.reduce((h, p) => (h[p.id] = p, h), {}), lt(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: at(() => [l.getAllColumns(), l._getOrderColumnsFn()], (b, h) => {
      let p = b.flatMap((x) => x.getLeafColumns());
      return h(p);
    }, lt(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (b) => {
      const h = l._getAllFlatColumnsById()[b];
      return process.env.NODE_ENV !== "production" && !h && console.error(`[Table] Column with id '${b}' does not exist.`), h;
    }
  };
  Object.assign(l, f);
  for (let b = 0; b < l._features.length; b++) {
    const h = l._features[b];
    h == null || h.createTable == null || h.createTable(l);
  }
  return l;
}
function u9() {
  return (e) => at(() => [e.options.data], (n) => {
    const t = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, a = function(l, r, o) {
      r === void 0 && (r = 0);
      const i = [];
      for (let d = 0; d < l.length; d++) {
        const u = AN(e, e._getRowId(l[d], d, o), l[d], d, r, void 0, o == null ? void 0 : o.id);
        if (t.flatRows.push(u), t.rowsById[u.id] = u, i.push(u), e.options.getSubRows) {
          var s;
          u.originalSubRows = e.options.getSubRows(l[d], d), (s = u.originalSubRows) != null && s.length && (u.subRows = a(u.originalSubRows, r + 1, u));
        }
      }
      return i;
    };
    return t.rows = a(n), t;
  }, lt(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
/**
   * vue-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function qo() {
  return !0;
}
const c9 = Symbol("merge-proxy"), f9 = {
  get(e, n, t) {
    return n === c9 ? t : e.get(n);
  },
  has(e, n) {
    return e.has(n);
  },
  set: qo,
  deleteProperty: qo,
  getOwnPropertyDescriptor(e, n) {
    return {
      configurable: !0,
      enumerable: !0,
      get() {
        return e.get(n);
      },
      set: qo,
      deleteProperty: qo
    };
  },
  ownKeys(e) {
    return e.keys();
  }
};
function $d(e) {
  return "value" in e ? e.value : e;
}
function Ir() {
  for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++)
    n[t] = arguments[t];
  return new Proxy({
    get(a) {
      for (let l = n.length - 1; l >= 0; l--) {
        const r = $d(n[l])[a];
        if (r !== void 0) return r;
      }
    },
    has(a) {
      for (let l = n.length - 1; l >= 0; l--)
        if (a in $d(n[l])) return !0;
      return !1;
    },
    keys() {
      const a = [];
      for (let l = 0; l < n.length; l++) a.push(...Object.keys($d(n[l])));
      return [...Array.from(new Set(a))];
    }
  }, f9);
}
const Tb = ye({
  props: ["render", "props"],
  setup: (e) => () => typeof e.render == "function" || typeof e.render == "object" ? ea(e.render, e.props) : e.render
});
function Ab(e) {
  return Ir(e, {
    data: L(e.data)
  });
}
function h9(e) {
  const n = Jo(e.data), t = Ir({
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    mergeOptions(r, o) {
      return n ? {
        ...r,
        ...o
      } : Ir(r, o);
    }
  }, n ? Ab(e) : e), a = d9(t);
  if (n) {
    const r = er(e.data);
    $e(r, () => {
      a.setState((o) => ({
        ...o,
        data: r.value
      }));
    }, {
      immediate: !0
    });
  }
  const l = R(a.initialState);
  return Kb(() => {
    a.setOptions((r) => {
      var o;
      const i = new Proxy({}, {
        get: (s, d) => l.value[d]
      });
      return Ir(r, n ? Ab(e) : e, {
        // merge the initialState and `options.state`
        // create a new proxy on each `setOptions` call
        // and get the value from state on each property access
        state: Ir(i, (o = e.state) != null ? o : {}),
        // Similarly, we'll maintain both our internal state and any user-provided
        // state.
        onStateChange: (s) => {
          s instanceof Function ? l.value = s(l.value) : l.value = s, e.onStateChange == null || e.onStateChange(s);
        }
      });
    });
  }), a;
}
const b9 = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M2.21232%2014.0601C1.91928%2012.6755%201.93115%2011.2743%202.21316%209.94038C3.32308%2010.0711%204.29187%209.7035%204.60865%208.93871C4.92544%208.17392%204.50032%207.22896%203.62307%206.53655C4.3669%205.3939%205.34931%204.39471%206.53554%203.62289C7.228%204.50059%208.17324%204.92601%208.93822%204.60914C9.7032%204.29227%2010.0708%203.32308%209.93979%202.21281C11.3243%201.91977%2012.7255%201.93164%2014.0595%202.21364C13.9288%203.32356%2014.2964%204.29235%2015.0612%204.60914C15.8259%204.92593%2016.7709%204.5008%2017.4633%203.62356C18.606%204.36739%2019.6052%205.3498%2020.377%206.53602C19.4993%207.22849%2019.0739%208.17373%2019.3907%208.93871C19.7076%209.70369%2020.6768%2010.0713%2021.7871%209.94028C22.0801%2011.3248%2022.0682%2012.726%2021.7862%2014.06C20.6763%2013.9293%2019.7075%2014.2969%2019.3907%2015.0616C19.0739%2015.8264%2019.4991%2016.7714%2020.3763%2017.4638C19.6325%2018.6064%2018.6501%2019.6056%2017.4638%2020.3775C16.7714%2019.4998%2015.8261%2019.0743%2015.0612%2019.3912C14.2962%2019.7081%2013.9286%2020.6773%2014.0596%2021.7875C12.675%2022.0806%2011.2738%2022.0687%209.93989%2021.7867C10.0706%2020.6768%209.70301%2019.708%208.93822%2019.3912C8.17343%2019.0744%207.22848%2019.4995%206.53606%2020.3768C5.39341%2019.633%204.39422%2018.6506%203.62241%2017.4643C4.5001%2016.7719%204.92552%2015.8266%204.60865%2015.0616C4.29179%2014.2967%203.32259%2013.9291%202.21232%2014.0601ZM3.99975%2012.2104C5.09956%2012.5148%206.00718%2013.2117%206.45641%2014.2963C6.90564%2015.3808%206.75667%2016.5154%206.19421%2017.5083C6.29077%2017.61%206.38998%2017.7092%206.49173%2017.8056C7.4846%2017.2432%208.61912%2017.0943%209.70359%2017.5435C10.7881%2017.9927%2011.485%2018.9002%2011.7894%2019.9999C11.9295%2020.0037%2012.0697%2020.0038%2012.2099%2020.0001C12.5143%2018.9003%2013.2112%2017.9927%2014.2958%2017.5435C15.3803%2017.0942%2016.5149%2017.2432%2017.5078%2017.8057C17.6096%2017.7091%2017.7087%2017.6099%2017.8051%2017.5081C17.2427%2016.5153%2017.0938%2015.3807%2017.543%2014.2963C17.9922%2013.2118%2018.8997%2012.5149%2019.9994%2012.2105C20.0032%2012.0704%2020.0033%2011.9301%2019.9996%2011.7899C18.8998%2011.4856%2017.9922%2010.7886%2017.543%209.70407C17.0937%208.61953%2017.2427%207.48494%2017.8052%206.49204C17.7086%206.39031%2017.6094%206.2912%2017.5076%206.19479C16.5148%206.75717%2015.3803%206.9061%2014.2958%206.4569C13.2113%206.0077%2012.5144%205.10016%2012.21%204.00044C12.0699%203.99666%2011.9297%203.99659%2011.7894%204.00024C11.4851%205.10005%2010.7881%206.00767%209.70359%206.4569C8.61904%206.90613%207.48446%206.75715%206.49155%206.1947C6.38982%206.29126%206.29071%206.39047%206.19431%206.49222C6.75668%207.48509%206.90561%208.61961%206.45641%209.70407C6.00721%2010.7885%205.09967%2011.4855%203.99995%2011.7899C3.99617%2011.93%203.9961%2012.0702%203.99975%2012.2104ZM11.9997%2015.0002C10.3428%2015.0002%208.99969%2013.657%208.99969%2012.0002C8.99969%2010.3433%2010.3428%209.00018%2011.9997%209.00018C13.6565%209.00018%2014.9997%2010.3433%2014.9997%2012.0002C14.9997%2013.657%2013.6565%2015.0002%2011.9997%2015.0002ZM11.9997%2013.0002C12.552%2013.0002%2012.9997%2012.5525%2012.9997%2012.0002C12.9997%2011.4479%2012.552%2011.0002%2011.9997%2011.0002C11.4474%2011.0002%2010.9997%2011.4479%2010.9997%2012.0002C10.9997%2012.5525%2011.4474%2013.0002%2011.9997%2013.0002Z'/%3e%3c/svg%3e";
function g9(e) {
  return e.map((n) => {
    const t = typeof n.header == "function" ? (l) => n.header({
      table: {
        getIsAllPageRowsSelected: () => l.table.getIsAllPageRowsSelected(),
        getIsSomePageRowsSelected: () => l.table.getIsSomePageRowsSelected(),
        toggleAllPageRowsSelected: (r) => l.table.toggleAllPageRowsSelected(r)
      }
    }) : n.header, a = {
      id: n.id,
      header: t,
      enableSorting: n.sortable,
      enableResizing: n.resizable,
      enablePinning: n.enablePinning ?? !1,
      meta: {
        enableColumnDragging: n.draggable,
        headerMenuItems: n.headerMenuItems,
        headerMenuAriaLabel: n.headerMenuAriaLabel,
        isCustomHeader: n.customHeader,
        noTruncate: n.noTruncate,
        // CONSTRAINT: no `??` here — `undefined` and `null` are two different headers downstream.
        sortDirection: n.sortDirection,
        locked: n.locked,
        showPinIcon: n.showPinIcon ?? !0
      }
    };
    return n.width !== void 0 && (a.size = n.width), n.minWidth !== void 0 && (a.minSize = n.minWidth), n.maxWidth !== void 0 && (a.maxSize = n.maxWidth), n.cell && (a.cell = (l) => n.cell({
      row: {
        original: l.row.original,
        getValue: (r) => l.row.getValue(r),
        id: l.row.id,
        getIsSelected: () => l.row.getIsSelected(),
        toggleSelected: (r) => l.row.toggleSelected(r)
      },
      getValue: () => l.getValue()
    })), n.key ? { ...a, accessorKey: n.key } : a;
  });
}
const m9 = ["aria-label"], p9 = { key: 0 }, v9 = {
  key: 1,
  class: "sticky right-0 z-30 w-10 p-0 bg-white dark:bg-(--colors-background-black-default)"
}, x9 = ["aria-label"], y9 = ["src"], k9 = { key: 0 }, w9 = {
  key: 1,
  "data-testid": "data-row-end",
  class: "row-end-cell sticky right-0 z-10 w-10 p-0 bg-white dark:bg-(--colors-background-black-default)"
}, C9 = { class: "flex items-center justify-center" }, S9 = {
  key: 2,
  "aria-hidden": "true"
}, $9 = 40, I9 = /* @__PURE__ */ ye({
  __name: "DataTable",
  props: {
    columns: {},
    data: {},
    hasSettings: { type: Boolean },
    columnVisibility: {},
    columnOrder: {},
    stickyHeader: { type: Boolean },
    maxHeight: {},
    emptyText: {},
    settingsAriaLabel: {},
    regionLabel: {},
    columnPinning: {},
    columnSizing: {},
    isRowMuted: { type: Function },
    isRowHighlighted: { type: Function }
  },
  emits: ["settings-click", "pin-column", "update:columnOrder", "update:columnPinning", "update:columnSizing"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = R(a.columnOrder ?? []);
    $e(
      () => a.columnOrder,
      (N) => {
        N && (r.value = N);
      }
    );
    const o = R({}), i = R(a.columnPinning ?? { left: [], right: [] }), s = R(null), d = R(null), u = R(0), f = m(() => a.hasSettings ? $9 : 0), b = R({}), h = R({}), p = /* @__PURE__ */ new Set(), y = R({ ...{
      startOffset: null,
      startSize: null,
      deltaOffset: null,
      deltaPercentage: null,
      isResizingColumn: !1,
      columnSizingStart: []
    } }), k = R(!1), $ = h9({
      get data() {
        return a.data;
      },
      get columns() {
        return g9(a.columns);
      },
      columnResizeMode: "onChange",
      enableRowSelection: !0,
      enableColumnPinning: !0,
      defaultColumn: {
        minSize: 130
      },
      state: {
        get columnOrder() {
          return r.value;
        },
        get columnVisibility() {
          return a.columnVisibility ?? {};
        },
        get columnSizing() {
          return b.value;
        },
        get columnSizingInfo() {
          return y.value;
        },
        get columnPinning() {
          return i.value;
        },
        get rowSelection() {
          return o.value;
        }
      },
      onColumnOrderChange: (N) => {
        const G = typeof N == "function" ? N(r.value) : N;
        r.value = G, l("update:columnOrder", G);
      },
      onColumnSizingChange: (N) => {
        b.value = typeof N == "function" ? N(b.value) : N;
      },
      onColumnSizingInfoChange: (N) => {
        y.value = typeof N == "function" ? N(y.value) : N;
      },
      onColumnPinningChange: (N) => {
        const G = typeof N == "function" ? N(i.value) : N, U = i.value, K = (G.left ?? []).length === (U.left ?? []).length && (G.left ?? []).every((xe, X) => xe === (U.left ?? [])[X]), ge = (G.right ?? []).length === (U.right ?? []).length && (G.right ?? []).every((xe, X) => xe === (U.right ?? [])[X]);
        K && ge || (i.value = G, l("update:columnPinning", G));
      },
      onRowSelectionChange: (N) => {
        o.value = typeof N == "function" ? N(o.value) : N;
      },
      getCoreRowModel: u9()
    }), S = m(() => ({
      allSelected: $.getIsAllPageRowsSelected(),
      someSelected: $.getIsSomePageRowsSelected(),
      toggleAll: (N) => $.toggleAllPageRowsSelected(N),
      isSelected: (N) => {
        var G;
        return ((G = $.getRowModel().rows.find((U) => U.original === N)) == null ? void 0 : G.getIsSelected()) ?? !1;
      },
      toggleRow: (N, G) => {
        var U;
        return (U = $.getRowModel().rows.find((K) => K.original === N)) == null ? void 0 : U.toggleSelected(G);
      }
    }));
    function T(N, G = "left") {
      const U = $.getColumn(N);
      U && (U.pin(G), l("pin-column", N, G));
    }
    function I(N) {
      T(N, !1);
    }
    function A(N) {
      r.value = N;
    }
    $e(
      () => a.columnPinning,
      (N) => {
        if (!N) return;
        const G = N.left ?? [], U = N.right ?? [], K = i.value, ge = G.length === (K.left ?? []).length && G.every((X, ie) => X === (K.left ?? [])[ie]), xe = U.length === (K.right ?? []).length && U.every((X, ie) => X === (K.right ?? [])[ie]);
        ge && xe || (i.value = { left: [...G], right: [...U] });
      },
      { deep: !0 }
    ), n({ selection: S, pinColumn: T, unpinColumn: I, setColumnOrder: A });
    function E() {
      var K, ge;
      if (!d.value || Object.keys(b.value).length > 0) return;
      const N = Array.from(d.value.querySelectorAll("thead th")), G = ((K = $.getHeaderGroups()[0]) == null ? void 0 : K.headers) ?? [], U = {};
      if (G.forEach((xe, X) => {
        const ie = N[X];
        if (ie) {
          const he = xe.column.columnDef.maxSize;
          U[xe.column.id] = he !== void 0 ? Math.min(ie.offsetWidth, he) : ie.offsetWidth;
        }
      }), Object.keys(U).length > 0) {
        const xe = d.value.clientWidth, X = xe - f.value, he = Object.values(U).reduce((oe, Ce) => oe + Ce, 0) - X;
        if (he !== 0) {
          const oe = (ge = [...G].reverse().find((Ce) => Ce.column.columnDef.maxSize === void 0)) == null ? void 0 : ge.column.id;
          oe !== void 0 && (U[oe] = Math.max(130, U[oe] - he));
        }
        $.setColumnSizing(U), u.value = xe, h.value = { ...U }, k.value = !0, D();
      }
    }
    function D() {
      if (!k.value) return;
      const N = a.columnSizing ?? {}, G = Object.keys(N);
      if (G.length === 0) {
        p.size > 0 && (b.value = { ...h.value }, p.clear());
        return;
      }
      const U = new Set($.getAllLeafColumns().map((X) => X.id)), K = {};
      for (const X of G) {
        const ie = N[X];
        U.has(X) && typeof ie == "number" && ie > 0 && (K[X] = ie);
      }
      const ge = Object.keys(K);
      ge.length === p.size && ge.every((X) => b.value[X] === K[X]) || (b.value = { ...h.value, ...K }, p.clear(), ge.forEach((X) => p.add(X)));
    }
    function z() {
      const N = {};
      p.forEach((G) => {
        const U = b.value[G];
        typeof U == "number" && (N[G] = U);
      }), l("update:columnSizing", N);
    }
    $e(
      () => y.value.isResizingColumn,
      (N, G) => {
        G && !N && (p.add(G), z());
      }
    ), $e(() => a.columnSizing, D, { deep: !0 });
    function Y(N) {
      var ie;
      if (!k.value) return;
      const G = N - u.value;
      if (G === 0) return;
      const K = (((ie = $.getHeaderGroups()[0]) == null ? void 0 : ie.headers) ?? []).filter(
        (he) => he.column.columnDef.maxSize === void 0 || he.column.columnDef.maxSize >= Number.MAX_SAFE_INTEGER
      );
      if (K.length === 0) return;
      const ge = { ...b.value }, xe = K.reduce(
        (he, oe) => he + (ge[oe.column.id] ?? oe.column.getSize()),
        0
      );
      let X = G;
      K.forEach((he, oe) => {
        const Ce = ge[he.column.id] ?? he.column.getSize(), H = he.column.columnDef.minSize ?? 130, Z = oe === K.length - 1 ? X : Math.round(G * (Ce / xe));
        ge[he.column.id] = Math.max(H, Ce + Z), X -= Z;
      }), b.value = ge, u.value = N;
    }
    let le = null;
    ct(() => {
      Ge(() => {
        d.value && (le = new ResizeObserver((N) => {
          var U, K;
          const G = ((U = N[0]) == null ? void 0 : U.contentRect.width) ?? ((K = d.value) == null ? void 0 : K.clientWidth) ?? 0;
          k.value ? Y(Math.round(G)) : G > 0 && E();
        }), le.observe(d.value), d.value.clientWidth > 0 && E());
      });
    }), kt(() => {
      le == null || le.disconnect(), le = null;
    });
    const ne = m(() => {
      if (k.value)
        return `${$.getTotalSize() + f.value}px`;
    }), re = m(() => k.value ? $.getTotalSize() + f.value < u.value : !1);
    function O(N) {
      var U;
      const G = $.getColumn(N);
      ((U = G == null ? void 0 : G.columnDef.meta) == null ? void 0 : U.locked) !== !0 && (s.value = N);
    }
    function P(N) {
      var G;
      return ((G = N.columnDef.meta) == null ? void 0 : G.locked) === !0 ? "locked" : N.getIsPinned() === "left" ? "pinned" : "regular";
    }
    function V(N) {
      return (G) => {
        if (G.preventDefault(), !s.value) return;
        const U = $.getVisibleLeafColumns().map((H) => H.id), K = U.indexOf(s.value), ge = U.indexOf(N);
        if (ge === 0 || K === -1 || ge === -1) return;
        const xe = $.getColumn(s.value), X = $.getColumn(N);
        if (!xe || !X) {
          s.value = null;
          return;
        }
        const ie = P(xe), he = P(X);
        if (ie === "locked" || he === "locked" || ie !== he) {
          s.value = null;
          return;
        }
        if (ie === "pinned" && he === "pinned") {
          const H = [...$.getState().columnPinning.left ?? []], Z = H.indexOf(s.value), ee = H.indexOf(N);
          if (Z !== -1 && ee !== -1 && Z !== ee) {
            const [J] = H.splice(Z, 1);
            H.splice(ee, 0, J), $.setColumnPinning({
              left: H,
              right: $.getState().columnPinning.right ?? []
            });
          }
        }
        const oe = [...U], [Ce] = oe.splice(K, 1);
        oe.splice(ge, 0, Ce), $.setColumnOrder(oe), s.value = null;
      };
    }
    function M(N) {
      const G = N.style.width, U = N.style.maxWidth;
      N.style.width = "max-content", N.style.maxWidth = "none";
      const K = N.scrollWidth;
      return N.style.width = G, N.style.maxWidth = U, K;
    }
    function B(N) {
      var ee, J, F;
      if (!d.value) return;
      const G = (ee = $.getHeaderGroups()[0]) == null ? void 0 : ee.headers.findIndex((_) => _.column.id === N);
      if (G === void 0 || G < 0) return;
      const K = Array.from(d.value.querySelectorAll("thead th"))[G], ge = K == null ? void 0 : K.querySelector(".truncate, [data-slot]"), xe = ge ? M(ge) : (K == null ? void 0 : K.scrollWidth) ?? 0, X = d.value.querySelectorAll("tbody tr");
      let ie = 0;
      X.forEach((_) => {
        const se = _.querySelectorAll("td")[G];
        if (se) {
          const Q = se.querySelector(".truncate");
          ie = Math.max(ie, Q ? M(Q) : se.scrollWidth);
        }
      });
      const he = (F = (J = $.getHeaderGroups()[0]) == null ? void 0 : J.headers[G]) == null ? void 0 : F.column, oe = (he == null ? void 0 : he.columnDef.minSize) ?? 130, Ce = (he == null ? void 0 : he.columnDef.maxSize) ?? 1e3, H = Math.min(
        Ce,
        Math.max(oe, Math.max(xe, ie) + 24)
      ), Z = { ...b.value, [N]: H };
      $.setColumnSizing(Z), p.add(N), z();
    }
    function q(N) {
      const G = N.getIsPinned();
      if (!G)
        return k.value ? { width: `${N.getSize()}px` } : void 0;
      const U = {
        position: "sticky",
        zIndex: "10"
      };
      return G === "left" && (U.left = `${N.getStart("left")}px`), k.value && (U.width = `${N.getSize()}px`), U;
    }
    return (N, G) => (c(), g("div", {
      class: C(["relative border-x border-(--colors-border-base-soft) dark:border-(--colors-border-base)", { "h-full flex flex-col": e.stickyHeader && !e.maxHeight }])
    }, [
      v("div", {
        ref_key: "containerRef",
        ref: d,
        role: "region",
        "aria-label": e.regionLabel ?? "Data table",
        "data-testid": "data-table-container",
        class: C(["relative overflow-x-auto text-(--text-text-heading)", { "overflow-y-auto flex-1 min-h-0": e.stickyHeader && !e.maxHeight }]),
        style: je({ scrollbarGutter: "stable", ...e.maxHeight ? { maxHeight: e.maxHeight, overflowY: "auto" } : {} })
      }, [
        te(L(iN), { "table-width": ne.value }, {
          default: ve(() => [
            te(L(CN), {
              "is-sticky": e.stickyHeader || !!e.maxHeight
            }, {
              default: ve(() => [
                (c(!0), g(de, null, Re(L($).getHeaderGroups(), (U) => (c(), W(L(ri), {
                  key: U.id
                }, {
                  default: ve(() => [
                    (c(!0), g(de, null, Re(U.headers, (K) => {
                      var ge, xe, X, ie, he, oe, Ce;
                      return c(), W(L(wN), {
                        key: K.id,
                        style: je(q(K.column)),
                        "is-pinned": K.column.getIsPinned() === "left",
                        "is-last-pinned": K.column.getIsLastColumn("left"),
                        "header-menu-items": (ge = K.column.columnDef.meta) == null ? void 0 : ge.headerMenuItems,
                        "menu-aria-label": (xe = K.column.columnDef.meta) == null ? void 0 : xe.headerMenuAriaLabel,
                        "is-custom-header": (X = K.column.columnDef.meta) == null ? void 0 : X.isCustomHeader,
                        "is-draggable": ((ie = K.column.columnDef.meta) == null ? void 0 : ie.enableColumnDragging) === !0,
                        "is-locked": ((he = K.column.columnDef.meta) == null ? void 0 : he.locked) === !0,
                        "is-pin-icon-visible": ((oe = K.column.columnDef.meta) == null ? void 0 : oe.showPinIcon) !== !1,
                        "sort-direction": (Ce = K.column.columnDef.meta) == null ? void 0 : Ce.sortDirection,
                        "is-resizable": K.column.getCanResize(),
                        "is-resizing-active": K.column.getIsResizing(),
                        class: "header-cell",
                        onDragHandleStart: (H) => O(K.column.id),
                        onDragover: G[0] || (G[0] = Je(() => {
                        }, ["prevent"])),
                        onDrop: (H) => V(K.column.id)(H),
                        onResizeStart: (H) => K.getResizeHandler()(H),
                        onResizeAuto: (H) => B(K.column.id)
                      }, {
                        default: ve(() => [
                          K.isPlaceholder ? w("", !0) : (c(), W(L(Tb), {
                            key: 0,
                            render: K.column.columnDef.header,
                            props: K.getContext()
                          }, null, 8, ["render", "props"]))
                        ]),
                        _: 2
                      }, 1032, ["style", "is-pinned", "is-last-pinned", "header-menu-items", "menu-aria-label", "is-custom-header", "is-draggable", "is-locked", "is-pin-icon-visible", "sort-direction", "is-resizable", "is-resizing-active", "onDragHandleStart", "onDrop", "onResizeStart", "onResizeAuto"]);
                    }), 128)),
                    re.value ? (c(), g("th", p9)) : w("", !0),
                    e.hasSettings ? (c(), g("th", v9, [
                      v("button", {
                        "data-testid": "data-settings",
                        "aria-label": e.settingsAriaLabel ?? "Column settings",
                        class: "data-settings-btn flex items-center justify-center w-10 h-10 p-0 cursor-pointer focus-visible:ring-2 focus-visible:ring-royalblue focus-visible:outline-none transition-colors",
                        onClick: G[1] || (G[1] = (K) => l("settings-click"))
                      }, [
                        v("img", {
                          class: "size-5",
                          src: L(b9),
                          alt: ""
                        }, null, 8, y9)
                      ], 8, x9)
                    ])) : w("", !0)
                  ]),
                  _: 2
                }, 1024))), 128))
              ]),
              _: 1
            }, 8, ["is-sticky"]),
            te(L(sN), null, {
              default: ve(() => {
                var U;
                return [
                  (U = L($).getRowModel().rows) != null && U.length ? (c(!0), g(de, { key: 0 }, Re(L($).getRowModel().rows, (K) => {
                    var ge, xe;
                    return c(), W(L(ri), {
                      key: K.id,
                      "data-state": K.getIsSelected() ? "selected" : void 0,
                      "data-muted": (ge = e.isRowMuted) != null && ge.call(e, K.original) ? "true" : void 0,
                      "data-highlighted": (xe = e.isRowHighlighted) != null && xe.call(e, K.original) ? "true" : void 0
                    }, {
                      default: ve(() => [
                        (c(!0), g(de, null, Re(K.getVisibleCells(), (X) => {
                          var ie;
                          return c(), W(L(yu), {
                            key: X.id,
                            "no-truncate": (ie = X.column.columnDef.meta) == null ? void 0 : ie.noTruncate,
                            style: je(q(X.column)),
                            class: C([
                              X.column.getIsPinned() === "left" ? "sticky z-10 bg-white dark:bg-(--colors-background-black-default) pinned-cell" : "",
                              X.column.getIsLastColumn("left") ? "pinned-cell-last" : ""
                            ])
                          }, {
                            default: ve(() => [
                              te(L(Tb), {
                                render: X.column.columnDef.cell ?? X.getValue,
                                props: X.getContext()
                              }, null, 8, ["render", "props"])
                            ]),
                            _: 2
                          }, 1032, ["no-truncate", "style", "class"]);
                        }), 128)),
                        re.value ? (c(), g("td", k9)) : w("", !0),
                        e.hasSettings && N.$slots["row-end"] ? (c(), g("td", w9, [
                          v("div", C9, [
                            Ae(N.$slots, "row-end", {
                              row: K.original
                            }, void 0, !0)
                          ])
                        ])) : e.hasSettings ? (c(), g("td", S9)) : w("", !0)
                      ]),
                      _: 2
                    }, 1032, ["data-state", "data-muted", "data-highlighted"]);
                  }), 128)) : (c(), W(L(ri), {
                    key: 1,
                    class: "border-b-0! hover:bg-white! dark:hover:bg-(--colors-background-black-default)!"
                  }, {
                    default: ve(() => [
                      te(L(yu), {
                        colspan: e.columns.length + 1,
                        class: "h-24 text-center"
                      }, {
                        default: ve(() => [
                          nt(j(e.emptyText ?? "No results."), 1)
                        ]),
                        _: 1
                      }, 8, ["colspan"])
                    ]),
                    _: 1
                  }))
                ];
              }),
              _: 3
            })
          ]),
          _: 3
        }, 8, ["table-width"])
      ], 14, m9)
    ], 2));
  }
}), lU = /* @__PURE__ */ dt(I9, [["__scopeId", "data-v-08ccb149"]]);
function rU(e, n, t) {
  return (a) => {
    const r = (e() || "").replace(/\D/g, ""), o = n() || "", i = yB[o], s = Hc(r, (i == null ? void 0 : i.hasTrunkZero) ?? !1);
    if (!s) return;
    const d = (i == null ? void 0 : i.min) ?? 6, u = (i == null ? void 0 : i.max) ?? 1 / 0, f = (i == null ? void 0 : i.name) ?? o, b = (i == null ? void 0 : i.placeholder) ?? Dl.placeholder;
    if (s.length < d)
      return t({ count: d, country: f, example: b });
    if (s.length > u)
      return t({ count: u, country: f, example: b });
  };
}
function Eb(e) {
  return e == null ? !0 : typeof e == "string" ? e.trim() === "" : !1;
}
function L9(e) {
  const n = typeof e == "string" ? { requiredMessage: e } : e, { requiredMessage: t, watchData: a } = n, l = typeof t == "function" ? t : () => t, r = R(/* @__PURE__ */ new Map()), o = m(() => Array.from(r.value.values())), i = m(() => r.value.size), s = m(() => r.value.size > 0);
  function d(x, y) {
    if (x.required && Eb(y))
      return l();
    if (x.validate)
      return x.validate(y);
  }
  function u(x, y) {
    const k = /* @__PURE__ */ new Map();
    for (const $ of x) {
      const S = d($, y[$.key]);
      S && k.set($.key, {
        key: $.key,
        label: $.label,
        message: S
      });
    }
    return r.value = k, k.size === 0;
  }
  function f(x, y) {
    const k = d(x, y);
    if (k) {
      const $ = new Map(r.value);
      return $.set(x.key, { key: x.key, label: x.label, message: k }), r.value = $, !1;
    } else
      return h(x.key), !0;
  }
  function b(x) {
    var y;
    return (y = r.value.get(x)) == null ? void 0 : y.message;
  }
  function h(x) {
    if (r.value.has(x)) {
      const y = new Map(r.value);
      y.delete(x), r.value = y;
    }
  }
  function p() {
    r.value = /* @__PURE__ */ new Map();
  }
  return a && $e(
    () => a,
    () => {
      if (s.value)
        for (const x of [...o.value]) {
          const y = a[x.key];
          Eb(y) || h(x.key);
        }
    },
    { deep: !0 }
  ), {
    errors: r,
    errorList: o,
    errorCount: i,
    hasErrors: s,
    validateAll: u,
    validateField: d,
    validateAndSetField: f,
    getFieldError: b,
    clearFieldError: h,
    clearAllErrors: p
  };
}
function T9(e) {
  const n = R(!1);
  async function t() {
    var a, l;
    if (e.validate()) {
      n.value = !0;
      try {
        await e.save(), (a = e.onSuccess) == null || a.call(e);
      } catch (r) {
        (l = e.onError) == null || l.call(e, r);
      } finally {
        n.value = !1;
      }
    }
  }
  return { isSaving: n, handleSubmit: t };
}
function zl(e) {
  if (e === null || typeof e != "object")
    return e;
  if (Array.isArray(e))
    return e.map(zl);
  const n = {};
  for (const t in e)
    Object.prototype.hasOwnProperty.call(e, t) && (n[t] = zl(e[t]));
  return n;
}
function Iu(e, n) {
  if (e === n) return !0;
  if (e === null || n === null) return e === n;
  if (typeof e != typeof n) return !1;
  if (typeof e != "object") return e === n;
  if (Array.isArray(e) && Array.isArray(n))
    return e.length !== n.length ? !1 : e.every((l, r) => Iu(l, n[r]));
  if (Array.isArray(e) || Array.isArray(n)) return !1;
  const t = Object.keys(e), a = Object.keys(n);
  return t.length !== a.length ? !1 : t.every(
    (l) => Iu(e[l], n[l])
  );
}
function A9(e) {
  const { data: n, enableBeforeUnload: t = !0, beforeUnloadMessage: a } = e, l = R(null), r = R(!1), o = m(() => r.value ? !0 : l.value === null ? !1 : !Iu(n, l.value));
  function i() {
    l.value = zl(n), r.value = !1;
  }
  function s() {
    l.value = zl(n), r.value = !1;
  }
  function d() {
    l.value !== null && Object.assign(n, zl(l.value)), r.value = !1;
  }
  function u() {
    return zl(l.value);
  }
  function f(h) {
    r.value = h;
  }
  function b(h) {
    if (o.value) {
      h.preventDefault();
      const p = a ? a() : "";
      return h.returnValue = p, p;
    }
  }
  return ct(() => {
    i(), t && window.addEventListener("beforeunload", b);
  }), kt(() => {
    t && window.removeEventListener("beforeunload", b);
  }), {
    isDirty: o,
    markAsSaved: s,
    resetToOriginal: d,
    getOriginalData: u,
    setDirty: f
  };
}
function oU(e) {
  const n = A9({
    data: e.data,
    enableBeforeUnload: e.enableBeforeUnload,
    beforeUnloadMessage: e.beforeUnloadMessage
  }), t = L9({
    requiredMessage: e.requiredMessage,
    watchData: e.data
  }), a = T9({
    validate: () => t.validateAll(e.fields(), e.data),
    save: e.save,
    onSuccess: () => {
      var l;
      t.clearAllErrors(), n.markAsSaved(), (l = e.onSuccess) == null || l.call(e);
    },
    onError: e.onError
  });
  return {
    // Dirty state
    isDirty: n.isDirty,
    markAsSaved: n.markAsSaved,
    resetToOriginal: n.resetToOriginal,
    setDirty: n.setDirty,
    // Validation
    errorList: t.errorList,
    errorCount: t.errorCount,
    hasErrors: t.hasErrors,
    getFieldError: t.getFieldError,
    clearFieldError: t.clearFieldError,
    clearAllErrors: t.clearAllErrors,
    // Submit
    isSaving: a.isSaving,
    handleSubmit: a.handleSubmit
  };
}
function E9(e) {
  const n = R(!1);
  if (typeof window > "u") return n;
  const t = window.matchMedia(e), a = () => {
    n.value = t.matches;
  };
  return Eu() && (ct(() => {
    a(), t.addEventListener("change", a);
  }), kt(() => {
    t.removeEventListener("change", a);
  })), n;
}
const R9 = {
  key: 0,
  class: "p-3"
}, B9 = { class: "flex flex-col-reverse md:flex-row items-center justify-between md:space-x-4" }, M9 = { class: "w-full lg:w-2/3 flex flex-col space-y-3 md:space-y-0 md:flex-row md:items-center" }, D9 = {
  key: 0,
  class: "flex items-center space-x-4"
}, z9 = {
  key: 1,
  class: "w-full md:w-auto flex flex-col md:flex-row mb-3 md:mb-0 items-stretch md:items-center justify-end md:space-x-3 shrink-0"
}, O9 = {
  key: 0,
  class: "flex flex-wrap"
}, P9 = { class: "relative" }, F9 = { class: "flex-1 min-h-0 flex flex-col" }, V9 = {
  key: 1,
  class: "border-t border-gainsboro dark:border-(--colors-border-base) p-5"
}, iU = /* @__PURE__ */ ye({
  __name: "DataTableWrapper",
  props: {
    bordered: { type: Boolean }
  },
  setup(e) {
    const n = tn();
    return (t, a) => (c(), g("div", {
      class: C([
        "relative bg-white rounded-xl flex-1 flex flex-col min-h-0",
        e.bordered ? "border border-(--border-border-base-soft) overflow-hidden shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)]" : "border-l border-border-base-soft has-[>div:nth-child(2)>[role=data-settings]]:rounded-tr-none"
      ])
    }, [
      a[0] || (a[0] = v("div", { class: "absolute bottom-0 left-1.5 right-0 h-px bg-linear-to-r from-(--background-background-gray) to-transparent" }, null, -1)),
      L(n)("filters") || L(n)("actions") ? (c(), g("div", R9, [
        v("div", B9, [
          v("div", M9, [
            L(n)("filters") ? (c(), g("div", D9, [
              Ae(t.$slots, "filters")
            ])) : w("", !0),
            L(n)("actions") ? (c(), g("div", z9, [
              Ae(t.$slots, "actions")
            ])) : w("", !0)
          ]),
          L(n)("filter-items") ? (c(), g("div", O9, [
            Ae(t.$slots, "filter-items")
          ])) : w("", !0)
        ])
      ])) : w("", !0),
      v("div", P9, [
        v("div", {
          class: C(["absolute top-0 right-0 h-0.5 bg-border-base-soft", L(n)("filters") ? "left-0" : "left-1.5"])
        }, null, 2)
      ]),
      v("div", F9, [
        Ae(t.$slots, "table")
      ]),
      L(n)("pager") ? (c(), g("div", V9, [
        Ae(t.$slots, "pager")
      ])) : w("", !0)
    ], 2));
  }
}), N9 = {
  key: 0,
  role: "menu",
  "data-testid": "card-actions-menu",
  class: "absolute right-0 top-10 z-50 min-w-160px rounded-xl border border-(--border-border-base-soft) bg-white py-1 shadow-[0_4px_16px_rgba(0,0,0,0.12)]"
}, H9 = ["onClick"], j9 = {
  key: 0,
  class: "skeleton w-full h-192px rounded-t-3xl"
}, W9 = {
  key: 1,
  class: "skeleton h-9 w-9 rounded-full shrink-0 m-6"
}, q9 = ["src", "alt"], U9 = { class: "h-9 w-9 rounded-full border border-(--border-border-base-soft) flex items-center justify-center bg-white" }, G9 = { class: "flex flex-col flex-1" }, K9 = {
  key: 0,
  class: "self-start bg-(--background-background-white-tertiary) text-xs font-medium px-1 py-0.5 rounded text-(--text-text-black-default)"
}, Y9 = {
  key: 1,
  class: "text-2xl font-bold text-(--text-text-heading) dark:text-(--colors-text-white-default) m-0"
}, J9 = {
  key: 2,
  class: "text-base text-(--text-text-body) dark:text-(--colors-text-white-secondary) m-0"
}, sU = /* @__PURE__ */ ye({
  __name: "Card",
  props: {
    layout: { default: "classic" },
    headerType: { default: "icon" },
    imageSrc: { default: void 0 },
    imageAlt: { default: "" },
    badge: { default: void 0 },
    title: { default: void 0 },
    description: { default: void 0 },
    primaryLabel: { default: void 0 },
    secondaryLabel: { default: void 0 },
    loading: { type: Boolean, default: !1 },
    actions: { default: void 0 }
  },
  emits: ["primary-click", "secondary-click"],
  setup(e, { emit: n }) {
    const t = n, {
      isOpen: a,
      dropdownRef: l,
      toggleDropdown: r,
      closeDropdown: o
    } = ar(), i = (d) => {
      var u;
      (u = d.onClick) == null || u.call(d), o();
    }, s = (d) => {
      l.value = d;
    };
    return (d, u) => (c(), g("div", {
      "data-testid": "card",
      class: C([
        "relative overflow-hidden rounded-3xl border border-(--border-border-base-medium) bg-white dark:bg-(--colors-background-black-default) shadow-[0px_0px_4px_rgba(0,0,0,0.1)]",
        e.layout === "aligned" ? "flex flex-row items-center" : "flex flex-col"
      ])
    }, [
      !e.loading && e.actions && e.actions.length ? (c(), g("div", {
        key: 0,
        ref: s,
        class: "absolute top-3 right-3 z-10",
        "data-testid": "card-actions"
      }, [
        v("button", {
          type: "button",
          "data-testid": "card-actions-trigger",
          class: "h-8 w-8 rounded-full border border-(--border-border-base-soft) bg-white flex items-center justify-center cursor-pointer hover:bg-(--background-background-white-tertiary) transition-colors",
          onClick: u[0] || (u[0] = //@ts-ignore
          (...f) => L(r) && L(r)(...f))
        }, [...u[3] || (u[3] = [
          v("i", { class: "ri-more-line text-sm text-(--text-text-body)" }, null, -1)
        ])]),
        te(At, {
          "enter-active-class": "transition duration-100 ease-out",
          "enter-from-class": "transform scale-95 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100",
          "leave-active-class": "transition duration-75 ease-out",
          "leave-from-class": "transform scale-100 opacity-100",
          "leave-to-class": "transform scale-95 opacity-0"
        }, {
          default: ve(() => [
            L(a) ? (c(), g("div", N9, [
              (c(!0), g(de, null, Re(e.actions, (f) => (c(), g("button", {
                key: f.label,
                type: "button",
                role: "menuitem",
                "data-testid": "card-action-item",
                class: C([
                  "w-full text-left px-4 py-2 text-sm hover:bg-(--background-background-white-tertiary) transition-colors flex items-center gap-2",
                  f.class || "text-(--text-text-black-default)"
                ]),
                onClick: (b) => i(f)
              }, [
                f.icon ? (c(), g("i", {
                  key: 0,
                  class: C(f.icon)
                }, null, 2)) : w("", !0),
                nt(" " + j(f.label), 1)
              ], 10, H9))), 128))
            ])) : w("", !0)
          ]),
          _: 1
        })
      ])) : w("", !0),
      e.loading ? (c(), g(de, { key: 1 }, [
        e.layout !== "aligned" ? (c(), g("div", j9)) : (c(), g("div", W9)),
        u[4] || (u[4] = co('<div class="flex flex-col gap-3 px-6 pb-6 pt-4 flex-1"><div class="skeleton h-5 w-16 rounded"></div><div class="skeleton h-8 w-3/4 rounded"></div><div class="skeleton h-4 w-full rounded"></div><div class="skeleton h-4 w-2/3 rounded"></div><div class="flex gap-2 pt-2"><div class="skeleton h-9 w-24 rounded-full"></div><div class="skeleton h-9 w-24 rounded-full"></div></div></div>', 1))
      ], 64)) : (c(), g(de, { key: 2 }, [
        Ae(d.$slots, "header", {}, () => [
          e.headerType === "image" ? (c(), g("div", {
            key: 0,
            class: C(e.layout === "aligned" ? "p-6 shrink-0" : "p-6")
          }, [
            e.imageSrc ? (c(), g("img", {
              key: 0,
              src: e.imageSrc,
              alt: e.imageAlt,
              class: C(
                e.layout === "aligned" ? "h-48 w-48 object-cover rounded-xl" : "w-full h-48 object-cover rounded-xl"
              )
            }, null, 10, q9)) : w("", !0)
          ], 2)) : (c(), g("div", {
            key: 1,
            class: C(e.layout === "aligned" ? "pl-6 shrink-0" : "pt-6 pb-6 px-6")
          }, [
            v("div", U9, [
              Ae(d.$slots, "icon")
            ])
          ], 2))
        ]),
        v("div", G9, [
          Ae(d.$slots, "default", {}, () => [
            v("div", {
              class: C(["flex flex-col gap-3", e.layout === "aligned" ? "p-6" : "px-6 pb-6"])
            }, [
              e.badge ? (c(), g("span", K9, j(e.badge), 1)) : w("", !0),
              e.title ? (c(), g("p", Y9, j(e.title), 1)) : w("", !0),
              e.description ? (c(), g("p", J9, j(e.description), 1)) : w("", !0)
            ], 2)
          ])
        ]),
        Ae(d.$slots, "footer", {}, () => [
          e.primaryLabel || e.secondaryLabel ? (c(), g("div", {
            key: 0,
            class: C([
              e.layout === "aligned" ? "px-6 flex flex-col gap-4 items-start shrink-0" : "px-6 pb-6 flex items-center gap-4"
            ])
          }, [
            e.primaryLabel ? (c(), W(Me, {
              key: 0,
              variant: "primary",
              size: "xs",
              label: e.primaryLabel,
              onClick: u[1] || (u[1] = (f) => t("primary-click"))
            }, null, 8, ["label"])) : w("", !0),
            e.secondaryLabel ? (c(), W(Me, {
              key: 1,
              variant: "secondary",
              size: "xs",
              label: e.secondaryLabel,
              onClick: u[2] || (u[2] = (f) => t("secondary-click"))
            }, null, 8, ["label"])) : w("", !0)
          ], 2)) : w("", !0)
        ])
      ], 64))
    ], 2));
  }
}), X9 = ["aria-checked", "aria-disabled"], Z9 = { class: "flex flex-col gap-1.5" }, dU = /* @__PURE__ */ ye({
  __name: "CardSelectable",
  props: {
    icon: { default: void 0 },
    title: { default: void 0 },
    description: { default: void 0 },
    selected: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    iconVariant: { default: "default" }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = e, a = n;
    function l(r) {
      t.disabled || a("click", r);
    }
    return (r, o) => (c(), g("button", {
      type: "button",
      "data-testid": "card-selectable",
      "aria-checked": e.selected,
      "aria-disabled": e.disabled || void 0,
      class: C([
        "relative flex flex-col gap-3 p-6 rounded-xl border text-left w-full",
        "transition-colors duration-120 ease-in-out",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-hover)",
        // Disabled wins over selected (a disabled card can't be the chosen option). Use the DS
        // disabled surface (grey fill + border) rather than a flat opacity so the disabled state
        // reads clearly against the enabled cards (OP-6222).
        e.disabled ? "bg-(--colors-background-disabled) border-(--colors-border-disabled) cursor-not-allowed pointer-events-none" : e.selected ? "bg-(--background-background-hover) border-(--border-border-hover) shadow-[0px_0px_2px_var(--border-border-hover)] cursor-pointer" : "bg-(--background-background-white) border-(--border-border-base-medium) hover:border-(--border-border-hover) active:bg-(--background-background-hover) cursor-pointer"
      ]),
      onClick: l
    }, [
      Ae(r.$slots, "default", {}, () => [
        v("div", {
          class: C([
            "h-9 w-9 flex items-center justify-center rounded-lg border shrink-0",
            e.disabled ? "bg-(--colors-background-disabled) border-(--colors-border-disabled)" : e.iconVariant === "accent" ? "bg-(--background-background-white) border-(--border-border-hover) shadow-[0px_0px_1px_var(--background-background-hover)]" : "bg-(--background-background-white) border-(--border-border-base-medium)"
          ])
        }, [
          v("i", {
            class: C([e.icon, "text-[20px]", e.disabled ? "text-(--colors-icon-disabled)" : "text-(--icons-icon-accent)"]),
            "aria-hidden": "true"
          }, null, 2)
        ], 2),
        v("div", Z9, [
          v("span", {
            class: C(["text-lg font-semibold", e.disabled ? "text-(--colors-text-disabled)" : "text-(--text-text-heading)"])
          }, j(e.title), 3),
          e.description ? (c(), g("span", {
            key: 0,
            class: C(["text-sm", e.disabled ? "text-(--colors-text-disabled)" : "text-(--text-text-body)"])
          }, j(e.description), 3)) : w("", !0)
        ])
      ])
    ], 10, X9));
  }
}), uU = /* @__PURE__ */ ye({
  __name: "Masonry",
  props: {
    gapX: { default: 20 },
    gapY: { default: 20 },
    breakpoint: { default: 640 },
    useViewport: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = Hn(), a = R([]), l = R(null), r = R([]), o = R(0), i = R(2), s = m(
      () => {
        var y;
        return (((y = t.default) == null ? void 0 : y.call(t)) ?? []).filter(
          (k) => k.type !== Au
        );
      }
    );
    function d() {
      const y = a.value;
      if (!y.length) return;
      const k = i.value, $ = Array(k).fill(0), S = [];
      for (const T of y) {
        const I = $.indexOf(Math.min(...$));
        S.push({ col: I, top: $[I] }), $[I] += T.offsetHeight + n.gapY;
      }
      r.value = S, o.value = Math.max(...$) - n.gapY;
    }
    function u(y) {
      const k = r.value[y];
      if (!k) return { visibility: "hidden" };
      const $ = i.value;
      if ($ === 1)
        return { top: `${k.top}px`, left: "0", width: "100%" };
      const S = 100 / $, T = n.gapX * ($ - 1) / $;
      return {
        top: `${k.top}px`,
        left: k.col === 0 ? "0" : `calc(${k.col * S}% + ${k.col * n.gapX / $}px)`,
        width: `calc(${S}% - ${T}px)`
      };
    }
    let f, b, h;
    function p() {
      h !== void 0 && cancelAnimationFrame(h), h = requestAnimationFrame(() => {
        h = void 0, d();
      });
    }
    function x(y) {
      i.value = y.matches ? 1 : 2, p();
    }
    return ct(async () => {
      await Ge(), n.useViewport ? (b = window.matchMedia(`(max-width: ${n.breakpoint}px)`), i.value = b.matches ? 1 : 2, b.addEventListener("change", x), d(), f = new ResizeObserver(p), a.value.forEach((y) => f.observe(y))) : (f = new ResizeObserver(() => {
        var k;
        const y = ((k = l.value) == null ? void 0 : k.offsetWidth) ?? 0;
        i.value = y < n.breakpoint ? 1 : 2, p();
      }), a.value.forEach((y) => f.observe(y)), l.value && f.observe(l.value));
    }), kt(() => {
      h !== void 0 && cancelAnimationFrame(h), f == null || f.disconnect(), b == null || b.removeEventListener("change", x);
    }), (y, k) => (c(), g("div", {
      ref_key: "containerRef",
      ref: l,
      class: "relative w-full",
      style: je({ height: `${o.value}px` })
    }, [
      (c(!0), g(de, null, Re(s.value, ($, S) => (c(), g("div", {
        key: S,
        ref_for: !0,
        ref_key: "itemRefs",
        ref: a,
        class: "absolute",
        style: je(u(S))
      }, [
        (c(), W(it($)))
      ], 4))), 128))
    ], 4));
  }
}), Q9 = { class: "group-hover:underline" }, _9 = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "InlineLink",
  props: {
    as: {},
    iconLeft: {}
  },
  setup(e) {
    return (n, t) => (c(), W(it(e.as), Fe(n.$attrs, { class: "flex items-center px-3 py-2 gap-1.5 group leading-5 text-sm text-(--text-text-black-default)" }), {
      default: ve(() => [
        e.iconLeft ? (c(), g("i", {
          key: 0,
          class: C(["text-current", e.iconLeft])
        }, null, 2)) : w("", !0),
        v("span", Q9, [
          Ae(n.$slots, "default")
        ])
      ]),
      _: 3
    }, 16));
  }
}), cU = _9, e7 = ["aria-labelledby", "aria-busy"], t7 = {
  key: 0,
  class: "flex flex-col space-y-5"
}, n7 = {
  key: 0,
  class: "flex items-center gap-2"
}, a7 = {
  key: 0,
  class: "flex items-center gap-2 shrink-0"
}, l7 = {
  key: 1,
  class: "flex-1 min-w-0 flex flex-col gap-2"
}, r7 = ["id"], o7 = {
  key: 1,
  class: "text-base leading-6 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)",
  "data-testid": "widget-shell-subtitle"
}, i7 = {
  key: 2,
  class: "flex items-center gap-3 shrink-0 ms-auto",
  "data-testid": "widget-shell-actions"
}, s7 = {
  key: 0,
  class: "flex items-center gap-1.5"
}, d7 = {
  key: 1,
  class: "flex items-center gap-1.5"
}, u7 = {
  key: 0,
  class: "flex-1 min-w-0 leading-6.5 text-num-16 font-medium truncate text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
}, c7 = {
  key: 1,
  class: "flex items-center ms-auto shrink-0"
}, f7 = {
  key: 1,
  "data-testid": "widget-shell-footer"
}, fU = /* @__PURE__ */ ye({
  __name: "WidgetShell",
  props: {
    header: {},
    subtitle: {},
    subheader: {},
    loading: { type: Boolean },
    flush: { type: Boolean },
    stretch: { type: Boolean },
    rounded: {},
    bordered: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = {
      xs: "rounded-(--border-border-radius-rounded-xs)",
      sm: "rounded-(--border-border-radius-rounded-sm)",
      m: "rounded-(--border-border-radius-rounded-l)",
      l: "rounded-(--border-border-radius-rounded-base)",
      xl: "rounded-(--border-border-radius-rounded-xl)",
      "2xl": "rounded-(--border-border-radius-rounded-xxl)"
    }, t = e, a = m(() => n[t.rounded ?? "m"]), l = qe(), r = Gn(), o = m(
      () => !t.flush && t.header && !r["aria-label"] ? l : void 0
    ), i = tn(), s = m(
      () => !!(t.header || t.subtitle || t.subheader) || i("before-actions") || i("actions") || i("nav-actions") || i("sub-info") || i("sub-actions")
    );
    return (d, u) => (c(), g("section", {
      "aria-labelledby": o.value,
      "aria-busy": e.loading || void 0,
      "data-testid": "widget-shell",
      class: C([
        a.value,
        e.bordered !== !1 ? "border border-(--border-border-base-soft) bg-(--colors-background-white) shadow-(--blur-shadow-s) break-inside-avoid" : void 0,
        e.bordered !== !1 ? "dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)" : void 0,
        e.flush ? "overflow-hidden" : "p-6 space-y-6",
        e.stretch ? "flex flex-col flex-1" : "inline-block w-full"
      ])
    }, [
      e.flush ? Ae(d.$slots, "default", { key: 0 }) : (c(), g(de, { key: 1 }, [
        s.value ? (c(), g("div", t7, [
          e.header || e.subtitle || L(i)("before-actions") || L(i)("actions") || L(i)("nav-actions") ? (c(), g("div", n7, [
            L(i)("before-actions") ? (c(), g("div", a7, [
              Ae(d.$slots, "before-actions")
            ])) : w("", !0),
            e.header || e.subtitle ? (c(), g("div", l7, [
              e.header ? (c(), g("h2", {
                key: 0,
                id: L(l),
                class: "min-w-0 leading-6.5 text-[1.375rem] font-bold truncate text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
              }, j(e.header), 9, r7)) : w("", !0),
              e.subtitle ? (c(), g("p", o7, j(e.subtitle), 1)) : w("", !0)
            ])) : w("", !0),
            L(i)("actions") || L(i)("nav-actions") ? (c(), g("div", i7, [
              Ae(d.$slots, "actions"),
              L(i)("nav-actions") ? (c(), g("div", s7, [
                Ae(d.$slots, "nav-actions")
              ])) : w("", !0)
            ])) : w("", !0)
          ])) : w("", !0),
          e.subheader || L(i)("sub-info") || L(i)("sub-actions") ? (c(), g("div", d7, [
            e.subheader ? (c(), g("h3", u7, j(e.subheader), 1)) : w("", !0),
            Ae(d.$slots, "sub-info"),
            L(i)("sub-actions") ? (c(), g("div", c7, [
              Ae(d.$slots, "sub-actions")
            ])) : w("", !0)
          ])) : w("", !0)
        ])) : w("", !0),
        v("div", {
          class: C(e.stretch ? "flex-1 flex flex-col" : "")
        }, [
          Ae(d.$slots, "default")
        ], 2),
        L(i)("footer") ? (c(), g("div", f7, [
          Ae(d.$slots, "footer")
        ])) : w("", !0)
      ], 64))
    ], 10, e7));
  }
}), h7 = { class: "flex flex-col min-h-0 h-full rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-medium) bg-white shadow-[0px_0px_4px_rgba(0,0,0,0.1)] overflow-hidden" }, hU = /* @__PURE__ */ ye({
  __name: "WidgetBlock",
  props: {
    headerBordered: { type: Boolean, default: !0 },
    footerBordered: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = tn();
    return (t, a) => (c(), g("div", h7, [
      L(n)("header") ? (c(), g("div", {
        key: 0,
        "data-testid": "widget-block-header",
        class: C(["sticky top-0 z-10 bg-white px-6 py-5", e.headerBordered ? "border-b border-(--border-border-base-soft)" : ""])
      }, [
        Ae(t.$slots, "header")
      ], 2)) : w("", !0),
      v("div", {
        "data-testid": "widget-block-main",
        class: C([
          "flex-1 min-h-0 overflow-y-auto overflow-x-hidden px-6 pb-6",
          L(n)("header") && !e.headerBordered ? "pt-0" : "pt-6"
        ])
      }, [
        Ae(t.$slots, "default")
      ], 2),
      L(n)("footer") ? (c(), g("div", {
        key: 1,
        "data-testid": "widget-block-footer",
        class: C(["px-6 py-4", e.footerBordered ? "border-t border-(--border-border-base-soft)" : ""])
      }, [
        Ae(t.$slots, "footer")
      ], 2)) : w("", !0)
    ]));
  }
}), b7 = {
  key: 0,
  class: "flex flex-col gap-1",
  "data-testid": "widget-section-header"
}, g7 = {
  key: 0,
  class: "text-lg font-semibold text-(--colors-text-black-default) m-0"
}, m7 = {
  key: 0,
  class: "text-sm text-(--text-text-body) m-0"
}, bU = /* @__PURE__ */ ye({
  __name: "WidgetSection",
  props: {
    title: {},
    subtitle: {},
    bordered: { type: Boolean, default: !0 },
    padded: { type: Boolean, default: !0 },
    gap: { default: "md" }
  },
  setup(e) {
    const n = e, t = tn(), a = m(
      () => !!n.title || !!n.subtitle || t("title") || t("subtitle")
    ), l = m(
      () => ({ sm: "gap-3", md: "gap-4", lg: "gap-5" })[n.gap]
    );
    return (r, o) => (c(), g("section", {
      class: C([
        "flex flex-col",
        l.value,
        e.bordered && "rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-soft)",
        e.padded && "p-6"
      ]),
      "data-testid": "widget-section"
    }, [
      a.value ? (c(), g("header", b7, [
        Ae(r.$slots, "title", {}, () => [
          e.title ? (c(), g("h3", g7, j(e.title), 1)) : w("", !0)
        ]),
        Ae(r.$slots, "subtitle", {}, () => [
          e.subtitle ? (c(), g("p", m7, j(e.subtitle), 1)) : w("", !0)
        ])
      ])) : w("", !0),
      Ae(r.$slots, "default")
    ], 2));
  }
}), p7 = {
  "data-testid": "cta-widget",
  class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6 rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-soft) shadow-[0px_0px_4px_rgba(0,0,0,0.1)] bg-white p-6",
  style: { "background-image": "var(--gradient-cta-widget)" }
}, v7 = { class: "flex flex-col gap-1.5 min-w-0" }, x7 = { class: "flex items-center gap-1.5" }, y7 = { class: "text-(length:--size-l) leading-(--line-height-l) font-(--weight-bold) text-(--text-text-black-default)" }, k7 = { class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-heading)" }, w7 = { class: "flex flex-col items-stretch sm:items-center sm:shrink-0" }, gU = /* @__PURE__ */ ye({
  __name: "CtaWidget",
  props: {
    title: { default: "" },
    titleIcon: { default: void 0 },
    description: { default: "" },
    ctaLabel: { default: "" },
    ctaIcon: { default: "ri-add-line" },
    ctaDisabled: { type: Boolean, default: !1 }
  },
  emits: ["cta-click"],
  setup(e, { emit: n }) {
    const t = n;
    return (a, l) => (c(), g("div", p7, [
      v("div", v7, [
        v("div", x7, [
          e.titleIcon ? (c(), g("i", {
            key: 0,
            class: C([e.titleIcon, "text-(length:--size-l) text-(--text-text-black-default)"]),
            "aria-hidden": "true"
          }, null, 2)) : w("", !0),
          v("p", y7, [
            Ae(a.$slots, "title", {}, () => [
              nt(j(e.title), 1)
            ])
          ])
        ]),
        v("p", k7, [
          Ae(a.$slots, "description", {}, () => [
            nt(j(e.description), 1)
          ])
        ])
      ]),
      v("div", w7, [
        Ae(a.$slots, "actions", {}, () => [
          e.ctaLabel ? (c(), W(Me, {
            key: 0,
            variant: "primary",
            size: "xl",
            "icon-left": e.ctaIcon,
            label: e.ctaLabel,
            disabled: e.ctaDisabled,
            onClick: l[0] || (l[0] = (r) => t("cta-click", r))
          }, null, 8, ["icon-left", "label", "disabled"])) : w("", !0)
        ])
      ])
    ]));
  }
}), C7 = {
  "data-testid": "stats-widget",
  class: "flex flex-col justify-center gap-3 rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-soft) bg-(--colors-background-white) p-6 shadow-(--blur-shadow-s) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)"
}, S7 = { class: "flex items-start gap-2" }, $7 = { class: "min-w-0 text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)" }, I7 = { class: "flex flex-wrap items-end gap-x-2 gap-y-1" }, L7 = {
  class: "text-(length:--size-4xl) leading-(--line-height-4xl) font-(--weight-bold) text-(--colors-text-heading) dark:text-(--colors-text-white-default)",
  "data-testid": "stats-widget-value"
}, T7 = ["aria-hidden"], A7 = {
  key: 0,
  class: "sr-only"
}, E7 = {
  key: 1,
  class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)",
  "data-testid": "stats-widget-caption"
}, R7 = {
  key: 0,
  class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)",
  "data-testid": "stats-widget-caption"
}, mU = /* @__PURE__ */ ye({
  __name: "StatsWidget",
  props: {
    icon: { default: void 0 },
    label: { default: "" },
    value: { default: null },
    placeholder: { default: "—" },
    placeholderLabel: { default: "" },
    caption: { default: "" },
    captionInline: { type: Boolean, default: !1 },
    hint: { default: "" },
    valueHint: { default: "" },
    hintIcon: { default: "ri-question-line" }
  },
  setup(e) {
    const n = e, t = m(() => n.value === null || n.value === void 0 || n.value === "");
    return (a, l) => (c(), g("div", C7, [
      v("div", S7, [
        e.icon ? (c(), g("i", {
          key: 0,
          class: C([e.icon, "shrink-0 text-(length:--size-xxl) leading-(--line-height-xxl) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"]),
          "aria-hidden": "true"
        }, null, 2)) : w("", !0),
        v("p", $7, [
          Ae(a.$slots, "label", {}, () => [
            nt(j(e.label), 1)
          ])
        ]),
        e.hint ? (c(), W(mt, {
          key: 1,
          text: e.hint,
          as: "span",
          "labels-trigger": "",
          role: "img",
          tabindex: "0",
          "aria-label": e.hint,
          class: "shrink-0 cursor-help self-center rounded-(--border-border-radius-rounded-full) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent",
          "data-testid": "stats-widget-hint"
        }, {
          default: ve(() => [
            v("i", {
              class: C([e.hintIcon, "block text-(length:--size-m) leading-(--line-height-l) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"]),
              "data-testid": "stats-widget-hint-icon",
              "aria-hidden": "true"
            }, null, 2)
          ]),
          _: 1
        }, 8, ["text", "aria-label"])) : w("", !0)
      ]),
      v("div", I7, [
        v("p", L7, [
          Ae(a.$slots, "value", {}, () => [
            t.value ? (c(), g(de, { key: 0 }, [
              v("span", {
                "aria-hidden": e.placeholderLabel ? "true" : void 0
              }, j(e.placeholder), 9, T7),
              e.placeholderLabel ? (c(), g("span", A7, j(e.placeholderLabel), 1)) : w("", !0)
            ], 64)) : (c(), g(de, { key: 1 }, [
              nt(j(e.value), 1)
            ], 64))
          ])
        ]),
        e.valueHint ? (c(), W(mt, {
          key: 0,
          text: e.valueHint,
          as: "span",
          "labels-trigger": "",
          role: "img",
          tabindex: "0",
          "aria-label": e.valueHint,
          class: "shrink-0 cursor-help self-center rounded-(--border-border-radius-rounded-full) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent",
          "data-testid": "stats-widget-value-hint"
        }, {
          default: ve(() => [
            v("i", {
              class: C([e.hintIcon, "block text-(length:--size-m) leading-(--line-height-l) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"]),
              "data-testid": "stats-widget-value-hint-icon",
              "aria-hidden": "true"
            }, null, 2)
          ]),
          _: 1
        }, 8, ["text", "aria-label"])) : w("", !0),
        e.caption && e.captionInline ? (c(), g("p", E7, j(e.caption), 1)) : w("", !0)
      ]),
      e.caption && !e.captionInline ? (c(), g("p", R7, j(e.caption), 1)) : w("", !0)
    ]));
  }
}), B7 = ["aria-expanded", "aria-controls", "disabled"], M7 = { class: "flex-shrink-0" }, D7 = {
  key: 0,
  class: "flex h-6 w-6 items-center justify-center rounded-full bg-[#009966] border border-gray-200",
  "data-testid": "collapsible-section-validated"
}, z7 = {
  key: 1,
  class: "flex h-6 w-6 items-center justify-center rounded-full bg-gray-100 dark:bg-[rgba(255,255,255,0.08)]"
}, O7 = { class: "flex-1 min-w-0" }, P7 = { class: "text-base font-semibold text-text-black-default dark:text-(--colors-text-white-default)" }, F7 = {
  key: 0,
  class: "text-sm text-gray-500 dark:text-(--colors-text-white-secondary) mt-0.5 truncate"
}, V7 = { class: "flex-shrink-0" }, N7 = ["id", "inert", "aria-hidden"], H7 = { class: "px-14 py-5" }, j7 = ["disabled"], W7 = {
  key: 0,
  class: "ri-loader-4-line animate-spin text-sm"
}, q7 = {
  key: 1,
  class: "ri-check-line text-sm"
}, U7 = ["disabled"], G7 = /* @__PURE__ */ ye({
  __name: "CollapsibleSection",
  props: {
    title: {},
    subtitle: { default: void 0 },
    icon: { default: void 0 },
    expanded: { type: Boolean, default: !1 },
    validated: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    showActions: { type: Boolean, default: !0 },
    validateDisabled: { type: Boolean, default: !1 },
    cancelDisabled: { type: Boolean, default: !1 },
    validateLoading: { type: Boolean, default: !1 },
    warning: { default: void 0 },
    validateLabel: { default: "Validate" },
    cancelLabel: { default: "Cancel" },
    actionsAlignment: { default: "start" }
  },
  emits: ["update:expanded", "validate", "cancel"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R(!1), r = R(null), o = R(null), i = R(null), s = R(null), d = () => {
      var y, k;
      (y = o.value) == null || y.focus(), document.activeElement !== o.value && ((k = r.value) == null || k.focus());
    };
    $e(
      () => t.expanded,
      (y) => {
        var k;
        y || (l.value = !1, (k = i.value) != null && k.contains(document.activeElement) && d());
      }
    ), $e(
      () => t.validateDisabled || t.validateLoading,
      (y) => {
        y && s.value && document.activeElement === s.value && d();
      }
    );
    const u = (y) => {
      y.propertyName === "max-height" && t.expanded && (l.value = !0);
    }, f = qe(), b = m(() => `${f}-content`), h = () => {
      t.disabled || a("update:expanded", !t.expanded);
    }, p = () => {
      a("validate");
    }, x = () => {
      a("cancel");
    };
    return (y, k) => (c(), g("div", {
      ref_key: "rootRef",
      ref: r,
      class: C(["rounded-xl border border-solid border-lightgray dark:border-(--colors-border-base) bg-white dark:bg-(--colors-background-black-default) overflow-hidden", { "opacity-60 cursor-not-allowed": e.disabled }]),
      "data-testid": "collapsible-section",
      tabindex: "-1"
    }, [
      v("button", {
        ref_key: "headerRef",
        ref: o,
        type: "button",
        class: C(["flex w-full items-center gap-6 px-6 py-5 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--border-border-hover)", [
          e.expanded ? "bg-gray-50 dark:bg-[rgba(255,255,255,0.03)]" : "",
          e.disabled ? "cursor-not-allowed" : "cursor-pointer hover:bg-gray-50 dark:hover:bg-[rgba(255,255,255,0.03)]"
        ]]),
        "aria-expanded": e.expanded,
        "aria-controls": b.value,
        disabled: e.disabled,
        "data-testid": "collapsible-section-header",
        onClick: h
      }, [
        v("div", M7, [
          e.validated ? (c(), g("div", D7, [...k[0] || (k[0] = [
            v("i", { class: "ri-check-fill text-white text-sm" }, null, -1)
          ])])) : e.icon ? (c(), g("div", z7, [
            v("i", {
              class: C([e.icon, "text-gray-500 dark:text-(--colors-text-white-secondary) text-base"])
            }, null, 2)
          ])) : w("", !0)
        ]),
        v("div", O7, [
          v("div", P7, j(e.title), 1),
          e.subtitle ? (c(), g("div", F7, j(e.subtitle), 1)) : w("", !0)
        ]),
        v("div", V7, [
          v("i", {
            class: C(["text-xl text-gray-400 dark:text-(--colors-text-white-secondary) transition-transform duration-200", e.expanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"])
          }, null, 2)
        ])
      ], 10, B7),
      v("div", {
        id: b.value,
        ref_key: "contentRef",
        ref: i,
        class: C(["collapsible-content", {
          "collapsible-content--expanded": e.expanded,
          "collapsible-content--open": l.value
        }]),
        role: "region",
        inert: !e.expanded || void 0,
        "aria-hidden": !e.expanded,
        onTransitionend: u
      }, [
        v("div", H7, [
          Ae(y.$slots, "default", {}, void 0, !0),
          e.showActions ? (c(), g("div", {
            key: 0,
            class: C(["flex items-center gap-3 mt-4", e.actionsAlignment === "end" ? "flex-row-reverse" : ""])
          }, [
            Ae(y.$slots, "actions", {
              validate: p,
              cancel: x
            }, () => [
              v("button", {
                ref_key: "validateRef",
                ref: s,
                type: "button",
                class: C([
                  "inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium text-white border border-[#6a7282] transition-colors",
                  e.validateDisabled || e.validateLoading ? "bg-[#242424] opacity-50 cursor-not-allowed" : "bg-[#242424] hover:bg-[#3a3a3a] cursor-pointer"
                ]),
                disabled: e.validateDisabled || e.validateLoading,
                "data-testid": "collapsible-section-validate",
                onClick: Je(p, ["stop"])
              }, [
                e.validateLoading ? (c(), g("i", W7)) : (c(), g("i", q7)),
                nt(" " + j(e.validateLabel), 1)
              ], 10, j7),
              v("button", {
                type: "button",
                class: C([
                  "inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium text-text-black-default dark:text-(--colors-text-white-default) bg-white dark:bg-(--colors-background-black-default) border border-solid border-[#919191] dark:border-(--colors-border-base) transition-colors",
                  e.cancelDisabled ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-50 dark:hover:bg-[rgba(255,255,255,0.05)] cursor-pointer"
                ]),
                disabled: e.cancelDisabled,
                "data-testid": "collapsible-section-cancel",
                onClick: Je(x, ["stop"])
              }, j(e.cancelLabel), 11, U7)
            ], !0)
          ], 2)) : w("", !0),
          e.warning ? (c(), W(L(_l), {
            key: 1,
            color: "danger",
            heading: e.warning,
            class: "mt-4",
            "data-testid": "collapsible-section-warning"
          }, null, 8, ["heading"])) : w("", !0)
        ])
      ], 42, N7)
    ], 2));
  }
}), pU = /* @__PURE__ */ dt(G7, [["__scopeId", "data-v-fb7f3a92"]]), K7 = ["aria-label"], Y7 = { class: "flex w-full flex-col items-center gap-5" }, J7 = { class: "flex w-full flex-col items-center gap-3.5" }, X7 = {
  key: 0,
  class: "max-w-full truncate rounded border border-(--colors-border-base-soft) bg-white px-1 py-0.5 text-xs font-medium leading-5 text-(--colors-text-black-default) dark:bg-(--colors-background-black-default) dark:text-(--colors-text-white-default)"
}, Z7 = { class: "flex w-full flex-col items-center gap-2.5 text-center" }, Q7 = { class: "min-h-[48px] w-full text-xl font-bold leading-6 text-(--colors-text-heading) line-clamp-2 dark:text-(--colors-text-white-default)" }, _7 = { class: "min-h-[20px] w-full truncate text-sm leading-5 text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)" }, vU = /* @__PURE__ */ ye({
  __name: "ProfileCard",
  props: {
    name: { default: void 0 },
    role: { default: void 0 },
    email: { default: void 0 },
    avatarUrl: { default: void 0 },
    buttonLabel: { default: void 0 },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e) {
    return (n, t) => (c(), g("article", {
      class: "flex w-full flex-col items-center gap-6",
      "aria-label": e.name
    }, [
      e.loading ? (c(), g(de, { key: 0 }, [
        t[1] || (t[1] = co('<div class="h-16 w-16 shrink-0 animate-pulse rounded-full bg-(--colors-border-base-soft)"></div><div class="flex w-full flex-col items-center gap-5"><div class="flex w-full flex-col items-center gap-3.5"><div class="h-5 w-28 animate-pulse rounded bg-(--colors-border-base-soft)"></div><div class="flex w-full flex-col items-center gap-2"><div class="h-6 w-4/5 animate-pulse rounded bg-(--colors-border-base-soft)"></div><div class="h-5 w-3/5 animate-pulse rounded bg-(--colors-border-base-soft)"></div></div></div><div class="h-7 w-32 animate-pulse rounded-full bg-(--colors-border-base-soft)"></div></div>', 2))
      ], 64)) : (c(), g(de, { key: 1 }, [
        te(Nt, {
          name: e.name ?? "",
          img: e.avatarUrl,
          size: "2xl",
          "avatar-style": "square",
          presentational: ""
        }, null, 8, ["name", "img"]),
        v("div", Y7, [
          v("div", J7, [
            e.role ? (c(), g("span", X7, j(e.role), 1)) : w("", !0),
            v("div", Z7, [
              v("p", Q7, j(e.name), 1),
              v("p", _7, j(e.email), 1)
            ])
          ]),
          te(Me, {
            variant: "secondary",
            size: "xs",
            label: e.buttonLabel,
            "icon-right": "ri-external-link-line",
            "aria-label": `${e.buttonLabel}: ${e.name}`,
            onClick: t[0] || (t[0] = (a) => n.$emit("click"))
          }, null, 8, ["label", "aria-label"])
        ])
      ], 64))
    ], 8, K7));
  }
}), eH = ["aria-label"], tH = { class: "flex w-full items-center" }, nH = ["aria-label"], aH = { class: "px-5 flex justify-center w-full" }, lH = { class: "flex w-full items-center" }, rH = { class: "flex flex-col items-center gap-0.5 text-center w-full px-5" }, oH = { class: "text-lg font-semibold leading-[22px] text-(--colors-text-heading) dark:text-(--colors-text-white-default)" }, iH = {
  key: 0,
  class: "text-lg font-semibold leading-[22px] text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
}, sH = {
  key: 1,
  class: "text-base leading-6 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
}, dH = ["aria-label"], uH = { class: "flex flex-col items-center" }, cH = ["aria-label"], fH = { class: "flex flex-col items-center" }, hH = { class: "flex flex-col gap-1 pb-8 pt-0.5" }, bH = { class: "text-lg font-semibold leading-[22px] text-(--colors-text-heading) dark:text-(--colors-text-white-default)" }, gH = {
  key: 0,
  class: "text-lg font-semibold leading-[22px] text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
}, mH = {
  key: 1,
  class: "text-base leading-6 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
}, xU = /* @__PURE__ */ ye({
  __name: "Timeline",
  props: {
    items: { default: () => [] },
    orientation: { default: "auto" },
    ariaLabel: { default: "Timeline" },
    loading: { type: Boolean, default: !1 },
    loadingCount: { default: 3 },
    itemMinWidth: { default: "160px" },
    showItemIcons: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = e, t = E9("(min-width: 768px)"), a = [
      "green",
      "violet",
      "yellow",
      "indigo",
      "cyan",
      "orange",
      "red",
      "purple",
      "neutral"
    ], l = (i, s) => i.badgeTheme ?? a[s % a.length], r = m(() => n.orientation === "horizontal" ? !0 : n.orientation === "vertical" ? !1 : t.value), o = m(() => Array.from({ length: n.loadingCount }));
    return (i, s) => r.value ? (c(), g("ol", {
      key: 0,
      "aria-label": e.ariaLabel,
      class: "flex w-full items-start overflow-x-auto pb-3"
    }, [
      e.loading ? (c(!0), g(de, { key: 0 }, Re(o.value, (d, u) => (c(), g("li", {
        key: u,
        class: "flex flex-1 flex-col items-center gap-4",
        style: je({ minWidth: e.itemMinWidth })
      }, [
        s[1] || (s[1] = v("div", { class: "px-5 flex justify-center w-full" }, [
          v("div", { class: "h-6 w-24 animate-pulse rounded bg-(--colors-border-base-soft)" })
        ], -1)),
        v("div", tH, [
          v("div", {
            class: C(["flex-1 h-px", u === 0 ? "invisible" : "bg-(--colors-border-base-soft)"])
          }, null, 2),
          s[0] || (s[0] = v("div", { class: "h-3 w-3 shrink-0 animate-pulse rounded-full bg-(--colors-border-base-soft)" }, null, -1)),
          v("div", {
            class: C([
              "flex-1 h-px",
              u === o.value.length - 1 ? "invisible" : "bg-(--colors-border-base-soft)"
            ])
          }, null, 2)
        ]),
        s[2] || (s[2] = v("div", { class: "flex flex-col items-center gap-2 w-full px-5" }, [
          v("div", { class: "h-5 w-28 animate-pulse rounded bg-(--colors-border-base-soft)" }),
          v("div", { class: "h-4 w-20 animate-pulse rounded bg-(--colors-border-base-soft)" })
        ], -1))
      ], 4))), 128)) : (c(!0), g(de, { key: 1 }, Re(e.items, (d, u) => (c(), g("li", {
        key: u,
        "aria-label": `${d.title}, ${d.date}`,
        class: "flex flex-1 flex-col items-center gap-4",
        style: je({ minWidth: e.itemMinWidth })
      }, [
        v("div", aH, [
          te(gt, {
            label: d.date,
            theme: l(d, u),
            "show-close-icon": !1,
            "show-left-icon": e.showItemIcons,
            size: "sm",
            class: "whitespace-nowrap",
            "left-icon": e.showItemIcons ? d.icon ?? "ri-calendar-line" : void 0
          }, null, 8, ["label", "theme", "show-left-icon", "left-icon"])
        ]),
        v("div", lH, [
          v("div", {
            class: C(["flex-1 h-px bg-(--colors-border-base-medium)", u === 0 ? "invisible" : ""])
          }, null, 2),
          s[3] || (s[3] = v("div", { class: "h-3 w-3 shrink-0 rounded-full border-2 border-white bg-(--icons-icon-disabled-light) dark:border-(--colors-border-base) z-10" }, null, -1)),
          v("div", {
            class: C([
              "flex-1 h-px bg-(--colors-border-base-medium)",
              u === e.items.length - 1 ? "invisible" : ""
            ])
          }, null, 2)
        ]),
        v("div", rH, [
          v("p", oH, j(d.title), 1),
          d.subtitle ? (c(), g("p", iH, j(d.subtitle), 1)) : w("", !0),
          d.description ? (c(), g("p", sH, j(d.description), 1)) : w("", !0)
        ])
      ], 12, nH))), 128))
    ], 8, eH)) : (c(), g("ol", {
      key: 1,
      "aria-label": e.ariaLabel,
      class: "flex flex-col"
    }, [
      e.loading ? (c(!0), g(de, { key: 0 }, Re(o.value, (d, u) => (c(), g("li", {
        key: u,
        class: "flex flex-row gap-4"
      }, [
        v("div", uH, [
          v("div", {
            class: C([
              "w-px flex-1 bg-(--colors-border-base-soft)",
              u === 0 ? "invisible" : "animate-pulse"
            ])
          }, null, 2),
          s[4] || (s[4] = v("div", { class: "h-3 w-3 shrink-0 animate-pulse rounded-full bg-(--colors-border-base-soft)" }, null, -1)),
          v("div", {
            class: C([
              "w-px flex-1 bg-(--colors-border-base-soft)",
              u === o.value.length - 1 ? "invisible" : "animate-pulse"
            ])
          }, null, 2)
        ]),
        s[5] || (s[5] = v("div", { class: "flex flex-col gap-2 pb-8 pt-0.5" }, [
          v("div", { class: "h-6 w-24 animate-pulse rounded bg-(--colors-border-base-soft)" }),
          v("div", { class: "h-5 w-36 animate-pulse rounded bg-(--colors-border-base-soft)" }),
          v("div", { class: "h-4 w-28 animate-pulse rounded bg-(--colors-border-base-soft)" })
        ], -1))
      ]))), 128)) : (c(!0), g(de, { key: 1 }, Re(e.items, (d, u) => (c(), g("li", {
        key: u,
        "aria-label": `${d.title}, ${d.date}`,
        class: "flex flex-row gap-4"
      }, [
        v("div", fH, [
          v("div", {
            class: C([
              "w-px h-[9px] shrink-0 bg-(--colors-border-base-medium)",
              u === 0 ? "invisible" : ""
            ])
          }, null, 2),
          s[6] || (s[6] = v("div", { class: "h-3 w-3 shrink-0 rounded-full border-2 border-white bg-(--icons-icon-disabled-light) dark:border-(--colors-border-base) z-10" }, null, -1)),
          v("div", {
            class: C([
              "w-px flex-1 bg-(--colors-border-base-medium)",
              u === e.items.length - 1 ? "invisible" : ""
            ])
          }, null, 2)
        ]),
        v("div", hH, [
          te(gt, {
            label: d.date,
            theme: l(d, u),
            "show-close-icon": !1,
            "show-left-icon": e.showItemIcons,
            size: "sm",
            class: "self-start",
            "left-icon": e.showItemIcons ? d.icon ?? "ri-calendar-line" : void 0
          }, null, 8, ["label", "theme", "show-left-icon", "left-icon"]),
          v("p", bH, j(d.title), 1),
          d.subtitle ? (c(), g("p", gH, j(d.subtitle), 1)) : w("", !0),
          d.description ? (c(), g("p", mH, j(d.description), 1)) : w("", !0)
        ])
      ], 8, cH))), 128))
    ], 8, dH));
  }
}), pH = ["aria-label"], vH = ["aria-orientation", "tabindex"], xH = ["id", "data-testid", "aria-selected", "aria-disabled", "aria-controls", "tabindex", "onClick"], yH = { class: "truncate" }, kH = {
  key: 1,
  class: "ri-lock-line text-(length:--icon-size-sm) leading-none text-(--icons-icon-disabled-strong)",
  "aria-hidden": "true"
}, wH = ["aria-label"], CH = "before:pointer-events-none before:absolute before:inset-x-0 before:bottom-0 before:-z-1 before:border-b-3 before:border-(--border-border-base-soft)", Rb = "nav-pill relative isolate border border-transparent py-[calc(--spacing(2.5)-1px)] px-[calc(--spacing(4)-1px)] before:absolute before:-inset-px before:-z-10 before:rounded-[inherit] before:opacity-0 before:[background:var(--nav-pill-ring)] after:absolute after:inset-[calc(var(--border-border-width-border-sm)-1px)] after:-z-10 after:rounded-[inherit] after:opacity-0 after:bg-(--background-background-white) focus-visible:after:opacity-100 focus-visible:after:shadow-(--shadow-focus-l-inset)", Bb = "before:opacity-100 after:opacity-100 forced-colors:border-[Highlight]", Id = "text-(--text-text-disabled-strong)", SH = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "NavTabs",
  props: {
    tabs: {},
    modelValue: {},
    fullWidth: { type: Boolean, default: !1 },
    overflowLabel: {},
    overflowPreviousLabel: {},
    type: { default: "border-bottom" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = m(() => e.type === "vertical-pills"), a = m(() => [
      "relative isolate max-w-full",
      e.fullWidth || t.value ? "w-full" : "w-fit",
      e.type === "border-bottom" && CH
    ]), l = {
      "border-bottom": "size-8",
      default: "size-6",
      pills: "size-10"
    }, r = {
      "border-bottom": "scroll-px-8",
      default: "scroll-px-6",
      pills: "scroll-px-10"
    }, o = (T) => [
      "absolute top-1/2 -translate-y-1/2 z-20 inline-flex items-center justify-center cursor-pointer",
      T,
      "rounded-(--border-border-radius-rounded-base) bg-(--background-background-white) hover:bg-(--background-background-hover)",
      "text-(--icons-icon-dark-default) transition-colors duration-150 motion-reduce:transition-none",
      "focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)",
      l[e.type]
    ], i = {
      "border-bottom": "flex items-end gap-3",
      default: "flex items-center gap-3",
      pills: "flex items-center gap-3",
      "vertical-pills": "flex flex-col justify-center gap-3"
    }, s = {
      "border-bottom": {
        // Figma pads 14 px above and below with a 3 px INSIDE stroke: the bottom padding gives the
        // border back, and the underline lands on the wrapper's rule.
        base: "px-0.5 pt-3.5 pb-[calc(--spacing(3.5)-3px)] border-b-3",
        activeMark: "border-solid [border-image:var(--gradient-brand-border)_1]",
        hoverMark: "border-transparent hover:[border-image:var(--gradient-brand-border)_1]",
        restMark: "border-transparent",
        activeText: "text-(--text-text-black-default)",
        hoverText: "hover:text-(--text-text-black-default)"
      },
      default: {
        base: "rounded-(--border-border-radius-rounded-xs)",
        activeMark: "underline",
        hoverMark: "hover:underline",
        restMark: "",
        activeText: "text-(--text-text-hover)",
        hoverText: "hover:text-(--text-text-hover)"
      },
      pills: {
        base: `${Rb} rounded-(--border-border-radius-rounded-full)`,
        activeMark: Bb,
        hoverMark: "hover:before:opacity-100 hover:after:opacity-100",
        restMark: "",
        activeText: "text-(--text-text-black-default)",
        hoverText: "hover:text-(--text-text-black-default)"
      },
      "vertical-pills": {
        base: `${Rb} justify-start rounded-(--border-border-radius-rounded-l)`,
        activeMark: Bb,
        hoverMark: "hover:before:opacity-100 hover:after:opacity-100",
        restMark: "",
        activeText: "text-(--text-text-black-default)",
        hoverText: "hover:text-(--text-text-black-default)"
      }
    };
    function d(T) {
      return T.locked === !0 || T.readOnly === !0;
    }
    function u(T) {
      const I = s[e.type], A = T.key === e.modelValue, E = e.type === "pills" || e.type === "vertical-pills";
      return T.locked ? [
        A ? I.activeMark : I.restMark,
        Id,
        "cursor-not-allowed",
        E && !A ? "bg-(--background-background-white)" : ""
      ] : A ? [I.activeMark, T.readOnly ? Id : I.activeText] : [I.hoverMark, T.readOnly ? Id : "text-(--text-text-body)", I.hoverText];
    }
    const f = n, b = R(null), h = R(null), p = R(null), x = $g({
      strip: b,
      arrow: h,
      backArrow: p,
      enabled: () => !t.value,
      selection: () => e.modelValue
    }), y = Gn(), k = m(() => {
      const { class: T, style: I, ...A } = y;
      return A;
    });
    function $(T) {
      T.locked || f("update:modelValue", T.key);
    }
    function S(T) {
      var z;
      const I = Array.from(
        T.currentTarget.querySelectorAll("[role=tab]")
      ), A = document.activeElement, E = A ? I.indexOf(A) : -1;
      let D;
      switch (T.key) {
        case (t.value ? "ArrowDown" : "ArrowRight"):
          D = E < 0 ? 0 : (E + 1) % I.length;
          break;
        case (t.value ? "ArrowUp" : "ArrowLeft"):
          D = E <= 0 ? I.length - 1 : E - 1;
          break;
        case "Home":
          D = 0;
          break;
        case "End":
          D = I.length - 1;
          break;
        case "Enter":
        case " ":
          if (A && A.getAttribute("aria-disabled") !== "true") {
            const Y = e.tabs[E];
            Y && f("update:modelValue", Y.key);
          }
          T.preventDefault();
          return;
        default:
          return;
      }
      T.preventDefault(), (z = I[D]) == null || z.focus();
    }
    return (T, I) => (c(), g("div", {
      class: C([a.value, L(y).class]),
      style: je(L(y).style)
    }, [
      L(x).showBackArrow.value ? (c(), g("button", {
        key: 0,
        ref_key: "backArrowRef",
        ref: p,
        type: "button",
        "aria-label": e.overflowPreviousLabel,
        "data-testid": "nav-tabs-overflow-back-arrow",
        class: C(o("left-0")),
        onClick: I[0] || (I[0] = //@ts-ignore
        (...A) => L(x).scrollBack && L(x).scrollBack(...A))
      }, [...I[3] || (I[3] = [
        v("i", {
          class: "ri-arrow-left-line text-(length:--icon-size-sm) leading-(--icon-size-sm)",
          "aria-hidden": "true"
        }, null, -1)
      ])], 10, pH)) : w("", !0),
      v("div", Fe({
        ref_key: "stripRef",
        ref: b
      }, k.value, {
        role: "tablist",
        "aria-orientation": t.value ? "vertical" : "horizontal",
        tabindex: L(x).overflowing.value ? -1 : void 0,
        class: [
          i[e.type],
          e.fullWidth || t.value ? "w-full" : "w-max max-w-full",
          !t.value && [
            "nav-tabs-scroll overflow-x-auto overflow-y-hidden",
            r[e.type]
          ]
        ],
        onKeydown: S,
        onScrollPassive: I[1] || (I[1] = //@ts-ignore
        (...A) => L(x).measure && L(x).measure(...A))
      }), [
        (c(!0), g(de, null, Re(e.tabs, (A) => (c(), W(mt, {
          key: A.key,
          class: C(t.value ? "w-full" : e.fullWidth ? "flex-1 min-w-0" : "shrink-0"),
          text: A.lockTooltip ?? "",
          disabled: !d(A) || !A.lockTooltip,
          position: t.value ? "right" : "bottom"
        }, {
          default: ve(() => [
            v("button", {
              id: A.id,
              type: "button",
              role: "tab",
              "data-testid": `nav-tab-${A.key}`,
              "aria-selected": A.key === e.modelValue,
              "aria-disabled": A.locked ? "true" : void 0,
              "aria-controls": A.panelId,
              tabindex: A.key === e.modelValue ? 0 : -1,
              class: C([
                "inline-flex min-w-0 items-center gap-1.5 whitespace-nowrap",
                "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)",
                "transition-colors motion-reduce:transition-none",
                "focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l-inset)",
                s[e.type].base,
                t.value ? "w-full" : e.fullWidth && "w-full justify-center",
                u(A)
              ]),
              onClick: (E) => $(A)
            }, [
              A.icon && !d(A) ? (c(), g("i", {
                key: 0,
                class: C([A.icon, "text-(length:--icon-size-sm) leading-none"]),
                "aria-hidden": "true"
              }, null, 2)) : w("", !0),
              v("span", yH, j(A.label), 1),
              d(A) ? (c(), g("i", kH)) : w("", !0)
            ], 10, xH)
          ]),
          _: 2
        }, 1032, ["class", "text", "disabled", "position"]))), 128))
      ], 16, vH),
      L(x).showArrow.value ? (c(), g("button", {
        key: 1,
        ref_key: "arrowRef",
        ref: h,
        type: "button",
        "aria-label": e.overflowLabel,
        "data-testid": "nav-tabs-overflow-arrow",
        class: C(o("right-0")),
        onClick: I[2] || (I[2] = //@ts-ignore
        (...A) => L(x).scrollForward && L(x).scrollForward(...A))
      }, [...I[4] || (I[4] = [
        v("i", {
          class: "ri-arrow-right-line text-(length:--icon-size-sm) leading-(--icon-size-sm)",
          "aria-hidden": "true"
        }, null, -1)
      ])], 10, wH)) : w("", !0)
    ], 6));
  }
}), yU = /* @__PURE__ */ dt(SH, [["__scopeId", "data-v-a1f63d2d"]]), Mb = /* @__PURE__ */ ye({
  __name: "StepperWizardPhaseIcon",
  props: {
    icon: {},
    disabled: { type: Boolean }
  },
  setup(e) {
    return (n, t) => (c(), W(Gt, {
      size: "md",
      type: "circle",
      variant: "outlined",
      color: e.disabled ? "disabled" : "white",
      icon: e.icon
    }, null, 8, ["color", "icon"]));
  }
}), $H = ["data-testid", "aria-current", "aria-disabled", "onClick"], IH = { class: "truncate" }, LH = ["data-testid", "aria-expanded", "aria-disabled", "onClick"], TH = { class: "flex items-center gap-3 truncate" }, AH = { class: "truncate" }, EH = ["data-testid", "aria-current", "aria-disabled", "onClick"], RH = {
  key: 1,
  class: "h-6 w-9 shrink-0",
  "aria-hidden": "true"
}, BH = { class: "py-0.5" }, Db = "flex items-center gap-3 p-1 w-full text-left rounded-(--border-border-radius-rounded-xs) text-base font-medium leading-6", kU = /* @__PURE__ */ ye({
  __name: "StepperWizardSidenav",
  props: {
    groups: {},
    currentStepId: {},
    showStatusIcons: { type: Boolean },
    showPhaseIcons: { type: Boolean }
  },
  emits: ["step-click", "group-toggle"],
  setup(e, { emit: n }) {
    function t(h, p) {
      if (h) return "text-(--text-text-disabled-light) cursor-not-allowed";
      const x = "text-(--text-text-heading) transition-colors";
      return p ? `${x} bg-[image:var(--gradient-brand-row-highlight)]` : `${x} hover:bg-[image:var(--gradient-brand-row-highlight)]`;
    }
    const a = e, l = n, r = Ha({});
    function o() {
      for (const h of a.groups)
        h.steps.length > 0 && (r[h.id] = h.defaultExpanded ?? !0);
    }
    o(), $e(
      () => a.groups,
      (h) => {
        for (const p of h)
          p.steps.length > 0 && !(p.id in r) && (r[p.id] = p.defaultExpanded ?? !0);
      },
      { deep: !1 }
    );
    const i = m(() => {
      var h;
      if (a.currentStepId)
        return (h = a.groups.find(
          (p) => p.steps.some((x) => x.id === a.currentStepId)
        )) == null ? void 0 : h.id;
    });
    $e(
      i,
      (h) => {
        h && (r[h] = !0);
      },
      { immediate: !0 }
    );
    function s(h, p) {
      return p != null && p.disabled ? "disabled" : h.id === a.currentStepId ? "current" : h.state ?? "upcoming";
    }
    function d(h) {
      switch (h) {
        case "done":
          return "ri-checkbox-circle-fill";
        case "current":
          return "ri-checkbox-circle-line";
        case "disabled":
          return "ri-checkbox-blank-circle-line";
        case "upcoming":
        default:
          return "ri-checkbox-blank-circle-line";
      }
    }
    function u(h) {
      l("step-click", h);
    }
    function f(h) {
      if (i.value === h) return;
      const p = !r[h];
      r[h] = p, l("group-toggle", h, p);
    }
    function b(h, p) {
      p != null && p.disabled || h.state !== "disabled" && (h.id, a.currentStepId, l("step-click", h.id));
    }
    return (h, p) => (c(), g("nav", {
      role: "navigation",
      class: C(["flex flex-col gap-3 pb-1.5 w-full min-w-72", h.$attrs.class])
    }, [
      (c(!0), g(de, null, Re(e.groups, (x) => (c(), g("div", {
        key: x.id,
        class: "flex flex-col gap-2 pr-1.5"
      }, [
        x.steps.length === 0 ? (c(), W(mt, {
          key: 0,
          class: "w-full",
          text: x.lockTooltip ?? "",
          disabled: !x.disabled || !x.lockTooltip,
          position: "bottom"
        }, {
          default: ve(() => [
            v("button", {
              type: "button",
              "data-testid": `sw-step-${x.id}`,
              "aria-current": x.id === e.currentStepId ? "step" : void 0,
              "aria-disabled": x.disabled ? "true" : void 0,
              class: C([Db, t(x.disabled, x.id === e.currentStepId)]),
              onClick: (y) => !x.disabled && u(x.id)
            }, [
              e.showPhaseIcons && x.icon ? (c(), W(Mb, {
                key: 0,
                icon: x.icon,
                disabled: x.disabled
              }, null, 8, ["icon", "disabled"])) : w("", !0),
              v("span", IH, j(x.label), 1)
            ], 10, $H)
          ]),
          _: 2
        }, 1032, ["text", "disabled"])) : (c(), g(de, { key: 1 }, [
          te(mt, {
            class: "w-full",
            text: x.lockTooltip ?? "",
            disabled: !x.disabled || !x.lockTooltip,
            position: "bottom"
          }, {
            default: ve(() => [
              v("button", {
                type: "button",
                "data-testid": `sw-group-${x.id}`,
                "aria-expanded": r[x.id],
                "aria-disabled": x.disabled ? "true" : void 0,
                class: C([
                  Db,
                  "justify-between",
                  t(x.disabled, i.value === x.id)
                ]),
                onClick: (y) => !x.disabled && f(x.id)
              }, [
                v("span", TH, [
                  e.showPhaseIcons && x.icon ? (c(), W(Mb, {
                    key: 0,
                    icon: x.icon,
                    disabled: x.disabled
                  }, null, 8, ["icon", "disabled"])) : w("", !0),
                  v("span", AH, j(x.label), 1)
                ]),
                v("i", {
                  class: C([
                    "ri-arrow-down-s-line text-xl shrink-0 transition-transform",
                    r[x.id] ? "-rotate-180" : ""
                  ]),
                  "aria-hidden": "true"
                }, null, 2)
              ], 10, LH)
            ]),
            _: 2
          }, 1032, ["text", "disabled"]),
          r[x.id] ? (c(!0), g(de, { key: 0 }, Re(x.steps, (y) => (c(), W(mt, {
            key: y.id,
            class: "w-full",
            text: y.lockTooltip ?? "",
            disabled: s(y, x) !== "disabled" || !y.lockTooltip,
            position: "bottom"
          }, {
            default: ve(() => [
              v("button", {
                type: "button",
                "data-testid": `sw-step-${y.id}`,
                "aria-current": s(y, x) === "current" ? "step" : void 0,
                "aria-disabled": s(y, x) === "disabled" ? "true" : void 0,
                class: C([
                  "flex items-start gap-3 px-1 w-full text-left text-sm font-medium leading-5",
                  s(y, x) === "disabled" ? "text-(--text-text-disabled-strong) cursor-not-allowed" : s(y, x) === "current" ? "text-(--text-text-hover)" : "text-(--text-text-body) hover:text-(--text-text-hover) transition-colors"
                ]),
                onClick: (k) => b(y, x)
              }, [
                e.showStatusIcons ? (c(), g("i", {
                  key: 0,
                  class: C([d(s(y, x)), "text-xl shrink-0"]),
                  "aria-hidden": "true"
                }, null, 2)) : (c(), g("span", RH)),
                v("span", BH, j(y.label), 1)
              ], 10, EH)
            ]),
            _: 2
          }, 1032, ["text", "disabled"]))), 128)) : w("", !0)
        ], 64))
      ]))), 128))
    ], 2));
  }
}), MH = {
  role: "status",
  "aria-live": "polite",
  class: "sr-only"
}, DH = {
  key: 0,
  "data-testid": "actions-status",
  role: "status",
  "aria-live": "polite",
  class: "sr-only"
}, zH = ["aria-label"], OH = { class: "inline-flex items-center gap-3.5 shrink-0" }, PH = {
  "data-testid": "actions-group",
  class: "flex items-center gap-1 min-w-0"
}, FH = {
  key: 0,
  "data-testid": "actions-loading",
  class: "flex items-center gap-2 px-2 shrink-0",
  "aria-hidden": "true"
}, VH = ["inert"], NH = { class: "hidden sm:inline" }, Ld = 640, zb = 560, HH = 1100, jH = "ri-lock-line", Td = 20, WH = "__untagged__", qH = 3, UH = '[data-testid="dropdown-menu"]', GH = /* @__PURE__ */ ye({
  __name: "FloatActionBar",
  props: {
    selectionCount: {},
    allPagesSelected: { type: Boolean },
    totalAcrossAllPages: {},
    actions: {},
    maxVisibleActions: { default: 4 },
    isLoading: { type: Boolean, default: !1 },
    actionsLoading: { type: Boolean, default: !1 },
    actionsError: { type: Boolean, default: !1 },
    moduleLabels: { default: void 0 },
    ariaLabel: {},
    selectedItemLabel: {},
    selectedItemsLabel: {},
    selectAllPagesLabel: {},
    moreLabel: {},
    moreActionsTitle: {},
    closeLabel: {},
    totalUnavailableLabel: {},
    selectionClearedLabel: {},
    actionsLoadingLabel: { default: void 0 }
  },
  emits: ["dismiss", "action-click", "select-all-pages"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = {
      primary: "primary",
      secondary: "secondary",
      text: "text",
      destructive: "error-text"
    };
    function r(Se) {
      return Se.variant ? l[Se.variant] : Se.destructive ? "error-text" : "text";
    }
    function o(Se) {
      return Se.variant === "destructive" || Se.destructive === !0;
    }
    function i(Se) {
      return s(Se) ? jH : Se.icon;
    }
    function s(Se) {
      return Se.disabled ? Se.disabledReason : void 0;
    }
    const d = m(() => t.actions.some((Se) => Se.order !== void 0) ? t.actions.map((Se, me) => ({ action: Se, index: me })).sort(
      (Se, me) => (Se.action.order ?? Number.MAX_SAFE_INTEGER) - (me.action.order ?? Number.MAX_SAFE_INTEGER) || Se.index - me.index
    ).map((Se) => Se.action) : t.actions), u = m(
      () => t.actionsLoading || t.actionsError ? [] : d.value
    ), f = m(
      () => u.value.filter((Se) => Se.placement !== "overflow")
    ), b = R(typeof window < "u" ? window.innerWidth : 1024);
    function h() {
      b.value = window.innerWidth, q.value !== null && (q.value = xe(q.value)), requestAnimationFrame($);
    }
    ct(() => window.addEventListener("resize", h)), kt(() => window.removeEventListener("resize", h));
    const p = R(null), x = R([]), y = R(t.actions.length);
    function k(Se) {
      return (me) => {
        x.value[Se] = me instanceof HTMLElement ? me : null;
      };
    }
    function $() {
      const Se = p.value;
      if (!Se) {
        y.value = f.value.length;
        return;
      }
      const me = Se.getBoundingClientRect().right, Be = x.value.findIndex(
        (Ye) => Ye && Ye.getBoundingClientRect().right > me + 1
      );
      y.value = Be === -1 ? f.value.length : Be;
    }
    let S = null;
    $e(
      p,
      (Se) => {
        S == null || S.disconnect(), Se && (S ?? (S = new ResizeObserver(() => requestAnimationFrame($))), S.observe(Se), requestAnimationFrame($));
      },
      { flush: "post", immediate: !0 }
    ), kt(() => S == null ? void 0 : S.disconnect());
    const T = m(
      () => f.value.map((Se) => `${Se.id}${Se.label}${i(Se) ?? ""}`).join("\0")
    );
    $e(T, () => requestAnimationFrame($));
    const I = m(() => b.value < Ld ? 0 : Math.min(y.value, t.maxVisibleActions));
    function A(Se) {
      return Se >= t.maxVisibleActions || b.value < Ld ? "hidden" : Se >= I.value ? "invisible" : "";
    }
    const E = m(() => {
      const Se = new Set(
        f.value.slice(0, I.value).map((me) => me.id)
      );
      return u.value.filter((me) => !Se.has(me.id));
    }), D = m(() => E.value.length > 0);
    $e(
      () => E.value.length,
      (Se) => {
        Se > Td && console.warn(
          `[FloatActionBar] More menu has ${Se} actions; only the first ${Td} are rendered.`
        );
      },
      { immediate: !0 }
    );
    const z = m(
      () => E.value.slice(0, Td)
    );
    function Y(Se) {
      return {
        label: Se.label,
        icon: i(Se),
        danger: o(Se),
        disabled: Se.disabled || t.isLoading,
        loading: Se.loading,
        // Shown as helper text under the label; an item carrying a description stays
        // focusable (aria-disabled) so the reason is keyboard-reachable (R74).
        description: s(Se),
        testId: "megamenu-nav-link",
        onClick: () => a("action-click", Se.id, O.value)
      };
    }
    const le = m(
      () => z.value.map(Y)
    ), ne = m(() => {
      const Se = [
        ...new Set(
          z.value.map((Ye) => Ye.module).filter((Ye) => !!Ye)
        )
      ], me = z.value.filter((Ye) => !Ye.module);
      if (Se.length + (me.length > 0 ? 1 : 0) < 2) return;
      const Be = Se.map((Ye) => {
        var Qe;
        return {
          key: Ye,
          // No fallback to the raw key: it is an identifier, and rendering it would ship
          // untranslated text to fr/nl users (R29). A heading-less column is the safe default.
          label: (Qe = t.moduleLabels) == null ? void 0 : Qe[Ye],
          items: z.value.filter((bt) => bt.module === Ye).map(Y)
        };
      });
      return me.length > 0 && Be.push({ key: WH, items: me.map(Y) }), Be;
    }), re = m(() => b.value < HH ? 2 : 4), O = m(() => ({
      selectedCount: t.selectionCount,
      allPagesSelected: t.allPagesSelected,
      totalCount: t.totalAcrossAllPages
    })), P = m(
      () => t.allPagesSelected && t.totalAcrossAllPages !== void 0 ? t.totalAcrossAllPages : t.selectionCount
    ), V = m(
      () => P.value === 1 ? t.selectedItemLabel : t.selectedItemsLabel
    ), M = R(null), B = R(null), q = R(null), N = R(!1);
    let G = 0, U = 0, K = 0;
    function ge() {
      var Se;
      return ((Se = M.value) == null ? void 0 : Se.offsetWidth) ?? 0;
    }
    function xe(Se) {
      return Math.max(16, Math.min(Se, window.innerWidth - ge() - 16));
    }
    let X = null;
    $e(
      () => M.value,
      (Se) => {
        X == null || X.disconnect(), !(!Se || typeof ResizeObserver > "u") && (X ?? (X = new ResizeObserver(() => {
          q.value !== null && (q.value = xe(q.value));
        })), X.observe(Se));
      },
      { flush: "post" }
    ), kt(() => X == null ? void 0 : X.disconnect());
    let ie = !1;
    function he(Se) {
      var me, Be;
      !M.value || Se.button !== 0 || ((Be = (me = Se.currentTarget) == null ? void 0 : me.setPointerCapture) == null || Be.call(me, Se.pointerId), ae(), N.value = !0, ie = !1, G = Se.clientX, U = Se.clientY, K = q.value ?? (window.innerWidth - ge()) / 2, Se.preventDefault());
    }
    function oe(Se) {
      if (!N.value) return;
      const me = Se.clientX - G;
      !ie && Math.hypot(me, Se.clientY - U) <= qH || (ie = !0, q.value = xe(K + me));
    }
    function Ce(Se) {
      var me, Be;
      N.value && (N.value = !1, (Be = (me = Se.currentTarget) == null ? void 0 : me.releasePointerCapture) == null || Be.call(me, Se.pointerId), Se.type === "pointerup" && (H.value = ie ? !1 : !H.value));
    }
    const H = R(!1);
    function Z(Se) {
      var me;
      if (Se.detail === 0) {
        H.value = !1;
        return;
      }
      if (Se.button === 0) {
        if (ee(Se.target)) {
          (me = B.value) != null && me.contains(Se.target) || (H.value = !1);
          return;
        }
        Se.preventDefault(), Se.stopPropagation(), q.value = xe(Se.clientX - ge() / 2), H.value = !1;
      }
    }
    function ee(Se) {
      var me;
      return Se instanceof Node && (!!((me = M.value) != null && me.contains(Se)) || Q(Se));
    }
    function J(Se) {
      Se.button !== 0 || ee(Se.target) || (Se.preventDefault(), Se.stopPropagation());
    }
    const F = [
      ["click", Z],
      ["pointerdown", J],
      ["mousedown", J],
      ["pointerup", J],
      ["mouseup", J]
    ];
    function _(Se) {
      for (const [me, Be] of F)
        Se ? document.addEventListener(me, Be, !0) : document.removeEventListener(me, Be, !0);
    }
    let ue = "";
    $e(H, (Se) => {
      _(Se);
      const me = document.documentElement;
      Se ? (ue = me.style.cursor, me.style.cursor = "crosshair") : me.style.cursor = ue;
    }), kt(() => {
      _(!1), H.value && (document.documentElement.style.cursor = ue);
    });
    const se = R(null);
    function Q(Se) {
      return Se instanceof Element && !!Se.closest(UH);
    }
    function ae() {
      var Be, Ye, Qe;
      if (!((Be = se.value) != null && Be.isOpen)) return;
      const Se = document.activeElement, me = !!Se && Q(Se);
      se.value.close(), me && ((Qe = (Ye = M.value) == null ? void 0 : Ye.querySelector('[data-testid="more-btn"]')) == null || Qe.focus());
    }
    $e(
      () => {
        var Se;
        return (Se = se.value) == null ? void 0 : Se.isOpen;
      },
      (Se) => {
        Se && (H.value = !1);
      }
    );
    const Te = R(null), Le = R([]);
    function pe(Se) {
      return (me) => {
        Le.value[Se] = me ?? null;
      };
    }
    function ke() {
      var Se;
      return (Se = Te.value) != null && Se.isVisible ? Te.value : Le.value.find((me) => me == null ? void 0 : me.isVisible) ?? null;
    }
    const fe = Symbol("float-action-bar");
    function ze(Se) {
      var Be, Ye, Qe;
      if (Se.key !== "Escape" || (Be = se.value) != null && Be.isOpen) return;
      const me = ke();
      if (me) {
        Se.stopPropagation(), Se.preventDefault(), me.hide();
        return;
      }
      if (H.value) {
        if (!ya(fe)) return;
        Se.preventDefault(), Se.target instanceof Node && ((Ye = M.value) != null && Ye.contains(Se.target)) && Se.stopPropagation(), H.value = !1;
        return;
      }
      Ee.value && ya(fe) && (Se.preventDefault(), Se.target instanceof Node && ((Qe = M.value) != null && Qe.contains(Se.target)) && Se.stopPropagation(), a("dismiss"));
    }
    ct(() => window.addEventListener("keydown", ze, !0)), kt(() => {
      window.removeEventListener("keydown", ze, !0), Fn(fe);
    });
    const Ee = m(() => t.selectionCount > 0);
    let He = null;
    $e(Ee, (Se) => {
      Se || (H.value = !1, N.value = !1);
    }), $e(
      Ee,
      (Se) => Se ? ra(fe) : Fn(fe)
    );
    let Ke = !1;
    ct(() => {
      Ke = !0, Ge(() => {
        Ke && Ee.value && ra(fe);
      });
    }), kt(() => {
      Ke = !1;
    }), $e(Ee, (Se) => {
      var me;
      if (Se) {
        He = document.activeElement instanceof HTMLElement && document.activeElement !== document.body ? document.activeElement : null;
        return;
      }
      (me = M.value) != null && me.contains(document.activeElement) && He && document.contains(He) && He.focus();
    });
    const et = R("");
    return $e(
      () => [t.selectionCount, t.allPagesSelected, t.totalAcrossAllPages],
      ([Se], me) => {
        const Be = me == null ? void 0 : me[0];
        Se > 0 ? et.value = `${P.value} ${V.value}` : Be !== void 0 && Be > 0 && (et.value = t.selectionClearedLabel);
      },
      { immediate: !0 }
    ), (Se, me) => (c(), g(de, null, [
      v("span", MH, j(et.value), 1),
      e.actionsLoadingLabel ? (c(), g("span", DH, j(e.actionsLoading ? e.actionsLoadingLabel : ""), 1)) : w("", !0),
      te(At, {
        name: "float-bar",
        appear: ""
      }, {
        default: ve(() => [
          e.selectionCount > 0 ? (c(), g("div", {
            key: 0,
            ref_key: "barRef",
            ref: M,
            "data-testid": "float-action-bar",
            role: "toolbar",
            "aria-label": e.ariaLabel,
            class: "inline-flex items-center gap-3.5 p-1.5 rounded-full overflow-hidden z-40 bg-(--background-background-black-default) shadow-(--shadow-xl)",
            style: je({
              position: "fixed",
              bottom: "24px",
              left: q.value !== null ? `${q.value}px` : "16px",
              right: q.value !== null ? void 0 : "16px",
              width: q.value !== null ? "max-content" : "fit-content",
              margin: q.value !== null ? void 0 : "0 auto",
              maxWidth: "calc(100vw - 32px)",
              cursor: N.value ? "grabbing" : H.value ? "crosshair" : void 0
            })
          }, [
            v("button", {
              ref_key: "handleRef",
              ref: B,
              "data-testid": "drag-handle",
              tabindex: "-1",
              "aria-hidden": "true",
              class: C([H.value ? "cursor-crosshair" : "cursor-grab", "flex shrink-0 items-center justify-center size-9 rounded-full bg-transparent border-none touch-none focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-(--border-border-accent)"]),
              onPointerdown: he,
              onPointermove: oe,
              onPointerup: Ce,
              onPointercancel: Ce,
              onClick: me[0] || (me[0] = Je(() => {
              }, ["prevent"]))
            }, [...me[3] || (me[3] = [
              v("i", {
                class: "ri-draggable text-(length:--icon-size-md) leading-(--icon-size-md) text-(--icons-icon-white-default)",
                "aria-hidden": "true"
              }, null, -1)
            ])], 34),
            v("div", OH, [
              te(Me, {
                "data-testid": "selection-count",
                variant: "secondary",
                size: "xs",
                label: b.value >= zb ? `${P.value} ${V.value}` : `${P.value}`,
                "icon-right": "ri-close-fill",
                "aria-label": `${P.value} ${V.value}`,
                class: "shrink-0",
                onClick: me[1] || (me[1] = (Be) => a("dismiss"))
              }, null, 8, ["label", "aria-label"]),
              te(mt, {
                ref_key: "selectAllTooltipRef",
                ref: Te,
                text: e.totalUnavailableLabel,
                disabled: e.totalAcrossAllPages !== void 0
              }, {
                default: ve(() => [
                  te(Bn, {
                    variant: "dark",
                    "model-value": e.allPagesSelected,
                    label: b.value >= zb ? e.selectAllPagesLabel : "",
                    "aria-label": e.selectAllPagesLabel,
                    "aria-disabled": e.totalAcrossAllPages === void 0,
                    class: "px-1 shrink-0 w-auto!",
                    "onUpdate:modelValue": me[2] || (me[2] = (Be) => a("select-all-pages", Be))
                  }, null, 8, ["model-value", "label", "aria-label", "aria-disabled"])
                ]),
                _: 1
              }, 8, ["text", "disabled"])
            ]),
            v("div", PH, [
              v("div", {
                ref_key: "btnAreaRef",
                ref: p,
                "data-testid": "action-buttons-area",
                class: "dark flex items-center gap-1 overflow-hidden min-w-0"
              }, [
                e.actionsLoading ? (c(), g("div", FH, [...me[4] || (me[4] = [
                  v("i", { class: "ri-loader-4-line animate-spin text-(length:--icon-size-sm) leading-(--icon-size-sm) text-(--icons-icon-white-default)" }, null, -1),
                  v("span", { class: "h-2 w-16 rounded-full bg-(--text-text-white-default) opacity-30" }, null, -1),
                  v("span", { class: "h-2 w-10 rounded-full bg-(--text-text-white-default) opacity-30" }, null, -1)
                ])])) : w("", !0),
                (c(!0), g(de, null, Re(f.value, (Be, Ye) => (c(), g("div", {
                  key: Be.id,
                  ref_for: !0,
                  ref: k(Ye),
                  class: C(["shrink-0", A(Ye)]),
                  inert: Ye >= I.value || void 0
                }, [
                  te(mt, {
                    ref_for: !0,
                    ref: pe(Ye),
                    text: s(Be) ?? "",
                    disabled: !s(Be)
                  }, {
                    default: ve(() => [
                      te(Me, {
                        "data-testid": `action-btn-${Be.id}`,
                        variant: r(Be),
                        size: "xs",
                        "icon-left": i(Be),
                        "icon-only": b.value < Ld,
                        loading: Be.loading,
                        disabled: !s(Be) && (Be.disabled || e.isLoading),
                        "aria-disabled": !!s(Be),
                        "aria-label": Be.label,
                        onClick: (Qe) => a("action-click", Be.id, O.value)
                      }, {
                        default: ve(() => [
                          v("span", NH, j(Be.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["data-testid", "variant", "icon-left", "icon-only", "loading", "disabled", "aria-disabled", "aria-label", "onClick"])
                    ]),
                    _: 2
                  }, 1032, ["text", "disabled"])
                ], 10, VH))), 128))
              ], 512),
              D.value ? (c(), W(cn, {
                key: 0,
                ref_key: "dropdownRef",
                ref: se,
                class: "shrink-0",
                "menu-item-variant": "nav",
                items: le.value,
                groups: ne.value,
                columns: re.value,
                "menu-header": e.moreActionsTitle,
                closeable: "",
                "close-label": e.closeLabel,
                "menu-reference": M.value,
                "menu-align": "right",
                "menu-side": "top",
                "menu-offset": 4
              }, {
                trigger: ve(({ triggerProps: Be }) => [
                  te(Me, Fe({
                    "data-testid": "more-btn",
                    variant: "secondary",
                    size: "xs",
                    "icon-left": "ri-more-line",
                    label: e.moreLabel,
                    class: "shrink-0"
                  }, Be), null, 16, ["label"])
                ]),
                _: 1
              }, 8, ["items", "groups", "columns", "menu-header", "close-label", "menu-reference"])) : w("", !0)
            ])
          ], 12, zH)) : w("", !0)
        ]),
        _: 1
      })
    ], 64));
  }
}), wU = /* @__PURE__ */ dt(GH, [["__scopeId", "data-v-ed745030"]]);
function CU(e, n = {}) {
  const t = er([]), a = R(!1), l = R(!1), r = R(null), o = R(void 0);
  let i = 0;
  async function s() {
    const d = ++i;
    a.value = !0, l.value = !1, r.value = null, t.value = [];
    try {
      const u = await e();
      if (d !== i) return;
      t.value = (u == null ? void 0 : u.actions) ?? [], o.value = u == null ? void 0 : u.version;
    } catch (u) {
      if (d !== i) return;
      l.value = !0, r.value = u, t.value = [];
    } finally {
      d === i && (a.value = !1);
    }
  }
  return n.immediate !== !1 && s(), { actions: t, isLoading: a, hasError: l, error: r, version: o, load: s };
}
const KH = {
  "data-testid": "field-skeleton",
  "aria-hidden": "true",
  class: "w-full"
}, YH = {
  key: 0,
  class: "flex items-center gap-2"
}, JH = {
  key: 0,
  class: "h-5 pb-0.5 flex items-center"
}, XH = /* @__PURE__ */ ye({
  __name: "FieldSkeleton",
  props: {
    variant: { default: "input" },
    size: { default: "md" },
    showLabel: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = {
      sm: "h-[32px]",
      md: "h-[36px]",
      lg: "h-[48px]",
      xl: "h-[52px]"
    };
    return (t, a) => (c(), g("div", KH, [
      e.variant === "checkbox" || e.variant === "toggle" ? (c(), g("div", YH, [
        v("div", {
          class: C([
            "skeleton shrink-0",
            e.variant === "toggle" ? "h-5 w-9 rounded-full" : "size-4 rounded"
          ])
        }, null, 2),
        a[0] || (a[0] = v("div", { class: "skeleton h-2.5 w-24 rounded-full" }, null, -1))
      ])) : (c(), g(de, { key: 1 }, [
        e.showLabel ? (c(), g("div", JH, [...a[1] || (a[1] = [
          v("div", { class: "skeleton h-2.5 w-24 rounded-full" }, null, -1)
        ])])) : w("", !0),
        v("div", {
          class: C([
            "skeleton w-full rounded-xl",
            e.variant === "textarea" ? "h-24" : n[e.size]
          ])
        }, null, 2)
      ], 64))
    ]));
  }
}), SU = /* @__PURE__ */ ye({
  __name: "FormSkeleton",
  props: {
    fields: { default: 6 },
    columns: { default: 2 },
    size: { default: "md" },
    showLabels: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", {
      "data-testid": "form-skeleton",
      "aria-hidden": "true",
      class: C(["grid gap-x-5 gap-y-4", e.columns === 2 ? "grid-cols-2" : "grid-cols-1"])
    }, [
      (c(!0), g(de, null, Re(e.fields, (a) => (c(), W(XH, {
        key: `form-skeleton-field-${a}`,
        size: e.size,
        "show-label": e.showLabels
      }, null, 8, ["size", "show-label"]))), 128))
    ], 2));
  }
}), ZH = {
  class: "flex flex-col gap-(--spacing-3)",
  "data-testid": "color-picker-palette"
}, QH = { class: "flex min-w-0 flex-1 rounded-(--border-border-radius-rounded-xs) border border-solid border-(--border-border-base-soft) bg-(--background-background-white) p-[calc(var(--spacing-1)-1px)]" }, _H = { class: "whitespace-nowrap text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-body)" }, ej = ["aria-label"], tj = ["aria-label", "aria-selected", "tabindex", "data-listbox-index", "onClick", "onFocus"], Uo = 6, nj = /* @__PURE__ */ ye({
  __name: "ColorPickerPalette",
  props: {
    swatches: {},
    modelValue: {},
    labels: {},
    showReset: { type: Boolean }
  },
  emits: ["select", "reset", "custom"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = R(null), o = m(
      () => a.modelValue ? a.swatches.findIndex((h) => h.hex === a.modelValue) : -1
    ), i = R(Math.max(0, o.value));
    $e(
      () => a.swatches.length,
      (h) => {
        i.value >= h && (i.value = Math.max(0, h - 1));
      }
    );
    function s() {
      const h = a.swatches[i.value];
      h && l("select", h.hex);
    }
    function d(h) {
      var p, x;
      i.value = h, (x = (p = r.value) == null ? void 0 : p.querySelector(`[data-listbox-index="${h}"]`)) == null || x.focus();
    }
    function u() {
      i.value = Math.max(0, o.value), Ge(() => d(i.value));
    }
    function f(h) {
      const p = a.swatches.length - 1, x = i.value;
      let y;
      switch (h.key) {
        case "ArrowRight":
          y = Math.min(p, x + 1);
          break;
        case "ArrowLeft":
          y = Math.max(0, x - 1);
          break;
        case "ArrowDown":
          y = x + Uo <= p ? x + Uo : x;
          break;
        case "ArrowUp":
          y = x - Uo >= 0 ? x - Uo : x;
          break;
        case "Home":
          y = 0;
          break;
        case "End":
          y = p;
          break;
        case "Enter":
          h.preventDefault(), s();
          return;
        case " ":
          h.preventDefault();
          return;
        default:
          return;
      }
      h.preventDefault(), h.stopPropagation(), d(y);
    }
    function b(h) {
      h.key === " " && (h.preventDefault(), s());
    }
    return n({ focusInitial: u }), (h, p) => (c(), g("div", ZH, [
      v("button", {
        type: "button",
        class: "flex w-full items-center gap-(--spacing-2) rounded-(--border-border-radius-rounded-xs) cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)",
        "data-testid": "color-picker-custom",
        onClick: p[0] || (p[0] = (x) => l("custom"))
      }, [
        v("span", QH, [
          v("span", {
            class: "h-(--spacing-6) w-full rounded-(--border-border-radius-rounded-xxs)",
            style: je({ backgroundColor: e.modelValue ?? "transparent" }),
            "data-testid": "color-picker-palette-preview"
          }, null, 4)
        ]),
        v("span", _H, j(e.labels.pickColor), 1)
      ]),
      v("div", {
        ref_key: "listboxRef",
        ref: r,
        role: "listbox",
        "aria-label": e.labels.palette,
        class: "grid w-fit grid-cols-6 gap-(--spacing-1)",
        "data-testid": "color-picker-swatches",
        onKeydown: f,
        onKeyup: b
      }, [
        (c(!0), g(de, null, Re(e.swatches, (x, y) => (c(), g("div", {
          key: y,
          role: "option",
          "aria-label": x.name,
          "aria-selected": y === o.value ? "true" : "false",
          tabindex: y === i.value ? 0 : -1,
          "data-listbox-index": y,
          class: C([
            "size-(--spacing-6) rounded-(--border-border-radius-rounded-xs) border border-solid cursor-pointer focus-visible:outline-none focus-visible:border-(--border-border-accent) focus-visible:shadow-[0px_0px_2px_0px_var(--background-background-hover)]",
            // Selected mark reuses the Button focus treatment: accent border + soft glow.
            y === o.value ? "border-(--border-border-accent) shadow-[0px_0px_2px_0px_var(--background-background-hover)]" : "border-(--border-border-base-soft)"
          ]),
          style: je({ backgroundColor: x.hex }),
          "data-testid": "color-picker-swatch",
          onClick: (k) => l("select", x.hex),
          onFocus: (k) => i.value = y
        }, null, 46, tj))), 128))
      ], 40, ej),
      e.showReset ? (c(), W(Me, {
        key: 0,
        class: "self-center",
        variant: "ghost",
        size: "xs",
        "icon-left": "ri-restart-line",
        label: e.labels.resetColor,
        "data-testid": "color-picker-reset",
        onClick: p[1] || (p[1] = (x) => l("reset"))
      }, null, 8, ["label"])) : w("", !0)
    ]));
  }
}), Qn = (e, n, t) => Math.min(t, Math.max(n, e));
function ga(e) {
  const n = e.trim().replace(/^#/, "");
  return /^[0-9a-f]{3}$/i.test(n) ? `#${n.split("").map((t) => t + t).join("").toUpperCase()}` : /^[0-9a-f]{6}$/i.test(n) ? `#${n.toUpperCase()}` : null;
}
function aj(e) {
  const n = ga(e) ?? "#000000", t = parseInt(n.slice(1), 16);
  return { r: t >> 16 & 255, g: t >> 8 & 255, b: t & 255 };
}
function Ob({ r: e, g: n, b: t }) {
  const a = (l) => Math.round(Qn(l, 0, 255)).toString(16).padStart(2, "0");
  return `#${a(e)}${a(n)}${a(t)}`.toUpperCase();
}
function Lu({ r: e, g: n, b: t }) {
  const a = e / 255, l = n / 255, r = t / 255, o = Math.max(a, l, r), i = o - Math.min(a, l, r);
  let s = 0;
  return i !== 0 && (o === a ? s = (l - r) / i % 6 : o === l ? s = (r - a) / i + 2 : s = (a - l) / i + 4, s = (s * 60 + 360) % 360), { h: s, s: o === 0 ? 0 : i / o * 100, v: o * 100 };
}
function Go({ h: e, s: n, v: t }) {
  const a = Qn(n, 0, 100) / 100, l = Qn(t, 0, 100) / 100, r = (o) => {
    const i = (o + (e % 360 + 360) / 60) % 6;
    return l - l * a * Math.max(0, Math.min(i, 4 - i, 1));
  };
  return { r: Math.round(r(5) * 255), g: Math.round(r(3) * 255), b: Math.round(r(1) * 255) };
}
function Pb({ r: e, g: n, b: t }) {
  const a = e / 255, l = n / 255, r = t / 255, o = Math.max(a, l, r), i = Math.min(a, l, r), s = (o + i) / 2, d = o - i, u = d === 0 ? 0 : d / (1 - Math.abs(2 * s - 1));
  return { h: Lu({ r: e, g: n, b: t }).h, s: u * 100, l: s * 100 };
}
function lj({ h: e, s: n, l: t }) {
  const a = Qn(n, 0, 100) / 100, l = Qn(t, 0, 100) / 100, r = a * Math.min(l, 1 - l), o = (i) => {
    const s = (i + (e % 360 + 360) / 30) % 12;
    return l - r * Math.max(-1, Math.min(s - 3, 9 - s, 1));
  };
  return { r: Math.round(o(0) * 255), g: Math.round(o(8) * 255), b: Math.round(o(4) * 255) };
}
const rj = {
  class: "flex flex-col gap-(--spacing-3)",
  "data-testid": "color-picker-spectrum"
}, oj = ["value", "aria-label", "aria-valuetext"], ij = ["value", "aria-label", "aria-valuetext"], sj = { class: "flex items-center gap-(--spacing-2)" }, dj = ["aria-label"], uj = ["value", "aria-label", "aria-valuetext"], cj = { class: "flex items-end gap-(--spacing-1)" }, fj = { class: "flex min-w-0 flex-1 gap-(--spacing-2)" }, hj = { class: "flex w-[69px] shrink-0 flex-col items-center gap-[10px]" }, bj = ["id", "value", "onKeydown"], gj = ["for"], mj = ["id", "value", "aria-label", "data-testid", "onInput", "onKeydown"], pj = ["for"], vj = ["aria-label"], Fb = "h-(--spacing-9) w-full min-w-0 rounded-(--border-border-radius-rounded-sm) border border-solid border-(--border-border-base-soft) bg-transparent px-(--spacing-1) text-center text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-heading) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)", Vb = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-heading)", xj = /* @__PURE__ */ ye({
  __name: "ColorPickerSpectrum",
  props: {
    modelValue: {},
    labels: {}
  },
  emits: ["update", "commit"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = qe(), o = R(null), i = R(null), s = R(null), d = R(null), u = R({ h: 0, s: 100, v: 100 }), f = m(() => Ob(Go(u.value))), b = m(() => `hsl(${u.value.h} 100% 50%)`);
    function h(X) {
      if (!X || ga(X) === f.value) return;
      const ie = Lu(aj(X));
      u.value = ie.s === 0 || ie.v === 0 ? { ...ie, h: u.value.h } : ie;
    }
    $e(() => a.modelValue, h, { immediate: !0 });
    function p(X) {
      u.value = { ...u.value, ...X }, l("update", f.value);
    }
    function x(X) {
      h(X), l("update", f.value);
    }
    const y = R(null);
    function k(X, ie) {
      const he = ie.getBoundingClientRect();
      return {
        x: he.width ? Qn((X.clientX - he.left) / he.width, 0, 1) : 0,
        y: he.height ? Qn((X.clientY - he.top) / he.height, 0, 1) : 0
      };
    }
    function $(X) {
      if (y.value === "area" && o.value) {
        const { x: ie, y: he } = k(X, o.value);
        p({ s: ie * 100, v: (1 - he) * 100 });
      } else y.value === "hue" && i.value && p({ h: k(X, i.value).x * 360 });
    }
    function S(X, ie) {
      var he, oe, Ce;
      ie.preventDefault(), y.value = X, (oe = (he = ie.currentTarget).setPointerCapture) == null || oe.call(he, ie.pointerId), $(ie), (Ce = (X === "area" ? s : d).value) == null || Ce.focus();
    }
    function T(X) {
      y.value && $(X);
    }
    function I() {
      y.value && (y.value = null, l("commit"));
    }
    function A(X, ie, he) {
      if (!X.shiftKey) return;
      const oe = { ArrowRight: 10, ArrowUp: 10, ArrowLeft: -10, ArrowDown: -10 }[X.key];
      oe !== void 0 && (X.preventDefault(), p({ [ie]: Qn(u.value[ie] + oe, 0, he) }), l("commit"));
    }
    const E = {
      ArrowRight: ["s", 1],
      ArrowLeft: ["s", -1],
      ArrowUp: ["v", 1],
      ArrowDown: ["v", -1],
      PageUp: ["v", 10],
      PageDown: ["v", -10]
    };
    function D(X) {
      const ie = E[X.key];
      if (!ie) return;
      const [he, oe] = ie;
      X.preventDefault();
      const Ce = X.shiftKey && Math.abs(oe) === 1 ? oe * 10 : oe;
      p({ [he]: Qn(Math.round(u.value[he]) + Ce, 0, 100) }), l("commit");
    }
    function z(X, ie) {
      p({ [ie]: Number(X.target.value) });
    }
    const Y = R(!1), le = m(
      () => `${a.labels.saturation} ${Math.round(u.value.s)} %, ${a.labels.brightness} ${Math.round(u.value.v)} %`
    ), ne = R(!1), re = R("rgb"), O = R(null), P = R(null), V = m(() => {
      const X = Go(u.value);
      if (re.value === "rgb")
        return [
          { short: "R", name: a.labels.red, value: X.r, max: 255 },
          { short: "G", name: a.labels.green, value: X.g, max: 255 },
          { short: "B", name: a.labels.blue, value: X.b, max: 255 }
        ];
      const ie = Pb(X);
      return [
        { short: "H", name: a.labels.hue, value: Math.round(u.value.h), max: 360 },
        { short: "S", name: a.labels.saturation, value: Math.round(ie.s), max: 100 },
        { short: "L", name: a.labels.lightness, value: Math.round(ie.l), max: 100 }
      ];
    });
    function M() {
      if (O.value === null) return;
      const X = ga(O.value);
      O.value = null, !(!X || X === f.value) && (x(X), l("commit"));
    }
    function B(X, ie) {
      const he = Qn(Math.round(ie), 0, V.value[X].max);
      if (re.value === "rgb") {
        const H = Go(u.value), Z = [H.r, H.g, H.b];
        Z[X] = he, x(Ob({ r: Z[0], g: Z[1], b: Z[2] }));
        return;
      }
      const oe = Pb(Go(u.value)), Ce = { h: u.value.h, s: oe.s, l: oe.l };
      X === 0 ? Ce.h = he : X === 1 ? Ce.s = he : Ce.l = he, p({ ...Lu(lj(Ce)), h: Ce.h });
    }
    function q(X, ie) {
      const he = ie.target.value;
      P.value = { index: X, text: he };
      const oe = Number.parseInt(he, 10);
      Number.isFinite(oe) && B(X, oe);
    }
    function N(X, ie) {
      const he = { ArrowUp: 1, ArrowDown: -1 }[ie.key];
      if (he === void 0) {
        ie.key === "Enter" && (ie.preventDefault(), G());
        return;
      }
      ie.preventDefault(), P.value = null, B(X, V.value[X].value + he * (ie.shiftKey ? 10 : 1)), l("commit");
    }
    function G() {
      P.value !== null && (P.value = null, l("commit"));
    }
    const U = R(!1);
    ct(() => {
      U.value = typeof window.EyeDropper == "function";
    });
    async function K() {
      const X = window.EyeDropper;
      if (X)
        try {
          const { sRGBHex: ie } = await new X().open(), he = ga(ie);
          if (!he) return;
          x(he), l("commit");
        } catch {
        }
    }
    const ge = `linear-gradient(to right, ${[0, 60, 120, 180, 240, 300, 360].map((X) => `hsl(${X} 100% 50%)`).join(", ")})`;
    function xe() {
      var X;
      (X = s.value) == null || X.focus();
    }
    return n({ focusInitial: xe }), (X, ie) => (c(), g("div", rj, [
      v("div", {
        ref_key: "areaRef",
        ref: o,
        class: "relative h-[119px] w-full touch-none cursor-crosshair rounded-(--border-border-radius-rounded-xs) outline-1 outline-solid outline-(--border-border-base-soft)",
        style: je({
          backgroundImage: `linear-gradient(to top, var(--colors-color-picker-black), transparent), linear-gradient(to right, var(--colors-background-white), ${b.value})`
        }),
        "data-testid": "color-picker-area",
        onPointerdown: ie[8] || (ie[8] = (he) => S("area", he)),
        onMousedown: ie[9] || (ie[9] = Je(() => {
        }, ["prevent"])),
        onPointermove: T,
        onPointerup: I,
        onPointercancel: I
      }, [
        v("span", {
          class: C([
            "pointer-events-none absolute size-[14px] -translate-x-1/2 translate-y-1/2 rounded-full border-3 border-solid border-(--colors-background-white) shadow-(--shadow-color-picker-handle)",
            Y.value && "ring-2 ring-(--border-border-accent)"
          ]),
          style: je({ left: `${u.value.s}%`, bottom: `${u.value.v}%` }),
          "data-testid": "color-picker-area-handle"
        }, null, 6),
        v("input", {
          ref_key: "saturationInputRef",
          ref: s,
          type: "range",
          class: "sr-only",
          min: "0",
          max: "100",
          step: "1",
          value: Math.round(u.value.s),
          "aria-label": e.labels.saturation,
          "aria-valuetext": le.value,
          "data-testid": "color-picker-saturation",
          onInput: ie[0] || (ie[0] = (he) => z(he, "s")),
          onChange: ie[1] || (ie[1] = (he) => l("commit")),
          onKeydown: D,
          onFocus: ie[2] || (ie[2] = (he) => Y.value = !0),
          onBlur: ie[3] || (ie[3] = (he) => Y.value = !1)
        }, null, 40, oj),
        v("input", {
          type: "range",
          class: "sr-only",
          min: "0",
          max: "100",
          step: "1",
          value: Math.round(u.value.v),
          "aria-label": e.labels.brightness,
          "aria-valuetext": le.value,
          tabindex: "-1",
          "data-testid": "color-picker-brightness",
          onInput: ie[4] || (ie[4] = (he) => z(he, "v")),
          onChange: ie[5] || (ie[5] = (he) => l("commit")),
          onKeydown: D,
          onFocus: ie[6] || (ie[6] = (he) => Y.value = !0),
          onBlur: ie[7] || (ie[7] = (he) => Y.value = !1)
        }, null, 40, ij)
      ], 36),
      v("div", sj, [
        U.value ? (c(), g("button", {
          key: 0,
          type: "button",
          class: "relative flex size-(--icon-size-md) shrink-0 items-center justify-center cursor-pointer rounded-(--border-border-radius-rounded-xs) text-(length:--icon-size-md) text-(--icons-icon-dark-default) after:absolute after:-inset-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)",
          "aria-label": e.labels.eyedropper,
          "data-testid": "color-picker-eyedropper",
          onClick: K
        }, [...ie[19] || (ie[19] = [
          v("i", {
            class: "ri-sip-line",
            "aria-hidden": "true"
          }, null, -1)
        ])], 8, dj)) : w("", !0),
        v("span", {
          class: "size-(--spacing-6) shrink-0 rounded-full",
          style: je({ backgroundColor: f.value }),
          "aria-hidden": "true",
          "data-testid": "color-picker-current"
        }, null, 4),
        v("div", {
          ref_key: "hueRef",
          ref: i,
          class: "relative h-[10px] min-w-0 flex-1 touch-none cursor-pointer rounded-(--border-border-radius-rounded-sm) outline-1 outline-solid outline-(--border-border-base-soft)",
          style: je({ backgroundImage: ge }),
          "data-testid": "color-picker-hue",
          onPointerdown: ie[15] || (ie[15] = (he) => S("hue", he)),
          onMousedown: ie[16] || (ie[16] = Je(() => {
          }, ["prevent"])),
          onPointermove: T,
          onPointerup: I,
          onPointercancel: I
        }, [
          v("span", {
            class: C([
              "pointer-events-none absolute top-1/2 size-(--spacing-4) -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-solid border-(--colors-background-white) shadow-(--shadow-color-picker-thumb)",
              ne.value && "ring-2 ring-(--border-border-accent)"
            ]),
            style: je({ left: `${u.value.h / 360 * 100}%`, backgroundColor: b.value }),
            "data-testid": "color-picker-hue-thumb"
          }, null, 6),
          v("input", {
            ref_key: "hueInputRef",
            ref: d,
            type: "range",
            class: "sr-only",
            min: "0",
            max: "360",
            step: "1",
            value: Math.round(u.value.h),
            "aria-label": e.labels.hue,
            "aria-valuetext": `${Math.round(u.value.h)}°`,
            "data-testid": "color-picker-hue-input",
            onInput: ie[10] || (ie[10] = (he) => z(he, "h")),
            onChange: ie[11] || (ie[11] = (he) => l("commit")),
            onKeydown: ie[12] || (ie[12] = (he) => A(he, "h", 360)),
            onFocus: ie[13] || (ie[13] = (he) => ne.value = !0),
            onBlur: ie[14] || (ie[14] = (he) => ne.value = !1)
          }, null, 40, uj)
        ], 36)
      ]),
      v("div", cj, [
        v("div", fj, [
          v("div", hj, [
            v("input", {
              id: `${L(r)}-hex`,
              type: "text",
              maxlength: "7",
              spellcheck: "false",
              class: C(Fb),
              value: O.value ?? f.value,
              "data-testid": "color-picker-hex",
              onInput: ie[17] || (ie[17] = (he) => O.value = he.target.value),
              onBlur: M,
              onKeydown: ht(Je(M, ["prevent"]), ["enter"])
            }, null, 40, bj),
            v("label", {
              for: `${L(r)}-hex`,
              class: C(Vb)
            }, j(e.labels.hex), 9, gj)
          ]),
          (c(!0), g(de, null, Re(V.value, (he, oe) => {
            var Ce;
            return c(), g("div", {
              key: `${re.value}-${he.short}`,
              class: "flex min-w-0 flex-1 flex-col items-center gap-[10px]"
            }, [
              v("input", {
                id: `${L(r)}-${he.short}`,
                type: "text",
                inputmode: "numeric",
                class: C(Fb),
                value: ((Ce = P.value) == null ? void 0 : Ce.index) === oe ? P.value.text : he.value,
                "aria-label": `${he.name} (${he.short})`,
                "data-testid": `color-picker-channel-${he.short}`,
                onInput: (H) => q(oe, H),
                onKeydown: (H) => N(oe, H),
                onBlur: G
              }, null, 40, mj),
              v("label", {
                for: `${L(r)}-${he.short}`,
                class: C(Vb),
                "aria-hidden": "true"
              }, j(he.short), 9, pj)
            ]);
          }), 128))
        ]),
        v("button", {
          type: "button",
          class: "relative flex size-(--icon-size-sm) shrink-0 items-center justify-center cursor-pointer rounded-(--border-border-radius-rounded-xs) text-(length:--icon-size-sm) text-(--icons-icon-dark-default) after:absolute after:-inset-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)",
          "aria-label": re.value === "rgb" ? e.labels.switchToHsl : e.labels.switchToRgb,
          "data-testid": "color-picker-format",
          onClick: ie[18] || (ie[18] = (he) => re.value = re.value === "rgb" ? "hsl" : "rgb")
        }, [...ie[20] || (ie[20] = [
          v("i", {
            class: "ri-expand-up-down-line",
            "aria-hidden": "true"
          }, null, -1)
        ])], 8, vj)
      ])
    ]));
  }
}), yj = {
  dialog: "Color picker",
  openPicker: "Choose a color",
  pickColor: "Pick a color",
  resetColor: "Reset color",
  palette: "Colors",
  saturation: "Saturation",
  brightness: "Brightness",
  hue: "Hue",
  hex: "Hex",
  red: "Red",
  green: "Green",
  blue: "Blue",
  lightness: "Lightness",
  eyedropper: "Pick a color from the screen",
  switchToHsl: "Switch to HSL",
  switchToRgb: "Switch to RGB",
  invalidHex: "Enter a color in the #RRGGBB format"
}, kj = {
  fr: {
    dialog: "Sélecteur de couleur",
    openPicker: "Choisir une couleur",
    pickColor: "Choisir une couleur",
    resetColor: "Réinitialiser la couleur",
    palette: "Couleurs",
    saturation: "Saturation",
    brightness: "Brillance",
    hue: "Teinte",
    hex: "Hex",
    red: "Rouge",
    green: "Vert",
    blue: "Bleu",
    lightness: "Luminosité",
    eyedropper: "Prélever une couleur à l'écran",
    switchToHsl: "Passer en TSL",
    switchToRgb: "Passer en RVB",
    invalidHex: "Saisissez une couleur au format #RRGGBB"
  },
  nl: {
    dialog: "Kleurkiezer",
    openPicker: "Kies een kleur",
    pickColor: "Kies een kleur",
    resetColor: "Kleur resetten",
    palette: "Kleuren",
    saturation: "Verzadiging",
    brightness: "Helderheid",
    hue: "Tint",
    hex: "Hex",
    red: "Rood",
    green: "Groen",
    blue: "Blauw",
    lightness: "Lichtheid",
    eyedropper: "Kleur van het scherm kiezen",
    switchToHsl: "Wisselen naar HSL",
    switchToRgb: "Wisselen naar RGB",
    invalidHex: "Voer een kleur in als #RRGGBB"
  }
}, Nb = {
  en: {
    indigo: "Indigo",
    green: "Green",
    yellow: "Yellow",
    red: "Red",
    orange: "Orange",
    violet: "Violet",
    purple: "Purple",
    pink: "Pink",
    cyan: "Cyan",
    gray: "Gray",
    slate: "Slate"
  },
  fr: {
    indigo: "Indigo",
    green: "Vert",
    yellow: "Jaune",
    red: "Rouge",
    orange: "Orange",
    violet: "Violet",
    purple: "Pourpre",
    pink: "Rose",
    cyan: "Cyan",
    gray: "Gris",
    slate: "Ardoise"
  },
  nl: {
    indigo: "Indigo",
    green: "Groen",
    yellow: "Geel",
    red: "Rood",
    orange: "Oranje",
    violet: "Violet",
    purple: "Paars",
    pink: "Roze",
    cyan: "Cyaan",
    gray: "Grijs",
    slate: "Leisteen"
  }
}, wj = [
  { hex: "#0A27FF", family: "indigo", shade: 700 },
  { hex: "#00A870", family: "green", shade: 500 },
  { hex: "#EECC01", family: "yellow", shade: 500 },
  { hex: "#F04438", family: "red", shade: 500 },
  { hex: "#FF881E", family: "orange", shade: 500 },
  { hex: "#00D492", family: "green", shade: 400 },
  { hex: "#615FFF", family: "indigo", shade: 400 },
  { hex: "#C4B4FF", family: "violet", shade: 300 },
  { hex: "#4542FF", family: "indigo", shade: 500 },
  { hex: "#FF993E", family: "orange", shade: 400 },
  { hex: "#FFDDC1", family: "orange", shade: 100 },
  { hex: "#DA9DFF", family: "purple", shade: 400 },
  { hex: "#C4B4FF", family: "violet", shade: 300 },
  { hex: "#D9D6FE", family: "violet", shade: 200 },
  { hex: "#FECDCA", family: "red", shade: 200 },
  { hex: "#FDA5D5", family: "pink", shade: 300 },
  { hex: "#FCD9BD", family: "orange", shade: 200 },
  { hex: "#E1FAFF", family: "cyan", shade: 100 },
  { hex: "#007595", family: "cyan", shade: 700 },
  { hex: "#BE5900", family: "orange", shade: 700 },
  { hex: "#FFF085", family: "yellow", shade: 200 },
  { hex: "#0A27FF", family: "indigo", shade: 700 },
  { hex: "#1430FF", family: "indigo", shade: 600 },
  { hex: "#52DBF5", family: "cyan", shade: 300 },
  { hex: "#E1FAFF", family: "cyan", shade: 100 },
  { hex: "#5EE9B5", family: "green", shade: 300 },
  { hex: "#F6339A", family: "pink", shade: 500 },
  { hex: "#E1FAFF", family: "cyan", shade: 100 },
  { hex: "#007A55", family: "green", shade: 700 },
  { hex: "#1E2939", family: "gray", shade: 800 },
  { hex: "#006045", family: "green", shade: 800 },
  { hex: "#6C3A8A", family: "purple", shade: 800 },
  { hex: "#CAD5E2", family: "slate", shade: 300 },
  { hex: "#F1F5F9", family: "slate", shade: 100 },
  { hex: "#F8FAFC", family: "slate", shade: 50 }
];
function Cj(e) {
  const n = Nb[e] ?? Nb.en;
  return wj.map(({ hex: t, family: a, shade: l }) => ({
    hex: t,
    name: `${n[a]} ${l}`
  }));
}
const Sj = ["disabled", "aria-label", "aria-expanded", "aria-controls"], $j = ["aria-label"], $U = /* @__PURE__ */ ye({
  __name: "ColorPicker",
  props: {
    modelValue: { default: null },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    hint: { default: void 0 },
    placeholder: { default: void 0 },
    id: { default: void 0 },
    name: { default: void 0 },
    width: { default: "384px" },
    fullWidth: { type: Boolean, default: !1 },
    language: { default: "en" },
    labels: { default: void 0 },
    swatches: { default: void 0 },
    showReset: { type: Boolean, default: !0 },
    resetValue: { default: null }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => t.language.slice(0, 2).toLowerCase()), r = m(() => ({
      ...kj[l.value] ?? yj,
      ...t.labels
    })), o = m(
      () => (t.swatches ?? Cj(l.value)).map((X) => ({
        ...X,
        hex: ga(X.hex) ?? X.hex
      }))
    ), i = m(() => t.modelValue ? ga(t.modelValue) : null), s = qe(), d = m(() => t.id ?? `${s}-input`), u = `${s}-panel`, f = m(
      () => t.label ? `${r.value.openPicker}, ${t.label}` : r.value.openPicker
    ), b = R(null), h = R(null), p = R(null), x = R(null), y = R(null), k = R(!1), $ = R("palette"), S = Symbol("color-picker");
    let T = null;
    const I = R(i.value ?? t.modelValue ?? ""), A = R(!1);
    let E = null, D = null;
    $e(
      () => t.modelValue,
      (X) => {
        const ie = X ? ga(X) : null;
        I.value = ie ?? X ?? "", A.value = !1, ie !== E && (E = null, D = ie);
      }
    );
    const z = m(
      () => t.error ?? (A.value ? r.value.invalidHex : void 0)
    );
    function Y(X, ie) {
      I.value = X ?? "", A.value = !1, X !== i.value && (a("update:modelValue", X), ie && a("change", X));
    }
    function le() {
      const X = I.value.trim();
      if (X === "") {
        Y(null, !0);
        return;
      }
      const ie = ga(X);
      ie ? Y(ie, !0) : A.value = !0;
    }
    async function ne() {
      var X;
      t.disabled || k.value || ($.value = "palette", E = null, k.value = !0, ra(S), await Ge(), !(!k.value || T || !h.value || !p.value) && (T = Xa(h.value, p.value, {
        strategy: "fixed",
        placement: "bottom-start",
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: ["top-start"] } },
          // altAxis keeps the panel inside a short viewport (200 % zoom) when neither side fits.
          { name: "preventOverflow", options: { padding: 8, altAxis: !0 } }
        ]
      }), (X = x.value) == null || X.focusInitial()));
    }
    function re(X) {
      k.value && ($.value === "spectrum" && ge(), k.value = !1, Fn(S), T == null || T.destroy(), T = null, X && Ge(() => {
        var ie;
        return (ie = h.value) == null ? void 0 : ie.focus();
      }));
    }
    function O() {
      k.value ? re(!1) : ne();
    }
    async function P() {
      var X;
      $.value = "spectrum", D = i.value, await Ge(), await (T == null ? void 0 : T.update()), (X = y.value) == null || X.focusInitial();
    }
    function V(X) {
      X.key !== "Escape" || !k.value || !ya(S) || (X.stopPropagation(), X.preventDefault(), re(!0));
    }
    function M() {
      return p.value ? Array.from(
        p.value.querySelectorAll(
          "button:not([disabled]), input:not([disabled]), [tabindex]"
        )
      ).filter((X) => {
        var ie;
        return !((ie = X.getAttribute("tabindex")) != null && ie.startsWith("-"));
      }) : [];
    }
    function B(X, ie) {
      ie && (X.preventDefault(), X.stopPropagation(), ie.focus());
    }
    function q(X) {
      X.key === "Tab" && !X.shiftKey && k.value && B(X, M()[0]);
    }
    function N(X) {
      if (X.key !== "Tab") {
        V(X);
        return;
      }
      const ie = M();
      X.shiftKey && document.activeElement === ie[0] ? B(X, h.value) : !X.shiftKey && document.activeElement === ie.at(-1) && B(X, document.getElementById(d.value));
    }
    function G(X) {
      var he;
      const ie = X.relatedTarget;
      ie && !((he = p.value) != null && he.contains(ie)) && ie !== h.value && re(!1);
    }
    rs(b, () => re(!1), {
      isActive: () => k.value,
      ignoreElements: () => [p.value]
    }), $e(
      () => t.disabled,
      (X) => {
        X && re(!1);
      }
    ), yt(() => re(!1));
    function U(X) {
      Y(X, !0), re(!0);
    }
    function K(X) {
      E = X, Y(X, !1);
    }
    function ge() {
      const X = E ?? i.value;
      X !== D && (D = X, a("change", X));
    }
    function xe() {
      Y(t.resetValue ? ga(t.resetValue) : null, !0);
    }
    return (X, ie) => (c(), g("div", {
      ref_key: "rootRef",
      ref: b,
      class: C(["relative flex min-w-0 items-start gap-(--spacing-1\\.5)", { "w-full": e.fullWidth }]),
      style: je(e.fullWidth ? void 0 : { width: e.width }),
      "data-testid": "color-picker",
      onKeydown: V
    }, [
      v("button", {
        ref_key: "triggerRef",
        ref: h,
        type: "button",
        disabled: e.disabled,
        "aria-label": f.value,
        "aria-haspopup": "dialog",
        "aria-expanded": k.value ? "true" : "false",
        "aria-controls": k.value ? u : void 0,
        class: C([
          // Figma strokes sit inside the box: the padding gives back the 1px border.
          "flex size-(--spacing-9) shrink-0 rounded-(--border-border-radius-rounded-xs) border border-solid border-(--border-border-base-soft) bg-(--background-background-white) p-[calc(var(--spacing-1)-1px)] focus-visible:outline-none focus-visible:border-(--border-border-accent) focus-visible:shadow-[0px_0px_2px_0px_var(--background-background-hover)]",
          // Aligns the swatch with the input row: TextInput's label line (20px) + its 2px gap.
          e.label && "mt-[calc(var(--line-height-l)+2px)]",
          e.disabled ? "cursor-not-allowed" : "cursor-pointer"
        ]),
        "data-testid": "color-picker-trigger",
        onClick: O,
        onKeydown: q
      }, [
        v("span", {
          class: "size-full rounded-(--border-border-radius-rounded-xs)",
          style: je({ backgroundColor: i.value ?? "transparent" }),
          "data-testid": "color-picker-trigger-preview"
        }, null, 4)
      ], 42, Sj),
      (c(), W(Nn, { to: "body" }, [
        k.value ? (c(), g("div", {
          key: 0,
          id: u,
          ref_key: "panelRef",
          ref: p,
          role: "dialog",
          tabindex: "-1",
          "aria-label": r.value.dialog,
          "data-focus-trap-allow-outside": "",
          class: C([
            "fixed z-[350] flex flex-col rounded-(--border-border-radius-rounded-l) border border-solid border-(--border-border-base-soft) bg-(--background-background-white) p-[calc(var(--spacing-3)-1px)] shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] outline-none",
            $.value === "palette" ? "w-(--color-picker-width-palette)" : "w-(--color-picker-width-spectrum)"
          ]),
          "data-testid": "color-picker-panel",
          onFocusout: G,
          onKeydown: N
        }, [
          $.value === "palette" ? (c(), W(nj, {
            key: 0,
            ref_key: "paletteRef",
            ref: x,
            swatches: o.value,
            "model-value": i.value,
            labels: r.value,
            "show-reset": e.showReset,
            onSelect: U,
            onReset: xe,
            onCustom: P
          }, null, 8, ["swatches", "model-value", "labels", "show-reset"])) : (c(), W(xj, {
            key: 1,
            ref_key: "spectrumRef",
            ref: y,
            "model-value": i.value,
            labels: r.value,
            onUpdate: K,
            onCommit: ge
          }, null, 8, ["model-value", "labels"]))
        ], 42, $j)) : w("", !0)
      ])),
      te(Wt, {
        id: d.value,
        modelValue: I.value,
        "onUpdate:modelValue": ie[0] || (ie[0] = (he) => I.value = he),
        class: "min-w-0 flex-1",
        "full-width": "",
        size: "md",
        name: e.name,
        label: e.label,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        disabled: e.disabled,
        error: z.value,
        hint: e.hint,
        placeholder: e.placeholder,
        onBlur: le,
        onKeydown: ht(le, ["enter"])
      }, {
        iconRight: ve(() => [...ie[1] || (ie[1] = [
          v("i", {
            class: "ri-search-line text-(length:--icon-size-sm) text-(--icons-icon-disabled-strong)",
            "aria-hidden": "true"
          }, null, -1)
        ])]),
        _: 1
      }, 8, ["id", "modelValue", "name", "label", "required", "required-indicator", "disabled", "error", "hint", "placeholder"])
    ], 38));
  }
}), Ij = ["aria-label"], Lj = {
  key: 1,
  role: "list",
  class: "stepper-navigation-scroll flex items-center gap-2 sm:gap-(--spacing-5) overflow-x-auto"
}, Tj = ["aria-label"], Aj = {
  key: 0,
  "aria-hidden": "true",
  class: "flex-1 border-t-(length:--border-border-width-border-base) border-(--border-border-base-soft)"
}, Ej = {
  key: 2,
  role: "list",
  class: "stepper-navigation-scroll overflow-x-auto"
}, Rj = { class: "relative flex w-max min-w-full items-center justify-between gap-2" }, Bj = ["aria-label"], Mj = ["aria-label"], Dj = { class: "flex flex-col items-start gap-(--spacing-0.5)" }, zj = {
  key: 0,
  "aria-hidden": "true",
  class: "text-(length:--size-m) leading-(--line-height-l) text-(--text-text-body) whitespace-nowrap"
}, Oj = {
  key: 4,
  role: "list",
  class: "flex flex-col items-start"
}, Pj = ["aria-label"], Fj = { class: "flex items-center gap-(--spacing-3)" }, Vj = { class: "flex flex-col items-start gap-(--spacing-0.5)" }, Nj = {
  key: 0,
  "aria-hidden": "true",
  class: "text-(length:--size-m) leading-(--line-height-l) text-(--text-text-body) whitespace-nowrap"
}, Hj = {
  key: 5,
  role: "list",
  class: "stepper-navigation-scroll flex flex-col items-start gap-(--spacing-4) w-full overflow-x-auto"
}, jj = ["aria-label"], Wj = {
  "aria-hidden": "true",
  class: "font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl) whitespace-nowrap"
}, qj = {
  "aria-hidden": "true",
  class: "flex-1 font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl)"
}, Uj = /* @__PURE__ */ ye({
  __name: "StepperNavigation",
  props: {
    steps: {},
    type: { default: "default" },
    labels: {},
    breakpoint: { default: "auto" }
  },
  emits: ["step-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = /* @__PURE__ */ new Set([
      "completed",
      "active",
      "error"
    ]);
    function r(P) {
      return l.has(P);
    }
    function o(P, V, M) {
      const B = t.labels.state[P.state];
      return `${P.label}, ${t.labels.step} ${V + 1} ${t.labels.of} ${M}, ${B}`;
    }
    function i(P) {
      a("step-click", P.id);
    }
    function s(P, V) {
      const M = r(P.state);
      return {
        type: M ? "button" : void 0,
        "data-testid": `stepper-navigation-step-${P.id}`,
        "aria-current": P.state === "active" ? "step" : void 0,
        "aria-disabled": M ? void 0 : "true",
        "aria-label": o(P, V, t.steps.length),
        onClick: M ? () => i(P) : void 0
      };
    }
    function d(P) {
      return r(P) ? "cursor-pointer focus:outline-none focus-visible:shadow-[0_0_2px_2px_var(--background-background-hover)]" : "";
    }
    const u = {
      upcoming: { variant: "outlined", color: "text" },
      active: { variant: "outlined", color: "gradient" },
      completed: { variant: "filled", color: "success" },
      error: { variant: "filled", color: "error" },
      disabled: { variant: "outlined", color: "disabled" }
    }, f = {
      completed: "ri-check-line",
      error: "ri-close-line"
    };
    function b(P, V) {
      const M = u[P.state], B = f[P.state];
      return B ? { ...M, icon: B } : { ...M, label: String(V + 1) };
    }
    function h(P, V) {
      const M = u[P.state], B = f[P.state];
      return B ? { ...M, icon: B } : P.icon ? { ...M, icon: P.icon, ...P.state === "upcoming" && { color: "white" } } : { ...M, label: String(V + 1) };
    }
    const p = {
      auto: "gap-2 sm:gap-(--spacing-4)",
      mobile: "gap-2",
      desktop: "gap-(--spacing-4)"
    }, x = {
      auto: "gap-1.5 sm:gap-(--spacing-2)",
      mobile: "gap-1.5",
      desktop: "gap-(--spacing-2)"
    }, y = {
      auto: "text-(length:--size-m) sm:text-(length:--size-l) leading-(--line-height-l) sm:leading-(--line-height-xxl)",
      mobile: "text-(length:--size-m) leading-(--line-height-l)",
      desktop: "text-(length:--size-l) leading-(--line-height-xxl)"
    }, k = m(() => t.type === "defaultVertical" ? "flex-col" : ""), $ = m(() => t.breakpoint !== "mobile"), S = m(() => t.breakpoint !== "desktop"), T = {
      auto: "flex-col gap-(--spacing-5) w-fit sm:w-auto sm:flex-row sm:items-center sm:gap-(--spacing-5) sm:overflow-x-auto",
      mobile: "flex-col gap-(--spacing-5) w-fit",
      desktop: "flex-row items-center gap-(--spacing-5) overflow-x-auto"
    }, I = {
      auto: "sm:w-36",
      mobile: "",
      desktop: "w-36"
    }, A = {
      upcoming: "text-(--text-text-body)",
      active: "text-(--text-text-accent)",
      completed: "text-(--text-text-body)",
      error: "text-(--text-text-body)",
      disabled: "text-(--text-text-disabled-light)"
    }, E = {
      upcoming: "bg-(--background-background-white) border border-(--border-border-base-soft)",
      active: "bg-(--background-background-white) stepper-navigation-gradient-border",
      completed: "bg-(--background-background-white) border border-(--border-border-success-strong)",
      error: "bg-(--background-background-white) border border-(--border-border-error-strong)",
      disabled: "bg-(--background-background-white) border border-(--border-border-disabled-subtle)"
    }, D = {
      upcoming: "text-(--text-text-body)",
      active: "text-(--text-text-accent)",
      completed: "text-(--text-text-success)",
      error: "text-(--text-text-error-strong)",
      disabled: "text-(--text-text-disabled-light)"
    }, z = {
      upcoming: "text-(--text-text-black-default)",
      active: "text-(--text-text-accent)",
      completed: "text-(--text-text-body)",
      error: "text-(--text-text-body)",
      disabled: "text-(--text-text-disabled-light)"
    }, Y = {
      auto: "h-14 sm:h-10",
      mobile: "h-14",
      desktop: "h-10"
    }, le = {
      auto: "top-9 sm:top-11",
      mobile: "top-9",
      desktop: "top-11"
    }, ne = {
      upcoming: "bg-(--background-background-white-secondary-soft) border-(--border-border-base-soft)",
      active: "bg-(--background-background-white) stepper-navigation-gradient-border",
      completed: "bg-(--background-background-success) border-(--border-border-success)",
      error: "bg-(--background-background-error) border-(--border-border-error-strong)",
      disabled: "bg-(--background-background-white-secondary-soft) border-(--border-border-base-soft)"
    }, re = {
      upcoming: "text-(--text-text-body)",
      active: "text-(--text-text-accent)",
      completed: "text-(--text-text-success)",
      error: "text-(--text-text-error-strong)",
      disabled: "text-(--text-text-body)"
    }, O = {
      active: "ri-arrow-right-line",
      completed: "ri-check-line",
      error: "ri-close-line"
    };
    return (P, V) => e.type === "default" || e.type === "defaultVertical" ? (c(), g("div", {
      key: 0,
      role: "list",
      class: C(["stepper-navigation-scroll flex items-center overflow-x-auto", p[e.breakpoint]])
    }, [
      (c(!0), g(de, null, Re(e.steps, (M, B) => (c(), g(de, {
        key: M.id
      }, [
        v("span", {
          role: "listitem",
          "aria-label": o(M, B, e.steps.length),
          class: "contents"
        }, [
          (c(), W(it(r(M.state) ? "button" : "span"), Fe({ ref_for: !0 }, s(M, B), {
            class: [
              "flex items-center shrink-0",
              k.value,
              x[e.breakpoint],
              d(M.state)
            ]
          }), {
            default: ve(() => [
              te(Gt, Fe({
                type: "circle",
                size: "sm"
              }, { ref_for: !0 }, b(M, B)), null, 16),
              v("span", {
                "aria-hidden": "true",
                class: C([
                  "font-(--weight-medium) whitespace-nowrap",
                  y[e.breakpoint],
                  A[M.state]
                ])
              }, j(M.label), 3)
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, Ij),
        B < e.steps.length - 1 && $.value ? (c(), g("span", {
          key: 0,
          "aria-hidden": "true",
          class: C([
            e.breakpoint === "auto" ? "hidden sm:block" : "",
            "flex-1 border-t border-(--border-border-base-soft)"
          ])
        }, null, 2)) : w("", !0),
        B < e.steps.length - 1 && S.value ? (c(), g("span", {
          key: 1,
          "aria-hidden": "true",
          class: C([
            e.breakpoint === "auto" ? "sm:hidden" : "",
            "flex h-4 w-[3.5px] shrink-0 items-center justify-center"
          ])
        }, [...V[0] || (V[0] = [
          v("span", { class: "h-4 w-px rotate-[10.98deg] skew-x-[1.87deg] bg-(--border-border-base-soft)" }, null, -1)
        ])], 2)) : w("", !0)
      ], 64))), 128))
    ], 2)) : e.type === "onlyIcons" ? (c(), g("div", Lj, [
      (c(!0), g(de, null, Re(e.steps, (M, B) => (c(), g(de, {
        key: M.id
      }, [
        v("span", {
          role: "listitem",
          "aria-label": o(M, B, e.steps.length),
          class: "contents"
        }, [
          (c(), W(it(r(M.state) ? "button" : "span"), Fe({ ref_for: !0 }, s(M, B), {
            class: ["flex items-center shrink-0", d(M.state)]
          }), {
            default: ve(() => [
              te(Gt, Fe({
                type: "circle",
                size: "md"
              }, { ref_for: !0 }, h(M, B)), null, 16)
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, Tj),
        B < e.steps.length - 1 ? (c(), g("span", Aj)) : w("", !0)
      ], 64))), 128))
    ])) : e.type === "withDots" ? (c(), g("div", Ej, [
      v("div", Rj, [
        v("span", {
          "aria-hidden": "true",
          class: C([
            "absolute inset-x-0 h-0 border-t-(length:--border-border-width-border-base) border-(--border-border-base-soft)",
            le[e.breakpoint]
          ])
        }, null, 2),
        (c(!0), g(de, null, Re(e.steps, (M, B) => (c(), g("span", {
          key: M.id,
          role: "listitem",
          "aria-label": o(M, B, e.steps.length),
          class: "contents"
        }, [
          (c(), W(it(r(M.state) ? "button" : "span"), Fe({ ref_for: !0 }, s(M, B), {
            class: [
              "relative flex flex-col items-center gap-(--spacing-3)",
              d(M.state)
            ]
          }), {
            default: ve(() => [
              v("span", {
                "aria-hidden": "true",
                class: C([
                  "font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl) whitespace-nowrap",
                  D[M.state]
                ])
              }, j(M.label), 3),
              v("span", {
                "aria-hidden": "true",
                class: C(["h-4 w-4 rounded-full", E[M.state]])
              }, null, 2)
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, Bj))), 128))
      ])
    ])) : e.type === "iconsAndText" ? (c(), g("div", {
      key: 3,
      role: "list",
      class: C(["stepper-navigation-scroll flex", T[e.breakpoint]])
    }, [
      (c(!0), g(de, null, Re(e.steps, (M, B) => (c(), g(de, {
        key: M.id
      }, [
        v("span", {
          role: "listitem",
          "aria-label": o(M, B, e.steps.length),
          class: "contents"
        }, [
          (c(), W(it(r(M.state) ? "button" : "span"), Fe({ ref_for: !0 }, s(M, B), {
            class: [
              "flex items-center gap-(--spacing-3) text-left shrink-0",
              B === 0 ? "" : I[e.breakpoint],
              d(M.state)
            ]
          }), {
            default: ve(() => [
              v("span", {
                class: C(e.breakpoint === "auto" ? "hidden sm:contents" : "contents")
              }, [
                $.value ? (c(), W(Gt, Fe({
                  key: 0,
                  type: "circle",
                  size: "sm"
                }, { ref_for: !0 }, h(M, B)), null, 16)) : w("", !0)
              ], 2),
              v("span", {
                class: C(e.breakpoint === "auto" ? "contents sm:hidden" : "contents")
              }, [
                S.value ? (c(), W(Gt, Fe({
                  key: 0,
                  type: "circle",
                  size: "md"
                }, { ref_for: !0 }, h(M, B)), null, 16)) : w("", !0)
              ], 2),
              v("span", Dj, [
                v("span", {
                  "aria-hidden": "true",
                  class: C([
                    "font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl) whitespace-nowrap",
                    A[M.state]
                  ])
                }, j(M.label), 3),
                M.helperText ? (c(), g("span", zj, j(M.helperText), 1)) : w("", !0)
              ])
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, Mj),
        B < e.steps.length - 1 && $.value ? (c(), g("span", {
          key: 0,
          "aria-hidden": "true",
          class: C([
            e.breakpoint === "auto" ? "hidden sm:block" : "",
            "flex-1 border-t-(length:--border-border-width-border-base) border-(--border-border-base-soft)"
          ])
        }, null, 2)) : w("", !0),
        B < e.steps.length - 1 && S.value ? (c(), g("span", {
          key: 1,
          "aria-hidden": "true",
          class: C([
            e.breakpoint === "auto" ? "block sm:hidden" : "",
            "self-center h-6 w-(--border-border-width-border-base) bg-(--border-border-base-soft)"
          ])
        }, null, 2)) : w("", !0)
      ], 64))), 128))
    ], 2)) : e.type === "vertical" ? (c(), g("div", Oj, [
      (c(!0), g(de, null, Re(e.steps, (M, B) => (c(), g(de, {
        key: M.id
      }, [
        v("span", {
          role: "listitem",
          "aria-label": o(M, B, e.steps.length),
          class: "contents"
        }, [
          (c(), W(it(r(M.state) ? "button" : "span"), Fe({ ref_for: !0 }, s(M, B), {
            class: ["flex items-center justify-between w-full text-left", d(M.state)]
          }), {
            default: ve(() => [
              v("span", Fj, [
                te(Gt, Fe({
                  type: "circle",
                  size: "md"
                }, { ref_for: !0 }, b(M, B)), null, 16),
                v("span", Vj, [
                  v("span", {
                    "aria-hidden": "true",
                    class: C([
                      "font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl) whitespace-nowrap",
                      z[M.state]
                    ])
                  }, j(M.label), 3),
                  M.helperText ? (c(), g("span", Nj, j(M.helperText), 1)) : w("", !0)
                ])
              ]),
              $.value ? (c(), g("i", {
                key: 0,
                "aria-hidden": "true",
                class: C([e.breakpoint === "auto" ? "hidden sm:block" : "", "ri-arrow-right-s-line text-base shrink-0"])
              }, null, 2)) : w("", !0)
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, Pj),
        B < e.steps.length - 1 ? (c(), g("span", {
          key: 0,
          "aria-hidden": "true",
          class: C(["ml-[17.5px] w-px bg-(--border-border-base-soft)", Y[e.breakpoint]])
        }, null, 2)) : w("", !0)
      ], 64))), 128))
    ])) : e.type === "cards" ? (c(), g("div", Hj, [
      (c(!0), g(de, null, Re(e.steps, (M, B) => (c(), g("span", {
        key: M.id,
        role: "listitem",
        "aria-label": o(M, B, e.steps.length),
        class: "contents"
      }, [
        (c(), W(it(r(M.state) ? "button" : "span"), Fe({ ref_for: !0 }, s(M, B), {
          class: [
            "flex items-center gap-(--spacing-2) w-full min-w-40 p-(--spacing-4) rounded-(--border-border-radius-rounded-l) border border-solid text-left",
            ne[M.state],
            re[M.state],
            d(M.state)
          ]
        }), {
          default: ve(() => [
            v("span", Wj, j(B + 1), 1),
            v("span", qj, j(M.label), 1),
            O[M.state] ? (c(), g("i", {
              key: 0,
              "aria-hidden": "true",
              class: C([O[M.state], "text-xl leading-none shrink-0"])
            }, null, 2)) : w("", !0)
          ]),
          _: 2
        }, 1040, ["class"]))
      ], 8, jj))), 128))
    ])) : w("", !0);
  }
}), IU = /* @__PURE__ */ dt(Uj, [["__scopeId", "data-v-4839e094"]]);
function px(e) {
  return "conditions" in e;
}
function Xc(e) {
  return e.kind === "group";
}
const Gj = /* @__PURE__ */ new Set(["isNull", "isNotNull"]), Kj = /* @__PURE__ */ new Set(["in", "notIn", "between"]);
function so(e) {
  return Gj.has(e);
}
function Zc(e) {
  return Kj.has(e);
}
function Yj(e) {
  return !e.field || !e.op ? !1 : so(e.op) ? !0 : Zc(e.op) ? e.op === "between" ? e.values.length === 2 && e.values.every((n) => n !== "") : e.values.length > 0 : e.value !== null && e.value !== "";
}
function Ko(e) {
  return vx(e);
}
function vx(e) {
  const n = [];
  for (const t of e.children)
    if (Xc(t)) {
      const a = vx(t);
      a.conditions.length > 0 && n.push(a);
    } else Yj(t) && n.push(Jj(t));
  return { operator: e.operator, conditions: n };
}
function Jj(e) {
  const n = {
    field: e.field,
    op: e.op
  };
  return so(e.op) || (Zc(e.op) ? n.values = [...e.values] : n.value = e.value), n;
}
function Hb(e, n) {
  return px(e) ? {
    _id: n(),
    kind: "group",
    operator: e.operator,
    children: e.conditions.map((t) => Tu(t, n))
  } : {
    _id: n(),
    kind: "group",
    operator: "and",
    children: [Tu(e, n)]
  };
}
function Tu(e, n) {
  return px(e) ? {
    _id: n(),
    kind: "group",
    operator: e.operator,
    children: e.conditions.map((t) => Tu(t, n))
  } : {
    _id: n(),
    kind: "criterion",
    field: e.field,
    op: e.op,
    value: e.value ?? null,
    values: e.values ? [...e.values] : []
  };
}
const Xj = /* @__PURE__ */ new Set(["lastNDays", "nextNDays"]);
function Zj(e) {
  return e.field === null && e.op === null;
}
function Qj(e, n) {
  if (e === "DateTime") {
    const l = Date.parse(String(n[0])), r = Date.parse(String(n[1]));
    return Number.isNaN(l) || Number.isNaN(r) ? null : [l, r];
  }
  const t = Number(n[0]), a = Number(n[1]);
  return Number.isNaN(t) || Number.isNaN(a) ? null : [t, a];
}
function _j(e, n) {
  if (Zj(e))
    return [];
  const t = e.field ? n.find((l) => l.path === e.field) : void 0;
  if (e.field && !t)
    return ["fieldOrphan"];
  if (!e.field || !e.op || !t)
    return ["valueRequired"];
  const a = [];
  if (t.operators.includes(e.op) || a.push("operatorIllegal"), so(e.op))
    return a;
  if (Xj.has(e.op)) {
    const l = Number(e.value);
    return (e.value === null || e.value === "" || !Number.isInteger(l) || l < 1) && a.push("daysInvalid"), a;
  }
  if (e.op === "between") {
    if (e.values.length !== 2 || e.values.some((r) => r === ""))
      return a.push("valueRequired"), a;
    const l = Qj(t.type, e.values);
    return (l === null || l[0] > l[1]) && a.push("rangeInvalid"), a;
  }
  return Zc(e.op) ? (e.values.length === 0 && a.push("valueRequired"), a) : e.value === null || e.value === "" ? (a.push("valueRequired"), a) : (t.type === "Number" || t.type === "Decimal" ? (typeof e.value != "number" || Number.isNaN(e.value)) && a.push("valueInvalid") : t.type === "DateTime" && Number.isNaN(Date.parse(String(e.value))) && a.push("valueInvalid"), a);
}
function jb(e, n) {
  const t = /* @__PURE__ */ new Map(), a = (l) => {
    for (const r of l.children)
      if (Xc(r))
        a(r);
      else {
        const o = _j(r, n);
        o.length > 0 && t.set(r._id, o);
      }
  };
  return a(e), t;
}
let Wb = 0;
function Ol() {
  return Wb += 1, `afb-${Wb}`;
}
function qb() {
  return { _id: Ol(), kind: "group", operator: "and", children: [] };
}
function Ub() {
  return { _id: Ol(), kind: "criterion", field: null, op: null, value: null, values: [] };
}
function Yo(e) {
  const n = (t) => t.kind === "group" ? {
    _id: t._id,
    kind: "group",
    operator: t.operator,
    children: t.children.map(n)
  } : {
    _id: t._id,
    kind: "criterion",
    field: t.field,
    op: t.op,
    value: t.value,
    values: [...t.values]
  };
  return n(e);
}
function xx(e, n) {
  if (e.kind !== n.kind)
    return !1;
  if (e.kind === "group" && n.kind === "group")
    return e.operator === n.operator && e.children.length === n.children.length && e.children.every((l, r) => xx(l, n.children[r]));
  const t = e, a = n;
  return t.field === a.field && t.op === a.op && t.value === a.value && t.values.length === a.values.length && t.values.every((l, r) => l === a.values[r]);
}
function eW(e, n) {
  const t = R(e ? Hb(e, Ol) : qb()), a = R(Yo(t.value)), l = R(/* @__PURE__ */ new Map()), r = m(() => l.value.size > 0), o = m(() => Pt(n) ?? []), i = m(
    () => jb(t.value, o.value).size === 0
  ), s = m(
    () => !xx(t.value, a.value)
  );
  function d(A) {
    A.children.push(Ub());
  }
  function u(A) {
    A.children.push({ _id: Ol(), kind: "group", operator: "and", children: [Ub()] });
  }
  function f(A) {
    const E = [A._id];
    if (A.kind === "group")
      for (const D of A.children)
        E.push(...f(D));
    return E;
  }
  function b(A, E) {
    const D = A.children.find((Y) => Y._id === E), z = D ? f(D) : [E];
    A.children = A.children.filter((Y) => Y._id !== E);
    for (const Y of z)
      $(Y);
  }
  function h(A, E) {
    A.operator = E;
  }
  function p(A) {
    return A.children.length >= 2;
  }
  function x(A) {
    const E = (D, z) => {
      if (D._id === A._id)
        return z;
      if (D.kind === "group")
        for (const Y of D.children) {
          const le = E(Y, z + 1);
          if (le !== null)
            return le;
        }
      return null;
    };
    return E(t.value, 1) ?? 1;
  }
  function y(A, E) {
    return x(A) < E;
  }
  function k(A) {
    return l.value = jb(t.value, A), l.value.size === 0;
  }
  function $(A) {
    if (l.value.has(A)) {
      const E = new Map(l.value);
      E.delete(A), l.value = E;
    }
  }
  function S() {
    a.value = Yo(t.value);
  }
  function T() {
    t.value = Yo(a.value), l.value = /* @__PURE__ */ new Map();
  }
  function I(A) {
    t.value = A ? Hb(A, Ol) : qb(), a.value = Yo(t.value), l.value = /* @__PURE__ */ new Map();
  }
  return {
    root: t,
    addCriterion: d,
    addGroup: u,
    removeNode: b,
    setConjunction: h,
    showConjunction: p,
    depthOf: x,
    canNest: y,
    snapshot: S,
    reset: T,
    reseed: I,
    newId: Ol,
    errors: l,
    hasErrors: r,
    isValidLive: i,
    isDirty: s,
    validate: k,
    clearNodeErrors: $
  };
}
function yx(e) {
  const n = eW(e.modelValue(), e.fields);
  function t() {
    n.root.value.children.length === 0 && (n.addCriterion(n.root.value), n.snapshot());
  }
  t(), ct(() => {
    n.snapshot();
  });
  function a(u) {
    n.reseed(u), t();
  }
  $e(
    n.root,
    () => {
      e.emitUpdate(Ko(n.root.value));
    },
    { deep: !0 }
  );
  const l = m(
    () => Ko(n.root.value).conditions.length > 0
  ), r = m(
    () => !e.busy() && l.value && n.isValidLive.value
  ), o = m(() => r.value || e.busy() ? null : l.value ? e.labels().saveDisabledInvalid ?? null : e.labels().saveDisabledEmpty ?? null);
  function i() {
    e.busy() || n.validate(e.fields()) && e.emitApply(Ko(n.root.value));
  }
  function s() {
    e.busy() || (n.reset(), e.emitReset());
  }
  function d() {
    r.value && e.emitSave(Ko(n.root.value));
  }
  return {
    builder: n,
    hasCompleteCriterion: l,
    canSave: r,
    saveDisabledReason: o,
    onApply: i,
    onReset: s,
    onSave: d,
    reseedFrom: a
  };
}
const kx = '[data-testid="filter-field-select-panel"]', tW = ["disabled", "aria-expanded"], nW = {
  key: 0,
  "data-testid": "filter-field-select-trigger-label",
  class: "sr-only"
}, aW = { class: "flex min-w-0 flex-1" }, lW = {
  key: 0,
  class: "flex min-h-4.5 items-center gap-1 text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-error-strong) dark:text-(--text-text-error)",
  role: "alert"
}, rW = ["aria-label"], oW = /* @__PURE__ */ ye({
  __name: "FilterFieldSelect",
  props: {
    fields: {},
    groups: { default: () => [] },
    modelValue: { default: "" },
    placeholder: {},
    searchPlaceholder: {},
    searchClearLabel: { default: "Clear search" },
    groupsLabel: {},
    noResultsLabel: {},
    resultsCountLabel: {},
    noFieldsLabel: {},
    emptyGroupLabel: {},
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !1 },
    error: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R(null), r = R(null), o = R(""), i = R(""), { isOpen: s, dropdownRef: d, toggleDropdown: u, closeDropdown: f } = ar({
      onClose: b,
      // The panel is teleported to <body>, so every click inside it reads as an
      // "outside" click to useDropdown unless it is explicitly ignored. The selector is
      // shared with the consumers that must ignore it too.
      ignoreSelectors: [kx]
    });
    function b() {
      o.value = "", i.value = "";
    }
    const h = R({}), p = 4, x = 8, y = 540, k = 240;
    function $() {
      var ee;
      const K = (ee = l.value) == null ? void 0 : ee.getBoundingClientRect();
      if (!K) return;
      const ge = typeof window < "u" ? window.innerWidth : K.right, xe = typeof window < "u" ? window.innerHeight : K.bottom, he = K.left + K.width / 2 > ge / 2 ? { right: `${ge - K.right}px` } : { left: `${K.left}px` }, oe = xe - K.bottom - p - x, Ce = K.top - p - x, H = oe < k && Ce > oe, Z = H ? { bottom: `${xe - K.top + p}px` } : { top: `${K.bottom + p}px` };
      h.value = {
        position: "fixed",
        ...he,
        ...Z,
        maxHeight: `${Math.min(y, Math.max(H ? Ce : oe, 0))}px`,
        zIndex: "350"
      };
    }
    function S() {
      typeof window > "u" || (window.addEventListener("scroll", $, !0), window.addEventListener("resize", $));
    }
    function T() {
      typeof window > "u" || (window.removeEventListener("scroll", $, !0), window.removeEventListener("resize", $));
    }
    $e(s, (K) => {
      K ? Ge(() => {
        var ge;
        $(), S(), (ge = r.value) == null || ge.focusSearch();
      }) : T();
    }), yt(T);
    const I = m(
      () => t.modelValue ? t.fields.find((K) => K.path === t.modelValue) ?? null : null
    ), A = m(
      () => t.fields.map((K) => ({ key: K.path, label: K.label, icon: K.icon, group: K.group }))
    );
    function E() {
      var ge, xe;
      const K = (ge = I.value) == null ? void 0 : ge.group;
      return K && t.groups.some((X) => X.value === K) ? K : ((xe = t.groups[0]) == null ? void 0 : xe.value) ?? "";
    }
    function D() {
      o.value = "", i.value = E(), u();
    }
    function z() {
      if (!t.disabled) {
        if (s.value) {
          f();
          return;
        }
        D();
      }
    }
    const Y = R(null), le = R(!1), ne = R(!1), re = m(() => ne.value || s.value ? !1 : le.value ? !0 : void 0);
    function O(K) {
      try {
        le.value = K.target.matches(":focus-visible");
      } catch {
        le.value = !0;
      }
    }
    function P() {
      le.value = !1, ne.value = !1;
    }
    function V(K) {
      var ge;
      if (K.key === "Escape" && !s.value && !ne.value && le.value && ((ge = Y.value) != null && ge.isTruncated)) {
        K.stopPropagation(), K.preventDefault(), ne.value = !0;
        return;
      }
      t.disabled || s.value || K.key !== "ArrowDown" && K.key !== "ArrowUp" || (K.preventDefault(), D());
    }
    function M(K) {
      a("update:modelValue", K), f(), Ge(() => {
        var ge;
        return (ge = l.value) == null ? void 0 : ge.focus();
      });
    }
    function B(K) {
      s.value && (K.stopPropagation(), K.preventDefault(), f(), Ge(() => {
        var ge;
        return (ge = l.value) == null ? void 0 : ge.focus();
      }));
    }
    const q = {
      sm: {
        container: "h-[32px] px-[calc(--spacing(2)-1px)] gap-2",
        text: "text-(length:--size-m) leading-(--line-height-l)",
        icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)"
      },
      md: {
        container: "h-[36px] px-[calc(--spacing(3)-1px)] gap-2",
        text: "text-(length:--size-m) leading-(--line-height-l)",
        icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)"
      },
      lg: {
        container: "h-[48px] px-[calc(--spacing(3.5)-1px)] gap-2",
        text: "text-(length:--size-l) leading-(--line-height-xxl)",
        icon: "text-(length:--icon-size-md) leading-(--icon-size-md)"
      },
      xl: {
        container: "h-[52px] px-[calc(--spacing(4)-1px)] gap-2",
        text: "text-(length:--size-l) leading-(--line-height-xxl)",
        icon: "text-(length:--icon-size-md) leading-(--icon-size-md)"
      }
    }, N = m(() => q[t.size]), G = m(() => !!t.error), U = m(() => {
      const K = "relative flex min-w-0 items-center w-full rounded-(--border-border-radius-rounded-l) border border-solid box-border text-left font-inter transition-colors select-none focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)";
      return t.disabled ? `${K} cursor-not-allowed bg-gainsboro-200 border-border-disabled-subtle text-text-disabled dark:bg-(--colors-background-disabled) dark:border-(--colors-border-disabled-subtle) dark:text-(--colors-text-disabled)` : G.value ? `${K} cursor-pointer bg-white border-(--border-border-error-strong) text-text-black-default dark:bg-(--colors-background-black-default) dark:border-(--border-border-error) dark:text-(--colors-text-white-default)` : s.value ? `${K} cursor-pointer bg-(--background-background-selected) border-(--border-border-accent) shadow-[0px_0px_2px_var(--border-border-accent)] text-text-black-default dark:bg-(--colors-background-black-default) dark:text-(--colors-text-white-default)` : `${K} cursor-pointer bg-(--background-background-white) border-(--border-border-base-medium) hover:border-(--border-border-accent) text-text-black-default dark:bg-(--colors-background-black-default) dark:border-(--colors-border-base) dark:text-(--colors-text-white-default)`;
    });
    return (K, ge) => {
      var xe;
      return c(), g("div", {
        ref_key: "dropdownRef",
        ref: d,
        class: C(["relative min-w-0 text-left", e.fullWidth ? "w-full" : "inline-block max-w-full"]),
        onKeydown: ht(B, ["escape"])
      }, [
        v("button", {
          ref_key: "triggerRef",
          ref: l,
          type: "button",
          "data-testid": "filter-field-select-trigger",
          class: C([U.value, N.value.container]),
          disabled: e.disabled,
          "aria-expanded": L(s),
          "aria-haspopup": "dialog",
          onClick: z,
          onKeydown: V,
          onFocus: O,
          onBlur: P
        }, [
          I.value ? (c(), g("span", nW, j(e.placeholder), 1)) : w("", !0),
          v("span", aW, [
            te(pt, {
              ref_key: "labelRef",
              ref: Y,
              text: ((xe = I.value) == null ? void 0 : xe.label) ?? e.placeholder,
              focusable: !1,
              open: re.value,
              "text-class": [
                N.value.text,
                e.disabled ? "" : I.value ? "text-text-black-default dark:text-(--colors-text-white-default)" : "text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
              ].join(" ")
            }, null, 8, ["text", "open", "text-class"])
          ]),
          v("i", {
            class: C(["ri-arrow-down-s-line shrink-0 transition-transform duration-200 ease-in-out", [
              N.value.icon,
              e.disabled ? "text-text-disabled" : "text-(--text-text-body-subtle)",
              L(s) ? "rotate-180" : "rotate-0"
            ]]),
            "aria-hidden": "true"
          }, null, 2)
        ], 42, tW),
        e.error ? (c(), g("p", lW, [
          ge[2] || (ge[2] = v("i", {
            class: "ri-error-warning-fill",
            "aria-hidden": "true"
          }, null, -1)),
          v("span", null, j(e.error), 1)
        ])) : w("", !0),
        (c(), W(Nn, { to: "body" }, [
          te(At, {
            "enter-active-class": "transition duration-100 ease-out motion-reduce:transition-none",
            "enter-from-class": "transform scale-95 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100",
            "leave-active-class": "transition duration-75 ease-out motion-reduce:transition-none",
            "leave-from-class": "transform scale-100 opacity-100",
            "leave-to-class": "transform scale-95 opacity-0"
          }, {
            default: ve(() => [
              L(s) ? (c(), g("div", {
                key: 0,
                role: "dialog",
                "aria-label": e.placeholder,
                "data-testid": "filter-field-select-panel",
                "data-focus-trap-allow-outside": "",
                style: je([{ width: L(_u).l }, h.value]),
                class: C(["flex max-w-[calc(100vw-2rem)] flex-col overflow-hidden", L(Za)]),
                onKeydown: ht(B, ["escape"])
              }, [
                te(ox, {
                  ref_key: "pickerRef",
                  ref: r,
                  "active-group": i.value,
                  "onUpdate:activeGroup": ge[0] || (ge[0] = (X) => i.value = X),
                  "search-query": o.value,
                  "onUpdate:searchQuery": ge[1] || (ge[1] = (X) => o.value = X),
                  fields: A.value,
                  groups: e.groups,
                  "strict-groups": "",
                  "groups-label": e.groupsLabel,
                  "search-placeholder": e.searchPlaceholder,
                  "search-clear-label": e.searchClearLabel,
                  "list-label": e.searchPlaceholder,
                  "selected-key": e.modelValue || void 0,
                  "no-results-label": e.noResultsLabel,
                  "results-count-label": e.resultsCountLabel,
                  "no-fields-label": e.noFieldsLabel,
                  "empty-group-label": e.emptyGroupLabel,
                  onSelect: M
                }, null, 8, ["active-group", "search-query", "fields", "groups", "groups-label", "search-placeholder", "search-clear-label", "list-label", "selected-key", "no-results-label", "results-count-label", "no-fields-label", "empty-group-label"])
              ], 46, rW)) : w("", !0)
            ]),
            _: 1
          })
        ]))
      ], 34);
    };
  }
});
function wx(e, n, t, a) {
  return [...new Set(e)].filter((l) => _i(l, n) === l && !n.some((r) => r.value === l)).map((l) => ({ value: l, label: iW(l, t, a) }));
}
function _i(e, n) {
  var a;
  if (n.some((l) => l.value === e)) return e;
  const t = e.toLowerCase();
  return ((a = n.find((l) => l.value.toLowerCase() === t)) == null ? void 0 : a.value) ?? e;
}
function iW(e, n, t) {
  if (!n) return t.valueUnknown;
  const a = n.labelOf(e);
  return a === void 0 ? t.valueLoading : a ?? t.valueUnknown;
}
const sW = /* @__PURE__ */ ye({
  __name: "CriterionValueChoice",
  props: {
    kind: {},
    criterion: {},
    field: {},
    labels: {}
  },
  emits: ["update:values", "update:value"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R([]), r = R(), o = R(!1), i = Ha(/* @__PURE__ */ new Map());
    let s = 0, d = !1;
    async function u(k) {
      const $ = t.field.optionSource;
      if (!$) return;
      d = !0;
      const S = ++s;
      o.value = !0;
      try {
        const T = await $.search(k);
        if (S !== s) return;
        for (const I of T.options) i.set(I.value, I.label);
        l.value = T.options, r.value = T.totalCount;
      } catch {
        if (S !== s) return;
        k === "" && (d = !1), l.value = [], r.value = 0;
      } finally {
        S === s && (o.value = !1);
      }
    }
    function f() {
      d || u("");
    }
    const b = m(() => {
      const k = t.criterion;
      return t.kind === "multiSelect" ? k.values.map(String) : k.value === null || k.value === "" ? [] : [String(k.value)];
    }), h = m(() => {
      const k = t.field.optionSource, $ = k ? l.value : t.field.options ?? [], S = [...i].map(([A, E]) => ({ value: A, label: E })), T = [...new Set(b.value)].map((A) => _i(A, S)).filter((A) => i.has(A) && !$.some((E) => E.value.toLowerCase() === A.toLowerCase())).map((A) => ({ value: A, label: i.get(A) })), I = [...$, ...T];
      return [...I, ...wx(b.value, I, k, t.labels)];
    }), p = m(() => [...new Set(b.value.map((k) => _i(k, h.value)))]), x = m(() => h.value.map((k) => ({ id: k.value, label: k.label }))), y = m(() => {
      const k = r.value;
      if (!(!t.field.optionSource || o.value || k === void 0 || k <= l.value.length))
        return as(t.labels.valueMoreResults, k);
    });
    return (k, $) => e.kind === "multiSelect" ? (c(), W(Eg, {
      key: 0,
      "model-value": p.value,
      options: x.value,
      async: !!e.field.optionSource,
      loading: o.value,
      "loading-label": e.labels.valueLoading,
      "total-count": e.field.optionSource ? r.value : void 0,
      "footer-label": y.value,
      placeholder: e.labels.valuePlaceholder,
      "aria-label": e.labels.valuePlaceholder,
      "confirm-label": e.labels.valueConfirm,
      "search-placeholder": e.labels.valueSearchPlaceholder,
      "search-clear-label": e.labels.valueSearchClear,
      "select-all-label": e.labels.valueSelectAll,
      "clear-all-label": e.labels.valueClearAll,
      "remove-chip-label": e.labels.valueRemoveChip,
      "empty-label": e.labels.valueEmpty,
      "show-select-all": !e.field.optionSource,
      "freeze-on-open": "",
      onFocusin: f,
      onSearch: u,
      "onUpdate:modelValue": $[0] || ($[0] = (S) => a("update:values", S))
    }, null, 8, ["model-value", "options", "async", "loading", "loading-label", "total-count", "footer-label", "placeholder", "aria-label", "confirm-label", "search-placeholder", "search-clear-label", "select-all-label", "clear-all-label", "remove-chip-label", "empty-label", "show-select-all"])) : (c(), W(Wv, {
      key: 1,
      "model-value": p.value[0] ?? "",
      options: h.value,
      loading: o.value,
      placeholder: e.labels.valuePlaceholder,
      "aria-label": e.labels.valuePlaceholder,
      "empty-label": e.labels.valueNoResults,
      "results-count-label": e.labels.valueResultsCount,
      "clear-label": e.labels.valueSearchClear,
      "results-label": e.labels.valueResultsLabel,
      "icon-left": "",
      onSearch: u,
      "onUpdate:modelValue": $[1] || ($[1] = (S) => a("update:value", S))
    }, null, 8, ["model-value", "options", "loading", "placeholder", "aria-label", "empty-label", "results-count-label", "clear-label", "results-label"]));
  }
}), dW = ["aria-label"], uW = { class: "flex flex-wrap items-start gap-3 py-1" }, cW = { class: "w-[100px] shrink-0" }, fW = ["aria-label"], hW = {
  key: 1,
  class: "flex h-[36px] w-full items-center rounded-xl border border-solid border-(--colors-border-base-medium) bg-(--background-background-white) px-2.5 text-sm font-medium text-(--colors-text-body) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:text-(--colors-text-white-default)",
  "aria-hidden": "true"
}, bW = { class: "min-w-0 flex-1" }, gW = {
  key: 6,
  class: "flex items-start gap-2"
}, mW = {
  "data-testid": "afb-days-suffix",
  class: "flex h-9 shrink-0 items-center text-sm text-(--colors-text-body)"
}, pW = ["data-testid"], vW = { class: "flex items-start gap-3" }, xW = { class: "flex flex-wrap items-center gap-3 pt-1" }, yW = /* @__PURE__ */ ye({
  __name: "CriteriaGroup",
  props: {
    group: {},
    fields: {},
    labels: {},
    maxDepth: {},
    builder: {},
    depth: {},
    fieldGroups: {}
  },
  setup(e) {
    const n = e;
    function t(P) {
      return P ? n.fields.find((V) => V.path === P) : void 0;
    }
    function a(P, V) {
      const M = P.type === "DateTime" ? n.labels.dateOperatorLabels : P.type === "String" ? n.labels.stringOperatorLabels : P.type === "Enum" || P.type === "Guid" ? n.labels.listOperatorLabels : void 0;
      return (M == null ? void 0 : M[V]) ?? n.labels.operatorLabels[V] ?? V;
    }
    function l(P) {
      const V = t(P.field);
      return V ? V.operators.map((M) => ({
        value: M,
        label: a(V, M)
      })) : [];
    }
    function r(P, V) {
      if ((P === "in" || P === "notIn") && (V.options || V.optionSource)) return "multiSelect";
      if (!(P !== "eq" && P !== "neq"))
        return V.options ? "select" : V.optionSource ? "autocomplete" : void 0;
    }
    function o(P) {
      if (P.field && !t(P.field))
        return "orphan";
      if (!P.field || !P.op)
        return "placeholder";
      if (so(P.op))
        return "none";
      const V = t(P.field), M = r(P.op, V);
      if (M) return M;
      const B = V.type;
      return P.op === "lastNDays" || P.op === "nextNDays" ? "days" : P.op === "between" ? B === "DateTime" ? "dateRange" : "numberRange" : P.op === "in" || P.op === "notIn" ? "tags" : B === "Bool" ? "bool" : B === "Number" || B === "Decimal" ? "number" : B === "DateTime" ? "date" : "text";
    }
    function i(P) {
      const V = o(P);
      return V === "dateRange" || V === "numberRange" || V === "tags" || V === "multiSelect";
    }
    function s(P) {
      return P.value === null || P.value === "" ? [] : [String(P.value)];
    }
    function d(P) {
      const V = t(P.field);
      if (!V) return [];
      const M = V.options ?? [];
      return [...M, ...wx(s(P), M, void 0, n.labels)];
    }
    function u(P) {
      return _i(I(P), d(P));
    }
    function f(P) {
      const V = o(P);
      return V === "multiSelect" || V === "autocomplete" ? V : void 0;
    }
    const b = m(() => [
      { value: "and", label: n.labels.and },
      { value: "or", label: n.labels.or }
    ]);
    function h(P, V) {
      n.builder.clearNodeErrors(P._id), P.field = V || null, P.op = null, P.value = null, P.values = [];
    }
    function p(P) {
      return !P || so(P) ? "none" : P === "between" ? "between" : P === "in" || P === "notIn" ? "set" : P === "lastNDays" || P === "nextNDays" ? "days" : "scalar";
    }
    function x(P, V) {
      n.builder.clearNodeErrors(P._id);
      const M = P.op;
      P.op = V || null, p(P.op) !== p(M) && (P.value = null, P.values = []);
    }
    function y(P, V) {
      var B;
      n.builder.clearNodeErrors(P._id);
      const M = (B = t(P.field)) == null ? void 0 : B.type;
      if (M === "Number" || M === "Decimal") {
        P.value = V === "" ? null : Number(V);
        return;
      }
      P.value = V === "" ? null : V;
    }
    function k(P, V) {
      n.builder.clearNodeErrors(P._id), P.value = V === "" ? null : Number(V);
    }
    function $(P, V, M) {
      n.builder.clearNodeErrors(P._id);
      const B = [P.values[0] ?? "", P.values[1] ?? ""];
      B[V] = M === null ? "" : M, P.values = B;
    }
    function S(P, V) {
      var B;
      n.builder.clearNodeErrors(P._id);
      const M = (B = t(P.field)) == null ? void 0 : B.type;
      if (M === "Number" || M === "Decimal") {
        P.values = V.map(Number).filter((q) => Number.isFinite(q));
        return;
      }
      P.values = [...V];
    }
    function T(P, V) {
      n.builder.clearNodeErrors(P._id), P.value = V === "" ? null : V === "true";
    }
    function I(P) {
      return P.value === null || P.value === void 0 ? "" : String(P.value);
    }
    function A(P) {
      return Xc(P);
    }
    const E = {
      valueRequired: "errorValueRequired",
      valueInvalid: "errorValueInvalid",
      rangeInvalid: "errorRangeInvalid",
      daysInvalid: "errorDaysInvalid",
      operatorIllegal: "errorOperatorIllegal",
      fieldOrphan: "errorFieldOrphan"
    };
    function D(P) {
      const V = n.builder.errors.value.get(P._id);
      return V != null && V.length ? n.labels[E[V[0]]] : null;
    }
    function z() {
      n.builder.addCriterion(n.group);
    }
    function Y() {
      n.builder.addGroup(n.group);
    }
    function le(P) {
      n.builder.removeNode(n.group, P);
    }
    function ne(P) {
      n.builder.setConjunction(n.group, P);
    }
    const re = m(() => n.builder.canNest(n.group, n.maxDepth)), O = m(
      () => n.group.operator === "or" ? n.labels.or : n.labels.and
    );
    return (P, V) => {
      const M = Mx("CriteriaGroup", !0);
      return c(), g("div", {
        class: C([
          "flex flex-col gap-2",
          // The root level sits directly on the modal body (no card, per Figma);
          // only nested groups get a neutral-gray bordered card so they read as a
          // sub-scope. The lavender accent card was a divergence from the design.
          e.depth > 1 ? "rounded-xl border border-solid border-(--colors-border-base-soft) bg-(--colors-background-white-secondary) p-4 dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default)" : ""
        ]),
        role: "group",
        "aria-label": e.labels.title
      }, [
        (c(!0), g(de, null, Re(e.group.children, (B, q) => (c(), g(de, {
          key: B._id
        }, [
          v("div", uW, [
            v("div", cW, [
              q === 1 ? (c(), g("div", {
                key: 0,
                role: "group",
                "aria-label": `${e.labels.and} / ${e.labels.or}`
              }, [
                te(ll, {
                  "data-testid": "afb-conjunction",
                  "model-value": e.group.operator,
                  options: b.value,
                  placeholder: e.labels.and,
                  "aria-label": `${e.labels.and} / ${e.labels.or}`,
                  size: "sm",
                  "full-width": "",
                  "onUpdate:modelValue": ne
                }, null, 8, ["model-value", "options", "placeholder", "aria-label"])
              ], 8, fW)) : q >= 2 ? (c(), g("span", hW, j(O.value), 1)) : w("", !0)
            ]),
            A(B) ? (c(), g(de, { key: 0 }, [
              te(M, {
                class: "min-w-0 flex-1",
                group: B,
                fields: e.fields,
                labels: e.labels,
                "max-depth": e.maxDepth,
                builder: e.builder,
                depth: e.depth + 1,
                "field-groups": e.fieldGroups
              }, null, 8, ["group", "fields", "labels", "max-depth", "builder", "depth", "field-groups"]),
              te(Me, {
                "data-testid": `afb-remove-${q}`,
                variant: "text",
                "icon-only": "",
                "icon-left": "ri-delete-bin-6-line",
                size: "sm",
                "aria-label": e.labels.removeCriterion,
                class: "shrink-0 mt-1",
                onClick: (N) => le(B._id)
              }, null, 8, ["data-testid", "aria-label", "onClick"])
            ], 64)) : o(B) === "orphan" ? (c(), g(de, { key: 1 }, [
              v("div", bW, [
                te(Wt, {
                  "model-value": B.field ?? "",
                  disabled: "",
                  "full-width": "",
                  error: e.labels.errorFieldOrphan
                }, null, 8, ["model-value", "error"])
              ]),
              te(Me, {
                "data-testid": `afb-remove-${q}`,
                variant: "text",
                "icon-only": "",
                "icon-left": "ri-delete-bin-6-line",
                size: "sm",
                "aria-label": e.labels.removeCriterion,
                class: "shrink-0 mt-1",
                onClick: (N) => le(B._id)
              }, null, 8, ["data-testid", "aria-label", "onClick"])
            ], 64)) : (c(), g(de, { key: 2 }, [
              te(oW, {
                "data-testid": `afb-field-${q}`,
                class: "min-w-0 flex-1",
                "model-value": B.field ?? "",
                fields: e.fields,
                groups: e.fieldGroups,
                placeholder: e.labels.fieldPlaceholder,
                "search-placeholder": e.labels.fieldSearchPlaceholder,
                "search-clear-label": e.labels.fieldSearchClear,
                "groups-label": e.labels.fieldGroupsLabel,
                "no-results-label": e.labels.fieldNoResults,
                "results-count-label": e.labels.fieldResultsCount,
                "no-fields-label": e.labels.fieldNoFields,
                "empty-group-label": e.labels.fieldEmptyGroup,
                "full-width": "",
                "onUpdate:modelValue": (N) => h(B, N)
              }, null, 8, ["data-testid", "model-value", "fields", "groups", "placeholder", "search-placeholder", "search-clear-label", "groups-label", "no-results-label", "results-count-label", "no-fields-label", "empty-group-label", "onUpdate:modelValue"]),
              te(ll, {
                "data-testid": `afb-operator-${q}`,
                class: "min-w-0 flex-1",
                "model-value": B.op ?? "",
                options: l(B),
                placeholder: e.labels.operatorPlaceholder,
                "aria-label": e.labels.operatorPlaceholder,
                disabled: !B.field,
                "full-width": "",
                "onUpdate:modelValue": (N) => x(B, N)
              }, null, 8, ["data-testid", "model-value", "options", "placeholder", "aria-label", "disabled", "onUpdate:modelValue"]),
              v("div", {
                class: C(i(B) ? "order-last basis-full min-w-0 pl-[112px]" : "min-w-0 flex-1")
              }, [
                o(B) === "placeholder" ? (c(), W(Wt, {
                  key: 0,
                  "model-value": "",
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  disabled: "",
                  "full-width": ""
                }, null, 8, ["placeholder", "aria-label"])) : o(B) === "select" ? (c(), W(ll, {
                  key: 1,
                  "data-testid": `afb-value-${q}`,
                  "model-value": u(B),
                  options: d(B),
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  searchable: "",
                  "search-placeholder": e.labels.valueSearchPlaceholder,
                  "search-clear-label": e.labels.valueSearchClear,
                  "no-results-label": e.labels.valueNoResults,
                  "results-count-label": e.labels.valueResultsCount,
                  "full-width": "",
                  "onUpdate:modelValue": (N) => y(B, N)
                }, null, 8, ["data-testid", "model-value", "options", "placeholder", "aria-label", "search-placeholder", "search-clear-label", "no-results-label", "results-count-label", "onUpdate:modelValue"])) : f(B) ? (c(), W(sW, {
                  key: `${B.field}:${f(B)}`,
                  "data-testid": `afb-value-${q}`,
                  kind: f(B),
                  criterion: B,
                  field: t(B.field),
                  labels: e.labels,
                  "onUpdate:values": (N) => S(B, N),
                  "onUpdate:value": (N) => y(B, N)
                }, null, 8, ["data-testid", "kind", "criterion", "field", "labels", "onUpdate:values", "onUpdate:value"])) : o(B) === "bool" ? (c(), W(ll, {
                  key: 3,
                  "data-testid": `afb-value-${q}`,
                  "model-value": B.value === null ? "" : String(B.value),
                  options: [
                    { value: "true", label: e.labels.boolTrue },
                    { value: "false", label: e.labels.boolFalse }
                  ],
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  "full-width": "",
                  "onUpdate:modelValue": (N) => T(B, N)
                }, null, 8, ["data-testid", "model-value", "options", "placeholder", "aria-label", "onUpdate:modelValue"])) : o(B) === "numberRange" ? (c(), W(Uv, {
                  key: 4,
                  "data-testid": `afb-value-${q}`,
                  "min-value": B.values[0] === void 0 || B.values[0] === "" ? null : Number(B.values[0]),
                  "max-value": B.values[1] === void 0 || B.values[1] === "" ? null : Number(B.values[1]),
                  "show-slider": !1,
                  "clamp-input-to-bounds": !1,
                  "min-placeholder": e.labels.rangeFrom,
                  "max-placeholder": e.labels.rangeTo,
                  "min-aria-label": e.labels.rangeFrom,
                  "max-aria-label": e.labels.rangeTo,
                  "separator-label": e.labels.rangeTo,
                  "onUpdate:minValue": (N) => $(B, 0, N),
                  "onUpdate:maxValue": (N) => $(B, 1, N)
                }, null, 8, ["data-testid", "min-value", "max-value", "min-placeholder", "max-placeholder", "min-aria-label", "max-aria-label", "separator-label", "onUpdate:minValue", "onUpdate:maxValue"])) : o(B) === "dateRange" ? (c(), W(e3, {
                  key: 5,
                  "data-testid": `afb-value-${q}`,
                  "start-date": String(B.values[0] ?? ""),
                  "end-date": String(B.values[1] ?? ""),
                  "start-placeholder": e.labels.rangeFrom,
                  "end-placeholder": e.labels.rangeTo,
                  "start-label": "",
                  "end-label": "",
                  language: e.labels.dateLocale ?? "en",
                  format: "yyyy-mm-dd",
                  "full-width": "",
                  "onUpdate:startDate": (N) => $(B, 0, N),
                  "onUpdate:endDate": (N) => $(B, 1, N)
                }, null, 8, ["data-testid", "start-date", "end-date", "start-placeholder", "end-placeholder", "language", "onUpdate:startDate", "onUpdate:endDate"])) : o(B) === "days" ? (c(), g("div", gW, [
                  te(Af, {
                    "data-testid": `afb-value-${q}`,
                    "model-value": I(B),
                    placeholder: e.labels.valuePlaceholder,
                    "aria-label": e.labels.valuePlaceholder,
                    "full-width": "",
                    "onUpdate:modelValue": (N) => k(B, N)
                  }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "onUpdate:modelValue"]),
                  v("span", mW, j(e.labels.daysSuffix), 1)
                ])) : o(B) === "tags" ? (c(), W(Y4, {
                  key: 7,
                  "data-testid": `afb-value-${q}`,
                  "model-value": B.values.map(String),
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  "remove-label": e.labels.removeValue,
                  "full-width": "",
                  "onUpdate:modelValue": (N) => S(B, N)
                }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "remove-label", "onUpdate:modelValue"])) : o(B) === "number" ? (c(), W(Af, {
                  key: 8,
                  "data-testid": `afb-value-${q}`,
                  "model-value": I(B),
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  "full-width": "",
                  "onUpdate:modelValue": (N) => y(B, N)
                }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "onUpdate:modelValue"])) : o(B) === "date" ? (c(), W(xu, {
                  key: 9,
                  "data-testid": `afb-value-${q}`,
                  "model-value": I(B),
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  language: e.labels.dateLocale ?? "en",
                  format: "yyyy-mm-dd",
                  "full-width": "",
                  "onUpdate:modelValue": (N) => y(B, N)
                }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "language", "onUpdate:modelValue"])) : o(B) === "text" ? (c(), W(Wt, {
                  key: 10,
                  "data-testid": `afb-value-${q}`,
                  "model-value": I(B),
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  "full-width": "",
                  "onUpdate:modelValue": (N) => y(B, N)
                }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "onUpdate:modelValue"])) : w("", !0)
              ], 2),
              te(Me, {
                "data-testid": `afb-remove-${q}`,
                variant: "text",
                "icon-only": "",
                "icon-left": "ri-delete-bin-6-line",
                size: "sm",
                "aria-label": e.labels.removeCriterion,
                class: "shrink-0 mt-1",
                onClick: (N) => le(B._id)
              }, null, 8, ["data-testid", "aria-label", "onClick"])
            ], 64))
          ]),
          !A(B) && D(B) ? (c(), g("p", {
            key: 0,
            "data-testid": `afb-error-${q}`,
            class: "ml-[112px] -mt-1 text-xs text-(--text-text-error-strong) dark:text-(--text-text-error)",
            role: "status"
          }, j(D(B)), 9, pW)) : w("", !0)
        ], 64))), 128)),
        v("div", vW, [
          V[0] || (V[0] = v("div", {
            class: "w-[100px] shrink-0",
            "aria-hidden": "true"
          }, null, -1)),
          v("div", xW, [
            te(Mn, {
              "data-testid": "afb-add-criterion",
              "icon-left": "ri-add-line",
              size: "l",
              onClick: z
            }, {
              default: ve(() => [
                nt(j(e.labels.addCriterion), 1)
              ]),
              _: 1
            }),
            re.value ? (c(), W(Mn, {
              key: 0,
              "data-testid": "afb-add-group",
              "icon-left": "ri-add-line",
              size: "l",
              onClick: Y
            }, {
              default: ve(() => [
                nt(j(e.labels.addGroup), 1)
              ]),
              _: 1
            })) : w("", !0)
          ])
        ])
      ], 10, dW);
    };
  }
}), kW = /* @__PURE__ */ dt(yW, [["__scopeId", "data-v-4dadbb9e"]]), wW = {
  "data-testid": "afb-body",
  class: "flex flex-col gap-6"
}, Cx = /* @__PURE__ */ ye({
  __name: "AdvancedFilterBody",
  props: {
    builder: {},
    fields: {},
    labels: {},
    maxDepth: { default: 2 },
    fieldGroups: {},
    showInfoAlert: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (n, t) => (c(), g(de, null, [
      e.builder.hasErrors.value ? (c(), W(_l, {
        key: 0,
        "data-testid": "afb-error-alert",
        color: "danger",
        surface: "card",
        layout: "inline",
        heading: e.labels.errorAlert
      }, null, 8, ["heading"])) : w("", !0),
      e.showInfoAlert ? (c(), W(_l, {
        key: 1,
        color: "info",
        surface: "card",
        layout: "inline",
        heading: e.labels.alert
      }, null, 8, ["heading"])) : w("", !0),
      v("div", wW, [
        te(kW, {
          group: e.builder.root.value,
          fields: e.fields,
          labels: e.labels,
          "max-depth": e.maxDepth,
          builder: e.builder,
          depth: 1,
          "field-groups": e.fieldGroups
        }, null, 8, ["group", "fields", "labels", "max-depth", "builder", "field-groups"])
      ])
    ], 64));
  }
}), CW = {
  "data-testid": "afb-footer-actions",
  class: "ms-auto flex flex-wrap items-center justify-end gap-4"
}, Sx = /* @__PURE__ */ ye({
  __name: "AdvancedFilterFooter",
  props: {
    labels: {},
    busy: { type: Boolean, default: !1 },
    showCancel: { type: Boolean, default: !0 },
    showSave: { type: Boolean, default: !1 },
    canSave: { type: Boolean },
    saveDisabledReason: {}
  },
  emits: ["reset", "cancel", "save", "apply"],
  setup(e, { emit: n }) {
    const t = n;
    return (a, l) => (c(), g(de, null, [
      te(Me, {
        "data-testid": "afb-reset",
        variant: "secondary",
        size: "md",
        label: e.labels.reset,
        disabled: e.busy,
        "icon-left": "ri-refresh-line",
        onClick: l[0] || (l[0] = (r) => t("reset"))
      }, null, 8, ["label", "disabled"]),
      v("div", CW, [
        e.showCancel ? (c(), W(Me, {
          key: 0,
          "data-testid": "afb-cancel",
          variant: "secondary",
          size: "md",
          label: e.labels.cancel,
          disabled: e.busy,
          onClick: l[1] || (l[1] = (r) => t("cancel"))
        }, null, 8, ["label", "disabled"])) : w("", !0),
        e.showSave ? (c(), W(mt, {
          key: 1,
          text: e.saveDisabledReason ?? "",
          disabled: e.saveDisabledReason === null,
          tabindex: e.saveDisabledReason ? 0 : void 0,
          "data-testid": "afb-save-tooltip",
          position: "top"
        }, {
          default: ve(() => [
            te(Me, {
              "data-testid": "afb-save",
              variant: "secondary",
              size: "md",
              label: e.labels.save,
              disabled: !e.canSave,
              "icon-left": "ri-save-3-fill",
              onClick: l[2] || (l[2] = (r) => t("save"))
            }, null, 8, ["label", "disabled"])
          ]),
          _: 1
        }, 8, ["text", "disabled", "tabindex"])) : w("", !0),
        te(Me, {
          "data-testid": "afb-apply",
          variant: "primary",
          size: "md",
          label: e.labels.apply,
          disabled: e.busy,
          loading: e.busy,
          "icon-left": "ri-check-fill",
          onClick: l[3] || (l[3] = (r) => t("apply"))
        }, null, 8, ["label", "disabled", "loading"])
      ])
    ], 64));
  }
}), LU = /* @__PURE__ */ ye({
  __name: "AdvancedFilterBuilder",
  props: {
    modelValue: {},
    fields: {},
    fieldGroups: { default: void 0 },
    maxDepth: { default: 2 },
    busy: { type: Boolean, default: !1 },
    labels: {},
    showSave: { type: Boolean, default: !1 },
    showCancel: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "apply", "reset", "cancel", "close", "save"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = yx({
      modelValue: () => t.modelValue,
      fields: () => t.fields,
      busy: () => t.busy,
      labels: () => t.labels,
      emitUpdate: (s) => a("update:modelValue", s),
      emitApply: (s) => a("apply", s),
      emitReset: () => a("reset"),
      emitSave: (s) => a("save", s)
    }), r = R(!0);
    function o() {
      t.busy || a("cancel");
    }
    function i() {
      r.value = !1, a("close");
    }
    return (s, d) => (c(), W(Ka, {
      modelValue: r.value,
      "onUpdate:modelValue": d[0] || (d[0] = (u) => r.value = u),
      size: "lg",
      "footer-position": "split",
      title: e.labels.title,
      icon: "ri-shuffle-line",
      "header-align": "middle-stacked",
      "show-header-border": !1,
      onClose: i
    }, {
      footer: ve(() => [
        te(Sx, {
          labels: e.labels,
          busy: e.busy,
          "show-cancel": e.showCancel,
          "show-save": e.showSave,
          "can-save": L(l).canSave.value,
          "save-disabled-reason": L(l).saveDisabledReason.value,
          onReset: L(l).onReset,
          onCancel: o,
          onSave: L(l).onSave,
          onApply: L(l).onApply
        }, null, 8, ["labels", "busy", "show-cancel", "show-save", "can-save", "save-disabled-reason", "onReset", "onSave", "onApply"])
      ]),
      default: ve(() => [
        te(Cx, {
          builder: L(l).builder,
          fields: e.fields,
          labels: e.labels,
          "max-depth": e.maxDepth,
          "field-groups": e.fieldGroups,
          "show-info-alert": ""
        }, null, 8, ["builder", "fields", "labels", "max-depth", "field-groups"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]));
  }
}), SW = ["aria-labelledby"], $W = {
  "data-testid": "afp-header",
  class: "flex min-w-0 shrink-0 items-center justify-between gap-2 max-sm:flex-wrap"
}, IW = ["aria-labelledby"], LW = {
  "data-testid": "afp-scroll",
  class: "flex min-h-0 min-w-0 flex-1 flex-col gap-4 overflow-y-auto px-6 py-5"
}, TW = {
  "data-testid": "afp-footer",
  class: "flex min-w-0 shrink-0 flex-wrap items-center justify-between gap-3 px-6"
}, TU = /* @__PURE__ */ ye({
  __name: "AdvancedFilterPopover",
  props: {
    open: { type: Boolean },
    anchorEl: {},
    modelValue: {},
    fields: {},
    fieldGroups: { default: void 0 },
    maxDepth: { default: 2 },
    busy: { type: Boolean, default: !1 },
    showSave: { type: Boolean, default: !1 },
    labels: {}
  },
  emits: ["update:open", "update:modelValue", "apply", "reset", "save", "view-all"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = yx({
      modelValue: () => a.modelValue,
      fields: () => a.fields,
      busy: () => a.busy,
      labels: () => a.labels,
      emitUpdate: (O) => l("update:modelValue", O),
      emitApply: (O) => l("apply", O),
      emitReset: () => l("reset"),
      emitSave: (O) => l("save", O)
    }), o = qe(), i = R(null);
    ts({
      active: An(a, "open"),
      container: i,
      containFocus: !0,
      // AC 10 — restore focus to the STABLE "Filtrer" trigger, not whatever had focus when the
      // panel opened: the opening click can come from a transient, self-closing control (e.g.
      // TableFilterSelector's own step-1 "Créer un filtre avancé"/"Voir tous les filtres
      // avancés" items — TableFilterSelector.vue's handleCreateAdvanced/handleViewAdvanced emit
      // then immediately closeDropdown(), unmounting the very button that was just clicked).
      // useFocusTrap's default previousActive-based restore captures that transient node's live
      // reference at open time, but by close time it's detached from the document — `.focus()`
      // on a detached node is a silent no-op, so focus fell back to `<body>`. `anchorEl` is
      // already the stable anchor this popover receives for positioning; reusing it here covers
      // both the direct-anchorEl-click case and the transient-control case identically.
      restoreFocusTo: () => a.anchorEl
    });
    const s = [
      kx,
      '[data-testid="dropdown-menu"]',
      '[data-testid="datepicker-dropdown-menu"]',
      '[data-testid="autocomplete-panel"]',
      '[role="tooltip"]',
      '[role="dialog"]',
      '[data-testid="modal-backdrop"]'
    ], d = 996, u = 588, f = 8, b = 4, h = R({});
    function p() {
      var G;
      const O = (G = a.anchorEl) == null ? void 0 : G.getBoundingClientRect();
      if (!O) return;
      const P = window.innerWidth, V = window.innerHeight, M = Math.min(d, P - 2 * f), B = O.bottom + b, q = Math.min(
        Math.max(f, O.left),
        Math.max(f, P - M - f)
      ), N = Math.min(u, V - B - f);
      h.value = {
        position: "fixed",
        top: `${B}px`,
        left: `${q}px`,
        width: `${M}px`,
        maxHeight: `${N}px`,
        // Page-level only: stays under the elevated save modal (z-300) that opens over it.
        zIndex: "50"
      };
    }
    function x() {
      window.addEventListener("scroll", p, !0), window.addEventListener("resize", p);
    }
    function y() {
      window.removeEventListener("scroll", p, !0), window.removeEventListener("resize", p);
    }
    let k = a.modelValue;
    $e(
      () => a.open,
      (O) => {
        if (O) {
          const P = a.modelValue !== k, V = r.builder.isDirty.value;
          (P || V) && (r.reseedFrom(a.modelValue), k = a.modelValue), Ge(() => {
            p(), x();
          });
        } else
          y();
      },
      { immediate: !0 }
    );
    const $ = Symbol("advanced-filter-popover");
    $e(
      () => a.open,
      (O) => {
        O ? ra($) : Fn($);
      },
      { immediate: !0 }
    ), yt(() => {
      y(), Fn($);
    });
    const S = R(!1), T = R(null);
    let I = !1;
    function A() {
      if (!r.builder.isDirty.value) {
        Y();
        return;
      }
      S.value = !0;
    }
    function E() {
      T.value = () => l("view-all"), A();
    }
    function D(O) {
      T.value = O, A();
    }
    function z() {
      Ge(() => {
        var O;
        return (O = a.anchorEl) == null ? void 0 : O.focus();
      });
    }
    function Y() {
      if (S.value = !1, r.builder.reset(), l("update:open", !1), T.value) {
        I = !0;
        const O = T.value;
        T.value = null, O();
      } else
        z();
    }
    function le() {
      S.value = !1, T.value = null;
    }
    function ne() {
      if (r.builder.reset(), I) {
        I = !1;
        return;
      }
      z();
    }
    n({ requestCloseThen: D, discard: ne });
    function re(O) {
      a.open && ya($) && (O.defaultPrevented || (O.stopPropagation(), O.preventDefault(), A()));
    }
    return rs(i, A, {
      isActive: () => a.open,
      ignoreSelectors: s
    }), (O, P) => (c(), W(Nn, { to: "body" }, [
      e.open ? (c(), g("div", {
        key: 0,
        ref_key: "panelRef",
        ref: i,
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": L(o),
        "data-testid": "afp-panel",
        style: je(h.value),
        class: "flex flex-col gap-2 rounded-(--border-border-radius-rounded-l) bg-(--background-background-white) px-3 py-4 shadow-(--blur-shadow-m) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)",
        onKeydown: ht(re, ["escape"])
      }, [
        v("div", $W, [
          v("h2", {
            "data-testid": "afp-title",
            class: "flex min-w-0",
            "aria-labelledby": L(o)
          }, [
            te(Yr, {
              id: L(o),
              type: "h5",
              "icon-left": "ri-shuffle-line",
              label: e.labels.title,
              "info-right": e.labels.titleInfo,
              "data-testid": "afp-heading"
            }, null, 8, ["id", "label", "info-right"])
          ], 8, IW),
          te(Mn, {
            "data-testid": "afp-view-all",
            size: "l",
            class: "max-w-full shrink-0 text-left",
            onClick: E
          }, {
            default: ve(() => [
              nt(j(e.labels.viewAllFilters), 1)
            ]),
            _: 1
          })
        ]),
        v("div", LW, [
          te(Cx, {
            builder: L(r).builder,
            fields: e.fields,
            labels: e.labels,
            "max-depth": e.maxDepth,
            "field-groups": e.fieldGroups,
            "show-info-alert": !1
          }, null, 8, ["builder", "fields", "labels", "max-depth", "field-groups"])
        ]),
        v("div", TW, [
          te(Sx, {
            labels: e.labels,
            busy: e.busy,
            "show-cancel": !1,
            "show-save": e.showSave,
            "can-save": L(r).canSave.value,
            "save-disabled-reason": L(r).saveDisabledReason.value,
            onReset: L(r).onReset,
            onSave: L(r).onSave,
            onApply: L(r).onApply
          }, null, 8, ["labels", "busy", "show-save", "can-save", "save-disabled-reason", "onReset", "onSave", "onApply"])
        ]),
        S.value ? (c(), W(oN, {
          key: 0,
          "model-value": S.value,
          title: e.labels.confirmCloseTitle,
          message: e.labels.confirmCloseMessage,
          "stay-label": e.labels.confirmCloseStay,
          "leave-label": e.labels.confirmCloseLeave,
          "onUpdate:modelValue": P[0] || (P[0] = (V) => S.value = V),
          onStay: le,
          onLeave: Y
        }, null, 8, ["model-value", "title", "message", "stay-label", "leave-label"])) : w("", !0)
      ], 44, SW)) : w("", !0)
    ]));
  }
}), AW = {
  key: 0,
  "data-testid": "banner",
  class: "@container/banner w-full min-w-0"
}, EW = {
  role: "status",
  "aria-live": "polite",
  "aria-atomic": "true",
  class: "sr-only",
  "data-testid": "banner-live"
}, RW = {
  key: 0,
  "data-testid": "banner-content",
  class: "flex min-w-0 flex-1 items-center justify-center gap-2.5"
}, BW = {
  key: 0,
  "data-testid": "banner-text",
  class: "min-w-0 wrap-break-word text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-black-default) dark:text-(--text-text-white-default)"
}, MW = {
  key: 1,
  "data-testid": "banner-content",
  class: "flex min-w-0 flex-1 flex-col gap-4 @5xl/banner:flex-row @5xl/banner:items-center @5xl/banner:justify-between @5xl/banner:gap-0"
}, DW = {
  key: 0,
  "data-testid": "banner-text-group",
  class: "flex min-w-0 flex-1 flex-col gap-1"
}, zW = {
  key: 1,
  "data-testid": "banner-description",
  class: "wrap-break-word text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body) dark:text-(--text-text-white-secondary)"
}, OW = {
  key: 1,
  "data-testid": "banner-text-group",
  class: "flex min-w-0 flex-1 items-center gap-4"
}, PW = {
  key: 0,
  "data-testid": "banner-logo",
  class: "flex shrink-0 items-center"
}, FW = {
  "data-testid": "banner-text",
  class: "min-w-0 wrap-break-word text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--text-text-black-default) dark:text-(--text-text-white-default)"
}, VW = 150, NW = 5e3, AU = /* @__PURE__ */ ye({
  __name: "Banner",
  props: {
    type: { default: "default" },
    text: { default: void 0 },
    heading: { default: void 0 },
    description: { default: void 0 },
    headingLevel: { default: 2 },
    icon: { default: "ri-notification-4-line" },
    link: { default: void 0 },
    primaryAction: { default: void 0 },
    secondaryAction: { default: void 0 },
    closeLabel: {}
  },
  emits: ["close", "link", "primary", "secondary"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R(!1), r = R("");
    let o;
    const i = m(
      () => (t.type === "heading" ? [t.heading, t.description] : [t.text]).filter(Boolean).join(" ")
    );
    function s() {
      clearTimeout(o), r.value = "", o = setTimeout(() => {
        r.value = i.value, o = setTimeout(() => r.value = "", NW);
      }, VW);
    }
    ct(s), $e(i, () => Ge(s)), yt(() => clearTimeout(o));
    const d = m(() => [
      "flex w-full min-w-0 p-4 bg-(--background-background-white) rounded-(--border-border-radius-rounded-l) dark:bg-(--background-background-black-default)",
      t.type === "logo" ? "items-start border border-(--border-border-base-soft) shadow-(--blur-shadow-s) dark:border-(--border-border-base) dark:shadow-(--blur-shadow-m-dark) @5xl/banner:items-center @5xl/banner:justify-between" : "border-b border-(--border-border-base-soft) dark:border-(--border-border-base)",
      t.type === "heading" ? "items-start @5xl/banner:items-center" : "",
      t.type === "default" ? "items-center" : ""
    ]);
    function u() {
      a("close"), l.value = !0;
    }
    return (f, b) => l.value ? w("", !0) : (c(), g("div", AW, [
      v("div", EW, j(r.value), 1),
      v("div", {
        "data-testid": "banner-surface",
        class: C(d.value)
      }, [
        e.type === "default" ? (c(), g("div", RW, [
          te(Gt, {
            icon: e.icon,
            color: "gradient",
            size: "sm",
            type: "circle",
            variant: "filled",
            class: "shrink-0"
          }, null, 8, ["icon"]),
          e.text ? (c(), g("p", BW, j(e.text), 1)) : w("", !0),
          e.link ? (c(), W(Mn, {
            key: 1,
            "data-testid": "banner-link",
            as: e.link.href ? "a" : "button",
            href: e.link.href,
            "aria-label": e.link.ariaLabel,
            size: "s",
            "icon-right": "ri-arrow-right-line",
            class: "shrink-0",
            onClick: b[0] || (b[0] = (h) => e.link.href || a("link"))
          }, {
            default: ve(() => [
              nt(j(e.link.label), 1)
            ]),
            _: 1
          }, 8, ["as", "href", "aria-label"])) : w("", !0)
        ])) : (c(), g("div", MW, [
          e.type === "heading" ? (c(), g("div", DW, [
            e.heading ? (c(), W(it(`h${e.headingLevel}`), {
              key: 0,
              "data-testid": "banner-heading",
              class: "wrap-break-word text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold) text-(--text-text-heading) dark:text-(--text-text-white-default)"
            }, {
              default: ve(() => [
                nt(j(e.heading), 1)
              ]),
              _: 1
            })) : w("", !0),
            e.description ? (c(), g("p", zW, j(e.description), 1)) : w("", !0)
          ])) : (c(), g("div", OW, [
            f.$slots.logo ? (c(), g("div", PW, [
              Ae(f.$slots, "logo")
            ])) : w("", !0),
            e.text ? (c(), g("div", {
              key: 1,
              "data-testid": "banner-text-frame",
              class: C(["flex min-w-0 flex-1 items-center", f.$slots.logo ? "border-l border-(--border-border-base-soft) pl-[calc(--spacing(4)-1px)] dark:border-(--border-border-base)" : ""])
            }, [
              v("p", FW, j(e.text), 1)
            ], 2)) : w("", !0)
          ])),
          e.secondaryAction || e.primaryAction ? (c(), g("div", {
            key: 2,
            "data-testid": "banner-actions",
            class: C(["flex shrink-0 flex-wrap items-center gap-3", e.type === "logo" ? "justify-end" : ""])
          }, [
            e.type === "heading" && e.secondaryAction ? (c(), W(Me, {
              key: 0,
              "data-testid": "banner-secondary",
              variant: "secondary",
              size: "xs",
              "icon-left": "ri-arrow-left-line",
              label: e.secondaryAction.label,
              onClick: b[1] || (b[1] = (h) => a("secondary"))
            }, null, 8, ["label"])) : w("", !0),
            e.primaryAction ? (c(), W(Me, {
              key: 1,
              "data-testid": "banner-primary",
              variant: "primary",
              size: "xs",
              "icon-right": e.type === "heading" ? "ri-arrow-right-line" : void 0,
              label: e.primaryAction.label,
              onClick: b[2] || (b[2] = (h) => a("primary"))
            }, null, 8, ["icon-right", "label"])) : w("", !0)
          ], 2)) : w("", !0)
        ])),
        te(Me, {
          "data-testid": "banner-close",
          variant: "tertiary",
          size: "xs",
          "icon-only": "",
          "icon-left": "ri-close-fill",
          "aria-label": e.closeLabel,
          class: C(["shrink-0", e.type === "default" ? "" : "@5xl/banner:ml-3"]),
          onClick: u
        }, null, 8, ["aria-label", "class"])
      ], 2)
    ]));
  }
}), EU = {
  "Background-background-black-default": "{Colors.Primary.800-base}",
  "Background-background-white": "{white}",
  "Background-background-white-secondary": "{Colors.Neutral.100}",
  "Background-background-white-secondary-soft": "{Colors.Neutral.050}",
  "Background-background-white-tertiary": "{Colors.Gray.100}",
  "Background-background-selected": "{Colors.Gray.050}",
  "Background-background-info": "{Colors.Violet.50}",
  "Background-background-success": "{Colors.Success.50}",
  "Background-background-warning": "{Colors.Warning.50}",
  "Background-background-error": "{Colors.Error.50}",
  "Background-background-hover": "{Colors.Indigo.50}",
  "Background-background-accent": "{Colors.Violet.50}",
  "Background-background-accent-strong": "{Colors.Indigo.600}",
  "Background-background-disabled": "{Colors.Gray.100}",
  "Background-background-disabled-strong": "{Colors.Gray.300}",
  "Background-background-disabled-opacity": "{Colors.Gray.200-opacity-medium}",
  "Background-background-disabled-subtle": "{Colors.Gray.050}",
  "Background-background-gray": "{Colors.Gray.200}",
  "Background-background-ia": "{Colors.Purple.50}",
  "Text-text-white-default": "{Colors.Neutral.050}",
  "Text-text-white-secondary": "{Colors.Neutral.100}",
  "Text-text-black-default": "{Colors.Primary.800-base}",
  "Text-text-brand-bold": "{Colors.Primary.800-opacity-bold}",
  "Text-text-heading": "{Colors.Primary.800-base}",
  "Text-text-body": "{Colors.Gray.700}",
  "Text-text-body-subtle": "{Colors.Gray.500}",
  "Text-text-disabled-strong": "{Colors.Gray.500}",
  "Text-text-disabled-light": "{Colors.Gray.400}",
  "Text-text-success-strong": "{Colors.Success.700}",
  "Text-text-success": "{Colors.Success.600}",
  "Text-text-success-subtle": "{Colors.Success.500}",
  "Text-text-warning": "{Colors.Warning.600}",
  "Text-Text-error": "{Colors.Error.600}",
  "Text-Text-error-strong": "{Colors.Error.700}",
  "Text-Text-error-subtle": "{Colors.Error.500}",
  "Text-Text-link": "{Colors.Violet.500}",
  "Text-Text-hover": "{Colors.Violet.800}",
  "Text-Text-info": "{Colors.Indigo.700}",
  "Text-Text-accent": "{Colors.Indigo.500}",
  "Icons-icon-black": "{black}",
  "Icons-icon-white": "{white}",
  "Icons-icon-dark-default": "{Colors.Primary.800-base}",
  "Icons-icon-white-default": "{Colors.Neutral.100}",
  "Icons-icon-disabled-strong": "{Colors.Gray.500}",
  "Icons-icon-disabled-light": "{Colors.Gray.400}",
  "Icons-icon-base": "{Colors.Gray.500}",
  "Icons-icon-base-strong": "{Colors.Gray.700}",
  "Icons-icon-link": "{Colors.Violet.500}",
  "Icons-icon-success": "{Colors.Success.500}",
  "Icons-icon-success-subtle": "{Colors.Success.400}",
  "Icons-icon-warning": "{Colors.Warning.600}",
  "Icons-icon-error": "{Colors.Error.700}",
  "Icons-icon-info": "{Colors.Indigo.700}",
  "Icons-icon-hover": "{Colors.Violet.800}",
  "Icons-icon-accent": "{Colors.Indigo.500}",
  "Icons-icon-accent-strong": "{Colors.Indigo.600}",
  "Icons-icon-ia": "{Colors.Purple.600}",
  "Icons-icon-cyan": "{Colors.Cyan.500}",
  "Icons-icon-color-default": "{Colors.Cyan.600}",
  "Components-Button-button-disabled": "{Colors.Gray.200-opacity-bold}",
  "Components-Button-Primary-button-primary": "{Colors.Primary.800-base}",
  "Components-Button-Primary-button-primary-hover": "{Colors.Gray.500}",
  "Components-Button-Secondary-button-secondary": "{white}",
  "Components-Button-Secondary-button-secondary-hover": "{Colors.Primary.800-opacity-bold}",
  "Components-Button-Secondary-button-secondary-focused": "{Colors.Indigo.400}",
  "Components-Button-Tertiary-button-tertiary-hover": "{Colors.Indigo.50}",
  "Components-Button-Tertiary-button-tertiary-focused": "{Colors.Indigo.50}",
  "Components-Button-Tab-button-tab-default": "{Colors.Gray.100}",
  "Components-Button-Tab-button-tab": "{white}",
  "Components-Button-Tab-button-tab-hover": "{Colors.Indigo.400}",
  "Components-Button-Tab-button-tab-active": "{white}",
  "Components-Button-Text-button-text": "{Colors.Primary.800-base}",
  "Components-Button-Text-button-text-hover": "{Colors.Indigo.700}",
  "Components-Button-Ghost-button-ghost-hover": "{Colors.Indigo.50}",
  "Components-Button-Functional-Success-button-success": "{Colors.Success.700}",
  "Components-Button-Functional-Success-button-success-hover": "{Colors.Success.800}",
  "Components-Button-Functional-Success-button-success-focused": "{Colors.Success.800}",
  "Components-Button-Functional-Desctructive error-Background-button-error": "{Colors.Error.600}",
  "Components-Button-Functional-Desctructive error-Background-button-error-hover": "{Colors.Error.700}",
  "Components-Button-Functional-Desctructive error-Background-button-error-focused": "{Colors.Error.900}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-icon": "{Colors.Error.600}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-hover-icon": "{Colors.Error.700}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-focused-icon": "{Colors.Error.900}",
  "Components-Badge-Background-badge-disabled-bg": "{Colors.Gray.300}",
  "Components-Badge-Background-badge-gray-bg": "{Colors.Gray.500}",
  "Components-Badge-Background-badge-error-bg": "{Colors.Error.200}",
  "Components-Badge-Background-badge-error-strong-bg": "{Colors.Error.500}",
  "Components-Badge-Background-badge-orange-bg": "{Colors.Warning.100}",
  "Components-Badge-Background-badge-orange-strong-bg": "{Colors.Warning.500}",
  "Components-Badge-Background-badge-yellow-bg": "{Colors.Yellow.100}",
  "Components-Badge-Background-badge-yellow-strong-bg": "{Colors.Yellow.300}",
  "Components-Badge-Background-badge-green-bg": "{Colors.Success.100}",
  "Components-Badge-Background-badge-green-strong-bg": "{Colors.Success.500}",
  "Components-Badge-Background-badge-indigo-soft-bg": "{Colors.Indigo.100}",
  "Components-Badge-Background-badge-indigo-medium-bg": "{Colors.Indigo.300}",
  "Components-Badge-Background-badge-indigo-strong-bg": "{Colors.Indigo.500}",
  "Components-Badge-Background-badge-accent-bg": "{Colors.Indigo.80-opacity}",
  "Components-Badge-Background-badge-violet-bg": "{Colors.Violet.200}",
  "Components-Badge-Background-badge-violet-strong-bg": "{Colors.Violet.400}",
  "Components-Badge-Background-badge-purple-bg": "{Colors.Purple.100}",
  "Components-Badge-Background-badge-purple-strong-bg": "{Colors.Purple.400}",
  "Components-Badge-Background-badge-neutral-bg": "{Colors.Neutral.200}",
  "Components-Badge-Background-badge-neutral-strong-bg": "{Colors.Neutral.400}",
  "Components-Badge-Background-badge-cyan-bg": "{Colors.Cyan.100}",
  "Components-Badge-Background-badge-cyan-strong-bg": "{Colors.Cyan.400}",
  "Components-Badge-Background-badge-white-bg": "{white}",
  "Components-Badge-Background-badge-dark-bg": "{Colors.Neutral.700}",
  "Components-Badge-Icon-badge-disabled-icon": "{Colors.Gray.500}",
  "Components-Badge-Icon-badge-black-icon": "{black}",
  "Components-Badge-Icon-badge-white-icon": "{white}",
  "Components-Badge-Icon-badge-white-default-icon": "{Colors.Neutral.100}",
  "Components-Badge-Icon-badge-dark-icon": "{Colors.Neutral.700}",
  "Components-Badge-Icon-badge-black-default-icon": "{Colors.Primary.800-base}",
  "Components-Badge-Text-badge-disabled-strong-text": "{Colors.Gray.500}",
  "Components-Badge-Text-badge-white-text": "{white}",
  "Components-Badge-Text-badge-white-default-text": "{Colors.Neutral.050}",
  "Components-Badge-Text-badge-black-text": "{black}",
  "Components-Badge-Text-badge-black-default-text": "{Colors.Primary.800-base}",
  "Components-Badge-Text-badge-body-text": "{Colors.Gray.700}",
  "Components-Badge-Border-badge-disabled-border": "{Colors.Gray.300}",
  "Components-Badge-Border-badge-white-border": "{white}",
  "Components-Badge-Border-badge-white-default-border": "{Colors.Neutral.400}",
  "Components-Badge-Border-badge-base-soft-border": "{Colors.Gray.200}",
  "Components-Badge-Border-badge-black-border": "{black}",
  "Components-Badge-Border-badge-dark-default-border": "{Colors.Primary.800-base}",
  "Components-Icon shape-Background-iconshape-disabled-bg": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Background-iconshape-red-bg": "{Colors.Error.100}",
  "Components-Icon shape-Background-iconshape-orange-bg": "{Colors.Warning.100}",
  "Components-Icon shape-Background-iconshape-yellow-bg": "{Colors.Yellow.100}",
  "Components-Icon shape-Background-iconshape-green-bg": "{Colors.Success.100}",
  "Components-Icon shape-Background-iconshape-indigo-bg": "{Colors.Indigo.100}",
  "Components-Icon shape-Background-iconshape-violet-bg": "{Colors.Violet.200}",
  "Components-Icon shape-Background-iconshape-purple-bg": "{Colors.Purple.100}",
  "Components-Icon shape-Background-iconshape-neutral-bg": "{Colors.Neutral.200}",
  "Components-Icon shape-Background-iconshape-cyan-bg": "{Colors.Cyan.100}",
  "Components-Icon shape-Background-iconshape-black-bg": "{black}",
  "Components-Icon shape-Background-iconshape-black-default-bg": "{Colors.Primary.800-base}",
  "Components-Icon shape-Background-iconshape-white-bg": "{white}",
  "Components-Icon shape-Background-iconshape-success-bg": "{Colors.Success.600}",
  "Components-Icon shape-Background-iconshape-error-bg": "{Colors.Error.500}",
  "Components-Icon shape-Background-iconshape-accent-bg": "{Colors.Indigo.50}",
  "Components-Icon shape-Icon-iconshape-black-icon": "{black}",
  "Components-Icon shape-Icon-iconshape-white-icon": "{white}",
  "Components-Icon shape-Icon-iconshape-white-default-icon": "{Colors.Neutral.100}",
  "Components-Icon shape-Icon-iconshape-disabled-icon": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Icon-iconshape-disabled-strong-icon": "{Colors.Gray.500}",
  "Components-Icon shape-Icon-iconshape-success-icon": "{Colors.Success.600}",
  "Components-Icon shape-Icon-iconshape-red-icon": "{Colors.Error.700}",
  "Components-Icon shape-Icon-iconshape-error-icon": "{Colors.Error.500}",
  "Components-Icon shape-Icon-iconshape-brand-icon": "{Colors.Primary.800-base}",
  "Components-Icon shape-Icon-iconshape-accent-gradient-icon": "{Colors.Primary.800-opacity-bold}",
  "Components-Icon shape-Icon-iconshape-orange-icon": "{Colors.Warning.600}",
  "Components-Icon shape-Icon-iconshape-yellow-icon": "{Colors.Yellow.600}",
  "Components-Icon shape-Icon-iconshape-green-icon": "{Colors.Success.500}",
  "Components-Icon shape-Icon-iconshape-indigo-icon": "{Colors.Indigo.400}",
  "Components-Icon shape-Icon-iconshape-violet-icon": "{Colors.Violet.700}",
  "Components-Icon shape-Icon-iconshape-purple-icon": "{Colors.Purple.700}",
  "Components-Icon shape-Icon-iconshape-neutral-icon": "{Colors.Neutral.200}",
  "Components-Icon shape-Icon-iconshape-default-icon": "{Colors.Cyan.600}",
  "Components-Icon shape-Border-iconshape-disabled-border": "{Colors.Gray.300}",
  "Components-Icon shape-Border-iconshape-default-border": "{Colors.Neutral.200}",
  "Components-Icon shape-Border-iconshape-accent-border": "{Colors.Cyan.600}",
  "Components-Icon shape-Border-iconshape-error-border": "{Colors.Error.600}",
  "Components-Icon shape-Border-iconshape-success-border": "{Colors.Success.500}",
  "Components-Icon shape-Text-iconshape-disabled-text": "{Colors.Gray.500}",
  "Components-Icon shape-Text-iconshape-black-default-text": "{Colors.Primary.800-base}",
  "Components-Icon shape-Text-iconshape-default-text": "{Colors.Cyan.600}",
  "Components-Icon shape-Text-iconshape-accent-gradient-text": "{Colors.Primary.800-opacity-bold}",
  "Components-Icon shape-Text-iconshape-error-text": "{Colors.Error.600}",
  "Components-Icon shape-Text-iconshape-success-text": "{Colors.Success.500}",
  "Components-Icon shape-Text-iconshape-white-default-text": "{Colors.Neutral.050}",
  "Components-Toggle-Background-toggle-active": "{Colors.Indigo.400}",
  "Components-Toggle-Background-toggle-unactive": "{Colors.Neutral.050}",
  "Components-Toggle-Background-toggle-disabled": "{Colors.Gray.300}",
  "Components-Toggle-Background-toggle-active-switch": "{Background.background-white}",
  "Components-Toggle-Background-toggle-disabled-switch": "{Colors.Gray.500}",
  "Components-Toggle-Icon-toggle-icon": "{Colors.Indigo.400}",
  "Components-Toggle-Icon-toggle-icon-disabled": "{Colors.Gray.200}",
  "Components-Toggle-Border-toggle-active-border": "{Colors.Indigo.300}",
  "Components-Toggle-Border-toggle-unactive-border": "{Colors.Neutral.500}",
  "Components-Toggle-Border-toggle-disabled-border": "{Colors.Gray.400}",
  "Border-border-black-default": "{Colors.Primary.800-base}",
  "Border-border-white-default": "{Colors.Neutral.400}",
  "Border-border-base": "{Colors.Gray.500}",
  "Border-border-base-medium": "{Colors.Gray.300}",
  "Border-border-base-soft": "{Colors.Gray.200}",
  "Border-border-disabled": "{Colors.Gray.300}",
  "Border-border-disabled-subtle": "{Colors.Gray.200}",
  "Border-border-primary-button": "{Colors.Gray.500}",
  "Border-border-primary-button-hover": "{Colors.Indigo.100}",
  "Border-border-secondary-button": "{Colors.Neutral.400}",
  "Border-border-secondary-button-hover": "{Colors.Indigo.400}",
  "Border-border-secondary-button-focus": "{Colors.Cyan.500}",
  "Border-border-tertiary-hover": "{Colors.White opacity.50-opacity}",
  "Border-border-tab": "{white}",
  "Border-border-tab-hover": "{Colors.Indigo.400}",
  "Border-border-tab-hover 2": "{Colors.Indigo.400}",
  "Border-border-accent": "{Colors.Indigo.500}",
  "Border-border-accent-subtle": "{Colors.Indigo.200}",
  "Border-border-hover": "{Colors.Violet.800}",
  "Border-border-info": "{Colors.Indigo.500}",
  "Border-border-info-strong": "{Colors.Indigo.700}",
  "Border-border-info-subtle": "{Colors.Indigo.200}",
  "Border-border-success-strong": "{Colors.Success.700}",
  "Border-border-success": "{Colors.Success.500}",
  "Border-border-error-strong": "{Colors.Error.700}",
  "Border-border-error": "{Colors.Error.600}",
  "Border-border-error-subtle": "{Colors.Error.200}",
  "Border-border-warning": "{Colors.Warning.500}",
  "Border-border-warning-subtle": "{Colors.Warning.200}",
  "Border-border-ia": "{Colors.Purple.200}",
  "Border-border-accessibility": "{Colors.Neutral.400}",
  "Border-border-white-full": "{white}"
}, RU = {
  "Background-background-black-default": "{Colors.Primary.800-base}",
  "Background-background-white": "{white}",
  "Background-background-white-secondary": "{Colors.Neutral.100}",
  "Background-background-white-secondary-soft": "{Colors.Neutral.050}",
  "Background-background-white-tertiary": "{Colors.Gray.100}",
  "Background-background-selected": "{Colors.Gray.050}",
  "Background-background-info": "{Colors.Indigo.50}",
  "Background-background-success": "{Colors.Success.50}",
  "Background-background-warning": "{Colors.Warning.50}",
  "Background-background-error": "{Colors.Error.50}",
  "Background-background-hover": "{Colors.Indigo.50}",
  "Background-background-accent": "{Colors.Indigo.50}",
  "Background-background-accent-strong": "{Colors.Indigo.50}",
  "Background-background-disabled": "{Colors.Gray.100}",
  "Background-background-disabled-strong": "{Colors.Gray.400}",
  "Background-background-disabled-opacity": "{Colors.Gray.200-opacity-medium}",
  "Background-background-disabled-subtle": "{Colors.Gray.050}",
  "Background-background-gray": "{Colors.Gray.200}",
  "Background-background-ia": "{Colors.Purple.50}",
  "Text-text-white-default": "{Colors.Neutral.050}",
  "Text-text-white-secondary": "{Colors.Neutral.050}",
  "Text-text-black-default": "{Colors.Primary.800-base}",
  "Text-text-brand-bold": "{Colors.Gray.700}",
  "Text-text-heading": "{Colors.Primary.800-base}",
  "Text-text-body": "{Colors.Gray.700}",
  "Text-text-body-subtle": "{Colors.Gray.600}",
  "Text-text-disabled-strong": "{Colors.Gray.800}",
  "Text-text-disabled-light": "{Colors.Gray.300}",
  "Text-text-success-strong": "{Colors.Success.700}",
  "Text-text-success": "{Colors.Success.600}",
  "Text-text-success-subtle": "{Colors.Success.500}",
  "Text-text-warning": "{Colors.Warning.600}",
  "Text-Text-error": "{Colors.Error.600}",
  "Text-Text-error-strong": "{Colors.Error.700}",
  "Text-Text-error-subtle": "{Colors.Error.500}",
  "Text-Text-link": "{Colors.Indigo.400}",
  "Text-Text-hover": "{Colors.Indigo.300}",
  "Text-Text-info": "{Colors.Indigo.600}",
  "Text-Text-accent": "{Colors.Indigo.400}",
  "Icons-icon-black": "{Colors.Primary.800-base}",
  "Icons-icon-white": "{Colors.Primary.800-base}",
  "Icons-icon-dark-default": "{Colors.Primary.800-base}",
  "Icons-icon-white-default": "{Colors.Neutral.050}",
  "Icons-icon-disabled-strong": "{Colors.Gray.800}",
  "Icons-icon-disabled-light": "{Colors.Gray.300}",
  "Icons-icon-base": "{Colors.Gray.500}",
  "Icons-icon-base-strong": "{Colors.Gray.700}",
  "Icons-icon-link": "{Colors.Indigo.400}",
  "Icons-icon-success": "{Colors.Success.500}",
  "Icons-icon-success-subtle": "{Colors.Success.300}",
  "Icons-icon-warning": "{Colors.Warning.300}",
  "Icons-icon-error": "{Colors.Error.500}",
  "Icons-icon-info": "{Colors.Indigo.400}",
  "Icons-icon-hover": "{Colors.Indigo.300}",
  "Icons-icon-accent": "{Colors.Indigo.400}",
  "Icons-icon-accent-strong": "{Colors.Indigo.600}",
  "Icons-icon-ia": "{Colors.Purple.600}",
  "Icons-icon-cyan": "{Colors.Cyan.600}",
  "Icons-icon-color-default": "{Colors.Cyan.700}",
  "Components-Button-button-disabled": "{Colors.Gray.400}",
  "Components-Button-Primary-button-primary": "{Colors.Black opacity.50-opacity-bold}",
  "Components-Button-Primary-button-primary-hover": "{Colors.Gray.500}",
  "Components-Button-Secondary-button-secondary": "{Colors.Neutral.050}",
  "Components-Button-Secondary-button-secondary-hover": "{Colors.Primary.800-opacity-bold}",
  "Components-Button-Secondary-button-secondary-focused": "{Colors.Indigo.500}",
  "Components-Button-Tertiary-button-tertiary-hover": "{Colors.Indigo.400}",
  "Components-Button-Tertiary-button-tertiary-focused": "{Colors.Primary.800-base}",
  "Components-Button-Tab-button-tab-default": "{Colors.Gray.200-opacity-medium}",
  "Components-Button-Tab-button-tab": "{Colors.Neutral.050}",
  "Components-Button-Tab-button-tab-hover": "{Colors.Indigo.400}",
  "Components-Button-Tab-button-tab-active": "{Colors.Gray.050}",
  "Components-Button-Text-button-text": "{Colors.Primary.800-base}",
  "Components-Button-Text-button-text-hover": "{Colors.Indigo.700}",
  "Components-Button-Ghost-button-ghost-hover": "{Colors.Indigo.400}",
  "Components-Button-Functional-Success-button-success": "{Colors.Success.200}",
  "Components-Button-Functional-Success-button-success-hover": "{Colors.Success.500}",
  "Components-Button-Functional-Success-button-success-focused": "{Colors.Success.600}",
  "Components-Button-Functional-Desctructive error-Background-button-error": "{Colors.Error.400}",
  "Components-Button-Functional-Desctructive error-Background-button-error-hover": "{Colors.Error.300}",
  "Components-Button-Functional-Desctructive error-Background-button-error-focused": "{Colors.Error.400}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-icon": "{Colors.Error.500}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-hover-icon": "{Colors.Error.700}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-focused-icon": "{Colors.Error.700}",
  "Components-Badge-Background-badge-disabled-bg": "{Colors.Gray.200-opacity-medium}",
  "Components-Badge-Background-badge-gray-bg": "{Colors.Gray.200-opacity-medium}",
  "Components-Badge-Background-badge-error-bg": "{Colors.Error.200}",
  "Components-Badge-Background-badge-error-strong-bg": "{Colors.Error.200}",
  "Components-Badge-Background-badge-orange-bg": "{Colors.Warning.100}",
  "Components-Badge-Background-badge-orange-strong-bg": "{Colors.Warning.100}",
  "Components-Badge-Background-badge-yellow-bg": "{Colors.Yellow.100}",
  "Components-Badge-Background-badge-yellow-strong-bg": "{Colors.Yellow.100}",
  "Components-Badge-Background-badge-green-bg": "{Colors.Success.100}",
  "Components-Badge-Background-badge-green-strong-bg": "{Colors.Success.100}",
  "Components-Badge-Background-badge-indigo-soft-bg": "{Colors.Indigo.100}",
  "Components-Badge-Background-badge-indigo-medium-bg": "{Colors.Indigo.100}",
  "Components-Badge-Background-badge-indigo-strong-bg": "{Colors.Indigo.600}",
  "Components-Badge-Background-badge-accent-bg": "{Colors.Indigo.80-opacity}",
  "Components-Badge-Background-badge-violet-bg": "{Colors.Violet.200}",
  "Components-Badge-Background-badge-violet-strong-bg": "{Colors.Violet.200}",
  "Components-Badge-Background-badge-purple-bg": "{Colors.Purple.100}",
  "Components-Badge-Background-badge-purple-strong-bg": "{Colors.Purple.100}",
  "Components-Badge-Background-badge-neutral-bg": "{Colors.Neutral.200}",
  "Components-Badge-Background-badge-neutral-strong-bg": "{Colors.Neutral.200}",
  "Components-Badge-Background-badge-cyan-bg": "{Colors.Cyan.100}",
  "Components-Badge-Background-badge-cyan-strong-bg": "{Colors.Cyan.100}",
  "Components-Badge-Background-badge-white-bg": "{white}",
  "Components-Badge-Background-badge-dark-bg": "{Colors.Neutral.700}",
  "Components-Badge-Icon-badge-disabled-icon": "{Colors.Gray.200-opacity-medium}",
  "Components-Badge-Icon-badge-black-icon": "{black}",
  "Components-Badge-Icon-badge-white-icon": "{white}",
  "Components-Badge-Icon-badge-white-default-icon": "{Colors.Neutral.100}",
  "Components-Badge-Icon-badge-dark-icon": "{Colors.Neutral.700}",
  "Components-Badge-Icon-badge-black-default-icon": "{Colors.Primary.800-base}",
  "Components-Badge-Text-badge-disabled-strong-text": "{Colors.Gray.200-opacity-medium}",
  "Components-Badge-Text-badge-white-text": "{white}",
  "Components-Badge-Text-badge-white-default-text": "{white}",
  "Components-Badge-Text-badge-black-text": "{Colors.Neutral.700}",
  "Components-Badge-Text-badge-black-default-text": "{Colors.Neutral.700}",
  "Components-Badge-Text-badge-body-text": "{Colors.Neutral.700}",
  "Components-Badge-Border-badge-disabled-border": "{Colors.Gray.200-opacity-medium}",
  "Components-Badge-Border-badge-white-border": "{white}",
  "Components-Badge-Border-badge-white-default-border": "{white}",
  "Components-Badge-Border-badge-base-soft-border": "{white}",
  "Components-Badge-Border-badge-black-border": "{Colors.Neutral.700}",
  "Components-Badge-Border-badge-dark-default-border": "{Colors.Neutral.700}",
  "Components-Icon shape-Background-iconshape-disabled-bg": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Background-iconshape-red-bg": "{Colors.Error.100}",
  "Components-Icon shape-Background-iconshape-orange-bg": "{Colors.Warning.100}",
  "Components-Icon shape-Background-iconshape-yellow-bg": "{Colors.Yellow.100}",
  "Components-Icon shape-Background-iconshape-green-bg": "{Colors.Success.100}",
  "Components-Icon shape-Background-iconshape-indigo-bg": "{Colors.Indigo.100}",
  "Components-Icon shape-Background-iconshape-violet-bg": "{Colors.Violet.200}",
  "Components-Icon shape-Background-iconshape-purple-bg": "{Colors.Purple.100}",
  "Components-Icon shape-Background-iconshape-neutral-bg": "{Colors.Neutral.200}",
  "Components-Icon shape-Background-iconshape-cyan-bg": "{Colors.Cyan.100}",
  "Components-Icon shape-Background-iconshape-black-bg": "{black}",
  "Components-Icon shape-Background-iconshape-black-default-bg": "{Colors.Primary.800-base}",
  "Components-Icon shape-Background-iconshape-white-bg": "{white}",
  "Components-Icon shape-Background-iconshape-success-bg": "{Colors.Success.600}",
  "Components-Icon shape-Background-iconshape-error-bg": "{Colors.Error.500}",
  "Components-Icon shape-Background-iconshape-accent-bg": "{Colors.Indigo.50}",
  "Components-Icon shape-Icon-iconshape-black-icon": "{black}",
  "Components-Icon shape-Icon-iconshape-white-icon": "{white}",
  "Components-Icon shape-Icon-iconshape-white-default-icon": "{Colors.Neutral.100}",
  "Components-Icon shape-Icon-iconshape-disabled-icon": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Icon-iconshape-disabled-strong-icon": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Icon-iconshape-success-icon": "{Colors.Success.600}",
  "Components-Icon shape-Icon-iconshape-red-icon": "{Colors.Error.500}",
  "Components-Icon shape-Icon-iconshape-error-icon": "{Colors.Error.500}",
  "Components-Icon shape-Icon-iconshape-brand-icon": "{Colors.Primary.800-base}",
  "Components-Icon shape-Icon-iconshape-accent-gradient-icon": "{Colors.Indigo.50}",
  "Components-Icon shape-Icon-iconshape-orange-icon": "{Colors.Warning.100}",
  "Components-Icon shape-Icon-iconshape-yellow-icon": "{Colors.Yellow.100}",
  "Components-Icon shape-Icon-iconshape-green-icon": "{Colors.Success.100}",
  "Components-Icon shape-Icon-iconshape-indigo-icon": "{Colors.Indigo.100}",
  "Components-Icon shape-Icon-iconshape-violet-icon": "{Colors.Violet.100}",
  "Components-Icon shape-Icon-iconshape-purple-icon": "{Colors.Purple.700}",
  "Components-Icon shape-Icon-iconshape-neutral-icon": "{Colors.Neutral.200}",
  "Components-Icon shape-Icon-iconshape-default-icon": "{Colors.Cyan.600}",
  "Components-Icon shape-Border-iconshape-disabled-border": "{Colors.Gray.300}",
  "Components-Icon shape-Border-iconshape-default-border": "{Colors.Gray.500}",
  "Components-Icon shape-Border-iconshape-accent-border": "{Colors.Cyan.600}",
  "Components-Icon shape-Border-iconshape-error-border": "{Colors.Cyan.600}",
  "Components-Icon shape-Border-iconshape-success-border": "{Colors.Cyan.600}",
  "Components-Icon shape-Text-iconshape-disabled-text": "{Colors.Gray.300}",
  "Components-Icon shape-Text-iconshape-black-default-text": "{Colors.Gray.300}",
  "Components-Icon shape-Text-iconshape-default-text": "{Colors.Gray.300}",
  "Components-Icon shape-Text-iconshape-accent-gradient-text": "{Colors.Cyan.600}",
  "Components-Icon shape-Text-iconshape-error-text": "{Colors.Cyan.600}",
  "Components-Icon shape-Text-iconshape-success-text": "{Colors.Cyan.600}",
  "Components-Icon shape-Text-iconshape-white-default-text": "{Colors.Cyan.600}",
  "Components-Toggle-Background-toggle-active": "{Colors.Indigo.500}",
  "Components-Toggle-Background-toggle-unactive": "{Colors.Neutral.050}",
  "Components-Toggle-Background-toggle-disabled": "{Colors.Gray.300}",
  "Components-Toggle-Background-toggle-active-switch": "{Background.background-white}",
  "Components-Toggle-Background-toggle-disabled-switch": "{Colors.Gray.500}",
  "Components-Toggle-Icon-toggle-icon": "{Colors.Indigo.500}",
  "Components-Toggle-Icon-toggle-icon-disabled": "{Colors.Gray.200}",
  "Components-Toggle-Border-toggle-active-border": "{Colors.Indigo.400}",
  "Components-Toggle-Border-toggle-unactive-border": "{Colors.Neutral.500}",
  "Components-Toggle-Border-toggle-disabled-border": "{Colors.Gray.400}",
  "Border-border-black-default": "{Colors.Primary.800-base}",
  "Border-border-white-default": "{Colors.Neutral.400}",
  "Border-border-base": "{Colors.Gray.500}",
  "Border-border-base-medium": "{Colors.Gray.300}",
  "Border-border-base-soft": "{Colors.Gray.200}",
  "Border-border-disabled": "{Colors.Gray.200}",
  "Border-border-disabled-subtle": "{Colors.Gray.200}",
  "Border-border-primary-button": "{Colors.Gray.400}",
  "Border-border-primary-button-hover": "{Colors.Indigo.100}",
  "Border-border-secondary-button": "{Colors.Neutral.400}",
  "Border-border-secondary-button-hover": "{Colors.Indigo.400}",
  "Border-border-secondary-button-focus": "{Colors.Cyan.500}",
  "Border-border-tertiary-hover": "{Colors.White opacity.50-opacity-medium}",
  "Border-border-tab": "{white}",
  "Border-border-tab-hover": "{Colors.Indigo.400}",
  "Border-border-tab-hover 2": "{Colors.Indigo.300}",
  "Border-border-accent": "{Colors.Indigo.400}",
  "Border-border-accent-subtle": "{Colors.Indigo.200}",
  "Border-border-hover": "{Colors.Indigo.400}",
  "Border-border-info": "{Colors.Indigo.400}",
  "Border-border-info-strong": "{Colors.Indigo.700}",
  "Border-border-info-subtle": "{Colors.Indigo.200}",
  "Border-border-success-strong": "{Colors.Success.600}",
  "Border-border-success": "{Colors.Success.400}",
  "Border-border-error-strong": "{Colors.Error.700}",
  "Border-border-error": "{Colors.Error.500}",
  "Border-border-error-subtle": "{Colors.Error.300}",
  "Border-border-warning": "{Colors.Warning.500}",
  "Border-border-warning-subtle": "{Colors.Warning.200}",
  "Border-border-ia": "{Colors.Purple.200}",
  "Border-border-accessibility": "{Colors.Neutral.400}",
  "Border-border-white-full": "{white}"
}, BU = {
  "spacing-0": "{number.0}",
  "spacing-1": "{number.1}",
  "spacing-2": "{number.2}",
  "spacing-3": "{number.3}",
  "spacing-4": "{number.4}",
  "spacing-5": "{number.5}",
  "spacing-6": "{number.6}",
  "spacing-8": "{number.8}",
  "spacing-9": "{number.9}",
  "spacing-10": "{number.10}",
  "spacing-12": "{number.12}",
  "spacing-14": "{number.14}",
  "spacing-16": "{number.16}",
  "spacing-20": "{number.20}",
  "spacing-24": "{number.24}",
  "spacing-px": "{number.px}",
  "spacing-0.5": "{number.0.5}",
  "spacing-1.5": "{number.1.5}",
  "spacing-3.5": "{number.3.5}",
  "icon-size-xs": "{number.3.5}",
  "icon-size-sm": "{number.4}",
  "icon-size-md": "{number.5}",
  "icon-size-lg": "{number.6}",
  "border-border-radius-rounded-0": "{border.border-radius.rounded-0}",
  "border-border-radius-rounded-xxs": "{border.border-radius.rounded-xxs}",
  "border-border-radius-rounded-xs": "{border.border-radius.rounded-xs}",
  "border-border-radius-rounded-sm": "{border.border-radius.rounded-sm}",
  "border-border-radius-rounded-l": "{border.border-radius.rounded-l}",
  "border-border-radius-rounded-base": "{border.border-radius.rounded-base}",
  "border-border-radius-rounded-xl": "{border.border-radius.rounded-xl}",
  "border-border-radius-rounded-xxl": "{border.border-radius.rounded-xxl}",
  "border-border-radius-rounded-full": "{border.border-radius.rounded-full}",
  "border-border-width-border-0": "{border.border-width.border-0}",
  "border-border-width-border": "{border.border-width.border}",
  "border-border-width-border-sm": "{border.border-width.border-sm}",
  "border-border-width-border-base": "{border.border-width.border-2}",
  "border-border-width-border-md": "{border.border-width.border-3}",
  "border-border-width-border-lg": "{border.border-width.border-4}",
  "border-border-width-border-xl": "{border.border-width.border-8}"
}, MU = {
  "Family-heading": "inter",
  "Family-text": "inter",
  "Size-xs": 10,
  "Size-sm": 12,
  "Size-m": 14,
  "Size-l": 16,
  "Size-xl": 18,
  "Size-xxl": 20,
  "Size-3xl": 22,
  "Size-4xl": 24,
  "Size-5xl": 28,
  "Size-6xl": 36,
  "Size-7xl": 40,
  "Size-8xl": 48,
  "Size-9xl": 52,
  "Weight-thin": 100,
  "Weight-extra-light": 200,
  "Weight-light": 300,
  "Weight-regular": 400,
  "Weight-medium": 500,
  "Weight-semi-bold": 600,
  "Weight-bold": 700,
  "Weight-extra-bold": 800,
  "Weight-black": 900,
  "Line-height-xs": 12,
  "Line-height-s": 14,
  "Line-height-m": 18,
  "Line-height-l": 20,
  "Line-height-xl": 22,
  "Line-height-xxl": 24,
  "Line-height-3xl": 26,
  "Line-height-4xl": 29,
  "Line-height-5xl": 34,
  "Line-height-6xl": 43,
  "Letter-spacing-Letter-spacing": 0,
  "Letter-case-case-original": "none",
  "Letter-case-case-upper": "uppercase",
  "Letter-case-case-lower": "lowercase",
  "Letter-case-case-title": "capitalize",
  "Letter-case-case-smallcaps": "smallcaps"
}, DU = {
  "Grid-grid-columns-l": "{number.2}",
  "Grid-grid-columns-m": "{number.1}",
  "Grid-grid-columns-xs": "{number.px}",
  "Grid-margin-4xl": "{number.24}",
  "Grid-margin-l": "{number.24}",
  "Grid-gutter": "{number.5}",
  "Grid-Sidebar-sidebar-open": 317,
  "Grid-Sidebar-sidebar-close": 158,
  "Grid-Sidebar-sidebar-toolbox": 279,
  "Grid-Container-cont-size": 1563,
  "Grid-Container-cont-size-navclosed": 1762,
  "Grid-Container-cont-size-toolbox": 1664,
  "Grid-Navbar-navbar-size": 1601,
  "Grid-Navbar-navbarclosed-size": 1762,
  "Breakpoints-width-XL": 1440,
  "Breakpoints-width-XXL": 1920
};
export {
  Xb as ACCORDION_CONTEXT_KEY,
  Zb as ACCORDION_ITEM_CONTEXT_KEY,
  GW as AccessSettings,
  jW as Accordion,
  WW as AccordionItem,
  Sq as AddressInput,
  Cx as AdvancedFilterBody,
  LU as AdvancedFilterBuilder,
  Sx as AdvancedFilterFooter,
  TU as AdvancedFilterPopover,
  _l as Alert,
  Wv as AutoComplete,
  Lq as AutoCompleteAllResultsModal,
  Nt as Avatar,
  Pv as AvatarGroup,
  Iq as AvatarLabel,
  gt as Badge,
  AU as Banner,
  VP as Breadcrumb,
  Me as Button,
  Ig as ButtonGroup,
  qW as ButtonLink,
  sU as Card,
  dU as CardSelectable,
  Bn as Checkbox,
  oq as CheckboxForm,
  rq as CheckboxGroup,
  G4 as CollapsibleSearch,
  pU as CollapsibleSection,
  $U as ColorPicker,
  Mq as CompactPager,
  eU as ConfirmDeleteModal,
  nq as CopyInput,
  kW as CriteriaGroup,
  gU as CtaWidget,
  ob as DEFAULT_COUNTRY,
  Dl as DEFAULT_PHONE_FORMAT,
  tx as DEFAULT_TABLE_LABELS,
  lU as DataTable,
  sN as DataTableBody,
  tU as DataTableCaption,
  yu as DataTableCell,
  iN as DataTableContainer,
  nU as DataTableEmpty,
  aU as DataTableFooter,
  wN as DataTableHead,
  CN as DataTableHeader,
  ri as DataTableRow,
  iU as DataTableWrapper,
  mq as DateGroupHeader,
  xu as DatePickerInput,
  e3 as DateRangePickerInput,
  Hr as DatepickerCell,
  Dz as DatepickerControls,
  Rz as DatepickerDobPicker,
  Uc as DatepickerDropdownMenu,
  Fv as DatepickerPanel,
  VM as DraggableListItem,
  QP as Drawer,
  cn as Dropdown,
  Cf as DropdownItemButton,
  en as DropdownListItem,
  pl as DropdownPanelFooter,
  vl as DropdownPanelHeader,
  _q as DynamicFormField,
  jc as EditableTitle,
  mB as EmailInput,
  kx as FILTER_FIELD_SELECT_PANEL_SELECTOR,
  jr as FROZEN_COLUMN_LIMIT,
  A8 as FacetedSearchDrawer,
  tq as FieldGroup,
  $t as FieldHelper,
  It as FieldLabel,
  XH as FieldSkeleton,
  KS as FileUploadInput,
  ec as FilterDropdown,
  ox as FilterFieldPicker,
  oW as FilterFieldSelect,
  lP as FilterPill,
  wU as FloatActionBar,
  Qq as FormErrorSummary,
  lV as FormSaveButton,
  SU as FormSkeleton,
  Gt as IconShape,
  iq as ImageInput,
  kq as ImageUploadInput,
  cU as InlineLink,
  pq as InteractionListItem,
  Yr as LabelDropdown,
  ED as ListItem,
  xq as ListItemAccordion,
  yq as ListItemAccordionRow,
  FM as ListItemCard,
  hM as ListItemGroup,
  Bq as LookupInput,
  Oq as MainDrawer,
  gq as MaskedInput,
  uU as Masonry,
  vq as MeetingListItem,
  eq as MetricCardAction,
  _W as MetricCardProgress,
  YW as MetricCardSimple,
  ZW as MetricCardWithBadge,
  QW as MetricCardWithChart,
  JW as MetricCardWithIcon,
  XW as MetricCardWithTrend,
  Ka as Modal,
  Eg as MultipleSelect,
  Jq as NavHeader,
  yU as NavTabs,
  Yq as Navbar,
  Af as NumberInput,
  Uv as NumberRangeInput,
  Rq as OtpInput,
  _n as PHONE_FORMATS,
  yB as PHONE_FORMATS_BY_DIAL_CODE,
  CO as Pager,
  cq as PasswordInput,
  bq as PhoneDisplay,
  RB as PhoneInput,
  qv as Popover,
  vU as ProfileCard,
  Ju as ProgressBar,
  gC as RadioButton,
  aq as RadioForm,
  lq as RadioFormGroup,
  qq as RecordsTable,
  $q as RelationInput,
  uq as RichTextEditor,
  ls as SearchInput,
  Kq as SecondarySidebar,
  mV as SegmentedPager,
  ll as SelectInput,
  Gq as Sidebar,
  UW as SortDropdown,
  Xq as SpeedDial,
  Vu as Spinner,
  n8 as SplitButton,
  mU as StatsWidget,
  IU as StepperNavigation,
  kU as StepperWizardSidenav,
  RO as TABLE_COLUMN_SETTINGS_KEY,
  Qv as TABLE_LABELS_KEY,
  Zv as TABLE_PERMISSIONS_KEY,
  or as TABLE_QUERY_KEY,
  Cs as TABLE_SEARCH_DEBOUNCE_MS,
  ws as TABLE_VIEWS_KEY,
  Uq as Table,
  ax as TableControls,
  lx as TableFilterBar,
  Wq as TableFilterSelector,
  Vq as TableHeader,
  sF as TablePanel,
  Fq as TableShell,
  iP as TableSkeleton,
  nx as TableTopbar,
  Y4 as TagInput,
  Wt as TextInput,
  Mn as TextLink,
  sq as Textarea,
  Tq as TimePickerInput,
  xU as Timeline,
  Zq as ToastContainer,
  UV as ToastItem,
  Eq as ToggleGroup,
  Aq as ToggleInput,
  nl as ToggleSwitch,
  mt as Tooltip,
  pt as TruncatedText,
  oN as UnsavedChangesModal,
  Cq as UrlInput,
  KW as WeekNavigator,
  hU as WidgetBlock,
  bU as WidgetSection,
  fU as WidgetShell,
  wq as YearMonthPickerInput,
  Tg as attachedPartClasses,
  Uy as buttonGroupTabId,
  RU as colorsDark,
  EU as colorsLight,
  rU as createPhoneValidator,
  Bv as datePatternFromFormat,
  Dv as deleteAcrossSeparator,
  vB as digitMaskFromPattern,
  Wa as fieldButtonSize,
  as as formatCountLabel,
  io as formatGroupedDigits,
  kB as formatPhoneForDisplay,
  gu as groupMaskFromPlaceholder,
  mr as groupPreservingTrunkZero,
  Xc as isDraftGroup,
  px as isGroupNode,
  Zc as isMultiValue,
  so as isValueless,
  Dq as mapApiPaginated,
  rb as maskGroupedInput,
  Mv as maskLiveInput,
  Hb as parse,
  DU as semanticBreakpoints,
  BU as semanticSpacing,
  MU as semanticTypography,
  Ko as serialize,
  Hc as significantDigitCount,
  ib as stripTrunkZero,
  hq as toE164,
  yx as useAdvancedFilterActions,
  jq as useColumnSettings,
  eW as useCriteriaBuilder,
  A9 as useDirtyState,
  Qb as useDisclosure,
  Pq as useDrawer,
  ar as useDropdown,
  CU as useFloatActionBarActions,
  ts as useFocusTrap,
  oU as useForm,
  T9 as useFormSubmit,
  L9 as useFormValidation,
  tn as useHasSlot,
  Ov as useListRowSurface,
  E9 as useMediaQuery,
  Hq as useResponsivePageSize,
  go as useRovingListbox,
  r1 as useSortable,
  ir as useTableLabels,
  zq as useTableQuery,
  Nq as useTableViews,
  EV as useToast,
  K0 as useTruncationDetector,
  fq as withHeuristicTrunkZero
};
